/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Definition for SawitPro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2024.06.20-1350
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface ActivateUserRequest
 */
export interface ActivateUserRequest {
    /**
     * The new status for the user. True for active, otherwise false
     * @type {boolean}
     * @memberof ActivateUserRequest
     */
    'isActive'?: boolean;
}
/**
 * Response data
 * @export
 * @interface ActivateUserResponse
 */
export interface ActivateUserResponse {
    /**
     * ID of the user
     * @type {string}
     * @memberof ActivateUserResponse
     */
    'id'?: string;
    /**
     * Name of the user
     * @type {string}
     * @memberof ActivateUserResponse
     */
    'name'?: string;
    /**
     * 
     * @type {UserStatusEnum}
     * @memberof ActivateUserResponse
     */
    'status'?: UserStatusEnum;
}


/**
 * 
 * @export
 * @interface ActivitiesListResponse
 */
export interface ActivitiesListResponse {
    /**
     * 
     * @type {ActivitiesListResponseData}
     * @memberof ActivitiesListResponse
     */
    'data': ActivitiesListResponseData;
}
/**
 * 
 * @export
 * @interface ActivitiesListResponseData
 */
export interface ActivitiesListResponseData {
    /**
     * 
     * @type {Array<ActivitiesListResponseDataItemsInner>}
     * @memberof ActivitiesListResponseData
     */
    'items': Array<ActivitiesListResponseDataItemsInner>;
}
/**
 * 
 * @export
 * @interface ActivitiesListResponseDataDriver
 */
export interface ActivitiesListResponseDataDriver {
    /**
     * Image URL of weighbridge_slip.jpeg
     * @type {string}
     * @memberof ActivitiesListResponseDataDriver
     */
    'photo': string;
    /**
     * Plat no of truck
     * @type {string}
     * @memberof ActivitiesListResponseDataDriver
     */
    'platNo': string;
    /**
     * Empty weight of truck
     * @type {number}
     * @memberof ActivitiesListResponseDataDriver
     */
    'emptyWeight': number;
    /**
     * Max. capacity of truck that can bring FFB
     * @type {number}
     * @memberof ActivitiesListResponseDataDriver
     */
    'maxCapacity': number;
}
/**
 * 
 * @export
 * @interface ActivitiesListResponseDataFieldCoordinator
 */
export interface ActivitiesListResponseDataFieldCoordinator {
    /**
     * Image URL of weighbridge_slip.jpeg
     * @type {string}
     * @memberof ActivitiesListResponseDataFieldCoordinator
     */
    'photo': string;
    /**
     * 
     * @type {WeighbridgeTicketStatusEnum}
     * @memberof ActivitiesListResponseDataFieldCoordinator
     */
    'status': WeighbridgeTicketStatusEnum;
    /**
     * Upload time of weighbridge slip (in epoch) and will be represented in utc0
     * @type {number}
     * @memberof ActivitiesListResponseDataFieldCoordinator
     */
    'uploadedAt': number;
}


/**
 * @type ActivitiesListResponseDataItemsInner
 * @export
 */
export type ActivitiesListResponseDataItemsInner = ActivitiesListResponseDataDriver | ActivitiesListResponseDataFieldCoordinator;

/**
 * 
 * @export
 * @interface ActivitiesListV2Response
 */
export interface ActivitiesListV2Response {
    /**
     * 
     * @type {Array<ActivitiesListResponseDataItemsInner>}
     * @memberof ActivitiesListV2Response
     */
    'items': Array<ActivitiesListResponseDataItemsInner>;
}
/**
 * 
 * @export
 * @interface AdminJobBoardsVacanciesGetJobVacancyDetailResponse
 */
export interface AdminJobBoardsVacanciesGetJobVacancyDetailResponse {
    /**
     * Unique identifier for this job vacancy
     * @type {string}
     * @memberof AdminJobBoardsVacanciesGetJobVacancyDetailResponse
     */
    'id': string;
    /**
     * name of this job vacancy
     * @type {string}
     * @memberof AdminJobBoardsVacanciesGetJobVacancyDetailResponse
     */
    'jobName': string;
    /**
     * description of this job vacancy
     * @type {string}
     * @memberof AdminJobBoardsVacanciesGetJobVacancyDetailResponse
     */
    'jobDescription': string;
    /**
     * total applicant for this job vacancy
     * @type {number}
     * @memberof AdminJobBoardsVacanciesGetJobVacancyDetailResponse
     */
    'totalApplicant': number;
    /**
     * 
     * @type {JobBoardsVacanciesStatusEnum}
     * @memberof AdminJobBoardsVacanciesGetJobVacancyDetailResponse
     */
    'status': JobBoardsVacanciesStatusEnum;
    /**
     * 
     * @type {JobBoardsVacanciesWage}
     * @memberof AdminJobBoardsVacanciesGetJobVacancyDetailResponse
     */
    'wage': JobBoardsVacanciesWage;
    /**
     * facilities of this job vacancy
     * @type {Array<string>}
     * @memberof AdminJobBoardsVacanciesGetJobVacancyDetailResponse
     */
    'facilities': Array<string>;
    /**
     * 
     * @type {JobBoardsVacanciesTerrain}
     * @memberof AdminJobBoardsVacanciesGetJobVacancyDetailResponse
     */
    'terrain': JobBoardsVacanciesTerrain;
    /**
     * 
     * @type {JobBoardsVacanciesFFB}
     * @memberof AdminJobBoardsVacanciesGetJobVacancyDetailResponse
     */
    'ffb': JobBoardsVacanciesFFB;
    /**
     * images of this job vacancy
     * @type {Array<string>}
     * @memberof AdminJobBoardsVacanciesGetJobVacancyDetailResponse
     */
    'images': Array<string>;
    /**
     * 
     * @type {JobBoardsVacanciesCategory}
     * @memberof AdminJobBoardsVacanciesGetJobVacancyDetailResponse
     */
    'category': JobBoardsVacanciesCategory;
    /**
     * 
     * @type {JobBoardsVacanciesLocation}
     * @memberof AdminJobBoardsVacanciesGetJobVacancyDetailResponse
     */
    'location': JobBoardsVacanciesLocation;
    /**
     * quota of this job vacancy
     * @type {number}
     * @memberof AdminJobBoardsVacanciesGetJobVacancyDetailResponse
     */
    'quota': number;
    /**
     * created at utc0 of this job vacancy
     * @type {number}
     * @memberof AdminJobBoardsVacanciesGetJobVacancyDetailResponse
     */
    'createdAtUtc0': number;
}


/**
 * this is for get list of applicants
 * @export
 * @interface AdminJobBoardsVacanciesGetListApplicantsResponse
 */
export interface AdminJobBoardsVacanciesGetListApplicantsResponse {
    /**
     * 
     * @type {AdminJobBoardsVacanciesGetListApplicantsResponseSummary}
     * @memberof AdminJobBoardsVacanciesGetListApplicantsResponse
     */
    'summary': AdminJobBoardsVacanciesGetListApplicantsResponseSummary;
    /**
     * this is for list of applicant
     * @type {Array<AdminJobBoardsVacanciesGetListApplicantsResponseItems>}
     * @memberof AdminJobBoardsVacanciesGetListApplicantsResponse
     */
    'items': Array<AdminJobBoardsVacanciesGetListApplicantsResponseItems>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof AdminJobBoardsVacanciesGetListApplicantsResponse
     */
    'pagination': PaginationResponse;
}
/**
 * 
 * @export
 * @interface AdminJobBoardsVacanciesGetListApplicantsResponseItems
 */
export interface AdminJobBoardsVacanciesGetListApplicantsResponseItems {
    /**
     * 
     * @type {string}
     * @memberof AdminJobBoardsVacanciesGetListApplicantsResponseItems
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminJobBoardsVacanciesGetListApplicantsResponseItems
     */
    'name': string;
    /**
     * 
     * @type {GenderEnum}
     * @memberof AdminJobBoardsVacanciesGetListApplicantsResponseItems
     */
    'gender': GenderEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminJobBoardsVacanciesGetListApplicantsResponseItems
     */
    'phoneNo': string;
    /**
     * 
     * @type {string}
     * @memberof AdminJobBoardsVacanciesGetListApplicantsResponseItems
     */
    'address': string;
    /**
     * 
     * @type {number}
     * @memberof AdminJobBoardsVacanciesGetListApplicantsResponseItems
     */
    'jobExperience': number;
    /**
     * 
     * @type {AdminJobBoardsVacanciesGetListApplicantsResponseItemsWage}
     * @memberof AdminJobBoardsVacanciesGetListApplicantsResponseItems
     */
    'wage': AdminJobBoardsVacanciesGetListApplicantsResponseItemsWage;
    /**
     * 
     * @type {JobBoardsVacanciesApplicationStatusEnum}
     * @memberof AdminJobBoardsVacanciesGetListApplicantsResponseItems
     */
    'status': JobBoardsVacanciesApplicationStatusEnum;
}


/**
 * 
 * @export
 * @interface AdminJobBoardsVacanciesGetListApplicantsResponseItemsWage
 */
export interface AdminJobBoardsVacanciesGetListApplicantsResponseItemsWage {
    /**
     * 
     * @type {number}
     * @memberof AdminJobBoardsVacanciesGetListApplicantsResponseItemsWage
     */
    'expected': number;
    /**
     * 
     * @type {string}
     * @memberof AdminJobBoardsVacanciesGetListApplicantsResponseItemsWage
     */
    'unit': string;
}
/**
 * 
 * @export
 * @interface AdminJobBoardsVacanciesGetListApplicantsResponseSummary
 */
export interface AdminJobBoardsVacanciesGetListApplicantsResponseSummary {
    /**
     * this is for get total apply from applicant
     * @type {number}
     * @memberof AdminJobBoardsVacanciesGetListApplicantsResponseSummary
     */
    'totalApplicant': number;
    /**
     * this is for get total status pending
     * @type {number}
     * @memberof AdminJobBoardsVacanciesGetListApplicantsResponseSummary
     */
    'statusPending': number;
    /**
     * this is for get total status accepted
     * @type {number}
     * @memberof AdminJobBoardsVacanciesGetListApplicantsResponseSummary
     */
    'statusAccepted': number;
    /**
     * this is for get status rejected
     * @type {number}
     * @memberof AdminJobBoardsVacanciesGetListApplicantsResponseSummary
     */
    'statusRejected': number;
}
/**
 * 
 * @export
 * @interface AdminsAgronomyBookingsCreateSummaryRequest
 */
export interface AdminsAgronomyBookingsCreateSummaryRequest {
    /**
     * url of a document contains summary detail
     * @type {string}
     * @memberof AdminsAgronomyBookingsCreateSummaryRequest
     */
    'documentUrl': string;
    /**
     * 
     * @type {AgronomyBookingSummaryDetail}
     * @memberof AdminsAgronomyBookingsCreateSummaryRequest
     */
    'detail': AgronomyBookingSummaryDetail;
    /**
     * contains summary detail with html tags
     * @type {string}
     * @memberof AdminsAgronomyBookingsCreateSummaryRequest
     */
    'htmlDetail': string;
}
/**
 * 
 * @export
 * @interface AdminsAgronomyBookingsCreateSummaryResponse
 */
export interface AdminsAgronomyBookingsCreateSummaryResponse {
    /**
     * 
     * @type {boolean}
     * @memberof AdminsAgronomyBookingsCreateSummaryResponse
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface AdminsAgronomyBookingsCreateTasksRequest
 */
export interface AdminsAgronomyBookingsCreateTasksRequest {
    /**
     * the amount of sawit point rewarded when user completed task, if point <= 0 this task is not eligible for reward.
     * @type {number}
     * @memberof AdminsAgronomyBookingsCreateTasksRequest
     */
    'pointReward': number;
    /**
     * content of the agronomy task in \"Tugas\" section.
     * @type {string}
     * @memberof AdminsAgronomyBookingsCreateTasksRequest
     */
    'detailTask': string;
    /**
     * content of the agronomy task in \"Saran\" section, value in HTML format.
     * @type {string}
     * @memberof AdminsAgronomyBookingsCreateTasksRequest
     */
    'detailSuggestion': string;
    /**
     * start date for when the task could grant point reward to user, value in string \"yyyy-mm-dd\" format.
     * @type {string}
     * @memberof AdminsAgronomyBookingsCreateTasksRequest
     */
    'startDate': string;
    /**
     * end date for when the task could grant point reward to user, value in string \"yyyy-mm-dd\" format.
     * @type {string}
     * @memberof AdminsAgronomyBookingsCreateTasksRequest
     */
    'endDate': string;
    /**
     * determine is the task will be shown in user\'s client app or not
     * @type {boolean}
     * @memberof AdminsAgronomyBookingsCreateTasksRequest
     */
    'isActive'?: boolean;
}
/**
 * 
 * @export
 * @interface AdminsAgronomyBookingsCreateTasksResponse
 */
export interface AdminsAgronomyBookingsCreateTasksResponse {
    /**
     * ID of the created agronomy task.
     * @type {string}
     * @memberof AdminsAgronomyBookingsCreateTasksResponse
     */
    'taskId': string;
}
/**
 * 
 * @export
 * @interface AdminsAgronomyBookingsUpdateTasksRequest
 */
export interface AdminsAgronomyBookingsUpdateTasksRequest {
    /**
     * the amount of sawit point rewarded when user completed task, if point <= 0 this task is not eligible for reward.
     * @type {number}
     * @memberof AdminsAgronomyBookingsUpdateTasksRequest
     */
    'pointReward'?: number;
    /**
     * content of the agronomy task in \"Tugas\" section.
     * @type {string}
     * @memberof AdminsAgronomyBookingsUpdateTasksRequest
     */
    'detailTask'?: string;
    /**
     * content of the agronomy task in \"Saran\" section, value in HTML format.
     * @type {string}
     * @memberof AdminsAgronomyBookingsUpdateTasksRequest
     */
    'detailSuggestion'?: string;
    /**
     * start date for when the task could grant point reward to user, value in string \"yyyy-mm-dd\" format.
     * @type {string}
     * @memberof AdminsAgronomyBookingsUpdateTasksRequest
     */
    'startDate'?: string;
    /**
     * end date for when the task could grant point reward to user, value in string \"yyyy-mm-dd\" format.
     * @type {string}
     * @memberof AdminsAgronomyBookingsUpdateTasksRequest
     */
    'endDate'?: string;
    /**
     * determine is the task will be shown in user\'s client app or not
     * @type {boolean}
     * @memberof AdminsAgronomyBookingsUpdateTasksRequest
     */
    'isActive'?: boolean;
}
/**
 * 
 * @export
 * @interface AdminsAgronomyBookingsUpdateTasksResponse
 */
export interface AdminsAgronomyBookingsUpdateTasksResponse {
    /**
     * ID of the updated agronomy task.
     * @type {string}
     * @memberof AdminsAgronomyBookingsUpdateTasksResponse
     */
    'taskId': string;
}
/**
 * 
 * @export
 * @interface AdminsAppCreateShortcutRequest
 */
export interface AdminsAppCreateShortcutRequest {
    /**
     * title of the app/feature shortcut, will be shown in mobile app home page
     * @type {string}
     * @memberof AdminsAppCreateShortcutRequest
     */
    'title': string;
    /**
     * description of the app/feature, not shown in the mobile app home page
     * @type {string}
     * @memberof AdminsAppCreateShortcutRequest
     */
    'description': string;
    /**
     * url of the shortcut icon image
     * @type {string}
     * @memberof AdminsAppCreateShortcutRequest
     */
    'imageUrl': string;
    /**
     * link/route to the targeted app page
     * @type {string}
     * @memberof AdminsAppCreateShortcutRequest
     */
    'route': string;
    /**
     * sequence of the app shortcut, used for ordering
     * @type {number}
     * @memberof AdminsAppCreateShortcutRequest
     */
    'sequence': number;
    /**
     * scopes of where the app shortcut will be shown. format = {APP-TYPE}.{LOGIN-TAG}.{SCOPE-TAG}
     * @type {Array<string>}
     * @memberof AdminsAppCreateShortcutRequest
     */
    'scopes': Array<string>;
    /**
     * the minimum client app version in integer format, for this app shortcut to be shown on. WARNING, make sure there are no overlapping \"minAppVersion\" & \"maxAppVersion\" for the created \'app_shortcut\' data in DB
     * @type {number}
     * @memberof AdminsAppCreateShortcutRequest
     */
    'minAppVersionCode'?: number;
    /**
     * the maximum client app version in integer format, for this app shortcut to be shown on. WARNING, make sure there are no overlapping \"minAppVersion\" & \"maxAppVersion\" for the created \'app_shortcut\' data in DB
     * @type {number}
     * @memberof AdminsAppCreateShortcutRequest
     */
    'maxAppVersionCode'?: number;
}
/**
 * 
 * @export
 * @interface AdminsAppCreateShortcutResponse
 */
export interface AdminsAppCreateShortcutResponse {
    /**
     * id of the created app shortcut
     * @type {string}
     * @memberof AdminsAppCreateShortcutResponse
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface AdminsAssetTruckCreateVerificationResponse
 */
export interface AdminsAssetTruckCreateVerificationResponse {
    /**
     * 
     * @type {boolean}
     * @memberof AdminsAssetTruckCreateVerificationResponse
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface AdminsAssetTruckUpdateVerificationRequest
 */
export interface AdminsAssetTruckUpdateVerificationRequest {
    /**
     * 
     * @type {TruckStatusEnum}
     * @memberof AdminsAssetTruckUpdateVerificationRequest
     */
    'status': TruckStatusEnum;
    /**
     * the reason of why the truck is rejected
     * @type {string}
     * @memberof AdminsAssetTruckUpdateVerificationRequest
     */
    'rejectedReason'?: string;
}


/**
 * 
 * @export
 * @interface AdminsAssetsUpdateFarmRequest
 */
export interface AdminsAssetsUpdateFarmRequest {
    /**
     * 
     * @type {AssetFarmStatusEnum}
     * @memberof AdminsAssetsUpdateFarmRequest
     */
    'status': AssetFarmStatusEnum;
    /**
     * input reason describing the status change, currently only used for status REJECTED reason
     * @type {string}
     * @memberof AdminsAssetsUpdateFarmRequest
     */
    'reason'?: string;
}
/**
 * 
 * @export
 * @interface AdminsAssetsUpdateFarmResponse
 */
export interface AdminsAssetsUpdateFarmResponse {
    /**
     * id of the updated farm data, represented in UUID type 4
     * @type {string}
     * @memberof AdminsAssetsUpdateFarmResponse
     */
    'id': string;
    /**
     * 
     * @type {AssetFarmStatusEnum}
     * @memberof AdminsAssetsUpdateFarmResponse
     */
    'status': AssetFarmStatusEnum;
    /**
     * Sawitpoin rewarded to owner of the farm for first time user\'s farm data is verified, if <= 0 user is not eligible for Sawitpoin reward
     * @type {number}
     * @memberof AdminsAssetsUpdateFarmResponse
     */
    'sawitpoinForUser': number;
}
/**
 * 
 * @export
 * @interface AdminsAwardGoldRequest
 */
export interface AdminsAwardGoldRequest {
    /**
     * List of user ID, gold, title & body to be given
     * @type {Array<AdminsAwardGoldRequestItem>}
     * @memberof AdminsAwardGoldRequest
     */
    'users': Array<AdminsAwardGoldRequestItem>;
}
/**
 * 
 * @export
 * @interface AdminsAwardGoldRequestItem
 */
export interface AdminsAwardGoldRequestItem {
    /**
     * User ID in UUID type 4 format
     * @type {string}
     * @memberof AdminsAwardGoldRequestItem
     */
    'id': string;
    /**
     * Gold amount to be given in mg
     * @type {number}
     * @memberof AdminsAwardGoldRequestItem
     */
    'amount': number;
    /**
     * Title of the activity
     * @type {string}
     * @memberof AdminsAwardGoldRequestItem
     */
    'title': string;
    /**
     * Body of the activity
     * @type {string}
     * @memberof AdminsAwardGoldRequestItem
     */
    'body': string;
    /**
     * List of reference of the SawitPoin activity
     * @type {Array<AdminsAwardGoldRequestReference>}
     * @memberof AdminsAwardGoldRequestItem
     */
    'reference': Array<AdminsAwardGoldRequestReference>;
}
/**
 * 
 * @export
 * @interface AdminsAwardGoldRequestReference
 */
export interface AdminsAwardGoldRequestReference {
    /**
     * Name of our database table for the reference
     * @type {string}
     * @memberof AdminsAwardGoldRequestReference
     */
    'table': string;
    /**
     * The ID of the reference (ID of the record in the table)
     * @type {string}
     * @memberof AdminsAwardGoldRequestReference
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface AdminsAwardSawitpoinRequest
 */
export interface AdminsAwardSawitpoinRequest {
    /**
     * List of user ID, poin, title & body to be given
     * @type {Array<AdminsAwardSawitpoinRequestItem>}
     * @memberof AdminsAwardSawitpoinRequest
     */
    'users': Array<AdminsAwardSawitpoinRequestItem>;
}
/**
 * 
 * @export
 * @interface AdminsAwardSawitpoinRequestItem
 */
export interface AdminsAwardSawitpoinRequestItem {
    /**
     * User ID in UUID type 4 format
     * @type {string}
     * @memberof AdminsAwardSawitpoinRequestItem
     */
    'id': string;
    /**
     * Sawitpoin to be given
     * @type {number}
     * @memberof AdminsAwardSawitpoinRequestItem
     */
    'poin': number;
    /**
     * Title of the transaction
     * @type {string}
     * @memberof AdminsAwardSawitpoinRequestItem
     */
    'title': string;
    /**
     * Body of the transaction
     * @type {string}
     * @memberof AdminsAwardSawitpoinRequestItem
     */
    'body': string;
    /**
     * List of reference of the SawitPoin activity
     * @type {Array<AdminsAwardSawitpoinRequestReference>}
     * @memberof AdminsAwardSawitpoinRequestItem
     */
    'reference': Array<AdminsAwardSawitpoinRequestReference>;
}
/**
 * 
 * @export
 * @interface AdminsAwardSawitpoinRequestReference
 */
export interface AdminsAwardSawitpoinRequestReference {
    /**
     * Name of our database table for the reference
     * @type {string}
     * @memberof AdminsAwardSawitpoinRequestReference
     */
    'table': string;
    /**
     * The ID of the reference (ID of the record in the table)
     * @type {string}
     * @memberof AdminsAwardSawitpoinRequestReference
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface AdminsCreateAgronomistBookingScheduleRequest
 */
export interface AdminsCreateAgronomistBookingScheduleRequest {
    /**
     * ID of the booking in UUID type 4
     * @type {string}
     * @memberof AdminsCreateAgronomistBookingScheduleRequest
     */
    'bookingId': string;
    /**
     * booking date in string \"dd/mm/yyyy\" format
     * @type {string}
     * @memberof AdminsCreateAgronomistBookingScheduleRequest
     */
    'date': string;
    /**
     * ID of the time slot in UUID type 4
     * @type {string}
     * @memberof AdminsCreateAgronomistBookingScheduleRequest
     */
    'timeSlotId': string;
    /**
     * user ID of the doctor
     * @type {string}
     * @memberof AdminsCreateAgronomistBookingScheduleRequest
     */
    'doctorId'?: string;
    /**
     * 
     * @type {AgronomyBookingScheduleStatusEnum}
     * @memberof AdminsCreateAgronomistBookingScheduleRequest
     */
    'scheduleStatus': AgronomyBookingScheduleStatusEnum;
}


/**
 * 
 * @export
 * @interface AdminsCreateAgronomistBookingScheduleResponse
 */
export interface AdminsCreateAgronomistBookingScheduleResponse {
    /**
     * ID of the created booking Id represented in UUID type 4
     * @type {string}
     * @memberof AdminsCreateAgronomistBookingScheduleResponse
     */
    'bookingScheduleId': string;
}
/**
 * 
 * @export
 * @interface AdminsCreateBannerRequest
 */
export interface AdminsCreateBannerRequest {
    /**
     * Title of a banner
     * @type {string}
     * @memberof AdminsCreateBannerRequest
     */
    'title': string;
    /**
     * Description of a banner that contains more information than the banner\'s title
     * @type {string}
     * @memberof AdminsCreateBannerRequest
     */
    'description': string;
    /**
     * link of a media (image, gif, or video) of a banner to be shown to user. The link must be publicly accessible
     * @type {string}
     * @memberof AdminsCreateBannerRequest
     */
    'link': string;
    /**
     * 
     * @type {BannerTypeEnum}
     * @memberof AdminsCreateBannerRequest
     */
    'type': BannerTypeEnum;
    /**
     * link to be used as deeplink or redirected to other website
     * @type {string}
     * @memberof AdminsCreateBannerRequest
     */
    'embededLink': string;
    /**
     * scopes of banner will be showed
     * @type {Array<string>}
     * @memberof AdminsCreateBannerRequest
     */
    'scopes'?: Array<string>;
}


/**
 * 
 * @export
 * @interface AdminsCreateBannerResponse
 */
export interface AdminsCreateBannerResponse {
    /**
     * ID of the created banner represented in UUID type 4
     * @type {string}
     * @memberof AdminsCreateBannerResponse
     */
    'bannerId': string;
}
/**
 * 
 * @export
 * @interface AdminsDeleteBannerResponse
 */
export interface AdminsDeleteBannerResponse {
    /**
     * 
     * @type {boolean}
     * @memberof AdminsDeleteBannerResponse
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface AdminsEcommerceCreateDigitalProductRequest
 */
export interface AdminsEcommerceCreateDigitalProductRequest {
    /**
     * Enum product status | - ACTIVE - INACTIVE
     * @type {string}
     * @memberof AdminsEcommerceCreateDigitalProductRequest
     */
    'status'?: string;
    /**
     * id of a product category in UUID type 4
     * @type {string}
     * @memberof AdminsEcommerceCreateDigitalProductRequest
     */
    'categoryIId': string;
    /**
     * id of a product category in UUID type 4
     * @type {string}
     * @memberof AdminsEcommerceCreateDigitalProductRequest
     */
    'categoryIIId'?: string;
    /**
     * 
     * @type {VendorEnum}
     * @memberof AdminsEcommerceCreateDigitalProductRequest
     */
    'vendor'?: VendorEnum;
    /**
     * total price of product
     * @type {number}
     * @memberof AdminsEcommerceCreateDigitalProductRequest
     */
    'sellingPrice': number;
    /**
     * vendor total price of product
     * @type {number}
     * @memberof AdminsEcommerceCreateDigitalProductRequest
     */
    'vendorOriginPrice'?: number;
    /**
     * denomination of product
     * @type {string}
     * @memberof AdminsEcommerceCreateDigitalProductRequest
     */
    'vendorDenom'?: string;
    /**
     * sort number
     * @type {number}
     * @memberof AdminsEcommerceCreateDigitalProductRequest
     */
    'sortNo'?: number;
    /**
     * product name
     * @type {string}
     * @memberof AdminsEcommerceCreateDigitalProductRequest
     */
    'name': string;
    /**
     * SKU
     * @type {string}
     * @memberof AdminsEcommerceCreateDigitalProductRequest
     */
    'sku'?: string;
    /**
     * start date utc0 for price list
     * @type {number}
     * @memberof AdminsEcommerceCreateDigitalProductRequest
     */
    'startDateUtc0'?: number;
    /**
     * end date utc0 for price list
     * @type {number}
     * @memberof AdminsEcommerceCreateDigitalProductRequest
     */
    'endDateUtc0'?: number;
    /**
     * image of url product
     * @type {string}
     * @memberof AdminsEcommerceCreateDigitalProductRequest
     */
    'imageURL'?: string;
}


/**
 * 
 * @export
 * @interface AdminsEcommerceCreateDigitalProductResponse
 */
export interface AdminsEcommerceCreateDigitalProductResponse {
    /**
     * product id
     * @type {string}
     * @memberof AdminsEcommerceCreateDigitalProductResponse
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface AdminsEcommerceCreateProductCategoryRequest
 */
export interface AdminsEcommerceCreateProductCategoryRequest {
    /**
     * category name
     * @type {string}
     * @memberof AdminsEcommerceCreateProductCategoryRequest
     */
    'name': string;
    /**
     * status of category | - ACTIVE - INACTIVE
     * @type {string}
     * @memberof AdminsEcommerceCreateProductCategoryRequest
     */
    'status': string;
    /**
     * category description
     * @type {string}
     * @memberof AdminsEcommerceCreateProductCategoryRequest
     */
    'description'?: string;
    /**
     * Max point usage allowed to buy the product (in %)
     * @type {number}
     * @memberof AdminsEcommerceCreateProductCategoryRequest
     */
    'maxPointUsage'?: number;
    /**
     * image of url product
     * @type {string}
     * @memberof AdminsEcommerceCreateProductCategoryRequest
     */
    'imageURL'?: string;
    /**
     * 
     * @type {Array<AdminsEcommerceGetProductCategoryRolePointUsageItem>}
     * @memberof AdminsEcommerceCreateProductCategoryRequest
     */
    'rolePointUsageItems': Array<AdminsEcommerceGetProductCategoryRolePointUsageItem>;
}
/**
 * 
 * @export
 * @interface AdminsEcommerceCreateProductRequest
 */
export interface AdminsEcommerceCreateProductRequest {
    /**
     * id of a product category in UUID type 4
     * @type {string}
     * @memberof AdminsEcommerceCreateProductRequest
     */
    'categoryId'?: string;
    /**
     * product sku
     * @type {string}
     * @memberof AdminsEcommerceCreateProductRequest
     */
    'sku'?: string;
    /**
     * Enum product status | - ACTIVE - INACTIVE
     * @type {string}
     * @memberof AdminsEcommerceCreateProductRequest
     */
    'status'?: string;
    /**
     * product name
     * @type {string}
     * @memberof AdminsEcommerceCreateProductRequest
     */
    'name'?: string;
    /**
     * product description
     * @type {string}
     * @memberof AdminsEcommerceCreateProductRequest
     */
    'description'?: string;
    /**
     * product description
     * @type {string}
     * @memberof AdminsEcommerceCreateProductRequest
     */
    'detailDescription'?: string;
    /**
     * 
     * @type {EcommerceProductUnitOfMeasurementEnum}
     * @memberof AdminsEcommerceCreateProductRequest
     */
    'unitOfMeasurement'?: EcommerceProductUnitOfMeasurementEnum;
    /**
     * unit of measurement product
     * @type {number}
     * @memberof AdminsEcommerceCreateProductRequest
     */
    'productWeight'?: number;
    /**
     * 
     * @type {EcommerceProductDimensionMeasurementEnum}
     * @memberof AdminsEcommerceCreateProductRequest
     */
    'dimensionMeasurement'?: EcommerceProductDimensionMeasurementEnum;
    /**
     * unit of measurement product
     * @type {number}
     * @memberof AdminsEcommerceCreateProductRequest
     */
    'dimensionLength'?: number;
    /**
     * dimension width of product
     * @type {number}
     * @memberof AdminsEcommerceCreateProductRequest
     */
    'dimensionWidth'?: number;
    /**
     * dimention height of product
     * @type {number}
     * @memberof AdminsEcommerceCreateProductRequest
     */
    'dimensionHeight'?: number;
    /**
     * image of url product
     * @type {string}
     * @memberof AdminsEcommerceCreateProductRequest
     */
    'imageURL'?: string;
    /**
     * 
     * @type {EcommerceProductTypeEnum}
     * @memberof AdminsEcommerceCreateProductRequest
     */
    'type': EcommerceProductTypeEnum;
}


/**
 * 
 * @export
 * @interface AdminsEcommerceCreateProductResponse
 */
export interface AdminsEcommerceCreateProductResponse {
    /**
     * product id
     * @type {string}
     * @memberof AdminsEcommerceCreateProductResponse
     */
    'id': string;
}
/**
 * list of digital product
 * @export
 * @interface AdminsEcommerceGetDigitalProductListResponse
 */
export interface AdminsEcommerceGetDigitalProductListResponse {
    /**
     * 
     * @type {Array<AdminsEcommerceGetDigitalProductListResponseItem>}
     * @memberof AdminsEcommerceGetDigitalProductListResponse
     */
    'items': Array<AdminsEcommerceGetDigitalProductListResponseItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof AdminsEcommerceGetDigitalProductListResponse
     */
    'pagination'?: PaginationResponse;
}
/**
 * 
 * @export
 * @interface AdminsEcommerceGetDigitalProductListResponseItem
 */
export interface AdminsEcommerceGetDigitalProductListResponseItem {
    /**
     * product id
     * @type {string}
     * @memberof AdminsEcommerceGetDigitalProductListResponseItem
     */
    'id': string;
    /**
     * Enum product status | - ACTIVE - INACTIVE
     * @type {string}
     * @memberof AdminsEcommerceGetDigitalProductListResponseItem
     */
    'status': string;
    /**
     * id of a product category in UUID type 4
     * @type {string}
     * @memberof AdminsEcommerceGetDigitalProductListResponseItem
     */
    'categoryIId': string;
    /**
     * id of a product category in UUID type 4
     * @type {string}
     * @memberof AdminsEcommerceGetDigitalProductListResponseItem
     */
    'categoryIIId': string;
    /**
     * 
     * @type {VendorEnum}
     * @memberof AdminsEcommerceGetDigitalProductListResponseItem
     */
    'vendor': VendorEnum;
    /**
     * total price of product
     * @type {number}
     * @memberof AdminsEcommerceGetDigitalProductListResponseItem
     */
    'sellingPrice': number;
    /**
     * vendor total price of product
     * @type {number}
     * @memberof AdminsEcommerceGetDigitalProductListResponseItem
     */
    'vendorOriginPrice': number;
    /**
     * denomination of product
     * @type {string}
     * @memberof AdminsEcommerceGetDigitalProductListResponseItem
     */
    'vendorDenom': string;
    /**
     * sort number
     * @type {number}
     * @memberof AdminsEcommerceGetDigitalProductListResponseItem
     */
    'sortNo': number;
    /**
     * product name
     * @type {string}
     * @memberof AdminsEcommerceGetDigitalProductListResponseItem
     */
    'name': string;
    /**
     * SKU
     * @type {string}
     * @memberof AdminsEcommerceGetDigitalProductListResponseItem
     */
    'sku': string;
    /**
     * image of url product
     * @type {string}
     * @memberof AdminsEcommerceGetDigitalProductListResponseItem
     */
    'imageURL': string;
}


/**
 * 
 * @export
 * @interface AdminsEcommerceGetProductCategoryItem
 */
export interface AdminsEcommerceGetProductCategoryItem {
    /**
     * category id
     * @type {string}
     * @memberof AdminsEcommerceGetProductCategoryItem
     */
    'id': string;
    /**
     * category name
     * @type {string}
     * @memberof AdminsEcommerceGetProductCategoryItem
     */
    'name': string;
    /**
     * category code
     * @type {string}
     * @memberof AdminsEcommerceGetProductCategoryItem
     */
    'code': string;
    /**
     * Max point usage allowed to buy the product (in %)
     * @type {number}
     * @memberof AdminsEcommerceGetProductCategoryItem
     */
    'maxPointUsage': number;
    /**
     * 
     * @type {Array<AdminsEcommerceGetProductCategoryRolePointUsageItem>}
     * @memberof AdminsEcommerceGetProductCategoryItem
     */
    'rolePointUsageItems': Array<AdminsEcommerceGetProductCategoryRolePointUsageItem>;
}
/**
 * list of product category
 * @export
 * @interface AdminsEcommerceGetProductCategoryResponse
 */
export interface AdminsEcommerceGetProductCategoryResponse {
    /**
     * 
     * @type {Array<AdminsEcommerceGetProductCategoryItem>}
     * @memberof AdminsEcommerceGetProductCategoryResponse
     */
    'items': Array<AdminsEcommerceGetProductCategoryItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof AdminsEcommerceGetProductCategoryResponse
     */
    'pagination'?: PaginationResponse;
}
/**
 * 
 * @export
 * @interface AdminsEcommerceGetProductCategoryRolePointUsageItem
 */
export interface AdminsEcommerceGetProductCategoryRolePointUsageItem {
    /**
     * 
     * @type {UserRoleEnum}
     * @memberof AdminsEcommerceGetProductCategoryRolePointUsageItem
     */
    'role': UserRoleEnum;
    /**
     * Max point usage allowed to buy the product (in %)
     * @type {number}
     * @memberof AdminsEcommerceGetProductCategoryRolePointUsageItem
     */
    'maxPointUsage': number;
}


/**
 * 
 * @export
 * @interface AdminsEcommerceGetProductDetailResponse
 */
export interface AdminsEcommerceGetProductDetailResponse {
    /**
     * product id
     * @type {string}
     * @memberof AdminsEcommerceGetProductDetailResponse
     */
    'id': string;
    /**
     * product name
     * @type {string}
     * @memberof AdminsEcommerceGetProductDetailResponse
     */
    'name': string;
    /**
     * 
     * @type {EcommerceProductTypeEnum}
     * @memberof AdminsEcommerceGetProductDetailResponse
     */
    'type': EcommerceProductTypeEnum;
    /**
     * product category id
     * @type {string}
     * @memberof AdminsEcommerceGetProductDetailResponse
     */
    'categoryId': string;
    /**
     * category name
     * @type {string}
     * @memberof AdminsEcommerceGetProductDetailResponse
     */
    'categoryName': string;
    /**
     * product sku
     * @type {string}
     * @memberof AdminsEcommerceGetProductDetailResponse
     */
    'sku': string;
    /**
     * Enum product status | - ACTIVE - INACTIVE
     * @type {string}
     * @memberof AdminsEcommerceGetProductDetailResponse
     */
    'status': string;
    /**
     * product description
     * @type {string}
     * @memberof AdminsEcommerceGetProductDetailResponse
     */
    'description': string;
    /**
     * product description
     * @type {string}
     * @memberof AdminsEcommerceGetProductDetailResponse
     */
    'detailDescription': string;
    /**
     * 
     * @type {EcommerceProductUnitOfMeasurementEnum}
     * @memberof AdminsEcommerceGetProductDetailResponse
     */
    'unitOfMeasurement': EcommerceProductUnitOfMeasurementEnum;
    /**
     * unit of measurement product
     * @type {number}
     * @memberof AdminsEcommerceGetProductDetailResponse
     */
    'productWeight': number;
    /**
     * 
     * @type {EcommerceProductDimensionMeasurementEnum}
     * @memberof AdminsEcommerceGetProductDetailResponse
     */
    'dimensionMeasurement': EcommerceProductDimensionMeasurementEnum;
    /**
     * unit of measurement product
     * @type {number}
     * @memberof AdminsEcommerceGetProductDetailResponse
     */
    'dimensionLength': number;
    /**
     * dimension width of product
     * @type {number}
     * @memberof AdminsEcommerceGetProductDetailResponse
     */
    'dimensionWidth': number;
    /**
     * dimension height of product
     * @type {number}
     * @memberof AdminsEcommerceGetProductDetailResponse
     */
    'dimensionHeight': number;
    /**
     * image of url product
     * @type {string}
     * @memberof AdminsEcommerceGetProductDetailResponse
     */
    'imageURL': string;
}


/**
 * 
 * @export
 * @interface AdminsEcommerceInventoryStockLocationCreateRequest
 */
export interface AdminsEcommerceInventoryStockLocationCreateRequest {
    /**
     * Stock Location Name
     * @type {string}
     * @memberof AdminsEcommerceInventoryStockLocationCreateRequest
     */
    'name': string;
    /**
     * Stock Location Owner Name
     * @type {string}
     * @memberof AdminsEcommerceInventoryStockLocationCreateRequest
     */
    'ownerName': string;
    /**
     * Stock Location Owner Phone Number
     * @type {string}
     * @memberof AdminsEcommerceInventoryStockLocationCreateRequest
     */
    'ownerPhoneNo': string;
    /**
     * Stock Location Address
     * @type {string}
     * @memberof AdminsEcommerceInventoryStockLocationCreateRequest
     */
    'address': string;
    /**
     * Stock Location Province
     * @type {string}
     * @memberof AdminsEcommerceInventoryStockLocationCreateRequest
     */
    'province': string;
    /**
     * Stock Location City
     * @type {string}
     * @memberof AdminsEcommerceInventoryStockLocationCreateRequest
     */
    'city': string;
    /**
     * Short Name for Invoice Code
     * @type {string}
     * @memberof AdminsEcommerceInventoryStockLocationCreateRequest
     */
    'invoiceCode': string;
    /**
     * Stock Location Latitude
     * @type {number}
     * @memberof AdminsEcommerceInventoryStockLocationCreateRequest
     */
    'latitude': number;
    /**
     * Stock Location Longitude
     * @type {number}
     * @memberof AdminsEcommerceInventoryStockLocationCreateRequest
     */
    'longitude': number;
    /**
     * Stock Location Open Hour
     * @type {string}
     * @memberof AdminsEcommerceInventoryStockLocationCreateRequest
     */
    'openHour': string;
    /**
     * Stock Location Close Hour
     * @type {string}
     * @memberof AdminsEcommerceInventoryStockLocationCreateRequest
     */
    'closeHour': string;
    /**
     * Flag Shown in Member App
     * @type {boolean}
     * @memberof AdminsEcommerceInventoryStockLocationCreateRequest
     */
    'isShownMember': boolean;
    /**
     * Flag Shown in Worker App
     * @type {boolean}
     * @memberof AdminsEcommerceInventoryStockLocationCreateRequest
     */
    'isShownWorker': boolean;
    /**
     * 
     * @type {StockLocationStatusEnum}
     * @memberof AdminsEcommerceInventoryStockLocationCreateRequest
     */
    'status': StockLocationStatusEnum;
    /**
     * ID of the Partner (mills) represented in UUID type 4
     * @type {string}
     * @memberof AdminsEcommerceInventoryStockLocationCreateRequest
     */
    'partnerId'?: string;
    /**
     * ID of the Vendor (mills) represented in UUID type 4
     * @type {string}
     * @memberof AdminsEcommerceInventoryStockLocationCreateRequest
     */
    'vendorId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminsEcommerceInventoryStockLocationCreateRequest
     */
    'imageUrlItems'?: Array<string>;
    /**
     * Reference point location
     * @type {string}
     * @memberof AdminsEcommerceInventoryStockLocationCreateRequest
     */
    'referenceLocation'?: string;
}


/**
 * 
 * @export
 * @interface AdminsEcommerceInventoryStockLocationDetailResponse
 */
export interface AdminsEcommerceInventoryStockLocationDetailResponse {
    /**
     * Stock Location UUID
     * @type {string}
     * @memberof AdminsEcommerceInventoryStockLocationDetailResponse
     */
    'id': string;
    /**
     * Stock Location Name
     * @type {string}
     * @memberof AdminsEcommerceInventoryStockLocationDetailResponse
     */
    'name': string;
    /**
     * Stock Location Owner Name
     * @type {string}
     * @memberof AdminsEcommerceInventoryStockLocationDetailResponse
     */
    'ownerName': string;
    /**
     * Stock Location Owner Phone Number
     * @type {string}
     * @memberof AdminsEcommerceInventoryStockLocationDetailResponse
     */
    'ownerPhoneNo': string;
    /**
     * Stock Location Address
     * @type {string}
     * @memberof AdminsEcommerceInventoryStockLocationDetailResponse
     */
    'address': string;
    /**
     * Stock Location Province
     * @type {string}
     * @memberof AdminsEcommerceInventoryStockLocationDetailResponse
     */
    'province': string;
    /**
     * Stock Location City
     * @type {string}
     * @memberof AdminsEcommerceInventoryStockLocationDetailResponse
     */
    'city': string;
    /**
     * Short Name for Invoice Code
     * @type {string}
     * @memberof AdminsEcommerceInventoryStockLocationDetailResponse
     */
    'invoiceCode': string;
    /**
     * Stock Location Latitude
     * @type {number}
     * @memberof AdminsEcommerceInventoryStockLocationDetailResponse
     */
    'latitude': number;
    /**
     * Stock Location Longitude
     * @type {number}
     * @memberof AdminsEcommerceInventoryStockLocationDetailResponse
     */
    'longitude': number;
    /**
     * Stock Location Open Hour
     * @type {string}
     * @memberof AdminsEcommerceInventoryStockLocationDetailResponse
     */
    'openHour': string;
    /**
     * Stock Location Close Hour
     * @type {string}
     * @memberof AdminsEcommerceInventoryStockLocationDetailResponse
     */
    'closeHour': string;
    /**
     * Flag Shown in Member App
     * @type {boolean}
     * @memberof AdminsEcommerceInventoryStockLocationDetailResponse
     */
    'isShownMember': boolean;
    /**
     * Flag Shown in Worker App
     * @type {boolean}
     * @memberof AdminsEcommerceInventoryStockLocationDetailResponse
     */
    'isShownWorker': boolean;
    /**
     * 
     * @type {StockLocationStatusEnum}
     * @memberof AdminsEcommerceInventoryStockLocationDetailResponse
     */
    'status': StockLocationStatusEnum;
    /**
     * ID of the Partner (mills) represented in UUID type 4
     * @type {string}
     * @memberof AdminsEcommerceInventoryStockLocationDetailResponse
     */
    'partnerId': string;
    /**
     * ID of the Vendor represented in UUID type 4
     * @type {string}
     * @memberof AdminsEcommerceInventoryStockLocationDetailResponse
     */
    'vendorId': string;
    /**
     * Name of the Vendor
     * @type {string}
     * @memberof AdminsEcommerceInventoryStockLocationDetailResponse
     */
    'vendorName': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminsEcommerceInventoryStockLocationDetailResponse
     */
    'imageUrlItems': Array<string>;
    /**
     * Reference point location
     * @type {string}
     * @memberof AdminsEcommerceInventoryStockLocationDetailResponse
     */
    'referenceLocation': string;
}


/**
 * Response data
 * @export
 * @interface AdminsEcommerceInventoryStockLocationListResponse
 */
export interface AdminsEcommerceInventoryStockLocationListResponse {
    /**
     * List of Stock Location Item
     * @type {Array<AdminsEcommerceInventoryStockLocationListResponseItem>}
     * @memberof AdminsEcommerceInventoryStockLocationListResponse
     */
    'items': Array<AdminsEcommerceInventoryStockLocationListResponseItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof AdminsEcommerceInventoryStockLocationListResponse
     */
    'pagination': PaginationResponse;
}
/**
 * 
 * @export
 * @interface AdminsEcommerceInventoryStockLocationListResponseItem
 */
export interface AdminsEcommerceInventoryStockLocationListResponseItem {
    /**
     * Stock Location UUID
     * @type {string}
     * @memberof AdminsEcommerceInventoryStockLocationListResponseItem
     */
    'id': string;
    /**
     * Stock Location Name
     * @type {string}
     * @memberof AdminsEcommerceInventoryStockLocationListResponseItem
     */
    'name': string;
    /**
     * Stock Location City
     * @type {string}
     * @memberof AdminsEcommerceInventoryStockLocationListResponseItem
     */
    'city': string;
    /**
     * Stock Location Open Hour
     * @type {string}
     * @memberof AdminsEcommerceInventoryStockLocationListResponseItem
     */
    'openHour': string;
    /**
     * Stock Location Close Hour
     * @type {string}
     * @memberof AdminsEcommerceInventoryStockLocationListResponseItem
     */
    'closeHour': string;
    /**
     * 
     * @type {StockLocationStatusEnum}
     * @memberof AdminsEcommerceInventoryStockLocationListResponseItem
     */
    'status': StockLocationStatusEnum;
    /**
     * ID of the Vendor represented in UUID type 4 (random) this for backward compatibility, we used uuid with type sting, some of store didn\'t vendor 
     * @type {string}
     * @memberof AdminsEcommerceInventoryStockLocationListResponseItem
     */
    'vendorId': string;
    /**
     * Name of the Vendor
     * @type {string}
     * @memberof AdminsEcommerceInventoryStockLocationListResponseItem
     */
    'vendorName': string;
}


/**
 * 
 * @export
 * @interface AdminsEcommerceInventoryStockLocationUpdateRequest
 */
export interface AdminsEcommerceInventoryStockLocationUpdateRequest {
    /**
     * Stock Location Name
     * @type {string}
     * @memberof AdminsEcommerceInventoryStockLocationUpdateRequest
     */
    'name': string;
    /**
     * Stock Location Owner Name
     * @type {string}
     * @memberof AdminsEcommerceInventoryStockLocationUpdateRequest
     */
    'ownerName': string;
    /**
     * Stock Location Owner Phone Number
     * @type {string}
     * @memberof AdminsEcommerceInventoryStockLocationUpdateRequest
     */
    'ownerPhoneNo': string;
    /**
     * Stock Location Address
     * @type {string}
     * @memberof AdminsEcommerceInventoryStockLocationUpdateRequest
     */
    'address': string;
    /**
     * Stock Location Province
     * @type {string}
     * @memberof AdminsEcommerceInventoryStockLocationUpdateRequest
     */
    'province': string;
    /**
     * Stock Location City
     * @type {string}
     * @memberof AdminsEcommerceInventoryStockLocationUpdateRequest
     */
    'city': string;
    /**
     * Short Name for Invoice Code
     * @type {string}
     * @memberof AdminsEcommerceInventoryStockLocationUpdateRequest
     */
    'invoiceCode': string;
    /**
     * Stock Location Latitude
     * @type {number}
     * @memberof AdminsEcommerceInventoryStockLocationUpdateRequest
     */
    'latitude': number;
    /**
     * Stock Location Longitude
     * @type {number}
     * @memberof AdminsEcommerceInventoryStockLocationUpdateRequest
     */
    'longitude': number;
    /**
     * Stock Location Open Hour
     * @type {string}
     * @memberof AdminsEcommerceInventoryStockLocationUpdateRequest
     */
    'openHour': string;
    /**
     * Stock Location Close Hour
     * @type {string}
     * @memberof AdminsEcommerceInventoryStockLocationUpdateRequest
     */
    'closeHour': string;
    /**
     * Flag Shown in Member App
     * @type {boolean}
     * @memberof AdminsEcommerceInventoryStockLocationUpdateRequest
     */
    'isShownMember': boolean;
    /**
     * Flag Shown in Worker App
     * @type {boolean}
     * @memberof AdminsEcommerceInventoryStockLocationUpdateRequest
     */
    'isShownWorker': boolean;
    /**
     * 
     * @type {StockLocationStatusEnum}
     * @memberof AdminsEcommerceInventoryStockLocationUpdateRequest
     */
    'status': StockLocationStatusEnum;
    /**
     * ID of the Partner (mills) represented in UUID type 4
     * @type {string}
     * @memberof AdminsEcommerceInventoryStockLocationUpdateRequest
     */
    'partnerId': string;
    /**
     * ID of the Vendor (mills) represented in UUID type 4
     * @type {string}
     * @memberof AdminsEcommerceInventoryStockLocationUpdateRequest
     */
    'vendorId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminsEcommerceInventoryStockLocationUpdateRequest
     */
    'imageUrlItems'?: Array<string>;
    /**
     * Reference point location
     * @type {string}
     * @memberof AdminsEcommerceInventoryStockLocationUpdateRequest
     */
    'referenceLocation'?: string;
}


/**
 * 
 * @export
 * @interface AdminsEcommerceInventoryStockLocationUpdateResponse
 */
export interface AdminsEcommerceInventoryStockLocationUpdateResponse {
    /**
     * Stock Location UUID
     * @type {string}
     * @memberof AdminsEcommerceInventoryStockLocationUpdateResponse
     */
    'id': string;
    /**
     * Stock Location Name
     * @type {string}
     * @memberof AdminsEcommerceInventoryStockLocationUpdateResponse
     */
    'name': string;
    /**
     * Stock Location Owner Name
     * @type {string}
     * @memberof AdminsEcommerceInventoryStockLocationUpdateResponse
     */
    'ownerName': string;
    /**
     * Stock Location Owner Phone No
     * @type {string}
     * @memberof AdminsEcommerceInventoryStockLocationUpdateResponse
     */
    'ownerPhoneNo': string;
    /**
     * Stock Location Address
     * @type {string}
     * @memberof AdminsEcommerceInventoryStockLocationUpdateResponse
     */
    'address': string;
    /**
     * Stock Location Province
     * @type {string}
     * @memberof AdminsEcommerceInventoryStockLocationUpdateResponse
     */
    'province': string;
    /**
     * Stock Location City
     * @type {string}
     * @memberof AdminsEcommerceInventoryStockLocationUpdateResponse
     */
    'city': string;
    /**
     * Short Name for Invoice Code
     * @type {string}
     * @memberof AdminsEcommerceInventoryStockLocationUpdateResponse
     */
    'invoiceCode': string;
    /**
     * Stock Location Latitude
     * @type {number}
     * @memberof AdminsEcommerceInventoryStockLocationUpdateResponse
     */
    'latitude': number;
    /**
     * Stock Location Longitude
     * @type {number}
     * @memberof AdminsEcommerceInventoryStockLocationUpdateResponse
     */
    'longitude': number;
    /**
     * Stock Location Open Hour
     * @type {string}
     * @memberof AdminsEcommerceInventoryStockLocationUpdateResponse
     */
    'openHour': string;
    /**
     * Stock Location Close Hour
     * @type {string}
     * @memberof AdminsEcommerceInventoryStockLocationUpdateResponse
     */
    'closeHour': string;
    /**
     * Flag Shown in Member App
     * @type {boolean}
     * @memberof AdminsEcommerceInventoryStockLocationUpdateResponse
     */
    'isShownMember': boolean;
    /**
     * Flag Shown in Worker App
     * @type {boolean}
     * @memberof AdminsEcommerceInventoryStockLocationUpdateResponse
     */
    'isShownWorker': boolean;
    /**
     * 
     * @type {StockLocationStatusEnum}
     * @memberof AdminsEcommerceInventoryStockLocationUpdateResponse
     */
    'status': StockLocationStatusEnum;
    /**
     * ID of the Vendor represented in UUID type 4
     * @type {string}
     * @memberof AdminsEcommerceInventoryStockLocationUpdateResponse
     */
    'vendorId': string;
    /**
     * Name of the Vendor
     * @type {string}
     * @memberof AdminsEcommerceInventoryStockLocationUpdateResponse
     */
    'vendorName': string;
}


/**
 * 
 * @export
 * @interface AdminsEcommerceProductGetResponse
 */
export interface AdminsEcommerceProductGetResponse {
    /**
     * 
     * @type {Array<AdminsGetProductListResponse>}
     * @memberof AdminsEcommerceProductGetResponse
     */
    'items': Array<AdminsGetProductListResponse>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof AdminsEcommerceProductGetResponse
     */
    'pagination': PaginationResponse;
}
/**
 * 
 * @export
 * @interface AdminsEcommerceProductPriceListsCreateRequest
 */
export interface AdminsEcommerceProductPriceListsCreateRequest {
    /**
     * product id
     * @type {string}
     * @memberof AdminsEcommerceProductPriceListsCreateRequest
     */
    'productId': string;
    /**
     * store id
     * @type {string}
     * @memberof AdminsEcommerceProductPriceListsCreateRequest
     */
    'storeId': string;
    /**
     * price
     * @type {number}
     * @memberof AdminsEcommerceProductPriceListsCreateRequest
     */
    'price': number;
    /**
     * start date utc0 for price list
     * @type {number}
     * @memberof AdminsEcommerceProductPriceListsCreateRequest
     */
    'startDateUtc0': number;
    /**
     * end date utc0 for price list
     * @type {number}
     * @memberof AdminsEcommerceProductPriceListsCreateRequest
     */
    'endDateUtc0': number;
    /**
     * is show member
     * @type {boolean}
     * @memberof AdminsEcommerceProductPriceListsCreateRequest
     */
    'isShowMember'?: boolean;
    /**
     * is show worker
     * @type {boolean}
     * @memberof AdminsEcommerceProductPriceListsCreateRequest
     */
    'isShowWorker'?: boolean;
    /**
     * is show farmer
     * @type {boolean}
     * @memberof AdminsEcommerceProductPriceListsCreateRequest
     */
    'isShowFarmer'?: boolean;
    /**
     * is show ambassador
     * @type {boolean}
     * @memberof AdminsEcommerceProductPriceListsCreateRequest
     */
    'isShowAmbassador'?: boolean;
    /**
     * is active
     * @type {boolean}
     * @memberof AdminsEcommerceProductPriceListsCreateRequest
     */
    'isActive'?: boolean;
    /**
     * minimum order
     * @type {number}
     * @memberof AdminsEcommerceProductPriceListsCreateRequest
     */
    'minimumOrder': number;
    /**
     * preparation duration
     * @type {number}
     * @memberof AdminsEcommerceProductPriceListsCreateRequest
     */
    'preparationDuration': number;
    /**
     * this is for goods inquiry
     * @type {boolean}
     * @memberof AdminsEcommerceProductPriceListsCreateRequest
     */
    'isInquiryAllowed'?: boolean;
    /**
     * 
     * @type {Array<AdminsEcommerceProductPriceListsCreateRequestPrices>}
     * @memberof AdminsEcommerceProductPriceListsCreateRequest
     */
    'prices'?: Array<AdminsEcommerceProductPriceListsCreateRequestPrices>;
}
/**
 * 
 * @export
 * @interface AdminsEcommerceProductPriceListsCreateRequestPrices
 */
export interface AdminsEcommerceProductPriceListsCreateRequestPrices {
    /**
     * Product Price for Current Tier
     * @type {number}
     * @memberof AdminsEcommerceProductPriceListsCreateRequestPrices
     */
    'price': number;
    /**
     * Minimum Quantity for Current Tier
     * @type {number}
     * @memberof AdminsEcommerceProductPriceListsCreateRequestPrices
     */
    'minimumQuantity': number;
    /**
     * Maximum Quantity for Current Tier
     * @type {number}
     * @memberof AdminsEcommerceProductPriceListsCreateRequestPrices
     */
    'maximumQuantity'?: number;
}
/**
 * 
 * @export
 * @interface AdminsEcommerceProductPriceListsCreateResponse
 */
export interface AdminsEcommerceProductPriceListsCreateResponse {
    /**
     * price id
     * @type {string}
     * @memberof AdminsEcommerceProductPriceListsCreateResponse
     */
    'id': string;
    /**
     * IDs of created price list
     * @type {Array<string>}
     * @memberof AdminsEcommerceProductPriceListsCreateResponse
     */
    'ids'?: Array<string>;
}
/**
 * 
 * @export
 * @interface AdminsEcommerceProductPriceListsUpdateRequest
 */
export interface AdminsEcommerceProductPriceListsUpdateRequest {
    /**
     * product id
     * @type {string}
     * @memberof AdminsEcommerceProductPriceListsUpdateRequest
     */
    'productId': string;
    /**
     * store id
     * @type {string}
     * @memberof AdminsEcommerceProductPriceListsUpdateRequest
     */
    'storeId': string;
    /**
     * price
     * @type {number}
     * @memberof AdminsEcommerceProductPriceListsUpdateRequest
     */
    'price': number;
    /**
     * start date utc0 for price list
     * @type {number}
     * @memberof AdminsEcommerceProductPriceListsUpdateRequest
     */
    'startDateUtc0': number;
    /**
     * end date utc0 for price list
     * @type {number}
     * @memberof AdminsEcommerceProductPriceListsUpdateRequest
     */
    'endDateUtc0': number;
    /**
     * is show member
     * @type {boolean}
     * @memberof AdminsEcommerceProductPriceListsUpdateRequest
     */
    'isShowMember'?: boolean;
    /**
     * is show worker
     * @type {boolean}
     * @memberof AdminsEcommerceProductPriceListsUpdateRequest
     */
    'isShowWorker'?: boolean;
    /**
     * is active
     * @type {boolean}
     * @memberof AdminsEcommerceProductPriceListsUpdateRequest
     */
    'isActive'?: boolean;
    /**
     * minimum order
     * @type {number}
     * @memberof AdminsEcommerceProductPriceListsUpdateRequest
     */
    'minimumOrder': number;
    /**
     * preparation duration
     * @type {number}
     * @memberof AdminsEcommerceProductPriceListsUpdateRequest
     */
    'preparationDuration': number;
    /**
     * this is for product goods inquiry
     * @type {boolean}
     * @memberof AdminsEcommerceProductPriceListsUpdateRequest
     */
    'isInquiryAllowed'?: boolean;
}
/**
 * Response data update pricelist
 * @export
 * @interface AdminsEcommerceProductPriceListsUpdateResponse
 */
export interface AdminsEcommerceProductPriceListsUpdateResponse {
    /**
     * pricelist id
     * @type {string}
     * @memberof AdminsEcommerceProductPriceListsUpdateResponse
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface AdminsEcommerceProductPriceListsUpdateV2Request
 */
export interface AdminsEcommerceProductPriceListsUpdateV2Request {
    /**
     * product id
     * @type {string}
     * @memberof AdminsEcommerceProductPriceListsUpdateV2Request
     */
    'productId': string;
    /**
     * store id
     * @type {string}
     * @memberof AdminsEcommerceProductPriceListsUpdateV2Request
     */
    'storeId': string;
    /**
     * start date utc0 for price list
     * @type {number}
     * @memberof AdminsEcommerceProductPriceListsUpdateV2Request
     */
    'previousStartDateUtc0': number;
    /**
     * end date utc0 for price list
     * @type {number}
     * @memberof AdminsEcommerceProductPriceListsUpdateV2Request
     */
    'previousEndDateUtc0': number;
    /**
     * start date utc0 for price list
     * @type {number}
     * @memberof AdminsEcommerceProductPriceListsUpdateV2Request
     */
    'startDateUtc0': number;
    /**
     * end date utc0 for price list
     * @type {number}
     * @memberof AdminsEcommerceProductPriceListsUpdateV2Request
     */
    'endDateUtc0': number;
    /**
     * is show member
     * @type {boolean}
     * @memberof AdminsEcommerceProductPriceListsUpdateV2Request
     */
    'isShowMember'?: boolean;
    /**
     * is show worker
     * @type {boolean}
     * @memberof AdminsEcommerceProductPriceListsUpdateV2Request
     */
    'isShowWorker'?: boolean;
    /**
     * is show farmer
     * @type {boolean}
     * @memberof AdminsEcommerceProductPriceListsUpdateV2Request
     */
    'isShowFarmer'?: boolean;
    /**
     * is show ambassador
     * @type {boolean}
     * @memberof AdminsEcommerceProductPriceListsUpdateV2Request
     */
    'isShowAmbassador'?: boolean;
    /**
     * is active
     * @type {boolean}
     * @memberof AdminsEcommerceProductPriceListsUpdateV2Request
     */
    'isActive'?: boolean;
    /**
     * preparation duration
     * @type {number}
     * @memberof AdminsEcommerceProductPriceListsUpdateV2Request
     */
    'preparationDuration': number;
    /**
     * this is for product goods inquiry
     * @type {boolean}
     * @memberof AdminsEcommerceProductPriceListsUpdateV2Request
     */
    'isInquiryAllowed'?: boolean;
    /**
     * 
     * @type {Array<AdminsEcommerceProductPriceListsUpdateV2RequestPrices>}
     * @memberof AdminsEcommerceProductPriceListsUpdateV2Request
     */
    'prices': Array<AdminsEcommerceProductPriceListsUpdateV2RequestPrices>;
}
/**
 * 
 * @export
 * @interface AdminsEcommerceProductPriceListsUpdateV2RequestPrices
 */
export interface AdminsEcommerceProductPriceListsUpdateV2RequestPrices {
    /**
     * Product Price for Current Tier
     * @type {number}
     * @memberof AdminsEcommerceProductPriceListsUpdateV2RequestPrices
     */
    'price': number;
    /**
     * Minimum Quantity for Current Tier
     * @type {number}
     * @memberof AdminsEcommerceProductPriceListsUpdateV2RequestPrices
     */
    'minimumQuantity': number;
    /**
     * Maximum Quantity for Current Tier
     * @type {number}
     * @memberof AdminsEcommerceProductPriceListsUpdateV2RequestPrices
     */
    'maximumQuantity'?: number;
}
/**
 * Response data update pricelist
 * @export
 * @interface AdminsEcommerceProductPriceListsUpdateV2Response
 */
export interface AdminsEcommerceProductPriceListsUpdateV2Response {
    /**
     * IDs of created price list
     * @type {Array<string>}
     * @memberof AdminsEcommerceProductPriceListsUpdateV2Response
     */
    'ids'?: Array<string>;
}
/**
 * 
 * @export
 * @interface AdminsEcommerceProductPricelistGetDetailResponse
 */
export interface AdminsEcommerceProductPricelistGetDetailResponse {
    /**
     * Pricelist ID represented in UUID
     * @type {string}
     * @memberof AdminsEcommerceProductPricelistGetDetailResponse
     */
    'pricelistId': string;
    /**
     * Stock Location ID represented in UUID
     * @type {string}
     * @memberof AdminsEcommerceProductPricelistGetDetailResponse
     */
    'stockLocationId': string;
    /**
     * Product ID represented in UUID
     * @type {string}
     * @memberof AdminsEcommerceProductPricelistGetDetailResponse
     */
    'productId': string;
    /**
     * Product Name
     * @type {string}
     * @memberof AdminsEcommerceProductPricelistGetDetailResponse
     */
    'productName': string;
    /**
     * Current Product Price
     * @type {number}
     * @memberof AdminsEcommerceProductPricelistGetDetailResponse
     */
    'price': number;
    /**
     * Current product price start time (in epoch) formatted in UTC-0
     * @type {number}
     * @memberof AdminsEcommerceProductPricelistGetDetailResponse
     */
    'priceStartTimeUtc0': number;
    /**
     * Current product price end time (in epoch) formatted in UTC-0
     * @type {number}
     * @memberof AdminsEcommerceProductPricelistGetDetailResponse
     */
    'priceEndTimeUtc0': number;
    /**
     * Max point usage allowed to buy the product (in %)
     * @type {number}
     * @memberof AdminsEcommerceProductPricelistGetDetailResponse
     */
    'maxPointUsage': number;
    /**
     * Day needed to prepare this product
     * @type {number}
     * @memberof AdminsEcommerceProductPricelistGetDetailResponse
     */
    'preparationDuration': number;
    /**
     * Minimum order allowed to buy the product
     * @type {number}
     * @memberof AdminsEcommerceProductPricelistGetDetailResponse
     */
    'minimumOrder': number;
    /**
     * Current Product Minimum Stock Balance
     * @type {number}
     * @memberof AdminsEcommerceProductPricelistGetDetailResponse
     */
    'minimumStock': number;
    /**
     * Current Product Stock Balance
     * @type {number}
     * @memberof AdminsEcommerceProductPricelistGetDetailResponse
     */
    'stock': number;
    /**
     * Whether the product is displayed or not in the Member App
     * @type {boolean}
     * @memberof AdminsEcommerceProductPricelistGetDetailResponse
     */
    'isShownMember': boolean;
    /**
     * Whether the product is displayed or not in the Worker App
     * @type {boolean}
     * @memberof AdminsEcommerceProductPricelistGetDetailResponse
     */
    'isShownWorker': boolean;
    /**
     * Whether it is allowed or not to use point to buy the product
     * @type {boolean}
     * @memberof AdminsEcommerceProductPricelistGetDetailResponse
     */
    'isPointAllowed': boolean;
    /**
     * Whether it is allowed or not to use pick up as delivery type
     * @type {boolean}
     * @memberof AdminsEcommerceProductPricelistGetDetailResponse
     */
    'isPickUpAllowed': boolean;
    /**
     * Whether it is allowed or not to cancel the order of this product
     * @type {boolean}
     * @memberof AdminsEcommerceProductPricelistGetDetailResponse
     */
    'isCancellable': boolean;
    /**
     * 
     * @type {EcommerceProductStatusEnum}
     * @memberof AdminsEcommerceProductPricelistGetDetailResponse
     */
    'status': EcommerceProductStatusEnum;
    /**
     * Whether it is allowed or not to use product goods inquiry
     * @type {boolean}
     * @memberof AdminsEcommerceProductPricelistGetDetailResponse
     */
    'isInquiryAllowed': boolean;
    /**
     * Is show farmer
     * @type {boolean}
     * @memberof AdminsEcommerceProductPricelistGetDetailResponse
     */
    'isShownFarmer': boolean;
    /**
     * Is show duta
     * @type {boolean}
     * @memberof AdminsEcommerceProductPricelistGetDetailResponse
     */
    'isShownAmbassador': boolean;
    /**
     * 
     * @type {Array<AdminsEcommerceProductPricelistGetDetailResponseItem>}
     * @memberof AdminsEcommerceProductPricelistGetDetailResponse
     */
    'prices': Array<AdminsEcommerceProductPricelistGetDetailResponseItem>;
}


/**
 * 
 * @export
 * @interface AdminsEcommerceProductPricelistGetDetailResponseItem
 */
export interface AdminsEcommerceProductPricelistGetDetailResponseItem {
    /**
     * Pricelist ID represented in UUID
     * @type {string}
     * @memberof AdminsEcommerceProductPricelistGetDetailResponseItem
     */
    'id': string;
    /**
     * Current Product Price
     * @type {number}
     * @memberof AdminsEcommerceProductPricelistGetDetailResponseItem
     */
    'price': number;
    /**
     * minimum Order
     * @type {number}
     * @memberof AdminsEcommerceProductPricelistGetDetailResponseItem
     */
    'minimumQuantity': number;
    /**
     * Maximum Order, this is not mandatory in reponse  if ther is value is null that mean the product has no maximum order 
     * @type {number}
     * @memberof AdminsEcommerceProductPricelistGetDetailResponseItem
     */
    'maximumQuantity'?: number;
    /**
     * Start Date UTC 0
     * @type {number}
     * @memberof AdminsEcommerceProductPricelistGetDetailResponseItem
     */
    'startDateUtc0': number;
    /**
     * End Date UTC 0
     * @type {number}
     * @memberof AdminsEcommerceProductPricelistGetDetailResponseItem
     */
    'endDateUtc0': number;
}
/**
 * 
 * @export
 * @interface AdminsEcommerceProductPricelistListResponse
 */
export interface AdminsEcommerceProductPricelistListResponse {
    /**
     * 
     * @type {Array<AdminsEcommerceProductPricelistListResponseItem>}
     * @memberof AdminsEcommerceProductPricelistListResponse
     */
    'items': Array<AdminsEcommerceProductPricelistListResponseItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof AdminsEcommerceProductPricelistListResponse
     */
    'pagination': PaginationResponse;
}
/**
 * 
 * @export
 * @interface AdminsEcommerceProductPricelistListResponseItem
 */
export interface AdminsEcommerceProductPricelistListResponseItem {
    /**
     * Pricelist ID represented in UUID
     * @type {string}
     * @memberof AdminsEcommerceProductPricelistListResponseItem
     */
    'pricelistId': string;
    /**
     * Stock Location ID represented in UUID, this is store location
     * @type {string}
     * @memberof AdminsEcommerceProductPricelistListResponseItem
     */
    'stockLocationId': string;
    /**
     * Product ID represented in UUID
     * @type {string}
     * @memberof AdminsEcommerceProductPricelistListResponseItem
     */
    'productId': string;
    /**
     * Stock ID represented in UUID
     * @type {string}
     * @memberof AdminsEcommerceProductPricelistListResponseItem
     */
    'stockId': string;
    /**
     * Product Name
     * @type {string}
     * @memberof AdminsEcommerceProductPricelistListResponseItem
     */
    'productName': string;
    /**
     * Current Product Price
     * @type {number}
     * @memberof AdminsEcommerceProductPricelistListResponseItem
     */
    'price': number;
    /**
     * Current Product Stock Balance
     * @type {number}
     * @memberof AdminsEcommerceProductPricelistListResponseItem
     */
    'stock': number;
    /**
     * Day needed to prepare the product
     * @type {number}
     * @memberof AdminsEcommerceProductPricelistListResponseItem
     */
    'preparationDuration': number;
    /**
     * 
     * @type {EcommerceProductStatusEnum}
     * @memberof AdminsEcommerceProductPricelistListResponseItem
     */
    'status': EcommerceProductStatusEnum;
    /**
     * Is inquiry allowed
     * @type {boolean}
     * @memberof AdminsEcommerceProductPricelistListResponseItem
     */
    'isInquiryAllowed': boolean;
    /**
     * Is show member
     * @type {boolean}
     * @memberof AdminsEcommerceProductPricelistListResponseItem
     */
    'isShowMember': boolean;
    /**
     * Is show worker
     * @type {boolean}
     * @memberof AdminsEcommerceProductPricelistListResponseItem
     */
    'isShowWorker': boolean;
    /**
     * Is show farmer
     * @type {boolean}
     * @memberof AdminsEcommerceProductPricelistListResponseItem
     */
    'isShowFarmer': boolean;
    /**
     * Is show duta
     * @type {boolean}
     * @memberof AdminsEcommerceProductPricelistListResponseItem
     */
    'isShowAmbassador': boolean;
    /**
     * 
     * @type {Array<AdminsEcommerceProductPricelistListResponsePriceItem>}
     * @memberof AdminsEcommerceProductPricelistListResponseItem
     */
    'prices': Array<AdminsEcommerceProductPricelistListResponsePriceItem>;
    /**
     * Start Date UTC 0
     * @type {number}
     * @memberof AdminsEcommerceProductPricelistListResponseItem
     */
    'startDateUtc0': number;
    /**
     * End Date UTC 0
     * @type {number}
     * @memberof AdminsEcommerceProductPricelistListResponseItem
     */
    'endDateUtc0': number;
}


/**
 * 
 * @export
 * @interface AdminsEcommerceProductPricelistListResponsePriceItem
 */
export interface AdminsEcommerceProductPricelistListResponsePriceItem {
    /**
     * Pricelist ID represented in UUID
     * @type {string}
     * @memberof AdminsEcommerceProductPricelistListResponsePriceItem
     */
    'id': string;
    /**
     * Current Product Price
     * @type {number}
     * @memberof AdminsEcommerceProductPricelistListResponsePriceItem
     */
    'price': number;
    /**
     * minimum Order
     * @type {number}
     * @memberof AdminsEcommerceProductPricelistListResponsePriceItem
     */
    'minimumQuantity': number;
    /**
     * Maximum Order, this is not mandatory in reponse  if ther is value is null that mean the product has no maximum order 
     * @type {number}
     * @memberof AdminsEcommerceProductPricelistListResponsePriceItem
     */
    'maximumQuantity'?: number;
    /**
     * Start Date UTC 0
     * @type {number}
     * @memberof AdminsEcommerceProductPricelistListResponsePriceItem
     */
    'startDateUtc0': number;
    /**
     * End Date UTC 0
     * @type {number}
     * @memberof AdminsEcommerceProductPricelistListResponsePriceItem
     */
    'endDateUtc0': number;
}
/**
 * productName         = This field is used for sorting the data by the product name price               = This field is used for sorting the data by the product price stock               = This field is used for sorting the data by the product stock balance preparationDuration = This field is used for sorting the data by the processing time duration pricelistStatus     = This field is used for sorting the data by the status 
 * @export
 * @enum {string}
 */

export const AdminsEcommerceProductPricelistListSortEnum = {
    ProductName: 'productName',
    Price: 'price',
    Stock: 'stock',
    PreparationDuration: 'preparationDuration',
    PricelistStatus: 'pricelistStatus'
} as const;

export type AdminsEcommerceProductPricelistListSortEnum = typeof AdminsEcommerceProductPricelistListSortEnum[keyof typeof AdminsEcommerceProductPricelistListSortEnum];


/**
 * 
 * @export
 * @interface AdminsEcommerceProductUpdateRequest
 */
export interface AdminsEcommerceProductUpdateRequest {
    /**
     * id of a product category in UUID type 4
     * @type {string}
     * @memberof AdminsEcommerceProductUpdateRequest
     */
    'categoryId'?: string;
    /**
     * product sku
     * @type {string}
     * @memberof AdminsEcommerceProductUpdateRequest
     */
    'sku'?: string;
    /**
     * Enum product status | - ACTIVE - INACTIVE
     * @type {string}
     * @memberof AdminsEcommerceProductUpdateRequest
     */
    'status'?: string;
    /**
     * product name
     * @type {string}
     * @memberof AdminsEcommerceProductUpdateRequest
     */
    'name'?: string;
    /**
     * product description
     * @type {string}
     * @memberof AdminsEcommerceProductUpdateRequest
     */
    'description'?: string;
    /**
     * product description
     * @type {string}
     * @memberof AdminsEcommerceProductUpdateRequest
     */
    'detailDescription'?: string;
    /**
     * 
     * @type {EcommerceProductUnitOfMeasurementEnum}
     * @memberof AdminsEcommerceProductUpdateRequest
     */
    'unitOfMeasurement'?: EcommerceProductUnitOfMeasurementEnum;
    /**
     * unit of measurement product
     * @type {number}
     * @memberof AdminsEcommerceProductUpdateRequest
     */
    'productWeight'?: number;
    /**
     * 
     * @type {EcommerceProductDimensionMeasurementEnum}
     * @memberof AdminsEcommerceProductUpdateRequest
     */
    'dimensionMeasurement'?: EcommerceProductDimensionMeasurementEnum;
    /**
     * unit of measurement product
     * @type {number}
     * @memberof AdminsEcommerceProductUpdateRequest
     */
    'dimensionLength'?: number;
    /**
     * dimension width of product
     * @type {number}
     * @memberof AdminsEcommerceProductUpdateRequest
     */
    'dimensionWidth'?: number;
    /**
     * dimention height of product
     * @type {number}
     * @memberof AdminsEcommerceProductUpdateRequest
     */
    'dimensionHeight'?: number;
    /**
     * image of url product
     * @type {string}
     * @memberof AdminsEcommerceProductUpdateRequest
     */
    'imageURL'?: string;
    /**
     * 
     * @type {EcommerceProductTypeEnum}
     * @memberof AdminsEcommerceProductUpdateRequest
     */
    'type': EcommerceProductTypeEnum;
}


/**
 * 
 * @export
 * @interface AdminsEcommerceUpdateDigitalProductRequest
 */
export interface AdminsEcommerceUpdateDigitalProductRequest {
    /**
     * Enum product status | - ACTIVE - INACTIVE
     * @type {string}
     * @memberof AdminsEcommerceUpdateDigitalProductRequest
     */
    'status'?: string;
    /**
     * id of a product category in UUID type 4
     * @type {string}
     * @memberof AdminsEcommerceUpdateDigitalProductRequest
     */
    'categoryIId': string;
    /**
     * id of a product category in UUID type 4
     * @type {string}
     * @memberof AdminsEcommerceUpdateDigitalProductRequest
     */
    'categoryIIId'?: string;
    /**
     * 
     * @type {VendorEnum}
     * @memberof AdminsEcommerceUpdateDigitalProductRequest
     */
    'vendor'?: VendorEnum;
    /**
     * total price of product
     * @type {number}
     * @memberof AdminsEcommerceUpdateDigitalProductRequest
     */
    'sellingPrice': number;
    /**
     * vendor total price of product
     * @type {number}
     * @memberof AdminsEcommerceUpdateDigitalProductRequest
     */
    'vendorOriginPrice'?: number;
    /**
     * denomination of product
     * @type {string}
     * @memberof AdminsEcommerceUpdateDigitalProductRequest
     */
    'vendorDenom'?: string;
    /**
     * sort number
     * @type {number}
     * @memberof AdminsEcommerceUpdateDigitalProductRequest
     */
    'sortNo'?: number;
    /**
     * product name
     * @type {string}
     * @memberof AdminsEcommerceUpdateDigitalProductRequest
     */
    'name': string;
    /**
     * SKU
     * @type {string}
     * @memberof AdminsEcommerceUpdateDigitalProductRequest
     */
    'sku'?: string;
    /**
     * start date utc0 for price list
     * @type {number}
     * @memberof AdminsEcommerceUpdateDigitalProductRequest
     */
    'startDateUtc0'?: number;
    /**
     * end date utc0 for price list
     * @type {number}
     * @memberof AdminsEcommerceUpdateDigitalProductRequest
     */
    'endDateUtc0'?: number;
    /**
     * image of url product
     * @type {string}
     * @memberof AdminsEcommerceUpdateDigitalProductRequest
     */
    'imageURL'?: string;
}


/**
 * 
 * @export
 * @interface AdminsEcommerceUpdateDigitalProductResponse
 */
export interface AdminsEcommerceUpdateDigitalProductResponse {
    /**
     * product id
     * @type {string}
     * @memberof AdminsEcommerceUpdateDigitalProductResponse
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface AdminsEcommerceUpdateProductCategoryRequest
 */
export interface AdminsEcommerceUpdateProductCategoryRequest {
    /**
     * category name
     * @type {string}
     * @memberof AdminsEcommerceUpdateProductCategoryRequest
     */
    'name': string;
    /**
     * status of category | - ACTIVE - INACTIVE
     * @type {string}
     * @memberof AdminsEcommerceUpdateProductCategoryRequest
     */
    'status': string;
    /**
     * category description
     * @type {string}
     * @memberof AdminsEcommerceUpdateProductCategoryRequest
     */
    'description'?: string;
    /**
     * Max point usage allowed to buy the product (in %)
     * @type {number}
     * @memberof AdminsEcommerceUpdateProductCategoryRequest
     */
    'maxPointUsage': number;
    /**
     * image of url product
     * @type {string}
     * @memberof AdminsEcommerceUpdateProductCategoryRequest
     */
    'imageURL'?: string;
    /**
     * 
     * @type {Array<AdminsEcommerceGetProductCategoryRolePointUsageItem>}
     * @memberof AdminsEcommerceUpdateProductCategoryRequest
     */
    'rolePointUsageItems': Array<AdminsEcommerceGetProductCategoryRolePointUsageItem>;
}
/**
 * 
 * @export
 * @interface AdminsEcommerceUpdateProductCategoryResponse
 */
export interface AdminsEcommerceUpdateProductCategoryResponse {
    /**
     * product category id
     * @type {string}
     * @memberof AdminsEcommerceUpdateProductCategoryResponse
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface AdminsEcommerceUploadProductImageRequest
 */
export interface AdminsEcommerceUploadProductImageRequest {
    /**
     * Image data
     * @type {File}
     * @memberof AdminsEcommerceUploadProductImageRequest
     */
    'imageData'?: File;
}
/**
 * 
 * @export
 * @interface AdminsEcommerceUploadProductImageResponse
 */
export interface AdminsEcommerceUploadProductImageResponse {
    /**
     * image of url product
     * @type {string}
     * @memberof AdminsEcommerceUploadProductImageResponse
     */
    'imageURL': string;
}
/**
 * 
 * @export
 * @interface AdminsFinanceCreateVendorRequest
 */
export interface AdminsFinanceCreateVendorRequest {
    /**
     * vendor name
     * @type {string}
     * @memberof AdminsFinanceCreateVendorRequest
     */
    'name': string;
    /**
     * 
     * @type {VendorTypeEnum}
     * @memberof AdminsFinanceCreateVendorRequest
     */
    'type': VendorTypeEnum;
    /**
     * owner name
     * @type {string}
     * @memberof AdminsFinanceCreateVendorRequest
     */
    'ownerName': string;
    /**
     * Phone number starting with 0 as prefix (08xxxxxxxxx)
     * @type {string}
     * @memberof AdminsFinanceCreateVendorRequest
     */
    'ownerPhoneNo': string;
    /**
     * PIC name
     * @type {string}
     * @memberof AdminsFinanceCreateVendorRequest
     */
    'picName'?: string;
    /**
     * Phone number starting with 0 as prefix (08xxxxxxxxx)
     * @type {string}
     * @memberof AdminsFinanceCreateVendorRequest
     */
    'picPhoneNo'?: string;
    /**
     * province of area
     * @type {string}
     * @memberof AdminsFinanceCreateVendorRequest
     */
    'province': string;
    /**
     * city of area
     * @type {string}
     * @memberof AdminsFinanceCreateVendorRequest
     */
    'city': string;
    /**
     * id of a bank in UUID type 4
     * @type {string}
     * @memberof AdminsFinanceCreateVendorRequest
     */
    'bankId'?: string;
    /**
     * Account Name of Vendor
     * @type {string}
     * @memberof AdminsFinanceCreateVendorRequest
     */
    'bankAccountName'?: string;
    /**
     * Bank Account Number
     * @type {string}
     * @memberof AdminsFinanceCreateVendorRequest
     */
    'bankAccountNo'?: string;
    /**
     * Tax Identity Number (NPWP)
     * @type {string}
     * @memberof AdminsFinanceCreateVendorRequest
     */
    'taxIdentityNo'?: string;
    /**
     * 
     * @type {TaxTypeEnum}
     * @memberof AdminsFinanceCreateVendorRequest
     */
    'taxType'?: TaxTypeEnum;
    /**
     * vendor address
     * @type {string}
     * @memberof AdminsFinanceCreateVendorRequest
     */
    'address': string;
    /**
     * Enum product status | - ACTIVE - INACTIVE
     * @type {string}
     * @memberof AdminsFinanceCreateVendorRequest
     */
    'status': string;
    /**
     * File path of saving book in bucket
     * @type {string}
     * @memberof AdminsFinanceCreateVendorRequest
     */
    'savingBookFilePath'?: string;
    /**
     * File path of MoU in bucket
     * @type {string}
     * @memberof AdminsFinanceCreateVendorRequest
     */
    'mouFilePath'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminsFinanceCreateVendorRequest
     */
    'isPC'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminsFinanceCreateVendorRequest
     */
    'isWifi'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminsFinanceCreateVendorRequest
     */
    'isFleet'?: boolean;
    /**
     * Fleet type of vendor
     * @type {string}
     * @memberof AdminsFinanceCreateVendorRequest
     */
    'fleetType'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminsFinanceCreateVendorRequest
     */
    'isTax'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminsFinanceCreateVendorRequest
     */
    'isWarehouse'?: boolean;
    /**
     * Stock Location Latitude
     * @type {number}
     * @memberof AdminsFinanceCreateVendorRequest
     */
    'latitude': number;
    /**
     * Stock Location Longitude
     * @type {number}
     * @memberof AdminsFinanceCreateVendorRequest
     */
    'longitude': number;
}


/**
 * 
 * @export
 * @interface AdminsFinanceCreateVendorResponse
 */
export interface AdminsFinanceCreateVendorResponse {
    /**
     * vendor id
     * @type {string}
     * @memberof AdminsFinanceCreateVendorResponse
     */
    'id': string;
}
/**
 * list of bank data
 * @export
 * @interface AdminsFinanceGetBankListResponse
 */
export interface AdminsFinanceGetBankListResponse {
    /**
     * 
     * @type {Array<AdminsFinanceGetBankListResponseItem>}
     * @memberof AdminsFinanceGetBankListResponse
     */
    'items': Array<AdminsFinanceGetBankListResponseItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof AdminsFinanceGetBankListResponse
     */
    'pagination'?: PaginationResponse;
}
/**
 * 
 * @export
 * @interface AdminsFinanceGetBankListResponseItem
 */
export interface AdminsFinanceGetBankListResponseItem {
    /**
     * bank id
     * @type {string}
     * @memberof AdminsFinanceGetBankListResponseItem
     */
    'id': string;
    /**
     * bank name
     * @type {string}
     * @memberof AdminsFinanceGetBankListResponseItem
     */
    'name': string;
    /**
     * bank description
     * @type {string}
     * @memberof AdminsFinanceGetBankListResponseItem
     */
    'description': string;
    /**
     * bank website
     * @type {string}
     * @memberof AdminsFinanceGetBankListResponseItem
     */
    'website': string;
}
/**
 * 
 * @export
 * @interface AdminsFinanceGetVendorDetailResponse
 */
export interface AdminsFinanceGetVendorDetailResponse {
    /**
     * id of a vendor in UUID type 4
     * @type {string}
     * @memberof AdminsFinanceGetVendorDetailResponse
     */
    'id': string;
    /**
     * vendor name
     * @type {string}
     * @memberof AdminsFinanceGetVendorDetailResponse
     */
    'name': string;
    /**
     * 
     * @type {VendorTypeEnum}
     * @memberof AdminsFinanceGetVendorDetailResponse
     */
    'type': VendorTypeEnum;
    /**
     * owner name
     * @type {string}
     * @memberof AdminsFinanceGetVendorDetailResponse
     */
    'ownerName': string;
    /**
     * Phone number starting with 0 as prefix (08xxxxxxxxx)
     * @type {string}
     * @memberof AdminsFinanceGetVendorDetailResponse
     */
    'ownerPhoneNo': string;
    /**
     * PIC name
     * @type {string}
     * @memberof AdminsFinanceGetVendorDetailResponse
     */
    'picName': string;
    /**
     * Phone number starting with 0 as prefix (08xxxxxxxxx)
     * @type {string}
     * @memberof AdminsFinanceGetVendorDetailResponse
     */
    'picPhoneNo': string;
    /**
     * province of area
     * @type {string}
     * @memberof AdminsFinanceGetVendorDetailResponse
     */
    'province': string;
    /**
     * city of area
     * @type {string}
     * @memberof AdminsFinanceGetVendorDetailResponse
     */
    'city': string;
    /**
     * id of a bank in UUID type 4
     * @type {string}
     * @memberof AdminsFinanceGetVendorDetailResponse
     */
    'bankId': string;
    /**
     * Account Name of Vendor
     * @type {string}
     * @memberof AdminsFinanceGetVendorDetailResponse
     */
    'bankAccountName': string;
    /**
     * Bank Account Number
     * @type {string}
     * @memberof AdminsFinanceGetVendorDetailResponse
     */
    'bankAccountNo': string;
    /**
     * Tax Identity Number (NPWP)
     * @type {string}
     * @memberof AdminsFinanceGetVendorDetailResponse
     */
    'taxIdentityNo': string;
    /**
     * 
     * @type {TaxTypeEnum}
     * @memberof AdminsFinanceGetVendorDetailResponse
     */
    'taxType': TaxTypeEnum;
    /**
     * vendor address
     * @type {string}
     * @memberof AdminsFinanceGetVendorDetailResponse
     */
    'address': string;
    /**
     * Enum product status | - ACTIVE - INACTIVE
     * @type {string}
     * @memberof AdminsFinanceGetVendorDetailResponse
     */
    'status': string;
    /**
     * File path of saving book in bucket
     * @type {string}
     * @memberof AdminsFinanceGetVendorDetailResponse
     */
    'savingBookFilePath': string;
    /**
     * File path of MoU in bucket
     * @type {string}
     * @memberof AdminsFinanceGetVendorDetailResponse
     */
    'mouFilePath': string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminsFinanceGetVendorDetailResponse
     */
    'isPC': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminsFinanceGetVendorDetailResponse
     */
    'isWifi': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminsFinanceGetVendorDetailResponse
     */
    'isFleet': boolean;
    /**
     * Fleet type of vendor
     * @type {string}
     * @memberof AdminsFinanceGetVendorDetailResponse
     */
    'fleetType': string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminsFinanceGetVendorDetailResponse
     */
    'isTax': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminsFinanceGetVendorDetailResponse
     */
    'isWarehouse': boolean;
    /**
     * Stock Location Latitude
     * @type {number}
     * @memberof AdminsFinanceGetVendorDetailResponse
     */
    'latitude': number;
    /**
     * Stock Location Longitude
     * @type {number}
     * @memberof AdminsFinanceGetVendorDetailResponse
     */
    'longitude': number;
}


/**
 * list of vendor data
 * @export
 * @interface AdminsFinanceGetVendorListResponse
 */
export interface AdminsFinanceGetVendorListResponse {
    /**
     * 
     * @type {Array<AdminsFinanceGetVendorListResponseItem>}
     * @memberof AdminsFinanceGetVendorListResponse
     */
    'items': Array<AdminsFinanceGetVendorListResponseItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof AdminsFinanceGetVendorListResponse
     */
    'pagination'?: PaginationResponse;
}
/**
 * 
 * @export
 * @interface AdminsFinanceGetVendorListResponseItem
 */
export interface AdminsFinanceGetVendorListResponseItem {
    /**
     * vendor id
     * @type {string}
     * @memberof AdminsFinanceGetVendorListResponseItem
     */
    'id': string;
    /**
     * vendor name
     * @type {string}
     * @memberof AdminsFinanceGetVendorListResponseItem
     */
    'name': string;
    /**
     * 
     * @type {VendorTypeEnum}
     * @memberof AdminsFinanceGetVendorListResponseItem
     */
    'type': VendorTypeEnum;
    /**
     * owner name of the vendor
     * @type {string}
     * @memberof AdminsFinanceGetVendorListResponseItem
     */
    'ownerName': string;
    /**
     * Regency of the vendor
     * @type {string}
     * @memberof AdminsFinanceGetVendorListResponseItem
     */
    'regency': string;
    /**
     * 
     * @type {VendorStatusEnum}
     * @memberof AdminsFinanceGetVendorListResponseItem
     */
    'status': VendorStatusEnum;
}


/**
 * 
 * @export
 * @interface AdminsFinanceUpdateVendorRequest
 */
export interface AdminsFinanceUpdateVendorRequest {
    /**
     * vendor name
     * @type {string}
     * @memberof AdminsFinanceUpdateVendorRequest
     */
    'name': string;
    /**
     * 
     * @type {VendorTypeEnum}
     * @memberof AdminsFinanceUpdateVendorRequest
     */
    'type': VendorTypeEnum;
    /**
     * owner name
     * @type {string}
     * @memberof AdminsFinanceUpdateVendorRequest
     */
    'ownerName': string;
    /**
     * Phone number starting with 0 as prefix (08xxxxxxxxx)
     * @type {string}
     * @memberof AdminsFinanceUpdateVendorRequest
     */
    'ownerPhoneNo': string;
    /**
     * PIC name
     * @type {string}
     * @memberof AdminsFinanceUpdateVendorRequest
     */
    'picName'?: string;
    /**
     * Phone number starting with 0 as prefix (08xxxxxxxxx)
     * @type {string}
     * @memberof AdminsFinanceUpdateVendorRequest
     */
    'picPhoneNo'?: string;
    /**
     * province of area
     * @type {string}
     * @memberof AdminsFinanceUpdateVendorRequest
     */
    'province': string;
    /**
     * city of area
     * @type {string}
     * @memberof AdminsFinanceUpdateVendorRequest
     */
    'city': string;
    /**
     * id of a bank in UUID type 4
     * @type {string}
     * @memberof AdminsFinanceUpdateVendorRequest
     */
    'bankId'?: string;
    /**
     * Account Name of Vendor
     * @type {string}
     * @memberof AdminsFinanceUpdateVendorRequest
     */
    'bankAccountName'?: string;
    /**
     * Bank Account Number
     * @type {string}
     * @memberof AdminsFinanceUpdateVendorRequest
     */
    'bankAccountNo'?: string;
    /**
     * Tax Identity Number (NPWP)
     * @type {string}
     * @memberof AdminsFinanceUpdateVendorRequest
     */
    'taxIdentityNo'?: string;
    /**
     * 
     * @type {TaxTypeEnum}
     * @memberof AdminsFinanceUpdateVendorRequest
     */
    'taxType'?: TaxTypeEnum;
    /**
     * vendor address
     * @type {string}
     * @memberof AdminsFinanceUpdateVendorRequest
     */
    'address': string;
    /**
     * Enum product status | - ACTIVE - INACTIVE
     * @type {string}
     * @memberof AdminsFinanceUpdateVendorRequest
     */
    'status': string;
    /**
     * File path of saving book in bucket
     * @type {string}
     * @memberof AdminsFinanceUpdateVendorRequest
     */
    'savingBookFilePath'?: string;
    /**
     * File path of MoU in bucket
     * @type {string}
     * @memberof AdminsFinanceUpdateVendorRequest
     */
    'mouFilePath'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminsFinanceUpdateVendorRequest
     */
    'isPC'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminsFinanceUpdateVendorRequest
     */
    'isWifi'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminsFinanceUpdateVendorRequest
     */
    'isFleet'?: boolean;
    /**
     * Fleet type of vendor
     * @type {string}
     * @memberof AdminsFinanceUpdateVendorRequest
     */
    'fleetType'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminsFinanceUpdateVendorRequest
     */
    'isTax'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminsFinanceUpdateVendorRequest
     */
    'isWarehouse'?: boolean;
    /**
     * Stock Location Latitude
     * @type {number}
     * @memberof AdminsFinanceUpdateVendorRequest
     */
    'latitude': number;
    /**
     * Stock Location Longitude
     * @type {number}
     * @memberof AdminsFinanceUpdateVendorRequest
     */
    'longitude': number;
}


/**
 * 
 * @export
 * @interface AdminsFinanceUpdateVendorResponse
 */
export interface AdminsFinanceUpdateVendorResponse {
    /**
     * id of a vendor in UUID type 4
     * @type {string}
     * @memberof AdminsFinanceUpdateVendorResponse
     */
    'id': string;
}
/**
 * list of inquiry item from vendor
 * @export
 * @interface AdminsFinanceVendorBillInquiryResponse
 */
export interface AdminsFinanceVendorBillInquiryResponse {
    /**
     * 
     * @type {Array<AdminsFinanceVendorBillInquiryResponseItem>}
     * @memberof AdminsFinanceVendorBillInquiryResponse
     */
    'items': Array<AdminsFinanceVendorBillInquiryResponseItem>;
}
/**
 * 
 * @export
 * @interface AdminsFinanceVendorBillInquiryResponseItem
 */
export interface AdminsFinanceVendorBillInquiryResponseItem {
    /**
     * bill id
     * @type {string}
     * @memberof AdminsFinanceVendorBillInquiryResponseItem
     */
    'biilId': string;
    /**
     * vendor price
     * @type {number}
     * @memberof AdminsFinanceVendorBillInquiryResponseItem
     */
    'originPrice': number;
    /**
     * product name
     * @type {string}
     * @memberof AdminsFinanceVendorBillInquiryResponseItem
     */
    'name': string;
    /**
     * denomination of product
     * @type {string}
     * @memberof AdminsFinanceVendorBillInquiryResponseItem
     */
    'denom': string;
}
/**
 * 
 * @export
 * @interface AdminsGetProductListResponse
 */
export interface AdminsGetProductListResponse {
    /**
     * product id
     * @type {string}
     * @memberof AdminsGetProductListResponse
     */
    'id': string;
    /**
     * product name
     * @type {string}
     * @memberof AdminsGetProductListResponse
     */
    'name': string;
    /**
     * product category
     * @type {string}
     * @memberof AdminsGetProductListResponse
     */
    'category': string;
    /**
     * product sku
     * @type {string}
     * @memberof AdminsGetProductListResponse
     */
    'sku': string;
    /**
     * Enum product status | - ACTIVE - INACTIVE
     * @type {string}
     * @memberof AdminsGetProductListResponse
     */
    'status': string;
    /**
     * type of product | - GOODS - DIGITAL - DIGITAL
     * @type {string}
     * @memberof AdminsGetProductListResponse
     */
    'type': string;
    /**
     * image of url product
     * @type {string}
     * @memberof AdminsGetProductListResponse
     */
    'imageURL': string;
}
/**
 * Response data
 * @export
 * @interface AdminsJobBoardsVacanciesCreateJobVacancyRequest
 */
export interface AdminsJobBoardsVacanciesCreateJobVacancyRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminsJobBoardsVacanciesCreateJobVacancyRequest
     */
    'jobName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminsJobBoardsVacanciesCreateJobVacancyRequest
     */
    'categoryCode': string;
    /**
     * 
     * @type {number}
     * @memberof AdminsJobBoardsVacanciesCreateJobVacancyRequest
     */
    'quota': number;
    /**
     * 
     * @type {AdminsJobBoardsVacanciesCreateJobVacancyRequestWage}
     * @memberof AdminsJobBoardsVacanciesCreateJobVacancyRequest
     */
    'wage': AdminsJobBoardsVacanciesCreateJobVacancyRequestWage;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminsJobBoardsVacanciesCreateJobVacancyRequest
     */
    'facilities': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminsJobBoardsVacanciesCreateJobVacancyRequest
     */
    'images': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AdminsJobBoardsVacanciesCreateJobVacancyRequest
     */
    'areaId': string;
    /**
     * 
     * @type {AdminsJobBoardsVacanciesCreateJobVacancyRequestTerrain}
     * @memberof AdminsJobBoardsVacanciesCreateJobVacancyRequest
     */
    'terrain': AdminsJobBoardsVacanciesCreateJobVacancyRequestTerrain;
    /**
     * 
     * @type {AdminsJobBoardsVacanciesCreateJobVacancyRequestFfb}
     * @memberof AdminsJobBoardsVacanciesCreateJobVacancyRequest
     */
    'ffb': AdminsJobBoardsVacanciesCreateJobVacancyRequestFfb;
    /**
     * 
     * @type {string}
     * @memberof AdminsJobBoardsVacanciesCreateJobVacancyRequest
     */
    'jobDescription': string;
}
/**
 * Request data for create job vacancy ffb
 * @export
 * @interface AdminsJobBoardsVacanciesCreateJobVacancyRequestFfb
 */
export interface AdminsJobBoardsVacanciesCreateJobVacancyRequestFfb {
    /**
     * 
     * @type {number}
     * @memberof AdminsJobBoardsVacanciesCreateJobVacancyRequestFfb
     */
    'minimumEstimation': number;
    /**
     * 
     * @type {number}
     * @memberof AdminsJobBoardsVacanciesCreateJobVacancyRequestFfb
     */
    'maximumEstimation': number;
    /**
     * 
     * @type {string}
     * @memberof AdminsJobBoardsVacanciesCreateJobVacancyRequestFfb
     */
    'collectionMethod': string;
    /**
     * 
     * @type {string}
     * @memberof AdminsJobBoardsVacanciesCreateJobVacancyRequestFfb
     */
    'additionalParameter'?: string;
}
/**
 * Request data for create job vacancy terrain
 * @export
 * @interface AdminsJobBoardsVacanciesCreateJobVacancyRequestTerrain
 */
export interface AdminsJobBoardsVacanciesCreateJobVacancyRequestTerrain {
    /**
     * 
     * @type {string}
     * @memberof AdminsJobBoardsVacanciesCreateJobVacancyRequestTerrain
     */
    'condition': string;
    /**
     * 
     * @type {string}
     * @memberof AdminsJobBoardsVacanciesCreateJobVacancyRequestTerrain
     */
    'soilType': string;
    /**
     * 
     * @type {number}
     * @memberof AdminsJobBoardsVacanciesCreateJobVacancyRequestTerrain
     */
    'minimumTreeHigh': number;
}
/**
 * Request data for create job vacancy wage
 * @export
 * @interface AdminsJobBoardsVacanciesCreateJobVacancyRequestWage
 */
export interface AdminsJobBoardsVacanciesCreateJobVacancyRequestWage {
    /**
     * 
     * @type {number}
     * @memberof AdminsJobBoardsVacanciesCreateJobVacancyRequestWage
     */
    'minimum': number;
    /**
     * 
     * @type {number}
     * @memberof AdminsJobBoardsVacanciesCreateJobVacancyRequestWage
     */
    'maximum': number;
    /**
     * 
     * @type {string}
     * @memberof AdminsJobBoardsVacanciesCreateJobVacancyRequestWage
     */
    'unit': string;
}
/**
 * Response data
 * @export
 * @interface AdminsJobBoardsVacanciesCreateJobVacancyResponse
 */
export interface AdminsJobBoardsVacanciesCreateJobVacancyResponse {
    /**
     * 
     * @type {string}
     * @memberof AdminsJobBoardsVacanciesCreateJobVacancyResponse
     */
    'id': string;
}
/**
 * Response data
 * @export
 * @interface AdminsJobBoardsVacanciesGetJobVacancyListResponse
 */
export interface AdminsJobBoardsVacanciesGetJobVacancyListResponse {
    /**
     * List of Job Vacancies
     * @type {Array<AdminsJobBoardsVacanciesGetJobVacancyListResponseItem>}
     * @memberof AdminsJobBoardsVacanciesGetJobVacancyListResponse
     */
    'items': Array<AdminsJobBoardsVacanciesGetJobVacancyListResponseItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof AdminsJobBoardsVacanciesGetJobVacancyListResponse
     */
    'pagination': PaginationResponse;
}
/**
 * 
 * @export
 * @interface AdminsJobBoardsVacanciesGetJobVacancyListResponseItem
 */
export interface AdminsJobBoardsVacanciesGetJobVacancyListResponseItem {
    /**
     * id of this job vacancy in UUID type 4
     * @type {string}
     * @memberof AdminsJobBoardsVacanciesGetJobVacancyListResponseItem
     */
    'id': string;
    /**
     * Job name
     * @type {string}
     * @memberof AdminsJobBoardsVacanciesGetJobVacancyListResponseItem
     */
    'jobName': string;
    /**
     * 
     * @type {AdminsJobBoardsVacanciesGetJobVacancyListResponseItemCategory}
     * @memberof AdminsJobBoardsVacanciesGetJobVacancyListResponseItem
     */
    'category': AdminsJobBoardsVacanciesGetJobVacancyListResponseItemCategory;
    /**
     * 
     * @type {AdminsJobBoardsVacanciesGetJobVacancyListResponseItemLocation}
     * @memberof AdminsJobBoardsVacanciesGetJobVacancyListResponseItem
     */
    'location': AdminsJobBoardsVacanciesGetJobVacancyListResponseItemLocation;
    /**
     * 
     * @type {JobBoardsVacanciesStatusEnum}
     * @memberof AdminsJobBoardsVacanciesGetJobVacancyListResponseItem
     */
    'status': JobBoardsVacanciesStatusEnum;
    /**
     * total applicant for this job vacancy
     * @type {number}
     * @memberof AdminsJobBoardsVacanciesGetJobVacancyListResponseItem
     */
    'totalApplicant': number;
    /**
     * created at in UTC0 timestamp
     * @type {number}
     * @memberof AdminsJobBoardsVacanciesGetJobVacancyListResponseItem
     */
    'createdAtUtc0': number;
}


/**
 * 
 * @export
 * @interface AdminsJobBoardsVacanciesGetJobVacancyListResponseItemCategory
 */
export interface AdminsJobBoardsVacanciesGetJobVacancyListResponseItemCategory {
    /**
     * Job category code
     * @type {string}
     * @memberof AdminsJobBoardsVacanciesGetJobVacancyListResponseItemCategory
     */
    'code': string;
    /**
     * Official name of job category
     * @type {string}
     * @memberof AdminsJobBoardsVacanciesGetJobVacancyListResponseItemCategory
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface AdminsJobBoardsVacanciesGetJobVacancyListResponseItemLocation
 */
export interface AdminsJobBoardsVacanciesGetJobVacancyListResponseItemLocation {
    /**
     * id of area in UUID type 4
     * @type {string}
     * @memberof AdminsJobBoardsVacanciesGetJobVacancyListResponseItemLocation
     */
    'areaId': string;
    /**
     * name of area
     * @type {string}
     * @memberof AdminsJobBoardsVacanciesGetJobVacancyListResponseItemLocation
     */
    'areaName': string;
}
/**
 * Response data
 * @export
 * @interface AdminsJobBoardsVacanciesUpdateJobVacancyRequest
 */
export interface AdminsJobBoardsVacanciesUpdateJobVacancyRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminsJobBoardsVacanciesUpdateJobVacancyRequest
     */
    'jobName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminsJobBoardsVacanciesUpdateJobVacancyRequest
     */
    'categoryCode': string;
    /**
     * 
     * @type {number}
     * @memberof AdminsJobBoardsVacanciesUpdateJobVacancyRequest
     */
    'quota': number;
    /**
     * 
     * @type {AdminsJobBoardsVacanciesUpdateJobVacancyRequestWage}
     * @memberof AdminsJobBoardsVacanciesUpdateJobVacancyRequest
     */
    'wage': AdminsJobBoardsVacanciesUpdateJobVacancyRequestWage;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminsJobBoardsVacanciesUpdateJobVacancyRequest
     */
    'facilities': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminsJobBoardsVacanciesUpdateJobVacancyRequest
     */
    'images': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AdminsJobBoardsVacanciesUpdateJobVacancyRequest
     */
    'areaId': string;
    /**
     * 
     * @type {AdminsJobBoardsVacanciesUpdateJobVacancyRequestTerrain}
     * @memberof AdminsJobBoardsVacanciesUpdateJobVacancyRequest
     */
    'terrain': AdminsJobBoardsVacanciesUpdateJobVacancyRequestTerrain;
    /**
     * 
     * @type {AdminsJobBoardsVacanciesUpdateJobVacancyRequestFfb}
     * @memberof AdminsJobBoardsVacanciesUpdateJobVacancyRequest
     */
    'ffb': AdminsJobBoardsVacanciesUpdateJobVacancyRequestFfb;
    /**
     * 
     * @type {string}
     * @memberof AdminsJobBoardsVacanciesUpdateJobVacancyRequest
     */
    'jobDescription': string;
}
/**
 * Request data for update job vacancy ffb
 * @export
 * @interface AdminsJobBoardsVacanciesUpdateJobVacancyRequestFfb
 */
export interface AdminsJobBoardsVacanciesUpdateJobVacancyRequestFfb {
    /**
     * 
     * @type {number}
     * @memberof AdminsJobBoardsVacanciesUpdateJobVacancyRequestFfb
     */
    'minimumEstimation': number;
    /**
     * 
     * @type {number}
     * @memberof AdminsJobBoardsVacanciesUpdateJobVacancyRequestFfb
     */
    'maximumEstimation': number;
    /**
     * 
     * @type {string}
     * @memberof AdminsJobBoardsVacanciesUpdateJobVacancyRequestFfb
     */
    'collectionMethod': string;
    /**
     * 
     * @type {string}
     * @memberof AdminsJobBoardsVacanciesUpdateJobVacancyRequestFfb
     */
    'additionalParameter': string;
}
/**
 * Request data for update job vacancy terrain
 * @export
 * @interface AdminsJobBoardsVacanciesUpdateJobVacancyRequestTerrain
 */
export interface AdminsJobBoardsVacanciesUpdateJobVacancyRequestTerrain {
    /**
     * 
     * @type {string}
     * @memberof AdminsJobBoardsVacanciesUpdateJobVacancyRequestTerrain
     */
    'condition': string;
    /**
     * 
     * @type {string}
     * @memberof AdminsJobBoardsVacanciesUpdateJobVacancyRequestTerrain
     */
    'soilType': string;
    /**
     * 
     * @type {number}
     * @memberof AdminsJobBoardsVacanciesUpdateJobVacancyRequestTerrain
     */
    'minimumTreeHigh': number;
}
/**
 * Request data for update job vacancy wage
 * @export
 * @interface AdminsJobBoardsVacanciesUpdateJobVacancyRequestWage
 */
export interface AdminsJobBoardsVacanciesUpdateJobVacancyRequestWage {
    /**
     * 
     * @type {number}
     * @memberof AdminsJobBoardsVacanciesUpdateJobVacancyRequestWage
     */
    'minimum': number;
    /**
     * 
     * @type {number}
     * @memberof AdminsJobBoardsVacanciesUpdateJobVacancyRequestWage
     */
    'maximum': number;
    /**
     * 
     * @type {string}
     * @memberof AdminsJobBoardsVacanciesUpdateJobVacancyRequestWage
     */
    'unit': string;
}
/**
 * 
 * @export
 * @interface AdminsJobBoardsVacanciesUpdateStatusApplicantsRequest
 */
export interface AdminsJobBoardsVacanciesUpdateStatusApplicantsRequest {
    /**
     * 
     * @type {JobBoardsVacanciesApplicationStatusEnum}
     * @memberof AdminsJobBoardsVacanciesUpdateStatusApplicantsRequest
     */
    'status': JobBoardsVacanciesApplicationStatusEnum;
}


/**
 * Response data
 * @export
 * @interface AdminsJobBoardsVacanciesUpdateStatusJobVacancyRequest
 */
export interface AdminsJobBoardsVacanciesUpdateStatusJobVacancyRequest {
    /**
     * 
     * @type {JobBoardsVacanciesStatusEnum}
     * @memberof AdminsJobBoardsVacanciesUpdateStatusJobVacancyRequest
     */
    'status': JobBoardsVacanciesStatusEnum;
}


/**
 * 
 * @export
 * @interface AdminsLoyaltyCreateVoucherRequest
 */
export interface AdminsLoyaltyCreateVoucherRequest {
    /**
     * Voucher rule id
     * @type {string}
     * @memberof AdminsLoyaltyCreateVoucherRequest
     */
    'voucherRuleId': string;
    /**
     * Voucher name
     * @type {string}
     * @memberof AdminsLoyaltyCreateVoucherRequest
     */
    'name': string;
    /**
     * Voucher CODE
     * @type {string}
     * @memberof AdminsLoyaltyCreateVoucherRequest
     */
    'code'?: string;
    /**
     * Voucher label
     * @type {string}
     * @memberof AdminsLoyaltyCreateVoucherRequest
     */
    'label': string;
    /**
     * 
     * @type {VoucherTypeEnum}
     * @memberof AdminsLoyaltyCreateVoucherRequest
     */
    'type': VoucherTypeEnum;
    /**
     * Voucher description
     * @type {string}
     * @memberof AdminsLoyaltyCreateVoucherRequest
     */
    'description': string;
    /**
     * Voucher image url
     * @type {string}
     * @memberof AdminsLoyaltyCreateVoucherRequest
     */
    'imageUrl': string;
    /**
     * 
     * @type {VoucherDiscountTypeEnum}
     * @memberof AdminsLoyaltyCreateVoucherRequest
     */
    'discountType': VoucherDiscountTypeEnum;
    /**
     * Voucher discount amount
     * @type {number}
     * @memberof AdminsLoyaltyCreateVoucherRequest
     */
    'discountAmount': number;
    /**
     * Voucher start datetime at UTC+0 in milliseconds
     * @type {number}
     * @memberof AdminsLoyaltyCreateVoucherRequest
     */
    'startAtUtc0': number;
    /**
     * Voucher end datetime at UTC+0 in milliseconds
     * @type {number}
     * @memberof AdminsLoyaltyCreateVoucherRequest
     */
    'endAtUtc0': number;
}


/**
 * 
 * @export
 * @interface AdminsLoyaltyCreateVoucherResponse
 */
export interface AdminsLoyaltyCreateVoucherResponse {
    /**
     * Voucher UUID
     * @type {string}
     * @memberof AdminsLoyaltyCreateVoucherResponse
     */
    'id': string;
    /**
     * Voucher name
     * @type {string}
     * @memberof AdminsLoyaltyCreateVoucherResponse
     */
    'name': string;
    /**
     * Voucher code
     * @type {string}
     * @memberof AdminsLoyaltyCreateVoucherResponse
     */
    'code': string;
    /**
     * Voucher label
     * @type {string}
     * @memberof AdminsLoyaltyCreateVoucherResponse
     */
    'label': string;
}
/**
 * 
 * @export
 * @interface AdminsLoyaltyCreateVoucherRuleRequest
 */
export interface AdminsLoyaltyCreateVoucherRuleRequest {
    /**
     * Voucher CODE
     * @type {string}
     * @memberof AdminsLoyaltyCreateVoucherRuleRequest
     */
    'code'?: string;
    /**
     * Voucher minimum total price
     * @type {number}
     * @memberof AdminsLoyaltyCreateVoucherRuleRequest
     */
    'minTotalPrice': number;
    /**
     * Voucher maximum discount price
     * @type {number}
     * @memberof AdminsLoyaltyCreateVoucherRuleRequest
     */
    'maxDiscountPrice': number;
    /**
     * Voucher maximum redemption
     * @type {number}
     * @memberof AdminsLoyaltyCreateVoucherRuleRequest
     */
    'maxRedemption': number;
    /**
     * Voucher maximum redemption per user
     * @type {number}
     * @memberof AdminsLoyaltyCreateVoucherRuleRequest
     */
    'maxRedemptionPerUser': number;
    /**
     * 
     * @type {Array<DeliveryMethodEnum>}
     * @memberof AdminsLoyaltyCreateVoucherRuleRequest
     */
    'orderDeliveryMethods': Array<DeliveryMethodEnum>;
    /**
     * 
     * @type {Array<PaymentMethodEnum>}
     * @memberof AdminsLoyaltyCreateVoucherRuleRequest
     */
    'paymentMethods': Array<PaymentMethodEnum>;
    /**
     * 
     * @type {Array<EcommerceProductTypeEnum>}
     * @memberof AdminsLoyaltyCreateVoucherRuleRequest
     */
    'productTypes': Array<EcommerceProductTypeEnum>;
    /**
     * Voucher all products
     * @type {boolean}
     * @memberof AdminsLoyaltyCreateVoucherRuleRequest
     */
    'isAllProduct': boolean;
    /**
     * 
     * @type {Array<AdminsLoyaltyVoucherRuleProductItem>}
     * @memberof AdminsLoyaltyCreateVoucherRuleRequest
     */
    'products': Array<AdminsLoyaltyVoucherRuleProductItem>;
    /**
     * Voucher all stores
     * @type {boolean}
     * @memberof AdminsLoyaltyCreateVoucherRuleRequest
     */
    'isAllStore': boolean;
    /**
     * 
     * @type {Array<AdminsLoyaltyVoucherRuleStoreItem>}
     * @memberof AdminsLoyaltyCreateVoucherRuleRequest
     */
    'stores': Array<AdminsLoyaltyVoucherRuleStoreItem>;
    /**
     * Voucher all category
     * @type {boolean}
     * @memberof AdminsLoyaltyCreateVoucherRuleRequest
     */
    'isAllCategory': boolean;
    /**
     * 
     * @type {Array<AdminsLoyaltyVoucherRuleCategoryItem>}
     * @memberof AdminsLoyaltyCreateVoucherRuleRequest
     */
    'categories': Array<AdminsLoyaltyVoucherRuleCategoryItem>;
    /**
     * 
     * @type {Array<AppTypeEnum>}
     * @memberof AdminsLoyaltyCreateVoucherRuleRequest
     */
    'appTypes': Array<AppTypeEnum>;
    /**
     * 
     * @type {Array<UserRoleEnum>}
     * @memberof AdminsLoyaltyCreateVoucherRuleRequest
     */
    'userRoles': Array<UserRoleEnum>;
    /**
     * voucher with sawit poin
     * @type {boolean}
     * @memberof AdminsLoyaltyCreateVoucherRuleRequest
     */
    'isSawitPoin': boolean;
}
/**
 * 
 * @export
 * @interface AdminsLoyaltyCreateVoucherRuleResponse
 */
export interface AdminsLoyaltyCreateVoucherRuleResponse {
    /**
     * Voucher UUID
     * @type {string}
     * @memberof AdminsLoyaltyCreateVoucherRuleResponse
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface AdminsLoyaltyGetVoucherDetailResponse
 */
export interface AdminsLoyaltyGetVoucherDetailResponse {
    /**
     * Voucher UUID
     * @type {string}
     * @memberof AdminsLoyaltyGetVoucherDetailResponse
     */
    'id': string;
    /**
     * Voucher name
     * @type {string}
     * @memberof AdminsLoyaltyGetVoucherDetailResponse
     */
    'name': string;
    /**
     * Voucher code
     * @type {string}
     * @memberof AdminsLoyaltyGetVoucherDetailResponse
     */
    'code'?: string;
    /**
     * Voucher label
     * @type {string}
     * @memberof AdminsLoyaltyGetVoucherDetailResponse
     */
    'label': string;
    /**
     * Voucher type
     * @type {string}
     * @memberof AdminsLoyaltyGetVoucherDetailResponse
     */
    'type': string;
    /**
     * Voucher description
     * @type {string}
     * @memberof AdminsLoyaltyGetVoucherDetailResponse
     */
    'description': string;
    /**
     * Voucher image url
     * @type {string}
     * @memberof AdminsLoyaltyGetVoucherDetailResponse
     */
    'imageUrl': string;
    /**
     * 
     * @type {VoucherDiscountTypeEnum}
     * @memberof AdminsLoyaltyGetVoucherDetailResponse
     */
    'discountType': VoucherDiscountTypeEnum;
    /**
     * Voucher discount amount
     * @type {number}
     * @memberof AdminsLoyaltyGetVoucherDetailResponse
     */
    'discountAmount': number;
    /**
     * Voucher minimum total price
     * @type {number}
     * @memberof AdminsLoyaltyGetVoucherDetailResponse
     */
    'minTotalPrice': number;
    /**
     * Voucher maximum discount price
     * @type {number}
     * @memberof AdminsLoyaltyGetVoucherDetailResponse
     */
    'maxDiscountPrice': number;
    /**
     * Voucher start datetime at UTC+0 in milliseconds
     * @type {number}
     * @memberof AdminsLoyaltyGetVoucherDetailResponse
     */
    'startDatetimeAtUtc0': number;
    /**
     * Voucher end datetime at UTC+0 in milliseconds
     * @type {number}
     * @memberof AdminsLoyaltyGetVoucherDetailResponse
     */
    'endDatetimeAtUtc0': number;
    /**
     * Voucher maximum redemption
     * @type {number}
     * @memberof AdminsLoyaltyGetVoucherDetailResponse
     */
    'maxRedemption': number;
    /**
     * Voucher maximum redemption per user
     * @type {number}
     * @memberof AdminsLoyaltyGetVoucherDetailResponse
     */
    'maxRedemptionPerUser': number;
    /**
     * 
     * @type {Array<PaymentMethodEnum>}
     * @memberof AdminsLoyaltyGetVoucherDetailResponse
     */
    'paymentMethods': Array<PaymentMethodEnum>;
    /**
     * 
     * @type {Array<EcommerceProductTypeEnum>}
     * @memberof AdminsLoyaltyGetVoucherDetailResponse
     */
    'productTypes': Array<EcommerceProductTypeEnum>;
    /**
     * Voucher eligible product list
     * @type {Array<AdminsLoyaltyVoucherRuleProductItem>}
     * @memberof AdminsLoyaltyGetVoucherDetailResponse
     */
    'products': Array<AdminsLoyaltyVoucherRuleProductItem>;
    /**
     * Voucher eligible category list
     * @type {Array<AdminsLoyaltyVoucherRuleCategoryItem>}
     * @memberof AdminsLoyaltyGetVoucherDetailResponse
     */
    'categories': Array<AdminsLoyaltyVoucherRuleCategoryItem>;
    /**
     * Voucher eligible store list
     * @type {Array<AdminsLoyaltyVoucherRuleStoreItem>}
     * @memberof AdminsLoyaltyGetVoucherDetailResponse
     */
    'stores': Array<AdminsLoyaltyVoucherRuleStoreItem>;
    /**
     * 
     * @type {Array<AppTypeEnum>}
     * @memberof AdminsLoyaltyGetVoucherDetailResponse
     */
    'appTypes': Array<AppTypeEnum>;
    /**
     * 
     * @type {Array<UserRoleEnum>}
     * @memberof AdminsLoyaltyGetVoucherDetailResponse
     */
    'userRoles': Array<UserRoleEnum>;
    /**
     * 
     * @type {Array<DeliveryMethodEnum>}
     * @memberof AdminsLoyaltyGetVoucherDetailResponse
     */
    'orderDeliveryMethods': Array<DeliveryMethodEnum>;
    /**
     * Voucher is point available
     * @type {boolean}
     * @memberof AdminsLoyaltyGetVoucherDetailResponse
     */
    'isSawitPoin': boolean;
}


/**
 * 
 * @export
 * @interface AdminsLoyaltyGetVoucherGenerateCode
 */
export interface AdminsLoyaltyGetVoucherGenerateCode {
    /**
     * Voucher CODE
     * @type {string}
     * @memberof AdminsLoyaltyGetVoucherGenerateCode
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface AdminsLoyaltyGetVoucherListResponse
 */
export interface AdminsLoyaltyGetVoucherListResponse {
    /**
     * 
     * @type {Array<AdminsLoyaltyGetVoucherListResponseItem>}
     * @memberof AdminsLoyaltyGetVoucherListResponse
     */
    'items': Array<AdminsLoyaltyGetVoucherListResponseItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof AdminsLoyaltyGetVoucherListResponse
     */
    'pagination': PaginationResponse;
}
/**
 * 
 * @export
 * @interface AdminsLoyaltyGetVoucherListResponseItem
 */
export interface AdminsLoyaltyGetVoucherListResponseItem {
    /**
     * Voucher UUID
     * @type {string}
     * @memberof AdminsLoyaltyGetVoucherListResponseItem
     */
    'id': string;
    /**
     * Voucher name
     * @type {string}
     * @memberof AdminsLoyaltyGetVoucherListResponseItem
     */
    'name': string;
    /**
     * Voucher code
     * @type {string}
     * @memberof AdminsLoyaltyGetVoucherListResponseItem
     */
    'code'?: string;
    /**
     * 
     * @type {VoucherTypeEnum}
     * @memberof AdminsLoyaltyGetVoucherListResponseItem
     */
    'type': VoucherTypeEnum;
    /**
     * Voucher label
     * @type {string}
     * @memberof AdminsLoyaltyGetVoucherListResponseItem
     */
    'label': string;
    /**
     * Total redemption
     * @type {number}
     * @memberof AdminsLoyaltyGetVoucherListResponseItem
     */
    'totalRedemption': number;
    /**
     * Maximum redemption
     * @type {number}
     * @memberof AdminsLoyaltyGetVoucherListResponseItem
     */
    'maxRedemption': number;
    /**
     * Maximum redemption per user
     * @type {number}
     * @memberof AdminsLoyaltyGetVoucherListResponseItem
     */
    'maxRedemptionPerUser': number;
    /**
     * Voucher start datetime at UTC+0
     * @type {number}
     * @memberof AdminsLoyaltyGetVoucherListResponseItem
     */
    'startDatetimeAtUtc0': number;
    /**
     * Voucher end datetime at UTC+0
     * @type {number}
     * @memberof AdminsLoyaltyGetVoucherListResponseItem
     */
    'endDatetimeAtUtc0': number;
    /**
     * status of voucher | - ACTIVE - INACTIVE
     * @type {string}
     * @memberof AdminsLoyaltyGetVoucherListResponseItem
     */
    'status': string;
}


/**
 * 
 * @export
 * @interface AdminsLoyaltyVoucherRuleCategoryItem
 */
export interface AdminsLoyaltyVoucherRuleCategoryItem {
    /**
     * Voucher UUID
     * @type {string}
     * @memberof AdminsLoyaltyVoucherRuleCategoryItem
     */
    'id': string;
    /**
     * name of category
     * @type {string}
     * @memberof AdminsLoyaltyVoucherRuleCategoryItem
     */
    'name': string;
    /**
     * category code
     * @type {string}
     * @memberof AdminsLoyaltyVoucherRuleCategoryItem
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface AdminsLoyaltyVoucherRuleProductItem
 */
export interface AdminsLoyaltyVoucherRuleProductItem {
    /**
     * Voucher UUID
     * @type {string}
     * @memberof AdminsLoyaltyVoucherRuleProductItem
     */
    'id': string;
    /**
     * name of product
     * @type {string}
     * @memberof AdminsLoyaltyVoucherRuleProductItem
     */
    'name': string;
    /**
     * 
     * @type {EcommerceProductTypeEnum}
     * @memberof AdminsLoyaltyVoucherRuleProductItem
     */
    'type': EcommerceProductTypeEnum;
}


/**
 * 
 * @export
 * @interface AdminsLoyaltyVoucherRuleStoreItem
 */
export interface AdminsLoyaltyVoucherRuleStoreItem {
    /**
     * Voucher UUID
     * @type {string}
     * @memberof AdminsLoyaltyVoucherRuleStoreItem
     */
    'id': string;
    /**
     * name of category
     * @type {string}
     * @memberof AdminsLoyaltyVoucherRuleStoreItem
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface AdminsMarketingsCreateArticleRequest
 */
export interface AdminsMarketingsCreateArticleRequest {
    /**
     * title of the article
     * @type {string}
     * @memberof AdminsMarketingsCreateArticleRequest
     */
    'title': string;
    /**
     * excerpt of the article
     * @type {string}
     * @memberof AdminsMarketingsCreateArticleRequest
     */
    'excerpt': string;
    /**
     * url of the image
     * @type {string}
     * @memberof AdminsMarketingsCreateArticleRequest
     */
    'imageUrl': string;
    /**
     * url of the article
     * @type {string}
     * @memberof AdminsMarketingsCreateArticleRequest
     */
    'sourceUrl': string;
    /**
     * sequence of a article, will be used for sorting
     * @type {number}
     * @memberof AdminsMarketingsCreateArticleRequest
     */
    'sequence': number;
    /**
     * time when the article is published in unix timestamp
     * @type {number}
     * @memberof AdminsMarketingsCreateArticleRequest
     */
    'publishedDateAtUtc0': number;
}
/**
 * Response data
 * @export
 * @interface AdminsMarketingsCreateArticleResponse
 */
export interface AdminsMarketingsCreateArticleResponse {
    /**
     * ID of the newly created article
     * @type {string}
     * @memberof AdminsMarketingsCreateArticleResponse
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface AdminsMarketingsCreateTestimonialRequest
 */
export interface AdminsMarketingsCreateTestimonialRequest {
    /**
     * title of the testimonial
     * @type {string}
     * @memberof AdminsMarketingsCreateTestimonialRequest
     */
    'title': string;
    /**
     * body of the testimonial
     * @type {string}
     * @memberof AdminsMarketingsCreateTestimonialRequest
     */
    'body': string;
    /**
     * name of the writer
     * @type {string}
     * @memberof AdminsMarketingsCreateTestimonialRequest
     */
    'writerName': string;
    /**
     * role of the writer
     * @type {string}
     * @memberof AdminsMarketingsCreateTestimonialRequest
     */
    'writerRole': string;
    /**
     * url of the writer picture
     * @type {string}
     * @memberof AdminsMarketingsCreateTestimonialRequest
     */
    'writerPictureUrl': string;
    /**
     * sequence of the testimonial, will be used for sorting
     * @type {number}
     * @memberof AdminsMarketingsCreateTestimonialRequest
     */
    'sequence': number;
    /**
     * scopes of testimonial will be showed
     * @type {Array<string>}
     * @memberof AdminsMarketingsCreateTestimonialRequest
     */
    'scopes': Array<string>;
}
/**
 * Response data
 * @export
 * @interface AdminsMarketingsCreateTestimonialResponse
 */
export interface AdminsMarketingsCreateTestimonialResponse {
    /**
     * ID of the newly created testimonial
     * @type {string}
     * @memberof AdminsMarketingsCreateTestimonialResponse
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface AdminsOrdersDeliveriesUpdateRequest
 */
export interface AdminsOrdersDeliveriesUpdateRequest {
    /**
     * Recipient name
     * @type {string}
     * @memberof AdminsOrdersDeliveriesUpdateRequest
     */
    'recipientName': string;
    /**
     * Phone number starting with 0 as prefix (08xxxxxxxxx)
     * @type {string}
     * @memberof AdminsOrdersDeliveriesUpdateRequest
     */
    'recipientPhoneNo': string;
    /**
     * Recipient vehicle number
     * @type {string}
     * @memberof AdminsOrdersDeliveriesUpdateRequest
     */
    'vehicleLicenseNo': string;
}
/**
 * 
 * @export
 * @interface AdminsOrdersDeliveriesUpdateResponse
 */
export interface AdminsOrdersDeliveriesUpdateResponse {
    /**
     * Successfully to update order delivery information
     * @type {boolean}
     * @memberof AdminsOrdersDeliveriesUpdateResponse
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface AdminsPlantationsCreateSeedRequest
 */
export interface AdminsPlantationsCreateSeedRequest {
    /**
     * name of a plantation seed
     * @type {string}
     * @memberof AdminsPlantationsCreateSeedRequest
     */
    'name': string;
    /**
     * description of a plantation seed
     * @type {string}
     * @memberof AdminsPlantationsCreateSeedRequest
     */
    'description': string;
    /**
     * variety of a plantation seed
     * @type {string}
     * @memberof AdminsPlantationsCreateSeedRequest
     */
    'variety': string;
    /**
     * sequence of a plantation seed, will be used for sorting
     * @type {number}
     * @memberof AdminsPlantationsCreateSeedRequest
     */
    'sequence': number;
    /**
     * active status for a planation seed. true for active, otherwise false. Default is true
     * @type {boolean}
     * @memberof AdminsPlantationsCreateSeedRequest
     */
    'isActive'?: boolean;
}
/**
 * 
 * @export
 * @interface AdminsPlantationsCreateSeedResponse
 */
export interface AdminsPlantationsCreateSeedResponse {
    /**
     * seed id
     * @type {string}
     * @memberof AdminsPlantationsCreateSeedResponse
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface AdminsPlantationsSeedsCreateYieldRequest
 */
export interface AdminsPlantationsSeedsCreateYieldRequest {
    /**
     * ID of the seed / seed brand in relation to table \'seed\'
     * @type {string}
     * @memberof AdminsPlantationsSeedsCreateYieldRequest
     */
    'seedId': string;
    /**
     * plantation seed growth stage <br> IMMATURE = not yet producing (TBM, 1 - 30 month) <br> MATURE_1 = is producing stage 1 (TM 1, 31 month/3 year - 8 year) <br> MATURE_2 = is producing stage 2 (TM 2, 8 - 15 year) <br> MATURE_3 = is producing stage 3 (TM 3, 15 - 20 year) <br> MATURE_4 = is producing stage 4 (TM 4, > 20 year)
     * @type {string}
     * @memberof AdminsPlantationsSeedsCreateYieldRequest
     */
    'growthStage': AdminsPlantationsSeedsCreateYieldRequestGrowthStageEnum;
    /**
     * the low range yield per hectare in ton data for the specified seed and growth stage
     * @type {number}
     * @memberof AdminsPlantationsSeedsCreateYieldRequest
     */
    'estateMonthlyYieldLow': number;
    /**
     * the high range yield per hectare in ton data for the specified seed and growth stage
     * @type {number}
     * @memberof AdminsPlantationsSeedsCreateYieldRequest
     */
    'estateMonthlyYieldHigh': number;
    /**
     * URL data source for this seed yield data
     * @type {string}
     * @memberof AdminsPlantationsSeedsCreateYieldRequest
     */
    'source': string;
    /**
     * flag to set data is_active column value in DB, default true
     * @type {boolean}
     * @memberof AdminsPlantationsSeedsCreateYieldRequest
     */
    'isActive'?: boolean;
}

export const AdminsPlantationsSeedsCreateYieldRequestGrowthStageEnum = {
    Immature: 'IMMATURE',
    Mature1: 'MATURE_1',
    Mature2: 'MATURE_2',
    Mature3: 'MATURE_3',
    Mature4: 'MATURE_4'
} as const;

export type AdminsPlantationsSeedsCreateYieldRequestGrowthStageEnum = typeof AdminsPlantationsSeedsCreateYieldRequestGrowthStageEnum[keyof typeof AdminsPlantationsSeedsCreateYieldRequestGrowthStageEnum];

/**
 * 
 * @export
 * @interface AdminsPlantationsSeedsCreateYieldResponse
 */
export interface AdminsPlantationsSeedsCreateYieldResponse {
    /**
     * the created seed_yield data id in DB
     * @type {string}
     * @memberof AdminsPlantationsSeedsCreateYieldResponse
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface AdminsPlantationsSeedsUpdateYieldRequest
 */
export interface AdminsPlantationsSeedsUpdateYieldRequest {
    /**
     * ID of the to be updated seed_yield data in DB
     * @type {string}
     * @memberof AdminsPlantationsSeedsUpdateYieldRequest
     */
    'id': string;
    /**
     * the low range yield per hectare in ton data for the specified seed and growth stage
     * @type {number}
     * @memberof AdminsPlantationsSeedsUpdateYieldRequest
     */
    'estateMonthlyYieldLow': number;
    /**
     * the high range yield per hectare in ton data for the specified seed and growth stage
     * @type {number}
     * @memberof AdminsPlantationsSeedsUpdateYieldRequest
     */
    'estateMonthlyYieldHigh': number;
    /**
     * URL data source for this seed yield data
     * @type {string}
     * @memberof AdminsPlantationsSeedsUpdateYieldRequest
     */
    'source': string;
    /**
     * flag to set data is_active column value in DB, default true
     * @type {boolean}
     * @memberof AdminsPlantationsSeedsUpdateYieldRequest
     */
    'isActive'?: boolean;
}
/**
 * 
 * @export
 * @interface AdminsPlantationsSeedsUpdateYieldResponse
 */
export interface AdminsPlantationsSeedsUpdateYieldResponse {
    /**
     * the updated seed_yield data id in DB
     * @type {string}
     * @memberof AdminsPlantationsSeedsUpdateYieldResponse
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface AdminsPlantationsUpdateSeedRequest
 */
export interface AdminsPlantationsUpdateSeedRequest {
    /**
     * id of a plantation seed, set to empty for create
     * @type {string}
     * @memberof AdminsPlantationsUpdateSeedRequest
     */
    'id'?: string;
    /**
     * name of a plantation seed
     * @type {string}
     * @memberof AdminsPlantationsUpdateSeedRequest
     */
    'name': string;
    /**
     * description of a plantation seed
     * @type {string}
     * @memberof AdminsPlantationsUpdateSeedRequest
     */
    'description': string;
    /**
     * variety of a plantation seed
     * @type {string}
     * @memberof AdminsPlantationsUpdateSeedRequest
     */
    'variety': string;
    /**
     * sequence of a plantation seed, will be used for sorting
     * @type {number}
     * @memberof AdminsPlantationsUpdateSeedRequest
     */
    'sequence': number;
    /**
     * active status for a planation seed. true for active, otherwise false. Default is true
     * @type {boolean}
     * @memberof AdminsPlantationsUpdateSeedRequest
     */
    'isActive'?: boolean;
}
/**
 * 
 * @export
 * @interface AdminsPlantationsUpdateSeedResponse
 */
export interface AdminsPlantationsUpdateSeedResponse {
    /**
     * seed id
     * @type {string}
     * @memberof AdminsPlantationsUpdateSeedResponse
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface AdminsRampVerifyRequest
 */
export interface AdminsRampVerifyRequest {
    /**
     * Status of the Ramp
     * @type {boolean}
     * @memberof AdminsRampVerifyRequest
     */
    'isVerified': boolean;
    /**
     * The reason when asset rejected or not verified
     * @type {string}
     * @memberof AdminsRampVerifyRequest
     */
    'reason'?: string;
}
/**
 * 
 * @export
 * @interface AdminsRampVerifyResponse
 */
export interface AdminsRampVerifyResponse {
    /**
     * ID of the Ramp
     * @type {string}
     * @memberof AdminsRampVerifyResponse
     */
    'id': string;
    /**
     * Name of the Ramp
     * @type {string}
     * @memberof AdminsRampVerifyResponse
     */
    'name': string;
    /**
     * 
     * @type {RampStatusEnum}
     * @memberof AdminsRampVerifyResponse
     */
    'status': RampStatusEnum;
}


/**
 * 
 * @export
 * @interface AdminsSawitpoinRedistributionRequest
 */
export interface AdminsSawitpoinRedistributionRequest {
    /**
     * Id of redistribution
     * @type {string}
     * @memberof AdminsSawitpoinRedistributionRequest
     */
    'id'?: string;
}
/**
 * Request data adding stock
 * @export
 * @interface AdminsSupplyChainInventoryStockCreateRequest
 */
export interface AdminsSupplyChainInventoryStockCreateRequest {
    /**
     * product id
     * @type {string}
     * @memberof AdminsSupplyChainInventoryStockCreateRequest
     */
    'productId': string;
    /**
     * store id
     * @type {string}
     * @memberof AdminsSupplyChainInventoryStockCreateRequest
     */
    'storeId': string;
    /**
     * stock amount
     * @type {number}
     * @memberof AdminsSupplyChainInventoryStockCreateRequest
     */
    'stockAmount': number;
    /**
     * is active
     * @type {boolean}
     * @memberof AdminsSupplyChainInventoryStockCreateRequest
     */
    'isActive'?: boolean;
}
/**
 * Response data adding product stock in inventory
 * @export
 * @interface AdminsSupplyChainInventoryStockCreateResponse
 */
export interface AdminsSupplyChainInventoryStockCreateResponse {
    /**
     * pricelist id
     * @type {string}
     * @memberof AdminsSupplyChainInventoryStockCreateResponse
     */
    'id': string;
}
/**
 * Response get detail stock detail
 * @export
 * @interface AdminsSupplyChainInventoryStockGetDetailResponse
 */
export interface AdminsSupplyChainInventoryStockGetDetailResponse {
    /**
     * stock id
     * @type {string}
     * @memberof AdminsSupplyChainInventoryStockGetDetailResponse
     */
    'Id'?: string;
    /**
     * product id
     * @type {string}
     * @memberof AdminsSupplyChainInventoryStockGetDetailResponse
     */
    'productId': string;
    /**
     * store id
     * @type {string}
     * @memberof AdminsSupplyChainInventoryStockGetDetailResponse
     */
    'storeId': string;
    /**
     * stock amount
     * @type {number}
     * @memberof AdminsSupplyChainInventoryStockGetDetailResponse
     */
    'stockAmount': number;
    /**
     * is active
     * @type {boolean}
     * @memberof AdminsSupplyChainInventoryStockGetDetailResponse
     */
    'isActive': boolean;
}
/**
 * Request data update stock
 * @export
 * @interface AdminsSupplyChainInventoryStockUpdateRequest
 */
export interface AdminsSupplyChainInventoryStockUpdateRequest {
    /**
     * product id
     * @type {string}
     * @memberof AdminsSupplyChainInventoryStockUpdateRequest
     */
    'productId': string;
    /**
     * store id
     * @type {string}
     * @memberof AdminsSupplyChainInventoryStockUpdateRequest
     */
    'storeId': string;
    /**
     * stock amount
     * @type {number}
     * @memberof AdminsSupplyChainInventoryStockUpdateRequest
     */
    'stockAmount': number;
    /**
     * is active
     * @type {boolean}
     * @memberof AdminsSupplyChainInventoryStockUpdateRequest
     */
    'isActive'?: boolean;
}
/**
 * Response data update product stock in inventory
 * @export
 * @interface AdminsSupplyChainInventoryStockUpdateResponse
 */
export interface AdminsSupplyChainInventoryStockUpdateResponse {
    /**
     * pricelist id
     * @type {string}
     * @memberof AdminsSupplyChainInventoryStockUpdateResponse
     */
    'id': string;
}
/**
 * @type AdminsSurveysCreateRequest
 * @export
 */
export type AdminsSurveysCreateRequest = Array<SurveyCreateRequest> | FeatureCollection;

/**
 * 
 * @export
 * @interface AdminsSurveysCreateResponseItem
 */
export interface AdminsSurveysCreateResponseItem {
    /**
     * ID of the newly created survey represented in UUID type 4
     * @type {string}
     * @memberof AdminsSurveysCreateResponseItem
     */
    'id'?: string;
    /**
     * error message for this surveys entity
     * @type {string}
     * @memberof AdminsSurveysCreateResponseItem
     */
    'errorMessage'?: string;
}
/**
 * 
 * @export
 * @interface AdminsUpdateAgronomistBookingRequest
 */
export interface AdminsUpdateAgronomistBookingRequest {
    /**
     * ID of the booking in UUID type 4
     * @type {string}
     * @memberof AdminsUpdateAgronomistBookingRequest
     */
    'bookingId': string;
    /**
     * 
     * @type {StatusAgronomistBookingEnum}
     * @memberof AdminsUpdateAgronomistBookingRequest
     */
    'bookingStatus': StatusAgronomistBookingEnum;
}


/**
 * 
 * @export
 * @interface AdminsUpdateAgronomistBookingResponse
 */
export interface AdminsUpdateAgronomistBookingResponse {
    /**
     * 
     * @type {boolean}
     * @memberof AdminsUpdateAgronomistBookingResponse
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface AdminsUpdateBannerRequest
 */
export interface AdminsUpdateBannerRequest {
    /**
     * ID of the banner to be updated represented in UUID type 4
     * @type {string}
     * @memberof AdminsUpdateBannerRequest
     */
    'id': string;
    /**
     * Title of a banner
     * @type {string}
     * @memberof AdminsUpdateBannerRequest
     */
    'title'?: string;
    /**
     * Description of a banner that contains more information than the banner\'s title
     * @type {string}
     * @memberof AdminsUpdateBannerRequest
     */
    'description'?: string;
    /**
     * link of a media (image, gif, or video) of a banner to be shown to user. The link must be publicly accessible
     * @type {string}
     * @memberof AdminsUpdateBannerRequest
     */
    'link'?: string;
    /**
     * 
     * @type {BannerTypeEnum}
     * @memberof AdminsUpdateBannerRequest
     */
    'type'?: BannerTypeEnum;
    /**
     * link to be used as deeplink or redirected to other website
     * @type {string}
     * @memberof AdminsUpdateBannerRequest
     */
    'embededLink'?: string;
    /**
     * scopes of banner will be showed
     * @type {Array<string>}
     * @memberof AdminsUpdateBannerRequest
     */
    'scopes'?: Array<string>;
    /**
     * priority of banner image order/sequence shown in the client API resp
     * @type {number}
     * @memberof AdminsUpdateBannerRequest
     */
    'priority'?: number;
}


/**
 * 
 * @export
 * @interface AdminsUpdateBannerResponse
 */
export interface AdminsUpdateBannerResponse {
    /**
     * ID of the updated banner represented in UUIDv4
     * @type {string}
     * @memberof AdminsUpdateBannerResponse
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface AdminsUserListResponse
 */
export interface AdminsUserListResponse {
    /**
     * 
     * @type {Array<AdminsUserListResponseItem>}
     * @memberof AdminsUserListResponse
     */
    'items': Array<AdminsUserListResponseItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof AdminsUserListResponse
     */
    'pagination': PaginationResponse;
}
/**
 * 
 * @export
 * @interface AdminsUserListResponseItem
 */
export interface AdminsUserListResponseItem {
    /**
     * ID of the user
     * @type {string}
     * @memberof AdminsUserListResponseItem
     */
    'id': string;
    /**
     * Name of the user
     * @type {string}
     * @memberof AdminsUserListResponseItem
     */
    'name': string;
    /**
     * Phone number starting with 0 as prefix (08xxxxxxxxx)
     * @type {string}
     * @memberof AdminsUserListResponseItem
     */
    'phoneNo': string;
}
/**
 * 
 * @export
 * @interface AdminsWorkersPatchActivitiesRequest
 */
export interface AdminsWorkersPatchActivitiesRequest {
    /**
     * 
     * @type {WorkerActivitiesVerificationStatusEnum}
     * @memberof AdminsWorkersPatchActivitiesRequest
     */
    'verificationStatus': WorkerActivitiesVerificationStatusEnum;
}


/**
 * 
 * @export
 * @interface AgronomistBookingRequest
 */
export interface AgronomistBookingRequest {
    /**
     * Name of member who want to book Agronomist\'s conslutation.
     * @type {string}
     * @memberof AgronomistBookingRequest
     */
    'name': string;
    /**
     * Encrypted phoneNumber using RSA256 with public key that\'s retrieved from local database
     * @type {string}
     * @memberof AgronomistBookingRequest
     */
    'phoneNumber': string;
    /**
     * 
     * @type {Village}
     * @memberof AgronomistBookingRequest
     */
    'farmAddress': Village;
    /**
     * Farm area in hectare
     * @type {number}
     * @memberof AgronomistBookingRequest
     */
    'farmArea': number;
    /**
     * 
     * @type {AverageEstateMonthlyYieldEnum}
     * @memberof AgronomistBookingRequest
     */
    'averageEstateMonthlyYield': AverageEstateMonthlyYieldEnum;
    /**
     * 
     * @type {SoilTypeEnum}
     * @memberof AgronomistBookingRequest
     * @deprecated
     */
    'soilType': SoilTypeEnum;
    /**
     * 
     * @type {SeedTypeEnum}
     * @memberof AgronomistBookingRequest
     * @deprecated
     */
    'seedType': SeedTypeEnum;
    /**
     * OrderId of an argonomist booking service in UUID
     * @type {string}
     * @memberof AgronomistBookingRequest
     */
    'orderId': string;
    /**
     * booking date in string \"yyyy-mm-dd\" format
     * @type {string}
     * @memberof AgronomistBookingRequest
     */
    'date'?: string;
    /**
     * ID of the time slot in UUID type 4
     * @type {string}
     * @memberof AgronomistBookingRequest
     */
    'timeSlotId'?: string;
    /**
     * Product UUID
     * @type {string}
     * @memberof AgronomistBookingRequest
     */
    'productId': string;
    /**
     * explanation of problems to be consultated
     * @type {string}
     * @memberof AgronomistBookingRequest
     */
    'problem': string;
    /**
     * user ID of the doctor
     * @type {string}
     * @memberof AgronomistBookingRequest
     */
    'doctorId'?: string;
}


/**
 * 
 * @export
 * @interface AgronomistBookingResponse
 */
export interface AgronomistBookingResponse {
    /**
     * ID of the created booking in UUID type 4
     * @type {string}
     * @memberof AgronomistBookingResponse
     */
    'bookingId'?: string;
}
/**
 * 
 * @export
 * @interface AgronomistBookingSummaryResponse
 */
export interface AgronomistBookingSummaryResponse {
    /**
     * ID of the agronomy booking detail
     * @type {string}
     * @memberof AgronomistBookingSummaryResponse
     */
    'bookingId': string;
    /**
     * agronomy problem description submitted by user
     * @type {string}
     * @memberof AgronomistBookingSummaryResponse
     */
    'problem': string;
    /**
     * images uploaded by user for this agronomy booking
     * @type {Array<string>}
     * @memberof AgronomistBookingSummaryResponse
     */
    'imageUrls': Array<string>;
    /**
     * url of a document contains summary detail
     * @type {string}
     * @memberof AgronomistBookingSummaryResponse
     */
    'documentUrl': string;
    /**
     * 
     * @type {AgronomyBookingSummaryDetail}
     * @memberof AgronomistBookingSummaryResponse
     */
    'detail': AgronomyBookingSummaryDetail;
    /**
     * contains summary detail with html tags
     * @type {string}
     * @memberof AgronomistBookingSummaryResponse
     */
    'htmlDetail': string;
    /**
     * 
     * @type {AgronomyGetBookingDetailResponseTaskCount}
     * @memberof AgronomistBookingSummaryResponse
     */
    'taskCount': AgronomyGetBookingDetailResponseTaskCount;
}
/**
 * 
 * @export
 * @interface AgronomistUpdateBookingStatusRequest
 */
export interface AgronomistUpdateBookingStatusRequest {
    /**
     * 
     * @type {StatusAgronomistBookingEnum}
     * @memberof AgronomistUpdateBookingStatusRequest
     */
    'status': StatusAgronomistBookingEnum;
}


/**
 * 
 * @export
 * @interface AgronomistUpdateBookingStatusResponse
 */
export interface AgronomistUpdateBookingStatusResponse {
    /**
     * 
     * @type {boolean}
     * @memberof AgronomistUpdateBookingStatusResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface AgronomyBookingCreateRequest
 */
export interface AgronomyBookingCreateRequest {
    /**
     * ID of a selected farm
     * @type {string}
     * @memberof AgronomyBookingCreateRequest
     */
    'farmId': string;
    /**
     * Name of member who want to book agronomy conslutation.
     * @type {string}
     * @memberof AgronomyBookingCreateRequest
     */
    'userName': string;
    /**
     * Encrypted phoneNumber using RSA256 with public key that\'s retrieved from local database
     * @type {string}
     * @memberof AgronomyBookingCreateRequest
     */
    'userPhoneNumber': string;
    /**
     * explanation of problems to be consultated
     * @type {string}
     * @memberof AgronomyBookingCreateRequest
     */
    'problem': string;
    /**
     * 
     * @type {OrderCreateRequest}
     * @memberof AgronomyBookingCreateRequest
     */
    'order': OrderCreateRequest;
}
/**
 * 
 * @export
 * @interface AgronomyBookingCreateResponse
 */
export interface AgronomyBookingCreateResponse {
    /**
     * ID of the created booking in UUID type 4
     * @type {string}
     * @memberof AgronomyBookingCreateResponse
     */
    'bookingId': string;
    /**
     * 
     * @type {OrderCreateResponse}
     * @memberof AgronomyBookingCreateResponse
     */
    'order': OrderCreateResponse;
}
/**
 * List of agronomist booking grouped by user id
 * @export
 * @interface AgronomyBookingListByIdResponse
 */
export interface AgronomyBookingListByIdResponse {
    /**
     * 
     * @type {Array<BookingItem>}
     * @memberof AgronomyBookingListByIdResponse
     */
    'items': Array<BookingItem>;
}
/**
 * BOOKED = booking schedule is already booked NOT AVAILABLE = booking schedule is not available AVAILABLE = booking schedule is available and can be booked 
 * @export
 * @enum {string}
 */

export const AgronomyBookingScheduleStatusEnum = {
    Booked: 'BOOKED',
    NotAvailable: 'NOT_AVAILABLE',
    Available: 'AVAILABLE'
} as const;

export type AgronomyBookingScheduleStatusEnum = typeof AgronomyBookingScheduleStatusEnum[keyof typeof AgronomyBookingScheduleStatusEnum];


/**
 * 
 * @export
 * @interface AgronomyBookingSummaryDetail
 */
export interface AgronomyBookingSummaryDetail {
    /**
     * symptom that happen
     * @type {string}
     * @memberof AgronomyBookingSummaryDetail
     */
    'condition': string;
    /**
     * cause of the problem based on symptom
     * @type {string}
     * @memberof AgronomyBookingSummaryDetail
     */
    'diagnose': string;
    /**
     * advice to be given based on diagnosis
     * @type {string}
     * @memberof AgronomyBookingSummaryDetail
     */
    'advice': string;
}
/**
 * 
 * @export
 * @interface AgronomyBookingsGetSchedulesResponse
 */
export interface AgronomyBookingsGetSchedulesResponse {
    /**
     * 
     * @type {Array<AgronomyBookingsGetSchedulesResponseItem>}
     * @memberof AgronomyBookingsGetSchedulesResponse
     */
    'items': Array<AgronomyBookingsGetSchedulesResponseItem>;
}
/**
 * 
 * @export
 * @interface AgronomyBookingsGetSchedulesResponseItem
 */
export interface AgronomyBookingsGetSchedulesResponseItem {
    /**
     * Id of the agronomy booking schedule date
     * @type {string}
     * @memberof AgronomyBookingsGetSchedulesResponseItem
     */
    'scheduleDateId': string;
    /**
     * time in epoch millis with timezone JKT and without hour, minute, second
     * @type {number}
     * @memberof AgronomyBookingsGetSchedulesResponseItem
     */
    'date': number;
    /**
     * label of the date with DD/MM/YYYY format
     * @type {string}
     * @memberof AgronomyBookingsGetSchedulesResponseItem
     */
    'description': string;
    /**
     * 
     * @type {AgronomyBookingScheduleStatusEnum}
     * @memberof AgronomyBookingsGetSchedulesResponseItem
     */
    'status': AgronomyBookingScheduleStatusEnum;
    /**
     * 
     * @type {Array<AgronomyBookingsGetSchedulesResponseItemTimeSlot>}
     * @memberof AgronomyBookingsGetSchedulesResponseItem
     */
    'timeSlots': Array<AgronomyBookingsGetSchedulesResponseItemTimeSlot>;
}


/**
 * 
 * @export
 * @interface AgronomyBookingsGetSchedulesResponseItemTimeSlot
 */
export interface AgronomyBookingsGetSchedulesResponseItemTimeSlot {
    /**
     * Id of the agronomy booking schedule
     * @type {string}
     * @memberof AgronomyBookingsGetSchedulesResponseItemTimeSlot
     */
    'scheduleId': string;
    /**
     * label of the time slot
     * @type {string}
     * @memberof AgronomyBookingsGetSchedulesResponseItemTimeSlot
     */
    'label': string;
    /**
     * 
     * @type {AgronomyBookingScheduleStatusEnum}
     * @memberof AgronomyBookingsGetSchedulesResponseItemTimeSlot
     */
    'status': AgronomyBookingScheduleStatusEnum;
}


/**
 * 
 * @export
 * @interface AgronomyBookingsGetTaskDetailResponse
 */
export interface AgronomyBookingsGetTaskDetailResponse {
    /**
     * ID of the agronomy booking task
     * @type {string}
     * @memberof AgronomyBookingsGetTaskDetailResponse
     */
    'taskId': string;
    /**
     * the amount of sawit point rewarded when user completed task, if point <= 0 this task is not eligible for reward.
     * @type {number}
     * @memberof AgronomyBookingsGetTaskDetailResponse
     */
    'pointReward': number;
    /**
     * 
     * @type {AgronomyBookingsTasksStatusEnum}
     * @memberof AgronomyBookingsGetTaskDetailResponse
     */
    'status': AgronomyBookingsTasksStatusEnum;
    /**
     * task\'s scheduled start date in unix timestamp
     * @type {number}
     * @memberof AgronomyBookingsGetTaskDetailResponse
     */
    'startDateUtc0': number;
    /**
     * task\'s scheduled end date in unix timestamp
     * @type {number}
     * @memberof AgronomyBookingsGetTaskDetailResponse
     */
    'endDateUtc0': number;
    /**
     * time when user completed task in unix timestamp
     * @type {number}
     * @memberof AgronomyBookingsGetTaskDetailResponse
     */
    'doneAtUtc0': number;
    /**
     * content of the agronomy task in \"Tugas\" section.
     * @type {string}
     * @memberof AgronomyBookingsGetTaskDetailResponse
     */
    'detailTask': string;
    /**
     * content of the agronomy task in \"Saran\" section, value in HTML format.
     * @type {string}
     * @memberof AgronomyBookingsGetTaskDetailResponse
     */
    'detailSuggestion'?: string;
}


/**
 * 
 * @export
 * @interface AgronomyBookingsGetTasksResponse
 */
export interface AgronomyBookingsGetTasksResponse {
    /**
     * 
     * @type {Array<AgronomyBookingsGetTasksResponseItem>}
     * @memberof AgronomyBookingsGetTasksResponse
     */
    'items': Array<AgronomyBookingsGetTasksResponseItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof AgronomyBookingsGetTasksResponse
     */
    'pagination': PaginationResponse;
}
/**
 * 
 * @export
 * @interface AgronomyBookingsGetTasksResponseItem
 */
export interface AgronomyBookingsGetTasksResponseItem {
    /**
     * ID of the agronomy booking task
     * @type {string}
     * @memberof AgronomyBookingsGetTasksResponseItem
     */
    'taskId': string;
    /**
     * the amount of sawit point rewarded when user completed task, if point <= 0 this task is not eligible for reward.
     * @type {number}
     * @memberof AgronomyBookingsGetTasksResponseItem
     */
    'pointReward': number;
    /**
     * 
     * @type {AgronomyBookingsTasksStatusEnum}
     * @memberof AgronomyBookingsGetTasksResponseItem
     */
    'status': AgronomyBookingsTasksStatusEnum;
    /**
     * task\'s scheduled start date in unix timestamp
     * @type {number}
     * @memberof AgronomyBookingsGetTasksResponseItem
     */
    'startDateUtc0': number;
    /**
     * task\'s scheduled end date in unix timestamp
     * @type {number}
     * @memberof AgronomyBookingsGetTasksResponseItem
     */
    'endDateUtc0': number;
    /**
     * time when user completed task in unix timestamp
     * @type {number}
     * @memberof AgronomyBookingsGetTasksResponseItem
     */
    'doneAtUtc0': number;
    /**
     * content of the agronomy task in \"Tugas\" section.
     * @type {string}
     * @memberof AgronomyBookingsGetTasksResponseItem
     */
    'detailTask': string;
}


/**
 * UPCOMING = not yet in scheduled task\'s start time <br> WAITING = waiting for user to do task <br> CONFIRMING = task done by user is in progress confirmation by system <br> DONE = task already done by user <br> 
 * @export
 * @enum {string}
 */

export const AgronomyBookingsTasksStatusEnum = {
    Upcoming: 'UPCOMING',
    Waiting: 'WAITING',
    Confirming: 'CONFIRMING',
    Done: 'DONE'
} as const;

export type AgronomyBookingsTasksStatusEnum = typeof AgronomyBookingsTasksStatusEnum[keyof typeof AgronomyBookingsTasksStatusEnum];


/**
 * 
 * @export
 * @interface AgronomyBookingsUpdateTaskRequest
 */
export interface AgronomyBookingsUpdateTaskRequest {
    /**
     * 
     * @type {AgronomyBookingsTasksStatusEnum}
     * @memberof AgronomyBookingsUpdateTaskRequest
     */
    'status': AgronomyBookingsTasksStatusEnum;
    /**
     * Photo to prove the the task has been done by user (not used yet)
     * @type {File}
     * @memberof AgronomyBookingsUpdateTaskRequest
     */
    'photo'?: File;
}


/**
 * 
 * @export
 * @interface AgronomyBookingsUpdateTaskResponse
 */
export interface AgronomyBookingsUpdateTaskResponse {
    /**
     * ID of the agronomy booking task
     * @type {string}
     * @memberof AgronomyBookingsUpdateTaskResponse
     */
    'taskId': string;
    /**
     * the amount of sawit point rewarded when user completed task, if point <= 0 this task is not eligible for reward.
     * @type {number}
     * @memberof AgronomyBookingsUpdateTaskResponse
     */
    'pointReward': number;
}
/**
 * 
 * @export
 * @interface AgronomyGetAgronomistsResponse
 */
export interface AgronomyGetAgronomistsResponse {
    /**
     * 
     * @type {Array<AgronomyGetAgronomistsResponseItem>}
     * @memberof AgronomyGetAgronomistsResponse
     */
    'items': Array<AgronomyGetAgronomistsResponseItem>;
}
/**
 * 
 * @export
 * @interface AgronomyGetAgronomistsResponseItem
 */
export interface AgronomyGetAgronomistsResponseItem {
    /**
     * id of the agoronomist data in DB represented in UUID type 4
     * @type {string}
     * @memberof AgronomyGetAgronomistsResponseItem
     */
    'id': string;
    /**
     * url of the agronomist photo
     * @type {string}
     * @memberof AgronomyGetAgronomistsResponseItem
     */
    'imageUrl': string;
    /**
     * full name with title of the agronomist
     * @type {string}
     * @memberof AgronomyGetAgronomistsResponseItem
     */
    'name': string;
    /**
     * description of agronomist profile
     * @type {string}
     * @memberof AgronomyGetAgronomistsResponseItem
     */
    'description': string;
    /**
     * details of agronomist experiences
     * @type {string}
     * @memberof AgronomyGetAgronomistsResponseItem
     */
    'experience': string;
    /**
     * sequence of the agronomist profile shown, used for ordering
     * @type {number}
     * @memberof AgronomyGetAgronomistsResponseItem
     */
    'sequence': number;
}
/**
 * 
 * @export
 * @interface AgronomyGetBookingDetailResponse
 */
export interface AgronomyGetBookingDetailResponse {
    /**
     * ID of the agronomy booking detail
     * @type {string}
     * @memberof AgronomyGetBookingDetailResponse
     */
    'bookingId': string;
    /**
     * agronomy problem description submitted by user
     * @type {string}
     * @memberof AgronomyGetBookingDetailResponse
     */
    'problem': string;
    /**
     * images uploaded by user for this agronomy booking
     * @type {Array<string>}
     * @memberof AgronomyGetBookingDetailResponse
     */
    'imageUrls': Array<string>;
    /**
     * url of a document contains summary detail
     * @type {string}
     * @memberof AgronomyGetBookingDetailResponse
     */
    'documentUrl': string;
    /**
     * 
     * @type {AgronomyBookingSummaryDetail}
     * @memberof AgronomyGetBookingDetailResponse
     */
    'detail': AgronomyBookingSummaryDetail;
    /**
     * contains summary detail with html tags
     * @type {string}
     * @memberof AgronomyGetBookingDetailResponse
     */
    'htmlDetail': string;
    /**
     * 
     * @type {AgronomyGetBookingDetailResponseTaskCount}
     * @memberof AgronomyGetBookingDetailResponse
     */
    'taskCount': AgronomyGetBookingDetailResponseTaskCount;
}
/**
 * summary of number of task related to this booking
 * @export
 * @interface AgronomyGetBookingDetailResponseTaskCount
 */
export interface AgronomyGetBookingDetailResponseTaskCount {
    /**
     * total number of task for this booking
     * @type {number}
     * @memberof AgronomyGetBookingDetailResponseTaskCount
     */
    'total': number;
    /**
     * total number of task already done by user in this booking
     * @type {number}
     * @memberof AgronomyGetBookingDetailResponseTaskCount
     */
    'done': number;
}
/**
 * 
 * @export
 * @interface AgronomyGetWebinarSurveyQuestionsResponse
 */
export interface AgronomyGetWebinarSurveyQuestionsResponse {
    /**
     * list of survey questions
     * @type {Array<AgronomyGetWebinarSurveyQuestionsResponseItem>}
     * @memberof AgronomyGetWebinarSurveyQuestionsResponse
     */
    'items': Array<AgronomyGetWebinarSurveyQuestionsResponseItem>;
}
/**
 * 
 * @export
 * @interface AgronomyGetWebinarSurveyQuestionsResponseItem
 */
export interface AgronomyGetWebinarSurveyQuestionsResponseItem {
    /**
     * Id of question representated in UUID V4
     * @type {string}
     * @memberof AgronomyGetWebinarSurveyQuestionsResponseItem
     */
    'id': string;
    /**
     * 
     * @type {AgronomyWebinarSurveyAnswerTypeEnum}
     * @memberof AgronomyGetWebinarSurveyQuestionsResponseItem
     */
    'type': AgronomyWebinarSurveyAnswerTypeEnum;
    /**
     * Question for participant
     * @type {string}
     * @memberof AgronomyGetWebinarSurveyQuestionsResponseItem
     */
    'question': string;
    /**
     * Placeholder for question with answer input type LONG_TEXT and SHORT_TEXT
     * @type {string}
     * @memberof AgronomyGetWebinarSurveyQuestionsResponseItem
     */
    'placeholder'?: string;
    /**
     * List of answer options for question with answer input type CHECKBOX and RADIO
     * @type {Array<string>}
     * @memberof AgronomyGetWebinarSurveyQuestionsResponseItem
     */
    'options'?: Array<string>;
}


/**
 * 
 * @export
 * @interface AgronomyGetWebinarsResponse
 */
export interface AgronomyGetWebinarsResponse {
    /**
     * 
     * @type {Array<AgronomyGetWebinarsResponseItem>}
     * @memberof AgronomyGetWebinarsResponse
     */
    'items': Array<AgronomyGetWebinarsResponseItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof AgronomyGetWebinarsResponse
     */
    'pagination': PaginationResponse;
    /**
     * server time in unix milli format at the time of API request
     * @type {number}
     * @memberof AgronomyGetWebinarsResponse
     */
    'serverTimeUtc0': number;
}
/**
 * 
 * @export
 * @interface AgronomyGetWebinarsResponseItem
 */
export interface AgronomyGetWebinarsResponseItem {
    /**
     * id of the webinar data in DB represented in UUID type 4
     * @type {string}
     * @memberof AgronomyGetWebinarsResponseItem
     */
    'id': string;
    /**
     * title of the webinar
     * @type {string}
     * @memberof AgronomyGetWebinarsResponseItem
     */
    'title': string;
    /**
     * description of the webinar
     * @type {string}
     * @memberof AgronomyGetWebinarsResponseItem
     */
    'description': string;
    /**
     * url of the webinar banner image
     * @type {string}
     * @memberof AgronomyGetWebinarsResponseItem
     */
    'bannerUrl': string;
    /**
     * start time of the webinar event in UTC0 format
     * @type {number}
     * @memberof AgronomyGetWebinarsResponseItem
     */
    'startAtUtc0': number;
    /**
     * end time of the webinar event in UTC0 format
     * @type {number}
     * @memberof AgronomyGetWebinarsResponseItem
     */
    'endAtUtc0': number;
    /**
     * 
     * @type {AgronomyWebinarStatusEnum}
     * @memberof AgronomyGetWebinarsResponseItem
     */
    'status': AgronomyWebinarStatusEnum;
    /**
     * link to the webinar online meeting, only available to registered user when webinar status is ONGOING
     * @type {string}
     * @memberof AgronomyGetWebinarsResponseItem
     */
    'meetingLink'?: string;
    /**
     * 
     * @type {AgronomyGetWebinarsResponseItemUser}
     * @memberof AgronomyGetWebinarsResponseItem
     */
    'user': AgronomyGetWebinarsResponseItemUser;
}


/**
 * 
 * @export
 * @interface AgronomyGetWebinarsResponseItemUser
 */
export interface AgronomyGetWebinarsResponseItemUser {
    /**
     * flag to show that the user has registered to the webinar
     * @type {boolean}
     * @memberof AgronomyGetWebinarsResponseItemUser
     */
    'isRegistered': boolean;
    /**
     * flag to show that the user has attended the webinar
     * @type {boolean}
     * @memberof AgronomyGetWebinarsResponseItemUser
     */
    'isAttended': boolean;
    /**
     * flag to show that the user is eligible to fill survey of the webinar
     * @type {boolean}
     * @memberof AgronomyGetWebinarsResponseItemUser
     */
    'isNeedSurvey': boolean;
}
/**
 * 
 * @export
 * @interface AgronomyPostWebinarSurveyAnswersRequest
 */
export interface AgronomyPostWebinarSurveyAnswersRequest {
    /**
     * List of object containing question id and response from the user
     * @type {Array<AgronomyPostWebinarSurveyAnswersRequestItem>}
     * @memberof AgronomyPostWebinarSurveyAnswersRequest
     */
    'items': Array<AgronomyPostWebinarSurveyAnswersRequestItem>;
}
/**
 * 
 * @export
 * @interface AgronomyPostWebinarSurveyAnswersRequestItem
 */
export interface AgronomyPostWebinarSurveyAnswersRequestItem {
    /**
     * Id of question representated as UUID V4
     * @type {string}
     * @memberof AgronomyPostWebinarSurveyAnswersRequestItem
     */
    'questionId': string;
    /**
     * Answer of the question from user
     * @type {string}
     * @memberof AgronomyPostWebinarSurveyAnswersRequestItem
     */
    'answer': string;
}
/**
 * 
 * @export
 * @interface AgronomyPostWebinarSurveyAnswersResponse
 */
export interface AgronomyPostWebinarSurveyAnswersResponse {
    /**
     * Indicating whether the process is successful or not
     * @type {boolean}
     * @memberof AgronomyPostWebinarSurveyAnswersResponse
     */
    'successful': boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const AgronomyProductTypeEnum = {
    TanyaDokterSawit: 'TANYA_DOKTER_SAWIT',
    UndangDokterSawit: 'UNDANG_DOKTER_SAWIT',
    AskAgronomist: 'ASK_AGRONOMIST',
    InviteAgronomist: 'INVITE_AGRONOMIST'
} as const;

export type AgronomyProductTypeEnum = typeof AgronomyProductTypeEnum[keyof typeof AgronomyProductTypeEnum];


/**
 * 
 * @export
 * @interface AgronomyRegisterWebinarRequest
 */
export interface AgronomyRegisterWebinarRequest {
    /**
     * Id of webinar represented in UUID version 4
     * @type {string}
     * @memberof AgronomyRegisterWebinarRequest
     */
    'webinarId': string;
    /**
     * Name of participant that will be displayed on the certificate
     * @type {string}
     * @memberof AgronomyRegisterWebinarRequest
     */
    'participantName': string;
    /**
     * Question from participant to agronomist
     * @type {string}
     * @memberof AgronomyRegisterWebinarRequest
     */
    'question'?: string;
    /**
     * Id of area represented in UUID version 4
     * @type {string}
     * @memberof AgronomyRegisterWebinarRequest
     */
    'areaId'?: string;
}
/**
 * 
 * @export
 * @interface AgronomyRegisterWebinarResponse
 */
export interface AgronomyRegisterWebinarResponse {
    /**
     * Id of webinar registration represented in UUID version 4
     * @type {string}
     * @memberof AgronomyRegisterWebinarResponse
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface AgronomyUpdateBookingRequest
 */
export interface AgronomyUpdateBookingRequest {
    /**
     * image urls uploaded by user
     * @type {Array<string>}
     * @memberof AgronomyUpdateBookingRequest
     */
    'imageUrls': Array<string>;
}
/**
 * 
 * @export
 * @interface AgronomyUpdateBookingResponse
 */
export interface AgronomyUpdateBookingResponse {
    /**
     * ID of the updated agronomy booking data
     * @type {string}
     * @memberof AgronomyUpdateBookingResponse
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface AgronomyWebinarDataItem
 */
export interface AgronomyWebinarDataItem {
    /**
     * id of the webinar data in DB represented in UUID type 4
     * @type {string}
     * @memberof AgronomyWebinarDataItem
     */
    'id': string;
    /**
     * title of the webinar
     * @type {string}
     * @memberof AgronomyWebinarDataItem
     */
    'title': string;
    /**
     * description of the webinar
     * @type {string}
     * @memberof AgronomyWebinarDataItem
     */
    'description': string;
    /**
     * url of the webinar banner image
     * @type {string}
     * @memberof AgronomyWebinarDataItem
     */
    'bannerUrl': string;
    /**
     * start time of the webinar event in UTC0 format
     * @type {number}
     * @memberof AgronomyWebinarDataItem
     */
    'startAtUtc0': number;
    /**
     * url of the webinar written material, only available after webinar ended
     * @type {string}
     * @memberof AgronomyWebinarDataItem
     */
    'materialUrl'?: string;
}
/**
 * 
 * @export
 * @interface AgronomyWebinarGetCertificatesResponse
 */
export interface AgronomyWebinarGetCertificatesResponse {
    /**
     * 
     * @type {Array<AgronomyWebinarGetCertificatesResponseItem>}
     * @memberof AgronomyWebinarGetCertificatesResponse
     */
    'items': Array<AgronomyWebinarGetCertificatesResponseItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof AgronomyWebinarGetCertificatesResponse
     */
    'pagination': PaginationResponse;
}
/**
 * 
 * @export
 * @interface AgronomyWebinarGetCertificatesResponseItem
 */
export interface AgronomyWebinarGetCertificatesResponseItem {
    /**
     * 
     * @type {AgronomyWebinarDataItem}
     * @memberof AgronomyWebinarGetCertificatesResponseItem
     */
    'webinar': AgronomyWebinarDataItem;
    /**
     * url of the user\'s webinar certificate
     * @type {string}
     * @memberof AgronomyWebinarGetCertificatesResponseItem
     */
    'certificateLink': string;
}
/**
 * 
 * @export
 * @interface AgronomyWebinarGetMaterialsResponse
 */
export interface AgronomyWebinarGetMaterialsResponse {
    /**
     * 
     * @type {Array<AgronomyWebinarDataItem>}
     * @memberof AgronomyWebinarGetMaterialsResponse
     */
    'items': Array<AgronomyWebinarDataItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof AgronomyWebinarGetMaterialsResponse
     */
    'pagination': PaginationResponse;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const AgronomyWebinarStatusEnum = {
    Upcoming: 'UPCOMING',
    Ongoing: 'ONGOING',
    Ended: 'ENDED'
} as const;

export type AgronomyWebinarStatusEnum = typeof AgronomyWebinarStatusEnum[keyof typeof AgronomyWebinarStatusEnum];


/**
 * Type of answer input
 * @export
 * @enum {string}
 */

export const AgronomyWebinarSurveyAnswerTypeEnum = {
    Checkbox: 'CHECKBOX',
    LongText: 'LONG_TEXT',
    Radio: 'RADIO',
    ShortText: 'SHORT_TEXT'
} as const;

export type AgronomyWebinarSurveyAnswerTypeEnum = typeof AgronomyWebinarSurveyAnswerTypeEnum[keyof typeof AgronomyWebinarSurveyAnswerTypeEnum];


/**
 * 
 * @export
 * @interface AgronomyWebinarsParticipantsAttendResponse
 */
export interface AgronomyWebinarsParticipantsAttendResponse {
    /**
     * flag that show this user has attended the webinar refer to `webinar_participant` table `is_attended` column
     * @type {boolean}
     * @memberof AgronomyWebinarsParticipantsAttendResponse
     */
    'isAttended': boolean;
}
/**
 * 
 * @export
 * @interface AppGetShortcutsResponse
 */
export interface AppGetShortcutsResponse {
    /**
     * 
     * @type {Array<AppGetShortcutsResponseItem>}
     * @memberof AppGetShortcutsResponse
     */
    'items': Array<AppGetShortcutsResponseItem>;
}
/**
 * 
 * @export
 * @interface AppGetShortcutsResponseItem
 */
export interface AppGetShortcutsResponseItem {
    /**
     * id of the app_shorcut data in DB represented in UUID type 4
     * @type {string}
     * @memberof AppGetShortcutsResponseItem
     */
    'id': string;
    /**
     * title of the app/feature shortcut
     * @type {string}
     * @memberof AppGetShortcutsResponseItem
     */
    'title': string;
    /**
     * description of the app/feature
     * @type {string}
     * @memberof AppGetShortcutsResponseItem
     */
    'description': string;
    /**
     * url of the shortcut icon image
     * @type {string}
     * @memberof AppGetShortcutsResponseItem
     */
    'imageUrl': string;
    /**
     * link/route to the targeted app page
     * @type {string}
     * @memberof AppGetShortcutsResponseItem
     */
    'route': string;
    /**
     * sequence of the app shortcut, used for ordering
     * @type {number}
     * @memberof AppGetShortcutsResponseItem
     */
    'sequence': number;
}
/**
 * 
 * @export
 * @interface AppRatingGetLatestResponse
 */
export interface AppRatingGetLatestResponse {
    /**
     * UTC unix milli of last user rating and review
     * @type {number}
     * @memberof AppRatingGetLatestResponse
     */
    'lastRatingTime': number;
    /**
     * indicates whether new rating and review is necessary
     * @type {boolean}
     * @memberof AppRatingGetLatestResponse
     */
    'needRating': boolean;
}
/**
 * 
 * @export
 * @interface AppRatingSubmitRequest
 */
export interface AppRatingSubmitRequest {
    /**
     * rating for feature
     * @type {number}
     * @memberof AppRatingSubmitRequest
     */
    'rating': number;
    /**
     * review for feature
     * @type {string}
     * @memberof AppRatingSubmitRequest
     */
    'review'?: string;
    /**
     * feature name. language: English. format: snake_case 
     * @type {string}
     * @memberof AppRatingSubmitRequest
     */
    'reference': string;
}
/**
 * 
 * @export
 * @interface AppRatingSubmitResponse
 */
export interface AppRatingSubmitResponse {
    /**
     * id of rating and review
     * @type {string}
     * @memberof AppRatingSubmitResponse
     */
    'id': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const AppShortcutScopeQueryEnum = {
    Home: 'HOME',
    Productivity: 'PRODUCTIVITY'
} as const;

export type AppShortcutScopeQueryEnum = typeof AppShortcutScopeQueryEnum[keyof typeof AppShortcutScopeQueryEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const AppTypeEnum = {
    Worker: 'WORKER',
    Member: 'MEMBER',
    PartnerWeb: 'PARTNER_WEB',
    AdminWeb: 'ADMIN_WEB',
    SalesAgent: 'SALES_AGENT',
    OnboardingApp: 'ONBOARDING_APP',
    Petani: 'PETANI',
    Duta: 'DUTA'
} as const;

export type AppTypeEnum = typeof AppTypeEnum[keyof typeof AppTypeEnum];


/**
 * 
 * @export
 * @interface AppVersionCheckResponse
 */
export interface AppVersionCheckResponse {
    /**
     * Condition to check whether the app needs updating.
     * @type {boolean}
     * @memberof AppVersionCheckResponse
     */
    'needsUpdate': boolean;
    /**
     * Condition to check whether the app update is flexible or mandatory. 
     * @type {boolean}
     * @memberof AppVersionCheckResponse
     */
    'isUpdateMandatory': boolean;
    /**
     * 
     * @type {AppVersionCheckResponseMasterDataVersion}
     * @memberof AppVersionCheckResponse
     */
    'masterData': AppVersionCheckResponseMasterDataVersion;
}
/**
 * Master data version e.g mills, area, etc.
 * @export
 * @interface AppVersionCheckResponseMasterDataVersion
 */
export interface AppVersionCheckResponseMasterDataVersion {
    /**
     * This field is used to compare mills master data version against local storage master data in app.Mobile apps will fetch the latest mills master data if server got higher version. 
     * @type {number}
     * @memberof AppVersionCheckResponseMasterDataVersion
     */
    'mills': number;
    /**
     * This field is used to compare contact master data version against local storage master data in app.Mobile apps will fetch the latest contact master data if server got higher version. 
     * @type {number}
     * @memberof AppVersionCheckResponseMasterDataVersion
     */
    'contact': number;
    /**
     * This field is used to compare block master data version against local storage master data in app.Mobile apps will fetch the latest block master data if server got higher version. 
     * @type {number}
     * @memberof AppVersionCheckResponseMasterDataVersion
     */
    'block': number;
    /**
     * This field is used to compare truck master data version against local storage master data in app.Mobile apps will fetch the latest truck master data if server got higher version. 
     * @type {number}
     * @memberof AppVersionCheckResponseMasterDataVersion
     */
    'truck': number;
    /**
     * This field is used to compare plantationActivityMaterial master data version against local storage master data in app.Mobile apps will fetch the latest plantationActivityMaterial master data if server got higher version. 
     * @type {number}
     * @memberof AppVersionCheckResponseMasterDataVersion
     */
    'plantationActivityMaterial': number;
}
/**
 * 
 * @export
 * @interface AssetAddTruckRequest
 */
export interface AssetAddTruckRequest {
    /**
     * Number plate of truck that will only allowed with regex pattern
     * @type {string}
     * @memberof AssetAddTruckRequest
     */
    'numberPlate': string;
    /**
     * Truck category id in UUID type 4
     * @type {string}
     * @memberof AssetAddTruckRequest
     */
    'truckCategoryId': string;
}
/**
 * 
 * @export
 * @interface AssetAddTruckRequestV2
 */
export interface AssetAddTruckRequestV2 {
    /**
     * Number plate of truck that will only allowed with regex pattern
     * @type {string}
     * @memberof AssetAddTruckRequestV2
     */
    'numberPlate': string;
    /**
     * Truck category id in UUID type 4
     * @type {string}
     * @memberof AssetAddTruckRequestV2
     */
    'truckCategoryId': string;
    /**
     * Photo url of truck
     * @type {string}
     * @memberof AssetAddTruckRequestV2
     */
    'photoUrl': string;
    /**
     * Longitude of truck location
     * @type {number}
     * @memberof AssetAddTruckRequestV2
     */
    'longitude'?: number;
    /**
     * Latitude of truck location
     * @type {number}
     * @memberof AssetAddTruckRequestV2
     */
    'latitude'?: number;
}
/**
 * 
 * @export
 * @interface AssetAddTruckResponse
 */
export interface AssetAddTruckResponse {
    /**
     * 
     * @type {boolean}
     * @memberof AssetAddTruckResponse
     */
    'success': boolean;
    /**
     * Added sawit point
     * @type {number}
     * @memberof AssetAddTruckResponse
     */
    'point': number;
}
/**
 * Category of the asset
 * @export
 * @enum {string}
 */

export const AssetCategoryEnum = {
    Ramp: 'RAMP',
    Truck: 'TRUCK',
    Farm: 'FARM',
    SupplierContract: 'SUPPLIER_CONTRACT'
} as const;

export type AssetCategoryEnum = typeof AssetCategoryEnum[keyof typeof AssetCategoryEnum];


/**
 * 
 * @export
 * @interface AssetDeleteTruckResponse
 */
export interface AssetDeleteTruckResponse {
    /**
     * 
     * @type {boolean}
     * @memberof AssetDeleteTruckResponse
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface AssetFarmDetailAverageEstateMonthlyYield
 */
export interface AssetFarmDetailAverageEstateMonthlyYield {
    /**
     * describe the Average Estate Monthly Yield value
     * @type {number}
     * @memberof AssetFarmDetailAverageEstateMonthlyYield
     */
    'value': number;
    /**
     * describe the year & month where the average estate monthly yield is calculated in `Mon YYYY` format
     * @type {string}
     * @memberof AssetFarmDetailAverageEstateMonthlyYield
     */
    'monthLabel'?: string;
}
/**
 * 
 * @export
 * @interface AssetFarmResponseOptimumFfbYield
 */
export interface AssetFarmResponseOptimumFfbYield {
    /**
     * the lower range of Optimal FFB Yield based on soil type, seed, and plant productive age UOM in ton/ha/month (\"ton/ha/bulan\")
     * @type {number}
     * @memberof AssetFarmResponseOptimumFfbYield
     */
    'min': number;
    /**
     * the upper range of Optimal FFB Yield based on soil type, seed, and plant productive age UOM in ton/ha/month (\"ton/ha/bulan\")
     * @type {number}
     * @memberof AssetFarmResponseOptimumFfbYield
     */
    'max': number;
}
/**
 * Status of Farm data in DB <br> DRAFT = farm data partially submitted by user <br> COMPLETED = DEPRECATED, all required farm data is submitted by user <br> NEW = all required farm data is submitted by user, will replace COMPLETED <br> VERIFIED = farm data is verified by admin <br> IN_VERIFICATION = farm data is in verification by admin <br> REJECTED = farm data is rejected by admin
 * @export
 * @enum {string}
 */

export const AssetFarmStatusEnum = {
    Draft: 'DRAFT',
    Completed: 'COMPLETED',
    New: 'NEW',
    Verified: 'VERIFIED',
    InVerification: 'IN_VERIFICATION',
    Rejected: 'REJECTED'
} as const;

export type AssetFarmStatusEnum = typeof AssetFarmStatusEnum[keyof typeof AssetFarmStatusEnum];


/**
 * 
 * @export
 * @interface AssetGetTruckCategoryResponse
 */
export interface AssetGetTruckCategoryResponse {
    /**
     * 
     * @type {Array<AssetGetTruckCategoryResponseItem>}
     * @memberof AssetGetTruckCategoryResponse
     */
    'items': Array<AssetGetTruckCategoryResponseItem>;
}
/**
 * 
 * @export
 * @interface AssetGetTruckCategoryResponseItem
 */
export interface AssetGetTruckCategoryResponseItem {
    /**
     * Truck category id in UUID type 4
     * @type {string}
     * @memberof AssetGetTruckCategoryResponseItem
     */
    'id': string;
    /**
     * Category name of truck
     * @type {string}
     * @memberof AssetGetTruckCategoryResponseItem
     */
    'name': string;
    /**
     * Capacity of truck in tonnes
     * @type {number}
     * @memberof AssetGetTruckCategoryResponseItem
     */
    'capacity': number;
}
/**
 * 
 * @export
 * @interface AssetGetTruckResponse
 */
export interface AssetGetTruckResponse {
    /**
     * 
     * @type {Array<AssetGetTruckResponseItem>}
     * @memberof AssetGetTruckResponse
     */
    'items': Array<AssetGetTruckResponseItem>;
}
/**
 * 
 * @export
 * @interface AssetGetTruckResponseItem
 */
export interface AssetGetTruckResponseItem {
    /**
     * Truck id in UUID type 4
     * @type {string}
     * @memberof AssetGetTruckResponseItem
     */
    'id': string;
    /**
     * Number plate of truck that will only allowed with regex pattern
     * @type {string}
     * @memberof AssetGetTruckResponseItem
     */
    'numberPlate': string;
    /**
     * Truck category id in UUID type 4
     * @type {string}
     * @memberof AssetGetTruckResponseItem
     */
    'truckCategoryId': string;
    /**
     * Category name of truck
     * @type {string}
     * @memberof AssetGetTruckResponseItem
     */
    'truckCategoryName': string;
    /**
     * Capacity of truck in tonnes
     * @type {number}
     * @memberof AssetGetTruckResponseItem
     */
    'capacity': number;
    /**
     * Photo url of truck
     * @type {string}
     * @memberof AssetGetTruckResponseItem
     */
    'photoUrl': string;
    /**
     * 
     * @type {TruckStatusEnum}
     * @memberof AssetGetTruckResponseItem
     */
    'status': TruckStatusEnum;
    /**
     * truck rejected reason
     * @type {string}
     * @memberof AssetGetTruckResponseItem
     */
    'rejectedReason': string;
}


/**
 * 
 * @export
 * @interface AssetUpdateTruckRequest
 */
export interface AssetUpdateTruckRequest {
    /**
     * Number plate of truck that will only allowed with regex pattern
     * @type {string}
     * @memberof AssetUpdateTruckRequest
     */
    'numberPlate': string;
    /**
     * Truck category id in UUID type 4
     * @type {string}
     * @memberof AssetUpdateTruckRequest
     */
    'truckCategoryId': string;
}
/**
 * 
 * @export
 * @interface AssetUpdateTruckRequestV2
 */
export interface AssetUpdateTruckRequestV2 {
    /**
     * Number plate of truck that will only allowed with regex pattern
     * @type {string}
     * @memberof AssetUpdateTruckRequestV2
     */
    'numberPlate': string;
    /**
     * Truck category id in UUID type 4
     * @type {string}
     * @memberof AssetUpdateTruckRequestV2
     */
    'truckCategoryId': string;
    /**
     * Photo url of truck
     * @type {string}
     * @memberof AssetUpdateTruckRequestV2
     */
    'photoUrl': string;
    /**
     * Longitude of truck location
     * @type {number}
     * @memberof AssetUpdateTruckRequestV2
     */
    'longitude': number;
    /**
     * Latitude of truck location
     * @type {number}
     * @memberof AssetUpdateTruckRequestV2
     */
    'latitude': number;
}
/**
 * 
 * @export
 * @interface AssetUpdateTruckResponse
 */
export interface AssetUpdateTruckResponse {
    /**
     * 
     * @type {boolean}
     * @memberof AssetUpdateTruckResponse
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface AssetsAddFarmRequest
 */
export interface AssetsAddFarmRequest {
    /**
     * 
     * @type {number}
     * @memberof AssetsAddFarmRequest
     */
    'fieldArea': number;
    /**
     * Id village of farm
     * @type {string}
     * @memberof AssetsAddFarmRequest
     */
    'villageId': string;
    /**
     * Village\'s name of farm
     * @type {string}
     * @memberof AssetsAddFarmRequest
     */
    'villageName': string;
    /**
     * Source page
     * @type {string}
     * @memberof AssetsAddFarmRequest
     */
    'sourcePage'?: string;
}
/**
 * 
 * @export
 * @interface AssetsAddFarmResponse
 */
export interface AssetsAddFarmResponse {
    /**
     * Added sawit point
     * @type {number}
     * @memberof AssetsAddFarmResponse
     */
    'point': number;
}
/**
 * 
 * @export
 * @interface AssetsAddFarmV2Request
 */
export interface AssetsAddFarmV2Request {
    /**
     * name of the farm
     * @type {string}
     * @memberof AssetsAddFarmV2Request
     */
    'name': string;
    /**
     * 
     * @type {Village}
     * @memberof AssetsAddFarmV2Request
     */
    'village': Village;
    /**
     * farm size in hectare
     * @type {number}
     * @memberof AssetsAddFarmV2Request
     */
    'areaHectare': number;
    /**
     * describe the Average Estate Monthly Yield
     * @type {number}
     * @memberof AssetsAddFarmV2Request
     */
    'averageEstateMonthlyYield': number;
    /**
     * 
     * @type {SoilTypeEnum}
     * @memberof AssetsAddFarmV2Request
     * @deprecated
     */
    'soilType': SoilTypeEnum;
    /**
     * Year of planting.
     * @type {number}
     * @memberof AssetsAddFarmV2Request
     */
    'plantedYear': number;
    /**
     * number of tree planted per hectare
     * @type {number}
     * @memberof AssetsAddFarmV2Request
     */
    'palmTreesPerHectare': number;
    /**
     * 
     * @type {SeedTypeEnum}
     * @memberof AssetsAddFarmV2Request
     * @deprecated
     */
    'seedType': SeedTypeEnum;
    /**
     * describe brand of the seed
     * @type {string}
     * @memberof AssetsAddFarmV2Request
     */
    'seedBrand': string;
}


/**
 * 
 * @export
 * @interface AssetsAddFarmV2Response
 */
export interface AssetsAddFarmV2Response {
    /**
     * True if poin is awarded, otherwise false
     * @type {boolean}
     * @memberof AssetsAddFarmV2Response
     */
    'rewardAwarded': boolean;
    /**
     * Added sawit point
     * @type {number}
     * @memberof AssetsAddFarmV2Response
     */
    'point': number;
}
/**
 * 
 * @export
 * @interface AssetsAddRampRequest
 */
export interface AssetsAddRampRequest {
    /**
     * Name of ramp asset
     * @type {string}
     * @memberof AssetsAddRampRequest
     */
    'assetName': string;
    /**
     * Id village of ramp
     * @type {string}
     * @memberof AssetsAddRampRequest
     */
    'villageId': string;
    /**
     * Village\'s name of ramp
     * @type {string}
     * @memberof AssetsAddRampRequest
     */
    'villageName': string;
    /**
     * Address of ramp
     * @type {string}
     * @memberof AssetsAddRampRequest
     */
    'address': string;
}
/**
 * 
 * @export
 * @interface AssetsAddRampResponse
 */
export interface AssetsAddRampResponse {
    /**
     * Added sawit point
     * @type {number}
     * @memberof AssetsAddRampResponse
     */
    'point': number;
}
/**
 * 
 * @export
 * @interface AssetsAddSupplierRequest
 */
export interface AssetsAddSupplierRequest {
    /**
     * Name of supplier asset
     * @type {string}
     * @memberof AssetsAddSupplierRequest
     */
    'assetName': string;
    /**
     * Id mills of supplier
     * @type {string}
     * @memberof AssetsAddSupplierRequest
     */
    'millsId': string;
    /**
     * Mills\'s name of supplier
     * @type {string}
     * @memberof AssetsAddSupplierRequest
     */
    'millsName': string;
}
/**
 * 
 * @export
 * @interface AssetsAddSupplierResponse
 */
export interface AssetsAddSupplierResponse {
    /**
     * Id of supplier
     * @type {string}
     * @memberof AssetsAddSupplierResponse
     */
    'id': string;
    /**
     * 
     * @type {MemberStatusEnum}
     * @memberof AssetsAddSupplierResponse
     */
    'status': MemberStatusEnum;
    /**
     * The lable of status that FE will show. Currently using Indonesian language
     * @type {string}
     * @memberof AssetsAddSupplierResponse
     */
    'statusLabel': string;
    /**
     * Added sawit point
     * @type {number}
     * @memberof AssetsAddSupplierResponse
     */
    'point': number;
}


/**
 * 
 * @export
 * @interface AssetsCreateOrUpdateFarmRequest
 */
export interface AssetsCreateOrUpdateFarmRequest {
    /**
     * id of a farm represented in UUID type 4 <br> when present and UUID value already exist in DB `farm` table, will update DB data based on the other req body field values, <br> otherwise will create new farm data in DB based on the other req body field values
     * @type {string}
     * @memberof AssetsCreateOrUpdateFarmRequest
     */
    'id'?: string;
    /**
     * name of the farm, when empty will be generated by system in \"{village name} ({ha}) {number}\" format
     * @type {string}
     * @memberof AssetsCreateOrUpdateFarmRequest
     */
    'name'?: string;
    /**
     * 
     * @type {Village}
     * @memberof AssetsCreateOrUpdateFarmRequest
     */
    'village'?: Village;
    /**
     * farm size in hectare
     * @type {number}
     * @memberof AssetsCreateOrUpdateFarmRequest
     */
    'areaHectare'?: number;
    /**
     * Year of planting
     * @type {number}
     * @memberof AssetsCreateOrUpdateFarmRequest
     */
    'plantedYear'?: number;
    /**
     * Month of planting
     * @type {number}
     * @memberof AssetsCreateOrUpdateFarmRequest
     */
    'plantedMonth'?: number;
    /**
     * number of trees planted per hectare
     * @type {number}
     * @memberof AssetsCreateOrUpdateFarmRequest
     */
    'palmTreesPerHectare'?: number;
    /**
     * DEPRECATED, Seed(s) types planted in the Farm
     * @type {Array<SeedTypeEnum>}
     * @memberof AssetsCreateOrUpdateFarmRequest
     * @deprecated
     */
    'seedTypes'?: Array<SeedTypeEnum>;
    /**
     * DEPRECATED, Brand of the seed(s) used in the farm
     * @type {Array<string>}
     * @memberof AssetsCreateOrUpdateFarmRequest
     * @deprecated
     */
    'seedBrands'?: Array<string>;
    /**
     * DEPRECATED, Farm soil(s) types
     * @type {Array<SoilTypeEnum>}
     * @memberof AssetsCreateOrUpdateFarmRequest
     * @deprecated
     */
    'soilTypes'?: Array<SoilTypeEnum>;
    /**
     * ID of the seed used in the farm
     * @type {string}
     * @memberof AssetsCreateOrUpdateFarmRequest
     * @deprecated
     */
    'seedId'?: string;
    /**
     * IDs of the seeds used in the farm, choices is from API `GET /api/v1/plantations/seeds`
     * @type {Array<string>}
     * @memberof AssetsCreateOrUpdateFarmRequest
     */
    'seedIds'?: Array<string>;
    /**
     * ID of the soil type of the farm
     * @type {string}
     * @memberof AssetsCreateOrUpdateFarmRequest
     */
    'soilTypeId'?: string;
    /**
     * describe the Average Estate Monthly Yield per hectare in ton
     * @type {number}
     * @memberof AssetsCreateOrUpdateFarmRequest
     */
    'averageEstateMonthlyYield'?: number;
    /**
     * attachment photo url
     * @type {string}
     * @memberof AssetsCreateOrUpdateFarmRequest
     */
    'photoUrl'?: string;
    /**
     * 
     * @type {UserActivityLocationInput}
     * @memberof AssetsCreateOrUpdateFarmRequest
     */
    'activityLocation'?: UserActivityLocationInput;
    /**
     * used by DUTA app, id of the user that this request is for
     * @type {string}
     * @memberof AssetsCreateOrUpdateFarmRequest
     */
    'userId'?: string;
}
/**
 * 
 * @export
 * @interface AssetsCreateOrUpdateFarmResponse
 */
export interface AssetsCreateOrUpdateFarmResponse {
    /**
     * id of the created/updated farm data, represented in UUID type 4
     * @type {string}
     * @memberof AssetsCreateOrUpdateFarmResponse
     */
    'id': string;
    /**
     * 
     * @type {AssetFarmStatusEnum}
     * @memberof AssetsCreateOrUpdateFarmResponse
     */
    'status': AssetFarmStatusEnum;
    /**
     * Sawitpoin reward for first time user completed farm data submission, if <= 0 user is not eligible for Sawitpoin reward
     * @type {number}
     * @memberof AssetsCreateOrUpdateFarmResponse
     */
    'sawitpoin': number;
}


/**
 * 
 * @export
 * @interface AssetsFarmDeleteResponse
 */
export interface AssetsFarmDeleteResponse {
    /**
     * 
     * @type {boolean}
     * @memberof AssetsFarmDeleteResponse
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface AssetsFarmDetailResponse
 */
export interface AssetsFarmDetailResponse {
    /**
     * id of a farm represented in UUID type 4
     * @type {string}
     * @memberof AssetsFarmDetailResponse
     */
    'id': string;
    /**
     * name of the farm
     * @type {string}
     * @memberof AssetsFarmDetailResponse
     */
    'name': string;
    /**
     * 
     * @type {Village}
     * @memberof AssetsFarmDetailResponse
     */
    'village': Village;
    /**
     * farm size in hectare
     * @type {number}
     * @memberof AssetsFarmDetailResponse
     */
    'areaHectare': number;
    /**
     * 
     * @type {AssetFarmDetailAverageEstateMonthlyYield}
     * @memberof AssetsFarmDetailResponse
     */
    'averageEstateMonthlyYield': AssetFarmDetailAverageEstateMonthlyYield;
    /**
     * 
     * @type {SoilTypeEnum}
     * @memberof AssetsFarmDetailResponse
     * @deprecated
     */
    'soilType': SoilTypeEnum;
    /**
     * Year of planting.
     * @type {number}
     * @memberof AssetsFarmDetailResponse
     */
    'plantedYear': number;
    /**
     * number of tree planted per hectare
     * @type {number}
     * @memberof AssetsFarmDetailResponse
     */
    'palmTreesPerHectare': number;
    /**
     * 
     * @type {SeedTypeEnum}
     * @memberof AssetsFarmDetailResponse
     * @deprecated
     */
    'seedType': SeedTypeEnum;
    /**
     * Month of planting.
     * @type {number}
     * @memberof AssetsFarmDetailResponse
     */
    'plantedMonth': number;
    /**
     * photo url
     * @type {string}
     * @memberof AssetsFarmDetailResponse
     */
    'photoUrl': string;
    /**
     * 
     * @type {AssetFarmStatusEnum}
     * @memberof AssetsFarmDetailResponse
     */
    'status': AssetFarmStatusEnum;
    /**
     * the reason why the farm is rejected. only available when status is REJECTED
     * @type {string}
     * @memberof AssetsFarmDetailResponse
     */
    'rejectedReason'?: string;
    /**
     * List of seed
     * @type {Array<AssetsFarmSeedDetailResponse>}
     * @memberof AssetsFarmDetailResponse
     */
    'seeds': Array<AssetsFarmSeedDetailResponse>;
    /**
     * total plant ages in month
     * @type {number}
     * @memberof AssetsFarmDetailResponse
     */
    'plantAgeInMonth': number;
    /**
     * ID of the soil type of the farm
     * @type {string}
     * @memberof AssetsFarmDetailResponse
     */
    'soilTypeId'?: string;
}


/**
 * 
 * @export
 * @interface AssetsFarmListResponse
 */
export interface AssetsFarmListResponse {
    /**
     * 
     * @type {Array<AssetsFarmListResponseItem>}
     * @memberof AssetsFarmListResponse
     */
    'items': Array<AssetsFarmListResponseItem>;
}
/**
 * 
 * @export
 * @interface AssetsFarmListResponseItem
 */
export interface AssetsFarmListResponseItem {
    /**
     * id of a farm represented in UUID type 4
     * @type {string}
     * @memberof AssetsFarmListResponseItem
     */
    'id': string;
    /**
     * name of the farm
     * @type {string}
     * @memberof AssetsFarmListResponseItem
     */
    'name': string;
    /**
     * location where the farm is located
     * @type {string}
     * @memberof AssetsFarmListResponseItem
     */
    'location': string;
    /**
     * the reason why the farm is rejected. only available when status is REJECTED
     * @type {string}
     * @memberof AssetsFarmListResponseItem
     */
    'rejectedReason'?: string;
    /**
     * 
     * @type {AssetFarmStatusEnum}
     * @memberof AssetsFarmListResponseItem
     */
    'status': AssetFarmStatusEnum;
    /**
     * farm size in hectare
     * @type {number}
     * @memberof AssetsFarmListResponseItem
     */
    'areaHectare': number;
    /**
     * List of seed
     * @type {Array<AssetsFarmListResponseItemSeedItem>}
     * @memberof AssetsFarmListResponseItem
     */
    'seeds': Array<AssetsFarmListResponseItemSeedItem>;
    /**
     * total plant ages in month
     * @type {number}
     * @memberof AssetsFarmListResponseItem
     */
    'plantAgeInMonth': number;
    /**
     * 
     * @type {AssetFarmResponseOptimumFfbYield}
     * @memberof AssetsFarmListResponseItem
     */
    'optimumFfbYield'?: AssetFarmResponseOptimumFfbYield;
}


/**
 * 
 * @export
 * @interface AssetsFarmListResponseItemSeedItem
 */
export interface AssetsFarmListResponseItemSeedItem {
    /**
     * Id of plantations seed
     * @type {string}
     * @memberof AssetsFarmListResponseItemSeedItem
     */
    'id': string;
    /**
     * name of the seed
     * @type {string}
     * @memberof AssetsFarmListResponseItemSeedItem
     */
    'name': string;
    /**
     * description of the seed
     * @type {string}
     * @memberof AssetsFarmListResponseItemSeedItem
     */
    'description': string;
    /**
     * variety of a plantation seed
     * @type {string}
     * @memberof AssetsFarmListResponseItemSeedItem
     */
    'variety': string;
}
/**
 * 
 * @export
 * @interface AssetsFarmSeedDetailResponse
 */
export interface AssetsFarmSeedDetailResponse {
    /**
     * Id of plantations seed
     * @type {string}
     * @memberof AssetsFarmSeedDetailResponse
     */
    'id': string;
    /**
     * name of the seed
     * @type {string}
     * @memberof AssetsFarmSeedDetailResponse
     */
    'name': string;
    /**
     * description of the seed
     * @type {string}
     * @memberof AssetsFarmSeedDetailResponse
     */
    'description': string;
    /**
     * variety of a plantation seed
     * @type {string}
     * @memberof AssetsFarmSeedDetailResponse
     */
    'variety': string;
    /**
     * 
     * @type {AssetsFarmSeedYieldResponse}
     * @memberof AssetsFarmSeedDetailResponse
     */
    'yield': AssetsFarmSeedYieldResponse;
}
/**
 * 
 * @export
 * @interface AssetsFarmSeedYieldResponse
 */
export interface AssetsFarmSeedYieldResponse {
    /**
     * the low range yield per hectare in ton data for the specified seed and growth stage
     * @type {number}
     * @memberof AssetsFarmSeedYieldResponse
     */
    'estateMonthlyYieldLow': number;
    /**
     * the high range yield per hectare in ton data for the specified seed and growth stage
     * @type {number}
     * @memberof AssetsFarmSeedYieldResponse
     */
    'estateMonthlyYieldHigh': number;
}
/**
 * 
 * @export
 * @interface AssetsGetRampResponse
 */
export interface AssetsGetRampResponse {
    /**
     * Name of the Ramp
     * @type {string}
     * @memberof AssetsGetRampResponse
     */
    'name': string;
    /**
     * ID of the village where the Ramp is located
     * @type {string}
     * @memberof AssetsGetRampResponse
     */
    'villageId': string;
    /**
     * Name of the village where the Ramp is located
     * @type {string}
     * @memberof AssetsGetRampResponse
     */
    'villageName': string;
    /**
     * Address of the Ramp
     * @type {string}
     * @memberof AssetsGetRampResponse
     */
    'address': string;
    /**
     * Link to the Ramp Photo for this Ramp used for verification purpose
     * @type {string}
     * @memberof AssetsGetRampResponse
     */
    'rampPhoto'?: string;
    /**
     * The total count of owned truck
     * @type {number}
     * @memberof AssetsGetRampResponse
     */
    'totalTruck': number;
    /**
     * The total count of worker
     * @type {number}
     * @memberof AssetsGetRampResponse
     */
    'totalWorker': number;
    /**
     * The capacity of weighbridge
     * @type {number}
     * @memberof AssetsGetRampResponse
     */
    'totalCapacity': number;
    /**
     * The status of ramp
     * @type {string}
     * @memberof AssetsGetRampResponse
     */
    'status': string;
    /**
     * The label of status of ramp
     * @type {string}
     * @memberof AssetsGetRampResponse
     */
    'statusLabel': string;
    /**
     * The reason when asset rejected
     * @type {string}
     * @memberof AssetsGetRampResponse
     */
    'rejectedReason'?: string;
}
/**
 * 
 * @export
 * @interface AssetsGetSupplierResponse
 */
export interface AssetsGetSupplierResponse {
    /**
     * Name of the Supplier
     * @type {string}
     * @memberof AssetsGetSupplierResponse
     */
    'name': string;
    /**
     * The ID of the Mill (Partner) related to this Supplier
     * @type {string}
     * @memberof AssetsGetSupplierResponse
     */
    'millId': string;
    /**
     * Name of the associated Mill (Partner) for this Supplier
     * @type {string}
     * @memberof AssetsGetSupplierResponse
     */
    'millName': string;
    /**
     * Link to the Weighbridge Ticket for this Supplier used for verification purpose
     * @type {string}
     * @memberof AssetsGetSupplierResponse
     */
    'weighbridgePhoto'?: string;
    /**
     * 
     * @type {MemberStatusEnum}
     * @memberof AssetsGetSupplierResponse
     */
    'status': MemberStatusEnum;
    /**
     * Status of the Supplier to be displayed on FE (in Indonesian).<br><br>  Values: Disetujui, Ditolak, Tertunda 
     * @type {string}
     * @memberof AssetsGetSupplierResponse
     */
    'statusLabel': string;
    /**
     * supplier contract rejected reason
     * @type {string}
     * @memberof AssetsGetSupplierResponse
     */
    'rejectedReason': string;
}


/**
 * 
 * @export
 * @interface AssetsRampListResponse
 */
export interface AssetsRampListResponse {
    /**
     * 
     * @type {Array<AssetsRampListResponseItem>}
     * @memberof AssetsRampListResponse
     */
    'items': Array<AssetsRampListResponseItem>;
}
/**
 * 
 * @export
 * @interface AssetsRampListResponseItem
 */
export interface AssetsRampListResponseItem {
    /**
     * Asset ID represented in UUID type 4
     * @type {string}
     * @memberof AssetsRampListResponseItem
     */
    'assetId': string;
    /**
     * Supplier Contract ID represented in UUID type 4
     * @type {string}
     * @memberof AssetsRampListResponseItem
     */
    'assetCategoryId': string;
    /**
     * 
     * @type {AssetCategoryEnum}
     * @memberof AssetsRampListResponseItem
     */
    'assetType': AssetCategoryEnum;
    /**
     * The name of Ramp
     * @type {string}
     * @memberof AssetsRampListResponseItem
     */
    'assetName': string;
    /**
     * ID of the village where the Ramp is located
     * @type {string}
     * @memberof AssetsRampListResponseItem
     */
    'villageId': string;
    /**
     * Name of the village where the Ramp is located
     * @type {string}
     * @memberof AssetsRampListResponseItem
     */
    'villageName': string;
    /**
     * Address of the Ramp
     * @type {string}
     * @memberof AssetsRampListResponseItem
     */
    'address': string;
    /**
     * The status of ramp
     * @type {string}
     * @memberof AssetsRampListResponseItem
     */
    'status': string;
    /**
     * The label of status of ramp
     * @type {string}
     * @memberof AssetsRampListResponseItem
     */
    'statusLabel': string;
    /**
     * The reason when asset rejected
     * @type {string}
     * @memberof AssetsRampListResponseItem
     */
    'rejectedReason'?: string;
}


/**
 * 
 * @export
 * @interface AssetsSupplierListResponse
 */
export interface AssetsSupplierListResponse {
    /**
     * 
     * @type {Array<AssetsSupplierListResponseItem>}
     * @memberof AssetsSupplierListResponse
     */
    'items': Array<AssetsSupplierListResponseItem>;
}
/**
 * 
 * @export
 * @interface AssetsSupplierListResponseItem
 */
export interface AssetsSupplierListResponseItem {
    /**
     * Asset ID represented in UUID type 4
     * @type {string}
     * @memberof AssetsSupplierListResponseItem
     */
    'assetId': string;
    /**
     * Supplier Contract ID represented in UUID type 4
     * @type {string}
     * @memberof AssetsSupplierListResponseItem
     */
    'assetCategoryId': string;
    /**
     * 
     * @type {AssetCategoryEnum}
     * @memberof AssetsSupplierListResponseItem
     */
    'assetType': AssetCategoryEnum;
    /**
     * The registered name of Supplier Contract (Supplier name)
     * @type {string}
     * @memberof AssetsSupplierListResponseItem
     */
    'assetName': string;
    /**
     * ID of the Partner (mills) represented in UUID type 4
     * @type {string}
     * @memberof AssetsSupplierListResponseItem
     */
    'millsId': string;
    /**
     * Partner (mills) name
     * @type {string}
     * @memberof AssetsSupplierListResponseItem
     */
    'millsName': string;
    /**
     * Code of the Supplier
     * @type {string}
     * @memberof AssetsSupplierListResponseItem
     */
    'supplierCode'?: string;
    /**
     * Cooperation date of the Supplier in epoch (with ms precision)
     * @type {number}
     * @memberof AssetsSupplierListResponseItem
     */
    'cooperationDate'?: number;
    /**
     * 
     * @type {MemberStatusEnum}
     * @memberof AssetsSupplierListResponseItem
     */
    'status': MemberStatusEnum;
    /**
     * supplier contract rejected reason
     * @type {string}
     * @memberof AssetsSupplierListResponseItem
     */
    'rejectedReason': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const AssetsTruckListScopeEnum = {
    Business: 'BUSINESS'
} as const;

export type AssetsTruckListScopeEnum = typeof AssetsTruckListScopeEnum[keyof typeof AssetsTruckListScopeEnum];


/**
 * 
 * @export
 * @interface AssetsUpdateRampRequest
 */
export interface AssetsUpdateRampRequest {
    /**
     * Name of the Supplier
     * @type {string}
     * @memberof AssetsUpdateRampRequest
     */
    'name': string;
    /**
     * ID of the Village where the Ramp is located
     * @type {string}
     * @memberof AssetsUpdateRampRequest
     */
    'villageId': string;
    /**
     * Address of the Ramp
     * @type {string}
     * @memberof AssetsUpdateRampRequest
     */
    'address': string;
    /**
     * The latitude of user\'s Ramp. Won\'t be updated if the value is not present
     * @type {number}
     * @memberof AssetsUpdateRampRequest
     */
    'latitude'?: number;
    /**
     * The longitude of user\'s Ramp. Won\'t be updated if the value is not present
     * @type {number}
     * @memberof AssetsUpdateRampRequest
     */
    'longitude'?: number;
    /**
     * Ramp Photo used for verification purpose
     * @type {string}
     * @memberof AssetsUpdateRampRequest
     */
    'rampPhoto': string;
    /**
     * The total count of owned truck
     * @type {number}
     * @memberof AssetsUpdateRampRequest
     */
    'totalTruck': number;
    /**
     * The total count of worker
     * @type {number}
     * @memberof AssetsUpdateRampRequest
     */
    'totalWorker': number;
    /**
     * The capacity of weighbridge
     * @type {number}
     * @memberof AssetsUpdateRampRequest
     */
    'totalCapacity': number;
}
/**
 * 
 * @export
 * @interface AssetsUpdateRampResponse
 */
export interface AssetsUpdateRampResponse {
    /**
     * Mark whether the update process is successful or not
     * @type {boolean}
     * @memberof AssetsUpdateRampResponse
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface AssetsUpdateSupplierRequest
 */
export interface AssetsUpdateSupplierRequest {
    /**
     * Name of the Supplier
     * @type {string}
     * @memberof AssetsUpdateSupplierRequest
     */
    'name': string;
    /**
     * ID of the Mill (Partner) related to this Supplier
     * @type {string}
     * @memberof AssetsUpdateSupplierRequest
     */
    'millId': string;
    /**
     * The latitude of user\'s Supplier. Won\'t be updated if the value is not present
     * @type {number}
     * @memberof AssetsUpdateSupplierRequest
     */
    'latitude'?: number;
    /**
     * The longitude of user\'s Supplier. Won\'t be updated if the value is not present
     * @type {number}
     * @memberof AssetsUpdateSupplierRequest
     */
    'longitude'?: number;
    /**
     * Weighbridge Photo for this Supplier used for verification purpose
     * @type {string}
     * @memberof AssetsUpdateSupplierRequest
     */
    'weighbridgePhoto'?: string;
}
/**
 * 
 * @export
 * @interface AssetsUpdateSupplierResponse
 */
export interface AssetsUpdateSupplierResponse {
    /**
     * Mark whether the update process is successful or not
     * @type {boolean}
     * @memberof AssetsUpdateSupplierResponse
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface AuditLogsCreateRequest
 */
export interface AuditLogsCreateRequest {
    /**
     * 
     * @type {AuditLogsEntityEnum}
     * @memberof AuditLogsCreateRequest
     */
    'entity': AuditLogsEntityEnum;
    /**
     * 
     * @type {AuditLogsCreateRequestMetadata}
     * @memberof AuditLogsCreateRequest
     */
    'metadata': AuditLogsCreateRequestMetadata;
}


/**
 * 
 * @export
 * @interface AuditLogsCreateRequestBase
 */
export interface AuditLogsCreateRequestBase {
    /**
     * timestamp when user do the action
     * @type {number}
     * @memberof AuditLogsCreateRequestBase
     */
    'timestamp': number;
}
/**
 * @type AuditLogsCreateRequestMetadata
 * @export
 */
export type AuditLogsCreateRequestMetadata = AuditLogsCreateRequestPermissionApps;

/**
 * 
 * @export
 * @interface AuditLogsCreateRequestPermissionApps
 */
export interface AuditLogsCreateRequestPermissionApps {
    /**
     * timestamp when user do the action
     * @type {number}
     * @memberof AuditLogsCreateRequestPermissionApps
     */
    'timestamp': number;
    /**
     * 
     * @type {AuditLogsPermissionNameEnum}
     * @memberof AuditLogsCreateRequestPermissionApps
     */
    'name': AuditLogsPermissionNameEnum;
    /**
     * permission allowance, deny or allow
     * @type {boolean}
     * @memberof AuditLogsCreateRequestPermissionApps
     */
    'allowed': boolean;
    /**
     * app screen name where the permission was requested
     * @type {string}
     * @memberof AuditLogsCreateRequestPermissionApps
     */
    'app_screen': string;
}


/**
 * 
 * @export
 * @interface AuditLogsCreateRequestPermissionAppsAllOf
 */
export interface AuditLogsCreateRequestPermissionAppsAllOf {
    /**
     * 
     * @type {AuditLogsPermissionNameEnum}
     * @memberof AuditLogsCreateRequestPermissionAppsAllOf
     */
    'name': AuditLogsPermissionNameEnum;
    /**
     * permission allowance, deny or allow
     * @type {boolean}
     * @memberof AuditLogsCreateRequestPermissionAppsAllOf
     */
    'allowed': boolean;
    /**
     * app screen name where the permission was requested
     * @type {string}
     * @memberof AuditLogsCreateRequestPermissionAppsAllOf
     */
    'app_screen': string;
}


/**
 * audit logs entity allowed
 * @export
 * @enum {string}
 */

export const AuditLogsEntityEnum = {
    Permission: 'PERMISSION',
    Authentication: 'AUTHENTICATION'
} as const;

export type AuditLogsEntityEnum = typeof AuditLogsEntityEnum[keyof typeof AuditLogsEntityEnum];


/**
 * audit logs permisson name allowed
 * @export
 * @enum {string}
 */

export const AuditLogsPermissionNameEnum = {
    Location: 'LOCATION',
    Storage: 'STORAGE',
    Camera: 'CAMERA',
    Contact: 'CONTACT',
    Notification: 'NOTIFICATION'
} as const;

export type AuditLogsPermissionNameEnum = typeof AuditLogsPermissionNameEnum[keyof typeof AuditLogsPermissionNameEnum];


/**
 * 
 * @export
 * @interface AuthJwtGetResponse
 */
export interface AuthJwtGetResponse {
    /**
     * 
     * @type {string}
     * @memberof AuthJwtGetResponse
     */
    'jwt'?: string;
}
/**
 * 
 * @export
 * @interface AuthOtpSendDutaRequest
 */
export interface AuthOtpSendDutaRequest {
    /**
     * Encrypted phoneNumber using RSA256 with public key that\'s retrieved from local database
     * @type {string}
     * @memberof AuthOtpSendDutaRequest
     */
    'phoneNo': string;
}
/**
 * 
 * @export
 * @interface AuthOtpSendRequest
 */
export interface AuthOtpSendRequest {
    /**
     * Encrypted phoneNumber using RSA256 with public key that\'s retrieved from local database
     * @type {string}
     * @memberof AuthOtpSendRequest
     */
    'phoneNumber': string;
    /**
     * Hash code that will be included in the SMS sent to users
     * @type {string}
     * @memberof AuthOtpSendRequest
     */
    'hashCode'?: string;
}
/**
 * 
 * @export
 * @interface AuthOtpSendResponse
 */
export interface AuthOtpSendResponse {
    /**
     * Phone number starting with 0 as prefix (08xxxxxxxxx)
     * @type {string}
     * @memberof AuthOtpSendResponse
     */
    'phoneNumber'?: string;
    /**
     * indication whether the otp is sent or not
     * @type {string}
     * @memberof AuthOtpSendResponse
     */
    'otp'?: string;
}
/**
 * 
 * @export
 * @interface AuthOtpSendResponseData
 */
export interface AuthOtpSendResponseData {
    /**
     * 
     * @type {string}
     * @memberof AuthOtpSendResponseData
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof AuthOtpSendResponseData
     */
    'otp': string;
}
/**
 * 
 * @export
 * @interface AuthOtpValidateDutaRequest
 */
export interface AuthOtpValidateDutaRequest {
    /**
     * Encrypted phoneNumber using RSA256 with public key that\'s retrieved from local database
     * @type {string}
     * @memberof AuthOtpValidateDutaRequest
     */
    'phoneNumber': string;
    /**
     * OTP
     * @type {string}
     * @memberof AuthOtpValidateDutaRequest
     */
    'otp': string;
}
/**
 * 
 * @export
 * @interface AuthOtpValidateDutaResponse
 */
export interface AuthOtpValidateDutaResponse {
    /**
     * OTP Token in UUID form
     * @type {string}
     * @memberof AuthOtpValidateDutaResponse
     */
    'otpToken': string;
    /**
     * LeadId is user identifier (duta)
     * @type {string}
     * @memberof AuthOtpValidateDutaResponse
     */
    'leadId': string;
}
/**
 * 
 * @export
 * @interface AuthOtpValidateRequest
 */
export interface AuthOtpValidateRequest {
    /**
     * Encrypted phoneNumber using RSA256 with public key that\'s retrieved from local database
     * @type {string}
     * @memberof AuthOtpValidateRequest
     */
    'phoneNumber': string;
    /**
     * OTP
     * @type {string}
     * @memberof AuthOtpValidateRequest
     */
    'otp': string;
}
/**
 * 
 * @export
 * @interface AuthOtpValidateResponse
 */
export interface AuthOtpValidateResponse {
    /**
     * 
     * @type {boolean}
     * @memberof AuthOtpValidateResponse
     */
    'otp': boolean;
    /**
     * OTP Token in UUID form
     * @type {string}
     * @memberof AuthOtpValidateResponse
     */
    'otpToken': string;
}
/**
 * 
 * @export
 * @interface AuthOtpValidateResponseData
 */
export interface AuthOtpValidateResponseData {
    /**
     * 
     * @type {boolean}
     * @memberof AuthOtpValidateResponseData
     */
    'otp': boolean;
    /**
     * 
     * @type {string}
     * @memberof AuthOtpValidateResponseData
     */
    'otpToken': string;
}
/**
 * 
 * @export
 * @interface AuthPhoneNumberValidateRequest
 */
export interface AuthPhoneNumberValidateRequest {
    /**
     * Encrypted phoneNumber using RSA256 with public key that\'s retrieved from local database
     * @type {string}
     * @memberof AuthPhoneNumberValidateRequest
     */
    'phoneNo': string;
    /**
     * Hash code that will be included in the SMS sent to users
     * @type {string}
     * @memberof AuthPhoneNumberValidateRequest
     */
    'hashCode'?: string;
}
/**
 * 
 * @export
 * @interface AuthPhoneNumberValidateResponse
 */
export interface AuthPhoneNumberValidateResponse {
    /**
     * Phone number starting with 0 as prefix (08xxxxxxxxx)
     * @type {string}
     * @memberof AuthPhoneNumberValidateResponse
     */
    'phoneNo': string;
    /**
     * 
     * @type {boolean}
     * @memberof AuthPhoneNumberValidateResponse
     */
    'registered': boolean;
}
/**
 * 
 * @export
 * @interface AuthPhoneNumberValidateResponseData
 */
export interface AuthPhoneNumberValidateResponseData {
    /**
     * 
     * @type {string}
     * @memberof AuthPhoneNumberValidateResponseData
     */
    'phoneNumber': string;
    /**
     * 
     * @type {boolean}
     * @memberof AuthPhoneNumberValidateResponseData
     */
    'registered': boolean;
}
/**
 * 
 * @export
 * @interface AuthPinChangeRequest
 */
export interface AuthPinChangeRequest {
    /**
     * Hash PIN using HMAC SHA 256
     * @type {string}
     * @memberof AuthPinChangeRequest
     */
    'oldPin': string;
    /**
     * Hash PIN using HMAC SHA 256
     * @type {string}
     * @memberof AuthPinChangeRequest
     */
    'newPin': string;
    /**
     * Hash PIN using HMAC SHA 256
     * @type {string}
     * @memberof AuthPinChangeRequest
     */
    'confirmationPin': string;
}
/**
 * 
 * @export
 * @interface AuthPinChangeResponse
 */
export interface AuthPinChangeResponse {
    /**
     * 
     * @type {string}
     * @memberof AuthPinChangeResponse
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface AuthPinCreateRequest
 */
export interface AuthPinCreateRequest {
    /**
     * OTP Token in UUID form
     * @type {string}
     * @memberof AuthPinCreateRequest
     */
    'otpToken': string;
    /**
     * Hash PIN using HMAC SHA 256
     * @type {string}
     * @memberof AuthPinCreateRequest
     */
    'newPin': string;
    /**
     * identify create pin process whether it\'s from Forgot Pin flow or not
     * @type {boolean}
     * @memberof AuthPinCreateRequest
     */
    'isForgotPin': boolean;
}
/**
 * 
 * @export
 * @interface AuthPinCreateResponse
 */
export interface AuthPinCreateResponse {
    /**
     * 
     * @type {string}
     * @memberof AuthPinCreateResponse
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface AuthPinValidateBadRequestErrorResponse
 */
export interface AuthPinValidateBadRequestErrorResponse {
    /**
     * Message explaining error that happened
     * @type {string}
     * @memberof AuthPinValidateBadRequestErrorResponse
     */
    'error': string;
}
/**
 * 
 * @export
 * @interface AuthPinValidateRequest
 */
export interface AuthPinValidateRequest {
    /**
     * Encrypted phoneNumber using RSA256 with public key that\'s retrieved from local database
     * @type {string}
     * @memberof AuthPinValidateRequest
     */
    'phoneNumber': string;
    /**
     * Hash PIN using HMAC SHA 256
     * @type {string}
     * @memberof AuthPinValidateRequest
     */
    'pin': string;
}
/**
 * 
 * @export
 * @interface AuthPinValidateResponse
 */
export interface AuthPinValidateResponse {
    /**
     * 
     * @type {string}
     * @memberof AuthPinValidateResponse
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface AuthRefreshJWTTokenResponse
 */
export interface AuthRefreshJWTTokenResponse {
    /**
     * Jwt Token
     * @type {string}
     * @memberof AuthRefreshJWTTokenResponse
     */
    'jwt': string;
}
/**
 * 
 * @export
 * @interface AuthRegisterLeadsRequest
 */
export interface AuthRegisterLeadsRequest {
    /**
     * Encrypted phoneNumber using RSA256 with public key that\'s retrieved from local database
     * @type {string}
     * @memberof AuthRegisterLeadsRequest
     */
    'phoneNo': string;
    /**
     * Name of the leads
     * @type {string}
     * @memberof AuthRegisterLeadsRequest
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface AuthRegisterLeadsResponse
 */
export interface AuthRegisterLeadsResponse {
    /**
     * ID of the leads that just been created
     * @type {string}
     * @memberof AuthRegisterLeadsResponse
     */
    'userId': string;
}
/**
 * 
 * @export
 * @interface AuthUpdateRegistrationRequest
 */
export interface AuthUpdateRegistrationRequest {
    /**
     * Name that is associated with the userId
     * @type {string}
     * @memberof AuthUpdateRegistrationRequest
     */
    'name': string;
    /**
     * 
     * @type {UserRoleEnum}
     * @memberof AuthUpdateRegistrationRequest
     */
    'role': UserRoleEnum;
    /**
     * Referral code that the user used for their registration
     * @type {string}
     * @memberof AuthUpdateRegistrationRequest
     */
    'referralCode'?: string;
    /**
     * Referral utm used in combination with referralCode
     * @type {string}
     * @memberof AuthUpdateRegistrationRequest
     */
    'referralUtm'?: string;
    /**
     * 
     * @type {Array<AssetCategoryEnum>}
     * @memberof AuthUpdateRegistrationRequest
     */
    'assets'?: Array<AssetCategoryEnum>;
}


/**
 * describe the Average Estate Monthly Yield Enum
 * @export
 * @enum {string}
 */

export const AverageEstateMonthlyYieldEnum = {
    _005: '0-0.5',
    _051: '0.5-1',
    _115: '1-1.5',
    _152: '1.5-2',
    _225: '2-2.5',
    _253: '2.5-3',
    _335: '3-3.5'
} as const;

export type AverageEstateMonthlyYieldEnum = typeof AverageEstateMonthlyYieldEnum[keyof typeof AverageEstateMonthlyYieldEnum];


/**
 * Response data
 * @export
 * @interface AwardSawitpoinInternalServerErrorResponse
 */
export interface AwardSawitpoinInternalServerErrorResponse {
    /**
     * 
     * @type {string}
     * @memberof AwardSawitpoinInternalServerErrorResponse
     */
    'error': string;
    /**
     * List of users that are failed to be processed
     * @type {Array<string>}
     * @memberof AwardSawitpoinInternalServerErrorResponse
     */
    'users': Array<string>;
}
/**
 * this is balance type enum
 * @export
 * @enum {string}
 */

export const BalanceTypeEnum = {
    Gold: 'GOLD',
    Sawitpoin: 'SAWITPOIN'
} as const;

export type BalanceTypeEnum = typeof BalanceTypeEnum[keyof typeof BalanceTypeEnum];


/**
 * 
 * @export
 * @interface BannerListResponse
 */
export interface BannerListResponse {
    /**
     * 
     * @type {BannerListResponseData}
     * @memberof BannerListResponse
     */
    'data'?: BannerListResponseData;
}
/**
 * 
 * @export
 * @interface BannerListResponseData
 */
export interface BannerListResponseData {
    /**
     * 
     * @type {Array<BannerListResponseItem>}
     * @memberof BannerListResponseData
     */
    'items'?: Array<BannerListResponseItem>;
}
/**
 * 
 * @export
 * @interface BannerListResponseItem
 */
export interface BannerListResponseItem {
    /**
     * banner ID generated automatically by the system
     * @type {string}
     * @memberof BannerListResponseItem
     */
    'bannerId': string;
    /**
     * Title of a banner
     * @type {string}
     * @memberof BannerListResponseItem
     */
    'title': string;
    /**
     * Description of a banner that contains more information than the banner\'s title
     * @type {string}
     * @memberof BannerListResponseItem
     */
    'description': string;
    /**
     * link of a media (image, gif, or video) of a banner to be shown to user. The link must be publicly accessible
     * @type {string}
     * @memberof BannerListResponseItem
     */
    'link': string;
    /**
     * link to be used as deeplink or redirected to other website
     * @type {string}
     * @memberof BannerListResponseItem
     */
    'embeded_link': string;
    /**
     * priority of a banner auto increment by the system
     * @type {number}
     * @memberof BannerListResponseItem
     */
    'priority': number;
    /**
     * 
     * @type {BannerTypeEnum}
     * @memberof BannerListResponseItem
     */
    'type': BannerTypeEnum;
    /**
     * active status of a banner, will be set as true by default
     * @type {boolean}
     * @memberof BannerListResponseItem
     */
    'isActive': boolean;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const BannerScopeQueryEnum = {
    Home: 'HOME',
    Ecommerce: 'ECOMMERCE',
    Promo: 'PROMO',
    AboutSawitpro: 'ABOUT_SAWITPRO',
    FarmerCampaign: 'FARMER_CAMPAIGN'
} as const;

export type BannerScopeQueryEnum = typeof BannerScopeQueryEnum[keyof typeof BannerScopeQueryEnum];


/**
 * describe the banner media, it could be video, image, link to website, or deeplink
 * @export
 * @enum {string}
 */

export const BannerTypeEnum = {
    ImagePng: 'image_png',
    ImageGif: 'image_gif',
    Video: 'video',
    LinkToWeb: 'link_to_web',
    DeepLinkApp: 'deep_link_app',
    DeepLinkOtherApp: 'deep_link_other_app'
} as const;

export type BannerTypeEnum = typeof BannerTypeEnum[keyof typeof BannerTypeEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const BlockTypeEnum = {
    SupplierContract: 'SUPPLIER_CONTRACT',
    FarmGroup: 'FARM_GROUP'
} as const;

export type BlockTypeEnum = typeof BlockTypeEnum[keyof typeof BlockTypeEnum];


/**
 * 
 * @export
 * @interface BlocksListResponse
 */
export interface BlocksListResponse {
    /**
     * 
     * @type {Array<BlocksListResponseItem>}
     * @memberof BlocksListResponse
     */
    'items': Array<BlocksListResponseItem>;
}
/**
 * 
 * @export
 * @interface BlocksListResponseItem
 */
export interface BlocksListResponseItem {
    /**
     * Id of plantations block
     * @type {string}
     * @memberof BlocksListResponseItem
     */
    'id': string;
    /**
     * name of the block
     * @type {string}
     * @memberof BlocksListResponseItem
     */
    'name': string;
    /**
     * Id of area
     * @type {string}
     * @memberof BlocksListResponseItem
     */
    'areaId': string;
    /**
     * hectare of the block
     * @type {number}
     * @memberof BlocksListResponseItem
     */
    'areaHectare': number;
    /**
     * Id of business
     * @type {string}
     * @memberof BlocksListResponseItem
     */
    'businessId': string;
    /**
     * Block\'s planted year
     * @type {number}
     * @memberof BlocksListResponseItem
     */
    'plantedYear': number;
    /**
     * Block\'s planted month
     * @type {number}
     * @memberof BlocksListResponseItem
     */
    'plantedMonth': number;
    /**
     * Id of seed
     * @type {string}
     * @memberof BlocksListResponseItem
     */
    'seedId': string;
}
/**
 * 
 * @export
 * @interface BookingItem
 */
export interface BookingItem {
    /**
     * Id village of ramp
     * @type {string}
     * @memberof BookingItem
     */
    'areaId'?: string;
    /**
     * Name from user that booked the agronomist consultation
     * @type {string}
     * @memberof BookingItem
     */
    'name'?: string;
    /**
     * Phonenumber from user that booked the agronomist consultation
     * @type {string}
     * @memberof BookingItem
     */
    'phoneNumber'?: string;
    /**
     * Village name where user farm is located
     * @type {string}
     * @memberof BookingItem
     */
    'address'?: string;
    /**
     * date of agronomist consultation booking
     * @type {string}
     * @memberof BookingItem
     */
    'date'?: string;
    /**
     * Time slot of agronomist consultation booking
     * @type {string}
     * @memberof BookingItem
     */
    'time'?: string;
    /**
     * The farm problem that needed to be solved by agronomist
     * @type {string}
     * @memberof BookingItem
     */
    'problem'?: string;
    /**
     * 
     * @type {StatusAgronomistBookingEnum}
     * @memberof BookingItem
     */
    'status'?: StatusAgronomistBookingEnum;
    /**
     * 
     * @type {StatusAgronomistEventBookingEnum}
     * @memberof BookingItem
     */
    'eventStatus'?: StatusAgronomistEventBookingEnum;
    /**
     * Doctor that assigned to handle this agronomist booking consultation
     * @type {string}
     * @memberof BookingItem
     */
    'doctorName'?: string;
    /**
     * ID of the created booking in UUID type used to group time slot in one day
     * @type {string}
     * @memberof BookingItem
     */
    'bookingId': string;
    /**
     * ID of order related to agronomy booking in UUID type
     * @type {string}
     * @memberof BookingItem
     */
    'orderId'?: string;
    /**
     * name of agronomist product type
     * @type {string}
     * @memberof BookingItem
     */
    'productName'?: string;
    /**
     * zoom hyperlink where agronomist and user meet for consultation
     * @type {string}
     * @memberof BookingItem
     */
    'zoomLink'?: string;
    /**
     * ID of farm related to agronomy booking in UUID type
     * @type {string}
     * @memberof BookingItem
     */
    'farmId'?: string;
    /**
     * name of farm this agronomy consultation booking belongs to
     * @type {string}
     * @memberof BookingItem
     */
    'farmName'?: string;
}


/**
 * 
 * @export
 * @interface BusinessGetFarmerGroupListResponse
 */
export interface BusinessGetFarmerGroupListResponse {
    /**
     * 
     * @type {Array<BusinessGetFarmerGroupListResponseItem>}
     * @memberof BusinessGetFarmerGroupListResponse
     */
    'items': Array<BusinessGetFarmerGroupListResponseItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof BusinessGetFarmerGroupListResponse
     */
    'pagination': PaginationResponse;
}
/**
 * 
 * @export
 * @interface BusinessGetFarmerGroupListResponseItem
 */
export interface BusinessGetFarmerGroupListResponseItem {
    /**
     * ID of the farmer group
     * @type {string}
     * @memberof BusinessGetFarmerGroupListResponseItem
     */
    'id': string;
    /**
     * ID of the business
     * @type {string}
     * @memberof BusinessGetFarmerGroupListResponseItem
     */
    'businessId': string;
    /**
     * name of the farmer group
     * @type {string}
     * @memberof BusinessGetFarmerGroupListResponseItem
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface CampaignAddParticipantRequest
 */
export interface CampaignAddParticipantRequest {
    /**
     * List of new participants for campaign
     * @type {Array<CreateEditCampaignRequestMemberItem>}
     * @memberof CampaignAddParticipantRequest
     */
    'participants': Array<CreateEditCampaignRequestMemberItem>;
}
/**
 * 
 * @export
 * @interface CampaignB2CCardItem
 */
export interface CampaignB2CCardItem {
    /**
     * 
     * @type {string}
     * @memberof CampaignB2CCardItem
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CampaignB2CCardItem
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof CampaignB2CCardItem
     */
    'subtitle': string;
}
/**
 * 
 * @export
 * @interface CampaignB2CCardResponse
 */
export interface CampaignB2CCardResponse {
    /**
     * List of b2c campaign card metadata
     * @type {Array<CampaignB2CCardItem>}
     * @memberof CampaignB2CCardResponse
     */
    'cards': Array<CampaignB2CCardItem>;
}
/**
 * 
 * @export
 * @interface CampaignB2CDetailResponse
 */
export interface CampaignB2CDetailResponse {
    /**
     * 
     * @type {string}
     * @memberof CampaignB2CDetailResponse
     */
    'id': string;
    /**
     * Name of the campaign
     * @type {string}
     * @memberof CampaignB2CDetailResponse
     */
    'name': string;
    /**
     * start time of the campaign. Use epoch time
     * @type {number}
     * @memberof CampaignB2CDetailResponse
     */
    'startTime': number;
    /**
     * End time of the campaign. Use epoch time
     * @type {number}
     * @memberof CampaignB2CDetailResponse
     */
    'endTime': number;
    /**
     * Description of the campaign
     * @type {string}
     * @memberof CampaignB2CDetailResponse
     */
    'desc': string;
    /**
     * To distinguish if the user has join this program or not
     * @type {boolean}
     * @memberof CampaignB2CDetailResponse
     */
    'hasJoined': boolean;
    /**
     * List of reward of this campaign
     * @type {Array<CampaignB2CDetailReward>}
     * @memberof CampaignB2CDetailResponse
     */
    'rewards': Array<CampaignB2CDetailReward>;
}
/**
 * 
 * @export
 * @interface CampaignB2CDetailReward
 */
export interface CampaignB2CDetailReward {
    /**
     * Icon of the campaign prize
     * @type {string}
     * @memberof CampaignB2CDetailReward
     */
    'icon': string;
    /**
     * Title of the campaign prize
     * @type {string}
     * @memberof CampaignB2CDetailReward
     */
    'title': string;
    /**
     * Desc of the campaign prize
     * @type {string}
     * @memberof CampaignB2CDetailReward
     */
    'desc'?: string;
}
/**
 * 
 * @export
 * @interface CampaignB2CFarmersHarvestRecordsItem
 */
export interface CampaignB2CFarmersHarvestRecordsItem {
    /**
     * the ID of created FFB Sell Price data
     * @type {string}
     * @memberof CampaignB2CFarmersHarvestRecordsItem
     */
    'id': string;
    /**
     * time of harvest related to the FFB Sell Price data in UTC0 format
     * @type {number}
     * @memberof CampaignB2CFarmersHarvestRecordsItem
     */
    'harvestTime': number;
    /**
     * farm name related to the FFB Sell Price data
     * @type {string}
     * @memberof CampaignB2CFarmersHarvestRecordsItem
     */
    'farmName': string;
    /**
     * ffb total weight of the harvest
     * @type {number}
     * @memberof CampaignB2CFarmersHarvestRecordsItem
     */
    'totalWeightKg': number;
    /**
     * SawitPoin earned for this particular catat panen
     * @type {number}
     * @memberof CampaignB2CFarmersHarvestRecordsItem
     */
    'sawitPoinEarned': number;
}
/**
 * 
 * @export
 * @interface CampaignB2CFarmersHarvestRecordsResponse
 */
export interface CampaignB2CFarmersHarvestRecordsResponse {
    /**
     * 
     * @type {Array<CampaignB2CFarmersHarvestRecordsItem>}
     * @memberof CampaignB2CFarmersHarvestRecordsResponse
     */
    'items': Array<CampaignB2CFarmersHarvestRecordsItem>;
    /**
     * total sawit poin earned from all harvest records
     * @type {number}
     * @memberof CampaignB2CFarmersHarvestRecordsResponse
     */
    'totalSawitPoinEarned'?: number;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof CampaignB2CFarmersHarvestRecordsResponse
     */
    'pagination': PaginationResponse;
}
/**
 * 
 * @export
 * @interface CampaignGetChainDeliveryResponse
 */
export interface CampaignGetChainDeliveryResponse {
    /**
     * Title of campaign chain delivery
     * @type {string}
     * @memberof CampaignGetChainDeliveryResponse
     */
    'title': string;
    /**
     * End time of the campaign. Use epoch time
     * @type {number}
     * @memberof CampaignGetChainDeliveryResponse
     */
    'endTime': number;
    /**
     * status of farm inserted or not
     * @type {boolean}
     * @memberof CampaignGetChainDeliveryResponse
     */
    'isSubmitted': boolean;
    /**
     * Action description of each role
     * @type {string}
     * @memberof CampaignGetChainDeliveryResponse
     */
    'actionTitle': string;
    /**
     * Action description of each role
     * @type {string}
     * @memberof CampaignGetChainDeliveryResponse
     */
    'actionDescription': string;
    /**
     * Action for user
     * @type {boolean}
     * @memberof CampaignGetChainDeliveryResponse
     */
    'actionable': boolean;
    /**
     * 
     * @type {CampaignRoleEnum}
     * @memberof CampaignGetChainDeliveryResponse
     */
    'role'?: CampaignRoleEnum;
}


/**
 * 
 * @export
 * @interface CampaignGetDetailChainDeliveryResponse
 */
export interface CampaignGetDetailChainDeliveryResponse {
    /**
     * list of detail campaign chain delivery
     * @type {Array<CampaignGetDetailChainDeliveryResponseItem>}
     * @memberof CampaignGetDetailChainDeliveryResponse
     */
    'items': Array<CampaignGetDetailChainDeliveryResponseItem>;
    /**
     * Total SawitPoin
     * @type {number}
     * @memberof CampaignGetDetailChainDeliveryResponse
     */
    'totalPoints': number;
    /**
     * Mark whether there is a data on the previous month (for pagination/filtering purpose)
     * @type {boolean}
     * @memberof CampaignGetDetailChainDeliveryResponse
     */
    'previousDataExists': boolean;
    /**
     * Mark whether there is a data on the next month (for pagination/filtering purpose)
     * @type {boolean}
     * @memberof CampaignGetDetailChainDeliveryResponse
     */
    'nextDataExists': boolean;
}
/**
 * 
 * @export
 * @interface CampaignGetDetailChainDeliveryResponseItem
 */
export interface CampaignGetDetailChainDeliveryResponseItem {
    /**
     * Datetime of catat jual
     * @type {number}
     * @memberof CampaignGetDetailChainDeliveryResponseItem
     */
    'datetime': number;
    /**
     * Name of harvester or small holder. Default is empty
     * @type {string}
     * @memberof CampaignGetDetailChainDeliveryResponseItem
     */
    'name': string;
    /**
     * The message to be shared by the user for their contact. If either the `name` or `platNo` property is empty, then this property will be filled. Otherwise, this will be empty
     * @type {string}
     * @memberof CampaignGetDetailChainDeliveryResponseItem
     */
    'shareMessage': string;
    /**
     * Number of truck delivery the supply. Default is empty
     * @type {string}
     * @memberof CampaignGetDetailChainDeliveryResponseItem
     */
    'platNo': string;
    /**
     * Name of Partner (Mill\'s Name)
     * @type {string}
     * @memberof CampaignGetDetailChainDeliveryResponseItem
     */
    'millName': string;
    /**
     * SawitPoin achieved
     * @type {number}
     * @memberof CampaignGetDetailChainDeliveryResponseItem
     */
    'incentive': number;
    /**
     * 
     * @type {CampaignRoleEnum}
     * @memberof CampaignGetDetailChainDeliveryResponseItem
     */
    'role': CampaignRoleEnum;
}


/**
 * 
 * @export
 * @interface CampaignListCodeResponse
 */
export interface CampaignListCodeResponse {
    /**
     * List of campaign codes
     * @type {Array<CampaignListCodeResponseItem>}
     * @memberof CampaignListCodeResponse
     */
    'items': Array<CampaignListCodeResponseItem>;
}
/**
 * 
 * @export
 * @interface CampaignListCodeResponseItem
 */
export interface CampaignListCodeResponseItem {
    /**
     * Campaign ID represented in UUID type 4
     * @type {string}
     * @memberof CampaignListCodeResponseItem
     */
    'id': string;
    /**
     * Campaign code (for previously added campaign without code, the string will be left empty)
     * @type {string}
     * @memberof CampaignListCodeResponseItem
     */
    'code': string;
}
/**
 * Participant type of the campaign
 * @export
 * @enum {string}
 */

export const CampaignParticipantTypeEnum = {
    Member: 'MEMBER',
    Supplier: 'SUPPLIER'
} as const;

export type CampaignParticipantTypeEnum = typeof CampaignParticipantTypeEnum[keyof typeof CampaignParticipantTypeEnum];


/**
 * 
 * @export
 * @interface CampaignProgramListResponseItem
 */
export interface CampaignProgramListResponseItem {
    /**
     * the id of the campaign program
     * @type {string}
     * @memberof CampaignProgramListResponseItem
     */
    'id': string;
    /**
     * the start time of the campaign program in unix milliseconds
     * @type {number}
     * @memberof CampaignProgramListResponseItem
     */
    'startTime': number;
    /**
     * the end time of the campaign program in unix milliseconds
     * @type {number}
     * @memberof CampaignProgramListResponseItem
     */
    'endTime': number;
    /**
     * total participant of the campaign program
     * @type {number}
     * @memberof CampaignProgramListResponseItem
     */
    'totalParticipant': number;
    /**
     * the name of the campaign program
     * @type {string}
     * @memberof CampaignProgramListResponseItem
     */
    'name': string;
    /**
     * 
     * @type {CampaignProgramStatusEnum}
     * @memberof CampaignProgramListResponseItem
     */
    'status': CampaignProgramStatusEnum;
}


/**
 * Enum that identifies status of campaign program
 * @export
 * @enum {string}
 */

export const CampaignProgramStatusEnum = {
    Scheduled: 'SCHEDULED',
    Ongoing: 'ONGOING',
    Finished: 'FINISHED'
} as const;

export type CampaignProgramStatusEnum = typeof CampaignProgramStatusEnum[keyof typeof CampaignProgramStatusEnum];


/**
 * 
 * @export
 * @interface CampaignRankDetailResponse
 */
export interface CampaignRankDetailResponse {
    /**
     * Current campaign rank show in list
     * @type {Array<CampaignRankDetailResponseItem>}
     * @memberof CampaignRankDetailResponse
     */
    'ranks'?: Array<CampaignRankDetailResponseItem>;
}
/**
 * 
 * @export
 * @interface CampaignRankDetailResponseItem
 */
export interface CampaignRankDetailResponseItem {
    /**
     * ID of campaign rank
     * @type {string}
     * @memberof CampaignRankDetailResponseItem
     */
    'id': string;
    /**
     * Name of campaign rank
     * @type {string}
     * @memberof CampaignRankDetailResponseItem
     */
    'name': string;
    /**
     * Multiplier for insentive each ton of supply
     * @type {number}
     * @memberof CampaignRankDetailResponseItem
     */
    'multiplier': number;
    /**
     * Criteria of each rank minimum supply
     * @type {number}
     * @memberof CampaignRankDetailResponseItem
     */
    'criteria': number;
    /**
     * Mark of current campaign rank
     * @type {boolean}
     * @memberof CampaignRankDetailResponseItem
     */
    'isCurrentRank': boolean;
}
/**
 * Enum used to identify campaign role
 * @export
 * @enum {string}
 */

export const CampaignRoleEnum = {
    Smallholder: 'SMALLHOLDER',
    Harvester: 'HARVESTER',
    Driver: 'DRIVER'
} as const;

export type CampaignRoleEnum = typeof CampaignRoleEnum[keyof typeof CampaignRoleEnum];


/**
 * Status of the campaign
 * @export
 * @enum {string}
 */

export const CampaignStatusEnum = {
    Ongoing: 'ONGOING',
    Scheduled: 'SCHEDULED',
    Cancelled: 'CANCELLED',
    End: 'END'
} as const;

export type CampaignStatusEnum = typeof CampaignStatusEnum[keyof typeof CampaignStatusEnum];


/**
 * Enum used to identify campaign type
 * @export
 * @enum {string}
 */

export const CampaignTypeEnum = {
    Memasok: 'MEMASOK',
    Jawara: 'JAWARA',
    Ranking: 'RANKING',
    RantaiPengiriman: 'RANTAI_PENGIRIMAN',
    Gold: 'GOLD'
} as const;

export type CampaignTypeEnum = typeof CampaignTypeEnum[keyof typeof CampaignTypeEnum];


/**
 * 
 * @export
 * @interface CampaignsGoldListResponse
 */
export interface CampaignsGoldListResponse {
    /**
     * 
     * @type {Array<CampaignsGoldListResponseItem>}
     * @memberof CampaignsGoldListResponse
     */
    'items': Array<CampaignsGoldListResponseItem>;
}
/**
 * 
 * @export
 * @interface CampaignsGoldListResponseItem
 */
export interface CampaignsGoldListResponseItem {
    /**
     * Title of the campaign
     * @type {string}
     * @memberof CampaignsGoldListResponseItem
     */
    'title': string;
    /**
     * Mark of campaign gold version.
     * @type {number}
     * @memberof CampaignsGoldListResponseItem
     */
    'version': number;
    /**
     * 
     * @type {CampaignsGoldListResponseTarget}
     * @memberof CampaignsGoldListResponseItem
     */
    'daily': CampaignsGoldListResponseTarget;
    /**
     * 
     * @type {CampaignsGoldListResponseTarget}
     * @memberof CampaignsGoldListResponseItem
     */
    'monthly': CampaignsGoldListResponseTarget;
    /**
     * 
     * @type {CampaignsGoldListResponseTarget}
     * @memberof CampaignsGoldListResponseItem
     */
    'quarterly': CampaignsGoldListResponseTarget;
    /**
     * ID campaign of selected campaign code represented in UUID type 4
     * @type {string}
     * @memberof CampaignsGoldListResponseItem
     */
    'campaignId': string;
}
/**
 * 
 * @export
 * @interface CampaignsGoldListResponseTarget
 */
export interface CampaignsGoldListResponseTarget {
    /**
     * Target of the Campaign Emas in Tonnage
     * @type {number}
     * @memberof CampaignsGoldListResponseTarget
     */
    'target': number;
    /**
     * Gold reward of the Campaign Emas in mg (1/1000 of a gram)
     * @type {number}
     * @memberof CampaignsGoldListResponseTarget
     */
    'gold': number;
}
/**
 * 
 * @export
 * @interface CampaignsGoldV2DailyProgressResponse
 */
export interface CampaignsGoldV2DailyProgressResponse {
    /**
     * List of users daily campaign gold
     * @type {Array<CampaignsGoldV2DailyProgressResponseItem>}
     * @memberof CampaignsGoldV2DailyProgressResponse
     */
    'items': Array<CampaignsGoldV2DailyProgressResponseItem>;
}
/**
 * 
 * @export
 * @interface CampaignsGoldV2DailyProgressResponseItem
 */
export interface CampaignsGoldV2DailyProgressResponseItem {
    /**
     * 
     * @type {number}
     * @memberof CampaignsGoldV2DailyProgressResponseItem
     */
    'day': number;
    /**
     * The user achiement on percent.
     * @type {number}
     * @memberof CampaignsGoldV2DailyProgressResponseItem
     */
    'achievementPercentage': number;
}
/**
 * 
 * @export
 * @interface CampaignsGoldV2DetailResponse
 */
export interface CampaignsGoldV2DetailResponse {
    /**
     * Campaign ID represented in UUID type 4
     * @type {string}
     * @memberof CampaignsGoldV2DetailResponse
     */
    'id': string;
    /**
     * Title of the campaign
     * @type {string}
     * @memberof CampaignsGoldV2DetailResponse
     */
    'title': string;
    /**
     * The total gold achievement of user (in mg or 1/1000 of a gram), will return 0 if the user has no Gold
     * @type {number}
     * @memberof CampaignsGoldV2DetailResponse
     */
    'total': number;
    /**
     * The sub total daily gold achievement of user (in mg or 1/1000 of a gram), will return 0 if the user has no Gold
     * @type {number}
     * @memberof CampaignsGoldV2DetailResponse
     */
    'subTotalDaily': number;
    /**
     * The sub total monthly gold achievement of user (in mg or 1/1000 of a gram), will return 0 if the user has no Gold
     * @type {number}
     * @memberof CampaignsGoldV2DetailResponse
     */
    'subTotalMonthly': number;
    /**
     * The sub total quarterly gold achievement of user (in mg or 1/1000 of a gram), will return 0 if the user has no Gold
     * @type {number}
     * @memberof CampaignsGoldV2DetailResponse
     */
    'subTotalQuarterly': number;
    /**
     * the start time of the very first Campaign Emas v2 that the user has joined
     * @type {number}
     * @memberof CampaignsGoldV2DetailResponse
     */
    'startTime': number;
    /**
     * the end time of the latest Campaign Emas v2 that the user has joined
     * @type {number}
     * @memberof CampaignsGoldV2DetailResponse
     */
    'endTime': number;
    /**
     * The target that must be met by user per day (ton).
     * @type {number}
     * @memberof CampaignsGoldV2DetailResponse
     */
    'targetTonDaily': number;
    /**
     * The target that must be met by user per day (ton).
     * @type {number}
     * @memberof CampaignsGoldV2DetailResponse
     */
    'targetTonMonthly': number;
    /**
     * The target that must be met by user per day (ton).
     * @type {number}
     * @memberof CampaignsGoldV2DetailResponse
     */
    'targetTonQuarterly': number;
}
/**
 * 
 * @export
 * @interface CampaignsGoldV2LeaderBoardResponse
 */
export interface CampaignsGoldV2LeaderBoardResponse {
    /**
     * List of users who have earned gold from Campaign Emas
     * @type {Array<CampaignsGoldV2LeaderBoardResponseItem>}
     * @memberof CampaignsGoldV2LeaderBoardResponse
     */
    'items': Array<CampaignsGoldV2LeaderBoardResponseItem>;
}
/**
 * 
 * @export
 * @interface CampaignsGoldV2LeaderBoardResponseItem
 */
export interface CampaignsGoldV2LeaderBoardResponseItem {
    /**
     * The user gold achievement ranking
     * @type {number}
     * @memberof CampaignsGoldV2LeaderBoardResponseItem
     */
    'rank': number;
    /**
     * Name of the user
     * @type {string}
     * @memberof CampaignsGoldV2LeaderBoardResponseItem
     */
    'name': string;
    /**
     * The total gold achievement of user (in mg or 1/1000 of a gram).
     * @type {number}
     * @memberof CampaignsGoldV2LeaderBoardResponseItem
     */
    'total': number;
    /**
     * Mark of current user
     * @type {boolean}
     * @memberof CampaignsGoldV2LeaderBoardResponseItem
     */
    'isCurrentUser': boolean;
}
/**
 * 
 * @export
 * @interface CampaignsGoldV2MonthlyProgressResponse
 */
export interface CampaignsGoldV2MonthlyProgressResponse {
    /**
     * Title of the additional target notification
     * @type {string}
     * @memberof CampaignsGoldV2MonthlyProgressResponse
     */
    'title': string;
    /**
     * Message of the additional target notification
     * @type {string}
     * @memberof CampaignsGoldV2MonthlyProgressResponse
     */
    'message': string;
    /**
     * The user baseline target (ton).
     * @type {number}
     * @memberof CampaignsGoldV2MonthlyProgressResponse
     */
    'baseline': number;
    /**
     * The current supply of user (ton).
     * @type {number}
     * @memberof CampaignsGoldV2MonthlyProgressResponse
     */
    'currentSupply': number;
    /**
     * 
     * @type {CampaignsGoldV2MonthlyProgressResponseItem}
     * @memberof CampaignsGoldV2MonthlyProgressResponse
     */
    'targetSupply': CampaignsGoldV2MonthlyProgressResponseItem;
    /**
     * 
     * @type {CampaignsGoldV2MonthlyProgressResponseItem}
     * @memberof CampaignsGoldV2MonthlyProgressResponse
     */
    'targetAdditional': CampaignsGoldV2MonthlyProgressResponseItem;
}
/**
 * 
 * @export
 * @interface CampaignsGoldV2MonthlyProgressResponseItem
 */
export interface CampaignsGoldV2MonthlyProgressResponseItem {
    /**
     * The current gold achievement of user (in mg or 1/1000 of a gram), will return 0 if the user has no Gold
     * @type {number}
     * @memberof CampaignsGoldV2MonthlyProgressResponseItem
     */
    'currentAchievement': number;
    /**
     * The user next supply target (ton).
     * @type {number}
     * @memberof CampaignsGoldV2MonthlyProgressResponseItem
     */
    'nextTarget': number;
    /**
     * The next gold achievement of user (in mg or 1/1000 of a gram), will return 0 if the user has no Gold
     * @type {number}
     * @memberof CampaignsGoldV2MonthlyProgressResponseItem
     */
    'nextAchievement': number;
}
/**
 * 
 * @export
 * @interface CampaignsGoldV2QuarterlyProgressResponse
 */
export interface CampaignsGoldV2QuarterlyProgressResponse {
    /**
     * The user baseline target (ton).
     * @type {number}
     * @memberof CampaignsGoldV2QuarterlyProgressResponse
     */
    'baseline': number;
    /**
     * The current supply of user (ton).
     * @type {number}
     * @memberof CampaignsGoldV2QuarterlyProgressResponse
     */
    'currentSupply': number;
    /**
     * The current gold achievement of user (in mg or 1/1000 of a gram), will return 0 if the user has no Gold
     * @type {number}
     * @memberof CampaignsGoldV2QuarterlyProgressResponse
     */
    'currentAchievement': number;
    /**
     * The user next supply target (ton).
     * @type {number}
     * @memberof CampaignsGoldV2QuarterlyProgressResponse
     */
    'nextTarget': number;
    /**
     * The next gold achievement of user (in mg or 1/1000 of a gram), will return 0 if the user has no Gold
     * @type {number}
     * @memberof CampaignsGoldV2QuarterlyProgressResponse
     */
    'nextAchievement': number;
    /**
     * Campaign start time in epoch
     * @type {number}
     * @memberof CampaignsGoldV2QuarterlyProgressResponse
     */
    'startTime': number;
    /**
     * Campaign end time in epoch
     * @type {number}
     * @memberof CampaignsGoldV2QuarterlyProgressResponse
     */
    'endTime': number;
}
/**
 * 
 * @export
 * @interface CampaignsListResponse
 */
export interface CampaignsListResponse {
    /**
     * 
     * @type {Array<CampaignsListResponseItem>}
     * @memberof CampaignsListResponse
     */
    'items': Array<CampaignsListResponseItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof CampaignsListResponse
     */
    'pagination': PaginationResponse;
}
/**
 * 
 * @export
 * @interface CampaignsListResponseItem
 */
export interface CampaignsListResponseItem {
    /**
     * Campaign ID represented in UUID type 4
     * @type {string}
     * @memberof CampaignsListResponseItem
     */
    'id': string;
    /**
     * The Partner (mill) name that created the campaign
     * @type {string}
     * @memberof CampaignsListResponseItem
     */
    'millName': string;
    /**
     * Campaign type name
     * @type {string}
     * @memberof CampaignsListResponseItem
     */
    'type': string;
    /**
     * Campaign title
     * @type {string}
     * @memberof CampaignsListResponseItem
     */
    'title': string;
    /**
     * The Supplier (DO) name that the user own
     * @type {string}
     * @memberof CampaignsListResponseItem
     */
    'supplierName': string;
    /**
     * Campaign target, will be returned null if the campaign is using `baseline` property
     * @type {number}
     * @memberof CampaignsListResponseItem
     */
    'target'?: number;
    /**
     * The user\'s campaign achievement of the campaign target, will be returned null if the campaign is using `supply` property
     * @type {number}
     * @memberof CampaignsListResponseItem
     */
    'achievement'?: number;
    /**
     * The baseline target of Campaign Increment type, will be return null if the campaign is using `target` property
     * @type {number}
     * @memberof CampaignsListResponseItem
     */
    'baseline'?: number;
    /**
     * The user\'s supply progress in measurement unit of current campaign, will be having the same value as `baseline` if supply already surpass that number. Will be return null if the campaign is using `achievement` property
     * @type {number}
     * @memberof CampaignsListResponseItem
     */
    'supply'?: number;
    /**
     * The excess supply (supply - baseline) of Campaign Increment type, will return the excess supply after the baseline is reached (otherwise 0). For other type of campaign will be returning 0
     * @type {number}
     * @memberof CampaignsListResponseItem
     */
    'excessSupply'?: number;
    /**
     * Campaign measurement unit
     * @type {string}
     * @memberof CampaignsListResponseItem
     */
    'measurementUnit': string;
    /**
     * Campaign start time in epoch
     * @type {number}
     * @memberof CampaignsListResponseItem
     */
    'startTime': number;
    /**
     * Campaign end time in epoch
     * @type {number}
     * @memberof CampaignsListResponseItem
     */
    'endTime': number;
    /**
     * Campaign reward (Sawitpoin)
     * @type {number}
     * @memberof CampaignsListResponseItem
     */
    'reward': number;
}
/**
 * 
 * @export
 * @interface CampaignsListTypeDefaultTarget
 */
export interface CampaignsListTypeDefaultTarget {
    /**
     * Default target ID represented in UUID type 4
     * @type {string}
     * @memberof CampaignsListTypeDefaultTarget
     */
    'id': string;
    /**
     * Default target unit
     * @type {string}
     * @memberof CampaignsListTypeDefaultTarget
     */
    'targetUnit': string;
}
/**
 * Response data
 * @export
 * @interface CampaignsListTypeResponse
 */
export interface CampaignsListTypeResponse {
    /**
     * List of campaign types
     * @type {Array<CampaignsListTypeResponseItem>}
     * @memberof CampaignsListTypeResponse
     */
    'items': Array<CampaignsListTypeResponseItem>;
}
/**
 * 
 * @export
 * @interface CampaignsListTypeResponseItem
 */
export interface CampaignsListTypeResponseItem {
    /**
     * Campaign type ID represented in UUID type 4
     * @type {string}
     * @memberof CampaignsListTypeResponseItem
     */
    'id': string;
    /**
     * Campaign type name
     * @type {string}
     * @memberof CampaignsListTypeResponseItem
     */
    'name': string;
    /**
     * Campaign type icon file url
     * @type {string}
     * @memberof CampaignsListTypeResponseItem
     */
    'iconUrl': string;
    /**
     * List of the current campaign type default target
     * @type {Array<CampaignsListTypeDefaultTarget>}
     * @memberof CampaignsListTypeResponseItem
     */
    'defaultTarget': Array<CampaignsListTypeDefaultTarget>;
}
/**
 * 
 * @export
 * @interface CampaignsProgramsCreateParticipantsInner
 */
export interface CampaignsProgramsCreateParticipantsInner {
    /**
     * A user ID that indicates the owner of a supplier contract
     * @type {string}
     * @memberof CampaignsProgramsCreateParticipantsInner
     */
    'userId': string;
    /**
     * 
     * @type {Array<CampaignsProgramsCreateTargetsInner>}
     * @memberof CampaignsProgramsCreateParticipantsInner
     */
    'targets': Array<CampaignsProgramsCreateTargetsInner>;
}
/**
 * 
 * @export
 * @interface CampaignsProgramsCreateRequest
 */
export interface CampaignsProgramsCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof CampaignsProgramsCreateRequest
     */
    'partnerId': string;
    /**
     * version of the campaign iterated by business
     * @type {number}
     * @memberof CampaignsProgramsCreateRequest
     */
    'version': number;
    /**
     * the name of the campaign program
     * @type {string}
     * @memberof CampaignsProgramsCreateRequest
     */
    'name': string;
    /**
     * the start of campaign program in milliseconds
     * @type {number}
     * @memberof CampaignsProgramsCreateRequest
     */
    'startTime': number;
    /**
     * the end of campaign program in milliseconds
     * @type {number}
     * @memberof CampaignsProgramsCreateRequest
     */
    'endTime': number;
    /**
     * list of participant that about to be added to the campaign gold
     * @type {Array<CampaignsProgramsCreateParticipantsInner>}
     * @memberof CampaignsProgramsCreateRequest
     */
    'participants': Array<CampaignsProgramsCreateParticipantsInner>;
}
/**
 * 
 * @export
 * @interface CampaignsProgramsCreateTargetsInner
 */
export interface CampaignsProgramsCreateTargetsInner {
    /**
     * 
     * @type {string}
     * @memberof CampaignsProgramsCreateTargetsInner
     */
    'type': CampaignsProgramsCreateTargetsInnerTypeEnum;
    /**
     * the target of the campaign in tonne (net weight adjusted)
     * @type {number}
     * @memberof CampaignsProgramsCreateTargetsInner
     */
    'targetFfbWeightTonne': number;
    /**
     * the start of campaign program in milliseconds
     * @type {number}
     * @memberof CampaignsProgramsCreateTargetsInner
     */
    'startTime': number;
    /**
     * the end of campaign program in milliseconds
     * @type {number}
     * @memberof CampaignsProgramsCreateTargetsInner
     */
    'endTime': number;
}

export const CampaignsProgramsCreateTargetsInnerTypeEnum = {
    Daily: 'DAILY',
    Monthly: 'MONTHLY',
    Quarterly: 'QUARTERLY'
} as const;

export type CampaignsProgramsCreateTargetsInnerTypeEnum = typeof CampaignsProgramsCreateTargetsInnerTypeEnum[keyof typeof CampaignsProgramsCreateTargetsInnerTypeEnum];

/**
 * 
 * @export
 * @interface CampaignsProgramsGetDetailParticipantCandidates
 */
export interface CampaignsProgramsGetDetailParticipantCandidates {
    /**
     * the id of the participant; the owner of a supplier contract.
     * @type {string}
     * @memberof CampaignsProgramsGetDetailParticipantCandidates
     */
    'userId': string;
    /**
     * the name of the user
     * @type {string}
     * @memberof CampaignsProgramsGetDetailParticipantCandidates
     */
    'userName': string;
}
/**
 * 
 * @export
 * @interface CampaignsProgramsGetDetailParticipantsInner
 */
export interface CampaignsProgramsGetDetailParticipantsInner {
    /**
     * unique ID of campaign gold indicated a user participation
     * @type {string}
     * @memberof CampaignsProgramsGetDetailParticipantsInner
     */
    'campaignGoldId': string;
    /**
     * the id of the participant; the owner of a supplier contract.
     * @type {string}
     * @memberof CampaignsProgramsGetDetailParticipantsInner
     */
    'userId': string;
    /**
     * the name of the user
     * @type {string}
     * @memberof CampaignsProgramsGetDetailParticipantsInner
     */
    'userName': string;
    /**
     * indicates the join time of the participant to campaign program
     * @type {number}
     * @memberof CampaignsProgramsGetDetailParticipantsInner
     */
    'createdAt': number;
    /**
     * assigned campaign target for the user
     * @type {Array<CampaignsProgramsGetDetailParticipantsTargetsInner>}
     * @memberof CampaignsProgramsGetDetailParticipantsInner
     */
    'targets': Array<CampaignsProgramsGetDetailParticipantsTargetsInner>;
}
/**
 * 
 * @export
 * @interface CampaignsProgramsGetDetailParticipantsTargetsInner
 */
export interface CampaignsProgramsGetDetailParticipantsTargetsInner {
    /**
     * the type of target
     * @type {string}
     * @memberof CampaignsProgramsGetDetailParticipantsTargetsInner
     */
    'type': CampaignsProgramsGetDetailParticipantsTargetsInnerTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof CampaignsProgramsGetDetailParticipantsTargetsInner
     */
    'targetFfbWeightTonne': number;
    /**
     * the start time of the target campaign program in unix milliseconds
     * @type {number}
     * @memberof CampaignsProgramsGetDetailParticipantsTargetsInner
     */
    'startTime': number;
    /**
     * the end time of the target campaign program in unix milliseconds
     * @type {number}
     * @memberof CampaignsProgramsGetDetailParticipantsTargetsInner
     */
    'endTime': number;
}

export const CampaignsProgramsGetDetailParticipantsTargetsInnerTypeEnum = {
    Daily: 'DAILY',
    Monthly: 'MONTHLY',
    Quarterly: 'QUARTERLY'
} as const;

export type CampaignsProgramsGetDetailParticipantsTargetsInnerTypeEnum = typeof CampaignsProgramsGetDetailParticipantsTargetsInnerTypeEnum[keyof typeof CampaignsProgramsGetDetailParticipantsTargetsInnerTypeEnum];

/**
 * 
 * @export
 * @interface CampaignsProgramsGetDetailRequest
 */
export interface CampaignsProgramsGetDetailRequest {
    /**
     * the unique identifier of campaign program
     * @type {string}
     * @memberof CampaignsProgramsGetDetailRequest
     */
    'id': string;
    /**
     * the name of campaign program
     * @type {string}
     * @memberof CampaignsProgramsGetDetailRequest
     */
    'name': string;
    /**
     * unique identifier of a partner
     * @type {string}
     * @memberof CampaignsProgramsGetDetailRequest
     */
    'partnerId': string;
    /**
     * The name of the partner associated with the campaign
     * @type {string}
     * @memberof CampaignsProgramsGetDetailRequest
     */
    'partnerName': string;
    /**
     * Campaign program version
     * @type {number}
     * @memberof CampaignsProgramsGetDetailRequest
     */
    'version': number;
    /**
     * the start time of the campaign program in unix milliseconds
     * @type {number}
     * @memberof CampaignsProgramsGetDetailRequest
     */
    'startTime': number;
    /**
     * the end time of the campaign program in unix milliseconds
     * @type {number}
     * @memberof CampaignsProgramsGetDetailRequest
     */
    'endTime': number;
    /**
     * indicates the creation time of the campaign program in milliseconds
     * @type {number}
     * @memberof CampaignsProgramsGetDetailRequest
     */
    'createdAt': number;
    /**
     * 
     * @type {CampaignStatusEnum}
     * @memberof CampaignsProgramsGetDetailRequest
     */
    'status': CampaignStatusEnum;
    /**
     * number of participant who join this campaign program
     * @type {number}
     * @memberof CampaignsProgramsGetDetailRequest
     */
    'totalParticipants': number;
    /**
     * list of participants of the campaigns
     * @type {Array<CampaignsProgramsGetDetailParticipantsInner>}
     * @memberof CampaignsProgramsGetDetailRequest
     */
    'participants': Array<CampaignsProgramsGetDetailParticipantsInner>;
    /**
     * The list of user ID who don\'t participant in the campaign yet
     * @type {Array<CampaignsProgramsGetDetailParticipantCandidates>}
     * @memberof CampaignsProgramsGetDetailRequest
     */
    'participantCandidates': Array<CampaignsProgramsGetDetailParticipantCandidates>;
}


/**
 * 
 * @export
 * @interface CampaignsProgramsGetList
 */
export interface CampaignsProgramsGetList {
    /**
     * 
     * @type {Array<CampaignProgramListResponseItem>}
     * @memberof CampaignsProgramsGetList
     */
    'items': Array<CampaignProgramListResponseItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof CampaignsProgramsGetList
     */
    'pagination': PaginationResponse;
}
/**
 * 
 * @export
 * @interface CampaignsProgramsGoldCreateParticipantsInner
 */
export interface CampaignsProgramsGoldCreateParticipantsInner {
    /**
     * A user ID that indicates the owner of a supplier contract
     * @type {string}
     * @memberof CampaignsProgramsGoldCreateParticipantsInner
     */
    'userId': string;
    /**
     * 
     * @type {Array<CampaignsProgramsCreateTargetsInner>}
     * @memberof CampaignsProgramsGoldCreateParticipantsInner
     */
    'targets': Array<CampaignsProgramsCreateTargetsInner>;
}
/**
 * 
 * @export
 * @interface CampaignsProgramsGoldCreateRequest
 */
export interface CampaignsProgramsGoldCreateRequest {
    /**
     * Campaign program ID is unique identifier of campaign program
     * @type {string}
     * @memberof CampaignsProgramsGoldCreateRequest
     */
    'campaignProgramId': string;
    /**
     * list of participants of the campaigns
     * @type {Array<CampaignsProgramsGoldCreateParticipantsInner>}
     * @memberof CampaignsProgramsGoldCreateRequest
     */
    'participants': Array<CampaignsProgramsGoldCreateParticipantsInner>;
}
/**
 * 
 * @export
 * @interface CampaignsProgramsGoldTargetAddRequestInner
 */
export interface CampaignsProgramsGoldTargetAddRequestInner {
    /**
     * Campaign program ID is unique identifier of campaign program
     * @type {string}
     * @memberof CampaignsProgramsGoldTargetAddRequestInner
     */
    'campaignGoldId': string;
    /**
     * 
     * @type {string}
     * @memberof CampaignsProgramsGoldTargetAddRequestInner
     */
    'type': CampaignsProgramsGoldTargetAddRequestInnerTypeEnum;
    /**
     * the target of the campaign in tonne (net weight adjusted)
     * @type {number}
     * @memberof CampaignsProgramsGoldTargetAddRequestInner
     */
    'targetFfbWeightTonne': number;
    /**
     * the start of campaign program in milliseconds
     * @type {number}
     * @memberof CampaignsProgramsGoldTargetAddRequestInner
     */
    'startTime': number;
    /**
     * the end of campaign program in milliseconds
     * @type {number}
     * @memberof CampaignsProgramsGoldTargetAddRequestInner
     */
    'endTime': number;
}

export const CampaignsProgramsGoldTargetAddRequestInnerTypeEnum = {
    Daily: 'DAILY',
    Monthly: 'MONTHLY',
    Quarterly: 'QUARTERLY'
} as const;

export type CampaignsProgramsGoldTargetAddRequestInnerTypeEnum = typeof CampaignsProgramsGoldTargetAddRequestInnerTypeEnum[keyof typeof CampaignsProgramsGoldTargetAddRequestInnerTypeEnum];

/**
 * The simulation reward
 * @export
 * @interface CampaignsSimulationIncrementBodyItem
 */
export interface CampaignsSimulationIncrementBodyItem {
    /**
     * The number of supply in ton
     * @type {string}
     * @memberof CampaignsSimulationIncrementBodyItem
     */
    'supply': string;
    /**
     * The surplus supply in ton
     * @type {string}
     * @memberof CampaignsSimulationIncrementBodyItem
     */
    'surplus': string;
    /**
     * The Sawitpoin (point) award for this specific surplus
     * @type {string}
     * @memberof CampaignsSimulationIncrementBodyItem
     */
    'point': string;
    /**
     * The total amount of Sawitpoin (award)
     * @type {string}
     * @memberof CampaignsSimulationIncrementBodyItem
     */
    'total': string;
}
/**
 * The multiplier object for campaign increment simulation
 * @export
 * @interface CampaignsSimulationIncrementMultiplierItem
 */
export interface CampaignsSimulationIncrementMultiplierItem {
    /**
     * The header on each card
     * @type {string}
     * @memberof CampaignsSimulationIncrementMultiplierItem
     */
    'header': string;
    /**
     * The body (message) on each card
     * @type {string}
     * @memberof CampaignsSimulationIncrementMultiplierItem
     */
    'message': string;
}
/**
 * Response data
 * @export
 * @interface CampaignsSimulationIncrementResponse
 */
export interface CampaignsSimulationIncrementResponse {
    /**
     * List of poin multiplier and its baseline target
     * @type {Array<CampaignsSimulationIncrementMultiplierItem>}
     * @memberof CampaignsSimulationIncrementResponse
     */
    'multiplier': Array<CampaignsSimulationIncrementMultiplierItem>;
    /**
     * The highlight reward of this campaign type (within HTML text form)
     * @type {string}
     * @memberof CampaignsSimulationIncrementResponse
     */
    'reward': string;
    /**
     * Target of the simulation
     * @type {string}
     * @memberof CampaignsSimulationIncrementResponse
     */
    'target': string;
    /**
     * 
     * @type {CampaignsSimulationIncrementSimulationItem}
     * @memberof CampaignsSimulationIncrementResponse
     */
    'simulation': CampaignsSimulationIncrementSimulationItem;
}
/**
 * The data to show within the simulation table
 * @export
 * @interface CampaignsSimulationIncrementSimulationItem
 */
export interface CampaignsSimulationIncrementSimulationItem {
    /**
     * List of header name for the simulation table
     * @type {Array<string>}
     * @memberof CampaignsSimulationIncrementSimulationItem
     */
    'header': Array<string>;
    /**
     * List of body data for the simulation table
     * @type {Array<CampaignsSimulationIncrementBodyItem>}
     * @memberof CampaignsSimulationIncrementSimulationItem
     */
    'body': Array<CampaignsSimulationIncrementBodyItem>;
}
/**
 * Response data
 * @export
 * @interface CancelCampaignResponse
 */
export interface CancelCampaignResponse {
    /**
     * Campaign ID
     * @type {string}
     * @memberof CancelCampaignResponse
     */
    'id': string;
    /**
     * Campaign name
     * @type {string}
     * @memberof CancelCampaignResponse
     */
    'name': string;
    /**
     * 
     * @type {CampaignStatusEnum}
     * @memberof CancelCampaignResponse
     */
    'status': CampaignStatusEnum;
}


/**
 * 
 * @export
 * @interface CartCreateRequest
 */
export interface CartCreateRequest {
    /**
     * List of Cart Item that will be stored to database
     * @type {Array<CartCreateRequestItem>}
     * @memberof CartCreateRequest
     */
    'items': Array<CartCreateRequestItem>;
}
/**
 * 
 * @export
 * @interface CartCreateRequestItem
 */
export interface CartCreateRequestItem {
    /**
     * Store ID
     * @type {string}
     * @memberof CartCreateRequestItem
     */
    'storeId': string;
    /**
     * List of Store Product Item
     * @type {Array<CartCreateRequestStoreProductItem>}
     * @memberof CartCreateRequestItem
     */
    'storeProductItems': Array<CartCreateRequestStoreProductItem>;
}
/**
 * 
 * @export
 * @interface CartCreateRequestStoreProductItem
 */
export interface CartCreateRequestStoreProductItem {
    /**
     * Product ID
     * @type {string}
     * @memberof CartCreateRequestStoreProductItem
     */
    'productId': string;
    /**
     * Product Quantity
     * @type {number}
     * @memberof CartCreateRequestStoreProductItem
     */
    'productQuantity': number;
    /**
     * Product Displayed Price
     * @type {number}
     * @memberof CartCreateRequestStoreProductItem
     */
    'productDisplayedPrice': number;
}
/**
 * 
 * @export
 * @interface CartCreateResponse
 */
export interface CartCreateResponse {
    /**
     * 
     * @type {boolean}
     * @memberof CartCreateResponse
     */
    'success': boolean;
    /**
     * List of Cart Item ID
     * @type {Array<string>}
     * @memberof CartCreateResponse
     */
    'cartItemIds': Array<string>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const CartStatusEnum = {
    Open: 'OPEN',
    Closed: 'CLOSED'
} as const;

export type CartStatusEnum = typeof CartStatusEnum[keyof typeof CartStatusEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const CartStatusItemEnum = {
    Open: 'OPEN',
    Closed: 'CLOSED'
} as const;

export type CartStatusItemEnum = typeof CartStatusItemEnum[keyof typeof CartStatusItemEnum];


/**
 * 
 * @export
 * @interface CartsGetDetailResponse
 */
export interface CartsGetDetailResponse {
    /**
     * Cart ID
     * @type {string}
     * @memberof CartsGetDetailResponse
     */
    'id': string;
    /**
     * 
     * @type {CartStatusEnum}
     * @memberof CartsGetDetailResponse
     */
    'status': CartStatusEnum;
    /**
     * Cart Total Price
     * @type {number}
     * @memberof CartsGetDetailResponse
     */
    'totalPrice': number;
    /**
     * Cart Product Count
     * @type {number}
     * @memberof CartsGetDetailResponse
     */
    'productCount': number;
    /**
     * List of Cart Store Item
     * @type {Array<CartsGetDetailResponseCartStoreItem>}
     * @memberof CartsGetDetailResponse
     */
    'cartStoreItems': Array<CartsGetDetailResponseCartStoreItem>;
}


/**
 * 
 * @export
 * @interface CartsGetDetailResponseCartStoreItem
 */
export interface CartsGetDetailResponseCartStoreItem {
    /**
     * Store ID
     * @type {string}
     * @memberof CartsGetDetailResponseCartStoreItem
     */
    'storeId': string;
    /**
     * Store Name
     * @type {string}
     * @memberof CartsGetDetailResponseCartStoreItem
     */
    'storeName': string;
    /**
     * Parent Partner Name
     * @type {string}
     * @memberof CartsGetDetailResponseCartStoreItem
     */
    'parentPartnerName': string;
    /**
     * Stock Location Address
     * @type {string}
     * @memberof CartsGetDetailResponseCartStoreItem
     */
    'address': string;
    /**
     * Stock Location Latitude
     * @type {number}
     * @memberof CartsGetDetailResponseCartStoreItem
     */
    'latitude': number;
    /**
     * Stock Location Longitude
     * @type {number}
     * @memberof CartsGetDetailResponseCartStoreItem
     */
    'longitude': number;
    /**
     * List of Store Product Item
     * @type {Array<CartsGetDetailResponseStoreProductItem>}
     * @memberof CartsGetDetailResponseCartStoreItem
     */
    'storeProductItems': Array<CartsGetDetailResponseStoreProductItem>;
}
/**
 * 
 * @export
 * @interface CartsGetDetailResponseStoreProductItem
 */
export interface CartsGetDetailResponseStoreProductItem {
    /**
     * Cart Item ID
     * @type {string}
     * @memberof CartsGetDetailResponseStoreProductItem
     */
    'cartItemId': string;
    /**
     * Product ID
     * @type {string}
     * @memberof CartsGetDetailResponseStoreProductItem
     */
    'productId': string;
    /**
     * Product Name
     * @type {string}
     * @memberof CartsGetDetailResponseStoreProductItem
     */
    'productName': string;
    /**
     * Product Quantity
     * @type {number}
     * @memberof CartsGetDetailResponseStoreProductItem
     */
    'productQuantity': number;
    /**
     * Product Stock
     * @type {number}
     * @memberof CartsGetDetailResponseStoreProductItem
     */
    'productStock': number;
    /**
     * Product Image URL
     * @type {string}
     * @memberof CartsGetDetailResponseStoreProductItem
     */
    'productImageUrl': string;
    /**
     * Product Displayed Price
     * @type {number}
     * @memberof CartsGetDetailResponseStoreProductItem
     */
    'productDisplayedPrice': number;
    /**
     * Product Current Price
     * @type {number}
     * @memberof CartsGetDetailResponseStoreProductItem
     */
    'productCurrentPrice': number;
    /**
     * 
     * @type {number}
     * @memberof CartsGetDetailResponseStoreProductItem
     */
    'priceAfterPoints': number;
    /**
     * 
     * @type {number}
     * @memberof CartsGetDetailResponseStoreProductItem
     */
    'priceReductionPercentage': number;
    /**
     * 
     * @type {number}
     * @memberof CartsGetDetailResponseStoreProductItem
     */
    'maxPointUsage': number;
    /**
     * minimum order quantity
     * @type {number}
     * @memberof CartsGetDetailResponseStoreProductItem
     */
    'minimumOrderQty': number;
    /**
     * 
     * @type {DeliveryEnum}
     * @memberof CartsGetDetailResponseStoreProductItem
     */
    'deliveryType': DeliveryEnum;
    /**
     * 
     * @type {Array<DeliveryEnum>}
     * @memberof CartsGetDetailResponseStoreProductItem
     */
    'deliveryTypes'?: Array<DeliveryEnum>;
    /**
     * 
     * @type {Array<CartsGetDetailResponseStoreProductItemPriceList>}
     * @memberof CartsGetDetailResponseStoreProductItem
     */
    'priceList'?: Array<CartsGetDetailResponseStoreProductItemPriceList>;
}


/**
 * 
 * @export
 * @interface CartsGetDetailResponseStoreProductItemPriceList
 */
export interface CartsGetDetailResponseStoreProductItemPriceList {
    /**
     * 
     * @type {string}
     * @memberof CartsGetDetailResponseStoreProductItemPriceList
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof CartsGetDetailResponseStoreProductItemPriceList
     */
    'price': number;
    /**
     * 
     * @type {number}
     * @memberof CartsGetDetailResponseStoreProductItemPriceList
     */
    'priceAfterPoints': number;
    /**
     * 
     * @type {number}
     * @memberof CartsGetDetailResponseStoreProductItemPriceList
     */
    'priceReductionPercentage': number;
    /**
     * 
     * @type {number}
     * @memberof CartsGetDetailResponseStoreProductItemPriceList
     */
    'maxPointUsage': number;
    /**
     * minimum order quantity
     * @type {number}
     * @memberof CartsGetDetailResponseStoreProductItemPriceList
     */
    'minimumOrderQty': number;
}
/**
 * 
 * @export
 * @interface CartsGetProductCountResponse
 */
export interface CartsGetProductCountResponse {
    /**
     * Total product count in cart
     * @type {number}
     * @memberof CartsGetProductCountResponse
     */
    'productCount': number;
}
/**
 * 
 * @export
 * @interface CartsItemsDeleteResponse
 */
export interface CartsItemsDeleteResponse {
    /**
     * 
     * @type {boolean}
     * @memberof CartsItemsDeleteResponse
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const CategoryCodeEnum = {
    Topup: 'TOPUP'
} as const;

export type CategoryCodeEnum = typeof CategoryCodeEnum[keyof typeof CategoryCodeEnum];


/**
 * 
 * @export
 * @interface CityResponseItem
 */
export interface CityResponseItem {
    /**
     * Name of city
     * @type {string}
     * @memberof CityResponseItem
     */
    'name': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const CollectorTypeEnum = {
    Collector: 'COLLECTOR',
    Farmer: 'FARMER',
    FarmerAssociation: 'FARMER_ASSOCIATION',
    Local: 'LOCAL'
} as const;

export type CollectorTypeEnum = typeof CollectorTypeEnum[keyof typeof CollectorTypeEnum];


/**
 * 
 * @export
 * @interface ConfirmLoyaltyRequestPointDisbursementRequest
 */
export interface ConfirmLoyaltyRequestPointDisbursementRequest {
    /**
     * Is point disbursement request approved
     * @type {boolean}
     * @memberof ConfirmLoyaltyRequestPointDisbursementRequest
     */
    'isApproved': boolean;
    /**
     * the reason if the request is rejected
     * @type {string}
     * @memberof ConfirmLoyaltyRequestPointDisbursementRequest
     */
    'reason'?: string;
}
/**
 * Coordinate Reference System that belong to this feature collection based on ESRI Geojson Format (RFC7159).
 * @export
 * @interface CoordinateReferenceSystem
 */
export interface CoordinateReferenceSystem {
    /**
     * Type of this Coordinate Reference System based on ESRI Geojson Format (RFC7159).
     * @type {string}
     * @memberof CoordinateReferenceSystem
     */
    'type': string;
    /**
     * 
     * @type {CoordinateReferenceSystemProperties}
     * @memberof CoordinateReferenceSystem
     */
    'properties': CoordinateReferenceSystemProperties;
}
/**
 * Properties of this  Coordinate Reference System based on ESRI Geojson Format (RFC7159).
 * @export
 * @interface CoordinateReferenceSystemProperties
 */
export interface CoordinateReferenceSystemProperties {
    /**
     * Name of this Coordinate Reference System based on ESRI Geojson Format (RFC7159).
     * @type {string}
     * @memberof CoordinateReferenceSystemProperties
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface CreateCampaignRequest
 */
export interface CreateCampaignRequest {
    /**
     * ID of selected campaign type represented in UUID type 4
     * @type {string}
     * @memberof CreateCampaignRequest
     */
    'campaignTypeId': string;
    /**
     * Name of campaign
     * @type {string}
     * @memberof CreateCampaignRequest
     */
    'name': string;
    /**
     * Start datetime of campaign (in epoch)
     * @type {number}
     * @memberof CreateCampaignRequest
     */
    'startAt': number;
    /**
     * End datetime of campaign (in epoch)
     * @type {number}
     * @memberof CreateCampaignRequest
     */
    'endAt': number;
    /**
     * Default reward poin value
     * @type {number}
     * @memberof CreateCampaignRequest
     */
    'defaultRewardValue': number;
    /**
     * List of campaign default target value
     * @type {Array<CreateEditCampaignRequestTargetItem>}
     * @memberof CreateCampaignRequest
     */
    'defaultTargetValue': Array<CreateEditCampaignRequestTargetItem>;
    /**
     * List of members that are enlisted for this campaign
     * @type {Array<CreateEditCampaignRequestMemberItem>}
     * @memberof CreateCampaignRequest
     */
    'member': Array<CreateEditCampaignRequestMemberItem>;
    /**
     * ID of the Partner (Mill) that this campaign will belongs to. If no partnerId is present, then this endpoint should use the one on user\'s JWT
     * @type {string}
     * @memberof CreateCampaignRequest
     */
    'partnerId'?: string;
}
/**
 * 
 * @export
 * @interface CreateEditCampaignRequestMemberItem
 */
export interface CreateEditCampaignRequestMemberItem {
    /**
     * User ID of the member
     * @type {string}
     * @memberof CreateEditCampaignRequestMemberItem
     */
    'userId': string;
    /**
     * Campaign poin reward for specific user
     * @type {number}
     * @memberof CreateEditCampaignRequestMemberItem
     */
    'rewardValue': number;
    /**
     * List of campaign default target value
     * @type {Array<CreateEditCampaignRequestTargetItem>}
     * @memberof CreateEditCampaignRequestMemberItem
     */
    'targetValue': Array<CreateEditCampaignRequestTargetItem>;
}
/**
 * 
 * @export
 * @interface CreateEditCampaignRequestParticipantItem
 */
export interface CreateEditCampaignRequestParticipantItem {
    /**
     * Id of participant (member/supplier)
     * @type {string}
     * @memberof CreateEditCampaignRequestParticipantItem
     */
    'id': string;
    /**
     * Campaign poin reward for specific user
     * @type {number}
     * @memberof CreateEditCampaignRequestParticipantItem
     */
    'rewardValue': number;
    /**
     * List of campaign default target value
     * @type {Array<CreateEditCampaignRequestTargetItem>}
     * @memberof CreateEditCampaignRequestParticipantItem
     */
    'targetValue': Array<CreateEditCampaignRequestTargetItem>;
}
/**
 * 
 * @export
 * @interface CreateEditCampaignRequestTargetItem
 */
export interface CreateEditCampaignRequestTargetItem {
    /**
     * ID of Default Target from Get Campaign Types endpoint.  In add participant this Campaign Target ID. 
     * @type {string}
     * @memberof CreateEditCampaignRequestTargetItem
     */
    'id': string;
    /**
     * Target unit
     * @type {string}
     * @memberof CreateEditCampaignRequestTargetItem
     */
    'unit': string;
    /**
     * Target value
     * @type {number}
     * @memberof CreateEditCampaignRequestTargetItem
     */
    'value': number;
}
/**
 * 
 * @export
 * @interface CreateEditCampaignResponse
 */
export interface CreateEditCampaignResponse {
    /**
     * ID of the newly created campaign represented in UUID type 4
     * @type {string}
     * @memberof CreateEditCampaignResponse
     */
    'id': string;
    /**
     * Name of the newly created campaign
     * @type {string}
     * @memberof CreateEditCampaignResponse
     */
    'name': string;
}
/**
 * IDR = Indonesian Rupiah (Rp) GOLD = Gold SAWITPOIN = SawitPoin 
 * @export
 * @enum {string}
 */

export const CurrencyCodeEnum = {
    Gold: 'GOLD',
    Idr: 'IDR',
    Sawitpoin: 'SAWITPOIN'
} as const;

export type CurrencyCodeEnum = typeof CurrencyCodeEnum[keyof typeof CurrencyCodeEnum];


/**
 * Booking date in UUID type used to group time slot in one day
 * @export
 * @interface DateItem
 */
export interface DateItem {
    /**
     * ID of the created booking date in UUID type used to group time slot in one day
     * @type {string}
     * @memberof DateItem
     */
    'dateId'?: string;
    /**
     * Date description that used to show the date in front end side
     * @type {string}
     * @memberof DateItem
     */
    'date'?: string;
    /**
     * List of time with its status
     * @type {Array<TimeSlotItem>}
     * @memberof DateItem
     */
    'timeSlots'?: Array<TimeSlotItem>;
}
/**
 * 
 * @export
 * @interface DefaultErrorResponse
 */
export interface DefaultErrorResponse {
    /**
     * 
     * @type {string}
     * @memberof DefaultErrorResponse
     */
    'error': string;
}
/**
 * 
 * @export
 * @interface DefaultSuccessResponse
 */
export interface DefaultSuccessResponse {
    /**
     * whether success or not
     * @type {boolean}
     * @memberof DefaultSuccessResponse
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const DeliveryEnum = {
    Pickup: 'PICKUP',
    Delivery: 'DELIVERY'
} as const;

export type DeliveryEnum = typeof DeliveryEnum[keyof typeof DeliveryEnum];


/**
 * Order Delivery method enum
 * @export
 * @enum {string}
 */

export const DeliveryMethodEnum = {
    Delivery: 'DELIVERY',
    Pickup: 'PICKUP'
} as const;

export type DeliveryMethodEnum = typeof DeliveryMethodEnum[keyof typeof DeliveryMethodEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const DeliveryTypeEnum = {
    Pickup: 'PICKUP',
    Delivery: 'DELIVERY'
} as const;

export type DeliveryTypeEnum = typeof DeliveryTypeEnum[keyof typeof DeliveryTypeEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const DepartmentPointDisbursementRequestEnum = {
    Engineering: 'Engineering',
    Product: 'Product',
    Operations: 'Operations',
    Hr: 'HR',
    Finance: 'Finance',
    Experience: 'Experience'
} as const;

export type DepartmentPointDisbursementRequestEnum = typeof DepartmentPointDisbursementRequestEnum[keyof typeof DepartmentPointDisbursementRequestEnum];


/**
 * diff price with previous data in status enum
 * @export
 * @enum {string}
 */

export const DiffPriceStatusEnum = {
    Increase: 'INCREASE',
    Decrease: 'DECREASE',
    Equal: 'EQUAL'
} as const;

export type DiffPriceStatusEnum = typeof DiffPriceStatusEnum[keyof typeof DiffPriceStatusEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const DisbursementRecipientSelectionTypeEnum = {
    All: 'ALL',
    Include: 'INCLUDE',
    Exclude: 'EXCLUDE'
} as const;

export type DisbursementRecipientSelectionTypeEnum = typeof DisbursementRecipientSelectionTypeEnum[keyof typeof DisbursementRecipientSelectionTypeEnum];


/**
 * 
 * @export
 * @interface DokuPaymentInformation
 */
export interface DokuPaymentInformation {
    /**
     * Doku Original Request Id
     * @type {string}
     * @memberof DokuPaymentInformation
     */
    'originalRequestId': string;
    /**
     * Doku Transaction Date
     * @type {string}
     * @memberof DokuPaymentInformation
     */
    'transactionDate': string;
    /**
     * Doku Transaction Status
     * @type {string}
     * @memberof DokuPaymentInformation
     */
    'transactionStatus': string;
    /**
     * Doku Invoice Number
     * @type {string}
     * @memberof DokuPaymentInformation
     */
    'invoiceNumber': string;
    /**
     * Doku Virtual Account Number
     * @type {string}
     * @memberof DokuPaymentInformation
     */
    'virtualAccountNumber': string;
    /**
     * Doku Transaction Amount
     * @type {number}
     * @memberof DokuPaymentInformation
     */
    'amount': number;
}
/**
 * list of vendor data
 * @export
 * @interface EcommerceCouponGetVendorListResponse
 */
export interface EcommerceCouponGetVendorListResponse {
    /**
     * 
     * @type {Array<EcommerceCouponGetVendorListResponseItem>}
     * @memberof EcommerceCouponGetVendorListResponse
     */
    'items': Array<EcommerceCouponGetVendorListResponseItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof EcommerceCouponGetVendorListResponse
     */
    'pagination'?: PaginationResponse;
}
/**
 * 
 * @export
 * @interface EcommerceCouponGetVendorListResponseItem
 */
export interface EcommerceCouponGetVendorListResponseItem {
    /**
     * 
     * @type {string}
     * @memberof EcommerceCouponGetVendorListResponseItem
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof EcommerceCouponGetVendorListResponseItem
     */
    'name': string;
    /**
     * Stock Location Address
     * @type {string}
     * @memberof EcommerceCouponGetVendorListResponseItem
     */
    'address': string;
    /**
     * Stock Location Latitude
     * @type {number}
     * @memberof EcommerceCouponGetVendorListResponseItem
     */
    'latitude': number;
    /**
     * Stock Location Longitude
     * @type {number}
     * @memberof EcommerceCouponGetVendorListResponseItem
     */
    'longitude': number;
}
/**
 * 
 * @export
 * @interface EcommerceCouponsRedeemRequest
 */
export interface EcommerceCouponsRedeemRequest {
    /**
     * Coupon Usage Code
     * @type {string}
     * @memberof EcommerceCouponsRedeemRequest
     */
    'couponCode': string;
    /**
     * Vendor UUID
     * @type {string}
     * @memberof EcommerceCouponsRedeemRequest
     */
    'vendorId': string;
}
/**
 * 
 * @export
 * @interface EcommerceCouponsRedeemResponse
 */
export interface EcommerceCouponsRedeemResponse {
    /**
     * Coupon Usage UUID
     * @type {string}
     * @memberof EcommerceCouponsRedeemResponse
     */
    'id': string;
}
/**
 * Addition Information of Customer
 * @export
 * @interface EcommerceCustomerAdditionalParameterItem
 */
export interface EcommerceCustomerAdditionalParameterItem {
    /**
     * Account Number of Customer
     * @type {string}
     * @memberof EcommerceCustomerAdditionalParameterItem
     */
    'accountNumber'?: string;
    /**
     * Meter Number of Customer
     * @type {string}
     * @memberof EcommerceCustomerAdditionalParameterItem
     */
    'meterNumber'?: string;
    /**
     * Power Capacity of Customer/ this is for pln
     * @type {string}
     * @memberof EcommerceCustomerAdditionalParameterItem
     */
    'powerCapacity'?: string;
    /**
     * Name of Customer
     * @type {string}
     * @memberof EcommerceCustomerAdditionalParameterItem
     */
    'name'?: string;
    /**
     * kWh of Customer
     * @type {string}
     * @memberof EcommerceCustomerAdditionalParameterItem
     */
    'kwh'?: string;
    /**
     * Reference Number of Customer
     * @type {string}
     * @memberof EcommerceCustomerAdditionalParameterItem
     */
    'referenceNumber'?: string;
}
/**
 * Coupon information
 * @export
 * @interface EcommerceCustomerCouponInformationItem
 */
export interface EcommerceCustomerCouponInformationItem {
    /**
     * Coupon Usage Id
     * @type {string}
     * @memberof EcommerceCustomerCouponInformationItem
     */
    'couponUsageId'?: string;
    /**
     * Coupon Code
     * @type {string}
     * @memberof EcommerceCustomerCouponInformationItem
     */
    'couponCode'?: string;
}
/**
 * List of pick-up locations
 * @export
 * @interface EcommerceDeliveryGetPickUpLocationsResponse
 */
export interface EcommerceDeliveryGetPickUpLocationsResponse {
    /**
     * List of Pick-Up Locations
     * @type {Array<EcommerceDeliveryGetPickUpLocationsResponseItem>}
     * @memberof EcommerceDeliveryGetPickUpLocationsResponse
     */
    'items': Array<EcommerceDeliveryGetPickUpLocationsResponseItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof EcommerceDeliveryGetPickUpLocationsResponse
     */
    'pagination': PaginationResponse;
}
/**
 * pick-up location data
 * @export
 * @interface EcommerceDeliveryGetPickUpLocationsResponseItem
 */
export interface EcommerceDeliveryGetPickUpLocationsResponseItem {
    /**
     * 
     * @type {string}
     * @memberof EcommerceDeliveryGetPickUpLocationsResponseItem
     */
    'locationId': string;
    /**
     * 
     * @type {string}
     * @memberof EcommerceDeliveryGetPickUpLocationsResponseItem
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof EcommerceDeliveryGetPickUpLocationsResponseItem
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof EcommerceDeliveryGetPickUpLocationsResponseItem
     */
    'province': string;
    /**
     * 
     * @type {string}
     * @memberof EcommerceDeliveryGetPickUpLocationsResponseItem
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof EcommerceDeliveryGetPickUpLocationsResponseItem
     */
    'district': string;
    /**
     * 
     * @type {number}
     * @memberof EcommerceDeliveryGetPickUpLocationsResponseItem
     */
    'distance'?: number;
}
/**
 * 
 * @export
 * @interface EcommerceGetCouponsVerifyResponse
 */
export interface EcommerceGetCouponsVerifyResponse {
    /**
     * coupon usage id
     * @type {string}
     * @memberof EcommerceGetCouponsVerifyResponse
     */
    'id': string;
    /**
     * coupon code
     * @type {string}
     * @memberof EcommerceGetCouponsVerifyResponse
     */
    'code': string;
    /**
     * this is for nominal
     * @type {number}
     * @memberof EcommerceGetCouponsVerifyResponse
     */
    'nominal': number;
    /**
     * coupon name, or product name
     * @type {string}
     * @memberof EcommerceGetCouponsVerifyResponse
     */
    'productName': string;
    /**
     * product description
     * @type {string}
     * @memberof EcommerceGetCouponsVerifyResponse
     */
    'productDescription': string;
    /**
     * product image
     * @type {string}
     * @memberof EcommerceGetCouponsVerifyResponse
     */
    'productImage': string;
    /**
     * this is for for enabling vendor name
     * @type {string}
     * @memberof EcommerceGetCouponsVerifyResponse
     */
    'vendorName': string;
}
/**
 * Response data
 * @export
 * @interface EcommerceGetGoodsProductListResponse
 */
export interface EcommerceGetGoodsProductListResponse {
    /**
     * Is store pick
     * @type {boolean}
     * @memberof EcommerceGetGoodsProductListResponse
     */
    'isStorePick': boolean;
    /**
     * List of Product item
     * @type {Array<EcommerceGetGoodsProductListResponseItem>}
     * @memberof EcommerceGetGoodsProductListResponse
     */
    'items': Array<EcommerceGetGoodsProductListResponseItem>;
}
/**
 * 
 * @export
 * @interface EcommerceGetGoodsProductListResponseItem
 */
export interface EcommerceGetGoodsProductListResponseItem {
    /**
     * 
     * @type {string}
     * @memberof EcommerceGetGoodsProductListResponseItem
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof EcommerceGetGoodsProductListResponseItem
     */
    'sku': string;
    /**
     * 
     * @type {string}
     * @memberof EcommerceGetGoodsProductListResponseItem
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof EcommerceGetGoodsProductListResponseItem
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof EcommerceGetGoodsProductListResponseItem
     */
    'photoUrl': string;
    /**
     * 
     * @type {string}
     * @memberof EcommerceGetGoodsProductListResponseItem
     */
    'unitOfMeasurement': string;
    /**
     * List of Product price list item
     * @type {Array<EcommerceGetGoodsProductListResponsePriceListItem>}
     * @memberof EcommerceGetGoodsProductListResponseItem
     */
    'priceListItems': Array<EcommerceGetGoodsProductListResponsePriceListItem>;
}
/**
 * 
 * @export
 * @interface EcommerceGetGoodsProductListResponsePriceListItem
 */
export interface EcommerceGetGoodsProductListResponsePriceListItem {
    /**
     * 
     * @type {string}
     * @memberof EcommerceGetGoodsProductListResponsePriceListItem
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof EcommerceGetGoodsProductListResponsePriceListItem
     */
    'price': number;
    /**
     * 
     * @type {number}
     * @memberof EcommerceGetGoodsProductListResponsePriceListItem
     */
    'slashedPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof EcommerceGetGoodsProductListResponsePriceListItem
     */
    'priceAfterPoints': number;
    /**
     * 
     * @type {number}
     * @memberof EcommerceGetGoodsProductListResponsePriceListItem
     */
    'priceReductionPercentage': number;
    /**
     * 
     * @type {number}
     * @memberof EcommerceGetGoodsProductListResponsePriceListItem
     */
    'stock': number;
    /**
     * 
     * @type {number}
     * @memberof EcommerceGetGoodsProductListResponsePriceListItem
     */
    'stockMinimum': number;
    /**
     * 
     * @type {number}
     * @memberof EcommerceGetGoodsProductListResponsePriceListItem
     */
    'maxPointUsage': number;
    /**
     * 
     * @type {boolean}
     * @memberof EcommerceGetGoodsProductListResponsePriceListItem
     */
    'isCancellable': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EcommerceGetGoodsProductListResponsePriceListItem
     */
    'isPickupAllowed': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EcommerceGetGoodsProductListResponsePriceListItem
     */
    'isInquiryAllowed': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EcommerceGetGoodsProductListResponsePriceListItem
     */
    'isPointAllowed': boolean;
    /**
     * minimum order quantity
     * @type {number}
     * @memberof EcommerceGetGoodsProductListResponsePriceListItem
     */
    'minimumOrderQty': number;
    /**
     * 
     * @type {number}
     * @memberof EcommerceGetGoodsProductListResponsePriceListItem
     */
    'preparationDuration': number;
    /**
     * 
     * @type {StoresListResponseItem}
     * @memberof EcommerceGetGoodsProductListResponsePriceListItem
     */
    'store': StoresListResponseItem;
}
/**
 * Response data
 * @export
 * @interface EcommerceGetGoodsProductListV2Response
 */
export interface EcommerceGetGoodsProductListV2Response {
    /**
     * List of Product item
     * @type {Array<EcommerceGetGoodsProductListV2ResponseItem>}
     * @memberof EcommerceGetGoodsProductListV2Response
     */
    'items': Array<EcommerceGetGoodsProductListV2ResponseItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof EcommerceGetGoodsProductListV2Response
     */
    'pagination': PaginationResponse;
}
/**
 * 
 * @export
 * @interface EcommerceGetGoodsProductListV2ResponseItem
 */
export interface EcommerceGetGoodsProductListV2ResponseItem {
    /**
     * 
     * @type {string}
     * @memberof EcommerceGetGoodsProductListV2ResponseItem
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof EcommerceGetGoodsProductListV2ResponseItem
     */
    'sku': string;
    /**
     * 
     * @type {string}
     * @memberof EcommerceGetGoodsProductListV2ResponseItem
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof EcommerceGetGoodsProductListV2ResponseItem
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof EcommerceGetGoodsProductListV2ResponseItem
     */
    'photoUrl': string;
    /**
     * 
     * @type {string}
     * @memberof EcommerceGetGoodsProductListV2ResponseItem
     */
    'unitOfMeasurement': string;
    /**
     * 
     * @type {EcommerceGetGoodsProductListV2ResponsePriceListItem}
     * @memberof EcommerceGetGoodsProductListV2ResponseItem
     */
    'priceList': EcommerceGetGoodsProductListV2ResponsePriceListItem;
}
/**
 * 
 * @export
 * @interface EcommerceGetGoodsProductListV2ResponsePriceListItem
 */
export interface EcommerceGetGoodsProductListV2ResponsePriceListItem {
    /**
     * 
     * @type {string}
     * @memberof EcommerceGetGoodsProductListV2ResponsePriceListItem
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof EcommerceGetGoodsProductListV2ResponsePriceListItem
     */
    'price': number;
    /**
     * 
     * @type {number}
     * @memberof EcommerceGetGoodsProductListV2ResponsePriceListItem
     */
    'priceAfterPoints': number;
    /**
     * 
     * @type {number}
     * @memberof EcommerceGetGoodsProductListV2ResponsePriceListItem
     */
    'priceReductionPercentage': number;
    /**
     * 
     * @type {number}
     * @memberof EcommerceGetGoodsProductListV2ResponsePriceListItem
     */
    'stock': number;
    /**
     * 
     * @type {number}
     * @memberof EcommerceGetGoodsProductListV2ResponsePriceListItem
     */
    'stockMinimum': number;
    /**
     * 
     * @type {number}
     * @memberof EcommerceGetGoodsProductListV2ResponsePriceListItem
     */
    'maxPointUsage': number;
    /**
     * 
     * @type {boolean}
     * @memberof EcommerceGetGoodsProductListV2ResponsePriceListItem
     */
    'isCancellable': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EcommerceGetGoodsProductListV2ResponsePriceListItem
     */
    'isPickupAllowed': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EcommerceGetGoodsProductListV2ResponsePriceListItem
     */
    'isInquiryAllowed': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EcommerceGetGoodsProductListV2ResponsePriceListItem
     */
    'isPointAllowed': boolean;
    /**
     * minimum order quantity
     * @type {number}
     * @memberof EcommerceGetGoodsProductListV2ResponsePriceListItem
     */
    'minimumOrderQty': number;
    /**
     * 
     * @type {number}
     * @memberof EcommerceGetGoodsProductListV2ResponsePriceListItem
     */
    'preparationDuration': number;
    /**
     * 
     * @type {StoresListV2ResponseItem}
     * @memberof EcommerceGetGoodsProductListV2ResponsePriceListItem
     */
    'store': StoresListV2ResponseItem;
}
/**
 * Response data
 * @export
 * @interface EcommerceGetGoodsProductListV3Response
 */
export interface EcommerceGetGoodsProductListV3Response {
    /**
     * List of Product item
     * @type {Array<EcommerceGetGoodsProductListV3ResponseItem>}
     * @memberof EcommerceGetGoodsProductListV3Response
     */
    'items': Array<EcommerceGetGoodsProductListV3ResponseItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof EcommerceGetGoodsProductListV3Response
     */
    'pagination': PaginationResponse;
}
/**
 * 
 * @export
 * @interface EcommerceGetGoodsProductListV3ResponseItem
 */
export interface EcommerceGetGoodsProductListV3ResponseItem {
    /**
     * 
     * @type {string}
     * @memberof EcommerceGetGoodsProductListV3ResponseItem
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof EcommerceGetGoodsProductListV3ResponseItem
     */
    'sku': string;
    /**
     * 
     * @type {string}
     * @memberof EcommerceGetGoodsProductListV3ResponseItem
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof EcommerceGetGoodsProductListV3ResponseItem
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof EcommerceGetGoodsProductListV3ResponseItem
     */
    'photoUrl': string;
    /**
     * 
     * @type {string}
     * @memberof EcommerceGetGoodsProductListV3ResponseItem
     */
    'unitOfMeasurement': string;
    /**
     * 
     * @type {number}
     * @memberof EcommerceGetGoodsProductListV3ResponseItem
     */
    'weight': number;
    /**
     * 
     * @type {number}
     * @memberof EcommerceGetGoodsProductListV3ResponseItem
     */
    'stock': number;
    /**
     * 
     * @type {number}
     * @memberof EcommerceGetGoodsProductListV3ResponseItem
     */
    'stockMinimum': number;
    /**
     * 
     * @type {boolean}
     * @memberof EcommerceGetGoodsProductListV3ResponseItem
     */
    'isCancellable': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EcommerceGetGoodsProductListV3ResponseItem
     */
    'isPickupAllowed': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EcommerceGetGoodsProductListV3ResponseItem
     */
    'isInquiryAllowed': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EcommerceGetGoodsProductListV3ResponseItem
     */
    'isPointAllowed': boolean;
    /**
     * 
     * @type {number}
     * @memberof EcommerceGetGoodsProductListV3ResponseItem
     */
    'preparationDuration': number;
    /**
     * 
     * @type {StoresListV3ResponseItem}
     * @memberof EcommerceGetGoodsProductListV3ResponseItem
     */
    'store': StoresListV3ResponseItem;
    /**
     * 
     * @type {Array<EcommerceGetGoodsProductListV3ResponsePriceListItem>}
     * @memberof EcommerceGetGoodsProductListV3ResponseItem
     */
    'priceList': Array<EcommerceGetGoodsProductListV3ResponsePriceListItem>;
    /**
     * 
     * @type {DeliveryEnum}
     * @memberof EcommerceGetGoodsProductListV3ResponseItem
     */
    'deliveryType': DeliveryEnum;
    /**
     * 
     * @type {Array<DeliveryEnum>}
     * @memberof EcommerceGetGoodsProductListV3ResponseItem
     */
    'deliveryTypes': Array<DeliveryEnum>;
    /**
     * 
     * @type {Array<EcommerceGetGoodsProductTag>}
     * @memberof EcommerceGetGoodsProductListV3ResponseItem
     */
    'imageTags': Array<EcommerceGetGoodsProductTag>;
    /**
     * 
     * @type {Array<EcommerceGetGoodsProductTag>}
     * @memberof EcommerceGetGoodsProductListV3ResponseItem
     */
    'productTags': Array<EcommerceGetGoodsProductTag>;
    /**
     * 
     * @type {number}
     * @memberof EcommerceGetGoodsProductListV3ResponseItem
     */
    'numberOfProductSold': number;
}


/**
 * 
 * @export
 * @interface EcommerceGetGoodsProductListV3ResponsePriceListItem
 */
export interface EcommerceGetGoodsProductListV3ResponsePriceListItem {
    /**
     * 
     * @type {string}
     * @memberof EcommerceGetGoodsProductListV3ResponsePriceListItem
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof EcommerceGetGoodsProductListV3ResponsePriceListItem
     */
    'price': number;
    /**
     * 
     * @type {number}
     * @memberof EcommerceGetGoodsProductListV3ResponsePriceListItem
     */
    'slashedPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof EcommerceGetGoodsProductListV3ResponsePriceListItem
     */
    'priceAfterPoints': number;
    /**
     * 
     * @type {number}
     * @memberof EcommerceGetGoodsProductListV3ResponsePriceListItem
     */
    'priceReductionPercentage': number;
    /**
     * 
     * @type {number}
     * @memberof EcommerceGetGoodsProductListV3ResponsePriceListItem
     */
    'maxPointUsage': number;
    /**
     * minimum order quantity
     * @type {number}
     * @memberof EcommerceGetGoodsProductListV3ResponsePriceListItem
     */
    'minimumOrderQty': number;
}
/**
 * Response data
 * @export
 * @interface EcommerceGetGoodsProductListV4Response
 */
export interface EcommerceGetGoodsProductListV4Response {
    /**
     * List of product catalog item
     * @type {Array<EcommerceGetGoodsProductListV4ResponseItem>}
     * @memberof EcommerceGetGoodsProductListV4Response
     */
    'items': Array<EcommerceGetGoodsProductListV4ResponseItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof EcommerceGetGoodsProductListV4Response
     */
    'pagination': PaginationResponse;
}
/**
 * 
 * @export
 * @interface EcommerceGetGoodsProductListV4ResponseItem
 */
export interface EcommerceGetGoodsProductListV4ResponseItem {
    /**
     * 
     * @type {string}
     * @memberof EcommerceGetGoodsProductListV4ResponseItem
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof EcommerceGetGoodsProductListV4ResponseItem
     */
    'sku': string;
    /**
     * 
     * @type {string}
     * @memberof EcommerceGetGoodsProductListV4ResponseItem
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof EcommerceGetGoodsProductListV4ResponseItem
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof EcommerceGetGoodsProductListV4ResponseItem
     */
    'photoUrl': string;
    /**
     * 
     * @type {string}
     * @memberof EcommerceGetGoodsProductListV4ResponseItem
     */
    'unitOfMeasurement': string;
    /**
     * 
     * @type {number}
     * @memberof EcommerceGetGoodsProductListV4ResponseItem
     */
    'weight': number;
    /**
     * 
     * @type {number}
     * @memberof EcommerceGetGoodsProductListV4ResponseItem
     */
    'stock': number;
    /**
     * 
     * @type {number}
     * @memberof EcommerceGetGoodsProductListV4ResponseItem
     */
    'stockMinimum': number;
    /**
     * 
     * @type {boolean}
     * @memberof EcommerceGetGoodsProductListV4ResponseItem
     */
    'isCancellable': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EcommerceGetGoodsProductListV4ResponseItem
     */
    'isPickupAllowed': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EcommerceGetGoodsProductListV4ResponseItem
     */
    'isInquiryAllowed': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EcommerceGetGoodsProductListV4ResponseItem
     */
    'isPointAllowed': boolean;
    /**
     * 
     * @type {number}
     * @memberof EcommerceGetGoodsProductListV4ResponseItem
     */
    'preparationDuration': number;
    /**
     * 
     * @type {EcommerceGetGoodsProductListV4ResponseZone}
     * @memberof EcommerceGetGoodsProductListV4ResponseItem
     */
    'zone': EcommerceGetGoodsProductListV4ResponseZone;
    /**
     * 
     * @type {Array<EcommerceGetGoodsProductListV4ResponsePriceListItem>}
     * @memberof EcommerceGetGoodsProductListV4ResponseItem
     */
    'priceList': Array<EcommerceGetGoodsProductListV4ResponsePriceListItem>;
    /**
     * 
     * @type {Array<DeliveryEnum>}
     * @memberof EcommerceGetGoodsProductListV4ResponseItem
     */
    'deliveryTypes': Array<DeliveryEnum>;
    /**
     * 
     * @type {Array<EcommerceGetGoodsProductTag>}
     * @memberof EcommerceGetGoodsProductListV4ResponseItem
     */
    'imageTags': Array<EcommerceGetGoodsProductTag>;
    /**
     * 
     * @type {Array<EcommerceGetGoodsProductTag>}
     * @memberof EcommerceGetGoodsProductListV4ResponseItem
     */
    'productTags': Array<EcommerceGetGoodsProductTag>;
    /**
     * 
     * @type {number}
     * @memberof EcommerceGetGoodsProductListV4ResponseItem
     */
    'numberOfProductSold': number;
}
/**
 * 
 * @export
 * @interface EcommerceGetGoodsProductListV4ResponsePriceListItem
 */
export interface EcommerceGetGoodsProductListV4ResponsePriceListItem {
    /**
     * 
     * @type {string}
     * @memberof EcommerceGetGoodsProductListV4ResponsePriceListItem
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof EcommerceGetGoodsProductListV4ResponsePriceListItem
     */
    'price': number;
    /**
     * 
     * @type {number}
     * @memberof EcommerceGetGoodsProductListV4ResponsePriceListItem
     */
    'slashedPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof EcommerceGetGoodsProductListV4ResponsePriceListItem
     */
    'priceAfterPoints': number;
    /**
     * 
     * @type {number}
     * @memberof EcommerceGetGoodsProductListV4ResponsePriceListItem
     */
    'priceReductionPercentage': number;
    /**
     * 
     * @type {number}
     * @memberof EcommerceGetGoodsProductListV4ResponsePriceListItem
     */
    'maxPointUsage': number;
    /**
     * minimum order quantity
     * @type {number}
     * @memberof EcommerceGetGoodsProductListV4ResponsePriceListItem
     */
    'minimumOrderQty': number;
}
/**
 * 
 * @export
 * @interface EcommerceGetGoodsProductListV4ResponseZone
 */
export interface EcommerceGetGoodsProductListV4ResponseZone {
    /**
     * Store UUID
     * @type {string}
     * @memberof EcommerceGetGoodsProductListV4ResponseZone
     */
    'id': string;
    /**
     * Store Name
     * @type {string}
     * @memberof EcommerceGetGoodsProductListV4ResponseZone
     */
    'name': string;
    /**
     * Store Address
     * @type {string}
     * @memberof EcommerceGetGoodsProductListV4ResponseZone
     */
    'address': string;
    /**
     * Store Province
     * @type {string}
     * @memberof EcommerceGetGoodsProductListV4ResponseZone
     */
    'province': string;
    /**
     * Store City
     * @type {string}
     * @memberof EcommerceGetGoodsProductListV4ResponseZone
     */
    'city': string;
    /**
     * Store District
     * @type {string}
     * @memberof EcommerceGetGoodsProductListV4ResponseZone
     */
    'district': string;
    /**
     * Id of area in UUID format
     * @type {string}
     * @memberof EcommerceGetGoodsProductListV4ResponseZone
     */
    'areaId': string;
}
/**
 * 
 * @export
 * @interface EcommerceGetGoodsProductTag
 */
export interface EcommerceGetGoodsProductTag {
    /**
     * 
     * @type {string}
     * @memberof EcommerceGetGoodsProductTag
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof EcommerceGetGoodsProductTag
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof EcommerceGetGoodsProductTag
     */
    'link': string;
    /**
     * 
     * @type {string}
     * @memberof EcommerceGetGoodsProductTag
     */
    'link_type': string;
}
/**
 * 
 * @export
 * @interface EcommerceGetMyCouponDetailResponse
 */
export interface EcommerceGetMyCouponDetailResponse {
    /**
     * 
     * @type {string}
     * @memberof EcommerceGetMyCouponDetailResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof EcommerceGetMyCouponDetailResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof EcommerceGetMyCouponDetailResponse
     */
    'qrcode': string;
}
/**
 * list of user coupon
 * @export
 * @interface EcommerceGetMyCouponResponse
 */
export interface EcommerceGetMyCouponResponse {
    /**
     * 
     * @type {Array<EcommerceGetMyCouponResponseItem>}
     * @memberof EcommerceGetMyCouponResponse
     */
    'items': Array<EcommerceGetMyCouponResponseItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof EcommerceGetMyCouponResponse
     */
    'pagination'?: PaginationResponse;
}
/**
 * 
 * @export
 * @interface EcommerceGetMyCouponResponseItem
 */
export interface EcommerceGetMyCouponResponseItem {
    /**
     * 
     * @type {string}
     * @memberof EcommerceGetMyCouponResponseItem
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof EcommerceGetMyCouponResponseItem
     */
    'name': string;
    /**
     * product description
     * @type {string}
     * @memberof EcommerceGetMyCouponResponseItem
     */
    'description': string;
    /**
     * image of url coupon
     * @type {string}
     * @memberof EcommerceGetMyCouponResponseItem
     */
    'imageUrl': string;
    /**
     * 
     * @type {string}
     * @memberof EcommerceGetMyCouponResponseItem
     */
    'couponUsageId': string;
    /**
     * 
     * @type {string}
     * @memberof EcommerceGetMyCouponResponseItem
     */
    'couponCode': string;
}
/**
 * 
 * @export
 * @interface EcommerceGetProductAdditionalFeeRequest
 */
export interface EcommerceGetProductAdditionalFeeRequest {
    /**
     * product id
     * @type {string}
     * @memberof EcommerceGetProductAdditionalFeeRequest
     */
    'productId': string;
    /**
     * quantity of product
     * @type {number}
     * @memberof EcommerceGetProductAdditionalFeeRequest
     */
    'quantity': number;
}
/**
 * 
 * @export
 * @interface EcommerceGetProductAdditionalFeeResponse
 */
export interface EcommerceGetProductAdditionalFeeResponse {
    /**
     * product id
     * @type {string}
     * @memberof EcommerceGetProductAdditionalFeeResponse
     */
    'productId': string;
    /**
     * quarantine fee of the product
     * @type {number}
     * @memberof EcommerceGetProductAdditionalFeeResponse
     */
    'quarantineFee'?: number;
    /**
     * certificate fee of the product
     * @type {number}
     * @memberof EcommerceGetProductAdditionalFeeResponse
     */
    'certificateFee'?: number;
    /**
     * stamp fee of the product
     * @type {number}
     * @memberof EcommerceGetProductAdditionalFeeResponse
     */
    'stampFee'?: number;
}
/**
 * 
 * @export
 * @interface EcommerceGetProductDetailResponse
 */
export interface EcommerceGetProductDetailResponse {
    /**
     * product id
     * @type {string}
     * @memberof EcommerceGetProductDetailResponse
     */
    'id': string;
    /**
     * product name
     * @type {string}
     * @memberof EcommerceGetProductDetailResponse
     */
    'name': string;
    /**
     * 
     * @type {EcommerceProductTypeEnum}
     * @memberof EcommerceGetProductDetailResponse
     */
    'type': EcommerceProductTypeEnum;
    /**
     * product category id
     * @type {string}
     * @memberof EcommerceGetProductDetailResponse
     */
    'categoryId': string;
    /**
     * category name
     * @type {string}
     * @memberof EcommerceGetProductDetailResponse
     */
    'categoryName': string;
    /**
     * product sku
     * @type {string}
     * @memberof EcommerceGetProductDetailResponse
     */
    'sku': string;
    /**
     * Enum product status | - ACTIVE - INACTIVE
     * @type {string}
     * @memberof EcommerceGetProductDetailResponse
     */
    'status': string;
    /**
     * product description
     * @type {string}
     * @memberof EcommerceGetProductDetailResponse
     */
    'description': string;
    /**
     * product description
     * @type {string}
     * @memberof EcommerceGetProductDetailResponse
     */
    'detailDescription': string;
    /**
     * 
     * @type {EcommerceProductUnitOfMeasurementEnum}
     * @memberof EcommerceGetProductDetailResponse
     */
    'unitOfMeasurement': EcommerceProductUnitOfMeasurementEnum;
    /**
     * unit of measurement product
     * @type {number}
     * @memberof EcommerceGetProductDetailResponse
     */
    'productWeight': number;
    /**
     * 
     * @type {EcommerceProductDimensionMeasurementEnum}
     * @memberof EcommerceGetProductDetailResponse
     */
    'dimensionMeasurement': EcommerceProductDimensionMeasurementEnum;
    /**
     * unit of measurement product
     * @type {number}
     * @memberof EcommerceGetProductDetailResponse
     */
    'dimensionLength': number;
    /**
     * dimension width of product
     * @type {number}
     * @memberof EcommerceGetProductDetailResponse
     */
    'dimensionWidth': number;
    /**
     * dimension height of product
     * @type {number}
     * @memberof EcommerceGetProductDetailResponse
     */
    'dimensionHeight': number;
    /**
     * image of url product
     * @type {string}
     * @memberof EcommerceGetProductDetailResponse
     */
    'imageURL': string;
    /**
     * List of Product price list item
     * @type {Array<EcommerceGetGoodsProductListResponsePriceListItem>}
     * @memberof EcommerceGetProductDetailResponse
     */
    'pricelistItems': Array<EcommerceGetGoodsProductListResponsePriceListItem>;
    /**
     * 
     * @type {Array<EcommerceGetGoodsProductTag>}
     * @memberof EcommerceGetProductDetailResponse
     */
    'imageTags': Array<EcommerceGetGoodsProductTag>;
    /**
     * 
     * @type {Array<EcommerceGetGoodsProductTag>}
     * @memberof EcommerceGetProductDetailResponse
     */
    'productTags': Array<EcommerceGetGoodsProductTag>;
    /**
     * 
     * @type {number}
     * @memberof EcommerceGetProductDetailResponse
     */
    'numberOfProductSold': number;
}


/**
 * 
 * @export
 * @interface EcommerceGetPromotionsListResponse
 */
export interface EcommerceGetPromotionsListResponse {
    /**
     * 
     * @type {Array<EcommerceGetPromotionsListResponseItem>}
     * @memberof EcommerceGetPromotionsListResponse
     */
    'items': Array<EcommerceGetPromotionsListResponseItem>;
}
/**
 * 
 * @export
 * @interface EcommerceGetPromotionsListResponseItem
 */
export interface EcommerceGetPromotionsListResponseItem {
    /**
     * id of promotions
     * @type {string}
     * @memberof EcommerceGetPromotionsListResponseItem
     */
    'id': string;
    /**
     * code of promotions
     * @type {string}
     * @memberof EcommerceGetPromotionsListResponseItem
     */
    'code': string;
    /**
     * title of promotions
     * @type {string}
     * @memberof EcommerceGetPromotionsListResponseItem
     */
    'title': string;
    /**
     * description of promotions
     * @type {string}
     * @memberof EcommerceGetPromotionsListResponseItem
     */
    'description': string;
    /**
     * image of promotions
     * @type {string}
     * @memberof EcommerceGetPromotionsListResponseItem
     */
    'image': string;
    /**
     * start date of promotions
     * @type {number}
     * @memberof EcommerceGetPromotionsListResponseItem
     */
    'startDateUtc0': number;
    /**
     * end date of promotions
     * @type {number}
     * @memberof EcommerceGetPromotionsListResponseItem
     */
    'endDateUtc0': number;
    /**
     * max point usage of promotions
     * @type {number}
     * @memberof EcommerceGetPromotionsListResponseItem
     */
    'maxPointUsage': number;
    /**
     * 
     * @type {Array<EcommerceGetPromotionsListResponseItemProducts>}
     * @memberof EcommerceGetPromotionsListResponseItem
     */
    'products': Array<EcommerceGetPromotionsListResponseItemProducts>;
}
/**
 * 
 * @export
 * @interface EcommerceGetPromotionsListResponseItemProducts
 */
export interface EcommerceGetPromotionsListResponseItemProducts {
    /**
     * product id
     * @type {string}
     * @memberof EcommerceGetPromotionsListResponseItemProducts
     */
    'id': string;
    /**
     * id of pricelist
     * @type {string}
     * @memberof EcommerceGetPromotionsListResponseItemProducts
     */
    'pricelistId': string;
    /**
     * name of product
     * @type {string}
     * @memberof EcommerceGetPromotionsListResponseItemProducts
     */
    'name': string;
    /**
     * price of product
     * @type {number}
     * @memberof EcommerceGetPromotionsListResponseItemProducts
     */
    'price': number;
    /**
     * quantity of product promo
     * @type {number}
     * @memberof EcommerceGetPromotionsListResponseItemProducts
     */
    'quantity': number;
    /**
     * type of product
     * @type {string}
     * @memberof EcommerceGetPromotionsListResponseItemProducts
     */
    'productType': string;
    /**
     * category code of product
     * @type {string}
     * @memberof EcommerceGetPromotionsListResponseItemProducts
     */
    'categoryCode': string;
    /**
     * category name of product
     * @type {string}
     * @memberof EcommerceGetPromotionsListResponseItemProducts
     */
    'categoryName': string;
    /**
     * image of product
     * @type {string}
     * @memberof EcommerceGetPromotionsListResponseItemProducts
     */
    'imageUrl': string;
    /**
     * id of promo item
     * @type {string}
     * @memberof EcommerceGetPromotionsListResponseItemProducts
     */
    'promoItemId': string;
}
/**
 * 
 * @export
 * @interface EcommerceProductCategoriesDigitalItem
 */
export interface EcommerceProductCategoriesDigitalItem {
    /**
     * name of category
     * @type {string}
     * @memberof EcommerceProductCategoriesDigitalItem
     */
    'name': string;
    /**
     * code of category
     * @type {string}
     * @memberof EcommerceProductCategoriesDigitalItem
     */
    'code': string;
    /**
     * parent code of category
     * @type {string}
     * @memberof EcommerceProductCategoriesDigitalItem
     */
    'parentCode': string;
    /**
     * parent name of category
     * @type {string}
     * @memberof EcommerceProductCategoriesDigitalItem
     */
    'parentName': string;
    /**
     * status of category
     * @type {string}
     * @memberof EcommerceProductCategoriesDigitalItem
     */
    'status': string;
    /**
     * 
     * @type {Array<EcommerceProductCategoriesDigitalProduct>}
     * @memberof EcommerceProductCategoriesDigitalItem
     */
    'products': Array<EcommerceProductCategoriesDigitalProduct>;
    /**
     * Product Image URL
     * @type {string}
     * @memberof EcommerceProductCategoriesDigitalItem
     */
    'imageUrl': string;
}
/**
 * 
 * @export
 * @interface EcommerceProductCategoriesDigitalProduct
 */
export interface EcommerceProductCategoriesDigitalProduct {
    /**
     * 
     * @type {string}
     * @memberof EcommerceProductCategoriesDigitalProduct
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof EcommerceProductCategoriesDigitalProduct
     */
    'sku': string;
    /**
     * 
     * @type {string}
     * @memberof EcommerceProductCategoriesDigitalProduct
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof EcommerceProductCategoriesDigitalProduct
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof EcommerceProductCategoriesDigitalProduct
     */
    'categoryName': string;
    /**
     * 
     * @type {string}
     * @memberof EcommerceProductCategoriesDigitalProduct
     */
    'categoryId': string;
    /**
     * 
     * @type {string}
     * @memberof EcommerceProductCategoriesDigitalProduct
     */
    'imageUrl': string;
    /**
     * 
     * @type {string}
     * @memberof EcommerceProductCategoriesDigitalProduct
     */
    'priceListId': string;
    /**
     * 
     * @type {number}
     * @memberof EcommerceProductCategoriesDigitalProduct
     */
    'maxPointUsage': number;
    /**
     * 
     * @type {number}
     * @memberof EcommerceProductCategoriesDigitalProduct
     */
    'price': number;
    /**
     * 
     * @type {number}
     * @memberof EcommerceProductCategoriesDigitalProduct
     */
    'priceAfterPoints': number;
    /**
     * 
     * @type {number}
     * @memberof EcommerceProductCategoriesDigitalProduct
     */
    'sort': number;
}
/**
 * 
 * @export
 * @interface EcommerceProductCategoriesDigitalResponse
 */
export interface EcommerceProductCategoriesDigitalResponse {
    /**
     * 
     * @type {Array<EcommerceProductCategoriesDigitalItem>}
     * @memberof EcommerceProductCategoriesDigitalResponse
     */
    'items': Array<EcommerceProductCategoriesDigitalItem>;
}
/**
 * Code of the product category | - telkomsel_airtime_prepaid - telkomsel_airtime_postpaid - telkomsel_airtime_package_data - seed - pupuk - pln_billpayment_prepaid - pln_billpayment_postpaid - non-fertilizer - gold - fertilizer - digital - coupon - billpayment_prepaid - billpayment_postpaid - airtime_prepaid - airtime_postpaid - airtime_package_data - agronomist - chemical 
 * @export
 * @enum {string}
 */

export const EcommerceProductCategoryCodeEnum = {
    TelkomselAirtimePrepaid: 'telkomsel_airtime_prepaid',
    TelkomselAirtimePostpaid: 'telkomsel_airtime_postpaid',
    TelkomselAirtimePackageData: 'telkomsel_airtime_package_data',
    Seed: 'seed',
    Pupuk: 'pupuk',
    PlnBillpaymentPrepaid: 'pln_billpayment_prepaid',
    PlnBillpaymentPostpaid: 'pln_billpayment_postpaid',
    NonFertilizer: 'non-fertilizer',
    Gold: 'gold',
    Fertilizer: 'fertilizer',
    Digital: 'digital',
    Coupon: 'coupon',
    BillpaymentPrepaid: 'billpayment_prepaid',
    BillpaymentPostpaid: 'billpayment_postpaid',
    AirtimePrepaid: 'airtime_prepaid',
    AirtimePostpaid: 'airtime_postpaid',
    AirtimePackageData: 'airtime_package_data',
    Agronomist: 'agronomist',
    Chemical: 'chemical'
} as const;

export type EcommerceProductCategoryCodeEnum = typeof EcommerceProductCategoryCodeEnum[keyof typeof EcommerceProductCategoryCodeEnum];


/**
 * 
 * @export
 * @interface EcommerceProductDigitalInquiryRequest
 */
export interface EcommerceProductDigitalInquiryRequest {
    /**
     * account number, its can be meter number etc
     * @type {string}
     * @memberof EcommerceProductDigitalInquiryRequest
     */
    'accountNumber': string;
    /**
     * product id
     * @type {string}
     * @memberof EcommerceProductDigitalInquiryRequest
     */
    'productId': string;
    /**
     * pricelist id
     * @type {string}
     * @memberof EcommerceProductDigitalInquiryRequest
     */
    'pricelistId'?: string;
}
/**
 * 
 * @export
 * @interface EcommerceProductDigitalInquiryResponse
 */
export interface EcommerceProductDigitalInquiryResponse {
    /**
     * inquiry id
     * @type {string}
     * @memberof EcommerceProductDigitalInquiryResponse
     */
    'id': string;
    /**
     * Account Number of Customer
     * @type {string}
     * @memberof EcommerceProductDigitalInquiryResponse
     */
    'accountNumber': string;
    /**
     * 
     * @type {EcommerceProductDigitalInquiryResponseAdditionalDataItem}
     * @memberof EcommerceProductDigitalInquiryResponse
     */
    'additionalData': EcommerceProductDigitalInquiryResponseAdditionalDataItem;
}
/**
 * 
 * @export
 * @interface EcommerceProductDigitalInquiryResponseAdditionalDataItem
 */
export interface EcommerceProductDigitalInquiryResponseAdditionalDataItem {
    /**
     * Name of Customer
     * @type {string}
     * @memberof EcommerceProductDigitalInquiryResponseAdditionalDataItem
     */
    'name'?: string;
    /**
     * Account Number of Customer
     * @type {string}
     * @memberof EcommerceProductDigitalInquiryResponseAdditionalDataItem
     */
    'accountNumber'?: string;
    /**
     * Meter Number of Customer
     * @type {string}
     * @memberof EcommerceProductDigitalInquiryResponseAdditionalDataItem
     */
    'meterNumber'?: string;
    /**
     * Power Capacity of Customer/ this is for pln
     * @type {string}
     * @memberof EcommerceProductDigitalInquiryResponseAdditionalDataItem
     */
    'powerCapacity'?: string;
    /**
     * kWh of Customer
     * @type {string}
     * @memberof EcommerceProductDigitalInquiryResponseAdditionalDataItem
     */
    'kwh'?: string;
    /**
     * Reference Number of Customer
     * @type {string}
     * @memberof EcommerceProductDigitalInquiryResponseAdditionalDataItem
     */
    'referenceNumber'?: string;
}
/**
 * dimension measurement
 * @export
 * @enum {string}
 */

export const EcommerceProductDimensionMeasurementEnum = {
    Mm: 'mm',
    Cm: 'cm',
    M: 'm'
} as const;

export type EcommerceProductDimensionMeasurementEnum = typeof EcommerceProductDimensionMeasurementEnum[keyof typeof EcommerceProductDimensionMeasurementEnum];


/**
 * 
 * @export
 * @interface EcommerceProductGoodsInquiryListResponse
 */
export interface EcommerceProductGoodsInquiryListResponse {
    /**
     * 
     * @type {Array<EcommerceProductGoodsInquiryListResponseItem>}
     * @memberof EcommerceProductGoodsInquiryListResponse
     */
    'items': Array<EcommerceProductGoodsInquiryListResponseItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof EcommerceProductGoodsInquiryListResponse
     */
    'pagination': PaginationResponse;
}
/**
 * 
 * @export
 * @interface EcommerceProductGoodsInquiryListResponseItem
 */
export interface EcommerceProductGoodsInquiryListResponseItem {
    /**
     * inquiry id
     * @type {string}
     * @memberof EcommerceProductGoodsInquiryListResponseItem
     */
    'id': string;
    /**
     * name of product
     * @type {string}
     * @memberof EcommerceProductGoodsInquiryListResponseItem
     */
    'name': string;
    /**
     * price of product
     * @type {number}
     * @memberof EcommerceProductGoodsInquiryListResponseItem
     */
    'price': number;
    /**
     * image of product
     * @type {string}
     * @memberof EcommerceProductGoodsInquiryListResponseItem
     */
    'imageUrl': string;
    /**
     * sla date of inquiry
     * @type {number}
     * @memberof EcommerceProductGoodsInquiryListResponseItem
     */
    'slaAtUtc0': number;
    /**
     * created date of inquiry
     * @type {number}
     * @memberof EcommerceProductGoodsInquiryListResponseItem
     */
    'createdAtUtc0': number;
}
/**
 * 
 * @export
 * @interface EcommerceProductGoodsInquiryRequest
 */
export interface EcommerceProductGoodsInquiryRequest {
    /**
     * pricelist id
     * @type {string}
     * @memberof EcommerceProductGoodsInquiryRequest
     */
    'pricelistId'?: string;
    /**
     * store id
     * @type {string}
     * @memberof EcommerceProductGoodsInquiryRequest
     */
    'storeId'?: string;
    /**
     * Quantity
     * @type {number}
     * @memberof EcommerceProductGoodsInquiryRequest
     */
    'quantity'?: number;
    /**
     * Customer Name
     * @type {string}
     * @memberof EcommerceProductGoodsInquiryRequest
     */
    'customerName': string;
    /**
     * Customer Phone Number
     * @type {string}
     * @memberof EcommerceProductGoodsInquiryRequest
     */
    'customerPhoneNumber': string;
    /**
     * Additional Information
     * @type {string}
     * @memberof EcommerceProductGoodsInquiryRequest
     */
    'additionalInformation': string;
}
/**
 * 
 * @export
 * @interface EcommerceProductGoodsInquiryResponse
 */
export interface EcommerceProductGoodsInquiryResponse {
    /**
     * inquiry id
     * @type {string}
     * @memberof EcommerceProductGoodsInquiryResponse
     */
    'id': string;
}
/**
 * Enum for merchant status
 * @export
 * @enum {string}
 */

export const EcommerceProductStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE'
} as const;

export type EcommerceProductStatusEnum = typeof EcommerceProductStatusEnum[keyof typeof EcommerceProductStatusEnum];


/**
 * - GOODS, this is for physical type products with stock. - SERVICE, this is for service type products like Sawitdoctor. - DIGITAL, this is for digital type products like prepaid mobile credit, bill payments. 
 * @export
 * @enum {string}
 */

export const EcommerceProductTypeEnum = {
    Goods: 'GOODS',
    Service: 'SERVICE',
    Digital: 'DIGITAL'
} as const;

export type EcommerceProductTypeEnum = typeof EcommerceProductTypeEnum[keyof typeof EcommerceProductTypeEnum];


/**
 * Filter by product type - ALL -> this is for all product type - GOODS -> this is for spesific product GOODS like fetilizer, seed, etc - SERVICE -> this is for spesific product SERVICE like dockter sawit etc - DIGITAL -> this is for spesific product DIGITAL like airtime,bill payment, voucher etc 
 * @export
 * @enum {string}
 */

export const EcommerceProductTypeFilterEnum = {
    All: 'ALL',
    Goods: 'GOODS',
    Service: 'SERVICE',
    Digital: 'DIGITAL'
} as const;

export type EcommerceProductTypeFilterEnum = typeof EcommerceProductTypeFilterEnum[keyof typeof EcommerceProductTypeFilterEnum];


/**
 * product unit of measurement
 * @export
 * @enum {string}
 */

export const EcommerceProductUnitOfMeasurementEnum = {
    Pcs: 'pcs',
    Sak: 'sak',
    Ton: 'ton',
    Kg: 'kg',
    Gram: 'gram',
    Pack: 'pack',
    Liter: 'liter'
} as const;

export type EcommerceProductUnitOfMeasurementEnum = typeof EcommerceProductUnitOfMeasurementEnum[keyof typeof EcommerceProductUnitOfMeasurementEnum];


/**
 * Response data
 * @export
 * @interface EcommerceSearchGoodsProductResponse
 */
export interface EcommerceSearchGoodsProductResponse {
    /**
     * List of keyword
     * @type {Array<string>}
     * @memberof EcommerceSearchGoodsProductResponse
     */
    'keywords': Array<string>;
    /**
     * List of category, key is category code and value is category name
     * @type {Array<KeyValueResponseItem>}
     * @memberof EcommerceSearchGoodsProductResponse
     */
    'categories': Array<KeyValueResponseItem>;
}
/**
 * list of city
 * @export
 * @interface EcommerceStoreGetAreasResponse
 */
export interface EcommerceStoreGetAreasResponse {
    /**
     * 
     * @type {Array<EcommerceStoreGetAreasResponseItem>}
     * @memberof EcommerceStoreGetAreasResponse
     */
    'items': Array<EcommerceStoreGetAreasResponseItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof EcommerceStoreGetAreasResponse
     */
    'pagination': PaginationResponse;
}
/**
 * list of item area under store
 * @export
 * @interface EcommerceStoreGetAreasResponseItem
 */
export interface EcommerceStoreGetAreasResponseItem {
    /**
     * Area ID
     * @type {string}
     * @memberof EcommerceStoreGetAreasResponseItem
     */
    'id': string;
    /**
     * Area Name
     * @type {string}
     * @memberof EcommerceStoreGetAreasResponseItem
     */
    'name': string;
    /**
     * Province Name
     * @type {string}
     * @memberof EcommerceStoreGetAreasResponseItem
     */
    'province': string;
    /**
     * City Name
     * @type {string}
     * @memberof EcommerceStoreGetAreasResponseItem
     */
    'city': string;
    /**
     * District Name
     * @type {string}
     * @memberof EcommerceStoreGetAreasResponseItem
     */
    'district': string;
}
/**
 * list of city
 * @export
 * @interface EcommerceStoresGetCitiesResponse
 */
export interface EcommerceStoresGetCitiesResponse {
    /**
     * 
     * @type {Array<EcommerceStoresGetCitiesResponseItem>}
     * @memberof EcommerceStoresGetCitiesResponse
     */
    'items': Array<EcommerceStoresGetCitiesResponseItem>;
}
/**
 * list of city
 * @export
 * @interface EcommerceStoresGetCitiesResponseItem
 */
export interface EcommerceStoresGetCitiesResponseItem {
    /**
     * City Name
     * @type {string}
     * @memberof EcommerceStoresGetCitiesResponseItem
     */
    'name': string;
}
/**
 * list of province
 * @export
 * @interface EcommerceStoresGetProvincesResponse
 */
export interface EcommerceStoresGetProvincesResponse {
    /**
     * 
     * @type {Array<EcommerceStoresGetProvincesResponseItem>}
     * @memberof EcommerceStoresGetProvincesResponse
     */
    'items': Array<EcommerceStoresGetProvincesResponseItem>;
}
/**
 * list of user province
 * @export
 * @interface EcommerceStoresGetProvincesResponseItem
 */
export interface EcommerceStoresGetProvincesResponseItem {
    /**
     * Province Name
     * @type {string}
     * @memberof EcommerceStoresGetProvincesResponseItem
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface EditCampaignRequest
 */
export interface EditCampaignRequest {
    /**
     * ID of the campaign type in UUID format
     * @type {string}
     * @memberof EditCampaignRequest
     */
    'campaignTypeId': string;
    /**
     * Name of campaign
     * @type {string}
     * @memberof EditCampaignRequest
     */
    'name': string;
    /**
     * Start datetime of campaign (in epoch) formatted in UTC-0
     * @type {number}
     * @memberof EditCampaignRequest
     */
    'startAt': number;
    /**
     * End datetime of campaign (in epoch) formatted in UTC-0
     * @type {number}
     * @memberof EditCampaignRequest
     */
    'endAt': number;
    /**
     * Default reward poin value
     * @type {number}
     * @memberof EditCampaignRequest
     */
    'defaultRewardValue': number;
    /**
     * List of campaign default target value
     * @type {Array<CreateEditCampaignRequestTargetItem>}
     * @memberof EditCampaignRequest
     */
    'defaultTargetValue': Array<CreateEditCampaignRequestTargetItem>;
    /**
     * List of members that are enlisted for this campaign
     * @type {Array<CreateEditCampaignRequestMemberItem>}
     * @memberof EditCampaignRequest
     */
    'member': Array<CreateEditCampaignRequestMemberItem>;
}
/**
 * List of allowed answer for Employment Compliance For Companies
 * @export
 * @enum {string}
 */

export const EmploymentComplianceForCompaniesEnum = {
    Ada: 'Ada',
    TidakAda: 'Tidak Ada',
    PengelolaanPribadi: 'Pengelolaan Pribadi'
} as const;

export type EmploymentComplianceForCompaniesEnum = typeof EmploymentComplianceForCompaniesEnum[keyof typeof EmploymentComplianceForCompaniesEnum];


/**
 * List of estate license allowed
 * @export
 * @enum {string}
 */

export const EstateLicenseEnum = {
    Hgu: 'HGU',
    Shm: 'SHM',
    Skgr: 'SKGR',
    Skc: 'SKC',
    IzinLokasi: 'Izin Lokasi',
    IupB: 'IUP-B',
    Hgb: 'HGB'
} as const;

export type EstateLicenseEnum = typeof EstateLicenseEnum[keyof typeof EstateLicenseEnum];


/**
 * List of allowed answer for Ethics Compliance For Companies
 * @export
 * @enum {string}
 */

export const EthicsComplianceForCompaniesEnum = {
    Ada: 'Ada',
    TidakAda: 'Tidak Ada',
    PengelolaanPribadi: 'Pengelolaan Pribadi'
} as const;

export type EthicsComplianceForCompaniesEnum = typeof EthicsComplianceForCompaniesEnum[keyof typeof EthicsComplianceForCompaniesEnum];


/**
 * 
 * @export
 * @interface ExperimentalWeighbridgeUploadCreateRequest
 */
export interface ExperimentalWeighbridgeUploadCreateRequest {
    /**
     * original file name with extension
     * @type {string}
     * @memberof ExperimentalWeighbridgeUploadCreateRequest
     */
    'originalFileName': string;
    /**
     * number of file size in bytes
     * @type {number}
     * @memberof ExperimentalWeighbridgeUploadCreateRequest
     */
    'fileSize': number;
    /**
     * 
     * @type {ExperimentalWeighbridgeUploadCreateRequestCoordinate}
     * @memberof ExperimentalWeighbridgeUploadCreateRequest
     */
    'coordinate': ExperimentalWeighbridgeUploadCreateRequestCoordinate;
    /**
     * picture metadata in string json format (optional)
     * @type {string}
     * @memberof ExperimentalWeighbridgeUploadCreateRequest
     */
    'metadata'?: string;
}
/**
 * 
 * @export
 * @interface ExperimentalWeighbridgeUploadCreateRequestCoordinate
 */
export interface ExperimentalWeighbridgeUploadCreateRequestCoordinate {
    /**
     * latitude coordinate
     * @type {number}
     * @memberof ExperimentalWeighbridgeUploadCreateRequestCoordinate
     */
    'latitude': number;
    /**
     * longitude coordinate
     * @type {number}
     * @memberof ExperimentalWeighbridgeUploadCreateRequestCoordinate
     */
    'longitude': number;
}
/**
 * 
 * @export
 * @interface ExperimentalWeighbridgeUploadCreateResponse
 */
export interface ExperimentalWeighbridgeUploadCreateResponse {
    /**
     * 
     * @type {string}
     * @memberof ExperimentalWeighbridgeUploadCreateResponse
     */
    'id': string;
    /**
     * Presigned url of upload image
     * @type {string}
     * @memberof ExperimentalWeighbridgeUploadCreateResponse
     */
    'presignedUrl': string;
    /**
     * Created Datetime of Weighbridge in epoch
     * @type {number}
     * @memberof ExperimentalWeighbridgeUploadCreateResponse
     */
    'createdAt': number;
}
/**
 * 
 * @export
 * @interface ExperimentalWeighbridgeUploadDetailResponse
 */
export interface ExperimentalWeighbridgeUploadDetailResponse {
    /**
     * ID of weighbridge data
     * @type {string}
     * @memberof ExperimentalWeighbridgeUploadDetailResponse
     */
    'id': string;
    /**
     * Image URL of weighbridge_slip.jpeg
     * @type {string}
     * @memberof ExperimentalWeighbridgeUploadDetailResponse
     */
    'photoUrl': string;
    /**
     * Delivery number (No. SP)
     * @type {string}
     * @memberof ExperimentalWeighbridgeUploadDetailResponse
     */
    'deliveryNo': string;
    /**
     * Number of Slip Timbangan (No. Tiket)
     * @type {string}
     * @memberof ExperimentalWeighbridgeUploadDetailResponse
     */
    'ticketNo': string;
    /**
     * Entry datetime in epoch (Tanggal Masuk)
     * @type {number}
     * @memberof ExperimentalWeighbridgeUploadDetailResponse
     */
    'entryTime': number;
    /**
     * Exit datetime in epoch (Tanggal Keluar)
     * @type {number}
     * @memberof ExperimentalWeighbridgeUploadDetailResponse
     */
    'exitTime': number;
    /**
     * Weight entry of FFB (Berat Masuk)
     * @type {number}
     * @memberof ExperimentalWeighbridgeUploadDetailResponse
     */
    'weightEntry': number;
    /**
     * Weight exit of FFB (Berat Keluar)
     * @type {number}
     * @memberof ExperimentalWeighbridgeUploadDetailResponse
     */
    'weightExit': number;
    /**
     * Weight netto of FFB (Berat Netto)
     * @type {number}
     * @memberof ExperimentalWeighbridgeUploadDetailResponse
     */
    'weightNetKg': number;
    /**
     * Percentage of sortation (Sortasi)
     * @type {number}
     * @memberof ExperimentalWeighbridgeUploadDetailResponse
     */
    'sortation': number;
    /**
     * Adjustment weight of FFB (Potongan)
     * @type {number}
     * @memberof ExperimentalWeighbridgeUploadDetailResponse
     */
    'adjustmentKg': number;
    /**
     * Final weight counted of FFB (Netto)
     * @type {number}
     * @memberof ExperimentalWeighbridgeUploadDetailResponse
     */
    'weightNetAdjustedKg': number;
    /**
     * Name of the operator (Operator WBS)
     * @type {string}
     * @memberof ExperimentalWeighbridgeUploadDetailResponse
     */
    'operatorName': string;
    /**
     * Quantity of bunch (Jumlah Janjang)
     * @type {number}
     * @memberof ExperimentalWeighbridgeUploadDetailResponse
     */
    'quantity': number;
    /**
     * Average weight of bunch (Komidel)
     * @type {number}
     * @memberof ExperimentalWeighbridgeUploadDetailResponse
     */
    'weightAverageBunchKg': number;
    /**
     * Name of supplier (Dari Supplier)
     * @type {string}
     * @memberof ExperimentalWeighbridgeUploadDetailResponse
     */
    'supplierName': string;
    /**
     * Truck number (No. Kendaraan)
     * @type {string}
     * @memberof ExperimentalWeighbridgeUploadDetailResponse
     */
    'truckNo': string;
    /**
     * Driver name (Nama Sopir)
     * @type {string}
     * @memberof ExperimentalWeighbridgeUploadDetailResponse
     */
    'driverName': string;
    /**
     * Partner name (PMKS / Pembeli TBS)
     * @type {string}
     * @memberof ExperimentalWeighbridgeUploadDetailResponse
     */
    'partnerName': string;
    /**
     * 
     * @type {ExperimentalWeighbridgeUploadStatusEnum}
     * @memberof ExperimentalWeighbridgeUploadDetailResponse
     */
    'status': ExperimentalWeighbridgeUploadStatusEnum;
}


/**
 * 
 * @export
 * @interface ExperimentalWeighbridgeUploadExtractResponse
 */
export interface ExperimentalWeighbridgeUploadExtractResponse {
    /**
     * Delivery number (No. SP)
     * @type {string}
     * @memberof ExperimentalWeighbridgeUploadExtractResponse
     */
    'deliveryNo'?: string;
    /**
     * Number of Slip Timbangan (No. Tiket)
     * @type {string}
     * @memberof ExperimentalWeighbridgeUploadExtractResponse
     */
    'ticketNo'?: string;
    /**
     * Entry datetime in epoch (Tanggal Masuk)
     * @type {number}
     * @memberof ExperimentalWeighbridgeUploadExtractResponse
     */
    'entryTime'?: number;
    /**
     * Exit datetime in epoch (Tanggal Keluar)
     * @type {number}
     * @memberof ExperimentalWeighbridgeUploadExtractResponse
     */
    'exitTime'?: number;
    /**
     * Weight entry of FFB (Berat Masuk)
     * @type {number}
     * @memberof ExperimentalWeighbridgeUploadExtractResponse
     */
    'weightEntry'?: number;
    /**
     * Weight exit of FFB (Berat Keluar)
     * @type {number}
     * @memberof ExperimentalWeighbridgeUploadExtractResponse
     */
    'weightExit'?: number;
    /**
     * Weight netto of FFB (Berat Netto)
     * @type {number}
     * @memberof ExperimentalWeighbridgeUploadExtractResponse
     */
    'weightNetKg'?: number;
    /**
     * Percentage of sortation (Sortasi)
     * @type {number}
     * @memberof ExperimentalWeighbridgeUploadExtractResponse
     */
    'sortation'?: number;
    /**
     * Adjustment weight of FFB (Potongan)
     * @type {number}
     * @memberof ExperimentalWeighbridgeUploadExtractResponse
     */
    'adjustmentKg'?: number;
    /**
     * Final weight counted of FFB (Netto)
     * @type {number}
     * @memberof ExperimentalWeighbridgeUploadExtractResponse
     */
    'weightNetAdjustedKg'?: number;
    /**
     * Name of the operator (Operator WBS)
     * @type {string}
     * @memberof ExperimentalWeighbridgeUploadExtractResponse
     */
    'operatorName'?: string;
    /**
     * Quantity of bunch (Jumlah Janjang)
     * @type {number}
     * @memberof ExperimentalWeighbridgeUploadExtractResponse
     */
    'quantity'?: number;
    /**
     * Average weight of bunch (Komidel)
     * @type {number}
     * @memberof ExperimentalWeighbridgeUploadExtractResponse
     */
    'weightAverageBunchKg'?: number;
    /**
     * Name of supplier (Dari Supplier)
     * @type {string}
     * @memberof ExperimentalWeighbridgeUploadExtractResponse
     */
    'supplierName'?: string;
    /**
     * Truck number (No. Kendaraan)
     * @type {string}
     * @memberof ExperimentalWeighbridgeUploadExtractResponse
     */
    'truckNo'?: string;
    /**
     * Driver name (Nama Sopir)
     * @type {string}
     * @memberof ExperimentalWeighbridgeUploadExtractResponse
     */
    'driverName'?: string;
    /**
     * Partner name (PMKS / Pembeli TBS)
     * @type {string}
     * @memberof ExperimentalWeighbridgeUploadExtractResponse
     */
    'partnerName'?: string;
}
/**
 * List of weighbridge tickets uploaded
 * @export
 * @interface ExperimentalWeighbridgeUploadListResponse
 */
export interface ExperimentalWeighbridgeUploadListResponse {
    /**
     * 
     * @type {Array<ExperimentalWeighbridgeUploadListResponseDataItem>}
     * @memberof ExperimentalWeighbridgeUploadListResponse
     */
    'items': Array<ExperimentalWeighbridgeUploadListResponseDataItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof ExperimentalWeighbridgeUploadListResponse
     */
    'pagination': PaginationResponse;
}
/**
 * Item of weighbridge ticket uploaded
 * @export
 * @interface ExperimentalWeighbridgeUploadListResponseDataItem
 */
export interface ExperimentalWeighbridgeUploadListResponseDataItem {
    /**
     * ID of weighbridge data
     * @type {string}
     * @memberof ExperimentalWeighbridgeUploadListResponseDataItem
     */
    'id': string;
    /**
     * Ticket No. of Weighbridge Slip
     * @type {string}
     * @memberof ExperimentalWeighbridgeUploadListResponseDataItem
     */
    'ticketNo': string;
    /**
     * Image URL of weighbridge_slip.jpeg
     * @type {string}
     * @memberof ExperimentalWeighbridgeUploadListResponseDataItem
     */
    'photoUrl': string;
    /**
     * Created Datetime of Weighbridge in epoch
     * @type {number}
     * @memberof ExperimentalWeighbridgeUploadListResponseDataItem
     */
    'createdAt': number;
}
/**
 * 
 * @export
 * @interface ExperimentalWeighbridgeUploadPictureResponse
 */
export interface ExperimentalWeighbridgeUploadPictureResponse {
    /**
     * ID of weighbridge data
     * @type {string}
     * @memberof ExperimentalWeighbridgeUploadPictureResponse
     */
    'id'?: string;
    /**
     * Image URL of weighbridge_slip.jpeg
     * @type {string}
     * @memberof ExperimentalWeighbridgeUploadPictureResponse
     */
    'photoUrl'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ExperimentalWeighbridgeUploadStatusEnum = {
    Processing: 'PROCESSING',
    Uploading: 'UPLOADING',
    Active: 'ACTIVE',
    Failed: 'FAILED'
} as const;

export type ExperimentalWeighbridgeUploadStatusEnum = typeof ExperimentalWeighbridgeUploadStatusEnum[keyof typeof ExperimentalWeighbridgeUploadStatusEnum];


/**
 * 
 * @export
 * @interface ExperimentalWeighbridgeUploadUpdateRequest
 */
export interface ExperimentalWeighbridgeUploadUpdateRequest {
    /**
     * Delivery number (No. SP)
     * @type {string}
     * @memberof ExperimentalWeighbridgeUploadUpdateRequest
     */
    'deliveryNo'?: string;
    /**
     * Number of Slip Timbangan (No. Tiket)
     * @type {string}
     * @memberof ExperimentalWeighbridgeUploadUpdateRequest
     */
    'ticketNo'?: string;
    /**
     * Entry datetime in epoch (Tanggal Masuk)
     * @type {number}
     * @memberof ExperimentalWeighbridgeUploadUpdateRequest
     */
    'entryTime'?: number;
    /**
     * Exit datetime in epoch (Tanggal Keluar)
     * @type {number}
     * @memberof ExperimentalWeighbridgeUploadUpdateRequest
     */
    'exitTime'?: number;
    /**
     * Weight entry of FFB (Berat Masuk)
     * @type {number}
     * @memberof ExperimentalWeighbridgeUploadUpdateRequest
     */
    'weightEntry'?: number;
    /**
     * Weight exit of FFB (Berat Keluar)
     * @type {number}
     * @memberof ExperimentalWeighbridgeUploadUpdateRequest
     */
    'weightExit'?: number;
    /**
     * Weight netto of FFB (Berat Netto)
     * @type {number}
     * @memberof ExperimentalWeighbridgeUploadUpdateRequest
     */
    'weightNetKg'?: number;
    /**
     * Percentage of sortation (Sortasi)
     * @type {number}
     * @memberof ExperimentalWeighbridgeUploadUpdateRequest
     */
    'sortation'?: number;
    /**
     * Adjustment weight of FFB (Potongan)
     * @type {number}
     * @memberof ExperimentalWeighbridgeUploadUpdateRequest
     */
    'adjustmentKg'?: number;
    /**
     * Final weight counted of FFB (Netto)
     * @type {number}
     * @memberof ExperimentalWeighbridgeUploadUpdateRequest
     */
    'weightNetAdjustedKg'?: number;
    /**
     * Name of the operator (Operator WBS)
     * @type {string}
     * @memberof ExperimentalWeighbridgeUploadUpdateRequest
     */
    'operatorName'?: string;
    /**
     * Quantity of bunch (Jumlah Janjang)
     * @type {number}
     * @memberof ExperimentalWeighbridgeUploadUpdateRequest
     */
    'quantity'?: number;
    /**
     * Average weight of bunch (Komidel)
     * @type {number}
     * @memberof ExperimentalWeighbridgeUploadUpdateRequest
     */
    'weightAverageBunchKg'?: number;
    /**
     * Name of supplier (Dari Supplier)
     * @type {string}
     * @memberof ExperimentalWeighbridgeUploadUpdateRequest
     */
    'supplierName'?: string;
    /**
     * Truck number (No. Kendaraan)
     * @type {string}
     * @memberof ExperimentalWeighbridgeUploadUpdateRequest
     */
    'truckNo'?: string;
    /**
     * Driver name (Nama Sopir)
     * @type {string}
     * @memberof ExperimentalWeighbridgeUploadUpdateRequest
     */
    'driverName'?: string;
    /**
     * Partner name (PMKS / Pembeli TBS)
     * @type {string}
     * @memberof ExperimentalWeighbridgeUploadUpdateRequest
     */
    'partnerName'?: string;
    /**
     * 
     * @type {ExperimentalWeighbridgeUploadStatusEnum}
     * @memberof ExperimentalWeighbridgeUploadUpdateRequest
     */
    'status'?: ExperimentalWeighbridgeUploadStatusEnum;
}


/**
 * 
 * @export
 * @interface ExperimentalWeighbridgeUploadUpdateResponse
 */
export interface ExperimentalWeighbridgeUploadUpdateResponse {
    /**
     * 
     * @type {string}
     * @memberof ExperimentalWeighbridgeUploadUpdateResponse
     */
    'id': string;
    /**
     * Ticket No. of Weighbridge Slip
     * @type {string}
     * @memberof ExperimentalWeighbridgeUploadUpdateResponse
     */
    'ticketNo': string;
    /**
     * 
     * @type {ExperimentalWeighbridgeUploadStatusEnum}
     * @memberof ExperimentalWeighbridgeUploadUpdateResponse
     */
    'status': ExperimentalWeighbridgeUploadStatusEnum;
    /**
     * Updated Datetime of Weighbridge in epoch
     * @type {number}
     * @memberof ExperimentalWeighbridgeUploadUpdateResponse
     */
    'updatedAt': number;
}


/**
 * type of buyer in FFB Sell Price data COLLECTOR = smaller FFB collector (\"Pengepul\") <br> FARMER_ASSOCIATION = cooperative or association formed by smallholder farmers (\"Kelompok Tani\") <br> MILLS = FFB processing plant/factory (\"Langsung ke Pabrik\")
 * @export
 * @enum {string}
 */

export const FFBBuyerTypeEnum = {
    Collector: 'COLLECTOR',
    FarmerAssociation: 'FARMER_ASSOCIATION',
    Mills: 'MILLS'
} as const;

export type FFBBuyerTypeEnum = typeof FFBBuyerTypeEnum[keyof typeof FFBBuyerTypeEnum];


/**
 * HandCarry: The collection method is hand carry for ffb (Dipikul) Cart: The collection method is cart for ffb (Gerobak) 
 * @export
 * @enum {string}
 */

export const FFBCollectionMethodEnum = {
    HandCarry: 'HandCarry',
    Cart: 'Cart'
} as const;

export type FFBCollectionMethodEnum = typeof FFBCollectionMethodEnum[keyof typeof FFBCollectionMethodEnum];


/**
 * List of buyer association that allowed
 * @export
 * @enum {string}
 */

export const FarmBuyerAssociationEnum = {
    Csv: 'CSV',
    _3rdParty: '3rd Party',
    Plasma: 'Plasma'
} as const;

export type FarmBuyerAssociationEnum = typeof FarmBuyerAssociationEnum[keyof typeof FarmBuyerAssociationEnum];


/**
 * Farm management type
 * @export
 * @enum {string}
 */

export const FarmManagementTypeEnum = {
    Perusahaan: 'Perusahaan',
    Pribadi: 'Pribadi',
    Lainnya: 'Lainnya'
} as const;

export type FarmManagementTypeEnum = typeof FarmManagementTypeEnum[keyof typeof FarmManagementTypeEnum];


/**
 * Feature Collection entity based on ESRI Geojson Format (RFC7159) that consists of many features.
 * @export
 * @interface FeatureCollection
 */
export interface FeatureCollection {
    /**
     * Type of this feature collection based on ESRI Geojson Format (RFC7159).
     * @type {string}
     * @memberof FeatureCollection
     */
    'type': string;
    /**
     * Name of this feature collection based on ESRI Geojson Format (RFC7159).
     * @type {string}
     * @memberof FeatureCollection
     */
    'name': string;
    /**
     * 
     * @type {CoordinateReferenceSystem}
     * @memberof FeatureCollection
     */
    'crs': CoordinateReferenceSystem;
    /**
     * 
     * @type {Array<GeoJSONFeature>}
     * @memberof FeatureCollection
     */
    'features': Array<GeoJSONFeature>;
}
/**
 * 
 * @export
 * @interface FeatureFlagStatusResponse
 */
export interface FeatureFlagStatusResponse {
    /**
     * Is feature flag enabled
     * @type {boolean}
     * @memberof FeatureFlagStatusResponse
     */
    'isEnabled': boolean;
}
/**
 * 
 * @export
 * @interface FeedbackUserForPartnerResponse
 */
export interface FeedbackUserForPartnerResponse {
    /**
     * 
     * @type {FeedbackUserForPartnerResponseUserFeedback}
     * @memberof FeedbackUserForPartnerResponse
     */
    'userFeedback': FeedbackUserForPartnerResponseUserFeedback | null;
}
/**
 * 
 * @export
 * @interface FeedbackUserForPartnerResponseUserFeedback
 */
export interface FeedbackUserForPartnerResponseUserFeedback {
    /**
     * Displayed name of user
     * @type {string}
     * @memberof FeedbackUserForPartnerResponseUserFeedback
     */
    'name': string;
    /**
     * Average rating of the Partner (mills)
     * @type {number}
     * @memberof FeedbackUserForPartnerResponseUserFeedback
     */
    'averageRating': number;
    /**
     * Feedback creation date (in epoch). The time will be set at midnight (00:00) UTC-0
     * @type {number}
     * @memberof FeedbackUserForPartnerResponseUserFeedback
     */
    'createdDate': number;
    /**
     * Comments of user for partner
     * @type {string}
     * @memberof FeedbackUserForPartnerResponseUserFeedback
     */
    'comments': string;
    /**
     * The rating assigned to the price component
     * @type {number}
     * @memberof FeedbackUserForPartnerResponseUserFeedback
     */
    'priceRating': number;
    /**
     * The rating assigned to the weighbridge component
     * @type {number}
     * @memberof FeedbackUserForPartnerResponseUserFeedback
     */
    'weighbridgeRating': number;
    /**
     * The rating assigned to the queue component
     * @type {number}
     * @memberof FeedbackUserForPartnerResponseUserFeedback
     */
    'queueRating': number;
    /**
     * The rating assigned to the sorting component
     * @type {number}
     * @memberof FeedbackUserForPartnerResponseUserFeedback
     */
    'sortingRating': number;
    /**
     * The rating assigned to the road access component
     * @type {number}
     * @memberof FeedbackUserForPartnerResponseUserFeedback
     */
    'roadAccessRating': number;
    /**
     * This field is used to identify whether member\'s user want to show their name as they give their feedback
     * @type {boolean}
     * @memberof FeedbackUserForPartnerResponseUserFeedback
     */
    'isAnonymous': boolean;
}
/**
 * 
 * @export
 * @interface FeedbacksReponseCreateResponse
 */
export interface FeedbacksReponseCreateResponse {
    /**
     * 
     * @type {boolean}
     * @memberof FeedbacksReponseCreateResponse
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const FfbSourceTypeEnum = {
    Subagent: 'SUBAGENT',
    Block: 'BLOCK'
} as const;

export type FfbSourceTypeEnum = typeof FfbSourceTypeEnum[keyof typeof FfbSourceTypeEnum];


/**
 * 
 * @export
 * @interface FileUploadDestination
 */
export interface FileUploadDestination {
    /**
     * 
     * @type {string}
     * @memberof FileUploadDestination
     */
    'type': FileUploadDestinationTypeEnum;
    /**
     * 
     * @type {FileUploadDestinationData}
     * @memberof FileUploadDestination
     */
    'data': FileUploadDestinationData;
}

export const FileUploadDestinationTypeEnum = {
    Url: 'url',
    S3bucket: 's3bucket'
} as const;

export type FileUploadDestinationTypeEnum = typeof FileUploadDestinationTypeEnum[keyof typeof FileUploadDestinationTypeEnum];

/**
 * @type FileUploadDestinationData
 * @export
 */
export type FileUploadDestinationData = FileUploadDestinationS3Bucket | FileUploadDestinationUrl;

/**
 * 
 * @export
 * @interface FileUploadDestinationS3Bucket
 */
export interface FileUploadDestinationS3Bucket {
    /**
     * S3 bucket name
     * @type {string}
     * @memberof FileUploadDestinationS3Bucket
     */
    'bucket': string;
    /**
     * S3 key
     * @type {string}
     * @memberof FileUploadDestinationS3Bucket
     */
    'key': string;
    /**
     * S3 region
     * @type {string}
     * @memberof FileUploadDestinationS3Bucket
     */
    'region'?: string;
    /**
     * AWS access key id. This is temporary.
     * @type {string}
     * @memberof FileUploadDestinationS3Bucket
     */
    'accessKeyId': string;
    /**
     * AWS secret access key
     * @type {string}
     * @memberof FileUploadDestinationS3Bucket
     */
    'secretAccessKey': string;
    /**
     * AWS session token
     * @type {string}
     * @memberof FileUploadDestinationS3Bucket
     */
    'sessionToken'?: string;
}
/**
 * 
 * @export
 * @interface FileUploadDestinationUrl
 */
export interface FileUploadDestinationUrl {
    /**
     * Presigned url of upload image
     * @type {string}
     * @memberof FileUploadDestinationUrl
     */
    'url': string;
}
/**
 * 
 * @export
 * @interface FinanceGetBalanceResponse
 */
export interface FinanceGetBalanceResponse {
    /**
     * The SawitPoin balance of a user, will return 0 if the user has no SawitPoin
     * @type {number}
     * @memberof FinanceGetBalanceResponse
     */
    'sawitpoin': number;
    /**
     * The Gold balance of a user (in mg or 1/1000 of a gram), will return 0 if the user has no Gold
     * @type {number}
     * @memberof FinanceGetBalanceResponse
     */
    'gold': number;
    /**
     * The information whether the user has had gold transaction.
     * @type {boolean}
     * @memberof FinanceGetBalanceResponse
     */
    'hasGoldTransaction': boolean;
}
/**
 * Response data
 * @export
 * @interface FinanceGetInvoiceDetailResponse
 */
export interface FinanceGetInvoiceDetailResponse {
    /**
     * 
     * @type {string}
     * @memberof FinanceGetInvoiceDetailResponse
     */
    'id': string;
    /**
     * Invoice Number
     * @type {string}
     * @memberof FinanceGetInvoiceDetailResponse
     */
    'invoiceNo': string;
    /**
     * Name of Customer
     * @type {string}
     * @memberof FinanceGetInvoiceDetailResponse
     */
    'customerName': string;
    /**
     * Phone number starting with 0 as prefix (08xxxxxxxxx)
     * @type {string}
     * @memberof FinanceGetInvoiceDetailResponse
     */
    'customerPhoneNo': string;
    /**
     * 
     * @type {number}
     * @memberof FinanceGetInvoiceDetailResponse
     */
    'dueAtUtc0': number;
    /**
     * 
     * @type {number}
     * @memberof FinanceGetInvoiceDetailResponse
     */
    'totalAmountDue': number;
    /**
     * 
     * @type {InvoiceStatusEnum}
     * @memberof FinanceGetInvoiceDetailResponse
     */
    'status': InvoiceStatusEnum;
    /**
     * List of Payment Item
     * @type {Array<FinanceGetInvoiceDetailResponseItem>}
     * @memberof FinanceGetInvoiceDetailResponse
     */
    'paymentItems': Array<FinanceGetInvoiceDetailResponseItem>;
}


/**
 * 
 * @export
 * @interface FinanceGetInvoiceDetailResponseItem
 */
export interface FinanceGetInvoiceDetailResponseItem {
    /**
     * 
     * @type {string}
     * @memberof FinanceGetInvoiceDetailResponseItem
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof FinanceGetInvoiceDetailResponseItem
     */
    'amountPaid': number;
    /**
     * 
     * @type {number}
     * @memberof FinanceGetInvoiceDetailResponseItem
     */
    'paidAtUtc'?: number;
    /**
     * 
     * @type {number}
     * @memberof FinanceGetInvoiceDetailResponseItem
     */
    'amountDue': number;
    /**
     * 
     * @type {number}
     * @memberof FinanceGetInvoiceDetailResponseItem
     */
    'expiredAtUtc'?: number;
    /**
     * 
     * @type {PaymentItemsPaymentMethodEnum}
     * @memberof FinanceGetInvoiceDetailResponseItem
     */
    'paymentMethod': PaymentItemsPaymentMethodEnum;
    /**
     * 
     * @type {PaymentStatusEnum}
     * @memberof FinanceGetInvoiceDetailResponseItem
     */
    'status': PaymentStatusEnum;
}


/**
 * Response data
 * @export
 * @interface FinanceInvoiceListResponse
 */
export interface FinanceInvoiceListResponse {
    /**
     * List of invoice payment item
     * @type {Array<FinanceInvoiceListResponseItem>}
     * @memberof FinanceInvoiceListResponse
     */
    'items': Array<FinanceInvoiceListResponseItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof FinanceInvoiceListResponse
     */
    'pagination': PaginationResponse;
}
/**
 * 
 * @export
 * @interface FinanceInvoiceListResponseItem
 */
export interface FinanceInvoiceListResponseItem {
    /**
     * Payment UUID
     * @type {string}
     * @memberof FinanceInvoiceListResponseItem
     */
    'id': string;
    /**
     * Invoice Number
     * @type {string}
     * @memberof FinanceInvoiceListResponseItem
     */
    'invoiceNo': string;
    /**
     * Name of User
     * @type {string}
     * @memberof FinanceInvoiceListResponseItem
     */
    'customerName': string;
    /**
     * Amount Due of Invoice User
     * @type {number}
     * @memberof FinanceInvoiceListResponseItem
     */
    'amountDue': number;
    /**
     * 
     * @type {InvoiceStatusEnum}
     * @memberof FinanceInvoiceListResponseItem
     */
    'status': InvoiceStatusEnum;
    /**
     * Date when order was created (in epoch). Will be represented in UTC-0, time will be set at midnight (00:00)
     * @type {number}
     * @memberof FinanceInvoiceListResponseItem
     */
    'orderCreatedAt': number;
    /**
     * Date when order was paid (in epoch). Will be represented in UTC-0, time will be set at midnight (00:00)
     * @type {number}
     * @memberof FinanceInvoiceListResponseItem
     */
    'paidAt'?: number;
}


/**
 * 
 * @export
 * @interface FinancePaymentVerifyDokuRequest
 */
export interface FinancePaymentVerifyDokuRequest {
    /**
     * Invoice number
     * @type {string}
     * @memberof FinancePaymentVerifyDokuRequest
     */
    'invoiceNo': string;
}
/**
 * 
 * @export
 * @interface FinancePaymentVerifyDokuResponse
 */
export interface FinancePaymentVerifyDokuResponse {
    /**
     * Payment Id
     * @type {string}
     * @memberof FinancePaymentVerifyDokuResponse
     */
    'id': string;
    /**
     * Payment Amount
     * @type {number}
     * @memberof FinancePaymentVerifyDokuResponse
     */
    'amount': number;
    /**
     * 
     * @type {PaymentItemsPaymentMethodEnum}
     * @memberof FinancePaymentVerifyDokuResponse
     */
    'paymentMethod': PaymentItemsPaymentMethodEnum;
    /**
     * 
     * @type {PaymentStatusEnum}
     * @memberof FinancePaymentVerifyDokuResponse
     */
    'status': PaymentStatusEnum;
    /**
     * Payment Gateway Ref Id
     * @type {string}
     * @memberof FinancePaymentVerifyDokuResponse
     */
    'paymentGatewayRefId': string;
    /**
     * 
     * @type {DokuPaymentInformation}
     * @memberof FinancePaymentVerifyDokuResponse
     */
    'dokuPaymentInformation': DokuPaymentInformation;
}


/**
 * 
 * @export
 * @interface FinancePaymentsMethodsListItem
 */
export interface FinancePaymentsMethodsListItem {
    /**
     * ID of the payment
     * @type {string}
     * @memberof FinancePaymentsMethodsListItem
     */
    'id': string;
    /**
     * 
     * @type {PaymentTypeEnum}
     * @memberof FinancePaymentsMethodsListItem
     */
    'type': PaymentTypeEnum;
    /**
     * Name of payment
     * @type {string}
     * @memberof FinancePaymentsMethodsListItem
     */
    'name': string;
    /**
     * Payment code, this is code from payment gateway
     * @type {string}
     * @memberof FinancePaymentsMethodsListItem
     */
    'code': string;
    /**
     * Description of payment
     * @type {string}
     * @memberof FinancePaymentsMethodsListItem
     */
    'description': string;
    /**
     * Image URL of payment
     * @type {string}
     * @memberof FinancePaymentsMethodsListItem
     */
    'imageURL': string;
    /**
     * Is payment method in maintenance
     * @type {boolean}
     * @memberof FinancePaymentsMethodsListItem
     */
    'isMaintenance': boolean;
}


/**
 * 
 * @export
 * @interface FinancePaymentsMethodsListResponse
 */
export interface FinancePaymentsMethodsListResponse {
    /**
     * 
     * @type {Array<FinancePaymentsMethodsListItem>}
     * @memberof FinancePaymentsMethodsListResponse
     */
    'items': Array<FinancePaymentsMethodsListItem>;
}
/**
 * 
 * @export
 * @interface FinanceReportsGetIncomeStatementsResponse
 */
export interface FinanceReportsGetIncomeStatementsResponse {
    /**
     * 
     * @type {FinanceReportsGetIncomeStatementsResponseSummary}
     * @memberof FinanceReportsGetIncomeStatementsResponse
     */
    'summary': FinanceReportsGetIncomeStatementsResponseSummary;
    /**
     * 
     * @type {Array<FinanceReportsGetIncomeStatementsResponseItem>}
     * @memberof FinanceReportsGetIncomeStatementsResponse
     */
    'items': Array<FinanceReportsGetIncomeStatementsResponseItem>;
}
/**
 * 
 * @export
 * @interface FinanceReportsGetIncomeStatementsResponseItem
 */
export interface FinanceReportsGetIncomeStatementsResponseItem {
    /**
     * 
     * @type {FinanceReportsGetIncomeStatementsResponseItemFarm}
     * @memberof FinanceReportsGetIncomeStatementsResponseItem
     */
    'farm': FinanceReportsGetIncomeStatementsResponseItemFarm;
    /**
     * 
     * @type {FinanceReportsGetIncomeStatementsResponseSummary}
     * @memberof FinanceReportsGetIncomeStatementsResponseItem
     */
    'incomeStatement': FinanceReportsGetIncomeStatementsResponseSummary;
}
/**
 * 
 * @export
 * @interface FinanceReportsGetIncomeStatementsResponseItemFarm
 */
export interface FinanceReportsGetIncomeStatementsResponseItemFarm {
    /**
     * id of a farm represented in UUID type 4
     * @type {string}
     * @memberof FinanceReportsGetIncomeStatementsResponseItemFarm
     */
    'id': string;
    /**
     * name of the farm
     * @type {string}
     * @memberof FinanceReportsGetIncomeStatementsResponseItemFarm
     */
    'name': string;
    /**
     * location name of where the farm is located
     * @type {string}
     * @memberof FinanceReportsGetIncomeStatementsResponseItemFarm
     */
    'location': string;
}
/**
 * 
 * @export
 * @interface FinanceReportsGetIncomeStatementsResponseSummary
 */
export interface FinanceReportsGetIncomeStatementsResponseSummary {
    /**
     * user\'s net income summary (\"Pendapatan Bersih\")
     * @type {number}
     * @memberof FinanceReportsGetIncomeStatementsResponseSummary
     */
    'net': number;
    /**
     * user\'s revenues summary (\"Pendapatan\")
     * @type {number}
     * @memberof FinanceReportsGetIncomeStatementsResponseSummary
     */
    'revenue': number;
    /**
     * user\'s expenses symmary (\"Pengeluaran\")
     * @type {number}
     * @memberof FinanceReportsGetIncomeStatementsResponseSummary
     */
    'expense': number;
}
/**
 * 
 * @export
 * @interface FinanceReportsIncomeStatementsGetDetailByFarmResponse
 */
export interface FinanceReportsIncomeStatementsGetDetailByFarmResponse {
    /**
     * 
     * @type {FinanceReportsGetIncomeStatementsResponseSummary}
     * @memberof FinanceReportsIncomeStatementsGetDetailByFarmResponse
     */
    'summary': FinanceReportsGetIncomeStatementsResponseSummary;
    /**
     * 
     * @type {FinanceReportsIncomeStatementsGetDetailByFarmResponseRevenueDetail}
     * @memberof FinanceReportsIncomeStatementsGetDetailByFarmResponse
     */
    'revenueDetail': FinanceReportsIncomeStatementsGetDetailByFarmResponseRevenueDetail;
    /**
     * 
     * @type {FinanceReportsIncomeStatementsGetDetailByFarmResponseExpenseDetail}
     * @memberof FinanceReportsIncomeStatementsGetDetailByFarmResponse
     */
    'expenseDetail': FinanceReportsIncomeStatementsGetDetailByFarmResponseExpenseDetail;
}
/**
 * 
 * @export
 * @interface FinanceReportsIncomeStatementsGetDetailByFarmResponseExpenseDetail
 */
export interface FinanceReportsIncomeStatementsGetDetailByFarmResponseExpenseDetail {
    /**
     * 
     * @type {FinanceReportsIncomeStatementsGetDetailByFarmResponseExpenseDetailData}
     * @memberof FinanceReportsIncomeStatementsGetDetailByFarmResponseExpenseDetail
     */
    'harvest': FinanceReportsIncomeStatementsGetDetailByFarmResponseExpenseDetailData;
    /**
     * 
     * @type {FinanceReportsIncomeStatementsGetDetailByFarmResponseExpenseDetailData}
     * @memberof FinanceReportsIncomeStatementsGetDetailByFarmResponseExpenseDetail
     */
    'upkeep': FinanceReportsIncomeStatementsGetDetailByFarmResponseExpenseDetailData;
    /**
     * 
     * @type {FinanceReportsIncomeStatementsGetDetailByFarmResponseExpenseDetailData}
     * @memberof FinanceReportsIncomeStatementsGetDetailByFarmResponseExpenseDetail
     */
    'pestAndDisease': FinanceReportsIncomeStatementsGetDetailByFarmResponseExpenseDetailData;
    /**
     * 
     * @type {FinanceReportsIncomeStatementsGetDetailByFarmResponseExpenseDetailData}
     * @memberof FinanceReportsIncomeStatementsGetDetailByFarmResponseExpenseDetail
     */
    'due': FinanceReportsIncomeStatementsGetDetailByFarmResponseExpenseDetailData;
    /**
     * 
     * @type {FinanceReportsIncomeStatementsGetDetailByFarmResponseExpenseDetailData}
     * @memberof FinanceReportsIncomeStatementsGetDetailByFarmResponseExpenseDetail
     */
    'agriInput': FinanceReportsIncomeStatementsGetDetailByFarmResponseExpenseDetailData;
}
/**
 * 
 * @export
 * @interface FinanceReportsIncomeStatementsGetDetailByFarmResponseExpenseDetailData
 */
export interface FinanceReportsIncomeStatementsGetDetailByFarmResponseExpenseDetailData {
    /**
     * user\'s total expense data for this category
     * @type {number}
     * @memberof FinanceReportsIncomeStatementsGetDetailByFarmResponseExpenseDetailData
     */
    'total': number;
    /**
     * 
     * @type {Array<FinanceReportsIncomeStatementsGetDetailByFarmResponseExpenseDetailDataItem>}
     * @memberof FinanceReportsIncomeStatementsGetDetailByFarmResponseExpenseDetailData
     */
    'items': Array<FinanceReportsIncomeStatementsGetDetailByFarmResponseExpenseDetailDataItem>;
}
/**
 * 
 * @export
 * @interface FinanceReportsIncomeStatementsGetDetailByFarmResponseExpenseDetailDataItem
 */
export interface FinanceReportsIncomeStatementsGetDetailByFarmResponseExpenseDetailDataItem {
    /**
     * expense data breakdown name in Bahasa Indonesia
     * @type {string}
     * @memberof FinanceReportsIncomeStatementsGetDetailByFarmResponseExpenseDetailDataItem
     */
    'label': string;
    /**
     * expense data breakdown value in Rp
     * @type {number}
     * @memberof FinanceReportsIncomeStatementsGetDetailByFarmResponseExpenseDetailDataItem
     */
    'value': number;
}
/**
 * 
 * @export
 * @interface FinanceReportsIncomeStatementsGetDetailByFarmResponseRevenueDetail
 */
export interface FinanceReportsIncomeStatementsGetDetailByFarmResponseRevenueDetail {
    /**
     * total weight of FFB sold in Kg (\"Total Berat TBS\")
     * @type {number}
     * @memberof FinanceReportsIncomeStatementsGetDetailByFarmResponseRevenueDetail
     */
    'ffbTotalWeightInKg': number;
    /**
     * average price of FFB sold per Kg in IDR (\"Rata-rata Harga TBS\")
     * @type {number}
     * @memberof FinanceReportsIncomeStatementsGetDetailByFarmResponseRevenueDetail
     */
    'averageFFBPricePerKg': number;
}
/**
 * Form validation error response. This is used for 400 Bad Request response when sending form data. 
 * @export
 * @interface FormValidationErrorResponse
 */
export interface FormValidationErrorResponse {
    /**
     * 
     * @type {string}
     * @memberof FormValidationErrorResponse
     */
    'error'?: string;
    /**
     * 
     * @type {Array<FormValidationErrorResponseFields>}
     * @memberof FormValidationErrorResponse
     */
    'fields'?: Array<FormValidationErrorResponseFields>;
}
/**
 * 
 * @export
 * @interface FormValidationErrorResponseFields
 */
export interface FormValidationErrorResponseFields {
    /**
     * 
     * @type {string}
     * @memberof FormValidationErrorResponseFields
     */
    'field'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormValidationErrorResponseFields
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface GamesCampaignLeaderboardAssets
 */
export interface GamesCampaignLeaderboardAssets {
    /**
     * 
     * @type {GamesCampaignLeaderboardAssetsBanner}
     * @memberof GamesCampaignLeaderboardAssets
     */
    'banner': GamesCampaignLeaderboardAssetsBanner;
}
/**
 * 
 * @export
 * @interface GamesCampaignLeaderboardAssetsBanner
 */
export interface GamesCampaignLeaderboardAssetsBanner {
    /**
     * url to the banner image, the link must be publicly accessible
     * @type {string}
     * @memberof GamesCampaignLeaderboardAssetsBanner
     */
    'imageUrl': string;
    /**
     * 
     * @type {BannerTypeEnum}
     * @memberof GamesCampaignLeaderboardAssetsBanner
     */
    'type': BannerTypeEnum;
    /**
     * link/route address to be used as the deeplink or other website redirection
     * @type {string}
     * @memberof GamesCampaignLeaderboardAssetsBanner
     */
    'embeddedLink': string;
}


/**
 * 
 * @export
 * @interface GamesCampaignLeaderboardDetail
 */
export interface GamesCampaignLeaderboardDetail {
    /**
     * id of the current leaderboard campaign
     * @type {string}
     * @memberof GamesCampaignLeaderboardDetail
     */
    'id': string;
    /**
     * start time of the current leaderboard campaign in UTC0 format
     * @type {number}
     * @memberof GamesCampaignLeaderboardDetail
     */
    'startAtUtc0': number;
    /**
     * end time of the current leaderboard campaign in UTC0 format
     * @type {number}
     * @memberof GamesCampaignLeaderboardDetail
     */
    'endAtUtc0': number;
    /**
     * number of player in the current leaderboard campaign
     * @type {number}
     * @memberof GamesCampaignLeaderboardDetail
     */
    'playerCount': number;
    /**
     * 
     * @type {GamesCampaignLeaderboardAssets}
     * @memberof GamesCampaignLeaderboardDetail
     */
    'assets': GamesCampaignLeaderboardAssets;
}
/**
 * 
 * @export
 * @interface GamesCampaignLeaderboardRankings
 */
export interface GamesCampaignLeaderboardRankings {
    /**
     * 
     * @type {Array<GamesCampaignLeaderboardRankingsItem>}
     * @memberof GamesCampaignLeaderboardRankings
     */
    'top': Array<GamesCampaignLeaderboardRankingsItem>;
    /**
     * 
     * @type {GamesCampaignLeaderboardRankingsItem}
     * @memberof GamesCampaignLeaderboardRankings
     */
    'self': GamesCampaignLeaderboardRankingsItem;
}
/**
 * 
 * @export
 * @interface GamesCampaignLeaderboardRankingsItem
 */
export interface GamesCampaignLeaderboardRankingsItem {
    /**
     * id of the leaderboard data
     * @type {string}
     * @memberof GamesCampaignLeaderboardRankingsItem
     */
    'id': string;
    /**
     * Player\'s ranking on current active leaderboard campaign
     * @type {number}
     * @memberof GamesCampaignLeaderboardRankingsItem
     */
    'ranking': number;
    /**
     * 
     * @type {UserSimpleDataResponse}
     * @memberof GamesCampaignLeaderboardRankingsItem
     */
    'user': UserSimpleDataResponse;
    /**
     * 
     * @type {GamesLeaderboardExpData}
     * @memberof GamesCampaignLeaderboardRankingsItem
     */
    'exp': GamesLeaderboardExpData;
}
/**
 * 
 * @export
 * @interface GamesGetCampaignLeaderboardResponse
 */
export interface GamesGetCampaignLeaderboardResponse {
    /**
     * timestamp at utc0 where the quiz game leaderboard is last updated
     * @type {number}
     * @memberof GamesGetCampaignLeaderboardResponse
     */
    'lastUpdatedAtUtc0': number;
    /**
     * 
     * @type {GamesGetCampaignLeaderboardResponseData}
     * @memberof GamesGetCampaignLeaderboardResponse
     */
    'data': GamesGetCampaignLeaderboardResponseData;
}
/**
 * 
 * @export
 * @interface GamesGetCampaignLeaderboardResponseData
 */
export interface GamesGetCampaignLeaderboardResponseData {
    /**
     * 
     * @type {GamesCampaignLeaderboardDetail}
     * @memberof GamesGetCampaignLeaderboardResponseData
     */
    'leaderboard': GamesCampaignLeaderboardDetail;
    /**
     * 
     * @type {GamesCampaignLeaderboardRankings}
     * @memberof GamesGetCampaignLeaderboardResponseData
     */
    'rankings': GamesCampaignLeaderboardRankings;
}
/**
 * 
 * @export
 * @interface GamesLeaderboardExpData
 */
export interface GamesLeaderboardExpData {
    /**
     * user\'s accumulated on current active leaderboard campaign
     * @type {number}
     * @memberof GamesLeaderboardExpData
     */
    'total': number;
    /**
     * breakdown by source list of user\'s exp
     * @type {Array<GamesLeaderboardExpDataDetailsItem>}
     * @memberof GamesLeaderboardExpData
     */
    'details': Array<GamesLeaderboardExpDataDetailsItem>;
}
/**
 * 
 * @export
 * @interface GamesLeaderboardExpDataDetailsItem
 */
export interface GamesLeaderboardExpDataDetailsItem {
    /**
     * 
     * @type {GamesLeaderboardRewardSourceEnum}
     * @memberof GamesLeaderboardExpDataDetailsItem
     */
    'source': GamesLeaderboardRewardSourceEnum;
    /**
     * user\'s accumulated exp from the specified source type
     * @type {number}
     * @memberof GamesLeaderboardExpDataDetailsItem
     */
    'exp': number;
}


/**
 * source of reward received by user in quiz campaign
 * @export
 * @enum {string}
 */

export const GamesLeaderboardRewardSourceEnum = {
    Streak: 'STREAK',
    Campaign: 'CAMPAIGN',
    Daily: 'DAILY',
    Referral: 'REFERRAL'
} as const;

export type GamesLeaderboardRewardSourceEnum = typeof GamesLeaderboardRewardSourceEnum[keyof typeof GamesLeaderboardRewardSourceEnum];


/**
 * 
 * @export
 * @interface GamesQuizCampaign
 */
export interface GamesQuizCampaign {
    /**
     * ID of the campaign
     * @type {string}
     * @memberof GamesQuizCampaign
     */
    'id': string;
    /**
     * start time of the current quiz campaign in UTC0 format
     * @type {number}
     * @memberof GamesQuizCampaign
     */
    'startAtUtc0': number;
    /**
     * end time of the current quiz campaign in UTC0 format
     * @type {number}
     * @memberof GamesQuizCampaign
     */
    'endAtUtc0': number;
    /**
     * List of reward
     * @type {Array<GamesQuizCampaignReward>}
     * @memberof GamesQuizCampaign
     */
    'rewards': Array<GamesQuizCampaignReward>;
}
/**
 * 
 * @export
 * @interface GamesQuizCampaignQuestionRetryRequest
 */
export interface GamesQuizCampaignQuestionRetryRequest {
    /**
     * ID of the question
     * @type {string}
     * @memberof GamesQuizCampaignQuestionRetryRequest
     */
    'questionId': string;
}
/**
 * 
 * @export
 * @interface GamesQuizCampaignQuestionRetryResponse
 */
export interface GamesQuizCampaignQuestionRetryResponse {
    /**
     * Indicator to show whether the Player can retry answering the question or not
     * @type {boolean}
     * @memberof GamesQuizCampaignQuestionRetryResponse
     */
    'isEligible': boolean;
}
/**
 * 
 * @export
 * @interface GamesQuizCampaignReward
 */
export interface GamesQuizCampaignReward {
    /**
     * Describe on which consecutive correct answers will be rewarded
     * @type {number}
     * @memberof GamesQuizCampaignReward
     */
    'day': number;
    /**
     * 
     * @type {GamesQuizCampaignRewardTypeEnum}
     * @memberof GamesQuizCampaignReward
     */
    'type': GamesQuizCampaignRewardTypeEnum;
    /**
     * Quantity of the reward
     * @type {number}
     * @memberof GamesQuizCampaignReward
     */
    'quantity': number;
}


/**
 * type of reward for quiz campaign
 * @export
 * @enum {string}
 */

export const GamesQuizCampaignRewardTypeEnum = {
    Point: 'POINT',
    Prize: 'PRIZE',
    Exp: 'EXP'
} as const;

export type GamesQuizCampaignRewardTypeEnum = typeof GamesQuizCampaignRewardTypeEnum[keyof typeof GamesQuizCampaignRewardTypeEnum];


/**
 * 
 * @export
 * @interface GamesQuizGetCampaignPlayerResponse
 */
export interface GamesQuizGetCampaignPlayerResponse {
    /**
     * 
     * @type {GamesQuizCampaign}
     * @memberof GamesQuizGetCampaignPlayerResponse
     */
    'campaign': GamesQuizCampaign;
    /**
     * 
     * @type {GamesQuizPlayer}
     * @memberof GamesQuizGetCampaignPlayerResponse
     */
    'player': GamesQuizPlayer;
    /**
     * 
     * @type {GamesQuizQuestionInfo}
     * @memberof GamesQuizGetCampaignPlayerResponse
     */
    'question': GamesQuizQuestionInfo;
}
/**
 * 
 * @export
 * @interface GamesQuizGetPlayerAnswersResponse
 */
export interface GamesQuizGetPlayerAnswersResponse {
    /**
     * List of question that has been answered correctly
     * @type {Array<GamesQuizPlayerAnswersItem>}
     * @memberof GamesQuizGetPlayerAnswersResponse
     */
    'items': Array<GamesQuizPlayerAnswersItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof GamesQuizGetPlayerAnswersResponse
     */
    'pagination': PaginationResponse;
}
/**
 * 
 * @export
 * @interface GamesQuizGetQuestionsResponse
 */
export interface GamesQuizGetQuestionsResponse {
    /**
     * quiz question id
     * @type {string}
     * @memberof GamesQuizGetQuestionsResponse
     */
    'id': string;
    /**
     * quiz question value
     * @type {string}
     * @memberof GamesQuizGetQuestionsResponse
     */
    'question': string;
    /**
     * attachment urls (image) for the specified question
     * @type {Array<string>}
     * @memberof GamesQuizGetQuestionsResponse
     */
    'attachments': Array<string>;
    /**
     * list of answer choices for this quiz question
     * @type {Array<GamesQuizGetQuestionsResponseAnswer>}
     * @memberof GamesQuizGetQuestionsResponse
     */
    'answers': Array<GamesQuizGetQuestionsResponseAnswer>;
}
/**
 * 
 * @export
 * @interface GamesQuizGetQuestionsResponseAnswer
 */
export interface GamesQuizGetQuestionsResponseAnswer {
    /**
     * quiz question\'s answer id
     * @type {string}
     * @memberof GamesQuizGetQuestionsResponseAnswer
     */
    'id': string;
    /**
     * quiz question\'s answer value
     * @type {string}
     * @memberof GamesQuizGetQuestionsResponseAnswer
     */
    'answer': string;
}
/**
 * 
 * @export
 * @interface GamesQuizPlayer
 */
export interface GamesQuizPlayer {
    /**
     * Player\'s current consecutive correct answer streak across campaign
     * @type {number}
     * @memberof GamesQuizPlayer
     */
    'overallStreak': number;
    /**
     * Player\'s current consecutive correct answer streak on this campaign
     * @type {number}
     * @memberof GamesQuizPlayer
     */
    'campaignStreak': number;
    /**
     * Player\'s maximum consecutive correct answer streak on this campaign
     * @type {number}
     * @memberof GamesQuizPlayer
     */
    'campaignMaxStreak': number;
    /**
     * Player\'s ranking on current active leaderboard campaign
     * @type {number}
     * @memberof GamesQuizPlayer
     */
    'ranking'?: number;
    /**
     * Player\'s accumulated on current active leaderboard campaign
     * @type {number}
     * @memberof GamesQuizPlayer
     */
    'exp'?: number;
    /**
     * 
     * @type {GamesQuizPlayerRewardsReceived}
     * @memberof GamesQuizPlayer
     */
    'rewardsReceived'?: GamesQuizPlayerRewardsReceived;
    /**
     * 
     * @type {GamesQuizPlayerAnswers}
     * @memberof GamesQuizPlayer
     */
    'quizAnswers'?: GamesQuizPlayerAnswers;
}
/**
 * 
 * @export
 * @interface GamesQuizPlayerAnswers
 */
export interface GamesQuizPlayerAnswers {
    /**
     * List of question that has been answered correctly
     * @type {Array<GamesQuizPlayerAnswersItem>}
     * @memberof GamesQuizPlayerAnswers
     */
    'items': Array<GamesQuizPlayerAnswersItem>;
}
/**
 * 
 * @export
 * @interface GamesQuizPlayerAnswersItem
 */
export interface GamesQuizPlayerAnswersItem {
    /**
     * ID of the player\'s chosen answer
     * @type {string}
     * @memberof GamesQuizPlayerAnswersItem
     */
    'playerAnswerId': string;
    /**
     * ID of the question
     * @type {string}
     * @memberof GamesQuizPlayerAnswersItem
     */
    'questionId': string;
    /**
     * UNIX millis when the question issued
     * @type {number}
     * @memberof GamesQuizPlayerAnswersItem
     */
    'quizTimeUtc0': number;
    /**
     * Information (Ilmu Sawit) from the question that is answerred correctly
     * @type {string}
     * @memberof GamesQuizPlayerAnswersItem
     */
    'knowledge': string;
}
/**
 * 
 * @export
 * @interface GamesQuizPlayerRewardsReceived
 */
export interface GamesQuizPlayerRewardsReceived {
    /**
     * List of received reward
     * @type {Array<GamesQuizPlayerRewardsReceivedItem>}
     * @memberof GamesQuizPlayerRewardsReceived
     */
    'items': Array<GamesQuizPlayerRewardsReceivedItem>;
}
/**
 * 
 * @export
 * @interface GamesQuizPlayerRewardsReceivedItem
 */
export interface GamesQuizPlayerRewardsReceivedItem {
    /**
     * Id of the reward
     * @type {string}
     * @memberof GamesQuizPlayerRewardsReceivedItem
     */
    'id': string;
    /**
     * Name of the reward
     * @type {string}
     * @memberof GamesQuizPlayerRewardsReceivedItem
     */
    'name': string;
    /**
     * Image of the reward
     * @type {string}
     * @memberof GamesQuizPlayerRewardsReceivedItem
     */
    'imageUrl': string;
    /**
     * 
     * @type {GamesQuizCampaignRewardTypeEnum}
     * @memberof GamesQuizPlayerRewardsReceivedItem
     */
    'type': GamesQuizCampaignRewardTypeEnum;
    /**
     * 
     * @type {GamesLeaderboardRewardSourceEnum}
     * @memberof GamesQuizPlayerRewardsReceivedItem
     */
    'source': GamesLeaderboardRewardSourceEnum;
    /**
     * Quantity of the reward
     * @type {number}
     * @memberof GamesQuizPlayerRewardsReceivedItem
     */
    'quantity': number;
    /**
     * UNIX millis when player get the reward
     * @type {number}
     * @memberof GamesQuizPlayerRewardsReceivedItem
     */
    'receivedAtUtc0': number;
}


/**
 * 
 * @export
 * @interface GamesQuizQuestionInfo
 */
export interface GamesQuizQuestionInfo {
    /**
     * UNIX millis to mark question reset time
     * @type {number}
     * @memberof GamesQuizQuestionInfo
     */
    'resetAtUtc0': number;
    /**
     * If true then player button \"Mulai\" is active. Otherwise the button is inactive.
     * @type {boolean}
     * @memberof GamesQuizQuestionInfo
     */
    'isEligible': boolean;
}
/**
 * 
 * @export
 * @interface GamesQuizQuestionsSubmitAnswerRequest
 */
export interface GamesQuizQuestionsSubmitAnswerRequest {
    /**
     * question id in UUID
     * @type {string}
     * @memberof GamesQuizQuestionsSubmitAnswerRequest
     */
    'questionId': string;
    /**
     * Invoice number
     * @type {string}
     * @memberof GamesQuizQuestionsSubmitAnswerRequest
     */
    'answerId': string;
}
/**
 * 
 * @export
 * @interface GamesQuizQuestionsSubmitAnswerResponse
 */
export interface GamesQuizQuestionsSubmitAnswerResponse {
    /**
     * quiz question id
     * @type {string}
     * @memberof GamesQuizQuestionsSubmitAnswerResponse
     */
    'questionId': string;
    /**
     * showing whether user\'s answer is correct or not
     * @type {boolean}
     * @memberof GamesQuizQuestionsSubmitAnswerResponse
     */
    'isCorrect': boolean;
    /**
     * knowledge regarding this quiz question, only return value when \'isCorrect\' is true
     * @type {string}
     * @memberof GamesQuizQuestionsSubmitAnswerResponse
     */
    'knowledge'?: string;
    /**
     * 
     * @type {GamesQuizCampaign}
     * @memberof GamesQuizQuestionsSubmitAnswerResponse
     */
    'campaign': GamesQuizCampaign;
    /**
     * 
     * @type {GamesQuizPlayer}
     * @memberof GamesQuizQuestionsSubmitAnswerResponse
     */
    'player': GamesQuizPlayer;
    /**
     * 
     * @type {GamesQuizQuestionsSubmitAnswerResponseRewards}
     * @memberof GamesQuizQuestionsSubmitAnswerResponse
     */
    'rewards'?: GamesQuizQuestionsSubmitAnswerResponseRewards;
}
/**
 * 
 * @export
 * @interface GamesQuizQuestionsSubmitAnswerResponseRewards
 */
export interface GamesQuizQuestionsSubmitAnswerResponseRewards {
    /**
     * flag to show whether the received rewards is raffle (client app show Prize Box page)
     * @type {boolean}
     * @memberof GamesQuizQuestionsSubmitAnswerResponseRewards
     */
    'isRaffle': boolean;
    /**
     * List of received reward
     * @type {Array<GamesQuizPlayerRewardsReceivedItem>}
     * @memberof GamesQuizQuestionsSubmitAnswerResponseRewards
     */
    'items': Array<GamesQuizPlayerRewardsReceivedItem>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const GenderEnum = {
    Male: 'MALE',
    Famale: 'FAMALE'
} as const;

export type GenderEnum = typeof GenderEnum[keyof typeof GenderEnum];


/**
 * 
 * @export
 * @interface GeoJSONFeature
 */
export interface GeoJSONFeature {
    /**
     * 
     * @type {GeoJSONFeatureEnum}
     * @memberof GeoJSONFeature
     */
    'type': GeoJSONFeatureEnum;
    /**
     * 
     * @type {GeoJSONFeatureGeometry}
     * @memberof GeoJSONFeature
     */
    'geometry': GeoJSONFeatureGeometry;
    /**
     * 
     * @type {GeoJSONFeatureProperties}
     * @memberof GeoJSONFeature
     */
    'properties'?: GeoJSONFeatureProperties;
}


/**
 * Feature Collection Enum (based on geoJSON format)
 * @export
 * @enum {string}
 */

export const GeoJSONFeatureCollectionEnum = {
    FeatureCollection: 'FeatureCollection'
} as const;

export type GeoJSONFeatureCollectionEnum = typeof GeoJSONFeatureCollectionEnum[keyof typeof GeoJSONFeatureCollectionEnum];


/**
 * Feature Enum (based on geoJSON format)
 * @export
 * @enum {string}
 */

export const GeoJSONFeatureEnum = {
    Feature: 'Feature'
} as const;

export type GeoJSONFeatureEnum = typeof GeoJSONFeatureEnum[keyof typeof GeoJSONFeatureEnum];


/**
 * @type GeoJSONFeatureGeometry
 * Follow GeoJSON Geometry is format based on JavaScript Object Notation (JSON). It has several types of object (LineString MultiLineString Polygon MultiPolygon Point) and using WGS84 coordinate system (EPSG:4326) for interoperability reason with GIS systems.
 * @export
 */
export type GeoJSONFeatureGeometry = LineString | MultiLineString | MultiPolygon | Point | Polygon;

/**
 * Farm data information related with business.
 * @export
 * @interface GeoJSONFeatureProperties
 */
export interface GeoJSONFeatureProperties {
    /**
     * Survey ID is generated by Android\'s app in order to store data in sqlite while working offline.
     * @type {string}
     * @memberof GeoJSONFeatureProperties
     */
    'surveyId': string;
    /**
     * Surveyor ID from person who conducts a survey.
     * @type {string}
     * @memberof GeoJSONFeatureProperties
     */
    'surveyorId': string;
    /**
     * Farm owner name. It will be used as identification for member name.
     * @type {string}
     * @memberof GeoJSONFeatureProperties
     */
    'name': string;
    /**
     * Allowed mill ID where FFB can be sent.
     * @type {string}
     * @memberof GeoJSONFeatureProperties
     */
    'millId': string;
    /**
     * external reference id that belongs to geolocation entity (ex:sap do id from delivery order attached to this entity).
     * @type {string}
     * @memberof GeoJSONFeatureProperties
     */
    'externalId'?: string;
    /**
     * Delivery Order Name. it will be used as delivery order identification of the survey data.
     * @type {string}
     * @memberof GeoJSONFeatureProperties
     */
    'doName'?: string;
    /**
     * Delivery order id that farmers belong to.
     * @type {string}
     * @memberof GeoJSONFeatureProperties
     */
    'doId'?: string;
    /**
     * farm group association id that belong to CSV.
     * @type {string}
     * @memberof GeoJSONFeatureProperties
     */
    'farmGroupAssociationId'?: string;
    /**
     * If farm group association is not found, fill the name into the survey data in this field, if found you can leave this field empty.
     * @type {string}
     * @memberof GeoJSONFeatureProperties
     */
    'farmGroupAssociationName'?: string;
    /**
     * farm group id that belong to farm group association.
     * @type {string}
     * @memberof GeoJSONFeatureProperties
     */
    'farmGroupId'?: string;
    /**
     * If farm group is not found, fill the name into the survey data in this field, if found you can leave this field empty.
     * @type {string}
     * @memberof GeoJSONFeatureProperties
     */
    'farmGroupName'?: string;
    /**
     * Encrypted phoneNumber using RSA256 with public key that\'s retrieved from local database
     * @type {string}
     * @memberof GeoJSONFeatureProperties
     */
    'phoneNumber': string;
    /**
     * Hash PIN using HMAC SHA 256
     * @type {string}
     * @memberof GeoJSONFeatureProperties
     */
    'pin': string;
    /**
     * Farm name. It will be used as identification for farm name.
     * @type {string}
     * @memberof GeoJSONFeatureProperties
     */
    'farmName'?: string;
    /**
     * village id that belong to this entity.
     * @type {string}
     * @memberof GeoJSONFeatureProperties
     */
    'villageId'?: string;
    /**
     * Farm area in hectare
     * @type {number}
     * @memberof GeoJSONFeatureProperties
     */
    'farmArea'?: number;
    /**
     * Productive plant area on the farm in hectare. It should not larger than farmArea
     * @type {number}
     * @memberof GeoJSONFeatureProperties
     */
    'productiveFarmArea'?: number;
    /**
     * Non productive plant area on the farm in hectare. It should not larger than farmArea
     * @type {number}
     * @memberof GeoJSONFeatureProperties
     */
    'nonProductiveFarmArea'?: number;
    /**
     * Monthly yield of oil palm FFB in kg.
     * @type {number}
     * @memberof GeoJSONFeatureProperties
     */
    'averageEstateMonthlyYield'?: number;
    /**
     * 
     * @type {EstateLicenseEnum}
     * @memberof GeoJSONFeatureProperties
     */
    'estateLicense'?: EstateLicenseEnum;
    /**
     * 
     * @type {STDBorNIBEnum}
     * @memberof GeoJSONFeatureProperties
     */
    'STDBorNIB'?: STDBorNIBEnum;
    /**
     * 
     * @type {SPPLorAMDALEnum}
     * @memberof GeoJSONFeatureProperties
     */
    'SPPLorAMDAL'?: SPPLorAMDALEnum;
    /**
     * 
     * @type {NonSpatialIssueLocalCommunityRightsEnum}
     * @memberof GeoJSONFeatureProperties
     */
    'localCommunityRightsIssue'?: NonSpatialIssueLocalCommunityRightsEnum;
    /**
     * 
     * @type {NonSpatialIssueWorkerRightsEnum}
     * @memberof GeoJSONFeatureProperties
     */
    'workerRightsIssue'?: NonSpatialIssueWorkerRightsEnum;
    /**
     * 
     * @type {NonSpatialIssueHumanRightsEnum}
     * @memberof GeoJSONFeatureProperties
     */
    'humanRightsIssue'?: NonSpatialIssueHumanRightsEnum;
    /**
     * 
     * @type {NonSpatialIssueIndigenousPeopleRightsEnum}
     * @memberof GeoJSONFeatureProperties
     */
    'indigenousPeopleRightsIssue'?: NonSpatialIssueIndigenousPeopleRightsEnum;
    /**
     * 
     * @type {FarmManagementTypeEnum}
     * @memberof GeoJSONFeatureProperties
     */
    'farmManagementType'?: FarmManagementTypeEnum;
    /**
     * 
     * @type {EmploymentComplianceForCompaniesEnum}
     * @memberof GeoJSONFeatureProperties
     */
    'employmentComplianceForCompanies'?: EmploymentComplianceForCompaniesEnum;
    /**
     * 
     * @type {TaxComplianceForCompaniesEnum}
     * @memberof GeoJSONFeatureProperties
     */
    'taxComplianceForCompanies'?: TaxComplianceForCompaniesEnum;
    /**
     * 
     * @type {EthicsComplianceForCompaniesEnum}
     * @memberof GeoJSONFeatureProperties
     */
    'ethicsComplianceForCompanies'?: EthicsComplianceForCompaniesEnum;
    /**
     * 
     * @type {FarmBuyerAssociationEnum}
     * @memberof GeoJSONFeatureProperties
     */
    'farmBuyerAssociation'?: FarmBuyerAssociationEnum;
    /**
     * 
     * @type {SustainableCertificateEnum}
     * @memberof GeoJSONFeatureProperties
     */
    'sustainableCertificate'?: SustainableCertificateEnum;
    /**
     * Year of planting. Only use single planted year even the farm is polyculture.
     * @type {number}
     * @memberof GeoJSONFeatureProperties
     */
    'plantedYear'?: number;
    /**
     * 
     * @type {SeedTypeEnum}
     * @memberof GeoJSONFeatureProperties
     * @deprecated
     */
    'seedType'?: SeedTypeEnum;
    /**
     * Monthly yield of oil palm FFB in tonnage.
     * @type {number}
     * @memberof GeoJSONFeatureProperties
     */
    'monthlyYieldEstate'?: number;
    /**
     * 
     * @type {NaturalVegetationEnum}
     * @memberof GeoJSONFeatureProperties
     */
    'naturalVegetation'?: NaturalVegetationEnum;
    /**
     * 
     * @type {LandConditionBeforeClearingEnum}
     * @memberof GeoJSONFeatureProperties
     */
    'landConditionBeforeClearing'?: LandConditionBeforeClearingEnum;
    /**
     * 
     * @type {LandClearingMethodEnum}
     * @memberof GeoJSONFeatureProperties
     */
    'landClearingMethod'?: LandClearingMethodEnum;
    /**
     * Type of coordinate data source
     * @type {string}
     * @memberof GeoJSONFeatureProperties
     */
    'source'?: GeoJSONFeaturePropertiesSourceEnum;
    /**
     * Farm id this for this GeoJSON feature(generated when feature entity is created)
     * @type {string}
     * @memberof GeoJSONFeatureProperties
     */
    'farmId'?: string;
}

export const GeoJSONFeaturePropertiesSourceEnum = {
    Gps: 'GPS',
    Drawing: 'Drawing'
} as const;

export type GeoJSONFeaturePropertiesSourceEnum = typeof GeoJSONFeaturePropertiesSourceEnum[keyof typeof GeoJSONFeaturePropertiesSourceEnum];

/**
 * 
 * @export
 * @interface GetActionRemindersResponse
 */
export interface GetActionRemindersResponse {
    /**
     * 
     * @type {Array<GetActionRemindersResponseItem>}
     * @memberof GetActionRemindersResponse
     */
    'items': Array<GetActionRemindersResponseItem>;
}
/**
 * 
 * @export
 * @interface GetActionRemindersResponseItem
 */
export interface GetActionRemindersResponseItem {
    /**
     * Id of action reminder
     * @type {string}
     * @memberof GetActionRemindersResponseItem
     */
    'id': string;
    /**
     * title of action reminder
     * @type {string}
     * @memberof GetActionRemindersResponseItem
     */
    'title': string;
    /**
     * description of action reminder
     * @type {string}
     * @memberof GetActionRemindersResponseItem
     */
    'description': string;
    /**
     * URL of action reminder icon
     * @type {string}
     * @memberof GetActionRemindersResponseItem
     */
    'icon': string;
    /**
     * type value of action reminder
     * @type {string}
     * @memberof GetActionRemindersResponseItem
     */
    'typeValue': string;
    /**
     * card type of action reminder
     * @type {string}
     * @memberof GetActionRemindersResponseItem
     */
    'cardType': string;
    /**
     * text of action reminder CTA
     * @type {string}
     * @memberof GetActionRemindersResponseItem
     */
    'ctaText': string;
    /**
     * route of action reminder CTA
     * @type {string}
     * @memberof GetActionRemindersResponseItem
     */
    'ctaRoute': string;
    /**
     * the feature type of action reminder
     * @type {string}
     * @memberof GetActionRemindersResponseItem
     */
    'featureType': string;
}
/**
 * 
 * @export
 * @interface GetCampaignEnlistedParticipants
 */
export interface GetCampaignEnlistedParticipants {
    /**
     * List of participant (member/supplier) enlisted in the campaign
     * @type {Array<GetCampaignParticipantItem>}
     * @memberof GetCampaignEnlistedParticipants
     */
    'items': Array<GetCampaignParticipantItem>;
}
/**
 * 
 * @export
 * @interface GetCampaignMemberTargetItem
 */
export interface GetCampaignMemberTargetItem {
    /**
     * Target ID, represented in UUID type 4
     * @type {string}
     * @memberof GetCampaignMemberTargetItem
     */
    'id': string;
    /**
     * Target name
     * @type {string}
     * @memberof GetCampaignMemberTargetItem
     */
    'name': string;
    /**
     * Target value
     * @type {number}
     * @memberof GetCampaignMemberTargetItem
     */
    'value': number;
}
/**
 * 
 * @export
 * @interface GetCampaignParticipantItem
 */
export interface GetCampaignParticipantItem {
    /**
     * User ID of the member
     * @type {string}
     * @memberof GetCampaignParticipantItem
     */
    'userId': string;
    /**
     * Member name
     * @type {string}
     * @memberof GetCampaignParticipantItem
     */
    'name': string;
    /**
     * Member\'s company name (Agen DO/SP/PB)
     * @type {string}
     * @memberof GetCampaignParticipantItem
     */
    'companyName': string;
    /**
     * List of member targets
     * @type {Array<GetCampaignMemberTargetItem>}
     * @memberof GetCampaignParticipantItem
     */
    'targetList': Array<GetCampaignMemberTargetItem>;
    /**
     * Member SawitPoin
     * @type {number}
     * @memberof GetCampaignParticipantItem
     */
    'point': number;
    /**
     * Progress of campaign target. It could be ton for campaign increment type, and percentage for others.
     * @type {number}
     * @memberof GetCampaignParticipantItem
     */
    'progress': number;
}
/**
 * Response data
 * @export
 * @interface GetCampaignResponse
 */
export interface GetCampaignResponse {
    /**
     * Campaign name
     * @type {string}
     * @memberof GetCampaignResponse
     */
    'name': string;
    /**
     * Campaign type
     * @type {string}
     * @memberof GetCampaignResponse
     */
    'type': string;
    /**
     * Campaign type ID represented by UUID type 4
     * @type {string}
     * @memberof GetCampaignResponse
     */
    'campaignTypeId': string;
    /**
     * Campaign creation date (in epoch). The time will be set at midnight (00:00) UTC-0
     * @type {number}
     * @memberof GetCampaignResponse
     */
    'createdDate': number;
    /**
     * 
     * @type {CampaignStatusEnum}
     * @memberof GetCampaignResponse
     */
    'status': CampaignStatusEnum;
    /**
     * The lable of status that FE will show. Currently using Indonesian language
     * @type {string}
     * @memberof GetCampaignResponse
     */
    'statusLabel': string;
    /**
     * Campaign start datetime (in epoch). Will be used to calculate the promotion duration.
     * @type {number}
     * @memberof GetCampaignResponse
     */
    'startAt': number;
    /**
     * Campaign end datetime (in epoch). Will be used to calculate the promotion duration.
     * @type {number}
     * @memberof GetCampaignResponse
     */
    'endAt': number;
    /**
     * Total budget of SawitPoin
     * @type {number}
     * @memberof GetCampaignResponse
     */
    'totalPoint': number;
    /**
     * Default reward poin value
     * @type {number}
     * @memberof GetCampaignResponse
     */
    'defaultRewardValue': number;
    /**
     * List of member targets
     * @type {Array<GetCampaignTargetItem>}
     * @memberof GetCampaignResponse
     */
    'targetHeaders': Array<GetCampaignTargetItem>;
    /**
     * 
     * @type {GetCampaignEnlistedParticipants}
     * @memberof GetCampaignResponse
     */
    'enlistedParticipants': GetCampaignEnlistedParticipants;
    /**
     * Campaign code
     * @type {string}
     * @memberof GetCampaignResponse
     */
    'campaignCode': string;
    /**
     * Count of participant (member/supplier) enlisted in the campaign
     * @type {number}
     * @memberof GetCampaignResponse
     */
    'participantCount': number;
    /**
     * 
     * @type {CampaignParticipantTypeEnum}
     * @memberof GetCampaignResponse
     */
    'participantType': CampaignParticipantTypeEnum;
}


/**
 * 
 * @export
 * @interface GetCampaignTargetItem
 */
export interface GetCampaignTargetItem {
    /**
     * Target ID, represented in UUID type 4
     * @type {string}
     * @memberof GetCampaignTargetItem
     */
    'id': string;
    /**
     * Target name
     * @type {string}
     * @memberof GetCampaignTargetItem
     */
    'name': string;
    /**
     * Target value
     * @type {number}
     * @memberof GetCampaignTargetItem
     */
    'defaultTargetValue': number;
}
/**
 * 
 * @export
 * @interface GetContactsResponse
 */
export interface GetContactsResponse {
    /**
     * 
     * @type {Array<GetContactsResponseItem>}
     * @memberof GetContactsResponse
     */
    'items': Array<GetContactsResponseItem>;
}
/**
 * 
 * @export
 * @interface GetContactsResponseItem
 */
export interface GetContactsResponseItem {
    /**
     * Contacts Id
     * @type {string}
     * @memberof GetContactsResponseItem
     */
    'id': string;
    /**
     * name of user
     * @type {string}
     * @memberof GetContactsResponseItem
     */
    'userName': string;
    /**
     * 
     * @type {JobNameEnum}
     * @memberof GetContactsResponseItem
     */
    'jobName': JobNameEnum;
    /**
     * Business Id
     * @type {string}
     * @memberof GetContactsResponseItem
     */
    'businessId': string;
    /**
     * name of business
     * @type {string}
     * @memberof GetContactsResponseItem
     */
    'businessName': string;
}


/**
 * 
 * @export
 * @interface GetLeadsSummaryResponse
 */
export interface GetLeadsSummaryResponse {
    /**
     * Number of leads
     * @type {number}
     * @memberof GetLeadsSummaryResponse
     */
    'leadsCount': number;
    /**
     * Number of sales (in this case `User`)
     * @type {number}
     * @memberof GetLeadsSummaryResponse
     */
    'saleCount': number;
    /**
     * Mark whether the user can do FFB Sale Price creation activity or not
     * @type {boolean}
     * @memberof GetLeadsSummaryResponse
     */
    'showFfbSalePrice': boolean;
    /**
     * Total commission for the Ambassador
     * @type {number}
     * @memberof GetLeadsSummaryResponse
     */
    'commission': number;
    /**
     * Total retention (active leads) for this ambassador
     * @type {number}
     * @memberof GetLeadsSummaryResponse
     */
    'leadRetention': number;
    /**
     * Tax for the commission
     * @type {number}
     * @memberof GetLeadsSummaryResponse
     */
    'tax': number;
}
/**
 * 
 * @export
 * @interface GetListLoyaltyPointDisbursementRequestResponse
 */
export interface GetListLoyaltyPointDisbursementRequestResponse {
    /**
     * 
     * @type {Array<GetListLoyaltyPointDisbursementRequestResponseItem>}
     * @memberof GetListLoyaltyPointDisbursementRequestResponse
     */
    'items': Array<GetListLoyaltyPointDisbursementRequestResponseItem>;
}
/**
 * 
 * @export
 * @interface GetListLoyaltyPointDisbursementRequestResponseItem
 */
export interface GetListLoyaltyPointDisbursementRequestResponseItem {
    /**
     * Id of request point disbursement
     * @type {string}
     * @memberof GetListLoyaltyPointDisbursementRequestResponseItem
     */
    'id': string;
    /**
     * date of disbursement request
     * @type {number}
     * @memberof GetListLoyaltyPointDisbursementRequestResponseItem
     */
    'requestDate': number;
    /**
     * name of user or requestor
     * @type {string}
     * @memberof GetListLoyaltyPointDisbursementRequestResponseItem
     */
    'applicantsName': string;
    /**
     * 
     * @type {DepartmentPointDisbursementRequestEnum}
     * @memberof GetListLoyaltyPointDisbursementRequestResponseItem
     */
    'department': DepartmentPointDisbursementRequestEnum;
    /**
     * Name of the disbursement type
     * @type {string}
     * @memberof GetListLoyaltyPointDisbursementRequestResponseItem
     */
    'disbursementType': string;
    /**
     * Purpose of disbursement
     * @type {string}
     * @memberof GetListLoyaltyPointDisbursementRequestResponseItem
     */
    'purpose': string;
    /**
     * Total sawitpoint
     * @type {number}
     * @memberof GetListLoyaltyPointDisbursementRequestResponseItem
     */
    'totalPoint': number;
    /**
     * Total recipient of sawitpoin
     * @type {number}
     * @memberof GetListLoyaltyPointDisbursementRequestResponseItem
     */
    'totalRecipients': number;
    /**
     * status request
     * @type {string}
     * @memberof GetListLoyaltyPointDisbursementRequestResponseItem
     */
    'status': string;
}


/**
 * 
 * @export
 * @interface GetListLoyaltyWeighbridgeCostResponse
 */
export interface GetListLoyaltyWeighbridgeCostResponse {
    /**
     * 
     * @type {Array<GetListLoyaltyWeighbridgeCostResponseItem>}
     * @memberof GetListLoyaltyWeighbridgeCostResponse
     */
    'items': Array<GetListLoyaltyWeighbridgeCostResponseItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof GetListLoyaltyWeighbridgeCostResponse
     */
    'pagination'?: PaginationResponse;
}
/**
 * 
 * @export
 * @interface GetListLoyaltyWeighbridgeCostResponseItem
 */
export interface GetListLoyaltyWeighbridgeCostResponseItem {
    /**
     * Id of supply cost master
     * @type {string}
     * @memberof GetListLoyaltyWeighbridgeCostResponseItem
     */
    'id': string;
    /**
     * Name of supply cost
     * @type {string}
     * @memberof GetListLoyaltyWeighbridgeCostResponseItem
     */
    'name': string;
    /**
     * 
     * @type {WeighbridgeCostTypeEnum}
     * @memberof GetListLoyaltyWeighbridgeCostResponseItem
     */
    'type': WeighbridgeCostTypeEnum;
    /**
     * Supply cost. If weighbridge data doesn\'t exist yet, the default cost will be returned
     * @type {number}
     * @memberof GetListLoyaltyWeighbridgeCostResponseItem
     */
    'cost': number;
}


/**
 * 
 * @export
 * @interface GetLoyaltyPointDisbursementRequestDataResponse
 */
export interface GetLoyaltyPointDisbursementRequestDataResponse {
    /**
     * 
     * @type {Array<LoyaltyRequestDataDisbursementType>}
     * @memberof GetLoyaltyPointDisbursementRequestDataResponse
     */
    'disbursementTypes': Array<LoyaltyRequestDataDisbursementType>;
}
/**
 * 
 * @export
 * @interface GetLoyaltyPointDisbursementRequestResponse
 */
export interface GetLoyaltyPointDisbursementRequestResponse {
    /**
     * Id of disbursement request
     * @type {string}
     * @memberof GetLoyaltyPointDisbursementRequestResponse
     */
    'id': string;
    /**
     * date of disbursement request
     * @type {number}
     * @memberof GetLoyaltyPointDisbursementRequestResponse
     */
    'requestDate': number;
    /**
     * name of user or requestor
     * @type {string}
     * @memberof GetLoyaltyPointDisbursementRequestResponse
     */
    'applicantsName': string;
    /**
     * 
     * @type {DepartmentPointDisbursementRequestEnum}
     * @memberof GetLoyaltyPointDisbursementRequestResponse
     */
    'department': DepartmentPointDisbursementRequestEnum;
    /**
     * Name of disbursement type
     * @type {string}
     * @memberof GetLoyaltyPointDisbursementRequestResponse
     */
    'disbursementType': string;
    /**
     * Purpose of disbursement request
     * @type {string}
     * @memberof GetLoyaltyPointDisbursementRequestResponse
     */
    'purpose': string;
    /**
     * Title of disbursement request
     * @type {string}
     * @memberof GetLoyaltyPointDisbursementRequestResponse
     */
    'title': string;
    /**
     * Description of disbursement request
     * @type {string}
     * @memberof GetLoyaltyPointDisbursementRequestResponse
     */
    'description': string;
    /**
     * Status of disbursement request
     * @type {string}
     * @memberof GetLoyaltyPointDisbursementRequestResponse
     */
    'status': string;
    /**
     * Reason of disbursement request when rejected
     * @type {string}
     * @memberof GetLoyaltyPointDisbursementRequestResponse
     */
    'reason': string;
    /**
     * Total sawitpoint
     * @type {number}
     * @memberof GetLoyaltyPointDisbursementRequestResponse
     */
    'totalPoint': number;
    /**
     * Total recipient of sawitpoin
     * @type {number}
     * @memberof GetLoyaltyPointDisbursementRequestResponse
     */
    'totalRecipients': number;
    /**
     * 
     * @type {Array<GetLoyaltyPointDisbursementRequestResponseRecipients>}
     * @memberof GetLoyaltyPointDisbursementRequestResponse
     */
    'recipients': Array<GetLoyaltyPointDisbursementRequestResponseRecipients>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof GetLoyaltyPointDisbursementRequestResponse
     */
    'pagination': PaginationResponse;
}


/**
 * 
 * @export
 * @interface GetLoyaltyPointDisbursementRequestResponseRecipients
 */
export interface GetLoyaltyPointDisbursementRequestResponseRecipients {
    /**
     * Id of recipient or user
     * @type {string}
     * @memberof GetLoyaltyPointDisbursementRequestResponseRecipients
     */
    'id': string;
    /**
     * Name of recipient of point disbursement.
     * @type {string}
     * @memberof GetLoyaltyPointDisbursementRequestResponseRecipients
     */
    'userName': string;
    /**
     * Phone number starting with 0 as prefix (08xxxxxxxxx)
     * @type {string}
     * @memberof GetLoyaltyPointDisbursementRequestResponseRecipients
     */
    'phoneNo': string;
    /**
     * Point of recipient
     * @type {number}
     * @memberof GetLoyaltyPointDisbursementRequestResponseRecipients
     */
    'point': number;
}
/**
 * 
 * @export
 * @interface GetOrderWarehouseResponse
 */
export interface GetOrderWarehouseResponse {
    /**
     * Invoice number
     * @type {string}
     * @memberof GetOrderWarehouseResponse
     */
    'invoiceNo': string;
    /**
     * Invoice status
     * @type {string}
     * @memberof GetOrderWarehouseResponse
     */
    'invoiceStatus': string;
    /**
     * Amount due
     * @type {number}
     * @memberof GetOrderWarehouseResponse
     */
    'amountDue': number;
    /**
     * Customer name
     * @type {string}
     * @memberof GetOrderWarehouseResponse
     */
    'customerName': string;
    /**
     * Phone number starting with 0 as prefix (08xxxxxxxxx)
     * @type {string}
     * @memberof GetOrderWarehouseResponse
     */
    'customerPhoneNo': string;
    /**
     * Sale order ID represented in UUID type 4
     * @type {string}
     * @memberof GetOrderWarehouseResponse
     */
    'orderId': string;
    /**
     * Order number
     * @type {string}
     * @memberof GetOrderWarehouseResponse
     */
    'orderNo': string;
    /**
     * Order date (in epoch) formatted in UTC-0
     * @type {number}
     * @memberof GetOrderWarehouseResponse
     */
    'orderDateAtUtc0': number;
    /**
     * 
     * @type {SaleOrderStatusEnum}
     * @memberof GetOrderWarehouseResponse
     */
    'orderStatus': SaleOrderStatusEnum;
    /**
     * 
     * @type {DeliveryTypeEnum}
     * @memberof GetOrderWarehouseResponse
     */
    'deliveryMethod': DeliveryTypeEnum;
    /**
     * List of product items
     * @type {Array<GetOrderWarehouseResponseProductItem>}
     * @memberof GetOrderWarehouseResponse
     */
    'productItems': Array<GetOrderWarehouseResponseProductItem>;
    /**
     * Recipient name
     * @type {string}
     * @memberof GetOrderWarehouseResponse
     */
    'recipientName': string;
    /**
     * Phone number starting with 0 as prefix (08xxxxxxxxx)
     * @type {string}
     * @memberof GetOrderWarehouseResponse
     */
    'recipientPhoneNo': string;
    /**
     * Vehicle license number
     * @type {string}
     * @memberof GetOrderWarehouseResponse
     */
    'vehicleLicenseNo': string;
}


/**
 * 
 * @export
 * @interface GetOrderWarehouseResponseProductItem
 */
export interface GetOrderWarehouseResponseProductItem {
    /**
     * Quantity of Product
     * @type {number}
     * @memberof GetOrderWarehouseResponseProductItem
     */
    'quantity': number;
    /**
     * Product current price
     * @type {number}
     * @memberof GetOrderWarehouseResponseProductItem
     */
    'price': number;
    /**
     * Name of Product
     * @type {string}
     * @memberof GetOrderWarehouseResponseProductItem
     */
    'name': string;
    /**
     * Product current price
     * @type {number}
     * @memberof GetOrderWarehouseResponseProductItem
     */
    'totalPrice': number;
}
/**
 * 
 * @export
 * @interface GetPlantationExpenseResponse
 */
export interface GetPlantationExpenseResponse {
    /**
     * id of a plantation sale in UUID type 4
     * @type {string}
     * @memberof GetPlantationExpenseResponse
     */
    'id': string;
    /**
     * Date of expense
     * @type {number}
     * @memberof GetPlantationExpenseResponse
     */
    'date': number;
    /**
     * id of farm group in UUID type 4
     * @type {string}
     * @memberof GetPlantationExpenseResponse
     */
    'groupId': string;
    /**
     * name of group
     * @type {string}
     * @memberof GetPlantationExpenseResponse
     */
    'groupName': string;
    /**
     * wages for administration
     * @type {number}
     * @memberof GetPlantationExpenseResponse
     */
    'adminWages': number;
    /**
     * wages for operational
     * @type {number}
     * @memberof GetPlantationExpenseResponse
     */
    'operationalWages': number;
    /**
     * wages for maintenance
     * @type {number}
     * @memberof GetPlantationExpenseResponse
     */
    'maintenanceWages': number;
}
/**
 * 
 * @export
 * @interface GetPlantationHarvestCostResponse
 */
export interface GetPlantationHarvestCostResponse {
    /**
     * 
     * @type {Array<GetPlantationHarvestCostResponseItem>}
     * @memberof GetPlantationHarvestCostResponse
     */
    'items': Array<GetPlantationHarvestCostResponseItem>;
}
/**
 * 
 * @export
 * @interface GetPlantationHarvestCostResponseActivityItem
 */
export interface GetPlantationHarvestCostResponseActivityItem {
    /**
     * id of harvest cost in UUID type 4
     * @type {string}
     * @memberof GetPlantationHarvestCostResponseActivityItem
     */
    'id'?: string;
    /**
     * 
     * @type {PlantationHarvestActivityTypeEnum}
     * @memberof GetPlantationHarvestCostResponseActivityItem
     */
    'activityType': PlantationHarvestActivityTypeEnum;
    /**
     * id of user or leader (contact) in UUID type 4
     * @type {string}
     * @memberof GetPlantationHarvestCostResponseActivityItem
     */
    'contactId': string;
    /**
     * name of user or leader
     * @type {string}
     * @memberof GetPlantationHarvestCostResponseActivityItem
     */
    'userName': string;
    /**
     * harvest wages on unit Upah/Kg
     * @type {number}
     * @memberof GetPlantationHarvestCostResponseActivityItem
     */
    'wages': number;
}


/**
 * 
 * @export
 * @interface GetPlantationHarvestCostResponseItem
 */
export interface GetPlantationHarvestCostResponseItem {
    /**
     * id of a weighbridge in UUID type 4
     * @type {string}
     * @memberof GetPlantationHarvestCostResponseItem
     */
    'weighbridgeId': string;
    /**
     * id of an activity weighing in UUID type 4
     * @type {string}
     * @memberof GetPlantationHarvestCostResponseItem
     */
    'activityWeighingId': string;
    /**
     * weighing date on block farm
     * @type {number}
     * @memberof GetPlantationHarvestCostResponseItem
     */
    'weighingDate': number;
    /**
     * delivery date of harvesting
     * @type {number}
     * @memberof GetPlantationHarvestCostResponseItem
     */
    'deliveryDate': number;
    /**
     * id of block in UUID type 4
     * @type {string}
     * @memberof GetPlantationHarvestCostResponseItem
     */
    'blockId': string;
    /**
     * block of farm
     * @type {string}
     * @memberof GetPlantationHarvestCostResponseItem
     */
    'block': string;
    /**
     * weight of ffb on kg
     * @type {number}
     * @memberof GetPlantationHarvestCostResponseItem
     */
    'weight': number;
    /**
     * 
     * @type {Array<GetPlantationHarvestCostResponseActivityItem>}
     * @memberof GetPlantationHarvestCostResponseItem
     */
    'activity': Array<GetPlantationHarvestCostResponseActivityItem>;
}
/**
 * 
 * @export
 * @interface GetPlantationSaleResponse
 */
export interface GetPlantationSaleResponse {
    /**
     * id of a plantation sale in UUID type 4
     * @type {string}
     * @memberof GetPlantationSaleResponse
     */
    'id': string;
    /**
     * id of weighbridge in UUID type 4
     * @type {string}
     * @memberof GetPlantationSaleResponse
     */
    'weighbridgeId': string;
    /**
     * no ticket of weighbridge
     * @type {string}
     * @memberof GetPlantationSaleResponse
     */
    'weighbridgeNoTicket': string;
    /**
     * delivery time of FFB. using epoch
     * @type {number}
     * @memberof GetPlantationSaleResponse
     */
    'deliveryTime': number;
    /**
     * truck number of FFB delivery
     * @type {string}
     * @memberof GetPlantationSaleResponse
     */
    'truckNumber': string;
    /**
     * weight of harvest from farm
     * @type {number}
     * @memberof GetPlantationSaleResponse
     */
    'weightNetFarm': number;
    /**
     * sortation from mill on percent
     * @type {number}
     * @memberof GetPlantationSaleResponse
     */
    'sortationPercent': number;
    /**
     * sortation from mill on kilogram
     * @type {number}
     * @memberof GetPlantationSaleResponse
     */
    'sortationKilo': number;
    /**
     * multiplier for delivery cost
     * @type {number}
     * @memberof GetPlantationSaleResponse
     */
    'multiplierDeliveryCost': number;
    /**
     * mill sell price
     * @type {number}
     * @memberof GetPlantationSaleResponse
     */
    'sellPrice': number;
    /**
     * other cost during harvest or delivery
     * @type {number}
     * @memberof GetPlantationSaleResponse
     */
    'otherCost': number;
}
/**
 * 
 * @export
 * @interface GetPlantationsExpensesResponse
 */
export interface GetPlantationsExpensesResponse {
    /**
     * 
     * @type {Array<GetPlantationsExpensesResponseItem>}
     * @memberof GetPlantationsExpensesResponse
     */
    'items': Array<GetPlantationsExpensesResponseItem>;
}
/**
 * 
 * @export
 * @interface GetPlantationsExpensesResponseItem
 */
export interface GetPlantationsExpensesResponseItem {
    /**
     * id of a plantation sale in UUID type 4
     * @type {string}
     * @memberof GetPlantationsExpensesResponseItem
     */
    'id': string;
    /**
     * Date of expense
     * @type {number}
     * @memberof GetPlantationsExpensesResponseItem
     */
    'date': number;
    /**
     * id of farm group in UUID type 4
     * @type {string}
     * @memberof GetPlantationsExpensesResponseItem
     */
    'groupId': string;
    /**
     * name of group
     * @type {string}
     * @memberof GetPlantationsExpensesResponseItem
     */
    'groupName': string;
    /**
     * wages for administration
     * @type {number}
     * @memberof GetPlantationsExpensesResponseItem
     */
    'adminWages': number;
    /**
     * wages for operational
     * @type {number}
     * @memberof GetPlantationsExpensesResponseItem
     */
    'operationalWages': number;
    /**
     * wages for maintenance
     * @type {number}
     * @memberof GetPlantationsExpensesResponseItem
     */
    'maintenanceWages': number;
}
/**
 * 
 * @export
 * @interface GetPlantationsSalesResponse
 */
export interface GetPlantationsSalesResponse {
    /**
     * 
     * @type {Array<GetPlantationsSalesResponseItem>}
     * @memberof GetPlantationsSalesResponse
     */
    'items': Array<GetPlantationsSalesResponseItem>;
}
/**
 * 
 * @export
 * @interface GetPlantationsSalesResponseItem
 */
export interface GetPlantationsSalesResponseItem {
    /**
     * id of a plantation sale in UUID type 4
     * @type {string}
     * @memberof GetPlantationsSalesResponseItem
     */
    'id': string;
    /**
     * id of weighbridge in UUID type 4
     * @type {string}
     * @memberof GetPlantationsSalesResponseItem
     */
    'weighbridgeId': string;
    /**
     * no ticket of weighbridge
     * @type {string}
     * @memberof GetPlantationsSalesResponseItem
     */
    'weighbridgeNoTicket': string;
    /**
     * delivery date to Mill
     * @type {number}
     * @memberof GetPlantationsSalesResponseItem
     */
    'deliveryDate': number;
    /**
     * the number plate of the vehicle used for delivery
     * @type {string}
     * @memberof GetPlantationsSalesResponseItem
     */
    'platNo': string;
    /**
     * block of farm
     * @type {string}
     * @memberof GetPlantationsSalesResponseItem
     */
    'block': string;
    /**
     * name of driver who deliver the harvest
     * @type {string}
     * @memberof GetPlantationsSalesResponseItem
     */
    'driverName': string;
    /**
     * weight of harvest from farm
     * @type {number}
     * @memberof GetPlantationsSalesResponseItem
     */
    'weightNetFarm': number;
    /**
     * weight of harvest from mill before sortation
     * @type {number}
     * @memberof GetPlantationsSalesResponseItem
     */
    'weightNetMill': number;
    /**
     * sortation from mill on percent
     * @type {number}
     * @memberof GetPlantationsSalesResponseItem
     */
    'sortationPercent': number;
    /**
     * sortation from mill on kilogram
     * @type {number}
     * @memberof GetPlantationsSalesResponseItem
     */
    'sortationKilo': number;
    /**
     * estimation sortation from mill
     * @type {number}
     * @memberof GetPlantationsSalesResponseItem
     */
    'estimationSortation': number;
    /**
     * weight net of harvest from mill after sortation
     * @type {number}
     * @memberof GetPlantationsSalesResponseItem
     */
    'weightNetAdjusted': number;
    /**
     * mill sell price
     * @type {number}
     * @memberof GetPlantationsSalesResponseItem
     */
    'sellPrice': number;
    /**
     * mill total price
     * @type {number}
     * @memberof GetPlantationsSalesResponseItem
     */
    'totalPrice': number;
    /**
     * costs during delivery
     * @type {number}
     * @memberof GetPlantationsSalesResponseItem
     */
    'deliveryCost': number;
    /**
     * Multiplier for delivery cost
     * @type {number}
     * @memberof GetPlantationsSalesResponseItem
     */
    'multiplierDeliveryCost'?: number;
    /**
     * costs during harvest
     * @type {number}
     * @memberof GetPlantationsSalesResponseItem
     */
    'harvestCost': number;
    /**
     * other cost during harvest or delivery
     * @type {number}
     * @memberof GetPlantationsSalesResponseItem
     */
    'otherCost': number;
    /**
     * total received by plantation
     * @type {number}
     * @memberof GetPlantationsSalesResponseItem
     */
    'totalReceived': number;
}
/**
 * 
 * @export
 * @interface GetPopupsListItem
 */
export interface GetPopupsListItem {
    /**
     * 
     * @type {string}
     * @memberof GetPopupsListItem
     */
    'id': string;
    /**
     * 
     * @type {PopupTypeEnum}
     * @memberof GetPopupsListItem
     */
    'type': PopupTypeEnum;
    /**
     * Title of popup
     * @type {string}
     * @memberof GetPopupsListItem
     */
    'title': string;
    /**
     * Message of popup
     * @type {string}
     * @memberof GetPopupsListItem
     */
    'message': string;
    /**
     * Image URL of popup
     * @type {string}
     * @memberof GetPopupsListItem
     */
    'imageURL': string;
    /**
     * 
     * @type {PopupsItemCTA}
     * @memberof GetPopupsListItem
     */
    'cta': PopupsItemCTA;
    /**
     * Expiry date of popup
     * @type {string}
     * @memberof GetPopupsListItem
     */
    'expiryDate': string;
}


/**
 * 
 * @export
 * @interface GetPopupsListResponse
 */
export interface GetPopupsListResponse {
    /**
     * 
     * @type {Array<GetPopupsListItem>}
     * @memberof GetPopupsListResponse
     */
    'items': Array<GetPopupsListItem>;
}
/**
 * list of product category
 * @export
 * @interface GetProductCategoriesResponse
 */
export interface GetProductCategoriesResponse {
    /**
     * 
     * @type {Array<GetProductCategoriesResponseItem>}
     * @memberof GetProductCategoriesResponse
     */
    'items': Array<GetProductCategoriesResponseItem>;
}
/**
 * 
 * @export
 * @interface GetProductCategoriesResponseItem
 */
export interface GetProductCategoriesResponseItem {
    /**
     * ID of product category
     * @type {string}
     * @memberof GetProductCategoriesResponseItem
     */
    'id': string;
    /**
     * Name of product category
     * @type {string}
     * @memberof GetProductCategoriesResponseItem
     */
    'name': string;
    /**
     * Code of product category
     * @type {string}
     * @memberof GetProductCategoriesResponseItem
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface GetSupplierContractsUsersResponse
 */
export interface GetSupplierContractsUsersResponse {
    /**
     * 
     * @type {Array<GetSupplierContractsUsersResponseItem>}
     * @memberof GetSupplierContractsUsersResponse
     */
    'items': Array<GetSupplierContractsUsersResponseItem>;
}
/**
 * 
 * @export
 * @interface GetSupplierContractsUsersResponseItem
 */
export interface GetSupplierContractsUsersResponseItem {
    /**
     * Unique identifier of a user
     * @type {string}
     * @memberof GetSupplierContractsUsersResponseItem
     */
    'id': string;
    /**
     * The name of the user
     * @type {string}
     * @memberof GetSupplierContractsUsersResponseItem
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetSuppliersContactsResponse
 */
export interface GetSuppliersContactsResponse {
    /**
     * 
     * @type {Array<GetSuppliersContactsResponseItem>}
     * @memberof GetSuppliersContactsResponse
     */
    'items': Array<GetSuppliersContactsResponseItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof GetSuppliersContactsResponse
     */
    'pagination': PaginationResponse;
}
/**
 * 
 * @export
 * @interface GetSuppliersContactsResponseItem
 */
export interface GetSuppliersContactsResponseItem {
    /**
     * Contact Id
     * @type {string}
     * @memberof GetSuppliersContactsResponseItem
     */
    'id': string;
    /**
     * Name of the user
     * @type {string}
     * @memberof GetSuppliersContactsResponseItem
     */
    'userName': string;
    /**
     * Phone number of the user
     * @type {string}
     * @memberof GetSuppliersContactsResponseItem
     */
    'phoneNumber': string;
    /**
     * 
     * @type {JobNameEnum}
     * @memberof GetSuppliersContactsResponseItem
     */
    'jobName': JobNameEnum;
    /**
     * Business Id
     * @type {string}
     * @memberof GetSuppliersContactsResponseItem
     */
    'businessId': string;
    /**
     * name of business
     * @type {string}
     * @memberof GetSuppliersContactsResponseItem
     */
    'businessName': string;
}


/**
 * 
 * @export
 * @interface GetUserRolePartnerItem
 */
export interface GetUserRolePartnerItem {
    /**
     * ID of the Partner, represented in UUID type 4
     * @type {string}
     * @memberof GetUserRolePartnerItem
     */
    'id': string;
    /**
     * Name of the Partner
     * @type {string}
     * @memberof GetUserRolePartnerItem
     */
    'name': string;
}
/**
 * Response data
 * @export
 * @interface GetUserRoleResponse
 */
export interface GetUserRoleResponse {
    /**
     * Name of the group
     * @type {string}
     * @memberof GetUserRoleResponse
     */
    'groupName': string;
    /**
     * Name of the company
     * @type {string}
     * @memberof GetUserRoleResponse
     */
    'companyName': string;
    /**
     * Total count of the mills
     * @type {number}
     * @memberof GetUserRoleResponse
     */
    'millsCount': number;
    /**
     * 
     * @type {UserRoleEnum}
     * @memberof GetUserRoleResponse
     */
    'userRole': UserRoleEnum;
    /**
     * List of user\'s partner
     * @type {Array<GetUserRolePartnerItem>}
     * @memberof GetUserRoleResponse
     */
    'partnerList': Array<GetUserRolePartnerItem>;
}


/**
 * credit is when `user` receive point and debit is when `user` giving point
 * @export
 * @enum {string}
 */

export const HistoryEntryTypeEnum = {
    Credit: 'CREDIT',
    Debit: 'DEBIT'
} as const;

export type HistoryEntryTypeEnum = typeof HistoryEntryTypeEnum[keyof typeof HistoryEntryTypeEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const InvoiceDirectionEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;

export type InvoiceDirectionEnum = typeof InvoiceDirectionEnum[keyof typeof InvoiceDirectionEnum];


/**
 * amountDue  = This field is used for sorting by the amount due of the invoice customerName  = This field is used for sorting by the name of the customer orderCreatedAt   = This field is used for sorting by the order\'s creation date paidAt   = This field is used for sorting by the date of the invoice\'s payment invoiceNo   = This field is used for sorting by the number of the invoice 
 * @export
 * @enum {string}
 */

export const InvoiceFinanceSortFieldEnum = {
    CustomerName: 'customerName',
    AmountDue: 'amountDue',
    OrderCreatedAt: 'orderCreatedAt',
    PaidAt: 'paidAt',
    InvoiceNo: 'invoiceNo'
} as const;

export type InvoiceFinanceSortFieldEnum = typeof InvoiceFinanceSortFieldEnum[keyof typeof InvoiceFinanceSortFieldEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const InvoiceStatusEnum = {
    Unpaid: 'UNPAID',
    Paid: 'PAID',
    PartialPaid: 'PARTIAL_PAID',
    Expired: 'EXPIRED',
    Cancelled: 'CANCELLED',
    Void: 'VOID'
} as const;

export type InvoiceStatusEnum = typeof InvoiceStatusEnum[keyof typeof InvoiceStatusEnum];


/**
 * 
 * @export
 * @interface InvoicesListResponse
 */
export interface InvoicesListResponse {
    /**
     * 
     * @type {Array<InvoicesListResponseItem>}
     * @memberof InvoicesListResponse
     */
    'items': Array<InvoicesListResponseItem>;
}
/**
 * 
 * @export
 * @interface InvoicesListResponseItem
 */
export interface InvoicesListResponseItem {
    /**
     * Invoice UUID
     * @type {string}
     * @memberof InvoicesListResponseItem
     */
    'id': string;
    /**
     * Generated invoice number
     * @type {string}
     * @memberof InvoicesListResponseItem
     */
    'invoiceNo': string;
    /**
     * Invoice amount due
     * @type {number}
     * @memberof InvoicesListResponseItem
     */
    'amountDue': number;
    /**
     * Invoice due time
     * @type {number}
     * @memberof InvoicesListResponseItem
     */
    'dueAtUtc0': number;
    /**
     * 
     * @type {InvoiceStatusEnum}
     * @memberof InvoicesListResponseItem
     */
    'status': InvoiceStatusEnum;
    /**
     * Invoice PDF file URL
     * @type {string}
     * @memberof InvoicesListResponseItem
     */
    'invoicePdfUrl': string;
    /**
     * List of Payment Item
     * @type {Array<InvoicesListResponseItemPaymentMethodItem>}
     * @memberof InvoicesListResponseItem
     */
    'paymentMethodItems': Array<InvoicesListResponseItemPaymentMethodItem>;
    /**
     * 
     * @type {InvoicesListResponseItemRefundInformation}
     * @memberof InvoicesListResponseItem
     */
    'refundInformation'?: InvoicesListResponseItemRefundInformation;
    /**
     * 
     * @type {InvoicesListResponseItemVoucherInformation}
     * @memberof InvoicesListResponseItem
     */
    'voucherInformation'?: InvoicesListResponseItemVoucherInformation;
    /**
     * 
     * @type {InvoicesListResponseItemShippingInformation}
     * @memberof InvoicesListResponseItem
     */
    'shippingInformation'?: InvoicesListResponseItemShippingInformation;
    /**
     * 
     * @type {EcommerceGetProductAdditionalFeeResponse}
     * @memberof InvoicesListResponseItem
     */
    'productAdditionalFee'?: EcommerceGetProductAdditionalFeeResponse;
}


/**
 * 
 * @export
 * @interface InvoicesListResponseItemPaymentMethodItem
 */
export interface InvoicesListResponseItemPaymentMethodItem {
    /**
     * Payment UUID
     * @type {string}
     * @memberof InvoicesListResponseItemPaymentMethodItem
     */
    'id': string;
    /**
     * The remaining amount of payments that need to be paid
     * @type {number}
     * @memberof InvoicesListResponseItemPaymentMethodItem
     */
    'amountDue': number;
    /**
     * The amount of payments that have already been paid
     * @type {number}
     * @memberof InvoicesListResponseItemPaymentMethodItem
     */
    'amountPaid': number;
    /**
     * 
     * @type {PaymentItemsPaymentMethodEnum}
     * @memberof InvoicesListResponseItemPaymentMethodItem
     */
    'paymentMethod': PaymentItemsPaymentMethodEnum;
    /**
     * 
     * @type {PaymentStatusEnum}
     * @memberof InvoicesListResponseItemPaymentMethodItem
     */
    'status': PaymentStatusEnum;
    /**
     * Destination payment account name
     * @type {string}
     * @memberof InvoicesListResponseItemPaymentMethodItem
     */
    'destinationAccountName'?: string;
    /**
     * Destination payment account number
     * @type {string}
     * @memberof InvoicesListResponseItemPaymentMethodItem
     */
    'destinationAccountNo'?: string;
    /**
     * How to pay API URL from DOKU
     * @type {string}
     * @memberof InvoicesListResponseItemPaymentMethodItem
     */
    'howToPayApi'?: string;
}


/**
 * 
 * @export
 * @interface InvoicesListResponseItemRefundInformation
 */
export interface InvoicesListResponseItemRefundInformation {
    /**
     * Refund epoch date
     * @type {number}
     * @memberof InvoicesListResponseItemRefundInformation
     */
    'refundDate': number;
    /**
     * Refund SawitPoint Amount
     * @type {number}
     * @memberof InvoicesListResponseItemRefundInformation
     */
    'refundAmount': number;
}
/**
 * 
 * @export
 * @interface InvoicesListResponseItemShippingInformation
 */
export interface InvoicesListResponseItemShippingInformation {
    /**
     * Total Shipping Cost
     * @type {number}
     * @memberof InvoicesListResponseItemShippingInformation
     */
    'totalShippingCost': number;
    /**
     * 
     * @type {DeliveryMethodEnum}
     * @memberof InvoicesListResponseItemShippingInformation
     */
    'deliveryType': DeliveryMethodEnum;
}


/**
 * 
 * @export
 * @interface InvoicesListResponseItemVoucherInformation
 */
export interface InvoicesListResponseItemVoucherInformation {
    /**
     * Voucher UUID
     * @type {string}
     * @memberof InvoicesListResponseItemVoucherInformation
     */
    'id': string;
    /**
     * Voucher code
     * @type {string}
     * @memberof InvoicesListResponseItemVoucherInformation
     */
    'code': string;
    /**
     * Voucher discount price
     * @type {number}
     * @memberof InvoicesListResponseItemVoucherInformation
     */
    'discountPrice': number;
    /**
     * Voucher name
     * @type {string}
     * @memberof InvoicesListResponseItemVoucherInformation
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface JobBoardsCreateApplicationsExperienceRequest
 */
export interface JobBoardsCreateApplicationsExperienceRequest {
    /**
     * code of job category
     * @type {string}
     * @memberof JobBoardsCreateApplicationsExperienceRequest
     */
    'jobCategoryCode': string;
    /**
     * total years of experience
     * @type {number}
     * @memberof JobBoardsCreateApplicationsExperienceRequest
     */
    'yearsOfExperience': number;
}
/**
 * 
 * @export
 * @interface JobBoardsCreateApplicationsRequest
 */
export interface JobBoardsCreateApplicationsRequest {
    /**
     * id of vacancy
     * @type {string}
     * @memberof JobBoardsCreateApplicationsRequest
     */
    'vacancyId': string;
    /**
     * expected wage from aplicant
     * @type {number}
     * @memberof JobBoardsCreateApplicationsRequest
     */
    'expectedWage': number;
    /**
     * applicant\'s gender
     * @type {string}
     * @memberof JobBoardsCreateApplicationsRequest
     */
    'gender': string;
    /**
     * applicant\'s birth date in yyyy-mm-dd format
     * @type {string}
     * @memberof JobBoardsCreateApplicationsRequest
     */
    'birthDate': string;
    /**
     * Area ID in string format
     * @type {string}
     * @memberof JobBoardsCreateApplicationsRequest
     */
    'areaId': string;
    /**
     * 
     * @type {JobBoardsCreateApplicationsExperienceRequest}
     * @memberof JobBoardsCreateApplicationsRequest
     */
    'experience': JobBoardsCreateApplicationsExperienceRequest;
}
/**
 * 
 * @export
 * @interface JobBoardsGetSeekersDomicile
 */
export interface JobBoardsGetSeekersDomicile {
    /**
     * Area ID in string format
     * @type {string}
     * @memberof JobBoardsGetSeekersDomicile
     */
    'areaId': string;
    /**
     * Job Seeker\'s city location
     * @type {string}
     * @memberof JobBoardsGetSeekersDomicile
     */
    'city': string;
    /**
     * Job Seeker\'s province location
     * @type {string}
     * @memberof JobBoardsGetSeekersDomicile
     */
    'province': string;
}
/**
 * 
 * @export
 * @interface JobBoardsGetSeekersExperience
 */
export interface JobBoardsGetSeekersExperience {
    /**
     * category code of job vacancy
     * @type {string}
     * @memberof JobBoardsGetSeekersExperience
     */
    'jobCategoryCode': string;
    /**
     * job seeker\'s experience in year per job category code
     * @type {number}
     * @memberof JobBoardsGetSeekersExperience
     */
    'yearsOfExperience': number;
    /**
     * job seeker\'s expected wage
     * @type {number}
     * @memberof JobBoardsGetSeekersExperience
     */
    'expectedWage': number;
}
/**
 * 
 * @export
 * @interface JobBoardsGetSeekersResponse
 */
export interface JobBoardsGetSeekersResponse {
    /**
     * Job Seeker\'s gender
     * @type {string}
     * @memberof JobBoardsGetSeekersResponse
     */
    'gender': string;
    /**
     * job seeker\'s birth date in yyyy-mm-dd format
     * @type {string}
     * @memberof JobBoardsGetSeekersResponse
     */
    'birthDate': string;
    /**
     * 
     * @type {JobBoardsGetSeekersDomicile}
     * @memberof JobBoardsGetSeekersResponse
     */
    'domicile': JobBoardsGetSeekersDomicile;
    /**
     * 
     * @type {Array<JobBoardsGetSeekersExperience>}
     * @memberof JobBoardsGetSeekersResponse
     */
    'experience': Array<JobBoardsGetSeekersExperience>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const JobBoardsVacanciesApplicationStatusEnum = {
    Rejected: 'REJECTED',
    Accepted: 'ACCEPTED',
    Pending: 'PENDING'
} as const;

export type JobBoardsVacanciesApplicationStatusEnum = typeof JobBoardsVacanciesApplicationStatusEnum[keyof typeof JobBoardsVacanciesApplicationStatusEnum];


/**
 * category of this job vacancy
 * @export
 * @interface JobBoardsVacanciesCategory
 */
export interface JobBoardsVacanciesCategory {
    /**
     * code of terrain of this job vacancy
     * @type {string}
     * @memberof JobBoardsVacanciesCategory
     */
    'code': string;
    /**
     * name of terrain of this job vacancy
     * @type {string}
     * @memberof JobBoardsVacanciesCategory
     */
    'name': string;
}
/**
 * Fresh Fruit Bucket of this job vacancy
 * @export
 * @interface JobBoardsVacanciesFFB
 */
export interface JobBoardsVacanciesFFB {
    /**
     * minimum estimation of ffb of this job vacancy
     * @type {number}
     * @memberof JobBoardsVacanciesFFB
     */
    'minimumEstimation': number;
    /**
     * maximum estimation of ffb of this job vacancy
     * @type {number}
     * @memberof JobBoardsVacanciesFFB
     */
    'maximumEstimation': number;
    /**
     * collection method of ffb of this job vacancy
     * @type {string}
     * @memberof JobBoardsVacanciesFFB
     */
    'ffbCollectionMethod': string;
    /**
     * 
     * @type {string}
     * @memberof JobBoardsVacanciesFFB
     */
    'additionalParameter': string;
}
/**
 * 
 * @export
 * @interface JobBoardsVacanciesGetJobVacancyDetailResponse
 */
export interface JobBoardsVacanciesGetJobVacancyDetailResponse {
    /**
     * id of this job vacancy in UUID type 4
     * @type {string}
     * @memberof JobBoardsVacanciesGetJobVacancyDetailResponse
     */
    'id': string;
    /**
     * name of this job vacancy
     * @type {string}
     * @memberof JobBoardsVacanciesGetJobVacancyDetailResponse
     */
    'name': string;
    /**
     * number of workers needed
     * @type {number}
     * @memberof JobBoardsVacanciesGetJobVacancyDetailResponse
     */
    'quota': number;
    /**
     * category code of this job vacancy
     * @type {string}
     * @memberof JobBoardsVacanciesGetJobVacancyDetailResponse
     */
    'categoryCode': string;
    /**
     * category name of this job vacancy. The name can be changed dynamically
     * @type {string}
     * @memberof JobBoardsVacanciesGetJobVacancyDetailResponse
     */
    'categoryName': string;
    /**
     * lowest wage of this job vacancy
     * @type {number}
     * @memberof JobBoardsVacanciesGetJobVacancyDetailResponse
     */
    'minWage'?: number;
    /**
     * highest wage of this job vacancy
     * @type {number}
     * @memberof JobBoardsVacanciesGetJobVacancyDetailResponse
     */
    'maxWage'?: number;
    /**
     * provided facilities of this job vacancy
     * @type {Array<string>}
     * @memberof JobBoardsVacanciesGetJobVacancyDetailResponse
     */
    'facilities': Array<string>;
    /**
     * 
     * @type {JobBoardsVacanciesGetJobVacancyDetailResponseTerrainInformation}
     * @memberof JobBoardsVacanciesGetJobVacancyDetailResponse
     */
    'terrainInformation': JobBoardsVacanciesGetJobVacancyDetailResponseTerrainInformation;
    /**
     * job-related details
     * @type {string}
     * @memberof JobBoardsVacanciesGetJobVacancyDetailResponse
     */
    'description': string;
    /**
     * unit of measurement that used to calculate worker wage
     * @type {string}
     * @memberof JobBoardsVacanciesGetJobVacancyDetailResponse
     */
    'unitOfWageMeasurement'?: string;
    /**
     * Restructure terrainInformation for display
     * @type {Array<string>}
     * @memberof JobBoardsVacanciesGetJobVacancyDetailResponse
     */
    'terrainInformationForDisplay': Array<string>;
    /**
     * user job application indicator
     * @type {boolean}
     * @memberof JobBoardsVacanciesGetJobVacancyDetailResponse
     */
    'isApplied': boolean;
}
/**
 * 
 * @export
 * @interface JobBoardsVacanciesGetJobVacancyDetailResponseTerrainInformation
 */
export interface JobBoardsVacanciesGetJobVacancyDetailResponseTerrainInformation {
    /**
     * work location of this job vacancy
     * @type {string}
     * @memberof JobBoardsVacanciesGetJobVacancyDetailResponseTerrainInformation
     */
    'location': string;
    /**
     * type of soil of this work area
     * @type {Array<string>}
     * @memberof JobBoardsVacanciesGetJobVacancyDetailResponseTerrainInformation
     */
    'soilType': Array<string>;
    /**
     * terrain condition of this work area
     * @type {string}
     * @memberof JobBoardsVacanciesGetJobVacancyDetailResponseTerrainInformation
     */
    'terrainCondition': string;
    /**
     * height of harvested tree
     * @type {number}
     * @memberof JobBoardsVacanciesGetJobVacancyDetailResponseTerrainInformation
     */
    'treeHeight': number;
    /**
     * minimum distance of loading collection
     * @type {number}
     * @memberof JobBoardsVacanciesGetJobVacancyDetailResponseTerrainInformation
     */
    'minFfbCollectionDistance'?: number;
    /**
     * maximum distance of loading collection
     * @type {number}
     * @memberof JobBoardsVacanciesGetJobVacancyDetailResponseTerrainInformation
     */
    'maxFfbCollectionDistance'?: number;
    /**
     * provided tool for loading collection
     * @type {string}
     * @memberof JobBoardsVacanciesGetJobVacancyDetailResponseTerrainInformation
     */
    'ffbCollectionMethod': string;
    /**
     * terrain-related addition information
     * @type {string}
     * @memberof JobBoardsVacanciesGetJobVacancyDetailResponseTerrainInformation
     */
    'additionalInformation'?: string;
}
/**
 * Response data
 * @export
 * @interface JobBoardsVacanciesGetJobVacancyListResponse
 */
export interface JobBoardsVacanciesGetJobVacancyListResponse {
    /**
     * List of Job Vacancies
     * @type {Array<JobBoardsVacanciesGetJobVacancyListResponseItem>}
     * @memberof JobBoardsVacanciesGetJobVacancyListResponse
     */
    'items': Array<JobBoardsVacanciesGetJobVacancyListResponseItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof JobBoardsVacanciesGetJobVacancyListResponse
     */
    'pagination': PaginationResponse;
}
/**
 * 
 * @export
 * @interface JobBoardsVacanciesGetJobVacancyListResponseItem
 */
export interface JobBoardsVacanciesGetJobVacancyListResponseItem {
    /**
     * id of this job vacancy in UUID type 4
     * @type {string}
     * @memberof JobBoardsVacanciesGetJobVacancyListResponseItem
     */
    'id': string;
    /**
     * name of this job vacancy
     * @type {string}
     * @memberof JobBoardsVacanciesGetJobVacancyListResponseItem
     */
    'name': string;
    /**
     * provided facilities of this job vacancy
     * @type {Array<string>}
     * @memberof JobBoardsVacanciesGetJobVacancyListResponseItem
     */
    'facilities': Array<string>;
    /**
     * province of work locataion
     * @type {string}
     * @memberof JobBoardsVacanciesGetJobVacancyListResponseItem
     */
    'province': string;
    /**
     * district of work locataion
     * @type {string}
     * @memberof JobBoardsVacanciesGetJobVacancyListResponseItem
     */
    'district': string;
    /**
     * user job application indicator
     * @type {boolean}
     * @memberof JobBoardsVacanciesGetJobVacancyListResponseItem
     */
    'isApplied': boolean;
    /**
     * category code of this job vacancy
     * @type {string}
     * @memberof JobBoardsVacanciesGetJobVacancyListResponseItem
     */
    'categoryCode': string;
    /**
     * category name of this job vacancy. The name can be changed dynamically
     * @type {string}
     * @memberof JobBoardsVacanciesGetJobVacancyListResponseItem
     */
    'categoryName': string;
    /**
     * Restructure terrainInformation for display
     * @type {Array<string>}
     * @memberof JobBoardsVacanciesGetJobVacancyListResponseItem
     */
    'terrainInformationForDisplay': Array<string>;
}
/**
 * category of this job vacancy
 * @export
 * @interface JobBoardsVacanciesLocation
 */
export interface JobBoardsVacanciesLocation {
    /**
     * area id
     * @type {string}
     * @memberof JobBoardsVacanciesLocation
     */
    'areaId': string;
    /**
     * name of area of this job vacancy
     * @type {string}
     * @memberof JobBoardsVacanciesLocation
     */
    'areaName': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const JobBoardsVacanciesStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE'
} as const;

export type JobBoardsVacanciesStatusEnum = typeof JobBoardsVacanciesStatusEnum[keyof typeof JobBoardsVacanciesStatusEnum];


/**
 * terrain of this job vacancy
 * @export
 * @interface JobBoardsVacanciesTerrain
 */
export interface JobBoardsVacanciesTerrain {
    /**
     * condition of terrain of this job vacancy
     * @type {string}
     * @memberof JobBoardsVacanciesTerrain
     */
    'condition': string;
    /**
     * soil type of terrain of this job vacancy
     * @type {string}
     * @memberof JobBoardsVacanciesTerrain
     */
    'soilType': string;
    /**
     * minimum tree high of terrain of this job vacancy
     * @type {number}
     * @memberof JobBoardsVacanciesTerrain
     */
    'minimumTreeHigh': number;
}
/**
 * wage of this job vacancy
 * @export
 * @interface JobBoardsVacanciesWage
 */
export interface JobBoardsVacanciesWage {
    /**
     * minimum wage of this job vacancy
     * @type {number}
     * @memberof JobBoardsVacanciesWage
     */
    'minimum': number;
    /**
     * maximum wage of this job vacancy
     * @type {number}
     * @memberof JobBoardsVacanciesWage
     */
    'maximum': number;
    /**
     * unit of wage of this job vacancy
     * @type {string}
     * @memberof JobBoardsVacanciesWage
     */
    'unit': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const JobNameEnum = {
    Harvester: 'HARVESTER',
    HarvesterLead: 'HARVESTER_LEAD',
    HarvesterSupervisor: 'HARVESTER_SUPERVISOR',
    LoaderCollection: 'LOADER_COLLECTION',
    LoaderTruck: 'LOADER_TRUCK',
    Weigher: 'WEIGHER',
    Driver: 'DRIVER',
    Upkeeper: 'UPKEEPER'
} as const;

export type JobNameEnum = typeof JobNameEnum[keyof typeof JobNameEnum];


/**
 * Job vacancy status
 * @export
 * @enum {string}
 */

export const JobVacancyStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE'
} as const;

export type JobVacancyStatusEnum = typeof JobVacancyStatusEnum[keyof typeof JobVacancyStatusEnum];


/**
 * Response data
 * @export
 * @interface KeyValueResponseItem
 */
export interface KeyValueResponseItem {
    /**
     * Key
     * @type {string}
     * @memberof KeyValueResponseItem
     */
    'key': string;
    /**
     * Value
     * @type {string}
     * @memberof KeyValueResponseItem
     */
    'value': string;
}
/**
 * List of land clearing method allowed
 * @export
 * @enum {string}
 */

export const LandClearingMethodEnum = {
    AlatBerat: 'Alat berat',
    ManualDibakar: 'Manual dibakar',
    ManualTidakDibakar: 'Manual tidak dibakar',
    TidakTahu: 'Tidak tahu'
} as const;

export type LandClearingMethodEnum = typeof LandClearingMethodEnum[keyof typeof LandClearingMethodEnum];


/**
 * list on land condition before the land used as palm oil plantation
 * @export
 * @enum {string}
 */

export const LandConditionBeforeClearingEnum = {
    HutanAlami: 'Hutan Alami',
    SemakBelukarSosok: 'Semak Belukar/Sosok',
    Rerumputan: 'Rerumputan',
    LahanTerbuka: 'Lahan Terbuka',
    Pertanian: 'Pertanian'
} as const;

export type LandConditionBeforeClearingEnum = typeof LandConditionBeforeClearingEnum[keyof typeof LandConditionBeforeClearingEnum];


/**
 * Status of the leads
 * @export
 * @enum {string}
 */

export const LeadsStatusEnum = {
    Leads: 'LEADS',
    Qualified: 'QUALIFIED',
    Sale: 'SALE'
} as const;

export type LeadsStatusEnum = typeof LeadsStatusEnum[keyof typeof LeadsStatusEnum];


/**
 * 
 * @export
 * @interface LineString
 */
export interface LineString {
    /**
     * 
     * @type {LineStringEnum}
     * @memberof LineString
     */
    'type': LineStringEnum;
    /**
     * 
     * @type {Array<Array<number>>}
     * @memberof LineString
     */
    'coordinates': Array<Array<number>>;
}


/**
 * Geometry line string type allowed
 * @export
 * @enum {string}
 */

export const LineStringEnum = {
    Line: 'Line'
} as const;

export type LineStringEnum = typeof LineStringEnum[keyof typeof LineStringEnum];


/**
 * 
 * @export
 * @interface ListCampaignResponse
 */
export interface ListCampaignResponse {
    /**
     * list of campaigns
     * @type {Array<ListCampaignResponseDataItem>}
     * @memberof ListCampaignResponse
     */
    'items': Array<ListCampaignResponseDataItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof ListCampaignResponse
     */
    'pagination': PaginationResponse;
}
/**
 * 
 * @export
 * @interface ListCampaignResponseDataItem
 */
export interface ListCampaignResponseDataItem {
    /**
     * Campaign ID
     * @type {string}
     * @memberof ListCampaignResponseDataItem
     */
    'id': string;
    /**
     * Name of the campaign
     * @type {string}
     * @memberof ListCampaignResponseDataItem
     */
    'campaignName': string;
    /**
     * 
     * @type {ListCampaignResponseDataItemCampaignType}
     * @memberof ListCampaignResponseDataItem
     */
    'campaignType': ListCampaignResponseDataItemCampaignType;
    /**
     * Campaign start datetime (in epoch)
     * @type {number}
     * @memberof ListCampaignResponseDataItem
     */
    'startAt': number;
    /**
     * 
     * @type {CampaignParticipantTypeEnum}
     * @memberof ListCampaignResponseDataItem
     */
    'participantType': CampaignParticipantTypeEnum;
    /**
     * Count of participant (member/supplier) enlisted in the campaign
     * @type {number}
     * @memberof ListCampaignResponseDataItem
     */
    'participantCount': number;
    /**
     * Progress percentage presented with decimal (1% = 0.01)
     * @type {number}
     * @memberof ListCampaignResponseDataItem
     */
    'progress': number;
    /**
     * 
     * @type {CampaignStatusEnum}
     * @memberof ListCampaignResponseDataItem
     */
    'status': CampaignStatusEnum;
}


/**
 * 
 * @export
 * @interface ListCampaignResponseDataItemCampaignType
 */
export interface ListCampaignResponseDataItemCampaignType {
    /**
     * Campaign type ID represented by UUID type 4
     * @type {string}
     * @memberof ListCampaignResponseDataItemCampaignType
     */
    'id': string;
    /**
     * Name of the campaign type
     * @type {string}
     * @memberof ListCampaignResponseDataItemCampaignType
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface ListMarketingsLeadsResponse
 */
export interface ListMarketingsLeadsResponse {
    /**
     * 
     * @type {Array<ListMarketingsLeadsResponseItem>}
     * @memberof ListMarketingsLeadsResponse
     */
    'items': Array<ListMarketingsLeadsResponseItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof ListMarketingsLeadsResponse
     */
    'pagination': PaginationResponse;
}
/**
 * 
 * @export
 * @interface ListMarketingsLeadsResponseItem
 */
export interface ListMarketingsLeadsResponseItem {
    /**
     * User ID of the leads
     * @type {string}
     * @memberof ListMarketingsLeadsResponseItem
     */
    'id': string;
    /**
     * Name of the leads
     * @type {string}
     * @memberof ListMarketingsLeadsResponseItem
     */
    'name': string;
    /**
     * Phone number of the leads
     * @type {string}
     * @memberof ListMarketingsLeadsResponseItem
     */
    'phoneNo': string;
    /**
     * List of asset type that the leads have. Currently will only return `FARM` type. Can be empty
     * @type {Array<AssetCategoryEnum>}
     * @memberof ListMarketingsLeadsResponseItem
     */
    'assets': Array<AssetCategoryEnum>;
    /**
     * Status of the leads (value will match the LeadsStatusEnum schema)
     * @type {string}
     * @memberof ListMarketingsLeadsResponseItem
     */
    'status': string;
    /**
     * Label of the status to be shown in the UI
     * @type {string}
     * @memberof ListMarketingsLeadsResponseItem
     */
    'statusLabel': string;
    /**
     * Share message to invite the leads via instant messaging or any other app
     * @type {string}
     * @memberof ListMarketingsLeadsResponseItem
     */
    'shareMessage': string;
    /**
     * Will return true if there\'s a rejected asset (for now it\'s only used for asset type `FARM`)
     * @type {boolean}
     * @memberof ListMarketingsLeadsResponseItem
     */
    'isAssetRejected': boolean;
}
/**
 * 
 * @export
 * @interface LocationsGetDistrictsResponse
 */
export interface LocationsGetDistrictsResponse {
    /**
     * 
     * @type {Array<LocationsGetDistrictsResponseItem>}
     * @memberof LocationsGetDistrictsResponse
     */
    'items': Array<LocationsGetDistrictsResponseItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof LocationsGetDistrictsResponse
     */
    'pagination': PaginationResponse;
}
/**
 * 
 * @export
 * @interface LocationsGetDistrictsResponseItem
 */
export interface LocationsGetDistrictsResponseItem {
    /**
     * ID of area/district location
     * @type {string}
     * @memberof LocationsGetDistrictsResponseItem
     */
    'id': string;
    /**
     * Location Area/District Name
     * @type {string}
     * @memberof LocationsGetDistrictsResponseItem
     */
    'name': string;
    /**
     * District
     * @type {string}
     * @memberof LocationsGetDistrictsResponseItem
     */
    'district': string;
    /**
     * City
     * @type {string}
     * @memberof LocationsGetDistrictsResponseItem
     */
    'city': string;
    /**
     * Province
     * @type {string}
     * @memberof LocationsGetDistrictsResponseItem
     */
    'province': string;
    /**
     * District Latitude
     * @type {number}
     * @memberof LocationsGetDistrictsResponseItem
     */
    'latitude': number;
    /**
     * District Longitude
     * @type {number}
     * @memberof LocationsGetDistrictsResponseItem
     */
    'longitude': number;
}
/**
 * 
 * @export
 * @interface LocationsGetProvinceListResponse
 */
export interface LocationsGetProvinceListResponse {
    /**
     * 
     * @type {Array<ProvinceResponseItem>}
     * @memberof LocationsGetProvinceListResponse
     */
    'items': Array<ProvinceResponseItem>;
}
/**
 * 
 * @export
 * @interface LocationsGetVillagesResponse
 */
export interface LocationsGetVillagesResponse {
    /**
     * 
     * @type {Array<LocationsGetVillagesResponseItem>}
     * @memberof LocationsGetVillagesResponse
     */
    'items': Array<LocationsGetVillagesResponseItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof LocationsGetVillagesResponse
     */
    'pagination': PaginationResponse;
}
/**
 * 
 * @export
 * @interface LocationsGetVillagesResponseItem
 */
export interface LocationsGetVillagesResponseItem {
    /**
     * Location Area/Village ID
     * @type {string}
     * @memberof LocationsGetVillagesResponseItem
     */
    'id': string;
    /**
     * Location Area/Village name
     * @type {string}
     * @memberof LocationsGetVillagesResponseItem
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface LoyaltyGetGoldHistoryResponse
 */
export interface LoyaltyGetGoldHistoryResponse {
    /**
     * 
     * @type {Array<LoyaltyGetGoldHistoryResponseItem>}
     * @memberof LoyaltyGetGoldHistoryResponse
     */
    'items': Array<LoyaltyGetGoldHistoryResponseItem>;
    /**
     * The total gold received by user (in mg or 1/1000 of a gram), will return 0 if the user has no Gold
     * @type {number}
     * @memberof LoyaltyGetGoldHistoryResponse
     */
    'totalGold': number;
    /**
     * The total gold credit of user (in mg or 1/1000 of a gram), will return 0 if the user has no Gold
     * @type {number}
     * @memberof LoyaltyGetGoldHistoryResponse
     */
    'totalCredit': number;
    /**
     * The total gold debit of user (in mg or 1/1000 of a gram), will return 0 if the user has no Gold
     * @type {number}
     * @memberof LoyaltyGetGoldHistoryResponse
     */
    'totalDebit': number;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof LoyaltyGetGoldHistoryResponse
     */
    'pagination': PaginationResponse;
}
/**
 * 
 * @export
 * @interface LoyaltyGetGoldHistoryResponseItem
 */
export interface LoyaltyGetGoldHistoryResponseItem {
    /**
     * ID of the entries on each activity
     * @type {string}
     * @memberof LoyaltyGetGoldHistoryResponseItem
     */
    'id': string;
    /**
     * Amount of the gold in mg (1/1000 gram)
     * @type {number}
     * @memberof LoyaltyGetGoldHistoryResponseItem
     */
    'amount': number;
    /**
     * Title of the activity
     * @type {string}
     * @memberof LoyaltyGetGoldHistoryResponseItem
     */
    'title': string;
    /**
     * Description of the activity
     * @type {string}
     * @memberof LoyaltyGetGoldHistoryResponseItem
     */
    'body': string;
    /**
     * Timestamp when the activity happened
     * @type {number}
     * @memberof LoyaltyGetGoldHistoryResponseItem
     */
    'transactionDate': number;
    /**
     * 
     * @type {HistoryEntryTypeEnum}
     * @memberof LoyaltyGetGoldHistoryResponseItem
     */
    'mutationType': HistoryEntryTypeEnum;
}


/**
 * 
 * @export
 * @interface LoyaltyGetRewardListResponse
 */
export interface LoyaltyGetRewardListResponse {
    /**
     * 
     * @type {Array<LoyaltyGetRewardListResponseItem>}
     * @memberof LoyaltyGetRewardListResponse
     */
    'items': Array<LoyaltyGetRewardListResponseItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof LoyaltyGetRewardListResponse
     */
    'pagination': PaginationResponse;
}
/**
 * 
 * @export
 * @interface LoyaltyGetRewardListResponseItem
 */
export interface LoyaltyGetRewardListResponseItem {
    /**
     * ID of the reward item
     * @type {string}
     * @memberof LoyaltyGetRewardListResponseItem
     */
    'id': string;
    /**
     * name of reward item
     * @type {string}
     * @memberof LoyaltyGetRewardListResponseItem
     */
    'name': string;
    /**
     * Amount of the gold in g
     * @type {number}
     * @memberof LoyaltyGetRewardListResponseItem
     */
    'nominal': number;
    /**
     * 
     * @type {CurrencyCodeEnum}
     * @memberof LoyaltyGetRewardListResponseItem
     */
    'currencyCode': CurrencyCodeEnum;
    /**
     * unit of measurement of reward
     * @type {string}
     * @memberof LoyaltyGetRewardListResponseItem
     */
    'uom': string;
    /**
     * Product Image of reward
     * @type {string}
     * @memberof LoyaltyGetRewardListResponseItem
     */
    'photoUrl': string;
    /**
     * Stock of reward list
     * @type {number}
     * @memberof LoyaltyGetRewardListResponseItem
     */
    'stock': number;
}


/**
 * 
 * @export
 * @interface LoyaltyHistoryListResponse
 */
export interface LoyaltyHistoryListResponse {
    /**
     * 
     * @type {Array<LoyaltyHistoryListResponseDataItem>}
     * @memberof LoyaltyHistoryListResponse
     */
    'items': Array<LoyaltyHistoryListResponseDataItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof LoyaltyHistoryListResponse
     */
    'pagination': PaginationResponse;
}
/**
 * 
 * @export
 * @interface LoyaltyHistoryListResponseDataItem
 */
export interface LoyaltyHistoryListResponseDataItem {
    /**
     * 
     * @type {string}
     * @memberof LoyaltyHistoryListResponseDataItem
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof LoyaltyHistoryListResponseDataItem
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyHistoryListResponseDataItem
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyHistoryListResponseDataItem
     */
    'body'?: string;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyHistoryListResponseDataItem
     */
    'pointUom'?: LoyaltyHistoryListResponseDataItemPointUomEnum;
    /**
     * date when transacrtion happened in unix timestamp
     * @type {number}
     * @memberof LoyaltyHistoryListResponseDataItem
     */
    'transactionDate': number;
    /**
     * 
     * @type {HistoryEntryTypeEnum}
     * @memberof LoyaltyHistoryListResponseDataItem
     */
    'debitCredit': HistoryEntryTypeEnum;
}

export const LoyaltyHistoryListResponseDataItemPointUomEnum = {
    Xp: 'XP',
    Point: 'POINT',
    Idr: 'IDR'
} as const;

export type LoyaltyHistoryListResponseDataItemPointUomEnum = typeof LoyaltyHistoryListResponseDataItemPointUomEnum[keyof typeof LoyaltyHistoryListResponseDataItemPointUomEnum];

/**
 * 
 * @export
 * @interface LoyaltyHistoryListTypesResponse
 */
export interface LoyaltyHistoryListTypesResponse {
    /**
     * 
     * @type {Array<LoyaltyHistoryListTypesResponseDataItem>}
     * @memberof LoyaltyHistoryListTypesResponse
     */
    'items': Array<LoyaltyHistoryListTypesResponseDataItem>;
}
/**
 * 
 * @export
 * @interface LoyaltyHistoryListTypesResponseDataItem
 */
export interface LoyaltyHistoryListTypesResponseDataItem {
    /**
     * The title that will be shown in filter list on FE
     * @type {string}
     * @memberof LoyaltyHistoryListTypesResponseDataItem
     */
    'title': string;
    /**
     * Enum for History SawitPoin list filter
     * @type {string}
     * @memberof LoyaltyHistoryListTypesResponseDataItem
     */
    'enum': string;
}
/**
 * 
 * @export
 * @interface LoyaltyMemberTransactionRequest
 */
export interface LoyaltyMemberTransactionRequest {
    /**
     * 
     * @type {string}
     * @memberof LoyaltyMemberTransactionRequest
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyMemberTransactionRequest
     */
    'voucherId'?: string;
    /**
     * 
     * @type {DeliveryEnum}
     * @memberof LoyaltyMemberTransactionRequest
     */
    'deliveryType': DeliveryEnum;
    /**
     * 
     * @type {number}
     * @memberof LoyaltyMemberTransactionRequest
     */
    'deliveryDate': number;
    /**
     * 
     * @type {PaymentMethodEnum}
     * @memberof LoyaltyMemberTransactionRequest
     */
    'paymentMethod': PaymentMethodEnum;
    /**
     * 
     * @type {number}
     * @memberof LoyaltyMemberTransactionRequest
     */
    'totalPayment': number;
    /**
     * 
     * @type {number}
     * @memberof LoyaltyMemberTransactionRequest
     */
    'pointUsed': number;
    /**
     * 
     * @type {number}
     * @memberof LoyaltyMemberTransactionRequest
     */
    'totalPrice': number;
    /**
     * 
     * @type {Array<ProductItem>}
     * @memberof LoyaltyMemberTransactionRequest
     */
    'items': Array<ProductItem>;
}


/**
 * 
 * @export
 * @interface LoyaltyMemberTransactionResponse
 */
export interface LoyaltyMemberTransactionResponse {
    /**
     * 
     * @type {boolean}
     * @memberof LoyaltyMemberTransactionResponse
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyMemberTransactionResponse
     */
    'approvalCode'?: string;
}
/**
 * Response data
 * @export
 * @interface LoyaltyPublicVoucherListResponse
 */
export interface LoyaltyPublicVoucherListResponse {
    /**
     * List of Public Voucher Item
     * @type {Array<LoyaltyPublicVoucherListResponseItem>}
     * @memberof LoyaltyPublicVoucherListResponse
     */
    'items': Array<LoyaltyPublicVoucherListResponseItem>;
}
/**
 * 
 * @export
 * @interface LoyaltyPublicVoucherListResponseItem
 */
export interface LoyaltyPublicVoucherListResponseItem {
    /**
     * Voucher UUID
     * @type {string}
     * @memberof LoyaltyPublicVoucherListResponseItem
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPublicVoucherListResponseItem
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPublicVoucherListResponseItem
     */
    'label': string;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPublicVoucherListResponseItem
     */
    'imageUrl': string;
    /**
     * 
     * @type {number}
     * @memberof LoyaltyPublicVoucherListResponseItem
     */
    'maxDiscountPrice': number;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPublicVoucherListResponseItem
     */
    'discountType': string;
    /**
     * 
     * @type {number}
     * @memberof LoyaltyPublicVoucherListResponseItem
     */
    'discountAmount': number;
}
/**
 * this is the request for the redem
 * @export
 * @interface LoyaltyRedeemRewardRequest
 */
export interface LoyaltyRedeemRewardRequest {
    /**
     * 
     * @type {Array<LoyaltyRedeemRewardRequestBalance>}
     * @memberof LoyaltyRedeemRewardRequest
     */
    'balances': Array<LoyaltyRedeemRewardRequestBalance>;
    /**
     * 
     * @type {Array<LoyaltyRedeemRewardRequestItem>}
     * @memberof LoyaltyRedeemRewardRequest
     */
    'items': Array<LoyaltyRedeemRewardRequestItem>;
}
/**
 * this is for the balance when redeeming the reward
 * @export
 * @interface LoyaltyRedeemRewardRequestBalance
 */
export interface LoyaltyRedeemRewardRequestBalance {
    /**
     * 
     * @type {BalanceTypeEnum}
     * @memberof LoyaltyRedeemRewardRequestBalance
     */
    'type': BalanceTypeEnum;
}


/**
 * this is for the item when redeeming the reward
 * @export
 * @interface LoyaltyRedeemRewardRequestItem
 */
export interface LoyaltyRedeemRewardRequestItem {
    /**
     * reward id
     * @type {string}
     * @memberof LoyaltyRedeemRewardRequestItem
     */
    'id': string;
    /**
     * reward name
     * @type {string}
     * @memberof LoyaltyRedeemRewardRequestItem
     */
    'name': string;
    /**
     * Quantity
     * @type {number}
     * @memberof LoyaltyRedeemRewardRequestItem
     */
    'quantity': number;
    /**
     * Nominal
     * @type {number}
     * @memberof LoyaltyRedeemRewardRequestItem
     */
    'nominal': number;
    /**
     * 
     * @type {CurrencyCodeEnum}
     * @memberof LoyaltyRedeemRewardRequestItem
     */
    'currencyCode': CurrencyCodeEnum;
}


/**
 * this is the response for the redem
 * @export
 * @interface LoyaltyRedeemRewardResponse
 */
export interface LoyaltyRedeemRewardResponse {
    /**
     * the id of the redem
     * @type {string}
     * @memberof LoyaltyRedeemRewardResponse
     */
    'Id': string;
    /**
     * 
     * @type {RewardRedeemStatusEnum}
     * @memberof LoyaltyRedeemRewardResponse
     */
    'status': RewardRedeemStatusEnum;
    /**
     * amount of the redem
     * @type {number}
     * @memberof LoyaltyRedeemRewardResponse
     */
    'amount': number;
    /**
     * 
     * @type {Array<LoyaltyRedeemRewardResponseItem>}
     * @memberof LoyaltyRedeemRewardResponse
     */
    'items': Array<LoyaltyRedeemRewardResponseItem>;
}


/**
 * Loyalty Reward Create Redeem Response Item
 * @export
 * @interface LoyaltyRedeemRewardResponseItem
 */
export interface LoyaltyRedeemRewardResponseItem {
    /**
     * reward id
     * @type {string}
     * @memberof LoyaltyRedeemRewardResponseItem
     */
    'id': string;
    /**
     * reward name
     * @type {string}
     * @memberof LoyaltyRedeemRewardResponseItem
     */
    'name': string;
    /**
     * Quantity
     * @type {number}
     * @memberof LoyaltyRedeemRewardResponseItem
     */
    'quantity': number;
    /**
     * Nominal
     * @type {number}
     * @memberof LoyaltyRedeemRewardResponseItem
     */
    'nominal': number;
    /**
     * 
     * @type {RewardRedeemStatusEnum}
     * @memberof LoyaltyRedeemRewardResponseItem
     */
    'status'?: RewardRedeemStatusEnum;
    /**
     * 
     * @type {CurrencyCodeEnum}
     * @memberof LoyaltyRedeemRewardResponseItem
     */
    'currencyCode': CurrencyCodeEnum;
}


/**
 * 
 * @export
 * @interface LoyaltyRequestDataDisbursementType
 */
export interface LoyaltyRequestDataDisbursementType {
    /**
     * ID of the disbursement type
     * @type {string}
     * @memberof LoyaltyRequestDataDisbursementType
     */
    'id': string;
    /**
     * Name of the disbursement type
     * @type {string}
     * @memberof LoyaltyRequestDataDisbursementType
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface LoyaltyRequestPointDisbursementRequest
 */
export interface LoyaltyRequestPointDisbursementRequest {
    /**
     * 
     * @type {DepartmentPointDisbursementRequestEnum}
     * @memberof LoyaltyRequestPointDisbursementRequest
     */
    'department': DepartmentPointDisbursementRequestEnum;
    /**
     * Id of disbursement type
     * @type {string}
     * @memberof LoyaltyRequestPointDisbursementRequest
     */
    'disbursementTypeId': string;
    /**
     * Purpose of disbursement request
     * @type {string}
     * @memberof LoyaltyRequestPointDisbursementRequest
     */
    'purpose': string;
    /**
     * Title of disbursement request
     * @type {string}
     * @memberof LoyaltyRequestPointDisbursementRequest
     */
    'title': string;
    /**
     * Description of disbursement request
     * @type {string}
     * @memberof LoyaltyRequestPointDisbursementRequest
     */
    'description': string;
    /**
     * points disbursed
     * @type {number}
     * @memberof LoyaltyRequestPointDisbursementRequest
     */
    'point': number;
    /**
     * 
     * @type {DisbursementRecipientSelectionTypeEnum}
     * @memberof LoyaltyRequestPointDisbursementRequest
     */
    'selectionType': DisbursementRecipientSelectionTypeEnum;
    /**
     * 
     * @type {Array<LoyaltyRequestPointDisbursementRequestRecipients>}
     * @memberof LoyaltyRequestPointDisbursementRequest
     */
    'recipients': Array<LoyaltyRequestPointDisbursementRequestRecipients>;
}


/**
 * 
 * @export
 * @interface LoyaltyRequestPointDisbursementRequestRecipients
 */
export interface LoyaltyRequestPointDisbursementRequestRecipients {
    /**
     * Id of user or recipient
     * @type {string}
     * @memberof LoyaltyRequestPointDisbursementRequestRecipients
     */
    'userId': string;
}
/**
 * 
 * @export
 * @interface LoyaltyTransferRequest
 */
export interface LoyaltyTransferRequest {
    /**
     * Encrypted phoneNumber using RSA256 with public key that\'s retrieved from local database
     * @type {string}
     * @memberof LoyaltyTransferRequest
     */
    'phoneNo': string;
    /**
     * Amount of point to be sent
     * @type {number}
     * @memberof LoyaltyTransferRequest
     */
    'amount': number;
    /**
     * Description of the transaction, will be shown in the notification & history
     * @type {string}
     * @memberof LoyaltyTransferRequest
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface LoyaltyTransferResponse
 */
export interface LoyaltyTransferResponse {
    /**
     * Indicating whether the transfer is successful or not
     * @type {boolean}
     * @memberof LoyaltyTransferResponse
     */
    'success': boolean;
}
/**
 * Response data
 * @export
 * @interface LoyaltyVoucherListResponse
 */
export interface LoyaltyVoucherListResponse {
    /**
     * List of Voucher item
     * @type {Array<LoyaltyVoucherListResponseItem>}
     * @memberof LoyaltyVoucherListResponse
     */
    'items': Array<LoyaltyVoucherListResponseItem>;
}
/**
 * 
 * @export
 * @interface LoyaltyVoucherListResponseItem
 */
export interface LoyaltyVoucherListResponseItem {
    /**
     * Voucher UUID
     * @type {string}
     * @memberof LoyaltyVoucherListResponseItem
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyVoucherListResponseItem
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyVoucherListResponseItem
     */
    'label': string;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyVoucherListResponseItem
     */
    'imageUrl': string;
    /**
     * 
     * @type {number}
     * @memberof LoyaltyVoucherListResponseItem
     */
    'maxDiscountPrice': number;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyVoucherListResponseItem
     */
    'discountType': string;
    /**
     * 
     * @type {number}
     * @memberof LoyaltyVoucherListResponseItem
     */
    'discountAmount': number;
    /**
     * 
     * @type {boolean}
     * @memberof LoyaltyVoucherListResponseItem
     */
    'isVoucherEligible': boolean;
}
/**
 * 
 * @export
 * @interface LoyaltyVouchersCalculateRequest
 */
export interface LoyaltyVouchersCalculateRequest {
    /**
     * Invoice ID in UUID type 4 format
     * @type {string}
     * @memberof LoyaltyVouchersCalculateRequest
     */
    'invoiceId': string;
    /**
     * flag for using point as payment
     * @type {boolean}
     * @memberof LoyaltyVouchersCalculateRequest
     */
    'pointUseStatus': boolean;
    /**
     * point ammount transaction of payment method
     * @type {number}
     * @memberof LoyaltyVouchersCalculateRequest
     */
    'pointAmount': number;
    /**
     * 
     * @type {PaymentsCreatePaymentPaymentMethodEnum}
     * @memberof LoyaltyVouchersCalculateRequest
     */
    'paymentMethod': PaymentsCreatePaymentPaymentMethodEnum;
    /**
     * Hash PIN using HMAC SHA 256
     * @type {string}
     * @memberof LoyaltyVouchersCalculateRequest
     */
    'pin'?: string;
    /**
     * Voucher ID in UUID type 4 format
     * @type {string}
     * @memberof LoyaltyVouchersCalculateRequest
     */
    'voucherUsageId': string;
}


/**
 * 
 * @export
 * @interface LoyaltyVouchersCalculateResponse
 */
export interface LoyaltyVouchersCalculateResponse {
    /**
     * Order UUID
     * @type {string}
     * @memberof LoyaltyVouchersCalculateResponse
     */
    'id': string;
    /**
     * Invoice UUID
     * @type {string}
     * @memberof LoyaltyVouchersCalculateResponse
     */
    'invoiceId': string;
    /**
     * Total Item Price
     * @type {number}
     * @memberof LoyaltyVouchersCalculateResponse
     */
    'totalPrice': number;
    /**
     * - The maximum percentage of points allowed to pay order - This will overide when voucher type is point 
     * @type {number}
     * @memberof LoyaltyVouchersCalculateResponse
     */
    'limitPointUsage': number;
    /**
     * - The maximum points allowed to pay the order in IDR - This will overide when voucher type is point 
     * @type {number}
     * @memberof LoyaltyVouchersCalculateResponse
     */
    'limitPointUsageIdr': number;
    /**
     * The discount price of the order when the discount is 0, this means the user use voucher type point 
     * @type {number}
     * @memberof LoyaltyVouchersCalculateResponse
     */
    'discountPrice': number;
    /**
     * sawit poin percentage transaction of payment method
     * @type {number}
     * @memberof LoyaltyVouchersCalculateResponse
     */
    'discountSawitPoinPercentage': number;
    /**
     * maximum sawit poin transaction of payment method
     * @type {number}
     * @memberof LoyaltyVouchersCalculateResponse
     */
    'maxDiscountSawitPoinIDR': number;
}
/**
 * 
 * @export
 * @interface LoyaltyVouchersGetDetailResponse
 */
export interface LoyaltyVouchersGetDetailResponse {
    /**
     * Voucher UUID
     * @type {string}
     * @memberof LoyaltyVouchersGetDetailResponse
     */
    'id': string;
    /**
     * Voucher name
     * @type {string}
     * @memberof LoyaltyVouchersGetDetailResponse
     */
    'name': string;
    /**
     * Voucher code
     * @type {string}
     * @memberof LoyaltyVouchersGetDetailResponse
     */
    'code': string;
    /**
     * Voucher label
     * @type {string}
     * @memberof LoyaltyVouchersGetDetailResponse
     */
    'label': string;
    /**
     * Voucher description
     * @type {string}
     * @memberof LoyaltyVouchersGetDetailResponse
     */
    'description': string;
    /**
     * Voucher terms and conditions
     * @type {string}
     * @memberof LoyaltyVouchersGetDetailResponse
     */
    'termsAndConditions': string;
    /**
     * Voucher image url
     * @type {string}
     * @memberof LoyaltyVouchersGetDetailResponse
     */
    'imageUrl': string;
    /**
     * Voucher start datetime at UTC+0 in milliseconds
     * @type {number}
     * @memberof LoyaltyVouchersGetDetailResponse
     */
    'startAtUtc0': number;
    /**
     * Voucher end datetime at UTC+0 in milliseconds
     * @type {number}
     * @memberof LoyaltyVouchersGetDetailResponse
     */
    'endAtUtc0': number;
}
/**
 * 
 * @export
 * @interface LoyaltyVouchersUsageRequest
 */
export interface LoyaltyVouchersUsageRequest {
    /**
     * Invoice ID in UUID type 4 format
     * @type {string}
     * @memberof LoyaltyVouchersUsageRequest
     */
    'invoiceId': string;
    /**
     * flag for using point as payment
     * @type {boolean}
     * @memberof LoyaltyVouchersUsageRequest
     */
    'pointUseStatus': boolean;
    /**
     * point ammount transaction of payment method
     * @type {number}
     * @memberof LoyaltyVouchersUsageRequest
     */
    'pointAmount': number;
    /**
     * 
     * @type {PaymentsCreatePaymentPaymentMethodEnum}
     * @memberof LoyaltyVouchersUsageRequest
     */
    'paymentMethod': PaymentsCreatePaymentPaymentMethodEnum;
    /**
     * voucher code
     * @type {string}
     * @memberof LoyaltyVouchersUsageRequest
     */
    'voucherCode'?: string;
    /**
     * voucher code
     * @type {string}
     * @memberof LoyaltyVouchersUsageRequest
     */
    'voucherId'?: string;
}


/**
 * 
 * @export
 * @interface LoyaltyVouchersUsageResponse
 */
export interface LoyaltyVouchersUsageResponse {
    /**
     * Voucher UUID
     * @type {string}
     * @memberof LoyaltyVouchersUsageResponse
     */
    'id': string;
    /**
     * Voucher usage UUID
     * @type {string}
     * @memberof LoyaltyVouchersUsageResponse
     */
    'voucherUsageId': string;
    /**
     * Voucher name
     * @type {string}
     * @memberof LoyaltyVouchersUsageResponse
     */
    'name': string;
    /**
     * Voucher code
     * @type {string}
     * @memberof LoyaltyVouchersUsageResponse
     */
    'code': string;
    /**
     * Voucher label
     * @type {string}
     * @memberof LoyaltyVouchersUsageResponse
     */
    'label': string;
    /**
     * Voucher description
     * @type {string}
     * @memberof LoyaltyVouchersUsageResponse
     */
    'description': string;
    /**
     * Voucher terms and conditions
     * @type {string}
     * @memberof LoyaltyVouchersUsageResponse
     */
    'termsAndConditions': string;
}
/**
 * 
 * @export
 * @interface LoyaltyWeighbridgeCostCreateRequest
 */
export interface LoyaltyWeighbridgeCostCreateRequest {
    /**
     * Name of weighbridge cost
     * @type {string}
     * @memberof LoyaltyWeighbridgeCostCreateRequest
     */
    'name': string;
    /**
     * 
     * @type {WeighbridgeCostTypeEnum}
     * @memberof LoyaltyWeighbridgeCostCreateRequest
     */
    'type': WeighbridgeCostTypeEnum;
    /**
     * Cost of daily weighbridge supply
     * @type {number}
     * @memberof LoyaltyWeighbridgeCostCreateRequest
     */
    'cost': number;
}


/**
 * 
 * @export
 * @interface MarketingsCPOPriceDetailsPricesResponse
 */
export interface MarketingsCPOPriceDetailsPricesResponse {
    /**
     * CPO price date
     * @type {number}
     * @memberof MarketingsCPOPriceDetailsPricesResponse
     */
    'date': number;
    /**
     * CPO price
     * @type {number}
     * @memberof MarketingsCPOPriceDetailsPricesResponse
     */
    'value': number;
}
/**
 * 
 * @export
 * @interface MarketingsCPOPriceDetailsResponse
 */
export interface MarketingsCPOPriceDetailsResponse {
    /**
     * CPO price total data
     * @type {number}
     * @memberof MarketingsCPOPriceDetailsResponse
     */
    'total': number;
    /**
     * 
     * @type {Array<MarketingsCPOPriceDetailsPricesResponse>}
     * @memberof MarketingsCPOPriceDetailsResponse
     */
    'prices': Array<MarketingsCPOPriceDetailsPricesResponse>;
}
/**
 * 
 * @export
 * @interface MarketingsFFBPricesGetLatestResponse
 */
export interface MarketingsFFBPricesGetLatestResponse {
    /**
     * gov ffb price date
     * @type {number}
     * @memberof MarketingsFFBPricesGetLatestResponse
     */
    'date': number;
    /**
     * gov ffb price effective start date
     * @type {number}
     * @memberof MarketingsFFBPricesGetLatestResponse
     */
    'startDate': number;
    /**
     * gov ffb price effective end date
     * @type {number}
     * @memberof MarketingsFFBPricesGetLatestResponse
     */
    'endDate': number;
    /**
     * ffb price value
     * @type {number}
     * @memberof MarketingsFFBPricesGetLatestResponse
     */
    'price': number;
    /**
     * the difference price compare with the previous date
     * @type {number}
     * @memberof MarketingsFFBPricesGetLatestResponse
     */
    'diffPrice': number;
    /**
     * diff price with previous ffb price data in percentage
     * @type {number}
     * @memberof MarketingsFFBPricesGetLatestResponse
     */
    'diffPricePercentage': number;
    /**
     * 
     * @type {DiffPriceStatusEnum}
     * @memberof MarketingsFFBPricesGetLatestResponse
     */
    'diffPriceStatus': DiffPriceStatusEnum;
}


/**
 * 
 * @export
 * @interface MarketingsGetArticlesResponse
 */
export interface MarketingsGetArticlesResponse {
    /**
     * url of the blog website
     * @type {string}
     * @memberof MarketingsGetArticlesResponse
     */
    'seeMorelink': string;
    /**
     * 
     * @type {Array<MarketingsGetArticlesResponseItem>}
     * @memberof MarketingsGetArticlesResponse
     */
    'items': Array<MarketingsGetArticlesResponseItem>;
}
/**
 * 
 * @export
 * @interface MarketingsGetArticlesResponseItem
 */
export interface MarketingsGetArticlesResponseItem {
    /**
     * id of a article represented in UUID type 4
     * @type {string}
     * @memberof MarketingsGetArticlesResponseItem
     */
    'id': string;
    /**
     * title of the article
     * @type {string}
     * @memberof MarketingsGetArticlesResponseItem
     */
    'title': string;
    /**
     * excerpt of the article
     * @type {string}
     * @memberof MarketingsGetArticlesResponseItem
     */
    'excerpt': string;
    /**
     * url of the image
     * @type {string}
     * @memberof MarketingsGetArticlesResponseItem
     */
    'imageUrl': string;
    /**
     * url of the article
     * @type {string}
     * @memberof MarketingsGetArticlesResponseItem
     */
    'sourceUrl': string;
    /**
     * sequence of a article, will be used for sorting
     * @type {number}
     * @memberof MarketingsGetArticlesResponseItem
     */
    'sequence': number;
    /**
     * time when the article is published in unix timestamp
     * @type {number}
     * @memberof MarketingsGetArticlesResponseItem
     */
    'publishedDateAtUtc0': number;
}
/**
 * 
 * @export
 * @interface MarketingsGetCurrentCPOPriceResponse
 */
export interface MarketingsGetCurrentCPOPriceResponse {
    /**
     * CPO price per Kg in IDR
     * @type {number}
     * @memberof MarketingsGetCurrentCPOPriceResponse
     */
    'pricePerKgIDR': number;
    /**
     * CPO price\'s date in DD/MM/YYYY format
     * @type {string}
     * @memberof MarketingsGetCurrentCPOPriceResponse
     */
    'dateLabel': string;
    /**
     * The changed price in percentage compare with the previous date
     * @type {number}
     * @memberof MarketingsGetCurrentCPOPriceResponse
     */
    'changedPercentage': number;
    /**
     * The changed price compare with the previous date
     * @type {number}
     * @memberof MarketingsGetCurrentCPOPriceResponse
     */
    'changedPrice': number;
}
/**
 * 
 * @export
 * @interface MarketingsGetFAQsResponse
 */
export interface MarketingsGetFAQsResponse {
    /**
     * 
     * @type {Array<MarketingsGetFAQsResponseItem>}
     * @memberof MarketingsGetFAQsResponse
     */
    'items': Array<MarketingsGetFAQsResponseItem>;
}
/**
 * 
 * @export
 * @interface MarketingsGetFAQsResponseItem
 */
export interface MarketingsGetFAQsResponseItem {
    /**
     * id of a FAQ represented in UUID type 4
     * @type {string}
     * @memberof MarketingsGetFAQsResponseItem
     */
    'id': string;
    /**
     * question of the FAQ
     * @type {string}
     * @memberof MarketingsGetFAQsResponseItem
     */
    'question': string;
    /**
     * answer of the FAQ
     * @type {string}
     * @memberof MarketingsGetFAQsResponseItem
     */
    'answer': string;
    /**
     * sequence of the FAQ, will be used for sorting
     * @type {number}
     * @memberof MarketingsGetFAQsResponseItem
     */
    'sequence': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const MarketingsGetFAQsScopeQueryEnum = {
    Home: 'HOME',
    Agronomy: 'AGRONOMY'
} as const;

export type MarketingsGetFAQsScopeQueryEnum = typeof MarketingsGetFAQsScopeQueryEnum[keyof typeof MarketingsGetFAQsScopeQueryEnum];


/**
 * 
 * @export
 * @interface MarketingsGetFFBPricesResponse
 */
export interface MarketingsGetFFBPricesResponse {
    /**
     * FFB price total data
     * @type {number}
     * @memberof MarketingsGetFFBPricesResponse
     */
    'total': number;
    /**
     * 
     * @type {Array<MarketingsGetFFBPricesResponsePrices>}
     * @memberof MarketingsGetFFBPricesResponse
     */
    'prices': Array<MarketingsGetFFBPricesResponsePrices>;
}
/**
 * 
 * @export
 * @interface MarketingsGetFFBPricesResponsePrices
 */
export interface MarketingsGetFFBPricesResponsePrices {
    /**
     * FFB price date unix
     * @type {number}
     * @memberof MarketingsGetFFBPricesResponsePrices
     */
    'date': number;
    /**
     * gov ffb price effective start date
     * @type {number}
     * @memberof MarketingsGetFFBPricesResponsePrices
     */
    'startDate': number;
    /**
     * gov ffb price effective end date
     * @type {number}
     * @memberof MarketingsGetFFBPricesResponsePrices
     */
    'endDate': number;
    /**
     * FFB price value
     * @type {number}
     * @memberof MarketingsGetFFBPricesResponsePrices
     */
    'value': number;
}
/**
 * 
 * @export
 * @interface MarketingsGetTestimonialsResponse
 */
export interface MarketingsGetTestimonialsResponse {
    /**
     * 
     * @type {Array<MarketingsGetTestimonialsResponseItem>}
     * @memberof MarketingsGetTestimonialsResponse
     */
    'items': Array<MarketingsGetTestimonialsResponseItem>;
}
/**
 * 
 * @export
 * @interface MarketingsGetTestimonialsResponseItem
 */
export interface MarketingsGetTestimonialsResponseItem {
    /**
     * id of a testimonial represented in UUID type 4
     * @type {string}
     * @memberof MarketingsGetTestimonialsResponseItem
     */
    'id': string;
    /**
     * title of the testimonial
     * @type {string}
     * @memberof MarketingsGetTestimonialsResponseItem
     */
    'title': string;
    /**
     * body of the testimonial
     * @type {string}
     * @memberof MarketingsGetTestimonialsResponseItem
     */
    'body': string;
    /**
     * name of the writer
     * @type {string}
     * @memberof MarketingsGetTestimonialsResponseItem
     */
    'writerName': string;
    /**
     * role of the writer
     * @type {string}
     * @memberof MarketingsGetTestimonialsResponseItem
     */
    'writerRole': string;
    /**
     * url of the writer picture
     * @type {string}
     * @memberof MarketingsGetTestimonialsResponseItem
     */
    'writerPictureUrl': string;
    /**
     * sequence of the testimonial, will be used for sorting
     * @type {number}
     * @memberof MarketingsGetTestimonialsResponseItem
     */
    'sequence': number;
}
/**
 * 
 * @export
 * @interface MarketingsGetVideosResponse
 */
export interface MarketingsGetVideosResponse {
    /**
     * 
     * @type {Array<MarketingsGetVideosResponseItem>}
     * @memberof MarketingsGetVideosResponse
     */
    'items': Array<MarketingsGetVideosResponseItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof MarketingsGetVideosResponse
     */
    'pagination': PaginationResponse;
}
/**
 * 
 * @export
 * @interface MarketingsGetVideosResponseItem
 */
export interface MarketingsGetVideosResponseItem {
    /**
     * id of a video represented in UUID type 4
     * @type {string}
     * @memberof MarketingsGetVideosResponseItem
     */
    'id': string;
    /**
     * title of the video
     * @type {string}
     * @memberof MarketingsGetVideosResponseItem
     */
    'title': string;
    /**
     * thumbnail url of the video
     * @type {string}
     * @memberof MarketingsGetVideosResponseItem
     */
    'thumbnailUrl': string;
    /**
     * url of the video
     * @type {string}
     * @memberof MarketingsGetVideosResponseItem
     */
    'videoUrl': string;
    /**
     * 
     * @type {MarketingsVideoPlatformEnum}
     * @memberof MarketingsGetVideosResponseItem
     */
    'platform': MarketingsVideoPlatformEnum;
    /**
     * video ID reference for the specified platform
     * @type {string}
     * @memberof MarketingsGetVideosResponseItem
     */
    'platformVideoId'?: string;
    /**
     * sequence of the video, will be used for sorting
     * @type {number}
     * @memberof MarketingsGetVideosResponseItem
     */
    'sequence': number;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const MarketingsGetVideosScopeQueryEnum = {
    Home: 'HOME',
    Agronomy: 'AGRONOMY'
} as const;

export type MarketingsGetVideosScopeQueryEnum = typeof MarketingsGetVideosScopeQueryEnum[keyof typeof MarketingsGetVideosScopeQueryEnum];


/**
 * type of platform used in the marketing videos data
 * @export
 * @enum {string}
 */

export const MarketingsVideoPlatformEnum = {
    Internal: 'INTERNAL',
    Youtube: 'YOUTUBE',
    Tiktok: 'TIKTOK',
    Vimeo: 'VIMEO'
} as const;

export type MarketingsVideoPlatformEnum = typeof MarketingsVideoPlatformEnum[keyof typeof MarketingsVideoPlatformEnum];


/**
 * 
 * @export
 * @interface MediaPresignedUrlRequest
 */
export interface MediaPresignedUrlRequest {
    /**
     * the operationType of
     * @type {string}
     * @memberof MediaPresignedUrlRequest
     */
    'operationType': string;
    /**
     * the extension of file to be uploaded
     * @type {string}
     * @memberof MediaPresignedUrlRequest
     */
    'mimeType': string;
    /**
     * the originalFileName of file to be uploaded
     * @type {string}
     * @memberof MediaPresignedUrlRequest
     */
    'originalFileName': string;
    /**
     * the fileSize of file to be uploaded in bytes
     * @type {number}
     * @memberof MediaPresignedUrlRequest
     */
    'fileSize': number;
}
/**
 * 
 * @export
 * @interface MediaPresignedUrlResponse
 */
export interface MediaPresignedUrlResponse {
    /**
     * 
     * @type {string}
     * @memberof MediaPresignedUrlResponse
     */
    'presignedUrl': string;
    /**
     * 
     * @type {string}
     * @memberof MediaPresignedUrlResponse
     */
    'filePath': string;
    /**
     * The public location of the file (depending on whether the bucket is publicly accessible or not)
     * @type {string}
     * @memberof MediaPresignedUrlResponse
     */
    'publicUrl': string;
}
/**
 * Member category
 * @export
 * @enum {string}
 */

export const MemberCategoryEnum = {
    Mill: 'MILL',
    DoAgent: 'DO_AGENT',
    Logistic: 'LOGISTIC'
} as const;

export type MemberCategoryEnum = typeof MemberCategoryEnum[keyof typeof MemberCategoryEnum];


/**
 * Status of the member
 * @export
 * @enum {string}
 */

export const MemberStatusEnum = {
    Active: 'ACTIVE',
    Pending: 'PENDING',
    Inactive: 'INACTIVE',
    Rejected: 'REJECTED'
} as const;

export type MemberStatusEnum = typeof MemberStatusEnum[keyof typeof MemberStatusEnum];


/**
 * 
 * @export
 * @interface MembersLoyaltyListActiveCampaignsResponse
 */
export interface MembersLoyaltyListActiveCampaignsResponse {
    /**
     * 
     * @type {MembersLoyaltyListActiveCampaignsResponseData}
     * @memberof MembersLoyaltyListActiveCampaignsResponse
     */
    'data'?: MembersLoyaltyListActiveCampaignsResponseData;
}
/**
 * 
 * @export
 * @interface MembersLoyaltyListActiveCampaignsResponseData
 */
export interface MembersLoyaltyListActiveCampaignsResponseData {
    /**
     * 
     * @type {Array<MembersLoyaltyListActiveCampaignsResponseDataItem>}
     * @memberof MembersLoyaltyListActiveCampaignsResponseData
     */
    'items': Array<MembersLoyaltyListActiveCampaignsResponseDataItem>;
}
/**
 * 
 * @export
 * @interface MembersLoyaltyListActiveCampaignsResponseDataItem
 */
export interface MembersLoyaltyListActiveCampaignsResponseDataItem {
    /**
     * 
     * @type {string}
     * @memberof MembersLoyaltyListActiveCampaignsResponseDataItem
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface MembersReferralsCreateRequest
 */
export interface MembersReferralsCreateRequest {
    /**
     * Encrypted phoneNumber using RSA256 with public key that retrieved from local database.
     * @type {string}
     * @memberof MembersReferralsCreateRequest
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof MembersReferralsCreateRequest
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface MembersReferralsCreateResponse
 */
export interface MembersReferralsCreateResponse {
    /**
     * 
     * @type {string}
     * @memberof MembersReferralsCreateResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MembersReferralsCreateResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof MembersReferralsCreateResponse
     */
    'phoneNumber': string;
    /**
     * 
     * @type {RankEnum}
     * @memberof MembersReferralsCreateResponse
     */
    'rank': RankEnum;
    /**
     * 
     * @type {number}
     * @memberof MembersReferralsCreateResponse
     */
    'date': number;
}


/**
 * 
 * @export
 * @interface MembersReferralsListResponse
 */
export interface MembersReferralsListResponse {
    /**
     * 
     * @type {Array<MembersReferralsListResponseDataItem>}
     * @memberof MembersReferralsListResponse
     */
    'items': Array<MembersReferralsListResponseDataItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof MembersReferralsListResponse
     */
    'pagination': PaginationResponse;
}
/**
 * 
 * @export
 * @interface MembersReferralsListResponseDataItem
 */
export interface MembersReferralsListResponseDataItem {
    /**
     * 
     * @type {string}
     * @memberof MembersReferralsListResponseDataItem
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MembersReferralsListResponseDataItem
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof MembersReferralsListResponseDataItem
     */
    'name': string;
    /**
     * 
     * @type {RankEnum}
     * @memberof MembersReferralsListResponseDataItem
     */
    'rank': RankEnum;
    /**
     * 
     * @type {number}
     * @memberof MembersReferralsListResponseDataItem
     */
    'date': number;
}


/**
 * 
 * @export
 * @interface MembersWeighbridgesCargoDescResponse
 */
export interface MembersWeighbridgesCargoDescResponse {
    /**
     * 
     * @type {Array<WeighbridgeCargoDescGetResponse>}
     * @memberof MembersWeighbridgesCargoDescResponse
     */
    'items': Array<WeighbridgeCargoDescGetResponse>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof MembersWeighbridgesCargoDescResponse
     */
    'pagination': PaginationResponse;
}
/**
 * 
 * @export
 * @interface MembersWeighbridgesResponse
 */
export interface MembersWeighbridgesResponse {
    /**
     * 
     * @type {Array<WeighbridgeGetResponse>}
     * @memberof MembersWeighbridgesResponse
     */
    'items': Array<WeighbridgeGetResponse>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof MembersWeighbridgesResponse
     */
    'pagination': PaginationResponse;
}
/**
 * Chatbot mode enum.
 * @export
 * @enum {string}
 */

export const MessagingChatChatbotModeEnum = {
    Online: 'online',
    Offline: 'offline'
} as const;

export type MessagingChatChatbotModeEnum = typeof MessagingChatChatbotModeEnum[keyof typeof MessagingChatChatbotModeEnum];


/**
 * 
 * @export
 * @interface MessagingChatConversation
 */
export interface MessagingChatConversation {
    /**
     * Chat conversation UUID
     * @type {string}
     * @memberof MessagingChatConversation
     */
    'id': string;
    /**
     * 
     * @type {MessagingChatConversationTypeEnum}
     * @memberof MessagingChatConversation
     */
    'type': MessagingChatConversationTypeEnum;
    /**
     * 
     * @type {Array<MessagingChatUser>}
     * @memberof MessagingChatConversation
     */
    'participants': Array<MessagingChatUser>;
    /**
     * The timestamp when the conversation was created.
     * @type {number}
     * @memberof MessagingChatConversation
     */
    'createdAt': number;
    /**
     * Stream URL, if exists. Usually when we try to create or get a conversation,  We want to make sure the user get into the chat stream right away. 
     * @type {string}
     * @memberof MessagingChatConversation
     */
    'streamUrl'?: string;
}


/**
 * Chat conversation type
 * @export
 * @enum {string}
 */

export const MessagingChatConversationTypeEnum = {
    Chatbot: 'chatbot',
    CustomerService: 'customer_service',
    Private: 'private',
    Group: 'group'
} as const;

export type MessagingChatConversationTypeEnum = typeof MessagingChatConversationTypeEnum[keyof typeof MessagingChatConversationTypeEnum];


/**
 * 
 * @export
 * @interface MessagingChatConversationsCreateOrGetRequest
 */
export interface MessagingChatConversationsCreateOrGetRequest {
    /**
     * 
     * @type {MessagingChatConversationTypeEnum}
     * @memberof MessagingChatConversationsCreateOrGetRequest
     */
    'type': MessagingChatConversationTypeEnum;
}


/**
 * 
 * @export
 * @interface MessagingChatConversationsListResponse
 */
export interface MessagingChatConversationsListResponse {
    /**
     * 
     * @type {Array<MessagingChatConversation>}
     * @memberof MessagingChatConversationsListResponse
     */
    'items': Array<MessagingChatConversation>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof MessagingChatConversationsListResponse
     */
    'pagination': PaginationResponse;
}
/**
 * 
 * @export
 * @interface MessagingChatConversationsMessagesCreateRequest
 */
export interface MessagingChatConversationsMessagesCreateRequest {
    /**
     * The message to send. For now we will use no formatting, e.g. **bold**. If the message is encrypted, it will be base64 encoded. If only attachments are sent, this field will contain empty string. 
     * @type {string}
     * @memberof MessagingChatConversationsMessagesCreateRequest
     */
    'message': string;
    /**
     * Whether the message is encrypted. If true, the message will be  encrypted using the recipient\'s public key. And the `message` field with contain the encrypted message in base64 encoding. 
     * @type {boolean}
     * @memberof MessagingChatConversationsMessagesCreateRequest
     */
    'isEncrypted': boolean;
    /**
     * An array of attachments to send with the message. This can be  anything from a file, image, video, or audio. The attachment will be  uploaded to the server and a URL will be returned. This URL can then  be used in the `message` field to reference the attachment. 
     * @type {Array<MessagingChatConversationsMessagesCreateRequestAttachment>}
     * @memberof MessagingChatConversationsMessagesCreateRequest
     */
    'attachments'?: Array<MessagingChatConversationsMessagesCreateRequestAttachment>;
}
/**
 * 
 * @export
 * @interface MessagingChatConversationsMessagesCreateRequestAttachment
 */
export interface MessagingChatConversationsMessagesCreateRequestAttachment {
    /**
     * 
     * @type {MessagingChatMessageAttachmentTypeEnum}
     * @memberof MessagingChatConversationsMessagesCreateRequestAttachment
     */
    'type': MessagingChatMessageAttachmentTypeEnum;
    /**
     * The base64 encoded content of the attachment. If the message is encrypted, then this will contain the base64 encoded of the encrypted binary data. 
     * @type {string}
     * @memberof MessagingChatConversationsMessagesCreateRequestAttachment
     */
    'content': string;
    /**
     * 
     * @type {MessagingChatConversationsMessagesCreateRequestAttachmentMetadata}
     * @memberof MessagingChatConversationsMessagesCreateRequestAttachment
     */
    'metadata': MessagingChatConversationsMessagesCreateRequestAttachmentMetadata;
}


/**
 * @type MessagingChatConversationsMessagesCreateRequestAttachmentMetadata
 * @export
 */
export type MessagingChatConversationsMessagesCreateRequestAttachmentMetadata = MessagingChatMessageAttachmentMetadataImage;

/**
 * 
 * @export
 * @interface MessagingChatConversationsMessagesListResponse
 */
export interface MessagingChatConversationsMessagesListResponse {
    /**
     * 
     * @type {Array<MessagingChatMessage>}
     * @memberof MessagingChatConversationsMessagesListResponse
     */
    'items': Array<MessagingChatMessage>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof MessagingChatConversationsMessagesListResponse
     */
    'pagination': PaginationResponse;
}
/**
 * 
 * @export
 * @interface MessagingChatConversationsPostOfflineMessagesRequest
 */
export interface MessagingChatConversationsPostOfflineMessagesRequest {
    /**
     * An array of messages sent during an offline session. 
     * @type {Array<MessagingChatConversationsPostOfflineMessagesRequestItem>}
     * @memberof MessagingChatConversationsPostOfflineMessagesRequest
     */
    'items': Array<MessagingChatConversationsPostOfflineMessagesRequestItem>;
}
/**
 * 
 * @export
 * @interface MessagingChatConversationsPostOfflineMessagesRequestItem
 */
export interface MessagingChatConversationsPostOfflineMessagesRequestItem {
    /**
     * ID of the message. Represented in UUID V4.
     * @type {string}
     * @memberof MessagingChatConversationsPostOfflineMessagesRequestItem
     */
    'id': string;
    /**
     * Content of the message.
     * @type {string}
     * @memberof MessagingChatConversationsPostOfflineMessagesRequestItem
     */
    'message': string;
    /**
     * 
     * @type {MessagingChatUserTypeEnum}
     * @memberof MessagingChatConversationsPostOfflineMessagesRequestItem
     */
    'senderType': MessagingChatUserTypeEnum;
    /**
     * Message encryption status.
     * @type {boolean}
     * @memberof MessagingChatConversationsPostOfflineMessagesRequestItem
     */
    'isEncrypted'?: boolean;
    /**
     * An array of attachments sent with the message. This can be  anything from a file, image, video, or audio. The attachment will be  uploaded to the server and a URL will be returned. This URL can then  be used in the `message` field to reference the attachment. 
     * @type {Array<MessagingChatConversationsMessagesCreateRequestAttachment>}
     * @memberof MessagingChatConversationsPostOfflineMessagesRequestItem
     */
    'attachments'?: Array<MessagingChatConversationsMessagesCreateRequestAttachment>;
    /**
     * The timestamp in epoch millis when the message was sent.
     * @type {number}
     * @memberof MessagingChatConversationsPostOfflineMessagesRequestItem
     */
    'createdAt': number;
    /**
     * The timestamp in epoch millis when the message was read by the user.
     * @type {number}
     * @memberof MessagingChatConversationsPostOfflineMessagesRequestItem
     */
    'readAt'?: number;
    /**
     * 
     * @type {MessagingChatMessageStatusEnum}
     * @memberof MessagingChatConversationsPostOfflineMessagesRequestItem
     */
    'status'?: MessagingChatMessageStatusEnum;
}


/**
 * 
 * @export
 * @interface MessagingChatConversationsPostOfflineMessagesResponse
 */
export interface MessagingChatConversationsPostOfflineMessagesResponse {
    /**
     * 
     * @type {boolean}
     * @memberof MessagingChatConversationsPostOfflineMessagesResponse
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface MessagingChatConversationsStreamCreateResponse
 */
export interface MessagingChatConversationsStreamCreateResponse {
    /**
     * URL of the Websocket Stream. We use URL instead of ID to enable us of flexibility of changing URL in the future for more performance. 
     * @type {string}
     * @memberof MessagingChatConversationsStreamCreateResponse
     */
    'url': string;
}
/**
 * 
 * @export
 * @interface MessagingChatMessage
 */
export interface MessagingChatMessage {
    /**
     * The unique identifier of the message.
     * @type {string}
     * @memberof MessagingChatMessage
     */
    'id': string;
    /**
     * The message to send. For now we will use no formatting, e.g. **bold**. If the message is encrypted, it will be base64 encoded. If only attachments are sent, this field will contain empty string. 
     * @type {string}
     * @memberof MessagingChatMessage
     */
    'message': string;
    /**
     * 
     * @type {MessagingChatUser}
     * @memberof MessagingChatMessage
     */
    'sender': MessagingChatUser;
    /**
     * 1 = User to chatbot, 2 = Chatbot to user
     * @type {number}
     * @memberof MessagingChatMessage
     */
    'direction': MessagingChatMessageDirectionEnum;
    /**
     * 
     * @type {MessagingChatChatbotModeEnum}
     * @memberof MessagingChatMessage
     */
    'mode': MessagingChatChatbotModeEnum;
    /**
     * Whether the message is encrypted. If true, the message will be  encrypted using the recipient\'s public key. And the `message` field with contain the encrypted message in base64 encoding. 
     * @type {boolean}
     * @memberof MessagingChatMessage
     */
    'isEncrypted': boolean;
    /**
     * An array of attachments to send with the message. This can be  anything from a file, image, video, or audio. The attachment will be  uploaded to the server and a URL will be returned. This URL can then  be used in the `message` field to reference the attachment. 
     * @type {Array<MessagingChatMessageAttachment>}
     * @memberof MessagingChatMessage
     */
    'attachments'?: Array<MessagingChatMessageAttachment>;
    /**
     * The timestamp when the message was created.
     * @type {number}
     * @memberof MessagingChatMessage
     */
    'createdAt': number;
    /**
     * The timestamp when the message was read by the user.
     * @type {number}
     * @memberof MessagingChatMessage
     */
    'readAt'?: number;
    /**
     * 
     * @type {MessagingChatMessageStatusEnum}
     * @memberof MessagingChatMessage
     */
    'status': MessagingChatMessageStatusEnum;
}

export const MessagingChatMessageDirectionEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2
} as const;

export type MessagingChatMessageDirectionEnum = typeof MessagingChatMessageDirectionEnum[keyof typeof MessagingChatMessageDirectionEnum];

/**
 * 
 * @export
 * @interface MessagingChatMessageAttachment
 */
export interface MessagingChatMessageAttachment {
    /**
     * The unique identifier of the message attachment.
     * @type {string}
     * @memberof MessagingChatMessageAttachment
     */
    'id': string;
    /**
     * 
     * @type {MessagingChatMessageAttachmentTypeEnum}
     * @memberof MessagingChatMessageAttachment
     */
    'type': MessagingChatMessageAttachmentTypeEnum;
    /**
     * The base64 encoded content of the attachment. If the message is encrypted, then this will contain the base64 encoded of the encrypted binary data. 
     * @type {string}
     * @memberof MessagingChatMessageAttachment
     */
    'content': string;
    /**
     * 
     * @type {MessagingChatConversationsMessagesCreateRequestAttachmentMetadata}
     * @memberof MessagingChatMessageAttachment
     */
    'metadata': MessagingChatConversationsMessagesCreateRequestAttachmentMetadata;
    /**
     * Forward compatibility for when the current version does not have capability to show the message attachment. This will enable the client to download the attachment from the server or open web view. 
     * @type {string}
     * @memberof MessagingChatMessageAttachment
     */
    'url': string;
}


/**
 * 
 * @export
 * @interface MessagingChatMessageAttachmentMetadataImage
 */
export interface MessagingChatMessageAttachmentMetadataImage {
    /**
     * The MIME type of the image.
     * @type {string}
     * @memberof MessagingChatMessageAttachmentMetadataImage
     */
    'mimeType': string;
    /**
     * The width of the image in pixels.
     * @type {number}
     * @memberof MessagingChatMessageAttachmentMetadataImage
     */
    'width': number;
    /**
     * The height of the image in pixels.
     * @type {number}
     * @memberof MessagingChatMessageAttachmentMetadataImage
     */
    'height': number;
}
/**
 * Attachment type enum.
 * @export
 * @enum {string}
 */

export const MessagingChatMessageAttachmentTypeEnum = {
    Image: 'image'
} as const;

export type MessagingChatMessageAttachmentTypeEnum = typeof MessagingChatMessageAttachmentTypeEnum[keyof typeof MessagingChatMessageAttachmentTypeEnum];


/**
 * Chat message status enum.
 * @export
 * @enum {string}
 */

export const MessagingChatMessageStatusEnum = {
    Draft: 'draft',
    Sent: 'sent',
    Delivered: 'delivered',
    Read: 'read',
    Unread: 'unread',
    Deleted: 'deleted',
    Undelivered: 'undelivered',
    Sending: 'sending'
} as const;

export type MessagingChatMessageStatusEnum = typeof MessagingChatMessageStatusEnum[keyof typeof MessagingChatMessageStatusEnum];


/**
 * 
 * @export
 * @interface MessagingChatUser
 */
export interface MessagingChatUser {
    /**
     * 
     * @type {MessagingChatUserTypeEnum}
     * @memberof MessagingChatUser
     */
    'type': MessagingChatUserTypeEnum;
    /**
     * User ID, if type is USER
     * @type {string}
     * @memberof MessagingChatUser
     */
    'userId'?: string;
    /**
     * Display name of the user
     * @type {string}
     * @memberof MessagingChatUser
     */
    'displayName': string;
    /**
     * Display profile image URL of the user
     * @type {string}
     * @memberof MessagingChatUser
     */
    'displayProfileImageUrl': string;
}


/**
 * User type in chat
 * @export
 * @enum {string}
 */

export const MessagingChatUserTypeEnum = {
    Chatbot: 'chatbot',
    Self: 'self'
} as const;

export type MessagingChatUserTypeEnum = typeof MessagingChatUserTypeEnum[keyof typeof MessagingChatUserTypeEnum];


/**
 * 
 * @export
 * @interface Mill
 */
export interface Mill {
    /**
     * Id of mill
     * @type {string}
     * @memberof Mill
     */
    'id': string;
    /**
     * Mill name
     * @type {string}
     * @memberof Mill
     */
    'name': string;
    /**
     * Latitude of mill
     * @type {number}
     * @memberof Mill
     */
    'latitude': number;
    /**
     * Longitude of mill
     * @type {number}
     * @memberof Mill
     */
    'longitude': number;
    /**
     * whether mill partner or not
     * @type {boolean}
     * @memberof Mill
     */
    'isPartner': boolean;
    /**
     * prefix used in ticket number issued by mill
     * @type {string}
     * @memberof Mill
     */
    'prefixTicketNumber': string;
}
/**
 * 
 * @export
 * @interface MillsGetResponse
 */
export interface MillsGetResponse {
    /**
     * 
     * @type {Array<Mill>}
     * @memberof MillsGetResponse
     */
    'items': Array<Mill>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof MillsGetResponse
     */
    'pagination'?: PaginationResponse;
}
/**
 * 
 * @export
 * @interface MultiLineString
 */
export interface MultiLineString {
    /**
     * 
     * @type {MultiLineStringEnum}
     * @memberof MultiLineString
     */
    'type': MultiLineStringEnum;
    /**
     * 
     * @type {Array<Array<Array<number>>>}
     * @memberof MultiLineString
     */
    'coordinates': Array<Array<Array<number>>>;
}


/**
 * Geometry multiline string type allowed
 * @export
 * @enum {string}
 */

export const MultiLineStringEnum = {
    MultiLine: 'MultiLine'
} as const;

export type MultiLineStringEnum = typeof MultiLineStringEnum[keyof typeof MultiLineStringEnum];


/**
 * 
 * @export
 * @interface MultiPolygon
 */
export interface MultiPolygon {
    /**
     * 
     * @type {MultiPolygonEnum}
     * @memberof MultiPolygon
     */
    'type': MultiPolygonEnum;
    /**
     * This coordinates type of multipolygon need 2 nested array before going to multipolygon data, it is based on GeoJSON format, this data structure is needed so we can directly insert the geoJSON data into postgis
     * @type {Array<Array<Array<Array<number>>>>}
     * @memberof MultiPolygon
     */
    'coordinates': Array<Array<Array<Array<number>>>>;
}


/**
 * Geometry multi polygon type allowed
 * @export
 * @enum {string}
 */

export const MultiPolygonEnum = {
    MultiPolygon: 'MultiPolygon'
} as const;

export type MultiPolygonEnum = typeof MultiPolygonEnum[keyof typeof MultiPolygonEnum];


/**
 * List of natural vegetation allowed
 * @export
 * @enum {string}
 */

export const NaturalVegetationEnum = {
    HutanAlami: 'Hutan Alami',
    SemakBelukarSosok: 'Semak Belukar/Sosok',
    Rerumputan: 'Rerumputan'
} as const;

export type NaturalVegetationEnum = typeof NaturalVegetationEnum[keyof typeof NaturalVegetationEnum];


/**
 * List of allowed answer for human rights issue
 * @export
 * @enum {string}
 */

export const NonSpatialIssueHumanRightsEnum = {
    Ada: 'Ada',
    AdaDanTelahSelesai: 'Ada dan Telah Selesai',
    AdaDanDalamProsesPenyelesaian: 'Ada dan dalam Proses Penyelesaian'
} as const;

export type NonSpatialIssueHumanRightsEnum = typeof NonSpatialIssueHumanRightsEnum[keyof typeof NonSpatialIssueHumanRightsEnum];


/**
 * List of allowed answer for indigenous people rights issue
 * @export
 * @enum {string}
 */

export const NonSpatialIssueIndigenousPeopleRightsEnum = {
    AdaMasyarakatAdatTidakAdaIsu: 'Ada Masyarakat Adat - Tidak Ada Isu',
    AdaMasyarakatAdatAdaIsuSelesai: 'Ada Masyarakat Adat - Ada Isu - Selesai',
    AdaMasyarakatAdatAdaIsuDalamProsesPenyelesaian: 'Ada Masyarakat Adat - Ada Isu - dalam Proses Penyelesaian',
    TidakAdaMasyarakatAdat: 'Tidak Ada Masyarakat Adat'
} as const;

export type NonSpatialIssueIndigenousPeopleRightsEnum = typeof NonSpatialIssueIndigenousPeopleRightsEnum[keyof typeof NonSpatialIssueIndigenousPeopleRightsEnum];


/**
 * List of allowed answer for local community rights issue
 * @export
 * @enum {string}
 */

export const NonSpatialIssueLocalCommunityRightsEnum = {
    Ada: 'Ada',
    AdaDanTelahSelesai: 'Ada dan Telah Selesai',
    AdaDanDalamProsesPenyelesaian: 'Ada dan dalam Proses Penyelesaian'
} as const;

export type NonSpatialIssueLocalCommunityRightsEnum = typeof NonSpatialIssueLocalCommunityRightsEnum[keyof typeof NonSpatialIssueLocalCommunityRightsEnum];


/**
 * List of allowed answer for worker rights issue
 * @export
 * @enum {string}
 */

export const NonSpatialIssueWorkerRightsEnum = {
    Ada: 'Ada',
    AdaDanTelahSelesai: 'Ada dan Telah Selesai',
    AdaDanDalamProsesPenyelesaian: 'Ada dan dalam Proses Penyelesaian'
} as const;

export type NonSpatialIssueWorkerRightsEnum = typeof NonSpatialIssueWorkerRightsEnum[keyof typeof NonSpatialIssueWorkerRightsEnum];


/**
 * 
 * @export
 * @interface NotificationCreateRequest
 */
export interface NotificationCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof NotificationCreateRequest
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationCreateRequest
     */
    'body': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationCreateRequest
     */
    'bodyDetail'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationCreateRequest
     */
    'url'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationCreateRequest
     */
    'shareButton'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationCreateRequest
     */
    'shopButton'?: boolean;
    /**
     * list of user id
     * @type {Array<string>}
     * @memberof NotificationCreateRequest
     */
    'receiver': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationCreateRequest
     */
    'waButton'?: boolean;
    /**
     * Notification execution time in unix timestamp
     * @type {number}
     * @memberof NotificationCreateRequest
     */
    'executionTime'?: number;
}
/**
 * 
 * @export
 * @interface NotificationCreateResponse
 */
export interface NotificationCreateResponse {
    /**
     * 
     * @type {boolean}
     * @memberof NotificationCreateResponse
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface NotificationListResponse
 */
export interface NotificationListResponse {
    /**
     * List of Notification
     * @type {Array<NotificationsGetDetailResponseItem>}
     * @memberof NotificationListResponse
     */
    'items': Array<NotificationsGetDetailResponseItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof NotificationListResponse
     */
    'pagination': PaginationResponse;
}
/**
 * 
 * @export
 * @interface NotificationsGetDetailResponse
 */
export interface NotificationsGetDetailResponse {
    /**
     * Id of Notifications Detail
     * @type {string}
     * @memberof NotificationsGetDetailResponse
     */
    'id': string;
    /**
     * Notifications Detail subject
     * @type {string}
     * @memberof NotificationsGetDetailResponse
     */
    'subject': string;
    /**
     * Notifications Detail content
     * @type {string}
     * @memberof NotificationsGetDetailResponse
     */
    'content': string;
    /**
     * Member SawitPRO notifications detail date (in epoch). Will be represented in UTC-0, time will be set at midnight (00:00)
     * @type {number}
     * @memberof NotificationsGetDetailResponse
     */
    'date': number;
    /**
     * Notifications Detail content
     * @type {string}
     * @memberof NotificationsGetDetailResponse
     */
    'url': string;
    /**
     * Mark the active button of Notifications Detail
     * @type {boolean}
     * @memberof NotificationsGetDetailResponse
     */
    'isButton': boolean;
    /**
     * Notifications Detail Body HTML
     * @type {string}
     * @memberof NotificationsGetDetailResponse
     */
    'bodyDetail': string;
    /**
     * Mark the active button of Link to shop
     * @type {boolean}
     * @memberof NotificationsGetDetailResponse
     */
    'shopButton': boolean;
    /**
     * Mark the active button of Share to WhatsApp
     * @type {boolean}
     * @memberof NotificationsGetDetailResponse
     */
    'waButton': boolean;
}
/**
 * 
 * @export
 * @interface NotificationsGetDetailResponseItem
 */
export interface NotificationsGetDetailResponseItem {
    /**
     * Id of Notification List
     * @type {string}
     * @memberof NotificationsGetDetailResponseItem
     */
    'id': string;
    /**
     * Notification List subject
     * @type {string}
     * @memberof NotificationsGetDetailResponseItem
     */
    'subject': string;
    /**
     * Notification List content
     * @type {string}
     * @memberof NotificationsGetDetailResponseItem
     */
    'content': string;
    /**
     * Member SawitPRO notification list date (in epoch). Will be represented in UTC-0, time will be set at midnight (00:00)
     * @type {number}
     * @memberof NotificationsGetDetailResponseItem
     */
    'date': number;
    /**
     * Mark the read of Notification List
     * @type {boolean}
     * @memberof NotificationsGetDetailResponseItem
     */
    'isRead': boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const OperatorEnum = {
    Indosat: 'INDOSAT',
    Telkomsel: 'TELKOMSEL',
    Im3: 'IM3',
    Xl: 'XL',
    Tri: 'TRI',
    Pln: 'PLN'
} as const;

export type OperatorEnum = typeof OperatorEnum[keyof typeof OperatorEnum];


/**
 * 
 * @export
 * @interface OrderCreateBadRequestErrorResponse
 */
export interface OrderCreateBadRequestErrorResponse {
    /**
     * 
     * @type {string}
     * @memberof OrderCreateBadRequestErrorResponse
     */
    'error': string;
    /**
     * 
     * @type {Array<OrderCreateBadRequestErrorResponseItem>}
     * @memberof OrderCreateBadRequestErrorResponse
     */
    'items': Array<OrderCreateBadRequestErrorResponseItem>;
}
/**
 * 
 * @export
 * @interface OrderCreateBadRequestErrorResponseAllOf
 */
export interface OrderCreateBadRequestErrorResponseAllOf {
    /**
     * 
     * @type {Array<OrderCreateBadRequestErrorResponseItem>}
     * @memberof OrderCreateBadRequestErrorResponseAllOf
     */
    'items': Array<OrderCreateBadRequestErrorResponseItem>;
}
/**
 * 
 * @export
 * @interface OrderCreateBadRequestErrorResponseItem
 */
export interface OrderCreateBadRequestErrorResponseItem {
    /**
     * Store UUID
     * @type {string}
     * @memberof OrderCreateBadRequestErrorResponseItem
     */
    'storeId': string;
    /**
     * Product UUID
     * @type {string}
     * @memberof OrderCreateBadRequestErrorResponseItem
     */
    'productId': string;
    /**
     * Product Quantity
     * @type {number}
     * @memberof OrderCreateBadRequestErrorResponseItem
     */
    'quantity': number;
    /**
     * Product displayed price for price update validation
     * @type {number}
     * @memberof OrderCreateBadRequestErrorResponseItem
     */
    'productDisplayedPrice': number;
    /**
     * Pricelist ID
     * @type {string}
     * @memberof OrderCreateBadRequestErrorResponseItem
     */
    'pricelistId'?: string;
    /**
     * Promo Item ID
     * @type {string}
     * @memberof OrderCreateBadRequestErrorResponseItem
     */
    'promoItemId'?: string;
    /**
     * Inquiry ID
     * @type {string}
     * @memberof OrderCreateBadRequestErrorResponseItem
     */
    'inquiryId'?: string;
    /**
     * 
     * @type {OrderCreateRequestItemMetadata}
     * @memberof OrderCreateBadRequestErrorResponseItem
     */
    'metaData'?: OrderCreateRequestItemMetadata;
    /**
     * Product current price
     * @type {number}
     * @memberof OrderCreateBadRequestErrorResponseItem
     */
    'productCurrentPrice': number;
    /**
     * Product current stock
     * @type {number}
     * @memberof OrderCreateBadRequestErrorResponseItem
     */
    'productCurrentStock': number;
}
/**
 * 
 * @export
 * @interface OrderCreateBadRequestErrorResponseItemAllOf
 */
export interface OrderCreateBadRequestErrorResponseItemAllOf {
    /**
     * Product current price
     * @type {number}
     * @memberof OrderCreateBadRequestErrorResponseItemAllOf
     */
    'productCurrentPrice': number;
    /**
     * Product current stock
     * @type {number}
     * @memberof OrderCreateBadRequestErrorResponseItemAllOf
     */
    'productCurrentStock': number;
}
/**
 * 
 * @export
 * @interface OrderCreateRequest
 */
export interface OrderCreateRequest {
    /**
     * User UUID
     * @type {string}
     * @memberof OrderCreateRequest
     */
    'userId'?: string;
    /**
     * Phone number of the user
     * @type {string}
     * @memberof OrderCreateRequest
     */
    'phoneNo'?: string;
    /**
     * 
     * @type {OrderCreateRequestDelivery}
     * @memberof OrderCreateRequest
     */
    'delivery'?: OrderCreateRequestDelivery;
    /**
     * 
     * @type {OrderCreateRequestShipping}
     * @memberof OrderCreateRequest
     */
    'shipping'?: OrderCreateRequestShipping;
    /**
     * 
     * @type {Array<OrderCreateRequestItem>}
     * @memberof OrderCreateRequest
     */
    'items': Array<OrderCreateRequestItem>;
}
/**
 * 
 * @export
 * @interface OrderCreateRequestDelivery
 */
export interface OrderCreateRequestDelivery {
    /**
     * 
     * @type {DeliveryTypeEnum}
     * @memberof OrderCreateRequestDelivery
     */
    'type': DeliveryTypeEnum;
    /**
     * Pickup schedule datetime (in epoch) formatted in UTC-0
     * @type {number}
     * @memberof OrderCreateRequestDelivery
     */
    'pickupScheduleAtUtc0': number;
    /**
     * Recipient name
     * @type {string}
     * @memberof OrderCreateRequestDelivery
     */
    'recipientName': string;
    /**
     * Recipient phone number
     * @type {string}
     * @memberof OrderCreateRequestDelivery
     */
    'recipientPhoneNo': string;
    /**
     * Recipient vehicle number
     * @type {string}
     * @memberof OrderCreateRequestDelivery
     */
    'vehicleLicenseNumber': string;
    /**
     * Id of pickup location
     * @type {string}
     * @memberof OrderCreateRequestDelivery
     */
    'pickupLocationId'?: string;
}


/**
 * 
 * @export
 * @interface OrderCreateRequestItem
 */
export interface OrderCreateRequestItem {
    /**
     * Store UUID
     * @type {string}
     * @memberof OrderCreateRequestItem
     */
    'storeId': string;
    /**
     * Product UUID
     * @type {string}
     * @memberof OrderCreateRequestItem
     */
    'productId': string;
    /**
     * Product Quantity
     * @type {number}
     * @memberof OrderCreateRequestItem
     */
    'quantity': number;
    /**
     * Product displayed price for price update validation
     * @type {number}
     * @memberof OrderCreateRequestItem
     */
    'productDisplayedPrice': number;
    /**
     * Pricelist ID
     * @type {string}
     * @memberof OrderCreateRequestItem
     */
    'pricelistId'?: string;
    /**
     * Promo Item ID
     * @type {string}
     * @memberof OrderCreateRequestItem
     */
    'promoItemId'?: string;
    /**
     * Inquiry ID
     * @type {string}
     * @memberof OrderCreateRequestItem
     */
    'inquiryId'?: string;
    /**
     * 
     * @type {OrderCreateRequestItemMetadata}
     * @memberof OrderCreateRequestItem
     */
    'metaData'?: OrderCreateRequestItemMetadata;
}
/**
 * 
 * @export
 * @interface OrderCreateRequestItemMetadata
 */
export interface OrderCreateRequestItemMetadata {
    /**
     * this is for customer number | Currently we use for digital product
     * @type {string}
     * @memberof OrderCreateRequestItemMetadata
     */
    'customerPhoneNo'?: string;
    /**
     * this is for customer number | Currently we use for pln number
     * @type {string}
     * @memberof OrderCreateRequestItemMetadata
     */
    'customerNo'?: string;
}
/**
 * 
 * @export
 * @interface OrderCreateRequestShipping
 */
export interface OrderCreateRequestShipping {
    /**
     * Address
     * @type {string}
     * @memberof OrderCreateRequestShipping
     */
    'address': string;
    /**
     * Destination area ID
     * @type {string}
     * @memberof OrderCreateRequestShipping
     */
    'destinationAreaId'?: string;
    /**
     * Destination city
     * @type {string}
     * @memberof OrderCreateRequestShipping
     */
    'destinationCity': string;
    /**
     * Destination district
     * @type {string}
     * @memberof OrderCreateRequestShipping
     */
    'destinationDistrict': string;
    /**
     * Origin city
     * @type {string}
     * @memberof OrderCreateRequestShipping
     */
    'originCity': string;
    /**
     * Origin district
     * @type {string}
     * @memberof OrderCreateRequestShipping
     */
    'originDistrict': string;
}
/**
 * 
 * @export
 * @interface OrderCreateResponse
 */
export interface OrderCreateResponse {
    /**
     * Order UUID
     * @type {string}
     * @memberof OrderCreateResponse
     */
    'id': string;
    /**
     * Invoice UUID
     * @type {string}
     * @memberof OrderCreateResponse
     */
    'invoiceId': string;
    /**
     * Total Item Price
     * @type {number}
     * @memberof OrderCreateResponse
     */
    'totalPrice': number;
    /**
     * The maximum percentage of points allowed to pay order
     * @type {number}
     * @memberof OrderCreateResponse
     */
    'limitPointUsage': number;
    /**
     * The maximum points allowed to pay the order in IDR
     * @type {number}
     * @memberof OrderCreateResponse
     */
    'limitPointUsageIdr': number;
    /**
     * 
     * @type {OrderCreateResponseDeliveryInformation}
     * @memberof OrderCreateResponse
     */
    'deliveryInformation'?: OrderCreateResponseDeliveryInformation;
}
/**
 * 
 * @export
 * @interface OrderCreateResponseDeliveryInformation
 */
export interface OrderCreateResponseDeliveryInformation {
    /**
     * Origin City
     * @type {string}
     * @memberof OrderCreateResponseDeliveryInformation
     */
    'originCity': string;
    /**
     * Origin District
     * @type {string}
     * @memberof OrderCreateResponseDeliveryInformation
     */
    'originDistrict': string;
    /**
     * total weight of product is kilogram
     * @type {number}
     * @memberof OrderCreateResponseDeliveryInformation
     */
    'totalWeight': number;
    /**
     * 
     * @type {Array<DeliveryTypeEnum>}
     * @memberof OrderCreateResponseDeliveryInformation
     */
    'types': Array<DeliveryTypeEnum>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const OrderDirectionEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;

export type OrderDirectionEnum = typeof OrderDirectionEnum[keyof typeof OrderDirectionEnum];


/**
 * 
 * @export
 * @interface OrderGetDetailCustomerItem
 */
export interface OrderGetDetailCustomerItem {
    /**
     * Phone Number of Customer
     * @type {string}
     * @memberof OrderGetDetailCustomerItem
     */
    'phoneNumber': string;
    /**
     * Account Number of Customer
     * @type {string}
     * @memberof OrderGetDetailCustomerItem
     */
    'accountNumber': string;
    /**
     * Token Number of Customer, currently only for pln
     * @type {string}
     * @memberof OrderGetDetailCustomerItem
     */
    'tokenNumber'?: string;
    /**
     * 
     * @type {EcommerceCustomerAdditionalParameterItem}
     * @memberof OrderGetDetailCustomerItem
     */
    'additionInformation'?: EcommerceCustomerAdditionalParameterItem;
    /**
     * 
     * @type {EcommerceCustomerCouponInformationItem}
     * @memberof OrderGetDetailCustomerItem
     */
    'couponInformation'?: EcommerceCustomerCouponInformationItem;
}
/**
 * totalPrice  = This field is used for sorting by the total sale order createdAt   = This field is used for sorting by the order\'s creation date status      = This field is used for sorting by the status of the sale order invoiceNo   = This field is used for sorting by the number of the invoice 
 * @export
 * @enum {string}
 */

export const OrderOperationSortFieldEnum = {
    TotalPrice: 'totalPrice',
    CreatedAt: 'createdAt',
    Status: 'status',
    InvoiceNo: 'invoiceNo'
} as const;

export type OrderOperationSortFieldEnum = typeof OrderOperationSortFieldEnum[keyof typeof OrderOperationSortFieldEnum];


/**
 * 
 * @export
 * @interface OrdersCancelConfirmationRequest
 */
export interface OrdersCancelConfirmationRequest {
    /**
     * Is order cancellation request approved
     * @type {boolean}
     * @memberof OrdersCancelConfirmationRequest
     */
    'isApproved': boolean;
}
/**
 * 
 * @export
 * @interface OrdersCancelConfirmationResponse
 */
export interface OrdersCancelConfirmationResponse {
    /**
     * 
     * @type {string}
     * @memberof OrdersCancelConfirmationResponse
     */
    'id': string;
    /**
     * 
     * @type {SaleOrderStatusEnum}
     * @memberof OrdersCancelConfirmationResponse
     */
    'status': SaleOrderStatusEnum;
}


/**
 * 
 * @export
 * @interface OrdersCancelRequest
 */
export interface OrdersCancelRequest {
    /**
     * The reason why the order is being cancelled
     * @type {string}
     * @memberof OrdersCancelRequest
     */
    'cancellationReason': string;
}
/**
 * 
 * @export
 * @interface OrdersCancelResponse
 */
export interface OrdersCancelResponse {
    /**
     * 
     * @type {string}
     * @memberof OrdersCancelResponse
     */
    'id': string;
    /**
     * 
     * @type {SaleOrderStatusEnum}
     * @memberof OrdersCancelResponse
     */
    'status': SaleOrderStatusEnum;
}


/**
 * 
 * @export
 * @interface OrdersDeliveriesCreateRequest
 */
export interface OrdersDeliveriesCreateRequest {
    /**
     * Recipient name
     * @type {string}
     * @memberof OrdersDeliveriesCreateRequest
     */
    'recipientName': string;
    /**
     * Phone number starting with 0 as prefix (08xxxxxxxxx)
     * @type {string}
     * @memberof OrdersDeliveriesCreateRequest
     */
    'recipientPhoneNumber': string;
    /**
     * Recipient vehicle number
     * @type {string}
     * @memberof OrdersDeliveriesCreateRequest
     */
    'vehicleLicenseNumber': string;
    /**
     * Pickup schedule datetime (in epoch) formatted in UTC-0
     * @type {number}
     * @memberof OrdersDeliveriesCreateRequest
     */
    'pickupScheduleAtUtc0': number;
    /**
     * 
     * @type {DeliveryTypeEnum}
     * @memberof OrdersDeliveriesCreateRequest
     */
    'deliveryType': DeliveryTypeEnum;
    /**
     * 
     * @type {OrdersDeliveriesCreateRequestShipping}
     * @memberof OrdersDeliveriesCreateRequest
     */
    'shipping'?: OrdersDeliveriesCreateRequestShipping;
    /**
     * Id of pickup location
     * @type {string}
     * @memberof OrdersDeliveriesCreateRequest
     */
    'pickupLocationId'?: string;
}


/**
 * 
 * @export
 * @interface OrdersDeliveriesCreateRequestShipping
 */
export interface OrdersDeliveriesCreateRequestShipping {
    /**
     * total weight of product
     * @type {number}
     * @memberof OrdersDeliveriesCreateRequestShipping
     */
    'totalShippingCost': number;
    /**
     * Origin Stock Location City
     * @type {string}
     * @memberof OrdersDeliveriesCreateRequestShipping
     */
    'originCity': string;
    /**
     * Origin Stock Location District
     * @type {string}
     * @memberof OrdersDeliveriesCreateRequestShipping
     */
    'originDistrict': string;
    /**
     * Destination Stock Location Area ID
     * @type {string}
     * @memberof OrdersDeliveriesCreateRequestShipping
     */
    'destinationAreaId'?: string;
    /**
     * Destination Stock Location City
     * @type {string}
     * @memberof OrdersDeliveriesCreateRequestShipping
     */
    'destinationCity': string;
    /**
     * Destination Stock Location District
     * @type {string}
     * @memberof OrdersDeliveriesCreateRequestShipping
     */
    'destinationDistrict': string;
    /**
     * Delivery address
     * @type {string}
     * @memberof OrdersDeliveriesCreateRequestShipping
     */
    'address': string;
}
/**
 * 
 * @export
 * @interface OrdersDeliveriesCreateResponse
 */
export interface OrdersDeliveriesCreateResponse {
    /**
     * Successfully to create order delivery information
     * @type {boolean}
     * @memberof OrdersDeliveriesCreateResponse
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface OrdersGetDetailResponse
 */
export interface OrdersGetDetailResponse {
    /**
     * Sale Order UUID
     * @type {string}
     * @memberof OrdersGetDetailResponse
     */
    'id': string;
    /**
     * Sale Order Number
     * @type {string}
     * @memberof OrdersGetDetailResponse
     */
    'orderNo': string;
    /**
     * 
     * @type {SaleOrderStatusEnum}
     * @memberof OrdersGetDetailResponse
     */
    'status': SaleOrderStatusEnum;
    /**
     * The time for the user to pick up their order
     * @type {number}
     * @memberof OrdersGetDetailResponse
     */
    'pickUpDateAtUtc0': number;
    /**
     * Total order price
     * @type {number}
     * @memberof OrdersGetDetailResponse
     */
    'totalItemPrice': number;
    /**
     * 
     * @type {Array<OrdersGetDetailResponseStoreOrderItem>}
     * @memberof OrdersGetDetailResponse
     */
    'storeOrderItems': Array<OrdersGetDetailResponseStoreOrderItem>;
    /**
     * Name of Recipient
     * @type {string}
     * @memberof OrdersGetDetailResponse
     */
    'recipientName': string;
    /**
     * Phone Number of Recipient
     * @type {string}
     * @memberof OrdersGetDetailResponse
     */
    'recipientPhoneNumber': string;
    /**
     * 
     * @type {OrderGetDetailCustomerItem}
     * @memberof OrdersGetDetailResponse
     */
    'customer': OrderGetDetailCustomerItem;
    /**
     * Order creation time
     * @type {number}
     * @memberof OrdersGetDetailResponse
     */
    'createdAtUtc0': number;
}


/**
 * 
 * @export
 * @interface OrdersGetDetailResponseStoreOrderItem
 */
export interface OrdersGetDetailResponseStoreOrderItem {
    /**
     * Store UUID
     * @type {string}
     * @memberof OrdersGetDetailResponseStoreOrderItem
     */
    'id': string;
    /**
     * Name of Store
     * @type {string}
     * @memberof OrdersGetDetailResponseStoreOrderItem
     */
    'storeName': string;
    /**
     * Address of Store
     * @type {string}
     * @memberof OrdersGetDetailResponseStoreOrderItem
     */
    'storeAddress': string;
    /**
     * 
     * @type {Array<OrdersGetDetailResponseStoreProductItem>}
     * @memberof OrdersGetDetailResponseStoreOrderItem
     */
    'productItems': Array<OrdersGetDetailResponseStoreProductItem>;
    /**
     * Stock Location Latitude
     * @type {number}
     * @memberof OrdersGetDetailResponseStoreOrderItem
     */
    'latitude': number;
    /**
     * Stock Location Longitude
     * @type {number}
     * @memberof OrdersGetDetailResponseStoreOrderItem
     */
    'longitude': number;
    /**
     * Name of Store Owner
     * @type {string}
     * @memberof OrdersGetDetailResponseStoreOrderItem
     */
    'picName': string;
    /**
     * Phone Number of Store Owner
     * @type {string}
     * @memberof OrdersGetDetailResponseStoreOrderItem
     */
    'picPhoneNumber': string;
}
/**
 * 
 * @export
 * @interface OrdersGetDetailResponseStoreProductItem
 */
export interface OrdersGetDetailResponseStoreProductItem {
    /**
     * Order Item UUID
     * @type {string}
     * @memberof OrdersGetDetailResponseStoreProductItem
     */
    'id': string;
    /**
     * Quantity of Product
     * @type {number}
     * @memberof OrdersGetDetailResponseStoreProductItem
     */
    'quantity': number;
    /**
     * Product current price
     * @type {number}
     * @memberof OrdersGetDetailResponseStoreProductItem
     */
    'price': number;
    /**
     * Name of Product
     * @type {string}
     * @memberof OrdersGetDetailResponseStoreProductItem
     */
    'productName': string;
    /**
     * Description of Product
     * @type {string}
     * @memberof OrdersGetDetailResponseStoreProductItem
     */
    'productDescription': string;
    /**
     * Image URL of Product
     * @type {string}
     * @memberof OrdersGetDetailResponseStoreProductItem
     */
    'productPhoto': string;
    /**
     * Product unit of measurement
     * @type {string}
     * @memberof OrdersGetDetailResponseStoreProductItem
     */
    'unitOfMeasurement': string;
    /**
     * Product category code, currently we are not using enum due to blocker if we have new category
     * @type {string}
     * @memberof OrdersGetDetailResponseStoreProductItem
     */
    'categoryCode': string;
    /**
     * 
     * @type {EcommerceProductTypeEnum}
     * @memberof OrdersGetDetailResponseStoreProductItem
     */
    'type'?: EcommerceProductTypeEnum;
}


/**
 * 
 * @export
 * @interface OrdersListOperationOrderDeliveryResponse
 */
export interface OrdersListOperationOrderDeliveryResponse {
    /**
     * 
     * @type {DeliveryEnum}
     * @memberof OrdersListOperationOrderDeliveryResponse
     */
    'method': DeliveryEnum;
    /**
     * name of who is recipient the item
     * @type {string}
     * @memberof OrdersListOperationOrderDeliveryResponse
     */
    'recipientName': string;
    /**
     * phone number of who is recipent the item
     * @type {string}
     * @memberof OrdersListOperationOrderDeliveryResponse
     */
    'recipientPhoneNo': string;
    /**
     * Recipient vehicle number
     * @type {string}
     * @memberof OrdersListOperationOrderDeliveryResponse
     */
    'vehicleLicenseNo': string;
}


/**
 * 
 * @export
 * @interface OrdersListOperationOrderItemResponse
 */
export interface OrdersListOperationOrderItemResponse {
    /**
     * Sale Order Item UUID
     * @type {string}
     * @memberof OrdersListOperationOrderItemResponse
     */
    'id': string;
    /**
     * Name of Store
     * @type {string}
     * @memberof OrdersListOperationOrderItemResponse
     */
    'storeName': string;
    /**
     * Name of Product
     * @type {string}
     * @memberof OrdersListOperationOrderItemResponse
     */
    'productName': string;
    /**
     * Product current price
     * @type {number}
     * @memberof OrdersListOperationOrderItemResponse
     */
    'productPrice': number;
    /**
     * Quantity of Product
     * @type {number}
     * @memberof OrdersListOperationOrderItemResponse
     */
    'quantity': number;
    /**
     * 
     * @type {SaleOrderStatusEnum}
     * @memberof OrdersListOperationOrderItemResponse
     */
    'status': SaleOrderStatusEnum;
    /**
     * 
     * @type {EcommerceProductTypeEnum}
     * @memberof OrdersListOperationOrderItemResponse
     */
    'productType': EcommerceProductTypeEnum;
}


/**
 * 
 * @export
 * @interface OrdersListOperationPaymentItem
 */
export interface OrdersListOperationPaymentItem {
    /**
     * 
     * @type {string}
     * @memberof OrdersListOperationPaymentItem
     */
    'id': string;
    /**
     * 
     * @type {PaymentStatusEnum}
     * @memberof OrdersListOperationPaymentItem
     */
    'status': PaymentStatusEnum;
    /**
     * 
     * @type {PaymentMethodEnum}
     * @memberof OrdersListOperationPaymentItem
     */
    'method': PaymentMethodEnum;
}


/**
 * 
 * @export
 * @interface OrdersListOperationResponse
 */
export interface OrdersListOperationResponse {
    /**
     * 
     * @type {Array<OrdersListOperationResponseItem>}
     * @memberof OrdersListOperationResponse
     */
    'items': Array<OrdersListOperationResponseItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof OrdersListOperationResponse
     */
    'pagination': PaginationResponse;
}
/**
 * 
 * @export
 * @interface OrdersListOperationResponseItem
 */
export interface OrdersListOperationResponseItem {
    /**
     * Sale Order UUID
     * @type {string}
     * @memberof OrdersListOperationResponseItem
     */
    'id': string;
    /**
     * Sale Order No
     * @type {string}
     * @memberof OrdersListOperationResponseItem
     */
    'orderNo': string;
    /**
     * User UUID
     * @type {string}
     * @memberof OrdersListOperationResponseItem
     */
    'userId': string;
    /**
     * Name User
     * @type {string}
     * @memberof OrdersListOperationResponseItem
     */
    'userName': string;
    /**
     * Product current price
     * @type {number}
     * @memberof OrdersListOperationResponseItem
     */
    'totalItemPrice': number;
    /**
     * 
     * @type {SaleOrderStatusEnum}
     * @memberof OrdersListOperationResponseItem
     */
    'status': SaleOrderStatusEnum;
    /**
     * 
     * @type {Array<OrdersListOperationOrderItemResponse>}
     * @memberof OrdersListOperationResponseItem
     */
    'orderItems': Array<OrdersListOperationOrderItemResponse>;
    /**
     * Invoice No
     * @type {string}
     * @memberof OrdersListOperationResponseItem
     */
    'invoiceNo': string;
    /**
     * The reason why the order is being cancelled
     * @type {string}
     * @memberof OrdersListOperationResponseItem
     */
    'cancellationReason': string;
    /**
     * Name of Store
     * @type {string}
     * @memberof OrdersListOperationResponseItem
     */
    'storeName': string;
    /**
     * Created Datetime of Order
     * @type {number}
     * @memberof OrdersListOperationResponseItem
     */
    'createdAt': number;
    /**
     * 
     * @type {OrdersListOperationOrderDeliveryResponse}
     * @memberof OrdersListOperationResponseItem
     */
    'orderDelivery': OrdersListOperationOrderDeliveryResponse;
    /**
     * 
     * @type {PaymentStatusEnum}
     * @memberof OrdersListOperationResponseItem
     */
    'paymentStatus': PaymentStatusEnum;
    /**
     * 
     * @type {Array<OrdersListOperationPaymentItem>}
     * @memberof OrdersListOperationResponseItem
     */
    'paymentItems': Array<OrdersListOperationPaymentItem>;
}


/**
 * 
 * @export
 * @interface OrdersListResponse
 */
export interface OrdersListResponse {
    /**
     * 
     * @type {Array<OrdersListResponseItem>}
     * @memberof OrdersListResponse
     */
    'items': Array<OrdersListResponseItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof OrdersListResponse
     */
    'pagination': PaginationResponse;
}
/**
 * 
 * @export
 * @interface OrdersListResponseItem
 */
export interface OrdersListResponseItem {
    /**
     * Order UUID
     * @type {string}
     * @memberof OrdersListResponseItem
     */
    'id': string;
    /**
     * 
     * @type {SaleOrderStatusEnum}
     * @memberof OrdersListResponseItem
     */
    'status': SaleOrderStatusEnum;
    /**
     * Product current price
     * @type {number}
     * @memberof OrdersListResponseItem
     */
    'totalItemPrice': number;
    /**
     * Total amount of order
     * @type {number}
     * @memberof OrdersListResponseItem
     */
    'totalAmount': number;
    /**
     * Created Datetime of Order
     * @type {number}
     * @memberof OrdersListResponseItem
     */
    'createdAt': number;
    /**
     * Total SKU
     * @type {number}
     * @memberof OrdersListResponseItem
     */
    'productCount': number;
    /**
     * 
     * @type {EcommerceProductTypeEnum}
     * @memberof OrdersListResponseItem
     */
    'productType': EcommerceProductTypeEnum;
    /**
     * 
     * @type {Array<OrdersListResponseStoreItem>}
     * @memberof OrdersListResponseItem
     */
    'storeItems': Array<OrdersListResponseStoreItem>;
}


/**
 * 
 * @export
 * @interface OrdersListResponseProductItem
 */
export interface OrdersListResponseProductItem {
    /**
     * Order Item UUID
     * @type {string}
     * @memberof OrdersListResponseProductItem
     */
    'id': string;
    /**
     * Quantity of Product
     * @type {number}
     * @memberof OrdersListResponseProductItem
     */
    'quantity': number;
    /**
     * Product current price
     * @type {number}
     * @memberof OrdersListResponseProductItem
     */
    'price': number;
    /**
     * Name of Product
     * @type {string}
     * @memberof OrdersListResponseProductItem
     */
    'productName': string;
    /**
     * Image URL of Product
     * @type {string}
     * @memberof OrdersListResponseProductItem
     */
    'productPhoto': string;
    /**
     * Product Category Code
     * @type {string}
     * @memberof OrdersListResponseProductItem
     */
    'productCategoryCode': string;
    /**
     * Schedule Start Datetime of Order
     * @type {number}
     * @memberof OrdersListResponseProductItem
     */
    'scheduleStart'?: number;
    /**
     * Schedule End Datetime of Order
     * @type {number}
     * @memberof OrdersListResponseProductItem
     */
    'scheduleEnd'?: number;
}
/**
 * 
 * @export
 * @interface OrdersListResponseStoreItem
 */
export interface OrdersListResponseStoreItem {
    /**
     * Store UUID
     * @type {string}
     * @memberof OrdersListResponseStoreItem
     */
    'id': string;
    /**
     * Name of Store
     * @type {string}
     * @memberof OrdersListResponseStoreItem
     */
    'storeName': string;
    /**
     * 
     * @type {Array<OrdersListResponseProductItem>}
     * @memberof OrdersListResponseStoreItem
     */
    'productItems': Array<OrdersListResponseProductItem>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const OrdersUpdateStatusEnum = {
    Confirmed: 'CONFIRMED',
    ReadyToPickUp: 'READY_TO_PICK_UP',
    Delivering: 'DELIVERING',
    FullDelivered: 'FULL_DELIVERED',
    PartiallyDelivered: 'PARTIALLY_DELIVERED',
    Completed: 'COMPLETED',
    Cancelled: 'CANCELLED'
} as const;

export type OrdersUpdateStatusEnum = typeof OrdersUpdateStatusEnum[keyof typeof OrdersUpdateStatusEnum];


/**
 * 
 * @export
 * @interface OrdersUpdateStatusRequest
 */
export interface OrdersUpdateStatusRequest {
    /**
     * 
     * @type {OrdersUpdateStatusEnum}
     * @memberof OrdersUpdateStatusRequest
     */
    'status': OrdersUpdateStatusEnum;
}


/**
 * 
 * @export
 * @interface OrdersUpdateStatusResponse
 */
export interface OrdersUpdateStatusResponse {
    /**
     * 
     * @type {string}
     * @memberof OrdersUpdateStatusResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof OrdersUpdateStatusResponse
     */
    'userId': string;
    /**
     * 
     * @type {number}
     * @memberof OrdersUpdateStatusResponse
     */
    'totalItemPrice': number;
    /**
     * 
     * @type {OrdersUpdateStatusEnum}
     * @memberof OrdersUpdateStatusResponse
     */
    'status': OrdersUpdateStatusEnum;
    /**
     * List of Sale Order Item
     * @type {Array<OrdersUpdateStatusSaleOrderItem>}
     * @memberof OrdersUpdateStatusResponse
     */
    'saleOrderItems': Array<OrdersUpdateStatusSaleOrderItem>;
}


/**
 * 
 * @export
 * @interface OrdersUpdateStatusSaleOrderItem
 */
export interface OrdersUpdateStatusSaleOrderItem {
    /**
     * 
     * @type {string}
     * @memberof OrdersUpdateStatusSaleOrderItem
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof OrdersUpdateStatusSaleOrderItem
     */
    'saleOrderId': string;
    /**
     * 
     * @type {string}
     * @memberof OrdersUpdateStatusSaleOrderItem
     */
    'storePriceListId': string;
    /**
     * 
     * @type {number}
     * @memberof OrdersUpdateStatusSaleOrderItem
     */
    'price': number;
    /**
     * 
     * @type {number}
     * @memberof OrdersUpdateStatusSaleOrderItem
     */
    'quantity': number;
    /**
     * 
     * @type {OrdersUpdateStatusEnum}
     * @memberof OrdersUpdateStatusSaleOrderItem
     */
    'status': OrdersUpdateStatusEnum;
}


/**
 * 
 * @export
 * @interface PaginationResponse
 */
export interface PaginationResponse {
    /**
     * Current page number.
     * @type {number}
     * @memberof PaginationResponse
     */
    'page': number;
    /**
     * Number of pages that can be accessed.
     * @type {number}
     * @memberof PaginationResponse
     */
    'pages': number;
    /**
     * Total number of items.
     * @type {number}
     * @memberof PaginationResponse
     */
    'total': number;
}
/**
 * 
 * @export
 * @interface PalmOilAuthPinChangeRequest
 */
export interface PalmOilAuthPinChangeRequest {
    /**
     * 
     * @type {string}
     * @memberof PalmOilAuthPinChangeRequest
     */
    'oldPin': string;
    /**
     * 
     * @type {string}
     * @memberof PalmOilAuthPinChangeRequest
     */
    'newPin': string;
}
/**
 * 
 * @export
 * @interface PalmOilAuthPinChangeResponse
 */
export interface PalmOilAuthPinChangeResponse {
    /**
     * 
     * @type {boolean}
     * @memberof PalmOilAuthPinChangeResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface PalmOilAuthPinCreateResponse
 */
export interface PalmOilAuthPinCreateResponse {
    /**
     * 
     * @type {PalmOilAuthPinCreateResponseData}
     * @memberof PalmOilAuthPinCreateResponse
     */
    'data': PalmOilAuthPinCreateResponseData;
}
/**
 * 
 * @export
 * @interface PalmOilAuthPinCreateResponseData
 */
export interface PalmOilAuthPinCreateResponseData {
    /**
     * 
     * @type {boolean}
     * @memberof PalmOilAuthPinCreateResponseData
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface PalmOilAuthPinValidateRequest
 */
export interface PalmOilAuthPinValidateRequest {
    /**
     * Encrypted phoneNumber using RSA256 with public key that retrieved from local database.
     * @type {string}
     * @memberof PalmOilAuthPinValidateRequest
     */
    'phoneNumber': string;
    /**
     * Hash PIN using HMAC SHA 256 with secret key `SawitPRO`.
     * @type {string}
     * @memberof PalmOilAuthPinValidateRequest
     */
    'pin': string;
}
/**
 * 
 * @export
 * @interface PalmOilAuthPinValidateResponse
 */
export interface PalmOilAuthPinValidateResponse {
    /**
     * 
     * @type {PalmOilAuthPinValidateResponseData}
     * @memberof PalmOilAuthPinValidateResponse
     */
    'data'?: PalmOilAuthPinValidateResponseData;
}
/**
 * 
 * @export
 * @interface PalmOilAuthPinValidateResponseData
 */
export interface PalmOilAuthPinValidateResponseData {
    /**
     * 
     * @type {boolean}
     * @memberof PalmOilAuthPinValidateResponseData
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface PalmOilFilesWeighBridgeCreateRequest
 */
export interface PalmOilFilesWeighBridgeCreateRequest {
    /**
     * Mime type will be used to define object format/type
     * @type {string}
     * @memberof PalmOilFilesWeighBridgeCreateRequest
     */
    'mimeType': string;
    /**
     * Name of the object (image)
     * @type {string}
     * @memberof PalmOilFilesWeighBridgeCreateRequest
     */
    'originalFileName': string;
    /**
     * File size of the object (image) in bytes
     * @type {number}
     * @memberof PalmOilFilesWeighBridgeCreateRequest
     */
    'fileSize': number;
}
/**
 * 
 * @export
 * @interface PalmOilFilesWeighBridgeCreateResponse
 */
export interface PalmOilFilesWeighBridgeCreateResponse {
    /**
     * 
     * @type {PalmOilFilesWeighBridgeCreateResponseData}
     * @memberof PalmOilFilesWeighBridgeCreateResponse
     */
    'data': PalmOilFilesWeighBridgeCreateResponseData;
}
/**
 * 
 * @export
 * @interface PalmOilFilesWeighBridgeCreateResponseData
 */
export interface PalmOilFilesWeighBridgeCreateResponseData {
    /**
     * Presigned URL for uploading object
     * @type {string}
     * @memberof PalmOilFilesWeighBridgeCreateResponseData
     */
    'uploadUrl': string;
    /**
     * Expiry datetime of Presigned URL (in epoch) and will be represented in utc0
     * @type {number}
     * @memberof PalmOilFilesWeighBridgeCreateResponseData
     */
    'uploadExpiresAt': number;
}
/**
 * 
 * @export
 * @interface PalmOilJwtGetResponse
 */
export interface PalmOilJwtGetResponse {
    /**
     * 
     * @type {string}
     * @memberof PalmOilJwtGetResponse
     */
    'jwt'?: string;
}
/**
 * 
 * @export
 * @interface PalmOilUsersNotificationGetDetailResponse
 */
export interface PalmOilUsersNotificationGetDetailResponse {
    /**
     * Id of Notifications Detail
     * @type {string}
     * @memberof PalmOilUsersNotificationGetDetailResponse
     */
    'id': string;
    /**
     * Notifications Detail subject
     * @type {string}
     * @memberof PalmOilUsersNotificationGetDetailResponse
     */
    'subject': string;
    /**
     * Notifications Detail content
     * @type {string}
     * @memberof PalmOilUsersNotificationGetDetailResponse
     */
    'content': string;
    /**
     * Member SawitPRO notifications detail date (in epoch). Will be represented in UTC-0, time will be set at midnight (00:00)
     * @type {number}
     * @memberof PalmOilUsersNotificationGetDetailResponse
     */
    'date': number;
    /**
     * Notifications Detail content
     * @type {string}
     * @memberof PalmOilUsersNotificationGetDetailResponse
     */
    'url': string;
    /**
     * Mark the active button of Notifications Detail
     * @type {boolean}
     * @memberof PalmOilUsersNotificationGetDetailResponse
     */
    'isButton': boolean;
    /**
     * Notifications Detail Body HTML
     * @type {string}
     * @memberof PalmOilUsersNotificationGetDetailResponse
     */
    'bodyDetail': string;
}
/**
 * 
 * @export
 * @interface PalmOilUsersOtpValidateRequest
 */
export interface PalmOilUsersOtpValidateRequest {
    /**
     * 
     * @type {string}
     * @memberof PalmOilUsersOtpValidateRequest
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof PalmOilUsersOtpValidateRequest
     */
    'otp': string;
}
/**
 * 
 * @export
 * @interface PalmOilUsersOtpValidateResponse
 */
export interface PalmOilUsersOtpValidateResponse {
    /**
     * 
     * @type {PalmOilUsersOtpValidateResponseData}
     * @memberof PalmOilUsersOtpValidateResponse
     */
    'data'?: PalmOilUsersOtpValidateResponseData;
}
/**
 * 
 * @export
 * @interface PalmOilUsersOtpValidateResponseData
 */
export interface PalmOilUsersOtpValidateResponseData {
    /**
     * 
     * @type {boolean}
     * @memberof PalmOilUsersOtpValidateResponseData
     */
    'otp': boolean;
    /**
     * 
     * @type {string}
     * @memberof PalmOilUsersOtpValidateResponseData
     */
    'otpToken': string;
}
/**
 * 
 * @export
 * @interface PalmOilUsersPhoneNumberValidateRequest
 */
export interface PalmOilUsersPhoneNumberValidateRequest {
    /**
     * Encrypted phoneNumber using RSA256 with public key that retrieved from local database.
     * @type {string}
     * @memberof PalmOilUsersPhoneNumberValidateRequest
     */
    'phoneNumber': string;
}
/**
 * 
 * @export
 * @interface PalmOilUsersPhoneNumberValidateResponse
 */
export interface PalmOilUsersPhoneNumberValidateResponse {
    /**
     * 
     * @type {PalmOilUsersPhoneNumberValidateResponseData}
     * @memberof PalmOilUsersPhoneNumberValidateResponse
     */
    'data'?: PalmOilUsersPhoneNumberValidateResponseData;
}
/**
 * 
 * @export
 * @interface PalmOilUsersPhoneNumberValidateResponseData
 */
export interface PalmOilUsersPhoneNumberValidateResponseData {
    /**
     * 
     * @type {string}
     * @memberof PalmOilUsersPhoneNumberValidateResponseData
     */
    'phoneNumber': string;
    /**
     * 
     * @type {boolean}
     * @memberof PalmOilUsersPhoneNumberValidateResponseData
     */
    'registered': boolean;
}
/**
 * 
 * @export
 * @interface PalmOilUsersUpdateRegistrationRequest
 */
export interface PalmOilUsersUpdateRegistrationRequest {
    /**
     * 
     * @type {string}
     * @memberof PalmOilUsersUpdateRegistrationRequest
     */
    'name'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PalmOilUsersUpdateRegistrationRequest
     */
    'assets'?: Array<string>;
}
/**
 * 
 * @export
 * @interface PalmOilUsersUpdateRegistrationResponse
 */
export interface PalmOilUsersUpdateRegistrationResponse {
    /**
     * 
     * @type {boolean}
     * @memberof PalmOilUsersUpdateRegistrationResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface PalmOilVillagesGetResponse
 */
export interface PalmOilVillagesGetResponse {
    /**
     * 
     * @type {PalmOilVillagesGetResponseData}
     * @memberof PalmOilVillagesGetResponse
     */
    'data'?: PalmOilVillagesGetResponseData;
}
/**
 * 
 * @export
 * @interface PalmOilVillagesGetResponseData
 */
export interface PalmOilVillagesGetResponseData {
    /**
     * 
     * @type {Array<PalmOilVillagesGetResponseDataItem>}
     * @memberof PalmOilVillagesGetResponseData
     */
    'items': Array<PalmOilVillagesGetResponseDataItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof PalmOilVillagesGetResponseData
     */
    'pagination'?: PaginationResponse;
}
/**
 * 
 * @export
 * @interface PalmOilVillagesGetResponseDataItem
 */
export interface PalmOilVillagesGetResponseDataItem {
    /**
     * 
     * @type {string}
     * @memberof PalmOilVillagesGetResponseDataItem
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PalmOilVillagesGetResponseDataItem
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface PalmOilWeighbridgeSubmitRequest
 */
export interface PalmOilWeighbridgeSubmitRequest {
    /**
     * 
     * @type {string}
     * @memberof PalmOilWeighbridgeSubmitRequest
     */
    'deliveryNo': string;
    /**
     * 
     * @type {string}
     * @memberof PalmOilWeighbridgeSubmitRequest
     */
    'truckNo': string;
    /**
     * 
     * @type {string}
     * @memberof PalmOilWeighbridgeSubmitRequest
     */
    'ticketNo': string;
    /**
     * 
     * @type {string}
     * @memberof PalmOilWeighbridgeSubmitRequest
     */
    'driverName': string;
    /**
     * 
     * @type {string}
     * @memberof PalmOilWeighbridgeSubmitRequest
     */
    'entryTime': string;
    /**
     * 
     * @type {string}
     * @memberof PalmOilWeighbridgeSubmitRequest
     */
    'exitTime': string;
    /**
     * 
     * @type {number}
     * @memberof PalmOilWeighbridgeSubmitRequest
     */
    'entryWeight': number;
    /**
     * 
     * @type {number}
     * @memberof PalmOilWeighbridgeSubmitRequest
     */
    'exitWeight': number;
    /**
     * 
     * @type {string}
     * @memberof PalmOilWeighbridgeSubmitRequest
     */
    'sortation': PalmOilWeighbridgeSubmitRequestSortationEnum;
    /**
     * 
     * @type {string}
     * @memberof PalmOilWeighbridgeSubmitRequest
     */
    'adjustment': PalmOilWeighbridgeSubmitRequestAdjustmentEnum;
    /**
     * 
     * @type {number}
     * @memberof PalmOilWeighbridgeSubmitRequest
     */
    'netAdjustmentWeight': number;
    /**
     * 
     * @type {string}
     * @memberof PalmOilWeighbridgeSubmitRequest
     */
    'operatorName': string;
    /**
     * 
     * @type {number}
     * @memberof PalmOilWeighbridgeSubmitRequest
     */
    'quantity': number;
    /**
     * 
     * @type {number}
     * @memberof PalmOilWeighbridgeSubmitRequest
     */
    'bunchAvgWeight': number;
    /**
     * 
     * @type {string}
     * @memberof PalmOilWeighbridgeSubmitRequest
     */
    'supplierName': string;
    /**
     * 
     * @type {string}
     * @memberof PalmOilWeighbridgeSubmitRequest
     */
    'partnerName': string;
    /**
     * 
     * @type {string}
     * @memberof PalmOilWeighbridgeSubmitRequest
     */
    'photo': string;
}

export const PalmOilWeighbridgeSubmitRequestSortationEnum = {
    Ffb: 'FFB',
    Cpo: 'CPO',
    Pk: 'PK'
} as const;

export type PalmOilWeighbridgeSubmitRequestSortationEnum = typeof PalmOilWeighbridgeSubmitRequestSortationEnum[keyof typeof PalmOilWeighbridgeSubmitRequestSortationEnum];
export const PalmOilWeighbridgeSubmitRequestAdjustmentEnum = {
    Up: 'UP',
    Down: 'DOWN'
} as const;

export type PalmOilWeighbridgeSubmitRequestAdjustmentEnum = typeof PalmOilWeighbridgeSubmitRequestAdjustmentEnum[keyof typeof PalmOilWeighbridgeSubmitRequestAdjustmentEnum];

/**
 * 
 * @export
 * @interface PalmOilWeighbridgeSubmitResponse
 */
export interface PalmOilWeighbridgeSubmitResponse {
    /**
     * 
     * @type {string}
     * @memberof PalmOilWeighbridgeSubmitResponse
     */
    'jwt'?: string;
}
/**
 * 
 * @export
 * @interface PalmOilWorkersRemoveResponse
 */
export interface PalmOilWorkersRemoveResponse {
    /**
     * 
     * @type {PalmOilWorkersUpdateResponseData}
     * @memberof PalmOilWorkersRemoveResponse
     */
    'data'?: PalmOilWorkersUpdateResponseData;
    /**
     * 
     * @type {string}
     * @memberof PalmOilWorkersRemoveResponse
     */
    'error'?: string;
    /**
     * 
     * @type {string}
     * @memberof PalmOilWorkersRemoveResponse
     */
    'jwt'?: string;
}
/**
 * 
 * @export
 * @interface PalmOilWorkersUpdateRequest
 */
export interface PalmOilWorkersUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof PalmOilWorkersUpdateRequest
     */
    'asset_type'?: PalmOilWorkersUpdateRequestAssetTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PalmOilWorkersUpdateRequest
     */
    'asset_category_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PalmOilWorkersUpdateRequest
     */
    'worker_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PalmOilWorkersUpdateRequest
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof PalmOilWorkersUpdateRequest
     */
    'truck_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PalmOilWorkersUpdateRequest
     */
    'farm_id'?: string;
}

export const PalmOilWorkersUpdateRequestAssetTypeEnum = {
    Truck: 'TRUCK',
    Harvester: 'HARVESTER'
} as const;

export type PalmOilWorkersUpdateRequestAssetTypeEnum = typeof PalmOilWorkersUpdateRequestAssetTypeEnum[keyof typeof PalmOilWorkersUpdateRequestAssetTypeEnum];

/**
 * 
 * @export
 * @interface PalmOilWorkersUpdateResponse
 */
export interface PalmOilWorkersUpdateResponse {
    /**
     * 
     * @type {PalmOilWorkersUpdateResponseData}
     * @memberof PalmOilWorkersUpdateResponse
     */
    'data'?: PalmOilWorkersUpdateResponseData;
    /**
     * 
     * @type {string}
     * @memberof PalmOilWorkersUpdateResponse
     */
    'error'?: string;
    /**
     * 
     * @type {string}
     * @memberof PalmOilWorkersUpdateResponse
     */
    'jwt'?: string;
}
/**
 * 
 * @export
 * @interface PalmOilWorkersUpdateResponseData
 */
export interface PalmOilWorkersUpdateResponseData {
    /**
     * 
     * @type {string}
     * @memberof PalmOilWorkersUpdateResponseData
     */
    'worker_id': string;
}
/**
 * 
 * @export
 * @interface PartnerIdRequest
 */
export interface PartnerIdRequest {
    /**
     * Partner UUID
     * @type {string}
     * @memberof PartnerIdRequest
     */
    'partnerId'?: string;
}
/**
 * 
 * @export
 * @interface PartnerVendorCreateProductPricelistRequest
 */
export interface PartnerVendorCreateProductPricelistRequest {
    /**
     * product id
     * @type {string}
     * @memberof PartnerVendorCreateProductPricelistRequest
     */
    'productId': string;
    /**
     * store id
     * @type {string}
     * @memberof PartnerVendorCreateProductPricelistRequest
     */
    'vendorId': string;
    /**
     * price
     * @type {number}
     * @memberof PartnerVendorCreateProductPricelistRequest
     */
    'price': number;
    /**
     * stock of product
     * @type {number}
     * @memberof PartnerVendorCreateProductPricelistRequest
     */
    'availableStock': number;
    /**
     * is shown in app
     * @type {boolean}
     * @memberof PartnerVendorCreateProductPricelistRequest
     */
    'isShown': boolean;
}
/**
 * 
 * @export
 * @interface PartnerVendorCreateProductPricelistResponse
 */
export interface PartnerVendorCreateProductPricelistResponse {
    /**
     * pricelist id
     * @type {string}
     * @memberof PartnerVendorCreateProductPricelistResponse
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface PartnerVendorGetProductPricelistsResponse
 */
export interface PartnerVendorGetProductPricelistsResponse {
    /**
     * 
     * @type {Array<PartnerVendorGetProductPricelistsResponseItem>}
     * @memberof PartnerVendorGetProductPricelistsResponse
     */
    'items': Array<PartnerVendorGetProductPricelistsResponseItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof PartnerVendorGetProductPricelistsResponse
     */
    'pagination': PaginationResponse;
}
/**
 * 
 * @export
 * @interface PartnerVendorGetProductPricelistsResponseItem
 */
export interface PartnerVendorGetProductPricelistsResponseItem {
    /**
     * Pricelist ID represented in UUID
     * @type {string}
     * @memberof PartnerVendorGetProductPricelistsResponseItem
     */
    'pricelistId': string;
    /**
     * Stock Location ID represented in UUID
     * @type {string}
     * @memberof PartnerVendorGetProductPricelistsResponseItem
     */
    'stockLocationId': string;
    /**
     * Product ID represented in UUID
     * @type {string}
     * @memberof PartnerVendorGetProductPricelistsResponseItem
     */
    'productId': string;
    /**
     * Stock ID represented in UUID
     * @type {string}
     * @memberof PartnerVendorGetProductPricelistsResponseItem
     */
    'stockId': string;
    /**
     * Product Name
     * @type {string}
     * @memberof PartnerVendorGetProductPricelistsResponseItem
     */
    'productName': string;
    /**
     * Product Image URL
     * @type {string}
     * @memberof PartnerVendorGetProductPricelistsResponseItem
     */
    'productImageUrl': string;
    /**
     * Flag Shown in Member App
     * @type {boolean}
     * @memberof PartnerVendorGetProductPricelistsResponseItem
     */
    'isShownMember': boolean;
    /**
     * Flag Shown in Worker App
     * @type {boolean}
     * @memberof PartnerVendorGetProductPricelistsResponseItem
     */
    'isShownWorker': boolean;
    /**
     * Current Product Price
     * @type {number}
     * @memberof PartnerVendorGetProductPricelistsResponseItem
     */
    'price': number;
    /**
     * Current Product Stock Balance
     * @type {number}
     * @memberof PartnerVendorGetProductPricelistsResponseItem
     */
    'stock': number;
    /**
     * 
     * @type {EcommerceProductStatusEnum}
     * @memberof PartnerVendorGetProductPricelistsResponseItem
     */
    'status': EcommerceProductStatusEnum;
}


/**
 * productName         = This field is used for sorting the data by the product name price               = This field is used for sorting the data by the product price stock               = This field is used for sorting the data by the product stock balance pricelistStatus     = This field is used for sorting the data by the status 
 * @export
 * @enum {string}
 */

export const PartnerVendorGetProductPricelistsSortEnum = {
    ProductName: 'productName',
    Price: 'price',
    Stock: 'stock',
    PricelistStatus: 'pricelistStatus'
} as const;

export type PartnerVendorGetProductPricelistsSortEnum = typeof PartnerVendorGetProductPricelistsSortEnum[keyof typeof PartnerVendorGetProductPricelistsSortEnum];


/**
 * 
 * @export
 * @interface PartnerVendorUpdateProductPricelistRequest
 */
export interface PartnerVendorUpdateProductPricelistRequest {
    /**
     * product id
     * @type {string}
     * @memberof PartnerVendorUpdateProductPricelistRequest
     */
    'productId': string;
    /**
     * store id
     * @type {string}
     * @memberof PartnerVendorUpdateProductPricelistRequest
     */
    'vendorId': string;
    /**
     * price
     * @type {number}
     * @memberof PartnerVendorUpdateProductPricelistRequest
     */
    'price': number;
    /**
     * stock of product
     * @type {number}
     * @memberof PartnerVendorUpdateProductPricelistRequest
     */
    'availableStock': number;
    /**
     * is shown in app
     * @type {boolean}
     * @memberof PartnerVendorUpdateProductPricelistRequest
     */
    'isShown': boolean;
    /**
     * stock id
     * @type {string}
     * @memberof PartnerVendorUpdateProductPricelistRequest
     */
    'stockId': string;
}
/**
 * 
 * @export
 * @interface PartnerVendorUpdateProductPricelistResponse
 */
export interface PartnerVendorUpdateProductPricelistResponse {
    /**
     * pricelist id
     * @type {string}
     * @memberof PartnerVendorUpdateProductPricelistResponse
     */
    'id': string;
}
/**
 * Response data
 * @export
 * @interface PartnersAssetsGetSummaryResponse
 */
export interface PartnersAssetsGetSummaryResponse {
    /**
     * List of Asset Summary items
     * @type {Array<PartnersAssetsGetSummaryResponseDataItem>}
     * @memberof PartnersAssetsGetSummaryResponse
     */
    'items': Array<PartnersAssetsGetSummaryResponseDataItem>;
}
/**
 * 
 * @export
 * @interface PartnersAssetsGetSummaryResponseDataItem
 */
export interface PartnersAssetsGetSummaryResponseDataItem {
    /**
     * 
     * @type {AssetCategoryEnum}
     * @memberof PartnersAssetsGetSummaryResponseDataItem
     */
    'category': AssetCategoryEnum;
    /**
     * The lable of status that FE will show. Currently using Indonesian language
     * @type {string}
     * @memberof PartnersAssetsGetSummaryResponseDataItem
     */
    'categoryLabel': string;
    /**
     * Category count
     * @type {number}
     * @memberof PartnersAssetsGetSummaryResponseDataItem
     */
    'count': number;
}


/**
 * Response data
 * @export
 * @interface PartnersCampaignsGetSummaryResponse
 */
export interface PartnersCampaignsGetSummaryResponse {
    /**
     * List of Campaign Summary item
     * @type {Array<PartnersCampaignsGetSummaryResponseItem>}
     * @memberof PartnersCampaignsGetSummaryResponse
     */
    'items': Array<PartnersCampaignsGetSummaryResponseItem>;
}
/**
 * 
 * @export
 * @interface PartnersCampaignsGetSummaryResponseItem
 */
export interface PartnersCampaignsGetSummaryResponseItem {
    /**
     * 
     * @type {CampaignStatusEnum}
     * @memberof PartnersCampaignsGetSummaryResponseItem
     */
    'status': CampaignStatusEnum;
    /**
     * The lable of status that FE will show. Currently using Indonesian language
     * @type {string}
     * @memberof PartnersCampaignsGetSummaryResponseItem
     */
    'statusLabel': string;
    /**
     * Campaign count
     * @type {number}
     * @memberof PartnersCampaignsGetSummaryResponseItem
     */
    'count': number;
}


/**
 * 
 * @export
 * @interface PartnersConfirmMemberRequest
 */
export interface PartnersConfirmMemberRequest {
    /**
     * True if request is accepted, otherwise false
     * @type {boolean}
     * @memberof PartnersConfirmMemberRequest
     */
    'isAccepted': boolean;
    /**
     * the reason of why the supplier contract rejected
     * @type {string}
     * @memberof PartnersConfirmMemberRequest
     */
    'rejectedReason'?: string;
}
/**
 * 
 * @export
 * @interface PartnersConfirmMemberResponse
 */
export interface PartnersConfirmMemberResponse {
    /**
     * Member ID in UUID type 4 format
     * @type {string}
     * @memberof PartnersConfirmMemberResponse
     */
    'id': string;
    /**
     * Updated member name
     * @type {string}
     * @memberof PartnersConfirmMemberResponse
     */
    'name': string;
    /**
     * 
     * @type {MemberStatusEnum}
     * @memberof PartnersConfirmMemberResponse
     */
    'status': MemberStatusEnum;
}


/**
 * 
 * @export
 * @interface PartnersCreateSupplierLinkItem
 */
export interface PartnersCreateSupplierLinkItem {
    /**
     * The ID of linked supplier
     * @type {string}
     * @memberof PartnersCreateSupplierLinkItem
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface PartnersCreateSupplierLinkRequest
 */
export interface PartnersCreateSupplierLinkRequest {
    /**
     * Encrypted phoneNumber using RSA256 with public key that\'s retrieved from local database
     * @type {string}
     * @memberof PartnersCreateSupplierLinkRequest
     */
    'ownerPhoneNo': string;
}
/**
 * 
 * @export
 * @interface PartnersCreateSupplierLinkResponse
 */
export interface PartnersCreateSupplierLinkResponse {
    /**
     * 
     * @type {Array<PartnersCreateSupplierLinkItem>}
     * @memberof PartnersCreateSupplierLinkResponse
     */
    'suppliers': Array<PartnersCreateSupplierLinkItem>;
}
/**
 * 
 * @export
 * @interface PartnersFFbPriceVerificationFraudRequest
 */
export interface PartnersFFbPriceVerificationFraudRequest {
    /**
     * reason why it mark as fraud
     * @type {string}
     * @memberof PartnersFFbPriceVerificationFraudRequest
     */
    'reason': string;
    /**
     * to mark or unmark user as fraud
     * @type {boolean}
     * @memberof PartnersFFbPriceVerificationFraudRequest
     */
    'isFraud': boolean;
}
/**
 * 
 * @export
 * @interface PartnersFeedbacksCreateRequest
 */
export interface PartnersFeedbacksCreateRequest {
    /**
     * The rating assigned to the price component
     * @type {number}
     * @memberof PartnersFeedbacksCreateRequest
     */
    'priceRating': number;
    /**
     * The rating assigned to the weighbridge component
     * @type {number}
     * @memberof PartnersFeedbacksCreateRequest
     */
    'weighbridgeRating': number;
    /**
     * The rating assigned to the queue component
     * @type {number}
     * @memberof PartnersFeedbacksCreateRequest
     */
    'queueRating': number;
    /**
     * The rating assigned to the sorting component
     * @type {number}
     * @memberof PartnersFeedbacksCreateRequest
     */
    'sortingRating': number;
    /**
     * The rating assigned to the road access component
     * @type {number}
     * @memberof PartnersFeedbacksCreateRequest
     */
    'roadAccessRating': number;
    /**
     * Comment from user. It could be feedback for partner (Category - MILL)
     * @type {string}
     * @memberof PartnersFeedbacksCreateRequest
     */
    'feedback': string;
    /**
     * This field is used to identify whether member\'s user want to show their name as they give their feedback
     * @type {boolean}
     * @memberof PartnersFeedbacksCreateRequest
     */
    'isAnonymous': boolean;
    /**
     * 
     * @type {ScreenEnum}
     * @memberof PartnersFeedbacksCreateRequest
     */
    'sourcePage': ScreenEnum;
}


/**
 * 
 * @export
 * @interface PartnersFeedbacksCreateResponse
 */
export interface PartnersFeedbacksCreateResponse {
    /**
     * Partner ID that identified as UUID
     * @type {string}
     * @memberof PartnersFeedbacksCreateResponse
     */
    'id': string;
    /**
     * 
     * @type {boolean}
     * @memberof PartnersFeedbacksCreateResponse
     */
    'success': boolean;
    /**
     * Added sawit point
     * @type {number}
     * @memberof PartnersFeedbacksCreateResponse
     */
    'point': number;
}
/**
 * 
 * @export
 * @interface PartnersFeedbacksListResponse
 */
export interface PartnersFeedbacksListResponse {
    /**
     * Partner ID that identified as UUID
     * @type {string}
     * @memberof PartnersFeedbacksListResponse
     */
    'id': string;
    /**
     * Partner name with category MILL
     * @type {string}
     * @memberof PartnersFeedbacksListResponse
     */
    'millName': string;
    /**
     * Feedback list from each member and will show only the latest feedback if the feedbacks belongs to them.
     * @type {Array<PartnersFeedbacksListResponseDataFeedbackItem>}
     * @memberof PartnersFeedbacksListResponse
     */
    'feedbacks': Array<PartnersFeedbacksListResponseDataFeedbackItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof PartnersFeedbacksListResponse
     */
    'pagination'?: PaginationResponse;
}
/**
 * 
 * @export
 * @interface PartnersFeedbacksListResponseDataFeedbackItem
 */
export interface PartnersFeedbacksListResponseDataFeedbackItem {
    /**
     * Feedback ID that identified as UUID
     * @type {string}
     * @memberof PartnersFeedbacksListResponseDataFeedbackItem
     */
    'id': string;
    /**
     * Review comment from member for partner
     * @type {string}
     * @memberof PartnersFeedbacksListResponseDataFeedbackItem
     */
    'review': string;
    /**
     * Name of the member that create the review
     * @type {string}
     * @memberof PartnersFeedbacksListResponseDataFeedbackItem
     */
    'name': string;
    /**
     * The average of all rating that the user has submit
     * @type {number}
     * @memberof PartnersFeedbacksListResponseDataFeedbackItem
     */
    'averageRating': number;
    /**
     * The creation date of the user\'s feedback
     * @type {number}
     * @memberof PartnersFeedbacksListResponseDataFeedbackItem
     */
    'date': number;
}
/**
 * 
 * @export
 * @interface PartnersFeedbacksSummaryResponse
 */
export interface PartnersFeedbacksSummaryResponse {
    /**
     * Name of the Partner (mills)
     * @type {string}
     * @memberof PartnersFeedbacksSummaryResponse
     */
    'name': string;
    /**
     * Average rating of the Partner (mills)
     * @type {number}
     * @memberof PartnersFeedbacksSummaryResponse
     */
    'averageRating': number;
    /**
     * Total feedback count of the Partner (mills)
     * @type {number}
     * @memberof PartnersFeedbacksSummaryResponse
     */
    'feedbackCount': number;
    /**
     * Average rating of the Partner (mills) in scale
     * @type {number}
     * @memberof PartnersFeedbacksSummaryResponse
     */
    'scaleRating': number;
    /**
     * Average rating of the Partner (mills) in price
     * @type {number}
     * @memberof PartnersFeedbacksSummaryResponse
     */
    'priceRating': number;
    /**
     * Average rating of the Partner (mills) in queue
     * @type {number}
     * @memberof PartnersFeedbacksSummaryResponse
     */
    'queueRating': number;
    /**
     * Average rating of the Partner (mills) in sortation
     * @type {number}
     * @memberof PartnersFeedbacksSummaryResponse
     */
    'sortationRating': number;
    /**
     * Average rating of the Partner (mills) in road access
     * @type {number}
     * @memberof PartnersFeedbacksSummaryResponse
     */
    'roadAccessRating': number;
}
/**
 * 
 * @export
 * @interface PartnersFfbPriceCreateFraudInfoResponse
 */
export interface PartnersFfbPriceCreateFraudInfoResponse {
    /**
     * date when fraud happened in epoch millis
     * @type {number}
     * @memberof PartnersFfbPriceCreateFraudInfoResponse
     */
    'date': number;
    /**
     * fraud reason
     * @type {string}
     * @memberof PartnersFfbPriceCreateFraudInfoResponse
     */
    'reason': string;
    /**
     * phone number for cs contact
     * @type {string}
     * @memberof PartnersFfbPriceCreateFraudInfoResponse
     */
    'contact': string;
}
/**
 * 
 * @export
 * @interface PartnersFfbPriceCreateRequest
 */
export interface PartnersFfbPriceCreateRequest {
    /**
     * ID of the Partner (mills) represented in UUID type 4
     * @type {string}
     * @memberof PartnersFfbPriceCreateRequest
     */
    'partnerMillId': string;
    /**
     * Partner (mills) name
     * @type {string}
     * @memberof PartnersFfbPriceCreateRequest
     */
    'partnerMillName': string;
    /**
     * FFB price
     * @type {number}
     * @memberof PartnersFfbPriceCreateRequest
     */
    'partnerMillFfbPrice': number;
    /**
     * Photo to prove the FFC price
     * @type {File}
     * @memberof PartnersFfbPriceCreateRequest
     */
    'partnerMillPhoto'?: File;
    /**
     * ID of the Partner (mills) represented in UUID type 4
     * @type {string}
     * @memberof PartnersFfbPriceCreateRequest
     */
    'otherMillId': string;
    /**
     * Partner (mills) name
     * @type {string}
     * @memberof PartnersFfbPriceCreateRequest
     */
    'otherMillName': string;
    /**
     * FFB price
     * @type {number}
     * @memberof PartnersFfbPriceCreateRequest
     */
    'otherMillFfbPrice': number;
    /**
     * Photo to prove the FFC price
     * @type {File}
     * @memberof PartnersFfbPriceCreateRequest
     */
    'otherMillPhoto'?: File;
    /**
     * Longitude where the request was submitted
     * @type {number}
     * @memberof PartnersFfbPriceCreateRequest
     */
    'longitude': number;
    /**
     * Latitude where the schedule was submitted
     * @type {number}
     * @memberof PartnersFfbPriceCreateRequest
     */
    'latitude': number;
}
/**
 * 
 * @export
 * @interface PartnersFfbPriceCreateResponse
 */
export interface PartnersFfbPriceCreateResponse {
    /**
     * 
     * @type {number}
     * @memberof PartnersFfbPriceCreateResponse
     */
    'point': number;
}
/**
 * 
 * @export
 * @interface PartnersFfbPriceCreateV2Request
 */
export interface PartnersFfbPriceCreateV2Request {
    /**
     * ID of the Partner (mills) represented in UUID type 4
     * @type {string}
     * @memberof PartnersFfbPriceCreateV2Request
     */
    'partnerId': string;
    /**
     * Partner (mills) name
     * @type {string}
     * @memberof PartnersFfbPriceCreateV2Request
     */
    'partnerName': string;
    /**
     * FFB price
     * @type {number}
     * @memberof PartnersFfbPriceCreateV2Request
     */
    'partnerFfbPrice': number;
    /**
     * Photo url of FFB Price screen shot
     * @type {string}
     * @memberof PartnersFfbPriceCreateV2Request
     */
    'partnerFfbPricePhotoUrl': string;
    /**
     * Longitude where the request was submitted
     * @type {number}
     * @memberof PartnersFfbPriceCreateV2Request
     */
    'longitude'?: number;
    /**
     * Latitude where the schedule was submitted
     * @type {number}
     * @memberof PartnersFfbPriceCreateV2Request
     */
    'latitude'?: number;
}
/**
 * 
 * @export
 * @interface PartnersFfbPriceCreateV2Response
 */
export interface PartnersFfbPriceCreateV2Response {
    /**
     * 
     * @type {number}
     * @memberof PartnersFfbPriceCreateV2Response
     */
    'point': number;
    /**
     * 
     * @type {PartnersFfbPriceCreateFraudInfoResponse}
     * @memberof PartnersFfbPriceCreateV2Response
     */
    'fraud'?: PartnersFfbPriceCreateFraudInfoResponse;
}
/**
 * 
 * @export
 * @interface PartnersFfbPriceCreateV3Request
 */
export interface PartnersFfbPriceCreateV3Request {
    /**
     * ID of the Partner (mills) represented in UUID type 4
     * @type {string}
     * @memberof PartnersFfbPriceCreateV3Request
     */
    'partnerId': string;
    /**
     * Partner (mills) name
     * @type {string}
     * @memberof PartnersFfbPriceCreateV3Request
     */
    'partnerName': string;
    /**
     * FFB price
     * @type {number}
     * @memberof PartnersFfbPriceCreateV3Request
     */
    'partnerFfbPrice': number;
    /**
     * Photo url of FFB Price screen shot
     * @type {string}
     * @memberof PartnersFfbPriceCreateV3Request
     */
    'partnerFfbPricePhotoUrl': string;
    /**
     * Longitude where the request was submitted
     * @type {number}
     * @memberof PartnersFfbPriceCreateV3Request
     */
    'longitude'?: number;
    /**
     * Latitude where the schedule was submitted
     * @type {number}
     * @memberof PartnersFfbPriceCreateV3Request
     */
    'latitude'?: number;
    /**
     * user\'s mobile app timezone
     * @type {string}
     * @memberof PartnersFfbPriceCreateV3Request
     */
    'userTimezone': string;
    /**
     * server time in unix milli format at the time of API request
     * @type {number}
     * @memberof PartnersFfbPriceCreateV3Request
     */
    'submittedAt': number;
    /**
     * generated uuid
     * @type {string}
     * @memberof PartnersFfbPriceCreateV3Request
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface PartnersFfbPriceCreateV3Response
 */
export interface PartnersFfbPriceCreateV3Response {
    /**
     * 
     * @type {number}
     * @memberof PartnersFfbPriceCreateV3Response
     */
    'point': number;
    /**
     * 
     * @type {PartnersFfbPriceCreateFraudInfoResponse}
     * @memberof PartnersFfbPriceCreateV3Response
     */
    'fraud'?: PartnersFfbPriceCreateFraudInfoResponse;
}
/**
 * 
 * @export
 * @interface PartnersFfbPriceLimitationResponse
 */
export interface PartnersFfbPriceLimitationResponse {
    /**
     * user may proceed to the form or not
     * @type {boolean}
     * @memberof PartnersFfbPriceLimitationResponse
     */
    'isLimited': boolean;
}
/**
 * 
 * @export
 * @interface PartnersFfbPriceVerificationRequest
 */
export interface PartnersFfbPriceVerificationRequest {
    /**
     * 
     * @type {WorkerActivitiesVerificationStatusEnum}
     * @memberof PartnersFfbPriceVerificationRequest
     */
    'verificationStatus': WorkerActivitiesVerificationStatusEnum;
    /**
     * The rejected reason of ffb price verification. It\'s only required for REJECTED status
     * @type {string}
     * @memberof PartnersFfbPriceVerificationRequest
     */
    'rejectedReason'?: string;
    /**
     * 
     * @type {PartnersFFbPriceVerificationFraudRequest}
     * @memberof PartnersFfbPriceVerificationRequest
     */
    'fraud'?: PartnersFFbPriceVerificationFraudRequest;
}


/**
 * 
 * @export
 * @interface PartnersFfbPriceVerificationResponse
 */
export interface PartnersFfbPriceVerificationResponse {
    /**
     * 
     * @type {boolean}
     * @memberof PartnersFfbPriceVerificationResponse
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface PartnersFfbPricesHistoriesResponseItem
 */
export interface PartnersFfbPricesHistoriesResponseItem {
    /**
     * ID mill represented in UUID type 4
     * @type {string}
     * @memberof PartnersFfbPricesHistoriesResponseItem
     */
    'millId': string;
    /**
     * Partner (mills) name
     * @type {string}
     * @memberof PartnersFfbPricesHistoriesResponseItem
     */
    'millName': string;
    /**
     * FFB price
     * @type {number}
     * @memberof PartnersFfbPricesHistoriesResponseItem
     */
    'ffbPrice': number;
    /**
     * time in epoch millis when the user submitted ffb price
     * @type {number}
     * @memberof PartnersFfbPricesHistoriesResponseItem
     */
    'createdAt': number;
    /**
     * the object can be used as reference for the new activity or not
     * @type {boolean}
     * @memberof PartnersFfbPricesHistoriesResponseItem
     */
    'referrable': boolean;
}
/**
 * 
 * @export
 * @interface PartnersFinanceGetInvoiceDetailResponse
 */
export interface PartnersFinanceGetInvoiceDetailResponse {
    /**
     * 
     * @type {string}
     * @memberof PartnersFinanceGetInvoiceDetailResponse
     */
    'id': string;
    /**
     * Invoice Number
     * @type {string}
     * @memberof PartnersFinanceGetInvoiceDetailResponse
     */
    'invoiceNo': string;
    /**
     * 
     * @type {InvoiceStatusEnum}
     * @memberof PartnersFinanceGetInvoiceDetailResponse
     */
    'status': InvoiceStatusEnum;
    /**
     * Invoice PDF file URL
     * @type {string}
     * @memberof PartnersFinanceGetInvoiceDetailResponse
     */
    'url': string;
    /**
     * Sale Order UUID
     * @type {string}
     * @memberof PartnersFinanceGetInvoiceDetailResponse
     */
    'orderId': string;
    /**
     * 
     * @type {SaleOrderStatusEnum}
     * @memberof PartnersFinanceGetInvoiceDetailResponse
     */
    'orderStatus': SaleOrderStatusEnum;
    /**
     * Order Number
     * @type {string}
     * @memberof PartnersFinanceGetInvoiceDetailResponse
     */
    'orderNo': string;
    /**
     * The time for the user to pick up their order
     * @type {number}
     * @memberof PartnersFinanceGetInvoiceDetailResponse
     */
    'pickUpDateAtUtc0': number;
    /**
     * Total order price
     * @type {number}
     * @memberof PartnersFinanceGetInvoiceDetailResponse
     */
    'totalItemPrice': number;
    /**
     * List of Payment Item
     * @type {Array<InvoicesListResponseItemPaymentMethodItem>}
     * @memberof PartnersFinanceGetInvoiceDetailResponse
     */
    'paymentMethodItems': Array<InvoicesListResponseItemPaymentMethodItem>;
    /**
     * 
     * @type {Array<OrdersGetDetailResponseStoreOrderItem>}
     * @memberof PartnersFinanceGetInvoiceDetailResponse
     */
    'storeOrderItems': Array<OrdersGetDetailResponseStoreOrderItem>;
    /**
     * Name of Recipient
     * @type {string}
     * @memberof PartnersFinanceGetInvoiceDetailResponse
     */
    'recipientName': string;
    /**
     * Phone Number of Recipient
     * @type {string}
     * @memberof PartnersFinanceGetInvoiceDetailResponse
     */
    'recipientPhoneNumber': string;
    /**
     * 
     * @type {OrderGetDetailCustomerItem}
     * @memberof PartnersFinanceGetInvoiceDetailResponse
     */
    'customer': OrderGetDetailCustomerItem;
    /**
     * Order creation time
     * @type {number}
     * @memberof PartnersFinanceGetInvoiceDetailResponse
     */
    'createdAtUtc0': number;
    /**
     * 
     * @type {InvoicesListResponseItemShippingInformation}
     * @memberof PartnersFinanceGetInvoiceDetailResponse
     */
    'shippingInformation': InvoicesListResponseItemShippingInformation;
}


/**
 * Response data
 * @export
 * @interface PartnersGetCouponDetailResponse
 */
export interface PartnersGetCouponDetailResponse {
    /**
     * the ID of coupon usage data
     * @type {string}
     * @memberof PartnersGetCouponDetailResponse
     */
    'id': string;
    /**
     * the name of coupon
     * @type {string}
     * @memberof PartnersGetCouponDetailResponse
     */
    'name': string;
    /**
     * the amount of coupon
     * @type {number}
     * @memberof PartnersGetCouponDetailResponse
     */
    'nominal': number;
    /**
     * the ID of user
     * @type {string}
     * @memberof PartnersGetCouponDetailResponse
     */
    'UserId': string;
    /**
     * the name of user
     * @type {string}
     * @memberof PartnersGetCouponDetailResponse
     */
    'UserName': string;
}
/**
 * 
 * @export
 * @interface PartnersGetFfbPricesItemResponse
 */
export interface PartnersGetFfbPricesItemResponse {
    /**
     * Partner (mills) name
     * @type {string}
     * @memberof PartnersGetFfbPricesItemResponse
     */
    'partnerMillName': string;
    /**
     * FFB price
     * @type {number}
     * @memberof PartnersGetFfbPricesItemResponse
     */
    'partnerMillFfbPrice': number;
    /**
     * Partner (mills) name
     * @type {string}
     * @memberof PartnersGetFfbPricesItemResponse
     */
    'nonPartnerMillName': string;
    /**
     * FFB price
     * @type {number}
     * @memberof PartnersGetFfbPricesItemResponse
     */
    'nonPartnerMillFfbPrice': number;
    /**
     * time in epoch millis when the user submitted ffb price
     * @type {number}
     * @memberof PartnersGetFfbPricesItemResponse
     */
    'createdAt': number;
}
/**
 * 
 * @export
 * @interface PartnersGetFfbPricesResponse
 */
export interface PartnersGetFfbPricesResponse {
    /**
     * 
     * @type {PartnersGetFfbPricesSummaryResponse}
     * @memberof PartnersGetFfbPricesResponse
     */
    'summary': PartnersGetFfbPricesSummaryResponse;
    /**
     * 
     * @type {Array<PartnersGetFfbPricesItemResponse>}
     * @memberof PartnersGetFfbPricesResponse
     */
    'items': Array<PartnersGetFfbPricesItemResponse>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof PartnersGetFfbPricesResponse
     */
    'pagination': PaginationResponse;
}
/**
 * 
 * @export
 * @interface PartnersGetFfbPricesSummaryResponse
 */
export interface PartnersGetFfbPricesSummaryResponse {
    /**
     * 
     * @type {number}
     * @memberof PartnersGetFfbPricesSummaryResponse
     */
    'today': number;
    /**
     * 
     * @type {number}
     * @memberof PartnersGetFfbPricesSummaryResponse
     */
    'yesterday': number;
    /**
     * 
     * @type {number}
     * @memberof PartnersGetFfbPricesSummaryResponse
     */
    'currentMonth': number;
    /**
     * 
     * @type {number}
     * @memberof PartnersGetFfbPricesSummaryResponse
     */
    'lastMonth': number;
}
/**
 * 
 * @export
 * @interface PartnersGetMemberResponse
 */
export interface PartnersGetMemberResponse {
    /**
     * 
     * @type {PartnersGetMemberResponseDetails}
     * @memberof PartnersGetMemberResponse
     */
    'details': PartnersGetMemberResponseDetails;
    /**
     * 
     * @type {PartnersGetMemberResponseCampaigns}
     * @memberof PartnersGetMemberResponse
     */
    'campaigns': PartnersGetMemberResponseCampaigns;
    /**
     * 
     * @type {PartnersGetMemberResponseAssets}
     * @memberof PartnersGetMemberResponse
     */
    'assets': PartnersGetMemberResponseAssets;
}
/**
 * Asset detail, grouped into 4 categories. Response will return max 5 items per asset category
 * @export
 * @interface PartnersGetMemberResponseAssets
 */
export interface PartnersGetMemberResponseAssets {
    /**
     * The count of total asset
     * @type {number}
     * @memberof PartnersGetMemberResponseAssets
     */
    'assetCount': number;
    /**
     * 
     * @type {PartnersGetMemberResponseAssetsSupplierContract}
     * @memberof PartnersGetMemberResponseAssets
     */
    'supplierContract': PartnersGetMemberResponseAssetsSupplierContract;
    /**
     * 
     * @type {PartnersGetMemberResponseAssetsRamp}
     * @memberof PartnersGetMemberResponseAssets
     */
    'ramp': PartnersGetMemberResponseAssetsRamp;
    /**
     * 
     * @type {PartnersGetMemberResponseAssetsTruck}
     * @memberof PartnersGetMemberResponseAssets
     */
    'truck': PartnersGetMemberResponseAssetsTruck;
    /**
     * 
     * @type {PartnersGetMemberResponseAssetsFarm}
     * @memberof PartnersGetMemberResponseAssets
     */
    'farm': PartnersGetMemberResponseAssetsFarm;
}
/**
 * 
 * @export
 * @interface PartnersGetMemberResponseAssetsFarm
 */
export interface PartnersGetMemberResponseAssetsFarm {
    /**
     * Count of the Farm items
     * @type {number}
     * @memberof PartnersGetMemberResponseAssetsFarm
     */
    'count': number;
    /**
     * List of Farm asset
     * @type {Array<PartnersGetMemberResponseFarmItem>}
     * @memberof PartnersGetMemberResponseAssetsFarm
     */
    'items': Array<PartnersGetMemberResponseFarmItem>;
}
/**
 * 
 * @export
 * @interface PartnersGetMemberResponseAssetsRamp
 */
export interface PartnersGetMemberResponseAssetsRamp {
    /**
     * Count of the Ramp items
     * @type {number}
     * @memberof PartnersGetMemberResponseAssetsRamp
     */
    'count': number;
    /**
     * List of Ramp asset
     * @type {Array<PartnersGetMemberResponseRampItem>}
     * @memberof PartnersGetMemberResponseAssetsRamp
     */
    'items': Array<PartnersGetMemberResponseRampItem>;
}
/**
 * 
 * @export
 * @interface PartnersGetMemberResponseAssetsSupplierContract
 */
export interface PartnersGetMemberResponseAssetsSupplierContract {
    /**
     * Count of the Supplier Contract items
     * @type {number}
     * @memberof PartnersGetMemberResponseAssetsSupplierContract
     */
    'count': number;
    /**
     * List of Agen DO/SP/PB
     * @type {Array<PartnersGetMemberResponseSupplierItem>}
     * @memberof PartnersGetMemberResponseAssetsSupplierContract
     */
    'items': Array<PartnersGetMemberResponseSupplierItem>;
}
/**
 * 
 * @export
 * @interface PartnersGetMemberResponseAssetsTruck
 */
export interface PartnersGetMemberResponseAssetsTruck {
    /**
     * Count of the Truck items
     * @type {number}
     * @memberof PartnersGetMemberResponseAssetsTruck
     */
    'count': number;
    /**
     * List of Truck asset
     * @type {Array<PartnersGetMemberResponseTruckItem>}
     * @memberof PartnersGetMemberResponseAssetsTruck
     */
    'items': Array<PartnersGetMemberResponseTruckItem>;
}
/**
 * 
 * @export
 * @interface PartnersGetMemberResponseCampaignItem
 */
export interface PartnersGetMemberResponseCampaignItem {
    /**
     * Campaign ID represented in UUID type 4
     * @type {string}
     * @memberof PartnersGetMemberResponseCampaignItem
     */
    'id': string;
    /**
     * Title of the campaign
     * @type {string}
     * @memberof PartnersGetMemberResponseCampaignItem
     */
    'title': string;
    /**
     * Type of the campaign
     * @type {string}
     * @memberof PartnersGetMemberResponseCampaignItem
     */
    'type': string;
    /**
     * Starting date of the campaign (in epoch). Will be represented in UTC-0, time will be set at midnight (00:00)
     * @type {number}
     * @memberof PartnersGetMemberResponseCampaignItem
     */
    'startDate': number;
    /**
     * Progress percentage presented with integer (1% = 1)
     * @type {number}
     * @memberof PartnersGetMemberResponseCampaignItem
     */
    'progress': number;
    /**
     * 
     * @type {CampaignStatusEnum}
     * @memberof PartnersGetMemberResponseCampaignItem
     */
    'status': CampaignStatusEnum;
    /**
     * The lable of status that FE will show. Currently using Indonesian language
     * @type {string}
     * @memberof PartnersGetMemberResponseCampaignItem
     */
    'statusLabel': string;
}


/**
 * 
 * @export
 * @interface PartnersGetMemberResponseCampaigns
 */
export interface PartnersGetMemberResponseCampaigns {
    /**
     * Total number of campaigns
     * @type {number}
     * @memberof PartnersGetMemberResponseCampaigns
     */
    'campaignCount': number;
    /**
     * List of campaigns
     * @type {Array<PartnersGetMemberResponseCampaignItem>}
     * @memberof PartnersGetMemberResponseCampaigns
     */
    'items': Array<PartnersGetMemberResponseCampaignItem>;
}
/**
 * 
 * @export
 * @interface PartnersGetMemberResponseDetails
 */
export interface PartnersGetMemberResponseDetails {
    /**
     * Member ID represented in UUID type 4
     * @type {string}
     * @memberof PartnersGetMemberResponseDetails
     */
    'memberId': string;
    /**
     * Member name
     * @type {string}
     * @memberof PartnersGetMemberResponseDetails
     */
    'name': string;
    /**
     * Phone number starting with 0 as prefix (08xxxxxxxxx)
     * @type {string}
     * @memberof PartnersGetMemberResponseDetails
     */
    'phoneNumber': string;
    /**
     * 
     * @type {MemberStatusEnum}
     * @memberof PartnersGetMemberResponseDetails
     */
    'status': MemberStatusEnum;
    /**
     * The lable of status that FE will show. Currently using Indonesian language
     * @type {string}
     * @memberof PartnersGetMemberResponseDetails
     */
    'statusLabel': string;
    /**
     * Member SawitPRO registration date (in epoch). Will be represented in UTC-0, time will be set at midnight (00:00)
     * @type {number}
     * @memberof PartnersGetMemberResponseDetails
     */
    'registrationDate': number;
    /**
     * Date when member request was approved by Partner (in epoch). Will be represented in UTC-0, time will be set at midnight (00:00)
     * @type {number}
     * @memberof PartnersGetMemberResponseDetails
     */
    'partnerApprovalDate': number;
    /**
     * Date when member was last seen active (in epoch). Will be represented in UTC-0, time will be set at midnight (00:00)
     * @type {number}
     * @memberof PartnersGetMemberResponseDetails
     */
    'lastActiveDate'?: number;
    /**
     * Date when member started cooperation (in epoch). Will be represented in UTC-0, time will be set at midnight (00:00)
     * @type {number}
     * @memberof PartnersGetMemberResponseDetails
     */
    'cooperationDate'?: number;
}


/**
 * 
 * @export
 * @interface PartnersGetMemberResponseFarmItem
 */
export interface PartnersGetMemberResponseFarmItem {
    /**
     * Farm ID represented in UUID type 4
     * @type {string}
     * @memberof PartnersGetMemberResponseFarmItem
     */
    'id': string;
    /**
     * Farm Area Name
     * @type {string}
     * @memberof PartnersGetMemberResponseFarmItem
     */
    'areaName': string;
    /**
     * Farm Size
     * @type {number}
     * @memberof PartnersGetMemberResponseFarmItem
     */
    'areaHectare': number;
}
/**
 * 
 * @export
 * @interface PartnersGetMemberResponseRampItem
 */
export interface PartnersGetMemberResponseRampItem {
    /**
     * Ramp ID represented in UUID type 4
     * @type {string}
     * @memberof PartnersGetMemberResponseRampItem
     */
    'id': string;
    /**
     * Ramp  Name
     * @type {string}
     * @memberof PartnersGetMemberResponseRampItem
     */
    'name': string;
    /**
     * Location of the ramp, will concat ramp address & area name (divided with comma `Ramp Address, Area Name`)
     * @type {string}
     * @memberof PartnersGetMemberResponseRampItem
     */
    'address': string;
}
/**
 * 
 * @export
 * @interface PartnersGetMemberResponseSupplierItem
 */
export interface PartnersGetMemberResponseSupplierItem {
    /**
     * Supplier ID represented in UUID type 4
     * @type {string}
     * @memberof PartnersGetMemberResponseSupplierItem
     */
    'id': string;
    /**
     * Supplier Name
     * @type {string}
     * @memberof PartnersGetMemberResponseSupplierItem
     */
    'name': string;
    /**
     * Supplier Code
     * @type {string}
     * @memberof PartnersGetMemberResponseSupplierItem
     */
    'code': string;
    /**
     * Mills Name
     * @type {string}
     * @memberof PartnersGetMemberResponseSupplierItem
     */
    'millsName': string;
    /**
     * 
     * @type {MemberStatusEnum}
     * @memberof PartnersGetMemberResponseSupplierItem
     */
    'status': MemberStatusEnum;
    /**
     * The lable of status that FE will show. Currently using Indonesian language
     * @type {string}
     * @memberof PartnersGetMemberResponseSupplierItem
     */
    'statusLabel': string;
}


/**
 * 
 * @export
 * @interface PartnersGetMemberResponseTruckItem
 */
export interface PartnersGetMemberResponseTruckItem {
    /**
     * Truck ID represented in UUID type 4
     * @type {string}
     * @memberof PartnersGetMemberResponseTruckItem
     */
    'id': string;
    /**
     * Truck Plate Number
     * @type {string}
     * @memberof PartnersGetMemberResponseTruckItem
     */
    'plateNo': string;
    /**
     * Truck Max Capacity (ton)
     * @type {number}
     * @memberof PartnersGetMemberResponseTruckItem
     */
    'maxCapacity': number;
}
/**
 * 
 * @export
 * @interface PartnersGetMembersItem
 */
export interface PartnersGetMembersItem {
    /**
     * Member (Supplier Contract) ID in UUID type 4 format
     * @type {string}
     * @memberof PartnersGetMembersItem
     */
    'memberId': string;
    /**
     * User ID in UUID type 4 format
     * @type {string}
     * @memberof PartnersGetMembersItem
     */
    'userId': string;
    /**
     * Member name
     * @type {string}
     * @memberof PartnersGetMembersItem
     */
    'name': string;
    /**
     * Member company name (Nama DO/SP/PB)
     * @type {string}
     * @memberof PartnersGetMembersItem
     */
    'companyName': string;
    /**
     * Phone number starting with 0 as prefix (08xxxxxxxxx)
     * @type {string}
     * @memberof PartnersGetMembersItem
     */
    'phoneNumber': string;
    /**
     * Member registered date (in epoch). Will be in UTC-0, time will be set at midnight (00:00)
     * @type {number}
     * @memberof PartnersGetMembersItem
     */
    'registerDate': number;
    /**
     * 
     * @type {MemberStatusEnum}
     * @memberof PartnersGetMembersItem
     */
    'status': MemberStatusEnum;
    /**
     * The lable of status that FE will show. Currently using Indonesian language
     * @type {string}
     * @memberof PartnersGetMembersItem
     */
    'statusLabel': string;
}


/**
 * Response data
 * @export
 * @interface PartnersGetMembersResponse
 */
export interface PartnersGetMembersResponse {
    /**
     * List of Member
     * @type {Array<PartnersGetMembersItem>}
     * @memberof PartnersGetMembersResponse
     */
    'items': Array<PartnersGetMembersItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof PartnersGetMembersResponse
     */
    'pagination': PaginationResponse;
}
/**
 * Response data
 * @export
 * @interface PartnersGetMembersStatusResponse
 */
export interface PartnersGetMembersStatusResponse {
    /**
     * List of members
     * @type {Array<PartnersGetMembersStatusResponseItem>}
     * @memberof PartnersGetMembersStatusResponse
     */
    'items': Array<PartnersGetMembersStatusResponseItem>;
}
/**
 * 
 * @export
 * @interface PartnersGetMembersStatusResponseItem
 */
export interface PartnersGetMembersStatusResponseItem {
    /**
     * Member ID
     * @type {string}
     * @memberof PartnersGetMembersStatusResponseItem
     */
    'id': string;
    /**
     * Member Name
     * @type {string}
     * @memberof PartnersGetMembersStatusResponseItem
     */
    'name': string;
    /**
     * 
     * @type {UserStatusEnum}
     * @memberof PartnersGetMembersStatusResponseItem
     */
    'status': UserStatusEnum;
    /**
     * 
     * @type {UserCampaignStatusEnum}
     * @memberof PartnersGetMembersStatusResponseItem
     */
    'userCampaignStatus': UserCampaignStatusEnum;
}


/**
 * 
 * @export
 * @interface PartnersGetSupplierResponse
 */
export interface PartnersGetSupplierResponse {
    /**
     * Supplier ID in UUID type 4 format
     * @type {string}
     * @memberof PartnersGetSupplierResponse
     */
    'id': string;
    /**
     * Supplier registered name
     * @type {string}
     * @memberof PartnersGetSupplierResponse
     */
    'supplierName': string;
    /**
     * Supplier\'s partner name
     * @type {string}
     * @memberof PartnersGetSupplierResponse
     */
    'partnerName': string;
    /**
     * 
     * @type {MemberStatusEnum}
     * @memberof PartnersGetSupplierResponse
     */
    'status': MemberStatusEnum;
}


/**
 * 
 * @export
 * @interface PartnersGetSuppliersItem
 */
export interface PartnersGetSuppliersItem {
    /**
     * Member (Supplier Contract) ID in UUID type 4 format
     * @type {string}
     * @memberof PartnersGetSuppliersItem
     */
    'supplierId': string;
    /**
     * Supplier name (Nama DO/SP/PB)
     * @type {string}
     * @memberof PartnersGetSuppliersItem
     */
    'supplierName': string;
    /**
     * Member name of a user that owns the supplier
     * @type {string}
     * @memberof PartnersGetSuppliersItem
     */
    'memberName': string;
    /**
     * Supplier approved date (in epoch). Will be in UTC-0, time will be set at midnight (00:00)
     * @type {number}
     * @memberof PartnersGetSuppliersItem
     */
    'approvedDate': number;
    /**
     * Supplier created date (in epoch). Will be in UTC-0, time will be set at midnight (00:00)
     * @type {number}
     * @memberof PartnersGetSuppliersItem
     */
    'requestDate': number;
    /**
     * 
     * @type {MemberStatusEnum}
     * @memberof PartnersGetSuppliersItem
     */
    'status': MemberStatusEnum;
    /**
     * The lable of status that FE will show. Currently using Indonesian language
     * @type {string}
     * @memberof PartnersGetSuppliersItem
     */
    'statusLabel': string;
    /**
     * URL of weighbridge photo
     * @type {string}
     * @memberof PartnersGetSuppliersItem
     */
    'weighbridgePhoto'?: string;
}


/**
 * Response data
 * @export
 * @interface PartnersGetSuppliersResponse
 */
export interface PartnersGetSuppliersResponse {
    /**
     * List of Suppliers
     * @type {Array<PartnersGetSuppliersItem>}
     * @memberof PartnersGetSuppliersResponse
     */
    'items': Array<PartnersGetSuppliersItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof PartnersGetSuppliersResponse
     */
    'pagination': PaginationResponse;
}
/**
 * Response data
 * @export
 * @interface PartnersGetSuppliersStatusResponse
 */
export interface PartnersGetSuppliersStatusResponse {
    /**
     * List of suppliers
     * @type {Array<PartnersGetSuppliersStatusResponseItem>}
     * @memberof PartnersGetSuppliersStatusResponse
     */
    'items': Array<PartnersGetSuppliersStatusResponseItem>;
}
/**
 * 
 * @export
 * @interface PartnersGetSuppliersStatusResponseItem
 */
export interface PartnersGetSuppliersStatusResponseItem {
    /**
     * ID of the Supplier
     * @type {string}
     * @memberof PartnersGetSuppliersStatusResponseItem
     */
    'id': string;
    /**
     * Name of the owner of current Supplier
     * @type {string}
     * @memberof PartnersGetSuppliersStatusResponseItem
     */
    'userName': string;
    /**
     * Supplier Name
     * @type {string}
     * @memberof PartnersGetSuppliersStatusResponseItem
     */
    'supplierName': string;
    /**
     * 
     * @type {MemberStatusEnum}
     * @memberof PartnersGetSuppliersStatusResponseItem
     */
    'status': MemberStatusEnum;
    /**
     * 
     * @type {SupplierCampaignStatusEnum}
     * @memberof PartnersGetSuppliersStatusResponseItem
     */
    'campaignStatus': SupplierCampaignStatusEnum;
}


/**
 * Response data
 * @export
 * @interface PartnersGetUsersByPartnerResponse
 */
export interface PartnersGetUsersByPartnerResponse {
    /**
     * List of users
     * @type {Array<PartnersGetUsersByPartnerUserItem>}
     * @memberof PartnersGetUsersByPartnerResponse
     */
    'items': Array<PartnersGetUsersByPartnerUserItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof PartnersGetUsersByPartnerResponse
     */
    'pagination': PaginationResponse;
}
/**
 * 
 * @export
 * @interface PartnersGetUsersByPartnerUserItem
 */
export interface PartnersGetUsersByPartnerUserItem {
    /**
     * User ID represented in UUID type 4
     * @type {string}
     * @memberof PartnersGetUsersByPartnerUserItem
     */
    'id': string;
    /**
     * User name
     * @type {string}
     * @memberof PartnersGetUsersByPartnerUserItem
     */
    'name': string;
    /**
     * Phone number starting with 0 as prefix (08xxxxxxxxx)
     * @type {string}
     * @memberof PartnersGetUsersByPartnerUserItem
     */
    'phoneNumber': string;
    /**
     * User register date (in epoch). Will be represented in UTC-0, time will be set at midnight (00:00)
     * @type {number}
     * @memberof PartnersGetUsersByPartnerUserItem
     */
    'registerDate': number;
    /**
     * 
     * @type {UserRoleEnum}
     * @memberof PartnersGetUsersByPartnerUserItem
     */
    'role': UserRoleEnum;
    /**
     * The lable of role that FE will show. Currently using Indonesian language
     * @type {string}
     * @memberof PartnersGetUsersByPartnerUserItem
     */
    'roleLabel': string;
    /**
     * 
     * @type {UserStatusEnum}
     * @memberof PartnersGetUsersByPartnerUserItem
     */
    'status': UserStatusEnum;
    /**
     * The lable of status that FE will show. Currently using Indonesian language
     * @type {string}
     * @memberof PartnersGetUsersByPartnerUserItem
     */
    'statusLabel': string;
}


/**
 * Response data
 * @export
 * @interface PartnersMembersGetSummaryResponse
 */
export interface PartnersMembersGetSummaryResponse {
    /**
     * List of Member Summary items
     * @type {Array<PartnersMembersGetSummaryResponseItem>}
     * @memberof PartnersMembersGetSummaryResponse
     */
    'items': Array<PartnersMembersGetSummaryResponseItem>;
}
/**
 * 
 * @export
 * @interface PartnersMembersGetSummaryResponseItem
 */
export interface PartnersMembersGetSummaryResponseItem {
    /**
     * 
     * @type {MemberStatusEnum}
     * @memberof PartnersMembersGetSummaryResponseItem
     */
    'status': MemberStatusEnum;
    /**
     * The lable of status that FE will show. Currently using Indonesian language
     * @type {string}
     * @memberof PartnersMembersGetSummaryResponseItem
     */
    'statusLabel': string;
    /**
     * Members count
     * @type {number}
     * @memberof PartnersMembersGetSummaryResponseItem
     */
    'count': number;
}


/**
 * 
 * @export
 * @interface PartnersPlantationsCreateSchedulesRequest
 */
export interface PartnersPlantationsCreateSchedulesRequest {
    /**
     * 
     * @type {PlantationActivityTypeEnum}
     * @memberof PartnersPlantationsCreateSchedulesRequest
     */
    'plantationActivityType': PlantationActivityTypeEnum;
    /**
     * The contact id of person who assigned to the plantation schedule
     * @type {string}
     * @memberof PartnersPlantationsCreateSchedulesRequest
     */
    'supervisorContactId': string;
    /**
     * Id of blocks which assigned on the plantation schedule
     * @type {Array<string>}
     * @memberof PartnersPlantationsCreateSchedulesRequest
     */
    'blockIds': Array<string>;
    /**
     * schedule date in unix timestamp
     * @type {number}
     * @memberof PartnersPlantationsCreateSchedulesRequest
     */
    'scheduleDateUtc0': number;
    /**
     * This is meant to be free text to be filled in by the creator for additional plantation schedule information
     * @type {string}
     * @memberof PartnersPlantationsCreateSchedulesRequest
     */
    'workInstruction'?: string;
}


/**
 * 
 * @export
 * @interface PartnersPlantationsGetBlockAssignmentsItemResponse
 */
export interface PartnersPlantationsGetBlockAssignmentsItemResponse {
    /**
     * Id of block assignment
     * @type {string}
     * @memberof PartnersPlantationsGetBlockAssignmentsItemResponse
     */
    'id': string;
    /**
     * harvester Id from paticular block assignment
     * @type {string}
     * @memberof PartnersPlantationsGetBlockAssignmentsItemResponse
     */
    'harvesterId': string;
    /**
     * harvester name from particular block assignment
     * @type {string}
     * @memberof PartnersPlantationsGetBlockAssignmentsItemResponse
     */
    'harvesterName': string;
    /**
     * total block hectare of block assignment
     * @type {number}
     * @memberof PartnersPlantationsGetBlockAssignmentsItemResponse
     */
    'totalAreaHectare': number;
    /**
     * List of campaign default target value
     * @type {Array<V2BlocksListResponseItem>}
     * @memberof PartnersPlantationsGetBlockAssignmentsItemResponse
     */
    'assignedBlocks': Array<V2BlocksListResponseItem>;
}
/**
 * 
 * @export
 * @interface PartnersPlantationsGetBlockAssignmentsResponse
 */
export interface PartnersPlantationsGetBlockAssignmentsResponse {
    /**
     * 
     * @type {Array<PartnersPlantationsGetBlockAssignmentsItemResponse>}
     * @memberof PartnersPlantationsGetBlockAssignmentsResponse
     */
    'items': Array<PartnersPlantationsGetBlockAssignmentsItemResponse>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof PartnersPlantationsGetBlockAssignmentsResponse
     */
    'pagination': PaginationResponse;
}
/**
 * 
 * @export
 * @interface PartnersPlantationsGetFfbProductionsResponse
 */
export interface PartnersPlantationsGetFfbProductionsResponse {
    /**
     * 
     * @type {Array<PartnersPlantationsGetFfbProductionsResponseItem>}
     * @memberof PartnersPlantationsGetFfbProductionsResponse
     */
    'items': Array<PartnersPlantationsGetFfbProductionsResponseItem>;
}
/**
 * 
 * @export
 * @interface PartnersPlantationsGetFfbProductionsResponseItem
 */
export interface PartnersPlantationsGetFfbProductionsResponseItem {
    /**
     * Unique identifier of the plantation ffb production
     * @type {string}
     * @memberof PartnersPlantationsGetFfbProductionsResponseItem
     */
    'id': string;
    /**
     * date of the plantation ffb production
     * @type {number}
     * @memberof PartnersPlantationsGetFfbProductionsResponseItem
     */
    'date': number;
    /**
     * the number of ffb have been harvested
     * @type {number}
     * @memberof PartnersPlantationsGetFfbProductionsResponseItem
     */
    'ffbHarvested': number;
    /**
     * the number of ffb have been harvested cumulative in one month
     * @type {number}
     * @memberof PartnersPlantationsGetFfbProductionsResponseItem
     */
    'ffbHarvestedCumulative': number;
    /**
     * the number of fruitles have been harvested in sack uom
     * @type {number}
     * @memberof PartnersPlantationsGetFfbProductionsResponseItem
     */
    'fruitlesHarvestedSack': number;
    /**
     * the number of fruitles have been harvested in sack uom cumulative in one month
     * @type {number}
     * @memberof PartnersPlantationsGetFfbProductionsResponseItem
     */
    'fruitlesHarvestedSackCumulative': number;
    /**
     * the number of ffb have been loaded
     * @type {number}
     * @memberof PartnersPlantationsGetFfbProductionsResponseItem
     */
    'ffbLoaded': number;
    /**
     * the number of ffb have been loaded cumulative in one month
     * @type {number}
     * @memberof PartnersPlantationsGetFfbProductionsResponseItem
     */
    'ffbLoadedCumulative': number;
    /**
     * the number of ffb have been sorted due to being unripe
     * @type {number}
     * @memberof PartnersPlantationsGetFfbProductionsResponseItem
     */
    'ffbSortedUnripe': number;
    /**
     * the number of ffb have been sorted due to being rotten
     * @type {number}
     * @memberof PartnersPlantationsGetFfbProductionsResponseItem
     */
    'ffbSortedRotten': number;
    /**
     * the number of ffb have been sorted due to other reason
     * @type {number}
     * @memberof PartnersPlantationsGetFfbProductionsResponseItem
     */
    'ffbSortedOther': number;
    /**
     * the number of ffb have been stored
     * @type {number}
     * @memberof PartnersPlantationsGetFfbProductionsResponseItem
     */
    'ffbStored': number;
    /**
     * the number of delivered ffb sourced from the harvest
     * @type {number}
     * @memberof PartnersPlantationsGetFfbProductionsResponseItem
     */
    'ffbDeliverySourceHarvest': number;
    /**
     * the number of delivered ffb sourced from the storage
     * @type {number}
     * @memberof PartnersPlantationsGetFfbProductionsResponseItem
     */
    'ffbDeliverySourceStored': number;
    /**
     * the number of delivered ffb in total
     * @type {number}
     * @memberof PartnersPlantationsGetFfbProductionsResponseItem
     */
    'ffbDeliveryTotal': number;
    /**
     * the number of returned ffb
     * @type {number}
     * @memberof PartnersPlantationsGetFfbProductionsResponseItem
     */
    'ffbReturned': number;
    /**
     * the number of sold ffb
     * @type {number}
     * @memberof PartnersPlantationsGetFfbProductionsResponseItem
     */
    'ffbSold': number;
    /**
     * the number of sold ffb cumulative in one month
     * @type {number}
     * @memberof PartnersPlantationsGetFfbProductionsResponseItem
     */
    'ffbSoldCumulative': number;
    /**
     * notes for specific ffb production
     * @type {string}
     * @memberof PartnersPlantationsGetFfbProductionsResponseItem
     */
    'notes': string;
}
/**
 * 
 * @export
 * @interface PartnersPlantationsGetSchedulesResponse
 */
export interface PartnersPlantationsGetSchedulesResponse {
    /**
     * 
     * @type {Array<PartnersPlantationsGetSchedulesResponseItem>}
     * @memberof PartnersPlantationsGetSchedulesResponse
     */
    'items': Array<PartnersPlantationsGetSchedulesResponseItem>;
}
/**
 * 
 * @export
 * @interface PartnersPlantationsGetSchedulesResponseItem
 */
export interface PartnersPlantationsGetSchedulesResponseItem {
    /**
     * Unique identifier of the plantation schedule
     * @type {string}
     * @memberof PartnersPlantationsGetSchedulesResponseItem
     */
    'id': string;
    /**
     * schedule date in unix timestamp
     * @type {number}
     * @memberof PartnersPlantationsGetSchedulesResponseItem
     */
    'scheduleDateUtc0': number;
    /**
     * Name of the supervisor
     * @type {string}
     * @memberof PartnersPlantationsGetSchedulesResponseItem
     */
    'supervisorName': string;
    /**
     * Unique identifier of the supervisor
     * @type {string}
     * @memberof PartnersPlantationsGetSchedulesResponseItem
     */
    'supervisorContactId': string;
    /**
     * 
     * @type {PlantationActivityTypeEnum}
     * @memberof PartnersPlantationsGetSchedulesResponseItem
     */
    'plantationActivityType': PlantationActivityTypeEnum;
    /**
     * 
     * @type {Array<PlantationScheduleBlocks>}
     * @memberof PartnersPlantationsGetSchedulesResponseItem
     */
    'blocks': Array<PlantationScheduleBlocks>;
    /**
     * 
     * @type {PlantationScheduleStatusEnum}
     * @memberof PartnersPlantationsGetSchedulesResponseItem
     */
    'status': PlantationScheduleStatusEnum;
    /**
     * Work instruction for the plantation schedule
     * @type {string}
     * @memberof PartnersPlantationsGetSchedulesResponseItem
     */
    'workInstruction'?: string;
    /**
     * reason when the schedule cancelled
     * @type {string}
     * @memberof PartnersPlantationsGetSchedulesResponseItem
     */
    'cancelReason'?: string;
}


/**
 * 
 * @export
 * @interface PartnersPlantationsUpdatePartialBlockAssignmentsRequest
 */
export interface PartnersPlantationsUpdatePartialBlockAssignmentsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof PartnersPlantationsUpdatePartialBlockAssignmentsRequest
     */
    'assignedBlocks'?: Array<string>;
}
/**
 * 
 * @export
 * @interface PartnersPlantationsUpdateSchedulesPartialRequest
 */
export interface PartnersPlantationsUpdateSchedulesPartialRequest {
    /**
     * 
     * @type {PlantationActivityTypeEnum}
     * @memberof PartnersPlantationsUpdateSchedulesPartialRequest
     */
    'plantationActivityType'?: PlantationActivityTypeEnum;
    /**
     * The contact id of person who assigned to the plantation schedule
     * @type {string}
     * @memberof PartnersPlantationsUpdateSchedulesPartialRequest
     */
    'supervisorContactId'?: string;
    /**
     * Id of blocks which assigned on the plantation schedule
     * @type {Array<string>}
     * @memberof PartnersPlantationsUpdateSchedulesPartialRequest
     */
    'blockIds'?: Array<string>;
    /**
     * schedule date in unix timestamp
     * @type {number}
     * @memberof PartnersPlantationsUpdateSchedulesPartialRequest
     */
    'scheduleDateUtc0'?: number;
    /**
     * This is meant to be free text to be filled in by the creator for additional plantation schedule information
     * @type {string}
     * @memberof PartnersPlantationsUpdateSchedulesPartialRequest
     */
    'workInstruction'?: string;
    /**
     * 
     * @type {PlantationScheduleStatusEnum}
     * @memberof PartnersPlantationsUpdateSchedulesPartialRequest
     */
    'status'?: PlantationScheduleStatusEnum;
    /**
     * cancel reason
     * @type {string}
     * @memberof PartnersPlantationsUpdateSchedulesPartialRequest
     */
    'cancelReason'?: string;
}


/**
 * 
 * @export
 * @interface PartnersSwitchRequest
 */
export interface PartnersSwitchRequest {
    /**
     * selected partner identifier, using UUID type 4
     * @type {string}
     * @memberof PartnersSwitchRequest
     */
    'partnerId': string;
}
/**
 * 
 * @export
 * @interface PartnersUsersVerifyRegistrationBadRequestResponse
 */
export interface PartnersUsersVerifyRegistrationBadRequestResponse {
    /**
     * 
     * @type {string}
     * @memberof PartnersUsersVerifyRegistrationBadRequestResponse
     */
    'error': string;
    /**
     * 
     * @type {PartnersUsersVerifyRegistrationStatusItem}
     * @memberof PartnersUsersVerifyRegistrationBadRequestResponse
     */
    'data': PartnersUsersVerifyRegistrationStatusItem;
}
/**
 * 
 * @export
 * @interface PartnersUsersVerifyRegistrationRequest
 */
export interface PartnersUsersVerifyRegistrationRequest {
    /**
     * OTP Token retrieved from registration link, using UUID type 4 with expiration time
     * @type {string}
     * @memberof PartnersUsersVerifyRegistrationRequest
     */
    'otpToken': string;
}
/**
 * 
 * @export
 * @interface PartnersUsersVerifyRegistrationStatusItem
 */
export interface PartnersUsersVerifyRegistrationStatusItem {
    /**
     * 
     * @type {TokenValidationErrorStatusEnum}
     * @memberof PartnersUsersVerifyRegistrationStatusItem
     */
    'status': TokenValidationErrorStatusEnum;
}


/**
 * list of redeemed coupon at specific vendor
 * @export
 * @interface PartnersVendorGetRedeemedCouponsResponse
 */
export interface PartnersVendorGetRedeemedCouponsResponse {
    /**
     * 
     * @type {Array<PartnersVendorGetRedeemedCouponsResponseItem>}
     * @memberof PartnersVendorGetRedeemedCouponsResponse
     */
    'items': Array<PartnersVendorGetRedeemedCouponsResponseItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof PartnersVendorGetRedeemedCouponsResponse
     */
    'pagination'?: PaginationResponse;
}
/**
 * 
 * @export
 * @interface PartnersVendorGetRedeemedCouponsResponseItem
 */
export interface PartnersVendorGetRedeemedCouponsResponseItem {
    /**
     * Coupon Usage UUID
     * @type {string}
     * @memberof PartnersVendorGetRedeemedCouponsResponseItem
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PartnersVendorGetRedeemedCouponsResponseItem
     */
    'customerName': string;
    /**
     * Coupon code
     * @type {string}
     * @memberof PartnersVendorGetRedeemedCouponsResponseItem
     */
    'couponCode': string;
    /**
     * Coupon name
     * @type {string}
     * @memberof PartnersVendorGetRedeemedCouponsResponseItem
     */
    'couponName': string;
    /**
     * coupon nominal
     * @type {number}
     * @memberof PartnersVendorGetRedeemedCouponsResponseItem
     */
    'nominal': number;
    /**
     * redeem time of coupon datetime at UTC+0 in milliseconds
     * @type {number}
     * @memberof PartnersVendorGetRedeemedCouponsResponseItem
     */
    'redeemedAtUtc0': number;
}
/**
 * 
 * @export
 * @interface PaymentItemVirtualAccountInfo
 */
export interface PaymentItemVirtualAccountInfo {
    /**
     * 
     * @type {string}
     * @memberof PaymentItemVirtualAccountInfo
     */
    'virtualAccountNumber': string;
    /**
     * 
     * @type {string}
     * @memberof PaymentItemVirtualAccountInfo
     */
    'howToPayPage': string;
    /**
     * 
     * @type {string}
     * @memberof PaymentItemVirtualAccountInfo
     */
    'howToPayApi': string;
    /**
     * 
     * @type {string}
     * @memberof PaymentItemVirtualAccountInfo
     */
    'createdDate': string;
    /**
     * 
     * @type {string}
     * @memberof PaymentItemVirtualAccountInfo
     */
    'expiredDate': string;
    /**
     * 
     * @type {string}
     * @memberof PaymentItemVirtualAccountInfo
     */
    'createdDateUtc': string;
    /**
     * 
     * @type {string}
     * @memberof PaymentItemVirtualAccountInfo
     */
    'expiredDateUtc': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PaymentItemsPaymentMethodEnum = {
    Briva: 'BRIVA',
    Mandiriva: 'MANDIRIVA',
    Point: 'POINT',
    ManualTransfer: 'MANUAL_TRANSFER'
} as const;

export type PaymentItemsPaymentMethodEnum = typeof PaymentItemsPaymentMethodEnum[keyof typeof PaymentItemsPaymentMethodEnum];


/**
 * Payment method enum
 * @export
 * @enum {string}
 */

export const PaymentMethodEnum = {
    Transfer: 'TRANSFER',
    Point: 'POINT',
    TransferAndPoint: 'TRANSFER_AND_POINT',
    Briva: 'BRIVA',
    Mandiriva: 'MANDIRIVA'
} as const;

export type PaymentMethodEnum = typeof PaymentMethodEnum[keyof typeof PaymentMethodEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const PaymentStatusEnum = {
    Paid: 'PAID',
    Unpaid: 'UNPAID',
    Expired: 'EXPIRED',
    Cancelled: 'CANCELLED'
} as const;

export type PaymentStatusEnum = typeof PaymentStatusEnum[keyof typeof PaymentStatusEnum];


/**
 * Type of payment | - SAWITPOIN           : payment with sawitpoin - TRANSFER            : payment with transfer  - SAWITPOIN_TRANSFER  : payment with sawitpoin and transfer - VIRTUAL_ACCOUNT     : payment with virtual account 
 * @export
 * @enum {string}
 */

export const PaymentTypeEnum = {
    Sawitpoin: 'SAWITPOIN',
    Transfer: 'TRANSFER',
    SawitpoinTransfer: 'SAWITPOIN_TRANSFER',
    VirtualAccount: 'VIRTUAL_ACCOUNT'
} as const;

export type PaymentTypeEnum = typeof PaymentTypeEnum[keyof typeof PaymentTypeEnum];


/**
 * 
 * @export
 * @interface PaymentsCreateDirectPaymentPaymentItem
 */
export interface PaymentsCreateDirectPaymentPaymentItem {
    /**
     * 
     * @type {string}
     * @memberof PaymentsCreateDirectPaymentPaymentItem
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof PaymentsCreateDirectPaymentPaymentItem
     */
    'amountPaid': number;
    /**
     * 
     * @type {number}
     * @memberof PaymentsCreateDirectPaymentPaymentItem
     */
    'paidAtUtc': number;
    /**
     * 
     * @type {number}
     * @memberof PaymentsCreateDirectPaymentPaymentItem
     */
    'expiredAtUtc': number;
    /**
     * 
     * @type {PaymentItemsPaymentMethodEnum}
     * @memberof PaymentsCreateDirectPaymentPaymentItem
     */
    'paymentMethod': PaymentItemsPaymentMethodEnum;
    /**
     * 
     * @type {PaymentStatusEnum}
     * @memberof PaymentsCreateDirectPaymentPaymentItem
     */
    'status': PaymentStatusEnum;
}


/**
 * 
 * @export
 * @interface PaymentsCreateDirectPaymentRequest
 */
export interface PaymentsCreateDirectPaymentRequest {
    /**
     * Invoice ID in UUID type 4 format
     * @type {string}
     * @memberof PaymentsCreateDirectPaymentRequest
     */
    'invoiceId': string;
    /**
     * point ammount transaction of payment method
     * @type {number}
     * @memberof PaymentsCreateDirectPaymentRequest
     */
    'pointAmount': number;
    /**
     * 
     * @type {PaymentsCreateDirectPaymentRequestPaymentMethodEnum}
     * @memberof PaymentsCreateDirectPaymentRequest
     */
    'paymentMethod': PaymentsCreateDirectPaymentRequestPaymentMethodEnum;
    /**
     * Hash PIN using HMAC SHA 256
     * @type {string}
     * @memberof PaymentsCreateDirectPaymentRequest
     */
    'pin'?: string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const PaymentsCreateDirectPaymentRequestPaymentMethodEnum = {
    Transfer: 'TRANSFER',
    Point: 'POINT',
    TransferAndPoint: 'TRANSFER_AND_POINT'
} as const;

export type PaymentsCreateDirectPaymentRequestPaymentMethodEnum = typeof PaymentsCreateDirectPaymentRequestPaymentMethodEnum[keyof typeof PaymentsCreateDirectPaymentRequestPaymentMethodEnum];


/**
 * 
 * @export
 * @interface PaymentsCreateDirectPaymentResponse
 */
export interface PaymentsCreateDirectPaymentResponse {
    /**
     * 
     * @type {string}
     * @memberof PaymentsCreateDirectPaymentResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PaymentsCreateDirectPaymentResponse
     */
    'orderId': string;
    /**
     * 
     * @type {string}
     * @memberof PaymentsCreateDirectPaymentResponse
     */
    'invoiceNo': string;
    /**
     * 
     * @type {number}
     * @memberof PaymentsCreateDirectPaymentResponse
     */
    'amountDue': number;
    /**
     * 
     * @type {number}
     * @memberof PaymentsCreateDirectPaymentResponse
     */
    'dueAtUtc': number;
    /**
     * 
     * @type {InvoiceStatusEnum}
     * @memberof PaymentsCreateDirectPaymentResponse
     */
    'status': InvoiceStatusEnum;
    /**
     * List of Payment Item
     * @type {Array<PaymentsCreateDirectPaymentPaymentItem>}
     * @memberof PaymentsCreateDirectPaymentResponse
     */
    'paymentItems': Array<PaymentsCreateDirectPaymentPaymentItem>;
}


/**
 * 
 * @export
 * @interface PaymentsCreatePaymentPaymentItemDirectPayment
 */
export interface PaymentsCreatePaymentPaymentItemDirectPayment {
    /**
     * 
     * @type {string}
     * @memberof PaymentsCreatePaymentPaymentItemDirectPayment
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof PaymentsCreatePaymentPaymentItemDirectPayment
     */
    'amountPaid': number;
    /**
     * 
     * @type {number}
     * @memberof PaymentsCreatePaymentPaymentItemDirectPayment
     */
    'paidAtUtc': number;
    /**
     * 
     * @type {number}
     * @memberof PaymentsCreatePaymentPaymentItemDirectPayment
     */
    'amountDue': number;
    /**
     * 
     * @type {number}
     * @memberof PaymentsCreatePaymentPaymentItemDirectPayment
     */
    'expiredAtUtc': number;
    /**
     * 
     * @type {PaymentItemsPaymentMethodEnum}
     * @memberof PaymentsCreatePaymentPaymentItemDirectPayment
     */
    'paymentMethod': PaymentItemsPaymentMethodEnum;
    /**
     * 
     * @type {PaymentStatusEnum}
     * @memberof PaymentsCreatePaymentPaymentItemDirectPayment
     */
    'status': PaymentStatusEnum;
}


/**
 * 
 * @export
 * @interface PaymentsCreatePaymentPaymentItemDoku
 */
export interface PaymentsCreatePaymentPaymentItemDoku {
    /**
     * 
     * @type {string}
     * @memberof PaymentsCreatePaymentPaymentItemDoku
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof PaymentsCreatePaymentPaymentItemDoku
     */
    'amountPaid': number;
    /**
     * 
     * @type {number}
     * @memberof PaymentsCreatePaymentPaymentItemDoku
     */
    'paidAtUtc': number;
    /**
     * 
     * @type {number}
     * @memberof PaymentsCreatePaymentPaymentItemDoku
     */
    'amountDue': number;
    /**
     * 
     * @type {number}
     * @memberof PaymentsCreatePaymentPaymentItemDoku
     */
    'expiredAtUtc': number;
    /**
     * 
     * @type {PaymentItemsPaymentMethodEnum}
     * @memberof PaymentsCreatePaymentPaymentItemDoku
     */
    'paymentMethod': PaymentItemsPaymentMethodEnum;
    /**
     * 
     * @type {PaymentStatusEnum}
     * @memberof PaymentsCreatePaymentPaymentItemDoku
     */
    'status': PaymentStatusEnum;
    /**
     * 
     * @type {PaymentItemVirtualAccountInfo}
     * @memberof PaymentsCreatePaymentPaymentItemDoku
     */
    'virtualAccountInfo': PaymentItemVirtualAccountInfo;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const PaymentsCreatePaymentPaymentMethodEnum = {
    Briva: 'BRIVA',
    Mandiriva: 'MANDIRIVA',
    Point: 'POINT',
    Transfer: 'TRANSFER'
} as const;

export type PaymentsCreatePaymentPaymentMethodEnum = typeof PaymentsCreatePaymentPaymentMethodEnum[keyof typeof PaymentsCreatePaymentPaymentMethodEnum];


/**
 * 
 * @export
 * @interface PaymentsCreatePaymentRequest
 */
export interface PaymentsCreatePaymentRequest {
    /**
     * phone number of the user that this request is for guest user
     * @type {string}
     * @memberof PaymentsCreatePaymentRequest
     */
    'phoneNo'?: string;
    /**
     * Invoice ID in UUID type 4 format
     * @type {string}
     * @memberof PaymentsCreatePaymentRequest
     */
    'invoiceId': string;
    /**
     * used by DUTA app, id of the user that this request is for
     * @type {string}
     * @memberof PaymentsCreatePaymentRequest
     */
    'userId'?: string;
    /**
     * flag for using point as payment
     * @type {boolean}
     * @memberof PaymentsCreatePaymentRequest
     */
    'pointUseStatus': boolean;
    /**
     * point ammount transaction of payment method
     * @type {number}
     * @memberof PaymentsCreatePaymentRequest
     */
    'pointAmount': number;
    /**
     * 
     * @type {PaymentsCreatePaymentPaymentMethodEnum}
     * @memberof PaymentsCreatePaymentRequest
     */
    'paymentMethod': PaymentsCreatePaymentPaymentMethodEnum;
    /**
     * Hash PIN using HMAC SHA 256
     * @type {string}
     * @memberof PaymentsCreatePaymentRequest
     */
    'pin'?: string;
    /**
     * Voucher ID in UUID type 4 format
     * @type {string}
     * @memberof PaymentsCreatePaymentRequest
     */
    'voucherUsageId'?: string;
}


/**
 * 
 * @export
 * @interface PaymentsCreatePaymentResponse
 */
export interface PaymentsCreatePaymentResponse {
    /**
     * 
     * @type {string}
     * @memberof PaymentsCreatePaymentResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PaymentsCreatePaymentResponse
     */
    'orderId': string;
    /**
     * 
     * @type {string}
     * @memberof PaymentsCreatePaymentResponse
     */
    'invoiceNo': string;
    /**
     * 
     * @type {number}
     * @memberof PaymentsCreatePaymentResponse
     */
    'amountDue': number;
    /**
     * 
     * @type {number}
     * @memberof PaymentsCreatePaymentResponse
     */
    'dueAtUtc': number;
    /**
     * 
     * @type {InvoiceStatusEnum}
     * @memberof PaymentsCreatePaymentResponse
     */
    'status': InvoiceStatusEnum;
    /**
     * List of Payment Item
     * @type {Array<PaymentsCreatePaymentResponsePaymentItemsInner>}
     * @memberof PaymentsCreatePaymentResponse
     */
    'paymentItems': Array<PaymentsCreatePaymentResponsePaymentItemsInner>;
}


/**
 * @type PaymentsCreatePaymentResponsePaymentItemsInner
 * @export
 */
export type PaymentsCreatePaymentResponsePaymentItemsInner = PaymentsCreatePaymentPaymentItemDirectPayment | PaymentsCreatePaymentPaymentItemDoku;

/**
 * 
 * @export
 * @interface PaymentsVerifyRequest
 */
export interface PaymentsVerifyRequest {
    /**
     * Payment ID in UUID
     * @type {string}
     * @memberof PaymentsVerifyRequest
     */
    'paymentId': string;
    /**
     * amount transfered by customer
     * @type {number}
     * @memberof PaymentsVerifyRequest
     */
    'amountPaid': number;
    /**
     * Unix timestamp when customer makes payment
     * @type {number}
     * @memberof PaymentsVerifyRequest
     */
    'paidDate': number;
    /**
     * Remark or description from finance
     * @type {string}
     * @memberof PaymentsVerifyRequest
     */
    'remark'?: string;
}
/**
 * 
 * @export
 * @interface PaymentsVerifyResponse
 */
export interface PaymentsVerifyResponse {
    /**
     * 
     * @type {string}
     * @memberof PaymentsVerifyResponse
     */
    'paymentId': string;
    /**
     * 
     * @type {PaymentStatusEnum}
     * @memberof PaymentsVerifyResponse
     */
    'status'?: PaymentStatusEnum;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const PeriodEnum = {
    Today: 'TODAY',
    Yesterday: 'YESTERDAY',
    CurrentMonth: 'CURRENT_MONTH',
    PreviousMonth: 'PREVIOUS_MONTH'
} as const;

export type PeriodEnum = typeof PeriodEnum[keyof typeof PeriodEnum];


/**
 * 
 * @export
 * @interface PlantationActivitiesCreateLoadsRequest
 */
export interface PlantationActivitiesCreateLoadsRequest {
    /**
     * Unique identifier for activity load
     * @type {string}
     * @memberof PlantationActivitiesCreateLoadsRequest
     */
    'id'?: string;
    /**
     * id of the truck that will be used to transport the FFB
     * @type {string}
     * @memberof PlantationActivitiesCreateLoadsRequest
     */
    'truckId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PlantationActivitiesCreateLoadsRequest
     */
    'loaderCollectionIds': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PlantationActivitiesCreateLoadsRequest
     */
    'loaderTruckIds': Array<string>;
    /**
     * UUID type 4
     * @type {string}
     * @memberof PlantationActivitiesCreateLoadsRequest
     */
    'blockId': string;
    /**
     * amount of FFB
     * @type {number}
     * @memberof PlantationActivitiesCreateLoadsRequest
     */
    'ffbQuantity': number;
    /**
     * amount of loose fruit
     * @type {number}
     * @memberof PlantationActivitiesCreateLoadsRequest
     */
    'looseFruitQuantity': number;
    /**
     * amount of rotten fruit
     * @type {number}
     * @memberof PlantationActivitiesCreateLoadsRequest
     */
    'rottenFruitQuantity': number;
    /**
     * amount of unripe fruit
     * @type {number}
     * @memberof PlantationActivitiesCreateLoadsRequest
     */
    'unripeFruitQuantity': number;
    /**
     * start date utc0 for price list
     * @type {number}
     * @memberof PlantationActivitiesCreateLoadsRequest
     */
    'loadingDateUtc0': number;
    /**
     * Latitude where the request was submitted
     * @type {number}
     * @memberof PlantationActivitiesCreateLoadsRequest
     */
    'latitude': number;
    /**
     * Longitude where the request was submitted
     * @type {number}
     * @memberof PlantationActivitiesCreateLoadsRequest
     */
    'longitude': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PlantationActivityTypeEnum = {
    Pruning: 'PRUNING',
    Spraying: 'SPRAYING',
    Slashing: 'SLASHING',
    Ablation: 'ABLATION',
    Sanitation: 'SANITATION',
    Fertilizing: 'FERTILIZING',
    Harvesting: 'HARVESTING',
    Upkeeping: 'UPKEEPING'
} as const;

export type PlantationActivityTypeEnum = typeof PlantationActivityTypeEnum[keyof typeof PlantationActivityTypeEnum];


/**
 * 
 * @export
 * @interface PlantationActivityUpkeepFeeUpdateRequest
 */
export interface PlantationActivityUpkeepFeeUpdateRequest {
    /**
     * The individual cost of upkeep activity
     * @type {number}
     * @memberof PlantationActivityUpkeepFeeUpdateRequest
     */
    'individualCost': number;
}
/**
 * 
 * @export
 * @interface PlantationActivityUpkeepListResponse
 */
export interface PlantationActivityUpkeepListResponse {
    /**
     * Total cost of fertilizing
     * @type {number}
     * @memberof PlantationActivityUpkeepListResponse
     */
    'fertilizingCost': number;
    /**
     * Total cost of pruning
     * @type {number}
     * @memberof PlantationActivityUpkeepListResponse
     */
    'pruningCost': number;
    /**
     * Total cost of spraying
     * @type {number}
     * @memberof PlantationActivityUpkeepListResponse
     */
    'sprayingCost': number;
    /**
     * Total cost of slashing
     * @type {number}
     * @memberof PlantationActivityUpkeepListResponse
     */
    'slashingCost': number;
    /**
     * Total cost of ablation
     * @type {number}
     * @memberof PlantationActivityUpkeepListResponse
     */
    'ablationCost': number;
    /**
     * Total cost of sanitation
     * @type {number}
     * @memberof PlantationActivityUpkeepListResponse
     */
    'sanitationCost': number;
    /**
     * List of Upkeep Activities
     * @type {Array<PlantationActivityUpkeepListResponseItem>}
     * @memberof PlantationActivityUpkeepListResponse
     */
    'items': Array<PlantationActivityUpkeepListResponseItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof PlantationActivityUpkeepListResponse
     */
    'pagination': PaginationResponse;
}
/**
 * 
 * @export
 * @interface PlantationActivityUpkeepListResponseItem
 */
export interface PlantationActivityUpkeepListResponseItem {
    /**
     * ID of the upkeep activity in UUID type 4
     * @type {string}
     * @memberof PlantationActivityUpkeepListResponseItem
     */
    'id': string;
    /**
     * Date of the activity
     * @type {number}
     * @memberof PlantationActivityUpkeepListResponseItem
     */
    'date': number;
    /**
     * Name of the worker that\'s doing the activity
     * @type {string}
     * @memberof PlantationActivityUpkeepListResponseItem
     */
    'workerName': string;
    /**
     * Block of the plantation
     * @type {string}
     * @memberof PlantationActivityUpkeepListResponseItem
     */
    'block': string;
    /**
     * Type of the upkeep activity
     * @type {string}
     * @memberof PlantationActivityUpkeepListResponseItem
     */
    'upkeepType': string;
    /**
     * Type of the upkeep activity in Bahasa
     * @type {string}
     * @memberof PlantationActivityUpkeepListResponseItem
     */
    'upkeepTypeLabel': string;
    /**
     * Count of the resource used for upkeep activity
     * @type {string}
     * @memberof PlantationActivityUpkeepListResponseItem
     */
    'count': string;
    /**
     * Information of the upkeep activity. Will return empty string if not exists.
     * @type {string}
     * @memberof PlantationActivityUpkeepListResponseItem
     */
    'upkeepInformation': string;
    /**
     * Cost of the resource used for upkeep activity per item. Will be null if not exists.
     * @type {number}
     * @memberof PlantationActivityUpkeepListResponseItem
     */
    'individualCost'?: number;
    /**
     * Total cost of the upkeep activity. Will be null if not exists.
     * @type {number}
     * @memberof PlantationActivityUpkeepListResponseItem
     */
    'totalCost'?: number;
}
/**
 * 
 * @export
 * @interface PlantationActivityWeighingListResponse
 */
export interface PlantationActivityWeighingListResponse {
    /**
     * 
     * @type {Array<PlantationActivityWeighingResponseItem>}
     * @memberof PlantationActivityWeighingListResponse
     */
    'items': Array<PlantationActivityWeighingResponseItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof PlantationActivityWeighingListResponse
     */
    'pagination': PaginationResponse;
}
/**
 * 
 * @export
 * @interface PlantationActivityWeighingResponseItem
 */
export interface PlantationActivityWeighingResponseItem {
    /**
     * Unique identifier of the weighing activity
     * @type {string}
     * @memberof PlantationActivityWeighingResponseItem
     */
    'id': string;
    /**
     * Time of the weighing activity
     * @type {number}
     * @memberof PlantationActivityWeighingResponseItem
     */
    'weighingTime': number;
    /**
     * Time of the delivery activity
     * @type {number}
     * @memberof PlantationActivityWeighingResponseItem
     */
    'deliveryTime': number;
    /**
     * Block name where the weighing activity is done
     * @type {string}
     * @memberof PlantationActivityWeighingResponseItem
     */
    'block': string;
    /**
     * Weight of the FFB
     * @type {number}
     * @memberof PlantationActivityWeighingResponseItem
     */
    'ffbWeight': number;
    /**
     * Name of the harvester (Tukang Panen)
     * @type {string}
     * @memberof PlantationActivityWeighingResponseItem
     */
    'harvesterName': string;
    /**
     * Name of the loader collection (Tukang Langsir)
     * @type {string}
     * @memberof PlantationActivityWeighingResponseItem
     */
    'loaderCollectionName': string;
    /**
     * Name of the weigher (Tukang Timbang)
     * @type {string}
     * @memberof PlantationActivityWeighingResponseItem
     */
    'weigherName': string;
    /**
     * Name of the loader truck (Tukang Muat)
     * @type {string}
     * @memberof PlantationActivityWeighingResponseItem
     */
    'loaderTruckName': string;
    /**
     * Whether the weighing activity is selected or not in the list on FE
     * @type {boolean}
     * @memberof PlantationActivityWeighingResponseItem
     */
    'isSelected': boolean;
}
/**
 * 
 * @export
 * @interface PlantationExpenseCreateUpdateRequest
 */
export interface PlantationExpenseCreateUpdateRequest {
    /**
     * id of farm group in UUID type 4
     * @type {string}
     * @memberof PlantationExpenseCreateUpdateRequest
     */
    'groupId': string;
    /**
     * Date of expense
     * @type {number}
     * @memberof PlantationExpenseCreateUpdateRequest
     */
    'date': number;
    /**
     * wages for administration
     * @type {number}
     * @memberof PlantationExpenseCreateUpdateRequest
     */
    'adminWages': number;
    /**
     * wages for operational
     * @type {number}
     * @memberof PlantationExpenseCreateUpdateRequest
     */
    'operationalWages': number;
    /**
     * wages for maintenance
     * @type {number}
     * @memberof PlantationExpenseCreateUpdateRequest
     */
    'maintenanceWages'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PlantationHarvestActivityTypeEnum = {
    Harvesting: 'HARVESTING',
    Hauling: 'HAULING',
    Weighing: 'WEIGHING',
    Loading: 'LOADING'
} as const;

export type PlantationHarvestActivityTypeEnum = typeof PlantationHarvestActivityTypeEnum[keyof typeof PlantationHarvestActivityTypeEnum];


/**
 * 
 * @export
 * @interface PlantationHarvestCostCreateRequest
 */
export interface PlantationHarvestCostCreateRequest {
    /**
     * id of an activity weighing in UUID type 4
     * @type {string}
     * @memberof PlantationHarvestCostCreateRequest
     */
    'activityWeighingId': string;
    /**
     * id of a block in UUID type 4
     * @type {string}
     * @memberof PlantationHarvestCostCreateRequest
     */
    'blockId': string;
    /**
     * Date of weighing
     * @type {number}
     * @memberof PlantationHarvestCostCreateRequest
     */
    'weighingDate': number;
    /**
     * 
     * @type {Array<PlantationHarvestCostCreateRequestActivityInner>}
     * @memberof PlantationHarvestCostCreateRequest
     */
    'activity': Array<PlantationHarvestCostCreateRequestActivityInner>;
}
/**
 * 
 * @export
 * @interface PlantationHarvestCostCreateRequestActivityInner
 */
export interface PlantationHarvestCostCreateRequestActivityInner {
    /**
     * id of a harvest cost detail in UUID type 4
     * @type {string}
     * @memberof PlantationHarvestCostCreateRequestActivityInner
     */
    'id'?: string;
    /**
     * id of user or leader (contact) in UUID type 4
     * @type {string}
     * @memberof PlantationHarvestCostCreateRequestActivityInner
     */
    'contactId': string;
    /**
     * 
     * @type {PlantationHarvestActivityTypeEnum}
     * @memberof PlantationHarvestCostCreateRequestActivityInner
     */
    'activityType': PlantationHarvestActivityTypeEnum;
    /**
     * wages on unit Upah/Kg each user
     * @type {number}
     * @memberof PlantationHarvestCostCreateRequestActivityInner
     */
    'wages': number;
}


/**
 * 
 * @export
 * @interface PlantationSaleCreateRequest
 */
export interface PlantationSaleCreateRequest {
    /**
     * id of a plantation sale in UUID type 4
     * @type {string}
     * @memberof PlantationSaleCreateRequest
     */
    'id'?: string;
    /**
     * id of weighbridge sale in UUID type 4
     * @type {string}
     * @memberof PlantationSaleCreateRequest
     */
    'weighbridgeId'?: string;
    /**
     * no ticket of weighbridge
     * @type {string}
     * @memberof PlantationSaleCreateRequest
     */
    'weighbridgeNoTicket': string;
    /**
     * delivery time of FFB. using epoch
     * @type {number}
     * @memberof PlantationSaleCreateRequest
     */
    'deliveryTime': number;
    /**
     * truck number of FFB delivery
     * @type {string}
     * @memberof PlantationSaleCreateRequest
     */
    'truckNumber': string;
    /**
     * weight of harvest from farm
     * @type {number}
     * @memberof PlantationSaleCreateRequest
     */
    'weightNetFarm': number;
    /**
     * sortation from mill on percent
     * @type {number}
     * @memberof PlantationSaleCreateRequest
     */
    'sortationPercent': number;
    /**
     * sortation from mill on kilogram
     * @type {number}
     * @memberof PlantationSaleCreateRequest
     */
    'sortationKilo': number;
    /**
     * multiplier for delivery cost
     * @type {number}
     * @memberof PlantationSaleCreateRequest
     */
    'multiplierDeliveryCost': number;
    /**
     * mill sell price
     * @type {number}
     * @memberof PlantationSaleCreateRequest
     */
    'sellPrice': number;
    /**
     * other cost during harvest or delivery
     * @type {number}
     * @memberof PlantationSaleCreateRequest
     */
    'otherCost': number;
}
/**
 * 
 * @export
 * @interface PlantationSaleMapWeighingRequest
 */
export interface PlantationSaleMapWeighingRequest {
    /**
     * UUID of the activity weighing
     * @type {Array<string>}
     * @memberof PlantationSaleMapWeighingRequest
     */
    'activities': Array<string>;
}
/**
 * 
 * @export
 * @interface PlantationScheduleBlocks
 */
export interface PlantationScheduleBlocks {
    /**
     * Unique identifier of the plantation block
     * @type {string}
     * @memberof PlantationScheduleBlocks
     */
    'id': string;
    /**
     * Name of the plantation block
     * @type {string}
     * @memberof PlantationScheduleBlocks
     */
    'name': string;
}
/**
 * List of allowed plantation schedule status
 * @export
 * @enum {string}
 */

export const PlantationScheduleStatusEnum = {
    Scheduled: 'SCHEDULED',
    Finished: 'FINISHED',
    Cancelled: 'CANCELLED',
    InProgress: 'IN_PROGRESS',
    VerifiedByHarvester: 'VERIFIED_BY_HARVESTER'
} as const;

export type PlantationScheduleStatusEnum = typeof PlantationScheduleStatusEnum[keyof typeof PlantationScheduleStatusEnum];


/**
 * 
 * @export
 * @interface PlantationsActivitiesCreateHarvestsRequest
 */
export interface PlantationsActivitiesCreateHarvestsRequest {
    /**
     * generated id
     * @type {string}
     * @memberof PlantationsActivitiesCreateHarvestsRequest
     */
    'id'?: string;
    /**
     * Quantity of FFB in Janjang
     * @type {number}
     * @memberof PlantationsActivitiesCreateHarvestsRequest
     */
    'ffbQuantity': number;
    /**
     * Estimated average FFB (BJR/Komidel) weight in kg
     * @type {number}
     * @memberof PlantationsActivitiesCreateHarvestsRequest
     */
    'estimatedWeightAverageBunchKg'?: number;
    /**
     * 
     * @type {string}
     * @memberof PlantationsActivitiesCreateHarvestsRequest
     */
    'ffbCollectionPoint'?: string;
    /**
     * Date when user take a photo
     * @type {number}
     * @memberof PlantationsActivitiesCreateHarvestsRequest
     */
    'harvestingDate': number;
    /**
     * 
     * @type {number}
     * @memberof PlantationsActivitiesCreateHarvestsRequest
     */
    'latitude': number;
    /**
     * 
     * @type {number}
     * @memberof PlantationsActivitiesCreateHarvestsRequest
     */
    'longitude': number;
    /**
     * Photo of harvest fruit
     * @type {File}
     * @memberof PlantationsActivitiesCreateHarvestsRequest
     */
    'photo'?: File;
    /**
     * datetime at UTC+0 in milliseconds when users create locally in offline mode
     * @type {number}
     * @memberof PlantationsActivitiesCreateHarvestsRequest
     */
    'submittedAt': number;
    /**
     * client timezone when user create harvesting activity
     * @type {string}
     * @memberof PlantationsActivitiesCreateHarvestsRequest
     */
    'userTimezone': string;
    /**
     * 
     * @type {string}
     * @memberof PlantationsActivitiesCreateHarvestsRequest
     */
    'type'?: PlantationsActivitiesCreateHarvestsRequestTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PlantationsActivitiesCreateHarvestsRequest
     */
    'blockId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PlantationsActivitiesCreateHarvestsRequest
     */
    'plantationScheduleId'?: string;
}

export const PlantationsActivitiesCreateHarvestsRequestTypeEnum = {
    Individual: 'INDIVIDUAL',
    PlantationManagement: 'PLANTATION_MANAGEMENT'
} as const;

export type PlantationsActivitiesCreateHarvestsRequestTypeEnum = typeof PlantationsActivitiesCreateHarvestsRequestTypeEnum[keyof typeof PlantationsActivitiesCreateHarvestsRequestTypeEnum];

/**
 * 
 * @export
 * @interface PlantationsActivitiesCreateUpkeepsItemsFertilizingRequest
 */
export interface PlantationsActivitiesCreateUpkeepsItemsFertilizingRequest {
    /**
     * amount of fertilizer used
     * @type {number}
     * @memberof PlantationsActivitiesCreateUpkeepsItemsFertilizingRequest
     */
    'fertilizerQuantity': number;
    /**
     * UUID type 4
     * @type {string}
     * @memberof PlantationsActivitiesCreateUpkeepsItemsFertilizingRequest
     */
    'blockId': string;
    /**
     * fertilizer url photo used at fertilizing upkeep activity
     * @type {string}
     * @memberof PlantationsActivitiesCreateUpkeepsItemsFertilizingRequest
     */
    'fertilizerPhoto': string;
    /**
     * Date when user finish the activity
     * @type {string}
     * @memberof PlantationsActivitiesCreateUpkeepsItemsFertilizingRequest
     */
    'upkeepingDate': string;
    /**
     * Latitude where the schedule was submitted
     * @type {number}
     * @memberof PlantationsActivitiesCreateUpkeepsItemsFertilizingRequest
     */
    'latitude': number;
    /**
     * Longitude where the request was submitted
     * @type {number}
     * @memberof PlantationsActivitiesCreateUpkeepsItemsFertilizingRequest
     */
    'longitude': number;
    /**
     * URL of upkeeping photo
     * @type {string}
     * @memberof PlantationsActivitiesCreateUpkeepsItemsFertilizingRequest
     */
    'upkeepingPhoto': string;
    /**
     * 
     * @type {string}
     * @memberof PlantationsActivitiesCreateUpkeepsItemsFertilizingRequest
     */
    'plantationScheduleId'?: string;
}
/**
 * 
 * @export
 * @interface PlantationsActivitiesCreateUpkeepsItemsRequest
 */
export interface PlantationsActivitiesCreateUpkeepsItemsRequest {
    /**
     * Quantity or achievement of the activity
     * @type {number}
     * @memberof PlantationsActivitiesCreateUpkeepsItemsRequest
     */
    'quantity': number;
    /**
     * UUID type 4
     * @type {string}
     * @memberof PlantationsActivitiesCreateUpkeepsItemsRequest
     */
    'blockId': string;
    /**
     * Date when user take photo
     * @type {string}
     * @memberof PlantationsActivitiesCreateUpkeepsItemsRequest
     */
    'upkeepingDate': string;
    /**
     * Latitude where the schedule was submitted
     * @type {number}
     * @memberof PlantationsActivitiesCreateUpkeepsItemsRequest
     */
    'latitude': number;
    /**
     * Longitude where the request was submitted
     * @type {number}
     * @memberof PlantationsActivitiesCreateUpkeepsItemsRequest
     */
    'longitude': number;
    /**
     * URL of upkeeping photo
     * @type {string}
     * @memberof PlantationsActivitiesCreateUpkeepsItemsRequest
     */
    'upkeepingPhoto': string;
    /**
     * 
     * @type {string}
     * @memberof PlantationsActivitiesCreateUpkeepsItemsRequest
     */
    'plantationScheduleId'?: string;
}
/**
 * 
 * @export
 * @interface PlantationsActivitiesCreateUpkeepsRequest
 */
export interface PlantationsActivitiesCreateUpkeepsRequest {
    /**
     * 
     * @type {TypePlantationsUpkeepActivitiesEnum}
     * @memberof PlantationsActivitiesCreateUpkeepsRequest
     */
    'type': TypePlantationsUpkeepActivitiesEnum;
    /**
     * 
     * @type {PlantationsActivitiesCreateUpkeepsRequestItems}
     * @memberof PlantationsActivitiesCreateUpkeepsRequest
     */
    'items': PlantationsActivitiesCreateUpkeepsRequestItems;
}


/**
 * @type PlantationsActivitiesCreateUpkeepsRequestItems
 * @export
 */
export type PlantationsActivitiesCreateUpkeepsRequestItems = PlantationsActivitiesCreateUpkeepsItemsFertilizingRequest | PlantationsActivitiesCreateUpkeepsItemsRequest;

/**
 * 
 * @export
 * @interface PlantationsActivitiesCreateUpkeepsResponse
 */
export interface PlantationsActivitiesCreateUpkeepsResponse {
    /**
     * activities is successfully saved or not
     * @type {boolean}
     * @memberof PlantationsActivitiesCreateUpkeepsResponse
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface PlantationsActivitiesGetHarvestsResponse
 */
export interface PlantationsActivitiesGetHarvestsResponse {
    /**
     * 
     * @type {Array<PlantationsGetActivitiesHarvestsItemsResponse>}
     * @memberof PlantationsActivitiesGetHarvestsResponse
     */
    'items': Array<PlantationsGetActivitiesHarvestsItemsResponse>;
}
/**
 * 
 * @export
 * @interface PlantationsActivitiesGetLimitsResponse
 */
export interface PlantationsActivitiesGetLimitsResponse {
    /**
     * maximum amount of plantations activities creation for current user
     * @type {number}
     * @memberof PlantationsActivitiesGetLimitsResponse
     */
    'limit': number;
    /**
     * remaning amount of plantations activities creation for current user
     * @type {number}
     * @memberof PlantationsActivitiesGetLimitsResponse
     */
    'remaining': number;
}
/**
 * 
 * @export
 * @interface PlantationsActivitiesMaterialsListResponse
 */
export interface PlantationsActivitiesMaterialsListResponse {
    /**
     * 
     * @type {Array<PlantationsActivitiesMaterialsListResponseItem>}
     * @memberof PlantationsActivitiesMaterialsListResponse
     */
    'items': Array<PlantationsActivitiesMaterialsListResponseItem>;
}
/**
 * 
 * @export
 * @interface PlantationsActivitiesMaterialsListResponseItem
 */
export interface PlantationsActivitiesMaterialsListResponseItem {
    /**
     * Id of plantation activity material
     * @type {string}
     * @memberof PlantationsActivitiesMaterialsListResponseItem
     */
    'id': string;
    /**
     * name of the plantation activity material
     * @type {string}
     * @memberof PlantationsActivitiesMaterialsListResponseItem
     */
    'name': string;
    /**
     * comment of the plantation activity material
     * @type {string}
     * @memberof PlantationsActivitiesMaterialsListResponseItem
     */
    'comment': string;
    /**
     * UOM of the plantation activity material
     * @type {string}
     * @memberof PlantationsActivitiesMaterialsListResponseItem
     */
    'uom': string;
}
/**
 * 
 * @export
 * @interface PlantationsActivitiesSmallholdersCreateUpkeepRequest
 */
export interface PlantationsActivitiesSmallholdersCreateUpkeepRequest {
    /**
     * Farm Id related to the upkeep
     * @type {string}
     * @memberof PlantationsActivitiesSmallholdersCreateUpkeepRequest
     */
    'farmId': string;
    /**
     * activity Id of the upkeep
     * @type {string}
     * @memberof PlantationsActivitiesSmallholdersCreateUpkeepRequest
     */
    'activityId': string;
    /**
     * date when the upkeep was done in unix timestamp
     * @type {number}
     * @memberof PlantationsActivitiesSmallholdersCreateUpkeepRequest
     */
    'date': number;
    /**
     * fertilizer Id related to the upkeep. Should be filled when activity is FERTILIZING
     * @type {string}
     * @memberof PlantationsActivitiesSmallholdersCreateUpkeepRequest
     */
    'fertilizerId'?: string;
    /**
     * quantity of the upkeep
     * @type {number}
     * @memberof PlantationsActivitiesSmallholdersCreateUpkeepRequest
     */
    'quantity': number;
    /**
     * Total cost of the upkeep
     * @type {number}
     * @memberof PlantationsActivitiesSmallholdersCreateUpkeepRequest
     */
    'totalCost': number;
    /**
     * other cost of the upkeep
     * @type {number}
     * @memberof PlantationsActivitiesSmallholdersCreateUpkeepRequest
     */
    'otherCost'?: number;
    /**
     * used by DUTA app, id of the user that this request is for
     * @type {string}
     * @memberof PlantationsActivitiesSmallholdersCreateUpkeepRequest
     */
    'userId'?: string;
}
/**
 * 
 * @export
 * @interface PlantationsActivitiesSmallholdersCreateUpkeepResponse
 */
export interface PlantationsActivitiesSmallholdersCreateUpkeepResponse {
    /**
     * smallholder upkeep activity is successfully saved or not
     * @type {boolean}
     * @memberof PlantationsActivitiesSmallholdersCreateUpkeepResponse
     */
    'success': boolean;
    /**
     * Sawitpoin reward for this action, if <= 0 user is not eligible for Sawitpoin reward
     * @type {number}
     * @memberof PlantationsActivitiesSmallholdersCreateUpkeepResponse
     */
    'sawitpoin': number;
}
/**
 * 
 * @export
 * @interface PlantationsActivitiesSmallholdersDeleteUpkeepResponse
 */
export interface PlantationsActivitiesSmallholdersDeleteUpkeepResponse {
    /**
     * id of the soft-deleted smallholder\'s upkeep_history data
     * @type {string}
     * @memberof PlantationsActivitiesSmallholdersDeleteUpkeepResponse
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface PlantationsActivitiesSmallholdersGetUpkeepsResponse
 */
export interface PlantationsActivitiesSmallholdersGetUpkeepsResponse {
    /**
     * 
     * @type {Array<PlantationsActivitiesSmallholdersGetUpkeepsResponseItem>}
     * @memberof PlantationsActivitiesSmallholdersGetUpkeepsResponse
     */
    'items': Array<PlantationsActivitiesSmallholdersGetUpkeepsResponseItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof PlantationsActivitiesSmallholdersGetUpkeepsResponse
     */
    'pagination': PaginationResponse;
}
/**
 * 
 * @export
 * @interface PlantationsActivitiesSmallholdersGetUpkeepsResponseItem
 */
export interface PlantationsActivitiesSmallholdersGetUpkeepsResponseItem {
    /**
     * Unique identifier of the upkeep
     * @type {string}
     * @memberof PlantationsActivitiesSmallholdersGetUpkeepsResponseItem
     */
    'id': string;
    /**
     * Name of the farm
     * @type {string}
     * @memberof PlantationsActivitiesSmallholdersGetUpkeepsResponseItem
     */
    'farmName': string;
    /**
     * Date of the upkeep
     * @type {number}
     * @memberof PlantationsActivitiesSmallholdersGetUpkeepsResponseItem
     */
    'date': number;
    /**
     * activity of the upkeep
     * @type {string}
     * @memberof PlantationsActivitiesSmallholdersGetUpkeepsResponseItem
     */
    'activity': string;
    /**
     * total cost of the upkeep
     * @type {number}
     * @memberof PlantationsActivitiesSmallholdersGetUpkeepsResponseItem
     */
    'amount': number;
}
/**
 * 
 * @export
 * @interface PlantationsActivitiesSmallholdersUpkeepsGetActivitiesResponse
 */
export interface PlantationsActivitiesSmallholdersUpkeepsGetActivitiesResponse {
    /**
     * 
     * @type {Array<PlantationsActivitiesSmallholdersUpkeepsGetActivitiesResponseItem>}
     * @memberof PlantationsActivitiesSmallholdersUpkeepsGetActivitiesResponse
     */
    'items': Array<PlantationsActivitiesSmallholdersUpkeepsGetActivitiesResponseItem>;
}
/**
 * 
 * @export
 * @interface PlantationsActivitiesSmallholdersUpkeepsGetActivitiesResponseItem
 */
export interface PlantationsActivitiesSmallholdersUpkeepsGetActivitiesResponseItem {
    /**
     * Id of the upkeep activity
     * @type {string}
     * @memberof PlantationsActivitiesSmallholdersUpkeepsGetActivitiesResponseItem
     */
    'id': string;
    /**
     * group of the upkeep activity
     * @type {string}
     * @memberof PlantationsActivitiesSmallholdersUpkeepsGetActivitiesResponseItem
     */
    'group': string;
    /**
     * label of the upkeep activity
     * @type {string}
     * @memberof PlantationsActivitiesSmallholdersUpkeepsGetActivitiesResponseItem
     */
    'label': string;
    /**
     * uom of the upkeep activity
     * @type {string}
     * @memberof PlantationsActivitiesSmallholdersUpkeepsGetActivitiesResponseItem
     */
    'uom': string;
}
/**
 * 
 * @export
 * @interface PlantationsActivitiesSmallholdersUpkeepsMaterialsGetFertilizersResponse
 */
export interface PlantationsActivitiesSmallholdersUpkeepsMaterialsGetFertilizersResponse {
    /**
     * 
     * @type {Array<PlantationsActivitiesSmallholdersUpkeepsMaterialsGetFertilizersResponseItem>}
     * @memberof PlantationsActivitiesSmallholdersUpkeepsMaterialsGetFertilizersResponse
     */
    'items': Array<PlantationsActivitiesSmallholdersUpkeepsMaterialsGetFertilizersResponseItem>;
}
/**
 * 
 * @export
 * @interface PlantationsActivitiesSmallholdersUpkeepsMaterialsGetFertilizersResponseItem
 */
export interface PlantationsActivitiesSmallholdersUpkeepsMaterialsGetFertilizersResponseItem {
    /**
     * Id of the plantation activity smallhoder upkeep material fertilizer
     * @type {string}
     * @memberof PlantationsActivitiesSmallholdersUpkeepsMaterialsGetFertilizersResponseItem
     */
    'id': string;
    /**
     * name of the plantation activity smallhoder upkeep material fertilizer
     * @type {string}
     * @memberof PlantationsActivitiesSmallholdersUpkeepsMaterialsGetFertilizersResponseItem
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface PlantationsCreateActivitiesItemsHarvestRequest
 */
export interface PlantationsCreateActivitiesItemsHarvestRequest {
    /**
     * Quantity of FFB in Janjang
     * @type {number}
     * @memberof PlantationsCreateActivitiesItemsHarvestRequest
     */
    'ffbQuantity': number;
    /**
     * 
     * @type {string}
     * @memberof PlantationsCreateActivitiesItemsHarvestRequest
     */
    'activityScheduleId'?: string;
    /**
     * Estimated average FFB (BJR/Komidel) weight in kg
     * @type {number}
     * @memberof PlantationsCreateActivitiesItemsHarvestRequest
     */
    'estimatedWeightAverageBunchKg': number;
    /**
     * 
     * @type {string}
     * @memberof PlantationsCreateActivitiesItemsHarvestRequest
     */
    'ffbCollectionPoint'?: string;
    /**
     * Date when user take a photo
     * @type {number}
     * @memberof PlantationsCreateActivitiesItemsHarvestRequest
     */
    'harvestingDate': number;
    /**
     * 
     * @type {number}
     * @memberof PlantationsCreateActivitiesItemsHarvestRequest
     */
    'latitude': number;
    /**
     * 
     * @type {number}
     * @memberof PlantationsCreateActivitiesItemsHarvestRequest
     */
    'longitude': number;
}
/**
 * 
 * @export
 * @interface PlantationsCreateActivitiesItemsRequest
 */
export interface PlantationsCreateActivitiesItemsRequest {
    /**
     * 
     * @type {PlantationsCreateActivitiesItemsHarvestRequest}
     * @memberof PlantationsCreateActivitiesItemsRequest
     */
    'harvest'?: PlantationsCreateActivitiesItemsHarvestRequest;
}
/**
 * 
 * @export
 * @interface PlantationsCreateActivitiesRequest
 */
export interface PlantationsCreateActivitiesRequest {
    /**
     * 
     * @type {TypePlantationsActivitiesEnum}
     * @memberof PlantationsCreateActivitiesRequest
     */
    'type': TypePlantationsActivitiesEnum;
    /**
     * 
     * @type {PlantationsCreateActivitiesItemsRequest}
     * @memberof PlantationsCreateActivitiesRequest
     */
    'items': PlantationsCreateActivitiesItemsRequest;
    /**
     * Photo of harvest fruit
     * @type {File}
     * @memberof PlantationsCreateActivitiesRequest
     */
    'photo'?: File;
}


/**
 * 
 * @export
 * @interface PlantationsCreateActivitiesResponse
 */
export interface PlantationsCreateActivitiesResponse {
    /**
     * 
     * @type {boolean}
     * @memberof PlantationsCreateActivitiesResponse
     */
    'success': boolean;
    /**
     * 
     * @type {number}
     * @memberof PlantationsCreateActivitiesResponse
     */
    'sawitpoin': number;
}
/**
 * 
 * @export
 * @interface PlantationsCreateFFBSellPriceRequest
 */
export interface PlantationsCreateFFBSellPriceRequest {
    /**
     * 
     * @type {PlantationsCreateFFBSellPriceRequestData}
     * @memberof PlantationsCreateFFBSellPriceRequest
     */
    'data': PlantationsCreateFFBSellPriceRequestData;
    /**
     * Photo of sales proof could be invoice, weightbridge card etc
     * @type {File}
     * @memberof PlantationsCreateFFBSellPriceRequest
     */
    'photo': File;
}
/**
 * 
 * @export
 * @interface PlantationsCreateFFBSellPriceRequestData
 */
export interface PlantationsCreateFFBSellPriceRequestData {
    /**
     * Farm Id related to the FFB Sell Data
     * @type {string}
     * @memberof PlantationsCreateFFBSellPriceRequestData
     */
    'farmId': string;
    /**
     * time of harvest in UTC0 format
     * @type {number}
     * @memberof PlantationsCreateFFBSellPriceRequestData
     */
    'harvestDateUtc0': number;
    /**
     * total weight of FFB sold in Kg
     * @type {number}
     * @memberof PlantationsCreateFFBSellPriceRequestData
     */
    'ffbTotalWeightInKg': number;
    /**
     * the price of FFB sold per Kg
     * @type {number}
     * @memberof PlantationsCreateFFBSellPriceRequestData
     */
    'ffbPricePerKg': number;
    /**
     * 
     * @type {PlantationsCreateFFBSellPriceRequestDataBuyer}
     * @memberof PlantationsCreateFFBSellPriceRequestData
     */
    'buyer': PlantationsCreateFFBSellPriceRequestDataBuyer;
    /**
     * 
     * @type {PlantationsCreateFFBSellPriceRequestDataTransport}
     * @memberof PlantationsCreateFFBSellPriceRequestData
     */
    'transport': PlantationsCreateFFBSellPriceRequestDataTransport;
    /**
     * delivery order name
     * @type {string}
     * @memberof PlantationsCreateFFBSellPriceRequestData
     */
    'doName'?: string;
    /**
     * 
     * @type {PlantationsCreateFFBSellPriceRequestDataCost}
     * @memberof PlantationsCreateFFBSellPriceRequestData
     */
    'cost': PlantationsCreateFFBSellPriceRequestDataCost;
    /**
     * used by DUTA app, id of the user that this request is for
     * @type {string}
     * @memberof PlantationsCreateFFBSellPriceRequestData
     */
    'userId'?: string;
}
/**
 * 
 * @export
 * @interface PlantationsCreateFFBSellPriceRequestDataBuyer
 */
export interface PlantationsCreateFFBSellPriceRequestDataBuyer {
    /**
     * 
     * @type {FFBBuyerTypeEnum}
     * @memberof PlantationsCreateFFBSellPriceRequestDataBuyer
     */
    'type': FFBBuyerTypeEnum;
    /**
     * FFB Buyer name
     * @type {string}
     * @memberof PlantationsCreateFFBSellPriceRequestDataBuyer
     */
    'name': string;
    /**
     * Phone number starting with 0 as prefix (08xxxxxxxxx)
     * @type {string}
     * @memberof PlantationsCreateFFBSellPriceRequestDataBuyer
     */
    'phoneNo'?: string;
    /**
     * Buyer Partner Id, for type=MILLS if already registered in SawitPro DB
     * @type {string}
     * @memberof PlantationsCreateFFBSellPriceRequestDataBuyer
     */
    'partnerId'?: string;
}


/**
 * 
 * @export
 * @interface PlantationsCreateFFBSellPriceRequestDataCost
 */
export interface PlantationsCreateFFBSellPriceRequestDataCost {
    /**
     * cost expended by seller for harvesting FFB
     * @type {number}
     * @memberof PlantationsCreateFFBSellPriceRequestDataCost
     */
    'harvestCostPerKg': number;
    /**
     * cost expended by seller for loading FFB (\"Biaya Langsir\")
     * @type {number}
     * @memberof PlantationsCreateFFBSellPriceRequestDataCost
     */
    'loadingCostPerKg': number;
    /**
     * other cost expended by seller when selling the FFB
     * @type {number}
     * @memberof PlantationsCreateFFBSellPriceRequestDataCost
     */
    'otherCost': number;
    /**
     * description of other cost expended by seller when selling the FFB
     * @type {string}
     * @memberof PlantationsCreateFFBSellPriceRequestDataCost
     */
    'otherCostDescription': string;
}
/**
 * 
 * @export
 * @interface PlantationsCreateFFBSellPriceRequestDataTransport
 */
export interface PlantationsCreateFFBSellPriceRequestDataTransport {
    /**
     * plate number of transport vehicle used
     * @type {string}
     * @memberof PlantationsCreateFFBSellPriceRequestDataTransport
     */
    'plateNumber'?: string;
}
/**
 * 
 * @export
 * @interface PlantationsCreateFFBSellPriceResponse
 */
export interface PlantationsCreateFFBSellPriceResponse {
    /**
     * the ID of created FFB Sell Price data
     * @type {string}
     * @memberof PlantationsCreateFFBSellPriceResponse
     */
    'id': string;
    /**
     * Sawitpoin reward for submitting FFB sell price data, if <= 0 user is not eligible for Sawitpoin reward
     * @type {number}
     * @memberof PlantationsCreateFFBSellPriceResponse
     */
    'sawitpoin': number;
}
/**
 * 
 * @export
 * @interface PlantationsDeleteFFBSellPriceResponse
 */
export interface PlantationsDeleteFFBSellPriceResponse {
    /**
     * id of the soft-deleted ffb_sell_price data
     * @type {string}
     * @memberof PlantationsDeleteFFBSellPriceResponse
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface PlantationsDeliveriesGapoktanCreateActivitiesRequest
 */
export interface PlantationsDeliveriesGapoktanCreateActivitiesRequest {
    /**
     * 
     * @type {string}
     * @memberof PlantationsDeliveriesGapoktanCreateActivitiesRequest
     */
    'ticketNumber': string;
    /**
     * Total FFB returned
     * @type {number}
     * @memberof PlantationsDeliveriesGapoktanCreateActivitiesRequest
     */
    'weightTruckAndFFBReturnedKg': number;
    /**
     * Total FFB returned
     * @type {number}
     * @memberof PlantationsDeliveriesGapoktanCreateActivitiesRequest
     */
    'totalFFBReturned': number;
    /**
     * Reason of FFB returned
     * @type {Array<string>}
     * @memberof PlantationsDeliveriesGapoktanCreateActivitiesRequest
     */
    'returnedReason': Array<string>;
    /**
     * Number plate of truck that will only allowed with regex pattern
     * @type {string}
     * @memberof PlantationsDeliveriesGapoktanCreateActivitiesRequest
     */
    'truckPlateNumber': string;
    /**
     * URL of weighbridge slip photo
     * @type {string}
     * @memberof PlantationsDeliveriesGapoktanCreateActivitiesRequest
     */
    'weighbridgePhotoUrl': string;
    /**
     * Longitude where the request was submitted
     * @type {number}
     * @memberof PlantationsDeliveriesGapoktanCreateActivitiesRequest
     */
    'longitude': number;
    /**
     * Latitude where the schedule was submitted
     * @type {number}
     * @memberof PlantationsDeliveriesGapoktanCreateActivitiesRequest
     */
    'latitude': number;
    /**
     * 
     * @type {WorkerCreateActivitiesFeebackRequest}
     * @memberof PlantationsDeliveriesGapoktanCreateActivitiesRequest
     */
    'feedbacks': WorkerCreateActivitiesFeebackRequest;
    /**
     * id of mills
     * @type {string}
     * @memberof PlantationsDeliveriesGapoktanCreateActivitiesRequest
     */
    'partnerId': string;
}
/**
 * 
 * @export
 * @interface PlantationsDeliveriesGapoktanCreateActivitiesResponse
 */
export interface PlantationsDeliveriesGapoktanCreateActivitiesResponse {
    /**
     * 
     * @type {number}
     * @memberof PlantationsDeliveriesGapoktanCreateActivitiesResponse
     */
    'point'?: number;
}
/**
 * 
 * @export
 * @interface PlantationsFFBSellPricesGetSummariesResponse
 */
export interface PlantationsFFBSellPricesGetSummariesResponse {
    /**
     * user\'s minimum harvest date data recorded in FFB Sell Price, could be used as FE year-month picker lower limit
     * @type {number}
     * @memberof PlantationsFFBSellPricesGetSummariesResponse
     */
    'minHarvestDateUtc0': number;
    /**
     * 
     * @type {PlantationsGetFFBSellPricesResponseItemsIncomeStatement}
     * @memberof PlantationsFFBSellPricesGetSummariesResponse
     */
    'incomeStatement': PlantationsGetFFBSellPricesResponseItemsIncomeStatement;
    /**
     * 
     * @type {PlantationsFFBSellPricesGetSummariesResponsePriceHistory}
     * @memberof PlantationsFFBSellPricesGetSummariesResponse
     */
    'priceHistory': PlantationsFFBSellPricesGetSummariesResponsePriceHistory;
    /**
     * 
     * @type {PlantationsFFBSellPricesGetSummariesResponseHarvestHistory}
     * @memberof PlantationsFFBSellPricesGetSummariesResponse
     */
    'harvestHistory': PlantationsFFBSellPricesGetSummariesResponseHarvestHistory;
}
/**
 * 
 * @export
 * @interface PlantationsFFBSellPricesGetSummariesResponseHarvestHistory
 */
export interface PlantationsFFBSellPricesGetSummariesResponseHarvestHistory {
    /**
     * 
     * @type {PlantationsFFBSellPricesGetSummariesResponseHarvestHistoryBar}
     * @memberof PlantationsFFBSellPricesGetSummariesResponseHarvestHistory
     */
    'bar': PlantationsFFBSellPricesGetSummariesResponseHarvestHistoryBar;
}
/**
 * 
 * @export
 * @interface PlantationsFFBSellPricesGetSummariesResponseHarvestHistoryBar
 */
export interface PlantationsFFBSellPricesGetSummariesResponseHarvestHistoryBar {
    /**
     * 
     * @type {Array<PlantationsFFBSellPricesGetSummariesResponseHarvestHistoryBarItems>}
     * @memberof PlantationsFFBSellPricesGetSummariesResponseHarvestHistoryBar
     */
    'items': Array<PlantationsFFBSellPricesGetSummariesResponseHarvestHistoryBarItems>;
}
/**
 * 
 * @export
 * @interface PlantationsFFBSellPricesGetSummariesResponseHarvestHistoryBarItems
 */
export interface PlantationsFFBSellPricesGetSummariesResponseHarvestHistoryBarItems {
    /**
     * The time of harvest for this FFB Sell Price summary data in UTC0 format
     * @type {number}
     * @memberof PlantationsFFBSellPricesGetSummariesResponseHarvestHistoryBarItems
     */
    'harvestDateUtc0': number;
    /**
     * The time of harvest for this FFB Sell Price summary data in \'D Mon\' or \'Mon\' format
     * @type {string}
     * @memberof PlantationsFFBSellPricesGetSummariesResponseHarvestHistoryBarItems
     */
    'harvestDateLabel': string;
    /**
     * the sum of sold harvested FFB weight in this harvest date
     * @type {number}
     * @memberof PlantationsFFBSellPricesGetSummariesResponseHarvestHistoryBarItems
     */
    'value': number;
    /**
     * harvested FFB weight unit
     * @type {string}
     * @memberof PlantationsFFBSellPricesGetSummariesResponseHarvestHistoryBarItems
     */
    'valueUnit': string;
}
/**
 * 
 * @export
 * @interface PlantationsFFBSellPricesGetSummariesResponsePriceHistory
 */
export interface PlantationsFFBSellPricesGetSummariesResponsePriceHistory {
    /**
     * 
     * @type {PlantationsFFBSellPricesGetSummariesResponsePriceHistoryBar}
     * @memberof PlantationsFFBSellPricesGetSummariesResponsePriceHistory
     */
    'bar': PlantationsFFBSellPricesGetSummariesResponsePriceHistoryBar;
}
/**
 * 
 * @export
 * @interface PlantationsFFBSellPricesGetSummariesResponsePriceHistoryBar
 */
export interface PlantationsFFBSellPricesGetSummariesResponsePriceHistoryBar {
    /**
     * 
     * @type {Array<PlantationsFFBSellPricesGetSummariesResponsePriceHistoryBarItems>}
     * @memberof PlantationsFFBSellPricesGetSummariesResponsePriceHistoryBar
     */
    'items': Array<PlantationsFFBSellPricesGetSummariesResponsePriceHistoryBarItems>;
}
/**
 * 
 * @export
 * @interface PlantationsFFBSellPricesGetSummariesResponsePriceHistoryBarItems
 */
export interface PlantationsFFBSellPricesGetSummariesResponsePriceHistoryBarItems {
    /**
     * The time of harvest for this FFB Sell Price summary data in UTC0 format
     * @type {number}
     * @memberof PlantationsFFBSellPricesGetSummariesResponsePriceHistoryBarItems
     */
    'harvestDateUtc0': number;
    /**
     * The time of harvest for this FFB Sell Price summary data in \'D Mon\' or \'Mon\' format
     * @type {string}
     * @memberof PlantationsFFBSellPricesGetSummariesResponsePriceHistoryBarItems
     */
    'harvestDateLabel': string;
    /**
     * the average FFB Sell Price data in this harvest date
     * @type {number}
     * @memberof PlantationsFFBSellPricesGetSummariesResponsePriceHistoryBarItems
     */
    'value': number;
    /**
     * FFB Sell Price unit
     * @type {string}
     * @memberof PlantationsFFBSellPricesGetSummariesResponsePriceHistoryBarItems
     */
    'valueUnit': string;
}
/**
 * 
 * @export
 * @interface PlantationsFFBSellPricesSummariesGetIncomeStatementResponse
 */
export interface PlantationsFFBSellPricesSummariesGetIncomeStatementResponse {
    /**
     * true if user already have \'asset\' with type FARM, even if user doesn\'t have any \'farm\' data (farm count 0), <br> if user doesn\'t have any `asset` with type FARM in DB, this field will be false.
     * @type {boolean}
     * @memberof PlantationsFFBSellPricesSummariesGetIncomeStatementResponse
     */
    'haveAssetFarm': boolean;
    /**
     * return data year filter, if 0 means returned data is ALL user\'s aggregated data, not filtered by year & month
     * @type {number}
     * @memberof PlantationsFFBSellPricesSummariesGetIncomeStatementResponse
     */
    'year': number;
    /**
     * return data month filter, if 0 means returned data is ALL user\'s aggregated data, not filtered by month in the specified year
     * @type {number}
     * @memberof PlantationsFFBSellPricesSummariesGetIncomeStatementResponse
     */
    'month': number;
    /**
     * 
     * @type {PlantationsGetFFBSellPricesResponseItemsIncomeStatement}
     * @memberof PlantationsFFBSellPricesSummariesGetIncomeStatementResponse
     */
    'incomeStatement': PlantationsGetFFBSellPricesResponseItemsIncomeStatement;
}
/**
 * 
 * @export
 * @interface PlantationsFfbSaleCostRequest
 */
export interface PlantationsFfbSaleCostRequest {
    /**
     * Id of supply cost id
     * @type {string}
     * @memberof PlantationsFfbSaleCostRequest
     */
    'id': string;
    /**
     * Supply cost
     * @type {number}
     * @memberof PlantationsFfbSaleCostRequest
     */
    'cost': number;
}
/**
 * 
 * @export
 * @interface PlantationsFfbSaleCreateRequest
 */
export interface PlantationsFfbSaleCreateRequest {
    /**
     * ID of the Weighbridge that the FFB is supplied, if provided means this will be an update request
     * @type {string}
     * @memberof PlantationsFfbSaleCreateRequest
     */
    'weighbridgeId'?: string;
    /**
     * ID of the Supplier that supply the FFB
     * @type {string}
     * @memberof PlantationsFfbSaleCreateRequest
     */
    'supplierId': string;
    /**
     * ID of the Mill where the FFB is supplied
     * @type {string}
     * @memberof PlantationsFfbSaleCreateRequest
     */
    'millId': string;
    /**
     * Weighbridge Ticket Number of the FFB supply
     * @type {string}
     * @memberof PlantationsFfbSaleCreateRequest
     */
    'weighbridgeNo': string;
    /**
     * Timestamp of the Weighbridge Ticket entry time in UNIX timestamp (epoch ms)
     * @type {number}
     * @memberof PlantationsFfbSaleCreateRequest
     */
    'saleTime': number;
    /**
     * Net Weight of the FFB supply (tonnage)
     * @type {number}
     * @memberof PlantationsFfbSaleCreateRequest
     */
    'netWeight': number;
    /**
     * Price of the FFB (IDR) per tonnage that the mill paid to the Supplier
     * @type {number}
     * @memberof PlantationsFfbSaleCreateRequest
     */
    'salePrice': number;
    /**
     * Percentage of the FFB sortation
     * @type {number}
     * @memberof PlantationsFfbSaleCreateRequest
     */
    'sortationPct': number;
    /**
     * Weight of the FFB sortation (tonnage)
     * @type {number}
     * @memberof PlantationsFfbSaleCreateRequest
     */
    'sortationWeight': number;
    /**
     * ID of the driver that delivers the FFB into the mill. It can be nil when user update weighbridge from mill integration
     * @type {string}
     * @memberof PlantationsFfbSaleCreateRequest
     */
    'driverId'?: string;
    /**
     * Name of the driver that delivers the FFB into the mill.
     * @type {string}
     * @memberof PlantationsFfbSaleCreateRequest
     */
    'driverName': string;
    /**
     * Plat number of the truck that supplies the FFB
     * @type {string}
     * @memberof PlantationsFfbSaleCreateRequest
     */
    'truckNo': string;
    /**
     * 
     * @type {Array<PlantationsFfbSaleSourceCreateRequest>}
     * @memberof PlantationsFfbSaleCreateRequest
     */
    'ffbSources': Array<PlantationsFfbSaleSourceCreateRequest>;
    /**
     * 
     * @type {Array<PlantationsFfbSaleCostRequest>}
     * @memberof PlantationsFfbSaleCreateRequest
     */
    'cost'?: Array<PlantationsFfbSaleCostRequest>;
}
/**
 * 
 * @export
 * @interface PlantationsFfbSaleSourceCreateRequest
 */
export interface PlantationsFfbSaleSourceCreateRequest {
    /**
     * ID of the Block where the FFB is supplied
     * @type {string}
     * @memberof PlantationsFfbSaleSourceCreateRequest
     */
    'blockId': string;
    /**
     * 
     * @type {FfbSourceTypeEnum}
     * @memberof PlantationsFfbSaleSourceCreateRequest
     */
    'sourceType': FfbSourceTypeEnum;
    /**
     * Gross Weight of the FFB supply (tonnage)
     * @type {number}
     * @memberof PlantationsFfbSaleSourceCreateRequest
     */
    'grossWeight': number;
    /**
     * Price of the FFB (IDR) per tonnage that the Supplier paid to the farmer (subagents)
     * @type {number}
     * @memberof PlantationsFfbSaleSourceCreateRequest
     */
    'buyPrice': number;
}


/**
 * 
 * @export
 * @interface PlantationsGetActivitiesHarvestsItemsResponse
 */
export interface PlantationsGetActivitiesHarvestsItemsResponse {
    /**
     * ID of the Harvesting Activity
     * @type {string}
     * @memberof PlantationsGetActivitiesHarvestsItemsResponse
     */
    'id': string;
    /**
     * harvester supervisor name who organize harvesting activity
     * @type {string}
     * @memberof PlantationsGetActivitiesHarvestsItemsResponse
     */
    'harvesterSupervisorName': string;
    /**
     * ID of the Harvesting Supervisor Id
     * @type {string}
     * @memberof PlantationsGetActivitiesHarvestsItemsResponse
     */
    'harvesterSupervisorId': string;
    /**
     * harvester name who harvest in the activity
     * @type {string}
     * @memberof PlantationsGetActivitiesHarvestsItemsResponse
     */
    'harvesterName': string;
    /**
     * ID of the Harvester Id
     * @type {string}
     * @memberof PlantationsGetActivitiesHarvestsItemsResponse
     */
    'harvesterId': string;
    /**
     * Quantity of FFB in Janjang
     * @type {number}
     * @memberof PlantationsGetActivitiesHarvestsItemsResponse
     */
    'totalFfbQuantity': number;
    /**
     * average FFB weight in kg (Perkiraan BJR/Komidel)
     * @type {number}
     * @memberof PlantationsGetActivitiesHarvestsItemsResponse
     */
    'estimatedWeightAverageBunchKg': number;
    /**
     * Date when user take a photo
     * @type {number}
     * @memberof PlantationsGetActivitiesHarvestsItemsResponse
     */
    'harvestingDate': number;
    /**
     * Photo url of FFB
     * @type {string}
     * @memberof PlantationsGetActivitiesHarvestsItemsResponse
     */
    'photoUrl': string;
    /**
     * block name
     * @type {string}
     * @memberof PlantationsGetActivitiesHarvestsItemsResponse
     */
    'blockName': string;
    /**
     * Stock Location Latitude
     * @type {number}
     * @memberof PlantationsGetActivitiesHarvestsItemsResponse
     */
    'latitude': number;
    /**
     * Stock Location Longitude
     * @type {number}
     * @memberof PlantationsGetActivitiesHarvestsItemsResponse
     */
    'longitude': number;
}
/**
 * 
 * @export
 * @interface PlantationsGetActivitiesHarvestsReportsItemHarvestersResponse
 */
export interface PlantationsGetActivitiesHarvestsReportsItemHarvestersResponse {
    /**
     * harvester name who harvest the ffb
     * @type {string}
     * @memberof PlantationsGetActivitiesHarvestsReportsItemHarvestersResponse
     */
    'harvesterName': string;
    /**
     * Quantity of FFB in Janjang
     * @type {number}
     * @memberof PlantationsGetActivitiesHarvestsReportsItemHarvestersResponse
     */
    'ffbQuantity': number;
}
/**
 * 
 * @export
 * @interface PlantationsGetActivitiesHarvestsReportsItemResponse
 */
export interface PlantationsGetActivitiesHarvestsReportsItemResponse {
    /**
     * harvester supervisor name who organize harvesting activity
     * @type {string}
     * @memberof PlantationsGetActivitiesHarvestsReportsItemResponse
     */
    'harvesterSupervisorName': string;
    /**
     * Quantity of FFB in Janjang
     * @type {number}
     * @memberof PlantationsGetActivitiesHarvestsReportsItemResponse
     */
    'totalFfbQuantity': number;
    /**
     * average FFB weight in kg (Perkiraan BJR/Komidel)
     * @type {number}
     * @memberof PlantationsGetActivitiesHarvestsReportsItemResponse
     */
    'estimatedWeightAverageBunchKg': number;
    /**
     * total harvester
     * @type {number}
     * @memberof PlantationsGetActivitiesHarvestsReportsItemResponse
     */
    'totalHarvester': number;
    /**
     * 
     * @type {Array<PlantationsGetActivitiesHarvestsReportsItemHarvestersResponse>}
     * @memberof PlantationsGetActivitiesHarvestsReportsItemResponse
     */
    'harvesters': Array<PlantationsGetActivitiesHarvestsReportsItemHarvestersResponse>;
}
/**
 * 
 * @export
 * @interface PlantationsGetActivitiesHarvestsReportsResponse
 */
export interface PlantationsGetActivitiesHarvestsReportsResponse {
    /**
     * 
     * @type {PlantationsGetActivitiesHarvestsReportsSummaryResponse}
     * @memberof PlantationsGetActivitiesHarvestsReportsResponse
     */
    'summary': PlantationsGetActivitiesHarvestsReportsSummaryResponse;
    /**
     * 
     * @type {Array<PlantationsGetActivitiesHarvestsReportsItemResponse>}
     * @memberof PlantationsGetActivitiesHarvestsReportsResponse
     */
    'items': Array<PlantationsGetActivitiesHarvestsReportsItemResponse>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof PlantationsGetActivitiesHarvestsReportsResponse
     */
    'pagination': PaginationResponse;
}
/**
 * 
 * @export
 * @interface PlantationsGetActivitiesHarvestsReportsSummaryResponse
 */
export interface PlantationsGetActivitiesHarvestsReportsSummaryResponse {
    /**
     * Quantity of FFB in Janjang
     * @type {number}
     * @memberof PlantationsGetActivitiesHarvestsReportsSummaryResponse
     */
    'totalFfbQuantity': number;
    /**
     * average FFB weight in kg (Perkiraan BJR/Komidel)
     * @type {number}
     * @memberof PlantationsGetActivitiesHarvestsReportsSummaryResponse
     */
    'estimatedWeightAverageBunchKg': number;
    /**
     * total harvester
     * @type {number}
     * @memberof PlantationsGetActivitiesHarvestsReportsSummaryResponse
     */
    'totalHarvester': number;
}
/**
 * 
 * @export
 * @interface PlantationsGetActivitiesItemsResponse
 */
export interface PlantationsGetActivitiesItemsResponse {
    /**
     * Id of plantations activities
     * @type {string}
     * @memberof PlantationsGetActivitiesItemsResponse
     */
    'id': string;
    /**
     * Photo url of FFB
     * @type {string}
     * @memberof PlantationsGetActivitiesItemsResponse
     */
    'photoUrl': string;
    /**
     * Quantity of FFB in Janjang
     * @type {number}
     * @memberof PlantationsGetActivitiesItemsResponse
     */
    'ffbQuantity': number;
    /**
     * average FFB weight in kg (Perkiraan BJR/Komidel)
     * @type {number}
     * @memberof PlantationsGetActivitiesItemsResponse
     */
    'estimatedWeightAverageBunchKg': number;
    /**
     * 
     * @type {string}
     * @memberof PlantationsGetActivitiesItemsResponse
     */
    'ffbCollectionPoint': string;
    /**
     * Date when user take a photo
     * @type {number}
     * @memberof PlantationsGetActivitiesItemsResponse
     */
    'harvestingDate': number;
    /**
     * FFB Count of Sawit Vision
     * @type {number}
     * @memberof PlantationsGetActivitiesItemsResponse
     */
    'sawitVisionFfbCount': number;
    /**
     * the ffb ripeness from sawit vision
     * @type {string}
     * @memberof PlantationsGetActivitiesItemsResponse
     */
    'sawitVisionRipeness': string;
    /**
     * the confidence level of sawit vision result. Show in percentage
     * @type {string}
     * @memberof PlantationsGetActivitiesItemsResponse
     */
    'sawitVisionConfidenceLevel': string;
}
/**
 * 
 * @export
 * @interface PlantationsGetActivitiesResponse
 */
export interface PlantationsGetActivitiesResponse {
    /**
     * 
     * @type {PlantationsGetActivitiesSummaryResponse}
     * @memberof PlantationsGetActivitiesResponse
     */
    'summary': PlantationsGetActivitiesSummaryResponse;
    /**
     * 
     * @type {Array<PlantationsGetActivitiesItemsResponse>}
     * @memberof PlantationsGetActivitiesResponse
     */
    'items': Array<PlantationsGetActivitiesItemsResponse>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof PlantationsGetActivitiesResponse
     */
    'pagination': PaginationResponse;
}
/**
 * 
 * @export
 * @interface PlantationsGetActivitiesSummaryResponse
 */
export interface PlantationsGetActivitiesSummaryResponse {
    /**
     * 
     * @type {number}
     * @memberof PlantationsGetActivitiesSummaryResponse
     */
    'today': number;
    /**
     * 
     * @type {number}
     * @memberof PlantationsGetActivitiesSummaryResponse
     */
    'yesterday': number;
    /**
     * 
     * @type {number}
     * @memberof PlantationsGetActivitiesSummaryResponse
     */
    'currentMonth': number;
    /**
     * 
     * @type {number}
     * @memberof PlantationsGetActivitiesSummaryResponse
     */
    'lastMonth': number;
}
/**
 * 
 * @export
 * @interface PlantationsGetFFBSellPricesResponse
 */
export interface PlantationsGetFFBSellPricesResponse {
    /**
     * 
     * @type {Array<PlantationsGetFFBSellPricesResponseItems>}
     * @memberof PlantationsGetFFBSellPricesResponse
     */
    'items': Array<PlantationsGetFFBSellPricesResponseItems>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof PlantationsGetFFBSellPricesResponse
     */
    'pagination': PaginationResponse;
}
/**
 * 
 * @export
 * @interface PlantationsGetFFBSellPricesResponseItems
 */
export interface PlantationsGetFFBSellPricesResponseItems {
    /**
     * the ID of created FFB Sell Price data
     * @type {string}
     * @memberof PlantationsGetFFBSellPricesResponseItems
     */
    'id': string;
    /**
     * time of harvest related to the FFB Sell Price data in UTC0 format
     * @type {number}
     * @memberof PlantationsGetFFBSellPricesResponseItems
     */
    'harvestDateUtc0': number;
    /**
     * 
     * @type {PlantationsGetFFBSellPricesResponseItemsFarm}
     * @memberof PlantationsGetFFBSellPricesResponseItems
     */
    'farm': PlantationsGetFFBSellPricesResponseItemsFarm;
    /**
     * 
     * @type {PlantationsGetFFBSellPricesResponseItemsIncomeStatementDetail}
     * @memberof PlantationsGetFFBSellPricesResponseItems
     */
    'incomeStatement': PlantationsGetFFBSellPricesResponseItemsIncomeStatementDetail;
}
/**
 * 
 * @export
 * @interface PlantationsGetFFBSellPricesResponseItemsFarm
 */
export interface PlantationsGetFFBSellPricesResponseItemsFarm {
    /**
     * farm Id related to the FFB Sell Price data
     * @type {string}
     * @memberof PlantationsGetFFBSellPricesResponseItemsFarm
     */
    'id': string;
    /**
     * farm name related to the FFB Sell Price data
     * @type {string}
     * @memberof PlantationsGetFFBSellPricesResponseItemsFarm
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface PlantationsGetFFBSellPricesResponseItemsIncomeStatement
 */
export interface PlantationsGetFFBSellPricesResponseItemsIncomeStatement {
    /**
     * currency used in the income statement
     * @type {string}
     * @memberof PlantationsGetFFBSellPricesResponseItemsIncomeStatement
     */
    'currency': string;
    /**
     * net income from this FFB Sell Price Data
     * @type {number}
     * @memberof PlantationsGetFFBSellPricesResponseItemsIncomeStatement
     */
    'net': number;
    /**
     * gross income from this FFB Sell Price Data
     * @type {number}
     * @memberof PlantationsGetFFBSellPricesResponseItemsIncomeStatement
     */
    'gross': number;
    /**
     * total cost expended in this FFB Sell Price Data
     * @type {number}
     * @memberof PlantationsGetFFBSellPricesResponseItemsIncomeStatement
     */
    'cost': number;
}
/**
 * 
 * @export
 * @interface PlantationsGetFFBSellPricesResponseItemsIncomeStatementCost
 */
export interface PlantationsGetFFBSellPricesResponseItemsIncomeStatementCost {
    /**
     * total cost expended in this FFB Sell Price Data
     * @type {number}
     * @memberof PlantationsGetFFBSellPricesResponseItemsIncomeStatementCost
     */
    'total': number;
    /**
     * cost expended by seller for harvesting FFB
     * @type {number}
     * @memberof PlantationsGetFFBSellPricesResponseItemsIncomeStatementCost
     */
    'harvestCostPerKg': number;
    /**
     * cost expended by seller for loading FFB (\"Biaya Langsir\")
     * @type {number}
     * @memberof PlantationsGetFFBSellPricesResponseItemsIncomeStatementCost
     */
    'loadingCostPerKg': number;
    /**
     * other cost expended by seller when selling the FFB
     * @type {number}
     * @memberof PlantationsGetFFBSellPricesResponseItemsIncomeStatementCost
     */
    'otherCost': number;
    /**
     * description of other cost expended by seller when selling the FFB
     * @type {string}
     * @memberof PlantationsGetFFBSellPricesResponseItemsIncomeStatementCost
     */
    'otherCostDescription': string;
}
/**
 * 
 * @export
 * @interface PlantationsGetFFBSellPricesResponseItemsIncomeStatementDetail
 */
export interface PlantationsGetFFBSellPricesResponseItemsIncomeStatementDetail {
    /**
     * currency used in the income statement
     * @type {string}
     * @memberof PlantationsGetFFBSellPricesResponseItemsIncomeStatementDetail
     */
    'currency': string;
    /**
     * net income from this FFB Sell Price Data
     * @type {number}
     * @memberof PlantationsGetFFBSellPricesResponseItemsIncomeStatementDetail
     */
    'net': number;
    /**
     * 
     * @type {PlantationsGetFFBSellPricesResponseItemsIncomeStatementGross}
     * @memberof PlantationsGetFFBSellPricesResponseItemsIncomeStatementDetail
     */
    'gross': PlantationsGetFFBSellPricesResponseItemsIncomeStatementGross;
    /**
     * 
     * @type {PlantationsGetFFBSellPricesResponseItemsIncomeStatementCost}
     * @memberof PlantationsGetFFBSellPricesResponseItemsIncomeStatementDetail
     */
    'cost': PlantationsGetFFBSellPricesResponseItemsIncomeStatementCost;
}
/**
 * 
 * @export
 * @interface PlantationsGetFFBSellPricesResponseItemsIncomeStatementGross
 */
export interface PlantationsGetFFBSellPricesResponseItemsIncomeStatementGross {
    /**
     * total gross income from this FFB Sell Price Data
     * @type {number}
     * @memberof PlantationsGetFFBSellPricesResponseItemsIncomeStatementGross
     */
    'total': number;
    /**
     * total weight of FFB sold in Kg
     * @type {number}
     * @memberof PlantationsGetFFBSellPricesResponseItemsIncomeStatementGross
     */
    'ffbTotalWeightInKg': number;
    /**
     * the price of FFB sold per Kg
     * @type {number}
     * @memberof PlantationsGetFFBSellPricesResponseItemsIncomeStatementGross
     */
    'ffbPricePerKg': number;
}
/**
 * 
 * @export
 * @interface PlantationsGetFfbSaleCostResponse
 */
export interface PlantationsGetFfbSaleCostResponse {
    /**
     * Id of supply cost id
     * @type {string}
     * @memberof PlantationsGetFfbSaleCostResponse
     */
    'id': string;
    /**
     * Name of supply cost
     * @type {string}
     * @memberof PlantationsGetFfbSaleCostResponse
     */
    'name': string;
    /**
     * 
     * @type {WeighbridgeCostTypeEnum}
     * @memberof PlantationsGetFfbSaleCostResponse
     */
    'type': WeighbridgeCostTypeEnum;
    /**
     * Supply cost
     * @type {number}
     * @memberof PlantationsGetFfbSaleCostResponse
     */
    'cost': number;
}


/**
 * 
 * @export
 * @interface PlantationsGetFfbSaleResponse
 */
export interface PlantationsGetFfbSaleResponse {
    /**
     * ID of the Weighbridge Ticket of this FFB supply
     * @type {string}
     * @memberof PlantationsGetFfbSaleResponse
     */
    'weighbridgeId': string;
    /**
     * ID of the Supplier who supplied the FFB
     * @type {string}
     * @memberof PlantationsGetFfbSaleResponse
     */
    'supplierId': string;
    /**
     * ID of the mill where the FFB is supplied
     * @type {string}
     * @memberof PlantationsGetFfbSaleResponse
     */
    'millId': string;
    /**
     * Timestamp of the Weighbridge Ticket entry time in UNIX timestamp (epoch ms)
     * @type {number}
     * @memberof PlantationsGetFfbSaleResponse
     */
    'supplyTime': number;
    /**
     * Net weight of the FFB supply (in kg)
     * @type {number}
     * @memberof PlantationsGetFfbSaleResponse
     */
    'netWeight': number;
    /**
     * Price of the FFB (IDR) per tonnage that the mill paid to the Supplier
     * @type {number}
     * @memberof PlantationsGetFfbSaleResponse
     */
    'sellPrice'?: number;
    /**
     * Percentage of the FFB sortation
     * @type {number}
     * @memberof PlantationsGetFfbSaleResponse
     */
    'sortationPct': number;
    /**
     * Weight of the FFB sortation (in kg)
     * @type {number}
     * @memberof PlantationsGetFfbSaleResponse
     */
    'sortationWeight': number;
    /**
     * Plat number of the truck that carried the FFB
     * @type {string}
     * @memberof PlantationsGetFfbSaleResponse
     */
    'truckNo': string;
    /**
     * ID of the driver who drove the truck that carried the FFB. It can be nil when user update weighbridge from mill integration
     * @type {string}
     * @memberof PlantationsGetFfbSaleResponse
     */
    'driverId'?: string;
    /**
     * Name of the driver who drove the truck that carried the FFB.
     * @type {string}
     * @memberof PlantationsGetFfbSaleResponse
     */
    'driverName': string;
    /**
     * Weighbridge ticket number
     * @type {string}
     * @memberof PlantationsGetFfbSaleResponse
     */
    'weighbridgeNo': string;
    /**
     * 
     * @type {Array<PlantationsGetFfbSaleSourceResponse>}
     * @memberof PlantationsGetFfbSaleResponse
     */
    'ffbSources': Array<PlantationsGetFfbSaleSourceResponse>;
    /**
     * 
     * @type {Array<PlantationsGetFfbSaleCostResponse>}
     * @memberof PlantationsGetFfbSaleResponse
     */
    'cost': Array<PlantationsGetFfbSaleCostResponse>;
    /**
     * The creator of this data (can be UUID of an user or `MILL INTEGRATION`)
     * @type {string}
     * @memberof PlantationsGetFfbSaleResponse
     */
    'createdBy': string;
}
/**
 * 
 * @export
 * @interface PlantationsGetFfbSaleSourceResponse
 */
export interface PlantationsGetFfbSaleSourceResponse {
    /**
     * ID of the Block where the FFB is supplied
     * @type {string}
     * @memberof PlantationsGetFfbSaleSourceResponse
     */
    'blockId': string;
    /**
     * 
     * @type {FfbSourceTypeEnum}
     * @memberof PlantationsGetFfbSaleSourceResponse
     */
    'sourceType': FfbSourceTypeEnum;
    /**
     * Gross Weight of the FFB supply (tonnage)
     * @type {number}
     * @memberof PlantationsGetFfbSaleSourceResponse
     */
    'grossWeight': number;
    /**
     * Price of the FFB (IDR) per tonnage that the Supplier paid to the farmer (subagents)
     * @type {number}
     * @memberof PlantationsGetFfbSaleSourceResponse
     */
    'buyPrice': number;
}


/**
 * 
 * @export
 * @interface PlantationsGetFfbSalesSummaryResponse
 */
export interface PlantationsGetFfbSalesSummaryResponse {
    /**
     * The number of deliveries from the current Supplier
     * @type {number}
     * @memberof PlantationsGetFfbSalesSummaryResponse
     */
    'totalDelivery': number;
    /**
     * The total net weight of FFB from the current Supplier
     * @type {number}
     * @memberof PlantationsGetFfbSalesSummaryResponse
     */
    'totalNetWeight': number;
    /**
     * The total revenue the current Supplier got from supplying FFB to mill
     * @type {number}
     * @memberof PlantationsGetFfbSalesSummaryResponse
     */
    'totalRevenue': number;
    /**
     * The total cost of operating the FFB Supply activities
     * @type {number}
     * @memberof PlantationsGetFfbSalesSummaryResponse
     */
    'totalCost': number;
    /**
     * The total net income of the current Supplier.
     * @type {number}
     * @memberof PlantationsGetFfbSalesSummaryResponse
     */
    'totalNetIncome': number;
}
/**
 * 
 * @export
 * @interface PlantationsGetSchedulesBlockItemResponse
 */
export interface PlantationsGetSchedulesBlockItemResponse {
    /**
     * Id of plantations block
     * @type {string}
     * @memberof PlantationsGetSchedulesBlockItemResponse
     */
    'id': string;
    /**
     * name of the block
     * @type {string}
     * @memberof PlantationsGetSchedulesBlockItemResponse
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface PlantationsGetSchedulesResponse
 */
export interface PlantationsGetSchedulesResponse {
    /**
     * 
     * @type {Array<PlantationsGetSchedulesResponseItem>}
     * @memberof PlantationsGetSchedulesResponse
     */
    'items': Array<PlantationsGetSchedulesResponseItem>;
}
/**
 * 
 * @export
 * @interface PlantationsGetSchedulesResponseItem
 */
export interface PlantationsGetSchedulesResponseItem {
    /**
     * id of a schedule represented in UUID type 4
     * @type {string}
     * @memberof PlantationsGetSchedulesResponseItem
     */
    'id': string;
    /**
     * type of schedule to distinct the activity it belongs to
     * @type {string}
     * @memberof PlantationsGetSchedulesResponseItem
     */
    'type': string;
    /**
     * user id of worker which has HARVEST SUPERVISOR role represented in UUID type 4
     * @type {string}
     * @memberof PlantationsGetSchedulesResponseItem
     */
    'supervisorId': string;
    /**
     * Name of the supervisor for this plantation schedule
     * @type {string}
     * @memberof PlantationsGetSchedulesResponseItem
     */
    'supervisorName': string;
    /**
     * Phone number starting with 0 as prefix (08xxxxxxxxx)
     * @type {string}
     * @memberof PlantationsGetSchedulesResponseItem
     */
    'supervisorPhoneNumber': string;
    /**
     * id of a farm this plantation schedule belongs to to represented in UUID type 4
     * @type {string}
     * @memberof PlantationsGetSchedulesResponseItem
     */
    'farmId': string;
    /**
     * Name of the farm this plantation schedule belongs to
     * @type {string}
     * @memberof PlantationsGetSchedulesResponseItem
     */
    'farmName': string;
    /**
     * id of a user this plantation schedule farm belongs to to represented in UUID type 4
     * @type {string}
     * @memberof PlantationsGetSchedulesResponseItem
     */
    'farmOwnerId': string;
    /**
     * Name of the user this plantation schedule farm belongs to
     * @type {string}
     * @memberof PlantationsGetSchedulesResponseItem
     */
    'farmOwnerName': string;
    /**
     * Phone number starting with 0 as prefix (08xxxxxxxxx)
     * @type {string}
     * @memberof PlantationsGetSchedulesResponseItem
     */
    'farmOwnerPhoneNumber': string;
    /**
     * Latitude where the schedule was made
     * @type {number}
     * @memberof PlantationsGetSchedulesResponseItem
     */
    'createdLatitude': number;
    /**
     * Longitude where the schedule was made
     * @type {number}
     * @memberof PlantationsGetSchedulesResponseItem
     */
    'createdLongitude': number;
    /**
     * schedule date in unix timestamp
     * @type {number}
     * @memberof PlantationsGetSchedulesResponseItem
     */
    'scheduleDateUtc0': number;
    /**
     * TPH (Tempat Pengumpulan Hasil) FFB
     * @type {string}
     * @memberof PlantationsGetSchedulesResponseItem
     */
    'collectionPoint': string;
    /**
     * 
     * @type {PlantationScheduleStatusEnum}
     * @memberof PlantationsGetSchedulesResponseItem
     */
    'status': PlantationScheduleStatusEnum;
}


/**
 * 
 * @export
 * @interface PlantationsGetSeedsResponse
 */
export interface PlantationsGetSeedsResponse {
    /**
     * 
     * @type {Array<PlantationsGetSeedsResponseItem>}
     * @memberof PlantationsGetSeedsResponse
     */
    'items': Array<PlantationsGetSeedsResponseItem>;
}
/**
 * 
 * @export
 * @interface PlantationsGetSeedsResponseItem
 */
export interface PlantationsGetSeedsResponseItem {
    /**
     * Id of plantations seed
     * @type {string}
     * @memberof PlantationsGetSeedsResponseItem
     */
    'id': string;
    /**
     * name of the seed
     * @type {string}
     * @memberof PlantationsGetSeedsResponseItem
     */
    'name': string;
    /**
     * description of the seed
     * @type {string}
     * @memberof PlantationsGetSeedsResponseItem
     */
    'description': string;
    /**
     * sequence of the seed
     * @type {number}
     * @memberof PlantationsGetSeedsResponseItem
     */
    'sequence': number;
}
/**
 * 
 * @export
 * @interface PlantationsGetSoilTypesResponse
 */
export interface PlantationsGetSoilTypesResponse {
    /**
     * List of soil type
     * @type {Array<PlantationsGetSoilTypesResponseItem>}
     * @memberof PlantationsGetSoilTypesResponse
     */
    'items': Array<PlantationsGetSoilTypesResponseItem>;
}
/**
 * 
 * @export
 * @interface PlantationsGetSoilTypesResponseItem
 */
export interface PlantationsGetSoilTypesResponseItem {
    /**
     * Id of soil type representated as UUID V4
     * @type {string}
     * @memberof PlantationsGetSoilTypesResponseItem
     */
    'id': string;
    /**
     * Name of soil type
     * @type {string}
     * @memberof PlantationsGetSoilTypesResponseItem
     */
    'name': string;
    /**
     * Description of soil type
     * @type {string}
     * @memberof PlantationsGetSoilTypesResponseItem
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface PlantationsListFfbSalesResponse
 */
export interface PlantationsListFfbSalesResponse {
    /**
     * 
     * @type {Array<PlantationsListFfbSalesResponseItem>}
     * @memberof PlantationsListFfbSalesResponse
     */
    'items': Array<PlantationsListFfbSalesResponseItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof PlantationsListFfbSalesResponse
     */
    'pagination': PaginationResponse;
}
/**
 * 
 * @export
 * @interface PlantationsListFfbSalesResponseItem
 */
export interface PlantationsListFfbSalesResponseItem {
    /**
     * ID of the Weighbridge Ticket of this FFB supply
     * @type {string}
     * @memberof PlantationsListFfbSalesResponseItem
     */
    'weighbridgeId': string;
    /**
     * Timestamp of the Weighbridge Ticket entry time in UNIX timestamp (epoch ms)
     * @type {number}
     * @memberof PlantationsListFfbSalesResponseItem
     */
    'supplyDatetime': number;
    /**
     * Weighbridge Ticket Number of the FFB supply
     * @type {string}
     * @memberof PlantationsListFfbSalesResponseItem
     */
    'weighbridgeNo': string;
    /**
     * Name of the mill where the FFB is supplied
     * @type {string}
     * @memberof PlantationsListFfbSalesResponseItem
     */
    'millName': string;
    /**
     * Revenue that the Supplier got from this FFB supply activity
     * @type {number}
     * @memberof PlantationsListFfbSalesResponseItem
     */
    'revenue': number;
    /**
     * Cost of this FFB supply activity
     * @type {number}
     * @memberof PlantationsListFfbSalesResponseItem
     */
    'cost'?: number;
    /**
     * Net Income of this FFB supply activity (revenue - cost)
     * @type {number}
     * @memberof PlantationsListFfbSalesResponseItem
     */
    'netIncome'?: number;
    /**
     * Price of the FFB (IDR) per tonnage that the mill paid to the Supplier
     * @type {number}
     * @memberof PlantationsListFfbSalesResponseItem
     */
    'sellPrice'?: number;
    /**
     * Price of the FFB (IDR) per tonnage that the Supplier paid to the farmer (their subagents). This is a semicolon-separated string of the price
     * @type {string}
     * @memberof PlantationsListFfbSalesResponseItem
     */
    'buyPrice'?: string;
    /**
     * Gross weight of the FFB supply (in kg)
     * @type {number}
     * @memberof PlantationsListFfbSalesResponseItem
     */
    'grossWeight': number;
    /**
     * Net weight of the FFB supply (in kg)
     * @type {number}
     * @memberof PlantationsListFfbSalesResponseItem
     */
    'netWeight': number;
    /**
     * Percentage of the FFB sortation
     * @type {number}
     * @memberof PlantationsListFfbSalesResponseItem
     */
    'sortationPct': number;
    /**
     * Weight of the FFB sortation (in kg)
     * @type {number}
     * @memberof PlantationsListFfbSalesResponseItem
     */
    'sortationWeight': number;
    /**
     * Plat number of the truck that carried the FFB
     * @type {string}
     * @memberof PlantationsListFfbSalesResponseItem
     */
    'truckNo': string;
    /**
     * List of the FFB sources (blocks) that supplied the FFB. This is a comma-separated string of the block names
     * @type {string}
     * @memberof PlantationsListFfbSalesResponseItem
     */
    'ffbSources'?: string;
}
/**
 * 
 * @export
 * @interface PlantationsReportsGetSalesPerFarmerGroupResponse
 */
export interface PlantationsReportsGetSalesPerFarmerGroupResponse {
    /**
     * report data year in YYYY format
     * @type {number}
     * @memberof PlantationsReportsGetSalesPerFarmerGroupResponse
     */
    'year': number;
    /**
     * report data month in MM format
     * @type {number}
     * @memberof PlantationsReportsGetSalesPerFarmerGroupResponse
     */
    'month': number;
    /**
     * total farm area of current data
     * @type {number}
     * @memberof PlantationsReportsGetSalesPerFarmerGroupResponse
     */
    'areaHectare': number;
    /**
     * 
     * @type {PlantationsReportsResponseNetIncome}
     * @memberof PlantationsReportsGetSalesPerFarmerGroupResponse
     */
    'netIncome': PlantationsReportsResponseNetIncome;
    /**
     * 
     * @type {Array<PlantationsReportsGetSalesPerFarmerGroupResponseItem>}
     * @memberof PlantationsReportsGetSalesPerFarmerGroupResponse
     */
    'items': Array<PlantationsReportsGetSalesPerFarmerGroupResponseItem>;
}
/**
 * 
 * @export
 * @interface PlantationsReportsGetSalesPerFarmerGroupResponseExpenseBreakdownItem
 */
export interface PlantationsReportsGetSalesPerFarmerGroupResponseExpenseBreakdownItem {
    /**
     * 
     * @type {PlantationsReportsGetSalesPerFarmerGroupResponseExpenseBreakdownItemTypeEnum}
     * @memberof PlantationsReportsGetSalesPerFarmerGroupResponseExpenseBreakdownItem
     */
    'type': PlantationsReportsGetSalesPerFarmerGroupResponseExpenseBreakdownItemTypeEnum;
    /**
     * label in bahasa indonesia of the expense breakdown type
     * @type {string}
     * @memberof PlantationsReportsGetSalesPerFarmerGroupResponseExpenseBreakdownItem
     */
    'typeLabel': string;
    /**
     * monetary value of the the expense breakdown per unitLabel in Rupiah
     * @type {number}
     * @memberof PlantationsReportsGetSalesPerFarmerGroupResponseExpenseBreakdownItem
     */
    'value': number;
    /**
     * unit of measure label in bahasa indonesia of the expense breakdown
     * @type {string}
     * @memberof PlantationsReportsGetSalesPerFarmerGroupResponseExpenseBreakdownItem
     */
    'uomLabel': string;
}


/**
 * type of expense breakdown
 * @export
 * @enum {string}
 */

export const PlantationsReportsGetSalesPerFarmerGroupResponseExpenseBreakdownItemTypeEnum = {
    Fertilizing: 'FERTILIZING',
    Pruning: 'PRUNING',
    Spraying: 'SPRAYING',
    Slashing: 'SLASHING',
    Ablation: 'ABLATION',
    Sanitation: 'SANITATION'
} as const;

export type PlantationsReportsGetSalesPerFarmerGroupResponseExpenseBreakdownItemTypeEnum = typeof PlantationsReportsGetSalesPerFarmerGroupResponseExpenseBreakdownItemTypeEnum[keyof typeof PlantationsReportsGetSalesPerFarmerGroupResponseExpenseBreakdownItemTypeEnum];


/**
 * 
 * @export
 * @interface PlantationsReportsGetSalesPerFarmerGroupResponseItem
 */
export interface PlantationsReportsGetSalesPerFarmerGroupResponseItem {
    /**
     * 
     * @type {PlantationsReportsGetSalesPerFarmerGroupResponseItemIncomeStatement}
     * @memberof PlantationsReportsGetSalesPerFarmerGroupResponseItem
     */
    'incomeStatement': PlantationsReportsGetSalesPerFarmerGroupResponseItemIncomeStatement;
    /**
     * 
     * @type {PlantationsReportsResponseFarmerGroup}
     * @memberof PlantationsReportsGetSalesPerFarmerGroupResponseItem
     */
    'farmerGroup': PlantationsReportsResponseFarmerGroup;
    /**
     * 
     * @type {PlantationsReportsResponseFarmer}
     * @memberof PlantationsReportsGetSalesPerFarmerGroupResponseItem
     */
    'farmer'?: PlantationsReportsResponseFarmer;
}
/**
 * 
 * @export
 * @interface PlantationsReportsGetSalesPerFarmerGroupResponseItemIncomeStatement
 */
export interface PlantationsReportsGetSalesPerFarmerGroupResponseItemIncomeStatement {
    /**
     * 
     * @type {PlantationsReportsGetSalesPerFarmerGroupResponseItemIncomeStatementGross}
     * @memberof PlantationsReportsGetSalesPerFarmerGroupResponseItemIncomeStatement
     */
    'gross': PlantationsReportsGetSalesPerFarmerGroupResponseItemIncomeStatementGross;
    /**
     * 
     * @type {PlantationsReportsGetSalesPerFarmerGroupResponseItemIncomeStatementExpense}
     * @memberof PlantationsReportsGetSalesPerFarmerGroupResponseItemIncomeStatement
     */
    'expense': PlantationsReportsGetSalesPerFarmerGroupResponseItemIncomeStatementExpense;
    /**
     * 
     * @type {PlantationsReportsResponseNetIncome}
     * @memberof PlantationsReportsGetSalesPerFarmerGroupResponseItemIncomeStatement
     */
    'net': PlantationsReportsResponseNetIncome;
}
/**
 * 
 * @export
 * @interface PlantationsReportsGetSalesPerFarmerGroupResponseItemIncomeStatementExpense
 */
export interface PlantationsReportsGetSalesPerFarmerGroupResponseItemIncomeStatementExpense {
    /**
     * total expenses for the current report data
     * @type {number}
     * @memberof PlantationsReportsGetSalesPerFarmerGroupResponseItemIncomeStatementExpense
     */
    'total': number;
    /**
     * 
     * @type {PlantationsReportsGetSalesPerFarmerGroupResponseItemIncomeStatementExpensePerHarvest}
     * @memberof PlantationsReportsGetSalesPerFarmerGroupResponseItemIncomeStatementExpense
     */
    'perHarvest': PlantationsReportsGetSalesPerFarmerGroupResponseItemIncomeStatementExpensePerHarvest;
    /**
     * 
     * @type {PlantationsReportsGetSalesPerFarmerGroupResponseItemIncomeStatementExpensePerMonth}
     * @memberof PlantationsReportsGetSalesPerFarmerGroupResponseItemIncomeStatementExpense
     */
    'perMonth': PlantationsReportsGetSalesPerFarmerGroupResponseItemIncomeStatementExpensePerMonth;
}
/**
 * 
 * @export
 * @interface PlantationsReportsGetSalesPerFarmerGroupResponseItemIncomeStatementExpensePerHarvest
 */
export interface PlantationsReportsGetSalesPerFarmerGroupResponseItemIncomeStatementExpensePerHarvest {
    /**
     * total expenses per harvest for the current report data
     * @type {number}
     * @memberof PlantationsReportsGetSalesPerFarmerGroupResponseItemIncomeStatementExpensePerHarvest
     */
    'total': number;
    /**
     * total FFB weight recorded in weighing process for the current report data
     * @type {number}
     * @memberof PlantationsReportsGetSalesPerFarmerGroupResponseItemIncomeStatementExpensePerHarvest
     */
    'ffbTotalWeightInKg': number;
    /**
     * average harvesting wage per kg for the current report data (\"Upah Panen\")
     * @type {number}
     * @memberof PlantationsReportsGetSalesPerFarmerGroupResponseItemIncomeStatementExpensePerHarvest
     */
    'harvestingWagePerKg': number;
    /**
     * average hauling wage per kg for the current report data (\"Upah Langsir\")
     * @type {number}
     * @memberof PlantationsReportsGetSalesPerFarmerGroupResponseItemIncomeStatementExpensePerHarvest
     */
    'haulingWagePerKg': number;
    /**
     * average loading wage per kg for the current report data (\"Upah Muat\")
     * @type {number}
     * @memberof PlantationsReportsGetSalesPerFarmerGroupResponseItemIncomeStatementExpensePerHarvest
     */
    'loadingWagePerKg': number;
    /**
     * average weighing wage per kg for the current report data (\"Upah Timbang\")
     * @type {number}
     * @memberof PlantationsReportsGetSalesPerFarmerGroupResponseItemIncomeStatementExpensePerHarvest
     */
    'weighingWagePerKg': number;
    /**
     * average delivery wage per kg for the current report data (\"Upah Aktivitas Pengiriman\")
     * @type {number}
     * @memberof PlantationsReportsGetSalesPerFarmerGroupResponseItemIncomeStatementExpensePerHarvest
     */
    'deliveryWagePerKg': number;
}
/**
 * 
 * @export
 * @interface PlantationsReportsGetSalesPerFarmerGroupResponseItemIncomeStatementExpensePerMonth
 */
export interface PlantationsReportsGetSalesPerFarmerGroupResponseItemIncomeStatementExpensePerMonth {
    /**
     * total monthly expenses for the current report data, available at end of month
     * @type {number}
     * @memberof PlantationsReportsGetSalesPerFarmerGroupResponseItemIncomeStatementExpensePerMonth
     */
    'total': number;
    /**
     * management monthly expenses for the current report data, available at end of month (\"Pengurus\")
     * @type {number}
     * @memberof PlantationsReportsGetSalesPerFarmerGroupResponseItemIncomeStatementExpensePerMonth
     */
    'managementFee': number;
    /**
     * operational monthly expenses for the current report data, available at end of month (\"Operasional\")
     * @type {number}
     * @memberof PlantationsReportsGetSalesPerFarmerGroupResponseItemIncomeStatementExpensePerMonth
     */
    'operationalFee': number;
    /**
     * total upkeep monthly expenses for the current report data, available at end of month (\"Perawatan\")
     * @type {number}
     * @memberof PlantationsReportsGetSalesPerFarmerGroupResponseItemIncomeStatementExpensePerMonth
     */
    'upkeepFee': number;
    /**
     * breakdown of each upkeep monthly expenses item for the current report data, available at end of month (under \"Perawatan\")
     * @type {Array<PlantationsReportsGetSalesPerFarmerGroupResponseExpenseBreakdownItem>}
     * @memberof PlantationsReportsGetSalesPerFarmerGroupResponseItemIncomeStatementExpensePerMonth
     */
    'upkeepFeeItems': Array<PlantationsReportsGetSalesPerFarmerGroupResponseExpenseBreakdownItem>;
}
/**
 * 
 * @export
 * @interface PlantationsReportsGetSalesPerFarmerGroupResponseItemIncomeStatementGross
 */
export interface PlantationsReportsGetSalesPerFarmerGroupResponseItemIncomeStatementGross {
    /**
     * total gross income for the current report data
     * @type {number}
     * @memberof PlantationsReportsGetSalesPerFarmerGroupResponseItemIncomeStatementGross
     */
    'total': number;
    /**
     * total FFB weight received by mills
     * @type {number}
     * @memberof PlantationsReportsGetSalesPerFarmerGroupResponseItemIncomeStatementGross
     */
    'ffbTotalWeightInKg': number;
    /**
     * average price from mills for this report data
     * @type {number}
     * @memberof PlantationsReportsGetSalesPerFarmerGroupResponseItemIncomeStatementGross
     */
    'millsFfbPricePerKg': number;
}
/**
 * 
 * @export
 * @interface PlantationsReportsGetSalesResponse
 */
export interface PlantationsReportsGetSalesResponse {
    /**
     * 
     * @type {Array<PlantationsReportsGetSalesResponseItem>}
     * @memberof PlantationsReportsGetSalesResponse
     */
    'items': Array<PlantationsReportsGetSalesResponseItem>;
}
/**
 * 
 * @export
 * @interface PlantationsReportsGetSalesResponseItem
 */
export interface PlantationsReportsGetSalesResponseItem {
    /**
     * report data year in YYYY format
     * @type {number}
     * @memberof PlantationsReportsGetSalesResponseItem
     */
    'year': number;
    /**
     * report data month in MM format
     * @type {number}
     * @memberof PlantationsReportsGetSalesResponseItem
     */
    'month': number;
    /**
     * total farm area of current data
     * @type {number}
     * @memberof PlantationsReportsGetSalesResponseItem
     */
    'areaHectare': number;
    /**
     * 
     * @type {PlantationsReportsResponseNetIncome}
     * @memberof PlantationsReportsGetSalesResponseItem
     */
    'netIncome': PlantationsReportsResponseNetIncome;
    /**
     * 
     * @type {PlantationsReportsResponseFarmerGroup}
     * @memberof PlantationsReportsGetSalesResponseItem
     */
    'farmerGroup'?: PlantationsReportsResponseFarmerGroup;
    /**
     * 
     * @type {PlantationsReportsResponseFarmer}
     * @memberof PlantationsReportsGetSalesResponseItem
     */
    'farmer'?: PlantationsReportsResponseFarmer;
}
/**
 * 
 * @export
 * @interface PlantationsReportsResponseFarmer
 */
export interface PlantationsReportsResponseFarmer {
    /**
     * total farm area owned by this farmer
     * @type {number}
     * @memberof PlantationsReportsResponseFarmer
     */
    'areaHectare': number;
    /**
     * total net income received by this farmer
     * @type {number}
     * @memberof PlantationsReportsResponseFarmer
     */
    'totalNetIncome': number;
}
/**
 * 
 * @export
 * @interface PlantationsReportsResponseFarmerGroup
 */
export interface PlantationsReportsResponseFarmerGroup {
    /**
     * business Id of the farmer group
     * @type {string}
     * @memberof PlantationsReportsResponseFarmerGroup
     */
    'id': string;
    /**
     * name of the seed
     * @type {string}
     * @memberof PlantationsReportsResponseFarmerGroup
     */
    'name': string;
    /**
     * total farm area of current farmer group
     * @type {number}
     * @memberof PlantationsReportsResponseFarmerGroup
     */
    'areaHectare': number;
    /**
     * 
     * @type {Array<PlantationsReportsResponseFarmerGroupBlock>}
     * @memberof PlantationsReportsResponseFarmerGroup
     */
    'blocks': Array<PlantationsReportsResponseFarmerGroupBlock>;
    /**
     * 
     * @type {Array<PlantationsReportsResponseFarmerGroupFarm>}
     * @memberof PlantationsReportsResponseFarmerGroup
     */
    'farms': Array<PlantationsReportsResponseFarmerGroupFarm>;
}
/**
 * 
 * @export
 * @interface PlantationsReportsResponseFarmerGroupBlock
 */
export interface PlantationsReportsResponseFarmerGroupBlock {
    /**
     * farmer group\'s farm block id
     * @type {string}
     * @memberof PlantationsReportsResponseFarmerGroupBlock
     */
    'id': string;
    /**
     * farmer group\'s farm block name
     * @type {string}
     * @memberof PlantationsReportsResponseFarmerGroupBlock
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface PlantationsReportsResponseFarmerGroupFarm
 */
export interface PlantationsReportsResponseFarmerGroupFarm {
    /**
     * farmer group\'s owned farm id
     * @type {string}
     * @memberof PlantationsReportsResponseFarmerGroupFarm
     */
    'id': string;
    /**
     * farmer group\'s owned farm name
     * @type {string}
     * @memberof PlantationsReportsResponseFarmerGroupFarm
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface PlantationsReportsResponseNetIncome
 */
export interface PlantationsReportsResponseNetIncome {
    /**
     * total amount of net income
     * @type {number}
     * @memberof PlantationsReportsResponseNetIncome
     */
    'total': number;
    /**
     * amount of net income per hectare
     * @type {number}
     * @memberof PlantationsReportsResponseNetIncome
     */
    'perHectare': number;
}
/**
 * 
 * @export
 * @interface PlantationsSchedulesCreateRequest
 */
export interface PlantationsSchedulesCreateRequest {
    /**
     * type of schedule to distinct the activity it belongs to
     * @type {string}
     * @memberof PlantationsSchedulesCreateRequest
     */
    'type': string;
    /**
     * harvester coordinator phone number starting with 0 as prefix (08xxxxxxxxx)
     * @type {string}
     * @memberof PlantationsSchedulesCreateRequest
     */
    'supervisorPhoneNumber': string;
    /**
     * supervisor name that send to verify worker on the system
     * @type {string}
     * @memberof PlantationsSchedulesCreateRequest
     */
    'supervisorName': string;
    /**
     * id of a farm this plantation schedule belongs to to represented in UUID type 4
     * @type {string}
     * @memberof PlantationsSchedulesCreateRequest
     */
    'farmId': string;
    /**
     * Latitude where the schedule was made
     * @type {number}
     * @memberof PlantationsSchedulesCreateRequest
     */
    'createdLatitude'?: number;
    /**
     * Longitude where the schedule was made
     * @type {number}
     * @memberof PlantationsSchedulesCreateRequest
     */
    'createdLongitude'?: number;
    /**
     * schedule date in unix timestamp
     * @type {number}
     * @memberof PlantationsSchedulesCreateRequest
     */
    'scheduleDateUtc0': number;
    /**
     * TPH (Tempat Pengumpulan Hasil) FFB
     * @type {string}
     * @memberof PlantationsSchedulesCreateRequest
     */
    'collectionPoint': string;
}
/**
 * 
 * @export
 * @interface PlantationsSchedulesCreateResponse
 */
export interface PlantationsSchedulesCreateResponse {
    /**
     * Plantation schedule id represented in UUID type 4
     * @type {string}
     * @memberof PlantationsSchedulesCreateResponse
     */
    'id': string;
    /**
     * True if poin is awarded, otherwise false
     * @type {boolean}
     * @memberof PlantationsSchedulesCreateResponse
     */
    'rewardAwarded': boolean;
    /**
     * Added sawit point
     * @type {number}
     * @memberof PlantationsSchedulesCreateResponse
     */
    'point': number;
}
/**
 * 
 * @export
 * @interface PlantationsSchedulesGetHarvestsDetailItemsResponse
 */
export interface PlantationsSchedulesGetHarvestsDetailItemsResponse {
    /**
     * id of harvesting activity represented in UUID type 4
     * @type {string}
     * @memberof PlantationsSchedulesGetHarvestsDetailItemsResponse
     */
    'id': string;
    /**
     * harvesting date in unix timestamp
     * @type {number}
     * @memberof PlantationsSchedulesGetHarvestsDetailItemsResponse
     */
    'harvestingDateUtc0': number;
    /**
     * Estimated average FFB (BJR/Komidel) weight in kg
     * @type {number}
     * @memberof PlantationsSchedulesGetHarvestsDetailItemsResponse
     */
    'estimatedWeightAverageBunchKg': number;
    /**
     * 
     * @type {string}
     * @memberof PlantationsSchedulesGetHarvestsDetailItemsResponse
     */
    'photoUrl': string;
    /**
     * TPH (Tempat Pengumpulan Hasil) FFB
     * @type {string}
     * @memberof PlantationsSchedulesGetHarvestsDetailItemsResponse
     */
    'ffbCollectionPoint': string;
}
/**
 * 
 * @export
 * @interface PlantationsSchedulesGetHarvestsDetailResponse
 */
export interface PlantationsSchedulesGetHarvestsDetailResponse {
    /**
     * id of a schedule represented in UUID type 4
     * @type {string}
     * @memberof PlantationsSchedulesGetHarvestsDetailResponse
     */
    'id': string;
    /**
     * user id of worker which has HARVEST SUPERVISOR role represented in UUID type 4
     * @type {string}
     * @memberof PlantationsSchedulesGetHarvestsDetailResponse
     */
    'supervisorId': string;
    /**
     * Name of the supervisor for this plantation schedule
     * @type {string}
     * @memberof PlantationsSchedulesGetHarvestsDetailResponse
     */
    'supervisorName': string;
    /**
     * Phone number starting with 0 as prefix (08xxxxxxxxx)
     * @type {string}
     * @memberof PlantationsSchedulesGetHarvestsDetailResponse
     */
    'supervisorPhoneNumber': string;
    /**
     * id of a farm this plantation schedule belongs to to represented in UUID type 4
     * @type {string}
     * @memberof PlantationsSchedulesGetHarvestsDetailResponse
     */
    'farmId': string;
    /**
     * Name of the farm this plantation schedule belongs to
     * @type {string}
     * @memberof PlantationsSchedulesGetHarvestsDetailResponse
     */
    'farmName': string;
    /**
     * schedule date in unix timestamp
     * @type {number}
     * @memberof PlantationsSchedulesGetHarvestsDetailResponse
     */
    'scheduleDateUtc0': number;
    /**
     * TPH (Tempat Pengumpulan Hasil) FFB
     * @type {string}
     * @memberof PlantationsSchedulesGetHarvestsDetailResponse
     */
    'collectionPoint': string;
    /**
     * 
     * @type {PlantationScheduleStatusEnum}
     * @memberof PlantationsSchedulesGetHarvestsDetailResponse
     */
    'status': PlantationScheduleStatusEnum;
    /**
     * 
     * @type {Array<PlantationsSchedulesGetHarvestsDetailItemsResponse>}
     * @memberof PlantationsSchedulesGetHarvestsDetailResponse
     */
    'items': Array<PlantationsSchedulesGetHarvestsDetailItemsResponse>;
}


/**
 * 
 * @export
 * @interface Point
 */
export interface Point {
    /**
     * 
     * @type {PointEnum}
     * @memberof Point
     */
    'type': PointEnum;
    /**
     * 
     * @type {Array<number>}
     * @memberof Point
     */
    'coordinates': Array<number>;
}


/**
 * Geometry point type allowed
 * @export
 * @enum {string}
 */

export const PointEnum = {
    Point: 'Point'
} as const;

export type PointEnum = typeof PointEnum[keyof typeof PointEnum];


/**
 * 
 * @export
 * @interface Polygon
 */
export interface Polygon {
    /**
     * 
     * @type {PolygonEnum}
     * @memberof Polygon
     */
    'type': PolygonEnum;
    /**
     * This coordinates type of polygon need 2 nested array before going to polygon data, it is based on GeoJSON format, this data structure is needed so we can directly insert the geoJSON data into postgis
     * @type {Array<Array<Array<number>>>}
     * @memberof Polygon
     */
    'coordinates': Array<Array<Array<number>>>;
}


/**
 * Geometry polygon type allowed
 * @export
 * @enum {string}
 */

export const PolygonEnum = {
    Polygon: 'Polygon'
} as const;

export type PolygonEnum = typeof PolygonEnum[keyof typeof PolygonEnum];


/**
 * - news this for news popup app update - promo this for promo popup 
 * @export
 * @enum {string}
 */

export const PopupTypeEnum = {
    News: 'news',
    Promo: 'promo'
} as const;

export type PopupTypeEnum = typeof PopupTypeEnum[keyof typeof PopupTypeEnum];


/**
 * 
 * @export
 * @interface PopupsItemCTA
 */
export interface PopupsItemCTA {
    /**
     * Title of CTA
     * @type {string}
     * @memberof PopupsItemCTA
     */
    'label'?: string;
    /**
     * URL of CTA
     * @type {string}
     * @memberof PopupsItemCTA
     */
    'action_url'?: string;
}
/**
 * 
 * @export
 * @interface ProductItem
 */
export interface ProductItem {
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    'itemId': string;
    /**
     * 
     * @type {number}
     * @memberof ProductItem
     */
    'qty': number;
    /**
     * 
     * @type {number}
     * @memberof ProductItem
     */
    'itemPrice': number;
}
/**
 * Response data
 * @export
 * @interface ProductListResponse
 */
export interface ProductListResponse {
    /**
     * List of Product item
     * @type {Array<ProductListResponseItem>}
     * @memberof ProductListResponse
     */
    'items': Array<ProductListResponseItem>;
}
/**
 * 
 * @export
 * @interface ProductListResponseItem
 */
export interface ProductListResponseItem {
    /**
     * 
     * @type {string}
     * @memberof ProductListResponseItem
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ProductListResponseItem
     */
    'sku': string;
    /**
     * 
     * @type {string}
     * @memberof ProductListResponseItem
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ProductListResponseItem
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof ProductListResponseItem
     */
    'photoUrl': string;
    /**
     * 
     * @type {number}
     * @memberof ProductListResponseItem
     */
    'stock': number;
    /**
     * 
     * @type {number}
     * @memberof ProductListResponseItem
     */
    'stockMinimum': number;
    /**
     * 
     * @type {string}
     * @memberof ProductListResponseItem
     */
    'unitOfMeasurement': string;
    /**
     * 
     * @type {string}
     * @memberof ProductListResponseItem
     */
    'storeId': string;
    /**
     * 
     * @type {number}
     * @memberof ProductListResponseItem
     */
    'price': number;
}
/**
 * 
 * @export
 * @interface ProvinceResponseItem
 */
export interface ProvinceResponseItem {
    /**
     * Province Name
     * @type {string}
     * @memberof ProvinceResponseItem
     */
    'name': string;
    /**
     * list of city
     * @type {Array<CityResponseItem>}
     * @memberof ProvinceResponseItem
     */
    'cities': Array<CityResponseItem>;
}
/**
 * this is for enum qrcode source
 * @export
 * @enum {string}
 */

export const QRCodeSourceEnum = {
    Vendor: 'vendor',
    Coupon: 'coupon'
} as const;

export type QRCodeSourceEnum = typeof QRCodeSourceEnum[keyof typeof QRCodeSourceEnum];


/**
 * 
 * @export
 * @interface QuestsListResponse
 */
export interface QuestsListResponse {
    /**
     * 
     * @type {Array<QuestsListResponseItem>}
     * @memberof QuestsListResponse
     */
    'quests': Array<QuestsListResponseItem>;
    /**
     * 
     * @type {Array<AssetCategoryEnum>}
     * @memberof QuestsListResponse
     */
    'emptyAssets': Array<AssetCategoryEnum>;
}
/**
 * 
 * @export
 * @interface QuestsListResponseItem
 */
export interface QuestsListResponseItem {
    /**
     * Instruction of the survey that will be shown on FE. Constructed with `short_name` of the mill
     * @type {string}
     * @memberof QuestsListResponseItem
     */
    'instruction': string;
    /**
     * ID of the Partner (mills) represented in UUID type 4 (for type Survey)
     * @type {string}
     * @memberof QuestsListResponseItem
     */
    'millId'?: string;
    /**
     * 
     * @type {QuestsTypeEnum}
     * @memberof QuestsListResponseItem
     */
    'surveyType': QuestsTypeEnum;
}


/**
 * 
 * @export
 * @interface QuestsSurveyListResponse
 */
export interface QuestsSurveyListResponse {
    /**
     * 
     * @type {Array<QuestsSurveyListResponseItem>}
     * @memberof QuestsSurveyListResponse
     */
    'items': Array<QuestsSurveyListResponseItem>;
}
/**
 * 
 * @export
 * @interface QuestsSurveyListResponseItem
 */
export interface QuestsSurveyListResponseItem {
    /**
     * Instruction of the survey that will be shown on FE. Constructed with `short_name` of the mill
     * @type {string}
     * @memberof QuestsSurveyListResponseItem
     */
    'instruction': string;
    /**
     * ID of the Partner (mills) represented in UUID type 4
     * @type {string}
     * @memberof QuestsSurveyListResponseItem
     */
    'millId': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const QuestsTypeEnum = {
    Survey: 'SURVEY',
    SellRecord: 'SELL_RECORD'
} as const;

export type QuestsTypeEnum = typeof QuestsTypeEnum[keyof typeof QuestsTypeEnum];


/**
 * Status of the Ramp
 * @export
 * @enum {string}
 */

export const RampStatusEnum = {
    Active: 'ACTIVE',
    Pending: 'PENDING',
    Rejected: 'REJECTED'
} as const;

export type RampStatusEnum = typeof RampStatusEnum[keyof typeof RampStatusEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const RankEnum = {
    Bos: 'BOS',
    Warga: 'WARGA'
} as const;

export type RankEnum = typeof RankEnum[keyof typeof RankEnum];


/**
 * Status of the redistribution Sawitpoin
 * @export
 * @enum {string}
 */

export const RedistributionStatusEnum = {
    End: 'END',
    Pending: 'PENDING',
    Failed: 'FAILED'
} as const;

export type RedistributionStatusEnum = typeof RedistributionStatusEnum[keyof typeof RedistributionStatusEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const ReportAssetContractFlagEnum = {
    Supplier: 'SUPPLIER',
    Delivery: 'DELIVERY'
} as const;

export type ReportAssetContractFlagEnum = typeof ReportAssetContractFlagEnum[keyof typeof ReportAssetContractFlagEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const ReportAssetContractTimeRangeEnum = {
    Today: 'TODAY',
    Last7: 'LAST_7',
    Last30: 'LAST_30',
    Last90: 'LAST_90',
    AllTime: 'ALL_TIME'
} as const;

export type ReportAssetContractTimeRangeEnum = typeof ReportAssetContractTimeRangeEnum[keyof typeof ReportAssetContractTimeRangeEnum];


/**
 * 
 * @export
 * @interface ReportContractDetailResponse
 */
export interface ReportContractDetailResponse {
    /**
     * 
     * @type {number}
     * @memberof ReportContractDetailResponse
     */
    'total': number;
    /**
     * 
     * @type {Array<ReportContractSummaryDetailChartItem>}
     * @memberof ReportContractDetailResponse
     */
    'reports': Array<ReportContractSummaryDetailChartItem>;
}
/**
 * 
 * @export
 * @interface ReportContractDetailResponseV2
 */
export interface ReportContractDetailResponseV2 {
    /**
     * 
     * @type {number}
     * @memberof ReportContractDetailResponseV2
     */
    'total': number;
    /**
     * 
     * @type {Array<ReportContractSummaryDetailChartItem>}
     * @memberof ReportContractDetailResponseV2
     */
    'reports': Array<ReportContractSummaryDetailChartItem>;
}
/**
 * 
 * @export
 * @interface ReportContractFilterResponseItem
 */
export interface ReportContractFilterResponseItem {
    /**
     * 
     * @type {string}
     * @memberof ReportContractFilterResponseItem
     */
    'contractId': string;
    /**
     * 
     * @type {string}
     * @memberof ReportContractFilterResponseItem
     */
    'contractName': string;
}
/**
 * 
 * @export
 * @interface ReportContractSummaryDetailChartItem
 */
export interface ReportContractSummaryDetailChartItem {
    /**
     * timestamp
     * @type {number}
     * @memberof ReportContractSummaryDetailChartItem
     */
    'date': number;
    /**
     * 
     * @type {number}
     * @memberof ReportContractSummaryDetailChartItem
     */
    'value': number;
}
/**
 * 
 * @export
 * @interface ReportContractSummaryResponse
 */
export interface ReportContractSummaryResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof ReportContractSummaryResponse
     */
    'mills': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ReportContractSummaryResponse
     */
    'totalSupply': number;
    /**
     * 
     * @type {number}
     * @memberof ReportContractSummaryResponse
     */
    'totalDelivery': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ReportSummaryStatus = {
    Success: 'SUCCESS',
    Failed: 'FAILED'
} as const;

export type ReportSummaryStatus = typeof ReportSummaryStatus[keyof typeof ReportSummaryStatus];


/**
 * 
 * @export
 * @interface ReportTruckListResponse
 */
export interface ReportTruckListResponse {
    /**
     * 
     * @type {Array<ReportTruckListResponseItem>}
     * @memberof ReportTruckListResponse
     */
    'items': Array<ReportTruckListResponseItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof ReportTruckListResponse
     */
    'pagination': PaginationResponse;
}
/**
 * 
 * @export
 * @interface ReportTruckListResponseItem
 */
export interface ReportTruckListResponseItem {
    /**
     * Plat no of truck
     * @type {string}
     * @memberof ReportTruckListResponseItem
     */
    'platNo': string;
    /**
     * Net weight of truck supply
     * @type {number}
     * @memberof ReportTruckListResponseItem
     */
    'netWeight': number;
    /**
     * Total delivery of truck
     * @type {number}
     * @memberof ReportTruckListResponseItem
     */
    'deliveryCount': number;
}
/**
 * 
 * @export
 * @interface ReportWorkerSummaryListResponseitem
 */
export interface ReportWorkerSummaryListResponseitem {
    /**
     * Name of activity item
     * @type {string}
     * @memberof ReportWorkerSummaryListResponseitem
     */
    'name': string;
    /**
     * Summary Report list date (in epoch). Will be represented in UTC-0, time will be set at midnight (00:00)
     * @type {number}
     * @memberof ReportWorkerSummaryListResponseitem
     */
    'dateTime': number;
    /**
     * 
     * @type {WeighbridgeTicketStatusEnum}
     * @memberof ReportWorkerSummaryListResponseitem
     */
    'status': WeighbridgeTicketStatusEnum;
    /**
     * Image url of activity item.
     * @type {string}
     * @memberof ReportWorkerSummaryListResponseitem
     */
    'imageUrl': string;
}


/**
 * 
 * @export
 * @interface ReportWorkersResponse
 */
export interface ReportWorkersResponse {
    /**
     * 
     * @type {Array<ReportWorkersResponseItem>}
     * @memberof ReportWorkersResponse
     */
    'items': Array<ReportWorkersResponseItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof ReportWorkersResponse
     */
    'pagination': PaginationResponse;
}
/**
 * 
 * @export
 * @interface ReportWorkersResponseItem
 */
export interface ReportWorkersResponseItem {
    /**
     * Id of worker
     * @type {string}
     * @memberof ReportWorkersResponseItem
     */
    'id': string;
    /**
     * Name of worker
     * @type {string}
     * @memberof ReportWorkersResponseItem
     */
    'name': string;
    /**
     * 
     * @type {WorkerStatusEnum}
     * @memberof ReportWorkersResponseItem
     */
    'status': WorkerStatusEnum;
    /**
     * Phone number starting with 0 as prefix (08xxxxxxxxx)
     * @type {string}
     * @memberof ReportWorkersResponseItem
     */
    'phoneNumber': string;
    /**
     * 
     * @type {Array<ReportWorkersRolesItemResponse>}
     * @memberof ReportWorkersResponseItem
     */
    'roles': Array<ReportWorkersRolesItemResponse>;
    /**
     * 
     * @type {Array<ReportWorkersSummaryItemResponse>}
     * @memberof ReportWorkersResponseItem
     */
    'summary': Array<ReportWorkersSummaryItemResponse>;
}


/**
 * 
 * @export
 * @interface ReportWorkersRolesItemResponse
 */
export interface ReportWorkersRolesItemResponse {
    /**
     * 
     * @type {WorkerCategoryEnum}
     * @memberof ReportWorkersRolesItemResponse
     */
    'name': WorkerCategoryEnum;
    /**
     * 
     * @type {string}
     * @memberof ReportWorkersRolesItemResponse
     */
    'millName': string;
}


/**
 * 
 * @export
 * @interface ReportWorkersSummaryItemResponse
 */
export interface ReportWorkersSummaryItemResponse {
    /**
     * 
     * @type {PeriodEnum}
     * @memberof ReportWorkersSummaryItemResponse
     */
    'period': PeriodEnum;
    /**
     * Count of summary report based on period
     * @type {number}
     * @memberof ReportWorkersSummaryItemResponse
     */
    'count': number;
}


/**
 * 
 * @export
 * @interface ReportWorkersSummaryResponse
 */
export interface ReportWorkersSummaryResponse {
    /**
     * 
     * @type {Array<ReportWorkersSummaryItemResponse>}
     * @memberof ReportWorkersSummaryResponse
     */
    'summary': Array<ReportWorkersSummaryItemResponse>;
    /**
     * 
     * @type {Array<ReportWorkerSummaryListResponseitem>}
     * @memberof ReportWorkersSummaryResponse
     */
    'items': Array<ReportWorkerSummaryListResponseitem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof ReportWorkersSummaryResponse
     */
    'pagination': PaginationResponse;
}
/**
 * 
 * @export
 * @interface ReportsGetReportShortcutDOItemResponse
 */
export interface ReportsGetReportShortcutDOItemResponse {
    /**
     * the name of the DO/SP/PB
     * @type {string}
     * @memberof ReportsGetReportShortcutDOItemResponse
     */
    'doName': string;
    /**
     * count of the mill the DO supply
     * @type {number}
     * @memberof ReportsGetReportShortcutDOItemResponse
     */
    'millCount': number;
    /**
     * the month and year of the report
     * @type {string}
     * @memberof ReportsGetReportShortcutDOItemResponse
     */
    'monthYear': string;
    /**
     * count of the delivery the DO done to the mills
     * @type {number}
     * @memberof ReportsGetReportShortcutDOItemResponse
     */
    'deliveryCount': number;
    /**
     * the total of supply the DO done delivered to the mills in ton
     * @type {number}
     * @memberof ReportsGetReportShortcutDOItemResponse
     */
    'totalSupply': number;
}
/**
 * 
 * @export
 * @interface ReportsGetReportShortcutFarmerItemResponse
 */
export interface ReportsGetReportShortcutFarmerItemResponse {
    /**
     * the name of the farm
     * @type {string}
     * @memberof ReportsGetReportShortcutFarmerItemResponse
     */
    'farmName': string;
    /**
     * the name of the area
     * @type {string}
     * @memberof ReportsGetReportShortcutFarmerItemResponse
     */
    'areaName': string;
    /**
     * the month and year of the report
     * @type {string}
     * @memberof ReportsGetReportShortcutFarmerItemResponse
     */
    'monthYear': string;
    /**
     * farmer revenue in the month
     * @type {number}
     * @memberof ReportsGetReportShortcutFarmerItemResponse
     */
    'revenue': number;
    /**
     * farmer expense in the month
     * @type {number}
     * @memberof ReportsGetReportShortcutFarmerItemResponse
     */
    'expense': number;
}
/**
 * 
 * @export
 * @interface ReportsGetReportShortcutGapoktanFarmerItemResponse
 */
export interface ReportsGetReportShortcutGapoktanFarmerItemResponse {
    /**
     * the name of the gapoktan farm
     * @type {string}
     * @memberof ReportsGetReportShortcutGapoktanFarmerItemResponse
     */
    'farmName': string;
    /**
     * the name of the gapoktan
     * @type {string}
     * @memberof ReportsGetReportShortcutGapoktanFarmerItemResponse
     */
    'gapoktanName': string;
    /**
     * the month and year of the report
     * @type {string}
     * @memberof ReportsGetReportShortcutGapoktanFarmerItemResponse
     */
    'monthYear': string;
    /**
     * revenue earned by the gapoktan farmer
     * @type {number}
     * @memberof ReportsGetReportShortcutGapoktanFarmerItemResponse
     */
    'revenue': number;
    /**
     * expense of the gapoktan farmer
     * @type {number}
     * @memberof ReportsGetReportShortcutGapoktanFarmerItemResponse
     */
    'expense': number;
}
/**
 * 
 * @export
 * @interface ReportsGetReportShortcutGapoktanManagerItemResponse
 */
export interface ReportsGetReportShortcutGapoktanManagerItemResponse {
    /**
     * the name of the gapoktan
     * @type {string}
     * @memberof ReportsGetReportShortcutGapoktanManagerItemResponse
     */
    'gapoktanName': string;
    /**
     * the month and year of the report
     * @type {string}
     * @memberof ReportsGetReportShortcutGapoktanManagerItemResponse
     */
    'monthYear': string;
    /**
     * revenue earned by the manager gapoktan
     * @type {number}
     * @memberof ReportsGetReportShortcutGapoktanManagerItemResponse
     */
    'revenue': number;
    /**
     * expense of the manager gapoktan
     * @type {number}
     * @memberof ReportsGetReportShortcutGapoktanManagerItemResponse
     */
    'expense': number;
}
/**
 * 
 * @export
 * @interface ReportsGetReportShortcutResponse
 */
export interface ReportsGetReportShortcutResponse {
    /**
     * 
     * @type {Array<ReportsGetReportShortcutFarmerItemResponse>}
     * @memberof ReportsGetReportShortcutResponse
     */
    'farmer': Array<ReportsGetReportShortcutFarmerItemResponse>;
    /**
     * 
     * @type {Array<ReportsGetReportShortcutSupplierItemResponse>}
     * @memberof ReportsGetReportShortcutResponse
     */
    'supplier': Array<ReportsGetReportShortcutSupplierItemResponse>;
    /**
     * 
     * @type {Array<ReportsGetReportShortcutDOItemResponse>}
     * @memberof ReportsGetReportShortcutResponse
     */
    'do': Array<ReportsGetReportShortcutDOItemResponse>;
    /**
     * 
     * @type {Array<ReportsGetReportShortcutGapoktanManagerItemResponse>}
     * @memberof ReportsGetReportShortcutResponse
     */
    'gapoktanManager': Array<ReportsGetReportShortcutGapoktanManagerItemResponse>;
    /**
     * 
     * @type {Array<ReportsGetReportShortcutGapoktanFarmerItemResponse>}
     * @memberof ReportsGetReportShortcutResponse
     */
    'gapoktanFarmer': Array<ReportsGetReportShortcutGapoktanFarmerItemResponse>;
}
/**
 * 
 * @export
 * @interface ReportsGetReportShortcutSupplierItemResponse
 */
export interface ReportsGetReportShortcutSupplierItemResponse {
    /**
     * cargo desc which supply to the mills
     * @type {string}
     * @memberof ReportsGetReportShortcutSupplierItemResponse
     */
    'cargoDesc': string;
    /**
     * number of mill who got supply
     * @type {number}
     * @memberof ReportsGetReportShortcutSupplierItemResponse
     */
    'millCount': number;
    /**
     * date of the report
     * @type {number}
     * @memberof ReportsGetReportShortcutSupplierItemResponse
     */
    'date': number;
    /**
     * the last supply from cargo desc to mill in ton
     * @type {number}
     * @memberof ReportsGetReportShortcutSupplierItemResponse
     */
    'lastSupply': number;
    /**
     * the total supply from cargo desc to mill in ton
     * @type {number}
     * @memberof ReportsGetReportShortcutSupplierItemResponse
     */
    'totalSupply': number;
}
/**
 * reward item of unit of measurement
 * @export
 * @enum {string}
 */

export const RewardItemUnitOfMeasurementEnum = {
    Mg: 'mg',
    G: 'g',
    Kg: 'kg'
} as const;

export type RewardItemUnitOfMeasurementEnum = typeof RewardItemUnitOfMeasurementEnum[keyof typeof RewardItemUnitOfMeasurementEnum];


/**
 * this is the status of the reward redeem
 * @export
 * @enum {string}
 */

export const RewardRedeemStatusEnum = {
    Cancelled: 'CANCELLED',
    Redeemed: 'REDEEMED',
    Completed: 'COMPLETED',
    Draft: 'DRAFT'
} as const;

export type RewardRedeemStatusEnum = typeof RewardRedeemStatusEnum[keyof typeof RewardRedeemStatusEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const RewardTypeEnum = {
    Exp: 'EXP',
    Point: 'POINT'
} as const;

export type RewardTypeEnum = typeof RewardTypeEnum[keyof typeof RewardTypeEnum];


/**
 * List of allowed answer for certificate ownership of SPPL or AMDAL
 * @export
 * @enum {string}
 */

export const SPPLorAMDALEnum = {
    Ada: 'Ada',
    TidakAda: 'Tidak Ada'
} as const;

export type SPPLorAMDALEnum = typeof SPPLorAMDALEnum[keyof typeof SPPLorAMDALEnum];


/**
 * List of allowed answer for certificate ownership of Surat Tanda Daftar Budidaya / Nomor Induk Berusaha
 * @export
 * @enum {string}
 */

export const STDBorNIBEnum = {
    Ada: 'Ada',
    TidakAda: 'Tidak Ada'
} as const;

export type STDBorNIBEnum = typeof STDBorNIBEnum[keyof typeof STDBorNIBEnum];


/**
 * DRAFT = order is created by user but not yet paid, NEW = order is already paid WAITING_FOR_CONFIRMATION = order is already paid by user and waiting for finance team to verify, CONFIRMED = order is already paid by user and already verified by finance team READY_TO_PICK_UP = order ready to pick up before sending to the user DELIVERING = orders are being shipped by the operations team FULL_DELIVERED = all orders is fully delivered PARTIALLY_DELIVERED = some orders is delivered COMPLETED = order is completely done CANCELLED = order is cancelled by user CANCEL_APPROVAL = Waiting for approval to cancel the order 
 * @export
 * @enum {string}
 */

export const SaleOrderStatusEnum = {
    Draft: 'DRAFT',
    New: 'NEW',
    WaitingForConfirmation: 'WAITING_FOR_CONFIRMATION',
    Confirmed: 'CONFIRMED',
    ReadyToPickUp: 'READY_TO_PICK_UP',
    Delivering: 'DELIVERING',
    FullDelivered: 'FULL_DELIVERED',
    PartiallyDelivered: 'PARTIALLY_DELIVERED',
    Completed: 'COMPLETED',
    Cancelled: 'CANCELLED',
    CancelApproval: 'CANCEL_APPROVAL'
} as const;

export type SaleOrderStatusEnum = typeof SaleOrderStatusEnum[keyof typeof SaleOrderStatusEnum];


/**
 * Enum for History SawitPoin list filter
 * @export
 * @enum {string}
 */

export const SawitpoinHistoryTypeEnum = {
    All: 'ALL',
    Campaign: 'CAMPAIGN',
    Quest: 'QUEST',
    Payment: 'PAYMENT',
    TransferSawitpoin: 'TRANSFER_SAWITPOIN',
    Refund: 'REFUND',
    Activity: 'ACTIVITY',
    Referral: 'REFERRAL',
    RegisterUser: 'REGISTER_USER',
    Other: 'OTHER'
} as const;

export type SawitpoinHistoryTypeEnum = typeof SawitpoinHistoryTypeEnum[keyof typeof SawitpoinHistoryTypeEnum];


/**
 * 
 * @export
 * @interface SawitpoinRedistributionCreateRequest
 */
export interface SawitpoinRedistributionCreateRequest {
    /**
     * Sharing percentage from DO to sub-agents
     * @type {number}
     * @memberof SawitpoinRedistributionCreateRequest
     */
    'percentage': number;
    /**
     * Id user of supplier owner
     * @type {string}
     * @memberof SawitpoinRedistributionCreateRequest
     */
    'userId': string;
    /**
     * Start date of redistribution in unix timestamp
     * @type {number}
     * @memberof SawitpoinRedistributionCreateRequest
     */
    'startDate'?: number;
    /**
     * End date of redistribution in unix timestamp
     * @type {number}
     * @memberof SawitpoinRedistributionCreateRequest
     */
    'endDate'?: number;
    /**
     * Estimation of sawitpoin
     * @type {number}
     * @memberof SawitpoinRedistributionCreateRequest
     */
    'estimationPoint'?: number;
}
/**
 * 
 * @export
 * @interface SawitpoinRedistributionDetailResponse
 */
export interface SawitpoinRedistributionDetailResponse {
    /**
     * List of sub-agent with detail supply
     * @type {Array<SawitpoinRedistributionDetailResponseItem>}
     * @memberof SawitpoinRedistributionDetailResponse
     */
    'items': Array<SawitpoinRedistributionDetailResponseItem>;
    /**
     * Total supply in kg
     * @type {number}
     * @memberof SawitpoinRedistributionDetailResponse
     */
    'totalSupply': number;
    /**
     * Total sawitpoin achieved
     * @type {number}
     * @memberof SawitpoinRedistributionDetailResponse
     */
    'totalPoint': number;
}
/**
 * 
 * @export
 * @interface SawitpoinRedistributionDetailResponseItem
 */
export interface SawitpoinRedistributionDetailResponseItem {
    /**
     * Code of sub-agent
     * @type {string}
     * @memberof SawitpoinRedistributionDetailResponseItem
     */
    'subAgentCode': string;
    /**
     * Name of the sub-agent
     * @type {string}
     * @memberof SawitpoinRedistributionDetailResponseItem
     */
    'subAgentName': string;
    /**
     * Supply in kg
     * @type {number}
     * @memberof SawitpoinRedistributionDetailResponseItem
     */
    'subAgentSupply': number;
    /**
     * Percentage of achievement
     * @type {number}
     * @memberof SawitpoinRedistributionDetailResponseItem
     */
    'subAgentAchieved': number;
    /**
     * Sawitpoin achieved
     * @type {number}
     * @memberof SawitpoinRedistributionDetailResponseItem
     */
    'subAgentPoint': number;
    /**
     * 
     * @type {SubAgentStatusEnum}
     * @memberof SawitpoinRedistributionDetailResponseItem
     */
    'subAgentStatus': SubAgentStatusEnum;
    /**
     * The lable of status that FE will show. Currently using Indonesian language
     * @type {string}
     * @memberof SawitpoinRedistributionDetailResponseItem
     */
    'subAgentStatusLabel': string;
}


/**
 * 
 * @export
 * @interface SawitpoinRedistributionEditRequest
 */
export interface SawitpoinRedistributionEditRequest {
    /**
     * Start date of redistribution in unix timestamp
     * @type {number}
     * @memberof SawitpoinRedistributionEditRequest
     */
    'startDate'?: number;
    /**
     * End date of redistribution in unix timestamp
     * @type {number}
     * @memberof SawitpoinRedistributionEditRequest
     */
    'endDate'?: number;
    /**
     * Sharing percentage from DO to sub-agents
     * @type {number}
     * @memberof SawitpoinRedistributionEditRequest
     */
    'percentage': number;
    /**
     * Estimation of sawitpoin
     * @type {number}
     * @memberof SawitpoinRedistributionEditRequest
     */
    'estimationPoint'?: number;
}
/**
 * 
 * @export
 * @interface SawitpoinRedistributionEditResponse
 */
export interface SawitpoinRedistributionEditResponse {
    /**
     * Start date of redistribution in unix timestamp
     * @type {number}
     * @memberof SawitpoinRedistributionEditResponse
     */
    'startDate': number;
    /**
     * End date of redistribution in unix timestamp
     * @type {number}
     * @memberof SawitpoinRedistributionEditResponse
     */
    'endDate': number;
    /**
     * Sharing percentage from DO to sub-agents
     * @type {number}
     * @memberof SawitpoinRedistributionEditResponse
     */
    'percentage': number;
    /**
     * Estimation of sawitpoin
     * @type {number}
     * @memberof SawitpoinRedistributionEditResponse
     */
    'estimationPoint': number;
}
/**
 * 
 * @export
 * @interface SawitpoinRedistributionListResponse
 */
export interface SawitpoinRedistributionListResponse {
    /**
     * List of redistribution
     * @type {Array<SawitpoinRedistributionListResponseItem>}
     * @memberof SawitpoinRedistributionListResponse
     */
    'items': Array<SawitpoinRedistributionListResponseItem>;
}
/**
 * 
 * @export
 * @interface SawitpoinRedistributionListResponseItem
 */
export interface SawitpoinRedistributionListResponseItem {
    /**
     * Id of redistribution
     * @type {string}
     * @memberof SawitpoinRedistributionListResponseItem
     */
    'id': string;
    /**
     * End date of redistribution in unix timestamp
     * @type {number}
     * @memberof SawitpoinRedistributionListResponseItem
     */
    'endDate': number;
    /**
     * Total sub-agents
     * @type {number}
     * @memberof SawitpoinRedistributionListResponseItem
     */
    'totalSubAgent': number;
    /**
     * Sharing percentage from DO to sub-agents
     * @type {number}
     * @memberof SawitpoinRedistributionListResponseItem
     */
    'percentage': number;
    /**
     * Estimation of sawitpoin
     * @type {number}
     * @memberof SawitpoinRedistributionListResponseItem
     */
    'estimationPoint': number;
    /**
     * Total sawitpoin has been shared to sub-agent
     * @type {number}
     * @memberof SawitpoinRedistributionListResponseItem
     */
    'sharedPoint': number;
    /**
     * 
     * @type {RedistributionStatusEnum}
     * @memberof SawitpoinRedistributionListResponseItem
     */
    'status': RedistributionStatusEnum;
    /**
     * Label of redistribution status
     * @type {string}
     * @memberof SawitpoinRedistributionListResponseItem
     */
    'statusLabel': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ScreenEnum = {
    Home: 'HOME',
    Profile: 'PROFILE',
    Shop: 'SHOP'
} as const;

export type ScreenEnum = typeof ScreenEnum[keyof typeof ScreenEnum];


/**
 * List of palm seed that allowed
 * @export
 * @enum {string}
 */

export const SeedTypeEnum = {
    Tenera: 'Tenera',
    Dura: 'Dura',
    Pisifera: 'Pisifera',
    KombinasiMayoritasDura: 'Kombinasi (Mayoritas Dura)',
    KombinasiMayoritasPisifera: 'Kombinasi (Mayoritas Pisifera)',
    KombinasiMayoritasTenera: 'Kombinasi (Mayoritas Tenera)',
    TidakDiketahui: 'Tidak Diketahui'
} as const;

export type SeedTypeEnum = typeof SeedTypeEnum[keyof typeof SeedTypeEnum];


/**
 * 
 * @export
 * @interface ShareCreateShareReferralRequest
 */
export interface ShareCreateShareReferralRequest {
    /**
     * https://cloud.storage.com/referrals/mission001.png
     * @type {string}
     * @memberof ShareCreateShareReferralRequest
     */
    'imageUrl'?: string;
    /**
     * source of referral activities
     * @type {string}
     * @memberof ShareCreateShareReferralRequest
     */
    'source': string;
}
/**
 * 
 * @export
 * @interface ShareCreateShareReferralResponse
 */
export interface ShareCreateShareReferralResponse {
    /**
     * redirect url of referral webview page
     * @type {string}
     * @memberof ShareCreateShareReferralResponse
     */
    'redirectUrl': string;
}
/**
 * 
 * @export
 * @interface ShareGetShareReferralResponse
 */
export interface ShareGetShareReferralResponse {
    /**
     * https://cloud.storage.com/referrals/mission001.png
     * @type {string}
     * @memberof ShareGetShareReferralResponse
     */
    'imageUrl': string;
    /**
     * list of missions related to the referral
     * @type {Array<string>}
     * @memberof ShareGetShareReferralResponse
     */
    'missions': Array<string>;
    /**
     * 
     * @type {Array<ShareGetShareReferralResponseReward>}
     * @memberof ShareGetShareReferralResponse
     */
    'rewards': Array<ShareGetShareReferralResponseReward>;
    /**
     * referral code concatenated with source
     * @type {string}
     * @memberof ShareGetShareReferralResponse
     */
    'referralCode': string;
    /**
     * 
     * @type {AppTypeEnum}
     * @memberof ShareGetShareReferralResponse
     */
    'appType': AppTypeEnum;
    /**
     * web page title
     * @type {string}
     * @memberof ShareGetShareReferralResponse
     */
    'title': string;
    /**
     * Description of the page
     * @type {string}
     * @memberof ShareGetShareReferralResponse
     */
    'description': string;
    /**
     * Custom message for share the referral
     * @type {string}
     * @memberof ShareGetShareReferralResponse
     */
    'customMessage'?: string;
}


/**
 * 
 * @export
 * @interface ShareGetShareReferralResponseReward
 */
export interface ShareGetShareReferralResponseReward {
    /**
     * nominal of the reward
     * @type {number}
     * @memberof ShareGetShareReferralResponseReward
     */
    'value': number;
    /**
     * 
     * @type {RewardTypeEnum}
     * @memberof ShareGetShareReferralResponseReward
     */
    'type': RewardTypeEnum;
}


/**
 * 
 * @export
 * @interface ShippingCostCalculateRequest
 */
export interface ShippingCostCalculateRequest {
    /**
     * Store ID
     * @type {string}
     * @memberof ShippingCostCalculateRequest
     */
    'storeId'?: string;
    /**
     * total weight of product
     * @type {number}
     * @memberof ShippingCostCalculateRequest
     */
    'totalWeight': number;
    /**
     * Origin Stock Location City
     * @type {string}
     * @memberof ShippingCostCalculateRequest
     */
    'originCity': string;
    /**
     * Origin Stock Location District
     * @type {string}
     * @memberof ShippingCostCalculateRequest
     */
    'originDistrict': string;
    /**
     * Destination Stock Location City
     * @type {string}
     * @memberof ShippingCostCalculateRequest
     */
    'destinationCity': string;
    /**
     * Destination Stock Location District
     * @type {string}
     * @memberof ShippingCostCalculateRequest
     */
    'destinationDistrict': string;
}
/**
 * 
 * @export
 * @interface ShippingCostCalculateResponse
 */
export interface ShippingCostCalculateResponse {
    /**
     * Total Shipping Cost in Rupiah
     * @type {number}
     * @memberof ShippingCostCalculateResponse
     */
    'totalShippingCost': number;
    /**
     * pricePerKg
     * @type {number}
     * @memberof ShippingCostCalculateResponse
     */
    'pricePerKg': number;
}
/**
 * 
 * @export
 * @interface ShippingCostCalculateV2Request
 */
export interface ShippingCostCalculateV2Request {
    /**
     * 
     * @type {Array<ShippingCostCalculateV2RequestItem>}
     * @memberof ShippingCostCalculateV2Request
     */
    'items': Array<ShippingCostCalculateV2RequestItem>;
    /**
     * Destination Stock Location City
     * @type {string}
     * @memberof ShippingCostCalculateV2Request
     */
    'destinationCity': string;
    /**
     * Destination Stock Location District
     * @type {string}
     * @memberof ShippingCostCalculateV2Request
     */
    'destinationDistrict': string;
}
/**
 * 
 * @export
 * @interface ShippingCostCalculateV2RequestItem
 */
export interface ShippingCostCalculateV2RequestItem {
    /**
     * id of product
     * @type {string}
     * @memberof ShippingCostCalculateV2RequestItem
     */
    'productId': string;
    /**
     * id of store
     * @type {string}
     * @memberof ShippingCostCalculateV2RequestItem
     */
    'storeId': string;
    /**
     * number of products
     * @type {number}
     * @memberof ShippingCostCalculateV2RequestItem
     */
    'quantity': number;
}
/**
 * 
 * @export
 * @interface ShippingCostCalculateV2Response
 */
export interface ShippingCostCalculateV2Response {
    /**
     * Total Shipping Cost in Rupiah
     * @type {number}
     * @memberof ShippingCostCalculateV2Response
     */
    'totalShippingCost': number;
    /**
     * pricePerKg
     * @type {number}
     * @memberof ShippingCostCalculateV2Response
     */
    'pricePerKg': number;
    /**
     * Origin city of store that provide the product
     * @type {string}
     * @memberof ShippingCostCalculateV2Response
     */
    'storeOriginCity': string;
    /**
     * Origin district of store that provide the product
     * @type {string}
     * @memberof ShippingCostCalculateV2Response
     */
    'storeOriginDistrict': string;
    /**
     * 
     * @type {Array<ShippingCostCalculateV2ResponseUnavailableItem>}
     * @memberof ShippingCostCalculateV2Response
     */
    'unavailableItems'?: Array<ShippingCostCalculateV2ResponseUnavailableItem>;
}
/**
 * 
 * @export
 * @interface ShippingCostCalculateV2ResponseUnavailableItem
 */
export interface ShippingCostCalculateV2ResponseUnavailableItem {
    /**
     * 
     * @type {string}
     * @memberof ShippingCostCalculateV2ResponseUnavailableItem
     */
    'productId': string;
    /**
     * 
     * @type {string}
     * @memberof ShippingCostCalculateV2ResponseUnavailableItem
     */
    'storeId': string;
}
/**
 * describe the soil type
 * @export
 * @enum {string}
 */

export const SoilTypeEnum = {
    Mineral: 'Mineral',
    Gambut: 'Gambut',
    Liat: 'Liat',
    Berpasir: 'Berpasir',
    SulfatMasam: 'Sulfat Masam',
    TidakDiketahui: 'Tidak Diketahui'
} as const;

export type SoilTypeEnum = typeof SoilTypeEnum[keyof typeof SoilTypeEnum];


/**
 * BOOKED = booking is created by user but booking\'s order not yet paid PAID = booking\'s order is already paid CANCELED = booking\'s order not yet paid & expired WAITING_FOR_SUMMARY = service has been done & wait for summary by admin or doctor DONE = summary is available 
 * @export
 * @enum {string}
 */

export const StatusAgronomistBookingEnum = {
    Booked: 'BOOKED',
    Paid: 'PAID',
    Canceled: 'CANCELED',
    WaitingForSummary: 'WAITING_FOR_SUMMARY',
    Done: 'DONE'
} as const;

export type StatusAgronomistBookingEnum = typeof StatusAgronomistBookingEnum[keyof typeof StatusAgronomistBookingEnum];


/**
 * UPCOMING = agronomy consultation that already paid but the schedule is still ahead WAITING_FOR_PAYMENT = agronomy consultation is still haven\'t paid, booking with this status will linked to payment page INPROGRESS = agronomy consultation is ongoing, user can get the link of the zoom when this event status happen DONE = agronomy consultation booking is already done 
 * @export
 * @enum {string}
 */

export const StatusAgronomistEventBookingEnum = {
    Upcoming: 'UPCOMING',
    WaitingForPayment: 'WAITING_FOR_PAYMENT',
    Inprogress: 'INPROGRESS',
    Done: 'DONE'
} as const;

export type StatusAgronomistEventBookingEnum = typeof StatusAgronomistEventBookingEnum[keyof typeof StatusAgronomistEventBookingEnum];


/**
 * 
 * @export
 * @interface StatusBadRequestErrorResponse
 */
export interface StatusBadRequestErrorResponse {
    /**
     * 
     * @type {string}
     * @memberof StatusBadRequestErrorResponse
     */
    'error': string;
}
/**
 * 
 * @export
 * @interface StatusConflictErrorResponseYaml
 */
export interface StatusConflictErrorResponseYaml {
    /**
     * Message explaining error that happened
     * @type {string}
     * @memberof StatusConflictErrorResponseYaml
     */
    'error': string;
}
/**
 * 
 * @export
 * @interface StatusDataNotFoundErrorResponse
 */
export interface StatusDataNotFoundErrorResponse {
    /**
     * 
     * @type {string}
     * @memberof StatusDataNotFoundErrorResponse
     */
    'error': string;
}
/**
 * 
 * @export
 * @interface StatusForbiddenErrorResponse
 */
export interface StatusForbiddenErrorResponse {
    /**
     * Message explaining error that happened
     * @type {string}
     * @memberof StatusForbiddenErrorResponse
     */
    'error': string;
}
/**
 * 
 * @export
 * @interface StatusNotFoundErrorResponse
 */
export interface StatusNotFoundErrorResponse {
    /**
     * Message explaining error that happened
     * @type {string}
     * @memberof StatusNotFoundErrorResponse
     */
    'error': string;
}
/**
 * 
 * @export
 * @interface StatusUnauthorizedErrorResponse
 */
export interface StatusUnauthorizedErrorResponse {
    /**
     * Message explaining the error that happened
     * @type {string}
     * @memberof StatusUnauthorizedErrorResponse
     */
    'error': string;
}
/**
 * 
 * @export
 * @interface StatusUnprocessableEntityErrorResponse
 */
export interface StatusUnprocessableEntityErrorResponse {
    /**
     * Message explaining error that happened
     * @type {string}
     * @memberof StatusUnprocessableEntityErrorResponse
     */
    'error': string;
}
/**
 * Enum product status
 * @export
 * @enum {string}
 */

export const StockLocationStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE'
} as const;

export type StockLocationStatusEnum = typeof StockLocationStatusEnum[keyof typeof StockLocationStatusEnum];


/**
 * Response data
 * @export
 * @interface StoresListResponse
 */
export interface StoresListResponse {
    /**
     * List of store item
     * @type {Array<StoresListResponseItem>}
     * @memberof StoresListResponse
     */
    'items': Array<StoresListResponseItem>;
}
/**
 * 
 * @export
 * @interface StoresListResponseItem
 */
export interface StoresListResponseItem {
    /**
     * Store UUID
     * @type {string}
     * @memberof StoresListResponseItem
     */
    'id': string;
    /**
     * Store Name
     * @type {string}
     * @memberof StoresListResponseItem
     */
    'name': string;
    /**
     * Legal Name
     * @type {string}
     * @memberof StoresListResponseItem
     */
    'legalName': string;
    /**
     * Mill Name
     * @type {string}
     * @memberof StoresListResponseItem
     */
    'millName': string;
    /**
     * Store Address
     * @type {string}
     * @memberof StoresListResponseItem
     */
    'address': string;
    /**
     * Store Longitude
     * @type {number}
     * @memberof StoresListResponseItem
     */
    'longitude': number;
    /**
     * Store Latitude
     * @type {number}
     * @memberof StoresListResponseItem
     */
    'latitude': number;
    /**
     * Store Distance in KM
     * @type {number}
     * @memberof StoresListResponseItem
     */
    'distance': number;
    /**
     * 
     * @type {DeliveryEnum}
     * @memberof StoresListResponseItem
     */
    'deliveryType': DeliveryEnum;
    /**
     * 
     * @type {Array<DeliveryEnum>}
     * @memberof StoresListResponseItem
     */
    'deliveryTypes': Array<DeliveryEnum>;
}


/**
 * 
 * @export
 * @interface StoresListV2ResponseItem
 */
export interface StoresListV2ResponseItem {
    /**
     * Store UUID
     * @type {string}
     * @memberof StoresListV2ResponseItem
     */
    'id': string;
    /**
     * Store Name
     * @type {string}
     * @memberof StoresListV2ResponseItem
     */
    'name': string;
    /**
     * Legal Name
     * @type {string}
     * @memberof StoresListV2ResponseItem
     */
    'legalName': string;
    /**
     * Mill Name
     * @type {string}
     * @memberof StoresListV2ResponseItem
     */
    'millName': string;
    /**
     * Store Address
     * @type {string}
     * @memberof StoresListV2ResponseItem
     */
    'address': string;
    /**
     * Store Longitude
     * @type {number}
     * @memberof StoresListV2ResponseItem
     */
    'longitude': number;
    /**
     * Store Latitude
     * @type {number}
     * @memberof StoresListV2ResponseItem
     */
    'latitude': number;
    /**
     * Store Distance in KM
     * @type {number}
     * @memberof StoresListV2ResponseItem
     */
    'distance': number;
    /**
     * Store City
     * @type {string}
     * @memberof StoresListV2ResponseItem
     */
    'city': string;
    /**
     * Store Province
     * @type {string}
     * @memberof StoresListV2ResponseItem
     */
    'province': string;
    /**
     * Store District
     * @type {string}
     * @memberof StoresListV2ResponseItem
     */
    'district': string;
}
/**
 * 
 * @export
 * @interface StoresListV3ResponseItem
 */
export interface StoresListV3ResponseItem {
    /**
     * Store UUID
     * @type {string}
     * @memberof StoresListV3ResponseItem
     */
    'id': string;
    /**
     * Store Name
     * @type {string}
     * @memberof StoresListV3ResponseItem
     */
    'name': string;
    /**
     * Legal Name
     * @type {string}
     * @memberof StoresListV3ResponseItem
     */
    'legalName': string;
    /**
     * Mill Name
     * @type {string}
     * @memberof StoresListV3ResponseItem
     */
    'millName': string;
    /**
     * Store Address
     * @type {string}
     * @memberof StoresListV3ResponseItem
     */
    'address': string;
    /**
     * Store Longitude
     * @type {number}
     * @memberof StoresListV3ResponseItem
     */
    'longitude': number;
    /**
     * Store Latitude
     * @type {number}
     * @memberof StoresListV3ResponseItem
     */
    'latitude': number;
    /**
     * Store Distance in KM
     * @type {number}
     * @memberof StoresListV3ResponseItem
     */
    'distance': number;
    /**
     * Store City
     * @type {string}
     * @memberof StoresListV3ResponseItem
     */
    'city': string;
    /**
     * Store Province
     * @type {string}
     * @memberof StoresListV3ResponseItem
     */
    'province': string;
    /**
     * Store District
     * @type {string}
     * @memberof StoresListV3ResponseItem
     */
    'district': string;
}
/**
 * 
 * @export
 * @interface SubAgentCreateRequest
 */
export interface SubAgentCreateRequest {
    /**
     * ID of supplier in UUID type
     * @type {string}
     * @memberof SubAgentCreateRequest
     */
    'supplierId': string;
    /**
     * Name of sub-agent
     * @type {string}
     * @memberof SubAgentCreateRequest
     */
    'subAgentName'?: string;
    /**
     * 
     * @type {CollectorTypeEnum}
     * @memberof SubAgentCreateRequest
     */
    'subAgentType': CollectorTypeEnum;
    /**
     * Encrypted phoneNumber using RSA256 with public key that\'s retrieved from local database
     * @type {string}
     * @memberof SubAgentCreateRequest
     */
    'subAgentPhone': string;
}


/**
 * 
 * @export
 * @interface SubAgentCreateResponse
 */
export interface SubAgentCreateResponse {
    /**
     * Sub-agent UUID
     * @type {string}
     * @memberof SubAgentCreateResponse
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface SubAgentListResponse
 */
export interface SubAgentListResponse {
    /**
     * List of sub-agent
     * @type {Array<SubAgentListResponseItem>}
     * @memberof SubAgentListResponse
     */
    'items': Array<SubAgentListResponseItem>;
}
/**
 * 
 * @export
 * @interface SubAgentListResponseItem
 */
export interface SubAgentListResponseItem {
    /**
     * Sub-agent UUID
     * @type {string}
     * @memberof SubAgentListResponseItem
     */
    'id': string;
    /**
     * Code of sub-agent
     * @type {string}
     * @memberof SubAgentListResponseItem
     */
    'subAgentCode': string;
    /**
     * Name of sub-agent
     * @type {string}
     * @memberof SubAgentListResponseItem
     */
    'subAgentName': string;
    /**
     * 
     * @type {CollectorTypeEnum}
     * @memberof SubAgentListResponseItem
     */
    'subAgentType': CollectorTypeEnum;
    /**
     * Label of sub-agent type
     * @type {string}
     * @memberof SubAgentListResponseItem
     */
    'subAgentTypeLabel': string;
    /**
     * Phone number of subagent
     * @type {string}
     * @memberof SubAgentListResponseItem
     */
    'subAgentPhone': string;
    /**
     * 
     * @type {SubAgentStatusEnum}
     * @memberof SubAgentListResponseItem
     */
    'status': SubAgentStatusEnum;
    /**
     * Label of sub-agent status
     * @type {string}
     * @memberof SubAgentListResponseItem
     */
    'statusLabel': string;
    /**
     * Total sub-agents truck
     * @type {number}
     * @memberof SubAgentListResponseItem
     */
    'totalTruck': number;
}


/**
 * Status of the sub-agent
 * @export
 * @enum {string}
 */

export const SubAgentStatusEnum = {
    Active: 'ACTIVE',
    Pending: 'PENDING'
} as const;

export type SubAgentStatusEnum = typeof SubAgentStatusEnum[keyof typeof SubAgentStatusEnum];


/**
 * 
 * @export
 * @interface SubAgentTruckCreateRequest
 */
export interface SubAgentTruckCreateRequest {
    /**
     * Plat no of truck
     * @type {string}
     * @memberof SubAgentTruckCreateRequest
     */
    'platNo': string;
    /**
     * Code of sub-agent
     * @type {string}
     * @memberof SubAgentTruckCreateRequest
     */
    'subAgentCode': string;
}
/**
 * 
 * @export
 * @interface SubAgentTruckListResponse
 */
export interface SubAgentTruckListResponse {
    /**
     * List of truck sub-agent
     * @type {Array<SubAgentTruckListResponseItem>}
     * @memberof SubAgentTruckListResponse
     */
    'items': Array<SubAgentTruckListResponseItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof SubAgentTruckListResponse
     */
    'pagination': PaginationResponse;
}
/**
 * 
 * @export
 * @interface SubAgentTruckListResponseItem
 */
export interface SubAgentTruckListResponseItem {
    /**
     * Id of sub-agent - truck
     * @type {string}
     * @memberof SubAgentTruckListResponseItem
     */
    'id'?: string;
    /**
     * Plat no of truck
     * @type {string}
     * @memberof SubAgentTruckListResponseItem
     */
    'platNo': string;
    /**
     * Code of sub-agent
     * @type {string}
     * @memberof SubAgentTruckListResponseItem
     */
    'subAgentCode': string;
    /**
     * Name of the sub-agent
     * @type {string}
     * @memberof SubAgentTruckListResponseItem
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface SubagentDailyPriceListResponse
 */
export interface SubagentDailyPriceListResponse {
    /**
     * List of sub-agent daily price
     * @type {Array<SubagentDailyPriceListResponseItem>}
     * @memberof SubagentDailyPriceListResponse
     */
    'items': Array<SubagentDailyPriceListResponseItem>;
}
/**
 * 
 * @export
 * @interface SubagentDailyPriceListResponseItem
 */
export interface SubagentDailyPriceListResponseItem {
    /**
     * The id of sub-agent
     * @type {string}
     * @memberof SubagentDailyPriceListResponseItem
     */
    'id': string;
    /**
     * The code of sub-agent
     * @type {string}
     * @memberof SubagentDailyPriceListResponseItem
     */
    'subagentCode': string;
    /**
     * The name of sub-agent
     * @type {string}
     * @memberof SubagentDailyPriceListResponseItem
     */
    'subagentName': string;
    /**
     * Daily price of each sub-agent
     * @type {number}
     * @memberof SubagentDailyPriceListResponseItem
     */
    'price': number;
}
/**
 * 
 * @export
 * @interface SubagentDailyPriceSaveRequest
 */
export interface SubagentDailyPriceSaveRequest {
    /**
     * The date for this subagent daily prices
     * @type {number}
     * @memberof SubagentDailyPriceSaveRequest
     */
    'date': number;
    /**
     * 
     * @type {Array<SubagentDailyPriceSaveRequestItem>}
     * @memberof SubagentDailyPriceSaveRequest
     */
    'subagents': Array<SubagentDailyPriceSaveRequestItem>;
}
/**
 * 
 * @export
 * @interface SubagentDailyPriceSaveRequestItem
 */
export interface SubagentDailyPriceSaveRequestItem {
    /**
     * The id of the Sub Agent
     * @type {string}
     * @memberof SubagentDailyPriceSaveRequestItem
     */
    'id': string;
    /**
     * The daily price for subagent\'s delivery
     * @type {number}
     * @memberof SubagentDailyPriceSaveRequestItem
     */
    'price': number;
}
/**
 * 
 * @export
 * @interface SubagentDailySupplyCostsResponse
 */
export interface SubagentDailySupplyCostsResponse {
    /**
     * Id of weighbridge. there will be null when create
     * @type {string}
     * @memberof SubagentDailySupplyCostsResponse
     */
    'id': string;
    /**
     * Date of weighbridge
     * @type {number}
     * @memberof SubagentDailySupplyCostsResponse
     */
    'deliveryDate': number;
    /**
     * The weighbridge ticket number
     * @type {string}
     * @memberof SubagentDailySupplyCostsResponse
     */
    'ticketNo': string;
    /**
     * The truck plat no that sent the delivery of the weighbridge
     * @type {string}
     * @memberof SubagentDailySupplyCostsResponse
     */
    'truckNo': string;
    /**
     * The net weight (in kg) of the delivery
     * @type {number}
     * @memberof SubagentDailySupplyCostsResponse
     */
    'netWeight': number;
    /**
     * Id of sub-agent
     * @type {string}
     * @memberof SubagentDailySupplyCostsResponse
     */
    'subagentId': string;
    /**
     * 
     * @type {Array<GetListLoyaltyWeighbridgeCostResponseItem>}
     * @memberof SubagentDailySupplyCostsResponse
     */
    'costs': Array<GetListLoyaltyWeighbridgeCostResponseItem>;
}
/**
 * 
 * @export
 * @interface SubagentDailySupplyCreateRequest
 */
export interface SubagentDailySupplyCreateRequest {
    /**
     * Id of weighbridge. there will be null when create
     * @type {string}
     * @memberof SubagentDailySupplyCreateRequest
     */
    'id'?: string;
    /**
     * Date of weighbridge
     * @type {number}
     * @memberof SubagentDailySupplyCreateRequest
     */
    'deliveryDate': number;
    /**
     * The weighbridge ticket number
     * @type {string}
     * @memberof SubagentDailySupplyCreateRequest
     */
    'ticketNo': string;
    /**
     * The truck plat no that sent the delivery of the weighbridge
     * @type {string}
     * @memberof SubagentDailySupplyCreateRequest
     */
    'truckNo': string;
    /**
     * The net weight (in kg) of the delivery
     * @type {number}
     * @memberof SubagentDailySupplyCreateRequest
     */
    'netWeight': number;
    /**
     * Id of sub-agent
     * @type {string}
     * @memberof SubagentDailySupplyCreateRequest
     */
    'subagentId': string;
    /**
     * 
     * @type {Array<SubagentDailySupplyCreateRequestItem>}
     * @memberof SubagentDailySupplyCreateRequest
     */
    'costs': Array<SubagentDailySupplyCreateRequestItem>;
}
/**
 * 
 * @export
 * @interface SubagentDailySupplyCreateRequestItem
 */
export interface SubagentDailySupplyCreateRequestItem {
    /**
     * Id of supply cost id
     * @type {string}
     * @memberof SubagentDailySupplyCreateRequestItem
     */
    'id': string;
    /**
     * Supply cost
     * @type {number}
     * @memberof SubagentDailySupplyCreateRequestItem
     */
    'cost': number;
}
/**
 * 
 * @export
 * @interface SubagentDailySupplyResponse
 */
export interface SubagentDailySupplyResponse {
    /**
     * Daily price from Mill, will be null if the price has not been filled
     * @type {number}
     * @memberof SubagentDailySupplyResponse
     */
    'millPrice'?: number;
    /**
     * The number of deliveries from the current Supplier
     * @type {number}
     * @memberof SubagentDailySupplyResponse
     */
    'totalDelivery': number;
    /**
     * The total net weight of FFB from the current Supplier
     * @type {number}
     * @memberof SubagentDailySupplyResponse
     */
    'totalNetWeight': number;
    /**
     * The total cash already withdrawn by the subagents from this Supplier
     * @type {number}
     * @memberof SubagentDailySupplyResponse
     */
    'totalSubagentDisbursement': number;
    /**
     * The total cash already withdrawn from the mill by this Supplier. Will be returned 0 if the price for each subagents has not been filled.
     * @type {number}
     * @memberof SubagentDailySupplyResponse
     */
    'totalMillDisbursement': number;
    /**
     * The total net income of the current Supplier. Will be returned 0 if the price for each subagents has not been filled.
     * @type {number}
     * @memberof SubagentDailySupplyResponse
     */
    'totalNetIncome': number;
    /**
     * 
     * @type {Array<SubagentDailySupplyResponseItem>}
     * @memberof SubagentDailySupplyResponse
     */
    'dailySupplies': Array<SubagentDailySupplyResponseItem>;
}
/**
 * 
 * @export
 * @interface SubagentDailySupplyResponseItem
 */
export interface SubagentDailySupplyResponseItem {
    /**
     * Id of weighbridge
     * @type {string}
     * @memberof SubagentDailySupplyResponseItem
     */
    'weighbridgeTicketId': string;
    /**
     * The weighbridge ticket number
     * @type {string}
     * @memberof SubagentDailySupplyResponseItem
     */
    'ticketNo': string;
    /**
     * The truck plat no that sent the delivery of the weighbridge
     * @type {string}
     * @memberof SubagentDailySupplyResponseItem
     */
    'truckNo': string;
    /**
     * The net weight (in kg) of the delivery
     * @type {number}
     * @memberof SubagentDailySupplyResponseItem
     */
    'netWeight': number;
    /**
     * The code of the Sub Agent
     * @type {string}
     * @memberof SubagentDailySupplyResponseItem
     */
    'subagentCode': string;
    /**
     * The name of the Sub Agent
     * @type {string}
     * @memberof SubagentDailySupplyResponseItem
     */
    'subagentName': string;
    /**
     * The price given for subagent\'s delivery
     * @type {number}
     * @memberof SubagentDailySupplyResponseItem
     */
    'subagentSellingPrice': number;
    /**
     * The amount of money disbursed to the specific subagent
     * @type {number}
     * @memberof SubagentDailySupplyResponseItem
     */
    'disbursement': number;
    /**
     * Date of weighbridge
     * @type {number}
     * @memberof SubagentDailySupplyResponseItem
     */
    'deliveryDate': number;
    /**
     * Weighbridge creator
     * @type {string}
     * @memberof SubagentDailySupplyResponseItem
     */
    'createdBy': string;
}
/**
 * 
 * @export
 * @interface SubagentMonthlySupplyResponse
 */
export interface SubagentMonthlySupplyResponse {
    /**
     * The total net weight of FFB from the current Supplier
     * @type {number}
     * @memberof SubagentMonthlySupplyResponse
     */
    'totalNetWeight': number;
    /**
     * Total earning before tax, will be null if the mill price hasn\'t set
     * @type {number}
     * @memberof SubagentMonthlySupplyResponse
     */
    'totalGross'?: number;
    /**
     * Total tax based on the earning, will be null if the mill price hasn\'t set
     * @type {number}
     * @memberof SubagentMonthlySupplyResponse
     */
    'totalTax'?: number;
    /**
     * The total net income of the current Supplier, will be null if the mill price hasn\'t set
     * @type {number}
     * @memberof SubagentMonthlySupplyResponse
     */
    'totalNetIncome'?: number;
    /**
     * 
     * @type {Array<SubagentMonthlySupplyResponseItem>}
     * @memberof SubagentMonthlySupplyResponse
     */
    'dailySupplies': Array<SubagentMonthlySupplyResponseItem>;
}
/**
 * 
 * @export
 * @interface SubagentMonthlySupplyResponseItem
 */
export interface SubagentMonthlySupplyResponseItem {
    /**
     * The date of the supply (in epoch)
     * @type {number}
     * @memberof SubagentMonthlySupplyResponseItem
     */
    'date': number;
    /**
     * The net weight (in kg) of the delivery
     * @type {number}
     * @memberof SubagentMonthlySupplyResponseItem
     */
    'netWeight': number;
    /**
     * FFB price from the mill, will be null if not exists
     * @type {number}
     * @memberof SubagentMonthlySupplyResponseItem
     */
    'millPrice'?: number;
    /**
     * The total gross before tax, will be null if the mill price hasn\'t set
     * @type {number}
     * @memberof SubagentMonthlySupplyResponseItem
     */
    'totalGross'?: number;
    /**
     * The total net after tax, will be null if the mill price hasn\'t set
     * @type {number}
     * @memberof SubagentMonthlySupplyResponseItem
     */
    'totalNet'?: number;
}
/**
 * Status of the Supplier whether they already participate on the same ongoing campaign type
 * @export
 * @enum {string}
 */

export const SupplierCampaignStatusEnum = {
    Available: 'AVAILABLE',
    NotAvailable: 'NOT_AVAILABLE'
} as const;

export type SupplierCampaignStatusEnum = typeof SupplierCampaignStatusEnum[keyof typeof SupplierCampaignStatusEnum];


/**
 * 
 * @export
 * @interface SupplierDailyPriceCreateRequest
 */
export interface SupplierDailyPriceCreateRequest {
    /**
     * The mill\'s (partner) daily price for the current supplier
     * @type {number}
     * @memberof SupplierDailyPriceCreateRequest
     */
    'price': number;
    /**
     * The date of the price (in epoch) with the time set to 0
     * @type {number}
     * @memberof SupplierDailyPriceCreateRequest
     */
    'date': number;
}
/**
 * 
 * @export
 * @interface SurveyCreateRequest
 */
export interface SurveyCreateRequest {
    /**
     * Survey ID is generated by Android\'s app in order to store data in sqlite while working offline.
     * @type {string}
     * @memberof SurveyCreateRequest
     */
    'surveyId': string;
    /**
     * Surveyor ID from person who conducts a survey.
     * @type {string}
     * @memberof SurveyCreateRequest
     */
    'surveyorId': string;
    /**
     * Farm owner name. It will be used as identification for member name.
     * @type {string}
     * @memberof SurveyCreateRequest
     */
    'name': string;
    /**
     * Allowed mill ID where FFB can be sent.
     * @type {string}
     * @memberof SurveyCreateRequest
     */
    'millId': string;
    /**
     * external reference id that belongs to geolocation entity (ex:sap do id from delivery order attached to this entity).
     * @type {string}
     * @memberof SurveyCreateRequest
     */
    'externalId'?: string;
    /**
     * Delivery Order Name. it will be used as delivery order identification of the survey data.
     * @type {string}
     * @memberof SurveyCreateRequest
     */
    'doName'?: string;
    /**
     * Delivery order id that farmers belong to.
     * @type {string}
     * @memberof SurveyCreateRequest
     */
    'doId'?: string;
    /**
     * farm group association id that belong to CSV.
     * @type {string}
     * @memberof SurveyCreateRequest
     */
    'farmGroupAssociationId'?: string;
    /**
     * If farm group association is not found, fill the name into the survey data in this field, if found you can leave this field empty.
     * @type {string}
     * @memberof SurveyCreateRequest
     */
    'farmGroupAssociationName'?: string;
    /**
     * farm group id that belong to farm group association.
     * @type {string}
     * @memberof SurveyCreateRequest
     */
    'farmGroupId'?: string;
    /**
     * If farm group is not found, fill the name into the survey data in this field, if found you can leave this field empty.
     * @type {string}
     * @memberof SurveyCreateRequest
     */
    'farmGroupName'?: string;
    /**
     * Encrypted phoneNumber using RSA256 with public key that\'s retrieved from local database
     * @type {string}
     * @memberof SurveyCreateRequest
     */
    'phoneNumber': string;
    /**
     * Hash PIN using HMAC SHA 256
     * @type {string}
     * @memberof SurveyCreateRequest
     */
    'pin': string;
    /**
     * Farm name. It will be used as identification for farm name.
     * @type {string}
     * @memberof SurveyCreateRequest
     */
    'farmName'?: string;
    /**
     * 
     * @type {Village}
     * @memberof SurveyCreateRequest
     */
    'village'?: Village;
    /**
     * Farm area in hectare
     * @type {number}
     * @memberof SurveyCreateRequest
     */
    'farmArea'?: number;
    /**
     * Productive plant area on the farm in hectare. It should not larger than farmArea
     * @type {number}
     * @memberof SurveyCreateRequest
     */
    'productiveFarmArea'?: number;
    /**
     * Non productive plant area on the farm in hectare. It should not larger than farmArea
     * @type {number}
     * @memberof SurveyCreateRequest
     */
    'nonProductiveFarmArea'?: number;
    /**
     * Monthly yield of oil palm FFB in kg.
     * @type {number}
     * @memberof SurveyCreateRequest
     */
    'averageEstateMonthlyYield'?: number;
    /**
     * 
     * @type {EstateLicenseEnum}
     * @memberof SurveyCreateRequest
     */
    'estateLicense'?: EstateLicenseEnum;
    /**
     * 
     * @type {STDBorNIBEnum}
     * @memberof SurveyCreateRequest
     */
    'STDBorNIB'?: STDBorNIBEnum;
    /**
     * 
     * @type {SPPLorAMDALEnum}
     * @memberof SurveyCreateRequest
     */
    'SPPLorAMDAL'?: SPPLorAMDALEnum;
    /**
     * 
     * @type {NonSpatialIssueLocalCommunityRightsEnum}
     * @memberof SurveyCreateRequest
     */
    'localCommunityRightsIssue'?: NonSpatialIssueLocalCommunityRightsEnum;
    /**
     * 
     * @type {NonSpatialIssueWorkerRightsEnum}
     * @memberof SurveyCreateRequest
     */
    'workerRightsIssue'?: NonSpatialIssueWorkerRightsEnum;
    /**
     * 
     * @type {NonSpatialIssueHumanRightsEnum}
     * @memberof SurveyCreateRequest
     */
    'humanRightsIssue'?: NonSpatialIssueHumanRightsEnum;
    /**
     * 
     * @type {NonSpatialIssueIndigenousPeopleRightsEnum}
     * @memberof SurveyCreateRequest
     */
    'indigenousPeopleRightsIssue'?: NonSpatialIssueIndigenousPeopleRightsEnum;
    /**
     * 
     * @type {FarmManagementTypeEnum}
     * @memberof SurveyCreateRequest
     */
    'farmManagementType'?: FarmManagementTypeEnum;
    /**
     * 
     * @type {EmploymentComplianceForCompaniesEnum}
     * @memberof SurveyCreateRequest
     */
    'employmentComplianceForCompanies'?: EmploymentComplianceForCompaniesEnum;
    /**
     * 
     * @type {TaxComplianceForCompaniesEnum}
     * @memberof SurveyCreateRequest
     */
    'taxComplianceForCompanies'?: TaxComplianceForCompaniesEnum;
    /**
     * 
     * @type {EthicsComplianceForCompaniesEnum}
     * @memberof SurveyCreateRequest
     */
    'ethicsComplianceForCompanies'?: EthicsComplianceForCompaniesEnum;
    /**
     * 
     * @type {FarmBuyerAssociationEnum}
     * @memberof SurveyCreateRequest
     */
    'farmBuyerAssociation'?: FarmBuyerAssociationEnum;
    /**
     * 
     * @type {SustainableCertificateEnum}
     * @memberof SurveyCreateRequest
     */
    'sustainableCertificate'?: SustainableCertificateEnum;
    /**
     * Year of planting. Only use single planted year even the farm is polyculture.
     * @type {number}
     * @memberof SurveyCreateRequest
     */
    'plantedYear'?: number;
    /**
     * 
     * @type {SeedTypeEnum}
     * @memberof SurveyCreateRequest
     * @deprecated
     */
    'seedType'?: SeedTypeEnum;
    /**
     * Monthly yield of oil palm FFB in tonnage.
     * @type {number}
     * @memberof SurveyCreateRequest
     */
    'monthlyYieldEstate'?: number;
    /**
     * 
     * @type {NaturalVegetationEnum}
     * @memberof SurveyCreateRequest
     */
    'naturalVegetation'?: NaturalVegetationEnum;
    /**
     * 
     * @type {LandConditionBeforeClearingEnum}
     * @memberof SurveyCreateRequest
     */
    'landConditionBeforeClearing'?: LandConditionBeforeClearingEnum;
    /**
     * 
     * @type {LandClearingMethodEnum}
     * @memberof SurveyCreateRequest
     */
    'landClearingMethod'?: LandClearingMethodEnum;
    /**
     * Containing multiple GeoJSONFeature to represent a farm/farms. Source of data (GPS or drawing) could be represented by GeoJSONFeature
     * @type {Array<GeoJSONFeature>}
     * @memberof SurveyCreateRequest
     */
    'geolocations'?: Array<GeoJSONFeature>;
}


/**
 * 
 * @export
 * @interface SurveyCreateResponse
 */
export interface SurveyCreateResponse {
    /**
     * ID of the newly created survey represented in UUID type 4
     * @type {string}
     * @memberof SurveyCreateResponse
     */
    'id': string;
}
/**
 * List of sustainable certificate that allowed
 * @export
 * @enum {string}
 */

export const SustainableCertificateEnum = {
    Ispo: 'ISPO',
    Rspo: 'RSPO',
    TanpaSertifikasiLestari: 'Tanpa Sertifikasi Lestari'
} as const;

export type SustainableCertificateEnum = typeof SustainableCertificateEnum[keyof typeof SustainableCertificateEnum];


/**
 * 
 * @export
 * @interface SystemTestEventResponse
 */
export interface SystemTestEventResponse {
    /**
     * ID from the event
     * @type {string}
     * @memberof SystemTestEventResponse
     */
    'id'?: string;
    /**
     * Date and time when the event was created
     * @type {string}
     * @memberof SystemTestEventResponse
     */
    'createdAt'?: string;
    /**
     * Message from the event
     * @type {string}
     * @memberof SystemTestEventResponse
     */
    'message'?: string;
    /**
     * ID from the provider
     * @type {string}
     * @memberof SystemTestEventResponse
     */
    'providerId'?: string;
}
/**
 * List of allowed answer for Tax Compliance For Companies
 * @export
 * @enum {string}
 */

export const TaxComplianceForCompaniesEnum = {
    Ada: 'Ada',
    TidakAda: 'Tidak Ada',
    PengelolaanPribadi: 'Pengelolaan Pribadi'
} as const;

export type TaxComplianceForCompaniesEnum = typeof TaxComplianceForCompaniesEnum[keyof typeof TaxComplianceForCompaniesEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const TaxTypeEnum = {
    Personal: 'PERSONAL',
    Organization: 'ORGANIZATION'
} as const;

export type TaxTypeEnum = typeof TaxTypeEnum[keyof typeof TaxTypeEnum];


/**
 * Time Slot Status to tell user whether the timeslot booked, available, or not available
 * @export
 * @enum {string}
 */

export const TimeSlotAvailabilityEnum = {
    Booked: 'BOOKED',
    Available: 'AVAILABLE',
    NotAvailable: 'NOT AVAILABLE'
} as const;

export type TimeSlotAvailabilityEnum = typeof TimeSlotAvailabilityEnum[keyof typeof TimeSlotAvailabilityEnum];


/**
 * 
 * @export
 * @interface TimeSlotItem
 */
export interface TimeSlotItem {
    /**
     * ID of the created booking time slot in UUID type used to represent one time slot for agronomist consultation
     * @type {string}
     * @memberof TimeSlotItem
     */
    'timeSlotId'?: string;
    /**
     * Time slot description that used to show the time slot in front end side
     * @type {string}
     * @memberof TimeSlotItem
     */
    'description'?: string;
    /**
     * 
     * @type {TimeSlotAvailabilityEnum}
     * @memberof TimeSlotItem
     */
    'status'?: TimeSlotAvailabilityEnum;
}


/**
 * Notify client about the cause of the error. Currently there\'s no expiration validation, so only `USED` that might be returned
 * @export
 * @enum {string}
 */

export const TokenValidationErrorStatusEnum = {
    Expired: 'EXPIRED',
    Used: 'USED'
} as const;

export type TokenValidationErrorStatusEnum = typeof TokenValidationErrorStatusEnum[keyof typeof TokenValidationErrorStatusEnum];


/**
 * Status of the Truck
 * @export
 * @enum {string}
 */

export const TruckStatusEnum = {
    Verified: 'VERIFIED',
    Pending: 'PENDING',
    Rejected: 'REJECTED'
} as const;

export type TruckStatusEnum = typeof TruckStatusEnum[keyof typeof TruckStatusEnum];


/**
 * 
 * @export
 * @interface TruckSubAgentListResponse
 */
export interface TruckSubAgentListResponse {
    /**
     * 
     * @type {Array<TruckSubAgentListResponseItem>}
     * @memberof TruckSubAgentListResponse
     */
    'trucks': Array<TruckSubAgentListResponseItem>;
}
/**
 * 
 * @export
 * @interface TruckSubAgentListResponseItem
 */
export interface TruckSubAgentListResponseItem {
    /**
     * Plat no of the truck
     * @type {string}
     * @memberof TruckSubAgentListResponseItem
     */
    'platNo': string;
}
/**
 * plantation activities enum
 * @export
 * @enum {string}
 */

export const TypePlantationsActivitiesEnum = {
    Harvest: 'HARVEST',
    HarvestAssociation: 'HARVEST_ASSOCIATION',
    Upkeep: 'UPKEEP',
    Weigh: 'WEIGH'
} as const;

export type TypePlantationsActivitiesEnum = typeof TypePlantationsActivitiesEnum[keyof typeof TypePlantationsActivitiesEnum];


/**
 * plantation upkeep activities
 * @export
 * @enum {string}
 */

export const TypePlantationsUpkeepActivitiesEnum = {
    Fertilizing: 'FERTILIZING',
    Pruning: 'PRUNING',
    Spraying: 'SPRAYING',
    Slashing: 'SLASHING',
    Ablation: 'ABLATION',
    Sanitation: 'SANITATION'
} as const;

export type TypePlantationsUpkeepActivitiesEnum = typeof TypePlantationsUpkeepActivitiesEnum[keyof typeof TypePlantationsUpkeepActivitiesEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const UnitOfWageEnum = {
    Ha: 'Ha',
    Kg: 'Kg',
    Ton: 'Ton'
} as const;

export type UnitOfWageEnum = typeof UnitOfWageEnum[keyof typeof UnitOfWageEnum];


/**
 * 
 * @export
 * @interface UpdateUserRequest
 */
export interface UpdateUserRequest {
    /**
     * 
     * @type {UserStatusEnum}
     * @memberof UpdateUserRequest
     */
    'status'?: UserStatusEnum;
    /**
     * 
     * @type {UserRoleEnum}
     * @memberof UpdateUserRequest
     */
    'role'?: UserRoleEnum;
}


/**
 * Response data
 * @export
 * @interface UpdateUserResponse
 */
export interface UpdateUserResponse {
    /**
     * User ID
     * @type {string}
     * @memberof UpdateUserResponse
     */
    'id': string;
    /**
     * User name
     * @type {string}
     * @memberof UpdateUserResponse
     */
    'name': string;
    /**
     * 
     * @type {UserStatusEnum}
     * @memberof UpdateUserResponse
     */
    'status': UserStatusEnum;
    /**
     * 
     * @type {UserRoleEnum}
     * @memberof UpdateUserResponse
     */
    'role': UserRoleEnum;
}


/**
 * optional, user client device lat-long when doing an activity
 * @export
 * @interface UserActivityLocationInput
 */
export interface UserActivityLocationInput {
    /**
     * latitude where the client device is at when doing an activity
     * @type {number}
     * @memberof UserActivityLocationInput
     */
    'latitude': number;
    /**
     * longitude where the client device is at when doing an activity
     * @type {number}
     * @memberof UserActivityLocationInput
     */
    'longitude': number;
}
/**
 * User status whether the member already joining the same campaign type
 * @export
 * @enum {string}
 */

export const UserCampaignStatusEnum = {
    Available: 'AVAILABLE',
    NotAvailable: 'NOT_AVAILABLE'
} as const;

export type UserCampaignStatusEnum = typeof UserCampaignStatusEnum[keyof typeof UserCampaignStatusEnum];


/**
 * Response data
 * @export
 * @interface UserGetProfileResponse
 */
export interface UserGetProfileResponse {
    /**
     * User\'s phone number
     * @type {string}
     * @memberof UserGetProfileResponse
     */
    'phoneNumber': string;
    /**
     * User\'s name
     * @type {string}
     * @memberof UserGetProfileResponse
     */
    'name': string;
    /**
     * User\'s referral code
     * @type {string}
     * @memberof UserGetProfileResponse
     */
    'referralCode': string;
    /**
     * The message that the user can send to their contacts
     * @type {string}
     * @memberof UserGetProfileResponse
     */
    'shareMessage': string;
}
/**
 * 
 * @export
 * @interface UserGetReferralSummaryResponse
 */
export interface UserGetReferralSummaryResponse {
    /**
     * User\'s referral code
     * @type {string}
     * @memberof UserGetReferralSummaryResponse
     */
    'referralCode': string;
    /**
     * The message that the user can send to their contacts, regarding invitation to SawitPRO applications
     * @type {string}
     * @memberof UserGetReferralSummaryResponse
     */
    'shareMessage': string;
    /**
     * The amount of SawitPoin that the user has received from referral. Default is 0 if the user has not received any SawitPoin from referral
     * @type {number}
     * @memberof UserGetReferralSummaryResponse
     */
    'referralPoints': number;
    /**
     * The amount of referrals that the user has made.  Default is 0 if the user has not made any referrals 
     * @type {number}
     * @memberof UserGetReferralSummaryResponse
     */
    'referralCount': number;
    /**
     * The amount of referrals that the user has made, and the referred user has registered to SawitPRO.  Default is 0 if the user has not made any referrals, or the referred user has not registered to SawitPRO 
     * @type {number}
     * @memberof UserGetReferralSummaryResponse
     */
    'registeredReferralCount': number;
    /**
     * The amount of referrals that the user has made, and the referred user has complete an onboarding activity.  Default is 0 if the user has not made any referrals, or the referred user has not made any transaction 
     * @type {number}
     * @memberof UserGetReferralSummaryResponse
     */
    'activeReferralCount': number;
    /**
     * A string containing HTML tags of Terms and Conditions that will be rendered on the client side
     * @type {string}
     * @memberof UserGetReferralSummaryResponse
     */
    'tnc': string;
}
/**
 * 
 * @export
 * @interface UserReferralListItem
 */
export interface UserReferralListItem {
    /**
     * Name of the referral
     * @type {string}
     * @memberof UserReferralListItem
     */
    'name': string;
    /**
     * Phone number of the referral, will only shown the first & last 4 digits, the rest will be masked
     * @type {string}
     * @memberof UserReferralListItem
     */
    'phoneNo': string;
    /**
     * Status of the referral to be shown by FE. Possible values are `Sudah daftar` and `Misi terselesaikan`
     * @type {string}
     * @memberof UserReferralListItem
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface UserReferralListResponse
 */
export interface UserReferralListResponse {
    /**
     * Total number of referrals based on the provided filter
     * @type {number}
     * @memberof UserReferralListResponse
     */
    'referralCount': number;
    /**
     * List of current user\'s referrals
     * @type {Array<UserReferralListItem>}
     * @memberof UserReferralListResponse
     */
    'items': Array<UserReferralListItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof UserReferralListResponse
     */
    'pagination': PaginationResponse;
}
/**
 * Partner user role
 * @export
 * @enum {string}
 */

export const UserRoleEnum = {
    PartnerAdmin: 'PARTNER_ADMIN',
    PartnerUser: 'PARTNER_USER',
    Marketing: 'MARKETING',
    SalesAgent: 'SALES_AGENT',
    Agent: 'AGENT',
    FieldCoordinator: 'FIELD_COORDINATOR',
    Harvester: 'HARVESTER',
    Driver: 'DRIVER',
    Verificator: 'VERIFICATOR',
    FinanceAccountant: 'FINANCE_ACCOUNTANT',
    Operation: 'OPERATION',
    WarehouseOfficer: 'WAREHOUSE_OFFICER',
    DoAdmin: 'DO_ADMIN',
    Administrator: 'ADMINISTRATOR',
    Gapoktan: 'GAPOKTAN',
    FinanceLead: 'FINANCE_LEAD',
    OperationLead: 'OPERATION_LEAD',
    StoreAdmin: 'STORE_ADMIN',
    Partner: 'PARTNER',
    Ambassador: 'AMBASSADOR',
    Farmer: 'FARMER',
    FarmAssistant: 'FARM_ASSISTANT',
    Individual: 'INDIVIDUAL',
    FinancialAssistant: 'FINANCIAL_ASSISTANT',
    EstateOwner: 'ESTATE_OWNER'
} as const;

export type UserRoleEnum = typeof UserRoleEnum[keyof typeof UserRoleEnum];


/**
 * 
 * @export
 * @interface UserSimpleDataResponse
 */
export interface UserSimpleDataResponse {
    /**
     * user id in UUIDv4 format
     * @type {string}
     * @memberof UserSimpleDataResponse
     */
    'id': string;
    /**
     * name of the User
     * @type {string}
     * @memberof UserSimpleDataResponse
     */
    'name': string;
}
/**
 * Status of the user
 * @export
 * @enum {string}
 */

export const UserStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE'
} as const;

export type UserStatusEnum = typeof UserStatusEnum[keyof typeof UserStatusEnum];


/**
 * 
 * @export
 * @interface UserValidateReferralCodeRequest
 */
export interface UserValidateReferralCodeRequest {
    /**
     * Referral code the user used, that will be validated
     * @type {string}
     * @memberof UserValidateReferralCodeRequest
     */
    'referralCode': string;
}
/**
 * 
 * @export
 * @interface UserValidateReferralCodeResponse
 */
export interface UserValidateReferralCodeResponse {
    /**
     * Indicating whether referral code is valid or not
     * @type {boolean}
     * @memberof UserValidateReferralCodeResponse
     */
    'isValid': boolean;
}
/**
 * 
 * @export
 * @interface UsersCreateRegistrationRequest
 */
export interface UsersCreateRegistrationRequest {
    /**
     * User\'s name
     * @type {string}
     * @memberof UsersCreateRegistrationRequest
     */
    'name': string;
    /**
     * The email address of the user. It should be a valid email format with a username followed by the @ symbol and a domain part. 
     * @type {string}
     * @memberof UsersCreateRegistrationRequest
     */
    'email'?: string;
    /**
     * UUID type 4
     * @type {string}
     * @memberof UsersCreateRegistrationRequest
     */
    'partnerId': string;
    /**
     * User\'s phone number (encrypted using RSA256 with public key dev). Phone number should have a minimum of 8 digits and maximum 13 digits, only digits/numbers are allowed, starting with 0 (08xxxxxxxxxx) 
     * @type {string}
     * @memberof UsersCreateRegistrationRequest
     */
    'phoneNumber': string;
    /**
     * 
     * @type {UserRoleEnum}
     * @memberof UsersCreateRegistrationRequest
     */
    'status'?: UserRoleEnum;
}


/**
 * Response data
 * @export
 * @interface UsersCreateRegistrationResponse
 */
export interface UsersCreateRegistrationResponse {
    /**
     * User ID of the newly created user
     * @type {string}
     * @memberof UsersCreateRegistrationResponse
     */
    'userId': string;
    /**
     * Name of the newly created user
     * @type {string}
     * @memberof UsersCreateRegistrationResponse
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface UsersOtpSendRequest
 */
export interface UsersOtpSendRequest {
    /**
     * Encrypted phoneNumber using RSA256 with public key that\'s retrieved from local database
     * @type {string}
     * @memberof UsersOtpSendRequest
     */
    'phoneNo': string;
    /**
     * Hash code that will be included in the SMS sent to users
     * @type {string}
     * @memberof UsersOtpSendRequest
     */
    'hashCode'?: string;
}
/**
 * 
 * @export
 * @interface UsersOtpSendResponse
 */
export interface UsersOtpSendResponse {
    /**
     * 
     * @type {string}
     * @memberof UsersOtpSendResponse
     */
    'phoneNo': string;
    /**
     * 
     * @type {string}
     * @memberof UsersOtpSendResponse
     */
    'otp': string;
}
/**
 * 
 * @export
 * @interface UsersUpdateFirebaseTokenRequest
 */
export interface UsersUpdateFirebaseTokenRequest {
    /**
     * Firebase token
     * @type {string}
     * @memberof UsersUpdateFirebaseTokenRequest
     */
    'firebaseToken': string;
}
/**
 * 
 * @export
 * @interface UsersUpdateFirebaseTokenResponse
 */
export interface UsersUpdateFirebaseTokenResponse {
    /**
     * 
     * @type {boolean}
     * @memberof UsersUpdateFirebaseTokenResponse
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface V2AgronomyCreateBookingRequest
 */
export interface V2AgronomyCreateBookingRequest {
    /**
     * id of a scheduled date in UUID type 4, required when productType is INVITE_AGRONOMIST
     * @type {string}
     * @memberof V2AgronomyCreateBookingRequest
     */
    'scheduleDateId'?: string;
    /**
     * location area/village ID, required when productType is INVITE_AGRONOMIST
     * @type {string}
     * @memberof V2AgronomyCreateBookingRequest
     */
    'areaId'?: string;
    /**
     * id of a scheduled agronomy in UUID type 4, required when productType is ASK_AGRONOMIST
     * @type {string}
     * @memberof V2AgronomyCreateBookingRequest
     */
    'scheduleId'?: string;
    /**
     * explanation of problems to be consultated
     * @type {string}
     * @memberof V2AgronomyCreateBookingRequest
     */
    'problem': string;
    /**
     * 
     * @type {OrderCreateRequest}
     * @memberof V2AgronomyCreateBookingRequest
     */
    'order': OrderCreateRequest;
    /**
     * agronomy product type that will be booked (ASK_AGRONOMIST, INVITE_AGRONOMIST)
     * @type {string}
     * @memberof V2AgronomyCreateBookingRequest
     */
    'productType': string;
    /**
     * used by DUTA app, id of the user that this request is for
     * @type {string}
     * @memberof V2AgronomyCreateBookingRequest
     */
    'userId'?: string;
}
/**
 * 
 * @export
 * @interface V2AgronomyCreateBookingResponse
 */
export interface V2AgronomyCreateBookingResponse {
    /**
     * id of the created agronomy booking data, represented in UUID type 4
     * @type {string}
     * @memberof V2AgronomyCreateBookingResponse
     */
    'bookingId': string;
    /**
     * 
     * @type {OrderCreateResponse}
     * @memberof V2AgronomyCreateBookingResponse
     */
    'order': OrderCreateResponse;
}
/**
 * 
 * @export
 * @interface V2AssetsAddRampRequest
 */
export interface V2AssetsAddRampRequest {
    /**
     * Name of ramp asset
     * @type {string}
     * @memberof V2AssetsAddRampRequest
     */
    'assetName': string;
    /**
     * Id village of ramp
     * @type {string}
     * @memberof V2AssetsAddRampRequest
     */
    'villageId': string;
    /**
     * Address of ramp
     * @type {string}
     * @memberof V2AssetsAddRampRequest
     */
    'address': string;
    /**
     * The latitude of user\'s Ramp
     * @type {number}
     * @memberof V2AssetsAddRampRequest
     */
    'latitude'?: number;
    /**
     * The longitude of user\'s Ramp
     * @type {number}
     * @memberof V2AssetsAddRampRequest
     */
    'longitude'?: number;
    /**
     * The photo of Ramp for the verification process
     * @type {string}
     * @memberof V2AssetsAddRampRequest
     */
    'rampPhoto': string;
    /**
     * The total count of owned truck
     * @type {number}
     * @memberof V2AssetsAddRampRequest
     */
    'totalTruck': number;
    /**
     * The total count of worker
     * @type {number}
     * @memberof V2AssetsAddRampRequest
     */
    'totalWorker': number;
    /**
     * The capacity of weighbridge
     * @type {number}
     * @memberof V2AssetsAddRampRequest
     */
    'totalCapacity': number;
}
/**
 * 
 * @export
 * @interface V2AssetsAddRampResponse
 */
export interface V2AssetsAddRampResponse {
    /**
     * Added SawitPoin, will return 0 if no point added
     * @type {number}
     * @memberof V2AssetsAddRampResponse
     */
    'point': number;
}
/**
 * 
 * @export
 * @interface V2AssetsAddSupplierRequest
 */
export interface V2AssetsAddSupplierRequest {
    /**
     * Name of supplier asset
     * @type {string}
     * @memberof V2AssetsAddSupplierRequest
     */
    'assetName': string;
    /**
     * Id mills of supplier
     * @type {string}
     * @memberof V2AssetsAddSupplierRequest
     */
    'millsId': string;
    /**
     * Mills\'s name of supplier
     * @type {string}
     * @memberof V2AssetsAddSupplierRequest
     */
    'millsName': string;
    /**
     * The latitude of user\'s Supplier
     * @type {number}
     * @memberof V2AssetsAddSupplierRequest
     */
    'latitude'?: number;
    /**
     * The longitude of user\'s Supplier
     * @type {number}
     * @memberof V2AssetsAddSupplierRequest
     */
    'longitude'?: number;
    /**
     * The weighbridge ticket to verify the Supplier ownership
     * @type {string}
     * @memberof V2AssetsAddSupplierRequest
     */
    'weighbridgePhoto': string;
}
/**
 * 
 * @export
 * @interface V2AssetsAddSupplierResponse
 */
export interface V2AssetsAddSupplierResponse {
    /**
     * Added SawitPoin, will return 0 if no point added
     * @type {number}
     * @memberof V2AssetsAddSupplierResponse
     */
    'point': number;
}
/**
 * 
 * @export
 * @interface V2AssetsSupplierListResponse
 */
export interface V2AssetsSupplierListResponse {
    /**
     * 
     * @type {Array<V2AssetsSupplierListResponseItem>}
     * @memberof V2AssetsSupplierListResponse
     */
    'items': Array<V2AssetsSupplierListResponseItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof V2AssetsSupplierListResponse
     */
    'pagination': PaginationResponse;
}
/**
 * 
 * @export
 * @interface V2AssetsSupplierListResponseItem
 */
export interface V2AssetsSupplierListResponseItem {
    /**
     * Asset ID represented in UUID type 4
     * @type {string}
     * @memberof V2AssetsSupplierListResponseItem
     */
    'assetId': string;
    /**
     * Supplier Contract ID represented in UUID type 4
     * @type {string}
     * @memberof V2AssetsSupplierListResponseItem
     */
    'assetCategoryId': string;
    /**
     * 
     * @type {AssetCategoryEnum}
     * @memberof V2AssetsSupplierListResponseItem
     */
    'assetType': AssetCategoryEnum;
    /**
     * The registered name of Supplier Contract (Supplier name)
     * @type {string}
     * @memberof V2AssetsSupplierListResponseItem
     */
    'assetName': string;
    /**
     * ID of the Partner (mills) represented in UUID type 4
     * @type {string}
     * @memberof V2AssetsSupplierListResponseItem
     */
    'millsId': string;
    /**
     * Partner (mills) name
     * @type {string}
     * @memberof V2AssetsSupplierListResponseItem
     */
    'millsName': string;
    /**
     * Code of the Supplier
     * @type {string}
     * @memberof V2AssetsSupplierListResponseItem
     */
    'supplierCode'?: string;
    /**
     * Cooperation date of the Supplier in epoch (with ms precision)
     * @type {number}
     * @memberof V2AssetsSupplierListResponseItem
     */
    'cooperationDate'?: number;
    /**
     * 
     * @type {MemberStatusEnum}
     * @memberof V2AssetsSupplierListResponseItem
     */
    'status': MemberStatusEnum;
    /**
     * supplier contract rejected reason
     * @type {string}
     * @memberof V2AssetsSupplierListResponseItem
     */
    'rejectedReason': string;
}


/**
 * 
 * @export
 * @interface V2BlocksListResponse
 */
export interface V2BlocksListResponse {
    /**
     * 
     * @type {Array<V2BlocksListResponseItem>}
     * @memberof V2BlocksListResponse
     */
    'items': Array<V2BlocksListResponseItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof V2BlocksListResponse
     */
    'pagination': PaginationResponse;
}
/**
 * 
 * @export
 * @interface V2BlocksListResponseItem
 */
export interface V2BlocksListResponseItem {
    /**
     * Id of plantations block
     * @type {string}
     * @memberof V2BlocksListResponseItem
     */
    'id': string;
    /**
     * name of the block
     * @type {string}
     * @memberof V2BlocksListResponseItem
     */
    'name': string;
    /**
     * Id of area
     * @type {string}
     * @memberof V2BlocksListResponseItem
     */
    'areaId': string;
    /**
     * hectare of the block
     * @type {number}
     * @memberof V2BlocksListResponseItem
     */
    'areaHectare': number;
    /**
     * Id of business
     * @type {string}
     * @memberof V2BlocksListResponseItem
     */
    'businessId': string;
    /**
     * Block\'s planted year
     * @type {number}
     * @memberof V2BlocksListResponseItem
     */
    'plantedYear': number;
    /**
     * Block\'s planted month
     * @type {number}
     * @memberof V2BlocksListResponseItem
     */
    'plantedMonth': number;
    /**
     * Id of seed
     * @type {string}
     * @memberof V2BlocksListResponseItem
     */
    'seedId': string;
}
/**
 * 
 * @export
 * @interface V2CampaignsGoldListResponse
 */
export interface V2CampaignsGoldListResponse {
    /**
     * 
     * @type {Array<V2CampaignsGoldListResponseItem>}
     * @memberof V2CampaignsGoldListResponse
     */
    'items': Array<V2CampaignsGoldListResponseItem>;
}
/**
 * 
 * @export
 * @interface V2CampaignsGoldListResponseItem
 */
export interface V2CampaignsGoldListResponseItem {
    /**
     * Title of the campaign
     * @type {string}
     * @memberof V2CampaignsGoldListResponseItem
     */
    'title': string;
    /**
     * Mark of campaign gold version.
     * @type {number}
     * @memberof V2CampaignsGoldListResponseItem
     */
    'version': number;
    /**
     * 
     * @type {CampaignsGoldListResponseTarget}
     * @memberof V2CampaignsGoldListResponseItem
     */
    'daily'?: CampaignsGoldListResponseTarget;
    /**
     * 
     * @type {CampaignsGoldListResponseTarget}
     * @memberof V2CampaignsGoldListResponseItem
     */
    'monthly'?: CampaignsGoldListResponseTarget;
    /**
     * 
     * @type {CampaignsGoldListResponseTarget}
     * @memberof V2CampaignsGoldListResponseItem
     */
    'quarterly'?: CampaignsGoldListResponseTarget;
    /**
     * ID campaign of selected campaign code represented in UUID type 4
     * @type {string}
     * @memberof V2CampaignsGoldListResponseItem
     */
    'campaignId': string;
}
/**
 * 
 * @export
 * @interface V2CampaignsListResponse
 */
export interface V2CampaignsListResponse {
    /**
     * 
     * @type {Array<V2CampaignsListResponseItem>}
     * @memberof V2CampaignsListResponse
     */
    'items': Array<V2CampaignsListResponseItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof V2CampaignsListResponse
     */
    'pagination': PaginationResponse;
}
/**
 * 
 * @export
 * @interface V2CampaignsListResponseGold
 */
export interface V2CampaignsListResponseGold {
    /**
     * 
     * @type {V2CampaignsListResponseGoldTarget}
     * @memberof V2CampaignsListResponseGold
     */
    'daily': V2CampaignsListResponseGoldTarget;
    /**
     * 
     * @type {V2CampaignsListResponseGoldTarget}
     * @memberof V2CampaignsListResponseGold
     */
    'monthly': V2CampaignsListResponseGoldTarget;
    /**
     * 
     * @type {V2CampaignsListResponseGoldTarget}
     * @memberof V2CampaignsListResponseGold
     */
    'quarterly': V2CampaignsListResponseGoldTarget;
}
/**
 * 
 * @export
 * @interface V2CampaignsListResponseGoldTarget
 */
export interface V2CampaignsListResponseGoldTarget {
    /**
     * Target of the Campaign Emas in Tonnage
     * @type {number}
     * @memberof V2CampaignsListResponseGoldTarget
     */
    'target': number;
    /**
     * Gold reward of the Campaign Emas in mg (1/1000 of a gram)
     * @type {number}
     * @memberof V2CampaignsListResponseGoldTarget
     */
    'gold': number;
}
/**
 * 
 * @export
 * @interface V2CampaignsListResponseItem
 */
export interface V2CampaignsListResponseItem {
    /**
     * Campaign ID represented in UUID type 4
     * @type {string}
     * @memberof V2CampaignsListResponseItem
     */
    'id': string;
    /**
     * The Partner (mill) name that created the campaign
     * @type {string}
     * @memberof V2CampaignsListResponseItem
     */
    'millName': string;
    /**
     * Campaign type name
     * @type {string}
     * @memberof V2CampaignsListResponseItem
     */
    'type': string;
    /**
     * 
     * @type {CampaignTypeEnum}
     * @memberof V2CampaignsListResponseItem
     */
    'typeIdentifier': CampaignTypeEnum;
    /**
     * Campaign title
     * @type {string}
     * @memberof V2CampaignsListResponseItem
     */
    'title': string;
    /**
     * The Supplier (DO) name that the user own
     * @type {string}
     * @memberof V2CampaignsListResponseItem
     */
    'supplierName': string;
    /**
     * Campaign target or baseline, depending on campaign type
     * @type {number}
     * @memberof V2CampaignsListResponseItem
     */
    'target': number;
    /**
     * The user\'s campaign achievement of the campaign target
     * @type {number}
     * @memberof V2CampaignsListResponseItem
     */
    'achievement': number;
    /**
     * The user\'s supply progress in measurement unit of current campaign.
     * @type {number}
     * @memberof V2CampaignsListResponseItem
     */
    'supply': number;
    /**
     * The excess supply (supply - target) of Campaign Increment (Jawara) type, will return the excess supply after the target is reached (otherwise 0).<br><br>  For other type of campaign will be returning 0 
     * @type {number}
     * @memberof V2CampaignsListResponseItem
     */
    'excessSupply': number;
    /**
     * Campaign measurement unit
     * @type {string}
     * @memberof V2CampaignsListResponseItem
     */
    'measurementUnit': string;
    /**
     * Campaign start time in epoch
     * @type {number}
     * @memberof V2CampaignsListResponseItem
     */
    'startTime': number;
    /**
     * Campaign end time in epoch
     * @type {number}
     * @memberof V2CampaignsListResponseItem
     */
    'endTime': number;
    /**
     * Campaign reward (Sawitpoin)
     * @type {number}
     * @memberof V2CampaignsListResponseItem
     */
    'reward': number;
    /**
     * The total of rewards obtained by campaign Jawara and Ranking in one period
     * @type {number}
     * @memberof V2CampaignsListResponseItem
     */
    'totalReward'?: number;
    /**
     * SawitPoin multiplier per ton supplied. Used as SawitPoin multiplier in its Rupiah value for Campaign SHD
     * @type {number}
     * @memberof V2CampaignsListResponseItem
     */
    'multiplier': number;
    /**
     * User ranking of the particular campaign, will be null if campaign don\'t have ranking
     * @type {string}
     * @memberof V2CampaignsListResponseItem
     */
    'ranking'?: string;
    /**
     * Additional information for the campaign (currently used to display the next ranking for the user). Will be formatted in HTML
     * @type {string}
     * @memberof V2CampaignsListResponseItem
     */
    'rankingInformation'?: string;
    /**
     * Instruction for the campaign
     * @type {string}
     * @memberof V2CampaignsListResponseItem
     */
    'instruction'?: string;
    /**
     * 
     * @type {V2CampaignsListResponseGold}
     * @memberof V2CampaignsListResponseItem
     */
    'goldTargets'?: V2CampaignsListResponseGold;
}


/**
 * 
 * @export
 * @interface V2CreateCampaignRequest
 */
export interface V2CreateCampaignRequest {
    /**
     * ID campaign of selected campaign code represented in UUID type 4
     * @type {string}
     * @memberof V2CreateCampaignRequest
     */
    'campaignId'?: string;
    /**
     * Code of campaign
     * @type {string}
     * @memberof V2CreateCampaignRequest
     */
    'campaignCode': string;
    /**
     * ID of selected campaign type represented in UUID type 4
     * @type {string}
     * @memberof V2CreateCampaignRequest
     */
    'campaignTypeId': string;
    /**
     * Name of campaign
     * @type {string}
     * @memberof V2CreateCampaignRequest
     */
    'name': string;
    /**
     * Start datetime of campaign (in epoch)
     * @type {number}
     * @memberof V2CreateCampaignRequest
     */
    'startAt': number;
    /**
     * End datetime of campaign (in epoch)
     * @type {number}
     * @memberof V2CreateCampaignRequest
     */
    'endAt': number;
    /**
     * Default reward poin value
     * @type {number}
     * @memberof V2CreateCampaignRequest
     */
    'defaultRewardValue': number;
    /**
     * List of campaign default target value
     * @type {Array<CreateEditCampaignRequestTargetItem>}
     * @memberof V2CreateCampaignRequest
     */
    'defaultTargetValue': Array<CreateEditCampaignRequestTargetItem>;
    /**
     * 
     * @type {CampaignParticipantTypeEnum}
     * @memberof V2CreateCampaignRequest
     */
    'participantType': CampaignParticipantTypeEnum;
    /**
     * List of members that are enlisted for this campaign
     * @type {Array<CreateEditCampaignRequestParticipantItem>}
     * @memberof V2CreateCampaignRequest
     */
    'participant': Array<CreateEditCampaignRequestParticipantItem>;
}


/**
 * list of store data
 * @export
 * @interface V2EcommerceCouponGetVendorListResponse
 */
export interface V2EcommerceCouponGetVendorListResponse {
    /**
     * 
     * @type {Array<V2EcommerceCouponGetVendorListResponseItem>}
     * @memberof V2EcommerceCouponGetVendorListResponse
     */
    'items': Array<V2EcommerceCouponGetVendorListResponseItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof V2EcommerceCouponGetVendorListResponse
     */
    'pagination'?: PaginationResponse;
}
/**
 * 
 * @export
 * @interface V2EcommerceCouponGetVendorListResponseItem
 */
export interface V2EcommerceCouponGetVendorListResponseItem {
    /**
     * 
     * @type {string}
     * @memberof V2EcommerceCouponGetVendorListResponseItem
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof V2EcommerceCouponGetVendorListResponseItem
     */
    'name': string;
    /**
     * Stock Location Address
     * @type {string}
     * @memberof V2EcommerceCouponGetVendorListResponseItem
     */
    'address': string;
    /**
     * Stock Location Latitude
     * @type {number}
     * @memberof V2EcommerceCouponGetVendorListResponseItem
     */
    'latitude': number;
    /**
     * Stock Location Longitude
     * @type {number}
     * @memberof V2EcommerceCouponGetVendorListResponseItem
     */
    'longitude': number;
    /**
     * List of Store Item
     * @type {Array<V2EcommerceCouponGetVendorListResponseStoreItem>}
     * @memberof V2EcommerceCouponGetVendorListResponseItem
     */
    'storeItems': Array<V2EcommerceCouponGetVendorListResponseStoreItem>;
}
/**
 * 
 * @export
 * @interface V2EcommerceCouponGetVendorListResponseStoreItem
 */
export interface V2EcommerceCouponGetVendorListResponseStoreItem {
    /**
     * Store ID
     * @type {string}
     * @memberof V2EcommerceCouponGetVendorListResponseStoreItem
     */
    'id': string;
    /**
     * Store Name
     * @type {string}
     * @memberof V2EcommerceCouponGetVendorListResponseStoreItem
     */
    'name': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof V2EcommerceCouponGetVendorListResponseStoreItem
     */
    'imageUrlItems': Array<string>;
    /**
     * Reference point location
     * @type {string}
     * @memberof V2EcommerceCouponGetVendorListResponseStoreItem
     */
    'referenceLocation': string;
}
/**
 * 
 * @export
 * @interface V2PartnersGetFfbPricesItemResponse
 */
export interface V2PartnersGetFfbPricesItemResponse {
    /**
     * ID ffb price represented in UUID type 4
     * @type {string}
     * @memberof V2PartnersGetFfbPricesItemResponse
     */
    'id': string;
    /**
     * Partner (mills) name
     * @type {string}
     * @memberof V2PartnersGetFfbPricesItemResponse
     */
    'millName': string;
    /**
     * FFB price
     * @type {number}
     * @memberof V2PartnersGetFfbPricesItemResponse
     */
    'ffbPrice': number;
    /**
     * time in epoch millis when the user submitted ffb price
     * @type {number}
     * @memberof V2PartnersGetFfbPricesItemResponse
     */
    'createdAt': number;
    /**
     * Verification Status of FFB Price data
     * @type {string}
     * @memberof V2PartnersGetFfbPricesItemResponse
     */
    'verificationStatus': string;
}
/**
 * 
 * @export
 * @interface V2PartnersGetFfbPricesResponse
 */
export interface V2PartnersGetFfbPricesResponse {
    /**
     * 
     * @type {Array<V2PartnersGetFfbPricesItemResponse>}
     * @memberof V2PartnersGetFfbPricesResponse
     */
    'items': Array<V2PartnersGetFfbPricesItemResponse>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof V2PartnersGetFfbPricesResponse
     */
    'pagination': PaginationResponse;
}
/**
 * 
 * @export
 * @interface V2PartnersGetMemberResponse
 */
export interface V2PartnersGetMemberResponse {
    /**
     * 
     * @type {V2PartnersGetMemberResponseDetails}
     * @memberof V2PartnersGetMemberResponse
     */
    'details': V2PartnersGetMemberResponseDetails;
    /**
     * 
     * @type {PartnersGetMemberResponseAssets}
     * @memberof V2PartnersGetMemberResponse
     */
    'assets': PartnersGetMemberResponseAssets;
}
/**
 * 
 * @export
 * @interface V2PartnersGetMemberResponseDetails
 */
export interface V2PartnersGetMemberResponseDetails {
    /**
     * User ID represented in UUID type 4
     * @type {string}
     * @memberof V2PartnersGetMemberResponseDetails
     */
    'userId': string;
    /**
     * Member name
     * @type {string}
     * @memberof V2PartnersGetMemberResponseDetails
     */
    'name': string;
    /**
     * Phone number starting with 0 as prefix (08xxxxxxxxx)
     * @type {string}
     * @memberof V2PartnersGetMemberResponseDetails
     */
    'phoneNumber': string;
    /**
     * Date when member request was approved by Partner (in epoch). Will be represented in UTC-0, time will be set at midnight (00:00)
     * @type {number}
     * @memberof V2PartnersGetMemberResponseDetails
     */
    'joinedDate': number;
}
/**
 * 
 * @export
 * @interface V2PartnersGetMembersItem
 */
export interface V2PartnersGetMembersItem {
    /**
     * User ID in UUID type 4 format
     * @type {string}
     * @memberof V2PartnersGetMembersItem
     */
    'userId': string;
    /**
     * Member name
     * @type {string}
     * @memberof V2PartnersGetMembersItem
     */
    'name': string;
    /**
     * Phone number starting with 0 as prefix (08xxxxxxxxx)
     * @type {string}
     * @memberof V2PartnersGetMembersItem
     */
    'phoneNumber': string;
    /**
     * Member registered date (in epoch). Will be in UTC-0, time will be set at midnight (00:00)
     * @type {number}
     * @memberof V2PartnersGetMembersItem
     */
    'registerDate': number;
}
/**
 * Response data
 * @export
 * @interface V2PartnersGetMembersResponse
 */
export interface V2PartnersGetMembersResponse {
    /**
     * List of Member
     * @type {Array<V2PartnersGetMembersItem>}
     * @memberof V2PartnersGetMembersResponse
     */
    'items': Array<V2PartnersGetMembersItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof V2PartnersGetMembersResponse
     */
    'pagination': PaginationResponse;
}
/**
 * 
 * @export
 * @interface V2PlantationCreateActivitiesDeliveriesRequest
 */
export interface V2PlantationCreateActivitiesDeliveriesRequest {
    /**
     * id of the activity
     * @type {string}
     * @memberof V2PlantationCreateActivitiesDeliveriesRequest
     */
    'id': string;
    /**
     * unix timestamp when the activity was submitted
     * @type {number}
     * @memberof V2PlantationCreateActivitiesDeliveriesRequest
     */
    'submittedAtUtc0': number;
    /**
     * user timezone
     * @type {string}
     * @memberof V2PlantationCreateActivitiesDeliveriesRequest
     */
    'userTimezone': string;
    /**
     * id of mills
     * @type {string}
     * @memberof V2PlantationCreateActivitiesDeliveriesRequest
     */
    'partnerId': string;
    /**
     * 
     * @type {string}
     * @memberof V2PlantationCreateActivitiesDeliveriesRequest
     */
    'ticketNumber': string;
    /**
     * 
     * @type {CollectorTypeEnum}
     * @memberof V2PlantationCreateActivitiesDeliveriesRequest
     */
    'collectorType': CollectorTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof V2PlantationCreateActivitiesDeliveriesRequest
     */
    'collectorName': string;
    /**
     * Count of pulangan (janjang)
     * @type {number}
     * @memberof V2PlantationCreateActivitiesDeliveriesRequest
     */
    'returnedQuantity': number;
    /**
     * Average of sawit weight (Komidel)
     * @type {number}
     * @memberof V2PlantationCreateActivitiesDeliveriesRequest
     */
    'weightAverageBunchKg': number;
    /**
     * Worker current latitude
     * @type {number}
     * @memberof V2PlantationCreateActivitiesDeliveriesRequest
     */
    'latitude': number;
    /**
     * Worker current longitude
     * @type {number}
     * @memberof V2PlantationCreateActivitiesDeliveriesRequest
     */
    'longitude': number;
    /**
     * url of the image of the returned ffb
     * @type {string}
     * @memberof V2PlantationCreateActivitiesDeliveriesRequest
     */
    'returnedFfbImageUrl': string;
    /**
     * url of the image of the weighbridge ticket
     * @type {string}
     * @memberof V2PlantationCreateActivitiesDeliveriesRequest
     */
    'weighbridgeTicketImageUrl': string;
    /**
     * 
     * @type {V2PlantationCreateActivitiesDeliveriesRequestFeedbacks}
     * @memberof V2PlantationCreateActivitiesDeliveriesRequest
     */
    'feedbacks': V2PlantationCreateActivitiesDeliveriesRequestFeedbacks;
}


/**
 * 
 * @export
 * @interface V2PlantationCreateActivitiesDeliveriesRequestFeedbacks
 */
export interface V2PlantationCreateActivitiesDeliveriesRequestFeedbacks {
    /**
     * The rating assigned to the price component
     * @type {number}
     * @memberof V2PlantationCreateActivitiesDeliveriesRequestFeedbacks
     */
    'priceRating': number;
    /**
     * The rating assigned to the weighbridge component
     * @type {number}
     * @memberof V2PlantationCreateActivitiesDeliveriesRequestFeedbacks
     */
    'weighbridgeRating': number;
    /**
     * The rating assigned to the queue component
     * @type {number}
     * @memberof V2PlantationCreateActivitiesDeliveriesRequestFeedbacks
     */
    'queueRating': number;
    /**
     * The rating assigned to the sorting component
     * @type {number}
     * @memberof V2PlantationCreateActivitiesDeliveriesRequestFeedbacks
     */
    'sortingRating': number;
    /**
     * The rating assigned to the road access component
     * @type {number}
     * @memberof V2PlantationCreateActivitiesDeliveriesRequestFeedbacks
     */
    'roadAccessRating': number;
    /**
     * Comment from user. It could be feedback for partner (Category - MILL)
     * @type {string}
     * @memberof V2PlantationCreateActivitiesDeliveriesRequestFeedbacks
     */
    'message': string;
    /**
     * This field is used to identify whether member\'s user want to show their name as they give their feedback
     * @type {boolean}
     * @memberof V2PlantationCreateActivitiesDeliveriesRequestFeedbacks
     */
    'isAnonymous': boolean;
}
/**
 * 
 * @export
 * @interface V2PlantationCreateActivitiesDeliveriesResponse
 */
export interface V2PlantationCreateActivitiesDeliveriesResponse {
    /**
     * 
     * @type {boolean}
     * @memberof V2PlantationCreateActivitiesDeliveriesResponse
     */
    'success': boolean;
    /**
     * 
     * @type {number}
     * @memberof V2PlantationCreateActivitiesDeliveriesResponse
     */
    'sawitpoin': number;
}
/**
 * 
 * @export
 * @interface V2PlantationsActivitiesSmallholdersCreateUpkeepRequest
 */
export interface V2PlantationsActivitiesSmallholdersCreateUpkeepRequest {
    /**
     * list of smallholder upkeep data that will be inserted
     * @type {Array<V2PlantationsActivitiesSmallholdersCreateUpkeepRequestItem>}
     * @memberof V2PlantationsActivitiesSmallholdersCreateUpkeepRequest
     */
    'items': Array<V2PlantationsActivitiesSmallholdersCreateUpkeepRequestItem>;
}
/**
 * 
 * @export
 * @interface V2PlantationsActivitiesSmallholdersCreateUpkeepRequestItem
 */
export interface V2PlantationsActivitiesSmallholdersCreateUpkeepRequestItem {
    /**
     * Farm Id related to the upkeep
     * @type {string}
     * @memberof V2PlantationsActivitiesSmallholdersCreateUpkeepRequestItem
     */
    'farmId': string;
    /**
     * activity Id of the upkeep
     * @type {string}
     * @memberof V2PlantationsActivitiesSmallholdersCreateUpkeepRequestItem
     */
    'activityId': string;
    /**
     * date when the upkeep was done in unix timestamp
     * @type {number}
     * @memberof V2PlantationsActivitiesSmallholdersCreateUpkeepRequestItem
     */
    'date': number;
    /**
     * fertilizer Id related to the upkeep. Should be filled when activity is FERTILIZING
     * @type {string}
     * @memberof V2PlantationsActivitiesSmallholdersCreateUpkeepRequestItem
     */
    'fertilizerId'?: string;
    /**
     * quantity of the upkeep
     * @type {number}
     * @memberof V2PlantationsActivitiesSmallholdersCreateUpkeepRequestItem
     */
    'quantity': number;
    /**
     * Total cost of the upkeep
     * @type {number}
     * @memberof V2PlantationsActivitiesSmallholdersCreateUpkeepRequestItem
     */
    'totalCost': number;
    /**
     * other cost of the upkeep
     * @type {number}
     * @memberof V2PlantationsActivitiesSmallholdersCreateUpkeepRequestItem
     */
    'otherCost'?: number;
    /**
     * used by DUTA app, id of the user that this request is for
     * @type {string}
     * @memberof V2PlantationsActivitiesSmallholdersCreateUpkeepRequestItem
     */
    'userId'?: string;
    /**
     * UNIX millis when data is modified offline
     * @type {number}
     * @memberof V2PlantationsActivitiesSmallholdersCreateUpkeepRequestItem
     */
    'offlineModifiedAtUtc0'?: number;
}
/**
 * 
 * @export
 * @interface V2PlantationsActivitiesSmallholdersCreateUpkeepResponse
 */
export interface V2PlantationsActivitiesSmallholdersCreateUpkeepResponse {
    /**
     * List of data that are processed successfully
     * @type {Array<V2PlantationsActivitiesSmallholdersCreateUpkeepResponseItem>}
     * @memberof V2PlantationsActivitiesSmallholdersCreateUpkeepResponse
     */
    'successItems'?: Array<V2PlantationsActivitiesSmallholdersCreateUpkeepResponseItem>;
    /**
     * List of data with error
     * @type {Array<V2PlantationsActivitiesSmallholdersCreateUpkeepResponseItem>}
     * @memberof V2PlantationsActivitiesSmallholdersCreateUpkeepResponse
     */
    'failedItems'?: Array<V2PlantationsActivitiesSmallholdersCreateUpkeepResponseItem>;
    /**
     * Sawitpoin reward for creating asset farm data, if <= 0 user is not eligible for Sawitpoin reward 
     * @type {number}
     * @memberof V2PlantationsActivitiesSmallholdersCreateUpkeepResponse
     */
    'sawitpoin'?: number;
}
/**
 * 
 * @export
 * @interface V2PlantationsActivitiesSmallholdersCreateUpkeepResponseItem
 */
export interface V2PlantationsActivitiesSmallholdersCreateUpkeepResponseItem {
    /**
     * Id of smallholder upkeep activity data
     * @type {string}
     * @memberof V2PlantationsActivitiesSmallholdersCreateUpkeepResponseItem
     */
    'id': string;
    /**
     * Contains error that occured during data processing
     * @type {string}
     * @memberof V2PlantationsActivitiesSmallholdersCreateUpkeepResponseItem
     */
    'errorMessage'?: string;
}
/**
 * 
 * @export
 * @interface V2PlantationsCreateActivitiesHarvestAssociationRequest
 */
export interface V2PlantationsCreateActivitiesHarvestAssociationRequest {
    /**
     * Id of block
     * @type {string}
     * @memberof V2PlantationsCreateActivitiesHarvestAssociationRequest
     */
    'blockId': string;
    /**
     * Quantity of FFB in Janjang
     * @type {number}
     * @memberof V2PlantationsCreateActivitiesHarvestAssociationRequest
     */
    'ffbQuantity': number;
    /**
     * Average FFB (BJR/Komidel) weight in kg
     * @type {number}
     * @memberof V2PlantationsCreateActivitiesHarvestAssociationRequest
     */
    'weightAverageBunchKg': number;
    /**
     * Date when user take a photo
     * @type {number}
     * @memberof V2PlantationsCreateActivitiesHarvestAssociationRequest
     */
    'harvestingDate': number;
    /**
     * Presigned Url of ffb collection
     * @type {string}
     * @memberof V2PlantationsCreateActivitiesHarvestAssociationRequest
     */
    'ffbColletionImageUrl': string;
    /**
     * contact id of harvester for particular harvesting activity
     * @type {string}
     * @memberof V2PlantationsCreateActivitiesHarvestAssociationRequest
     */
    'harvesterId': string;
    /**
     * 
     * @type {number}
     * @memberof V2PlantationsCreateActivitiesHarvestAssociationRequest
     */
    'latitude': number;
    /**
     * 
     * @type {number}
     * @memberof V2PlantationsCreateActivitiesHarvestAssociationRequest
     */
    'longitude': number;
    /**
     * 
     * @type {string}
     * @memberof V2PlantationsCreateActivitiesHarvestAssociationRequest
     */
    'plantationScheduleId'?: string;
}
/**
 * 
 * @export
 * @interface V2PlantationsCreateActivitiesHarvestRequest
 */
export interface V2PlantationsCreateActivitiesHarvestRequest {
    /**
     * Quantity of FFB in Janjang
     * @type {number}
     * @memberof V2PlantationsCreateActivitiesHarvestRequest
     */
    'ffbQuantity': number;
    /**
     * 
     * @type {string}
     * @memberof V2PlantationsCreateActivitiesHarvestRequest
     */
    'activityScheduleId'?: string;
    /**
     * Estimated average FFB (BJR/Komidel) weight in kg
     * @type {number}
     * @memberof V2PlantationsCreateActivitiesHarvestRequest
     */
    'estimatedWeightAverageBunchKg': number;
    /**
     * 
     * @type {string}
     * @memberof V2PlantationsCreateActivitiesHarvestRequest
     */
    'ffbCollectionPoint'?: string;
    /**
     * Date when user take a photo
     * @type {number}
     * @memberof V2PlantationsCreateActivitiesHarvestRequest
     */
    'harvestingDate': number;
    /**
     * 
     * @type {number}
     * @memberof V2PlantationsCreateActivitiesHarvestRequest
     */
    'latitude': number;
    /**
     * 
     * @type {number}
     * @memberof V2PlantationsCreateActivitiesHarvestRequest
     */
    'longitude': number;
    /**
     * Photo of harvest fruit
     * @type {string}
     * @memberof V2PlantationsCreateActivitiesHarvestRequest
     */
    'photo': string;
    /**
     * hashed string from photo
     * @type {string}
     * @memberof V2PlantationsCreateActivitiesHarvestRequest
     */
    'hashedPhoto'?: string;
}
/**
 * 
 * @export
 * @interface V2PlantationsCreateActivitiesRequest
 */
export interface V2PlantationsCreateActivitiesRequest {
    /**
     * 
     * @type {TypePlantationsActivitiesEnum}
     * @memberof V2PlantationsCreateActivitiesRequest
     */
    'type': TypePlantationsActivitiesEnum;
    /**
     * 
     * @type {V2PlantationsCreateActivitiesRequestItems}
     * @memberof V2PlantationsCreateActivitiesRequest
     */
    'items': V2PlantationsCreateActivitiesRequestItems;
}


/**
 * @type V2PlantationsCreateActivitiesRequestItems
 * @export
 */
export type V2PlantationsCreateActivitiesRequestItems = V2PlantationsCreateActivitiesHarvestAssociationRequest | V2PlantationsCreateActivitiesHarvestRequest | V2PlantationsCreateActivitiesWeighRequest;

/**
 * 
 * @export
 * @interface V2PlantationsCreateActivitiesResponse
 */
export interface V2PlantationsCreateActivitiesResponse {
    /**
     * 
     * @type {boolean}
     * @memberof V2PlantationsCreateActivitiesResponse
     */
    'success': boolean;
    /**
     * 
     * @type {number}
     * @memberof V2PlantationsCreateActivitiesResponse
     */
    'sawitpoin': number;
}
/**
 * 
 * @export
 * @interface V2PlantationsCreateActivitiesWeighRequest
 */
export interface V2PlantationsCreateActivitiesWeighRequest {
    /**
     * Date when user do weighing
     * @type {number}
     * @memberof V2PlantationsCreateActivitiesWeighRequest
     */
    'weighingDateUtc0': number;
    /**
     * Id of block
     * @type {string}
     * @memberof V2PlantationsCreateActivitiesWeighRequest
     */
    'blockId': string;
    /**
     * Total FFB weight in kg
     * @type {number}
     * @memberof V2PlantationsCreateActivitiesWeighRequest
     */
    'ffbWeightKg': number;
    /**
     * Id of truck
     * @type {string}
     * @memberof V2PlantationsCreateActivitiesWeighRequest
     */
    'truckId': string;
    /**
     * contact id of harvester lead (\"Ketua Regu Panen\")
     * @type {string}
     * @memberof V2PlantationsCreateActivitiesWeighRequest
     */
    'harvesterLeadId': string;
    /**
     * contact id of loader collection (\"Tukang Langsir\")
     * @type {string}
     * @memberof V2PlantationsCreateActivitiesWeighRequest
     */
    'loaderCollectionId': string;
    /**
     * contact id of loader truck (\"Tukang Angkut\")
     * @type {string}
     * @memberof V2PlantationsCreateActivitiesWeighRequest
     */
    'loaderTruckId': string;
    /**
     * 
     * @type {UserActivityLocationInput}
     * @memberof V2PlantationsCreateActivitiesWeighRequest
     */
    'activityLocation'?: UserActivityLocationInput;
}
/**
 * 
 * @export
 * @interface V2PlantationsCreateFFBSellPriceRequest
 */
export interface V2PlantationsCreateFFBSellPriceRequest {
    /**
     * list of FFB sell price that will be inserted
     * @type {Array<V2PlantationsCreateFFBSellPriceRequestItem>}
     * @memberof V2PlantationsCreateFFBSellPriceRequest
     */
    'items': Array<V2PlantationsCreateFFBSellPriceRequestItem>;
}
/**
 * 
 * @export
 * @interface V2PlantationsCreateFFBSellPriceRequestItem
 */
export interface V2PlantationsCreateFFBSellPriceRequestItem {
    /**
     * Farm Id related to the FFB Sell Data
     * @type {string}
     * @memberof V2PlantationsCreateFFBSellPriceRequestItem
     */
    'farmId': string;
    /**
     * time of harvest in UTC0 format
     * @type {number}
     * @memberof V2PlantationsCreateFFBSellPriceRequestItem
     */
    'harvestDateUtc0': number;
    /**
     * total weight of FFB sold in Kg
     * @type {number}
     * @memberof V2PlantationsCreateFFBSellPriceRequestItem
     */
    'ffbTotalWeightInKg': number;
    /**
     * the price of FFB sold per Kg
     * @type {number}
     * @memberof V2PlantationsCreateFFBSellPriceRequestItem
     */
    'ffbPricePerKg': number;
    /**
     * 
     * @type {PlantationsCreateFFBSellPriceRequestDataBuyer}
     * @memberof V2PlantationsCreateFFBSellPriceRequestItem
     */
    'buyer': PlantationsCreateFFBSellPriceRequestDataBuyer;
    /**
     * delivery order name
     * @type {string}
     * @memberof V2PlantationsCreateFFBSellPriceRequestItem
     */
    'doName'?: string;
    /**
     * 
     * @type {PlantationsCreateFFBSellPriceRequestDataCost}
     * @memberof V2PlantationsCreateFFBSellPriceRequestItem
     */
    'cost': PlantationsCreateFFBSellPriceRequestDataCost;
    /**
     * 
     * @type {PlantationsCreateFFBSellPriceRequestDataTransport}
     * @memberof V2PlantationsCreateFFBSellPriceRequestItem
     */
    'transport': PlantationsCreateFFBSellPriceRequestDataTransport;
    /**
     * image url of ffb sell price
     * @type {string}
     * @memberof V2PlantationsCreateFFBSellPriceRequestItem
     */
    'photoUrl'?: string;
    /**
     * used by DUTA app, id of the user that this request is for
     * @type {string}
     * @memberof V2PlantationsCreateFFBSellPriceRequestItem
     */
    'userId'?: string;
    /**
     * UNIX millis when data is modified offline
     * @type {number}
     * @memberof V2PlantationsCreateFFBSellPriceRequestItem
     */
    'offlineModifiedAtUtc0'?: number;
}
/**
 * 
 * @export
 * @interface V2PlantationsCreateFFBSellPriceResponse
 */
export interface V2PlantationsCreateFFBSellPriceResponse {
    /**
     * List of data that are processed successfully
     * @type {Array<V2PlantationsCreateFFBSellPriceResponseItem>}
     * @memberof V2PlantationsCreateFFBSellPriceResponse
     */
    'successItems'?: Array<V2PlantationsCreateFFBSellPriceResponseItem>;
    /**
     * List of data with error
     * @type {Array<V2PlantationsCreateFFBSellPriceResponseItem>}
     * @memberof V2PlantationsCreateFFBSellPriceResponse
     */
    'failedItems'?: Array<V2PlantationsCreateFFBSellPriceResponseItem>;
    /**
     * Sawitpoin reward for submitting FFB sell price data, if <= 0 user is not eligible for Sawitpoin reward 
     * @type {number}
     * @memberof V2PlantationsCreateFFBSellPriceResponse
     */
    'sawitpoin'?: number;
}
/**
 * 
 * @export
 * @interface V2PlantationsCreateFFBSellPriceResponseItem
 */
export interface V2PlantationsCreateFFBSellPriceResponseItem {
    /**
     * Id of FFB sell price record
     * @type {string}
     * @memberof V2PlantationsCreateFFBSellPriceResponseItem
     */
    'id': string;
    /**
     * Contains error that occured during data processing
     * @type {string}
     * @memberof V2PlantationsCreateFFBSellPriceResponseItem
     */
    'errorMessage'?: string;
}
/**
 * 
 * @export
 * @interface V2PlantationsGetSchedulesResponse
 */
export interface V2PlantationsGetSchedulesResponse {
    /**
     * 
     * @type {Array<V2PlantationsGetSchedulesResponseItem>}
     * @memberof V2PlantationsGetSchedulesResponse
     */
    'items': Array<V2PlantationsGetSchedulesResponseItem>;
}
/**
 * 
 * @export
 * @interface V2PlantationsGetSchedulesResponseItem
 */
export interface V2PlantationsGetSchedulesResponseItem {
    /**
     * id of a schedule represented in UUID type 4
     * @type {string}
     * @memberof V2PlantationsGetSchedulesResponseItem
     */
    'id': string;
    /**
     * 
     * @type {PlantationActivityTypeEnum}
     * @memberof V2PlantationsGetSchedulesResponseItem
     */
    'plantationActivityType': PlantationActivityTypeEnum;
    /**
     * user id of worker which has HARVEST SUPERVISOR role represented in UUID type 4
     * @type {string}
     * @memberof V2PlantationsGetSchedulesResponseItem
     */
    'supervisorId': string;
    /**
     * Name of the supervisor for this plantation schedule
     * @type {string}
     * @memberof V2PlantationsGetSchedulesResponseItem
     */
    'supervisorName': string;
    /**
     * schedule date in unix timestamp
     * @type {number}
     * @memberof V2PlantationsGetSchedulesResponseItem
     */
    'scheduleDateUtc0': number;
    /**
     * 
     * @type {PlantationScheduleStatusEnum}
     * @memberof V2PlantationsGetSchedulesResponseItem
     */
    'status': PlantationScheduleStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof V2PlantationsGetSchedulesResponseItem
     */
    'workInstruction': string;
    /**
     * 
     * @type {Array<PlantationsGetSchedulesBlockItemResponse>}
     * @memberof V2PlantationsGetSchedulesResponseItem
     */
    'blocks': Array<PlantationsGetSchedulesBlockItemResponse>;
}


/**
 * 
 * @export
 * @interface V2SubAgentTruckCreate
 */
export interface V2SubAgentTruckCreate {
    /**
     * Plat no of truck
     * @type {string}
     * @memberof V2SubAgentTruckCreate
     */
    'platNo': string;
    /**
     * Code of sub-agent
     * @type {string}
     * @memberof V2SubAgentTruckCreate
     */
    'subAgentCode': string;
    /**
     * The ticket no of the weighbridge ticket
     * @type {string}
     * @memberof V2SubAgentTruckCreate
     */
    'weighbridgeNo'?: string;
}
/**
 * 
 * @export
 * @interface V3AssetsCreateOrUpdateFarmsRequest
 */
export interface V3AssetsCreateOrUpdateFarmsRequest {
    /**
     * list of assets farm that will be inserted or updated
     * @type {Array<V3AssetsCreateOrUpdateFarmsRequestItem>}
     * @memberof V3AssetsCreateOrUpdateFarmsRequest
     */
    'items': Array<V3AssetsCreateOrUpdateFarmsRequestItem>;
}
/**
 * 
 * @export
 * @interface V3AssetsCreateOrUpdateFarmsRequestItem
 */
export interface V3AssetsCreateOrUpdateFarmsRequestItem {
    /**
     * id of a farm represented in UUID type 4 <br> when present and UUID value already exist in DB `farm` table, will update DB data based on the other req body field values, <br> otherwise will create new farm data in DB based on the other req body field values
     * @type {string}
     * @memberof V3AssetsCreateOrUpdateFarmsRequestItem
     */
    'id': string;
    /**
     * optional, name of the farm, when empty will be generated by system in \"{village name} ({ha}) {number}\" format
     * @type {string}
     * @memberof V3AssetsCreateOrUpdateFarmsRequestItem
     */
    'name'?: string;
    /**
     * 
     * @type {Village}
     * @memberof V3AssetsCreateOrUpdateFarmsRequestItem
     */
    'village'?: Village;
    /**
     * farm size in hectare
     * @type {number}
     * @memberof V3AssetsCreateOrUpdateFarmsRequestItem
     */
    'areaHectare'?: number;
    /**
     * Year of planting
     * @type {number}
     * @memberof V3AssetsCreateOrUpdateFarmsRequestItem
     */
    'plantedYear'?: number;
    /**
     * Month of planting
     * @type {number}
     * @memberof V3AssetsCreateOrUpdateFarmsRequestItem
     */
    'plantedMonth'?: number;
    /**
     * number of trees planted per hectare
     * @type {number}
     * @memberof V3AssetsCreateOrUpdateFarmsRequestItem
     */
    'palmTreesPerHectare'?: number;
    /**
     * IDs of the seeds used in the farm, choices is from API `GET /api/v1/plantations/seeds`
     * @type {Array<string>}
     * @memberof V3AssetsCreateOrUpdateFarmsRequestItem
     */
    'seedIds'?: Array<string>;
    /**
     * ID of the soil type of the farm
     * @type {string}
     * @memberof V3AssetsCreateOrUpdateFarmsRequestItem
     */
    'soilTypeId'?: string;
    /**
     * describe the Average Estate Monthly Yield per hectare in ton
     * @type {number}
     * @memberof V3AssetsCreateOrUpdateFarmsRequestItem
     */
    'averageEstateMonthlyYield'?: number;
    /**
     * attachment photo url
     * @type {string}
     * @memberof V3AssetsCreateOrUpdateFarmsRequestItem
     */
    'photoUrl'?: string;
    /**
     * 
     * @type {UserActivityLocationInput}
     * @memberof V3AssetsCreateOrUpdateFarmsRequestItem
     */
    'activityLocation'?: UserActivityLocationInput;
    /**
     * used by DUTA app, id of the user that this request is for
     * @type {string}
     * @memberof V3AssetsCreateOrUpdateFarmsRequestItem
     */
    'userId'?: string;
    /**
     * UNIX millis when data is modified offline
     * @type {number}
     * @memberof V3AssetsCreateOrUpdateFarmsRequestItem
     */
    'offlineModifiedAtUtc0'?: number;
}
/**
 * 
 * @export
 * @interface V3AssetsCreateOrUpdateFarmsResponse
 */
export interface V3AssetsCreateOrUpdateFarmsResponse {
    /**
     * List of data that are processed successfully
     * @type {Array<V3AssetsCreateOrUpdateFarmsResponseItem>}
     * @memberof V3AssetsCreateOrUpdateFarmsResponse
     */
    'successItems'?: Array<V3AssetsCreateOrUpdateFarmsResponseItem>;
    /**
     * List of data with error
     * @type {Array<V3AssetsCreateOrUpdateFarmsResponseItem>}
     * @memberof V3AssetsCreateOrUpdateFarmsResponse
     */
    'failedItems'?: Array<V3AssetsCreateOrUpdateFarmsResponseItem>;
    /**
     * Sawitpoin reward for creating asset farm data, if <= 0 user is not eligible for Sawitpoin reward 
     * @type {number}
     * @memberof V3AssetsCreateOrUpdateFarmsResponse
     */
    'sawitpoin'?: number;
}
/**
 * 
 * @export
 * @interface V3AssetsCreateOrUpdateFarmsResponseItem
 */
export interface V3AssetsCreateOrUpdateFarmsResponseItem {
    /**
     * Id of asset farm data
     * @type {string}
     * @memberof V3AssetsCreateOrUpdateFarmsResponseItem
     */
    'id': string;
    /**
     * Contains error that occured during data processing
     * @type {string}
     * @memberof V3AssetsCreateOrUpdateFarmsResponseItem
     */
    'errorMessage'?: string;
}
/**
 * 
 * @export
 * @interface V3ReportContractDetailResponse
 */
export interface V3ReportContractDetailResponse {
    /**
     * total value of weight net adjusted in ton
     * @type {number}
     * @memberof V3ReportContractDetailResponse
     */
    'total': number;
    /**
     * 
     * @type {Array<V3ReportContractSummaryDetailChartItem>}
     * @memberof V3ReportContractDetailResponse
     */
    'reports': Array<V3ReportContractSummaryDetailChartItem>;
}
/**
 * 
 * @export
 * @interface V3ReportContractSummaryDetailChartItem
 */
export interface V3ReportContractSummaryDetailChartItem {
    /**
     * entry or exit time of weighbridge data
     * @type {number}
     * @memberof V3ReportContractSummaryDetailChartItem
     */
    'date': number;
    /**
     * 
     * @type {number}
     * @memberof V3ReportContractSummaryDetailChartItem
     */
    'value': number;
}
/**
 * 
 * @export
 * @interface V3ReportsContractsSummariesResponse
 */
export interface V3ReportsContractsSummariesResponse {
    /**
     * 
     * @type {Array<V3ReportsContractsSummariesResponseItem>}
     * @memberof V3ReportsContractsSummariesResponse
     */
    'items': Array<V3ReportsContractsSummariesResponseItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof V3ReportsContractsSummariesResponse
     */
    'pagination': PaginationResponse;
}
/**
 * 
 * @export
 * @interface V3ReportsContractsSummariesResponseItem
 */
export interface V3ReportsContractsSummariesResponseItem {
    /**
     * the name of the DO/SP/PB
     * @type {string}
     * @memberof V3ReportsContractsSummariesResponseItem
     */
    'supplierContractName': string;
    /**
     * count of the mill the DO supply
     * @type {number}
     * @memberof V3ReportsContractsSummariesResponseItem
     */
    'millCount': number;
    /**
     * the month and year of the report
     * @type {string}
     * @memberof V3ReportsContractsSummariesResponseItem
     */
    'monthYear': string;
    /**
     * the total of supply the DO done delivered to the mills in ton
     * @type {number}
     * @memberof V3ReportsContractsSummariesResponseItem
     */
    'totalSupply': number;
    /**
     * the last supply the DO done delivered to the mills in ton
     * @type {number}
     * @memberof V3ReportsContractsSummariesResponseItem
     */
    'lastSupply': number;
}
/**
 * 
 * @export
 * @interface V4ReportContractDetailOfDetailResponse
 */
export interface V4ReportContractDetailOfDetailResponse {
    /**
     * Registered Name of Supplier Contract
     * @type {string}
     * @memberof V4ReportContractDetailOfDetailResponse
     */
    'supplierContractName': string;
    /**
     * Partner Name
     * @type {string}
     * @memberof V4ReportContractDetailOfDetailResponse
     */
    'partnerName': string;
    /**
     * 
     * @type {Array<V4ReportContractDetailOfDetailResponseItem>}
     * @memberof V4ReportContractDetailOfDetailResponse
     */
    'items': Array<V4ReportContractDetailOfDetailResponseItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof V4ReportContractDetailOfDetailResponse
     */
    'pagination': PaginationResponse;
}
/**
 * 
 * @export
 * @interface V4ReportContractDetailOfDetailResponseItem
 */
export interface V4ReportContractDetailOfDetailResponseItem {
    /**
     * truck plate number
     * @type {string}
     * @memberof V4ReportContractDetailOfDetailResponseItem
     */
    'platNumber': string;
    /**
     * weighnet adjusted supply in ton and round down
     * @type {number}
     * @memberof V4ReportContractDetailOfDetailResponseItem
     */
    'weighNetAdjustedTon': number;
    /**
     * the sortation data in weighslip with 2 decimal and round down
     * @type {number}
     * @memberof V4ReportContractDetailOfDetailResponseItem
     */
    'sortation': number;
    /**
     * flag showing the supply is above average deviation
     * @type {boolean}
     * @memberof V4ReportContractDetailOfDetailResponseItem
     */
    'isOutlierSortation': boolean;
}
/**
 * 
 * @export
 * @interface V4ReportContractDetailResponse
 */
export interface V4ReportContractDetailResponse {
    /**
     * Registered Name of Supplier Contract
     * @type {string}
     * @memberof V4ReportContractDetailResponse
     */
    'supplierContractName': string;
    /**
     * Partner Name
     * @type {string}
     * @memberof V4ReportContractDetailResponse
     */
    'partnerName': string;
    /**
     * 
     * @type {Array<V4ReportContractDetailResponseItem>}
     * @memberof V4ReportContractDetailResponse
     */
    'items': Array<V4ReportContractDetailResponseItem>;
}
/**
 * 
 * @export
 * @interface V4ReportContractDetailResponseItem
 */
export interface V4ReportContractDetailResponseItem {
    /**
     * entry or exit date in weighbridge data
     * @type {number}
     * @memberof V4ReportContractDetailResponseItem
     */
    'date': number;
    /**
     * the total of supply in ton
     * @type {number}
     * @memberof V4ReportContractDetailResponseItem
     */
    'total': number;
    /**
     * 
     * @type {Array<V4ReportContractDetailResponseItemSupplies>}
     * @memberof V4ReportContractDetailResponseItem
     */
    'supplies': Array<V4ReportContractDetailResponseItemSupplies>;
}
/**
 * 
 * @export
 * @interface V4ReportContractDetailResponseItemSupplies
 */
export interface V4ReportContractDetailResponseItemSupplies {
    /**
     * truck plate number
     * @type {string}
     * @memberof V4ReportContractDetailResponseItemSupplies
     */
    'platNumber': string;
    /**
     * weighnet adjusted supply in ton and round down
     * @type {number}
     * @memberof V4ReportContractDetailResponseItemSupplies
     */
    'weighNetAdjustedTon': number;
    /**
     * the sortation data in weighslip with 2 decimal and round down
     * @type {number}
     * @memberof V4ReportContractDetailResponseItemSupplies
     */
    'sortation': number;
    /**
     * flag showing the supply is above average deviation
     * @type {boolean}
     * @memberof V4ReportContractDetailResponseItemSupplies
     */
    'isOutlierSortation': boolean;
}
/**
 * 
 * @export
 * @interface V4ReportsContractsSummariesResponse
 */
export interface V4ReportsContractsSummariesResponse {
    /**
     * 
     * @type {Array<V4ReportsContractsSummariesResponseItem>}
     * @memberof V4ReportsContractsSummariesResponse
     */
    'items': Array<V4ReportsContractsSummariesResponseItem>;
}
/**
 * 
 * @export
 * @interface V4ReportsContractsSummariesResponseItem
 */
export interface V4ReportsContractsSummariesResponseItem {
    /**
     * name of the supplier contract
     * @type {string}
     * @memberof V4ReportsContractsSummariesResponseItem
     */
    'supplierContractName': string;
    /**
     * id of supplier contract
     * @type {string}
     * @memberof V4ReportsContractsSummariesResponseItem
     */
    'supplierContractId': string;
    /**
     * name of partner
     * @type {string}
     * @memberof V4ReportsContractsSummariesResponseItem
     */
    'partnerName': string;
    /**
     * id of partner
     * @type {string}
     * @memberof V4ReportsContractsSummariesResponseItem
     */
    'partnerId': string;
    /**
     * supplier contract\'s total trip
     * @type {number}
     * @memberof V4ReportsContractsSummariesResponseItem
     */
    'totalTrip': number;
    /**
     * supplier contract\'s total supply in tonnage (round floor)
     * @type {number}
     * @memberof V4ReportsContractsSummariesResponseItem
     */
    'totalSupply': number;
    /**
     * supplier contract\'s sortation average (only 2 digit after comma, round floor)
     * @type {number}
     * @memberof V4ReportsContractsSummariesResponseItem
     */
    'sortationAverage': number;
    /**
     * supplier contract\'s latest supply date in unixmilli
     * @type {number}
     * @memberof V4ReportsContractsSummariesResponseItem
     */
    'latestSupply': number;
    /**
     * supplier contract\'s latest supply date which the sortation is outlier in unixmilli
     * @type {number}
     * @memberof V4ReportsContractsSummariesResponseItem
     */
    'latestOutlierSortation': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const VendorDirectionEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;

export type VendorDirectionEnum = typeof VendorDirectionEnum[keyof typeof VendorDirectionEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const VendorEnum = {
    Doku: 'DOKU'
} as const;

export type VendorEnum = typeof VendorEnum[keyof typeof VendorEnum];


/**
 * type  = This field is used for sorting by the vendor type ownerName  = This field is used for sorting by the owner name of the vendor regency    = This field is used for sorting by the regency of the vendor status     = This field is used for sorting by the status of the vendor 
 * @export
 * @enum {string}
 */

export const VendorSortFieldEnum = {
    Type: 'type',
    OwnerName: 'ownerName',
    Regency: 'regency',
    Status: 'status'
} as const;

export type VendorSortFieldEnum = typeof VendorSortFieldEnum[keyof typeof VendorSortFieldEnum];


/**
 * Enum product status
 * @export
 * @enum {string}
 */

export const VendorStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE'
} as const;

export type VendorStatusEnum = typeof VendorStatusEnum[keyof typeof VendorStatusEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const VendorTypeEnum = {
    FarmerStore: 'FARMER_STORE',
    GroceryStore: 'GROCERY_STORE',
    Company: 'COMPANY'
} as const;

export type VendorTypeEnum = typeof VendorTypeEnum[keyof typeof VendorTypeEnum];


/**
 * 
 * @export
 * @interface Village
 */
export interface Village {
    /**
     * Village ID that sourced from \"https://map.igismap.com/gis-data/indonesia/administrative_division_village_boundaries_id1\"
     * @type {string}
     * @memberof Village
     */
    'id': string;
    /**
     * Village name
     * @type {string}
     * @memberof Village
     */
    'name': string;
}
/**
 * Voucher discount type
 * @export
 * @enum {string}
 */

export const VoucherDiscountTypeEnum = {
    Percentage: 'PERCENTAGE',
    Nominal: 'NOMINAL',
    Sawitpoinpercentage: 'SAWITPOINPERCENTAGE'
} as const;

export type VoucherDiscountTypeEnum = typeof VoucherDiscountTypeEnum[keyof typeof VoucherDiscountTypeEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const VoucherTypeEnum = {
    Private: 'PRIVATE',
    Public: 'PUBLIC'
} as const;

export type VoucherTypeEnum = typeof VoucherTypeEnum[keyof typeof VoucherTypeEnum];


/**
 * 
 * @export
 * @interface WebhooksDokuReceivePaymentNotificationAcquirerObject
 */
export interface WebhooksDokuReceivePaymentNotificationAcquirerObject {
    /**
     * 
     * @type {string}
     * @memberof WebhooksDokuReceivePaymentNotificationAcquirerObject
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface WebhooksDokuReceivePaymentNotificationChannelObject
 */
export interface WebhooksDokuReceivePaymentNotificationChannelObject {
    /**
     * 
     * @type {string}
     * @memberof WebhooksDokuReceivePaymentNotificationChannelObject
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface WebhooksDokuReceivePaymentNotificationIdentifierObject
 */
export interface WebhooksDokuReceivePaymentNotificationIdentifierObject {
    /**
     * 
     * @type {string}
     * @memberof WebhooksDokuReceivePaymentNotificationIdentifierObject
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof WebhooksDokuReceivePaymentNotificationIdentifierObject
     */
    'value'?: string;
}
/**
 * 
 * @export
 * @interface WebhooksDokuReceivePaymentNotificationOrderObject
 */
export interface WebhooksDokuReceivePaymentNotificationOrderObject {
    /**
     * 
     * @type {string}
     * @memberof WebhooksDokuReceivePaymentNotificationOrderObject
     */
    'invoice_number': string;
    /**
     * 
     * @type {number}
     * @memberof WebhooksDokuReceivePaymentNotificationOrderObject
     */
    'amount': number;
}
/**
 * 
 * @export
 * @interface WebhooksDokuReceivePaymentNotificationRequest
 */
export interface WebhooksDokuReceivePaymentNotificationRequest {
    /**
     * 
     * @type {WebhooksDokuReceivePaymentNotificationServiceObject}
     * @memberof WebhooksDokuReceivePaymentNotificationRequest
     */
    'service': WebhooksDokuReceivePaymentNotificationServiceObject;
    /**
     * 
     * @type {WebhooksDokuReceivePaymentNotificationAcquirerObject}
     * @memberof WebhooksDokuReceivePaymentNotificationRequest
     */
    'acquirer': WebhooksDokuReceivePaymentNotificationAcquirerObject;
    /**
     * 
     * @type {WebhooksDokuReceivePaymentNotificationChannelObject}
     * @memberof WebhooksDokuReceivePaymentNotificationRequest
     */
    'channel': WebhooksDokuReceivePaymentNotificationChannelObject;
    /**
     * 
     * @type {WebhooksDokuReceivePaymentNotificationTransactionObject}
     * @memberof WebhooksDokuReceivePaymentNotificationRequest
     */
    'transaction': WebhooksDokuReceivePaymentNotificationTransactionObject;
    /**
     * 
     * @type {WebhooksDokuReceivePaymentNotificationOrderObject}
     * @memberof WebhooksDokuReceivePaymentNotificationRequest
     */
    'order': WebhooksDokuReceivePaymentNotificationOrderObject;
    /**
     * 
     * @type {WebhooksDokuReceivePaymentNotificationVirtualAccountInfoObject}
     * @memberof WebhooksDokuReceivePaymentNotificationRequest
     */
    'virtual_account_info': WebhooksDokuReceivePaymentNotificationVirtualAccountInfoObject;
    /**
     * 
     * @type {WebhooksDokuReceivePaymentNotificationVirtualAccountPaymentObject}
     * @memberof WebhooksDokuReceivePaymentNotificationRequest
     */
    'virtual_account_payment': WebhooksDokuReceivePaymentNotificationVirtualAccountPaymentObject;
}
/**
 * 
 * @export
 * @interface WebhooksDokuReceivePaymentNotificationServiceObject
 */
export interface WebhooksDokuReceivePaymentNotificationServiceObject {
    /**
     * 
     * @type {string}
     * @memberof WebhooksDokuReceivePaymentNotificationServiceObject
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface WebhooksDokuReceivePaymentNotificationTransactionObject
 */
export interface WebhooksDokuReceivePaymentNotificationTransactionObject {
    /**
     * 
     * @type {string}
     * @memberof WebhooksDokuReceivePaymentNotificationTransactionObject
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof WebhooksDokuReceivePaymentNotificationTransactionObject
     */
    'date': string;
    /**
     * 
     * @type {string}
     * @memberof WebhooksDokuReceivePaymentNotificationTransactionObject
     */
    'original_request_id': string;
}
/**
 * 
 * @export
 * @interface WebhooksDokuReceivePaymentNotificationVirtualAccountInfoObject
 */
export interface WebhooksDokuReceivePaymentNotificationVirtualAccountInfoObject {
    /**
     * 
     * @type {string}
     * @memberof WebhooksDokuReceivePaymentNotificationVirtualAccountInfoObject
     */
    'virtual_account_number': string;
}
/**
 * 
 * @export
 * @interface WebhooksDokuReceivePaymentNotificationVirtualAccountPaymentObject
 */
export interface WebhooksDokuReceivePaymentNotificationVirtualAccountPaymentObject {
    /**
     * 
     * @type {Array<WebhooksDokuReceivePaymentNotificationIdentifierObject>}
     * @memberof WebhooksDokuReceivePaymentNotificationVirtualAccountPaymentObject
     */
    'identifier'?: Array<WebhooksDokuReceivePaymentNotificationIdentifierObject>;
}
/**
 * 
 * @export
 * @interface WebhooksIvowabaReceiveInboundMessageNotificationContactItem
 */
export interface WebhooksIvowabaReceiveInboundMessageNotificationContactItem {
    /**
     * 
     * @type {WebhooksIvowabaReceiveInboundMessageNotificationContactItemProfile}
     * @memberof WebhooksIvowabaReceiveInboundMessageNotificationContactItem
     */
    'profile'?: WebhooksIvowabaReceiveInboundMessageNotificationContactItemProfile;
    /**
     * 
     * @type {string}
     * @memberof WebhooksIvowabaReceiveInboundMessageNotificationContactItem
     */
    'wa_id': string;
}
/**
 * 
 * @export
 * @interface WebhooksIvowabaReceiveInboundMessageNotificationContactItemProfile
 */
export interface WebhooksIvowabaReceiveInboundMessageNotificationContactItemProfile {
    /**
     * 
     * @type {string}
     * @memberof WebhooksIvowabaReceiveInboundMessageNotificationContactItemProfile
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface WebhooksIvowabaReceiveInboundMessageNotificationMessageItem
 */
export interface WebhooksIvowabaReceiveInboundMessageNotificationMessageItem {
    /**
     * 
     * @type {string}
     * @memberof WebhooksIvowabaReceiveInboundMessageNotificationMessageItem
     */
    'from': string;
    /**
     * Message ID
     * @type {string}
     * @memberof WebhooksIvowabaReceiveInboundMessageNotificationMessageItem
     */
    'id': string;
    /**
     * Message timestamp
     * @type {string}
     * @memberof WebhooksIvowabaReceiveInboundMessageNotificationMessageItem
     */
    'timestamp': string;
    /**
     * Message type
     * @type {string}
     * @memberof WebhooksIvowabaReceiveInboundMessageNotificationMessageItem
     */
    'type': string;
    /**
     * 
     * @type {WebhooksIvowabaReceiveInboundMessageNotificationMessageItemText}
     * @memberof WebhooksIvowabaReceiveInboundMessageNotificationMessageItem
     */
    'text'?: WebhooksIvowabaReceiveInboundMessageNotificationMessageItemText;
}
/**
 * 
 * @export
 * @interface WebhooksIvowabaReceiveInboundMessageNotificationMessageItemText
 */
export interface WebhooksIvowabaReceiveInboundMessageNotificationMessageItemText {
    /**
     * 
     * @type {string}
     * @memberof WebhooksIvowabaReceiveInboundMessageNotificationMessageItemText
     */
    'body'?: string;
}
/**
 * 
 * @export
 * @interface WebhooksIvowabaReceiveInboundMessageNotificationRequest
 */
export interface WebhooksIvowabaReceiveInboundMessageNotificationRequest {
    /**
     * 
     * @type {Array<WebhooksIvowabaReceiveInboundMessageNotificationContactItem>}
     * @memberof WebhooksIvowabaReceiveInboundMessageNotificationRequest
     */
    'contacts'?: Array<WebhooksIvowabaReceiveInboundMessageNotificationContactItem>;
    /**
     * 
     * @type {Array<WebhooksIvowabaReceiveInboundMessageNotificationMessageItem>}
     * @memberof WebhooksIvowabaReceiveInboundMessageNotificationRequest
     */
    'messages': Array<WebhooksIvowabaReceiveInboundMessageNotificationMessageItem>;
}
/**
 * 
 * @export
 * @interface WebhooksIvowabaReceiveMessageStatusNotificationRequest
 */
export interface WebhooksIvowabaReceiveMessageStatusNotificationRequest {
    /**
     * 
     * @type {Array<WebhooksIvowabaReceiveMessageStatusNotificationStatusItem>}
     * @memberof WebhooksIvowabaReceiveMessageStatusNotificationRequest
     */
    'statuses': Array<WebhooksIvowabaReceiveMessageStatusNotificationStatusItem>;
}
/**
 * 
 * @export
 * @interface WebhooksIvowabaReceiveMessageStatusNotificationStatusItem
 */
export interface WebhooksIvowabaReceiveMessageStatusNotificationStatusItem {
    /**
     * Message ID
     * @type {string}
     * @memberof WebhooksIvowabaReceiveMessageStatusNotificationStatusItem
     */
    'id': string;
    /**
     * Recipient ID
     * @type {string}
     * @memberof WebhooksIvowabaReceiveMessageStatusNotificationStatusItem
     */
    'recipient_id': string;
    /**
     * Message status
     * @type {string}
     * @memberof WebhooksIvowabaReceiveMessageStatusNotificationStatusItem
     */
    'status': WebhooksIvowabaReceiveMessageStatusNotificationStatusItemStatusEnum;
    /**
     * Message type
     * @type {string}
     * @memberof WebhooksIvowabaReceiveMessageStatusNotificationStatusItem
     */
    'type': WebhooksIvowabaReceiveMessageStatusNotificationStatusItemTypeEnum;
    /**
     * Message timestamp in second
     * @type {string}
     * @memberof WebhooksIvowabaReceiveMessageStatusNotificationStatusItem
     */
    'timestamp': string;
    /**
     * 
     * @type {WebhooksIvowabaReceiveMessageStatusNotificationStatusItemConversation}
     * @memberof WebhooksIvowabaReceiveMessageStatusNotificationStatusItem
     */
    'conversation'?: WebhooksIvowabaReceiveMessageStatusNotificationStatusItemConversation;
    /**
     * 
     * @type {WebhooksIvowabaReceiveMessageStatusNotificationStatusItemPricing}
     * @memberof WebhooksIvowabaReceiveMessageStatusNotificationStatusItem
     */
    'pricing'?: WebhooksIvowabaReceiveMessageStatusNotificationStatusItemPricing;
    /**
     * List of errors
     * @type {Array<WebhooksIvowabaReceiveMessageStatusNotificationStatusItemError>}
     * @memberof WebhooksIvowabaReceiveMessageStatusNotificationStatusItem
     */
    'errors'?: Array<WebhooksIvowabaReceiveMessageStatusNotificationStatusItemError>;
}

export const WebhooksIvowabaReceiveMessageStatusNotificationStatusItemStatusEnum = {
    Sent: 'sent',
    Delivered: 'delivered',
    Read: 'read',
    Deleted: 'deleted',
    Failed: 'failed'
} as const;

export type WebhooksIvowabaReceiveMessageStatusNotificationStatusItemStatusEnum = typeof WebhooksIvowabaReceiveMessageStatusNotificationStatusItemStatusEnum[keyof typeof WebhooksIvowabaReceiveMessageStatusNotificationStatusItemStatusEnum];
export const WebhooksIvowabaReceiveMessageStatusNotificationStatusItemTypeEnum = {
    Message: 'message'
} as const;

export type WebhooksIvowabaReceiveMessageStatusNotificationStatusItemTypeEnum = typeof WebhooksIvowabaReceiveMessageStatusNotificationStatusItemTypeEnum[keyof typeof WebhooksIvowabaReceiveMessageStatusNotificationStatusItemTypeEnum];

/**
 * 
 * @export
 * @interface WebhooksIvowabaReceiveMessageStatusNotificationStatusItemConversation
 */
export interface WebhooksIvowabaReceiveMessageStatusNotificationStatusItemConversation {
    /**
     * Conversation ID
     * @type {string}
     * @memberof WebhooksIvowabaReceiveMessageStatusNotificationStatusItemConversation
     */
    'id': string;
    /**
     * Conversation expiration timestamp in second
     * @type {number}
     * @memberof WebhooksIvowabaReceiveMessageStatusNotificationStatusItemConversation
     */
    'expiration_timestamp': number;
    /**
     * 
     * @type {WebhooksIvowabaReceiveMessageStatusNotificationStatusItemConversationOrigin}
     * @memberof WebhooksIvowabaReceiveMessageStatusNotificationStatusItemConversation
     */
    'origin': WebhooksIvowabaReceiveMessageStatusNotificationStatusItemConversationOrigin;
}
/**
 * 
 * @export
 * @interface WebhooksIvowabaReceiveMessageStatusNotificationStatusItemConversationOrigin
 */
export interface WebhooksIvowabaReceiveMessageStatusNotificationStatusItemConversationOrigin {
    /**
     * Conversation origin type
     * @type {string}
     * @memberof WebhooksIvowabaReceiveMessageStatusNotificationStatusItemConversationOrigin
     */
    'type': WebhooksIvowabaReceiveMessageStatusNotificationStatusItemConversationOriginTypeEnum;
}

export const WebhooksIvowabaReceiveMessageStatusNotificationStatusItemConversationOriginTypeEnum = {
    BusinessInitiated: 'business_initiated'
} as const;

export type WebhooksIvowabaReceiveMessageStatusNotificationStatusItemConversationOriginTypeEnum = typeof WebhooksIvowabaReceiveMessageStatusNotificationStatusItemConversationOriginTypeEnum[keyof typeof WebhooksIvowabaReceiveMessageStatusNotificationStatusItemConversationOriginTypeEnum];

/**
 * 
 * @export
 * @interface WebhooksIvowabaReceiveMessageStatusNotificationStatusItemError
 */
export interface WebhooksIvowabaReceiveMessageStatusNotificationStatusItemError {
    /**
     * Error code
     * @type {number}
     * @memberof WebhooksIvowabaReceiveMessageStatusNotificationStatusItemError
     */
    'code': number;
    /**
     * Error message
     * @type {string}
     * @memberof WebhooksIvowabaReceiveMessageStatusNotificationStatusItemError
     */
    'title': string;
    /**
     * Error reference
     * @type {string}
     * @memberof WebhooksIvowabaReceiveMessageStatusNotificationStatusItemError
     */
    'href'?: string;
}
/**
 * 
 * @export
 * @interface WebhooksIvowabaReceiveMessageStatusNotificationStatusItemPricing
 */
export interface WebhooksIvowabaReceiveMessageStatusNotificationStatusItemPricing {
    /**
     * Is billable
     * @type {boolean}
     * @memberof WebhooksIvowabaReceiveMessageStatusNotificationStatusItemPricing
     */
    'billable': boolean;
    /**
     * Message category
     * @type {string}
     * @memberof WebhooksIvowabaReceiveMessageStatusNotificationStatusItemPricing
     */
    'category': WebhooksIvowabaReceiveMessageStatusNotificationStatusItemPricingCategoryEnum;
    /**
     * Pricing model
     * @type {string}
     * @memberof WebhooksIvowabaReceiveMessageStatusNotificationStatusItemPricing
     */
    'pricing_model': WebhooksIvowabaReceiveMessageStatusNotificationStatusItemPricingPricingModelEnum;
}

export const WebhooksIvowabaReceiveMessageStatusNotificationStatusItemPricingCategoryEnum = {
    BusinessInitiated: 'business_initiated'
} as const;

export type WebhooksIvowabaReceiveMessageStatusNotificationStatusItemPricingCategoryEnum = typeof WebhooksIvowabaReceiveMessageStatusNotificationStatusItemPricingCategoryEnum[keyof typeof WebhooksIvowabaReceiveMessageStatusNotificationStatusItemPricingCategoryEnum];
export const WebhooksIvowabaReceiveMessageStatusNotificationStatusItemPricingPricingModelEnum = {
    Cbp: 'CBP'
} as const;

export type WebhooksIvowabaReceiveMessageStatusNotificationStatusItemPricingPricingModelEnum = typeof WebhooksIvowabaReceiveMessageStatusNotificationStatusItemPricingPricingModelEnum[keyof typeof WebhooksIvowabaReceiveMessageStatusNotificationStatusItemPricingPricingModelEnum];

/**
 * @type WebhooksIvowabaReceiveNotificationRequest
 * @export
 */
export type WebhooksIvowabaReceiveNotificationRequest = WebhooksIvowabaReceiveInboundMessageNotificationRequest | WebhooksIvowabaReceiveMessageStatusNotificationRequest;

/**
 * 
 * @export
 * @interface WeighbridgeCargoDescGetResponse
 */
export interface WeighbridgeCargoDescGetResponse {
    /**
     * Partner name
     * @type {string}
     * @memberof WeighbridgeCargoDescGetResponse
     */
    'partner': string;
    /**
     * Entry datetime (in epoch)
     * @type {number}
     * @memberof WeighbridgeCargoDescGetResponse
     */
    'lastSupplyDate': number;
    /**
     * Cargo description
     * @type {string}
     * @memberof WeighbridgeCargoDescGetResponse
     */
    'cargoDesc': string;
    /**
     * 
     * @type {number}
     * @memberof WeighbridgeCargoDescGetResponse
     */
    'lastSupply': number;
    /**
     * 
     * @type {number}
     * @memberof WeighbridgeCargoDescGetResponse
     */
    'thisMonthSupply': number;
}
/**
 * Weighbridge cost type
 * @export
 * @enum {string}
 */

export const WeighbridgeCostTypeEnum = {
    PerKg: 'PER_KG',
    Fix: 'FIX'
} as const;

export type WeighbridgeCostTypeEnum = typeof WeighbridgeCostTypeEnum[keyof typeof WeighbridgeCostTypeEnum];


/**
 * 
 * @export
 * @interface WeighbridgeGetResponse
 */
export interface WeighbridgeGetResponse {
    /**
     * Image URL of weighbridge_slip.jpeg
     * @type {string}
     * @memberof WeighbridgeGetResponse
     */
    'photo': string;
    /**
     * Delivery number
     * @type {string}
     * @memberof WeighbridgeGetResponse
     */
    'deliveryNo': string;
    /**
     * Number of Slip Timbangan
     * @type {string}
     * @memberof WeighbridgeGetResponse
     */
    'ticketNo': string;
    /**
     * Entry datetime (in epoch)
     * @type {number}
     * @memberof WeighbridgeGetResponse
     */
    'entryTime': number;
    /**
     * Exit datetime (in epoch)
     * @type {number}
     * @memberof WeighbridgeGetResponse
     */
    'exitTime': number;
    /**
     * Weight entry of FFB
     * @type {number}
     * @memberof WeighbridgeGetResponse
     */
    'weightEntry': number;
    /**
     * Weight exit of FFB
     * @type {number}
     * @memberof WeighbridgeGetResponse
     */
    'weightExit': number;
    /**
     * Weight netto of FFB
     * @type {number}
     * @memberof WeighbridgeGetResponse
     */
    'weightNetKg': number;
    /**
     * Percentage of sortation
     * @type {number}
     * @memberof WeighbridgeGetResponse
     */
    'sortation': number;
    /**
     * Adjustment weight of FFB
     * @type {number}
     * @memberof WeighbridgeGetResponse
     */
    'adjustmentKg': number;
    /**
     * Final weight counted of FFB
     * @type {number}
     * @memberof WeighbridgeGetResponse
     */
    'weightNetAdjustedKg': number;
    /**
     * Name of the operator
     * @type {string}
     * @memberof WeighbridgeGetResponse
     */
    'operatorName': string;
    /**
     * Quantity of bunch
     * @type {number}
     * @memberof WeighbridgeGetResponse
     */
    'quantity': number;
    /**
     * Average weight of bunch
     * @type {number}
     * @memberof WeighbridgeGetResponse
     */
    'weightAverageBunchKg': number;
    /**
     * Name of supplier
     * @type {string}
     * @memberof WeighbridgeGetResponse
     */
    'supplierName': string;
    /**
     * Truck number
     * @type {string}
     * @memberof WeighbridgeGetResponse
     */
    'truckNo': string;
    /**
     * Driver name
     * @type {string}
     * @memberof WeighbridgeGetResponse
     */
    'driverName': string;
    /**
     * Partner name
     * @type {string}
     * @memberof WeighbridgeGetResponse
     */
    'partnerName': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const WeighbridgeTicketStatusEnum = {
    Fraud: 'FRAUD',
    Confirmed: 'CONFIRMED',
    NeedVerify: 'NEED_VERIFY',
    Duplicate: 'DUPLICATE',
    Verified: 'VERIFIED',
    Rejected: 'REJECTED'
} as const;

export type WeighbridgeTicketStatusEnum = typeof WeighbridgeTicketStatusEnum[keyof typeof WeighbridgeTicketStatusEnum];


/**
 * 
 * @export
 * @interface WeighbridgeUploadBulkSubmitRequest
 */
export interface WeighbridgeUploadBulkSubmitRequest {
    /**
     * List of weighbridgeupload fields
     * @type {Array<WeighbridgeUploadBulkSubmitRequestWeighbridgeuploadsInner>}
     * @memberof WeighbridgeUploadBulkSubmitRequest
     */
    'weighbridgeuploads': Array<WeighbridgeUploadBulkSubmitRequestWeighbridgeuploadsInner>;
}
/**
 * 
 * @export
 * @interface WeighbridgeUploadBulkSubmitRequestWeighbridgeuploadsInner
 */
export interface WeighbridgeUploadBulkSubmitRequestWeighbridgeuploadsInner {
    /**
     * ID of weighbridge
     * @type {string}
     * @memberof WeighbridgeUploadBulkSubmitRequestWeighbridgeuploadsInner
     */
    'id'?: string;
    /**
     * Delivery number (No. SP)
     * @type {string}
     * @memberof WeighbridgeUploadBulkSubmitRequestWeighbridgeuploadsInner
     */
    'deliveryNo'?: string;
    /**
     * Number of Slip Timbangan (No. Tiket)
     * @type {string}
     * @memberof WeighbridgeUploadBulkSubmitRequestWeighbridgeuploadsInner
     */
    'ticketNo'?: string;
    /**
     * Entry datetime in epoch (Tanggal Masuk)
     * @type {number}
     * @memberof WeighbridgeUploadBulkSubmitRequestWeighbridgeuploadsInner
     */
    'entryTime'?: number;
    /**
     * Exit datetime in epoch (Tanggal Keluar)
     * @type {number}
     * @memberof WeighbridgeUploadBulkSubmitRequestWeighbridgeuploadsInner
     */
    'exitTime'?: number;
    /**
     * Weight entry of FFB (Berat Masuk)
     * @type {number}
     * @memberof WeighbridgeUploadBulkSubmitRequestWeighbridgeuploadsInner
     */
    'weightEntry'?: number;
    /**
     * Weight exit of FFB (Berat Keluar)
     * @type {number}
     * @memberof WeighbridgeUploadBulkSubmitRequestWeighbridgeuploadsInner
     */
    'weightExit'?: number;
    /**
     * Weight netto of FFB (Berat Netto)
     * @type {number}
     * @memberof WeighbridgeUploadBulkSubmitRequestWeighbridgeuploadsInner
     */
    'weightNetKg'?: number;
    /**
     * Percentage of sortation (Sortasi)
     * @type {number}
     * @memberof WeighbridgeUploadBulkSubmitRequestWeighbridgeuploadsInner
     */
    'sortation'?: number;
    /**
     * Adjustment weight of FFB (Potongan)
     * @type {number}
     * @memberof WeighbridgeUploadBulkSubmitRequestWeighbridgeuploadsInner
     */
    'adjustmentKg'?: number;
    /**
     * Final weight counted of FFB (Netto)
     * @type {number}
     * @memberof WeighbridgeUploadBulkSubmitRequestWeighbridgeuploadsInner
     */
    'weightNetAdjustedKg'?: number;
    /**
     * Name of the operator (Operator WBS)
     * @type {string}
     * @memberof WeighbridgeUploadBulkSubmitRequestWeighbridgeuploadsInner
     */
    'operatorName'?: string;
    /**
     * Quantity of bunch (Jumlah Janjang)
     * @type {number}
     * @memberof WeighbridgeUploadBulkSubmitRequestWeighbridgeuploadsInner
     */
    'quantity'?: number;
    /**
     * Average weight of bunch (Komidel)
     * @type {number}
     * @memberof WeighbridgeUploadBulkSubmitRequestWeighbridgeuploadsInner
     */
    'weightAverageBunchKg'?: number;
    /**
     * Name of supplier (Dari Supplier)
     * @type {string}
     * @memberof WeighbridgeUploadBulkSubmitRequestWeighbridgeuploadsInner
     */
    'supplierName'?: string;
    /**
     * Truck number (No. Kendaraan)
     * @type {string}
     * @memberof WeighbridgeUploadBulkSubmitRequestWeighbridgeuploadsInner
     */
    'truckNo'?: string;
    /**
     * Driver name (Nama Sopir)
     * @type {string}
     * @memberof WeighbridgeUploadBulkSubmitRequestWeighbridgeuploadsInner
     */
    'driverName'?: string;
    /**
     * Partner name (PMKS / Pembeli TBS)
     * @type {string}
     * @memberof WeighbridgeUploadBulkSubmitRequestWeighbridgeuploadsInner
     */
    'partnerName'?: string;
    /**
     * 
     * @type {WeighbridgeUploadStatusEnum}
     * @memberof WeighbridgeUploadBulkSubmitRequestWeighbridgeuploadsInner
     */
    'status'?: WeighbridgeUploadStatusEnum;
    /**
     * 
     * @type {WeighbridgeUploadOcrStatusEnum}
     * @memberof WeighbridgeUploadBulkSubmitRequestWeighbridgeuploadsInner
     */
    'ocrStatus'?: WeighbridgeUploadOcrStatusEnum;
    /**
     * Flagging to indicate data is from OCR
     * @type {boolean}
     * @memberof WeighbridgeUploadBulkSubmitRequestWeighbridgeuploadsInner
     */
    'isFromOcr'?: boolean;
}


/**
 * 
 * @export
 * @interface WeighbridgeUploadBulkSubmitRequestWeighbridgeuploadsInnerAllOf
 */
export interface WeighbridgeUploadBulkSubmitRequestWeighbridgeuploadsInnerAllOf {
    /**
     * ID of weighbridge
     * @type {string}
     * @memberof WeighbridgeUploadBulkSubmitRequestWeighbridgeuploadsInnerAllOf
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface WeighbridgeUploadBulkSubmitResponse
 */
export interface WeighbridgeUploadBulkSubmitResponse {
    /**
     * 
     * @type {boolean}
     * @memberof WeighbridgeUploadBulkSubmitResponse
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface WeighbridgeUploadCreateRequest
 */
export interface WeighbridgeUploadCreateRequest {
    /**
     * original file name with extension
     * @type {string}
     * @memberof WeighbridgeUploadCreateRequest
     */
    'originalFileName': string;
    /**
     * number of file size in bytes
     * @type {number}
     * @memberof WeighbridgeUploadCreateRequest
     */
    'fileSize': number;
    /**
     * 
     * @type {WeighbridgeUploadCreateRequestCoordinate}
     * @memberof WeighbridgeUploadCreateRequest
     */
    'coordinate': WeighbridgeUploadCreateRequestCoordinate;
    /**
     * picture metadata in string json format (optional)
     * @type {string}
     * @memberof WeighbridgeUploadCreateRequest
     */
    'metadata'?: string;
}
/**
 * 
 * @export
 * @interface WeighbridgeUploadCreateRequestCoordinate
 */
export interface WeighbridgeUploadCreateRequestCoordinate {
    /**
     * latitude coordinate
     * @type {number}
     * @memberof WeighbridgeUploadCreateRequestCoordinate
     */
    'latitude': number;
    /**
     * longitude coordinate
     * @type {number}
     * @memberof WeighbridgeUploadCreateRequestCoordinate
     */
    'longitude': number;
}
/**
 * 
 * @export
 * @interface WeighbridgeUploadCreateResponse
 */
export interface WeighbridgeUploadCreateResponse {
    /**
     * 
     * @type {string}
     * @memberof WeighbridgeUploadCreateResponse
     */
    'id': string;
    /**
     * 
     * @type {FileUploadDestination}
     * @memberof WeighbridgeUploadCreateResponse
     */
    'upload': FileUploadDestination;
    /**
     * Created Datetime of Weighbridge in epoch
     * @type {number}
     * @memberof WeighbridgeUploadCreateResponse
     */
    'createdAt': number;
}
/**
 * 
 * @export
 * @interface WeighbridgeUploadDetailResponse
 */
export interface WeighbridgeUploadDetailResponse {
    /**
     * ID of weighbridge data
     * @type {string}
     * @memberof WeighbridgeUploadDetailResponse
     */
    'id': string;
    /**
     * Image URL of weighbridge_slip.jpeg
     * @type {string}
     * @memberof WeighbridgeUploadDetailResponse
     */
    'photoUrl': string;
    /**
     * Delivery number (No. SP)
     * @type {string}
     * @memberof WeighbridgeUploadDetailResponse
     */
    'deliveryNo': string;
    /**
     * Number of Slip Timbangan (No. Tiket)
     * @type {string}
     * @memberof WeighbridgeUploadDetailResponse
     */
    'ticketNo': string;
    /**
     * Entry datetime in epoch (Tanggal Masuk)
     * @type {number}
     * @memberof WeighbridgeUploadDetailResponse
     */
    'entryTime': number;
    /**
     * Exit datetime in epoch (Tanggal Keluar)
     * @type {number}
     * @memberof WeighbridgeUploadDetailResponse
     */
    'exitTime': number;
    /**
     * Weight entry of FFB (Berat Masuk)
     * @type {number}
     * @memberof WeighbridgeUploadDetailResponse
     */
    'weightEntry': number;
    /**
     * Weight exit of FFB (Berat Keluar)
     * @type {number}
     * @memberof WeighbridgeUploadDetailResponse
     */
    'weightExit': number;
    /**
     * Weight netto of FFB (Berat Netto)
     * @type {number}
     * @memberof WeighbridgeUploadDetailResponse
     */
    'weightNetKg': number;
    /**
     * Percentage of sortation (Sortasi)
     * @type {number}
     * @memberof WeighbridgeUploadDetailResponse
     */
    'sortation': number;
    /**
     * Adjustment weight of FFB (Potongan)
     * @type {number}
     * @memberof WeighbridgeUploadDetailResponse
     */
    'adjustmentKg': number;
    /**
     * Final weight counted of FFB (Netto)
     * @type {number}
     * @memberof WeighbridgeUploadDetailResponse
     */
    'weightNetAdjustedKg': number;
    /**
     * Name of the operator (Operator WBS)
     * @type {string}
     * @memberof WeighbridgeUploadDetailResponse
     */
    'operatorName': string;
    /**
     * Quantity of bunch (Jumlah Janjang)
     * @type {number}
     * @memberof WeighbridgeUploadDetailResponse
     */
    'quantity': number;
    /**
     * Average weight of bunch (Komidel)
     * @type {number}
     * @memberof WeighbridgeUploadDetailResponse
     */
    'weightAverageBunchKg': number;
    /**
     * Name of supplier (Dari Supplier)
     * @type {string}
     * @memberof WeighbridgeUploadDetailResponse
     */
    'supplierName': string;
    /**
     * Truck number (No. Kendaraan)
     * @type {string}
     * @memberof WeighbridgeUploadDetailResponse
     */
    'truckNo': string;
    /**
     * Driver name (Nama Sopir)
     * @type {string}
     * @memberof WeighbridgeUploadDetailResponse
     */
    'driverName': string;
    /**
     * Partner name (PMKS / Pembeli TBS)
     * @type {string}
     * @memberof WeighbridgeUploadDetailResponse
     */
    'partnerName': string;
    /**
     * 
     * @type {WeighbridgeUploadStatusEnum}
     * @memberof WeighbridgeUploadDetailResponse
     */
    'status': WeighbridgeUploadStatusEnum;
    /**
     * 
     * @type {WeighbridgeUploadOcrStatusEnum}
     * @memberof WeighbridgeUploadDetailResponse
     */
    'ocrStatus': WeighbridgeUploadOcrStatusEnum;
    /**
     * Flagging to indicate data is from OCR
     * @type {boolean}
     * @memberof WeighbridgeUploadDetailResponse
     */
    'isFromOcr': boolean;
}


/**
 * 
 * @export
 * @interface WeighbridgeUploadExtractResponse
 */
export interface WeighbridgeUploadExtractResponse {
    /**
     * Delivery number (No. SP)
     * @type {string}
     * @memberof WeighbridgeUploadExtractResponse
     */
    'deliveryNo'?: string;
    /**
     * Number of Slip Timbangan (No. Tiket)
     * @type {string}
     * @memberof WeighbridgeUploadExtractResponse
     */
    'ticketNo'?: string;
    /**
     * Entry datetime in epoch (Tanggal Masuk)
     * @type {number}
     * @memberof WeighbridgeUploadExtractResponse
     */
    'entryTime'?: number;
    /**
     * Exit datetime in epoch (Tanggal Keluar)
     * @type {number}
     * @memberof WeighbridgeUploadExtractResponse
     */
    'exitTime'?: number;
    /**
     * Weight entry of FFB (Berat Masuk)
     * @type {number}
     * @memberof WeighbridgeUploadExtractResponse
     */
    'weightEntry'?: number;
    /**
     * Weight exit of FFB (Berat Keluar)
     * @type {number}
     * @memberof WeighbridgeUploadExtractResponse
     */
    'weightExit'?: number;
    /**
     * Weight netto of FFB (Berat Netto)
     * @type {number}
     * @memberof WeighbridgeUploadExtractResponse
     */
    'weightNetKg'?: number;
    /**
     * Percentage of sortation (Sortasi)
     * @type {number}
     * @memberof WeighbridgeUploadExtractResponse
     */
    'sortation'?: number;
    /**
     * Adjustment weight of FFB (Potongan)
     * @type {number}
     * @memberof WeighbridgeUploadExtractResponse
     */
    'adjustmentKg'?: number;
    /**
     * Final weight counted of FFB (Netto)
     * @type {number}
     * @memberof WeighbridgeUploadExtractResponse
     */
    'weightNetAdjustedKg'?: number;
    /**
     * Name of the operator (Operator WBS)
     * @type {string}
     * @memberof WeighbridgeUploadExtractResponse
     */
    'operatorName'?: string;
    /**
     * Quantity of bunch (Jumlah Janjang)
     * @type {number}
     * @memberof WeighbridgeUploadExtractResponse
     */
    'quantity'?: number;
    /**
     * Average weight of bunch (Komidel)
     * @type {number}
     * @memberof WeighbridgeUploadExtractResponse
     */
    'weightAverageBunchKg'?: number;
    /**
     * Name of supplier (Dari Supplier)
     * @type {string}
     * @memberof WeighbridgeUploadExtractResponse
     */
    'supplierName'?: string;
    /**
     * Truck number (No. Kendaraan)
     * @type {string}
     * @memberof WeighbridgeUploadExtractResponse
     */
    'truckNo'?: string;
    /**
     * Driver name (Nama Sopir)
     * @type {string}
     * @memberof WeighbridgeUploadExtractResponse
     */
    'driverName'?: string;
    /**
     * Partner name (PMKS / Pembeli TBS)
     * @type {string}
     * @memberof WeighbridgeUploadExtractResponse
     */
    'partnerName'?: string;
}
/**
 * List of weighbridge tickets uploaded
 * @export
 * @interface WeighbridgeUploadListResponse
 */
export interface WeighbridgeUploadListResponse {
    /**
     * 
     * @type {Array<WeighbridgeUploadListResponseDataItem>}
     * @memberof WeighbridgeUploadListResponse
     */
    'items': Array<WeighbridgeUploadListResponseDataItem>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof WeighbridgeUploadListResponse
     */
    'pagination': PaginationResponse;
}
/**
 * Item of weighbridge ticket uploaded
 * @export
 * @interface WeighbridgeUploadListResponseDataItem
 */
export interface WeighbridgeUploadListResponseDataItem {
    /**
     * ID of weighbridge data
     * @type {string}
     * @memberof WeighbridgeUploadListResponseDataItem
     */
    'id': string;
    /**
     * Ticket No. of Weighbridge Slip
     * @type {string}
     * @memberof WeighbridgeUploadListResponseDataItem
     */
    'ticketNo': string;
    /**
     * Image URL of weighbridge_slip.jpeg
     * @type {string}
     * @memberof WeighbridgeUploadListResponseDataItem
     */
    'photoUrl': string;
    /**
     * Created Datetime of Weighbridge in epoch
     * @type {number}
     * @memberof WeighbridgeUploadListResponseDataItem
     */
    'createdAt': number;
    /**
     * 
     * @type {WeighbridgeUploadOcrStatusEnum}
     * @memberof WeighbridgeUploadListResponseDataItem
     */
    'ocrStatus': WeighbridgeUploadOcrStatusEnum;
    /**
     * Flagging to indicate data is from OCR
     * @type {boolean}
     * @memberof WeighbridgeUploadListResponseDataItem
     */
    'isFromOcr': boolean;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const WeighbridgeUploadOcrStatusEnum = {
    Pending: 'PENDING',
    InProcess: 'IN_PROCESS',
    Finish: 'FINISH'
} as const;

export type WeighbridgeUploadOcrStatusEnum = typeof WeighbridgeUploadOcrStatusEnum[keyof typeof WeighbridgeUploadOcrStatusEnum];


/**
 * 
 * @export
 * @interface WeighbridgeUploadPictureResponse
 */
export interface WeighbridgeUploadPictureResponse {
    /**
     * ID of weighbridge data
     * @type {string}
     * @memberof WeighbridgeUploadPictureResponse
     */
    'id'?: string;
    /**
     * Image URL of weighbridge_slip.jpeg
     * @type {string}
     * @memberof WeighbridgeUploadPictureResponse
     */
    'photoUrl'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const WeighbridgeUploadStatusEnum = {
    Processing: 'PROCESSING',
    Uploading: 'UPLOADING',
    Active: 'ACTIVE',
    Failed: 'FAILED'
} as const;

export type WeighbridgeUploadStatusEnum = typeof WeighbridgeUploadStatusEnum[keyof typeof WeighbridgeUploadStatusEnum];


/**
 * 
 * @export
 * @interface WeighbridgeUploadUpdateRequest
 */
export interface WeighbridgeUploadUpdateRequest {
    /**
     * Delivery number (No. SP)
     * @type {string}
     * @memberof WeighbridgeUploadUpdateRequest
     */
    'deliveryNo'?: string;
    /**
     * Number of Slip Timbangan (No. Tiket)
     * @type {string}
     * @memberof WeighbridgeUploadUpdateRequest
     */
    'ticketNo'?: string;
    /**
     * Entry datetime in epoch (Tanggal Masuk)
     * @type {number}
     * @memberof WeighbridgeUploadUpdateRequest
     */
    'entryTime'?: number;
    /**
     * Exit datetime in epoch (Tanggal Keluar)
     * @type {number}
     * @memberof WeighbridgeUploadUpdateRequest
     */
    'exitTime'?: number;
    /**
     * Weight entry of FFB (Berat Masuk)
     * @type {number}
     * @memberof WeighbridgeUploadUpdateRequest
     */
    'weightEntry'?: number;
    /**
     * Weight exit of FFB (Berat Keluar)
     * @type {number}
     * @memberof WeighbridgeUploadUpdateRequest
     */
    'weightExit'?: number;
    /**
     * Weight netto of FFB (Berat Netto)
     * @type {number}
     * @memberof WeighbridgeUploadUpdateRequest
     */
    'weightNetKg'?: number;
    /**
     * Percentage of sortation (Sortasi)
     * @type {number}
     * @memberof WeighbridgeUploadUpdateRequest
     */
    'sortation'?: number;
    /**
     * Adjustment weight of FFB (Potongan)
     * @type {number}
     * @memberof WeighbridgeUploadUpdateRequest
     */
    'adjustmentKg'?: number;
    /**
     * Final weight counted of FFB (Netto)
     * @type {number}
     * @memberof WeighbridgeUploadUpdateRequest
     */
    'weightNetAdjustedKg'?: number;
    /**
     * Name of the operator (Operator WBS)
     * @type {string}
     * @memberof WeighbridgeUploadUpdateRequest
     */
    'operatorName'?: string;
    /**
     * Quantity of bunch (Jumlah Janjang)
     * @type {number}
     * @memberof WeighbridgeUploadUpdateRequest
     */
    'quantity'?: number;
    /**
     * Average weight of bunch (Komidel)
     * @type {number}
     * @memberof WeighbridgeUploadUpdateRequest
     */
    'weightAverageBunchKg'?: number;
    /**
     * Name of supplier (Dari Supplier)
     * @type {string}
     * @memberof WeighbridgeUploadUpdateRequest
     */
    'supplierName'?: string;
    /**
     * Truck number (No. Kendaraan)
     * @type {string}
     * @memberof WeighbridgeUploadUpdateRequest
     */
    'truckNo'?: string;
    /**
     * Driver name (Nama Sopir)
     * @type {string}
     * @memberof WeighbridgeUploadUpdateRequest
     */
    'driverName'?: string;
    /**
     * Partner name (PMKS / Pembeli TBS)
     * @type {string}
     * @memberof WeighbridgeUploadUpdateRequest
     */
    'partnerName'?: string;
    /**
     * 
     * @type {WeighbridgeUploadStatusEnum}
     * @memberof WeighbridgeUploadUpdateRequest
     */
    'status'?: WeighbridgeUploadStatusEnum;
    /**
     * 
     * @type {WeighbridgeUploadOcrStatusEnum}
     * @memberof WeighbridgeUploadUpdateRequest
     */
    'ocrStatus'?: WeighbridgeUploadOcrStatusEnum;
    /**
     * Flagging to indicate data is from OCR
     * @type {boolean}
     * @memberof WeighbridgeUploadUpdateRequest
     */
    'isFromOcr'?: boolean;
}


/**
 * 
 * @export
 * @interface WeighbridgeUploadUpdateResponse
 */
export interface WeighbridgeUploadUpdateResponse {
    /**
     * 
     * @type {string}
     * @memberof WeighbridgeUploadUpdateResponse
     */
    'id': string;
    /**
     * Ticket No. of Weighbridge Slip
     * @type {string}
     * @memberof WeighbridgeUploadUpdateResponse
     */
    'ticketNo': string;
    /**
     * 
     * @type {WeighbridgeUploadStatusEnum}
     * @memberof WeighbridgeUploadUpdateResponse
     */
    'status': WeighbridgeUploadStatusEnum;
    /**
     * Updated Datetime of Weighbridge in epoch
     * @type {number}
     * @memberof WeighbridgeUploadUpdateResponse
     */
    'updatedAt': number;
}


/**
 * 
 * @export
 * @interface WorkerActivitiesGetLimitationResponse
 */
export interface WorkerActivitiesGetLimitationResponse {
    /**
     * user may proceed to the form or not true means limitation is reached false means limitation is not reached 
     * @type {boolean}
     * @memberof WorkerActivitiesGetLimitationResponse
     */
    'isLimited': boolean;
}
/**
 * Verification status of worker activity
 * @export
 * @enum {string}
 */

export const WorkerActivitiesVerificationStatusEnum = {
    NeedVerification: 'NEED_VERIFICATION',
    Verified: 'VERIFIED',
    Rejected: 'REJECTED'
} as const;

export type WorkerActivitiesVerificationStatusEnum = typeof WorkerActivitiesVerificationStatusEnum[keyof typeof WorkerActivitiesVerificationStatusEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const WorkerCategoryEnum = {
    Driver: 'DRIVER',
    Harvester: 'HARVESTER',
    FieldCoordinator: 'FIELD_COORDINATOR'
} as const;

export type WorkerCategoryEnum = typeof WorkerCategoryEnum[keyof typeof WorkerCategoryEnum];


/**
 * 
 * @export
 * @interface WorkerCreateActivitiesFeebackRequest
 */
export interface WorkerCreateActivitiesFeebackRequest {
    /**
     * The rating assigned to the price component
     * @type {number}
     * @memberof WorkerCreateActivitiesFeebackRequest
     */
    'priceRating': number;
    /**
     * The rating assigned to the weighbridge component
     * @type {number}
     * @memberof WorkerCreateActivitiesFeebackRequest
     */
    'weighbridgeRating': number;
    /**
     * The rating assigned to the queue component
     * @type {number}
     * @memberof WorkerCreateActivitiesFeebackRequest
     */
    'queueRating': number;
    /**
     * The rating assigned to the sorting component
     * @type {number}
     * @memberof WorkerCreateActivitiesFeebackRequest
     */
    'sortingRating': number;
    /**
     * The rating assigned to the road access component
     * @type {number}
     * @memberof WorkerCreateActivitiesFeebackRequest
     */
    'roadAccessRating': number;
    /**
     * Comment from user. It could be feedback for partner (Category - MILL)
     * @type {string}
     * @memberof WorkerCreateActivitiesFeebackRequest
     */
    'message': string;
    /**
     * This field is used to identify whether member\'s user want to show their name as they give their feedback
     * @type {boolean}
     * @memberof WorkerCreateActivitiesFeebackRequest
     */
    'isAnonymous': boolean;
}
/**
 * 
 * @export
 * @interface WorkerCreateActivitiesRequest
 */
export interface WorkerCreateActivitiesRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkerCreateActivitiesRequest
     */
    'ticketNumber': string;
    /**
     * 
     * @type {CollectorTypeEnum}
     * @memberof WorkerCreateActivitiesRequest
     */
    'collectorType': CollectorTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof WorkerCreateActivitiesRequest
     */
    'collectorName': string;
    /**
     * Count of pulangan (janjang)
     * @type {number}
     * @memberof WorkerCreateActivitiesRequest
     */
    'returQuantity': number;
    /**
     * Average of sawit weight (Komidel)
     * @type {number}
     * @memberof WorkerCreateActivitiesRequest
     */
    'weightAverageBunchKg': number;
    /**
     * 
     * @type {WorkerCreateActivitiesFeebackRequest}
     * @memberof WorkerCreateActivitiesRequest
     */
    'feedbacks': WorkerCreateActivitiesFeebackRequest;
}


/**
 * 
 * @export
 * @interface WorkerCreateActivitiesRequestV2
 */
export interface WorkerCreateActivitiesRequestV2 {
    /**
     * 
     * @type {string}
     * @memberof WorkerCreateActivitiesRequestV2
     */
    'ticketNumber': string;
    /**
     * 
     * @type {CollectorTypeEnum}
     * @memberof WorkerCreateActivitiesRequestV2
     */
    'collectorType': CollectorTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof WorkerCreateActivitiesRequestV2
     */
    'collectorName': string;
    /**
     * Count of pulangan (janjang)
     * @type {number}
     * @memberof WorkerCreateActivitiesRequestV2
     */
    'returQuantity': number;
    /**
     * Average of sawit weight (Komidel)
     * @type {number}
     * @memberof WorkerCreateActivitiesRequestV2
     */
    'weightAverageBunchKg': number;
    /**
     * Worker current latitude
     * @type {number}
     * @memberof WorkerCreateActivitiesRequestV2
     */
    'latitude': number;
    /**
     * Worker current longitude
     * @type {number}
     * @memberof WorkerCreateActivitiesRequestV2
     */
    'longitude': number;
    /**
     * 
     * @type {WorkerCreateActivitiesFeebackRequest}
     * @memberof WorkerCreateActivitiesRequestV2
     */
    'feedbacks': WorkerCreateActivitiesFeebackRequest;
}


/**
 * 
 * @export
 * @interface WorkerCreateActivitiesResponse
 */
export interface WorkerCreateActivitiesResponse {
    /**
     * 
     * @type {boolean}
     * @memberof WorkerCreateActivitiesResponse
     */
    'success': boolean;
    /**
     * 
     * @type {number}
     * @memberof WorkerCreateActivitiesResponse
     */
    'point': number;
}
/**
 * 
 * @export
 * @interface WorkerCreateActivitiesV3Request
 */
export interface WorkerCreateActivitiesV3Request {
    /**
     * 
     * @type {string}
     * @memberof WorkerCreateActivitiesV3Request
     */
    'ticketNumber': string;
    /**
     * 
     * @type {CollectorTypeEnum}
     * @memberof WorkerCreateActivitiesV3Request
     */
    'collectorType': CollectorTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof WorkerCreateActivitiesV3Request
     */
    'collectorName': string;
    /**
     * Count of pulangan (janjang)
     * @type {number}
     * @memberof WorkerCreateActivitiesV3Request
     */
    'returnedQuantity': number;
    /**
     * Average of sawit weight (Komidel)
     * @type {number}
     * @memberof WorkerCreateActivitiesV3Request
     */
    'weightAverageBunchKg': number;
    /**
     * Worker current latitude
     * @type {number}
     * @memberof WorkerCreateActivitiesV3Request
     */
    'latitude': number;
    /**
     * Worker current longitude
     * @type {number}
     * @memberof WorkerCreateActivitiesV3Request
     */
    'longitude': number;
    /**
     * Photo of returned fresh fruit bunches
     * @type {File}
     * @memberof WorkerCreateActivitiesV3Request
     */
    'returnedFfbPhoto': File;
    /**
     * 
     * @type {WorkerCreateActivitiesFeebackRequest}
     * @memberof WorkerCreateActivitiesV3Request
     */
    'feedbacks': WorkerCreateActivitiesFeebackRequest;
}


/**
 * 
 * @export
 * @interface WorkerCreateActivitiesV3Response
 */
export interface WorkerCreateActivitiesV3Response {
    /**
     * 
     * @type {boolean}
     * @memberof WorkerCreateActivitiesV3Response
     */
    'success': boolean;
    /**
     * 
     * @type {number}
     * @memberof WorkerCreateActivitiesV3Response
     */
    'sawitpoin': number;
}
/**
 * 
 * @export
 * @interface WorkerCreateActivitiesV4Request
 */
export interface WorkerCreateActivitiesV4Request {
    /**
     * id of mills
     * @type {string}
     * @memberof WorkerCreateActivitiesV4Request
     */
    'partnerId': string;
    /**
     * 
     * @type {string}
     * @memberof WorkerCreateActivitiesV4Request
     */
    'ticketNumber': string;
    /**
     * 
     * @type {CollectorTypeEnum}
     * @memberof WorkerCreateActivitiesV4Request
     */
    'collectorType': CollectorTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof WorkerCreateActivitiesV4Request
     */
    'collectorName': string;
    /**
     * Count of pulangan (janjang)
     * @type {number}
     * @memberof WorkerCreateActivitiesV4Request
     */
    'returnedQuantity': number;
    /**
     * Average of sawit weight (Komidel)
     * @type {number}
     * @memberof WorkerCreateActivitiesV4Request
     */
    'weightAverageBunchKg': number;
    /**
     * Worker current latitude
     * @type {number}
     * @memberof WorkerCreateActivitiesV4Request
     */
    'latitude': number;
    /**
     * Worker current longitude
     * @type {number}
     * @memberof WorkerCreateActivitiesV4Request
     */
    'longitude': number;
    /**
     * URL of returned ffb image
     * @type {string}
     * @memberof WorkerCreateActivitiesV4Request
     */
    'returnedFfbImageUrl': string;
    /**
     * URL of non partner\'s weighbridge ticket image
     * @type {string}
     * @memberof WorkerCreateActivitiesV4Request
     */
    'weighbridgeTicketImageUrl'?: string;
    /**
     * 
     * @type {WorkerCreateActivitiesFeebackRequest}
     * @memberof WorkerCreateActivitiesV4Request
     */
    'feedbacks': WorkerCreateActivitiesFeebackRequest;
}


/**
 * 
 * @export
 * @interface WorkerCreateActivitiesV4Response
 */
export interface WorkerCreateActivitiesV4Response {
    /**
     * 
     * @type {boolean}
     * @memberof WorkerCreateActivitiesV4Response
     */
    'success': boolean;
    /**
     * 
     * @type {number}
     * @memberof WorkerCreateActivitiesV4Response
     */
    'sawitpoin': number;
}
/**
 * 
 * @export
 * @interface WorkerGetActivitiesItemsResponse
 */
export interface WorkerGetActivitiesItemsResponse {
    /**
     * Summary Report list date (in epoch). Will be represented in UTC-0, time will be set at midnight (00:00)
     * @type {number}
     * @memberof WorkerGetActivitiesItemsResponse
     */
    'dateTime': number;
    /**
     * Ticket number of weighbridge, got from weighbridge QR code
     * @type {string}
     * @memberof WorkerGetActivitiesItemsResponse
     */
    'ticketNumber': string;
    /**
     * 
     * @type {string}
     * @memberof WorkerGetActivitiesItemsResponse
     */
    'workerName': string;
    /**
     * Count of pulangan (janjang)
     * @type {number}
     * @memberof WorkerGetActivitiesItemsResponse
     */
    'returQuantity': number;
    /**
     * Average of sawit weight (Komidel)
     * @type {number}
     * @memberof WorkerGetActivitiesItemsResponse
     */
    'weightAverageBunchKg': number;
    /**
     * REWARDED = Driver got point <br> NOT_REWARDED = Driver don\'t get point <br> PENDING = Driver submission need verification checking because the driver is marked as fraud before
     * @type {string}
     * @memberof WorkerGetActivitiesItemsResponse
     */
    'status': string;
    /**
     * name of mill
     * @type {string}
     * @memberof WorkerGetActivitiesItemsResponse
     */
    'millName': string;
}
/**
 * 
 * @export
 * @interface WorkerGetActivitiesResponse
 */
export interface WorkerGetActivitiesResponse {
    /**
     * 
     * @type {Array<WorkerGetActivitiesItemsResponse>}
     * @memberof WorkerGetActivitiesResponse
     */
    'items': Array<WorkerGetActivitiesItemsResponse>;
    /**
     * 
     * @type {WorkerGetActivitiesSummaryResponse}
     * @memberof WorkerGetActivitiesResponse
     */
    'summary': WorkerGetActivitiesSummaryResponse;
}
/**
 * 
 * @export
 * @interface WorkerGetActivitiesSummaryResponse
 */
export interface WorkerGetActivitiesSummaryResponse {
    /**
     * 
     * @type {number}
     * @memberof WorkerGetActivitiesSummaryResponse
     */
    'today': number;
    /**
     * 
     * @type {number}
     * @memberof WorkerGetActivitiesSummaryResponse
     */
    'yesterday': number;
    /**
     * 
     * @type {number}
     * @memberof WorkerGetActivitiesSummaryResponse
     */
    'thisMonth': number;
    /**
     * 
     * @type {number}
     * @memberof WorkerGetActivitiesSummaryResponse
     */
    'lastMonth': number;
}
/**
 * ACTIVE = woker is registered by member and done registered/login in worker app, NOT_ACTIVE = worker is deleted by member user or inactive, NOT_REGISTERED = woker is registered by member user, and not registered yet in worker app 
 * @export
 * @enum {string}
 */

export const WorkerStatusEnum = {
    Active: 'ACTIVE',
    NotRegistered: 'NOT_REGISTERED',
    NotActive: 'NOT_ACTIVE'
} as const;

export type WorkerStatusEnum = typeof WorkerStatusEnum[keyof typeof WorkerStatusEnum];


/**
 * 
 * @export
 * @interface WorkersCreateRequest
 */
export interface WorkersCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkersCreateRequest
     */
    'name': string;
    /**
     * Phone number starting with 0 as prefix (08xxxxxxxxx)
     * @type {string}
     * @memberof WorkersCreateRequest
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof WorkersCreateRequest
     */
    'assetCategoryId': string;
    /**
     * 
     * @type {WorkerCategoryEnum}
     * @memberof WorkersCreateRequest
     */
    'assetType': WorkerCategoryEnum;
    /**
     * 
     * @type {ScreenEnum}
     * @memberof WorkersCreateRequest
     */
    'sourcePage': ScreenEnum;
}


/**
 * 
 * @export
 * @interface WorkersCreateResponse
 */
export interface WorkersCreateResponse {
    /**
     * 
     * @type {string}
     * @memberof WorkersCreateResponse
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface WorkersRemoveResponse
 */
export interface WorkersRemoveResponse {
    /**
     * 
     * @type {boolean}
     * @memberof WorkersRemoveResponse
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface WorkersUpdateRequest
 */
export interface WorkersUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkersUpdateRequest
     */
    'name': string;
    /**
     * Phone number starting with 0 as prefix (08xxxxxxxxx)
     * @type {string}
     * @memberof WorkersUpdateRequest
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof WorkersUpdateRequest
     */
    'assetCategoryId': string;
    /**
     * 
     * @type {WorkerCategoryEnum}
     * @memberof WorkersUpdateRequest
     */
    'assetType': WorkerCategoryEnum;
    /**
     * 
     * @type {ScreenEnum}
     * @memberof WorkersUpdateRequest
     */
    'sourcePage': ScreenEnum;
}


/**
 * 
 * @export
 * @interface WorkersUpdateResponse
 */
export interface WorkersUpdateResponse {
    /**
     * 
     * @type {string}
     * @memberof WorkersUpdateResponse
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface WorkersWeighbridgeSubmitBadRequestResponse
 */
export interface WorkersWeighbridgeSubmitBadRequestResponse {
    /**
     * Message explaining error that happened
     * @type {string}
     * @memberof WorkersWeighbridgeSubmitBadRequestResponse
     */
    'error': string;
}
/**
 * 
 * @export
 * @interface WorkersWeighbridgeSubmitRequest
 */
export interface WorkersWeighbridgeSubmitRequest {
    /**
     * the name of uploaded file to S3
     * @type {string}
     * @memberof WorkersWeighbridgeSubmitRequest
     */
    'filename': string;
}
/**
 * 
 * @export
 * @interface WorkersWeighbridgeSubmitResponse
 */
export interface WorkersWeighbridgeSubmitResponse {
    /**
     * 
     * @type {string}
     * @memberof WorkersWeighbridgeSubmitResponse
     */
    'jwt': string;
}
/**
 * 
 * @export
 * @interface WorkersWeighbridgeUpdateBadRequestResponse
 */
export interface WorkersWeighbridgeUpdateBadRequestResponse {
    /**
     * Message explaining error that happened
     * @type {string}
     * @memberof WorkersWeighbridgeUpdateBadRequestResponse
     */
    'error': string;
}
/**
 * 
 * @export
 * @interface WorkersWeighbridgeUpdateRequest
 */
export interface WorkersWeighbridgeUpdateRequest {
    /**
     * Delivery No. of Weighbridge Slip
     * @type {string}
     * @memberof WorkersWeighbridgeUpdateRequest
     */
    'deliveryNo'?: string;
    /**
     * Ticket No. of Weighbridge Slip
     * @type {string}
     * @memberof WorkersWeighbridgeUpdateRequest
     */
    'ticketNo'?: string;
    /**
     * Truck No. of Weighbridge Slip, remove space if any
     * @type {string}
     * @memberof WorkersWeighbridgeUpdateRequest
     */
    'truckNo'?: string;
    /**
     * Driver Name. of Weighbridge Slip
     * @type {string}
     * @memberof WorkersWeighbridgeUpdateRequest
     */
    'driverName'?: string;
    /**
     * Entry Time of Weighbridge Slip
     * @type {string}
     * @memberof WorkersWeighbridgeUpdateRequest
     */
    'entryTime'?: string;
    /**
     * Exit Time of Weighbridge Slip
     * @type {string}
     * @memberof WorkersWeighbridgeUpdateRequest
     */
    'exitTime'?: string;
    /**
     * Weight Entry of Weighbridge Slip (in KG)
     * @type {number}
     * @memberof WorkersWeighbridgeUpdateRequest
     */
    'weightEntry'?: number;
    /**
     * Weight Exit of Weighbridge Slip (in KG)
     * @type {number}
     * @memberof WorkersWeighbridgeUpdateRequest
     */
    'weightExit'?: number;
    /**
     * Weight Net of Weighbridge Slip (in KG)
     * @type {number}
     * @memberof WorkersWeighbridgeUpdateRequest
     */
    'weightNet'?: number;
    /**
     * Sort Percentage of Weighbridge Slip (in %)
     * @type {number}
     * @memberof WorkersWeighbridgeUpdateRequest
     */
    'sortation'?: number;
    /**
     * Adjustment Weight of Weighbridge Slip (in KG)
     * @type {number}
     * @memberof WorkersWeighbridgeUpdateRequest
     */
    'adjustmentWeight'?: number;
    /**
     * Adjustment Weight of Weighbridge Slip (in KG)
     * @type {number}
     * @memberof WorkersWeighbridgeUpdateRequest
     */
    'weightNetAdjusted'?: number;
    /**
     * Operator Name. of Weighbridge Slip
     * @type {string}
     * @memberof WorkersWeighbridgeUpdateRequest
     */
    'operatorName'?: string;
    /**
     * Total Fresh Fruit Bunch of Weighbridge Slip (in KG)
     * @type {number}
     * @memberof WorkersWeighbridgeUpdateRequest
     */
    'quantity'?: number;
    /**
     * Weight Average of Bunch (in KG)
     * @type {number}
     * @memberof WorkersWeighbridgeUpdateRequest
     */
    'weightAverageBunch'?: number;
    /**
     * 
     * @type {WeighbridgeTicketStatusEnum}
     * @memberof WorkersWeighbridgeUpdateRequest
     */
    'status': WeighbridgeTicketStatusEnum;
    /**
     * Supplier Name of Weighbridge Slip
     * @type {string}
     * @memberof WorkersWeighbridgeUpdateRequest
     */
    'supplierName'?: string;
    /**
     * Partner Name of Weighbridge Slip
     * @type {string}
     * @memberof WorkersWeighbridgeUpdateRequest
     */
    'partnerName'?: string;
    /**
     * Cargo Description of Weighbridge Slip
     * @type {string}
     * @memberof WorkersWeighbridgeUpdateRequest
     */
    'cargoDesc'?: string;
}


/**
 * 
 * @export
 * @interface WorkersWeighbridgeUpdateResponse
 */
export interface WorkersWeighbridgeUpdateResponse {
    /**
     * 
     * @type {boolean}
     * @memberof WorkersWeighbridgeUpdateResponse
     */
    'success': boolean;
}
/**
 * List of confirmed weighbridge tickets
 * @export
 * @interface WorkersWeighbridgesListResponse
 */
export interface WorkersWeighbridgesListResponse {
    /**
     * 
     * @type {WorkersWeighbridgesListResponseDataItem}
     * @memberof WorkersWeighbridgesListResponse
     */
    'items': WorkersWeighbridgesListResponseDataItem;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof WorkersWeighbridgesListResponse
     */
    'pagination': PaginationResponse;
}
/**
 * Item of confirmed weighbridge ticket
 * @export
 * @interface WorkersWeighbridgesListResponseDataItem
 */
export interface WorkersWeighbridgesListResponseDataItem {
    /**
     * ID of weighbridge data
     * @type {string}
     * @memberof WorkersWeighbridgesListResponseDataItem
     */
    'id': string;
    /**
     * Ticket No. of Weighbridge Slip
     * @type {string}
     * @memberof WorkersWeighbridgesListResponseDataItem
     */
    'ticketNo': string;
    /**
     * Name of supplier
     * @type {string}
     * @memberof WorkersWeighbridgesListResponseDataItem
     */
    'supplierRegisteredName': string;
    /**
     * Name of member
     * @type {string}
     * @memberof WorkersWeighbridgesListResponseDataItem
     */
    'userName': string;
    /**
     * Image URL of weighbridge_slip.jpeg
     * @type {string}
     * @memberof WorkersWeighbridgesListResponseDataItem
     */
    'photoUrl': string;
    /**
     * Sort Percentage of Weighbridge Slip (in %)
     * @type {number}
     * @memberof WorkersWeighbridgesListResponseDataItem
     */
    'sortation': number;
    /**
     * Received date of weighbridge slip (in epoch) formatted in UTC-0
     * @type {number}
     * @memberof WorkersWeighbridgesListResponseDataItem
     */
    'date': number;
    /**
     * Weight Net of Weighbridge Slip (in KG)
     * @type {number}
     * @memberof WorkersWeighbridgesListResponseDataItem
     */
    'weightNet': number;
}

/**
 * ActionRemindersApi - axios parameter creator
 * @export
 */
export const ActionRemindersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Called by mobile app to Get all user\'s action reminder
         * @summary Get all active Action Reminder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActionReminders: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/action-reminders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ActionRemindersApi - functional programming interface
 * @export
 */
export const ActionRemindersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ActionRemindersApiAxiosParamCreator(configuration)
    return {
        /**
         * Called by mobile app to Get all user\'s action reminder
         * @summary Get all active Action Reminder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActionReminders(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetActionRemindersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActionReminders(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ActionRemindersApi - factory interface
 * @export
 */
export const ActionRemindersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ActionRemindersApiFp(configuration)
    return {
        /**
         * Called by mobile app to Get all user\'s action reminder
         * @summary Get all active Action Reminder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActionReminders(options?: any): AxiosPromise<GetActionRemindersResponse> {
            return localVarFp.getActionReminders(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ActionRemindersApi - object-oriented interface
 * @export
 * @class ActionRemindersApi
 * @extends {BaseAPI}
 */
export class ActionRemindersApi extends BaseAPI {
    /**
     * Called by mobile app to Get all user\'s action reminder
     * @summary Get all active Action Reminder
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionRemindersApi
     */
    public getActionReminders(options?: AxiosRequestConfig) {
        return ActionRemindersApiFp(this.configuration).getActionReminders(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AdminsApi - axios parameter creator
 * @export
 */
export const AdminsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This endpoint will be called by admin to create agronomy booking summary.
         * @summary Create an agronomy booking summary for specified {bookingId}
         * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
         * @param {string} bookingId Booking UUID
         * @param {AdminsAgronomyBookingsCreateSummaryRequest} adminsAgronomyBookingsCreateSummaryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsAgronomyBookingsCreateSummary: async (authorization: string, bookingId: string, adminsAgronomyBookingsCreateSummaryRequest: AdminsAgronomyBookingsCreateSummaryRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('adminsAgronomyBookingsCreateSummary', 'authorization', authorization)
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('adminsAgronomyBookingsCreateSummary', 'bookingId', bookingId)
            // verify required parameter 'adminsAgronomyBookingsCreateSummaryRequest' is not null or undefined
            assertParamExists('adminsAgronomyBookingsCreateSummary', 'adminsAgronomyBookingsCreateSummaryRequest', adminsAgronomyBookingsCreateSummaryRequest)
            const localVarPath = `/api/v1/admins/agronomy/bookings/{bookingId}/summary`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminsAgronomyBookingsCreateSummaryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint will be called by admin to create an agronomy task. The created task will be visible for user related to the agronomy booking.
         * @summary Create an agronomy task for specified {bookingId}
         * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
         * @param {string} bookingId Booking UUID
         * @param {AdminsAgronomyBookingsCreateTasksRequest} adminsAgronomyBookingsCreateTasksRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsAgronomyBookingsCreateTasks: async (authorization: string, bookingId: string, adminsAgronomyBookingsCreateTasksRequest: AdminsAgronomyBookingsCreateTasksRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('adminsAgronomyBookingsCreateTasks', 'authorization', authorization)
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('adminsAgronomyBookingsCreateTasks', 'bookingId', bookingId)
            // verify required parameter 'adminsAgronomyBookingsCreateTasksRequest' is not null or undefined
            assertParamExists('adminsAgronomyBookingsCreateTasks', 'adminsAgronomyBookingsCreateTasksRequest', adminsAgronomyBookingsCreateTasksRequest)
            const localVarPath = `/api/v1/admins/agronomy/bookings/{bookingId}/tasks`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminsAgronomyBookingsCreateTasksRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint will be called by admin to update an agronomy task data. The updated task data will be visible for user related to the agronomy booking.
         * @summary Update an agronomy task data for specified {taskId}
         * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
         * @param {string} taskId Agronomy Task UUID
         * @param {AdminsAgronomyBookingsUpdateTasksRequest} adminsAgronomyBookingsUpdateTasksRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsAgronomyBookingsUpdateTasks: async (authorization: string, taskId: string, adminsAgronomyBookingsUpdateTasksRequest: AdminsAgronomyBookingsUpdateTasksRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('adminsAgronomyBookingsUpdateTasks', 'authorization', authorization)
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('adminsAgronomyBookingsUpdateTasks', 'taskId', taskId)
            // verify required parameter 'adminsAgronomyBookingsUpdateTasksRequest' is not null or undefined
            assertParamExists('adminsAgronomyBookingsUpdateTasks', 'adminsAgronomyBookingsUpdateTasksRequest', adminsAgronomyBookingsUpdateTasksRequest)
            const localVarPath = `/api/v1/admins/agronomy/bookings/tasks/{taskId}`
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminsAgronomyBookingsUpdateTasksRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Used by SawitPRO Admin to create app shortcuts, that will be shown in the mobile app home page.
         * @summary Create App Shortcut
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {AdminsAppCreateShortcutRequest} adminsAppCreateShortcutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsAppCreateShortcut: async (aPPTYPE: AppTypeEnum, adminsAppCreateShortcutRequest: AdminsAppCreateShortcutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('adminsAppCreateShortcut', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'adminsAppCreateShortcutRequest' is not null or undefined
            assertParamExists('adminsAppCreateShortcut', 'adminsAppCreateShortcutRequest', adminsAppCreateShortcutRequest)
            const localVarPath = `/api/v1/admins/app/shortcuts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminsAppCreateShortcutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Verification for Asset of Truck
         * @summary Asset Truck Verification
         * @param {string} truckId 
         * @param {AdminsAssetTruckUpdateVerificationRequest} [adminsAssetTruckUpdateVerificationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsAssetTruckUpdateVerification: async (truckId: string, adminsAssetTruckUpdateVerificationRequest?: AdminsAssetTruckUpdateVerificationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'truckId' is not null or undefined
            assertParamExists('adminsAssetTruckUpdateVerification', 'truckId', truckId)
            const localVarPath = `/api/v1/admins/assets/trucks/{truckId}/verification`
                .replace(`{${"truckId"}}`, encodeURIComponent(String(truckId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminsAssetTruckUpdateVerificationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Admin update asset farm data, used by verificator to validate user farm data
         * @summary Admin Update Asset Farm
         * @param {string} farmId farm UUID
         * @param {AdminsAssetsUpdateFarmRequest} [adminsAssetsUpdateFarmRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsAssetsUpdateFarm: async (farmId: string, adminsAssetsUpdateFarmRequest?: AdminsAssetsUpdateFarmRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'farmId' is not null or undefined
            assertParamExists('adminsAssetsUpdateFarm', 'farmId', farmId)
            const localVarPath = `/api/v1/admins/assets/farms/{farmId}`
                .replace(`{${"farmId"}}`, encodeURIComponent(String(farmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminsAssetsUpdateFarmRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Used by SawitPRO Admin to award Gold to our users
         * @summary Award Gold to Users
         * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
         * @param {AdminsAwardGoldRequest} adminsAwardGoldRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsAwardGold: async (authorization: string, adminsAwardGoldRequest: AdminsAwardGoldRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('adminsAwardGold', 'authorization', authorization)
            // verify required parameter 'adminsAwardGoldRequest' is not null or undefined
            assertParamExists('adminsAwardGold', 'adminsAwardGoldRequest', adminsAwardGoldRequest)
            const localVarPath = `/api/v1/admins/award-gold`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminsAwardGoldRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Used by SawitPRO Admin to award Sawitpoin to our users.
         * @summary Award Sawitpoin to User
         * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
         * @param {AdminsAwardSawitpoinRequest} adminsAwardSawitpoinRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsAwardSawitpoin: async (authorization: string, adminsAwardSawitpoinRequest: AdminsAwardSawitpoinRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('adminsAwardSawitpoin', 'authorization', authorization)
            // verify required parameter 'adminsAwardSawitpoinRequest' is not null or undefined
            assertParamExists('adminsAwardSawitpoin', 'adminsAwardSawitpoinRequest', adminsAwardSawitpoinRequest)
            const localVarPath = `/api/v1/admins/award-sawitpoin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminsAwardSawitpoinRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint will be called by admin to create or update booking schedule.
         * @summary Create or update a booking schedule for an agronomist service
         * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
         * @param {AdminsCreateAgronomistBookingScheduleRequest} adminsCreateAgronomistBookingScheduleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsCreateAgronomistBookingSchedule: async (authorization: string, adminsCreateAgronomistBookingScheduleRequest: AdminsCreateAgronomistBookingScheduleRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('adminsCreateAgronomistBookingSchedule', 'authorization', authorization)
            // verify required parameter 'adminsCreateAgronomistBookingScheduleRequest' is not null or undefined
            assertParamExists('adminsCreateAgronomistBookingSchedule', 'adminsCreateAgronomistBookingScheduleRequest', adminsCreateAgronomistBookingScheduleRequest)
            const localVarPath = `/api/v1/admins/agronomist/booking/schedule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminsCreateAgronomistBookingScheduleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint will be called by admin to create a banner. There is a link redirects to a media & the link should be set as public. Priority field will be used to sort the banners data when fetch all banners API is called.
         * @summary Create a banner
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
         * @param {AdminsCreateBannerRequest} adminsCreateBannerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsCreateBanner: async (aPPTYPE: AppTypeEnum, authorization: string, adminsCreateBannerRequest: AdminsCreateBannerRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('adminsCreateBanner', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('adminsCreateBanner', 'authorization', authorization)
            // verify required parameter 'adminsCreateBannerRequest' is not null or undefined
            assertParamExists('adminsCreateBanner', 'adminsCreateBannerRequest', adminsCreateBannerRequest)
            const localVarPath = `/api/v1/admins/banners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminsCreateBannerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint will be called by admin to soft-delete a banner by changing its isActive value to false in DB
         * @summary Soft delete of a banner
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
         * @param {string} bannerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsDeleteBanner: async (aPPTYPE: AppTypeEnum, authorization: string, bannerId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('adminsDeleteBanner', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('adminsDeleteBanner', 'authorization', authorization)
            // verify required parameter 'bannerId' is not null or undefined
            assertParamExists('adminsDeleteBanner', 'bannerId', bannerId)
            const localVarPath = `/api/v1/admins/banners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (bannerId !== undefined) {
                localVarQueryParameter['bannerId'] = bannerId;
            }

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * this is for create DIGITAL product
         * @summary Create DIGITAL Product
         * @param {AdminsEcommerceCreateDigitalProductRequest} adminsEcommerceCreateDigitalProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsEcommerceCreateDigitalProduct: async (adminsEcommerceCreateDigitalProductRequest: AdminsEcommerceCreateDigitalProductRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminsEcommerceCreateDigitalProductRequest' is not null or undefined
            assertParamExists('adminsEcommerceCreateDigitalProduct', 'adminsEcommerceCreateDigitalProductRequest', adminsEcommerceCreateDigitalProductRequest)
            const localVarPath = `/api/v1/admins/ecommerce/product/digital/prepaid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminsEcommerceCreateDigitalProductRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * this is for create product
         * @summary Create Product
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {AdminsEcommerceCreateProductRequest} adminsEcommerceCreateProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsEcommerceCreateProduct: async (authorization: string, adminsEcommerceCreateProductRequest: AdminsEcommerceCreateProductRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('adminsEcommerceCreateProduct', 'authorization', authorization)
            // verify required parameter 'adminsEcommerceCreateProductRequest' is not null or undefined
            assertParamExists('adminsEcommerceCreateProduct', 'adminsEcommerceCreateProductRequest', adminsEcommerceCreateProductRequest)
            const localVarPath = `/api/v1/admins/ecommerce/product`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminsEcommerceCreateProductRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * this is for creating category product
         * @summary Create Product Category
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {AdminsEcommerceCreateProductCategoryRequest} [adminsEcommerceCreateProductCategoryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsEcommerceCreateProductCategory: async (authorization: string, adminsEcommerceCreateProductCategoryRequest?: AdminsEcommerceCreateProductCategoryRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('adminsEcommerceCreateProductCategory', 'authorization', authorization)
            const localVarPath = `/api/v1/admins/ecommerce/product/category`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminsEcommerceCreateProductCategoryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * this is for get DIGITAL product list
         * @summary Get DIGITAL Product Detail
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsEcommerceGetDigitalProductList: async (page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admins/ecommerce/product/digital/prepaid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * this is for getting the product list for web admin
         * @summary Get List Product
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} status this is for filter product status
         * @param {string} [search] this is for search prod
         * @param {string} [searchField] this is for search field when we are seach   - name  &#x3D; search by name 
         * @param {string} [categoryCode] Filter product by category code. If is nil, will return all products. If specified, will return products that have category code that match the specified value. 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsEcommerceGetListProduct: async (authorization: string, status: string, search?: string, searchField?: string, categoryCode?: string, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('adminsEcommerceGetListProduct', 'authorization', authorization)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('adminsEcommerceGetListProduct', 'status', status)
            const localVarPath = `/api/v1/admins/ecommerce/product`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['searchField'] = searchField;
            }

            if (categoryCode !== undefined) {
                localVarQueryParameter['categoryCode'] = categoryCode;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * this is for getting detail of product for web admin
         * @summary Get Product Category
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {string} [status] product category status
         * @param {string} [name] product category name
         * @param {string} [parentCategoryCode] Product Category Code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsEcommerceGetProductCategory: async (authorization: string, page?: number, limit?: number, status?: string, name?: string, parentCategoryCode?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('adminsEcommerceGetProductCategory', 'authorization', authorization)
            const localVarPath = `/api/v1/admins/ecommerce/product/category`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (parentCategoryCode !== undefined) {
                localVarQueryParameter['parentCategoryCode'] = parentCategoryCode;
            }

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * this is for getting detail of product for web admin
         * @summary Get Detail Product
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} productId product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsEcommerceGetProductDetail: async (authorization: string, productId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('adminsEcommerceGetProductDetail', 'authorization', authorization)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('adminsEcommerceGetProductDetail', 'productId', productId)
            const localVarPath = `/api/v1/admins/ecommerce/product/{productId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create Inventory Stock Location
         * @summary Create Inventory Stock Location
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {AdminsEcommerceInventoryStockLocationCreateRequest} adminsEcommerceInventoryStockLocationCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsEcommerceInventoryStockLocationCreate: async (authorization: string, adminsEcommerceInventoryStockLocationCreateRequest: AdminsEcommerceInventoryStockLocationCreateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('adminsEcommerceInventoryStockLocationCreate', 'authorization', authorization)
            // verify required parameter 'adminsEcommerceInventoryStockLocationCreateRequest' is not null or undefined
            assertParamExists('adminsEcommerceInventoryStockLocationCreate', 'adminsEcommerceInventoryStockLocationCreateRequest', adminsEcommerceInventoryStockLocationCreateRequest)
            const localVarPath = `/api/v1/admins/ecommerce/inventory/stock-location`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminsEcommerceInventoryStockLocationCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Display Stock Location Detail
         * @summary Get Stock Location Detail for Admin
         * @param {string} stockLocationId Stock Location UUID
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsEcommerceInventoryStockLocationDetail: async (stockLocationId: string, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stockLocationId' is not null or undefined
            assertParamExists('adminsEcommerceInventoryStockLocationDetail', 'stockLocationId', stockLocationId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('adminsEcommerceInventoryStockLocationDetail', 'authorization', authorization)
            const localVarPath = `/api/v1/admins/ecommerce/inventory/stock-location/{stockLocationId}`
                .replace(`{${"stockLocationId"}}`, encodeURIComponent(String(stockLocationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Display Inventory Stock Location List
         * @summary Get Inventory Stock Location List
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {StockLocationStatusEnum} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsEcommerceInventoryStockLocationList: async (authorization: string, page?: number, limit?: number, status?: StockLocationStatusEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('adminsEcommerceInventoryStockLocationList', 'authorization', authorization)
            const localVarPath = `/api/v1/admins/ecommerce/inventory/stock-location`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update Stock Location data
         * @summary Update Stock Location for Admin
         * @param {string} stockLocationId Stock Location UUID
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {AdminsEcommerceInventoryStockLocationUpdateRequest} adminsEcommerceInventoryStockLocationUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsEcommerceInventoryStockLocationUpdate: async (stockLocationId: string, authorization: string, adminsEcommerceInventoryStockLocationUpdateRequest: AdminsEcommerceInventoryStockLocationUpdateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stockLocationId' is not null or undefined
            assertParamExists('adminsEcommerceInventoryStockLocationUpdate', 'stockLocationId', stockLocationId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('adminsEcommerceInventoryStockLocationUpdate', 'authorization', authorization)
            // verify required parameter 'adminsEcommerceInventoryStockLocationUpdateRequest' is not null or undefined
            assertParamExists('adminsEcommerceInventoryStockLocationUpdate', 'adminsEcommerceInventoryStockLocationUpdateRequest', adminsEcommerceInventoryStockLocationUpdateRequest)
            const localVarPath = `/api/v1/admins/ecommerce/inventory/stock-location/{stockLocationId}`
                .replace(`{${"stockLocationId"}}`, encodeURIComponent(String(stockLocationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminsEcommerceInventoryStockLocationUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint will be called by admin to get detail of product pricelist.
         * @summary Get product pricelist detail for admin web
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} pricelistId Pricelist UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsEcommerceProductPricelistGetDetail: async (authorization: string, pricelistId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('adminsEcommerceProductPricelistGetDetail', 'authorization', authorization)
            // verify required parameter 'pricelistId' is not null or undefined
            assertParamExists('adminsEcommerceProductPricelistGetDetail', 'pricelistId', pricelistId)
            const localVarPath = `/api/v1/admins/ecommerce/product/pricelist/{pricelistId}`
                .replace(`{${"pricelistId"}}`, encodeURIComponent(String(pricelistId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint will be called by admin to get list of product pricelist.
         * @summary Get list of product pricelist for admin web
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} [stockLocationId] Stock Location UUID
         * @param {EcommerceProductStatusEnum} [status] 
         * @param {AdminsEcommerceProductPricelistListSortEnum} [sort] Sort field name
         * @param {OrderDirectionEnum} [direction] Sort direction
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsEcommerceProductPricelistList: async (authorization: string, stockLocationId?: string, status?: EcommerceProductStatusEnum, sort?: AdminsEcommerceProductPricelistListSortEnum, direction?: OrderDirectionEnum, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('adminsEcommerceProductPricelistList', 'authorization', authorization)
            const localVarPath = `/api/v1/admins/ecommerce/product/pricelist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stockLocationId !== undefined) {
                localVarQueryParameter['stockLocationId'] = stockLocationId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download report of sale order in csv
         * @summary Download report of sale order in csv
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {number} [timeFrom] Sale Order Created Time
         * @param {number} [timeTo] Sale Order Created Time
         * @param {SaleOrderStatusEnum} [status] Sale Order status
         * @param {OrderOperationSortFieldEnum} [sort] Sort by
         * @param {OrderDirectionEnum} [direction] Sort direction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsEcommerceReportSaleOrder: async (authorization: string, timeFrom?: number, timeTo?: number, status?: SaleOrderStatusEnum, sort?: OrderOperationSortFieldEnum, direction?: OrderDirectionEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('adminsEcommerceReportSaleOrder', 'authorization', authorization)
            const localVarPath = `/api/v1/admins/ecommerce/report/saleorder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (timeFrom !== undefined) {
                localVarQueryParameter['timeFrom'] = timeFrom;
            }

            if (timeTo !== undefined) {
                localVarQueryParameter['timeTo'] = timeTo;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * this is for updating DIGITAL product
         * @summary update DIGITAL Product
         * @param {string} productId product Id
         * @param {AdminsEcommerceUpdateDigitalProductRequest} adminsEcommerceUpdateDigitalProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsEcommerceUpdateDigitalProduct: async (productId: string, adminsEcommerceUpdateDigitalProductRequest: AdminsEcommerceUpdateDigitalProductRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('adminsEcommerceUpdateDigitalProduct', 'productId', productId)
            // verify required parameter 'adminsEcommerceUpdateDigitalProductRequest' is not null or undefined
            assertParamExists('adminsEcommerceUpdateDigitalProduct', 'adminsEcommerceUpdateDigitalProductRequest', adminsEcommerceUpdateDigitalProductRequest)
            const localVarPath = `/api/v1/admins/ecommerce/product/{productId}/digital/prepaid`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminsEcommerceUpdateDigitalProductRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * this is for update product in partner web
         * @summary Update Product
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} productId product Id
         * @param {AdminsEcommerceProductUpdateRequest} adminsEcommerceProductUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsEcommerceUpdateProduct: async (authorization: string, productId: string, adminsEcommerceProductUpdateRequest: AdminsEcommerceProductUpdateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('adminsEcommerceUpdateProduct', 'authorization', authorization)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('adminsEcommerceUpdateProduct', 'productId', productId)
            // verify required parameter 'adminsEcommerceProductUpdateRequest' is not null or undefined
            assertParamExists('adminsEcommerceUpdateProduct', 'adminsEcommerceProductUpdateRequest', adminsEcommerceProductUpdateRequest)
            const localVarPath = `/api/v1/admins/ecommerce/product/{productId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminsEcommerceProductUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * this is for updating category product
         * @summary Update Product Category
         * @param {string} productCategoryId product category UUID
         * @param {AdminsEcommerceUpdateProductCategoryRequest} [adminsEcommerceUpdateProductCategoryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsEcommerceUpdateProductCategory: async (productCategoryId: string, adminsEcommerceUpdateProductCategoryRequest?: AdminsEcommerceUpdateProductCategoryRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productCategoryId' is not null or undefined
            assertParamExists('adminsEcommerceUpdateProductCategory', 'productCategoryId', productCategoryId)
            const localVarPath = `/api/v1/admins/ecommerce/product/category/{productCategoryId}`
                .replace(`{${"productCategoryId"}}`, encodeURIComponent(String(productCategoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminsEcommerceUpdateProductCategoryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint for upload product image
         * @summary Upload Product Image
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {File} [imageData] Image data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsEcommerceUploadProductImage: async (authorization: string, imageData?: File, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('adminsEcommerceUploadProductImage', 'authorization', authorization)
            const localVarPath = `/api/v1/admins/ecommerce/product/image`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


            if (imageData !== undefined) { 
                localVarFormParams.append('imageData', imageData as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * this is for creating new vendor
         * @summary Create Vendor
         * @param {AdminsFinanceCreateVendorRequest} adminsFinanceCreateVendorRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsFinanceCreateVendor: async (adminsFinanceCreateVendorRequest: AdminsFinanceCreateVendorRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminsFinanceCreateVendorRequest' is not null or undefined
            assertParamExists('adminsFinanceCreateVendor', 'adminsFinanceCreateVendorRequest', adminsFinanceCreateVendorRequest)
            const localVarPath = `/api/v1/admins/finance/vendor`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminsFinanceCreateVendorRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * this is for getting bank list
         * @summary Bank List
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsFinanceGetBankList: async (page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admins/finance/bank`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * this is for getting detail of vendor for ADMIN WEB
         * @summary Get Vendor Detail
         * @param {string} vendorId vendor Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsFinanceGetVendorDetail: async (vendorId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vendorId' is not null or undefined
            assertParamExists('adminsFinanceGetVendorDetail', 'vendorId', vendorId)
            const localVarPath = `/api/v1/admins/finance/vendor/{vendorId}`
                .replace(`{${"vendorId"}}`, encodeURIComponent(String(vendorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * this is for getting vendor list
         * @summary Vendor List
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {VendorStatusEnum} [status] 
         * @param {string} [name] Vendor Name
         * @param {VendorTypeEnum} [type] 
         * @param {VendorSortFieldEnum} [sortField] 
         * @param {VendorDirectionEnum} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsFinanceGetVendorList: async (page?: number, limit?: number, status?: VendorStatusEnum, name?: string, type?: VendorTypeEnum, sortField?: VendorSortFieldEnum, sortBy?: VendorDirectionEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admins/finance/vendor`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (sortField !== undefined) {
                localVarQueryParameter['sortField'] = sortField;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * this is for updating data of vendor for ADMIN WEB
         * @summary Update vendor
         * @param {string} vendorId vendor Id
         * @param {AdminsFinanceUpdateVendorRequest} adminsFinanceUpdateVendorRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsFinanceUpdateVendor: async (vendorId: string, adminsFinanceUpdateVendorRequest: AdminsFinanceUpdateVendorRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vendorId' is not null or undefined
            assertParamExists('adminsFinanceUpdateVendor', 'vendorId', vendorId)
            // verify required parameter 'adminsFinanceUpdateVendorRequest' is not null or undefined
            assertParamExists('adminsFinanceUpdateVendor', 'adminsFinanceUpdateVendorRequest', adminsFinanceUpdateVendorRequest)
            const localVarPath = `/api/v1/admins/finance/vendor/{vendorId}`
                .replace(`{${"vendorId"}}`, encodeURIComponent(String(vendorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminsFinanceUpdateVendorRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * this is for inquirying product from vendor
         * @summary inquiry to vendor bill
         * @param {string} categoryId Product Category ID in UUID type 4 format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsFinanceVendorBillInquiry: async (categoryId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'categoryId' is not null or undefined
            assertParamExists('adminsFinanceVendorBillInquiry', 'categoryId', categoryId)
            const localVarPath = `/api/v1/admins/finance/vendor/bill/inquiry`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (categoryId !== undefined) {
                localVarQueryParameter['categoryId'] = categoryId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create Job Vacancy in web admin
         * @summary Create Job Vacancy in web admin
         * @param {AdminsJobBoardsVacanciesCreateJobVacancyRequest} adminsJobBoardsVacanciesCreateJobVacancyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsJobBoardsVacanciesCreateJobVacancy: async (adminsJobBoardsVacanciesCreateJobVacancyRequest: AdminsJobBoardsVacanciesCreateJobVacancyRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminsJobBoardsVacanciesCreateJobVacancyRequest' is not null or undefined
            assertParamExists('adminsJobBoardsVacanciesCreateJobVacancy', 'adminsJobBoardsVacanciesCreateJobVacancyRequest', adminsJobBoardsVacanciesCreateJobVacancyRequest)
            const localVarPath = `/api/v1/admins/job-boards/vacancies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminsJobBoardsVacanciesCreateJobVacancyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Used by Worker App to get detail of a job vacancy
         * @summary Job Vacancy Detail
         * @param {string} jobVacancyId Job Vacancy UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsJobBoardsVacanciesGetJobVacancyDetail: async (jobVacancyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobVacancyId' is not null or undefined
            assertParamExists('adminsJobBoardsVacanciesGetJobVacancyDetail', 'jobVacancyId', jobVacancyId)
            const localVarPath = `/api/v1/admins/job-boards/vacancies/{jobVacancyId}`
                .replace(`{${"jobVacancyId"}}`, encodeURIComponent(String(jobVacancyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Job Vacancy List in admin web
         * @summary Get Job Vacancy List in admin web
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {string} [orderBy] Column used for ordering, will accept the field name from response object
         * @param {OrderDirectionEnum} [direction] 
         * @param {string} [filterByCategory] Filter by category query parameter
         * @param {string} [searchValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsJobBoardsVacanciesGetJobVacancyList: async (page?: number, limit?: number, orderBy?: string, direction?: OrderDirectionEnum, filterByCategory?: string, searchValue?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admins/job-boards/vacancies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (filterByCategory !== undefined) {
                localVarQueryParameter['filterByCategory'] = filterByCategory;
            }

            if (searchValue !== undefined) {
                localVarQueryParameter['searchValue'] = searchValue;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This used for getting list of appliicant in job detail
         * @summary Job Applicant list
         * @param {string} jobVacancyId Job Vacancy UUID
         * @param {string} [filterBy] field of filter
         * @param {string} [filterByValue] filter by value
         * @param {string} [orderBy] Column used for ordering, will accept the field name from response object
         * @param {OrderDirectionEnum} [direction] 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsJobBoardsVacanciesGetListApplicants: async (jobVacancyId: string, filterBy?: string, filterByValue?: string, orderBy?: string, direction?: OrderDirectionEnum, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobVacancyId' is not null or undefined
            assertParamExists('adminsJobBoardsVacanciesGetListApplicants', 'jobVacancyId', jobVacancyId)
            const localVarPath = `/api/v1/admins/job-boards/vacancies/{jobVacancyId}/applicants`
                .replace(`{${"jobVacancyId"}}`, encodeURIComponent(String(jobVacancyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (filterBy !== undefined) {
                localVarQueryParameter['filterBy'] = filterBy;
            }

            if (filterByValue !== undefined) {
                localVarQueryParameter['filterByValue'] = filterByValue;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update Job Vacancy in web admin
         * @summary Update Job Vacancy in web admin
         * @param {string} jobVacancyId Job Vacancy UUID
         * @param {AdminsJobBoardsVacanciesUpdateJobVacancyRequest} adminsJobBoardsVacanciesUpdateJobVacancyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsJobBoardsVacanciesUpdateJobVacancy: async (jobVacancyId: string, adminsJobBoardsVacanciesUpdateJobVacancyRequest: AdminsJobBoardsVacanciesUpdateJobVacancyRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobVacancyId' is not null or undefined
            assertParamExists('adminsJobBoardsVacanciesUpdateJobVacancy', 'jobVacancyId', jobVacancyId)
            // verify required parameter 'adminsJobBoardsVacanciesUpdateJobVacancyRequest' is not null or undefined
            assertParamExists('adminsJobBoardsVacanciesUpdateJobVacancy', 'adminsJobBoardsVacanciesUpdateJobVacancyRequest', adminsJobBoardsVacanciesUpdateJobVacancyRequest)
            const localVarPath = `/api/v1/admins/job-boards/vacancies/{jobVacancyId}`
                .replace(`{${"jobVacancyId"}}`, encodeURIComponent(String(jobVacancyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminsJobBoardsVacanciesUpdateJobVacancyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This used for getting list of appliicant in job detail
         * @summary Update Status
         * @param {string} applicantId 
         * @param {AdminsJobBoardsVacanciesUpdateStatusApplicantsRequest} [adminsJobBoardsVacanciesUpdateStatusApplicantsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsJobBoardsVacanciesUpdateStatusApplicants: async (applicantId: string, adminsJobBoardsVacanciesUpdateStatusApplicantsRequest?: AdminsJobBoardsVacanciesUpdateStatusApplicantsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'applicantId' is not null or undefined
            assertParamExists('adminsJobBoardsVacanciesUpdateStatusApplicants', 'applicantId', applicantId)
            const localVarPath = `/api/v1/admins/job-boards/vacancies/applicants/{applicantId}/status`
                .replace(`{${"applicantId"}}`, encodeURIComponent(String(applicantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminsJobBoardsVacanciesUpdateStatusApplicantsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update Job Vacancy status in web admin
         * @summary Update Job Vacancy status in web admin
         * @param {string} jobVacancyId Job Vacancy UUID
         * @param {AdminsJobBoardsVacanciesUpdateStatusJobVacancyRequest} adminsJobBoardsVacanciesUpdateStatusJobVacancyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsJobBoardsVacanciesUpdateStatusJobVacancy: async (jobVacancyId: string, adminsJobBoardsVacanciesUpdateStatusJobVacancyRequest: AdminsJobBoardsVacanciesUpdateStatusJobVacancyRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobVacancyId' is not null or undefined
            assertParamExists('adminsJobBoardsVacanciesUpdateStatusJobVacancy', 'jobVacancyId', jobVacancyId)
            // verify required parameter 'adminsJobBoardsVacanciesUpdateStatusJobVacancyRequest' is not null or undefined
            assertParamExists('adminsJobBoardsVacanciesUpdateStatusJobVacancy', 'adminsJobBoardsVacanciesUpdateStatusJobVacancyRequest', adminsJobBoardsVacanciesUpdateStatusJobVacancyRequest)
            const localVarPath = `/api/v1/admins/job-boards/vacancies/{jobVacancyId}/status`
                .replace(`{${"jobVacancyId"}}`, encodeURIComponent(String(jobVacancyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminsJobBoardsVacanciesUpdateStatusJobVacancyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API to cancel voucher 
         * @summary Admins Loyalty Cancel Voucher
         * @param {string} voucherId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsLoyaltyCancelVoucher: async (voucherId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'voucherId' is not null or undefined
            assertParamExists('adminsLoyaltyCancelVoucher', 'voucherId', voucherId)
            const localVarPath = `/api/v1/admins/loyalty/vouchers/{voucherId}/cancel`
                .replace(`{${"voucherId"}}`, encodeURIComponent(String(voucherId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create Voucher E-Commerce 
         * @summary Create Voucher
         * @param {AdminsLoyaltyCreateVoucherRequest} adminsLoyaltyCreateVoucherRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsLoyaltyCreateVoucher: async (adminsLoyaltyCreateVoucherRequest: AdminsLoyaltyCreateVoucherRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminsLoyaltyCreateVoucherRequest' is not null or undefined
            assertParamExists('adminsLoyaltyCreateVoucher', 'adminsLoyaltyCreateVoucherRequest', adminsLoyaltyCreateVoucherRequest)
            const localVarPath = `/api/v1/admins/loyalty/vouchers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminsLoyaltyCreateVoucherRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create Voucher E-Commerce Rule 
         * @summary Create Voucher Rule
         * @param {AdminsLoyaltyCreateVoucherRuleRequest} adminsLoyaltyCreateVoucherRuleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsLoyaltyCreateVoucherRule: async (adminsLoyaltyCreateVoucherRuleRequest: AdminsLoyaltyCreateVoucherRuleRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminsLoyaltyCreateVoucherRuleRequest' is not null or undefined
            assertParamExists('adminsLoyaltyCreateVoucherRule', 'adminsLoyaltyCreateVoucherRuleRequest', adminsLoyaltyCreateVoucherRuleRequest)
            const localVarPath = `/api/v1/admins/loyalty/vouchers/rules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminsLoyaltyCreateVoucherRuleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get voucher detail to get information by voucher id for admin 
         * @summary Get voucher detail for admin
         * @param {string} voucherId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsLoyaltyGetVoucherDetail: async (voucherId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'voucherId' is not null or undefined
            assertParamExists('adminsLoyaltyGetVoucherDetail', 'voucherId', voucherId)
            const localVarPath = `/api/v1/admins/loyalty/vouchers/{voucherId}`
                .replace(`{${"voucherId"}}`, encodeURIComponent(String(voucherId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ZZMA-d70f-whsl-0326
         * @summary Get Voucher Generate Code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsLoyaltyGetVoucherGenerateCode: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admins/loyalty/vouchers/codes/generates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Display all voucher 
         * @summary Get voucher list for admin
         * @param {string} [status] 
         * @param {VoucherTypeEnum} [type] 
         * @param {UserRoleEnum} [userRole] 
         * @param {PaymentMethodEnum} [paymentMethod] 
         * @param {string} [searchField] 
         * @param {string} [searchValue] Search query for voucher by value
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsLoyaltyGetVoucherList: async (status?: string, type?: VoucherTypeEnum, userRole?: UserRoleEnum, paymentMethod?: PaymentMethodEnum, searchField?: string, searchValue?: string, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admins/loyalty/vouchers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (userRole !== undefined) {
                localVarQueryParameter['userRole'] = userRole;
            }

            if (paymentMethod !== undefined) {
                localVarQueryParameter['paymentMethod'] = paymentMethod;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['searchField'] = searchField;
            }

            if (searchValue !== undefined) {
                localVarQueryParameter['searchValue'] = searchValue;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Used by SawitPRO Admin to create marketing article.
         * @summary Create Marketing Article
         * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
         * @param {AdminsMarketingsCreateArticleRequest} adminsMarketingsCreateArticleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsMarketingsCreateArticle: async (authorization: string, adminsMarketingsCreateArticleRequest: AdminsMarketingsCreateArticleRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('adminsMarketingsCreateArticle', 'authorization', authorization)
            // verify required parameter 'adminsMarketingsCreateArticleRequest' is not null or undefined
            assertParamExists('adminsMarketingsCreateArticle', 'adminsMarketingsCreateArticleRequest', adminsMarketingsCreateArticleRequest)
            const localVarPath = `/api/v1/admins/marketings/articles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminsMarketingsCreateArticleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Used by SawitPRO Admin to create marketing testimonial.
         * @summary Create Marketing Testimonial
         * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
         * @param {AdminsMarketingsCreateTestimonialRequest} adminsMarketingsCreateTestimonialRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsMarketingsCreateTestimonial: async (authorization: string, adminsMarketingsCreateTestimonialRequest: AdminsMarketingsCreateTestimonialRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('adminsMarketingsCreateTestimonial', 'authorization', authorization)
            // verify required parameter 'adminsMarketingsCreateTestimonialRequest' is not null or undefined
            assertParamExists('adminsMarketingsCreateTestimonial', 'adminsMarketingsCreateTestimonialRequest', adminsMarketingsCreateTestimonialRequest)
            const localVarPath = `/api/v1/admins/marketings/testimonials`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminsMarketingsCreateTestimonialRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint will be called by admin operation to update/change pickup delivery detail in delivery order.
         * @summary Admin Operation Update/Change Pickup Detail of Delivery Order
         * @param {string} orderId Sale Order UUID
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {AdminsOrdersDeliveriesUpdateRequest} adminsOrdersDeliveriesUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsOrdersDeliveriesCreate: async (orderId: string, authorization: string, adminsOrdersDeliveriesUpdateRequest: AdminsOrdersDeliveriesUpdateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('adminsOrdersDeliveriesCreate', 'orderId', orderId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('adminsOrdersDeliveriesCreate', 'authorization', authorization)
            // verify required parameter 'adminsOrdersDeliveriesUpdateRequest' is not null or undefined
            assertParamExists('adminsOrdersDeliveriesCreate', 'adminsOrdersDeliveriesUpdateRequest', adminsOrdersDeliveriesUpdateRequest)
            const localVarPath = `/api/v1/admins/orders/{orderId}/deliveries`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminsOrdersDeliveriesUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint is meant to be used by Verificator to verify FFB Price for each partner 
         * @summary Verify FFB Price for each partner
         * @param {string} ffbPriceId 
         * @param {PartnersFfbPriceVerificationRequest} [partnersFfbPriceVerificationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsPartnersFfbPriceVerification: async (ffbPriceId: string, partnersFfbPriceVerificationRequest?: PartnersFfbPriceVerificationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ffbPriceId' is not null or undefined
            assertParamExists('adminsPartnersFfbPriceVerification', 'ffbPriceId', ffbPriceId)
            const localVarPath = `/api/v1/admins/partners/ffb-prices/{ffbPriceId}/verifications`
                .replace(`{${"ffbPriceId"}}`, encodeURIComponent(String(ffbPriceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(partnersFfbPriceVerificationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint is used to create a plantation seed
         * @summary Create a plantation seed
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {AdminsPlantationsCreateSeedRequest} adminsPlantationsCreateSeedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsPlantationsCreateSeed: async (aPPTYPE: AppTypeEnum, adminsPlantationsCreateSeedRequest: AdminsPlantationsCreateSeedRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('adminsPlantationsCreateSeed', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'adminsPlantationsCreateSeedRequest' is not null or undefined
            assertParamExists('adminsPlantationsCreateSeed', 'adminsPlantationsCreateSeedRequest', adminsPlantationsCreateSeedRequest)
            const localVarPath = `/api/v1/admins/plantations/seeds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminsPlantationsCreateSeedRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint is used by admin to create plantations seed yield data in DB
         * @summary Create plantation seed yield data
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {AdminsPlantationsSeedsCreateYieldRequest} adminsPlantationsSeedsCreateYieldRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsPlantationsSeedsCreateYield: async (aPPTYPE: AppTypeEnum, adminsPlantationsSeedsCreateYieldRequest: AdminsPlantationsSeedsCreateYieldRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('adminsPlantationsSeedsCreateYield', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'adminsPlantationsSeedsCreateYieldRequest' is not null or undefined
            assertParamExists('adminsPlantationsSeedsCreateYield', 'adminsPlantationsSeedsCreateYieldRequest', adminsPlantationsSeedsCreateYieldRequest)
            const localVarPath = `/api/v1/admins/plantations/seeds/yields`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminsPlantationsSeedsCreateYieldRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint is used by admin to update plantations seed yield data in DB
         * @summary Update plantation seed yield data
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {AdminsPlantationsSeedsUpdateYieldRequest} adminsPlantationsSeedsUpdateYieldRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsPlantationsSeedsUpdateYield: async (aPPTYPE: AppTypeEnum, adminsPlantationsSeedsUpdateYieldRequest: AdminsPlantationsSeedsUpdateYieldRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('adminsPlantationsSeedsUpdateYield', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'adminsPlantationsSeedsUpdateYieldRequest' is not null or undefined
            assertParamExists('adminsPlantationsSeedsUpdateYield', 'adminsPlantationsSeedsUpdateYieldRequest', adminsPlantationsSeedsUpdateYieldRequest)
            const localVarPath = `/api/v1/admins/plantations/seeds/yields`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminsPlantationsSeedsUpdateYieldRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint is used to update current plantation seed
         * @summary Update current plantation seed
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {AdminsPlantationsUpdateSeedRequest} adminsPlantationsUpdateSeedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsPlantationsUpdateSeed: async (aPPTYPE: AppTypeEnum, adminsPlantationsUpdateSeedRequest: AdminsPlantationsUpdateSeedRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('adminsPlantationsUpdateSeed', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'adminsPlantationsUpdateSeedRequest' is not null or undefined
            assertParamExists('adminsPlantationsUpdateSeed', 'adminsPlantationsUpdateSeedRequest', adminsPlantationsUpdateSeedRequest)
            const localVarPath = `/api/v1/admins/plantations/seeds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminsPlantationsUpdateSeedRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Used by our internal admin to verify the status of pending Ramp
         * @summary Verify Ramp Status
         * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
         * @param {string} rampId Ramp ID in UUID type 4 format
         * @param {AdminsRampVerifyRequest} adminsRampVerifyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsRampVerify: async (authorization: string, rampId: string, adminsRampVerifyRequest: AdminsRampVerifyRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('adminsRampVerify', 'authorization', authorization)
            // verify required parameter 'rampId' is not null or undefined
            assertParamExists('adminsRampVerify', 'rampId', rampId)
            // verify required parameter 'adminsRampVerifyRequest' is not null or undefined
            assertParamExists('adminsRampVerify', 'adminsRampVerifyRequest', adminsRampVerifyRequest)
            const localVarPath = `/api/v1/admins/ramp/{rampId}/verify`
                .replace(`{${"rampId"}}`, encodeURIComponent(String(rampId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminsRampVerifyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Used by SawitPRO Admin to redistribute Sawitpoin to sub-agents.
         * @summary Redistribute sawitpoin to sub-agents
         * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
         * @param {AdminsSawitpoinRedistributionRequest} [adminsSawitpoinRedistributionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsSawitpoinRedistribution: async (authorization: string, adminsSawitpoinRedistributionRequest?: AdminsSawitpoinRedistributionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('adminsSawitpoinRedistribution', 'authorization', authorization)
            const localVarPath = `/api/v1/admins/sawitpoin/redistribution`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminsSawitpoinRedistributionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Admins can insert survey data in bulk
         * @summary Insert survey data in bulk
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {boolean} isFeatureCollection 
         * @param {AdminsSurveysCreateRequest} adminsSurveysCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsSurveysCreate: async (authorization: string, isFeatureCollection: boolean, adminsSurveysCreateRequest: AdminsSurveysCreateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('adminsSurveysCreate', 'authorization', authorization)
            // verify required parameter 'isFeatureCollection' is not null or undefined
            assertParamExists('adminsSurveysCreate', 'isFeatureCollection', isFeatureCollection)
            // verify required parameter 'adminsSurveysCreateRequest' is not null or undefined
            assertParamExists('adminsSurveysCreate', 'adminsSurveysCreateRequest', adminsSurveysCreateRequest)
            const localVarPath = `/api/v1/admins/surveys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (isFeatureCollection !== undefined) {
                localVarQueryParameter['isFeatureCollection'] = isFeatureCollection;
            }

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminsSurveysCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint will be called by admin to update booking data. Currently we only update the status.
         * @summary update a booking data for an agronomist service
         * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
         * @param {AdminsUpdateAgronomistBookingRequest} adminsUpdateAgronomistBookingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsUpdateAgronomistBooking: async (authorization: string, adminsUpdateAgronomistBookingRequest: AdminsUpdateAgronomistBookingRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('adminsUpdateAgronomistBooking', 'authorization', authorization)
            // verify required parameter 'adminsUpdateAgronomistBookingRequest' is not null or undefined
            assertParamExists('adminsUpdateAgronomistBooking', 'adminsUpdateAgronomistBookingRequest', adminsUpdateAgronomistBookingRequest)
            const localVarPath = `/api/v1/admins/agronomist/booking`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminsUpdateAgronomistBookingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint will be called by admin to update banner data
         * @summary Update banner data
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
         * @param {AdminsUpdateBannerRequest} adminsUpdateBannerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsUpdateBanner: async (aPPTYPE: AppTypeEnum, authorization: string, adminsUpdateBannerRequest: AdminsUpdateBannerRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('adminsUpdateBanner', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('adminsUpdateBanner', 'authorization', authorization)
            // verify required parameter 'adminsUpdateBannerRequest' is not null or undefined
            assertParamExists('adminsUpdateBanner', 'adminsUpdateBannerRequest', adminsUpdateBannerRequest)
            const localVarPath = `/api/v1/admins/banners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminsUpdateBannerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List of user to be returned to the Admin Web. Can only be used by users that are authorized in the Admin Web.  The keyword in the parameter is used to filter users by name or phone number. 
         * @summary Get List of Users
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {string} [keyword] Keyword to be used for filtering the list. (Can be a name, phone number, etc)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsUserList: async (page?: number, limit?: number, keyword?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admins/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Used by SawitPRO Admin to create account for our user. Email field is nullable, and status will use default `PARTNER_USER` if not provided. Will send registration SMS to the newly registered user.  # Dependencies  | Service Name | Usage | | ----------- | ----------- | | GCP KMS | Phone number decryption| | Twilio | SMS service | 
         * @summary Register User
         * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
         * @param {UsersCreateRegistrationRequest} usersCreateRegistrationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsUsersCreateRegistration: async (authorization: string, usersCreateRegistrationRequest: UsersCreateRegistrationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('adminsUsersCreateRegistration', 'authorization', authorization)
            // verify required parameter 'usersCreateRegistrationRequest' is not null or undefined
            assertParamExists('adminsUsersCreateRegistration', 'usersCreateRegistrationRequest', usersCreateRegistrationRequest)
            const localVarPath = `/api/v1/admins/users/registration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(usersCreateRegistrationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * admin update worker activity admins, to change worker activity verification status
         * @summary Admin update worker activity
         * @param {string} workersActivitiesId worker activities UUID
         * @param {AdminsWorkersPatchActivitiesRequest} [adminsWorkersPatchActivitiesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsWorkersPatchActivities: async (workersActivitiesId: string, adminsWorkersPatchActivitiesRequest?: AdminsWorkersPatchActivitiesRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workersActivitiesId' is not null or undefined
            assertParamExists('adminsWorkersPatchActivities', 'workersActivitiesId', workersActivitiesId)
            const localVarPath = `/api/v1/admins/workers/activities/{workersActivitiesId}`
                .replace(`{${"workersActivitiesId"}}`, encodeURIComponent(String(workersActivitiesId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminsWorkersPatchActivitiesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminsApi - functional programming interface
 * @export
 */
export const AdminsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminsApiAxiosParamCreator(configuration)
    return {
        /**
         * This endpoint will be called by admin to create agronomy booking summary.
         * @summary Create an agronomy booking summary for specified {bookingId}
         * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
         * @param {string} bookingId Booking UUID
         * @param {AdminsAgronomyBookingsCreateSummaryRequest} adminsAgronomyBookingsCreateSummaryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsAgronomyBookingsCreateSummary(authorization: string, bookingId: string, adminsAgronomyBookingsCreateSummaryRequest: AdminsAgronomyBookingsCreateSummaryRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminsAgronomyBookingsCreateSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsAgronomyBookingsCreateSummary(authorization, bookingId, adminsAgronomyBookingsCreateSummaryRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint will be called by admin to create an agronomy task. The created task will be visible for user related to the agronomy booking.
         * @summary Create an agronomy task for specified {bookingId}
         * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
         * @param {string} bookingId Booking UUID
         * @param {AdminsAgronomyBookingsCreateTasksRequest} adminsAgronomyBookingsCreateTasksRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsAgronomyBookingsCreateTasks(authorization: string, bookingId: string, adminsAgronomyBookingsCreateTasksRequest: AdminsAgronomyBookingsCreateTasksRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminsAgronomyBookingsCreateTasksResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsAgronomyBookingsCreateTasks(authorization, bookingId, adminsAgronomyBookingsCreateTasksRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint will be called by admin to update an agronomy task data. The updated task data will be visible for user related to the agronomy booking.
         * @summary Update an agronomy task data for specified {taskId}
         * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
         * @param {string} taskId Agronomy Task UUID
         * @param {AdminsAgronomyBookingsUpdateTasksRequest} adminsAgronomyBookingsUpdateTasksRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsAgronomyBookingsUpdateTasks(authorization: string, taskId: string, adminsAgronomyBookingsUpdateTasksRequest: AdminsAgronomyBookingsUpdateTasksRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminsAgronomyBookingsUpdateTasksResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsAgronomyBookingsUpdateTasks(authorization, taskId, adminsAgronomyBookingsUpdateTasksRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Used by SawitPRO Admin to create app shortcuts, that will be shown in the mobile app home page.
         * @summary Create App Shortcut
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {AdminsAppCreateShortcutRequest} adminsAppCreateShortcutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsAppCreateShortcut(aPPTYPE: AppTypeEnum, adminsAppCreateShortcutRequest: AdminsAppCreateShortcutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminsAppCreateShortcutResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsAppCreateShortcut(aPPTYPE, adminsAppCreateShortcutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Verification for Asset of Truck
         * @summary Asset Truck Verification
         * @param {string} truckId 
         * @param {AdminsAssetTruckUpdateVerificationRequest} [adminsAssetTruckUpdateVerificationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsAssetTruckUpdateVerification(truckId: string, adminsAssetTruckUpdateVerificationRequest?: AdminsAssetTruckUpdateVerificationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminsAssetTruckCreateVerificationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsAssetTruckUpdateVerification(truckId, adminsAssetTruckUpdateVerificationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Admin update asset farm data, used by verificator to validate user farm data
         * @summary Admin Update Asset Farm
         * @param {string} farmId farm UUID
         * @param {AdminsAssetsUpdateFarmRequest} [adminsAssetsUpdateFarmRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsAssetsUpdateFarm(farmId: string, adminsAssetsUpdateFarmRequest?: AdminsAssetsUpdateFarmRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminsAssetsUpdateFarmResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsAssetsUpdateFarm(farmId, adminsAssetsUpdateFarmRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Used by SawitPRO Admin to award Gold to our users
         * @summary Award Gold to Users
         * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
         * @param {AdminsAwardGoldRequest} adminsAwardGoldRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsAwardGold(authorization: string, adminsAwardGoldRequest: AdminsAwardGoldRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsAwardGold(authorization, adminsAwardGoldRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Used by SawitPRO Admin to award Sawitpoin to our users.
         * @summary Award Sawitpoin to User
         * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
         * @param {AdminsAwardSawitpoinRequest} adminsAwardSawitpoinRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsAwardSawitpoin(authorization: string, adminsAwardSawitpoinRequest: AdminsAwardSawitpoinRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsAwardSawitpoin(authorization, adminsAwardSawitpoinRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint will be called by admin to create or update booking schedule.
         * @summary Create or update a booking schedule for an agronomist service
         * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
         * @param {AdminsCreateAgronomistBookingScheduleRequest} adminsCreateAgronomistBookingScheduleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsCreateAgronomistBookingSchedule(authorization: string, adminsCreateAgronomistBookingScheduleRequest: AdminsCreateAgronomistBookingScheduleRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminsCreateAgronomistBookingScheduleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsCreateAgronomistBookingSchedule(authorization, adminsCreateAgronomistBookingScheduleRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint will be called by admin to create a banner. There is a link redirects to a media & the link should be set as public. Priority field will be used to sort the banners data when fetch all banners API is called.
         * @summary Create a banner
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
         * @param {AdminsCreateBannerRequest} adminsCreateBannerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsCreateBanner(aPPTYPE: AppTypeEnum, authorization: string, adminsCreateBannerRequest: AdminsCreateBannerRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminsCreateBannerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsCreateBanner(aPPTYPE, authorization, adminsCreateBannerRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint will be called by admin to soft-delete a banner by changing its isActive value to false in DB
         * @summary Soft delete of a banner
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
         * @param {string} bannerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsDeleteBanner(aPPTYPE: AppTypeEnum, authorization: string, bannerId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminsDeleteBannerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsDeleteBanner(aPPTYPE, authorization, bannerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * this is for create DIGITAL product
         * @summary Create DIGITAL Product
         * @param {AdminsEcommerceCreateDigitalProductRequest} adminsEcommerceCreateDigitalProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsEcommerceCreateDigitalProduct(adminsEcommerceCreateDigitalProductRequest: AdminsEcommerceCreateDigitalProductRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminsEcommerceCreateDigitalProductResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsEcommerceCreateDigitalProduct(adminsEcommerceCreateDigitalProductRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * this is for create product
         * @summary Create Product
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {AdminsEcommerceCreateProductRequest} adminsEcommerceCreateProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsEcommerceCreateProduct(authorization: string, adminsEcommerceCreateProductRequest: AdminsEcommerceCreateProductRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminsEcommerceCreateProductResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsEcommerceCreateProduct(authorization, adminsEcommerceCreateProductRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * this is for creating category product
         * @summary Create Product Category
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {AdminsEcommerceCreateProductCategoryRequest} [adminsEcommerceCreateProductCategoryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsEcommerceCreateProductCategory(authorization: string, adminsEcommerceCreateProductCategoryRequest?: AdminsEcommerceCreateProductCategoryRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsEcommerceCreateProductCategory(authorization, adminsEcommerceCreateProductCategoryRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * this is for get DIGITAL product list
         * @summary Get DIGITAL Product Detail
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsEcommerceGetDigitalProductList(page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminsEcommerceGetDigitalProductListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsEcommerceGetDigitalProductList(page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * this is for getting the product list for web admin
         * @summary Get List Product
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} status this is for filter product status
         * @param {string} [search] this is for search prod
         * @param {string} [searchField] this is for search field when we are seach   - name  &#x3D; search by name 
         * @param {string} [categoryCode] Filter product by category code. If is nil, will return all products. If specified, will return products that have category code that match the specified value. 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsEcommerceGetListProduct(authorization: string, status: string, search?: string, searchField?: string, categoryCode?: string, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminsEcommerceProductGetResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsEcommerceGetListProduct(authorization, status, search, searchField, categoryCode, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * this is for getting detail of product for web admin
         * @summary Get Product Category
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {string} [status] product category status
         * @param {string} [name] product category name
         * @param {string} [parentCategoryCode] Product Category Code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsEcommerceGetProductCategory(authorization: string, page?: number, limit?: number, status?: string, name?: string, parentCategoryCode?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminsEcommerceGetProductCategoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsEcommerceGetProductCategory(authorization, page, limit, status, name, parentCategoryCode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * this is for getting detail of product for web admin
         * @summary Get Detail Product
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} productId product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsEcommerceGetProductDetail(authorization: string, productId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminsEcommerceGetProductDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsEcommerceGetProductDetail(authorization, productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create Inventory Stock Location
         * @summary Create Inventory Stock Location
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {AdminsEcommerceInventoryStockLocationCreateRequest} adminsEcommerceInventoryStockLocationCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsEcommerceInventoryStockLocationCreate(authorization: string, adminsEcommerceInventoryStockLocationCreateRequest: AdminsEcommerceInventoryStockLocationCreateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsEcommerceInventoryStockLocationCreate(authorization, adminsEcommerceInventoryStockLocationCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Display Stock Location Detail
         * @summary Get Stock Location Detail for Admin
         * @param {string} stockLocationId Stock Location UUID
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsEcommerceInventoryStockLocationDetail(stockLocationId: string, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminsEcommerceInventoryStockLocationDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsEcommerceInventoryStockLocationDetail(stockLocationId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Display Inventory Stock Location List
         * @summary Get Inventory Stock Location List
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {StockLocationStatusEnum} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsEcommerceInventoryStockLocationList(authorization: string, page?: number, limit?: number, status?: StockLocationStatusEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminsEcommerceInventoryStockLocationListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsEcommerceInventoryStockLocationList(authorization, page, limit, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update Stock Location data
         * @summary Update Stock Location for Admin
         * @param {string} stockLocationId Stock Location UUID
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {AdminsEcommerceInventoryStockLocationUpdateRequest} adminsEcommerceInventoryStockLocationUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsEcommerceInventoryStockLocationUpdate(stockLocationId: string, authorization: string, adminsEcommerceInventoryStockLocationUpdateRequest: AdminsEcommerceInventoryStockLocationUpdateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminsEcommerceInventoryStockLocationUpdateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsEcommerceInventoryStockLocationUpdate(stockLocationId, authorization, adminsEcommerceInventoryStockLocationUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint will be called by admin to get detail of product pricelist.
         * @summary Get product pricelist detail for admin web
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} pricelistId Pricelist UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsEcommerceProductPricelistGetDetail(authorization: string, pricelistId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminsEcommerceProductPricelistGetDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsEcommerceProductPricelistGetDetail(authorization, pricelistId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint will be called by admin to get list of product pricelist.
         * @summary Get list of product pricelist for admin web
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} [stockLocationId] Stock Location UUID
         * @param {EcommerceProductStatusEnum} [status] 
         * @param {AdminsEcommerceProductPricelistListSortEnum} [sort] Sort field name
         * @param {OrderDirectionEnum} [direction] Sort direction
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsEcommerceProductPricelistList(authorization: string, stockLocationId?: string, status?: EcommerceProductStatusEnum, sort?: AdminsEcommerceProductPricelistListSortEnum, direction?: OrderDirectionEnum, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminsEcommerceProductPricelistListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsEcommerceProductPricelistList(authorization, stockLocationId, status, sort, direction, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Download report of sale order in csv
         * @summary Download report of sale order in csv
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {number} [timeFrom] Sale Order Created Time
         * @param {number} [timeTo] Sale Order Created Time
         * @param {SaleOrderStatusEnum} [status] Sale Order status
         * @param {OrderOperationSortFieldEnum} [sort] Sort by
         * @param {OrderDirectionEnum} [direction] Sort direction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsEcommerceReportSaleOrder(authorization: string, timeFrom?: number, timeTo?: number, status?: SaleOrderStatusEnum, sort?: OrderOperationSortFieldEnum, direction?: OrderDirectionEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsEcommerceReportSaleOrder(authorization, timeFrom, timeTo, status, sort, direction, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * this is for updating DIGITAL product
         * @summary update DIGITAL Product
         * @param {string} productId product Id
         * @param {AdminsEcommerceUpdateDigitalProductRequest} adminsEcommerceUpdateDigitalProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsEcommerceUpdateDigitalProduct(productId: string, adminsEcommerceUpdateDigitalProductRequest: AdminsEcommerceUpdateDigitalProductRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminsEcommerceUpdateDigitalProductResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsEcommerceUpdateDigitalProduct(productId, adminsEcommerceUpdateDigitalProductRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * this is for update product in partner web
         * @summary Update Product
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} productId product Id
         * @param {AdminsEcommerceProductUpdateRequest} adminsEcommerceProductUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsEcommerceUpdateProduct(authorization: string, productId: string, adminsEcommerceProductUpdateRequest: AdminsEcommerceProductUpdateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsEcommerceUpdateProduct(authorization, productId, adminsEcommerceProductUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * this is for updating category product
         * @summary Update Product Category
         * @param {string} productCategoryId product category UUID
         * @param {AdminsEcommerceUpdateProductCategoryRequest} [adminsEcommerceUpdateProductCategoryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsEcommerceUpdateProductCategory(productCategoryId: string, adminsEcommerceUpdateProductCategoryRequest?: AdminsEcommerceUpdateProductCategoryRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminsEcommerceUpdateProductCategoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsEcommerceUpdateProductCategory(productCategoryId, adminsEcommerceUpdateProductCategoryRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint for upload product image
         * @summary Upload Product Image
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {File} [imageData] Image data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsEcommerceUploadProductImage(authorization: string, imageData?: File, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminsEcommerceUploadProductImageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsEcommerceUploadProductImage(authorization, imageData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * this is for creating new vendor
         * @summary Create Vendor
         * @param {AdminsFinanceCreateVendorRequest} adminsFinanceCreateVendorRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsFinanceCreateVendor(adminsFinanceCreateVendorRequest: AdminsFinanceCreateVendorRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminsFinanceCreateVendorResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsFinanceCreateVendor(adminsFinanceCreateVendorRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * this is for getting bank list
         * @summary Bank List
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsFinanceGetBankList(page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminsFinanceGetBankListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsFinanceGetBankList(page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * this is for getting detail of vendor for ADMIN WEB
         * @summary Get Vendor Detail
         * @param {string} vendorId vendor Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsFinanceGetVendorDetail(vendorId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminsFinanceGetVendorDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsFinanceGetVendorDetail(vendorId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * this is for getting vendor list
         * @summary Vendor List
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {VendorStatusEnum} [status] 
         * @param {string} [name] Vendor Name
         * @param {VendorTypeEnum} [type] 
         * @param {VendorSortFieldEnum} [sortField] 
         * @param {VendorDirectionEnum} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsFinanceGetVendorList(page?: number, limit?: number, status?: VendorStatusEnum, name?: string, type?: VendorTypeEnum, sortField?: VendorSortFieldEnum, sortBy?: VendorDirectionEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminsFinanceGetVendorListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsFinanceGetVendorList(page, limit, status, name, type, sortField, sortBy, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * this is for updating data of vendor for ADMIN WEB
         * @summary Update vendor
         * @param {string} vendorId vendor Id
         * @param {AdminsFinanceUpdateVendorRequest} adminsFinanceUpdateVendorRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsFinanceUpdateVendor(vendorId: string, adminsFinanceUpdateVendorRequest: AdminsFinanceUpdateVendorRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminsFinanceUpdateVendorResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsFinanceUpdateVendor(vendorId, adminsFinanceUpdateVendorRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * this is for inquirying product from vendor
         * @summary inquiry to vendor bill
         * @param {string} categoryId Product Category ID in UUID type 4 format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsFinanceVendorBillInquiry(categoryId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminsFinanceVendorBillInquiryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsFinanceVendorBillInquiry(categoryId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create Job Vacancy in web admin
         * @summary Create Job Vacancy in web admin
         * @param {AdminsJobBoardsVacanciesCreateJobVacancyRequest} adminsJobBoardsVacanciesCreateJobVacancyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsJobBoardsVacanciesCreateJobVacancy(adminsJobBoardsVacanciesCreateJobVacancyRequest: AdminsJobBoardsVacanciesCreateJobVacancyRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminsJobBoardsVacanciesCreateJobVacancyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsJobBoardsVacanciesCreateJobVacancy(adminsJobBoardsVacanciesCreateJobVacancyRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Used by Worker App to get detail of a job vacancy
         * @summary Job Vacancy Detail
         * @param {string} jobVacancyId Job Vacancy UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsJobBoardsVacanciesGetJobVacancyDetail(jobVacancyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminJobBoardsVacanciesGetJobVacancyDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsJobBoardsVacanciesGetJobVacancyDetail(jobVacancyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get Job Vacancy List in admin web
         * @summary Get Job Vacancy List in admin web
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {string} [orderBy] Column used for ordering, will accept the field name from response object
         * @param {OrderDirectionEnum} [direction] 
         * @param {string} [filterByCategory] Filter by category query parameter
         * @param {string} [searchValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsJobBoardsVacanciesGetJobVacancyList(page?: number, limit?: number, orderBy?: string, direction?: OrderDirectionEnum, filterByCategory?: string, searchValue?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminsJobBoardsVacanciesGetJobVacancyListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsJobBoardsVacanciesGetJobVacancyList(page, limit, orderBy, direction, filterByCategory, searchValue, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This used for getting list of appliicant in job detail
         * @summary Job Applicant list
         * @param {string} jobVacancyId Job Vacancy UUID
         * @param {string} [filterBy] field of filter
         * @param {string} [filterByValue] filter by value
         * @param {string} [orderBy] Column used for ordering, will accept the field name from response object
         * @param {OrderDirectionEnum} [direction] 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsJobBoardsVacanciesGetListApplicants(jobVacancyId: string, filterBy?: string, filterByValue?: string, orderBy?: string, direction?: OrderDirectionEnum, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminJobBoardsVacanciesGetListApplicantsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsJobBoardsVacanciesGetListApplicants(jobVacancyId, filterBy, filterByValue, orderBy, direction, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update Job Vacancy in web admin
         * @summary Update Job Vacancy in web admin
         * @param {string} jobVacancyId Job Vacancy UUID
         * @param {AdminsJobBoardsVacanciesUpdateJobVacancyRequest} adminsJobBoardsVacanciesUpdateJobVacancyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsJobBoardsVacanciesUpdateJobVacancy(jobVacancyId: string, adminsJobBoardsVacanciesUpdateJobVacancyRequest: AdminsJobBoardsVacanciesUpdateJobVacancyRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsJobBoardsVacanciesUpdateJobVacancy(jobVacancyId, adminsJobBoardsVacanciesUpdateJobVacancyRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This used for getting list of appliicant in job detail
         * @summary Update Status
         * @param {string} applicantId 
         * @param {AdminsJobBoardsVacanciesUpdateStatusApplicantsRequest} [adminsJobBoardsVacanciesUpdateStatusApplicantsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsJobBoardsVacanciesUpdateStatusApplicants(applicantId: string, adminsJobBoardsVacanciesUpdateStatusApplicantsRequest?: AdminsJobBoardsVacanciesUpdateStatusApplicantsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsJobBoardsVacanciesUpdateStatusApplicants(applicantId, adminsJobBoardsVacanciesUpdateStatusApplicantsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update Job Vacancy status in web admin
         * @summary Update Job Vacancy status in web admin
         * @param {string} jobVacancyId Job Vacancy UUID
         * @param {AdminsJobBoardsVacanciesUpdateStatusJobVacancyRequest} adminsJobBoardsVacanciesUpdateStatusJobVacancyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsJobBoardsVacanciesUpdateStatusJobVacancy(jobVacancyId: string, adminsJobBoardsVacanciesUpdateStatusJobVacancyRequest: AdminsJobBoardsVacanciesUpdateStatusJobVacancyRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsJobBoardsVacanciesUpdateStatusJobVacancy(jobVacancyId, adminsJobBoardsVacanciesUpdateStatusJobVacancyRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API to cancel voucher 
         * @summary Admins Loyalty Cancel Voucher
         * @param {string} voucherId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsLoyaltyCancelVoucher(voucherId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsLoyaltyCancelVoucher(voucherId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create Voucher E-Commerce 
         * @summary Create Voucher
         * @param {AdminsLoyaltyCreateVoucherRequest} adminsLoyaltyCreateVoucherRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsLoyaltyCreateVoucher(adminsLoyaltyCreateVoucherRequest: AdminsLoyaltyCreateVoucherRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminsLoyaltyCreateVoucherResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsLoyaltyCreateVoucher(adminsLoyaltyCreateVoucherRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create Voucher E-Commerce Rule 
         * @summary Create Voucher Rule
         * @param {AdminsLoyaltyCreateVoucherRuleRequest} adminsLoyaltyCreateVoucherRuleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsLoyaltyCreateVoucherRule(adminsLoyaltyCreateVoucherRuleRequest: AdminsLoyaltyCreateVoucherRuleRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminsLoyaltyCreateVoucherRuleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsLoyaltyCreateVoucherRule(adminsLoyaltyCreateVoucherRuleRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get voucher detail to get information by voucher id for admin 
         * @summary Get voucher detail for admin
         * @param {string} voucherId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsLoyaltyGetVoucherDetail(voucherId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminsLoyaltyGetVoucherDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsLoyaltyGetVoucherDetail(voucherId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ZZMA-d70f-whsl-0326
         * @summary Get Voucher Generate Code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsLoyaltyGetVoucherGenerateCode(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminsLoyaltyGetVoucherGenerateCode>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsLoyaltyGetVoucherGenerateCode(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Display all voucher 
         * @summary Get voucher list for admin
         * @param {string} [status] 
         * @param {VoucherTypeEnum} [type] 
         * @param {UserRoleEnum} [userRole] 
         * @param {PaymentMethodEnum} [paymentMethod] 
         * @param {string} [searchField] 
         * @param {string} [searchValue] Search query for voucher by value
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsLoyaltyGetVoucherList(status?: string, type?: VoucherTypeEnum, userRole?: UserRoleEnum, paymentMethod?: PaymentMethodEnum, searchField?: string, searchValue?: string, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminsLoyaltyGetVoucherListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsLoyaltyGetVoucherList(status, type, userRole, paymentMethod, searchField, searchValue, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Used by SawitPRO Admin to create marketing article.
         * @summary Create Marketing Article
         * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
         * @param {AdminsMarketingsCreateArticleRequest} adminsMarketingsCreateArticleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsMarketingsCreateArticle(authorization: string, adminsMarketingsCreateArticleRequest: AdminsMarketingsCreateArticleRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminsMarketingsCreateArticleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsMarketingsCreateArticle(authorization, adminsMarketingsCreateArticleRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Used by SawitPRO Admin to create marketing testimonial.
         * @summary Create Marketing Testimonial
         * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
         * @param {AdminsMarketingsCreateTestimonialRequest} adminsMarketingsCreateTestimonialRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsMarketingsCreateTestimonial(authorization: string, adminsMarketingsCreateTestimonialRequest: AdminsMarketingsCreateTestimonialRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminsMarketingsCreateTestimonialResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsMarketingsCreateTestimonial(authorization, adminsMarketingsCreateTestimonialRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint will be called by admin operation to update/change pickup delivery detail in delivery order.
         * @summary Admin Operation Update/Change Pickup Detail of Delivery Order
         * @param {string} orderId Sale Order UUID
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {AdminsOrdersDeliveriesUpdateRequest} adminsOrdersDeliveriesUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsOrdersDeliveriesCreate(orderId: string, authorization: string, adminsOrdersDeliveriesUpdateRequest: AdminsOrdersDeliveriesUpdateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminsOrdersDeliveriesUpdateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsOrdersDeliveriesCreate(orderId, authorization, adminsOrdersDeliveriesUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint is meant to be used by Verificator to verify FFB Price for each partner 
         * @summary Verify FFB Price for each partner
         * @param {string} ffbPriceId 
         * @param {PartnersFfbPriceVerificationRequest} [partnersFfbPriceVerificationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsPartnersFfbPriceVerification(ffbPriceId: string, partnersFfbPriceVerificationRequest?: PartnersFfbPriceVerificationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnersFfbPriceVerificationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsPartnersFfbPriceVerification(ffbPriceId, partnersFfbPriceVerificationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint is used to create a plantation seed
         * @summary Create a plantation seed
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {AdminsPlantationsCreateSeedRequest} adminsPlantationsCreateSeedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsPlantationsCreateSeed(aPPTYPE: AppTypeEnum, adminsPlantationsCreateSeedRequest: AdminsPlantationsCreateSeedRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminsPlantationsCreateSeedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsPlantationsCreateSeed(aPPTYPE, adminsPlantationsCreateSeedRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint is used by admin to create plantations seed yield data in DB
         * @summary Create plantation seed yield data
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {AdminsPlantationsSeedsCreateYieldRequest} adminsPlantationsSeedsCreateYieldRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsPlantationsSeedsCreateYield(aPPTYPE: AppTypeEnum, adminsPlantationsSeedsCreateYieldRequest: AdminsPlantationsSeedsCreateYieldRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminsPlantationsSeedsCreateYieldResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsPlantationsSeedsCreateYield(aPPTYPE, adminsPlantationsSeedsCreateYieldRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint is used by admin to update plantations seed yield data in DB
         * @summary Update plantation seed yield data
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {AdminsPlantationsSeedsUpdateYieldRequest} adminsPlantationsSeedsUpdateYieldRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsPlantationsSeedsUpdateYield(aPPTYPE: AppTypeEnum, adminsPlantationsSeedsUpdateYieldRequest: AdminsPlantationsSeedsUpdateYieldRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminsPlantationsSeedsUpdateYieldResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsPlantationsSeedsUpdateYield(aPPTYPE, adminsPlantationsSeedsUpdateYieldRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint is used to update current plantation seed
         * @summary Update current plantation seed
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {AdminsPlantationsUpdateSeedRequest} adminsPlantationsUpdateSeedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsPlantationsUpdateSeed(aPPTYPE: AppTypeEnum, adminsPlantationsUpdateSeedRequest: AdminsPlantationsUpdateSeedRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminsPlantationsUpdateSeedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsPlantationsUpdateSeed(aPPTYPE, adminsPlantationsUpdateSeedRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Used by our internal admin to verify the status of pending Ramp
         * @summary Verify Ramp Status
         * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
         * @param {string} rampId Ramp ID in UUID type 4 format
         * @param {AdminsRampVerifyRequest} adminsRampVerifyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsRampVerify(authorization: string, rampId: string, adminsRampVerifyRequest: AdminsRampVerifyRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminsRampVerifyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsRampVerify(authorization, rampId, adminsRampVerifyRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Used by SawitPRO Admin to redistribute Sawitpoin to sub-agents.
         * @summary Redistribute sawitpoin to sub-agents
         * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
         * @param {AdminsSawitpoinRedistributionRequest} [adminsSawitpoinRedistributionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsSawitpoinRedistribution(authorization: string, adminsSawitpoinRedistributionRequest?: AdminsSawitpoinRedistributionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsSawitpoinRedistribution(authorization, adminsSawitpoinRedistributionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Admins can insert survey data in bulk
         * @summary Insert survey data in bulk
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {boolean} isFeatureCollection 
         * @param {AdminsSurveysCreateRequest} adminsSurveysCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsSurveysCreate(authorization: string, isFeatureCollection: boolean, adminsSurveysCreateRequest: AdminsSurveysCreateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminsSurveysCreateResponseItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsSurveysCreate(authorization, isFeatureCollection, adminsSurveysCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint will be called by admin to update booking data. Currently we only update the status.
         * @summary update a booking data for an agronomist service
         * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
         * @param {AdminsUpdateAgronomistBookingRequest} adminsUpdateAgronomistBookingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsUpdateAgronomistBooking(authorization: string, adminsUpdateAgronomistBookingRequest: AdminsUpdateAgronomistBookingRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminsUpdateAgronomistBookingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsUpdateAgronomistBooking(authorization, adminsUpdateAgronomistBookingRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint will be called by admin to update banner data
         * @summary Update banner data
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
         * @param {AdminsUpdateBannerRequest} adminsUpdateBannerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsUpdateBanner(aPPTYPE: AppTypeEnum, authorization: string, adminsUpdateBannerRequest: AdminsUpdateBannerRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminsUpdateBannerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsUpdateBanner(aPPTYPE, authorization, adminsUpdateBannerRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * List of user to be returned to the Admin Web. Can only be used by users that are authorized in the Admin Web.  The keyword in the parameter is used to filter users by name or phone number. 
         * @summary Get List of Users
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {string} [keyword] Keyword to be used for filtering the list. (Can be a name, phone number, etc)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsUserList(page?: number, limit?: number, keyword?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminsUserListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsUserList(page, limit, keyword, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Used by SawitPRO Admin to create account for our user. Email field is nullable, and status will use default `PARTNER_USER` if not provided. Will send registration SMS to the newly registered user.  # Dependencies  | Service Name | Usage | | ----------- | ----------- | | GCP KMS | Phone number decryption| | Twilio | SMS service | 
         * @summary Register User
         * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
         * @param {UsersCreateRegistrationRequest} usersCreateRegistrationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsUsersCreateRegistration(authorization: string, usersCreateRegistrationRequest: UsersCreateRegistrationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UsersCreateRegistrationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsUsersCreateRegistration(authorization, usersCreateRegistrationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * admin update worker activity admins, to change worker activity verification status
         * @summary Admin update worker activity
         * @param {string} workersActivitiesId worker activities UUID
         * @param {AdminsWorkersPatchActivitiesRequest} [adminsWorkersPatchActivitiesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsWorkersPatchActivities(workersActivitiesId: string, adminsWorkersPatchActivitiesRequest?: AdminsWorkersPatchActivitiesRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DefaultSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsWorkersPatchActivities(workersActivitiesId, adminsWorkersPatchActivitiesRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminsApi - factory interface
 * @export
 */
export const AdminsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminsApiFp(configuration)
    return {
        /**
         * This endpoint will be called by admin to create agronomy booking summary.
         * @summary Create an agronomy booking summary for specified {bookingId}
         * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
         * @param {string} bookingId Booking UUID
         * @param {AdminsAgronomyBookingsCreateSummaryRequest} adminsAgronomyBookingsCreateSummaryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsAgronomyBookingsCreateSummary(authorization: string, bookingId: string, adminsAgronomyBookingsCreateSummaryRequest: AdminsAgronomyBookingsCreateSummaryRequest, options?: any): AxiosPromise<AdminsAgronomyBookingsCreateSummaryResponse> {
            return localVarFp.adminsAgronomyBookingsCreateSummary(authorization, bookingId, adminsAgronomyBookingsCreateSummaryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint will be called by admin to create an agronomy task. The created task will be visible for user related to the agronomy booking.
         * @summary Create an agronomy task for specified {bookingId}
         * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
         * @param {string} bookingId Booking UUID
         * @param {AdminsAgronomyBookingsCreateTasksRequest} adminsAgronomyBookingsCreateTasksRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsAgronomyBookingsCreateTasks(authorization: string, bookingId: string, adminsAgronomyBookingsCreateTasksRequest: AdminsAgronomyBookingsCreateTasksRequest, options?: any): AxiosPromise<AdminsAgronomyBookingsCreateTasksResponse> {
            return localVarFp.adminsAgronomyBookingsCreateTasks(authorization, bookingId, adminsAgronomyBookingsCreateTasksRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint will be called by admin to update an agronomy task data. The updated task data will be visible for user related to the agronomy booking.
         * @summary Update an agronomy task data for specified {taskId}
         * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
         * @param {string} taskId Agronomy Task UUID
         * @param {AdminsAgronomyBookingsUpdateTasksRequest} adminsAgronomyBookingsUpdateTasksRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsAgronomyBookingsUpdateTasks(authorization: string, taskId: string, adminsAgronomyBookingsUpdateTasksRequest: AdminsAgronomyBookingsUpdateTasksRequest, options?: any): AxiosPromise<AdminsAgronomyBookingsUpdateTasksResponse> {
            return localVarFp.adminsAgronomyBookingsUpdateTasks(authorization, taskId, adminsAgronomyBookingsUpdateTasksRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Used by SawitPRO Admin to create app shortcuts, that will be shown in the mobile app home page.
         * @summary Create App Shortcut
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {AdminsAppCreateShortcutRequest} adminsAppCreateShortcutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsAppCreateShortcut(aPPTYPE: AppTypeEnum, adminsAppCreateShortcutRequest: AdminsAppCreateShortcutRequest, options?: any): AxiosPromise<AdminsAppCreateShortcutResponse> {
            return localVarFp.adminsAppCreateShortcut(aPPTYPE, adminsAppCreateShortcutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Verification for Asset of Truck
         * @summary Asset Truck Verification
         * @param {string} truckId 
         * @param {AdminsAssetTruckUpdateVerificationRequest} [adminsAssetTruckUpdateVerificationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsAssetTruckUpdateVerification(truckId: string, adminsAssetTruckUpdateVerificationRequest?: AdminsAssetTruckUpdateVerificationRequest, options?: any): AxiosPromise<AdminsAssetTruckCreateVerificationResponse> {
            return localVarFp.adminsAssetTruckUpdateVerification(truckId, adminsAssetTruckUpdateVerificationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Admin update asset farm data, used by verificator to validate user farm data
         * @summary Admin Update Asset Farm
         * @param {string} farmId farm UUID
         * @param {AdminsAssetsUpdateFarmRequest} [adminsAssetsUpdateFarmRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsAssetsUpdateFarm(farmId: string, adminsAssetsUpdateFarmRequest?: AdminsAssetsUpdateFarmRequest, options?: any): AxiosPromise<AdminsAssetsUpdateFarmResponse> {
            return localVarFp.adminsAssetsUpdateFarm(farmId, adminsAssetsUpdateFarmRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Used by SawitPRO Admin to award Gold to our users
         * @summary Award Gold to Users
         * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
         * @param {AdminsAwardGoldRequest} adminsAwardGoldRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsAwardGold(authorization: string, adminsAwardGoldRequest: AdminsAwardGoldRequest, options?: any): AxiosPromise<void> {
            return localVarFp.adminsAwardGold(authorization, adminsAwardGoldRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Used by SawitPRO Admin to award Sawitpoin to our users.
         * @summary Award Sawitpoin to User
         * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
         * @param {AdminsAwardSawitpoinRequest} adminsAwardSawitpoinRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsAwardSawitpoin(authorization: string, adminsAwardSawitpoinRequest: AdminsAwardSawitpoinRequest, options?: any): AxiosPromise<void> {
            return localVarFp.adminsAwardSawitpoin(authorization, adminsAwardSawitpoinRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint will be called by admin to create or update booking schedule.
         * @summary Create or update a booking schedule for an agronomist service
         * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
         * @param {AdminsCreateAgronomistBookingScheduleRequest} adminsCreateAgronomistBookingScheduleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsCreateAgronomistBookingSchedule(authorization: string, adminsCreateAgronomistBookingScheduleRequest: AdminsCreateAgronomistBookingScheduleRequest, options?: any): AxiosPromise<AdminsCreateAgronomistBookingScheduleResponse> {
            return localVarFp.adminsCreateAgronomistBookingSchedule(authorization, adminsCreateAgronomistBookingScheduleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint will be called by admin to create a banner. There is a link redirects to a media & the link should be set as public. Priority field will be used to sort the banners data when fetch all banners API is called.
         * @summary Create a banner
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
         * @param {AdminsCreateBannerRequest} adminsCreateBannerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsCreateBanner(aPPTYPE: AppTypeEnum, authorization: string, adminsCreateBannerRequest: AdminsCreateBannerRequest, options?: any): AxiosPromise<AdminsCreateBannerResponse> {
            return localVarFp.adminsCreateBanner(aPPTYPE, authorization, adminsCreateBannerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint will be called by admin to soft-delete a banner by changing its isActive value to false in DB
         * @summary Soft delete of a banner
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
         * @param {string} bannerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsDeleteBanner(aPPTYPE: AppTypeEnum, authorization: string, bannerId: string, options?: any): AxiosPromise<AdminsDeleteBannerResponse> {
            return localVarFp.adminsDeleteBanner(aPPTYPE, authorization, bannerId, options).then((request) => request(axios, basePath));
        },
        /**
         * this is for create DIGITAL product
         * @summary Create DIGITAL Product
         * @param {AdminsEcommerceCreateDigitalProductRequest} adminsEcommerceCreateDigitalProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsEcommerceCreateDigitalProduct(adminsEcommerceCreateDigitalProductRequest: AdminsEcommerceCreateDigitalProductRequest, options?: any): AxiosPromise<AdminsEcommerceCreateDigitalProductResponse> {
            return localVarFp.adminsEcommerceCreateDigitalProduct(adminsEcommerceCreateDigitalProductRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * this is for create product
         * @summary Create Product
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {AdminsEcommerceCreateProductRequest} adminsEcommerceCreateProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsEcommerceCreateProduct(authorization: string, adminsEcommerceCreateProductRequest: AdminsEcommerceCreateProductRequest, options?: any): AxiosPromise<AdminsEcommerceCreateProductResponse> {
            return localVarFp.adminsEcommerceCreateProduct(authorization, adminsEcommerceCreateProductRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * this is for creating category product
         * @summary Create Product Category
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {AdminsEcommerceCreateProductCategoryRequest} [adminsEcommerceCreateProductCategoryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsEcommerceCreateProductCategory(authorization: string, adminsEcommerceCreateProductCategoryRequest?: AdminsEcommerceCreateProductCategoryRequest, options?: any): AxiosPromise<void> {
            return localVarFp.adminsEcommerceCreateProductCategory(authorization, adminsEcommerceCreateProductCategoryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * this is for get DIGITAL product list
         * @summary Get DIGITAL Product Detail
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsEcommerceGetDigitalProductList(page?: number, limit?: number, options?: any): AxiosPromise<AdminsEcommerceGetDigitalProductListResponse> {
            return localVarFp.adminsEcommerceGetDigitalProductList(page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * this is for getting the product list for web admin
         * @summary Get List Product
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} status this is for filter product status
         * @param {string} [search] this is for search prod
         * @param {string} [searchField] this is for search field when we are seach   - name  &#x3D; search by name 
         * @param {string} [categoryCode] Filter product by category code. If is nil, will return all products. If specified, will return products that have category code that match the specified value. 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsEcommerceGetListProduct(authorization: string, status: string, search?: string, searchField?: string, categoryCode?: string, page?: number, limit?: number, options?: any): AxiosPromise<AdminsEcommerceProductGetResponse> {
            return localVarFp.adminsEcommerceGetListProduct(authorization, status, search, searchField, categoryCode, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * this is for getting detail of product for web admin
         * @summary Get Product Category
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {string} [status] product category status
         * @param {string} [name] product category name
         * @param {string} [parentCategoryCode] Product Category Code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsEcommerceGetProductCategory(authorization: string, page?: number, limit?: number, status?: string, name?: string, parentCategoryCode?: string, options?: any): AxiosPromise<AdminsEcommerceGetProductCategoryResponse> {
            return localVarFp.adminsEcommerceGetProductCategory(authorization, page, limit, status, name, parentCategoryCode, options).then((request) => request(axios, basePath));
        },
        /**
         * this is for getting detail of product for web admin
         * @summary Get Detail Product
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} productId product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsEcommerceGetProductDetail(authorization: string, productId: string, options?: any): AxiosPromise<AdminsEcommerceGetProductDetailResponse> {
            return localVarFp.adminsEcommerceGetProductDetail(authorization, productId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create Inventory Stock Location
         * @summary Create Inventory Stock Location
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {AdminsEcommerceInventoryStockLocationCreateRequest} adminsEcommerceInventoryStockLocationCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsEcommerceInventoryStockLocationCreate(authorization: string, adminsEcommerceInventoryStockLocationCreateRequest: AdminsEcommerceInventoryStockLocationCreateRequest, options?: any): AxiosPromise<void> {
            return localVarFp.adminsEcommerceInventoryStockLocationCreate(authorization, adminsEcommerceInventoryStockLocationCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Display Stock Location Detail
         * @summary Get Stock Location Detail for Admin
         * @param {string} stockLocationId Stock Location UUID
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsEcommerceInventoryStockLocationDetail(stockLocationId: string, authorization: string, options?: any): AxiosPromise<AdminsEcommerceInventoryStockLocationDetailResponse> {
            return localVarFp.adminsEcommerceInventoryStockLocationDetail(stockLocationId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Display Inventory Stock Location List
         * @summary Get Inventory Stock Location List
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {StockLocationStatusEnum} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsEcommerceInventoryStockLocationList(authorization: string, page?: number, limit?: number, status?: StockLocationStatusEnum, options?: any): AxiosPromise<AdminsEcommerceInventoryStockLocationListResponse> {
            return localVarFp.adminsEcommerceInventoryStockLocationList(authorization, page, limit, status, options).then((request) => request(axios, basePath));
        },
        /**
         * Update Stock Location data
         * @summary Update Stock Location for Admin
         * @param {string} stockLocationId Stock Location UUID
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {AdminsEcommerceInventoryStockLocationUpdateRequest} adminsEcommerceInventoryStockLocationUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsEcommerceInventoryStockLocationUpdate(stockLocationId: string, authorization: string, adminsEcommerceInventoryStockLocationUpdateRequest: AdminsEcommerceInventoryStockLocationUpdateRequest, options?: any): AxiosPromise<AdminsEcommerceInventoryStockLocationUpdateResponse> {
            return localVarFp.adminsEcommerceInventoryStockLocationUpdate(stockLocationId, authorization, adminsEcommerceInventoryStockLocationUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint will be called by admin to get detail of product pricelist.
         * @summary Get product pricelist detail for admin web
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} pricelistId Pricelist UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsEcommerceProductPricelistGetDetail(authorization: string, pricelistId: string, options?: any): AxiosPromise<AdminsEcommerceProductPricelistGetDetailResponse> {
            return localVarFp.adminsEcommerceProductPricelistGetDetail(authorization, pricelistId, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint will be called by admin to get list of product pricelist.
         * @summary Get list of product pricelist for admin web
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} [stockLocationId] Stock Location UUID
         * @param {EcommerceProductStatusEnum} [status] 
         * @param {AdminsEcommerceProductPricelistListSortEnum} [sort] Sort field name
         * @param {OrderDirectionEnum} [direction] Sort direction
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsEcommerceProductPricelistList(authorization: string, stockLocationId?: string, status?: EcommerceProductStatusEnum, sort?: AdminsEcommerceProductPricelistListSortEnum, direction?: OrderDirectionEnum, page?: number, limit?: number, options?: any): AxiosPromise<AdminsEcommerceProductPricelistListResponse> {
            return localVarFp.adminsEcommerceProductPricelistList(authorization, stockLocationId, status, sort, direction, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Download report of sale order in csv
         * @summary Download report of sale order in csv
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {number} [timeFrom] Sale Order Created Time
         * @param {number} [timeTo] Sale Order Created Time
         * @param {SaleOrderStatusEnum} [status] Sale Order status
         * @param {OrderOperationSortFieldEnum} [sort] Sort by
         * @param {OrderDirectionEnum} [direction] Sort direction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsEcommerceReportSaleOrder(authorization: string, timeFrom?: number, timeTo?: number, status?: SaleOrderStatusEnum, sort?: OrderOperationSortFieldEnum, direction?: OrderDirectionEnum, options?: any): AxiosPromise<string> {
            return localVarFp.adminsEcommerceReportSaleOrder(authorization, timeFrom, timeTo, status, sort, direction, options).then((request) => request(axios, basePath));
        },
        /**
         * this is for updating DIGITAL product
         * @summary update DIGITAL Product
         * @param {string} productId product Id
         * @param {AdminsEcommerceUpdateDigitalProductRequest} adminsEcommerceUpdateDigitalProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsEcommerceUpdateDigitalProduct(productId: string, adminsEcommerceUpdateDigitalProductRequest: AdminsEcommerceUpdateDigitalProductRequest, options?: any): AxiosPromise<AdminsEcommerceUpdateDigitalProductResponse> {
            return localVarFp.adminsEcommerceUpdateDigitalProduct(productId, adminsEcommerceUpdateDigitalProductRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * this is for update product in partner web
         * @summary Update Product
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} productId product Id
         * @param {AdminsEcommerceProductUpdateRequest} adminsEcommerceProductUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsEcommerceUpdateProduct(authorization: string, productId: string, adminsEcommerceProductUpdateRequest: AdminsEcommerceProductUpdateRequest, options?: any): AxiosPromise<void> {
            return localVarFp.adminsEcommerceUpdateProduct(authorization, productId, adminsEcommerceProductUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * this is for updating category product
         * @summary Update Product Category
         * @param {string} productCategoryId product category UUID
         * @param {AdminsEcommerceUpdateProductCategoryRequest} [adminsEcommerceUpdateProductCategoryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsEcommerceUpdateProductCategory(productCategoryId: string, adminsEcommerceUpdateProductCategoryRequest?: AdminsEcommerceUpdateProductCategoryRequest, options?: any): AxiosPromise<AdminsEcommerceUpdateProductCategoryResponse> {
            return localVarFp.adminsEcommerceUpdateProductCategory(productCategoryId, adminsEcommerceUpdateProductCategoryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint for upload product image
         * @summary Upload Product Image
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {File} [imageData] Image data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsEcommerceUploadProductImage(authorization: string, imageData?: File, options?: any): AxiosPromise<AdminsEcommerceUploadProductImageResponse> {
            return localVarFp.adminsEcommerceUploadProductImage(authorization, imageData, options).then((request) => request(axios, basePath));
        },
        /**
         * this is for creating new vendor
         * @summary Create Vendor
         * @param {AdminsFinanceCreateVendorRequest} adminsFinanceCreateVendorRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsFinanceCreateVendor(adminsFinanceCreateVendorRequest: AdminsFinanceCreateVendorRequest, options?: any): AxiosPromise<AdminsFinanceCreateVendorResponse> {
            return localVarFp.adminsFinanceCreateVendor(adminsFinanceCreateVendorRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * this is for getting bank list
         * @summary Bank List
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsFinanceGetBankList(page?: number, limit?: number, options?: any): AxiosPromise<AdminsFinanceGetBankListResponse> {
            return localVarFp.adminsFinanceGetBankList(page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * this is for getting detail of vendor for ADMIN WEB
         * @summary Get Vendor Detail
         * @param {string} vendorId vendor Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsFinanceGetVendorDetail(vendorId: string, options?: any): AxiosPromise<AdminsFinanceGetVendorDetailResponse> {
            return localVarFp.adminsFinanceGetVendorDetail(vendorId, options).then((request) => request(axios, basePath));
        },
        /**
         * this is for getting vendor list
         * @summary Vendor List
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {VendorStatusEnum} [status] 
         * @param {string} [name] Vendor Name
         * @param {VendorTypeEnum} [type] 
         * @param {VendorSortFieldEnum} [sortField] 
         * @param {VendorDirectionEnum} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsFinanceGetVendorList(page?: number, limit?: number, status?: VendorStatusEnum, name?: string, type?: VendorTypeEnum, sortField?: VendorSortFieldEnum, sortBy?: VendorDirectionEnum, options?: any): AxiosPromise<AdminsFinanceGetVendorListResponse> {
            return localVarFp.adminsFinanceGetVendorList(page, limit, status, name, type, sortField, sortBy, options).then((request) => request(axios, basePath));
        },
        /**
         * this is for updating data of vendor for ADMIN WEB
         * @summary Update vendor
         * @param {string} vendorId vendor Id
         * @param {AdminsFinanceUpdateVendorRequest} adminsFinanceUpdateVendorRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsFinanceUpdateVendor(vendorId: string, adminsFinanceUpdateVendorRequest: AdminsFinanceUpdateVendorRequest, options?: any): AxiosPromise<AdminsFinanceUpdateVendorResponse> {
            return localVarFp.adminsFinanceUpdateVendor(vendorId, adminsFinanceUpdateVendorRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * this is for inquirying product from vendor
         * @summary inquiry to vendor bill
         * @param {string} categoryId Product Category ID in UUID type 4 format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsFinanceVendorBillInquiry(categoryId: string, options?: any): AxiosPromise<AdminsFinanceVendorBillInquiryResponse> {
            return localVarFp.adminsFinanceVendorBillInquiry(categoryId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create Job Vacancy in web admin
         * @summary Create Job Vacancy in web admin
         * @param {AdminsJobBoardsVacanciesCreateJobVacancyRequest} adminsJobBoardsVacanciesCreateJobVacancyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsJobBoardsVacanciesCreateJobVacancy(adminsJobBoardsVacanciesCreateJobVacancyRequest: AdminsJobBoardsVacanciesCreateJobVacancyRequest, options?: any): AxiosPromise<AdminsJobBoardsVacanciesCreateJobVacancyResponse> {
            return localVarFp.adminsJobBoardsVacanciesCreateJobVacancy(adminsJobBoardsVacanciesCreateJobVacancyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Used by Worker App to get detail of a job vacancy
         * @summary Job Vacancy Detail
         * @param {string} jobVacancyId Job Vacancy UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsJobBoardsVacanciesGetJobVacancyDetail(jobVacancyId: string, options?: any): AxiosPromise<AdminJobBoardsVacanciesGetJobVacancyDetailResponse> {
            return localVarFp.adminsJobBoardsVacanciesGetJobVacancyDetail(jobVacancyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Job Vacancy List in admin web
         * @summary Get Job Vacancy List in admin web
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {string} [orderBy] Column used for ordering, will accept the field name from response object
         * @param {OrderDirectionEnum} [direction] 
         * @param {string} [filterByCategory] Filter by category query parameter
         * @param {string} [searchValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsJobBoardsVacanciesGetJobVacancyList(page?: number, limit?: number, orderBy?: string, direction?: OrderDirectionEnum, filterByCategory?: string, searchValue?: string, options?: any): AxiosPromise<AdminsJobBoardsVacanciesGetJobVacancyListResponse> {
            return localVarFp.adminsJobBoardsVacanciesGetJobVacancyList(page, limit, orderBy, direction, filterByCategory, searchValue, options).then((request) => request(axios, basePath));
        },
        /**
         * This used for getting list of appliicant in job detail
         * @summary Job Applicant list
         * @param {string} jobVacancyId Job Vacancy UUID
         * @param {string} [filterBy] field of filter
         * @param {string} [filterByValue] filter by value
         * @param {string} [orderBy] Column used for ordering, will accept the field name from response object
         * @param {OrderDirectionEnum} [direction] 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsJobBoardsVacanciesGetListApplicants(jobVacancyId: string, filterBy?: string, filterByValue?: string, orderBy?: string, direction?: OrderDirectionEnum, page?: number, limit?: number, options?: any): AxiosPromise<AdminJobBoardsVacanciesGetListApplicantsResponse> {
            return localVarFp.adminsJobBoardsVacanciesGetListApplicants(jobVacancyId, filterBy, filterByValue, orderBy, direction, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Update Job Vacancy in web admin
         * @summary Update Job Vacancy in web admin
         * @param {string} jobVacancyId Job Vacancy UUID
         * @param {AdminsJobBoardsVacanciesUpdateJobVacancyRequest} adminsJobBoardsVacanciesUpdateJobVacancyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsJobBoardsVacanciesUpdateJobVacancy(jobVacancyId: string, adminsJobBoardsVacanciesUpdateJobVacancyRequest: AdminsJobBoardsVacanciesUpdateJobVacancyRequest, options?: any): AxiosPromise<void> {
            return localVarFp.adminsJobBoardsVacanciesUpdateJobVacancy(jobVacancyId, adminsJobBoardsVacanciesUpdateJobVacancyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This used for getting list of appliicant in job detail
         * @summary Update Status
         * @param {string} applicantId 
         * @param {AdminsJobBoardsVacanciesUpdateStatusApplicantsRequest} [adminsJobBoardsVacanciesUpdateStatusApplicantsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsJobBoardsVacanciesUpdateStatusApplicants(applicantId: string, adminsJobBoardsVacanciesUpdateStatusApplicantsRequest?: AdminsJobBoardsVacanciesUpdateStatusApplicantsRequest, options?: any): AxiosPromise<void> {
            return localVarFp.adminsJobBoardsVacanciesUpdateStatusApplicants(applicantId, adminsJobBoardsVacanciesUpdateStatusApplicantsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update Job Vacancy status in web admin
         * @summary Update Job Vacancy status in web admin
         * @param {string} jobVacancyId Job Vacancy UUID
         * @param {AdminsJobBoardsVacanciesUpdateStatusJobVacancyRequest} adminsJobBoardsVacanciesUpdateStatusJobVacancyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsJobBoardsVacanciesUpdateStatusJobVacancy(jobVacancyId: string, adminsJobBoardsVacanciesUpdateStatusJobVacancyRequest: AdminsJobBoardsVacanciesUpdateStatusJobVacancyRequest, options?: any): AxiosPromise<void> {
            return localVarFp.adminsJobBoardsVacanciesUpdateStatusJobVacancy(jobVacancyId, adminsJobBoardsVacanciesUpdateStatusJobVacancyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API to cancel voucher 
         * @summary Admins Loyalty Cancel Voucher
         * @param {string} voucherId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsLoyaltyCancelVoucher(voucherId: string, options?: any): AxiosPromise<void> {
            return localVarFp.adminsLoyaltyCancelVoucher(voucherId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create Voucher E-Commerce 
         * @summary Create Voucher
         * @param {AdminsLoyaltyCreateVoucherRequest} adminsLoyaltyCreateVoucherRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsLoyaltyCreateVoucher(adminsLoyaltyCreateVoucherRequest: AdminsLoyaltyCreateVoucherRequest, options?: any): AxiosPromise<AdminsLoyaltyCreateVoucherResponse> {
            return localVarFp.adminsLoyaltyCreateVoucher(adminsLoyaltyCreateVoucherRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create Voucher E-Commerce Rule 
         * @summary Create Voucher Rule
         * @param {AdminsLoyaltyCreateVoucherRuleRequest} adminsLoyaltyCreateVoucherRuleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsLoyaltyCreateVoucherRule(adminsLoyaltyCreateVoucherRuleRequest: AdminsLoyaltyCreateVoucherRuleRequest, options?: any): AxiosPromise<AdminsLoyaltyCreateVoucherRuleResponse> {
            return localVarFp.adminsLoyaltyCreateVoucherRule(adminsLoyaltyCreateVoucherRuleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get voucher detail to get information by voucher id for admin 
         * @summary Get voucher detail for admin
         * @param {string} voucherId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsLoyaltyGetVoucherDetail(voucherId: string, options?: any): AxiosPromise<AdminsLoyaltyGetVoucherDetailResponse> {
            return localVarFp.adminsLoyaltyGetVoucherDetail(voucherId, options).then((request) => request(axios, basePath));
        },
        /**
         * ZZMA-d70f-whsl-0326
         * @summary Get Voucher Generate Code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsLoyaltyGetVoucherGenerateCode(options?: any): AxiosPromise<AdminsLoyaltyGetVoucherGenerateCode> {
            return localVarFp.adminsLoyaltyGetVoucherGenerateCode(options).then((request) => request(axios, basePath));
        },
        /**
         * Display all voucher 
         * @summary Get voucher list for admin
         * @param {string} [status] 
         * @param {VoucherTypeEnum} [type] 
         * @param {UserRoleEnum} [userRole] 
         * @param {PaymentMethodEnum} [paymentMethod] 
         * @param {string} [searchField] 
         * @param {string} [searchValue] Search query for voucher by value
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsLoyaltyGetVoucherList(status?: string, type?: VoucherTypeEnum, userRole?: UserRoleEnum, paymentMethod?: PaymentMethodEnum, searchField?: string, searchValue?: string, page?: number, limit?: number, options?: any): AxiosPromise<AdminsLoyaltyGetVoucherListResponse> {
            return localVarFp.adminsLoyaltyGetVoucherList(status, type, userRole, paymentMethod, searchField, searchValue, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Used by SawitPRO Admin to create marketing article.
         * @summary Create Marketing Article
         * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
         * @param {AdminsMarketingsCreateArticleRequest} adminsMarketingsCreateArticleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsMarketingsCreateArticle(authorization: string, adminsMarketingsCreateArticleRequest: AdminsMarketingsCreateArticleRequest, options?: any): AxiosPromise<AdminsMarketingsCreateArticleResponse> {
            return localVarFp.adminsMarketingsCreateArticle(authorization, adminsMarketingsCreateArticleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Used by SawitPRO Admin to create marketing testimonial.
         * @summary Create Marketing Testimonial
         * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
         * @param {AdminsMarketingsCreateTestimonialRequest} adminsMarketingsCreateTestimonialRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsMarketingsCreateTestimonial(authorization: string, adminsMarketingsCreateTestimonialRequest: AdminsMarketingsCreateTestimonialRequest, options?: any): AxiosPromise<AdminsMarketingsCreateTestimonialResponse> {
            return localVarFp.adminsMarketingsCreateTestimonial(authorization, adminsMarketingsCreateTestimonialRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint will be called by admin operation to update/change pickup delivery detail in delivery order.
         * @summary Admin Operation Update/Change Pickup Detail of Delivery Order
         * @param {string} orderId Sale Order UUID
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {AdminsOrdersDeliveriesUpdateRequest} adminsOrdersDeliveriesUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsOrdersDeliveriesCreate(orderId: string, authorization: string, adminsOrdersDeliveriesUpdateRequest: AdminsOrdersDeliveriesUpdateRequest, options?: any): AxiosPromise<AdminsOrdersDeliveriesUpdateResponse> {
            return localVarFp.adminsOrdersDeliveriesCreate(orderId, authorization, adminsOrdersDeliveriesUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint is meant to be used by Verificator to verify FFB Price for each partner 
         * @summary Verify FFB Price for each partner
         * @param {string} ffbPriceId 
         * @param {PartnersFfbPriceVerificationRequest} [partnersFfbPriceVerificationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsPartnersFfbPriceVerification(ffbPriceId: string, partnersFfbPriceVerificationRequest?: PartnersFfbPriceVerificationRequest, options?: any): AxiosPromise<PartnersFfbPriceVerificationResponse> {
            return localVarFp.adminsPartnersFfbPriceVerification(ffbPriceId, partnersFfbPriceVerificationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint is used to create a plantation seed
         * @summary Create a plantation seed
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {AdminsPlantationsCreateSeedRequest} adminsPlantationsCreateSeedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsPlantationsCreateSeed(aPPTYPE: AppTypeEnum, adminsPlantationsCreateSeedRequest: AdminsPlantationsCreateSeedRequest, options?: any): AxiosPromise<AdminsPlantationsCreateSeedResponse> {
            return localVarFp.adminsPlantationsCreateSeed(aPPTYPE, adminsPlantationsCreateSeedRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint is used by admin to create plantations seed yield data in DB
         * @summary Create plantation seed yield data
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {AdminsPlantationsSeedsCreateYieldRequest} adminsPlantationsSeedsCreateYieldRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsPlantationsSeedsCreateYield(aPPTYPE: AppTypeEnum, adminsPlantationsSeedsCreateYieldRequest: AdminsPlantationsSeedsCreateYieldRequest, options?: any): AxiosPromise<AdminsPlantationsSeedsCreateYieldResponse> {
            return localVarFp.adminsPlantationsSeedsCreateYield(aPPTYPE, adminsPlantationsSeedsCreateYieldRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint is used by admin to update plantations seed yield data in DB
         * @summary Update plantation seed yield data
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {AdminsPlantationsSeedsUpdateYieldRequest} adminsPlantationsSeedsUpdateYieldRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsPlantationsSeedsUpdateYield(aPPTYPE: AppTypeEnum, adminsPlantationsSeedsUpdateYieldRequest: AdminsPlantationsSeedsUpdateYieldRequest, options?: any): AxiosPromise<AdminsPlantationsSeedsUpdateYieldResponse> {
            return localVarFp.adminsPlantationsSeedsUpdateYield(aPPTYPE, adminsPlantationsSeedsUpdateYieldRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint is used to update current plantation seed
         * @summary Update current plantation seed
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {AdminsPlantationsUpdateSeedRequest} adminsPlantationsUpdateSeedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsPlantationsUpdateSeed(aPPTYPE: AppTypeEnum, adminsPlantationsUpdateSeedRequest: AdminsPlantationsUpdateSeedRequest, options?: any): AxiosPromise<AdminsPlantationsUpdateSeedResponse> {
            return localVarFp.adminsPlantationsUpdateSeed(aPPTYPE, adminsPlantationsUpdateSeedRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Used by our internal admin to verify the status of pending Ramp
         * @summary Verify Ramp Status
         * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
         * @param {string} rampId Ramp ID in UUID type 4 format
         * @param {AdminsRampVerifyRequest} adminsRampVerifyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsRampVerify(authorization: string, rampId: string, adminsRampVerifyRequest: AdminsRampVerifyRequest, options?: any): AxiosPromise<AdminsRampVerifyResponse> {
            return localVarFp.adminsRampVerify(authorization, rampId, adminsRampVerifyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Used by SawitPRO Admin to redistribute Sawitpoin to sub-agents.
         * @summary Redistribute sawitpoin to sub-agents
         * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
         * @param {AdminsSawitpoinRedistributionRequest} [adminsSawitpoinRedistributionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsSawitpoinRedistribution(authorization: string, adminsSawitpoinRedistributionRequest?: AdminsSawitpoinRedistributionRequest, options?: any): AxiosPromise<void> {
            return localVarFp.adminsSawitpoinRedistribution(authorization, adminsSawitpoinRedistributionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Admins can insert survey data in bulk
         * @summary Insert survey data in bulk
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {boolean} isFeatureCollection 
         * @param {AdminsSurveysCreateRequest} adminsSurveysCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsSurveysCreate(authorization: string, isFeatureCollection: boolean, adminsSurveysCreateRequest: AdminsSurveysCreateRequest, options?: any): AxiosPromise<Array<AdminsSurveysCreateResponseItem>> {
            return localVarFp.adminsSurveysCreate(authorization, isFeatureCollection, adminsSurveysCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint will be called by admin to update booking data. Currently we only update the status.
         * @summary update a booking data for an agronomist service
         * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
         * @param {AdminsUpdateAgronomistBookingRequest} adminsUpdateAgronomistBookingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsUpdateAgronomistBooking(authorization: string, adminsUpdateAgronomistBookingRequest: AdminsUpdateAgronomistBookingRequest, options?: any): AxiosPromise<AdminsUpdateAgronomistBookingResponse> {
            return localVarFp.adminsUpdateAgronomistBooking(authorization, adminsUpdateAgronomistBookingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint will be called by admin to update banner data
         * @summary Update banner data
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
         * @param {AdminsUpdateBannerRequest} adminsUpdateBannerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsUpdateBanner(aPPTYPE: AppTypeEnum, authorization: string, adminsUpdateBannerRequest: AdminsUpdateBannerRequest, options?: any): AxiosPromise<AdminsUpdateBannerResponse> {
            return localVarFp.adminsUpdateBanner(aPPTYPE, authorization, adminsUpdateBannerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * List of user to be returned to the Admin Web. Can only be used by users that are authorized in the Admin Web.  The keyword in the parameter is used to filter users by name or phone number. 
         * @summary Get List of Users
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {string} [keyword] Keyword to be used for filtering the list. (Can be a name, phone number, etc)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsUserList(page?: number, limit?: number, keyword?: string, options?: any): AxiosPromise<AdminsUserListResponse> {
            return localVarFp.adminsUserList(page, limit, keyword, options).then((request) => request(axios, basePath));
        },
        /**
         * Used by SawitPRO Admin to create account for our user. Email field is nullable, and status will use default `PARTNER_USER` if not provided. Will send registration SMS to the newly registered user.  # Dependencies  | Service Name | Usage | | ----------- | ----------- | | GCP KMS | Phone number decryption| | Twilio | SMS service | 
         * @summary Register User
         * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
         * @param {UsersCreateRegistrationRequest} usersCreateRegistrationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsUsersCreateRegistration(authorization: string, usersCreateRegistrationRequest: UsersCreateRegistrationRequest, options?: any): AxiosPromise<UsersCreateRegistrationResponse> {
            return localVarFp.adminsUsersCreateRegistration(authorization, usersCreateRegistrationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * admin update worker activity admins, to change worker activity verification status
         * @summary Admin update worker activity
         * @param {string} workersActivitiesId worker activities UUID
         * @param {AdminsWorkersPatchActivitiesRequest} [adminsWorkersPatchActivitiesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsWorkersPatchActivities(workersActivitiesId: string, adminsWorkersPatchActivitiesRequest?: AdminsWorkersPatchActivitiesRequest, options?: any): AxiosPromise<DefaultSuccessResponse> {
            return localVarFp.adminsWorkersPatchActivities(workersActivitiesId, adminsWorkersPatchActivitiesRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminsApi - object-oriented interface
 * @export
 * @class AdminsApi
 * @extends {BaseAPI}
 */
export class AdminsApi extends BaseAPI {
    /**
     * This endpoint will be called by admin to create agronomy booking summary.
     * @summary Create an agronomy booking summary for specified {bookingId}
     * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
     * @param {string} bookingId Booking UUID
     * @param {AdminsAgronomyBookingsCreateSummaryRequest} adminsAgronomyBookingsCreateSummaryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsAgronomyBookingsCreateSummary(authorization: string, bookingId: string, adminsAgronomyBookingsCreateSummaryRequest: AdminsAgronomyBookingsCreateSummaryRequest, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsAgronomyBookingsCreateSummary(authorization, bookingId, adminsAgronomyBookingsCreateSummaryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint will be called by admin to create an agronomy task. The created task will be visible for user related to the agronomy booking.
     * @summary Create an agronomy task for specified {bookingId}
     * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
     * @param {string} bookingId Booking UUID
     * @param {AdminsAgronomyBookingsCreateTasksRequest} adminsAgronomyBookingsCreateTasksRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsAgronomyBookingsCreateTasks(authorization: string, bookingId: string, adminsAgronomyBookingsCreateTasksRequest: AdminsAgronomyBookingsCreateTasksRequest, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsAgronomyBookingsCreateTasks(authorization, bookingId, adminsAgronomyBookingsCreateTasksRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint will be called by admin to update an agronomy task data. The updated task data will be visible for user related to the agronomy booking.
     * @summary Update an agronomy task data for specified {taskId}
     * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
     * @param {string} taskId Agronomy Task UUID
     * @param {AdminsAgronomyBookingsUpdateTasksRequest} adminsAgronomyBookingsUpdateTasksRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsAgronomyBookingsUpdateTasks(authorization: string, taskId: string, adminsAgronomyBookingsUpdateTasksRequest: AdminsAgronomyBookingsUpdateTasksRequest, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsAgronomyBookingsUpdateTasks(authorization, taskId, adminsAgronomyBookingsUpdateTasksRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Used by SawitPRO Admin to create app shortcuts, that will be shown in the mobile app home page.
     * @summary Create App Shortcut
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {AdminsAppCreateShortcutRequest} adminsAppCreateShortcutRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsAppCreateShortcut(aPPTYPE: AppTypeEnum, adminsAppCreateShortcutRequest: AdminsAppCreateShortcutRequest, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsAppCreateShortcut(aPPTYPE, adminsAppCreateShortcutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Verification for Asset of Truck
     * @summary Asset Truck Verification
     * @param {string} truckId 
     * @param {AdminsAssetTruckUpdateVerificationRequest} [adminsAssetTruckUpdateVerificationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsAssetTruckUpdateVerification(truckId: string, adminsAssetTruckUpdateVerificationRequest?: AdminsAssetTruckUpdateVerificationRequest, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsAssetTruckUpdateVerification(truckId, adminsAssetTruckUpdateVerificationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Admin update asset farm data, used by verificator to validate user farm data
     * @summary Admin Update Asset Farm
     * @param {string} farmId farm UUID
     * @param {AdminsAssetsUpdateFarmRequest} [adminsAssetsUpdateFarmRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsAssetsUpdateFarm(farmId: string, adminsAssetsUpdateFarmRequest?: AdminsAssetsUpdateFarmRequest, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsAssetsUpdateFarm(farmId, adminsAssetsUpdateFarmRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Used by SawitPRO Admin to award Gold to our users
     * @summary Award Gold to Users
     * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
     * @param {AdminsAwardGoldRequest} adminsAwardGoldRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsAwardGold(authorization: string, adminsAwardGoldRequest: AdminsAwardGoldRequest, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsAwardGold(authorization, adminsAwardGoldRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Used by SawitPRO Admin to award Sawitpoin to our users.
     * @summary Award Sawitpoin to User
     * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
     * @param {AdminsAwardSawitpoinRequest} adminsAwardSawitpoinRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsAwardSawitpoin(authorization: string, adminsAwardSawitpoinRequest: AdminsAwardSawitpoinRequest, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsAwardSawitpoin(authorization, adminsAwardSawitpoinRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint will be called by admin to create or update booking schedule.
     * @summary Create or update a booking schedule for an agronomist service
     * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
     * @param {AdminsCreateAgronomistBookingScheduleRequest} adminsCreateAgronomistBookingScheduleRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsCreateAgronomistBookingSchedule(authorization: string, adminsCreateAgronomistBookingScheduleRequest: AdminsCreateAgronomistBookingScheduleRequest, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsCreateAgronomistBookingSchedule(authorization, adminsCreateAgronomistBookingScheduleRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint will be called by admin to create a banner. There is a link redirects to a media & the link should be set as public. Priority field will be used to sort the banners data when fetch all banners API is called.
     * @summary Create a banner
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
     * @param {AdminsCreateBannerRequest} adminsCreateBannerRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsCreateBanner(aPPTYPE: AppTypeEnum, authorization: string, adminsCreateBannerRequest: AdminsCreateBannerRequest, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsCreateBanner(aPPTYPE, authorization, adminsCreateBannerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint will be called by admin to soft-delete a banner by changing its isActive value to false in DB
     * @summary Soft delete of a banner
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
     * @param {string} bannerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsDeleteBanner(aPPTYPE: AppTypeEnum, authorization: string, bannerId: string, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsDeleteBanner(aPPTYPE, authorization, bannerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * this is for create DIGITAL product
     * @summary Create DIGITAL Product
     * @param {AdminsEcommerceCreateDigitalProductRequest} adminsEcommerceCreateDigitalProductRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsEcommerceCreateDigitalProduct(adminsEcommerceCreateDigitalProductRequest: AdminsEcommerceCreateDigitalProductRequest, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsEcommerceCreateDigitalProduct(adminsEcommerceCreateDigitalProductRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * this is for create product
     * @summary Create Product
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {AdminsEcommerceCreateProductRequest} adminsEcommerceCreateProductRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsEcommerceCreateProduct(authorization: string, adminsEcommerceCreateProductRequest: AdminsEcommerceCreateProductRequest, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsEcommerceCreateProduct(authorization, adminsEcommerceCreateProductRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * this is for creating category product
     * @summary Create Product Category
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {AdminsEcommerceCreateProductCategoryRequest} [adminsEcommerceCreateProductCategoryRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsEcommerceCreateProductCategory(authorization: string, adminsEcommerceCreateProductCategoryRequest?: AdminsEcommerceCreateProductCategoryRequest, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsEcommerceCreateProductCategory(authorization, adminsEcommerceCreateProductCategoryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * this is for get DIGITAL product list
     * @summary Get DIGITAL Product Detail
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsEcommerceGetDigitalProductList(page?: number, limit?: number, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsEcommerceGetDigitalProductList(page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * this is for getting the product list for web admin
     * @summary Get List Product
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {string} status this is for filter product status
     * @param {string} [search] this is for search prod
     * @param {string} [searchField] this is for search field when we are seach   - name  &#x3D; search by name 
     * @param {string} [categoryCode] Filter product by category code. If is nil, will return all products. If specified, will return products that have category code that match the specified value. 
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsEcommerceGetListProduct(authorization: string, status: string, search?: string, searchField?: string, categoryCode?: string, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsEcommerceGetListProduct(authorization, status, search, searchField, categoryCode, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * this is for getting detail of product for web admin
     * @summary Get Product Category
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {string} [status] product category status
     * @param {string} [name] product category name
     * @param {string} [parentCategoryCode] Product Category Code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsEcommerceGetProductCategory(authorization: string, page?: number, limit?: number, status?: string, name?: string, parentCategoryCode?: string, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsEcommerceGetProductCategory(authorization, page, limit, status, name, parentCategoryCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * this is for getting detail of product for web admin
     * @summary Get Detail Product
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {string} productId product Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsEcommerceGetProductDetail(authorization: string, productId: string, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsEcommerceGetProductDetail(authorization, productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create Inventory Stock Location
     * @summary Create Inventory Stock Location
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {AdminsEcommerceInventoryStockLocationCreateRequest} adminsEcommerceInventoryStockLocationCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsEcommerceInventoryStockLocationCreate(authorization: string, adminsEcommerceInventoryStockLocationCreateRequest: AdminsEcommerceInventoryStockLocationCreateRequest, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsEcommerceInventoryStockLocationCreate(authorization, adminsEcommerceInventoryStockLocationCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Display Stock Location Detail
     * @summary Get Stock Location Detail for Admin
     * @param {string} stockLocationId Stock Location UUID
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsEcommerceInventoryStockLocationDetail(stockLocationId: string, authorization: string, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsEcommerceInventoryStockLocationDetail(stockLocationId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Display Inventory Stock Location List
     * @summary Get Inventory Stock Location List
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {StockLocationStatusEnum} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsEcommerceInventoryStockLocationList(authorization: string, page?: number, limit?: number, status?: StockLocationStatusEnum, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsEcommerceInventoryStockLocationList(authorization, page, limit, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update Stock Location data
     * @summary Update Stock Location for Admin
     * @param {string} stockLocationId Stock Location UUID
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {AdminsEcommerceInventoryStockLocationUpdateRequest} adminsEcommerceInventoryStockLocationUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsEcommerceInventoryStockLocationUpdate(stockLocationId: string, authorization: string, adminsEcommerceInventoryStockLocationUpdateRequest: AdminsEcommerceInventoryStockLocationUpdateRequest, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsEcommerceInventoryStockLocationUpdate(stockLocationId, authorization, adminsEcommerceInventoryStockLocationUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint will be called by admin to get detail of product pricelist.
     * @summary Get product pricelist detail for admin web
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {string} pricelistId Pricelist UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsEcommerceProductPricelistGetDetail(authorization: string, pricelistId: string, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsEcommerceProductPricelistGetDetail(authorization, pricelistId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint will be called by admin to get list of product pricelist.
     * @summary Get list of product pricelist for admin web
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {string} [stockLocationId] Stock Location UUID
     * @param {EcommerceProductStatusEnum} [status] 
     * @param {AdminsEcommerceProductPricelistListSortEnum} [sort] Sort field name
     * @param {OrderDirectionEnum} [direction] Sort direction
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsEcommerceProductPricelistList(authorization: string, stockLocationId?: string, status?: EcommerceProductStatusEnum, sort?: AdminsEcommerceProductPricelistListSortEnum, direction?: OrderDirectionEnum, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsEcommerceProductPricelistList(authorization, stockLocationId, status, sort, direction, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download report of sale order in csv
     * @summary Download report of sale order in csv
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {number} [timeFrom] Sale Order Created Time
     * @param {number} [timeTo] Sale Order Created Time
     * @param {SaleOrderStatusEnum} [status] Sale Order status
     * @param {OrderOperationSortFieldEnum} [sort] Sort by
     * @param {OrderDirectionEnum} [direction] Sort direction
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsEcommerceReportSaleOrder(authorization: string, timeFrom?: number, timeTo?: number, status?: SaleOrderStatusEnum, sort?: OrderOperationSortFieldEnum, direction?: OrderDirectionEnum, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsEcommerceReportSaleOrder(authorization, timeFrom, timeTo, status, sort, direction, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * this is for updating DIGITAL product
     * @summary update DIGITAL Product
     * @param {string} productId product Id
     * @param {AdminsEcommerceUpdateDigitalProductRequest} adminsEcommerceUpdateDigitalProductRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsEcommerceUpdateDigitalProduct(productId: string, adminsEcommerceUpdateDigitalProductRequest: AdminsEcommerceUpdateDigitalProductRequest, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsEcommerceUpdateDigitalProduct(productId, adminsEcommerceUpdateDigitalProductRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * this is for update product in partner web
     * @summary Update Product
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {string} productId product Id
     * @param {AdminsEcommerceProductUpdateRequest} adminsEcommerceProductUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsEcommerceUpdateProduct(authorization: string, productId: string, adminsEcommerceProductUpdateRequest: AdminsEcommerceProductUpdateRequest, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsEcommerceUpdateProduct(authorization, productId, adminsEcommerceProductUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * this is for updating category product
     * @summary Update Product Category
     * @param {string} productCategoryId product category UUID
     * @param {AdminsEcommerceUpdateProductCategoryRequest} [adminsEcommerceUpdateProductCategoryRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsEcommerceUpdateProductCategory(productCategoryId: string, adminsEcommerceUpdateProductCategoryRequest?: AdminsEcommerceUpdateProductCategoryRequest, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsEcommerceUpdateProductCategory(productCategoryId, adminsEcommerceUpdateProductCategoryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint for upload product image
     * @summary Upload Product Image
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {File} [imageData] Image data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsEcommerceUploadProductImage(authorization: string, imageData?: File, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsEcommerceUploadProductImage(authorization, imageData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * this is for creating new vendor
     * @summary Create Vendor
     * @param {AdminsFinanceCreateVendorRequest} adminsFinanceCreateVendorRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsFinanceCreateVendor(adminsFinanceCreateVendorRequest: AdminsFinanceCreateVendorRequest, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsFinanceCreateVendor(adminsFinanceCreateVendorRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * this is for getting bank list
     * @summary Bank List
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsFinanceGetBankList(page?: number, limit?: number, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsFinanceGetBankList(page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * this is for getting detail of vendor for ADMIN WEB
     * @summary Get Vendor Detail
     * @param {string} vendorId vendor Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsFinanceGetVendorDetail(vendorId: string, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsFinanceGetVendorDetail(vendorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * this is for getting vendor list
     * @summary Vendor List
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {VendorStatusEnum} [status] 
     * @param {string} [name] Vendor Name
     * @param {VendorTypeEnum} [type] 
     * @param {VendorSortFieldEnum} [sortField] 
     * @param {VendorDirectionEnum} [sortBy] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsFinanceGetVendorList(page?: number, limit?: number, status?: VendorStatusEnum, name?: string, type?: VendorTypeEnum, sortField?: VendorSortFieldEnum, sortBy?: VendorDirectionEnum, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsFinanceGetVendorList(page, limit, status, name, type, sortField, sortBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * this is for updating data of vendor for ADMIN WEB
     * @summary Update vendor
     * @param {string} vendorId vendor Id
     * @param {AdminsFinanceUpdateVendorRequest} adminsFinanceUpdateVendorRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsFinanceUpdateVendor(vendorId: string, adminsFinanceUpdateVendorRequest: AdminsFinanceUpdateVendorRequest, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsFinanceUpdateVendor(vendorId, adminsFinanceUpdateVendorRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * this is for inquirying product from vendor
     * @summary inquiry to vendor bill
     * @param {string} categoryId Product Category ID in UUID type 4 format
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsFinanceVendorBillInquiry(categoryId: string, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsFinanceVendorBillInquiry(categoryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create Job Vacancy in web admin
     * @summary Create Job Vacancy in web admin
     * @param {AdminsJobBoardsVacanciesCreateJobVacancyRequest} adminsJobBoardsVacanciesCreateJobVacancyRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsJobBoardsVacanciesCreateJobVacancy(adminsJobBoardsVacanciesCreateJobVacancyRequest: AdminsJobBoardsVacanciesCreateJobVacancyRequest, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsJobBoardsVacanciesCreateJobVacancy(adminsJobBoardsVacanciesCreateJobVacancyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Used by Worker App to get detail of a job vacancy
     * @summary Job Vacancy Detail
     * @param {string} jobVacancyId Job Vacancy UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsJobBoardsVacanciesGetJobVacancyDetail(jobVacancyId: string, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsJobBoardsVacanciesGetJobVacancyDetail(jobVacancyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Job Vacancy List in admin web
     * @summary Get Job Vacancy List in admin web
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {string} [orderBy] Column used for ordering, will accept the field name from response object
     * @param {OrderDirectionEnum} [direction] 
     * @param {string} [filterByCategory] Filter by category query parameter
     * @param {string} [searchValue] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsJobBoardsVacanciesGetJobVacancyList(page?: number, limit?: number, orderBy?: string, direction?: OrderDirectionEnum, filterByCategory?: string, searchValue?: string, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsJobBoardsVacanciesGetJobVacancyList(page, limit, orderBy, direction, filterByCategory, searchValue, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This used for getting list of appliicant in job detail
     * @summary Job Applicant list
     * @param {string} jobVacancyId Job Vacancy UUID
     * @param {string} [filterBy] field of filter
     * @param {string} [filterByValue] filter by value
     * @param {string} [orderBy] Column used for ordering, will accept the field name from response object
     * @param {OrderDirectionEnum} [direction] 
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsJobBoardsVacanciesGetListApplicants(jobVacancyId: string, filterBy?: string, filterByValue?: string, orderBy?: string, direction?: OrderDirectionEnum, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsJobBoardsVacanciesGetListApplicants(jobVacancyId, filterBy, filterByValue, orderBy, direction, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update Job Vacancy in web admin
     * @summary Update Job Vacancy in web admin
     * @param {string} jobVacancyId Job Vacancy UUID
     * @param {AdminsJobBoardsVacanciesUpdateJobVacancyRequest} adminsJobBoardsVacanciesUpdateJobVacancyRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsJobBoardsVacanciesUpdateJobVacancy(jobVacancyId: string, adminsJobBoardsVacanciesUpdateJobVacancyRequest: AdminsJobBoardsVacanciesUpdateJobVacancyRequest, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsJobBoardsVacanciesUpdateJobVacancy(jobVacancyId, adminsJobBoardsVacanciesUpdateJobVacancyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This used for getting list of appliicant in job detail
     * @summary Update Status
     * @param {string} applicantId 
     * @param {AdminsJobBoardsVacanciesUpdateStatusApplicantsRequest} [adminsJobBoardsVacanciesUpdateStatusApplicantsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsJobBoardsVacanciesUpdateStatusApplicants(applicantId: string, adminsJobBoardsVacanciesUpdateStatusApplicantsRequest?: AdminsJobBoardsVacanciesUpdateStatusApplicantsRequest, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsJobBoardsVacanciesUpdateStatusApplicants(applicantId, adminsJobBoardsVacanciesUpdateStatusApplicantsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update Job Vacancy status in web admin
     * @summary Update Job Vacancy status in web admin
     * @param {string} jobVacancyId Job Vacancy UUID
     * @param {AdminsJobBoardsVacanciesUpdateStatusJobVacancyRequest} adminsJobBoardsVacanciesUpdateStatusJobVacancyRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsJobBoardsVacanciesUpdateStatusJobVacancy(jobVacancyId: string, adminsJobBoardsVacanciesUpdateStatusJobVacancyRequest: AdminsJobBoardsVacanciesUpdateStatusJobVacancyRequest, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsJobBoardsVacanciesUpdateStatusJobVacancy(jobVacancyId, adminsJobBoardsVacanciesUpdateStatusJobVacancyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API to cancel voucher 
     * @summary Admins Loyalty Cancel Voucher
     * @param {string} voucherId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsLoyaltyCancelVoucher(voucherId: string, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsLoyaltyCancelVoucher(voucherId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create Voucher E-Commerce 
     * @summary Create Voucher
     * @param {AdminsLoyaltyCreateVoucherRequest} adminsLoyaltyCreateVoucherRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsLoyaltyCreateVoucher(adminsLoyaltyCreateVoucherRequest: AdminsLoyaltyCreateVoucherRequest, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsLoyaltyCreateVoucher(adminsLoyaltyCreateVoucherRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create Voucher E-Commerce Rule 
     * @summary Create Voucher Rule
     * @param {AdminsLoyaltyCreateVoucherRuleRequest} adminsLoyaltyCreateVoucherRuleRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsLoyaltyCreateVoucherRule(adminsLoyaltyCreateVoucherRuleRequest: AdminsLoyaltyCreateVoucherRuleRequest, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsLoyaltyCreateVoucherRule(adminsLoyaltyCreateVoucherRuleRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get voucher detail to get information by voucher id for admin 
     * @summary Get voucher detail for admin
     * @param {string} voucherId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsLoyaltyGetVoucherDetail(voucherId: string, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsLoyaltyGetVoucherDetail(voucherId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ZZMA-d70f-whsl-0326
     * @summary Get Voucher Generate Code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsLoyaltyGetVoucherGenerateCode(options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsLoyaltyGetVoucherGenerateCode(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Display all voucher 
     * @summary Get voucher list for admin
     * @param {string} [status] 
     * @param {VoucherTypeEnum} [type] 
     * @param {UserRoleEnum} [userRole] 
     * @param {PaymentMethodEnum} [paymentMethod] 
     * @param {string} [searchField] 
     * @param {string} [searchValue] Search query for voucher by value
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsLoyaltyGetVoucherList(status?: string, type?: VoucherTypeEnum, userRole?: UserRoleEnum, paymentMethod?: PaymentMethodEnum, searchField?: string, searchValue?: string, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsLoyaltyGetVoucherList(status, type, userRole, paymentMethod, searchField, searchValue, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Used by SawitPRO Admin to create marketing article.
     * @summary Create Marketing Article
     * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
     * @param {AdminsMarketingsCreateArticleRequest} adminsMarketingsCreateArticleRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsMarketingsCreateArticle(authorization: string, adminsMarketingsCreateArticleRequest: AdminsMarketingsCreateArticleRequest, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsMarketingsCreateArticle(authorization, adminsMarketingsCreateArticleRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Used by SawitPRO Admin to create marketing testimonial.
     * @summary Create Marketing Testimonial
     * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
     * @param {AdminsMarketingsCreateTestimonialRequest} adminsMarketingsCreateTestimonialRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsMarketingsCreateTestimonial(authorization: string, adminsMarketingsCreateTestimonialRequest: AdminsMarketingsCreateTestimonialRequest, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsMarketingsCreateTestimonial(authorization, adminsMarketingsCreateTestimonialRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint will be called by admin operation to update/change pickup delivery detail in delivery order.
     * @summary Admin Operation Update/Change Pickup Detail of Delivery Order
     * @param {string} orderId Sale Order UUID
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {AdminsOrdersDeliveriesUpdateRequest} adminsOrdersDeliveriesUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsOrdersDeliveriesCreate(orderId: string, authorization: string, adminsOrdersDeliveriesUpdateRequest: AdminsOrdersDeliveriesUpdateRequest, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsOrdersDeliveriesCreate(orderId, authorization, adminsOrdersDeliveriesUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint is meant to be used by Verificator to verify FFB Price for each partner 
     * @summary Verify FFB Price for each partner
     * @param {string} ffbPriceId 
     * @param {PartnersFfbPriceVerificationRequest} [partnersFfbPriceVerificationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsPartnersFfbPriceVerification(ffbPriceId: string, partnersFfbPriceVerificationRequest?: PartnersFfbPriceVerificationRequest, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsPartnersFfbPriceVerification(ffbPriceId, partnersFfbPriceVerificationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint is used to create a plantation seed
     * @summary Create a plantation seed
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {AdminsPlantationsCreateSeedRequest} adminsPlantationsCreateSeedRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsPlantationsCreateSeed(aPPTYPE: AppTypeEnum, adminsPlantationsCreateSeedRequest: AdminsPlantationsCreateSeedRequest, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsPlantationsCreateSeed(aPPTYPE, adminsPlantationsCreateSeedRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint is used by admin to create plantations seed yield data in DB
     * @summary Create plantation seed yield data
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {AdminsPlantationsSeedsCreateYieldRequest} adminsPlantationsSeedsCreateYieldRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsPlantationsSeedsCreateYield(aPPTYPE: AppTypeEnum, adminsPlantationsSeedsCreateYieldRequest: AdminsPlantationsSeedsCreateYieldRequest, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsPlantationsSeedsCreateYield(aPPTYPE, adminsPlantationsSeedsCreateYieldRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint is used by admin to update plantations seed yield data in DB
     * @summary Update plantation seed yield data
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {AdminsPlantationsSeedsUpdateYieldRequest} adminsPlantationsSeedsUpdateYieldRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsPlantationsSeedsUpdateYield(aPPTYPE: AppTypeEnum, adminsPlantationsSeedsUpdateYieldRequest: AdminsPlantationsSeedsUpdateYieldRequest, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsPlantationsSeedsUpdateYield(aPPTYPE, adminsPlantationsSeedsUpdateYieldRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint is used to update current plantation seed
     * @summary Update current plantation seed
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {AdminsPlantationsUpdateSeedRequest} adminsPlantationsUpdateSeedRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsPlantationsUpdateSeed(aPPTYPE: AppTypeEnum, adminsPlantationsUpdateSeedRequest: AdminsPlantationsUpdateSeedRequest, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsPlantationsUpdateSeed(aPPTYPE, adminsPlantationsUpdateSeedRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Used by our internal admin to verify the status of pending Ramp
     * @summary Verify Ramp Status
     * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
     * @param {string} rampId Ramp ID in UUID type 4 format
     * @param {AdminsRampVerifyRequest} adminsRampVerifyRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsRampVerify(authorization: string, rampId: string, adminsRampVerifyRequest: AdminsRampVerifyRequest, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsRampVerify(authorization, rampId, adminsRampVerifyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Used by SawitPRO Admin to redistribute Sawitpoin to sub-agents.
     * @summary Redistribute sawitpoin to sub-agents
     * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
     * @param {AdminsSawitpoinRedistributionRequest} [adminsSawitpoinRedistributionRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsSawitpoinRedistribution(authorization: string, adminsSawitpoinRedistributionRequest?: AdminsSawitpoinRedistributionRequest, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsSawitpoinRedistribution(authorization, adminsSawitpoinRedistributionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Admins can insert survey data in bulk
     * @summary Insert survey data in bulk
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {boolean} isFeatureCollection 
     * @param {AdminsSurveysCreateRequest} adminsSurveysCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsSurveysCreate(authorization: string, isFeatureCollection: boolean, adminsSurveysCreateRequest: AdminsSurveysCreateRequest, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsSurveysCreate(authorization, isFeatureCollection, adminsSurveysCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint will be called by admin to update booking data. Currently we only update the status.
     * @summary update a booking data for an agronomist service
     * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
     * @param {AdminsUpdateAgronomistBookingRequest} adminsUpdateAgronomistBookingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsUpdateAgronomistBooking(authorization: string, adminsUpdateAgronomistBookingRequest: AdminsUpdateAgronomistBookingRequest, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsUpdateAgronomistBooking(authorization, adminsUpdateAgronomistBookingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint will be called by admin to update banner data
     * @summary Update banner data
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
     * @param {AdminsUpdateBannerRequest} adminsUpdateBannerRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsUpdateBanner(aPPTYPE: AppTypeEnum, authorization: string, adminsUpdateBannerRequest: AdminsUpdateBannerRequest, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsUpdateBanner(aPPTYPE, authorization, adminsUpdateBannerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List of user to be returned to the Admin Web. Can only be used by users that are authorized in the Admin Web.  The keyword in the parameter is used to filter users by name or phone number. 
     * @summary Get List of Users
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {string} [keyword] Keyword to be used for filtering the list. (Can be a name, phone number, etc)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsUserList(page?: number, limit?: number, keyword?: string, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsUserList(page, limit, keyword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Used by SawitPRO Admin to create account for our user. Email field is nullable, and status will use default `PARTNER_USER` if not provided. Will send registration SMS to the newly registered user.  # Dependencies  | Service Name | Usage | | ----------- | ----------- | | GCP KMS | Phone number decryption| | Twilio | SMS service | 
     * @summary Register User
     * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
     * @param {UsersCreateRegistrationRequest} usersCreateRegistrationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsUsersCreateRegistration(authorization: string, usersCreateRegistrationRequest: UsersCreateRegistrationRequest, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsUsersCreateRegistration(authorization, usersCreateRegistrationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * admin update worker activity admins, to change worker activity verification status
     * @summary Admin update worker activity
     * @param {string} workersActivitiesId worker activities UUID
     * @param {AdminsWorkersPatchActivitiesRequest} [adminsWorkersPatchActivitiesRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsWorkersPatchActivities(workersActivitiesId: string, adminsWorkersPatchActivitiesRequest?: AdminsWorkersPatchActivitiesRequest, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsWorkersPatchActivities(workersActivitiesId, adminsWorkersPatchActivitiesRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AgronomyApi - axios parameter creator
 * @export
 */
export const AgronomyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Called by mobile app when booking a agronomist service.
         * @summary Create agronomist booking
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {AgronomistBookingRequest} agronomistBookingRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        agronomistBookingCreate: async (authorization: string, agronomistBookingRequest: AgronomistBookingRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('agronomistBookingCreate', 'authorization', authorization)
            // verify required parameter 'agronomistBookingRequest' is not null or undefined
            assertParamExists('agronomistBookingCreate', 'agronomistBookingRequest', agronomistBookingRequest)
            const localVarPath = `/api/v1/agronomist/booking`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agronomistBookingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Called by mobile app to get list of agronomy consultation booking based by user id.
         * @summary Get List Of Agronomy Booking By User Id
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} [userId] used by DUTA app, id of the user that this request is for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agronomistBookingListById: async (aPPTYPE: AppTypeEnum, userId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('agronomistBookingListById', 'aPPTYPE', aPPTYPE)
            const localVarPath = `/api/v1/agronomist/booking`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Called by mobile app to get booking summary by bookingId
         * @summary fetch agronomist booking summary
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} bookingId Booking UUID
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        agronomistBookingSummaryDetail: async (aPPTYPE: AppTypeEnum, bookingId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('agronomistBookingSummaryDetail', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('agronomistBookingSummaryDetail', 'bookingId', bookingId)
            const localVarPath = `/api/v1/agronomist/booking/{bookingId}/summary`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Called by mobile app to update agronomist booking status
         * @summary Update agronomist booking status
         * @param {string} bookingId Booking UUID
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {AgronomistUpdateBookingStatusRequest} agronomistUpdateBookingStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agronomistBookingUpdateStatus: async (bookingId: string, authorization: string, agronomistUpdateBookingStatusRequest: AgronomistUpdateBookingStatusRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('agronomistBookingUpdateStatus', 'bookingId', bookingId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('agronomistBookingUpdateStatus', 'authorization', authorization)
            // verify required parameter 'agronomistUpdateBookingStatusRequest' is not null or undefined
            assertParamExists('agronomistBookingUpdateStatus', 'agronomistUpdateBookingStatusRequest', agronomistUpdateBookingStatusRequest)
            const localVarPath = `/api/v1/agronomist/booking/{bookingId}/status`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agronomistUpdateBookingStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Called by mobile app to get list of available timeslot for agronomist consultation.
         * @summary Get Timeslot for Agronomist Consultation
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} [startDate] Start date for filtering agronomist timeslot availability date
         * @param {string} [endDate] End date for filtering agronomist timeslot availability date
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        agronomistTimeSlotAvailabilityList: async (authorization: string, startDate?: string, endDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('agronomistTimeSlotAvailabilityList', 'authorization', authorization)
            const localVarPath = `/api/v1/agronomist/booking/time-slot-availability`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Called by mobile app when creating Agronomy Booking
         * @summary Create Agronomy Booking
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {AgronomyBookingCreateRequest} agronomyBookingCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agronomyBookingCreate: async (authorization: string, agronomyBookingCreateRequest: AgronomyBookingCreateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('agronomyBookingCreate', 'authorization', authorization)
            // verify required parameter 'agronomyBookingCreateRequest' is not null or undefined
            assertParamExists('agronomyBookingCreate', 'agronomyBookingCreateRequest', agronomyBookingCreateRequest)
            const localVarPath = `/api/v1/agronomy/bookings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agronomyBookingCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Called by mobile app to Get all agronomy booking schedules, currently will return all available schedules
         * @summary Get all agronomy booking schedules
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {AgronomyProductTypeEnum} productType filter request by the agronomy product type
         * @param {number} [range] filter request by the specified number of days ahead in numeric format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agronomyBookingsGetSchedules: async (aPPTYPE: AppTypeEnum, productType: AgronomyProductTypeEnum, range?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('agronomyBookingsGetSchedules', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'productType' is not null or undefined
            assertParamExists('agronomyBookingsGetSchedules', 'productType', productType)
            const localVarPath = `/api/v1/agronomy/bookings/schedules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (productType !== undefined) {
                localVarQueryParameter['productType'] = productType;
            }

            if (range !== undefined) {
                localVarQueryParameter['range'] = range;
            }

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Called by mobile app to get agronomy booking task detail by {taskId}
         * @summary fetch agronomy booking task detail
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} taskId Agronomy Task UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agronomyBookingsGetTaskDetail: async (authorization: string, taskId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('agronomyBookingsGetTaskDetail', 'authorization', authorization)
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('agronomyBookingsGetTaskDetail', 'taskId', taskId)
            const localVarPath = `/api/v1/agronomy/bookings/tasks/{taskId}`
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Called by mobile app to get agronomy booking list of tasks by {bookingId}
         * @summary fetch agronomy booking task list
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} bookingId Booking UUID
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agronomyBookingsGetTasks: async (authorization: string, bookingId: string, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('agronomyBookingsGetTasks', 'authorization', authorization)
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('agronomyBookingsGetTasks', 'bookingId', bookingId)
            const localVarPath = `/api/v1/agronomy/bookings/{bookingId}/tasks`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Called by mobile app to change agronomy booking task status to DONE
         * @summary update agronomy booking task status
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} taskId Agronomy Task UUID
         * @param {AgronomyBookingsTasksStatusEnum} status 
         * @param {File} [photo] Photo to prove the the task has been done by user (not used yet)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agronomyBookingsUpdateTask: async (authorization: string, taskId: string, status: AgronomyBookingsTasksStatusEnum, photo?: File, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('agronomyBookingsUpdateTask', 'authorization', authorization)
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('agronomyBookingsUpdateTask', 'taskId', taskId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('agronomyBookingsUpdateTask', 'status', status)
            const localVarPath = `/api/v1/agronomy/bookings/tasks/{taskId}`
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


            if (status !== undefined) { 
                localVarFormParams.append('status', new Blob([JSON.stringify(status)], { type: "application/json", }));
            }
    
            if (photo !== undefined) { 
                localVarFormParams.append('photo', photo as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Called by mobile app to get list of agronomist (\"Dokter Sawit\") profiles
         * @summary get list of agronomist profiles
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {AgronomyProductTypeEnum} scope required, type of agronomy product to filter response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agronomyGetAgronomists: async (aPPTYPE: AppTypeEnum, scope: AgronomyProductTypeEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('agronomyGetAgronomists', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'scope' is not null or undefined
            assertParamExists('agronomyGetAgronomists', 'scope', scope)
            const localVarPath = `/api/v1/agronomy/agronomists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Called by mobile app to get booking details by {bookingId}, which also contains booking summary and task count
         * @summary fetch agronomy booking details
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} bookingId Booking UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agronomyGetBookingDetail: async (aPPTYPE: AppTypeEnum, bookingId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('agronomyGetBookingDetail', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('agronomyGetBookingDetail', 'bookingId', bookingId)
            const localVarPath = `/api/v1/agronomy/bookings/{bookingId}`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets webinar survey questions by id of webinar
         * @summary Get Webinar Survey Questions
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} webinarId Id of webinar representated in UUID V4
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agronomyGetWebinarSurveyQuestions: async (aPPTYPE: AppTypeEnum, webinarId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('agronomyGetWebinarSurveyQuestions', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'webinarId' is not null or undefined
            assertParamExists('agronomyGetWebinarSurveyQuestions', 'webinarId', webinarId)
            const localVarPath = `/api/v1/agronomy/webinars/{webinarId}/survey/questions`
                .replace(`{${"webinarId"}}`, encodeURIComponent(String(webinarId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Called by mobile app to get list of active webinar (\"Dokter Sawit Webinar\") events
         * @summary Get List of Active Webinars
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {number} [limit] Number of items per page.
         * @param {number} [page] Current page number to be accessed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agronomyGetWebinars: async (aPPTYPE: AppTypeEnum, limit?: number, page?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('agronomyGetWebinars', 'aPPTYPE', aPPTYPE)
            const localVarPath = `/api/v1/agronomy/webinars`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Posts webinar survey answers 
         * @summary Post Webinar Survey Answers
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} webinarId Id of webinar representated in UUID V4
         * @param {AgronomyPostWebinarSurveyAnswersRequest} agronomyPostWebinarSurveyAnswersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agronomyPostWebinarSurveyAnswers: async (aPPTYPE: AppTypeEnum, webinarId: string, agronomyPostWebinarSurveyAnswersRequest: AgronomyPostWebinarSurveyAnswersRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('agronomyPostWebinarSurveyAnswers', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'webinarId' is not null or undefined
            assertParamExists('agronomyPostWebinarSurveyAnswers', 'webinarId', webinarId)
            // verify required parameter 'agronomyPostWebinarSurveyAnswersRequest' is not null or undefined
            assertParamExists('agronomyPostWebinarSurveyAnswers', 'agronomyPostWebinarSurveyAnswersRequest', agronomyPostWebinarSurveyAnswersRequest)
            const localVarPath = `/api/v1/agronomy/webinars/{webinarId}/survey`
                .replace(`{${"webinarId"}}`, encodeURIComponent(String(webinarId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agronomyPostWebinarSurveyAnswersRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API to register a user to a webinar. They have to fill participant name because it will be put on the certificate. 
         * @summary Register Webinar
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {AgronomyRegisterWebinarRequest} agronomyRegisterWebinarRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agronomyRegisterWebinar: async (aPPTYPE: AppTypeEnum, agronomyRegisterWebinarRequest: AgronomyRegisterWebinarRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('agronomyRegisterWebinar', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'agronomyRegisterWebinarRequest' is not null or undefined
            assertParamExists('agronomyRegisterWebinar', 'agronomyRegisterWebinarRequest', agronomyRegisterWebinarRequest)
            const localVarPath = `/api/v1/agronomy/webinars/participant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agronomyRegisterWebinarRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Called by mobile app to update booking data by {bookingId}, currently only used for user to add images to booking data
         * @summary update agronomy booking data
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} bookingId Booking UUID
         * @param {AgronomyUpdateBookingRequest} agronomyUpdateBookingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agronomyUpdateBooking: async (aPPTYPE: AppTypeEnum, bookingId: string, agronomyUpdateBookingRequest: AgronomyUpdateBookingRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('agronomyUpdateBooking', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('agronomyUpdateBooking', 'bookingId', bookingId)
            // verify required parameter 'agronomyUpdateBookingRequest' is not null or undefined
            assertParamExists('agronomyUpdateBooking', 'agronomyUpdateBookingRequest', agronomyUpdateBookingRequest)
            const localVarPath = `/api/v1/agronomy/bookings/{bookingId}`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agronomyUpdateBookingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API to list user\'s webinar certificates ordered by startAtUtc0 desc. 
         * @summary Get User Webinar Certificates
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {number} [limit] Number of items per page.
         * @param {number} [page] Current page number to be accessed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agronomyWebinarGetCertificates: async (aPPTYPE: AppTypeEnum, limit?: number, page?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('agronomyWebinarGetCertificates', 'aPPTYPE', aPPTYPE)
            const localVarPath = `/api/v1/agronomy/webinars/certificates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API to list all available webinar written materials ordered by startAtUtc0 desc. 
         * @summary Get All Available Webinar Materials
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {number} [limit] Number of items per page.
         * @param {number} [page] Current page number to be accessed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agronomyWebinarGetMaterials: async (aPPTYPE: AppTypeEnum, limit?: number, page?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('agronomyWebinarGetMaterials', 'aPPTYPE', aPPTYPE)
            const localVarPath = `/api/v1/agronomy/webinars/materials`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * called by mobile app when user went into the webinar meeting link to flag user is_attended data to true
         * @summary User Attend Webinar
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} webinarId Id of webinar representated in UUID V4
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agronomyWebinarsParticipantsAttend: async (aPPTYPE: AppTypeEnum, webinarId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('agronomyWebinarsParticipantsAttend', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'webinarId' is not null or undefined
            assertParamExists('agronomyWebinarsParticipantsAttend', 'webinarId', webinarId)
            const localVarPath = `/api/v1/agronomy/webinars/{webinarId}/participants/attend`
                .replace(`{${"webinarId"}}`, encodeURIComponent(String(webinarId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Called by mobile app when creating Agronomy Booking
         * @summary Create Agronomy Booking
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {V2AgronomyCreateBookingRequest} v2AgronomyCreateBookingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AgronomyCreateBooking: async (aPPTYPE: AppTypeEnum, v2AgronomyCreateBookingRequest: V2AgronomyCreateBookingRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('v2AgronomyCreateBooking', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'v2AgronomyCreateBookingRequest' is not null or undefined
            assertParamExists('v2AgronomyCreateBooking', 'v2AgronomyCreateBookingRequest', v2AgronomyCreateBookingRequest)
            const localVarPath = `/api/v2/agronomy/bookings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(v2AgronomyCreateBookingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgronomyApi - functional programming interface
 * @export
 */
export const AgronomyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AgronomyApiAxiosParamCreator(configuration)
    return {
        /**
         * Called by mobile app when booking a agronomist service.
         * @summary Create agronomist booking
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {AgronomistBookingRequest} agronomistBookingRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async agronomistBookingCreate(authorization: string, agronomistBookingRequest: AgronomistBookingRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgronomistBookingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agronomistBookingCreate(authorization, agronomistBookingRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Called by mobile app to get list of agronomy consultation booking based by user id.
         * @summary Get List Of Agronomy Booking By User Id
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} [userId] used by DUTA app, id of the user that this request is for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agronomistBookingListById(aPPTYPE: AppTypeEnum, userId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgronomyBookingListByIdResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agronomistBookingListById(aPPTYPE, userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Called by mobile app to get booking summary by bookingId
         * @summary fetch agronomist booking summary
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} bookingId Booking UUID
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async agronomistBookingSummaryDetail(aPPTYPE: AppTypeEnum, bookingId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgronomistBookingSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agronomistBookingSummaryDetail(aPPTYPE, bookingId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Called by mobile app to update agronomist booking status
         * @summary Update agronomist booking status
         * @param {string} bookingId Booking UUID
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {AgronomistUpdateBookingStatusRequest} agronomistUpdateBookingStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agronomistBookingUpdateStatus(bookingId: string, authorization: string, agronomistUpdateBookingStatusRequest: AgronomistUpdateBookingStatusRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgronomistUpdateBookingStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agronomistBookingUpdateStatus(bookingId, authorization, agronomistUpdateBookingStatusRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Called by mobile app to get list of available timeslot for agronomist consultation.
         * @summary Get Timeslot for Agronomist Consultation
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} [startDate] Start date for filtering agronomist timeslot availability date
         * @param {string} [endDate] End date for filtering agronomist timeslot availability date
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async agronomistTimeSlotAvailabilityList(authorization: string, startDate?: string, endDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DateItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agronomistTimeSlotAvailabilityList(authorization, startDate, endDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Called by mobile app when creating Agronomy Booking
         * @summary Create Agronomy Booking
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {AgronomyBookingCreateRequest} agronomyBookingCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agronomyBookingCreate(authorization: string, agronomyBookingCreateRequest: AgronomyBookingCreateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgronomyBookingCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agronomyBookingCreate(authorization, agronomyBookingCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Called by mobile app to Get all agronomy booking schedules, currently will return all available schedules
         * @summary Get all agronomy booking schedules
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {AgronomyProductTypeEnum} productType filter request by the agronomy product type
         * @param {number} [range] filter request by the specified number of days ahead in numeric format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agronomyBookingsGetSchedules(aPPTYPE: AppTypeEnum, productType: AgronomyProductTypeEnum, range?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgronomyBookingsGetSchedulesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agronomyBookingsGetSchedules(aPPTYPE, productType, range, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Called by mobile app to get agronomy booking task detail by {taskId}
         * @summary fetch agronomy booking task detail
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} taskId Agronomy Task UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agronomyBookingsGetTaskDetail(authorization: string, taskId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgronomyBookingsGetTaskDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agronomyBookingsGetTaskDetail(authorization, taskId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Called by mobile app to get agronomy booking list of tasks by {bookingId}
         * @summary fetch agronomy booking task list
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} bookingId Booking UUID
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agronomyBookingsGetTasks(authorization: string, bookingId: string, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgronomyBookingsGetTasksResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agronomyBookingsGetTasks(authorization, bookingId, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Called by mobile app to change agronomy booking task status to DONE
         * @summary update agronomy booking task status
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} taskId Agronomy Task UUID
         * @param {AgronomyBookingsTasksStatusEnum} status 
         * @param {File} [photo] Photo to prove the the task has been done by user (not used yet)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agronomyBookingsUpdateTask(authorization: string, taskId: string, status: AgronomyBookingsTasksStatusEnum, photo?: File, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgronomyBookingsUpdateTaskResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agronomyBookingsUpdateTask(authorization, taskId, status, photo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Called by mobile app to get list of agronomist (\"Dokter Sawit\") profiles
         * @summary get list of agronomist profiles
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {AgronomyProductTypeEnum} scope required, type of agronomy product to filter response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agronomyGetAgronomists(aPPTYPE: AppTypeEnum, scope: AgronomyProductTypeEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgronomyGetAgronomistsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agronomyGetAgronomists(aPPTYPE, scope, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Called by mobile app to get booking details by {bookingId}, which also contains booking summary and task count
         * @summary fetch agronomy booking details
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} bookingId Booking UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agronomyGetBookingDetail(aPPTYPE: AppTypeEnum, bookingId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgronomyGetBookingDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agronomyGetBookingDetail(aPPTYPE, bookingId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Gets webinar survey questions by id of webinar
         * @summary Get Webinar Survey Questions
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} webinarId Id of webinar representated in UUID V4
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agronomyGetWebinarSurveyQuestions(aPPTYPE: AppTypeEnum, webinarId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgronomyGetWebinarSurveyQuestionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agronomyGetWebinarSurveyQuestions(aPPTYPE, webinarId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Called by mobile app to get list of active webinar (\"Dokter Sawit Webinar\") events
         * @summary Get List of Active Webinars
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {number} [limit] Number of items per page.
         * @param {number} [page] Current page number to be accessed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agronomyGetWebinars(aPPTYPE: AppTypeEnum, limit?: number, page?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgronomyGetWebinarsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agronomyGetWebinars(aPPTYPE, limit, page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Posts webinar survey answers 
         * @summary Post Webinar Survey Answers
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} webinarId Id of webinar representated in UUID V4
         * @param {AgronomyPostWebinarSurveyAnswersRequest} agronomyPostWebinarSurveyAnswersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agronomyPostWebinarSurveyAnswers(aPPTYPE: AppTypeEnum, webinarId: string, agronomyPostWebinarSurveyAnswersRequest: AgronomyPostWebinarSurveyAnswersRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgronomyPostWebinarSurveyAnswersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agronomyPostWebinarSurveyAnswers(aPPTYPE, webinarId, agronomyPostWebinarSurveyAnswersRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API to register a user to a webinar. They have to fill participant name because it will be put on the certificate. 
         * @summary Register Webinar
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {AgronomyRegisterWebinarRequest} agronomyRegisterWebinarRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agronomyRegisterWebinar(aPPTYPE: AppTypeEnum, agronomyRegisterWebinarRequest: AgronomyRegisterWebinarRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgronomyRegisterWebinarResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agronomyRegisterWebinar(aPPTYPE, agronomyRegisterWebinarRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Called by mobile app to update booking data by {bookingId}, currently only used for user to add images to booking data
         * @summary update agronomy booking data
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} bookingId Booking UUID
         * @param {AgronomyUpdateBookingRequest} agronomyUpdateBookingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agronomyUpdateBooking(aPPTYPE: AppTypeEnum, bookingId: string, agronomyUpdateBookingRequest: AgronomyUpdateBookingRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgronomyUpdateBookingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agronomyUpdateBooking(aPPTYPE, bookingId, agronomyUpdateBookingRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API to list user\'s webinar certificates ordered by startAtUtc0 desc. 
         * @summary Get User Webinar Certificates
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {number} [limit] Number of items per page.
         * @param {number} [page] Current page number to be accessed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agronomyWebinarGetCertificates(aPPTYPE: AppTypeEnum, limit?: number, page?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgronomyWebinarGetCertificatesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agronomyWebinarGetCertificates(aPPTYPE, limit, page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API to list all available webinar written materials ordered by startAtUtc0 desc. 
         * @summary Get All Available Webinar Materials
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {number} [limit] Number of items per page.
         * @param {number} [page] Current page number to be accessed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agronomyWebinarGetMaterials(aPPTYPE: AppTypeEnum, limit?: number, page?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgronomyWebinarGetMaterialsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agronomyWebinarGetMaterials(aPPTYPE, limit, page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * called by mobile app when user went into the webinar meeting link to flag user is_attended data to true
         * @summary User Attend Webinar
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} webinarId Id of webinar representated in UUID V4
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agronomyWebinarsParticipantsAttend(aPPTYPE: AppTypeEnum, webinarId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgronomyWebinarsParticipantsAttendResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agronomyWebinarsParticipantsAttend(aPPTYPE, webinarId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Called by mobile app when creating Agronomy Booking
         * @summary Create Agronomy Booking
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {V2AgronomyCreateBookingRequest} v2AgronomyCreateBookingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AgronomyCreateBooking(aPPTYPE: AppTypeEnum, v2AgronomyCreateBookingRequest: V2AgronomyCreateBookingRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V2AgronomyCreateBookingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AgronomyCreateBooking(aPPTYPE, v2AgronomyCreateBookingRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AgronomyApi - factory interface
 * @export
 */
export const AgronomyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AgronomyApiFp(configuration)
    return {
        /**
         * Called by mobile app when booking a agronomist service.
         * @summary Create agronomist booking
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {AgronomistBookingRequest} agronomistBookingRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        agronomistBookingCreate(authorization: string, agronomistBookingRequest: AgronomistBookingRequest, options?: any): AxiosPromise<AgronomistBookingResponse> {
            return localVarFp.agronomistBookingCreate(authorization, agronomistBookingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Called by mobile app to get list of agronomy consultation booking based by user id.
         * @summary Get List Of Agronomy Booking By User Id
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} [userId] used by DUTA app, id of the user that this request is for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agronomistBookingListById(aPPTYPE: AppTypeEnum, userId?: string, options?: any): AxiosPromise<AgronomyBookingListByIdResponse> {
            return localVarFp.agronomistBookingListById(aPPTYPE, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Called by mobile app to get booking summary by bookingId
         * @summary fetch agronomist booking summary
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} bookingId Booking UUID
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        agronomistBookingSummaryDetail(aPPTYPE: AppTypeEnum, bookingId: string, options?: any): AxiosPromise<AgronomistBookingSummaryResponse> {
            return localVarFp.agronomistBookingSummaryDetail(aPPTYPE, bookingId, options).then((request) => request(axios, basePath));
        },
        /**
         * Called by mobile app to update agronomist booking status
         * @summary Update agronomist booking status
         * @param {string} bookingId Booking UUID
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {AgronomistUpdateBookingStatusRequest} agronomistUpdateBookingStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agronomistBookingUpdateStatus(bookingId: string, authorization: string, agronomistUpdateBookingStatusRequest: AgronomistUpdateBookingStatusRequest, options?: any): AxiosPromise<AgronomistUpdateBookingStatusResponse> {
            return localVarFp.agronomistBookingUpdateStatus(bookingId, authorization, agronomistUpdateBookingStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Called by mobile app to get list of available timeslot for agronomist consultation.
         * @summary Get Timeslot for Agronomist Consultation
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} [startDate] Start date for filtering agronomist timeslot availability date
         * @param {string} [endDate] End date for filtering agronomist timeslot availability date
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        agronomistTimeSlotAvailabilityList(authorization: string, startDate?: string, endDate?: string, options?: any): AxiosPromise<Array<DateItem>> {
            return localVarFp.agronomistTimeSlotAvailabilityList(authorization, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * Called by mobile app when creating Agronomy Booking
         * @summary Create Agronomy Booking
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {AgronomyBookingCreateRequest} agronomyBookingCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agronomyBookingCreate(authorization: string, agronomyBookingCreateRequest: AgronomyBookingCreateRequest, options?: any): AxiosPromise<AgronomyBookingCreateResponse> {
            return localVarFp.agronomyBookingCreate(authorization, agronomyBookingCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Called by mobile app to Get all agronomy booking schedules, currently will return all available schedules
         * @summary Get all agronomy booking schedules
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {AgronomyProductTypeEnum} productType filter request by the agronomy product type
         * @param {number} [range] filter request by the specified number of days ahead in numeric format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agronomyBookingsGetSchedules(aPPTYPE: AppTypeEnum, productType: AgronomyProductTypeEnum, range?: number, options?: any): AxiosPromise<AgronomyBookingsGetSchedulesResponse> {
            return localVarFp.agronomyBookingsGetSchedules(aPPTYPE, productType, range, options).then((request) => request(axios, basePath));
        },
        /**
         * Called by mobile app to get agronomy booking task detail by {taskId}
         * @summary fetch agronomy booking task detail
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} taskId Agronomy Task UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agronomyBookingsGetTaskDetail(authorization: string, taskId: string, options?: any): AxiosPromise<AgronomyBookingsGetTaskDetailResponse> {
            return localVarFp.agronomyBookingsGetTaskDetail(authorization, taskId, options).then((request) => request(axios, basePath));
        },
        /**
         * Called by mobile app to get agronomy booking list of tasks by {bookingId}
         * @summary fetch agronomy booking task list
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} bookingId Booking UUID
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agronomyBookingsGetTasks(authorization: string, bookingId: string, page?: number, limit?: number, options?: any): AxiosPromise<AgronomyBookingsGetTasksResponse> {
            return localVarFp.agronomyBookingsGetTasks(authorization, bookingId, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Called by mobile app to change agronomy booking task status to DONE
         * @summary update agronomy booking task status
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} taskId Agronomy Task UUID
         * @param {AgronomyBookingsTasksStatusEnum} status 
         * @param {File} [photo] Photo to prove the the task has been done by user (not used yet)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agronomyBookingsUpdateTask(authorization: string, taskId: string, status: AgronomyBookingsTasksStatusEnum, photo?: File, options?: any): AxiosPromise<AgronomyBookingsUpdateTaskResponse> {
            return localVarFp.agronomyBookingsUpdateTask(authorization, taskId, status, photo, options).then((request) => request(axios, basePath));
        },
        /**
         * Called by mobile app to get list of agronomist (\"Dokter Sawit\") profiles
         * @summary get list of agronomist profiles
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {AgronomyProductTypeEnum} scope required, type of agronomy product to filter response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agronomyGetAgronomists(aPPTYPE: AppTypeEnum, scope: AgronomyProductTypeEnum, options?: any): AxiosPromise<AgronomyGetAgronomistsResponse> {
            return localVarFp.agronomyGetAgronomists(aPPTYPE, scope, options).then((request) => request(axios, basePath));
        },
        /**
         * Called by mobile app to get booking details by {bookingId}, which also contains booking summary and task count
         * @summary fetch agronomy booking details
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} bookingId Booking UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agronomyGetBookingDetail(aPPTYPE: AppTypeEnum, bookingId: string, options?: any): AxiosPromise<AgronomyGetBookingDetailResponse> {
            return localVarFp.agronomyGetBookingDetail(aPPTYPE, bookingId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets webinar survey questions by id of webinar
         * @summary Get Webinar Survey Questions
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} webinarId Id of webinar representated in UUID V4
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agronomyGetWebinarSurveyQuestions(aPPTYPE: AppTypeEnum, webinarId: string, options?: any): AxiosPromise<AgronomyGetWebinarSurveyQuestionsResponse> {
            return localVarFp.agronomyGetWebinarSurveyQuestions(aPPTYPE, webinarId, options).then((request) => request(axios, basePath));
        },
        /**
         * Called by mobile app to get list of active webinar (\"Dokter Sawit Webinar\") events
         * @summary Get List of Active Webinars
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {number} [limit] Number of items per page.
         * @param {number} [page] Current page number to be accessed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agronomyGetWebinars(aPPTYPE: AppTypeEnum, limit?: number, page?: number, options?: any): AxiosPromise<AgronomyGetWebinarsResponse> {
            return localVarFp.agronomyGetWebinars(aPPTYPE, limit, page, options).then((request) => request(axios, basePath));
        },
        /**
         * Posts webinar survey answers 
         * @summary Post Webinar Survey Answers
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} webinarId Id of webinar representated in UUID V4
         * @param {AgronomyPostWebinarSurveyAnswersRequest} agronomyPostWebinarSurveyAnswersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agronomyPostWebinarSurveyAnswers(aPPTYPE: AppTypeEnum, webinarId: string, agronomyPostWebinarSurveyAnswersRequest: AgronomyPostWebinarSurveyAnswersRequest, options?: any): AxiosPromise<AgronomyPostWebinarSurveyAnswersResponse> {
            return localVarFp.agronomyPostWebinarSurveyAnswers(aPPTYPE, webinarId, agronomyPostWebinarSurveyAnswersRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API to register a user to a webinar. They have to fill participant name because it will be put on the certificate. 
         * @summary Register Webinar
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {AgronomyRegisterWebinarRequest} agronomyRegisterWebinarRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agronomyRegisterWebinar(aPPTYPE: AppTypeEnum, agronomyRegisterWebinarRequest: AgronomyRegisterWebinarRequest, options?: any): AxiosPromise<AgronomyRegisterWebinarResponse> {
            return localVarFp.agronomyRegisterWebinar(aPPTYPE, agronomyRegisterWebinarRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Called by mobile app to update booking data by {bookingId}, currently only used for user to add images to booking data
         * @summary update agronomy booking data
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} bookingId Booking UUID
         * @param {AgronomyUpdateBookingRequest} agronomyUpdateBookingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agronomyUpdateBooking(aPPTYPE: AppTypeEnum, bookingId: string, agronomyUpdateBookingRequest: AgronomyUpdateBookingRequest, options?: any): AxiosPromise<AgronomyUpdateBookingResponse> {
            return localVarFp.agronomyUpdateBooking(aPPTYPE, bookingId, agronomyUpdateBookingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API to list user\'s webinar certificates ordered by startAtUtc0 desc. 
         * @summary Get User Webinar Certificates
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {number} [limit] Number of items per page.
         * @param {number} [page] Current page number to be accessed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agronomyWebinarGetCertificates(aPPTYPE: AppTypeEnum, limit?: number, page?: number, options?: any): AxiosPromise<AgronomyWebinarGetCertificatesResponse> {
            return localVarFp.agronomyWebinarGetCertificates(aPPTYPE, limit, page, options).then((request) => request(axios, basePath));
        },
        /**
         * API to list all available webinar written materials ordered by startAtUtc0 desc. 
         * @summary Get All Available Webinar Materials
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {number} [limit] Number of items per page.
         * @param {number} [page] Current page number to be accessed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agronomyWebinarGetMaterials(aPPTYPE: AppTypeEnum, limit?: number, page?: number, options?: any): AxiosPromise<AgronomyWebinarGetMaterialsResponse> {
            return localVarFp.agronomyWebinarGetMaterials(aPPTYPE, limit, page, options).then((request) => request(axios, basePath));
        },
        /**
         * called by mobile app when user went into the webinar meeting link to flag user is_attended data to true
         * @summary User Attend Webinar
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} webinarId Id of webinar representated in UUID V4
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agronomyWebinarsParticipantsAttend(aPPTYPE: AppTypeEnum, webinarId: string, options?: any): AxiosPromise<AgronomyWebinarsParticipantsAttendResponse> {
            return localVarFp.agronomyWebinarsParticipantsAttend(aPPTYPE, webinarId, options).then((request) => request(axios, basePath));
        },
        /**
         * Called by mobile app when creating Agronomy Booking
         * @summary Create Agronomy Booking
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {V2AgronomyCreateBookingRequest} v2AgronomyCreateBookingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AgronomyCreateBooking(aPPTYPE: AppTypeEnum, v2AgronomyCreateBookingRequest: V2AgronomyCreateBookingRequest, options?: any): AxiosPromise<V2AgronomyCreateBookingResponse> {
            return localVarFp.v2AgronomyCreateBooking(aPPTYPE, v2AgronomyCreateBookingRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AgronomyApi - object-oriented interface
 * @export
 * @class AgronomyApi
 * @extends {BaseAPI}
 */
export class AgronomyApi extends BaseAPI {
    /**
     * Called by mobile app when booking a agronomist service.
     * @summary Create agronomist booking
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {AgronomistBookingRequest} agronomistBookingRequest 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AgronomyApi
     */
    public agronomistBookingCreate(authorization: string, agronomistBookingRequest: AgronomistBookingRequest, options?: AxiosRequestConfig) {
        return AgronomyApiFp(this.configuration).agronomistBookingCreate(authorization, agronomistBookingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Called by mobile app to get list of agronomy consultation booking based by user id.
     * @summary Get List Of Agronomy Booking By User Id
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} [userId] used by DUTA app, id of the user that this request is for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgronomyApi
     */
    public agronomistBookingListById(aPPTYPE: AppTypeEnum, userId?: string, options?: AxiosRequestConfig) {
        return AgronomyApiFp(this.configuration).agronomistBookingListById(aPPTYPE, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Called by mobile app to get booking summary by bookingId
     * @summary fetch agronomist booking summary
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} bookingId Booking UUID
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AgronomyApi
     */
    public agronomistBookingSummaryDetail(aPPTYPE: AppTypeEnum, bookingId: string, options?: AxiosRequestConfig) {
        return AgronomyApiFp(this.configuration).agronomistBookingSummaryDetail(aPPTYPE, bookingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Called by mobile app to update agronomist booking status
     * @summary Update agronomist booking status
     * @param {string} bookingId Booking UUID
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {AgronomistUpdateBookingStatusRequest} agronomistUpdateBookingStatusRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgronomyApi
     */
    public agronomistBookingUpdateStatus(bookingId: string, authorization: string, agronomistUpdateBookingStatusRequest: AgronomistUpdateBookingStatusRequest, options?: AxiosRequestConfig) {
        return AgronomyApiFp(this.configuration).agronomistBookingUpdateStatus(bookingId, authorization, agronomistUpdateBookingStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Called by mobile app to get list of available timeslot for agronomist consultation.
     * @summary Get Timeslot for Agronomist Consultation
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {string} [startDate] Start date for filtering agronomist timeslot availability date
     * @param {string} [endDate] End date for filtering agronomist timeslot availability date
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AgronomyApi
     */
    public agronomistTimeSlotAvailabilityList(authorization: string, startDate?: string, endDate?: string, options?: AxiosRequestConfig) {
        return AgronomyApiFp(this.configuration).agronomistTimeSlotAvailabilityList(authorization, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Called by mobile app when creating Agronomy Booking
     * @summary Create Agronomy Booking
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {AgronomyBookingCreateRequest} agronomyBookingCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgronomyApi
     */
    public agronomyBookingCreate(authorization: string, agronomyBookingCreateRequest: AgronomyBookingCreateRequest, options?: AxiosRequestConfig) {
        return AgronomyApiFp(this.configuration).agronomyBookingCreate(authorization, agronomyBookingCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Called by mobile app to Get all agronomy booking schedules, currently will return all available schedules
     * @summary Get all agronomy booking schedules
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {AgronomyProductTypeEnum} productType filter request by the agronomy product type
     * @param {number} [range] filter request by the specified number of days ahead in numeric format
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgronomyApi
     */
    public agronomyBookingsGetSchedules(aPPTYPE: AppTypeEnum, productType: AgronomyProductTypeEnum, range?: number, options?: AxiosRequestConfig) {
        return AgronomyApiFp(this.configuration).agronomyBookingsGetSchedules(aPPTYPE, productType, range, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Called by mobile app to get agronomy booking task detail by {taskId}
     * @summary fetch agronomy booking task detail
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {string} taskId Agronomy Task UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgronomyApi
     */
    public agronomyBookingsGetTaskDetail(authorization: string, taskId: string, options?: AxiosRequestConfig) {
        return AgronomyApiFp(this.configuration).agronomyBookingsGetTaskDetail(authorization, taskId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Called by mobile app to get agronomy booking list of tasks by {bookingId}
     * @summary fetch agronomy booking task list
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {string} bookingId Booking UUID
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgronomyApi
     */
    public agronomyBookingsGetTasks(authorization: string, bookingId: string, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return AgronomyApiFp(this.configuration).agronomyBookingsGetTasks(authorization, bookingId, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Called by mobile app to change agronomy booking task status to DONE
     * @summary update agronomy booking task status
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {string} taskId Agronomy Task UUID
     * @param {AgronomyBookingsTasksStatusEnum} status 
     * @param {File} [photo] Photo to prove the the task has been done by user (not used yet)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgronomyApi
     */
    public agronomyBookingsUpdateTask(authorization: string, taskId: string, status: AgronomyBookingsTasksStatusEnum, photo?: File, options?: AxiosRequestConfig) {
        return AgronomyApiFp(this.configuration).agronomyBookingsUpdateTask(authorization, taskId, status, photo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Called by mobile app to get list of agronomist (\"Dokter Sawit\") profiles
     * @summary get list of agronomist profiles
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {AgronomyProductTypeEnum} scope required, type of agronomy product to filter response
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgronomyApi
     */
    public agronomyGetAgronomists(aPPTYPE: AppTypeEnum, scope: AgronomyProductTypeEnum, options?: AxiosRequestConfig) {
        return AgronomyApiFp(this.configuration).agronomyGetAgronomists(aPPTYPE, scope, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Called by mobile app to get booking details by {bookingId}, which also contains booking summary and task count
     * @summary fetch agronomy booking details
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} bookingId Booking UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgronomyApi
     */
    public agronomyGetBookingDetail(aPPTYPE: AppTypeEnum, bookingId: string, options?: AxiosRequestConfig) {
        return AgronomyApiFp(this.configuration).agronomyGetBookingDetail(aPPTYPE, bookingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets webinar survey questions by id of webinar
     * @summary Get Webinar Survey Questions
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} webinarId Id of webinar representated in UUID V4
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgronomyApi
     */
    public agronomyGetWebinarSurveyQuestions(aPPTYPE: AppTypeEnum, webinarId: string, options?: AxiosRequestConfig) {
        return AgronomyApiFp(this.configuration).agronomyGetWebinarSurveyQuestions(aPPTYPE, webinarId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Called by mobile app to get list of active webinar (\"Dokter Sawit Webinar\") events
     * @summary Get List of Active Webinars
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {number} [limit] Number of items per page.
     * @param {number} [page] Current page number to be accessed.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgronomyApi
     */
    public agronomyGetWebinars(aPPTYPE: AppTypeEnum, limit?: number, page?: number, options?: AxiosRequestConfig) {
        return AgronomyApiFp(this.configuration).agronomyGetWebinars(aPPTYPE, limit, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Posts webinar survey answers 
     * @summary Post Webinar Survey Answers
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} webinarId Id of webinar representated in UUID V4
     * @param {AgronomyPostWebinarSurveyAnswersRequest} agronomyPostWebinarSurveyAnswersRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgronomyApi
     */
    public agronomyPostWebinarSurveyAnswers(aPPTYPE: AppTypeEnum, webinarId: string, agronomyPostWebinarSurveyAnswersRequest: AgronomyPostWebinarSurveyAnswersRequest, options?: AxiosRequestConfig) {
        return AgronomyApiFp(this.configuration).agronomyPostWebinarSurveyAnswers(aPPTYPE, webinarId, agronomyPostWebinarSurveyAnswersRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API to register a user to a webinar. They have to fill participant name because it will be put on the certificate. 
     * @summary Register Webinar
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {AgronomyRegisterWebinarRequest} agronomyRegisterWebinarRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgronomyApi
     */
    public agronomyRegisterWebinar(aPPTYPE: AppTypeEnum, agronomyRegisterWebinarRequest: AgronomyRegisterWebinarRequest, options?: AxiosRequestConfig) {
        return AgronomyApiFp(this.configuration).agronomyRegisterWebinar(aPPTYPE, agronomyRegisterWebinarRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Called by mobile app to update booking data by {bookingId}, currently only used for user to add images to booking data
     * @summary update agronomy booking data
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} bookingId Booking UUID
     * @param {AgronomyUpdateBookingRequest} agronomyUpdateBookingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgronomyApi
     */
    public agronomyUpdateBooking(aPPTYPE: AppTypeEnum, bookingId: string, agronomyUpdateBookingRequest: AgronomyUpdateBookingRequest, options?: AxiosRequestConfig) {
        return AgronomyApiFp(this.configuration).agronomyUpdateBooking(aPPTYPE, bookingId, agronomyUpdateBookingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API to list user\'s webinar certificates ordered by startAtUtc0 desc. 
     * @summary Get User Webinar Certificates
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {number} [limit] Number of items per page.
     * @param {number} [page] Current page number to be accessed.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgronomyApi
     */
    public agronomyWebinarGetCertificates(aPPTYPE: AppTypeEnum, limit?: number, page?: number, options?: AxiosRequestConfig) {
        return AgronomyApiFp(this.configuration).agronomyWebinarGetCertificates(aPPTYPE, limit, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API to list all available webinar written materials ordered by startAtUtc0 desc. 
     * @summary Get All Available Webinar Materials
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {number} [limit] Number of items per page.
     * @param {number} [page] Current page number to be accessed.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgronomyApi
     */
    public agronomyWebinarGetMaterials(aPPTYPE: AppTypeEnum, limit?: number, page?: number, options?: AxiosRequestConfig) {
        return AgronomyApiFp(this.configuration).agronomyWebinarGetMaterials(aPPTYPE, limit, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * called by mobile app when user went into the webinar meeting link to flag user is_attended data to true
     * @summary User Attend Webinar
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} webinarId Id of webinar representated in UUID V4
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgronomyApi
     */
    public agronomyWebinarsParticipantsAttend(aPPTYPE: AppTypeEnum, webinarId: string, options?: AxiosRequestConfig) {
        return AgronomyApiFp(this.configuration).agronomyWebinarsParticipantsAttend(aPPTYPE, webinarId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Called by mobile app when creating Agronomy Booking
     * @summary Create Agronomy Booking
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {V2AgronomyCreateBookingRequest} v2AgronomyCreateBookingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgronomyApi
     */
    public v2AgronomyCreateBooking(aPPTYPE: AppTypeEnum, v2AgronomyCreateBookingRequest: V2AgronomyCreateBookingRequest, options?: AxiosRequestConfig) {
        return AgronomyApiFp(this.configuration).v2AgronomyCreateBooking(aPPTYPE, v2AgronomyCreateBookingRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AppApi - axios parameter creator
 * @export
 */
export const AppApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Called by mobile app to retrive list of available app/feature shortcuts, response could be different in different APP-TYPE and login state
         * @summary Get list of app shortcuts.
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {number} [vERSIONCODE] Version code of the app that\&#39;s accessing the endpoint.
         * @param {string} [vERSIONNAME] The complete version of the app that\&#39;s accessing the endpoint.
         * @param {AppShortcutScopeQueryEnum} [scope] scope of app shortcut
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appGetShortcuts: async (aPPTYPE: AppTypeEnum, vERSIONCODE?: number, vERSIONNAME?: string, scope?: AppShortcutScopeQueryEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('appGetShortcuts', 'aPPTYPE', aPPTYPE)
            const localVarPath = `/api/v1/app/shortcuts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }

            if (vERSIONCODE != null) {
                localVarHeaderParameter['VERSION-CODE'] = typeof vERSIONCODE === 'string' 
                    ? vERSIONCODE 
                    : JSON.stringify(vERSIONCODE);
            }

            if (vERSIONNAME != null) {
                localVarHeaderParameter['VERSION-NAME'] = String(vERSIONNAME);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get latest time of application feature rating and review to determine if new rating and review is necessary at this time 
         * @summary Get Latest App Feature Rating and Review Time
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} reference feature name. language: English. format: snake_case 
         * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appRatingGetLatest: async (aPPTYPE: AppTypeEnum, reference: string, xFIREBASEINSTALLATIONID?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('appRatingGetLatest', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'reference' is not null or undefined
            assertParamExists('appRatingGetLatest', 'reference', reference)
            const localVarPath = `/api/v1/app/rating/latest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (reference !== undefined) {
                localVarQueryParameter['reference'] = reference;
            }

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }

            if (xFIREBASEINSTALLATIONID != null) {
                localVarHeaderParameter['X-FIREBASE-INSTALLATION-ID'] = String(xFIREBASEINSTALLATIONID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Submit rating and review for an application feature 
         * @summary Submit App Feature Rating and Review
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {AppRatingSubmitRequest} appRatingSubmitRequest 
         * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
         * @param {number} [vERSIONCODE] Version code of the app that\&#39;s accessing the endpoint.
         * @param {string} [vERSIONNAME] The complete version of the app that\&#39;s accessing the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appRatingSubmit: async (aPPTYPE: AppTypeEnum, appRatingSubmitRequest: AppRatingSubmitRequest, xFIREBASEINSTALLATIONID?: string, vERSIONCODE?: number, vERSIONNAME?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('appRatingSubmit', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'appRatingSubmitRequest' is not null or undefined
            assertParamExists('appRatingSubmit', 'appRatingSubmitRequest', appRatingSubmitRequest)
            const localVarPath = `/api/v1/app/rating`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }

            if (xFIREBASEINSTALLATIONID != null) {
                localVarHeaderParameter['X-FIREBASE-INSTALLATION-ID'] = String(xFIREBASEINSTALLATIONID);
            }

            if (vERSIONCODE != null) {
                localVarHeaderParameter['VERSION-CODE'] = typeof vERSIONCODE === 'string' 
                    ? vERSIONCODE 
                    : JSON.stringify(vERSIONCODE);
            }

            if (vERSIONNAME != null) {
                localVarHeaderParameter['VERSION-NAME'] = String(vERSIONNAME);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(appRatingSubmitRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AppApi - functional programming interface
 * @export
 */
export const AppApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AppApiAxiosParamCreator(configuration)
    return {
        /**
         * Called by mobile app to retrive list of available app/feature shortcuts, response could be different in different APP-TYPE and login state
         * @summary Get list of app shortcuts.
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {number} [vERSIONCODE] Version code of the app that\&#39;s accessing the endpoint.
         * @param {string} [vERSIONNAME] The complete version of the app that\&#39;s accessing the endpoint.
         * @param {AppShortcutScopeQueryEnum} [scope] scope of app shortcut
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appGetShortcuts(aPPTYPE: AppTypeEnum, vERSIONCODE?: number, vERSIONNAME?: string, scope?: AppShortcutScopeQueryEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppGetShortcutsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appGetShortcuts(aPPTYPE, vERSIONCODE, vERSIONNAME, scope, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get latest time of application feature rating and review to determine if new rating and review is necessary at this time 
         * @summary Get Latest App Feature Rating and Review Time
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} reference feature name. language: English. format: snake_case 
         * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appRatingGetLatest(aPPTYPE: AppTypeEnum, reference: string, xFIREBASEINSTALLATIONID?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppRatingGetLatestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appRatingGetLatest(aPPTYPE, reference, xFIREBASEINSTALLATIONID, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Submit rating and review for an application feature 
         * @summary Submit App Feature Rating and Review
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {AppRatingSubmitRequest} appRatingSubmitRequest 
         * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
         * @param {number} [vERSIONCODE] Version code of the app that\&#39;s accessing the endpoint.
         * @param {string} [vERSIONNAME] The complete version of the app that\&#39;s accessing the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appRatingSubmit(aPPTYPE: AppTypeEnum, appRatingSubmitRequest: AppRatingSubmitRequest, xFIREBASEINSTALLATIONID?: string, vERSIONCODE?: number, vERSIONNAME?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppRatingSubmitResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appRatingSubmit(aPPTYPE, appRatingSubmitRequest, xFIREBASEINSTALLATIONID, vERSIONCODE, vERSIONNAME, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AppApi - factory interface
 * @export
 */
export const AppApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AppApiFp(configuration)
    return {
        /**
         * Called by mobile app to retrive list of available app/feature shortcuts, response could be different in different APP-TYPE and login state
         * @summary Get list of app shortcuts.
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {number} [vERSIONCODE] Version code of the app that\&#39;s accessing the endpoint.
         * @param {string} [vERSIONNAME] The complete version of the app that\&#39;s accessing the endpoint.
         * @param {AppShortcutScopeQueryEnum} [scope] scope of app shortcut
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appGetShortcuts(aPPTYPE: AppTypeEnum, vERSIONCODE?: number, vERSIONNAME?: string, scope?: AppShortcutScopeQueryEnum, options?: any): AxiosPromise<AppGetShortcutsResponse> {
            return localVarFp.appGetShortcuts(aPPTYPE, vERSIONCODE, vERSIONNAME, scope, options).then((request) => request(axios, basePath));
        },
        /**
         * Get latest time of application feature rating and review to determine if new rating and review is necessary at this time 
         * @summary Get Latest App Feature Rating and Review Time
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} reference feature name. language: English. format: snake_case 
         * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appRatingGetLatest(aPPTYPE: AppTypeEnum, reference: string, xFIREBASEINSTALLATIONID?: string, options?: any): AxiosPromise<AppRatingGetLatestResponse> {
            return localVarFp.appRatingGetLatest(aPPTYPE, reference, xFIREBASEINSTALLATIONID, options).then((request) => request(axios, basePath));
        },
        /**
         * Submit rating and review for an application feature 
         * @summary Submit App Feature Rating and Review
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {AppRatingSubmitRequest} appRatingSubmitRequest 
         * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
         * @param {number} [vERSIONCODE] Version code of the app that\&#39;s accessing the endpoint.
         * @param {string} [vERSIONNAME] The complete version of the app that\&#39;s accessing the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appRatingSubmit(aPPTYPE: AppTypeEnum, appRatingSubmitRequest: AppRatingSubmitRequest, xFIREBASEINSTALLATIONID?: string, vERSIONCODE?: number, vERSIONNAME?: string, options?: any): AxiosPromise<AppRatingSubmitResponse> {
            return localVarFp.appRatingSubmit(aPPTYPE, appRatingSubmitRequest, xFIREBASEINSTALLATIONID, vERSIONCODE, vERSIONNAME, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AppApi - object-oriented interface
 * @export
 * @class AppApi
 * @extends {BaseAPI}
 */
export class AppApi extends BaseAPI {
    /**
     * Called by mobile app to retrive list of available app/feature shortcuts, response could be different in different APP-TYPE and login state
     * @summary Get list of app shortcuts.
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {number} [vERSIONCODE] Version code of the app that\&#39;s accessing the endpoint.
     * @param {string} [vERSIONNAME] The complete version of the app that\&#39;s accessing the endpoint.
     * @param {AppShortcutScopeQueryEnum} [scope] scope of app shortcut
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appGetShortcuts(aPPTYPE: AppTypeEnum, vERSIONCODE?: number, vERSIONNAME?: string, scope?: AppShortcutScopeQueryEnum, options?: AxiosRequestConfig) {
        return AppApiFp(this.configuration).appGetShortcuts(aPPTYPE, vERSIONCODE, vERSIONNAME, scope, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get latest time of application feature rating and review to determine if new rating and review is necessary at this time 
     * @summary Get Latest App Feature Rating and Review Time
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} reference feature name. language: English. format: snake_case 
     * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appRatingGetLatest(aPPTYPE: AppTypeEnum, reference: string, xFIREBASEINSTALLATIONID?: string, options?: AxiosRequestConfig) {
        return AppApiFp(this.configuration).appRatingGetLatest(aPPTYPE, reference, xFIREBASEINSTALLATIONID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Submit rating and review for an application feature 
     * @summary Submit App Feature Rating and Review
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {AppRatingSubmitRequest} appRatingSubmitRequest 
     * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
     * @param {number} [vERSIONCODE] Version code of the app that\&#39;s accessing the endpoint.
     * @param {string} [vERSIONNAME] The complete version of the app that\&#39;s accessing the endpoint.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appRatingSubmit(aPPTYPE: AppTypeEnum, appRatingSubmitRequest: AppRatingSubmitRequest, xFIREBASEINSTALLATIONID?: string, vERSIONCODE?: number, vERSIONNAME?: string, options?: AxiosRequestConfig) {
        return AppApiFp(this.configuration).appRatingSubmit(aPPTYPE, appRatingSubmitRequest, xFIREBASEINSTALLATIONID, vERSIONCODE, vERSIONNAME, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AssetsApi - axios parameter creator
 * @export
 */
export const AssetsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get Truck by Id
         * @summary Get Truck By Id
         * @param {string} truckId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetGetTruck: async (truckId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'truckId' is not null or undefined
            assertParamExists('assetGetTruck', 'truckId', truckId)
            const localVarPath = `/api/v1/assets/truck/{truckId}`
                .replace(`{${"truckId"}}`, encodeURIComponent(String(truckId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add asset of farm, will return jwt in header response
         * @summary Add Asset of Farm
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {AssetsAddFarmRequest} [assetsAddFarmRequest] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        assetsAddFarm: async (aPPTYPE: AppTypeEnum, assetsAddFarmRequest?: AssetsAddFarmRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('assetsAddFarm', 'aPPTYPE', aPPTYPE)
            const localVarPath = `/api/v1/assets/farm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assetsAddFarmRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add asset of farm, will return jwt in header response
         * @summary Add Asset of Farm
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {AssetsAddFarmV2Request} [assetsAddFarmV2Request] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        assetsAddFarmV2: async (aPPTYPE: AppTypeEnum, assetsAddFarmV2Request?: AssetsAddFarmV2Request, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('assetsAddFarmV2', 'aPPTYPE', aPPTYPE)
            const localVarPath = `/api/v2/assets/farm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assetsAddFarmV2Request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add asset of ramp, will return jwt in header response
         * @summary Add Asset of RAMP
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {AssetsAddRampRequest} [assetsAddRampRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsAddRamp: async (authorization: string, assetsAddRampRequest?: AssetsAddRampRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('assetsAddRamp', 'authorization', authorization)
            const localVarPath = `/api/v1/assets/ramp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assetsAddRampRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add asset of supplier, will return jwt in header response
         * @summary Add Asset of Supplier
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {AssetsAddSupplierRequest} [assetsAddSupplierRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsAddSupplier: async (authorization: string, assetsAddSupplierRequest?: AssetsAddSupplierRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('assetsAddSupplier', 'authorization', authorization)
            const localVarPath = `/api/v1/assets/supplier`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assetsAddSupplierRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add asset of truck, will return jwt in header response
         * @summary Add Asset of Truck
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {AssetAddTruckRequest} [assetAddTruckRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsAddTruck: async (authorization: string, assetAddTruckRequest?: AssetAddTruckRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('assetsAddTruck', 'authorization', authorization)
            const localVarPath = `/api/v1/assets/truck`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assetAddTruckRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add asset of truck, will return jwt in header response
         * @summary Add Asset of Truck V2
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {AssetAddTruckRequestV2} [assetAddTruckRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsAddTruckV2: async (authorization: string, assetAddTruckRequestV2?: AssetAddTruckRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('assetsAddTruckV2', 'authorization', authorization)
            const localVarPath = `/api/v2/assets/truck`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assetAddTruckRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create or Update Asset Farm based on the req body <br> when `id` has value and existed in DB `farm` table, will update farm data, otherwise will create new farm data
         * @summary Create or Update Asset Farm
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {AssetsCreateOrUpdateFarmRequest} [assetsCreateOrUpdateFarmRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsCreateOrUpdateFarm: async (aPPTYPE: AppTypeEnum, assetsCreateOrUpdateFarmRequest?: AssetsCreateOrUpdateFarmRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('assetsCreateOrUpdateFarm', 'aPPTYPE', aPPTYPE)
            const localVarPath = `/api/v1/assets/farm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assetsCreateOrUpdateFarmRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Soft delete user\'s asset truck from assets list by truckId 
         * @summary Remove Asset of Truck
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} truckId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsDeleteTruck: async (authorization: string, truckId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('assetsDeleteTruck', 'authorization', authorization)
            // verify required parameter 'truckId' is not null or undefined
            assertParamExists('assetsDeleteTruck', 'truckId', truckId)
            const localVarPath = `/api/v1/assets/truck`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (truckId !== undefined) {
                localVarQueryParameter['truckId'] = truckId;
            }

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch list of empty asset category
         * @summary Get Empty Asset Type
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsEmptyCategoryList: async (authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('assetsEmptyCategoryList', 'authorization', authorization)
            const localVarPath = `/api/v1/asset/empty-category`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Soft delete asset farm by ID
         * @summary Delete asset farm by ID
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} farmId farm UUID
         * @param {string} [userId] used by DUTA app, id of the user that this request is for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsFarmDelete: async (aPPTYPE: AppTypeEnum, farmId: string, userId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('assetsFarmDelete', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'farmId' is not null or undefined
            assertParamExists('assetsFarmDelete', 'farmId', farmId)
            const localVarPath = `/api/v1/assets/farm/{farmId}`
                .replace(`{${"farmId"}}`, encodeURIComponent(String(farmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch asset Farm detail
         * @summary Get asset Farm detail
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} farmId farm UUID
         * @param {string} [userId] used by DUTA app, id of the user that this request is for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsFarmDetail: async (aPPTYPE: AppTypeEnum, farmId: string, userId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('assetsFarmDetail', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'farmId' is not null or undefined
            assertParamExists('assetsFarmDetail', 'farmId', farmId)
            const localVarPath = `/api/v1/assets/farm/{farmId}`
                .replace(`{${"farmId"}}`, encodeURIComponent(String(farmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch asset Farms by User ID
         * @summary Get Farm Assets
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} [userId] used by DUTA app, id of the user that this request is for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsFarmList: async (aPPTYPE: AppTypeEnum, userId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('assetsFarmList', 'aPPTYPE', aPPTYPE)
            const localVarPath = `/api/v2/assets/farm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch detail of Ramp asset by User ID
         * @summary Get Ramp Asset Detail
         * @param {string} rampId Ramp ID in UUID type 4 format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsGetRamp: async (rampId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rampId' is not null or undefined
            assertParamExists('assetsGetRamp', 'rampId', rampId)
            const localVarPath = `/api/v1/assets/ramp/{rampId}`
                .replace(`{${"rampId"}}`, encodeURIComponent(String(rampId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch detail of Supplier asset by User ID
         * @summary Get Supplier Asset Detail
         * @param {string} supplierId Supplier ID in UUID type 4 format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsGetSupplier: async (supplierId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('assetsGetSupplier', 'supplierId', supplierId)
            const localVarPath = `/api/v1/assets/supplier/{supplierId}`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch asset Ramp by User ID
         * @summary Get Ramp Assets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsRampList: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/assets/ramp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch asset Supplier by User ID
         * @summary Get Supplier Assets
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {Array<MemberStatusEnum>} [status] Status of the supplier, will return all status if not present
         * @param {string} [contractName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsSupplierList: async (authorization: string, status?: Array<MemberStatusEnum>, contractName?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('assetsSupplierList', 'authorization', authorization)
            const localVarPath = `/api/v1/assets/supplier`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (status) {
                localVarQueryParameter['status'] = status;
            }

            if (contractName !== undefined) {
                localVarQueryParameter['contractName'] = contractName;
            }

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch list of truck category
         * @summary Get All of truck category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsTruckGetCategory: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/assets/truck/category`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch list assets of truck by user id (auth)
         * @summary Get All Asset of Truck
         * @param {AssetsTruckListScopeEnum} [scope] scope of assets truck list
         * @param {TruckStatusEnum} [status] status of truck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsTruckList: async (scope?: AssetsTruckListScopeEnum, status?: TruckStatusEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/assets/truck`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update detail of Ramp
         * @summary Update Ramp Asset
         * @param {string} rampId Ramp ID in UUID type 4 format
         * @param {AssetsUpdateRampRequest} [assetsUpdateRampRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsUpdateRamp: async (rampId: string, assetsUpdateRampRequest?: AssetsUpdateRampRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rampId' is not null or undefined
            assertParamExists('assetsUpdateRamp', 'rampId', rampId)
            const localVarPath = `/api/v1/assets/ramp/{rampId}`
                .replace(`{${"rampId"}}`, encodeURIComponent(String(rampId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assetsUpdateRampRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update detail of Supplier
         * @summary Update Supplier Asset
         * @param {string} supplierId Supplier ID in UUID type 4 format
         * @param {AssetsUpdateSupplierRequest} [assetsUpdateSupplierRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsUpdateSupplier: async (supplierId: string, assetsUpdateSupplierRequest?: AssetsUpdateSupplierRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('assetsUpdateSupplier', 'supplierId', supplierId)
            const localVarPath = `/api/v1/assets/supplier/{supplierId}`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assetsUpdateSupplierRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update asset of truck, will return jwt in header response
         * @summary Update Asset of Truck
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} truckId 
         * @param {AssetUpdateTruckRequest} [assetUpdateTruckRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsUpdateTruck: async (authorization: string, truckId: string, assetUpdateTruckRequest?: AssetUpdateTruckRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('assetsUpdateTruck', 'authorization', authorization)
            // verify required parameter 'truckId' is not null or undefined
            assertParamExists('assetsUpdateTruck', 'truckId', truckId)
            const localVarPath = `/api/v1/assets/truck`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (truckId !== undefined) {
                localVarQueryParameter['truckId'] = truckId;
            }

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assetUpdateTruckRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update asset of truck, will return jwt in header response
         * @summary Update Asset of Truck V2
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} truckId 
         * @param {AssetUpdateTruckRequestV2} [assetUpdateTruckRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsUpdateTruckV2: async (authorization: string, truckId: string, assetUpdateTruckRequestV2?: AssetUpdateTruckRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('assetsUpdateTruckV2', 'authorization', authorization)
            // verify required parameter 'truckId' is not null or undefined
            assertParamExists('assetsUpdateTruckV2', 'truckId', truckId)
            const localVarPath = `/api/v2/assets/truck`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (truckId !== undefined) {
                localVarQueryParameter['truckId'] = truckId;
            }

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assetUpdateTruckRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add asset of ramp, will return jwt in header response
         * @summary Add Asset Ramp V2
         * @param {V2AssetsAddRampRequest} [v2AssetsAddRampRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AssetsAddRamp: async (v2AssetsAddRampRequest?: V2AssetsAddRampRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/assets/ramp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(v2AssetsAddRampRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add asset of supplier, will return jwt in header response
         * @summary Add Asset of Supplier V2
         * @param {V2AssetsAddSupplierRequest} [v2AssetsAddSupplierRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AssetsAddSupplier: async (v2AssetsAddSupplierRequest?: V2AssetsAddSupplierRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/assets/supplier`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(v2AssetsAddSupplierRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch asset Supplier via contact of the current user. The v1 is still using `asset` relation to the user, while this endpoint will use `contact` & `business` in order to fetch the suppliers
         * @summary Get Supplier Assets V2
         * @param {Array<MemberStatusEnum>} [status] Status of the supplier, will return all status if not present
         * @param {string} [contractName] 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AssetsSupplierList: async (status?: Array<MemberStatusEnum>, contractName?: string, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/assets/supplier`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (status) {
                localVarQueryParameter['status'] = status;
            }

            if (contractName !== undefined) {
                localVarQueryParameter['contractName'] = contractName;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create or Update multiple Asset Farm based on the req body <br> when `id` has value and existed in DB `farm` table, will update farm data, otherwise will create new farm data
         * @summary Create or Update Multiple Asset Farm
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {V3AssetsCreateOrUpdateFarmsRequest} [v3AssetsCreateOrUpdateFarmsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v3AssetsCreateOrUpdateFarms: async (aPPTYPE: AppTypeEnum, v3AssetsCreateOrUpdateFarmsRequest?: V3AssetsCreateOrUpdateFarmsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('v3AssetsCreateOrUpdateFarms', 'aPPTYPE', aPPTYPE)
            const localVarPath = `/api/v3/assets/farms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(v3AssetsCreateOrUpdateFarmsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AssetsApi - functional programming interface
 * @export
 */
export const AssetsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AssetsApiAxiosParamCreator(configuration)
    return {
        /**
         * Get Truck by Id
         * @summary Get Truck By Id
         * @param {string} truckId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetGetTruck(truckId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetGetTruckResponseItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetGetTruck(truckId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Add asset of farm, will return jwt in header response
         * @summary Add Asset of Farm
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {AssetsAddFarmRequest} [assetsAddFarmRequest] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async assetsAddFarm(aPPTYPE: AppTypeEnum, assetsAddFarmRequest?: AssetsAddFarmRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetsAddFarmResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetsAddFarm(aPPTYPE, assetsAddFarmRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Add asset of farm, will return jwt in header response
         * @summary Add Asset of Farm
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {AssetsAddFarmV2Request} [assetsAddFarmV2Request] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async assetsAddFarmV2(aPPTYPE: AppTypeEnum, assetsAddFarmV2Request?: AssetsAddFarmV2Request, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetsAddFarmV2Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetsAddFarmV2(aPPTYPE, assetsAddFarmV2Request, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Add asset of ramp, will return jwt in header response
         * @summary Add Asset of RAMP
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {AssetsAddRampRequest} [assetsAddRampRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetsAddRamp(authorization: string, assetsAddRampRequest?: AssetsAddRampRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetsAddRampResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetsAddRamp(authorization, assetsAddRampRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Add asset of supplier, will return jwt in header response
         * @summary Add Asset of Supplier
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {AssetsAddSupplierRequest} [assetsAddSupplierRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetsAddSupplier(authorization: string, assetsAddSupplierRequest?: AssetsAddSupplierRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetsAddSupplierResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetsAddSupplier(authorization, assetsAddSupplierRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Add asset of truck, will return jwt in header response
         * @summary Add Asset of Truck
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {AssetAddTruckRequest} [assetAddTruckRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetsAddTruck(authorization: string, assetAddTruckRequest?: AssetAddTruckRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetAddTruckResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetsAddTruck(authorization, assetAddTruckRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Add asset of truck, will return jwt in header response
         * @summary Add Asset of Truck V2
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {AssetAddTruckRequestV2} [assetAddTruckRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetsAddTruckV2(authorization: string, assetAddTruckRequestV2?: AssetAddTruckRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetAddTruckResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetsAddTruckV2(authorization, assetAddTruckRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create or Update Asset Farm based on the req body <br> when `id` has value and existed in DB `farm` table, will update farm data, otherwise will create new farm data
         * @summary Create or Update Asset Farm
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {AssetsCreateOrUpdateFarmRequest} [assetsCreateOrUpdateFarmRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetsCreateOrUpdateFarm(aPPTYPE: AppTypeEnum, assetsCreateOrUpdateFarmRequest?: AssetsCreateOrUpdateFarmRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetsCreateOrUpdateFarmResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetsCreateOrUpdateFarm(aPPTYPE, assetsCreateOrUpdateFarmRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Soft delete user\'s asset truck from assets list by truckId 
         * @summary Remove Asset of Truck
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} truckId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetsDeleteTruck(authorization: string, truckId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetDeleteTruckResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetsDeleteTruck(authorization, truckId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch list of empty asset category
         * @summary Get Empty Asset Type
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetsEmptyCategoryList(authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AssetCategoryEnum>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetsEmptyCategoryList(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Soft delete asset farm by ID
         * @summary Delete asset farm by ID
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} farmId farm UUID
         * @param {string} [userId] used by DUTA app, id of the user that this request is for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetsFarmDelete(aPPTYPE: AppTypeEnum, farmId: string, userId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetsFarmDeleteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetsFarmDelete(aPPTYPE, farmId, userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch asset Farm detail
         * @summary Get asset Farm detail
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} farmId farm UUID
         * @param {string} [userId] used by DUTA app, id of the user that this request is for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetsFarmDetail(aPPTYPE: AppTypeEnum, farmId: string, userId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetsFarmDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetsFarmDetail(aPPTYPE, farmId, userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch asset Farms by User ID
         * @summary Get Farm Assets
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} [userId] used by DUTA app, id of the user that this request is for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetsFarmList(aPPTYPE: AppTypeEnum, userId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetsFarmListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetsFarmList(aPPTYPE, userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch detail of Ramp asset by User ID
         * @summary Get Ramp Asset Detail
         * @param {string} rampId Ramp ID in UUID type 4 format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetsGetRamp(rampId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetsGetRampResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetsGetRamp(rampId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch detail of Supplier asset by User ID
         * @summary Get Supplier Asset Detail
         * @param {string} supplierId Supplier ID in UUID type 4 format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetsGetSupplier(supplierId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetsGetSupplierResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetsGetSupplier(supplierId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch asset Ramp by User ID
         * @summary Get Ramp Assets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetsRampList(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetsRampListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetsRampList(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch asset Supplier by User ID
         * @summary Get Supplier Assets
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {Array<MemberStatusEnum>} [status] Status of the supplier, will return all status if not present
         * @param {string} [contractName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetsSupplierList(authorization: string, status?: Array<MemberStatusEnum>, contractName?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetsSupplierListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetsSupplierList(authorization, status, contractName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch list of truck category
         * @summary Get All of truck category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetsTruckGetCategory(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetGetTruckCategoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetsTruckGetCategory(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch list assets of truck by user id (auth)
         * @summary Get All Asset of Truck
         * @param {AssetsTruckListScopeEnum} [scope] scope of assets truck list
         * @param {TruckStatusEnum} [status] status of truck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetsTruckList(scope?: AssetsTruckListScopeEnum, status?: TruckStatusEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetGetTruckResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetsTruckList(scope, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update detail of Ramp
         * @summary Update Ramp Asset
         * @param {string} rampId Ramp ID in UUID type 4 format
         * @param {AssetsUpdateRampRequest} [assetsUpdateRampRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetsUpdateRamp(rampId: string, assetsUpdateRampRequest?: AssetsUpdateRampRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetsUpdateRampResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetsUpdateRamp(rampId, assetsUpdateRampRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update detail of Supplier
         * @summary Update Supplier Asset
         * @param {string} supplierId Supplier ID in UUID type 4 format
         * @param {AssetsUpdateSupplierRequest} [assetsUpdateSupplierRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetsUpdateSupplier(supplierId: string, assetsUpdateSupplierRequest?: AssetsUpdateSupplierRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetsUpdateSupplierResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetsUpdateSupplier(supplierId, assetsUpdateSupplierRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update asset of truck, will return jwt in header response
         * @summary Update Asset of Truck
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} truckId 
         * @param {AssetUpdateTruckRequest} [assetUpdateTruckRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetsUpdateTruck(authorization: string, truckId: string, assetUpdateTruckRequest?: AssetUpdateTruckRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetUpdateTruckResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetsUpdateTruck(authorization, truckId, assetUpdateTruckRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update asset of truck, will return jwt in header response
         * @summary Update Asset of Truck V2
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} truckId 
         * @param {AssetUpdateTruckRequestV2} [assetUpdateTruckRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetsUpdateTruckV2(authorization: string, truckId: string, assetUpdateTruckRequestV2?: AssetUpdateTruckRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetUpdateTruckResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetsUpdateTruckV2(authorization, truckId, assetUpdateTruckRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Add asset of ramp, will return jwt in header response
         * @summary Add Asset Ramp V2
         * @param {V2AssetsAddRampRequest} [v2AssetsAddRampRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AssetsAddRamp(v2AssetsAddRampRequest?: V2AssetsAddRampRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V2AssetsAddRampResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AssetsAddRamp(v2AssetsAddRampRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Add asset of supplier, will return jwt in header response
         * @summary Add Asset of Supplier V2
         * @param {V2AssetsAddSupplierRequest} [v2AssetsAddSupplierRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AssetsAddSupplier(v2AssetsAddSupplierRequest?: V2AssetsAddSupplierRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V2AssetsAddSupplierResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AssetsAddSupplier(v2AssetsAddSupplierRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch asset Supplier via contact of the current user. The v1 is still using `asset` relation to the user, while this endpoint will use `contact` & `business` in order to fetch the suppliers
         * @summary Get Supplier Assets V2
         * @param {Array<MemberStatusEnum>} [status] Status of the supplier, will return all status if not present
         * @param {string} [contractName] 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AssetsSupplierList(status?: Array<MemberStatusEnum>, contractName?: string, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V2AssetsSupplierListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AssetsSupplierList(status, contractName, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create or Update multiple Asset Farm based on the req body <br> when `id` has value and existed in DB `farm` table, will update farm data, otherwise will create new farm data
         * @summary Create or Update Multiple Asset Farm
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {V3AssetsCreateOrUpdateFarmsRequest} [v3AssetsCreateOrUpdateFarmsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v3AssetsCreateOrUpdateFarms(aPPTYPE: AppTypeEnum, v3AssetsCreateOrUpdateFarmsRequest?: V3AssetsCreateOrUpdateFarmsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V3AssetsCreateOrUpdateFarmsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v3AssetsCreateOrUpdateFarms(aPPTYPE, v3AssetsCreateOrUpdateFarmsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AssetsApi - factory interface
 * @export
 */
export const AssetsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AssetsApiFp(configuration)
    return {
        /**
         * Get Truck by Id
         * @summary Get Truck By Id
         * @param {string} truckId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetGetTruck(truckId: string, options?: any): AxiosPromise<AssetGetTruckResponseItem> {
            return localVarFp.assetGetTruck(truckId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add asset of farm, will return jwt in header response
         * @summary Add Asset of Farm
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {AssetsAddFarmRequest} [assetsAddFarmRequest] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        assetsAddFarm(aPPTYPE: AppTypeEnum, assetsAddFarmRequest?: AssetsAddFarmRequest, options?: any): AxiosPromise<AssetsAddFarmResponse> {
            return localVarFp.assetsAddFarm(aPPTYPE, assetsAddFarmRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Add asset of farm, will return jwt in header response
         * @summary Add Asset of Farm
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {AssetsAddFarmV2Request} [assetsAddFarmV2Request] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        assetsAddFarmV2(aPPTYPE: AppTypeEnum, assetsAddFarmV2Request?: AssetsAddFarmV2Request, options?: any): AxiosPromise<AssetsAddFarmV2Response> {
            return localVarFp.assetsAddFarmV2(aPPTYPE, assetsAddFarmV2Request, options).then((request) => request(axios, basePath));
        },
        /**
         * Add asset of ramp, will return jwt in header response
         * @summary Add Asset of RAMP
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {AssetsAddRampRequest} [assetsAddRampRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsAddRamp(authorization: string, assetsAddRampRequest?: AssetsAddRampRequest, options?: any): AxiosPromise<AssetsAddRampResponse> {
            return localVarFp.assetsAddRamp(authorization, assetsAddRampRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Add asset of supplier, will return jwt in header response
         * @summary Add Asset of Supplier
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {AssetsAddSupplierRequest} [assetsAddSupplierRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsAddSupplier(authorization: string, assetsAddSupplierRequest?: AssetsAddSupplierRequest, options?: any): AxiosPromise<AssetsAddSupplierResponse> {
            return localVarFp.assetsAddSupplier(authorization, assetsAddSupplierRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Add asset of truck, will return jwt in header response
         * @summary Add Asset of Truck
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {AssetAddTruckRequest} [assetAddTruckRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsAddTruck(authorization: string, assetAddTruckRequest?: AssetAddTruckRequest, options?: any): AxiosPromise<AssetAddTruckResponse> {
            return localVarFp.assetsAddTruck(authorization, assetAddTruckRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Add asset of truck, will return jwt in header response
         * @summary Add Asset of Truck V2
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {AssetAddTruckRequestV2} [assetAddTruckRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsAddTruckV2(authorization: string, assetAddTruckRequestV2?: AssetAddTruckRequestV2, options?: any): AxiosPromise<AssetAddTruckResponse> {
            return localVarFp.assetsAddTruckV2(authorization, assetAddTruckRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * Create or Update Asset Farm based on the req body <br> when `id` has value and existed in DB `farm` table, will update farm data, otherwise will create new farm data
         * @summary Create or Update Asset Farm
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {AssetsCreateOrUpdateFarmRequest} [assetsCreateOrUpdateFarmRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsCreateOrUpdateFarm(aPPTYPE: AppTypeEnum, assetsCreateOrUpdateFarmRequest?: AssetsCreateOrUpdateFarmRequest, options?: any): AxiosPromise<AssetsCreateOrUpdateFarmResponse> {
            return localVarFp.assetsCreateOrUpdateFarm(aPPTYPE, assetsCreateOrUpdateFarmRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Soft delete user\'s asset truck from assets list by truckId 
         * @summary Remove Asset of Truck
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} truckId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsDeleteTruck(authorization: string, truckId: string, options?: any): AxiosPromise<AssetDeleteTruckResponse> {
            return localVarFp.assetsDeleteTruck(authorization, truckId, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch list of empty asset category
         * @summary Get Empty Asset Type
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsEmptyCategoryList(authorization: string, options?: any): AxiosPromise<Array<AssetCategoryEnum>> {
            return localVarFp.assetsEmptyCategoryList(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Soft delete asset farm by ID
         * @summary Delete asset farm by ID
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} farmId farm UUID
         * @param {string} [userId] used by DUTA app, id of the user that this request is for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsFarmDelete(aPPTYPE: AppTypeEnum, farmId: string, userId?: string, options?: any): AxiosPromise<AssetsFarmDeleteResponse> {
            return localVarFp.assetsFarmDelete(aPPTYPE, farmId, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch asset Farm detail
         * @summary Get asset Farm detail
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} farmId farm UUID
         * @param {string} [userId] used by DUTA app, id of the user that this request is for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsFarmDetail(aPPTYPE: AppTypeEnum, farmId: string, userId?: string, options?: any): AxiosPromise<AssetsFarmDetailResponse> {
            return localVarFp.assetsFarmDetail(aPPTYPE, farmId, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch asset Farms by User ID
         * @summary Get Farm Assets
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} [userId] used by DUTA app, id of the user that this request is for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsFarmList(aPPTYPE: AppTypeEnum, userId?: string, options?: any): AxiosPromise<AssetsFarmListResponse> {
            return localVarFp.assetsFarmList(aPPTYPE, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch detail of Ramp asset by User ID
         * @summary Get Ramp Asset Detail
         * @param {string} rampId Ramp ID in UUID type 4 format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsGetRamp(rampId: string, options?: any): AxiosPromise<AssetsGetRampResponse> {
            return localVarFp.assetsGetRamp(rampId, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch detail of Supplier asset by User ID
         * @summary Get Supplier Asset Detail
         * @param {string} supplierId Supplier ID in UUID type 4 format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsGetSupplier(supplierId: string, options?: any): AxiosPromise<AssetsGetSupplierResponse> {
            return localVarFp.assetsGetSupplier(supplierId, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch asset Ramp by User ID
         * @summary Get Ramp Assets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsRampList(options?: any): AxiosPromise<AssetsRampListResponse> {
            return localVarFp.assetsRampList(options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch asset Supplier by User ID
         * @summary Get Supplier Assets
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {Array<MemberStatusEnum>} [status] Status of the supplier, will return all status if not present
         * @param {string} [contractName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsSupplierList(authorization: string, status?: Array<MemberStatusEnum>, contractName?: string, options?: any): AxiosPromise<AssetsSupplierListResponse> {
            return localVarFp.assetsSupplierList(authorization, status, contractName, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch list of truck category
         * @summary Get All of truck category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsTruckGetCategory(options?: any): AxiosPromise<AssetGetTruckCategoryResponse> {
            return localVarFp.assetsTruckGetCategory(options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch list assets of truck by user id (auth)
         * @summary Get All Asset of Truck
         * @param {AssetsTruckListScopeEnum} [scope] scope of assets truck list
         * @param {TruckStatusEnum} [status] status of truck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsTruckList(scope?: AssetsTruckListScopeEnum, status?: TruckStatusEnum, options?: any): AxiosPromise<AssetGetTruckResponse> {
            return localVarFp.assetsTruckList(scope, status, options).then((request) => request(axios, basePath));
        },
        /**
         * Update detail of Ramp
         * @summary Update Ramp Asset
         * @param {string} rampId Ramp ID in UUID type 4 format
         * @param {AssetsUpdateRampRequest} [assetsUpdateRampRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsUpdateRamp(rampId: string, assetsUpdateRampRequest?: AssetsUpdateRampRequest, options?: any): AxiosPromise<AssetsUpdateRampResponse> {
            return localVarFp.assetsUpdateRamp(rampId, assetsUpdateRampRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update detail of Supplier
         * @summary Update Supplier Asset
         * @param {string} supplierId Supplier ID in UUID type 4 format
         * @param {AssetsUpdateSupplierRequest} [assetsUpdateSupplierRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsUpdateSupplier(supplierId: string, assetsUpdateSupplierRequest?: AssetsUpdateSupplierRequest, options?: any): AxiosPromise<AssetsUpdateSupplierResponse> {
            return localVarFp.assetsUpdateSupplier(supplierId, assetsUpdateSupplierRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update asset of truck, will return jwt in header response
         * @summary Update Asset of Truck
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} truckId 
         * @param {AssetUpdateTruckRequest} [assetUpdateTruckRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsUpdateTruck(authorization: string, truckId: string, assetUpdateTruckRequest?: AssetUpdateTruckRequest, options?: any): AxiosPromise<AssetUpdateTruckResponse> {
            return localVarFp.assetsUpdateTruck(authorization, truckId, assetUpdateTruckRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update asset of truck, will return jwt in header response
         * @summary Update Asset of Truck V2
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} truckId 
         * @param {AssetUpdateTruckRequestV2} [assetUpdateTruckRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsUpdateTruckV2(authorization: string, truckId: string, assetUpdateTruckRequestV2?: AssetUpdateTruckRequestV2, options?: any): AxiosPromise<AssetUpdateTruckResponse> {
            return localVarFp.assetsUpdateTruckV2(authorization, truckId, assetUpdateTruckRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * Add asset of ramp, will return jwt in header response
         * @summary Add Asset Ramp V2
         * @param {V2AssetsAddRampRequest} [v2AssetsAddRampRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AssetsAddRamp(v2AssetsAddRampRequest?: V2AssetsAddRampRequest, options?: any): AxiosPromise<V2AssetsAddRampResponse> {
            return localVarFp.v2AssetsAddRamp(v2AssetsAddRampRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Add asset of supplier, will return jwt in header response
         * @summary Add Asset of Supplier V2
         * @param {V2AssetsAddSupplierRequest} [v2AssetsAddSupplierRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AssetsAddSupplier(v2AssetsAddSupplierRequest?: V2AssetsAddSupplierRequest, options?: any): AxiosPromise<V2AssetsAddSupplierResponse> {
            return localVarFp.v2AssetsAddSupplier(v2AssetsAddSupplierRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch asset Supplier via contact of the current user. The v1 is still using `asset` relation to the user, while this endpoint will use `contact` & `business` in order to fetch the suppliers
         * @summary Get Supplier Assets V2
         * @param {Array<MemberStatusEnum>} [status] Status of the supplier, will return all status if not present
         * @param {string} [contractName] 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AssetsSupplierList(status?: Array<MemberStatusEnum>, contractName?: string, page?: number, limit?: number, options?: any): AxiosPromise<V2AssetsSupplierListResponse> {
            return localVarFp.v2AssetsSupplierList(status, contractName, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Create or Update multiple Asset Farm based on the req body <br> when `id` has value and existed in DB `farm` table, will update farm data, otherwise will create new farm data
         * @summary Create or Update Multiple Asset Farm
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {V3AssetsCreateOrUpdateFarmsRequest} [v3AssetsCreateOrUpdateFarmsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v3AssetsCreateOrUpdateFarms(aPPTYPE: AppTypeEnum, v3AssetsCreateOrUpdateFarmsRequest?: V3AssetsCreateOrUpdateFarmsRequest, options?: any): AxiosPromise<V3AssetsCreateOrUpdateFarmsResponse> {
            return localVarFp.v3AssetsCreateOrUpdateFarms(aPPTYPE, v3AssetsCreateOrUpdateFarmsRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AssetsApi - object-oriented interface
 * @export
 * @class AssetsApi
 * @extends {BaseAPI}
 */
export class AssetsApi extends BaseAPI {
    /**
     * Get Truck by Id
     * @summary Get Truck By Id
     * @param {string} truckId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public assetGetTruck(truckId: string, options?: AxiosRequestConfig) {
        return AssetsApiFp(this.configuration).assetGetTruck(truckId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add asset of farm, will return jwt in header response
     * @summary Add Asset of Farm
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {AssetsAddFarmRequest} [assetsAddFarmRequest] 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public assetsAddFarm(aPPTYPE: AppTypeEnum, assetsAddFarmRequest?: AssetsAddFarmRequest, options?: AxiosRequestConfig) {
        return AssetsApiFp(this.configuration).assetsAddFarm(aPPTYPE, assetsAddFarmRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add asset of farm, will return jwt in header response
     * @summary Add Asset of Farm
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {AssetsAddFarmV2Request} [assetsAddFarmV2Request] 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public assetsAddFarmV2(aPPTYPE: AppTypeEnum, assetsAddFarmV2Request?: AssetsAddFarmV2Request, options?: AxiosRequestConfig) {
        return AssetsApiFp(this.configuration).assetsAddFarmV2(aPPTYPE, assetsAddFarmV2Request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add asset of ramp, will return jwt in header response
     * @summary Add Asset of RAMP
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {AssetsAddRampRequest} [assetsAddRampRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public assetsAddRamp(authorization: string, assetsAddRampRequest?: AssetsAddRampRequest, options?: AxiosRequestConfig) {
        return AssetsApiFp(this.configuration).assetsAddRamp(authorization, assetsAddRampRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add asset of supplier, will return jwt in header response
     * @summary Add Asset of Supplier
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {AssetsAddSupplierRequest} [assetsAddSupplierRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public assetsAddSupplier(authorization: string, assetsAddSupplierRequest?: AssetsAddSupplierRequest, options?: AxiosRequestConfig) {
        return AssetsApiFp(this.configuration).assetsAddSupplier(authorization, assetsAddSupplierRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add asset of truck, will return jwt in header response
     * @summary Add Asset of Truck
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {AssetAddTruckRequest} [assetAddTruckRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public assetsAddTruck(authorization: string, assetAddTruckRequest?: AssetAddTruckRequest, options?: AxiosRequestConfig) {
        return AssetsApiFp(this.configuration).assetsAddTruck(authorization, assetAddTruckRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add asset of truck, will return jwt in header response
     * @summary Add Asset of Truck V2
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {AssetAddTruckRequestV2} [assetAddTruckRequestV2] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public assetsAddTruckV2(authorization: string, assetAddTruckRequestV2?: AssetAddTruckRequestV2, options?: AxiosRequestConfig) {
        return AssetsApiFp(this.configuration).assetsAddTruckV2(authorization, assetAddTruckRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create or Update Asset Farm based on the req body <br> when `id` has value and existed in DB `farm` table, will update farm data, otherwise will create new farm data
     * @summary Create or Update Asset Farm
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {AssetsCreateOrUpdateFarmRequest} [assetsCreateOrUpdateFarmRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public assetsCreateOrUpdateFarm(aPPTYPE: AppTypeEnum, assetsCreateOrUpdateFarmRequest?: AssetsCreateOrUpdateFarmRequest, options?: AxiosRequestConfig) {
        return AssetsApiFp(this.configuration).assetsCreateOrUpdateFarm(aPPTYPE, assetsCreateOrUpdateFarmRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Soft delete user\'s asset truck from assets list by truckId 
     * @summary Remove Asset of Truck
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {string} truckId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public assetsDeleteTruck(authorization: string, truckId: string, options?: AxiosRequestConfig) {
        return AssetsApiFp(this.configuration).assetsDeleteTruck(authorization, truckId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch list of empty asset category
     * @summary Get Empty Asset Type
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public assetsEmptyCategoryList(authorization: string, options?: AxiosRequestConfig) {
        return AssetsApiFp(this.configuration).assetsEmptyCategoryList(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Soft delete asset farm by ID
     * @summary Delete asset farm by ID
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} farmId farm UUID
     * @param {string} [userId] used by DUTA app, id of the user that this request is for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public assetsFarmDelete(aPPTYPE: AppTypeEnum, farmId: string, userId?: string, options?: AxiosRequestConfig) {
        return AssetsApiFp(this.configuration).assetsFarmDelete(aPPTYPE, farmId, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch asset Farm detail
     * @summary Get asset Farm detail
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} farmId farm UUID
     * @param {string} [userId] used by DUTA app, id of the user that this request is for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public assetsFarmDetail(aPPTYPE: AppTypeEnum, farmId: string, userId?: string, options?: AxiosRequestConfig) {
        return AssetsApiFp(this.configuration).assetsFarmDetail(aPPTYPE, farmId, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch asset Farms by User ID
     * @summary Get Farm Assets
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} [userId] used by DUTA app, id of the user that this request is for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public assetsFarmList(aPPTYPE: AppTypeEnum, userId?: string, options?: AxiosRequestConfig) {
        return AssetsApiFp(this.configuration).assetsFarmList(aPPTYPE, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch detail of Ramp asset by User ID
     * @summary Get Ramp Asset Detail
     * @param {string} rampId Ramp ID in UUID type 4 format
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public assetsGetRamp(rampId: string, options?: AxiosRequestConfig) {
        return AssetsApiFp(this.configuration).assetsGetRamp(rampId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch detail of Supplier asset by User ID
     * @summary Get Supplier Asset Detail
     * @param {string} supplierId Supplier ID in UUID type 4 format
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public assetsGetSupplier(supplierId: string, options?: AxiosRequestConfig) {
        return AssetsApiFp(this.configuration).assetsGetSupplier(supplierId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch asset Ramp by User ID
     * @summary Get Ramp Assets
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public assetsRampList(options?: AxiosRequestConfig) {
        return AssetsApiFp(this.configuration).assetsRampList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch asset Supplier by User ID
     * @summary Get Supplier Assets
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {Array<MemberStatusEnum>} [status] Status of the supplier, will return all status if not present
     * @param {string} [contractName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public assetsSupplierList(authorization: string, status?: Array<MemberStatusEnum>, contractName?: string, options?: AxiosRequestConfig) {
        return AssetsApiFp(this.configuration).assetsSupplierList(authorization, status, contractName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch list of truck category
     * @summary Get All of truck category
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public assetsTruckGetCategory(options?: AxiosRequestConfig) {
        return AssetsApiFp(this.configuration).assetsTruckGetCategory(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch list assets of truck by user id (auth)
     * @summary Get All Asset of Truck
     * @param {AssetsTruckListScopeEnum} [scope] scope of assets truck list
     * @param {TruckStatusEnum} [status] status of truck
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public assetsTruckList(scope?: AssetsTruckListScopeEnum, status?: TruckStatusEnum, options?: AxiosRequestConfig) {
        return AssetsApiFp(this.configuration).assetsTruckList(scope, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update detail of Ramp
     * @summary Update Ramp Asset
     * @param {string} rampId Ramp ID in UUID type 4 format
     * @param {AssetsUpdateRampRequest} [assetsUpdateRampRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public assetsUpdateRamp(rampId: string, assetsUpdateRampRequest?: AssetsUpdateRampRequest, options?: AxiosRequestConfig) {
        return AssetsApiFp(this.configuration).assetsUpdateRamp(rampId, assetsUpdateRampRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update detail of Supplier
     * @summary Update Supplier Asset
     * @param {string} supplierId Supplier ID in UUID type 4 format
     * @param {AssetsUpdateSupplierRequest} [assetsUpdateSupplierRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public assetsUpdateSupplier(supplierId: string, assetsUpdateSupplierRequest?: AssetsUpdateSupplierRequest, options?: AxiosRequestConfig) {
        return AssetsApiFp(this.configuration).assetsUpdateSupplier(supplierId, assetsUpdateSupplierRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update asset of truck, will return jwt in header response
     * @summary Update Asset of Truck
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {string} truckId 
     * @param {AssetUpdateTruckRequest} [assetUpdateTruckRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public assetsUpdateTruck(authorization: string, truckId: string, assetUpdateTruckRequest?: AssetUpdateTruckRequest, options?: AxiosRequestConfig) {
        return AssetsApiFp(this.configuration).assetsUpdateTruck(authorization, truckId, assetUpdateTruckRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update asset of truck, will return jwt in header response
     * @summary Update Asset of Truck V2
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {string} truckId 
     * @param {AssetUpdateTruckRequestV2} [assetUpdateTruckRequestV2] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public assetsUpdateTruckV2(authorization: string, truckId: string, assetUpdateTruckRequestV2?: AssetUpdateTruckRequestV2, options?: AxiosRequestConfig) {
        return AssetsApiFp(this.configuration).assetsUpdateTruckV2(authorization, truckId, assetUpdateTruckRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add asset of ramp, will return jwt in header response
     * @summary Add Asset Ramp V2
     * @param {V2AssetsAddRampRequest} [v2AssetsAddRampRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public v2AssetsAddRamp(v2AssetsAddRampRequest?: V2AssetsAddRampRequest, options?: AxiosRequestConfig) {
        return AssetsApiFp(this.configuration).v2AssetsAddRamp(v2AssetsAddRampRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add asset of supplier, will return jwt in header response
     * @summary Add Asset of Supplier V2
     * @param {V2AssetsAddSupplierRequest} [v2AssetsAddSupplierRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public v2AssetsAddSupplier(v2AssetsAddSupplierRequest?: V2AssetsAddSupplierRequest, options?: AxiosRequestConfig) {
        return AssetsApiFp(this.configuration).v2AssetsAddSupplier(v2AssetsAddSupplierRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch asset Supplier via contact of the current user. The v1 is still using `asset` relation to the user, while this endpoint will use `contact` & `business` in order to fetch the suppliers
     * @summary Get Supplier Assets V2
     * @param {Array<MemberStatusEnum>} [status] Status of the supplier, will return all status if not present
     * @param {string} [contractName] 
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public v2AssetsSupplierList(status?: Array<MemberStatusEnum>, contractName?: string, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return AssetsApiFp(this.configuration).v2AssetsSupplierList(status, contractName, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create or Update multiple Asset Farm based on the req body <br> when `id` has value and existed in DB `farm` table, will update farm data, otherwise will create new farm data
     * @summary Create or Update Multiple Asset Farm
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {V3AssetsCreateOrUpdateFarmsRequest} [v3AssetsCreateOrUpdateFarmsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public v3AssetsCreateOrUpdateFarms(aPPTYPE: AppTypeEnum, v3AssetsCreateOrUpdateFarmsRequest?: V3AssetsCreateOrUpdateFarmsRequest, options?: AxiosRequestConfig) {
        return AssetsApiFp(this.configuration).v3AssetsCreateOrUpdateFarms(aPPTYPE, v3AssetsCreateOrUpdateFarmsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AuditLogsApi - axios parameter creator
 * @export
 */
export const AuditLogsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create audit logs
         * @summary Create Audit Logs
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {AuditLogsCreateRequest} [auditLogsCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        auditLogsCreate: async (aPPTYPE: AppTypeEnum, auditLogsCreateRequest?: AuditLogsCreateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('auditLogsCreate', 'aPPTYPE', aPPTYPE)
            const localVarPath = `/api/v1/audit-logs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(auditLogsCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuditLogsApi - functional programming interface
 * @export
 */
export const AuditLogsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuditLogsApiAxiosParamCreator(configuration)
    return {
        /**
         * Create audit logs
         * @summary Create Audit Logs
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {AuditLogsCreateRequest} [auditLogsCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async auditLogsCreate(aPPTYPE: AppTypeEnum, auditLogsCreateRequest?: AuditLogsCreateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DefaultSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.auditLogsCreate(aPPTYPE, auditLogsCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AuditLogsApi - factory interface
 * @export
 */
export const AuditLogsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuditLogsApiFp(configuration)
    return {
        /**
         * Create audit logs
         * @summary Create Audit Logs
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {AuditLogsCreateRequest} [auditLogsCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        auditLogsCreate(aPPTYPE: AppTypeEnum, auditLogsCreateRequest?: AuditLogsCreateRequest, options?: any): AxiosPromise<DefaultSuccessResponse> {
            return localVarFp.auditLogsCreate(aPPTYPE, auditLogsCreateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuditLogsApi - object-oriented interface
 * @export
 * @class AuditLogsApi
 * @extends {BaseAPI}
 */
export class AuditLogsApi extends BaseAPI {
    /**
     * Create audit logs
     * @summary Create Audit Logs
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {AuditLogsCreateRequest} [auditLogsCreateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditLogsApi
     */
    public auditLogsCreate(aPPTYPE: AppTypeEnum, auditLogsCreateRequest?: AuditLogsCreateRequest, options?: AxiosRequestConfig) {
        return AuditLogsApiFp(this.configuration).auditLogsCreate(aPPTYPE, auditLogsCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AuthApi - axios parameter creator
 * @export
 */
export const AuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Refresh JWT for a user
         * @summary Refresh JWT Token
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authJwtGet: async (authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('authJwtGet', 'authorization', authorization)
            const localVarPath = `/api/v1/auth/jwt`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send OTP for a user  # Dependencies  | Service Name | Usage | | ----------- | ----------- | | GCP KMS | Phone number decryption| | Twilio | Send OTP via SMS | 
         * @summary (Dropped) Request send OTP
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {AuthOtpSendRequest} authOtpSendRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        authOtpSend: async (aPPTYPE: AppTypeEnum, authOtpSendRequest: AuthOtpSendRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('authOtpSend', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'authOtpSendRequest' is not null or undefined
            assertParamExists('authOtpSend', 'authOtpSendRequest', authOtpSendRequest)
            const localVarPath = `/api/v1/auth/otp/send`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(authOtpSendRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send OTP for leads of a Duta  # Dependencies  | Service Name | Usage | | ----------- | ----------- | | GCP KMS | Phone number decryption| | Twilio/Jatis | Send OTP via SMS | 
         * @summary Request send OTP for Duta App
         * @param {AuthOtpSendDutaRequest} authOtpSendDutaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authOtpSendDuta: async (authOtpSendDutaRequest: AuthOtpSendDutaRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authOtpSendDutaRequest' is not null or undefined
            assertParamExists('authOtpSendDuta', 'authOtpSendDutaRequest', authOtpSendDutaRequest)
            const localVarPath = `/api/v1/auth/otp/send/duta`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(authOtpSendDutaRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validate OTP for a user  # Dependencies  | Service Name | Usage | | ----------- | ----------- | | GCP KMS | Phone number decryption| | Twilio | OTP Validation | 
         * @summary Validate OTP
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {AuthOtpValidateRequest} authOtpValidateRequest 
         * @param {number} [vERSIONCODE] Version code of the app that\&#39;s accessing the endpoint.
         * @param {string} [vERSIONNAME] The complete version of the app that\&#39;s accessing the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authOtpValidate: async (aPPTYPE: AppTypeEnum, authOtpValidateRequest: AuthOtpValidateRequest, vERSIONCODE?: number, vERSIONNAME?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('authOtpValidate', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'authOtpValidateRequest' is not null or undefined
            assertParamExists('authOtpValidate', 'authOtpValidateRequest', authOtpValidateRequest)
            const localVarPath = `/api/v1/auth/otp/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }

            if (vERSIONCODE != null) {
                localVarHeaderParameter['VERSION-CODE'] = typeof vERSIONCODE === 'string' 
                    ? vERSIONCODE 
                    : JSON.stringify(vERSIONCODE);
            }

            if (vERSIONNAME != null) {
                localVarHeaderParameter['VERSION-NAME'] = String(vERSIONNAME);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(authOtpValidateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validate OTP for a specific user with duta role
         * @summary Validate OTP for Duta
         * @param {AuthOtpValidateDutaRequest} authOtpValidateDutaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authOtpValidateDuta: async (authOtpValidateDutaRequest: AuthOtpValidateDutaRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authOtpValidateDutaRequest' is not null or undefined
            assertParamExists('authOtpValidateDuta', 'authOtpValidateDutaRequest', authOtpValidateDutaRequest)
            const localVarPath = `/api/v1/auth/otp/validate/duta`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(authOtpValidateDutaRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Check phone number registered or not  # Dependencies  | Service Name | Usage | | ----------- | ----------- | | GCP KMS | Phone number decryption| | Twilio | SMS service | 
         * @summary Validate user phone number
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {AuthPhoneNumberValidateRequest} authPhoneNumberValidateRequest 
         * @param {string} [xFirebaseToken] Firebase token (FCM) will be used for push notification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authPhoneNumberValidate: async (aPPTYPE: AppTypeEnum, authPhoneNumberValidateRequest: AuthPhoneNumberValidateRequest, xFirebaseToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('authPhoneNumberValidate', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'authPhoneNumberValidateRequest' is not null or undefined
            assertParamExists('authPhoneNumberValidate', 'authPhoneNumberValidateRequest', authPhoneNumberValidateRequest)
            const localVarPath = `/api/v1/auth/phone-no/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }

            if (xFirebaseToken != null) {
                localVarHeaderParameter['X-Firebase-Token'] = String(xFirebaseToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(authPhoneNumberValidateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change PIN for a user  # Dependencies  | Service Name | Usage | | ----------- | ----------- | | GCP KMS | Phone number decryption| 
         * @summary Change PIN (with old PIN)
         * @param {AuthPinChangeRequest} authPinChangeRequest 
         * @param {AppTypeEnum} [aPPTYPE] The name of the app that\&#39;s accessing the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authPinChange: async (authPinChangeRequest: AuthPinChangeRequest, aPPTYPE?: AppTypeEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authPinChangeRequest' is not null or undefined
            assertParamExists('authPinChange', 'authPinChangeRequest', authPinChangeRequest)
            const localVarPath = `/api/v1/auth/pin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(authPinChangeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create PIN for a user
         * @summary Create PIN (after OTP valid)
         * @param {AuthPinCreateRequest} authPinCreateRequest 
         * @param {AppTypeEnum} [aPPTYPE] The name of the app that\&#39;s accessing the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authPinCreate: async (authPinCreateRequest: AuthPinCreateRequest, aPPTYPE?: AppTypeEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authPinCreateRequest' is not null or undefined
            assertParamExists('authPinCreate', 'authPinCreateRequest', authPinCreateRequest)
            const localVarPath = `/api/v1/auth/pin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(authPinCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Check the combination of phone number and pin of the user, if valid means user successfully logged in  # Dependencies  | Service Name | Usage | | ----------- | ----------- | | GCP KMS | Phone number decryption| 
         * @summary Validate user PIN (Login)
         * @param {AuthPinValidateRequest} authPinValidateRequest 
         * @param {AppTypeEnum} [aPPTYPE] The name of the app that\&#39;s accessing the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authPinValidate: async (authPinValidateRequest: AuthPinValidateRequest, aPPTYPE?: AppTypeEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authPinValidateRequest' is not null or undefined
            assertParamExists('authPinValidate', 'authPinValidateRequest', authPinValidateRequest)
            const localVarPath = `/api/v1/auth/pin/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(authPinValidateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Register new leads (client) under the current user  # Dependencies  | Service Name | Usage | | ----------- | ----------- | | GCP KMS | Phone number decryption| 
         * @summary Register New Leads
         * @param {AuthRegisterLeadsRequest} authRegisterLeadsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authRegisterLeads: async (authRegisterLeadsRequest: AuthRegisterLeadsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authRegisterLeadsRequest' is not null or undefined
            assertParamExists('authRegisterLeads', 'authRegisterLeadsRequest', authRegisterLeadsRequest)
            const localVarPath = `/api/v1/auth/register-leads`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(authRegisterLeadsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update registration data such as name and assets for a user
         * @summary Update Registration Data
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {AuthUpdateRegistrationRequest} authUpdateRegistrationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authUpdateRegistration: async (aPPTYPE: AppTypeEnum, authUpdateRegistrationRequest: AuthUpdateRegistrationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('authUpdateRegistration', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'authUpdateRegistrationRequest' is not null or undefined
            assertParamExists('authUpdateRegistration', 'authUpdateRegistrationRequest', authUpdateRegistrationRequest)
            const localVarPath = `/api/v1/auth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(authUpdateRegistrationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Request send OTP
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {UsersOtpSendRequest} usersOtpSendRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersOtpSend: async (aPPTYPE: AppTypeEnum, usersOtpSendRequest: UsersOtpSendRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('usersOtpSend', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'usersOtpSendRequest' is not null or undefined
            assertParamExists('usersOtpSend', 'usersOtpSendRequest', usersOtpSendRequest)
            const localVarPath = `/api/v1/users/otp/send`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(usersOtpSendRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthApi - functional programming interface
 * @export
 */
export const AuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration)
    return {
        /**
         * Refresh JWT for a user
         * @summary Refresh JWT Token
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authJwtGet(authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthRefreshJWTTokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authJwtGet(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Send OTP for a user  # Dependencies  | Service Name | Usage | | ----------- | ----------- | | GCP KMS | Phone number decryption| | Twilio | Send OTP via SMS | 
         * @summary (Dropped) Request send OTP
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {AuthOtpSendRequest} authOtpSendRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async authOtpSend(aPPTYPE: AppTypeEnum, authOtpSendRequest: AuthOtpSendRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthOtpSendResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authOtpSend(aPPTYPE, authOtpSendRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Send OTP for leads of a Duta  # Dependencies  | Service Name | Usage | | ----------- | ----------- | | GCP KMS | Phone number decryption| | Twilio/Jatis | Send OTP via SMS | 
         * @summary Request send OTP for Duta App
         * @param {AuthOtpSendDutaRequest} authOtpSendDutaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authOtpSendDuta(authOtpSendDutaRequest: AuthOtpSendDutaRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authOtpSendDuta(authOtpSendDutaRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Validate OTP for a user  # Dependencies  | Service Name | Usage | | ----------- | ----------- | | GCP KMS | Phone number decryption| | Twilio | OTP Validation | 
         * @summary Validate OTP
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {AuthOtpValidateRequest} authOtpValidateRequest 
         * @param {number} [vERSIONCODE] Version code of the app that\&#39;s accessing the endpoint.
         * @param {string} [vERSIONNAME] The complete version of the app that\&#39;s accessing the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authOtpValidate(aPPTYPE: AppTypeEnum, authOtpValidateRequest: AuthOtpValidateRequest, vERSIONCODE?: number, vERSIONNAME?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthOtpValidateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authOtpValidate(aPPTYPE, authOtpValidateRequest, vERSIONCODE, vERSIONNAME, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Validate OTP for a specific user with duta role
         * @summary Validate OTP for Duta
         * @param {AuthOtpValidateDutaRequest} authOtpValidateDutaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authOtpValidateDuta(authOtpValidateDutaRequest: AuthOtpValidateDutaRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthOtpValidateDutaResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authOtpValidateDuta(authOtpValidateDutaRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Check phone number registered or not  # Dependencies  | Service Name | Usage | | ----------- | ----------- | | GCP KMS | Phone number decryption| | Twilio | SMS service | 
         * @summary Validate user phone number
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {AuthPhoneNumberValidateRequest} authPhoneNumberValidateRequest 
         * @param {string} [xFirebaseToken] Firebase token (FCM) will be used for push notification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authPhoneNumberValidate(aPPTYPE: AppTypeEnum, authPhoneNumberValidateRequest: AuthPhoneNumberValidateRequest, xFirebaseToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthPhoneNumberValidateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authPhoneNumberValidate(aPPTYPE, authPhoneNumberValidateRequest, xFirebaseToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Change PIN for a user  # Dependencies  | Service Name | Usage | | ----------- | ----------- | | GCP KMS | Phone number decryption| 
         * @summary Change PIN (with old PIN)
         * @param {AuthPinChangeRequest} authPinChangeRequest 
         * @param {AppTypeEnum} [aPPTYPE] The name of the app that\&#39;s accessing the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authPinChange(authPinChangeRequest: AuthPinChangeRequest, aPPTYPE?: AppTypeEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthPinChangeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authPinChange(authPinChangeRequest, aPPTYPE, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create PIN for a user
         * @summary Create PIN (after OTP valid)
         * @param {AuthPinCreateRequest} authPinCreateRequest 
         * @param {AppTypeEnum} [aPPTYPE] The name of the app that\&#39;s accessing the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authPinCreate(authPinCreateRequest: AuthPinCreateRequest, aPPTYPE?: AppTypeEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthPinCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authPinCreate(authPinCreateRequest, aPPTYPE, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Check the combination of phone number and pin of the user, if valid means user successfully logged in  # Dependencies  | Service Name | Usage | | ----------- | ----------- | | GCP KMS | Phone number decryption| 
         * @summary Validate user PIN (Login)
         * @param {AuthPinValidateRequest} authPinValidateRequest 
         * @param {AppTypeEnum} [aPPTYPE] The name of the app that\&#39;s accessing the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authPinValidate(authPinValidateRequest: AuthPinValidateRequest, aPPTYPE?: AppTypeEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthPinValidateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authPinValidate(authPinValidateRequest, aPPTYPE, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Register new leads (client) under the current user  # Dependencies  | Service Name | Usage | | ----------- | ----------- | | GCP KMS | Phone number decryption| 
         * @summary Register New Leads
         * @param {AuthRegisterLeadsRequest} authRegisterLeadsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authRegisterLeads(authRegisterLeadsRequest: AuthRegisterLeadsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthRegisterLeadsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authRegisterLeads(authRegisterLeadsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update registration data such as name and assets for a user
         * @summary Update Registration Data
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {AuthUpdateRegistrationRequest} authUpdateRegistrationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authUpdateRegistration(aPPTYPE: AppTypeEnum, authUpdateRegistrationRequest: AuthUpdateRegistrationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authUpdateRegistration(aPPTYPE, authUpdateRegistrationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Request send OTP
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {UsersOtpSendRequest} usersOtpSendRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersOtpSend(aPPTYPE: AppTypeEnum, usersOtpSendRequest: UsersOtpSendRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UsersOtpSendResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersOtpSend(aPPTYPE, usersOtpSendRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AuthApi - factory interface
 * @export
 */
export const AuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthApiFp(configuration)
    return {
        /**
         * Refresh JWT for a user
         * @summary Refresh JWT Token
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authJwtGet(authorization: string, options?: any): AxiosPromise<AuthRefreshJWTTokenResponse> {
            return localVarFp.authJwtGet(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Send OTP for a user  # Dependencies  | Service Name | Usage | | ----------- | ----------- | | GCP KMS | Phone number decryption| | Twilio | Send OTP via SMS | 
         * @summary (Dropped) Request send OTP
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {AuthOtpSendRequest} authOtpSendRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        authOtpSend(aPPTYPE: AppTypeEnum, authOtpSendRequest: AuthOtpSendRequest, options?: any): AxiosPromise<AuthOtpSendResponse> {
            return localVarFp.authOtpSend(aPPTYPE, authOtpSendRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Send OTP for leads of a Duta  # Dependencies  | Service Name | Usage | | ----------- | ----------- | | GCP KMS | Phone number decryption| | Twilio/Jatis | Send OTP via SMS | 
         * @summary Request send OTP for Duta App
         * @param {AuthOtpSendDutaRequest} authOtpSendDutaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authOtpSendDuta(authOtpSendDutaRequest: AuthOtpSendDutaRequest, options?: any): AxiosPromise<void> {
            return localVarFp.authOtpSendDuta(authOtpSendDutaRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Validate OTP for a user  # Dependencies  | Service Name | Usage | | ----------- | ----------- | | GCP KMS | Phone number decryption| | Twilio | OTP Validation | 
         * @summary Validate OTP
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {AuthOtpValidateRequest} authOtpValidateRequest 
         * @param {number} [vERSIONCODE] Version code of the app that\&#39;s accessing the endpoint.
         * @param {string} [vERSIONNAME] The complete version of the app that\&#39;s accessing the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authOtpValidate(aPPTYPE: AppTypeEnum, authOtpValidateRequest: AuthOtpValidateRequest, vERSIONCODE?: number, vERSIONNAME?: string, options?: any): AxiosPromise<AuthOtpValidateResponse> {
            return localVarFp.authOtpValidate(aPPTYPE, authOtpValidateRequest, vERSIONCODE, vERSIONNAME, options).then((request) => request(axios, basePath));
        },
        /**
         * Validate OTP for a specific user with duta role
         * @summary Validate OTP for Duta
         * @param {AuthOtpValidateDutaRequest} authOtpValidateDutaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authOtpValidateDuta(authOtpValidateDutaRequest: AuthOtpValidateDutaRequest, options?: any): AxiosPromise<AuthOtpValidateDutaResponse> {
            return localVarFp.authOtpValidateDuta(authOtpValidateDutaRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Check phone number registered or not  # Dependencies  | Service Name | Usage | | ----------- | ----------- | | GCP KMS | Phone number decryption| | Twilio | SMS service | 
         * @summary Validate user phone number
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {AuthPhoneNumberValidateRequest} authPhoneNumberValidateRequest 
         * @param {string} [xFirebaseToken] Firebase token (FCM) will be used for push notification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authPhoneNumberValidate(aPPTYPE: AppTypeEnum, authPhoneNumberValidateRequest: AuthPhoneNumberValidateRequest, xFirebaseToken?: string, options?: any): AxiosPromise<AuthPhoneNumberValidateResponse> {
            return localVarFp.authPhoneNumberValidate(aPPTYPE, authPhoneNumberValidateRequest, xFirebaseToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Change PIN for a user  # Dependencies  | Service Name | Usage | | ----------- | ----------- | | GCP KMS | Phone number decryption| 
         * @summary Change PIN (with old PIN)
         * @param {AuthPinChangeRequest} authPinChangeRequest 
         * @param {AppTypeEnum} [aPPTYPE] The name of the app that\&#39;s accessing the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authPinChange(authPinChangeRequest: AuthPinChangeRequest, aPPTYPE?: AppTypeEnum, options?: any): AxiosPromise<AuthPinChangeResponse> {
            return localVarFp.authPinChange(authPinChangeRequest, aPPTYPE, options).then((request) => request(axios, basePath));
        },
        /**
         * Create PIN for a user
         * @summary Create PIN (after OTP valid)
         * @param {AuthPinCreateRequest} authPinCreateRequest 
         * @param {AppTypeEnum} [aPPTYPE] The name of the app that\&#39;s accessing the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authPinCreate(authPinCreateRequest: AuthPinCreateRequest, aPPTYPE?: AppTypeEnum, options?: any): AxiosPromise<AuthPinCreateResponse> {
            return localVarFp.authPinCreate(authPinCreateRequest, aPPTYPE, options).then((request) => request(axios, basePath));
        },
        /**
         * Check the combination of phone number and pin of the user, if valid means user successfully logged in  # Dependencies  | Service Name | Usage | | ----------- | ----------- | | GCP KMS | Phone number decryption| 
         * @summary Validate user PIN (Login)
         * @param {AuthPinValidateRequest} authPinValidateRequest 
         * @param {AppTypeEnum} [aPPTYPE] The name of the app that\&#39;s accessing the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authPinValidate(authPinValidateRequest: AuthPinValidateRequest, aPPTYPE?: AppTypeEnum, options?: any): AxiosPromise<AuthPinValidateResponse> {
            return localVarFp.authPinValidate(authPinValidateRequest, aPPTYPE, options).then((request) => request(axios, basePath));
        },
        /**
         * Register new leads (client) under the current user  # Dependencies  | Service Name | Usage | | ----------- | ----------- | | GCP KMS | Phone number decryption| 
         * @summary Register New Leads
         * @param {AuthRegisterLeadsRequest} authRegisterLeadsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authRegisterLeads(authRegisterLeadsRequest: AuthRegisterLeadsRequest, options?: any): AxiosPromise<AuthRegisterLeadsResponse> {
            return localVarFp.authRegisterLeads(authRegisterLeadsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update registration data such as name and assets for a user
         * @summary Update Registration Data
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {AuthUpdateRegistrationRequest} authUpdateRegistrationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authUpdateRegistration(aPPTYPE: AppTypeEnum, authUpdateRegistrationRequest: AuthUpdateRegistrationRequest, options?: any): AxiosPromise<void> {
            return localVarFp.authUpdateRegistration(aPPTYPE, authUpdateRegistrationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Request send OTP
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {UsersOtpSendRequest} usersOtpSendRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersOtpSend(aPPTYPE: AppTypeEnum, usersOtpSendRequest: UsersOtpSendRequest, options?: any): AxiosPromise<UsersOtpSendResponse> {
            return localVarFp.usersOtpSend(aPPTYPE, usersOtpSendRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI {
    /**
     * Refresh JWT for a user
     * @summary Refresh JWT Token
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authJwtGet(authorization: string, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authJwtGet(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send OTP for a user  # Dependencies  | Service Name | Usage | | ----------- | ----------- | | GCP KMS | Phone number decryption| | Twilio | Send OTP via SMS | 
     * @summary (Dropped) Request send OTP
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {AuthOtpSendRequest} authOtpSendRequest 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authOtpSend(aPPTYPE: AppTypeEnum, authOtpSendRequest: AuthOtpSendRequest, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authOtpSend(aPPTYPE, authOtpSendRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send OTP for leads of a Duta  # Dependencies  | Service Name | Usage | | ----------- | ----------- | | GCP KMS | Phone number decryption| | Twilio/Jatis | Send OTP via SMS | 
     * @summary Request send OTP for Duta App
     * @param {AuthOtpSendDutaRequest} authOtpSendDutaRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authOtpSendDuta(authOtpSendDutaRequest: AuthOtpSendDutaRequest, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authOtpSendDuta(authOtpSendDutaRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Validate OTP for a user  # Dependencies  | Service Name | Usage | | ----------- | ----------- | | GCP KMS | Phone number decryption| | Twilio | OTP Validation | 
     * @summary Validate OTP
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {AuthOtpValidateRequest} authOtpValidateRequest 
     * @param {number} [vERSIONCODE] Version code of the app that\&#39;s accessing the endpoint.
     * @param {string} [vERSIONNAME] The complete version of the app that\&#39;s accessing the endpoint.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authOtpValidate(aPPTYPE: AppTypeEnum, authOtpValidateRequest: AuthOtpValidateRequest, vERSIONCODE?: number, vERSIONNAME?: string, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authOtpValidate(aPPTYPE, authOtpValidateRequest, vERSIONCODE, vERSIONNAME, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Validate OTP for a specific user with duta role
     * @summary Validate OTP for Duta
     * @param {AuthOtpValidateDutaRequest} authOtpValidateDutaRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authOtpValidateDuta(authOtpValidateDutaRequest: AuthOtpValidateDutaRequest, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authOtpValidateDuta(authOtpValidateDutaRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Check phone number registered or not  # Dependencies  | Service Name | Usage | | ----------- | ----------- | | GCP KMS | Phone number decryption| | Twilio | SMS service | 
     * @summary Validate user phone number
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {AuthPhoneNumberValidateRequest} authPhoneNumberValidateRequest 
     * @param {string} [xFirebaseToken] Firebase token (FCM) will be used for push notification
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authPhoneNumberValidate(aPPTYPE: AppTypeEnum, authPhoneNumberValidateRequest: AuthPhoneNumberValidateRequest, xFirebaseToken?: string, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authPhoneNumberValidate(aPPTYPE, authPhoneNumberValidateRequest, xFirebaseToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Change PIN for a user  # Dependencies  | Service Name | Usage | | ----------- | ----------- | | GCP KMS | Phone number decryption| 
     * @summary Change PIN (with old PIN)
     * @param {AuthPinChangeRequest} authPinChangeRequest 
     * @param {AppTypeEnum} [aPPTYPE] The name of the app that\&#39;s accessing the endpoint.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authPinChange(authPinChangeRequest: AuthPinChangeRequest, aPPTYPE?: AppTypeEnum, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authPinChange(authPinChangeRequest, aPPTYPE, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create PIN for a user
     * @summary Create PIN (after OTP valid)
     * @param {AuthPinCreateRequest} authPinCreateRequest 
     * @param {AppTypeEnum} [aPPTYPE] The name of the app that\&#39;s accessing the endpoint.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authPinCreate(authPinCreateRequest: AuthPinCreateRequest, aPPTYPE?: AppTypeEnum, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authPinCreate(authPinCreateRequest, aPPTYPE, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Check the combination of phone number and pin of the user, if valid means user successfully logged in  # Dependencies  | Service Name | Usage | | ----------- | ----------- | | GCP KMS | Phone number decryption| 
     * @summary Validate user PIN (Login)
     * @param {AuthPinValidateRequest} authPinValidateRequest 
     * @param {AppTypeEnum} [aPPTYPE] The name of the app that\&#39;s accessing the endpoint.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authPinValidate(authPinValidateRequest: AuthPinValidateRequest, aPPTYPE?: AppTypeEnum, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authPinValidate(authPinValidateRequest, aPPTYPE, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Register new leads (client) under the current user  # Dependencies  | Service Name | Usage | | ----------- | ----------- | | GCP KMS | Phone number decryption| 
     * @summary Register New Leads
     * @param {AuthRegisterLeadsRequest} authRegisterLeadsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authRegisterLeads(authRegisterLeadsRequest: AuthRegisterLeadsRequest, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authRegisterLeads(authRegisterLeadsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update registration data such as name and assets for a user
     * @summary Update Registration Data
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {AuthUpdateRegistrationRequest} authUpdateRegistrationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authUpdateRegistration(aPPTYPE: AppTypeEnum, authUpdateRegistrationRequest: AuthUpdateRegistrationRequest, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authUpdateRegistration(aPPTYPE, authUpdateRegistrationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Request send OTP
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {UsersOtpSendRequest} usersOtpSendRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public usersOtpSend(aPPTYPE: AppTypeEnum, usersOtpSendRequest: UsersOtpSendRequest, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).usersOtpSend(aPPTYPE, usersOtpSendRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * BlocksApi - axios parameter creator
 * @export
 */
export const BlocksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Called by mobile app to Get all user\'s blocks
         * @summary Get all Blocks by UserId in JWT
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blocksList: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/blocks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Will return list of blocks that are connected to current user. Will use User ID from JWT and lookup the blocks by utilizing `contact` and `business`.  The V1 is using relation with `farm_group` and `farm_group_association` only, while this new V2 endpoint will also use another relations with any `business`. 
         * @summary Get Blocks V2
         * @param {BlockTypeEnum} [type] Type of business that owns the block. Will return all if this param is not provided
         * @param {string} [supplierId] Supplier ID in UUID type 4 format. Won\&#39;t filter by supplier if not provided
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {string} [name] Search by name of block
         * @param {string} [sortBy] Sort the results by the specified field.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2BlocksList: async (type?: BlockTypeEnum, supplierId?: string, page?: number, limit?: number, name?: string, sortBy?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/blocks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (supplierId !== undefined) {
                localVarQueryParameter['supplierId'] = supplierId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BlocksApi - functional programming interface
 * @export
 */
export const BlocksApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BlocksApiAxiosParamCreator(configuration)
    return {
        /**
         * Called by mobile app to Get all user\'s blocks
         * @summary Get all Blocks by UserId in JWT
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async blocksList(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BlocksListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.blocksList(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Will return list of blocks that are connected to current user. Will use User ID from JWT and lookup the blocks by utilizing `contact` and `business`.  The V1 is using relation with `farm_group` and `farm_group_association` only, while this new V2 endpoint will also use another relations with any `business`. 
         * @summary Get Blocks V2
         * @param {BlockTypeEnum} [type] Type of business that owns the block. Will return all if this param is not provided
         * @param {string} [supplierId] Supplier ID in UUID type 4 format. Won\&#39;t filter by supplier if not provided
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {string} [name] Search by name of block
         * @param {string} [sortBy] Sort the results by the specified field.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2BlocksList(type?: BlockTypeEnum, supplierId?: string, page?: number, limit?: number, name?: string, sortBy?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V2BlocksListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2BlocksList(type, supplierId, page, limit, name, sortBy, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BlocksApi - factory interface
 * @export
 */
export const BlocksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BlocksApiFp(configuration)
    return {
        /**
         * Called by mobile app to Get all user\'s blocks
         * @summary Get all Blocks by UserId in JWT
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blocksList(options?: any): AxiosPromise<BlocksListResponse> {
            return localVarFp.blocksList(options).then((request) => request(axios, basePath));
        },
        /**
         * Will return list of blocks that are connected to current user. Will use User ID from JWT and lookup the blocks by utilizing `contact` and `business`.  The V1 is using relation with `farm_group` and `farm_group_association` only, while this new V2 endpoint will also use another relations with any `business`. 
         * @summary Get Blocks V2
         * @param {BlockTypeEnum} [type] Type of business that owns the block. Will return all if this param is not provided
         * @param {string} [supplierId] Supplier ID in UUID type 4 format. Won\&#39;t filter by supplier if not provided
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {string} [name] Search by name of block
         * @param {string} [sortBy] Sort the results by the specified field.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2BlocksList(type?: BlockTypeEnum, supplierId?: string, page?: number, limit?: number, name?: string, sortBy?: string, options?: any): AxiosPromise<V2BlocksListResponse> {
            return localVarFp.v2BlocksList(type, supplierId, page, limit, name, sortBy, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BlocksApi - object-oriented interface
 * @export
 * @class BlocksApi
 * @extends {BaseAPI}
 */
export class BlocksApi extends BaseAPI {
    /**
     * Called by mobile app to Get all user\'s blocks
     * @summary Get all Blocks by UserId in JWT
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlocksApi
     */
    public blocksList(options?: AxiosRequestConfig) {
        return BlocksApiFp(this.configuration).blocksList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Will return list of blocks that are connected to current user. Will use User ID from JWT and lookup the blocks by utilizing `contact` and `business`.  The V1 is using relation with `farm_group` and `farm_group_association` only, while this new V2 endpoint will also use another relations with any `business`. 
     * @summary Get Blocks V2
     * @param {BlockTypeEnum} [type] Type of business that owns the block. Will return all if this param is not provided
     * @param {string} [supplierId] Supplier ID in UUID type 4 format. Won\&#39;t filter by supplier if not provided
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {string} [name] Search by name of block
     * @param {string} [sortBy] Sort the results by the specified field.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlocksApi
     */
    public v2BlocksList(type?: BlockTypeEnum, supplierId?: string, page?: number, limit?: number, name?: string, sortBy?: string, options?: AxiosRequestConfig) {
        return BlocksApiFp(this.configuration).v2BlocksList(type, supplierId, page, limit, name, sortBy, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * BusinessApi - axios parameter creator
 * @export
 */
export const BusinessApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Called by mobile app to get List of farmer groups by manager
         * @summary Get List Farmer Group related with the role gapoktan with scope manager
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        businessGetFarmerGroupList: async (page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/business/farmer-groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BusinessApi - functional programming interface
 * @export
 */
export const BusinessApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BusinessApiAxiosParamCreator(configuration)
    return {
        /**
         * Called by mobile app to get List of farmer groups by manager
         * @summary Get List Farmer Group related with the role gapoktan with scope manager
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async businessGetFarmerGroupList(page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BusinessGetFarmerGroupListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.businessGetFarmerGroupList(page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BusinessApi - factory interface
 * @export
 */
export const BusinessApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BusinessApiFp(configuration)
    return {
        /**
         * Called by mobile app to get List of farmer groups by manager
         * @summary Get List Farmer Group related with the role gapoktan with scope manager
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        businessGetFarmerGroupList(page?: number, limit?: number, options?: any): AxiosPromise<BusinessGetFarmerGroupListResponse> {
            return localVarFp.businessGetFarmerGroupList(page, limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BusinessApi - object-oriented interface
 * @export
 * @class BusinessApi
 * @extends {BaseAPI}
 */
export class BusinessApi extends BaseAPI {
    /**
     * Called by mobile app to get List of farmer groups by manager
     * @summary Get List Farmer Group related with the role gapoktan with scope manager
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessApi
     */
    public businessGetFarmerGroupList(page?: number, limit?: number, options?: AxiosRequestConfig) {
        return BusinessApiFp(this.configuration).businessGetFarmerGroupList(page, limit, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CampaignsApi - axios parameter creator
 * @export
 */
export const CampaignsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This endpoint will return detail data of b2c campaign 
         * @summary Campaign B2C card metadata
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignB2CCard: async (aPPTYPE: AppTypeEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('campaignB2CCard', 'aPPTYPE', aPPTYPE)
            const localVarPath = `/api/v1/campaigns/b2c`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint will return campaign detail data 
         * @summary Campaign B2C detail data
         * @param {string} campaignId Campaign B2C UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignB2CDetail: async (campaignId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('campaignB2CDetail', 'campaignId', campaignId)
            const localVarPath = `/api/v1/campaigns/b2c/detail/{campaignId}`
                .replace(`{${"campaignId"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint returns list of harvest records
         * @summary Campaign B2C harvest records
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignB2CFarmersHarvestRecords: async (page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/campaigns/b2c/farmers/harvest-records`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint register a user to a campaign program b2c 
         * @param {string} campaignId Campaign B2C UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignB2CJoin: async (campaignId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('campaignB2CJoin', 'campaignId', campaignId)
            const localVarPath = `/api/v1/campaigns/b2c/join/{campaignId}`
                .replace(`{${"campaignId"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Used by worker (Smallholder, Harvester, Driver)  The `role` property is used to identify which card (on FE) should be used.  
         * @summary Campaign Chain Delivery
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignsGetChainDelivery: async (aPPTYPE: AppTypeEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('campaignsGetChainDelivery', 'aPPTYPE', aPPTYPE)
            const localVarPath = `/api/v1/campaigns/chain-delivery/validation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Used by worker (Smallholder, Harvester, Driver)  The `role` property is used to identify which card (on FE) should be used.  And the `shareMessage` is used as the message body on invite user feature 
         * @summary Campaign Chain Delivery Detail
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {number} datetime Datetime for filtering data list. Use epoch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignsGetDetailChainDelivery: async (aPPTYPE: AppTypeEnum, datetime: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('campaignsGetDetailChainDelivery', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'datetime' is not null or undefined
            assertParamExists('campaignsGetDetailChainDelivery', 'datetime', datetime)
            const localVarPath = `/api/v1/campaigns/chain-delivery`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (datetime !== undefined) {
                localVarQueryParameter['datetime'] = datetime;
            }

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Will return list of Campaign Emas that is currently available.  The client will limit the number of items returned if there is a requirement to do that. 
         * @summary List of Campaign Golds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignsGoldList: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/campaigns/gold`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Will return user progress of Daily Campaign Emas. 
         * @summary The Daily Progress of Campaign Gold 2.0
         * @param {string} campaignGoldV2Id Campaign Gold UUID
         * @param {number} month Month in MM format
         * @param {number} year Year in YYYY format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignsGoldV2DailyProgress: async (campaignGoldV2Id: string, month: number, year: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignGoldV2Id' is not null or undefined
            assertParamExists('campaignsGoldV2DailyProgress', 'campaignGoldV2Id', campaignGoldV2Id)
            // verify required parameter 'month' is not null or undefined
            assertParamExists('campaignsGoldV2DailyProgress', 'month', month)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('campaignsGoldV2DailyProgress', 'year', year)
            const localVarPath = `/api/v1/campaigns/goldv2/{campaignGoldV2Id}/daily`
                .replace(`{${"campaignGoldV2Id"}}`, encodeURIComponent(String(campaignGoldV2Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Will return detail of Campaign Emas that is currently available. 
         * @summary Detail of Campaign Gold 2.0
         * @param {string} campaignGoldV2Id Campaign Gold UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignsGoldV2Detail: async (campaignGoldV2Id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignGoldV2Id' is not null or undefined
            assertParamExists('campaignsGoldV2Detail', 'campaignGoldV2Id', campaignGoldV2Id)
            const localVarPath = `/api/v1/campaigns/goldv2/{campaignGoldV2Id}`
                .replace(`{${"campaignGoldV2Id"}}`, encodeURIComponent(String(campaignGoldV2Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Will return list of users who have earned gold from Campaign Emas. 
         * @summary List of Leaderboard Campaign Golds 2.0
         * @param {string} [partnerId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignsGoldV2LeaderBoard: async (partnerId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/campaigns/goldv2/leaderboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (partnerId !== undefined) {
                localVarQueryParameter['partnerId'] = partnerId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Will return user progress of Monthly Campaign Emas. 
         * @summary The Monthly Progress of Campaign Gold 2.0
         * @param {string} campaignGoldV2Id Campaign Gold UUID
         * @param {number} month Month in MM format
         * @param {number} year Year in YYYY format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignsGoldV2MonthlyProgress: async (campaignGoldV2Id: string, month: number, year: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignGoldV2Id' is not null or undefined
            assertParamExists('campaignsGoldV2MonthlyProgress', 'campaignGoldV2Id', campaignGoldV2Id)
            // verify required parameter 'month' is not null or undefined
            assertParamExists('campaignsGoldV2MonthlyProgress', 'month', month)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('campaignsGoldV2MonthlyProgress', 'year', year)
            const localVarPath = `/api/v1/campaigns/goldv2/{campaignGoldV2Id}/monthly`
                .replace(`{${"campaignGoldV2Id"}}`, encodeURIComponent(String(campaignGoldV2Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Will return user progress of Quarterly Campaign Emas. 
         * @summary The Quarterly Progress of Campaign Gold 2.0
         * @param {string} campaignGoldV2Id Campaign Gold UUID
         * @param {number} month Month in MM format
         * @param {number} year Year in YYYY format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignsGoldV2QuarterlyProgress: async (campaignGoldV2Id: string, month: number, year: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignGoldV2Id' is not null or undefined
            assertParamExists('campaignsGoldV2QuarterlyProgress', 'campaignGoldV2Id', campaignGoldV2Id)
            // verify required parameter 'month' is not null or undefined
            assertParamExists('campaignsGoldV2QuarterlyProgress', 'month', month)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('campaignsGoldV2QuarterlyProgress', 'year', year)
            const localVarPath = `/api/v1/campaigns/goldv2/{campaignGoldV2Id}/quarterly`
                .replace(`{${"campaignGoldV2Id"}}`, encodeURIComponent(String(campaignGoldV2Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Used by MemberApp to get list of campaigns, filtered with current User ID. Will return list ordered by latest progress update & nearest campaign end date.
         * @summary List of Campaigns
         * @param {Array<CampaignStatusEnum>} [status] 
         * @param {Array<string>} [type] Filled with campaign type ID (from Get Campaign Types). Default will show campaign type
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignsList: async (status?: Array<CampaignStatusEnum>, type?: Array<string>, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/campaigns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (status) {
                localVarQueryParameter['status'] = status.join(COLLECTION_FORMATS.csv);
            }

            if (type) {
                localVarQueryParameter['type'] = type.join(COLLECTION_FORMATS.csv);
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Used by all Partner user to retrive list of Campaign codes (for tiering purpose)
         * @summary List Campaign Codes
         * @param {string} [code] Search query for campaign code by code name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignsListCode: async (code?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/campaigns/codes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Used by all Partner user to retrive list of Campaign types
         * @summary List Campaign Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignsListType: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/campaigns/types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create campaign program 
         * @summary Create a Campaign Program
         * @param {CampaignsProgramsCreateRequest} [campaignsProgramsCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignsProgramsCreate: async (campaignsProgramsCreateRequest?: CampaignsProgramsCreateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/campaigns/programs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(campaignsProgramsCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This api returns campaign program detail
         * @summary Get campaign program detail
         * @param {string} campaignProgramId Unique ID of campaign program (uuid format)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignsProgramsGetDetail: async (campaignProgramId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignProgramId' is not null or undefined
            assertParamExists('campaignsProgramsGetDetail', 'campaignProgramId', campaignProgramId)
            const localVarPath = `/api/v1/campaigns/programs/{campaignProgramId}`
                .replace(`{${"campaignProgramId"}}`, encodeURIComponent(String(campaignProgramId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Will return list of campaign program 
         * @summary List of Campaigns Programs
         * @param {string} [partnerId] 
         * @param {number} [version] 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignsProgramsGetList: async (partnerId?: string, version?: number, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/campaigns/programs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (partnerId !== undefined) {
                localVarQueryParameter['partnerId'] = partnerId;
            }

            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add new target to existing campaign program
         * @summary Add New Participant to A Campaign Program
         * @param {CampaignsProgramsGoldCreateRequest} [campaignsProgramsGoldCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignsProgramsGoldCreate: async (campaignsProgramsGoldCreateRequest?: CampaignsProgramsGoldCreateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/campaigns/programs/gold`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(campaignsProgramsGoldCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add New Target to a campaign participant
         * @summary Add New Target to a campaign participant
         * @param {Array<CampaignsProgramsGoldTargetAddRequestInner>} [campaignsProgramsGoldTargetAddRequestInner] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignsProgramsGoldTargetAdd: async (campaignsProgramsGoldTargetAddRequestInner?: Array<CampaignsProgramsGoldTargetAddRequestInner>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/campaigns/programs/gold/targets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(campaignsProgramsGoldTargetAddRequestInner, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get current campaign rank show in list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignsRankDetail: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/campaigns/rank-detail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Used by MemberApp inside Campaign Increment detail page to retrieve detail of its reward simulation.
         * @summary Simulation of Campaign Increment Reward
         * @param {number} [baseline] Baseline (Ton) for generate campaign calculation simulations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignsSimulationIncrement: async (baseline?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/campaigns/simulation/increment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (baseline !== undefined) {
                localVarQueryParameter['baseline'] = baseline;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Will return list of Campaign Emas that is currently available.  The client will limit the number of items returned if there is a requirement to do that. 
         * @summary List of Campaign Golds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CampaignsGoldList: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/campaigns/gold`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Used by MemberApp to get list of campaigns, filtered with current User ID.
         * @summary List of Campaigns V2
         * @param {Array<CampaignStatusEnum>} [status] 
         * @param {Array<string>} [type] Filled with campaign type ID (from Get Campaign Types). Default will show campaign type
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CampaignsList: async (status?: Array<CampaignStatusEnum>, type?: Array<string>, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/campaigns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (status) {
                localVarQueryParameter['status'] = status.join(COLLECTION_FORMATS.csv);
            }

            if (type) {
                localVarQueryParameter['type'] = type.join(COLLECTION_FORMATS.csv);
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CampaignsApi - functional programming interface
 * @export
 */
export const CampaignsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CampaignsApiAxiosParamCreator(configuration)
    return {
        /**
         * This endpoint will return detail data of b2c campaign 
         * @summary Campaign B2C card metadata
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignB2CCard(aPPTYPE: AppTypeEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignB2CCardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignB2CCard(aPPTYPE, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint will return campaign detail data 
         * @summary Campaign B2C detail data
         * @param {string} campaignId Campaign B2C UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignB2CDetail(campaignId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignB2CDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignB2CDetail(campaignId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint returns list of harvest records
         * @summary Campaign B2C harvest records
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignB2CFarmersHarvestRecords(page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignB2CFarmersHarvestRecordsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignB2CFarmersHarvestRecords(page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint register a user to a campaign program b2c 
         * @param {string} campaignId Campaign B2C UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignB2CJoin(campaignId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignB2CJoin(campaignId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Used by worker (Smallholder, Harvester, Driver)  The `role` property is used to identify which card (on FE) should be used.  
         * @summary Campaign Chain Delivery
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignsGetChainDelivery(aPPTYPE: AppTypeEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignGetChainDeliveryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignsGetChainDelivery(aPPTYPE, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Used by worker (Smallholder, Harvester, Driver)  The `role` property is used to identify which card (on FE) should be used.  And the `shareMessage` is used as the message body on invite user feature 
         * @summary Campaign Chain Delivery Detail
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {number} datetime Datetime for filtering data list. Use epoch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignsGetDetailChainDelivery(aPPTYPE: AppTypeEnum, datetime: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignGetDetailChainDeliveryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignsGetDetailChainDelivery(aPPTYPE, datetime, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Will return list of Campaign Emas that is currently available.  The client will limit the number of items returned if there is a requirement to do that. 
         * @summary List of Campaign Golds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignsGoldList(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignsGoldListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignsGoldList(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Will return user progress of Daily Campaign Emas. 
         * @summary The Daily Progress of Campaign Gold 2.0
         * @param {string} campaignGoldV2Id Campaign Gold UUID
         * @param {number} month Month in MM format
         * @param {number} year Year in YYYY format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignsGoldV2DailyProgress(campaignGoldV2Id: string, month: number, year: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignsGoldV2DailyProgressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignsGoldV2DailyProgress(campaignGoldV2Id, month, year, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Will return detail of Campaign Emas that is currently available. 
         * @summary Detail of Campaign Gold 2.0
         * @param {string} campaignGoldV2Id Campaign Gold UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignsGoldV2Detail(campaignGoldV2Id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignsGoldV2DetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignsGoldV2Detail(campaignGoldV2Id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Will return list of users who have earned gold from Campaign Emas. 
         * @summary List of Leaderboard Campaign Golds 2.0
         * @param {string} [partnerId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignsGoldV2LeaderBoard(partnerId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignsGoldV2LeaderBoardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignsGoldV2LeaderBoard(partnerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Will return user progress of Monthly Campaign Emas. 
         * @summary The Monthly Progress of Campaign Gold 2.0
         * @param {string} campaignGoldV2Id Campaign Gold UUID
         * @param {number} month Month in MM format
         * @param {number} year Year in YYYY format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignsGoldV2MonthlyProgress(campaignGoldV2Id: string, month: number, year: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignsGoldV2MonthlyProgressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignsGoldV2MonthlyProgress(campaignGoldV2Id, month, year, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Will return user progress of Quarterly Campaign Emas. 
         * @summary The Quarterly Progress of Campaign Gold 2.0
         * @param {string} campaignGoldV2Id Campaign Gold UUID
         * @param {number} month Month in MM format
         * @param {number} year Year in YYYY format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignsGoldV2QuarterlyProgress(campaignGoldV2Id: string, month: number, year: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignsGoldV2QuarterlyProgressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignsGoldV2QuarterlyProgress(campaignGoldV2Id, month, year, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Used by MemberApp to get list of campaigns, filtered with current User ID. Will return list ordered by latest progress update & nearest campaign end date.
         * @summary List of Campaigns
         * @param {Array<CampaignStatusEnum>} [status] 
         * @param {Array<string>} [type] Filled with campaign type ID (from Get Campaign Types). Default will show campaign type
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignsList(status?: Array<CampaignStatusEnum>, type?: Array<string>, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignsListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignsList(status, type, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Used by all Partner user to retrive list of Campaign codes (for tiering purpose)
         * @summary List Campaign Codes
         * @param {string} [code] Search query for campaign code by code name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignsListCode(code?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignListCodeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignsListCode(code, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Used by all Partner user to retrive list of Campaign types
         * @summary List Campaign Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignsListType(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignsListTypeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignsListType(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create campaign program 
         * @summary Create a Campaign Program
         * @param {CampaignsProgramsCreateRequest} [campaignsProgramsCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignsProgramsCreate(campaignsProgramsCreateRequest?: CampaignsProgramsCreateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignsProgramsCreate(campaignsProgramsCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This api returns campaign program detail
         * @summary Get campaign program detail
         * @param {string} campaignProgramId Unique ID of campaign program (uuid format)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignsProgramsGetDetail(campaignProgramId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignsProgramsGetDetailRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignsProgramsGetDetail(campaignProgramId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Will return list of campaign program 
         * @summary List of Campaigns Programs
         * @param {string} [partnerId] 
         * @param {number} [version] 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignsProgramsGetList(partnerId?: string, version?: number, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignsProgramsGetList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignsProgramsGetList(partnerId, version, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Add new target to existing campaign program
         * @summary Add New Participant to A Campaign Program
         * @param {CampaignsProgramsGoldCreateRequest} [campaignsProgramsGoldCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignsProgramsGoldCreate(campaignsProgramsGoldCreateRequest?: CampaignsProgramsGoldCreateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignsProgramsGoldCreate(campaignsProgramsGoldCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Add New Target to a campaign participant
         * @summary Add New Target to a campaign participant
         * @param {Array<CampaignsProgramsGoldTargetAddRequestInner>} [campaignsProgramsGoldTargetAddRequestInner] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignsProgramsGoldTargetAdd(campaignsProgramsGoldTargetAddRequestInner?: Array<CampaignsProgramsGoldTargetAddRequestInner>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignsProgramsGoldTargetAdd(campaignsProgramsGoldTargetAddRequestInner, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get current campaign rank show in list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignsRankDetail(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignRankDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignsRankDetail(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Used by MemberApp inside Campaign Increment detail page to retrieve detail of its reward simulation.
         * @summary Simulation of Campaign Increment Reward
         * @param {number} [baseline] Baseline (Ton) for generate campaign calculation simulations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignsSimulationIncrement(baseline?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignsSimulationIncrementResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignsSimulationIncrement(baseline, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Will return list of Campaign Emas that is currently available.  The client will limit the number of items returned if there is a requirement to do that. 
         * @summary List of Campaign Golds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2CampaignsGoldList(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V2CampaignsGoldListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2CampaignsGoldList(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Used by MemberApp to get list of campaigns, filtered with current User ID.
         * @summary List of Campaigns V2
         * @param {Array<CampaignStatusEnum>} [status] 
         * @param {Array<string>} [type] Filled with campaign type ID (from Get Campaign Types). Default will show campaign type
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2CampaignsList(status?: Array<CampaignStatusEnum>, type?: Array<string>, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V2CampaignsListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2CampaignsList(status, type, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CampaignsApi - factory interface
 * @export
 */
export const CampaignsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CampaignsApiFp(configuration)
    return {
        /**
         * This endpoint will return detail data of b2c campaign 
         * @summary Campaign B2C card metadata
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignB2CCard(aPPTYPE: AppTypeEnum, options?: any): AxiosPromise<CampaignB2CCardResponse> {
            return localVarFp.campaignB2CCard(aPPTYPE, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint will return campaign detail data 
         * @summary Campaign B2C detail data
         * @param {string} campaignId Campaign B2C UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignB2CDetail(campaignId: string, options?: any): AxiosPromise<CampaignB2CDetailResponse> {
            return localVarFp.campaignB2CDetail(campaignId, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint returns list of harvest records
         * @summary Campaign B2C harvest records
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignB2CFarmersHarvestRecords(page?: number, limit?: number, options?: any): AxiosPromise<CampaignB2CFarmersHarvestRecordsResponse> {
            return localVarFp.campaignB2CFarmersHarvestRecords(page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint register a user to a campaign program b2c 
         * @param {string} campaignId Campaign B2C UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignB2CJoin(campaignId: string, options?: any): AxiosPromise<void> {
            return localVarFp.campaignB2CJoin(campaignId, options).then((request) => request(axios, basePath));
        },
        /**
         * Used by worker (Smallholder, Harvester, Driver)  The `role` property is used to identify which card (on FE) should be used.  
         * @summary Campaign Chain Delivery
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignsGetChainDelivery(aPPTYPE: AppTypeEnum, options?: any): AxiosPromise<CampaignGetChainDeliveryResponse> {
            return localVarFp.campaignsGetChainDelivery(aPPTYPE, options).then((request) => request(axios, basePath));
        },
        /**
         * Used by worker (Smallholder, Harvester, Driver)  The `role` property is used to identify which card (on FE) should be used.  And the `shareMessage` is used as the message body on invite user feature 
         * @summary Campaign Chain Delivery Detail
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {number} datetime Datetime for filtering data list. Use epoch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignsGetDetailChainDelivery(aPPTYPE: AppTypeEnum, datetime: number, options?: any): AxiosPromise<CampaignGetDetailChainDeliveryResponse> {
            return localVarFp.campaignsGetDetailChainDelivery(aPPTYPE, datetime, options).then((request) => request(axios, basePath));
        },
        /**
         * Will return list of Campaign Emas that is currently available.  The client will limit the number of items returned if there is a requirement to do that. 
         * @summary List of Campaign Golds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignsGoldList(options?: any): AxiosPromise<CampaignsGoldListResponse> {
            return localVarFp.campaignsGoldList(options).then((request) => request(axios, basePath));
        },
        /**
         * Will return user progress of Daily Campaign Emas. 
         * @summary The Daily Progress of Campaign Gold 2.0
         * @param {string} campaignGoldV2Id Campaign Gold UUID
         * @param {number} month Month in MM format
         * @param {number} year Year in YYYY format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignsGoldV2DailyProgress(campaignGoldV2Id: string, month: number, year: number, options?: any): AxiosPromise<CampaignsGoldV2DailyProgressResponse> {
            return localVarFp.campaignsGoldV2DailyProgress(campaignGoldV2Id, month, year, options).then((request) => request(axios, basePath));
        },
        /**
         * Will return detail of Campaign Emas that is currently available. 
         * @summary Detail of Campaign Gold 2.0
         * @param {string} campaignGoldV2Id Campaign Gold UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignsGoldV2Detail(campaignGoldV2Id: string, options?: any): AxiosPromise<CampaignsGoldV2DetailResponse> {
            return localVarFp.campaignsGoldV2Detail(campaignGoldV2Id, options).then((request) => request(axios, basePath));
        },
        /**
         * Will return list of users who have earned gold from Campaign Emas. 
         * @summary List of Leaderboard Campaign Golds 2.0
         * @param {string} [partnerId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignsGoldV2LeaderBoard(partnerId?: string, options?: any): AxiosPromise<CampaignsGoldV2LeaderBoardResponse> {
            return localVarFp.campaignsGoldV2LeaderBoard(partnerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Will return user progress of Monthly Campaign Emas. 
         * @summary The Monthly Progress of Campaign Gold 2.0
         * @param {string} campaignGoldV2Id Campaign Gold UUID
         * @param {number} month Month in MM format
         * @param {number} year Year in YYYY format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignsGoldV2MonthlyProgress(campaignGoldV2Id: string, month: number, year: number, options?: any): AxiosPromise<CampaignsGoldV2MonthlyProgressResponse> {
            return localVarFp.campaignsGoldV2MonthlyProgress(campaignGoldV2Id, month, year, options).then((request) => request(axios, basePath));
        },
        /**
         * Will return user progress of Quarterly Campaign Emas. 
         * @summary The Quarterly Progress of Campaign Gold 2.0
         * @param {string} campaignGoldV2Id Campaign Gold UUID
         * @param {number} month Month in MM format
         * @param {number} year Year in YYYY format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignsGoldV2QuarterlyProgress(campaignGoldV2Id: string, month: number, year: number, options?: any): AxiosPromise<CampaignsGoldV2QuarterlyProgressResponse> {
            return localVarFp.campaignsGoldV2QuarterlyProgress(campaignGoldV2Id, month, year, options).then((request) => request(axios, basePath));
        },
        /**
         * Used by MemberApp to get list of campaigns, filtered with current User ID. Will return list ordered by latest progress update & nearest campaign end date.
         * @summary List of Campaigns
         * @param {Array<CampaignStatusEnum>} [status] 
         * @param {Array<string>} [type] Filled with campaign type ID (from Get Campaign Types). Default will show campaign type
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignsList(status?: Array<CampaignStatusEnum>, type?: Array<string>, page?: number, limit?: number, options?: any): AxiosPromise<CampaignsListResponse> {
            return localVarFp.campaignsList(status, type, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Used by all Partner user to retrive list of Campaign codes (for tiering purpose)
         * @summary List Campaign Codes
         * @param {string} [code] Search query for campaign code by code name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignsListCode(code?: string, options?: any): AxiosPromise<CampaignListCodeResponse> {
            return localVarFp.campaignsListCode(code, options).then((request) => request(axios, basePath));
        },
        /**
         * Used by all Partner user to retrive list of Campaign types
         * @summary List Campaign Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignsListType(options?: any): AxiosPromise<CampaignsListTypeResponse> {
            return localVarFp.campaignsListType(options).then((request) => request(axios, basePath));
        },
        /**
         * Create campaign program 
         * @summary Create a Campaign Program
         * @param {CampaignsProgramsCreateRequest} [campaignsProgramsCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignsProgramsCreate(campaignsProgramsCreateRequest?: CampaignsProgramsCreateRequest, options?: any): AxiosPromise<void> {
            return localVarFp.campaignsProgramsCreate(campaignsProgramsCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This api returns campaign program detail
         * @summary Get campaign program detail
         * @param {string} campaignProgramId Unique ID of campaign program (uuid format)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignsProgramsGetDetail(campaignProgramId: string, options?: any): AxiosPromise<CampaignsProgramsGetDetailRequest> {
            return localVarFp.campaignsProgramsGetDetail(campaignProgramId, options).then((request) => request(axios, basePath));
        },
        /**
         * Will return list of campaign program 
         * @summary List of Campaigns Programs
         * @param {string} [partnerId] 
         * @param {number} [version] 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignsProgramsGetList(partnerId?: string, version?: number, page?: number, limit?: number, options?: any): AxiosPromise<CampaignsProgramsGetList> {
            return localVarFp.campaignsProgramsGetList(partnerId, version, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Add new target to existing campaign program
         * @summary Add New Participant to A Campaign Program
         * @param {CampaignsProgramsGoldCreateRequest} [campaignsProgramsGoldCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignsProgramsGoldCreate(campaignsProgramsGoldCreateRequest?: CampaignsProgramsGoldCreateRequest, options?: any): AxiosPromise<void> {
            return localVarFp.campaignsProgramsGoldCreate(campaignsProgramsGoldCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Add New Target to a campaign participant
         * @summary Add New Target to a campaign participant
         * @param {Array<CampaignsProgramsGoldTargetAddRequestInner>} [campaignsProgramsGoldTargetAddRequestInner] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignsProgramsGoldTargetAdd(campaignsProgramsGoldTargetAddRequestInner?: Array<CampaignsProgramsGoldTargetAddRequestInner>, options?: any): AxiosPromise<void> {
            return localVarFp.campaignsProgramsGoldTargetAdd(campaignsProgramsGoldTargetAddRequestInner, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get current campaign rank show in list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignsRankDetail(options?: any): AxiosPromise<CampaignRankDetailResponse> {
            return localVarFp.campaignsRankDetail(options).then((request) => request(axios, basePath));
        },
        /**
         * Used by MemberApp inside Campaign Increment detail page to retrieve detail of its reward simulation.
         * @summary Simulation of Campaign Increment Reward
         * @param {number} [baseline] Baseline (Ton) for generate campaign calculation simulations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignsSimulationIncrement(baseline?: number, options?: any): AxiosPromise<CampaignsSimulationIncrementResponse> {
            return localVarFp.campaignsSimulationIncrement(baseline, options).then((request) => request(axios, basePath));
        },
        /**
         * Will return list of Campaign Emas that is currently available.  The client will limit the number of items returned if there is a requirement to do that. 
         * @summary List of Campaign Golds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CampaignsGoldList(options?: any): AxiosPromise<V2CampaignsGoldListResponse> {
            return localVarFp.v2CampaignsGoldList(options).then((request) => request(axios, basePath));
        },
        /**
         * Used by MemberApp to get list of campaigns, filtered with current User ID.
         * @summary List of Campaigns V2
         * @param {Array<CampaignStatusEnum>} [status] 
         * @param {Array<string>} [type] Filled with campaign type ID (from Get Campaign Types). Default will show campaign type
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CampaignsList(status?: Array<CampaignStatusEnum>, type?: Array<string>, page?: number, limit?: number, options?: any): AxiosPromise<V2CampaignsListResponse> {
            return localVarFp.v2CampaignsList(status, type, page, limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CampaignsApi - object-oriented interface
 * @export
 * @class CampaignsApi
 * @extends {BaseAPI}
 */
export class CampaignsApi extends BaseAPI {
    /**
     * This endpoint will return detail data of b2c campaign 
     * @summary Campaign B2C card metadata
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignsApi
     */
    public campaignB2CCard(aPPTYPE: AppTypeEnum, options?: AxiosRequestConfig) {
        return CampaignsApiFp(this.configuration).campaignB2CCard(aPPTYPE, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint will return campaign detail data 
     * @summary Campaign B2C detail data
     * @param {string} campaignId Campaign B2C UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignsApi
     */
    public campaignB2CDetail(campaignId: string, options?: AxiosRequestConfig) {
        return CampaignsApiFp(this.configuration).campaignB2CDetail(campaignId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint returns list of harvest records
     * @summary Campaign B2C harvest records
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignsApi
     */
    public campaignB2CFarmersHarvestRecords(page?: number, limit?: number, options?: AxiosRequestConfig) {
        return CampaignsApiFp(this.configuration).campaignB2CFarmersHarvestRecords(page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint register a user to a campaign program b2c 
     * @param {string} campaignId Campaign B2C UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignsApi
     */
    public campaignB2CJoin(campaignId: string, options?: AxiosRequestConfig) {
        return CampaignsApiFp(this.configuration).campaignB2CJoin(campaignId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Used by worker (Smallholder, Harvester, Driver)  The `role` property is used to identify which card (on FE) should be used.  
     * @summary Campaign Chain Delivery
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignsApi
     */
    public campaignsGetChainDelivery(aPPTYPE: AppTypeEnum, options?: AxiosRequestConfig) {
        return CampaignsApiFp(this.configuration).campaignsGetChainDelivery(aPPTYPE, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Used by worker (Smallholder, Harvester, Driver)  The `role` property is used to identify which card (on FE) should be used.  And the `shareMessage` is used as the message body on invite user feature 
     * @summary Campaign Chain Delivery Detail
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {number} datetime Datetime for filtering data list. Use epoch
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignsApi
     */
    public campaignsGetDetailChainDelivery(aPPTYPE: AppTypeEnum, datetime: number, options?: AxiosRequestConfig) {
        return CampaignsApiFp(this.configuration).campaignsGetDetailChainDelivery(aPPTYPE, datetime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Will return list of Campaign Emas that is currently available.  The client will limit the number of items returned if there is a requirement to do that. 
     * @summary List of Campaign Golds
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignsApi
     */
    public campaignsGoldList(options?: AxiosRequestConfig) {
        return CampaignsApiFp(this.configuration).campaignsGoldList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Will return user progress of Daily Campaign Emas. 
     * @summary The Daily Progress of Campaign Gold 2.0
     * @param {string} campaignGoldV2Id Campaign Gold UUID
     * @param {number} month Month in MM format
     * @param {number} year Year in YYYY format
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignsApi
     */
    public campaignsGoldV2DailyProgress(campaignGoldV2Id: string, month: number, year: number, options?: AxiosRequestConfig) {
        return CampaignsApiFp(this.configuration).campaignsGoldV2DailyProgress(campaignGoldV2Id, month, year, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Will return detail of Campaign Emas that is currently available. 
     * @summary Detail of Campaign Gold 2.0
     * @param {string} campaignGoldV2Id Campaign Gold UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignsApi
     */
    public campaignsGoldV2Detail(campaignGoldV2Id: string, options?: AxiosRequestConfig) {
        return CampaignsApiFp(this.configuration).campaignsGoldV2Detail(campaignGoldV2Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Will return list of users who have earned gold from Campaign Emas. 
     * @summary List of Leaderboard Campaign Golds 2.0
     * @param {string} [partnerId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignsApi
     */
    public campaignsGoldV2LeaderBoard(partnerId?: string, options?: AxiosRequestConfig) {
        return CampaignsApiFp(this.configuration).campaignsGoldV2LeaderBoard(partnerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Will return user progress of Monthly Campaign Emas. 
     * @summary The Monthly Progress of Campaign Gold 2.0
     * @param {string} campaignGoldV2Id Campaign Gold UUID
     * @param {number} month Month in MM format
     * @param {number} year Year in YYYY format
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignsApi
     */
    public campaignsGoldV2MonthlyProgress(campaignGoldV2Id: string, month: number, year: number, options?: AxiosRequestConfig) {
        return CampaignsApiFp(this.configuration).campaignsGoldV2MonthlyProgress(campaignGoldV2Id, month, year, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Will return user progress of Quarterly Campaign Emas. 
     * @summary The Quarterly Progress of Campaign Gold 2.0
     * @param {string} campaignGoldV2Id Campaign Gold UUID
     * @param {number} month Month in MM format
     * @param {number} year Year in YYYY format
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignsApi
     */
    public campaignsGoldV2QuarterlyProgress(campaignGoldV2Id: string, month: number, year: number, options?: AxiosRequestConfig) {
        return CampaignsApiFp(this.configuration).campaignsGoldV2QuarterlyProgress(campaignGoldV2Id, month, year, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Used by MemberApp to get list of campaigns, filtered with current User ID. Will return list ordered by latest progress update & nearest campaign end date.
     * @summary List of Campaigns
     * @param {Array<CampaignStatusEnum>} [status] 
     * @param {Array<string>} [type] Filled with campaign type ID (from Get Campaign Types). Default will show campaign type
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignsApi
     */
    public campaignsList(status?: Array<CampaignStatusEnum>, type?: Array<string>, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return CampaignsApiFp(this.configuration).campaignsList(status, type, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Used by all Partner user to retrive list of Campaign codes (for tiering purpose)
     * @summary List Campaign Codes
     * @param {string} [code] Search query for campaign code by code name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignsApi
     */
    public campaignsListCode(code?: string, options?: AxiosRequestConfig) {
        return CampaignsApiFp(this.configuration).campaignsListCode(code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Used by all Partner user to retrive list of Campaign types
     * @summary List Campaign Types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignsApi
     */
    public campaignsListType(options?: AxiosRequestConfig) {
        return CampaignsApiFp(this.configuration).campaignsListType(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create campaign program 
     * @summary Create a Campaign Program
     * @param {CampaignsProgramsCreateRequest} [campaignsProgramsCreateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignsApi
     */
    public campaignsProgramsCreate(campaignsProgramsCreateRequest?: CampaignsProgramsCreateRequest, options?: AxiosRequestConfig) {
        return CampaignsApiFp(this.configuration).campaignsProgramsCreate(campaignsProgramsCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This api returns campaign program detail
     * @summary Get campaign program detail
     * @param {string} campaignProgramId Unique ID of campaign program (uuid format)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignsApi
     */
    public campaignsProgramsGetDetail(campaignProgramId: string, options?: AxiosRequestConfig) {
        return CampaignsApiFp(this.configuration).campaignsProgramsGetDetail(campaignProgramId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Will return list of campaign program 
     * @summary List of Campaigns Programs
     * @param {string} [partnerId] 
     * @param {number} [version] 
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignsApi
     */
    public campaignsProgramsGetList(partnerId?: string, version?: number, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return CampaignsApiFp(this.configuration).campaignsProgramsGetList(partnerId, version, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add new target to existing campaign program
     * @summary Add New Participant to A Campaign Program
     * @param {CampaignsProgramsGoldCreateRequest} [campaignsProgramsGoldCreateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignsApi
     */
    public campaignsProgramsGoldCreate(campaignsProgramsGoldCreateRequest?: CampaignsProgramsGoldCreateRequest, options?: AxiosRequestConfig) {
        return CampaignsApiFp(this.configuration).campaignsProgramsGoldCreate(campaignsProgramsGoldCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add New Target to a campaign participant
     * @summary Add New Target to a campaign participant
     * @param {Array<CampaignsProgramsGoldTargetAddRequestInner>} [campaignsProgramsGoldTargetAddRequestInner] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignsApi
     */
    public campaignsProgramsGoldTargetAdd(campaignsProgramsGoldTargetAddRequestInner?: Array<CampaignsProgramsGoldTargetAddRequestInner>, options?: AxiosRequestConfig) {
        return CampaignsApiFp(this.configuration).campaignsProgramsGoldTargetAdd(campaignsProgramsGoldTargetAddRequestInner, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get current campaign rank show in list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignsApi
     */
    public campaignsRankDetail(options?: AxiosRequestConfig) {
        return CampaignsApiFp(this.configuration).campaignsRankDetail(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Used by MemberApp inside Campaign Increment detail page to retrieve detail of its reward simulation.
     * @summary Simulation of Campaign Increment Reward
     * @param {number} [baseline] Baseline (Ton) for generate campaign calculation simulations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignsApi
     */
    public campaignsSimulationIncrement(baseline?: number, options?: AxiosRequestConfig) {
        return CampaignsApiFp(this.configuration).campaignsSimulationIncrement(baseline, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Will return list of Campaign Emas that is currently available.  The client will limit the number of items returned if there is a requirement to do that. 
     * @summary List of Campaign Golds
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignsApi
     */
    public v2CampaignsGoldList(options?: AxiosRequestConfig) {
        return CampaignsApiFp(this.configuration).v2CampaignsGoldList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Used by MemberApp to get list of campaigns, filtered with current User ID.
     * @summary List of Campaigns V2
     * @param {Array<CampaignStatusEnum>} [status] 
     * @param {Array<string>} [type] Filled with campaign type ID (from Get Campaign Types). Default will show campaign type
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignsApi
     */
    public v2CampaignsList(status?: Array<CampaignStatusEnum>, type?: Array<string>, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return CampaignsApiFp(this.configuration).v2CampaignsList(status, type, page, limit, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ChatApi - axios parameter creator
 * @export
 */
export const ChatApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This endpoint allows us to create a new conversation or retrieve an  existing one. It requires a parameter specifying the type of  conversation to create - such as bot, customer support, 1-1 private,  multi-user, or group/community chat.  Additional parameters are then needed, for instance, the recipient\'s  user ID for a 1-1 private conversation, or the group ID for a group  conversation.  If the conversation exists, this will create a new  conversation. This API accepts user\'s JWT for authenticated user or device ID in the header for unauthenticated user. 
         * @summary Create new or get existing chat conversation.
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {MessagingChatConversationsCreateOrGetRequest} messagingChatConversationsCreateOrGetRequest 
         * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingChatConversationsCreateOrGet: async (aPPTYPE: AppTypeEnum, messagingChatConversationsCreateOrGetRequest: MessagingChatConversationsCreateOrGetRequest, xFIREBASEINSTALLATIONID?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('messagingChatConversationsCreateOrGet', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'messagingChatConversationsCreateOrGetRequest' is not null or undefined
            assertParamExists('messagingChatConversationsCreateOrGet', 'messagingChatConversationsCreateOrGetRequest', messagingChatConversationsCreateOrGetRequest)
            const localVarPath = `/api/v1/messaging/chat/conversations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }

            if (xFIREBASEINSTALLATIONID != null) {
                localVarHeaderParameter['X-FIREBASE-INSTALLATION-ID'] = String(xFIREBASEINSTALLATIONID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(messagingChatConversationsCreateOrGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This API is used to get list of recent chat conversation. This API accepts user\'s JWT for authenticated user or device ID in the header for unauthenticated user. 
         * @summary List of recent chat conversation.
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {number} [since] The timestamp to start the list of messages from.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingChatConversationsList: async (aPPTYPE: AppTypeEnum, xFIREBASEINSTALLATIONID?: string, page?: number, limit?: number, since?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('messagingChatConversationsList', 'aPPTYPE', aPPTYPE)
            const localVarPath = `/api/v1/messaging/chat/conversations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (since !== undefined) {
                localVarQueryParameter['since'] = since;
            }

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }

            if (xFIREBASEINSTALLATIONID != null) {
                localVarHeaderParameter['X-FIREBASE-INSTALLATION-ID'] = String(xFIREBASEINSTALLATIONID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This API is used to create a new chat message in a conversation. This API accepts user\'s JWT for authenticated user or device ID in the header for unauthenticated user. 
         * @summary Create a new chat message in a conversation.
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} conversationId Chat conversation UUID
         * @param {MessagingChatConversationsMessagesCreateRequest} messagingChatConversationsMessagesCreateRequest 
         * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingChatConversationsMessagesCreate: async (aPPTYPE: AppTypeEnum, conversationId: string, messagingChatConversationsMessagesCreateRequest: MessagingChatConversationsMessagesCreateRequest, xFIREBASEINSTALLATIONID?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('messagingChatConversationsMessagesCreate', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('messagingChatConversationsMessagesCreate', 'conversationId', conversationId)
            // verify required parameter 'messagingChatConversationsMessagesCreateRequest' is not null or undefined
            assertParamExists('messagingChatConversationsMessagesCreate', 'messagingChatConversationsMessagesCreateRequest', messagingChatConversationsMessagesCreateRequest)
            const localVarPath = `/api/v1/messaging/chat/conversations/{conversationId}/messages`
                .replace(`{${"conversationId"}}`, encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }

            if (xFIREBASEINSTALLATIONID != null) {
                localVarHeaderParameter['X-FIREBASE-INSTALLATION-ID'] = String(xFIREBASEINSTALLATIONID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(messagingChatConversationsMessagesCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This API is used to get list of recent chat messages in a conversation.  This API accepts user\'s JWT for authenticated user or device ID in the  header for unauthenticated user. 
         * @summary List of recent chat messages in a conversation.
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} conversationId Chat conversation UUID
         * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {number} [since] The timestamp to start the list of messages from.
         * @param {number} [until] The timestamp to end the list of messages returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingChatConversationsMessagesList: async (aPPTYPE: AppTypeEnum, conversationId: string, xFIREBASEINSTALLATIONID?: string, page?: number, limit?: number, since?: number, until?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('messagingChatConversationsMessagesList', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('messagingChatConversationsMessagesList', 'conversationId', conversationId)
            const localVarPath = `/api/v1/messaging/chat/conversations/{conversationId}/messages`
                .replace(`{${"conversationId"}}`, encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (since !== undefined) {
                localVarQueryParameter['since'] = since;
            }

            if (until !== undefined) {
                localVarQueryParameter['until'] = until;
            }

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }

            if (xFIREBASEINSTALLATIONID != null) {
                localVarHeaderParameter['X-FIREBASE-INSTALLATION-ID'] = String(xFIREBASEINSTALLATIONID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This API is used to post offline messages. This API accepts JWT for authenticated user or device ID in the header for unauthenticated user. 
         * @summary Post offline messages for synchronization
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} conversationId Chat conversation UUID
         * @param {MessagingChatConversationsPostOfflineMessagesRequest} messagingChatConversationsPostOfflineMessagesRequest 
         * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingChatConversationsPostOfflineMessages: async (aPPTYPE: AppTypeEnum, conversationId: string, messagingChatConversationsPostOfflineMessagesRequest: MessagingChatConversationsPostOfflineMessagesRequest, xFIREBASEINSTALLATIONID?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('messagingChatConversationsPostOfflineMessages', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('messagingChatConversationsPostOfflineMessages', 'conversationId', conversationId)
            // verify required parameter 'messagingChatConversationsPostOfflineMessagesRequest' is not null or undefined
            assertParamExists('messagingChatConversationsPostOfflineMessages', 'messagingChatConversationsPostOfflineMessagesRequest', messagingChatConversationsPostOfflineMessagesRequest)
            const localVarPath = `/api/v1/messaging/chat/conversations/{conversationId}/messages/offline`
                .replace(`{${"conversationId"}}`, encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }

            if (xFIREBASEINSTALLATIONID != null) {
                localVarHeaderParameter['X-FIREBASE-INSTALLATION-ID'] = String(xFIREBASEINSTALLATIONID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(messagingChatConversationsPostOfflineMessagesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Websocket stream. This will allow app to send message and receive new  messages without the overhead of new HTTP connection request. This  endpoint will receive 1 query parameter stream ID.  This endpoint accepts user\'s JWT for authenticated user or device ID in the header for unauthenticated user. 
         * @summary Provides websocket path for streaming chat conversation.
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} streamId Stream ID
         * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingChatConversationsStream: async (aPPTYPE: AppTypeEnum, streamId: string, xFIREBASEINSTALLATIONID?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('messagingChatConversationsStream', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'streamId' is not null or undefined
            assertParamExists('messagingChatConversationsStream', 'streamId', streamId)
            const localVarPath = `/api/v1/messaging/chat/conversations/stream`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (streamId !== undefined) {
                localVarQueryParameter['streamId'] = streamId;
            }

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }

            if (xFIREBASEINSTALLATIONID != null) {
                localVarHeaderParameter['X-FIREBASE-INSTALLATION-ID'] = String(xFIREBASEINSTALLATIONID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This API is used to create a new chat websocket stream for a  conversation. This will return the URL of the stream.  We will return the URL instead of the stream ID so in the future we  have the flexibility on separating the engine for better performance. This API accepts user\'s JWT for authenticated user or device ID in the  header for unauthenticated user. 
         * @summary Create a new chat stream in a conversation.
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} conversationId Chat conversation UUID
         * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingChatConversationsStreamCreate: async (aPPTYPE: AppTypeEnum, conversationId: string, xFIREBASEINSTALLATIONID?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('messagingChatConversationsStreamCreate', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('messagingChatConversationsStreamCreate', 'conversationId', conversationId)
            const localVarPath = `/api/v1/messaging/chat/conversations/{conversationId}/stream`
                .replace(`{${"conversationId"}}`, encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }

            if (xFIREBASEINSTALLATIONID != null) {
                localVarHeaderParameter['X-FIREBASE-INSTALLATION-ID'] = String(xFIREBASEINSTALLATIONID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChatApi - functional programming interface
 * @export
 */
export const ChatApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChatApiAxiosParamCreator(configuration)
    return {
        /**
         * This endpoint allows us to create a new conversation or retrieve an  existing one. It requires a parameter specifying the type of  conversation to create - such as bot, customer support, 1-1 private,  multi-user, or group/community chat.  Additional parameters are then needed, for instance, the recipient\'s  user ID for a 1-1 private conversation, or the group ID for a group  conversation.  If the conversation exists, this will create a new  conversation. This API accepts user\'s JWT for authenticated user or device ID in the header for unauthenticated user. 
         * @summary Create new or get existing chat conversation.
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {MessagingChatConversationsCreateOrGetRequest} messagingChatConversationsCreateOrGetRequest 
         * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async messagingChatConversationsCreateOrGet(aPPTYPE: AppTypeEnum, messagingChatConversationsCreateOrGetRequest: MessagingChatConversationsCreateOrGetRequest, xFIREBASEINSTALLATIONID?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessagingChatConversation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.messagingChatConversationsCreateOrGet(aPPTYPE, messagingChatConversationsCreateOrGetRequest, xFIREBASEINSTALLATIONID, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This API is used to get list of recent chat conversation. This API accepts user\'s JWT for authenticated user or device ID in the header for unauthenticated user. 
         * @summary List of recent chat conversation.
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {number} [since] The timestamp to start the list of messages from.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async messagingChatConversationsList(aPPTYPE: AppTypeEnum, xFIREBASEINSTALLATIONID?: string, page?: number, limit?: number, since?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessagingChatConversationsListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.messagingChatConversationsList(aPPTYPE, xFIREBASEINSTALLATIONID, page, limit, since, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This API is used to create a new chat message in a conversation. This API accepts user\'s JWT for authenticated user or device ID in the header for unauthenticated user. 
         * @summary Create a new chat message in a conversation.
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} conversationId Chat conversation UUID
         * @param {MessagingChatConversationsMessagesCreateRequest} messagingChatConversationsMessagesCreateRequest 
         * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async messagingChatConversationsMessagesCreate(aPPTYPE: AppTypeEnum, conversationId: string, messagingChatConversationsMessagesCreateRequest: MessagingChatConversationsMessagesCreateRequest, xFIREBASEINSTALLATIONID?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessagingChatMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.messagingChatConversationsMessagesCreate(aPPTYPE, conversationId, messagingChatConversationsMessagesCreateRequest, xFIREBASEINSTALLATIONID, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This API is used to get list of recent chat messages in a conversation.  This API accepts user\'s JWT for authenticated user or device ID in the  header for unauthenticated user. 
         * @summary List of recent chat messages in a conversation.
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} conversationId Chat conversation UUID
         * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {number} [since] The timestamp to start the list of messages from.
         * @param {number} [until] The timestamp to end the list of messages returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async messagingChatConversationsMessagesList(aPPTYPE: AppTypeEnum, conversationId: string, xFIREBASEINSTALLATIONID?: string, page?: number, limit?: number, since?: number, until?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessagingChatConversationsMessagesListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.messagingChatConversationsMessagesList(aPPTYPE, conversationId, xFIREBASEINSTALLATIONID, page, limit, since, until, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This API is used to post offline messages. This API accepts JWT for authenticated user or device ID in the header for unauthenticated user. 
         * @summary Post offline messages for synchronization
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} conversationId Chat conversation UUID
         * @param {MessagingChatConversationsPostOfflineMessagesRequest} messagingChatConversationsPostOfflineMessagesRequest 
         * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async messagingChatConversationsPostOfflineMessages(aPPTYPE: AppTypeEnum, conversationId: string, messagingChatConversationsPostOfflineMessagesRequest: MessagingChatConversationsPostOfflineMessagesRequest, xFIREBASEINSTALLATIONID?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessagingChatConversationsPostOfflineMessagesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.messagingChatConversationsPostOfflineMessages(aPPTYPE, conversationId, messagingChatConversationsPostOfflineMessagesRequest, xFIREBASEINSTALLATIONID, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Websocket stream. This will allow app to send message and receive new  messages without the overhead of new HTTP connection request. This  endpoint will receive 1 query parameter stream ID.  This endpoint accepts user\'s JWT for authenticated user or device ID in the header for unauthenticated user. 
         * @summary Provides websocket path for streaming chat conversation.
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} streamId Stream ID
         * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async messagingChatConversationsStream(aPPTYPE: AppTypeEnum, streamId: string, xFIREBASEINSTALLATIONID?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.messagingChatConversationsStream(aPPTYPE, streamId, xFIREBASEINSTALLATIONID, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This API is used to create a new chat websocket stream for a  conversation. This will return the URL of the stream.  We will return the URL instead of the stream ID so in the future we  have the flexibility on separating the engine for better performance. This API accepts user\'s JWT for authenticated user or device ID in the  header for unauthenticated user. 
         * @summary Create a new chat stream in a conversation.
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} conversationId Chat conversation UUID
         * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async messagingChatConversationsStreamCreate(aPPTYPE: AppTypeEnum, conversationId: string, xFIREBASEINSTALLATIONID?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessagingChatConversationsStreamCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.messagingChatConversationsStreamCreate(aPPTYPE, conversationId, xFIREBASEINSTALLATIONID, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ChatApi - factory interface
 * @export
 */
export const ChatApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChatApiFp(configuration)
    return {
        /**
         * This endpoint allows us to create a new conversation or retrieve an  existing one. It requires a parameter specifying the type of  conversation to create - such as bot, customer support, 1-1 private,  multi-user, or group/community chat.  Additional parameters are then needed, for instance, the recipient\'s  user ID for a 1-1 private conversation, or the group ID for a group  conversation.  If the conversation exists, this will create a new  conversation. This API accepts user\'s JWT for authenticated user or device ID in the header for unauthenticated user. 
         * @summary Create new or get existing chat conversation.
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {MessagingChatConversationsCreateOrGetRequest} messagingChatConversationsCreateOrGetRequest 
         * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingChatConversationsCreateOrGet(aPPTYPE: AppTypeEnum, messagingChatConversationsCreateOrGetRequest: MessagingChatConversationsCreateOrGetRequest, xFIREBASEINSTALLATIONID?: string, options?: any): AxiosPromise<MessagingChatConversation> {
            return localVarFp.messagingChatConversationsCreateOrGet(aPPTYPE, messagingChatConversationsCreateOrGetRequest, xFIREBASEINSTALLATIONID, options).then((request) => request(axios, basePath));
        },
        /**
         * This API is used to get list of recent chat conversation. This API accepts user\'s JWT for authenticated user or device ID in the header for unauthenticated user. 
         * @summary List of recent chat conversation.
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {number} [since] The timestamp to start the list of messages from.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingChatConversationsList(aPPTYPE: AppTypeEnum, xFIREBASEINSTALLATIONID?: string, page?: number, limit?: number, since?: number, options?: any): AxiosPromise<MessagingChatConversationsListResponse> {
            return localVarFp.messagingChatConversationsList(aPPTYPE, xFIREBASEINSTALLATIONID, page, limit, since, options).then((request) => request(axios, basePath));
        },
        /**
         * This API is used to create a new chat message in a conversation. This API accepts user\'s JWT for authenticated user or device ID in the header for unauthenticated user. 
         * @summary Create a new chat message in a conversation.
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} conversationId Chat conversation UUID
         * @param {MessagingChatConversationsMessagesCreateRequest} messagingChatConversationsMessagesCreateRequest 
         * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingChatConversationsMessagesCreate(aPPTYPE: AppTypeEnum, conversationId: string, messagingChatConversationsMessagesCreateRequest: MessagingChatConversationsMessagesCreateRequest, xFIREBASEINSTALLATIONID?: string, options?: any): AxiosPromise<MessagingChatMessage> {
            return localVarFp.messagingChatConversationsMessagesCreate(aPPTYPE, conversationId, messagingChatConversationsMessagesCreateRequest, xFIREBASEINSTALLATIONID, options).then((request) => request(axios, basePath));
        },
        /**
         * This API is used to get list of recent chat messages in a conversation.  This API accepts user\'s JWT for authenticated user or device ID in the  header for unauthenticated user. 
         * @summary List of recent chat messages in a conversation.
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} conversationId Chat conversation UUID
         * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {number} [since] The timestamp to start the list of messages from.
         * @param {number} [until] The timestamp to end the list of messages returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingChatConversationsMessagesList(aPPTYPE: AppTypeEnum, conversationId: string, xFIREBASEINSTALLATIONID?: string, page?: number, limit?: number, since?: number, until?: number, options?: any): AxiosPromise<MessagingChatConversationsMessagesListResponse> {
            return localVarFp.messagingChatConversationsMessagesList(aPPTYPE, conversationId, xFIREBASEINSTALLATIONID, page, limit, since, until, options).then((request) => request(axios, basePath));
        },
        /**
         * This API is used to post offline messages. This API accepts JWT for authenticated user or device ID in the header for unauthenticated user. 
         * @summary Post offline messages for synchronization
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} conversationId Chat conversation UUID
         * @param {MessagingChatConversationsPostOfflineMessagesRequest} messagingChatConversationsPostOfflineMessagesRequest 
         * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingChatConversationsPostOfflineMessages(aPPTYPE: AppTypeEnum, conversationId: string, messagingChatConversationsPostOfflineMessagesRequest: MessagingChatConversationsPostOfflineMessagesRequest, xFIREBASEINSTALLATIONID?: string, options?: any): AxiosPromise<MessagingChatConversationsPostOfflineMessagesResponse> {
            return localVarFp.messagingChatConversationsPostOfflineMessages(aPPTYPE, conversationId, messagingChatConversationsPostOfflineMessagesRequest, xFIREBASEINSTALLATIONID, options).then((request) => request(axios, basePath));
        },
        /**
         * Websocket stream. This will allow app to send message and receive new  messages without the overhead of new HTTP connection request. This  endpoint will receive 1 query parameter stream ID.  This endpoint accepts user\'s JWT for authenticated user or device ID in the header for unauthenticated user. 
         * @summary Provides websocket path for streaming chat conversation.
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} streamId Stream ID
         * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingChatConversationsStream(aPPTYPE: AppTypeEnum, streamId: string, xFIREBASEINSTALLATIONID?: string, options?: any): AxiosPromise<object> {
            return localVarFp.messagingChatConversationsStream(aPPTYPE, streamId, xFIREBASEINSTALLATIONID, options).then((request) => request(axios, basePath));
        },
        /**
         * This API is used to create a new chat websocket stream for a  conversation. This will return the URL of the stream.  We will return the URL instead of the stream ID so in the future we  have the flexibility on separating the engine for better performance. This API accepts user\'s JWT for authenticated user or device ID in the  header for unauthenticated user. 
         * @summary Create a new chat stream in a conversation.
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} conversationId Chat conversation UUID
         * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingChatConversationsStreamCreate(aPPTYPE: AppTypeEnum, conversationId: string, xFIREBASEINSTALLATIONID?: string, options?: any): AxiosPromise<MessagingChatConversationsStreamCreateResponse> {
            return localVarFp.messagingChatConversationsStreamCreate(aPPTYPE, conversationId, xFIREBASEINSTALLATIONID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ChatApi - object-oriented interface
 * @export
 * @class ChatApi
 * @extends {BaseAPI}
 */
export class ChatApi extends BaseAPI {
    /**
     * This endpoint allows us to create a new conversation or retrieve an  existing one. It requires a parameter specifying the type of  conversation to create - such as bot, customer support, 1-1 private,  multi-user, or group/community chat.  Additional parameters are then needed, for instance, the recipient\'s  user ID for a 1-1 private conversation, or the group ID for a group  conversation.  If the conversation exists, this will create a new  conversation. This API accepts user\'s JWT for authenticated user or device ID in the header for unauthenticated user. 
     * @summary Create new or get existing chat conversation.
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {MessagingChatConversationsCreateOrGetRequest} messagingChatConversationsCreateOrGetRequest 
     * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public messagingChatConversationsCreateOrGet(aPPTYPE: AppTypeEnum, messagingChatConversationsCreateOrGetRequest: MessagingChatConversationsCreateOrGetRequest, xFIREBASEINSTALLATIONID?: string, options?: AxiosRequestConfig) {
        return ChatApiFp(this.configuration).messagingChatConversationsCreateOrGet(aPPTYPE, messagingChatConversationsCreateOrGetRequest, xFIREBASEINSTALLATIONID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This API is used to get list of recent chat conversation. This API accepts user\'s JWT for authenticated user or device ID in the header for unauthenticated user. 
     * @summary List of recent chat conversation.
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {number} [since] The timestamp to start the list of messages from.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public messagingChatConversationsList(aPPTYPE: AppTypeEnum, xFIREBASEINSTALLATIONID?: string, page?: number, limit?: number, since?: number, options?: AxiosRequestConfig) {
        return ChatApiFp(this.configuration).messagingChatConversationsList(aPPTYPE, xFIREBASEINSTALLATIONID, page, limit, since, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This API is used to create a new chat message in a conversation. This API accepts user\'s JWT for authenticated user or device ID in the header for unauthenticated user. 
     * @summary Create a new chat message in a conversation.
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} conversationId Chat conversation UUID
     * @param {MessagingChatConversationsMessagesCreateRequest} messagingChatConversationsMessagesCreateRequest 
     * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public messagingChatConversationsMessagesCreate(aPPTYPE: AppTypeEnum, conversationId: string, messagingChatConversationsMessagesCreateRequest: MessagingChatConversationsMessagesCreateRequest, xFIREBASEINSTALLATIONID?: string, options?: AxiosRequestConfig) {
        return ChatApiFp(this.configuration).messagingChatConversationsMessagesCreate(aPPTYPE, conversationId, messagingChatConversationsMessagesCreateRequest, xFIREBASEINSTALLATIONID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This API is used to get list of recent chat messages in a conversation.  This API accepts user\'s JWT for authenticated user or device ID in the  header for unauthenticated user. 
     * @summary List of recent chat messages in a conversation.
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} conversationId Chat conversation UUID
     * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {number} [since] The timestamp to start the list of messages from.
     * @param {number} [until] The timestamp to end the list of messages returned.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public messagingChatConversationsMessagesList(aPPTYPE: AppTypeEnum, conversationId: string, xFIREBASEINSTALLATIONID?: string, page?: number, limit?: number, since?: number, until?: number, options?: AxiosRequestConfig) {
        return ChatApiFp(this.configuration).messagingChatConversationsMessagesList(aPPTYPE, conversationId, xFIREBASEINSTALLATIONID, page, limit, since, until, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This API is used to post offline messages. This API accepts JWT for authenticated user or device ID in the header for unauthenticated user. 
     * @summary Post offline messages for synchronization
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} conversationId Chat conversation UUID
     * @param {MessagingChatConversationsPostOfflineMessagesRequest} messagingChatConversationsPostOfflineMessagesRequest 
     * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public messagingChatConversationsPostOfflineMessages(aPPTYPE: AppTypeEnum, conversationId: string, messagingChatConversationsPostOfflineMessagesRequest: MessagingChatConversationsPostOfflineMessagesRequest, xFIREBASEINSTALLATIONID?: string, options?: AxiosRequestConfig) {
        return ChatApiFp(this.configuration).messagingChatConversationsPostOfflineMessages(aPPTYPE, conversationId, messagingChatConversationsPostOfflineMessagesRequest, xFIREBASEINSTALLATIONID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Websocket stream. This will allow app to send message and receive new  messages without the overhead of new HTTP connection request. This  endpoint will receive 1 query parameter stream ID.  This endpoint accepts user\'s JWT for authenticated user or device ID in the header for unauthenticated user. 
     * @summary Provides websocket path for streaming chat conversation.
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} streamId Stream ID
     * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public messagingChatConversationsStream(aPPTYPE: AppTypeEnum, streamId: string, xFIREBASEINSTALLATIONID?: string, options?: AxiosRequestConfig) {
        return ChatApiFp(this.configuration).messagingChatConversationsStream(aPPTYPE, streamId, xFIREBASEINSTALLATIONID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This API is used to create a new chat websocket stream for a  conversation. This will return the URL of the stream.  We will return the URL instead of the stream ID so in the future we  have the flexibility on separating the engine for better performance. This API accepts user\'s JWT for authenticated user or device ID in the  header for unauthenticated user. 
     * @summary Create a new chat stream in a conversation.
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} conversationId Chat conversation UUID
     * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public messagingChatConversationsStreamCreate(aPPTYPE: AppTypeEnum, conversationId: string, xFIREBASEINSTALLATIONID?: string, options?: AxiosRequestConfig) {
        return ChatApiFp(this.configuration).messagingChatConversationsStreamCreate(aPPTYPE, conversationId, xFIREBASEINSTALLATIONID, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ContactsApi - axios parameter creator
 * @export
 */
export const ContactsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get contacts will return contacts data in the same business as the current user  with ability to filter by job name 
         * @summary Get contacts
         * @param {JobNameEnum} [jobName] name of job
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContacts: async (jobName?: JobNameEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/contacts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (jobName !== undefined) {
                localVarQueryParameter['jobName'] = jobName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get contacts will return contacts data connected with the current Supplier
         * @summary Get Suppliers\' Contacts
         * @param {string} [supplierId] Supplier ID in UUID type 4 format. Won\&#39;t filter by supplier if not provided
         * @param {JobNameEnum} [job] If present, will filter the data based on provided job
         * @param {number} [limit] Number of items per page.
         * @param {number} [page] Current page number to be accessed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuppliersContacts: async (supplierId?: string, job?: JobNameEnum, limit?: number, page?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/suppliers/contacts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (supplierId !== undefined) {
                localVarQueryParameter['supplierId'] = supplierId;
            }

            if (job !== undefined) {
                localVarQueryParameter['job'] = job;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContactsApi - functional programming interface
 * @export
 */
export const ContactsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContactsApiAxiosParamCreator(configuration)
    return {
        /**
         * Get contacts will return contacts data in the same business as the current user  with ability to filter by job name 
         * @summary Get contacts
         * @param {JobNameEnum} [jobName] name of job
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContacts(jobName?: JobNameEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetContactsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContacts(jobName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get contacts will return contacts data connected with the current Supplier
         * @summary Get Suppliers\' Contacts
         * @param {string} [supplierId] Supplier ID in UUID type 4 format. Won\&#39;t filter by supplier if not provided
         * @param {JobNameEnum} [job] If present, will filter the data based on provided job
         * @param {number} [limit] Number of items per page.
         * @param {number} [page] Current page number to be accessed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSuppliersContacts(supplierId?: string, job?: JobNameEnum, limit?: number, page?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSuppliersContactsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSuppliersContacts(supplierId, job, limit, page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ContactsApi - factory interface
 * @export
 */
export const ContactsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContactsApiFp(configuration)
    return {
        /**
         * Get contacts will return contacts data in the same business as the current user  with ability to filter by job name 
         * @summary Get contacts
         * @param {JobNameEnum} [jobName] name of job
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContacts(jobName?: JobNameEnum, options?: any): AxiosPromise<GetContactsResponse> {
            return localVarFp.getContacts(jobName, options).then((request) => request(axios, basePath));
        },
        /**
         * Get contacts will return contacts data connected with the current Supplier
         * @summary Get Suppliers\' Contacts
         * @param {string} [supplierId] Supplier ID in UUID type 4 format. Won\&#39;t filter by supplier if not provided
         * @param {JobNameEnum} [job] If present, will filter the data based on provided job
         * @param {number} [limit] Number of items per page.
         * @param {number} [page] Current page number to be accessed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuppliersContacts(supplierId?: string, job?: JobNameEnum, limit?: number, page?: number, options?: any): AxiosPromise<GetSuppliersContactsResponse> {
            return localVarFp.getSuppliersContacts(supplierId, job, limit, page, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ContactsApi - object-oriented interface
 * @export
 * @class ContactsApi
 * @extends {BaseAPI}
 */
export class ContactsApi extends BaseAPI {
    /**
     * Get contacts will return contacts data in the same business as the current user  with ability to filter by job name 
     * @summary Get contacts
     * @param {JobNameEnum} [jobName] name of job
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    public getContacts(jobName?: JobNameEnum, options?: AxiosRequestConfig) {
        return ContactsApiFp(this.configuration).getContacts(jobName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get contacts will return contacts data connected with the current Supplier
     * @summary Get Suppliers\' Contacts
     * @param {string} [supplierId] Supplier ID in UUID type 4 format. Won\&#39;t filter by supplier if not provided
     * @param {JobNameEnum} [job] If present, will filter the data based on provided job
     * @param {number} [limit] Number of items per page.
     * @param {number} [page] Current page number to be accessed.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    public getSuppliersContacts(supplierId?: string, job?: JobNameEnum, limit?: number, page?: number, options?: AxiosRequestConfig) {
        return ContactsApiFp(this.configuration).getSuppliersContacts(supplierId, job, limit, page, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * EcommerceApi - axios parameter creator
 * @export
 */
export const EcommerceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Admins can able create product pricelist
         * @summary Create product pricelist
         * @param {AdminsEcommerceProductPriceListsCreateRequest} [adminsEcommerceProductPriceListsCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsEcommerceProductPriceListsCreate: async (adminsEcommerceProductPriceListsCreateRequest?: AdminsEcommerceProductPriceListsCreateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admins/ecommerce/product/pricelist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminsEcommerceProductPriceListsCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * admins can able to update product pricelist
         * @summary Update product pricelist
         * @param {string} pricelistId Pricelist UUID
         * @param {AdminsEcommerceProductPriceListsUpdateRequest} [adminsEcommerceProductPriceListsUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsEcommerceProductPriceListsUpdate: async (pricelistId: string, adminsEcommerceProductPriceListsUpdateRequest?: AdminsEcommerceProductPriceListsUpdateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pricelistId' is not null or undefined
            assertParamExists('adminsEcommerceProductPriceListsUpdate', 'pricelistId', pricelistId)
            const localVarPath = `/api/v1/admins/ecommerce/product/pricelist/{pricelistId}`
                .replace(`{${"pricelistId"}}`, encodeURIComponent(String(pricelistId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminsEcommerceProductPriceListsUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * admins can be able to update product pricelist
         * @summary Update product pricelist V2
         * @param {AdminsEcommerceProductPriceListsUpdateV2Request} [adminsEcommerceProductPriceListsUpdateV2Request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsEcommerceProductPriceListsUpdateV2: async (adminsEcommerceProductPriceListsUpdateV2Request?: AdminsEcommerceProductPriceListsUpdateV2Request, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/admins/ecommerce/product/pricelist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminsEcommerceProductPriceListsUpdateV2Request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Used by MemberApp to create cart data for user 
         * @summary Create cart data for user
         * @param {CartCreateRequest} cartCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartCreate: async (cartCreateRequest: CartCreateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cartCreateRequest' is not null or undefined
            assertParamExists('cartCreate', 'cartCreateRequest', cartCreateRequest)
            const localVarPath = `/api/v1/carts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cartCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Used by MemberApp to get cart data for user 
         * @summary Get cart data for user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartsGetDetail: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/carts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Product SKU Count in One Cart
         * @summary Get Total Product SKU of Cart
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartsGetProductCount: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/carts/products/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Used by MemberApp to remove product from active cart 
         * @summary Remove product from cart
         * @param {string} cartItemId Cart Item UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartsItemsDelete: async (cartItemId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cartItemId' is not null or undefined
            assertParamExists('cartsItemsDelete', 'cartItemId', cartItemId)
            const localVarPath = `/api/v1/carts/items/{cartItemId}`
                .replace(`{${"cartItemId"}}`, encodeURIComponent(String(cartItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * this is for getting eligible vendor list of coupon
         * @summary Get Eligible Vendor of Coupon
         * @param {string} couponId coupon Id
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ecommerceCouponGetVendorList: async (couponId: string, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'couponId' is not null or undefined
            assertParamExists('ecommerceCouponGetVendorList', 'couponId', couponId)
            const localVarPath = `/api/v1/ecommerce/products/digitals/coupons/{couponId}/vendors`
                .replace(`{${"couponId"}}`, encodeURIComponent(String(couponId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * this is for getting eligible vendor list of coupon
         * @summary Redeem coupon
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {EcommerceCouponsRedeemRequest} ecommerceCouponsRedeemRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ecommerceCouponsRedeem: async (aPPTYPE: AppTypeEnum, ecommerceCouponsRedeemRequest: EcommerceCouponsRedeemRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('ecommerceCouponsRedeem', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'ecommerceCouponsRedeemRequest' is not null or undefined
            assertParamExists('ecommerceCouponsRedeem', 'ecommerceCouponsRedeemRequest', ecommerceCouponsRedeemRequest)
            const localVarPath = `/api/v1/ecommerce/products/digitals/coupons/redeem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ecommerceCouponsRedeemRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get list of pick up locations 
         * @summary Get List of Pick Up Location
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} [zoneId] zone id in uuid format
         * @param {number} [longitude] longitude of current user
         * @param {number} [latitude] latitude of current user
         * @param {number} [limit] Number of items per page.
         * @param {number} [page] Current page number to be accessed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ecommerceDeliveriesPickUpsGetPickUpLocations: async (aPPTYPE: AppTypeEnum, zoneId?: string, longitude?: number, latitude?: number, limit?: number, page?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('ecommerceDeliveriesPickUpsGetPickUpLocations', 'aPPTYPE', aPPTYPE)
            const localVarPath = `/api/v1/ecommerce/deliveries/pick-ups/locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (zoneId !== undefined) {
                localVarQueryParameter['zoneId'] = zoneId;
            }

            if (longitude !== undefined) {
                localVarQueryParameter['longitude'] = longitude;
            }

            if (latitude !== undefined) {
                localVarQueryParameter['latitude'] = latitude;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * this is for verify that coupon is eligible or not for that vendor
         * @summary Ecommerce Get Coupons Verify
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} couponCode coupon code
         * @param {QRCodeSourceEnum} qrcodeSource qrcode source, this getting from scanner from web or mobile
         * @param {string} qrcodeValue qrcode value, this value of qrcode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ecommerceGetCouponsVerify: async (aPPTYPE: AppTypeEnum, couponCode: string, qrcodeSource: QRCodeSourceEnum, qrcodeValue: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('ecommerceGetCouponsVerify', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'couponCode' is not null or undefined
            assertParamExists('ecommerceGetCouponsVerify', 'couponCode', couponCode)
            // verify required parameter 'qrcodeSource' is not null or undefined
            assertParamExists('ecommerceGetCouponsVerify', 'qrcodeSource', qrcodeSource)
            // verify required parameter 'qrcodeValue' is not null or undefined
            assertParamExists('ecommerceGetCouponsVerify', 'qrcodeValue', qrcodeValue)
            const localVarPath = `/api/v1/ecommerce/products/digitals/coupons/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (couponCode !== undefined) {
                localVarQueryParameter['couponCode'] = couponCode;
            }

            if (qrcodeSource !== undefined) {
                localVarQueryParameter['qrcodeSource'] = qrcodeSource;
            }

            if (qrcodeValue !== undefined) {
                localVarQueryParameter['qrcodeValue'] = qrcodeValue;
            }

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Display all product with type goods 
         * @summary Get product list
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} [storeId] 
         * @param {string} [categoryCode] Filter product by category code. If is nil, will return all products. If specified, will return products that have category code that match the specified value. 
         * @param {number} [longitude] 
         * @param {number} [latitude] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ecommerceGetGoodsProductList: async (aPPTYPE: AppTypeEnum, storeId?: string, categoryCode?: string, longitude?: number, latitude?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('ecommerceGetGoodsProductList', 'aPPTYPE', aPPTYPE)
            const localVarPath = `/api/v1/ecommerce/products/goods`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (categoryCode !== undefined) {
                localVarQueryParameter['categoryCode'] = categoryCode;
            }

            if (longitude !== undefined) {
                localVarQueryParameter['longitude'] = longitude;
            }

            if (latitude !== undefined) {
                localVarQueryParameter['latitude'] = latitude;
            }

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * this is display the product base on sku and pricelist
         * @summary Get product list V2
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} [storeId] 
         * @param {string} [categoryCode] Filter product by category code. If is nil, will return all products. If specified, will return products that have category code that match the specified value. 
         * @param {number} [longitude] 
         * @param {number} [latitude] 
         * @param {number} [limit] Number of items per page.
         * @param {number} [page] Current page number to be accessed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ecommerceGetGoodsProductListV2: async (aPPTYPE: AppTypeEnum, storeId?: string, categoryCode?: string, longitude?: number, latitude?: number, limit?: number, page?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('ecommerceGetGoodsProductListV2', 'aPPTYPE', aPPTYPE)
            const localVarPath = `/api/v2/ecommerce/products/goods`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (categoryCode !== undefined) {
                localVarQueryParameter['categoryCode'] = categoryCode;
            }

            if (longitude !== undefined) {
                localVarQueryParameter['longitude'] = longitude;
            }

            if (latitude !== undefined) {
                localVarQueryParameter['latitude'] = latitude;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * this is display the product base on sku and pricelist
         * @summary Get product list V3
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} [storeId] 
         * @param {string} [categoryCode] Filter product by category code. If is nil, will return all products. If specified, will return products that have category code that match the specified value. 
         * @param {number} [longitude] 
         * @param {number} [latitude] 
         * @param {number} [limit] Number of items per page.
         * @param {number} [page] Current page number to be accessed.
         * @param {string} [searchValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ecommerceGetGoodsProductListV3: async (aPPTYPE: AppTypeEnum, storeId?: string, categoryCode?: string, longitude?: number, latitude?: number, limit?: number, page?: number, searchValue?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('ecommerceGetGoodsProductListV3', 'aPPTYPE', aPPTYPE)
            const localVarPath = `/api/v3/ecommerce/products/goods`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (categoryCode !== undefined) {
                localVarQueryParameter['categoryCode'] = categoryCode;
            }

            if (longitude !== undefined) {
                localVarQueryParameter['longitude'] = longitude;
            }

            if (latitude !== undefined) {
                localVarQueryParameter['latitude'] = latitude;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (searchValue !== undefined) {
                localVarQueryParameter['searchValue'] = searchValue;
            }

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * this is display the product catalog based on zone
         * @summary Get product list V4
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} [storeId] 
         * @param {string} [categoryCode] Filter product by category code. If is nil, will return all products. If specified, will return products that have category code that match the specified value. 
         * @param {number} [limit] Number of items per page.
         * @param {number} [page] Current page number to be accessed.
         * @param {string} [searchValue] 
         * @param {string} [areaId] id of current user area
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ecommerceGetGoodsProductListV4: async (aPPTYPE: AppTypeEnum, storeId?: string, categoryCode?: string, limit?: number, page?: number, searchValue?: string, areaId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('ecommerceGetGoodsProductListV4', 'aPPTYPE', aPPTYPE)
            const localVarPath = `/api/v4/ecommerce/products/goods`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (categoryCode !== undefined) {
                localVarQueryParameter['categoryCode'] = categoryCode;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (searchValue !== undefined) {
                localVarQueryParameter['searchValue'] = searchValue;
            }

            if (areaId !== undefined) {
                localVarQueryParameter['areaId'] = areaId;
            }

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * this is for getting eligible vendor list of coupon
         * @summary Get Eligible Vendor of Coupon
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ecommerceGetMyCoupon: async (page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ecommerce/products/digitals/my-coupon`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * this is for getting additional fee of a product in mobile apps
         * @summary Get Additional Fee of Product
         * @param {EcommerceGetProductAdditionalFeeRequest} [ecommerceGetProductAdditionalFeeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ecommerceGetProductAdditionalFee: async (ecommerceGetProductAdditionalFeeRequest?: EcommerceGetProductAdditionalFeeRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ecommerce/products/additional-fees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ecommerceGetProductAdditionalFeeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * this is for getting detail of product in mobile apps
         * @summary Get Detail Product
         * @param {string} productId product Id
         * @param {string} [storeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ecommerceGetProductDetail: async (productId: string, storeId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('ecommerceGetProductDetail', 'productId', productId)
            const localVarPath = `/api/v1/ecommerce/products/{productId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get List Products Digital 
         * @summary Get Products digital by category Filter
         * @param {string} biller category code
         * @param {string} [operator] category code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ecommerceGetProductsDigitalsList: async (biller: string, operator?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'biller' is not null or undefined
            assertParamExists('ecommerceGetProductsDigitalsList', 'biller', biller)
            const localVarPath = `/api/v1/ecommerce/products/digitals/{biller}`
                .replace(`{${"biller"}}`, encodeURIComponent(String(biller)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (operator !== undefined) {
                localVarQueryParameter['operator'] = operator;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get List Of Promotions 
         * @summary Get List Of Promotions
         * @param {string} [promoCode] promo code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ecommerceGetPromotionsList: async (promoCode?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ecommerce/promotions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (promoCode !== undefined) {
                localVarQueryParameter['promoCode'] = promoCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Inquiry Digital Product
         * @summary Inquiry Digital Product
         * @param {EcommerceProductDigitalInquiryRequest} [ecommerceProductDigitalInquiryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ecommerceProductDigitalInquiry: async (ecommerceProductDigitalInquiryRequest?: EcommerceProductDigitalInquiryRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ecommerce/products/digitals/inquiries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ecommerceProductDigitalInquiryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Inquiry Digital Product
         * @summary Inquiry Goods Product
         * @param {EcommerceProductGoodsInquiryRequest} [ecommerceProductGoodsInquiryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ecommerceProductGoodsInquiry: async (ecommerceProductGoodsInquiryRequest?: EcommerceProductGoodsInquiryRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ecommerce/products/goods/inquiries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ecommerceProductGoodsInquiryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Inquiry Digital Product
         * @summary Inquiry Goods Product
         * @param {number} [startDate] 
         * @param {number} [endDate] 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ecommerceProductGoodsInquiryList: async (startDate?: number, endDate?: number, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ecommerce/products/goods/inquiries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This Api for getting recomendation product base on search value
         * @summary Search Product
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} searchValue 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ecommerceSearchGoodsProduct: async (aPPTYPE: AppTypeEnum, searchValue: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('ecommerceSearchGoodsProduct', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'searchValue' is not null or undefined
            assertParamExists('ecommerceSearchGoodsProduct', 'searchValue', searchValue)
            const localVarPath = `/api/v1/ecommerce/products/goods/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (searchValue !== undefined) {
                localVarQueryParameter['searchValue'] = searchValue;
            }

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get store areas
         * @summary Get Store Areas
         * @param {string} [searchName] 
         * @param {string} [zoneId] 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ecommerceStoreGetAreas: async (searchName?: string, zoneId?: string, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ecommerce/stores/areas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (searchName !== undefined) {
                localVarQueryParameter['searchName'] = searchName;
            }

            if (zoneId !== undefined) {
                localVarQueryParameter['zoneId'] = zoneId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This is for mobile app to get list of cities store
         * @summary Getting List of cities store
         * @param {string} [province] 
         * @param {string} [city] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ecommerceStoreGetCities: async (province?: string, city?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ecommerce/stores/cities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (province !== undefined) {
                localVarQueryParameter['province'] = province;
            }

            if (city !== undefined) {
                localVarQueryParameter['city'] = city;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This is for mobile app to get list of provinces store
         * @summary Getting List of provinces store
         * @param {string} [province] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ecommerceStoreGetProvinces: async (province?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ecommerce/stores/provinces`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (province !== undefined) {
                localVarQueryParameter['province'] = province;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Display finance invoice detail 
         * @summary Get finance invoice detail
         * @param {string} invoiceId Invoice UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        financeGetInvoiceDetail: async (invoiceId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invoiceId' is not null or undefined
            assertParamExists('financeGetInvoiceDetail', 'invoiceId', invoiceId)
            const localVarPath = `/api/v1/finance/invoices/{invoiceId}`
                .replace(`{${"invoiceId"}}`, encodeURIComponent(String(invoiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Display list of finance invoice 
         * @summary Get finance invoice list
         * @param {InvoiceStatusEnum} [invoiceStatus] 
         * @param {string} [invoiceNo] 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {InvoiceFinanceSortFieldEnum} [sortField] 
         * @param {InvoiceDirectionEnum} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        financeInvoiceList: async (invoiceStatus?: InvoiceStatusEnum, invoiceNo?: string, page?: number, limit?: number, sortField?: InvoiceFinanceSortFieldEnum, sortBy?: InvoiceDirectionEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/finance/invoices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (invoiceStatus !== undefined) {
                localVarQueryParameter['invoiceStatus'] = invoiceStatus;
            }

            if (invoiceNo !== undefined) {
                localVarQueryParameter['invoiceNo'] = invoiceNo;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortField !== undefined) {
                localVarQueryParameter['sortField'] = sortField;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Used by finance to check and update payment status when the customer has transfer to VA and system not receive notification from doku 
         * @summary Verify Manual Doku Payment Briva by Finance
         * @param {FinancePaymentVerifyDokuRequest} financePaymentVerifyDokuRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        financePaymentVerifyDoku: async (financePaymentVerifyDokuRequest: FinancePaymentVerifyDokuRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'financePaymentVerifyDokuRequest' is not null or undefined
            assertParamExists('financePaymentVerifyDoku', 'financePaymentVerifyDokuRequest', financePaymentVerifyDokuRequest)
            const localVarPath = `/api/v1/finance/payment-verify/doku`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(financePaymentVerifyDokuRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * this is for getting detail of product in mobile apps
         * @summary Get Product Category
         * @param {EcommerceProductTypeEnum} [type] 
         * @param {string} [areaId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductCategories: async (type?: EcommerceProductTypeEnum, areaId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/products/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (areaId !== undefined) {
                localVarQueryParameter['area_id'] = areaId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Invoice List By Order Id
         * @summary Get Invoice List By Order Id
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} orderId 
         * @param {string} [userId] used by DUTA app, id of the user that this request is for
         * @param {string} [phoneNo] Phone number of the user, this is for guest mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicesList: async (aPPTYPE: AppTypeEnum, orderId: string, userId?: string, phoneNo?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('invoicesList', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('invoicesList', 'orderId', orderId)
            const localVarPath = `/api/v1/invoices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (phoneNo !== undefined) {
                localVarQueryParameter['phoneNo'] = phoneNo;
            }

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create Order E-Commerce 
         * @summary Create Order
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {OrderCreateRequest} orderCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderCreate: async (aPPTYPE: AppTypeEnum, orderCreateRequest: OrderCreateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('orderCreate', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'orderCreateRequest' is not null or undefined
            assertParamExists('orderCreate', 'orderCreateRequest', orderCreateRequest)
            const localVarPath = `/api/v1/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orderCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Used to cancel an order by the user <br>If the order status is DRAFT, the order can be canceled without approval <br>If the order status is NEW, the order can be canceled without approval and the system will refund the payment at SawitPoin <br>If the order status is CONFIRMED, the order can be canceled with approval <br>If the order status is READY_TO_PICK_UP/ FULL_DELIVERED/ COMPLETED/ CANCELED, the order cannot be canceled 
         * @summary Cancel Order
         * @param {string} orderId Sale Order UUID
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {OrdersCancelRequest} ordersCancelRequest 
         * @param {string} [userId] used by DUTA app, id of the user that this request is for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersCancel: async (orderId: string, aPPTYPE: AppTypeEnum, ordersCancelRequest: OrdersCancelRequest, userId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('ordersCancel', 'orderId', orderId)
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('ordersCancel', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'ordersCancelRequest' is not null or undefined
            assertParamExists('ordersCancel', 'ordersCancelRequest', ordersCancelRequest)
            const localVarPath = `/api/v1/orders/{orderId}/cancel`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ordersCancelRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create Delivery Order Information E-Commerce 
         * @summary Create Delivery Order Information
         * @param {string} orderId Sale Order UUID
         * @param {OrdersDeliveriesCreateRequest} ordersDeliveriesCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersDeliveriesCreate: async (orderId: string, ordersDeliveriesCreateRequest: OrdersDeliveriesCreateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('ordersDeliveriesCreate', 'orderId', orderId)
            // verify required parameter 'ordersDeliveriesCreateRequest' is not null or undefined
            assertParamExists('ordersDeliveriesCreate', 'ordersDeliveriesCreateRequest', ordersDeliveriesCreateRequest)
            const localVarPath = `/api/v1/orders/{orderId}/deliveries`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ordersDeliveriesCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Sale Order Detail
         * @summary Get Sale Order Detail
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} orderId Sale Order UUID
         * @param {string} [userId] used by DUTA app, id of the user that this request is for
         * @param {string} [phoneNo] Phone number of the user, this is for guest mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersGetDetail: async (aPPTYPE: AppTypeEnum, orderId: string, userId?: string, phoneNo?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('ordersGetDetail', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('ordersGetDetail', 'orderId', orderId)
            const localVarPath = `/api/v1/orders/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (phoneNo !== undefined) {
                localVarQueryParameter['phoneNo'] = phoneNo;
            }

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Display all order
         * @summary Get order list
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {SaleOrderStatusEnum} [status] 
         * @param {number} [startDate] 
         * @param {number} [endDate] 
         * @param {EcommerceProductTypeFilterEnum} [productType] 
         * @param {string} [userId] used by DUTA app, id of the user that this request is for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersList: async (aPPTYPE: AppTypeEnum, page?: number, limit?: number, status?: SaleOrderStatusEnum, startDate?: number, endDate?: number, productType?: EcommerceProductTypeFilterEnum, userId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('ordersList', 'aPPTYPE', aPPTYPE)
            const localVarPath = `/api/v1/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (productType !== undefined) {
                localVarQueryParameter['productType'] = productType;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Used by operation and warehouse team to update sale order status when manage/proceeding the sale order 
         * @summary Update Sale Order Status
         * @param {string} orderId Sale Order UUID
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {OrdersUpdateStatusRequest} ordersUpdateStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersUpdateStatus: async (orderId: string, aPPTYPE: AppTypeEnum, ordersUpdateStatusRequest: OrdersUpdateStatusRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('ordersUpdateStatus', 'orderId', orderId)
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('ordersUpdateStatus', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'ordersUpdateStatusRequest' is not null or undefined
            assertParamExists('ordersUpdateStatus', 'ordersUpdateStatusRequest', ordersUpdateStatusRequest)
            const localVarPath = `/api/v1/orders/{orderId}/status`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ordersUpdateStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * User can create payment after order product 
         * @summary Create Payment with Generic Payment Method
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {PaymentsCreatePaymentRequest} paymentsCreatePaymentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsCreate: async (aPPTYPE: AppTypeEnum, paymentsCreatePaymentRequest: PaymentsCreatePaymentRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('paymentsCreate', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'paymentsCreatePaymentRequest' is not null or undefined
            assertParamExists('paymentsCreate', 'paymentsCreatePaymentRequest', paymentsCreatePaymentRequest)
            const localVarPath = `/api/v1/payments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(paymentsCreatePaymentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * User can create payment after order product 
         * @summary Create Payment
         * @param {PaymentsCreateDirectPaymentRequest} paymentsCreateDirectPaymentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsCreateDirectPayment: async (paymentsCreateDirectPaymentRequest: PaymentsCreateDirectPaymentRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paymentsCreateDirectPaymentRequest' is not null or undefined
            assertParamExists('paymentsCreateDirectPayment', 'paymentsCreateDirectPaymentRequest', paymentsCreateDirectPaymentRequest)
            const localVarPath = `/api/v1/payments/direct-payment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(paymentsCreateDirectPaymentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Used by finance to update a payment status when the customer has made a bank transfer 
         * @summary Verify Manual Transfer by Finance
         * @param {PaymentsVerifyRequest} paymentsVerifyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsVerify: async (paymentsVerifyRequest: PaymentsVerifyRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paymentsVerifyRequest' is not null or undefined
            assertParamExists('paymentsVerify', 'paymentsVerifyRequest', paymentsVerifyRequest)
            const localVarPath = `/api/v1/payments/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(paymentsVerifyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Display all product 
         * @summary Get product list
         * @param {string} [storeId] 
         * @param {string} [categoryCode] Filter product by category code. If is nil, will return all products. If specified, will return products that have category code that match the specified value. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productList: async (storeId?: string, categoryCode?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (categoryCode !== undefined) {
                localVarQueryParameter['categoryCode'] = categoryCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Display all store 
         * @summary Get store list
         * @param {number} [longitude] 
         * @param {number} [latitude] 
         * @param {string} [province] 
         * @param {string} [city] 
         * @param {string} [searchName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storesList: async (longitude?: number, latitude?: number, province?: string, city?: string, searchName?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/stores`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (longitude !== undefined) {
                localVarQueryParameter['longitude'] = longitude;
            }

            if (latitude !== undefined) {
                localVarQueryParameter['latitude'] = latitude;
            }

            if (province !== undefined) {
                localVarQueryParameter['province'] = province;
            }

            if (city !== undefined) {
                localVarQueryParameter['city'] = city;
            }

            if (searchName !== undefined) {
                localVarQueryParameter['searchName'] = searchName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * this is for getting eligible store list of coupon
         * @summary Get Eligible Store of Coupon
         * @param {string} couponId coupon Id
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {string} [province] 
         * @param {string} [city] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2EcommerceCouponGetVendorList: async (couponId: string, page?: number, limit?: number, province?: string, city?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'couponId' is not null or undefined
            assertParamExists('v2EcommerceCouponGetVendorList', 'couponId', couponId)
            const localVarPath = `/api/v2/ecommerce/products/digitals/coupons/{couponId}/vendors`
                .replace(`{${"couponId"}}`, encodeURIComponent(String(couponId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (province !== undefined) {
                localVarQueryParameter['province'] = province;
            }

            if (city !== undefined) {
                localVarQueryParameter['city'] = city;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EcommerceApi - functional programming interface
 * @export
 */
export const EcommerceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EcommerceApiAxiosParamCreator(configuration)
    return {
        /**
         * Admins can able create product pricelist
         * @summary Create product pricelist
         * @param {AdminsEcommerceProductPriceListsCreateRequest} [adminsEcommerceProductPriceListsCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsEcommerceProductPriceListsCreate(adminsEcommerceProductPriceListsCreateRequest?: AdminsEcommerceProductPriceListsCreateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminsEcommerceProductPriceListsCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsEcommerceProductPriceListsCreate(adminsEcommerceProductPriceListsCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * admins can able to update product pricelist
         * @summary Update product pricelist
         * @param {string} pricelistId Pricelist UUID
         * @param {AdminsEcommerceProductPriceListsUpdateRequest} [adminsEcommerceProductPriceListsUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsEcommerceProductPriceListsUpdate(pricelistId: string, adminsEcommerceProductPriceListsUpdateRequest?: AdminsEcommerceProductPriceListsUpdateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminsEcommerceProductPriceListsUpdateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsEcommerceProductPriceListsUpdate(pricelistId, adminsEcommerceProductPriceListsUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * admins can be able to update product pricelist
         * @summary Update product pricelist V2
         * @param {AdminsEcommerceProductPriceListsUpdateV2Request} [adminsEcommerceProductPriceListsUpdateV2Request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsEcommerceProductPriceListsUpdateV2(adminsEcommerceProductPriceListsUpdateV2Request?: AdminsEcommerceProductPriceListsUpdateV2Request, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminsEcommerceProductPriceListsUpdateV2Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsEcommerceProductPriceListsUpdateV2(adminsEcommerceProductPriceListsUpdateV2Request, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Used by MemberApp to create cart data for user 
         * @summary Create cart data for user
         * @param {CartCreateRequest} cartCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cartCreate(cartCreateRequest: CartCreateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CartCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cartCreate(cartCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Used by MemberApp to get cart data for user 
         * @summary Get cart data for user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cartsGetDetail(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CartsGetDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cartsGetDetail(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get Product SKU Count in One Cart
         * @summary Get Total Product SKU of Cart
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cartsGetProductCount(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CartsGetProductCountResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cartsGetProductCount(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Used by MemberApp to remove product from active cart 
         * @summary Remove product from cart
         * @param {string} cartItemId Cart Item UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cartsItemsDelete(cartItemId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CartsItemsDeleteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cartsItemsDelete(cartItemId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * this is for getting eligible vendor list of coupon
         * @summary Get Eligible Vendor of Coupon
         * @param {string} couponId coupon Id
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ecommerceCouponGetVendorList(couponId: string, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EcommerceCouponGetVendorListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ecommerceCouponGetVendorList(couponId, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * this is for getting eligible vendor list of coupon
         * @summary Redeem coupon
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {EcommerceCouponsRedeemRequest} ecommerceCouponsRedeemRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ecommerceCouponsRedeem(aPPTYPE: AppTypeEnum, ecommerceCouponsRedeemRequest: EcommerceCouponsRedeemRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EcommerceCouponsRedeemResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ecommerceCouponsRedeem(aPPTYPE, ecommerceCouponsRedeemRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get list of pick up locations 
         * @summary Get List of Pick Up Location
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} [zoneId] zone id in uuid format
         * @param {number} [longitude] longitude of current user
         * @param {number} [latitude] latitude of current user
         * @param {number} [limit] Number of items per page.
         * @param {number} [page] Current page number to be accessed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ecommerceDeliveriesPickUpsGetPickUpLocations(aPPTYPE: AppTypeEnum, zoneId?: string, longitude?: number, latitude?: number, limit?: number, page?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EcommerceDeliveryGetPickUpLocationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ecommerceDeliveriesPickUpsGetPickUpLocations(aPPTYPE, zoneId, longitude, latitude, limit, page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * this is for verify that coupon is eligible or not for that vendor
         * @summary Ecommerce Get Coupons Verify
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} couponCode coupon code
         * @param {QRCodeSourceEnum} qrcodeSource qrcode source, this getting from scanner from web or mobile
         * @param {string} qrcodeValue qrcode value, this value of qrcode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ecommerceGetCouponsVerify(aPPTYPE: AppTypeEnum, couponCode: string, qrcodeSource: QRCodeSourceEnum, qrcodeValue: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EcommerceGetCouponsVerifyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ecommerceGetCouponsVerify(aPPTYPE, couponCode, qrcodeSource, qrcodeValue, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Display all product with type goods 
         * @summary Get product list
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} [storeId] 
         * @param {string} [categoryCode] Filter product by category code. If is nil, will return all products. If specified, will return products that have category code that match the specified value. 
         * @param {number} [longitude] 
         * @param {number} [latitude] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ecommerceGetGoodsProductList(aPPTYPE: AppTypeEnum, storeId?: string, categoryCode?: string, longitude?: number, latitude?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EcommerceGetGoodsProductListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ecommerceGetGoodsProductList(aPPTYPE, storeId, categoryCode, longitude, latitude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * this is display the product base on sku and pricelist
         * @summary Get product list V2
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} [storeId] 
         * @param {string} [categoryCode] Filter product by category code. If is nil, will return all products. If specified, will return products that have category code that match the specified value. 
         * @param {number} [longitude] 
         * @param {number} [latitude] 
         * @param {number} [limit] Number of items per page.
         * @param {number} [page] Current page number to be accessed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ecommerceGetGoodsProductListV2(aPPTYPE: AppTypeEnum, storeId?: string, categoryCode?: string, longitude?: number, latitude?: number, limit?: number, page?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EcommerceGetGoodsProductListV2Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ecommerceGetGoodsProductListV2(aPPTYPE, storeId, categoryCode, longitude, latitude, limit, page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * this is display the product base on sku and pricelist
         * @summary Get product list V3
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} [storeId] 
         * @param {string} [categoryCode] Filter product by category code. If is nil, will return all products. If specified, will return products that have category code that match the specified value. 
         * @param {number} [longitude] 
         * @param {number} [latitude] 
         * @param {number} [limit] Number of items per page.
         * @param {number} [page] Current page number to be accessed.
         * @param {string} [searchValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ecommerceGetGoodsProductListV3(aPPTYPE: AppTypeEnum, storeId?: string, categoryCode?: string, longitude?: number, latitude?: number, limit?: number, page?: number, searchValue?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EcommerceGetGoodsProductListV3Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ecommerceGetGoodsProductListV3(aPPTYPE, storeId, categoryCode, longitude, latitude, limit, page, searchValue, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * this is display the product catalog based on zone
         * @summary Get product list V4
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} [storeId] 
         * @param {string} [categoryCode] Filter product by category code. If is nil, will return all products. If specified, will return products that have category code that match the specified value. 
         * @param {number} [limit] Number of items per page.
         * @param {number} [page] Current page number to be accessed.
         * @param {string} [searchValue] 
         * @param {string} [areaId] id of current user area
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ecommerceGetGoodsProductListV4(aPPTYPE: AppTypeEnum, storeId?: string, categoryCode?: string, limit?: number, page?: number, searchValue?: string, areaId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EcommerceGetGoodsProductListV4Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ecommerceGetGoodsProductListV4(aPPTYPE, storeId, categoryCode, limit, page, searchValue, areaId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * this is for getting eligible vendor list of coupon
         * @summary Get Eligible Vendor of Coupon
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ecommerceGetMyCoupon(page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EcommerceGetMyCouponResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ecommerceGetMyCoupon(page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * this is for getting additional fee of a product in mobile apps
         * @summary Get Additional Fee of Product
         * @param {EcommerceGetProductAdditionalFeeRequest} [ecommerceGetProductAdditionalFeeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ecommerceGetProductAdditionalFee(ecommerceGetProductAdditionalFeeRequest?: EcommerceGetProductAdditionalFeeRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EcommerceGetProductAdditionalFeeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ecommerceGetProductAdditionalFee(ecommerceGetProductAdditionalFeeRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * this is for getting detail of product in mobile apps
         * @summary Get Detail Product
         * @param {string} productId product Id
         * @param {string} [storeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ecommerceGetProductDetail(productId: string, storeId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EcommerceGetProductDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ecommerceGetProductDetail(productId, storeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get List Products Digital 
         * @summary Get Products digital by category Filter
         * @param {string} biller category code
         * @param {string} [operator] category code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ecommerceGetProductsDigitalsList(biller: string, operator?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EcommerceProductCategoriesDigitalResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ecommerceGetProductsDigitalsList(biller, operator, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get List Of Promotions 
         * @summary Get List Of Promotions
         * @param {string} [promoCode] promo code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ecommerceGetPromotionsList(promoCode?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EcommerceGetPromotionsListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ecommerceGetPromotionsList(promoCode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Inquiry Digital Product
         * @summary Inquiry Digital Product
         * @param {EcommerceProductDigitalInquiryRequest} [ecommerceProductDigitalInquiryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ecommerceProductDigitalInquiry(ecommerceProductDigitalInquiryRequest?: EcommerceProductDigitalInquiryRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EcommerceProductDigitalInquiryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ecommerceProductDigitalInquiry(ecommerceProductDigitalInquiryRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Inquiry Digital Product
         * @summary Inquiry Goods Product
         * @param {EcommerceProductGoodsInquiryRequest} [ecommerceProductGoodsInquiryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ecommerceProductGoodsInquiry(ecommerceProductGoodsInquiryRequest?: EcommerceProductGoodsInquiryRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EcommerceProductGoodsInquiryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ecommerceProductGoodsInquiry(ecommerceProductGoodsInquiryRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Inquiry Digital Product
         * @summary Inquiry Goods Product
         * @param {number} [startDate] 
         * @param {number} [endDate] 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ecommerceProductGoodsInquiryList(startDate?: number, endDate?: number, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EcommerceProductGoodsInquiryListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ecommerceProductGoodsInquiryList(startDate, endDate, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This Api for getting recomendation product base on search value
         * @summary Search Product
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} searchValue 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ecommerceSearchGoodsProduct(aPPTYPE: AppTypeEnum, searchValue: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EcommerceSearchGoodsProductResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ecommerceSearchGoodsProduct(aPPTYPE, searchValue, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get store areas
         * @summary Get Store Areas
         * @param {string} [searchName] 
         * @param {string} [zoneId] 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ecommerceStoreGetAreas(searchName?: string, zoneId?: string, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EcommerceStoreGetAreasResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ecommerceStoreGetAreas(searchName, zoneId, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This is for mobile app to get list of cities store
         * @summary Getting List of cities store
         * @param {string} [province] 
         * @param {string} [city] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ecommerceStoreGetCities(province?: string, city?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EcommerceStoresGetCitiesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ecommerceStoreGetCities(province, city, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This is for mobile app to get list of provinces store
         * @summary Getting List of provinces store
         * @param {string} [province] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ecommerceStoreGetProvinces(province?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EcommerceStoresGetProvincesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ecommerceStoreGetProvinces(province, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Display finance invoice detail 
         * @summary Get finance invoice detail
         * @param {string} invoiceId Invoice UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async financeGetInvoiceDetail(invoiceId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FinanceGetInvoiceDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.financeGetInvoiceDetail(invoiceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Display list of finance invoice 
         * @summary Get finance invoice list
         * @param {InvoiceStatusEnum} [invoiceStatus] 
         * @param {string} [invoiceNo] 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {InvoiceFinanceSortFieldEnum} [sortField] 
         * @param {InvoiceDirectionEnum} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async financeInvoiceList(invoiceStatus?: InvoiceStatusEnum, invoiceNo?: string, page?: number, limit?: number, sortField?: InvoiceFinanceSortFieldEnum, sortBy?: InvoiceDirectionEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FinanceInvoiceListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.financeInvoiceList(invoiceStatus, invoiceNo, page, limit, sortField, sortBy, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Used by finance to check and update payment status when the customer has transfer to VA and system not receive notification from doku 
         * @summary Verify Manual Doku Payment Briva by Finance
         * @param {FinancePaymentVerifyDokuRequest} financePaymentVerifyDokuRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async financePaymentVerifyDoku(financePaymentVerifyDokuRequest: FinancePaymentVerifyDokuRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FinancePaymentVerifyDokuResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.financePaymentVerifyDoku(financePaymentVerifyDokuRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * this is for getting detail of product in mobile apps
         * @summary Get Product Category
         * @param {EcommerceProductTypeEnum} [type] 
         * @param {string} [areaId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductCategories(type?: EcommerceProductTypeEnum, areaId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetProductCategoriesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductCategories(type, areaId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get Invoice List By Order Id
         * @summary Get Invoice List By Order Id
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} orderId 
         * @param {string} [userId] used by DUTA app, id of the user that this request is for
         * @param {string} [phoneNo] Phone number of the user, this is for guest mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invoicesList(aPPTYPE: AppTypeEnum, orderId: string, userId?: string, phoneNo?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoicesListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invoicesList(aPPTYPE, orderId, userId, phoneNo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create Order E-Commerce 
         * @summary Create Order
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {OrderCreateRequest} orderCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderCreate(aPPTYPE: AppTypeEnum, orderCreateRequest: OrderCreateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderCreate(aPPTYPE, orderCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Used to cancel an order by the user <br>If the order status is DRAFT, the order can be canceled without approval <br>If the order status is NEW, the order can be canceled without approval and the system will refund the payment at SawitPoin <br>If the order status is CONFIRMED, the order can be canceled with approval <br>If the order status is READY_TO_PICK_UP/ FULL_DELIVERED/ COMPLETED/ CANCELED, the order cannot be canceled 
         * @summary Cancel Order
         * @param {string} orderId Sale Order UUID
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {OrdersCancelRequest} ordersCancelRequest 
         * @param {string} [userId] used by DUTA app, id of the user that this request is for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ordersCancel(orderId: string, aPPTYPE: AppTypeEnum, ordersCancelRequest: OrdersCancelRequest, userId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrdersCancelResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ordersCancel(orderId, aPPTYPE, ordersCancelRequest, userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create Delivery Order Information E-Commerce 
         * @summary Create Delivery Order Information
         * @param {string} orderId Sale Order UUID
         * @param {OrdersDeliveriesCreateRequest} ordersDeliveriesCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ordersDeliveriesCreate(orderId: string, ordersDeliveriesCreateRequest: OrdersDeliveriesCreateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrdersDeliveriesCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ordersDeliveriesCreate(orderId, ordersDeliveriesCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get Sale Order Detail
         * @summary Get Sale Order Detail
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} orderId Sale Order UUID
         * @param {string} [userId] used by DUTA app, id of the user that this request is for
         * @param {string} [phoneNo] Phone number of the user, this is for guest mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ordersGetDetail(aPPTYPE: AppTypeEnum, orderId: string, userId?: string, phoneNo?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrdersGetDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ordersGetDetail(aPPTYPE, orderId, userId, phoneNo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Display all order
         * @summary Get order list
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {SaleOrderStatusEnum} [status] 
         * @param {number} [startDate] 
         * @param {number} [endDate] 
         * @param {EcommerceProductTypeFilterEnum} [productType] 
         * @param {string} [userId] used by DUTA app, id of the user that this request is for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ordersList(aPPTYPE: AppTypeEnum, page?: number, limit?: number, status?: SaleOrderStatusEnum, startDate?: number, endDate?: number, productType?: EcommerceProductTypeFilterEnum, userId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrdersListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ordersList(aPPTYPE, page, limit, status, startDate, endDate, productType, userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Used by operation and warehouse team to update sale order status when manage/proceeding the sale order 
         * @summary Update Sale Order Status
         * @param {string} orderId Sale Order UUID
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {OrdersUpdateStatusRequest} ordersUpdateStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ordersUpdateStatus(orderId: string, aPPTYPE: AppTypeEnum, ordersUpdateStatusRequest: OrdersUpdateStatusRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrdersUpdateStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ordersUpdateStatus(orderId, aPPTYPE, ordersUpdateStatusRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * User can create payment after order product 
         * @summary Create Payment with Generic Payment Method
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {PaymentsCreatePaymentRequest} paymentsCreatePaymentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsCreate(aPPTYPE: AppTypeEnum, paymentsCreatePaymentRequest: PaymentsCreatePaymentRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentsCreatePaymentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsCreate(aPPTYPE, paymentsCreatePaymentRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * User can create payment after order product 
         * @summary Create Payment
         * @param {PaymentsCreateDirectPaymentRequest} paymentsCreateDirectPaymentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsCreateDirectPayment(paymentsCreateDirectPaymentRequest: PaymentsCreateDirectPaymentRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentsCreateDirectPaymentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsCreateDirectPayment(paymentsCreateDirectPaymentRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Used by finance to update a payment status when the customer has made a bank transfer 
         * @summary Verify Manual Transfer by Finance
         * @param {PaymentsVerifyRequest} paymentsVerifyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsVerify(paymentsVerifyRequest: PaymentsVerifyRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentsVerifyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsVerify(paymentsVerifyRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Display all product 
         * @summary Get product list
         * @param {string} [storeId] 
         * @param {string} [categoryCode] Filter product by category code. If is nil, will return all products. If specified, will return products that have category code that match the specified value. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productList(storeId?: string, categoryCode?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productList(storeId, categoryCode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Display all store 
         * @summary Get store list
         * @param {number} [longitude] 
         * @param {number} [latitude] 
         * @param {string} [province] 
         * @param {string} [city] 
         * @param {string} [searchName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storesList(longitude?: number, latitude?: number, province?: string, city?: string, searchName?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StoresListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storesList(longitude, latitude, province, city, searchName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * this is for getting eligible store list of coupon
         * @summary Get Eligible Store of Coupon
         * @param {string} couponId coupon Id
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {string} [province] 
         * @param {string} [city] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2EcommerceCouponGetVendorList(couponId: string, page?: number, limit?: number, province?: string, city?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V2EcommerceCouponGetVendorListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2EcommerceCouponGetVendorList(couponId, page, limit, province, city, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EcommerceApi - factory interface
 * @export
 */
export const EcommerceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EcommerceApiFp(configuration)
    return {
        /**
         * Admins can able create product pricelist
         * @summary Create product pricelist
         * @param {AdminsEcommerceProductPriceListsCreateRequest} [adminsEcommerceProductPriceListsCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsEcommerceProductPriceListsCreate(adminsEcommerceProductPriceListsCreateRequest?: AdminsEcommerceProductPriceListsCreateRequest, options?: any): AxiosPromise<AdminsEcommerceProductPriceListsCreateResponse> {
            return localVarFp.adminsEcommerceProductPriceListsCreate(adminsEcommerceProductPriceListsCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * admins can able to update product pricelist
         * @summary Update product pricelist
         * @param {string} pricelistId Pricelist UUID
         * @param {AdminsEcommerceProductPriceListsUpdateRequest} [adminsEcommerceProductPriceListsUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsEcommerceProductPriceListsUpdate(pricelistId: string, adminsEcommerceProductPriceListsUpdateRequest?: AdminsEcommerceProductPriceListsUpdateRequest, options?: any): AxiosPromise<AdminsEcommerceProductPriceListsUpdateResponse> {
            return localVarFp.adminsEcommerceProductPriceListsUpdate(pricelistId, adminsEcommerceProductPriceListsUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * admins can be able to update product pricelist
         * @summary Update product pricelist V2
         * @param {AdminsEcommerceProductPriceListsUpdateV2Request} [adminsEcommerceProductPriceListsUpdateV2Request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsEcommerceProductPriceListsUpdateV2(adminsEcommerceProductPriceListsUpdateV2Request?: AdminsEcommerceProductPriceListsUpdateV2Request, options?: any): AxiosPromise<AdminsEcommerceProductPriceListsUpdateV2Response> {
            return localVarFp.adminsEcommerceProductPriceListsUpdateV2(adminsEcommerceProductPriceListsUpdateV2Request, options).then((request) => request(axios, basePath));
        },
        /**
         * Used by MemberApp to create cart data for user 
         * @summary Create cart data for user
         * @param {CartCreateRequest} cartCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartCreate(cartCreateRequest: CartCreateRequest, options?: any): AxiosPromise<CartCreateResponse> {
            return localVarFp.cartCreate(cartCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Used by MemberApp to get cart data for user 
         * @summary Get cart data for user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartsGetDetail(options?: any): AxiosPromise<CartsGetDetailResponse> {
            return localVarFp.cartsGetDetail(options).then((request) => request(axios, basePath));
        },
        /**
         * Get Product SKU Count in One Cart
         * @summary Get Total Product SKU of Cart
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartsGetProductCount(options?: any): AxiosPromise<CartsGetProductCountResponse> {
            return localVarFp.cartsGetProductCount(options).then((request) => request(axios, basePath));
        },
        /**
         * Used by MemberApp to remove product from active cart 
         * @summary Remove product from cart
         * @param {string} cartItemId Cart Item UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartsItemsDelete(cartItemId: string, options?: any): AxiosPromise<CartsItemsDeleteResponse> {
            return localVarFp.cartsItemsDelete(cartItemId, options).then((request) => request(axios, basePath));
        },
        /**
         * this is for getting eligible vendor list of coupon
         * @summary Get Eligible Vendor of Coupon
         * @param {string} couponId coupon Id
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ecommerceCouponGetVendorList(couponId: string, page?: number, limit?: number, options?: any): AxiosPromise<EcommerceCouponGetVendorListResponse> {
            return localVarFp.ecommerceCouponGetVendorList(couponId, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * this is for getting eligible vendor list of coupon
         * @summary Redeem coupon
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {EcommerceCouponsRedeemRequest} ecommerceCouponsRedeemRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ecommerceCouponsRedeem(aPPTYPE: AppTypeEnum, ecommerceCouponsRedeemRequest: EcommerceCouponsRedeemRequest, options?: any): AxiosPromise<EcommerceCouponsRedeemResponse> {
            return localVarFp.ecommerceCouponsRedeem(aPPTYPE, ecommerceCouponsRedeemRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get list of pick up locations 
         * @summary Get List of Pick Up Location
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} [zoneId] zone id in uuid format
         * @param {number} [longitude] longitude of current user
         * @param {number} [latitude] latitude of current user
         * @param {number} [limit] Number of items per page.
         * @param {number} [page] Current page number to be accessed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ecommerceDeliveriesPickUpsGetPickUpLocations(aPPTYPE: AppTypeEnum, zoneId?: string, longitude?: number, latitude?: number, limit?: number, page?: number, options?: any): AxiosPromise<EcommerceDeliveryGetPickUpLocationsResponse> {
            return localVarFp.ecommerceDeliveriesPickUpsGetPickUpLocations(aPPTYPE, zoneId, longitude, latitude, limit, page, options).then((request) => request(axios, basePath));
        },
        /**
         * this is for verify that coupon is eligible or not for that vendor
         * @summary Ecommerce Get Coupons Verify
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} couponCode coupon code
         * @param {QRCodeSourceEnum} qrcodeSource qrcode source, this getting from scanner from web or mobile
         * @param {string} qrcodeValue qrcode value, this value of qrcode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ecommerceGetCouponsVerify(aPPTYPE: AppTypeEnum, couponCode: string, qrcodeSource: QRCodeSourceEnum, qrcodeValue: string, options?: any): AxiosPromise<EcommerceGetCouponsVerifyResponse> {
            return localVarFp.ecommerceGetCouponsVerify(aPPTYPE, couponCode, qrcodeSource, qrcodeValue, options).then((request) => request(axios, basePath));
        },
        /**
         * Display all product with type goods 
         * @summary Get product list
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} [storeId] 
         * @param {string} [categoryCode] Filter product by category code. If is nil, will return all products. If specified, will return products that have category code that match the specified value. 
         * @param {number} [longitude] 
         * @param {number} [latitude] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ecommerceGetGoodsProductList(aPPTYPE: AppTypeEnum, storeId?: string, categoryCode?: string, longitude?: number, latitude?: number, options?: any): AxiosPromise<EcommerceGetGoodsProductListResponse> {
            return localVarFp.ecommerceGetGoodsProductList(aPPTYPE, storeId, categoryCode, longitude, latitude, options).then((request) => request(axios, basePath));
        },
        /**
         * this is display the product base on sku and pricelist
         * @summary Get product list V2
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} [storeId] 
         * @param {string} [categoryCode] Filter product by category code. If is nil, will return all products. If specified, will return products that have category code that match the specified value. 
         * @param {number} [longitude] 
         * @param {number} [latitude] 
         * @param {number} [limit] Number of items per page.
         * @param {number} [page] Current page number to be accessed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ecommerceGetGoodsProductListV2(aPPTYPE: AppTypeEnum, storeId?: string, categoryCode?: string, longitude?: number, latitude?: number, limit?: number, page?: number, options?: any): AxiosPromise<EcommerceGetGoodsProductListV2Response> {
            return localVarFp.ecommerceGetGoodsProductListV2(aPPTYPE, storeId, categoryCode, longitude, latitude, limit, page, options).then((request) => request(axios, basePath));
        },
        /**
         * this is display the product base on sku and pricelist
         * @summary Get product list V3
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} [storeId] 
         * @param {string} [categoryCode] Filter product by category code. If is nil, will return all products. If specified, will return products that have category code that match the specified value. 
         * @param {number} [longitude] 
         * @param {number} [latitude] 
         * @param {number} [limit] Number of items per page.
         * @param {number} [page] Current page number to be accessed.
         * @param {string} [searchValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ecommerceGetGoodsProductListV3(aPPTYPE: AppTypeEnum, storeId?: string, categoryCode?: string, longitude?: number, latitude?: number, limit?: number, page?: number, searchValue?: string, options?: any): AxiosPromise<EcommerceGetGoodsProductListV3Response> {
            return localVarFp.ecommerceGetGoodsProductListV3(aPPTYPE, storeId, categoryCode, longitude, latitude, limit, page, searchValue, options).then((request) => request(axios, basePath));
        },
        /**
         * this is display the product catalog based on zone
         * @summary Get product list V4
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} [storeId] 
         * @param {string} [categoryCode] Filter product by category code. If is nil, will return all products. If specified, will return products that have category code that match the specified value. 
         * @param {number} [limit] Number of items per page.
         * @param {number} [page] Current page number to be accessed.
         * @param {string} [searchValue] 
         * @param {string} [areaId] id of current user area
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ecommerceGetGoodsProductListV4(aPPTYPE: AppTypeEnum, storeId?: string, categoryCode?: string, limit?: number, page?: number, searchValue?: string, areaId?: string, options?: any): AxiosPromise<EcommerceGetGoodsProductListV4Response> {
            return localVarFp.ecommerceGetGoodsProductListV4(aPPTYPE, storeId, categoryCode, limit, page, searchValue, areaId, options).then((request) => request(axios, basePath));
        },
        /**
         * this is for getting eligible vendor list of coupon
         * @summary Get Eligible Vendor of Coupon
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ecommerceGetMyCoupon(page?: number, limit?: number, options?: any): AxiosPromise<EcommerceGetMyCouponResponse> {
            return localVarFp.ecommerceGetMyCoupon(page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * this is for getting additional fee of a product in mobile apps
         * @summary Get Additional Fee of Product
         * @param {EcommerceGetProductAdditionalFeeRequest} [ecommerceGetProductAdditionalFeeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ecommerceGetProductAdditionalFee(ecommerceGetProductAdditionalFeeRequest?: EcommerceGetProductAdditionalFeeRequest, options?: any): AxiosPromise<EcommerceGetProductAdditionalFeeResponse> {
            return localVarFp.ecommerceGetProductAdditionalFee(ecommerceGetProductAdditionalFeeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * this is for getting detail of product in mobile apps
         * @summary Get Detail Product
         * @param {string} productId product Id
         * @param {string} [storeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ecommerceGetProductDetail(productId: string, storeId?: string, options?: any): AxiosPromise<EcommerceGetProductDetailResponse> {
            return localVarFp.ecommerceGetProductDetail(productId, storeId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get List Products Digital 
         * @summary Get Products digital by category Filter
         * @param {string} biller category code
         * @param {string} [operator] category code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ecommerceGetProductsDigitalsList(biller: string, operator?: string, options?: any): AxiosPromise<EcommerceProductCategoriesDigitalResponse> {
            return localVarFp.ecommerceGetProductsDigitalsList(biller, operator, options).then((request) => request(axios, basePath));
        },
        /**
         * Get List Of Promotions 
         * @summary Get List Of Promotions
         * @param {string} [promoCode] promo code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ecommerceGetPromotionsList(promoCode?: string, options?: any): AxiosPromise<EcommerceGetPromotionsListResponse> {
            return localVarFp.ecommerceGetPromotionsList(promoCode, options).then((request) => request(axios, basePath));
        },
        /**
         * Inquiry Digital Product
         * @summary Inquiry Digital Product
         * @param {EcommerceProductDigitalInquiryRequest} [ecommerceProductDigitalInquiryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ecommerceProductDigitalInquiry(ecommerceProductDigitalInquiryRequest?: EcommerceProductDigitalInquiryRequest, options?: any): AxiosPromise<EcommerceProductDigitalInquiryResponse> {
            return localVarFp.ecommerceProductDigitalInquiry(ecommerceProductDigitalInquiryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Inquiry Digital Product
         * @summary Inquiry Goods Product
         * @param {EcommerceProductGoodsInquiryRequest} [ecommerceProductGoodsInquiryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ecommerceProductGoodsInquiry(ecommerceProductGoodsInquiryRequest?: EcommerceProductGoodsInquiryRequest, options?: any): AxiosPromise<EcommerceProductGoodsInquiryResponse> {
            return localVarFp.ecommerceProductGoodsInquiry(ecommerceProductGoodsInquiryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Inquiry Digital Product
         * @summary Inquiry Goods Product
         * @param {number} [startDate] 
         * @param {number} [endDate] 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ecommerceProductGoodsInquiryList(startDate?: number, endDate?: number, page?: number, limit?: number, options?: any): AxiosPromise<EcommerceProductGoodsInquiryListResponse> {
            return localVarFp.ecommerceProductGoodsInquiryList(startDate, endDate, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * This Api for getting recomendation product base on search value
         * @summary Search Product
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} searchValue 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ecommerceSearchGoodsProduct(aPPTYPE: AppTypeEnum, searchValue: string, options?: any): AxiosPromise<EcommerceSearchGoodsProductResponse> {
            return localVarFp.ecommerceSearchGoodsProduct(aPPTYPE, searchValue, options).then((request) => request(axios, basePath));
        },
        /**
         * Get store areas
         * @summary Get Store Areas
         * @param {string} [searchName] 
         * @param {string} [zoneId] 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ecommerceStoreGetAreas(searchName?: string, zoneId?: string, page?: number, limit?: number, options?: any): AxiosPromise<EcommerceStoreGetAreasResponse> {
            return localVarFp.ecommerceStoreGetAreas(searchName, zoneId, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * This is for mobile app to get list of cities store
         * @summary Getting List of cities store
         * @param {string} [province] 
         * @param {string} [city] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ecommerceStoreGetCities(province?: string, city?: string, options?: any): AxiosPromise<EcommerceStoresGetCitiesResponse> {
            return localVarFp.ecommerceStoreGetCities(province, city, options).then((request) => request(axios, basePath));
        },
        /**
         * This is for mobile app to get list of provinces store
         * @summary Getting List of provinces store
         * @param {string} [province] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ecommerceStoreGetProvinces(province?: string, options?: any): AxiosPromise<EcommerceStoresGetProvincesResponse> {
            return localVarFp.ecommerceStoreGetProvinces(province, options).then((request) => request(axios, basePath));
        },
        /**
         * Display finance invoice detail 
         * @summary Get finance invoice detail
         * @param {string} invoiceId Invoice UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        financeGetInvoiceDetail(invoiceId: string, options?: any): AxiosPromise<FinanceGetInvoiceDetailResponse> {
            return localVarFp.financeGetInvoiceDetail(invoiceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Display list of finance invoice 
         * @summary Get finance invoice list
         * @param {InvoiceStatusEnum} [invoiceStatus] 
         * @param {string} [invoiceNo] 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {InvoiceFinanceSortFieldEnum} [sortField] 
         * @param {InvoiceDirectionEnum} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        financeInvoiceList(invoiceStatus?: InvoiceStatusEnum, invoiceNo?: string, page?: number, limit?: number, sortField?: InvoiceFinanceSortFieldEnum, sortBy?: InvoiceDirectionEnum, options?: any): AxiosPromise<FinanceInvoiceListResponse> {
            return localVarFp.financeInvoiceList(invoiceStatus, invoiceNo, page, limit, sortField, sortBy, options).then((request) => request(axios, basePath));
        },
        /**
         * Used by finance to check and update payment status when the customer has transfer to VA and system not receive notification from doku 
         * @summary Verify Manual Doku Payment Briva by Finance
         * @param {FinancePaymentVerifyDokuRequest} financePaymentVerifyDokuRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        financePaymentVerifyDoku(financePaymentVerifyDokuRequest: FinancePaymentVerifyDokuRequest, options?: any): AxiosPromise<FinancePaymentVerifyDokuResponse> {
            return localVarFp.financePaymentVerifyDoku(financePaymentVerifyDokuRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * this is for getting detail of product in mobile apps
         * @summary Get Product Category
         * @param {EcommerceProductTypeEnum} [type] 
         * @param {string} [areaId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductCategories(type?: EcommerceProductTypeEnum, areaId?: string, options?: any): AxiosPromise<GetProductCategoriesResponse> {
            return localVarFp.getProductCategories(type, areaId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Invoice List By Order Id
         * @summary Get Invoice List By Order Id
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} orderId 
         * @param {string} [userId] used by DUTA app, id of the user that this request is for
         * @param {string} [phoneNo] Phone number of the user, this is for guest mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicesList(aPPTYPE: AppTypeEnum, orderId: string, userId?: string, phoneNo?: string, options?: any): AxiosPromise<InvoicesListResponse> {
            return localVarFp.invoicesList(aPPTYPE, orderId, userId, phoneNo, options).then((request) => request(axios, basePath));
        },
        /**
         * Create Order E-Commerce 
         * @summary Create Order
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {OrderCreateRequest} orderCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderCreate(aPPTYPE: AppTypeEnum, orderCreateRequest: OrderCreateRequest, options?: any): AxiosPromise<OrderCreateResponse> {
            return localVarFp.orderCreate(aPPTYPE, orderCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Used to cancel an order by the user <br>If the order status is DRAFT, the order can be canceled without approval <br>If the order status is NEW, the order can be canceled without approval and the system will refund the payment at SawitPoin <br>If the order status is CONFIRMED, the order can be canceled with approval <br>If the order status is READY_TO_PICK_UP/ FULL_DELIVERED/ COMPLETED/ CANCELED, the order cannot be canceled 
         * @summary Cancel Order
         * @param {string} orderId Sale Order UUID
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {OrdersCancelRequest} ordersCancelRequest 
         * @param {string} [userId] used by DUTA app, id of the user that this request is for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersCancel(orderId: string, aPPTYPE: AppTypeEnum, ordersCancelRequest: OrdersCancelRequest, userId?: string, options?: any): AxiosPromise<OrdersCancelResponse> {
            return localVarFp.ordersCancel(orderId, aPPTYPE, ordersCancelRequest, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create Delivery Order Information E-Commerce 
         * @summary Create Delivery Order Information
         * @param {string} orderId Sale Order UUID
         * @param {OrdersDeliveriesCreateRequest} ordersDeliveriesCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersDeliveriesCreate(orderId: string, ordersDeliveriesCreateRequest: OrdersDeliveriesCreateRequest, options?: any): AxiosPromise<OrdersDeliveriesCreateResponse> {
            return localVarFp.ordersDeliveriesCreate(orderId, ordersDeliveriesCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Sale Order Detail
         * @summary Get Sale Order Detail
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} orderId Sale Order UUID
         * @param {string} [userId] used by DUTA app, id of the user that this request is for
         * @param {string} [phoneNo] Phone number of the user, this is for guest mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersGetDetail(aPPTYPE: AppTypeEnum, orderId: string, userId?: string, phoneNo?: string, options?: any): AxiosPromise<OrdersGetDetailResponse> {
            return localVarFp.ordersGetDetail(aPPTYPE, orderId, userId, phoneNo, options).then((request) => request(axios, basePath));
        },
        /**
         * Display all order
         * @summary Get order list
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {SaleOrderStatusEnum} [status] 
         * @param {number} [startDate] 
         * @param {number} [endDate] 
         * @param {EcommerceProductTypeFilterEnum} [productType] 
         * @param {string} [userId] used by DUTA app, id of the user that this request is for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersList(aPPTYPE: AppTypeEnum, page?: number, limit?: number, status?: SaleOrderStatusEnum, startDate?: number, endDate?: number, productType?: EcommerceProductTypeFilterEnum, userId?: string, options?: any): AxiosPromise<OrdersListResponse> {
            return localVarFp.ordersList(aPPTYPE, page, limit, status, startDate, endDate, productType, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Used by operation and warehouse team to update sale order status when manage/proceeding the sale order 
         * @summary Update Sale Order Status
         * @param {string} orderId Sale Order UUID
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {OrdersUpdateStatusRequest} ordersUpdateStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersUpdateStatus(orderId: string, aPPTYPE: AppTypeEnum, ordersUpdateStatusRequest: OrdersUpdateStatusRequest, options?: any): AxiosPromise<OrdersUpdateStatusResponse> {
            return localVarFp.ordersUpdateStatus(orderId, aPPTYPE, ordersUpdateStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * User can create payment after order product 
         * @summary Create Payment with Generic Payment Method
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {PaymentsCreatePaymentRequest} paymentsCreatePaymentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsCreate(aPPTYPE: AppTypeEnum, paymentsCreatePaymentRequest: PaymentsCreatePaymentRequest, options?: any): AxiosPromise<PaymentsCreatePaymentResponse> {
            return localVarFp.paymentsCreate(aPPTYPE, paymentsCreatePaymentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * User can create payment after order product 
         * @summary Create Payment
         * @param {PaymentsCreateDirectPaymentRequest} paymentsCreateDirectPaymentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsCreateDirectPayment(paymentsCreateDirectPaymentRequest: PaymentsCreateDirectPaymentRequest, options?: any): AxiosPromise<PaymentsCreateDirectPaymentResponse> {
            return localVarFp.paymentsCreateDirectPayment(paymentsCreateDirectPaymentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Used by finance to update a payment status when the customer has made a bank transfer 
         * @summary Verify Manual Transfer by Finance
         * @param {PaymentsVerifyRequest} paymentsVerifyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsVerify(paymentsVerifyRequest: PaymentsVerifyRequest, options?: any): AxiosPromise<PaymentsVerifyResponse> {
            return localVarFp.paymentsVerify(paymentsVerifyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Display all product 
         * @summary Get product list
         * @param {string} [storeId] 
         * @param {string} [categoryCode] Filter product by category code. If is nil, will return all products. If specified, will return products that have category code that match the specified value. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productList(storeId?: string, categoryCode?: string, options?: any): AxiosPromise<ProductListResponse> {
            return localVarFp.productList(storeId, categoryCode, options).then((request) => request(axios, basePath));
        },
        /**
         * Display all store 
         * @summary Get store list
         * @param {number} [longitude] 
         * @param {number} [latitude] 
         * @param {string} [province] 
         * @param {string} [city] 
         * @param {string} [searchName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storesList(longitude?: number, latitude?: number, province?: string, city?: string, searchName?: string, options?: any): AxiosPromise<StoresListResponse> {
            return localVarFp.storesList(longitude, latitude, province, city, searchName, options).then((request) => request(axios, basePath));
        },
        /**
         * this is for getting eligible store list of coupon
         * @summary Get Eligible Store of Coupon
         * @param {string} couponId coupon Id
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {string} [province] 
         * @param {string} [city] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2EcommerceCouponGetVendorList(couponId: string, page?: number, limit?: number, province?: string, city?: string, options?: any): AxiosPromise<V2EcommerceCouponGetVendorListResponse> {
            return localVarFp.v2EcommerceCouponGetVendorList(couponId, page, limit, province, city, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EcommerceApi - object-oriented interface
 * @export
 * @class EcommerceApi
 * @extends {BaseAPI}
 */
export class EcommerceApi extends BaseAPI {
    /**
     * Admins can able create product pricelist
     * @summary Create product pricelist
     * @param {AdminsEcommerceProductPriceListsCreateRequest} [adminsEcommerceProductPriceListsCreateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EcommerceApi
     */
    public adminsEcommerceProductPriceListsCreate(adminsEcommerceProductPriceListsCreateRequest?: AdminsEcommerceProductPriceListsCreateRequest, options?: AxiosRequestConfig) {
        return EcommerceApiFp(this.configuration).adminsEcommerceProductPriceListsCreate(adminsEcommerceProductPriceListsCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * admins can able to update product pricelist
     * @summary Update product pricelist
     * @param {string} pricelistId Pricelist UUID
     * @param {AdminsEcommerceProductPriceListsUpdateRequest} [adminsEcommerceProductPriceListsUpdateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EcommerceApi
     */
    public adminsEcommerceProductPriceListsUpdate(pricelistId: string, adminsEcommerceProductPriceListsUpdateRequest?: AdminsEcommerceProductPriceListsUpdateRequest, options?: AxiosRequestConfig) {
        return EcommerceApiFp(this.configuration).adminsEcommerceProductPriceListsUpdate(pricelistId, adminsEcommerceProductPriceListsUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * admins can be able to update product pricelist
     * @summary Update product pricelist V2
     * @param {AdminsEcommerceProductPriceListsUpdateV2Request} [adminsEcommerceProductPriceListsUpdateV2Request] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EcommerceApi
     */
    public adminsEcommerceProductPriceListsUpdateV2(adminsEcommerceProductPriceListsUpdateV2Request?: AdminsEcommerceProductPriceListsUpdateV2Request, options?: AxiosRequestConfig) {
        return EcommerceApiFp(this.configuration).adminsEcommerceProductPriceListsUpdateV2(adminsEcommerceProductPriceListsUpdateV2Request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Used by MemberApp to create cart data for user 
     * @summary Create cart data for user
     * @param {CartCreateRequest} cartCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EcommerceApi
     */
    public cartCreate(cartCreateRequest: CartCreateRequest, options?: AxiosRequestConfig) {
        return EcommerceApiFp(this.configuration).cartCreate(cartCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Used by MemberApp to get cart data for user 
     * @summary Get cart data for user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EcommerceApi
     */
    public cartsGetDetail(options?: AxiosRequestConfig) {
        return EcommerceApiFp(this.configuration).cartsGetDetail(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Product SKU Count in One Cart
     * @summary Get Total Product SKU of Cart
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EcommerceApi
     */
    public cartsGetProductCount(options?: AxiosRequestConfig) {
        return EcommerceApiFp(this.configuration).cartsGetProductCount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Used by MemberApp to remove product from active cart 
     * @summary Remove product from cart
     * @param {string} cartItemId Cart Item UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EcommerceApi
     */
    public cartsItemsDelete(cartItemId: string, options?: AxiosRequestConfig) {
        return EcommerceApiFp(this.configuration).cartsItemsDelete(cartItemId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * this is for getting eligible vendor list of coupon
     * @summary Get Eligible Vendor of Coupon
     * @param {string} couponId coupon Id
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EcommerceApi
     */
    public ecommerceCouponGetVendorList(couponId: string, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return EcommerceApiFp(this.configuration).ecommerceCouponGetVendorList(couponId, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * this is for getting eligible vendor list of coupon
     * @summary Redeem coupon
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {EcommerceCouponsRedeemRequest} ecommerceCouponsRedeemRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EcommerceApi
     */
    public ecommerceCouponsRedeem(aPPTYPE: AppTypeEnum, ecommerceCouponsRedeemRequest: EcommerceCouponsRedeemRequest, options?: AxiosRequestConfig) {
        return EcommerceApiFp(this.configuration).ecommerceCouponsRedeem(aPPTYPE, ecommerceCouponsRedeemRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get list of pick up locations 
     * @summary Get List of Pick Up Location
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} [zoneId] zone id in uuid format
     * @param {number} [longitude] longitude of current user
     * @param {number} [latitude] latitude of current user
     * @param {number} [limit] Number of items per page.
     * @param {number} [page] Current page number to be accessed.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EcommerceApi
     */
    public ecommerceDeliveriesPickUpsGetPickUpLocations(aPPTYPE: AppTypeEnum, zoneId?: string, longitude?: number, latitude?: number, limit?: number, page?: number, options?: AxiosRequestConfig) {
        return EcommerceApiFp(this.configuration).ecommerceDeliveriesPickUpsGetPickUpLocations(aPPTYPE, zoneId, longitude, latitude, limit, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * this is for verify that coupon is eligible or not for that vendor
     * @summary Ecommerce Get Coupons Verify
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} couponCode coupon code
     * @param {QRCodeSourceEnum} qrcodeSource qrcode source, this getting from scanner from web or mobile
     * @param {string} qrcodeValue qrcode value, this value of qrcode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EcommerceApi
     */
    public ecommerceGetCouponsVerify(aPPTYPE: AppTypeEnum, couponCode: string, qrcodeSource: QRCodeSourceEnum, qrcodeValue: string, options?: AxiosRequestConfig) {
        return EcommerceApiFp(this.configuration).ecommerceGetCouponsVerify(aPPTYPE, couponCode, qrcodeSource, qrcodeValue, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Display all product with type goods 
     * @summary Get product list
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} [storeId] 
     * @param {string} [categoryCode] Filter product by category code. If is nil, will return all products. If specified, will return products that have category code that match the specified value. 
     * @param {number} [longitude] 
     * @param {number} [latitude] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EcommerceApi
     */
    public ecommerceGetGoodsProductList(aPPTYPE: AppTypeEnum, storeId?: string, categoryCode?: string, longitude?: number, latitude?: number, options?: AxiosRequestConfig) {
        return EcommerceApiFp(this.configuration).ecommerceGetGoodsProductList(aPPTYPE, storeId, categoryCode, longitude, latitude, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * this is display the product base on sku and pricelist
     * @summary Get product list V2
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} [storeId] 
     * @param {string} [categoryCode] Filter product by category code. If is nil, will return all products. If specified, will return products that have category code that match the specified value. 
     * @param {number} [longitude] 
     * @param {number} [latitude] 
     * @param {number} [limit] Number of items per page.
     * @param {number} [page] Current page number to be accessed.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EcommerceApi
     */
    public ecommerceGetGoodsProductListV2(aPPTYPE: AppTypeEnum, storeId?: string, categoryCode?: string, longitude?: number, latitude?: number, limit?: number, page?: number, options?: AxiosRequestConfig) {
        return EcommerceApiFp(this.configuration).ecommerceGetGoodsProductListV2(aPPTYPE, storeId, categoryCode, longitude, latitude, limit, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * this is display the product base on sku and pricelist
     * @summary Get product list V3
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} [storeId] 
     * @param {string} [categoryCode] Filter product by category code. If is nil, will return all products. If specified, will return products that have category code that match the specified value. 
     * @param {number} [longitude] 
     * @param {number} [latitude] 
     * @param {number} [limit] Number of items per page.
     * @param {number} [page] Current page number to be accessed.
     * @param {string} [searchValue] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EcommerceApi
     */
    public ecommerceGetGoodsProductListV3(aPPTYPE: AppTypeEnum, storeId?: string, categoryCode?: string, longitude?: number, latitude?: number, limit?: number, page?: number, searchValue?: string, options?: AxiosRequestConfig) {
        return EcommerceApiFp(this.configuration).ecommerceGetGoodsProductListV3(aPPTYPE, storeId, categoryCode, longitude, latitude, limit, page, searchValue, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * this is display the product catalog based on zone
     * @summary Get product list V4
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} [storeId] 
     * @param {string} [categoryCode] Filter product by category code. If is nil, will return all products. If specified, will return products that have category code that match the specified value. 
     * @param {number} [limit] Number of items per page.
     * @param {number} [page] Current page number to be accessed.
     * @param {string} [searchValue] 
     * @param {string} [areaId] id of current user area
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EcommerceApi
     */
    public ecommerceGetGoodsProductListV4(aPPTYPE: AppTypeEnum, storeId?: string, categoryCode?: string, limit?: number, page?: number, searchValue?: string, areaId?: string, options?: AxiosRequestConfig) {
        return EcommerceApiFp(this.configuration).ecommerceGetGoodsProductListV4(aPPTYPE, storeId, categoryCode, limit, page, searchValue, areaId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * this is for getting eligible vendor list of coupon
     * @summary Get Eligible Vendor of Coupon
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EcommerceApi
     */
    public ecommerceGetMyCoupon(page?: number, limit?: number, options?: AxiosRequestConfig) {
        return EcommerceApiFp(this.configuration).ecommerceGetMyCoupon(page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * this is for getting additional fee of a product in mobile apps
     * @summary Get Additional Fee of Product
     * @param {EcommerceGetProductAdditionalFeeRequest} [ecommerceGetProductAdditionalFeeRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EcommerceApi
     */
    public ecommerceGetProductAdditionalFee(ecommerceGetProductAdditionalFeeRequest?: EcommerceGetProductAdditionalFeeRequest, options?: AxiosRequestConfig) {
        return EcommerceApiFp(this.configuration).ecommerceGetProductAdditionalFee(ecommerceGetProductAdditionalFeeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * this is for getting detail of product in mobile apps
     * @summary Get Detail Product
     * @param {string} productId product Id
     * @param {string} [storeId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EcommerceApi
     */
    public ecommerceGetProductDetail(productId: string, storeId?: string, options?: AxiosRequestConfig) {
        return EcommerceApiFp(this.configuration).ecommerceGetProductDetail(productId, storeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get List Products Digital 
     * @summary Get Products digital by category Filter
     * @param {string} biller category code
     * @param {string} [operator] category code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EcommerceApi
     */
    public ecommerceGetProductsDigitalsList(biller: string, operator?: string, options?: AxiosRequestConfig) {
        return EcommerceApiFp(this.configuration).ecommerceGetProductsDigitalsList(biller, operator, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get List Of Promotions 
     * @summary Get List Of Promotions
     * @param {string} [promoCode] promo code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EcommerceApi
     */
    public ecommerceGetPromotionsList(promoCode?: string, options?: AxiosRequestConfig) {
        return EcommerceApiFp(this.configuration).ecommerceGetPromotionsList(promoCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Inquiry Digital Product
     * @summary Inquiry Digital Product
     * @param {EcommerceProductDigitalInquiryRequest} [ecommerceProductDigitalInquiryRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EcommerceApi
     */
    public ecommerceProductDigitalInquiry(ecommerceProductDigitalInquiryRequest?: EcommerceProductDigitalInquiryRequest, options?: AxiosRequestConfig) {
        return EcommerceApiFp(this.configuration).ecommerceProductDigitalInquiry(ecommerceProductDigitalInquiryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Inquiry Digital Product
     * @summary Inquiry Goods Product
     * @param {EcommerceProductGoodsInquiryRequest} [ecommerceProductGoodsInquiryRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EcommerceApi
     */
    public ecommerceProductGoodsInquiry(ecommerceProductGoodsInquiryRequest?: EcommerceProductGoodsInquiryRequest, options?: AxiosRequestConfig) {
        return EcommerceApiFp(this.configuration).ecommerceProductGoodsInquiry(ecommerceProductGoodsInquiryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Inquiry Digital Product
     * @summary Inquiry Goods Product
     * @param {number} [startDate] 
     * @param {number} [endDate] 
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EcommerceApi
     */
    public ecommerceProductGoodsInquiryList(startDate?: number, endDate?: number, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return EcommerceApiFp(this.configuration).ecommerceProductGoodsInquiryList(startDate, endDate, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This Api for getting recomendation product base on search value
     * @summary Search Product
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} searchValue 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EcommerceApi
     */
    public ecommerceSearchGoodsProduct(aPPTYPE: AppTypeEnum, searchValue: string, options?: AxiosRequestConfig) {
        return EcommerceApiFp(this.configuration).ecommerceSearchGoodsProduct(aPPTYPE, searchValue, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get store areas
     * @summary Get Store Areas
     * @param {string} [searchName] 
     * @param {string} [zoneId] 
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EcommerceApi
     */
    public ecommerceStoreGetAreas(searchName?: string, zoneId?: string, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return EcommerceApiFp(this.configuration).ecommerceStoreGetAreas(searchName, zoneId, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This is for mobile app to get list of cities store
     * @summary Getting List of cities store
     * @param {string} [province] 
     * @param {string} [city] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EcommerceApi
     */
    public ecommerceStoreGetCities(province?: string, city?: string, options?: AxiosRequestConfig) {
        return EcommerceApiFp(this.configuration).ecommerceStoreGetCities(province, city, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This is for mobile app to get list of provinces store
     * @summary Getting List of provinces store
     * @param {string} [province] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EcommerceApi
     */
    public ecommerceStoreGetProvinces(province?: string, options?: AxiosRequestConfig) {
        return EcommerceApiFp(this.configuration).ecommerceStoreGetProvinces(province, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Display finance invoice detail 
     * @summary Get finance invoice detail
     * @param {string} invoiceId Invoice UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EcommerceApi
     */
    public financeGetInvoiceDetail(invoiceId: string, options?: AxiosRequestConfig) {
        return EcommerceApiFp(this.configuration).financeGetInvoiceDetail(invoiceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Display list of finance invoice 
     * @summary Get finance invoice list
     * @param {InvoiceStatusEnum} [invoiceStatus] 
     * @param {string} [invoiceNo] 
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {InvoiceFinanceSortFieldEnum} [sortField] 
     * @param {InvoiceDirectionEnum} [sortBy] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EcommerceApi
     */
    public financeInvoiceList(invoiceStatus?: InvoiceStatusEnum, invoiceNo?: string, page?: number, limit?: number, sortField?: InvoiceFinanceSortFieldEnum, sortBy?: InvoiceDirectionEnum, options?: AxiosRequestConfig) {
        return EcommerceApiFp(this.configuration).financeInvoiceList(invoiceStatus, invoiceNo, page, limit, sortField, sortBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Used by finance to check and update payment status when the customer has transfer to VA and system not receive notification from doku 
     * @summary Verify Manual Doku Payment Briva by Finance
     * @param {FinancePaymentVerifyDokuRequest} financePaymentVerifyDokuRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EcommerceApi
     */
    public financePaymentVerifyDoku(financePaymentVerifyDokuRequest: FinancePaymentVerifyDokuRequest, options?: AxiosRequestConfig) {
        return EcommerceApiFp(this.configuration).financePaymentVerifyDoku(financePaymentVerifyDokuRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * this is for getting detail of product in mobile apps
     * @summary Get Product Category
     * @param {EcommerceProductTypeEnum} [type] 
     * @param {string} [areaId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EcommerceApi
     */
    public getProductCategories(type?: EcommerceProductTypeEnum, areaId?: string, options?: AxiosRequestConfig) {
        return EcommerceApiFp(this.configuration).getProductCategories(type, areaId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Invoice List By Order Id
     * @summary Get Invoice List By Order Id
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} orderId 
     * @param {string} [userId] used by DUTA app, id of the user that this request is for
     * @param {string} [phoneNo] Phone number of the user, this is for guest mode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EcommerceApi
     */
    public invoicesList(aPPTYPE: AppTypeEnum, orderId: string, userId?: string, phoneNo?: string, options?: AxiosRequestConfig) {
        return EcommerceApiFp(this.configuration).invoicesList(aPPTYPE, orderId, userId, phoneNo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create Order E-Commerce 
     * @summary Create Order
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {OrderCreateRequest} orderCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EcommerceApi
     */
    public orderCreate(aPPTYPE: AppTypeEnum, orderCreateRequest: OrderCreateRequest, options?: AxiosRequestConfig) {
        return EcommerceApiFp(this.configuration).orderCreate(aPPTYPE, orderCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Used to cancel an order by the user <br>If the order status is DRAFT, the order can be canceled without approval <br>If the order status is NEW, the order can be canceled without approval and the system will refund the payment at SawitPoin <br>If the order status is CONFIRMED, the order can be canceled with approval <br>If the order status is READY_TO_PICK_UP/ FULL_DELIVERED/ COMPLETED/ CANCELED, the order cannot be canceled 
     * @summary Cancel Order
     * @param {string} orderId Sale Order UUID
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {OrdersCancelRequest} ordersCancelRequest 
     * @param {string} [userId] used by DUTA app, id of the user that this request is for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EcommerceApi
     */
    public ordersCancel(orderId: string, aPPTYPE: AppTypeEnum, ordersCancelRequest: OrdersCancelRequest, userId?: string, options?: AxiosRequestConfig) {
        return EcommerceApiFp(this.configuration).ordersCancel(orderId, aPPTYPE, ordersCancelRequest, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create Delivery Order Information E-Commerce 
     * @summary Create Delivery Order Information
     * @param {string} orderId Sale Order UUID
     * @param {OrdersDeliveriesCreateRequest} ordersDeliveriesCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EcommerceApi
     */
    public ordersDeliveriesCreate(orderId: string, ordersDeliveriesCreateRequest: OrdersDeliveriesCreateRequest, options?: AxiosRequestConfig) {
        return EcommerceApiFp(this.configuration).ordersDeliveriesCreate(orderId, ordersDeliveriesCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Sale Order Detail
     * @summary Get Sale Order Detail
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} orderId Sale Order UUID
     * @param {string} [userId] used by DUTA app, id of the user that this request is for
     * @param {string} [phoneNo] Phone number of the user, this is for guest mode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EcommerceApi
     */
    public ordersGetDetail(aPPTYPE: AppTypeEnum, orderId: string, userId?: string, phoneNo?: string, options?: AxiosRequestConfig) {
        return EcommerceApiFp(this.configuration).ordersGetDetail(aPPTYPE, orderId, userId, phoneNo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Display all order
     * @summary Get order list
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {SaleOrderStatusEnum} [status] 
     * @param {number} [startDate] 
     * @param {number} [endDate] 
     * @param {EcommerceProductTypeFilterEnum} [productType] 
     * @param {string} [userId] used by DUTA app, id of the user that this request is for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EcommerceApi
     */
    public ordersList(aPPTYPE: AppTypeEnum, page?: number, limit?: number, status?: SaleOrderStatusEnum, startDate?: number, endDate?: number, productType?: EcommerceProductTypeFilterEnum, userId?: string, options?: AxiosRequestConfig) {
        return EcommerceApiFp(this.configuration).ordersList(aPPTYPE, page, limit, status, startDate, endDate, productType, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Used by operation and warehouse team to update sale order status when manage/proceeding the sale order 
     * @summary Update Sale Order Status
     * @param {string} orderId Sale Order UUID
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {OrdersUpdateStatusRequest} ordersUpdateStatusRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EcommerceApi
     */
    public ordersUpdateStatus(orderId: string, aPPTYPE: AppTypeEnum, ordersUpdateStatusRequest: OrdersUpdateStatusRequest, options?: AxiosRequestConfig) {
        return EcommerceApiFp(this.configuration).ordersUpdateStatus(orderId, aPPTYPE, ordersUpdateStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * User can create payment after order product 
     * @summary Create Payment with Generic Payment Method
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {PaymentsCreatePaymentRequest} paymentsCreatePaymentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EcommerceApi
     */
    public paymentsCreate(aPPTYPE: AppTypeEnum, paymentsCreatePaymentRequest: PaymentsCreatePaymentRequest, options?: AxiosRequestConfig) {
        return EcommerceApiFp(this.configuration).paymentsCreate(aPPTYPE, paymentsCreatePaymentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * User can create payment after order product 
     * @summary Create Payment
     * @param {PaymentsCreateDirectPaymentRequest} paymentsCreateDirectPaymentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EcommerceApi
     */
    public paymentsCreateDirectPayment(paymentsCreateDirectPaymentRequest: PaymentsCreateDirectPaymentRequest, options?: AxiosRequestConfig) {
        return EcommerceApiFp(this.configuration).paymentsCreateDirectPayment(paymentsCreateDirectPaymentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Used by finance to update a payment status when the customer has made a bank transfer 
     * @summary Verify Manual Transfer by Finance
     * @param {PaymentsVerifyRequest} paymentsVerifyRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EcommerceApi
     */
    public paymentsVerify(paymentsVerifyRequest: PaymentsVerifyRequest, options?: AxiosRequestConfig) {
        return EcommerceApiFp(this.configuration).paymentsVerify(paymentsVerifyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Display all product 
     * @summary Get product list
     * @param {string} [storeId] 
     * @param {string} [categoryCode] Filter product by category code. If is nil, will return all products. If specified, will return products that have category code that match the specified value. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EcommerceApi
     */
    public productList(storeId?: string, categoryCode?: string, options?: AxiosRequestConfig) {
        return EcommerceApiFp(this.configuration).productList(storeId, categoryCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Display all store 
     * @summary Get store list
     * @param {number} [longitude] 
     * @param {number} [latitude] 
     * @param {string} [province] 
     * @param {string} [city] 
     * @param {string} [searchName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EcommerceApi
     */
    public storesList(longitude?: number, latitude?: number, province?: string, city?: string, searchName?: string, options?: AxiosRequestConfig) {
        return EcommerceApiFp(this.configuration).storesList(longitude, latitude, province, city, searchName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * this is for getting eligible store list of coupon
     * @summary Get Eligible Store of Coupon
     * @param {string} couponId coupon Id
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {string} [province] 
     * @param {string} [city] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EcommerceApi
     */
    public v2EcommerceCouponGetVendorList(couponId: string, page?: number, limit?: number, province?: string, city?: string, options?: AxiosRequestConfig) {
        return EcommerceApiFp(this.configuration).v2EcommerceCouponGetVendorList(couponId, page, limit, province, city, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * EcommerceOperationApi - axios parameter creator
 * @export
 */
export const EcommerceOperationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Used to approve or reject cancel order request 
         * @summary Confirm Cancel Order Request by Operation
         * @param {string} orderId Sale Order UUID
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {OrdersCancelConfirmationRequest} ordersCancelConfirmationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersCancelConfirmation: async (orderId: string, aPPTYPE: AppTypeEnum, ordersCancelConfirmationRequest: OrdersCancelConfirmationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('ordersCancelConfirmation', 'orderId', orderId)
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('ordersCancelConfirmation', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'ordersCancelConfirmationRequest' is not null or undefined
            assertParamExists('ordersCancelConfirmation', 'ordersCancelConfirmationRequest', ordersCancelConfirmationRequest)
            const localVarPath = `/api/v1/orders/{orderId}/cancel/confirmation`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ordersCancelConfirmationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Display all order for operation
         * @summary Get order list for operation team
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {SaleOrderStatusEnum} [orderStatus] 
         * @param {string} [orderNo] Sale Order Number
         * @param {OrderOperationSortFieldEnum} [sortField] 
         * @param {OrderDirectionEnum} [sortBy] 
         * @param {EcommerceProductTypeEnum} [productType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersListOperation: async (page?: number, limit?: number, orderStatus?: SaleOrderStatusEnum, orderNo?: string, sortField?: OrderOperationSortFieldEnum, sortBy?: OrderDirectionEnum, productType?: EcommerceProductTypeEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/orders/operation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (orderStatus !== undefined) {
                localVarQueryParameter['orderStatus'] = orderStatus;
            }

            if (orderNo !== undefined) {
                localVarQueryParameter['orderNo'] = orderNo;
            }

            if (sortField !== undefined) {
                localVarQueryParameter['sortField'] = sortField;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (productType !== undefined) {
                localVarQueryParameter['productType'] = productType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EcommerceOperationApi - functional programming interface
 * @export
 */
export const EcommerceOperationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EcommerceOperationApiAxiosParamCreator(configuration)
    return {
        /**
         * Used to approve or reject cancel order request 
         * @summary Confirm Cancel Order Request by Operation
         * @param {string} orderId Sale Order UUID
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {OrdersCancelConfirmationRequest} ordersCancelConfirmationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ordersCancelConfirmation(orderId: string, aPPTYPE: AppTypeEnum, ordersCancelConfirmationRequest: OrdersCancelConfirmationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrdersCancelConfirmationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ordersCancelConfirmation(orderId, aPPTYPE, ordersCancelConfirmationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Display all order for operation
         * @summary Get order list for operation team
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {SaleOrderStatusEnum} [orderStatus] 
         * @param {string} [orderNo] Sale Order Number
         * @param {OrderOperationSortFieldEnum} [sortField] 
         * @param {OrderDirectionEnum} [sortBy] 
         * @param {EcommerceProductTypeEnum} [productType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ordersListOperation(page?: number, limit?: number, orderStatus?: SaleOrderStatusEnum, orderNo?: string, sortField?: OrderOperationSortFieldEnum, sortBy?: OrderDirectionEnum, productType?: EcommerceProductTypeEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrdersListOperationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ordersListOperation(page, limit, orderStatus, orderNo, sortField, sortBy, productType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EcommerceOperationApi - factory interface
 * @export
 */
export const EcommerceOperationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EcommerceOperationApiFp(configuration)
    return {
        /**
         * Used to approve or reject cancel order request 
         * @summary Confirm Cancel Order Request by Operation
         * @param {string} orderId Sale Order UUID
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {OrdersCancelConfirmationRequest} ordersCancelConfirmationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersCancelConfirmation(orderId: string, aPPTYPE: AppTypeEnum, ordersCancelConfirmationRequest: OrdersCancelConfirmationRequest, options?: any): AxiosPromise<OrdersCancelConfirmationResponse> {
            return localVarFp.ordersCancelConfirmation(orderId, aPPTYPE, ordersCancelConfirmationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Display all order for operation
         * @summary Get order list for operation team
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {SaleOrderStatusEnum} [orderStatus] 
         * @param {string} [orderNo] Sale Order Number
         * @param {OrderOperationSortFieldEnum} [sortField] 
         * @param {OrderDirectionEnum} [sortBy] 
         * @param {EcommerceProductTypeEnum} [productType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersListOperation(page?: number, limit?: number, orderStatus?: SaleOrderStatusEnum, orderNo?: string, sortField?: OrderOperationSortFieldEnum, sortBy?: OrderDirectionEnum, productType?: EcommerceProductTypeEnum, options?: any): AxiosPromise<OrdersListOperationResponse> {
            return localVarFp.ordersListOperation(page, limit, orderStatus, orderNo, sortField, sortBy, productType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EcommerceOperationApi - object-oriented interface
 * @export
 * @class EcommerceOperationApi
 * @extends {BaseAPI}
 */
export class EcommerceOperationApi extends BaseAPI {
    /**
     * Used to approve or reject cancel order request 
     * @summary Confirm Cancel Order Request by Operation
     * @param {string} orderId Sale Order UUID
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {OrdersCancelConfirmationRequest} ordersCancelConfirmationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EcommerceOperationApi
     */
    public ordersCancelConfirmation(orderId: string, aPPTYPE: AppTypeEnum, ordersCancelConfirmationRequest: OrdersCancelConfirmationRequest, options?: AxiosRequestConfig) {
        return EcommerceOperationApiFp(this.configuration).ordersCancelConfirmation(orderId, aPPTYPE, ordersCancelConfirmationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Display all order for operation
     * @summary Get order list for operation team
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {SaleOrderStatusEnum} [orderStatus] 
     * @param {string} [orderNo] Sale Order Number
     * @param {OrderOperationSortFieldEnum} [sortField] 
     * @param {OrderDirectionEnum} [sortBy] 
     * @param {EcommerceProductTypeEnum} [productType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EcommerceOperationApi
     */
    public ordersListOperation(page?: number, limit?: number, orderStatus?: SaleOrderStatusEnum, orderNo?: string, sortField?: OrderOperationSortFieldEnum, sortBy?: OrderDirectionEnum, productType?: EcommerceProductTypeEnum, options?: AxiosRequestConfig) {
        return EcommerceOperationApiFp(this.configuration).ordersListOperation(page, limit, orderStatus, orderNo, sortField, sortBy, productType, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * EcommerceWarehouseApi - axios parameter creator
 * @export
 */
export const EcommerceWarehouseApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Display order for warehouse
         * @summary Get order for warehouse team
         * @param {string} invoiceNo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderWarehouse: async (invoiceNo: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invoiceNo' is not null or undefined
            assertParamExists('getOrderWarehouse', 'invoiceNo', invoiceNo)
            const localVarPath = `/api/v1/orders/warehouse`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (invoiceNo !== undefined) {
                localVarQueryParameter['invoiceNo'] = invoiceNo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EcommerceWarehouseApi - functional programming interface
 * @export
 */
export const EcommerceWarehouseApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EcommerceWarehouseApiAxiosParamCreator(configuration)
    return {
        /**
         * Display order for warehouse
         * @summary Get order for warehouse team
         * @param {string} invoiceNo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderWarehouse(invoiceNo: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrderWarehouseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderWarehouse(invoiceNo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EcommerceWarehouseApi - factory interface
 * @export
 */
export const EcommerceWarehouseApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EcommerceWarehouseApiFp(configuration)
    return {
        /**
         * Display order for warehouse
         * @summary Get order for warehouse team
         * @param {string} invoiceNo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderWarehouse(invoiceNo: string, options?: any): AxiosPromise<GetOrderWarehouseResponse> {
            return localVarFp.getOrderWarehouse(invoiceNo, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EcommerceWarehouseApi - object-oriented interface
 * @export
 * @class EcommerceWarehouseApi
 * @extends {BaseAPI}
 */
export class EcommerceWarehouseApi extends BaseAPI {
    /**
     * Display order for warehouse
     * @summary Get order for warehouse team
     * @param {string} invoiceNo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EcommerceWarehouseApi
     */
    public getOrderWarehouse(invoiceNo: string, options?: AxiosRequestConfig) {
        return EcommerceWarehouseApiFp(this.configuration).getOrderWarehouse(invoiceNo, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ExperimentalApi - axios parameter creator
 * @export
 */
export const ExperimentalApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Submit weighbridge upload picture and get presigned url
         * @summary Submit weighbridge upload picture
         * @param {ExperimentalWeighbridgeUploadCreateRequest} experimentalWeighbridgeUploadCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        experimentalWeighbridgeUploadCreate: async (experimentalWeighbridgeUploadCreateRequest: ExperimentalWeighbridgeUploadCreateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'experimentalWeighbridgeUploadCreateRequest' is not null or undefined
            assertParamExists('experimentalWeighbridgeUploadCreate', 'experimentalWeighbridgeUploadCreateRequest', experimentalWeighbridgeUploadCreateRequest)
            const localVarPath = `/api/v1/experimental/weighbridgeupload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(experimentalWeighbridgeUploadCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get weighbridge upload detail.
         * @summary Get Weighbridge Upload Detail
         * @param {string} weighbridgeUploadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        experimentalWeighbridgeUploadDetail: async (weighbridgeUploadId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'weighbridgeUploadId' is not null or undefined
            assertParamExists('experimentalWeighbridgeUploadDetail', 'weighbridgeUploadId', weighbridgeUploadId)
            const localVarPath = `/api/v1/experimental/weighbridgeupload/{weighbridgeUploadId}`
                .replace(`{${"weighbridgeUploadId"}}`, encodeURIComponent(String(weighbridgeUploadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get weighbridge upload extracted field from uploaded picture.
         * @summary Get Weighbridge Upload Extracted Field from Uploaded Picture
         * @param {string} weighbridgeUploadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        experimentalWeighbridgeUploadExtract: async (weighbridgeUploadId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'weighbridgeUploadId' is not null or undefined
            assertParamExists('experimentalWeighbridgeUploadExtract', 'weighbridgeUploadId', weighbridgeUploadId)
            const localVarPath = `/api/v1/experimental/weighbridgeupload/{weighbridgeUploadId}/extract`
                .replace(`{${"weighbridgeUploadId"}}`, encodeURIComponent(String(weighbridgeUploadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List of weighbridge uploaded
         * @summary List Weighbridge Uploaded
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        experimentalWeighbridgeUploadList: async (page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/experimental/weighbridgeupload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get weighbridge upload detail picture asset (presigned url).
         * @summary Get Weighbridge Upload Picture
         * @param {string} weighbridgeUploadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        experimentalWeighbridgeUploadPicture: async (weighbridgeUploadId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'weighbridgeUploadId' is not null or undefined
            assertParamExists('experimentalWeighbridgeUploadPicture', 'weighbridgeUploadId', weighbridgeUploadId)
            const localVarPath = `/api/v1/experimental/weighbridgeupload/{weighbridgeUploadId}/picture`
                .replace(`{${"weighbridgeUploadId"}}`, encodeURIComponent(String(weighbridgeUploadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update weighbridge upload
         * @summary Update weighbridge upload
         * @param {string} weighbridgeUploadId 
         * @param {ExperimentalWeighbridgeUploadUpdateRequest} experimentalWeighbridgeUploadUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        experimentalWeighbridgeUploadUpdate: async (weighbridgeUploadId: string, experimentalWeighbridgeUploadUpdateRequest: ExperimentalWeighbridgeUploadUpdateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'weighbridgeUploadId' is not null or undefined
            assertParamExists('experimentalWeighbridgeUploadUpdate', 'weighbridgeUploadId', weighbridgeUploadId)
            // verify required parameter 'experimentalWeighbridgeUploadUpdateRequest' is not null or undefined
            assertParamExists('experimentalWeighbridgeUploadUpdate', 'experimentalWeighbridgeUploadUpdateRequest', experimentalWeighbridgeUploadUpdateRequest)
            const localVarPath = `/api/v1/experimental/weighbridgeupload/{weighbridgeUploadId}`
                .replace(`{${"weighbridgeUploadId"}}`, encodeURIComponent(String(weighbridgeUploadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(experimentalWeighbridgeUploadUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExperimentalApi - functional programming interface
 * @export
 */
export const ExperimentalApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExperimentalApiAxiosParamCreator(configuration)
    return {
        /**
         * Submit weighbridge upload picture and get presigned url
         * @summary Submit weighbridge upload picture
         * @param {ExperimentalWeighbridgeUploadCreateRequest} experimentalWeighbridgeUploadCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async experimentalWeighbridgeUploadCreate(experimentalWeighbridgeUploadCreateRequest: ExperimentalWeighbridgeUploadCreateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExperimentalWeighbridgeUploadCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.experimentalWeighbridgeUploadCreate(experimentalWeighbridgeUploadCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get weighbridge upload detail.
         * @summary Get Weighbridge Upload Detail
         * @param {string} weighbridgeUploadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async experimentalWeighbridgeUploadDetail(weighbridgeUploadId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExperimentalWeighbridgeUploadDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.experimentalWeighbridgeUploadDetail(weighbridgeUploadId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get weighbridge upload extracted field from uploaded picture.
         * @summary Get Weighbridge Upload Extracted Field from Uploaded Picture
         * @param {string} weighbridgeUploadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async experimentalWeighbridgeUploadExtract(weighbridgeUploadId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExperimentalWeighbridgeUploadExtractResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.experimentalWeighbridgeUploadExtract(weighbridgeUploadId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * List of weighbridge uploaded
         * @summary List Weighbridge Uploaded
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async experimentalWeighbridgeUploadList(page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExperimentalWeighbridgeUploadListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.experimentalWeighbridgeUploadList(page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get weighbridge upload detail picture asset (presigned url).
         * @summary Get Weighbridge Upload Picture
         * @param {string} weighbridgeUploadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async experimentalWeighbridgeUploadPicture(weighbridgeUploadId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExperimentalWeighbridgeUploadPictureResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.experimentalWeighbridgeUploadPicture(weighbridgeUploadId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update weighbridge upload
         * @summary Update weighbridge upload
         * @param {string} weighbridgeUploadId 
         * @param {ExperimentalWeighbridgeUploadUpdateRequest} experimentalWeighbridgeUploadUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async experimentalWeighbridgeUploadUpdate(weighbridgeUploadId: string, experimentalWeighbridgeUploadUpdateRequest: ExperimentalWeighbridgeUploadUpdateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExperimentalWeighbridgeUploadUpdateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.experimentalWeighbridgeUploadUpdate(weighbridgeUploadId, experimentalWeighbridgeUploadUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ExperimentalApi - factory interface
 * @export
 */
export const ExperimentalApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExperimentalApiFp(configuration)
    return {
        /**
         * Submit weighbridge upload picture and get presigned url
         * @summary Submit weighbridge upload picture
         * @param {ExperimentalWeighbridgeUploadCreateRequest} experimentalWeighbridgeUploadCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        experimentalWeighbridgeUploadCreate(experimentalWeighbridgeUploadCreateRequest: ExperimentalWeighbridgeUploadCreateRequest, options?: any): AxiosPromise<ExperimentalWeighbridgeUploadCreateResponse> {
            return localVarFp.experimentalWeighbridgeUploadCreate(experimentalWeighbridgeUploadCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get weighbridge upload detail.
         * @summary Get Weighbridge Upload Detail
         * @param {string} weighbridgeUploadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        experimentalWeighbridgeUploadDetail(weighbridgeUploadId: string, options?: any): AxiosPromise<ExperimentalWeighbridgeUploadDetailResponse> {
            return localVarFp.experimentalWeighbridgeUploadDetail(weighbridgeUploadId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get weighbridge upload extracted field from uploaded picture.
         * @summary Get Weighbridge Upload Extracted Field from Uploaded Picture
         * @param {string} weighbridgeUploadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        experimentalWeighbridgeUploadExtract(weighbridgeUploadId: string, options?: any): AxiosPromise<ExperimentalWeighbridgeUploadExtractResponse> {
            return localVarFp.experimentalWeighbridgeUploadExtract(weighbridgeUploadId, options).then((request) => request(axios, basePath));
        },
        /**
         * List of weighbridge uploaded
         * @summary List Weighbridge Uploaded
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        experimentalWeighbridgeUploadList(page?: number, limit?: number, options?: any): AxiosPromise<ExperimentalWeighbridgeUploadListResponse> {
            return localVarFp.experimentalWeighbridgeUploadList(page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Get weighbridge upload detail picture asset (presigned url).
         * @summary Get Weighbridge Upload Picture
         * @param {string} weighbridgeUploadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        experimentalWeighbridgeUploadPicture(weighbridgeUploadId: string, options?: any): AxiosPromise<ExperimentalWeighbridgeUploadPictureResponse> {
            return localVarFp.experimentalWeighbridgeUploadPicture(weighbridgeUploadId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update weighbridge upload
         * @summary Update weighbridge upload
         * @param {string} weighbridgeUploadId 
         * @param {ExperimentalWeighbridgeUploadUpdateRequest} experimentalWeighbridgeUploadUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        experimentalWeighbridgeUploadUpdate(weighbridgeUploadId: string, experimentalWeighbridgeUploadUpdateRequest: ExperimentalWeighbridgeUploadUpdateRequest, options?: any): AxiosPromise<ExperimentalWeighbridgeUploadUpdateResponse> {
            return localVarFp.experimentalWeighbridgeUploadUpdate(weighbridgeUploadId, experimentalWeighbridgeUploadUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExperimentalApi - object-oriented interface
 * @export
 * @class ExperimentalApi
 * @extends {BaseAPI}
 */
export class ExperimentalApi extends BaseAPI {
    /**
     * Submit weighbridge upload picture and get presigned url
     * @summary Submit weighbridge upload picture
     * @param {ExperimentalWeighbridgeUploadCreateRequest} experimentalWeighbridgeUploadCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExperimentalApi
     */
    public experimentalWeighbridgeUploadCreate(experimentalWeighbridgeUploadCreateRequest: ExperimentalWeighbridgeUploadCreateRequest, options?: AxiosRequestConfig) {
        return ExperimentalApiFp(this.configuration).experimentalWeighbridgeUploadCreate(experimentalWeighbridgeUploadCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get weighbridge upload detail.
     * @summary Get Weighbridge Upload Detail
     * @param {string} weighbridgeUploadId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExperimentalApi
     */
    public experimentalWeighbridgeUploadDetail(weighbridgeUploadId: string, options?: AxiosRequestConfig) {
        return ExperimentalApiFp(this.configuration).experimentalWeighbridgeUploadDetail(weighbridgeUploadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get weighbridge upload extracted field from uploaded picture.
     * @summary Get Weighbridge Upload Extracted Field from Uploaded Picture
     * @param {string} weighbridgeUploadId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExperimentalApi
     */
    public experimentalWeighbridgeUploadExtract(weighbridgeUploadId: string, options?: AxiosRequestConfig) {
        return ExperimentalApiFp(this.configuration).experimentalWeighbridgeUploadExtract(weighbridgeUploadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List of weighbridge uploaded
     * @summary List Weighbridge Uploaded
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExperimentalApi
     */
    public experimentalWeighbridgeUploadList(page?: number, limit?: number, options?: AxiosRequestConfig) {
        return ExperimentalApiFp(this.configuration).experimentalWeighbridgeUploadList(page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get weighbridge upload detail picture asset (presigned url).
     * @summary Get Weighbridge Upload Picture
     * @param {string} weighbridgeUploadId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExperimentalApi
     */
    public experimentalWeighbridgeUploadPicture(weighbridgeUploadId: string, options?: AxiosRequestConfig) {
        return ExperimentalApiFp(this.configuration).experimentalWeighbridgeUploadPicture(weighbridgeUploadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update weighbridge upload
     * @summary Update weighbridge upload
     * @param {string} weighbridgeUploadId 
     * @param {ExperimentalWeighbridgeUploadUpdateRequest} experimentalWeighbridgeUploadUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExperimentalApi
     */
    public experimentalWeighbridgeUploadUpdate(weighbridgeUploadId: string, experimentalWeighbridgeUploadUpdateRequest: ExperimentalWeighbridgeUploadUpdateRequest, options?: AxiosRequestConfig) {
        return ExperimentalApiFp(this.configuration).experimentalWeighbridgeUploadUpdate(weighbridgeUploadId, experimentalWeighbridgeUploadUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FeaturesApi - axios parameter creator
 * @export
 */
export const FeaturesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This endpoint is used to get feature flag is enable or not 
         * @summary Get Feature Flag Is Enable or Not
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} featureFlagName Name of feature flag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagStatus: async (authorization: string, featureFlagName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('featureFlagStatus', 'authorization', authorization)
            // verify required parameter 'featureFlagName' is not null or undefined
            assertParamExists('featureFlagStatus', 'featureFlagName', featureFlagName)
            const localVarPath = `/api/v1/features/statuses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (featureFlagName !== undefined) {
                localVarQueryParameter['featureFlagName'] = featureFlagName;
            }

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FeaturesApi - functional programming interface
 * @export
 */
export const FeaturesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FeaturesApiAxiosParamCreator(configuration)
    return {
        /**
         * This endpoint is used to get feature flag is enable or not 
         * @summary Get Feature Flag Is Enable or Not
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} featureFlagName Name of feature flag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featureFlagStatus(authorization: string, featureFlagName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeatureFlagStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featureFlagStatus(authorization, featureFlagName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FeaturesApi - factory interface
 * @export
 */
export const FeaturesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FeaturesApiFp(configuration)
    return {
        /**
         * This endpoint is used to get feature flag is enable or not 
         * @summary Get Feature Flag Is Enable or Not
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} featureFlagName Name of feature flag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagStatus(authorization: string, featureFlagName: string, options?: any): AxiosPromise<FeatureFlagStatusResponse> {
            return localVarFp.featureFlagStatus(authorization, featureFlagName, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FeaturesApi - object-oriented interface
 * @export
 * @class FeaturesApi
 * @extends {BaseAPI}
 */
export class FeaturesApi extends BaseAPI {
    /**
     * This endpoint is used to get feature flag is enable or not 
     * @summary Get Feature Flag Is Enable or Not
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {string} featureFlagName Name of feature flag
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturesApi
     */
    public featureFlagStatus(authorization: string, featureFlagName: string, options?: AxiosRequestConfig) {
        return FeaturesApiFp(this.configuration).featureFlagStatus(authorization, featureFlagName, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FinanceApi - axios parameter creator
 * @export
 */
export const FinanceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get latest SawitPoin and Gold balance
         * @summary Get Latest Balance
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        financeGetBalance: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/finance/balance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Display all payment method 
         * @summary Get payment list payment method
         * @param {string} [code] Filter for the payment method code
         * @param {string} [id] Filter for the payment method id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        financePaymentsMethodsList: async (code?: string, id?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/finance/payments/methods`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get User\'s Income Stament Report containing total revenue, expenses and net income and then the summary in each farm
         * @summary Get User\'s Income Statement Report List
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        financeReportsGetIncomeStatements: async (aPPTYPE: AppTypeEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('financeReportsGetIncomeStatements', 'aPPTYPE', aPPTYPE)
            const localVarPath = `/api/v1/finance/reports/income-statements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get User\'s Income Stament Report containing detail of revenue, expenses and net income of the specified farm
         * @summary Get User\'s Income Statement Report Detail By Farm Id
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} farmId farm UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        financeReportsIncomeStatementsGetDetailByFarm: async (aPPTYPE: AppTypeEnum, farmId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('financeReportsIncomeStatementsGetDetailByFarm', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'farmId' is not null or undefined
            assertParamExists('financeReportsIncomeStatementsGetDetailByFarm', 'farmId', farmId)
            const localVarPath = `/api/v1/finance/reports/income-statements/farms/{farmId}`
                .replace(`{${"farmId"}}`, encodeURIComponent(String(farmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FinanceApi - functional programming interface
 * @export
 */
export const FinanceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FinanceApiAxiosParamCreator(configuration)
    return {
        /**
         * Get latest SawitPoin and Gold balance
         * @summary Get Latest Balance
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async financeGetBalance(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FinanceGetBalanceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.financeGetBalance(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Display all payment method 
         * @summary Get payment list payment method
         * @param {string} [code] Filter for the payment method code
         * @param {string} [id] Filter for the payment method id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async financePaymentsMethodsList(code?: string, id?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FinancePaymentsMethodsListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.financePaymentsMethodsList(code, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get User\'s Income Stament Report containing total revenue, expenses and net income and then the summary in each farm
         * @summary Get User\'s Income Statement Report List
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async financeReportsGetIncomeStatements(aPPTYPE: AppTypeEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FinanceReportsGetIncomeStatementsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.financeReportsGetIncomeStatements(aPPTYPE, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get User\'s Income Stament Report containing detail of revenue, expenses and net income of the specified farm
         * @summary Get User\'s Income Statement Report Detail By Farm Id
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} farmId farm UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async financeReportsIncomeStatementsGetDetailByFarm(aPPTYPE: AppTypeEnum, farmId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FinanceReportsIncomeStatementsGetDetailByFarmResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.financeReportsIncomeStatementsGetDetailByFarm(aPPTYPE, farmId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FinanceApi - factory interface
 * @export
 */
export const FinanceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FinanceApiFp(configuration)
    return {
        /**
         * Get latest SawitPoin and Gold balance
         * @summary Get Latest Balance
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        financeGetBalance(options?: any): AxiosPromise<FinanceGetBalanceResponse> {
            return localVarFp.financeGetBalance(options).then((request) => request(axios, basePath));
        },
        /**
         * Display all payment method 
         * @summary Get payment list payment method
         * @param {string} [code] Filter for the payment method code
         * @param {string} [id] Filter for the payment method id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        financePaymentsMethodsList(code?: string, id?: string, options?: any): AxiosPromise<FinancePaymentsMethodsListResponse> {
            return localVarFp.financePaymentsMethodsList(code, id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get User\'s Income Stament Report containing total revenue, expenses and net income and then the summary in each farm
         * @summary Get User\'s Income Statement Report List
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        financeReportsGetIncomeStatements(aPPTYPE: AppTypeEnum, options?: any): AxiosPromise<FinanceReportsGetIncomeStatementsResponse> {
            return localVarFp.financeReportsGetIncomeStatements(aPPTYPE, options).then((request) => request(axios, basePath));
        },
        /**
         * Get User\'s Income Stament Report containing detail of revenue, expenses and net income of the specified farm
         * @summary Get User\'s Income Statement Report Detail By Farm Id
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} farmId farm UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        financeReportsIncomeStatementsGetDetailByFarm(aPPTYPE: AppTypeEnum, farmId: string, options?: any): AxiosPromise<FinanceReportsIncomeStatementsGetDetailByFarmResponse> {
            return localVarFp.financeReportsIncomeStatementsGetDetailByFarm(aPPTYPE, farmId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FinanceApi - object-oriented interface
 * @export
 * @class FinanceApi
 * @extends {BaseAPI}
 */
export class FinanceApi extends BaseAPI {
    /**
     * Get latest SawitPoin and Gold balance
     * @summary Get Latest Balance
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FinanceApi
     */
    public financeGetBalance(options?: AxiosRequestConfig) {
        return FinanceApiFp(this.configuration).financeGetBalance(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Display all payment method 
     * @summary Get payment list payment method
     * @param {string} [code] Filter for the payment method code
     * @param {string} [id] Filter for the payment method id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FinanceApi
     */
    public financePaymentsMethodsList(code?: string, id?: string, options?: AxiosRequestConfig) {
        return FinanceApiFp(this.configuration).financePaymentsMethodsList(code, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get User\'s Income Stament Report containing total revenue, expenses and net income and then the summary in each farm
     * @summary Get User\'s Income Statement Report List
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FinanceApi
     */
    public financeReportsGetIncomeStatements(aPPTYPE: AppTypeEnum, options?: AxiosRequestConfig) {
        return FinanceApiFp(this.configuration).financeReportsGetIncomeStatements(aPPTYPE, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get User\'s Income Stament Report containing detail of revenue, expenses and net income of the specified farm
     * @summary Get User\'s Income Statement Report Detail By Farm Id
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} farmId farm UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FinanceApi
     */
    public financeReportsIncomeStatementsGetDetailByFarm(aPPTYPE: AppTypeEnum, farmId: string, options?: AxiosRequestConfig) {
        return FinanceApiFp(this.configuration).financeReportsIncomeStatementsGetDetailByFarm(aPPTYPE, farmId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * GamesApi - axios parameter creator
 * @export
 */
export const GamesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get the detail of current game top leaderboard along with user\'s current ranking. for this API v1 only show Games Quiz Leaderboard. 
         * @summary Get Game Current Leaderboard
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesGetCampaignLeaderboard: async (aPPTYPE: AppTypeEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('gamesGetCampaignLeaderboard', 'aPPTYPE', aPPTYPE)
            const localVarPath = `/api/v1/games/leaderboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Initiate retry the question by exchanging Sawit Poin 
         * @summary Retry Question
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} campaignId Campaign ID, represented in UUID type 4 format
         * @param {GamesQuizCampaignQuestionRetryRequest} gamesQuizCampaignQuestionRetryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesQuizCampaignQuestionRetry: async (aPPTYPE: AppTypeEnum, campaignId: string, gamesQuizCampaignQuestionRetryRequest: GamesQuizCampaignQuestionRetryRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('gamesQuizCampaignQuestionRetry', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('gamesQuizCampaignQuestionRetry', 'campaignId', campaignId)
            // verify required parameter 'gamesQuizCampaignQuestionRetryRequest' is not null or undefined
            assertParamExists('gamesQuizCampaignQuestionRetry', 'gamesQuizCampaignQuestionRetryRequest', gamesQuizCampaignQuestionRetryRequest)
            const localVarPath = `/api/v1/games/quiz/{campaignId}/questions/retry`
                .replace(`{${"campaignId"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gamesQuizCampaignQuestionRetryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the detail of quiz campaign (rewards) and player (streak information, rewards received, quiz responses, and question), when player streak need to be reseted, this API will also reset current player streak. 
         * @summary Get or Initiate Quiz Campaign Player Detail
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesQuizGetCampaignPlayer: async (aPPTYPE: AppTypeEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('gamesQuizGetCampaignPlayer', 'aPPTYPE', aPPTYPE)
            const localVarPath = `/api/v1/games/quiz/player`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get list of all quiz that player has answered correctly, containing the knowledge value of each quiz. ordered by \'quizTimeUtc0\' DESC, used in games quiz\'s \"Sekolah Sawit\" page 
         * @summary Get All Player\'s Quiz Answers
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {number} [limit] Number of items per page.
         * @param {number} [page] Current page number to be accessed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesQuizGetPlayerAnswers: async (aPPTYPE: AppTypeEnum, limit?: number, page?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('gamesQuizGetPlayerAnswers', 'aPPTYPE', aPPTYPE)
            const localVarPath = `/api/v1/games/quiz/player/answers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get User currently available Quiz Question based on {campaignId}
         * @summary Get Quiz Questions
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} campaignId Campaign ID, represented in UUID type 4 format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesQuizGetQuestions: async (aPPTYPE: AppTypeEnum, campaignId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('gamesQuizGetQuestions', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('gamesQuizGetQuestions', 'campaignId', campaignId)
            const localVarPath = `/api/v1/games/quiz/{campaignId}/questions`
                .replace(`{${"campaignId"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Submit Player\'s answer for the specified Quiz Question based on {campaignId}
         * @summary Submit Quiz Answer
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} campaignId Campaign ID, represented in UUID type 4 format
         * @param {GamesQuizQuestionsSubmitAnswerRequest} gamesQuizQuestionsSubmitAnswerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesQuizQuestionsSubmitAnswer: async (aPPTYPE: AppTypeEnum, campaignId: string, gamesQuizQuestionsSubmitAnswerRequest: GamesQuizQuestionsSubmitAnswerRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('gamesQuizQuestionsSubmitAnswer', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('gamesQuizQuestionsSubmitAnswer', 'campaignId', campaignId)
            // verify required parameter 'gamesQuizQuestionsSubmitAnswerRequest' is not null or undefined
            assertParamExists('gamesQuizQuestionsSubmitAnswer', 'gamesQuizQuestionsSubmitAnswerRequest', gamesQuizQuestionsSubmitAnswerRequest)
            const localVarPath = `/api/v1/games/quiz/{campaignId}/questions/answer`
                .replace(`{${"campaignId"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gamesQuizQuestionsSubmitAnswerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GamesApi - functional programming interface
 * @export
 */
export const GamesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GamesApiAxiosParamCreator(configuration)
    return {
        /**
         * Get the detail of current game top leaderboard along with user\'s current ranking. for this API v1 only show Games Quiz Leaderboard. 
         * @summary Get Game Current Leaderboard
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamesGetCampaignLeaderboard(aPPTYPE: AppTypeEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GamesGetCampaignLeaderboardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamesGetCampaignLeaderboard(aPPTYPE, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Initiate retry the question by exchanging Sawit Poin 
         * @summary Retry Question
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} campaignId Campaign ID, represented in UUID type 4 format
         * @param {GamesQuizCampaignQuestionRetryRequest} gamesQuizCampaignQuestionRetryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamesQuizCampaignQuestionRetry(aPPTYPE: AppTypeEnum, campaignId: string, gamesQuizCampaignQuestionRetryRequest: GamesQuizCampaignQuestionRetryRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GamesQuizCampaignQuestionRetryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamesQuizCampaignQuestionRetry(aPPTYPE, campaignId, gamesQuizCampaignQuestionRetryRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get the detail of quiz campaign (rewards) and player (streak information, rewards received, quiz responses, and question), when player streak need to be reseted, this API will also reset current player streak. 
         * @summary Get or Initiate Quiz Campaign Player Detail
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamesQuizGetCampaignPlayer(aPPTYPE: AppTypeEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GamesQuizGetCampaignPlayerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamesQuizGetCampaignPlayer(aPPTYPE, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get list of all quiz that player has answered correctly, containing the knowledge value of each quiz. ordered by \'quizTimeUtc0\' DESC, used in games quiz\'s \"Sekolah Sawit\" page 
         * @summary Get All Player\'s Quiz Answers
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {number} [limit] Number of items per page.
         * @param {number} [page] Current page number to be accessed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamesQuizGetPlayerAnswers(aPPTYPE: AppTypeEnum, limit?: number, page?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GamesQuizGetPlayerAnswersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamesQuizGetPlayerAnswers(aPPTYPE, limit, page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get User currently available Quiz Question based on {campaignId}
         * @summary Get Quiz Questions
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} campaignId Campaign ID, represented in UUID type 4 format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamesQuizGetQuestions(aPPTYPE: AppTypeEnum, campaignId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GamesQuizGetQuestionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamesQuizGetQuestions(aPPTYPE, campaignId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Submit Player\'s answer for the specified Quiz Question based on {campaignId}
         * @summary Submit Quiz Answer
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} campaignId Campaign ID, represented in UUID type 4 format
         * @param {GamesQuizQuestionsSubmitAnswerRequest} gamesQuizQuestionsSubmitAnswerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamesQuizQuestionsSubmitAnswer(aPPTYPE: AppTypeEnum, campaignId: string, gamesQuizQuestionsSubmitAnswerRequest: GamesQuizQuestionsSubmitAnswerRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GamesQuizQuestionsSubmitAnswerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gamesQuizQuestionsSubmitAnswer(aPPTYPE, campaignId, gamesQuizQuestionsSubmitAnswerRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GamesApi - factory interface
 * @export
 */
export const GamesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GamesApiFp(configuration)
    return {
        /**
         * Get the detail of current game top leaderboard along with user\'s current ranking. for this API v1 only show Games Quiz Leaderboard. 
         * @summary Get Game Current Leaderboard
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesGetCampaignLeaderboard(aPPTYPE: AppTypeEnum, options?: any): AxiosPromise<GamesGetCampaignLeaderboardResponse> {
            return localVarFp.gamesGetCampaignLeaderboard(aPPTYPE, options).then((request) => request(axios, basePath));
        },
        /**
         * Initiate retry the question by exchanging Sawit Poin 
         * @summary Retry Question
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} campaignId Campaign ID, represented in UUID type 4 format
         * @param {GamesQuizCampaignQuestionRetryRequest} gamesQuizCampaignQuestionRetryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesQuizCampaignQuestionRetry(aPPTYPE: AppTypeEnum, campaignId: string, gamesQuizCampaignQuestionRetryRequest: GamesQuizCampaignQuestionRetryRequest, options?: any): AxiosPromise<GamesQuizCampaignQuestionRetryResponse> {
            return localVarFp.gamesQuizCampaignQuestionRetry(aPPTYPE, campaignId, gamesQuizCampaignQuestionRetryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the detail of quiz campaign (rewards) and player (streak information, rewards received, quiz responses, and question), when player streak need to be reseted, this API will also reset current player streak. 
         * @summary Get or Initiate Quiz Campaign Player Detail
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesQuizGetCampaignPlayer(aPPTYPE: AppTypeEnum, options?: any): AxiosPromise<GamesQuizGetCampaignPlayerResponse> {
            return localVarFp.gamesQuizGetCampaignPlayer(aPPTYPE, options).then((request) => request(axios, basePath));
        },
        /**
         * Get list of all quiz that player has answered correctly, containing the knowledge value of each quiz. ordered by \'quizTimeUtc0\' DESC, used in games quiz\'s \"Sekolah Sawit\" page 
         * @summary Get All Player\'s Quiz Answers
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {number} [limit] Number of items per page.
         * @param {number} [page] Current page number to be accessed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesQuizGetPlayerAnswers(aPPTYPE: AppTypeEnum, limit?: number, page?: number, options?: any): AxiosPromise<GamesQuizGetPlayerAnswersResponse> {
            return localVarFp.gamesQuizGetPlayerAnswers(aPPTYPE, limit, page, options).then((request) => request(axios, basePath));
        },
        /**
         * Get User currently available Quiz Question based on {campaignId}
         * @summary Get Quiz Questions
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} campaignId Campaign ID, represented in UUID type 4 format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesQuizGetQuestions(aPPTYPE: AppTypeEnum, campaignId: string, options?: any): AxiosPromise<GamesQuizGetQuestionsResponse> {
            return localVarFp.gamesQuizGetQuestions(aPPTYPE, campaignId, options).then((request) => request(axios, basePath));
        },
        /**
         * Submit Player\'s answer for the specified Quiz Question based on {campaignId}
         * @summary Submit Quiz Answer
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} campaignId Campaign ID, represented in UUID type 4 format
         * @param {GamesQuizQuestionsSubmitAnswerRequest} gamesQuizQuestionsSubmitAnswerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesQuizQuestionsSubmitAnswer(aPPTYPE: AppTypeEnum, campaignId: string, gamesQuizQuestionsSubmitAnswerRequest: GamesQuizQuestionsSubmitAnswerRequest, options?: any): AxiosPromise<GamesQuizQuestionsSubmitAnswerResponse> {
            return localVarFp.gamesQuizQuestionsSubmitAnswer(aPPTYPE, campaignId, gamesQuizQuestionsSubmitAnswerRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GamesApi - object-oriented interface
 * @export
 * @class GamesApi
 * @extends {BaseAPI}
 */
export class GamesApi extends BaseAPI {
    /**
     * Get the detail of current game top leaderboard along with user\'s current ranking. for this API v1 only show Games Quiz Leaderboard. 
     * @summary Get Game Current Leaderboard
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamesApi
     */
    public gamesGetCampaignLeaderboard(aPPTYPE: AppTypeEnum, options?: AxiosRequestConfig) {
        return GamesApiFp(this.configuration).gamesGetCampaignLeaderboard(aPPTYPE, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Initiate retry the question by exchanging Sawit Poin 
     * @summary Retry Question
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} campaignId Campaign ID, represented in UUID type 4 format
     * @param {GamesQuizCampaignQuestionRetryRequest} gamesQuizCampaignQuestionRetryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamesApi
     */
    public gamesQuizCampaignQuestionRetry(aPPTYPE: AppTypeEnum, campaignId: string, gamesQuizCampaignQuestionRetryRequest: GamesQuizCampaignQuestionRetryRequest, options?: AxiosRequestConfig) {
        return GamesApiFp(this.configuration).gamesQuizCampaignQuestionRetry(aPPTYPE, campaignId, gamesQuizCampaignQuestionRetryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the detail of quiz campaign (rewards) and player (streak information, rewards received, quiz responses, and question), when player streak need to be reseted, this API will also reset current player streak. 
     * @summary Get or Initiate Quiz Campaign Player Detail
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamesApi
     */
    public gamesQuizGetCampaignPlayer(aPPTYPE: AppTypeEnum, options?: AxiosRequestConfig) {
        return GamesApiFp(this.configuration).gamesQuizGetCampaignPlayer(aPPTYPE, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get list of all quiz that player has answered correctly, containing the knowledge value of each quiz. ordered by \'quizTimeUtc0\' DESC, used in games quiz\'s \"Sekolah Sawit\" page 
     * @summary Get All Player\'s Quiz Answers
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {number} [limit] Number of items per page.
     * @param {number} [page] Current page number to be accessed.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamesApi
     */
    public gamesQuizGetPlayerAnswers(aPPTYPE: AppTypeEnum, limit?: number, page?: number, options?: AxiosRequestConfig) {
        return GamesApiFp(this.configuration).gamesQuizGetPlayerAnswers(aPPTYPE, limit, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get User currently available Quiz Question based on {campaignId}
     * @summary Get Quiz Questions
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} campaignId Campaign ID, represented in UUID type 4 format
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamesApi
     */
    public gamesQuizGetQuestions(aPPTYPE: AppTypeEnum, campaignId: string, options?: AxiosRequestConfig) {
        return GamesApiFp(this.configuration).gamesQuizGetQuestions(aPPTYPE, campaignId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Submit Player\'s answer for the specified Quiz Question based on {campaignId}
     * @summary Submit Quiz Answer
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} campaignId Campaign ID, represented in UUID type 4 format
     * @param {GamesQuizQuestionsSubmitAnswerRequest} gamesQuizQuestionsSubmitAnswerRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamesApi
     */
    public gamesQuizQuestionsSubmitAnswer(aPPTYPE: AppTypeEnum, campaignId: string, gamesQuizQuestionsSubmitAnswerRequest: GamesQuizQuestionsSubmitAnswerRequest, options?: AxiosRequestConfig) {
        return GamesApiFp(this.configuration).gamesQuizQuestionsSubmitAnswer(aPPTYPE, campaignId, gamesQuizQuestionsSubmitAnswerRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * GetMyCouponDetailApi - axios parameter creator
 * @export
 */
export const GetMyCouponDetailApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * this is for getting eligible vendor coupon detail
         * @summary Get My Coupon Detail
         * @param {string} couponId coupon Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ecommerceGetMyCouponDetail: async (couponId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'couponId' is not null or undefined
            assertParamExists('ecommerceGetMyCouponDetail', 'couponId', couponId)
            const localVarPath = `/api/v1/partners/coupons/digitals/my-coupon/{couponId}`
                .replace(`{${"couponId"}}`, encodeURIComponent(String(couponId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GetMyCouponDetailApi - functional programming interface
 * @export
 */
export const GetMyCouponDetailApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GetMyCouponDetailApiAxiosParamCreator(configuration)
    return {
        /**
         * this is for getting eligible vendor coupon detail
         * @summary Get My Coupon Detail
         * @param {string} couponId coupon Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ecommerceGetMyCouponDetail(couponId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EcommerceGetMyCouponDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ecommerceGetMyCouponDetail(couponId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GetMyCouponDetailApi - factory interface
 * @export
 */
export const GetMyCouponDetailApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GetMyCouponDetailApiFp(configuration)
    return {
        /**
         * this is for getting eligible vendor coupon detail
         * @summary Get My Coupon Detail
         * @param {string} couponId coupon Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ecommerceGetMyCouponDetail(couponId: string, options?: any): AxiosPromise<EcommerceGetMyCouponDetailResponse> {
            return localVarFp.ecommerceGetMyCouponDetail(couponId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GetMyCouponDetailApi - object-oriented interface
 * @export
 * @class GetMyCouponDetailApi
 * @extends {BaseAPI}
 */
export class GetMyCouponDetailApi extends BaseAPI {
    /**
     * this is for getting eligible vendor coupon detail
     * @summary Get My Coupon Detail
     * @param {string} couponId coupon Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetMyCouponDetailApi
     */
    public ecommerceGetMyCouponDetail(couponId: string, options?: AxiosRequestConfig) {
        return GetMyCouponDetailApiFp(this.configuration).ecommerceGetMyCouponDetail(couponId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * JobBoardsApi - axios parameter creator
 * @export
 */
export const JobBoardsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create job board application 
         * @summary Create Job Board Application
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {JobBoardsCreateApplicationsRequest} jobBoardsCreateApplicationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobBoardsCreateApplications: async (aPPTYPE: AppTypeEnum, jobBoardsCreateApplicationsRequest: JobBoardsCreateApplicationsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('jobBoardsCreateApplications', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'jobBoardsCreateApplicationsRequest' is not null or undefined
            assertParamExists('jobBoardsCreateApplications', 'jobBoardsCreateApplicationsRequest', jobBoardsCreateApplicationsRequest)
            const localVarPath = `/api/v1/job-boards/applications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobBoardsCreateApplicationsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Used by Worker App to Get the Seeker Data
         * @summary Job Boards Seekers Data
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} userId 
         * @param {string} [jobCategoryCode] job vacancy category code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobBoardsGetSeekers: async (aPPTYPE: AppTypeEnum, userId: string, jobCategoryCode?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('jobBoardsGetSeekers', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('jobBoardsGetSeekers', 'userId', userId)
            const localVarPath = `/api/v1/job-boards/seekers/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (jobCategoryCode !== undefined) {
                localVarQueryParameter['jobCategoryCode'] = jobCategoryCode;
            }

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Used by Worker App to get detail of a job vacancy
         * @summary Job Vacancy Detail
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} jobVacancyId Job Vacancy UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobBoardsVacanciesGetJobVacancyDetail: async (aPPTYPE: AppTypeEnum, jobVacancyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('jobBoardsVacanciesGetJobVacancyDetail', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'jobVacancyId' is not null or undefined
            assertParamExists('jobBoardsVacanciesGetJobVacancyDetail', 'jobVacancyId', jobVacancyId)
            const localVarPath = `/api/v1/job-boards/vacancies/{jobVacancyId}`
                .replace(`{${"jobVacancyId"}}`, encodeURIComponent(String(jobVacancyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Used by Worker App to get list of a job vacancy
         * @summary Job Vacancy List
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} [searchName] 
         * @param {number} [limit] Number of items per page.
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [latitude] 
         * @param {number} [longitude] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobBoardsVacanciesGetJobVacancyList: async (aPPTYPE: AppTypeEnum, searchName?: string, limit?: number, page?: number, latitude?: number, longitude?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('jobBoardsVacanciesGetJobVacancyList', 'aPPTYPE', aPPTYPE)
            const localVarPath = `/api/v1/job-boards/vacancies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (searchName !== undefined) {
                localVarQueryParameter['searchName'] = searchName;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (latitude !== undefined) {
                localVarQueryParameter['latitude'] = latitude;
            }

            if (longitude !== undefined) {
                localVarQueryParameter['longitude'] = longitude;
            }

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * JobBoardsApi - functional programming interface
 * @export
 */
export const JobBoardsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = JobBoardsApiAxiosParamCreator(configuration)
    return {
        /**
         * Create job board application 
         * @summary Create Job Board Application
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {JobBoardsCreateApplicationsRequest} jobBoardsCreateApplicationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobBoardsCreateApplications(aPPTYPE: AppTypeEnum, jobBoardsCreateApplicationsRequest: JobBoardsCreateApplicationsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DefaultSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobBoardsCreateApplications(aPPTYPE, jobBoardsCreateApplicationsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Used by Worker App to Get the Seeker Data
         * @summary Job Boards Seekers Data
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} userId 
         * @param {string} [jobCategoryCode] job vacancy category code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobBoardsGetSeekers(aPPTYPE: AppTypeEnum, userId: string, jobCategoryCode?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobBoardsGetSeekersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobBoardsGetSeekers(aPPTYPE, userId, jobCategoryCode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Used by Worker App to get detail of a job vacancy
         * @summary Job Vacancy Detail
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} jobVacancyId Job Vacancy UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobBoardsVacanciesGetJobVacancyDetail(aPPTYPE: AppTypeEnum, jobVacancyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobBoardsVacanciesGetJobVacancyDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobBoardsVacanciesGetJobVacancyDetail(aPPTYPE, jobVacancyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Used by Worker App to get list of a job vacancy
         * @summary Job Vacancy List
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} [searchName] 
         * @param {number} [limit] Number of items per page.
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [latitude] 
         * @param {number} [longitude] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobBoardsVacanciesGetJobVacancyList(aPPTYPE: AppTypeEnum, searchName?: string, limit?: number, page?: number, latitude?: number, longitude?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobBoardsVacanciesGetJobVacancyListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobBoardsVacanciesGetJobVacancyList(aPPTYPE, searchName, limit, page, latitude, longitude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * JobBoardsApi - factory interface
 * @export
 */
export const JobBoardsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = JobBoardsApiFp(configuration)
    return {
        /**
         * Create job board application 
         * @summary Create Job Board Application
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {JobBoardsCreateApplicationsRequest} jobBoardsCreateApplicationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobBoardsCreateApplications(aPPTYPE: AppTypeEnum, jobBoardsCreateApplicationsRequest: JobBoardsCreateApplicationsRequest, options?: any): AxiosPromise<DefaultSuccessResponse> {
            return localVarFp.jobBoardsCreateApplications(aPPTYPE, jobBoardsCreateApplicationsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Used by Worker App to Get the Seeker Data
         * @summary Job Boards Seekers Data
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} userId 
         * @param {string} [jobCategoryCode] job vacancy category code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobBoardsGetSeekers(aPPTYPE: AppTypeEnum, userId: string, jobCategoryCode?: string, options?: any): AxiosPromise<JobBoardsGetSeekersResponse> {
            return localVarFp.jobBoardsGetSeekers(aPPTYPE, userId, jobCategoryCode, options).then((request) => request(axios, basePath));
        },
        /**
         * Used by Worker App to get detail of a job vacancy
         * @summary Job Vacancy Detail
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} jobVacancyId Job Vacancy UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobBoardsVacanciesGetJobVacancyDetail(aPPTYPE: AppTypeEnum, jobVacancyId: string, options?: any): AxiosPromise<JobBoardsVacanciesGetJobVacancyDetailResponse> {
            return localVarFp.jobBoardsVacanciesGetJobVacancyDetail(aPPTYPE, jobVacancyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Used by Worker App to get list of a job vacancy
         * @summary Job Vacancy List
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} [searchName] 
         * @param {number} [limit] Number of items per page.
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [latitude] 
         * @param {number} [longitude] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobBoardsVacanciesGetJobVacancyList(aPPTYPE: AppTypeEnum, searchName?: string, limit?: number, page?: number, latitude?: number, longitude?: number, options?: any): AxiosPromise<JobBoardsVacanciesGetJobVacancyListResponse> {
            return localVarFp.jobBoardsVacanciesGetJobVacancyList(aPPTYPE, searchName, limit, page, latitude, longitude, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * JobBoardsApi - object-oriented interface
 * @export
 * @class JobBoardsApi
 * @extends {BaseAPI}
 */
export class JobBoardsApi extends BaseAPI {
    /**
     * Create job board application 
     * @summary Create Job Board Application
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {JobBoardsCreateApplicationsRequest} jobBoardsCreateApplicationsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobBoardsApi
     */
    public jobBoardsCreateApplications(aPPTYPE: AppTypeEnum, jobBoardsCreateApplicationsRequest: JobBoardsCreateApplicationsRequest, options?: AxiosRequestConfig) {
        return JobBoardsApiFp(this.configuration).jobBoardsCreateApplications(aPPTYPE, jobBoardsCreateApplicationsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Used by Worker App to Get the Seeker Data
     * @summary Job Boards Seekers Data
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} userId 
     * @param {string} [jobCategoryCode] job vacancy category code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobBoardsApi
     */
    public jobBoardsGetSeekers(aPPTYPE: AppTypeEnum, userId: string, jobCategoryCode?: string, options?: AxiosRequestConfig) {
        return JobBoardsApiFp(this.configuration).jobBoardsGetSeekers(aPPTYPE, userId, jobCategoryCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Used by Worker App to get detail of a job vacancy
     * @summary Job Vacancy Detail
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} jobVacancyId Job Vacancy UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobBoardsApi
     */
    public jobBoardsVacanciesGetJobVacancyDetail(aPPTYPE: AppTypeEnum, jobVacancyId: string, options?: AxiosRequestConfig) {
        return JobBoardsApiFp(this.configuration).jobBoardsVacanciesGetJobVacancyDetail(aPPTYPE, jobVacancyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Used by Worker App to get list of a job vacancy
     * @summary Job Vacancy List
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} [searchName] 
     * @param {number} [limit] Number of items per page.
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [latitude] 
     * @param {number} [longitude] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobBoardsApi
     */
    public jobBoardsVacanciesGetJobVacancyList(aPPTYPE: AppTypeEnum, searchName?: string, limit?: number, page?: number, latitude?: number, longitude?: number, options?: AxiosRequestConfig) {
        return JobBoardsApiFp(this.configuration).jobBoardsVacanciesGetJobVacancyList(aPPTYPE, searchName, limit, page, latitude, longitude, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * LocationApi - axios parameter creator
 * @export
 */
export const LocationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Currently, this endpoint usage in admin web for getting information provinces and cities
         * @summary Getting List of provinces and cities
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} [provinceName] Filter for getting by Province name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationGetProvince: async (authorization: string, provinceName?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('locationGetProvince', 'authorization', authorization)
            const localVarPath = `/api/v1/locations/provinces`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (provinceName !== undefined) {
                localVarQueryParameter['provinceName'] = provinceName;
            }

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Used by MemberApp and WorkerApp to get list of district.
         * @summary List of District by Name
         * @param {string} [name] 
         * @param {number} [latitude] 
         * @param {number} [longitude] 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationsGetDistricts: async (name?: string, latitude?: number, longitude?: number, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/locations/districts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (latitude !== undefined) {
                localVarQueryParameter['latitude'] = latitude;
            }

            if (longitude !== undefined) {
                localVarQueryParameter['longitude'] = longitude;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Used by MemberApp and WorkerApp to get list of villages.
         * @summary List of Villages by Name
         * @param {string} [name] 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationsGetVillages: async (name?: string, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/locations/villages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LocationApi - functional programming interface
 * @export
 */
export const LocationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LocationApiAxiosParamCreator(configuration)
    return {
        /**
         * Currently, this endpoint usage in admin web for getting information provinces and cities
         * @summary Getting List of provinces and cities
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} [provinceName] Filter for getting by Province name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locationGetProvince(authorization: string, provinceName?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationsGetProvinceListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.locationGetProvince(authorization, provinceName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Used by MemberApp and WorkerApp to get list of district.
         * @summary List of District by Name
         * @param {string} [name] 
         * @param {number} [latitude] 
         * @param {number} [longitude] 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locationsGetDistricts(name?: string, latitude?: number, longitude?: number, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationsGetDistrictsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.locationsGetDistricts(name, latitude, longitude, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Used by MemberApp and WorkerApp to get list of villages.
         * @summary List of Villages by Name
         * @param {string} [name] 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locationsGetVillages(name?: string, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationsGetVillagesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.locationsGetVillages(name, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LocationApi - factory interface
 * @export
 */
export const LocationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LocationApiFp(configuration)
    return {
        /**
         * Currently, this endpoint usage in admin web for getting information provinces and cities
         * @summary Getting List of provinces and cities
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} [provinceName] Filter for getting by Province name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationGetProvince(authorization: string, provinceName?: string, options?: any): AxiosPromise<LocationsGetProvinceListResponse> {
            return localVarFp.locationGetProvince(authorization, provinceName, options).then((request) => request(axios, basePath));
        },
        /**
         * Used by MemberApp and WorkerApp to get list of district.
         * @summary List of District by Name
         * @param {string} [name] 
         * @param {number} [latitude] 
         * @param {number} [longitude] 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationsGetDistricts(name?: string, latitude?: number, longitude?: number, page?: number, limit?: number, options?: any): AxiosPromise<LocationsGetDistrictsResponse> {
            return localVarFp.locationsGetDistricts(name, latitude, longitude, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Used by MemberApp and WorkerApp to get list of villages.
         * @summary List of Villages by Name
         * @param {string} [name] 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationsGetVillages(name?: string, page?: number, limit?: number, options?: any): AxiosPromise<LocationsGetVillagesResponse> {
            return localVarFp.locationsGetVillages(name, page, limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LocationApi - object-oriented interface
 * @export
 * @class LocationApi
 * @extends {BaseAPI}
 */
export class LocationApi extends BaseAPI {
    /**
     * Currently, this endpoint usage in admin web for getting information provinces and cities
     * @summary Getting List of provinces and cities
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {string} [provinceName] Filter for getting by Province name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public locationGetProvince(authorization: string, provinceName?: string, options?: AxiosRequestConfig) {
        return LocationApiFp(this.configuration).locationGetProvince(authorization, provinceName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Used by MemberApp and WorkerApp to get list of district.
     * @summary List of District by Name
     * @param {string} [name] 
     * @param {number} [latitude] 
     * @param {number} [longitude] 
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public locationsGetDistricts(name?: string, latitude?: number, longitude?: number, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return LocationApiFp(this.configuration).locationsGetDistricts(name, latitude, longitude, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Used by MemberApp and WorkerApp to get list of villages.
     * @summary List of Villages by Name
     * @param {string} [name] 
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public locationsGetVillages(name?: string, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return LocationApiFp(this.configuration).locationsGetVillages(name, page, limit, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * LoyaltyApi - axios parameter creator
 * @export
 */
export const LoyaltyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Confirm The Request of Point Disbursement. Will only be accessible by administrator and finance lead to approve/reject the request.
         * @summary Confirm The Request of Point Disbursement
         * @param {string} pointDisbursementId ID of point disbursement request
         * @param {ConfirmLoyaltyRequestPointDisbursementRequest} [confirmLoyaltyRequestPointDisbursementRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmLoyaltyRequestPointDisbursement: async (pointDisbursementId: string, confirmLoyaltyRequestPointDisbursementRequest?: ConfirmLoyaltyRequestPointDisbursementRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pointDisbursementId' is not null or undefined
            assertParamExists('confirmLoyaltyRequestPointDisbursement', 'pointDisbursementId', pointDisbursementId)
            const localVarPath = `/api/v1/loyalty/point-disbursement/request/{pointDisbursementId}/confirm`
                .replace(`{${"pointDisbursementId"}}`, encodeURIComponent(String(pointDisbursementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(confirmLoyaltyRequestPointDisbursementRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returning list of point disbursement request. Will only be accessible by administrator and finance lead.
         * @summary Get List of Point Disbursement Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListLoyaltyPointDisbursementRequest: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/loyalty/point-disbursement/request`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List of Weighbridge Supply Master Cost
         * @summary Get List Weighbridge Supply Master Cost
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListLoyaltyWeighbridgeCost: async (page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/loyalty/weighbridge-cost`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returning detail of point disbursement request and also list of recipients with pagination. Will only be accessible by administrator and finance lead.
         * @summary Get point disbursement request detail
         * @param {string} pointDisbursementId ID of point disbursement request
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoyaltyPointDisbursementRequest: async (pointDisbursementId: string, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pointDisbursementId' is not null or undefined
            assertParamExists('getLoyaltyPointDisbursementRequest', 'pointDisbursementId', pointDisbursementId)
            const localVarPath = `/api/v1/loyalty/point-disbursement/request/{pointDisbursementId}`
                .replace(`{${"pointDisbursementId"}}`, encodeURIComponent(String(pointDisbursementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returning list of disbursement types. Will only be accessible on Admin Web.
         * @summary Get Data For Request Point Disbursement
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoyaltyPointDisbursementRequestData: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/loyalty/point-disbursement/request-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Will return the list of credit/debit history of gold. The response will be ordered by the created at in descending order
         * @summary Get History List of Gold Currency
         * @param {number} [date] Date for filtering list of data (in epoch) formatted in UTC-0. Will use current date if not provided
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loyaltyGetGoldHistory: async (date?: number, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/loyalty/gold/history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get list of point transactions. Receiving points, redemption, and transfer points. 
         * @summary Get History List
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {number} [startTime] Filter for list History SawitPoin, if empty will use all time. Use epoch timestamp
         * @param {number} [endTime] Filter for list History SawitPoin, if empty will use current timestamp. Use epoch timestamp
         * @param {SawitpoinHistoryTypeEnum} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loyaltyHistoryList: async (authorization: string, page?: number, limit?: number, startTime?: number, endTime?: number, type?: SawitpoinHistoryTypeEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('loyaltyHistoryList', 'authorization', authorization)
            const localVarPath = `/api/v1/loyalty/history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = endTime;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get list of available types for History List endpoint. 
         * @summary Get Types of History List
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loyaltyHistoryListTypes: async (authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('loyaltyHistoryListTypes', 'authorization', authorization)
            const localVarPath = `/api/v1/loyalty/history/types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Display all public vouchers 
         * @summary Get public vouchers list for user
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} [userId] used by DUTA app, id of the user that this request is for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loyaltyPublicVoucherList: async (aPPTYPE: AppTypeEnum, userId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('loyaltyPublicVoucherList', 'aPPTYPE', aPPTYPE)
            const localVarPath = `/api/v1/loyalty/vouchers/public`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Request for disbursement point. Will only be accessible by administrator and finance lead.
         * @summary Request of Point Disbursement
         * @param {LoyaltyRequestPointDisbursementRequest} [loyaltyRequestPointDisbursementRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loyaltyRequestPointDisbursement: async (loyaltyRequestPointDisbursementRequest?: LoyaltyRequestPointDisbursementRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/loyalty/point-disbursement/request`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loyaltyRequestPointDisbursementRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * For transferring point between 2 users
         * @summary Transferring Point to Other User
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {LoyaltyTransferRequest} loyaltyTransferRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loyaltyTransfer: async (aPPTYPE: AppTypeEnum, loyaltyTransferRequest: LoyaltyTransferRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('loyaltyTransfer', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'loyaltyTransferRequest' is not null or undefined
            assertParamExists('loyaltyTransfer', 'loyaltyTransferRequest', loyaltyTransferRequest)
            const localVarPath = `/api/v1/loyalty/transfer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loyaltyTransferRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Display all voucher 
         * @summary Get voucher list for user
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} invoiceId Invoice ID in UUID type 4 format
         * @param {number} pointAmount point ammount transaction of payment method
         * @param {boolean} pointUseStatus flag for using point as payment
         * @param {PaymentsCreatePaymentPaymentMethodEnum} paymentMethod payment method of transaction
         * @param {string} [userId] used by DUTA app, id of the user that this request is for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loyaltyVoucherList: async (aPPTYPE: AppTypeEnum, invoiceId: string, pointAmount: number, pointUseStatus: boolean, paymentMethod: PaymentsCreatePaymentPaymentMethodEnum, userId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('loyaltyVoucherList', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'invoiceId' is not null or undefined
            assertParamExists('loyaltyVoucherList', 'invoiceId', invoiceId)
            // verify required parameter 'pointAmount' is not null or undefined
            assertParamExists('loyaltyVoucherList', 'pointAmount', pointAmount)
            // verify required parameter 'pointUseStatus' is not null or undefined
            assertParamExists('loyaltyVoucherList', 'pointUseStatus', pointUseStatus)
            // verify required parameter 'paymentMethod' is not null or undefined
            assertParamExists('loyaltyVoucherList', 'paymentMethod', paymentMethod)
            const localVarPath = `/api/v1/loyalty/vouchers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (invoiceId !== undefined) {
                localVarQueryParameter['invoiceId'] = invoiceId;
            }

            if (pointAmount !== undefined) {
                localVarQueryParameter['pointAmount'] = pointAmount;
            }

            if (pointUseStatus !== undefined) {
                localVarQueryParameter['pointUseStatus'] = pointUseStatus;
            }

            if (paymentMethod !== undefined) {
                localVarQueryParameter['paymentMethod'] = paymentMethod;
            }

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Calculate voucher based on payment method 
         * @summary Calculate voucher
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {LoyaltyVouchersCalculateRequest} loyaltyVouchersCalculateRequest 
         * @param {string} [userId] used by DUTA app, id of the user that this request is for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loyaltyVouchersCalculate: async (aPPTYPE: AppTypeEnum, loyaltyVouchersCalculateRequest: LoyaltyVouchersCalculateRequest, userId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('loyaltyVouchersCalculate', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'loyaltyVouchersCalculateRequest' is not null or undefined
            assertParamExists('loyaltyVouchersCalculate', 'loyaltyVouchersCalculateRequest', loyaltyVouchersCalculateRequest)
            const localVarPath = `/api/v1/loyalty/vouchers/calculate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loyaltyVouchersCalculateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get voucher detail to get information by voucher id 
         * @summary Get voucher detail
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} voucherId 
         * @param {string} [userId] used by DUTA app, id of the user that this request is for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loyaltyVouchersGetDetail: async (aPPTYPE: AppTypeEnum, voucherId: string, userId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('loyaltyVouchersGetDetail', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'voucherId' is not null or undefined
            assertParamExists('loyaltyVouchersGetDetail', 'voucherId', voucherId)
            const localVarPath = `/api/v1/loyalty/vouchers/{voucherId}`
                .replace(`{${"voucherId"}}`, encodeURIComponent(String(voucherId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Initiate to use voucher 
         * @summary Use voucher by user
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {LoyaltyVouchersUsageRequest} loyaltyVouchersUsageRequest 
         * @param {string} [userId] used by DUTA app, id of the user that this request is for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loyaltyVouchersUsage: async (aPPTYPE: AppTypeEnum, loyaltyVouchersUsageRequest: LoyaltyVouchersUsageRequest, userId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('loyaltyVouchersUsage', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'loyaltyVouchersUsageRequest' is not null or undefined
            assertParamExists('loyaltyVouchersUsage', 'loyaltyVouchersUsageRequest', loyaltyVouchersUsageRequest)
            const localVarPath = `/api/v1/loyalty/vouchers/usage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loyaltyVouchersUsageRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endpoint for create weighbridge supply master cost
         * @summary Create Weighbridge Supply Master Cost
         * @param {LoyaltyWeighbridgeCostCreateRequest} loyaltyWeighbridgeCostCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loyaltyWeighbridgeCostCreate: async (loyaltyWeighbridgeCostCreateRequest: LoyaltyWeighbridgeCostCreateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loyaltyWeighbridgeCostCreateRequest' is not null or undefined
            assertParamExists('loyaltyWeighbridgeCostCreate', 'loyaltyWeighbridgeCostCreateRequest', loyaltyWeighbridgeCostCreateRequest)
            const localVarPath = `/api/v1/loyalty/weighbridge-cost`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loyaltyWeighbridgeCostCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endpoint for update weighbridge supply cost
         * @summary Update Weighbridge Supply Cost
         * @param {string} weighbridgeCostId Weighbridge Master Cost UUID
         * @param {LoyaltyWeighbridgeCostCreateRequest} loyaltyWeighbridgeCostCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loyaltyWeighbridgeCostUpdate: async (weighbridgeCostId: string, loyaltyWeighbridgeCostCreateRequest: LoyaltyWeighbridgeCostCreateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'weighbridgeCostId' is not null or undefined
            assertParamExists('loyaltyWeighbridgeCostUpdate', 'weighbridgeCostId', weighbridgeCostId)
            // verify required parameter 'loyaltyWeighbridgeCostCreateRequest' is not null or undefined
            assertParamExists('loyaltyWeighbridgeCostUpdate', 'loyaltyWeighbridgeCostCreateRequest', loyaltyWeighbridgeCostCreateRequest)
            const localVarPath = `/api/v1/loyalty/weighbridge-cost/{weighbridgeCostId}`
                .replace(`{${"weighbridgeCostId"}}`, encodeURIComponent(String(weighbridgeCostId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loyaltyWeighbridgeCostCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LoyaltyApi - functional programming interface
 * @export
 */
export const LoyaltyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LoyaltyApiAxiosParamCreator(configuration)
    return {
        /**
         * Confirm The Request of Point Disbursement. Will only be accessible by administrator and finance lead to approve/reject the request.
         * @summary Confirm The Request of Point Disbursement
         * @param {string} pointDisbursementId ID of point disbursement request
         * @param {ConfirmLoyaltyRequestPointDisbursementRequest} [confirmLoyaltyRequestPointDisbursementRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmLoyaltyRequestPointDisbursement(pointDisbursementId: string, confirmLoyaltyRequestPointDisbursementRequest?: ConfirmLoyaltyRequestPointDisbursementRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirmLoyaltyRequestPointDisbursement(pointDisbursementId, confirmLoyaltyRequestPointDisbursementRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returning list of point disbursement request. Will only be accessible by administrator and finance lead.
         * @summary Get List of Point Disbursement Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getListLoyaltyPointDisbursementRequest(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetListLoyaltyPointDisbursementRequestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getListLoyaltyPointDisbursementRequest(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * List of Weighbridge Supply Master Cost
         * @summary Get List Weighbridge Supply Master Cost
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getListLoyaltyWeighbridgeCost(page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetListLoyaltyWeighbridgeCostResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getListLoyaltyWeighbridgeCost(page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returning detail of point disbursement request and also list of recipients with pagination. Will only be accessible by administrator and finance lead.
         * @summary Get point disbursement request detail
         * @param {string} pointDisbursementId ID of point disbursement request
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLoyaltyPointDisbursementRequest(pointDisbursementId: string, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLoyaltyPointDisbursementRequestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLoyaltyPointDisbursementRequest(pointDisbursementId, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returning list of disbursement types. Will only be accessible on Admin Web.
         * @summary Get Data For Request Point Disbursement
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLoyaltyPointDisbursementRequestData(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLoyaltyPointDisbursementRequestDataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLoyaltyPointDisbursementRequestData(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Will return the list of credit/debit history of gold. The response will be ordered by the created at in descending order
         * @summary Get History List of Gold Currency
         * @param {number} [date] Date for filtering list of data (in epoch) formatted in UTC-0. Will use current date if not provided
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loyaltyGetGoldHistory(date?: number, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoyaltyGetGoldHistoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loyaltyGetGoldHistory(date, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get list of point transactions. Receiving points, redemption, and transfer points. 
         * @summary Get History List
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {number} [startTime] Filter for list History SawitPoin, if empty will use all time. Use epoch timestamp
         * @param {number} [endTime] Filter for list History SawitPoin, if empty will use current timestamp. Use epoch timestamp
         * @param {SawitpoinHistoryTypeEnum} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loyaltyHistoryList(authorization: string, page?: number, limit?: number, startTime?: number, endTime?: number, type?: SawitpoinHistoryTypeEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoyaltyHistoryListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loyaltyHistoryList(authorization, page, limit, startTime, endTime, type, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get list of available types for History List endpoint. 
         * @summary Get Types of History List
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loyaltyHistoryListTypes(authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoyaltyHistoryListTypesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loyaltyHistoryListTypes(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Display all public vouchers 
         * @summary Get public vouchers list for user
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} [userId] used by DUTA app, id of the user that this request is for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loyaltyPublicVoucherList(aPPTYPE: AppTypeEnum, userId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoyaltyPublicVoucherListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loyaltyPublicVoucherList(aPPTYPE, userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Request for disbursement point. Will only be accessible by administrator and finance lead.
         * @summary Request of Point Disbursement
         * @param {LoyaltyRequestPointDisbursementRequest} [loyaltyRequestPointDisbursementRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loyaltyRequestPointDisbursement(loyaltyRequestPointDisbursementRequest?: LoyaltyRequestPointDisbursementRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loyaltyRequestPointDisbursement(loyaltyRequestPointDisbursementRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * For transferring point between 2 users
         * @summary Transferring Point to Other User
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {LoyaltyTransferRequest} loyaltyTransferRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loyaltyTransfer(aPPTYPE: AppTypeEnum, loyaltyTransferRequest: LoyaltyTransferRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoyaltyTransferResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loyaltyTransfer(aPPTYPE, loyaltyTransferRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Display all voucher 
         * @summary Get voucher list for user
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} invoiceId Invoice ID in UUID type 4 format
         * @param {number} pointAmount point ammount transaction of payment method
         * @param {boolean} pointUseStatus flag for using point as payment
         * @param {PaymentsCreatePaymentPaymentMethodEnum} paymentMethod payment method of transaction
         * @param {string} [userId] used by DUTA app, id of the user that this request is for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loyaltyVoucherList(aPPTYPE: AppTypeEnum, invoiceId: string, pointAmount: number, pointUseStatus: boolean, paymentMethod: PaymentsCreatePaymentPaymentMethodEnum, userId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoyaltyVoucherListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loyaltyVoucherList(aPPTYPE, invoiceId, pointAmount, pointUseStatus, paymentMethod, userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Calculate voucher based on payment method 
         * @summary Calculate voucher
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {LoyaltyVouchersCalculateRequest} loyaltyVouchersCalculateRequest 
         * @param {string} [userId] used by DUTA app, id of the user that this request is for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loyaltyVouchersCalculate(aPPTYPE: AppTypeEnum, loyaltyVouchersCalculateRequest: LoyaltyVouchersCalculateRequest, userId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoyaltyVouchersCalculateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loyaltyVouchersCalculate(aPPTYPE, loyaltyVouchersCalculateRequest, userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get voucher detail to get information by voucher id 
         * @summary Get voucher detail
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} voucherId 
         * @param {string} [userId] used by DUTA app, id of the user that this request is for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loyaltyVouchersGetDetail(aPPTYPE: AppTypeEnum, voucherId: string, userId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoyaltyVouchersGetDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loyaltyVouchersGetDetail(aPPTYPE, voucherId, userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Initiate to use voucher 
         * @summary Use voucher by user
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {LoyaltyVouchersUsageRequest} loyaltyVouchersUsageRequest 
         * @param {string} [userId] used by DUTA app, id of the user that this request is for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loyaltyVouchersUsage(aPPTYPE: AppTypeEnum, loyaltyVouchersUsageRequest: LoyaltyVouchersUsageRequest, userId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoyaltyVouchersUsageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loyaltyVouchersUsage(aPPTYPE, loyaltyVouchersUsageRequest, userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Endpoint for create weighbridge supply master cost
         * @summary Create Weighbridge Supply Master Cost
         * @param {LoyaltyWeighbridgeCostCreateRequest} loyaltyWeighbridgeCostCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loyaltyWeighbridgeCostCreate(loyaltyWeighbridgeCostCreateRequest: LoyaltyWeighbridgeCostCreateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loyaltyWeighbridgeCostCreate(loyaltyWeighbridgeCostCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Endpoint for update weighbridge supply cost
         * @summary Update Weighbridge Supply Cost
         * @param {string} weighbridgeCostId Weighbridge Master Cost UUID
         * @param {LoyaltyWeighbridgeCostCreateRequest} loyaltyWeighbridgeCostCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loyaltyWeighbridgeCostUpdate(weighbridgeCostId: string, loyaltyWeighbridgeCostCreateRequest: LoyaltyWeighbridgeCostCreateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loyaltyWeighbridgeCostUpdate(weighbridgeCostId, loyaltyWeighbridgeCostCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LoyaltyApi - factory interface
 * @export
 */
export const LoyaltyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LoyaltyApiFp(configuration)
    return {
        /**
         * Confirm The Request of Point Disbursement. Will only be accessible by administrator and finance lead to approve/reject the request.
         * @summary Confirm The Request of Point Disbursement
         * @param {string} pointDisbursementId ID of point disbursement request
         * @param {ConfirmLoyaltyRequestPointDisbursementRequest} [confirmLoyaltyRequestPointDisbursementRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmLoyaltyRequestPointDisbursement(pointDisbursementId: string, confirmLoyaltyRequestPointDisbursementRequest?: ConfirmLoyaltyRequestPointDisbursementRequest, options?: any): AxiosPromise<void> {
            return localVarFp.confirmLoyaltyRequestPointDisbursement(pointDisbursementId, confirmLoyaltyRequestPointDisbursementRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Returning list of point disbursement request. Will only be accessible by administrator and finance lead.
         * @summary Get List of Point Disbursement Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListLoyaltyPointDisbursementRequest(options?: any): AxiosPromise<GetListLoyaltyPointDisbursementRequestResponse> {
            return localVarFp.getListLoyaltyPointDisbursementRequest(options).then((request) => request(axios, basePath));
        },
        /**
         * List of Weighbridge Supply Master Cost
         * @summary Get List Weighbridge Supply Master Cost
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListLoyaltyWeighbridgeCost(page?: number, limit?: number, options?: any): AxiosPromise<GetListLoyaltyWeighbridgeCostResponse> {
            return localVarFp.getListLoyaltyWeighbridgeCost(page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Returning detail of point disbursement request and also list of recipients with pagination. Will only be accessible by administrator and finance lead.
         * @summary Get point disbursement request detail
         * @param {string} pointDisbursementId ID of point disbursement request
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoyaltyPointDisbursementRequest(pointDisbursementId: string, page?: number, limit?: number, options?: any): AxiosPromise<GetLoyaltyPointDisbursementRequestResponse> {
            return localVarFp.getLoyaltyPointDisbursementRequest(pointDisbursementId, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Returning list of disbursement types. Will only be accessible on Admin Web.
         * @summary Get Data For Request Point Disbursement
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoyaltyPointDisbursementRequestData(options?: any): AxiosPromise<GetLoyaltyPointDisbursementRequestDataResponse> {
            return localVarFp.getLoyaltyPointDisbursementRequestData(options).then((request) => request(axios, basePath));
        },
        /**
         * Will return the list of credit/debit history of gold. The response will be ordered by the created at in descending order
         * @summary Get History List of Gold Currency
         * @param {number} [date] Date for filtering list of data (in epoch) formatted in UTC-0. Will use current date if not provided
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loyaltyGetGoldHistory(date?: number, page?: number, limit?: number, options?: any): AxiosPromise<LoyaltyGetGoldHistoryResponse> {
            return localVarFp.loyaltyGetGoldHistory(date, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Get list of point transactions. Receiving points, redemption, and transfer points. 
         * @summary Get History List
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {number} [startTime] Filter for list History SawitPoin, if empty will use all time. Use epoch timestamp
         * @param {number} [endTime] Filter for list History SawitPoin, if empty will use current timestamp. Use epoch timestamp
         * @param {SawitpoinHistoryTypeEnum} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loyaltyHistoryList(authorization: string, page?: number, limit?: number, startTime?: number, endTime?: number, type?: SawitpoinHistoryTypeEnum, options?: any): AxiosPromise<LoyaltyHistoryListResponse> {
            return localVarFp.loyaltyHistoryList(authorization, page, limit, startTime, endTime, type, options).then((request) => request(axios, basePath));
        },
        /**
         * Get list of available types for History List endpoint. 
         * @summary Get Types of History List
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loyaltyHistoryListTypes(authorization: string, options?: any): AxiosPromise<LoyaltyHistoryListTypesResponse> {
            return localVarFp.loyaltyHistoryListTypes(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Display all public vouchers 
         * @summary Get public vouchers list for user
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} [userId] used by DUTA app, id of the user that this request is for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loyaltyPublicVoucherList(aPPTYPE: AppTypeEnum, userId?: string, options?: any): AxiosPromise<LoyaltyPublicVoucherListResponse> {
            return localVarFp.loyaltyPublicVoucherList(aPPTYPE, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Request for disbursement point. Will only be accessible by administrator and finance lead.
         * @summary Request of Point Disbursement
         * @param {LoyaltyRequestPointDisbursementRequest} [loyaltyRequestPointDisbursementRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loyaltyRequestPointDisbursement(loyaltyRequestPointDisbursementRequest?: LoyaltyRequestPointDisbursementRequest, options?: any): AxiosPromise<void> {
            return localVarFp.loyaltyRequestPointDisbursement(loyaltyRequestPointDisbursementRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * For transferring point between 2 users
         * @summary Transferring Point to Other User
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {LoyaltyTransferRequest} loyaltyTransferRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loyaltyTransfer(aPPTYPE: AppTypeEnum, loyaltyTransferRequest: LoyaltyTransferRequest, options?: any): AxiosPromise<LoyaltyTransferResponse> {
            return localVarFp.loyaltyTransfer(aPPTYPE, loyaltyTransferRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Display all voucher 
         * @summary Get voucher list for user
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} invoiceId Invoice ID in UUID type 4 format
         * @param {number} pointAmount point ammount transaction of payment method
         * @param {boolean} pointUseStatus flag for using point as payment
         * @param {PaymentsCreatePaymentPaymentMethodEnum} paymentMethod payment method of transaction
         * @param {string} [userId] used by DUTA app, id of the user that this request is for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loyaltyVoucherList(aPPTYPE: AppTypeEnum, invoiceId: string, pointAmount: number, pointUseStatus: boolean, paymentMethod: PaymentsCreatePaymentPaymentMethodEnum, userId?: string, options?: any): AxiosPromise<LoyaltyVoucherListResponse> {
            return localVarFp.loyaltyVoucherList(aPPTYPE, invoiceId, pointAmount, pointUseStatus, paymentMethod, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Calculate voucher based on payment method 
         * @summary Calculate voucher
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {LoyaltyVouchersCalculateRequest} loyaltyVouchersCalculateRequest 
         * @param {string} [userId] used by DUTA app, id of the user that this request is for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loyaltyVouchersCalculate(aPPTYPE: AppTypeEnum, loyaltyVouchersCalculateRequest: LoyaltyVouchersCalculateRequest, userId?: string, options?: any): AxiosPromise<LoyaltyVouchersCalculateResponse> {
            return localVarFp.loyaltyVouchersCalculate(aPPTYPE, loyaltyVouchersCalculateRequest, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get voucher detail to get information by voucher id 
         * @summary Get voucher detail
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} voucherId 
         * @param {string} [userId] used by DUTA app, id of the user that this request is for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loyaltyVouchersGetDetail(aPPTYPE: AppTypeEnum, voucherId: string, userId?: string, options?: any): AxiosPromise<LoyaltyVouchersGetDetailResponse> {
            return localVarFp.loyaltyVouchersGetDetail(aPPTYPE, voucherId, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Initiate to use voucher 
         * @summary Use voucher by user
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {LoyaltyVouchersUsageRequest} loyaltyVouchersUsageRequest 
         * @param {string} [userId] used by DUTA app, id of the user that this request is for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loyaltyVouchersUsage(aPPTYPE: AppTypeEnum, loyaltyVouchersUsageRequest: LoyaltyVouchersUsageRequest, userId?: string, options?: any): AxiosPromise<LoyaltyVouchersUsageResponse> {
            return localVarFp.loyaltyVouchersUsage(aPPTYPE, loyaltyVouchersUsageRequest, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint for create weighbridge supply master cost
         * @summary Create Weighbridge Supply Master Cost
         * @param {LoyaltyWeighbridgeCostCreateRequest} loyaltyWeighbridgeCostCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loyaltyWeighbridgeCostCreate(loyaltyWeighbridgeCostCreateRequest: LoyaltyWeighbridgeCostCreateRequest, options?: any): AxiosPromise<void> {
            return localVarFp.loyaltyWeighbridgeCostCreate(loyaltyWeighbridgeCostCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint for update weighbridge supply cost
         * @summary Update Weighbridge Supply Cost
         * @param {string} weighbridgeCostId Weighbridge Master Cost UUID
         * @param {LoyaltyWeighbridgeCostCreateRequest} loyaltyWeighbridgeCostCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loyaltyWeighbridgeCostUpdate(weighbridgeCostId: string, loyaltyWeighbridgeCostCreateRequest: LoyaltyWeighbridgeCostCreateRequest, options?: any): AxiosPromise<void> {
            return localVarFp.loyaltyWeighbridgeCostUpdate(weighbridgeCostId, loyaltyWeighbridgeCostCreateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LoyaltyApi - object-oriented interface
 * @export
 * @class LoyaltyApi
 * @extends {BaseAPI}
 */
export class LoyaltyApi extends BaseAPI {
    /**
     * Confirm The Request of Point Disbursement. Will only be accessible by administrator and finance lead to approve/reject the request.
     * @summary Confirm The Request of Point Disbursement
     * @param {string} pointDisbursementId ID of point disbursement request
     * @param {ConfirmLoyaltyRequestPointDisbursementRequest} [confirmLoyaltyRequestPointDisbursementRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoyaltyApi
     */
    public confirmLoyaltyRequestPointDisbursement(pointDisbursementId: string, confirmLoyaltyRequestPointDisbursementRequest?: ConfirmLoyaltyRequestPointDisbursementRequest, options?: AxiosRequestConfig) {
        return LoyaltyApiFp(this.configuration).confirmLoyaltyRequestPointDisbursement(pointDisbursementId, confirmLoyaltyRequestPointDisbursementRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returning list of point disbursement request. Will only be accessible by administrator and finance lead.
     * @summary Get List of Point Disbursement Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoyaltyApi
     */
    public getListLoyaltyPointDisbursementRequest(options?: AxiosRequestConfig) {
        return LoyaltyApiFp(this.configuration).getListLoyaltyPointDisbursementRequest(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List of Weighbridge Supply Master Cost
     * @summary Get List Weighbridge Supply Master Cost
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoyaltyApi
     */
    public getListLoyaltyWeighbridgeCost(page?: number, limit?: number, options?: AxiosRequestConfig) {
        return LoyaltyApiFp(this.configuration).getListLoyaltyWeighbridgeCost(page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returning detail of point disbursement request and also list of recipients with pagination. Will only be accessible by administrator and finance lead.
     * @summary Get point disbursement request detail
     * @param {string} pointDisbursementId ID of point disbursement request
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoyaltyApi
     */
    public getLoyaltyPointDisbursementRequest(pointDisbursementId: string, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return LoyaltyApiFp(this.configuration).getLoyaltyPointDisbursementRequest(pointDisbursementId, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returning list of disbursement types. Will only be accessible on Admin Web.
     * @summary Get Data For Request Point Disbursement
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoyaltyApi
     */
    public getLoyaltyPointDisbursementRequestData(options?: AxiosRequestConfig) {
        return LoyaltyApiFp(this.configuration).getLoyaltyPointDisbursementRequestData(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Will return the list of credit/debit history of gold. The response will be ordered by the created at in descending order
     * @summary Get History List of Gold Currency
     * @param {number} [date] Date for filtering list of data (in epoch) formatted in UTC-0. Will use current date if not provided
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoyaltyApi
     */
    public loyaltyGetGoldHistory(date?: number, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return LoyaltyApiFp(this.configuration).loyaltyGetGoldHistory(date, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get list of point transactions. Receiving points, redemption, and transfer points. 
     * @summary Get History List
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {number} [startTime] Filter for list History SawitPoin, if empty will use all time. Use epoch timestamp
     * @param {number} [endTime] Filter for list History SawitPoin, if empty will use current timestamp. Use epoch timestamp
     * @param {SawitpoinHistoryTypeEnum} [type] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoyaltyApi
     */
    public loyaltyHistoryList(authorization: string, page?: number, limit?: number, startTime?: number, endTime?: number, type?: SawitpoinHistoryTypeEnum, options?: AxiosRequestConfig) {
        return LoyaltyApiFp(this.configuration).loyaltyHistoryList(authorization, page, limit, startTime, endTime, type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get list of available types for History List endpoint. 
     * @summary Get Types of History List
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoyaltyApi
     */
    public loyaltyHistoryListTypes(authorization: string, options?: AxiosRequestConfig) {
        return LoyaltyApiFp(this.configuration).loyaltyHistoryListTypes(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Display all public vouchers 
     * @summary Get public vouchers list for user
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} [userId] used by DUTA app, id of the user that this request is for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoyaltyApi
     */
    public loyaltyPublicVoucherList(aPPTYPE: AppTypeEnum, userId?: string, options?: AxiosRequestConfig) {
        return LoyaltyApiFp(this.configuration).loyaltyPublicVoucherList(aPPTYPE, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Request for disbursement point. Will only be accessible by administrator and finance lead.
     * @summary Request of Point Disbursement
     * @param {LoyaltyRequestPointDisbursementRequest} [loyaltyRequestPointDisbursementRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoyaltyApi
     */
    public loyaltyRequestPointDisbursement(loyaltyRequestPointDisbursementRequest?: LoyaltyRequestPointDisbursementRequest, options?: AxiosRequestConfig) {
        return LoyaltyApiFp(this.configuration).loyaltyRequestPointDisbursement(loyaltyRequestPointDisbursementRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * For transferring point between 2 users
     * @summary Transferring Point to Other User
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {LoyaltyTransferRequest} loyaltyTransferRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoyaltyApi
     */
    public loyaltyTransfer(aPPTYPE: AppTypeEnum, loyaltyTransferRequest: LoyaltyTransferRequest, options?: AxiosRequestConfig) {
        return LoyaltyApiFp(this.configuration).loyaltyTransfer(aPPTYPE, loyaltyTransferRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Display all voucher 
     * @summary Get voucher list for user
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} invoiceId Invoice ID in UUID type 4 format
     * @param {number} pointAmount point ammount transaction of payment method
     * @param {boolean} pointUseStatus flag for using point as payment
     * @param {PaymentsCreatePaymentPaymentMethodEnum} paymentMethod payment method of transaction
     * @param {string} [userId] used by DUTA app, id of the user that this request is for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoyaltyApi
     */
    public loyaltyVoucherList(aPPTYPE: AppTypeEnum, invoiceId: string, pointAmount: number, pointUseStatus: boolean, paymentMethod: PaymentsCreatePaymentPaymentMethodEnum, userId?: string, options?: AxiosRequestConfig) {
        return LoyaltyApiFp(this.configuration).loyaltyVoucherList(aPPTYPE, invoiceId, pointAmount, pointUseStatus, paymentMethod, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Calculate voucher based on payment method 
     * @summary Calculate voucher
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {LoyaltyVouchersCalculateRequest} loyaltyVouchersCalculateRequest 
     * @param {string} [userId] used by DUTA app, id of the user that this request is for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoyaltyApi
     */
    public loyaltyVouchersCalculate(aPPTYPE: AppTypeEnum, loyaltyVouchersCalculateRequest: LoyaltyVouchersCalculateRequest, userId?: string, options?: AxiosRequestConfig) {
        return LoyaltyApiFp(this.configuration).loyaltyVouchersCalculate(aPPTYPE, loyaltyVouchersCalculateRequest, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get voucher detail to get information by voucher id 
     * @summary Get voucher detail
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} voucherId 
     * @param {string} [userId] used by DUTA app, id of the user that this request is for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoyaltyApi
     */
    public loyaltyVouchersGetDetail(aPPTYPE: AppTypeEnum, voucherId: string, userId?: string, options?: AxiosRequestConfig) {
        return LoyaltyApiFp(this.configuration).loyaltyVouchersGetDetail(aPPTYPE, voucherId, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Initiate to use voucher 
     * @summary Use voucher by user
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {LoyaltyVouchersUsageRequest} loyaltyVouchersUsageRequest 
     * @param {string} [userId] used by DUTA app, id of the user that this request is for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoyaltyApi
     */
    public loyaltyVouchersUsage(aPPTYPE: AppTypeEnum, loyaltyVouchersUsageRequest: LoyaltyVouchersUsageRequest, userId?: string, options?: AxiosRequestConfig) {
        return LoyaltyApiFp(this.configuration).loyaltyVouchersUsage(aPPTYPE, loyaltyVouchersUsageRequest, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endpoint for create weighbridge supply master cost
     * @summary Create Weighbridge Supply Master Cost
     * @param {LoyaltyWeighbridgeCostCreateRequest} loyaltyWeighbridgeCostCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoyaltyApi
     */
    public loyaltyWeighbridgeCostCreate(loyaltyWeighbridgeCostCreateRequest: LoyaltyWeighbridgeCostCreateRequest, options?: AxiosRequestConfig) {
        return LoyaltyApiFp(this.configuration).loyaltyWeighbridgeCostCreate(loyaltyWeighbridgeCostCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endpoint for update weighbridge supply cost
     * @summary Update Weighbridge Supply Cost
     * @param {string} weighbridgeCostId Weighbridge Master Cost UUID
     * @param {LoyaltyWeighbridgeCostCreateRequest} loyaltyWeighbridgeCostCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoyaltyApi
     */
    public loyaltyWeighbridgeCostUpdate(weighbridgeCostId: string, loyaltyWeighbridgeCostCreateRequest: LoyaltyWeighbridgeCostCreateRequest, options?: AxiosRequestConfig) {
        return LoyaltyApiFp(this.configuration).loyaltyWeighbridgeCostUpdate(weighbridgeCostId, loyaltyWeighbridgeCostCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MarketingsApi - axios parameter creator
 * @export
 */
export const MarketingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Called by mobile app to get list of active banners.
         * @summary List of active banners sorted by priority
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {BannerScopeQueryEnum} [scope] scope of banner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bannerList: async (aPPTYPE: AppTypeEnum, scope?: BannerScopeQueryEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('bannerList', 'aPPTYPE', aPPTYPE)
            const localVarPath = `/api/v1/banners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Summary of Leads under the Ambassador
         * @summary Get Leads Summary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeadsSummary: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/marketings/leads/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List of Duta SawitPRO leads
         * @summary List Leads
         * @param {string} [search] User\&#39;s attribute (either phone number or name) for searching. If not provided, it will return all users
         * @param {LeadsStatusEnum} [status] Status of the leads, will return all status if not present
         * @param {AssetCategoryEnum} [assetCategory] To filter leads based on asset category
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketingsLeads: async (search?: string, status?: LeadsStatusEnum, assetCategory?: AssetCategoryEnum, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/marketings/leads`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (assetCategory !== undefined) {
                localVarQueryParameter['assetCategory'] = assetCategory;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get CPO price details 
         * @summary Get CPO price details
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketingsCPOPriceDetails: async (aPPTYPE: AppTypeEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('marketingsCPOPriceDetails', 'aPPTYPE', aPPTYPE)
            const localVarPath = `/api/v1/marketings/cpo-price/details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get latest goverment\'s ffb price based on province 
         * @summary Get latest gov ffb price
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} [province] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketingsFFBPricesGetLatest: async (aPPTYPE: AppTypeEnum, province?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('marketingsFFBPricesGetLatest', 'aPPTYPE', aPPTYPE)
            const localVarPath = `/api/v1/marketings/ffb-prices/latest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (province !== undefined) {
                localVarQueryParameter['province'] = province;
            }

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get articles will return articles data with limit defined in BE 
         * @summary Get article list
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketingsGetArticles: async (aPPTYPE: AppTypeEnum, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('marketingsGetArticles', 'aPPTYPE', aPPTYPE)
            const localVarPath = `/api/v1/marketings/articles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get CPO price will return the latest CPO price 
         * @summary Get current CPO International price
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketingsGetCurrentCPOPrice: async (aPPTYPE: AppTypeEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('marketingsGetCurrentCPOPrice', 'aPPTYPE', aPPTYPE)
            const localVarPath = `/api/v1/marketings/cpo-price`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get FAQ will return all FAQs data 
         * @summary Get FAQ list
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {MarketingsGetFAQsScopeQueryEnum} [scope] scope of get marketing FAQs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketingsGetFAQs: async (aPPTYPE: AppTypeEnum, scope?: MarketingsGetFAQsScopeQueryEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('marketingsGetFAQs', 'aPPTYPE', aPPTYPE)
            const localVarPath = `/api/v1/marketings/faqs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get goverment\'s FFB price based on province 
         * @summary Get gov FFB price
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} [province] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketingsGetFFBPrices: async (aPPTYPE: AppTypeEnum, province?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('marketingsGetFFBPrices', 'aPPTYPE', aPPTYPE)
            const localVarPath = `/api/v1/marketings/ffb-prices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (province !== undefined) {
                localVarQueryParameter['province'] = province;
            }

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get testimonials will return all testimonials data 
         * @summary Get testimonial list
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketingsGetTestimonials: async (aPPTYPE: AppTypeEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('marketingsGetTestimonials', 'aPPTYPE', aPPTYPE)
            const localVarPath = `/api/v1/marketings/testimonials`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get marketing videos will return all marketing videos data 
         * @summary Get marketing video list
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {MarketingsGetVideosScopeQueryEnum} [scope] scope of get marketing videos
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketingsGetVideos: async (aPPTYPE: AppTypeEnum, scope?: MarketingsGetVideosScopeQueryEnum, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('marketingsGetVideos', 'aPPTYPE', aPPTYPE)
            const localVarPath = `/api/v1/marketings/videos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MarketingsApi - functional programming interface
 * @export
 */
export const MarketingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MarketingsApiAxiosParamCreator(configuration)
    return {
        /**
         * Called by mobile app to get list of active banners.
         * @summary List of active banners sorted by priority
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {BannerScopeQueryEnum} [scope] scope of banner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bannerList(aPPTYPE: AppTypeEnum, scope?: BannerScopeQueryEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BannerListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bannerList(aPPTYPE, scope, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Summary of Leads under the Ambassador
         * @summary Get Leads Summary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLeadsSummary(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLeadsSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLeadsSummary(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * List of Duta SawitPRO leads
         * @summary List Leads
         * @param {string} [search] User\&#39;s attribute (either phone number or name) for searching. If not provided, it will return all users
         * @param {LeadsStatusEnum} [status] Status of the leads, will return all status if not present
         * @param {AssetCategoryEnum} [assetCategory] To filter leads based on asset category
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMarketingsLeads(search?: string, status?: LeadsStatusEnum, assetCategory?: AssetCategoryEnum, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListMarketingsLeadsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMarketingsLeads(search, status, assetCategory, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get CPO price details 
         * @summary Get CPO price details
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async marketingsCPOPriceDetails(aPPTYPE: AppTypeEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketingsCPOPriceDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.marketingsCPOPriceDetails(aPPTYPE, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get latest goverment\'s ffb price based on province 
         * @summary Get latest gov ffb price
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} [province] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async marketingsFFBPricesGetLatest(aPPTYPE: AppTypeEnum, province?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketingsFFBPricesGetLatestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.marketingsFFBPricesGetLatest(aPPTYPE, province, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get articles will return articles data with limit defined in BE 
         * @summary Get article list
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async marketingsGetArticles(aPPTYPE: AppTypeEnum, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketingsGetArticlesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.marketingsGetArticles(aPPTYPE, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get CPO price will return the latest CPO price 
         * @summary Get current CPO International price
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async marketingsGetCurrentCPOPrice(aPPTYPE: AppTypeEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketingsGetCurrentCPOPriceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.marketingsGetCurrentCPOPrice(aPPTYPE, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get FAQ will return all FAQs data 
         * @summary Get FAQ list
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {MarketingsGetFAQsScopeQueryEnum} [scope] scope of get marketing FAQs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async marketingsGetFAQs(aPPTYPE: AppTypeEnum, scope?: MarketingsGetFAQsScopeQueryEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketingsGetFAQsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.marketingsGetFAQs(aPPTYPE, scope, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get goverment\'s FFB price based on province 
         * @summary Get gov FFB price
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} [province] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async marketingsGetFFBPrices(aPPTYPE: AppTypeEnum, province?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketingsGetFFBPricesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.marketingsGetFFBPrices(aPPTYPE, province, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get testimonials will return all testimonials data 
         * @summary Get testimonial list
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async marketingsGetTestimonials(aPPTYPE: AppTypeEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketingsGetTestimonialsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.marketingsGetTestimonials(aPPTYPE, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get marketing videos will return all marketing videos data 
         * @summary Get marketing video list
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {MarketingsGetVideosScopeQueryEnum} [scope] scope of get marketing videos
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async marketingsGetVideos(aPPTYPE: AppTypeEnum, scope?: MarketingsGetVideosScopeQueryEnum, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketingsGetVideosResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.marketingsGetVideos(aPPTYPE, scope, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MarketingsApi - factory interface
 * @export
 */
export const MarketingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MarketingsApiFp(configuration)
    return {
        /**
         * Called by mobile app to get list of active banners.
         * @summary List of active banners sorted by priority
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {BannerScopeQueryEnum} [scope] scope of banner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bannerList(aPPTYPE: AppTypeEnum, scope?: BannerScopeQueryEnum, options?: any): AxiosPromise<BannerListResponse> {
            return localVarFp.bannerList(aPPTYPE, scope, options).then((request) => request(axios, basePath));
        },
        /**
         * Summary of Leads under the Ambassador
         * @summary Get Leads Summary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeadsSummary(options?: any): AxiosPromise<GetLeadsSummaryResponse> {
            return localVarFp.getLeadsSummary(options).then((request) => request(axios, basePath));
        },
        /**
         * List of Duta SawitPRO leads
         * @summary List Leads
         * @param {string} [search] User\&#39;s attribute (either phone number or name) for searching. If not provided, it will return all users
         * @param {LeadsStatusEnum} [status] Status of the leads, will return all status if not present
         * @param {AssetCategoryEnum} [assetCategory] To filter leads based on asset category
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketingsLeads(search?: string, status?: LeadsStatusEnum, assetCategory?: AssetCategoryEnum, page?: number, limit?: number, options?: any): AxiosPromise<ListMarketingsLeadsResponse> {
            return localVarFp.listMarketingsLeads(search, status, assetCategory, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Get CPO price details 
         * @summary Get CPO price details
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketingsCPOPriceDetails(aPPTYPE: AppTypeEnum, options?: any): AxiosPromise<MarketingsCPOPriceDetailsResponse> {
            return localVarFp.marketingsCPOPriceDetails(aPPTYPE, options).then((request) => request(axios, basePath));
        },
        /**
         * Get latest goverment\'s ffb price based on province 
         * @summary Get latest gov ffb price
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} [province] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketingsFFBPricesGetLatest(aPPTYPE: AppTypeEnum, province?: string, options?: any): AxiosPromise<MarketingsFFBPricesGetLatestResponse> {
            return localVarFp.marketingsFFBPricesGetLatest(aPPTYPE, province, options).then((request) => request(axios, basePath));
        },
        /**
         * Get articles will return articles data with limit defined in BE 
         * @summary Get article list
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketingsGetArticles(aPPTYPE: AppTypeEnum, limit?: number, options?: any): AxiosPromise<MarketingsGetArticlesResponse> {
            return localVarFp.marketingsGetArticles(aPPTYPE, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Get CPO price will return the latest CPO price 
         * @summary Get current CPO International price
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketingsGetCurrentCPOPrice(aPPTYPE: AppTypeEnum, options?: any): AxiosPromise<MarketingsGetCurrentCPOPriceResponse> {
            return localVarFp.marketingsGetCurrentCPOPrice(aPPTYPE, options).then((request) => request(axios, basePath));
        },
        /**
         * Get FAQ will return all FAQs data 
         * @summary Get FAQ list
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {MarketingsGetFAQsScopeQueryEnum} [scope] scope of get marketing FAQs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketingsGetFAQs(aPPTYPE: AppTypeEnum, scope?: MarketingsGetFAQsScopeQueryEnum, options?: any): AxiosPromise<MarketingsGetFAQsResponse> {
            return localVarFp.marketingsGetFAQs(aPPTYPE, scope, options).then((request) => request(axios, basePath));
        },
        /**
         * Get goverment\'s FFB price based on province 
         * @summary Get gov FFB price
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} [province] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketingsGetFFBPrices(aPPTYPE: AppTypeEnum, province?: string, options?: any): AxiosPromise<MarketingsGetFFBPricesResponse> {
            return localVarFp.marketingsGetFFBPrices(aPPTYPE, province, options).then((request) => request(axios, basePath));
        },
        /**
         * Get testimonials will return all testimonials data 
         * @summary Get testimonial list
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketingsGetTestimonials(aPPTYPE: AppTypeEnum, options?: any): AxiosPromise<MarketingsGetTestimonialsResponse> {
            return localVarFp.marketingsGetTestimonials(aPPTYPE, options).then((request) => request(axios, basePath));
        },
        /**
         * Get marketing videos will return all marketing videos data 
         * @summary Get marketing video list
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {MarketingsGetVideosScopeQueryEnum} [scope] scope of get marketing videos
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketingsGetVideos(aPPTYPE: AppTypeEnum, scope?: MarketingsGetVideosScopeQueryEnum, page?: number, limit?: number, options?: any): AxiosPromise<MarketingsGetVideosResponse> {
            return localVarFp.marketingsGetVideos(aPPTYPE, scope, page, limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MarketingsApi - object-oriented interface
 * @export
 * @class MarketingsApi
 * @extends {BaseAPI}
 */
export class MarketingsApi extends BaseAPI {
    /**
     * Called by mobile app to get list of active banners.
     * @summary List of active banners sorted by priority
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {BannerScopeQueryEnum} [scope] scope of banner
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketingsApi
     */
    public bannerList(aPPTYPE: AppTypeEnum, scope?: BannerScopeQueryEnum, options?: AxiosRequestConfig) {
        return MarketingsApiFp(this.configuration).bannerList(aPPTYPE, scope, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Summary of Leads under the Ambassador
     * @summary Get Leads Summary
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketingsApi
     */
    public getLeadsSummary(options?: AxiosRequestConfig) {
        return MarketingsApiFp(this.configuration).getLeadsSummary(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List of Duta SawitPRO leads
     * @summary List Leads
     * @param {string} [search] User\&#39;s attribute (either phone number or name) for searching. If not provided, it will return all users
     * @param {LeadsStatusEnum} [status] Status of the leads, will return all status if not present
     * @param {AssetCategoryEnum} [assetCategory] To filter leads based on asset category
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketingsApi
     */
    public listMarketingsLeads(search?: string, status?: LeadsStatusEnum, assetCategory?: AssetCategoryEnum, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return MarketingsApiFp(this.configuration).listMarketingsLeads(search, status, assetCategory, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get CPO price details 
     * @summary Get CPO price details
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketingsApi
     */
    public marketingsCPOPriceDetails(aPPTYPE: AppTypeEnum, options?: AxiosRequestConfig) {
        return MarketingsApiFp(this.configuration).marketingsCPOPriceDetails(aPPTYPE, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get latest goverment\'s ffb price based on province 
     * @summary Get latest gov ffb price
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} [province] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketingsApi
     */
    public marketingsFFBPricesGetLatest(aPPTYPE: AppTypeEnum, province?: string, options?: AxiosRequestConfig) {
        return MarketingsApiFp(this.configuration).marketingsFFBPricesGetLatest(aPPTYPE, province, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get articles will return articles data with limit defined in BE 
     * @summary Get article list
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {number} [limit] Number of items per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketingsApi
     */
    public marketingsGetArticles(aPPTYPE: AppTypeEnum, limit?: number, options?: AxiosRequestConfig) {
        return MarketingsApiFp(this.configuration).marketingsGetArticles(aPPTYPE, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get CPO price will return the latest CPO price 
     * @summary Get current CPO International price
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketingsApi
     */
    public marketingsGetCurrentCPOPrice(aPPTYPE: AppTypeEnum, options?: AxiosRequestConfig) {
        return MarketingsApiFp(this.configuration).marketingsGetCurrentCPOPrice(aPPTYPE, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get FAQ will return all FAQs data 
     * @summary Get FAQ list
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {MarketingsGetFAQsScopeQueryEnum} [scope] scope of get marketing FAQs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketingsApi
     */
    public marketingsGetFAQs(aPPTYPE: AppTypeEnum, scope?: MarketingsGetFAQsScopeQueryEnum, options?: AxiosRequestConfig) {
        return MarketingsApiFp(this.configuration).marketingsGetFAQs(aPPTYPE, scope, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get goverment\'s FFB price based on province 
     * @summary Get gov FFB price
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} [province] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketingsApi
     */
    public marketingsGetFFBPrices(aPPTYPE: AppTypeEnum, province?: string, options?: AxiosRequestConfig) {
        return MarketingsApiFp(this.configuration).marketingsGetFFBPrices(aPPTYPE, province, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get testimonials will return all testimonials data 
     * @summary Get testimonial list
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketingsApi
     */
    public marketingsGetTestimonials(aPPTYPE: AppTypeEnum, options?: AxiosRequestConfig) {
        return MarketingsApiFp(this.configuration).marketingsGetTestimonials(aPPTYPE, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get marketing videos will return all marketing videos data 
     * @summary Get marketing video list
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {MarketingsGetVideosScopeQueryEnum} [scope] scope of get marketing videos
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketingsApi
     */
    public marketingsGetVideos(aPPTYPE: AppTypeEnum, scope?: MarketingsGetVideosScopeQueryEnum, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return MarketingsApiFp(this.configuration).marketingsGetVideos(aPPTYPE, scope, page, limit, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MediaApi - axios parameter creator
 * @export
 */
export const MediaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This endpoint is meant to be used to generate presigned url to upload media file
         * @summary Generate presigned URL to upload media file
         * @param {MediaPresignedUrlRequest} [mediaPresignedUrlRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mediaPresignedUrl: async (mediaPresignedUrlRequest?: MediaPresignedUrlRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/media/presigned-url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mediaPresignedUrlRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MediaApi - functional programming interface
 * @export
 */
export const MediaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MediaApiAxiosParamCreator(configuration)
    return {
        /**
         * This endpoint is meant to be used to generate presigned url to upload media file
         * @summary Generate presigned URL to upload media file
         * @param {MediaPresignedUrlRequest} [mediaPresignedUrlRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mediaPresignedUrl(mediaPresignedUrlRequest?: MediaPresignedUrlRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MediaPresignedUrlResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mediaPresignedUrl(mediaPresignedUrlRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MediaApi - factory interface
 * @export
 */
export const MediaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MediaApiFp(configuration)
    return {
        /**
         * This endpoint is meant to be used to generate presigned url to upload media file
         * @summary Generate presigned URL to upload media file
         * @param {MediaPresignedUrlRequest} [mediaPresignedUrlRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mediaPresignedUrl(mediaPresignedUrlRequest?: MediaPresignedUrlRequest, options?: any): AxiosPromise<MediaPresignedUrlResponse> {
            return localVarFp.mediaPresignedUrl(mediaPresignedUrlRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MediaApi - object-oriented interface
 * @export
 * @class MediaApi
 * @extends {BaseAPI}
 */
export class MediaApi extends BaseAPI {
    /**
     * This endpoint is meant to be used to generate presigned url to upload media file
     * @summary Generate presigned URL to upload media file
     * @param {MediaPresignedUrlRequest} [mediaPresignedUrlRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaApi
     */
    public mediaPresignedUrl(mediaPresignedUrlRequest?: MediaPresignedUrlRequest, options?: AxiosRequestConfig) {
        return MediaApiFp(this.configuration).mediaPresignedUrl(mediaPresignedUrlRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MembersApi - axios parameter creator
 * @export
 */
export const MembersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This endpoint is meant to be used to submit a response for feedback that already posted about a partner mill. e.g. response about wrong feedback. 
         * @summary Submit Response of Feedback
         * @param {string} feedbackId Feedback ID, represented in UUID type 4 format
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        feedbacksReponsesCreate: async (feedbackId: string, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'feedbackId' is not null or undefined
            assertParamExists('feedbacksReponsesCreate', 'feedbackId', feedbackId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('feedbacksReponsesCreate', 'authorization', authorization)
            const localVarPath = `/api/v1/feedbacks/{feedbackId}/response`
                .replace(`{${"feedbackId"}}`, encodeURIComponent(String(feedbackId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Used by MemberApp to get list of their(member) weighbridge, can be filter by cargo desc 
         * @summary List of weighbridge
         * @param {string} [cargoDesc] Weighbridge cargo desc
         * @param {string} [partnerName] Weighbridge partner name
         * @param {string} [yearMonth] Weighbridge date YYYY-MM format
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        membersGetWeighbridges: async (cargoDesc?: string, partnerName?: string, yearMonth?: string, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/members/weighbridges`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (cargoDesc !== undefined) {
                localVarQueryParameter['cargoDesc'] = cargoDesc;
            }

            if (partnerName !== undefined) {
                localVarQueryParameter['partnerName'] = partnerName;
            }

            if (yearMonth !== undefined) {
                localVarQueryParameter['yearMonth'] = yearMonth;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get active campaigns for the members
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        membersLoyaltyListActiveCampaigns: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/members/loyalty/v1/campaigns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Member can add a friend as referrals. Used by MemberApp to add a new one. 
         * @summary Create a Referral by User
         * @param {MembersReferralsCreateRequest} [membersReferralsCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        membersReferralsCreate: async (membersReferralsCreateRequest?: MembersReferralsCreateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/members/referrals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(membersReferralsCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Used by MemberApp to get list of friend referrals. 
         * @summary List of friend referrals by User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        membersReferralsList: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/members/referrals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add referrals
         * @param {string} userId 
         * @param {MembersReferralsCreateRequest} membersReferralsCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        membersUsersAddReferral: async (userId: string, membersReferralsCreateRequest: MembersReferralsCreateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('membersUsersAddReferral', 'userId', userId)
            // verify required parameter 'membersReferralsCreateRequest' is not null or undefined
            assertParamExists('membersUsersAddReferral', 'membersReferralsCreateRequest', membersReferralsCreateRequest)
            const localVarPath = `/members/users/{userId}/referrals`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(membersReferralsCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint is meant to be used to submit feedback by Partner ID. Users can submit their comment and give rating by some parameters as price, weighbridge, queue, sorting, and road access. If the users has submitted feedback before, then they submit it again, it will replace the existing feedback. 
         * @summary Submit Feedback for Partner
         * @param {string} partnerId Partner UUID
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {PartnersFeedbacksCreateRequest} partnersFeedbacksCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersFeedbacksCreate: async (partnerId: string, authorization: string, partnersFeedbacksCreateRequest: PartnersFeedbacksCreateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('partnersFeedbacksCreate', 'partnerId', partnerId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('partnersFeedbacksCreate', 'authorization', authorization)
            // verify required parameter 'partnersFeedbacksCreateRequest' is not null or undefined
            assertParamExists('partnersFeedbacksCreate', 'partnersFeedbacksCreateRequest', partnersFeedbacksCreateRequest)
            const localVarPath = `/api/v1/partners/{partnerId}/feedbacks`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(partnersFeedbacksCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Surveyor will visit farm owner and do field survey. They will collect some data and also its geolocation of their farmArea. Temporary survey member and its farms data. Combined registering a member and collecting data into single json.
         * @summary Submit survey data
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {SurveyCreateRequest} surveyCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        surveyCreate: async (authorization: string, surveyCreateRequest: SurveyCreateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('surveyCreate', 'authorization', authorization)
            // verify required parameter 'surveyCreateRequest' is not null or undefined
            assertParamExists('surveyCreate', 'surveyCreateRequest', surveyCreateRequest)
            const localVarPath = `/api/v1/survey`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(surveyCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This Api is used to add worker for partner or member
         * @summary Create worker
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {WorkersCreateRequest} workersCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workersCreate: async (authorization: string, workersCreateRequest: WorkersCreateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('workersCreate', 'authorization', authorization)
            // verify required parameter 'workersCreateRequest' is not null or undefined
            assertParamExists('workersCreate', 'workersCreateRequest', workersCreateRequest)
            const localVarPath = `/api/v1/workers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workersCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This Api is used to remove worker for partner or member
         * @summary Remove Worker
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} workerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workersRemove: async (authorization: string, workerId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('workersRemove', 'authorization', authorization)
            // verify required parameter 'workerId' is not null or undefined
            assertParamExists('workersRemove', 'workerId', workerId)
            const localVarPath = `/api/v1/workers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (workerId !== undefined) {
                localVarQueryParameter['workerId'] = workerId;
            }

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This Api is used to update worker for partner or member
         * @summary Update Worker
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} workerId 
         * @param {WorkersUpdateRequest} [workersUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workersUpdate: async (authorization: string, workerId: string, workersUpdateRequest?: WorkersUpdateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('workersUpdate', 'authorization', authorization)
            // verify required parameter 'workerId' is not null or undefined
            assertParamExists('workersUpdate', 'workerId', workerId)
            const localVarPath = `/api/v1/workers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (workerId !== undefined) {
                localVarQueryParameter['workerId'] = workerId;
            }

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workersUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MembersApi - functional programming interface
 * @export
 */
export const MembersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MembersApiAxiosParamCreator(configuration)
    return {
        /**
         * This endpoint is meant to be used to submit a response for feedback that already posted about a partner mill. e.g. response about wrong feedback. 
         * @summary Submit Response of Feedback
         * @param {string} feedbackId Feedback ID, represented in UUID type 4 format
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async feedbacksReponsesCreate(feedbackId: string, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeedbacksReponseCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.feedbacksReponsesCreate(feedbackId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Used by MemberApp to get list of their(member) weighbridge, can be filter by cargo desc 
         * @summary List of weighbridge
         * @param {string} [cargoDesc] Weighbridge cargo desc
         * @param {string} [partnerName] Weighbridge partner name
         * @param {string} [yearMonth] Weighbridge date YYYY-MM format
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async membersGetWeighbridges(cargoDesc?: string, partnerName?: string, yearMonth?: string, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MembersWeighbridgesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.membersGetWeighbridges(cargoDesc, partnerName, yearMonth, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get active campaigns for the members
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async membersLoyaltyListActiveCampaigns(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MembersLoyaltyListActiveCampaignsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.membersLoyaltyListActiveCampaigns(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Member can add a friend as referrals. Used by MemberApp to add a new one. 
         * @summary Create a Referral by User
         * @param {MembersReferralsCreateRequest} [membersReferralsCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async membersReferralsCreate(membersReferralsCreateRequest?: MembersReferralsCreateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MembersReferralsCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.membersReferralsCreate(membersReferralsCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Used by MemberApp to get list of friend referrals. 
         * @summary List of friend referrals by User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async membersReferralsList(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MembersReferralsListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.membersReferralsList(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Add referrals
         * @param {string} userId 
         * @param {MembersReferralsCreateRequest} membersReferralsCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async membersUsersAddReferral(userId: string, membersReferralsCreateRequest: MembersReferralsCreateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MembersReferralsCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.membersUsersAddReferral(userId, membersReferralsCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint is meant to be used to submit feedback by Partner ID. Users can submit their comment and give rating by some parameters as price, weighbridge, queue, sorting, and road access. If the users has submitted feedback before, then they submit it again, it will replace the existing feedback. 
         * @summary Submit Feedback for Partner
         * @param {string} partnerId Partner UUID
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {PartnersFeedbacksCreateRequest} partnersFeedbacksCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partnersFeedbacksCreate(partnerId: string, authorization: string, partnersFeedbacksCreateRequest: PartnersFeedbacksCreateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnersFeedbacksCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partnersFeedbacksCreate(partnerId, authorization, partnersFeedbacksCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Surveyor will visit farm owner and do field survey. They will collect some data and also its geolocation of their farmArea. Temporary survey member and its farms data. Combined registering a member and collecting data into single json.
         * @summary Submit survey data
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {SurveyCreateRequest} surveyCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async surveyCreate(authorization: string, surveyCreateRequest: SurveyCreateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveyCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.surveyCreate(authorization, surveyCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This Api is used to add worker for partner or member
         * @summary Create worker
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {WorkersCreateRequest} workersCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workersCreate(authorization: string, workersCreateRequest: WorkersCreateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkersCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workersCreate(authorization, workersCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This Api is used to remove worker for partner or member
         * @summary Remove Worker
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} workerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workersRemove(authorization: string, workerId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkersRemoveResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workersRemove(authorization, workerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This Api is used to update worker for partner or member
         * @summary Update Worker
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} workerId 
         * @param {WorkersUpdateRequest} [workersUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workersUpdate(authorization: string, workerId: string, workersUpdateRequest?: WorkersUpdateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkersUpdateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workersUpdate(authorization, workerId, workersUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MembersApi - factory interface
 * @export
 */
export const MembersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MembersApiFp(configuration)
    return {
        /**
         * This endpoint is meant to be used to submit a response for feedback that already posted about a partner mill. e.g. response about wrong feedback. 
         * @summary Submit Response of Feedback
         * @param {string} feedbackId Feedback ID, represented in UUID type 4 format
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        feedbacksReponsesCreate(feedbackId: string, authorization: string, options?: any): AxiosPromise<FeedbacksReponseCreateResponse> {
            return localVarFp.feedbacksReponsesCreate(feedbackId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Used by MemberApp to get list of their(member) weighbridge, can be filter by cargo desc 
         * @summary List of weighbridge
         * @param {string} [cargoDesc] Weighbridge cargo desc
         * @param {string} [partnerName] Weighbridge partner name
         * @param {string} [yearMonth] Weighbridge date YYYY-MM format
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        membersGetWeighbridges(cargoDesc?: string, partnerName?: string, yearMonth?: string, page?: number, limit?: number, options?: any): AxiosPromise<MembersWeighbridgesResponse> {
            return localVarFp.membersGetWeighbridges(cargoDesc, partnerName, yearMonth, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get active campaigns for the members
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        membersLoyaltyListActiveCampaigns(options?: any): AxiosPromise<MembersLoyaltyListActiveCampaignsResponse> {
            return localVarFp.membersLoyaltyListActiveCampaigns(options).then((request) => request(axios, basePath));
        },
        /**
         * Member can add a friend as referrals. Used by MemberApp to add a new one. 
         * @summary Create a Referral by User
         * @param {MembersReferralsCreateRequest} [membersReferralsCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        membersReferralsCreate(membersReferralsCreateRequest?: MembersReferralsCreateRequest, options?: any): AxiosPromise<MembersReferralsCreateResponse> {
            return localVarFp.membersReferralsCreate(membersReferralsCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Used by MemberApp to get list of friend referrals. 
         * @summary List of friend referrals by User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        membersReferralsList(options?: any): AxiosPromise<MembersReferralsListResponse> {
            return localVarFp.membersReferralsList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add referrals
         * @param {string} userId 
         * @param {MembersReferralsCreateRequest} membersReferralsCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        membersUsersAddReferral(userId: string, membersReferralsCreateRequest: MembersReferralsCreateRequest, options?: any): AxiosPromise<MembersReferralsCreateResponse> {
            return localVarFp.membersUsersAddReferral(userId, membersReferralsCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint is meant to be used to submit feedback by Partner ID. Users can submit their comment and give rating by some parameters as price, weighbridge, queue, sorting, and road access. If the users has submitted feedback before, then they submit it again, it will replace the existing feedback. 
         * @summary Submit Feedback for Partner
         * @param {string} partnerId Partner UUID
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {PartnersFeedbacksCreateRequest} partnersFeedbacksCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersFeedbacksCreate(partnerId: string, authorization: string, partnersFeedbacksCreateRequest: PartnersFeedbacksCreateRequest, options?: any): AxiosPromise<PartnersFeedbacksCreateResponse> {
            return localVarFp.partnersFeedbacksCreate(partnerId, authorization, partnersFeedbacksCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Surveyor will visit farm owner and do field survey. They will collect some data and also its geolocation of their farmArea. Temporary survey member and its farms data. Combined registering a member and collecting data into single json.
         * @summary Submit survey data
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {SurveyCreateRequest} surveyCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        surveyCreate(authorization: string, surveyCreateRequest: SurveyCreateRequest, options?: any): AxiosPromise<SurveyCreateResponse> {
            return localVarFp.surveyCreate(authorization, surveyCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This Api is used to add worker for partner or member
         * @summary Create worker
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {WorkersCreateRequest} workersCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workersCreate(authorization: string, workersCreateRequest: WorkersCreateRequest, options?: any): AxiosPromise<WorkersCreateResponse> {
            return localVarFp.workersCreate(authorization, workersCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This Api is used to remove worker for partner or member
         * @summary Remove Worker
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} workerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workersRemove(authorization: string, workerId: string, options?: any): AxiosPromise<WorkersRemoveResponse> {
            return localVarFp.workersRemove(authorization, workerId, options).then((request) => request(axios, basePath));
        },
        /**
         * This Api is used to update worker for partner or member
         * @summary Update Worker
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} workerId 
         * @param {WorkersUpdateRequest} [workersUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workersUpdate(authorization: string, workerId: string, workersUpdateRequest?: WorkersUpdateRequest, options?: any): AxiosPromise<WorkersUpdateResponse> {
            return localVarFp.workersUpdate(authorization, workerId, workersUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MembersApi - object-oriented interface
 * @export
 * @class MembersApi
 * @extends {BaseAPI}
 */
export class MembersApi extends BaseAPI {
    /**
     * This endpoint is meant to be used to submit a response for feedback that already posted about a partner mill. e.g. response about wrong feedback. 
     * @summary Submit Response of Feedback
     * @param {string} feedbackId Feedback ID, represented in UUID type 4 format
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembersApi
     */
    public feedbacksReponsesCreate(feedbackId: string, authorization: string, options?: AxiosRequestConfig) {
        return MembersApiFp(this.configuration).feedbacksReponsesCreate(feedbackId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Used by MemberApp to get list of their(member) weighbridge, can be filter by cargo desc 
     * @summary List of weighbridge
     * @param {string} [cargoDesc] Weighbridge cargo desc
     * @param {string} [partnerName] Weighbridge partner name
     * @param {string} [yearMonth] Weighbridge date YYYY-MM format
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembersApi
     */
    public membersGetWeighbridges(cargoDesc?: string, partnerName?: string, yearMonth?: string, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return MembersApiFp(this.configuration).membersGetWeighbridges(cargoDesc, partnerName, yearMonth, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get active campaigns for the members
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembersApi
     */
    public membersLoyaltyListActiveCampaigns(options?: AxiosRequestConfig) {
        return MembersApiFp(this.configuration).membersLoyaltyListActiveCampaigns(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Member can add a friend as referrals. Used by MemberApp to add a new one. 
     * @summary Create a Referral by User
     * @param {MembersReferralsCreateRequest} [membersReferralsCreateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembersApi
     */
    public membersReferralsCreate(membersReferralsCreateRequest?: MembersReferralsCreateRequest, options?: AxiosRequestConfig) {
        return MembersApiFp(this.configuration).membersReferralsCreate(membersReferralsCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Used by MemberApp to get list of friend referrals. 
     * @summary List of friend referrals by User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembersApi
     */
    public membersReferralsList(options?: AxiosRequestConfig) {
        return MembersApiFp(this.configuration).membersReferralsList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add referrals
     * @param {string} userId 
     * @param {MembersReferralsCreateRequest} membersReferralsCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembersApi
     */
    public membersUsersAddReferral(userId: string, membersReferralsCreateRequest: MembersReferralsCreateRequest, options?: AxiosRequestConfig) {
        return MembersApiFp(this.configuration).membersUsersAddReferral(userId, membersReferralsCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint is meant to be used to submit feedback by Partner ID. Users can submit their comment and give rating by some parameters as price, weighbridge, queue, sorting, and road access. If the users has submitted feedback before, then they submit it again, it will replace the existing feedback. 
     * @summary Submit Feedback for Partner
     * @param {string} partnerId Partner UUID
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {PartnersFeedbacksCreateRequest} partnersFeedbacksCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembersApi
     */
    public partnersFeedbacksCreate(partnerId: string, authorization: string, partnersFeedbacksCreateRequest: PartnersFeedbacksCreateRequest, options?: AxiosRequestConfig) {
        return MembersApiFp(this.configuration).partnersFeedbacksCreate(partnerId, authorization, partnersFeedbacksCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Surveyor will visit farm owner and do field survey. They will collect some data and also its geolocation of their farmArea. Temporary survey member and its farms data. Combined registering a member and collecting data into single json.
     * @summary Submit survey data
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {SurveyCreateRequest} surveyCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembersApi
     */
    public surveyCreate(authorization: string, surveyCreateRequest: SurveyCreateRequest, options?: AxiosRequestConfig) {
        return MembersApiFp(this.configuration).surveyCreate(authorization, surveyCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This Api is used to add worker for partner or member
     * @summary Create worker
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {WorkersCreateRequest} workersCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembersApi
     */
    public workersCreate(authorization: string, workersCreateRequest: WorkersCreateRequest, options?: AxiosRequestConfig) {
        return MembersApiFp(this.configuration).workersCreate(authorization, workersCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This Api is used to remove worker for partner or member
     * @summary Remove Worker
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {string} workerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembersApi
     */
    public workersRemove(authorization: string, workerId: string, options?: AxiosRequestConfig) {
        return MembersApiFp(this.configuration).workersRemove(authorization, workerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This Api is used to update worker for partner or member
     * @summary Update Worker
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {string} workerId 
     * @param {WorkersUpdateRequest} [workersUpdateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembersApi
     */
    public workersUpdate(authorization: string, workerId: string, workersUpdateRequest?: WorkersUpdateRequest, options?: AxiosRequestConfig) {
        return MembersApiFp(this.configuration).workersUpdate(authorization, workerId, workersUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MessagingApi - axios parameter creator
 * @export
 */
export const MessagingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This endpoint allows us to create a new conversation or retrieve an  existing one. It requires a parameter specifying the type of  conversation to create - such as bot, customer support, 1-1 private,  multi-user, or group/community chat.  Additional parameters are then needed, for instance, the recipient\'s  user ID for a 1-1 private conversation, or the group ID for a group  conversation.  If the conversation exists, this will create a new  conversation. This API accepts user\'s JWT for authenticated user or device ID in the header for unauthenticated user. 
         * @summary Create new or get existing chat conversation.
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {MessagingChatConversationsCreateOrGetRequest} messagingChatConversationsCreateOrGetRequest 
         * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingChatConversationsCreateOrGet: async (aPPTYPE: AppTypeEnum, messagingChatConversationsCreateOrGetRequest: MessagingChatConversationsCreateOrGetRequest, xFIREBASEINSTALLATIONID?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('messagingChatConversationsCreateOrGet', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'messagingChatConversationsCreateOrGetRequest' is not null or undefined
            assertParamExists('messagingChatConversationsCreateOrGet', 'messagingChatConversationsCreateOrGetRequest', messagingChatConversationsCreateOrGetRequest)
            const localVarPath = `/api/v1/messaging/chat/conversations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }

            if (xFIREBASEINSTALLATIONID != null) {
                localVarHeaderParameter['X-FIREBASE-INSTALLATION-ID'] = String(xFIREBASEINSTALLATIONID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(messagingChatConversationsCreateOrGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This API is used to get list of recent chat conversation. This API accepts user\'s JWT for authenticated user or device ID in the header for unauthenticated user. 
         * @summary List of recent chat conversation.
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {number} [since] The timestamp to start the list of messages from.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingChatConversationsList: async (aPPTYPE: AppTypeEnum, xFIREBASEINSTALLATIONID?: string, page?: number, limit?: number, since?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('messagingChatConversationsList', 'aPPTYPE', aPPTYPE)
            const localVarPath = `/api/v1/messaging/chat/conversations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (since !== undefined) {
                localVarQueryParameter['since'] = since;
            }

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }

            if (xFIREBASEINSTALLATIONID != null) {
                localVarHeaderParameter['X-FIREBASE-INSTALLATION-ID'] = String(xFIREBASEINSTALLATIONID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This API is used to create a new chat message in a conversation. This API accepts user\'s JWT for authenticated user or device ID in the header for unauthenticated user. 
         * @summary Create a new chat message in a conversation.
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} conversationId Chat conversation UUID
         * @param {MessagingChatConversationsMessagesCreateRequest} messagingChatConversationsMessagesCreateRequest 
         * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingChatConversationsMessagesCreate: async (aPPTYPE: AppTypeEnum, conversationId: string, messagingChatConversationsMessagesCreateRequest: MessagingChatConversationsMessagesCreateRequest, xFIREBASEINSTALLATIONID?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('messagingChatConversationsMessagesCreate', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('messagingChatConversationsMessagesCreate', 'conversationId', conversationId)
            // verify required parameter 'messagingChatConversationsMessagesCreateRequest' is not null or undefined
            assertParamExists('messagingChatConversationsMessagesCreate', 'messagingChatConversationsMessagesCreateRequest', messagingChatConversationsMessagesCreateRequest)
            const localVarPath = `/api/v1/messaging/chat/conversations/{conversationId}/messages`
                .replace(`{${"conversationId"}}`, encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }

            if (xFIREBASEINSTALLATIONID != null) {
                localVarHeaderParameter['X-FIREBASE-INSTALLATION-ID'] = String(xFIREBASEINSTALLATIONID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(messagingChatConversationsMessagesCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This API is used to get list of recent chat messages in a conversation.  This API accepts user\'s JWT for authenticated user or device ID in the  header for unauthenticated user. 
         * @summary List of recent chat messages in a conversation.
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} conversationId Chat conversation UUID
         * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {number} [since] The timestamp to start the list of messages from.
         * @param {number} [until] The timestamp to end the list of messages returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingChatConversationsMessagesList: async (aPPTYPE: AppTypeEnum, conversationId: string, xFIREBASEINSTALLATIONID?: string, page?: number, limit?: number, since?: number, until?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('messagingChatConversationsMessagesList', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('messagingChatConversationsMessagesList', 'conversationId', conversationId)
            const localVarPath = `/api/v1/messaging/chat/conversations/{conversationId}/messages`
                .replace(`{${"conversationId"}}`, encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (since !== undefined) {
                localVarQueryParameter['since'] = since;
            }

            if (until !== undefined) {
                localVarQueryParameter['until'] = until;
            }

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }

            if (xFIREBASEINSTALLATIONID != null) {
                localVarHeaderParameter['X-FIREBASE-INSTALLATION-ID'] = String(xFIREBASEINSTALLATIONID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This API is used to post offline messages. This API accepts JWT for authenticated user or device ID in the header for unauthenticated user. 
         * @summary Post offline messages for synchronization
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} conversationId Chat conversation UUID
         * @param {MessagingChatConversationsPostOfflineMessagesRequest} messagingChatConversationsPostOfflineMessagesRequest 
         * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingChatConversationsPostOfflineMessages: async (aPPTYPE: AppTypeEnum, conversationId: string, messagingChatConversationsPostOfflineMessagesRequest: MessagingChatConversationsPostOfflineMessagesRequest, xFIREBASEINSTALLATIONID?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('messagingChatConversationsPostOfflineMessages', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('messagingChatConversationsPostOfflineMessages', 'conversationId', conversationId)
            // verify required parameter 'messagingChatConversationsPostOfflineMessagesRequest' is not null or undefined
            assertParamExists('messagingChatConversationsPostOfflineMessages', 'messagingChatConversationsPostOfflineMessagesRequest', messagingChatConversationsPostOfflineMessagesRequest)
            const localVarPath = `/api/v1/messaging/chat/conversations/{conversationId}/messages/offline`
                .replace(`{${"conversationId"}}`, encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }

            if (xFIREBASEINSTALLATIONID != null) {
                localVarHeaderParameter['X-FIREBASE-INSTALLATION-ID'] = String(xFIREBASEINSTALLATIONID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(messagingChatConversationsPostOfflineMessagesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Websocket stream. This will allow app to send message and receive new  messages without the overhead of new HTTP connection request. This  endpoint will receive 1 query parameter stream ID.  This endpoint accepts user\'s JWT for authenticated user or device ID in the header for unauthenticated user. 
         * @summary Provides websocket path for streaming chat conversation.
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} streamId Stream ID
         * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingChatConversationsStream: async (aPPTYPE: AppTypeEnum, streamId: string, xFIREBASEINSTALLATIONID?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('messagingChatConversationsStream', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'streamId' is not null or undefined
            assertParamExists('messagingChatConversationsStream', 'streamId', streamId)
            const localVarPath = `/api/v1/messaging/chat/conversations/stream`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (streamId !== undefined) {
                localVarQueryParameter['streamId'] = streamId;
            }

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }

            if (xFIREBASEINSTALLATIONID != null) {
                localVarHeaderParameter['X-FIREBASE-INSTALLATION-ID'] = String(xFIREBASEINSTALLATIONID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This API is used to create a new chat websocket stream for a  conversation. This will return the URL of the stream.  We will return the URL instead of the stream ID so in the future we  have the flexibility on separating the engine for better performance. This API accepts user\'s JWT for authenticated user or device ID in the  header for unauthenticated user. 
         * @summary Create a new chat stream in a conversation.
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} conversationId Chat conversation UUID
         * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingChatConversationsStreamCreate: async (aPPTYPE: AppTypeEnum, conversationId: string, xFIREBASEINSTALLATIONID?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('messagingChatConversationsStreamCreate', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('messagingChatConversationsStreamCreate', 'conversationId', conversationId)
            const localVarPath = `/api/v1/messaging/chat/conversations/{conversationId}/stream`
                .replace(`{${"conversationId"}}`, encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }

            if (xFIREBASEINSTALLATIONID != null) {
                localVarHeaderParameter['X-FIREBASE-INSTALLATION-ID'] = String(xFIREBASEINSTALLATIONID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MessagingApi - functional programming interface
 * @export
 */
export const MessagingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MessagingApiAxiosParamCreator(configuration)
    return {
        /**
         * This endpoint allows us to create a new conversation or retrieve an  existing one. It requires a parameter specifying the type of  conversation to create - such as bot, customer support, 1-1 private,  multi-user, or group/community chat.  Additional parameters are then needed, for instance, the recipient\'s  user ID for a 1-1 private conversation, or the group ID for a group  conversation.  If the conversation exists, this will create a new  conversation. This API accepts user\'s JWT for authenticated user or device ID in the header for unauthenticated user. 
         * @summary Create new or get existing chat conversation.
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {MessagingChatConversationsCreateOrGetRequest} messagingChatConversationsCreateOrGetRequest 
         * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async messagingChatConversationsCreateOrGet(aPPTYPE: AppTypeEnum, messagingChatConversationsCreateOrGetRequest: MessagingChatConversationsCreateOrGetRequest, xFIREBASEINSTALLATIONID?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessagingChatConversation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.messagingChatConversationsCreateOrGet(aPPTYPE, messagingChatConversationsCreateOrGetRequest, xFIREBASEINSTALLATIONID, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This API is used to get list of recent chat conversation. This API accepts user\'s JWT for authenticated user or device ID in the header for unauthenticated user. 
         * @summary List of recent chat conversation.
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {number} [since] The timestamp to start the list of messages from.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async messagingChatConversationsList(aPPTYPE: AppTypeEnum, xFIREBASEINSTALLATIONID?: string, page?: number, limit?: number, since?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessagingChatConversationsListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.messagingChatConversationsList(aPPTYPE, xFIREBASEINSTALLATIONID, page, limit, since, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This API is used to create a new chat message in a conversation. This API accepts user\'s JWT for authenticated user or device ID in the header for unauthenticated user. 
         * @summary Create a new chat message in a conversation.
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} conversationId Chat conversation UUID
         * @param {MessagingChatConversationsMessagesCreateRequest} messagingChatConversationsMessagesCreateRequest 
         * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async messagingChatConversationsMessagesCreate(aPPTYPE: AppTypeEnum, conversationId: string, messagingChatConversationsMessagesCreateRequest: MessagingChatConversationsMessagesCreateRequest, xFIREBASEINSTALLATIONID?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessagingChatMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.messagingChatConversationsMessagesCreate(aPPTYPE, conversationId, messagingChatConversationsMessagesCreateRequest, xFIREBASEINSTALLATIONID, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This API is used to get list of recent chat messages in a conversation.  This API accepts user\'s JWT for authenticated user or device ID in the  header for unauthenticated user. 
         * @summary List of recent chat messages in a conversation.
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} conversationId Chat conversation UUID
         * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {number} [since] The timestamp to start the list of messages from.
         * @param {number} [until] The timestamp to end the list of messages returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async messagingChatConversationsMessagesList(aPPTYPE: AppTypeEnum, conversationId: string, xFIREBASEINSTALLATIONID?: string, page?: number, limit?: number, since?: number, until?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessagingChatConversationsMessagesListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.messagingChatConversationsMessagesList(aPPTYPE, conversationId, xFIREBASEINSTALLATIONID, page, limit, since, until, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This API is used to post offline messages. This API accepts JWT for authenticated user or device ID in the header for unauthenticated user. 
         * @summary Post offline messages for synchronization
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} conversationId Chat conversation UUID
         * @param {MessagingChatConversationsPostOfflineMessagesRequest} messagingChatConversationsPostOfflineMessagesRequest 
         * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async messagingChatConversationsPostOfflineMessages(aPPTYPE: AppTypeEnum, conversationId: string, messagingChatConversationsPostOfflineMessagesRequest: MessagingChatConversationsPostOfflineMessagesRequest, xFIREBASEINSTALLATIONID?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessagingChatConversationsPostOfflineMessagesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.messagingChatConversationsPostOfflineMessages(aPPTYPE, conversationId, messagingChatConversationsPostOfflineMessagesRequest, xFIREBASEINSTALLATIONID, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Websocket stream. This will allow app to send message and receive new  messages without the overhead of new HTTP connection request. This  endpoint will receive 1 query parameter stream ID.  This endpoint accepts user\'s JWT for authenticated user or device ID in the header for unauthenticated user. 
         * @summary Provides websocket path for streaming chat conversation.
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} streamId Stream ID
         * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async messagingChatConversationsStream(aPPTYPE: AppTypeEnum, streamId: string, xFIREBASEINSTALLATIONID?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.messagingChatConversationsStream(aPPTYPE, streamId, xFIREBASEINSTALLATIONID, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This API is used to create a new chat websocket stream for a  conversation. This will return the URL of the stream.  We will return the URL instead of the stream ID so in the future we  have the flexibility on separating the engine for better performance. This API accepts user\'s JWT for authenticated user or device ID in the  header for unauthenticated user. 
         * @summary Create a new chat stream in a conversation.
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} conversationId Chat conversation UUID
         * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async messagingChatConversationsStreamCreate(aPPTYPE: AppTypeEnum, conversationId: string, xFIREBASEINSTALLATIONID?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessagingChatConversationsStreamCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.messagingChatConversationsStreamCreate(aPPTYPE, conversationId, xFIREBASEINSTALLATIONID, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MessagingApi - factory interface
 * @export
 */
export const MessagingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MessagingApiFp(configuration)
    return {
        /**
         * This endpoint allows us to create a new conversation or retrieve an  existing one. It requires a parameter specifying the type of  conversation to create - such as bot, customer support, 1-1 private,  multi-user, or group/community chat.  Additional parameters are then needed, for instance, the recipient\'s  user ID for a 1-1 private conversation, or the group ID for a group  conversation.  If the conversation exists, this will create a new  conversation. This API accepts user\'s JWT for authenticated user or device ID in the header for unauthenticated user. 
         * @summary Create new or get existing chat conversation.
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {MessagingChatConversationsCreateOrGetRequest} messagingChatConversationsCreateOrGetRequest 
         * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingChatConversationsCreateOrGet(aPPTYPE: AppTypeEnum, messagingChatConversationsCreateOrGetRequest: MessagingChatConversationsCreateOrGetRequest, xFIREBASEINSTALLATIONID?: string, options?: any): AxiosPromise<MessagingChatConversation> {
            return localVarFp.messagingChatConversationsCreateOrGet(aPPTYPE, messagingChatConversationsCreateOrGetRequest, xFIREBASEINSTALLATIONID, options).then((request) => request(axios, basePath));
        },
        /**
         * This API is used to get list of recent chat conversation. This API accepts user\'s JWT for authenticated user or device ID in the header for unauthenticated user. 
         * @summary List of recent chat conversation.
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {number} [since] The timestamp to start the list of messages from.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingChatConversationsList(aPPTYPE: AppTypeEnum, xFIREBASEINSTALLATIONID?: string, page?: number, limit?: number, since?: number, options?: any): AxiosPromise<MessagingChatConversationsListResponse> {
            return localVarFp.messagingChatConversationsList(aPPTYPE, xFIREBASEINSTALLATIONID, page, limit, since, options).then((request) => request(axios, basePath));
        },
        /**
         * This API is used to create a new chat message in a conversation. This API accepts user\'s JWT for authenticated user or device ID in the header for unauthenticated user. 
         * @summary Create a new chat message in a conversation.
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} conversationId Chat conversation UUID
         * @param {MessagingChatConversationsMessagesCreateRequest} messagingChatConversationsMessagesCreateRequest 
         * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingChatConversationsMessagesCreate(aPPTYPE: AppTypeEnum, conversationId: string, messagingChatConversationsMessagesCreateRequest: MessagingChatConversationsMessagesCreateRequest, xFIREBASEINSTALLATIONID?: string, options?: any): AxiosPromise<MessagingChatMessage> {
            return localVarFp.messagingChatConversationsMessagesCreate(aPPTYPE, conversationId, messagingChatConversationsMessagesCreateRequest, xFIREBASEINSTALLATIONID, options).then((request) => request(axios, basePath));
        },
        /**
         * This API is used to get list of recent chat messages in a conversation.  This API accepts user\'s JWT for authenticated user or device ID in the  header for unauthenticated user. 
         * @summary List of recent chat messages in a conversation.
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} conversationId Chat conversation UUID
         * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {number} [since] The timestamp to start the list of messages from.
         * @param {number} [until] The timestamp to end the list of messages returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingChatConversationsMessagesList(aPPTYPE: AppTypeEnum, conversationId: string, xFIREBASEINSTALLATIONID?: string, page?: number, limit?: number, since?: number, until?: number, options?: any): AxiosPromise<MessagingChatConversationsMessagesListResponse> {
            return localVarFp.messagingChatConversationsMessagesList(aPPTYPE, conversationId, xFIREBASEINSTALLATIONID, page, limit, since, until, options).then((request) => request(axios, basePath));
        },
        /**
         * This API is used to post offline messages. This API accepts JWT for authenticated user or device ID in the header for unauthenticated user. 
         * @summary Post offline messages for synchronization
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} conversationId Chat conversation UUID
         * @param {MessagingChatConversationsPostOfflineMessagesRequest} messagingChatConversationsPostOfflineMessagesRequest 
         * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingChatConversationsPostOfflineMessages(aPPTYPE: AppTypeEnum, conversationId: string, messagingChatConversationsPostOfflineMessagesRequest: MessagingChatConversationsPostOfflineMessagesRequest, xFIREBASEINSTALLATIONID?: string, options?: any): AxiosPromise<MessagingChatConversationsPostOfflineMessagesResponse> {
            return localVarFp.messagingChatConversationsPostOfflineMessages(aPPTYPE, conversationId, messagingChatConversationsPostOfflineMessagesRequest, xFIREBASEINSTALLATIONID, options).then((request) => request(axios, basePath));
        },
        /**
         * Websocket stream. This will allow app to send message and receive new  messages without the overhead of new HTTP connection request. This  endpoint will receive 1 query parameter stream ID.  This endpoint accepts user\'s JWT for authenticated user or device ID in the header for unauthenticated user. 
         * @summary Provides websocket path for streaming chat conversation.
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} streamId Stream ID
         * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingChatConversationsStream(aPPTYPE: AppTypeEnum, streamId: string, xFIREBASEINSTALLATIONID?: string, options?: any): AxiosPromise<object> {
            return localVarFp.messagingChatConversationsStream(aPPTYPE, streamId, xFIREBASEINSTALLATIONID, options).then((request) => request(axios, basePath));
        },
        /**
         * This API is used to create a new chat websocket stream for a  conversation. This will return the URL of the stream.  We will return the URL instead of the stream ID so in the future we  have the flexibility on separating the engine for better performance. This API accepts user\'s JWT for authenticated user or device ID in the  header for unauthenticated user. 
         * @summary Create a new chat stream in a conversation.
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} conversationId Chat conversation UUID
         * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingChatConversationsStreamCreate(aPPTYPE: AppTypeEnum, conversationId: string, xFIREBASEINSTALLATIONID?: string, options?: any): AxiosPromise<MessagingChatConversationsStreamCreateResponse> {
            return localVarFp.messagingChatConversationsStreamCreate(aPPTYPE, conversationId, xFIREBASEINSTALLATIONID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MessagingApi - object-oriented interface
 * @export
 * @class MessagingApi
 * @extends {BaseAPI}
 */
export class MessagingApi extends BaseAPI {
    /**
     * This endpoint allows us to create a new conversation or retrieve an  existing one. It requires a parameter specifying the type of  conversation to create - such as bot, customer support, 1-1 private,  multi-user, or group/community chat.  Additional parameters are then needed, for instance, the recipient\'s  user ID for a 1-1 private conversation, or the group ID for a group  conversation.  If the conversation exists, this will create a new  conversation. This API accepts user\'s JWT for authenticated user or device ID in the header for unauthenticated user. 
     * @summary Create new or get existing chat conversation.
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {MessagingChatConversationsCreateOrGetRequest} messagingChatConversationsCreateOrGetRequest 
     * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessagingApi
     */
    public messagingChatConversationsCreateOrGet(aPPTYPE: AppTypeEnum, messagingChatConversationsCreateOrGetRequest: MessagingChatConversationsCreateOrGetRequest, xFIREBASEINSTALLATIONID?: string, options?: AxiosRequestConfig) {
        return MessagingApiFp(this.configuration).messagingChatConversationsCreateOrGet(aPPTYPE, messagingChatConversationsCreateOrGetRequest, xFIREBASEINSTALLATIONID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This API is used to get list of recent chat conversation. This API accepts user\'s JWT for authenticated user or device ID in the header for unauthenticated user. 
     * @summary List of recent chat conversation.
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {number} [since] The timestamp to start the list of messages from.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessagingApi
     */
    public messagingChatConversationsList(aPPTYPE: AppTypeEnum, xFIREBASEINSTALLATIONID?: string, page?: number, limit?: number, since?: number, options?: AxiosRequestConfig) {
        return MessagingApiFp(this.configuration).messagingChatConversationsList(aPPTYPE, xFIREBASEINSTALLATIONID, page, limit, since, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This API is used to create a new chat message in a conversation. This API accepts user\'s JWT for authenticated user or device ID in the header for unauthenticated user. 
     * @summary Create a new chat message in a conversation.
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} conversationId Chat conversation UUID
     * @param {MessagingChatConversationsMessagesCreateRequest} messagingChatConversationsMessagesCreateRequest 
     * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessagingApi
     */
    public messagingChatConversationsMessagesCreate(aPPTYPE: AppTypeEnum, conversationId: string, messagingChatConversationsMessagesCreateRequest: MessagingChatConversationsMessagesCreateRequest, xFIREBASEINSTALLATIONID?: string, options?: AxiosRequestConfig) {
        return MessagingApiFp(this.configuration).messagingChatConversationsMessagesCreate(aPPTYPE, conversationId, messagingChatConversationsMessagesCreateRequest, xFIREBASEINSTALLATIONID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This API is used to get list of recent chat messages in a conversation.  This API accepts user\'s JWT for authenticated user or device ID in the  header for unauthenticated user. 
     * @summary List of recent chat messages in a conversation.
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} conversationId Chat conversation UUID
     * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {number} [since] The timestamp to start the list of messages from.
     * @param {number} [until] The timestamp to end the list of messages returned.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessagingApi
     */
    public messagingChatConversationsMessagesList(aPPTYPE: AppTypeEnum, conversationId: string, xFIREBASEINSTALLATIONID?: string, page?: number, limit?: number, since?: number, until?: number, options?: AxiosRequestConfig) {
        return MessagingApiFp(this.configuration).messagingChatConversationsMessagesList(aPPTYPE, conversationId, xFIREBASEINSTALLATIONID, page, limit, since, until, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This API is used to post offline messages. This API accepts JWT for authenticated user or device ID in the header for unauthenticated user. 
     * @summary Post offline messages for synchronization
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} conversationId Chat conversation UUID
     * @param {MessagingChatConversationsPostOfflineMessagesRequest} messagingChatConversationsPostOfflineMessagesRequest 
     * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessagingApi
     */
    public messagingChatConversationsPostOfflineMessages(aPPTYPE: AppTypeEnum, conversationId: string, messagingChatConversationsPostOfflineMessagesRequest: MessagingChatConversationsPostOfflineMessagesRequest, xFIREBASEINSTALLATIONID?: string, options?: AxiosRequestConfig) {
        return MessagingApiFp(this.configuration).messagingChatConversationsPostOfflineMessages(aPPTYPE, conversationId, messagingChatConversationsPostOfflineMessagesRequest, xFIREBASEINSTALLATIONID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Websocket stream. This will allow app to send message and receive new  messages without the overhead of new HTTP connection request. This  endpoint will receive 1 query parameter stream ID.  This endpoint accepts user\'s JWT for authenticated user or device ID in the header for unauthenticated user. 
     * @summary Provides websocket path for streaming chat conversation.
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} streamId Stream ID
     * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessagingApi
     */
    public messagingChatConversationsStream(aPPTYPE: AppTypeEnum, streamId: string, xFIREBASEINSTALLATIONID?: string, options?: AxiosRequestConfig) {
        return MessagingApiFp(this.configuration).messagingChatConversationsStream(aPPTYPE, streamId, xFIREBASEINSTALLATIONID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This API is used to create a new chat websocket stream for a  conversation. This will return the URL of the stream.  We will return the URL instead of the stream ID so in the future we  have the flexibility on separating the engine for better performance. This API accepts user\'s JWT for authenticated user or device ID in the  header for unauthenticated user. 
     * @summary Create a new chat stream in a conversation.
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} conversationId Chat conversation UUID
     * @param {string} [xFIREBASEINSTALLATIONID] &#x60;X-FIREBASE-INSTALLATION-ID&#x60; could be used as device identifier to handle non-login API requests. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessagingApi
     */
    public messagingChatConversationsStreamCreate(aPPTYPE: AppTypeEnum, conversationId: string, xFIREBASEINSTALLATIONID?: string, options?: AxiosRequestConfig) {
        return MessagingApiFp(this.configuration).messagingChatConversationsStreamCreate(aPPTYPE, conversationId, xFIREBASEINSTALLATIONID, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MillsApi - axios parameter creator
 * @export
 */
export const MillsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This endpoint will return list of mill
         * @summary List Mills
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} [name] 
         * @param {boolean} [isPartner] 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMills: async (aPPTYPE: AppTypeEnum, name?: string, isPartner?: boolean, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('getMills', 'aPPTYPE', aPPTYPE)
            const localVarPath = `/api/v1/mills`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (isPartner !== undefined) {
                localVarQueryParameter['isPartner'] = isPartner;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MillsApi - functional programming interface
 * @export
 */
export const MillsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MillsApiAxiosParamCreator(configuration)
    return {
        /**
         * This endpoint will return list of mill
         * @summary List Mills
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} [name] 
         * @param {boolean} [isPartner] 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMills(aPPTYPE: AppTypeEnum, name?: string, isPartner?: boolean, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MillsGetResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMills(aPPTYPE, name, isPartner, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MillsApi - factory interface
 * @export
 */
export const MillsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MillsApiFp(configuration)
    return {
        /**
         * This endpoint will return list of mill
         * @summary List Mills
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} [name] 
         * @param {boolean} [isPartner] 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMills(aPPTYPE: AppTypeEnum, name?: string, isPartner?: boolean, page?: number, limit?: number, options?: any): AxiosPromise<MillsGetResponse> {
            return localVarFp.getMills(aPPTYPE, name, isPartner, page, limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MillsApi - object-oriented interface
 * @export
 * @class MillsApi
 * @extends {BaseAPI}
 */
export class MillsApi extends BaseAPI {
    /**
     * This endpoint will return list of mill
     * @summary List Mills
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} [name] 
     * @param {boolean} [isPartner] 
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MillsApi
     */
    public getMills(aPPTYPE: AppTypeEnum, name?: string, isPartner?: boolean, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return MillsApiFp(this.configuration).getMills(aPPTYPE, name, isPartner, page, limit, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * NotificationsApi - axios parameter creator
 * @export
 */
export const NotificationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Used by marketing to blast custom notification to user
         * @summary create custom notification
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {NotificationCreateRequest} notificationCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationCreate: async (authorization: string, notificationCreateRequest: NotificationCreateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('notificationCreate', 'authorization', authorization)
            // verify required parameter 'notificationCreateRequest' is not null or undefined
            assertParamExists('notificationCreate', 'notificationCreateRequest', notificationCreateRequest)
            const localVarPath = `/api/v1/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notificationCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Used by Member and Worker App to get list notification of current user
         * @summary List Notifications
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationList: async (authorization: string, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('notificationList', 'authorization', authorization)
            const localVarPath = `/api/v1/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Used by Member and Worker App to get details of a notification
         * @summary Notifications Detail
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} notificationId notification type UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationsGetDetail: async (authorization: string, notificationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('notificationsGetDetail', 'authorization', authorization)
            // verify required parameter 'notificationId' is not null or undefined
            assertParamExists('notificationsGetDetail', 'notificationId', notificationId)
            const localVarPath = `/api/v1/notifications/{notificationId}`
                .replace(`{${"notificationId"}}`, encodeURIComponent(String(notificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationsApi - functional programming interface
 * @export
 */
export const NotificationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationsApiAxiosParamCreator(configuration)
    return {
        /**
         * Used by marketing to blast custom notification to user
         * @summary create custom notification
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {NotificationCreateRequest} notificationCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationCreate(authorization: string, notificationCreateRequest: NotificationCreateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationCreate(authorization, notificationCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Used by Member and Worker App to get list notification of current user
         * @summary List Notifications
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationList(authorization: string, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationList(authorization, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Used by Member and Worker App to get details of a notification
         * @summary Notifications Detail
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} notificationId notification type UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationsGetDetail(authorization: string, notificationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationsGetDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationsGetDetail(authorization, notificationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * NotificationsApi - factory interface
 * @export
 */
export const NotificationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationsApiFp(configuration)
    return {
        /**
         * Used by marketing to blast custom notification to user
         * @summary create custom notification
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {NotificationCreateRequest} notificationCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationCreate(authorization: string, notificationCreateRequest: NotificationCreateRequest, options?: any): AxiosPromise<NotificationCreateResponse> {
            return localVarFp.notificationCreate(authorization, notificationCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Used by Member and Worker App to get list notification of current user
         * @summary List Notifications
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationList(authorization: string, page?: number, limit?: number, options?: any): AxiosPromise<NotificationListResponse> {
            return localVarFp.notificationList(authorization, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Used by Member and Worker App to get details of a notification
         * @summary Notifications Detail
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} notificationId notification type UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationsGetDetail(authorization: string, notificationId: string, options?: any): AxiosPromise<NotificationsGetDetailResponse> {
            return localVarFp.notificationsGetDetail(authorization, notificationId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotificationsApi - object-oriented interface
 * @export
 * @class NotificationsApi
 * @extends {BaseAPI}
 */
export class NotificationsApi extends BaseAPI {
    /**
     * Used by marketing to blast custom notification to user
     * @summary create custom notification
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {NotificationCreateRequest} notificationCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public notificationCreate(authorization: string, notificationCreateRequest: NotificationCreateRequest, options?: AxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).notificationCreate(authorization, notificationCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Used by Member and Worker App to get list notification of current user
     * @summary List Notifications
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public notificationList(authorization: string, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).notificationList(authorization, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Used by Member and Worker App to get details of a notification
     * @summary Notifications Detail
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {string} notificationId notification type UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public notificationsGetDetail(authorization: string, notificationId: string, options?: AxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).notificationsGetDetail(authorization, notificationId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PalmOilApi - axios parameter creator
 * @export
 */
export const PalmOilApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Change PIN (with old PIN)
         * @param {PalmOilAuthPinChangeRequest} palmOilAuthPinChangeRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        palmOilAuthPinChange: async (palmOilAuthPinChangeRequest: PalmOilAuthPinChangeRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'palmOilAuthPinChangeRequest' is not null or undefined
            assertParamExists('palmOilAuthPinChange', 'palmOilAuthPinChangeRequest', palmOilAuthPinChangeRequest)
            const localVarPath = `/palm-oil/v1/users/pin/change`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(palmOilAuthPinChangeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Process the pin is already encrypted in frontend, but backend still needs to hash it before saving in database.
         * @summary Create PIN (after OTP valid)
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        palmOilAuthPinCreate: async (body: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('palmOilAuthPinCreate', 'body', body)
            const localVarPath = `/palm-oil/v1/users/pin/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate user PIN.
         * @param {PalmOilAuthPinValidateRequest} palmOilAuthPinValidateRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        palmOilAuthPinValidate: async (palmOilAuthPinValidateRequest: PalmOilAuthPinValidateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'palmOilAuthPinValidateRequest' is not null or undefined
            assertParamExists('palmOilAuthPinValidate', 'palmOilAuthPinValidateRequest', palmOilAuthPinValidateRequest)
            const localVarPath = `/palm-oil/v1/users/pin/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(palmOilAuthPinValidateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint will be used to generate presigned URL for uploading object (image) directly to AWS S3 with expiry time
         * @summary Generate Presigned URL for uploading object
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {PalmOilFilesWeighBridgeCreateRequest} palmOilFilesWeighBridgeCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        palmOilFilesWeighBridgeCreate: async (authorization: string, palmOilFilesWeighBridgeCreateRequest: PalmOilFilesWeighBridgeCreateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('palmOilFilesWeighBridgeCreate', 'authorization', authorization)
            // verify required parameter 'palmOilFilesWeighBridgeCreateRequest' is not null or undefined
            assertParamExists('palmOilFilesWeighBridgeCreate', 'palmOilFilesWeighBridgeCreateRequest', palmOilFilesWeighBridgeCreateRequest)
            const localVarPath = `/api/v1/files/weighbridge`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(palmOilFilesWeighBridgeCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get JWT
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        palmOilJwtGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/palm-oil/v1/jwt`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Used by Member and Worker App to get details of a notification
         * @summary Notifications Detail
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} notification notification type UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        palmOilUsersNotificationsGetDetail: async (authorization: string, notification: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('palmOilUsersNotificationsGetDetail', 'authorization', authorization)
            // verify required parameter 'notification' is not null or undefined
            assertParamExists('palmOilUsersNotificationsGetDetail', 'notification', notification)
            const localVarPath = `/palm-oil/v1/users/notification-detail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (notification !== undefined) {
                localVarQueryParameter['notification'] = notification;
            }

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate OTP
         * @param {PalmOilUsersOtpValidateRequest} palmOilUsersOtpValidateRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        palmOilUsersOtpValidate: async (palmOilUsersOtpValidateRequest: PalmOilUsersOtpValidateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'palmOilUsersOtpValidateRequest' is not null or undefined
            assertParamExists('palmOilUsersOtpValidate', 'palmOilUsersOtpValidateRequest', palmOilUsersOtpValidateRequest)
            const localVarPath = `/palm-oil/v1/users/otp/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(palmOilUsersOtpValidateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate user phone number.
         * @param {PalmOilUsersPhoneNumberValidateRequest} palmOilUsersPhoneNumberValidateRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        palmOilUsersPhoneNumberValidate: async (palmOilUsersPhoneNumberValidateRequest: PalmOilUsersPhoneNumberValidateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'palmOilUsersPhoneNumberValidateRequest' is not null or undefined
            assertParamExists('palmOilUsersPhoneNumberValidate', 'palmOilUsersPhoneNumberValidateRequest', palmOilUsersPhoneNumberValidateRequest)
            const localVarPath = `/palm-oil/v1/users/phone-no/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(palmOilUsersPhoneNumberValidateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get referrals
         * @param {string} userId 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        palmOilUsersReferrals: async (userId: string, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('palmOilUsersReferrals', 'userId', userId)
            const localVarPath = `/palm-oil/v1/users/{userId}/referrals`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Registration Data
         * @param {string} userId 
         * @param {PalmOilUsersUpdateRegistrationRequest} palmOilUsersUpdateRegistrationRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        palmOilUsersUpdateRegistration: async (userId: string, palmOilUsersUpdateRegistrationRequest: PalmOilUsersUpdateRegistrationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('palmOilUsersUpdateRegistration', 'userId', userId)
            // verify required parameter 'palmOilUsersUpdateRegistrationRequest' is not null or undefined
            assertParamExists('palmOilUsersUpdateRegistration', 'palmOilUsersUpdateRegistrationRequest', palmOilUsersUpdateRegistrationRequest)
            const localVarPath = `/palm-oil/v1/users/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(palmOilUsersUpdateRegistrationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get villages
         * @param {string} [name] 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        palmOilVillagesGet: async (name?: string, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/palm-oil/v1/villages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Submit weighbridge data
         * @param {PalmOilWeighbridgeSubmitRequest} [palmOilWeighbridgeSubmitRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        palmOilWeighbridgeSubmit: async (palmOilWeighbridgeSubmitRequest?: PalmOilWeighbridgeSubmitRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/palm-oil/v1/weighbridge`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(palmOilWeighbridgeSubmitRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove Worker
         * @param {string} workerId 
         * @param {WorkerCategoryEnum} category 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        palmOilWorkersRemove: async (workerId: string, category: WorkerCategoryEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workerId' is not null or undefined
            assertParamExists('palmOilWorkersRemove', 'workerId', workerId)
            // verify required parameter 'category' is not null or undefined
            assertParamExists('palmOilWorkersRemove', 'category', category)
            const localVarPath = `/palm-oil/v1/workers/{workerId}`
                .replace(`{${"workerId"}}`, encodeURIComponent(String(workerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Worker
         * @param {string} workerId 
         * @param {WorkerCategoryEnum} category 
         * @param {PalmOilWorkersUpdateRequest} palmOilWorkersUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        palmOilWorkersUpdate: async (workerId: string, category: WorkerCategoryEnum, palmOilWorkersUpdateRequest: PalmOilWorkersUpdateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workerId' is not null or undefined
            assertParamExists('palmOilWorkersUpdate', 'workerId', workerId)
            // verify required parameter 'category' is not null or undefined
            assertParamExists('palmOilWorkersUpdate', 'category', category)
            // verify required parameter 'palmOilWorkersUpdateRequest' is not null or undefined
            assertParamExists('palmOilWorkersUpdate', 'palmOilWorkersUpdateRequest', palmOilWorkersUpdateRequest)
            const localVarPath = `/palm-oil/v1/workers/{workerId}`
                .replace(`{${"workerId"}}`, encodeURIComponent(String(workerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(palmOilWorkersUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PalmOilApi - functional programming interface
 * @export
 */
export const PalmOilApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PalmOilApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Change PIN (with old PIN)
         * @param {PalmOilAuthPinChangeRequest} palmOilAuthPinChangeRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async palmOilAuthPinChange(palmOilAuthPinChangeRequest: PalmOilAuthPinChangeRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PalmOilAuthPinChangeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.palmOilAuthPinChange(palmOilAuthPinChangeRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Process the pin is already encrypted in frontend, but backend still needs to hash it before saving in database.
         * @summary Create PIN (after OTP valid)
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async palmOilAuthPinCreate(body: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PalmOilAuthPinCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.palmOilAuthPinCreate(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Validate user PIN.
         * @param {PalmOilAuthPinValidateRequest} palmOilAuthPinValidateRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async palmOilAuthPinValidate(palmOilAuthPinValidateRequest: PalmOilAuthPinValidateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PalmOilAuthPinValidateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.palmOilAuthPinValidate(palmOilAuthPinValidateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint will be used to generate presigned URL for uploading object (image) directly to AWS S3 with expiry time
         * @summary Generate Presigned URL for uploading object
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {PalmOilFilesWeighBridgeCreateRequest} palmOilFilesWeighBridgeCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async palmOilFilesWeighBridgeCreate(authorization: string, palmOilFilesWeighBridgeCreateRequest: PalmOilFilesWeighBridgeCreateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PalmOilFilesWeighBridgeCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.palmOilFilesWeighBridgeCreate(authorization, palmOilFilesWeighBridgeCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get JWT
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async palmOilJwtGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PalmOilJwtGetResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.palmOilJwtGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Used by Member and Worker App to get details of a notification
         * @summary Notifications Detail
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} notification notification type UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async palmOilUsersNotificationsGetDetail(authorization: string, notification: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PalmOilUsersNotificationGetDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.palmOilUsersNotificationsGetDetail(authorization, notification, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Validate OTP
         * @param {PalmOilUsersOtpValidateRequest} palmOilUsersOtpValidateRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async palmOilUsersOtpValidate(palmOilUsersOtpValidateRequest: PalmOilUsersOtpValidateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PalmOilUsersOtpValidateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.palmOilUsersOtpValidate(palmOilUsersOtpValidateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Validate user phone number.
         * @param {PalmOilUsersPhoneNumberValidateRequest} palmOilUsersPhoneNumberValidateRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async palmOilUsersPhoneNumberValidate(palmOilUsersPhoneNumberValidateRequest: PalmOilUsersPhoneNumberValidateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PalmOilUsersPhoneNumberValidateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.palmOilUsersPhoneNumberValidate(palmOilUsersPhoneNumberValidateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get referrals
         * @param {string} userId 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async palmOilUsersReferrals(userId: string, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MembersReferralsListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.palmOilUsersReferrals(userId, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update Registration Data
         * @param {string} userId 
         * @param {PalmOilUsersUpdateRegistrationRequest} palmOilUsersUpdateRegistrationRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async palmOilUsersUpdateRegistration(userId: string, palmOilUsersUpdateRegistrationRequest: PalmOilUsersUpdateRegistrationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PalmOilUsersUpdateRegistrationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.palmOilUsersUpdateRegistration(userId, palmOilUsersUpdateRegistrationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get villages
         * @param {string} [name] 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async palmOilVillagesGet(name?: string, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PalmOilVillagesGetResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.palmOilVillagesGet(name, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Submit weighbridge data
         * @param {PalmOilWeighbridgeSubmitRequest} [palmOilWeighbridgeSubmitRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async palmOilWeighbridgeSubmit(palmOilWeighbridgeSubmitRequest?: PalmOilWeighbridgeSubmitRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PalmOilWeighbridgeSubmitResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.palmOilWeighbridgeSubmit(palmOilWeighbridgeSubmitRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Remove Worker
         * @param {string} workerId 
         * @param {WorkerCategoryEnum} category 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async palmOilWorkersRemove(workerId: string, category: WorkerCategoryEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PalmOilWorkersRemoveResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.palmOilWorkersRemove(workerId, category, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update Worker
         * @param {string} workerId 
         * @param {WorkerCategoryEnum} category 
         * @param {PalmOilWorkersUpdateRequest} palmOilWorkersUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async palmOilWorkersUpdate(workerId: string, category: WorkerCategoryEnum, palmOilWorkersUpdateRequest: PalmOilWorkersUpdateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PalmOilWorkersUpdateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.palmOilWorkersUpdate(workerId, category, palmOilWorkersUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PalmOilApi - factory interface
 * @export
 */
export const PalmOilApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PalmOilApiFp(configuration)
    return {
        /**
         * 
         * @summary Change PIN (with old PIN)
         * @param {PalmOilAuthPinChangeRequest} palmOilAuthPinChangeRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        palmOilAuthPinChange(palmOilAuthPinChangeRequest: PalmOilAuthPinChangeRequest, options?: any): AxiosPromise<PalmOilAuthPinChangeResponse> {
            return localVarFp.palmOilAuthPinChange(palmOilAuthPinChangeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Process the pin is already encrypted in frontend, but backend still needs to hash it before saving in database.
         * @summary Create PIN (after OTP valid)
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        palmOilAuthPinCreate(body: object, options?: any): AxiosPromise<PalmOilAuthPinCreateResponse> {
            return localVarFp.palmOilAuthPinCreate(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Validate user PIN.
         * @param {PalmOilAuthPinValidateRequest} palmOilAuthPinValidateRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        palmOilAuthPinValidate(palmOilAuthPinValidateRequest: PalmOilAuthPinValidateRequest, options?: any): AxiosPromise<PalmOilAuthPinValidateResponse> {
            return localVarFp.palmOilAuthPinValidate(palmOilAuthPinValidateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint will be used to generate presigned URL for uploading object (image) directly to AWS S3 with expiry time
         * @summary Generate Presigned URL for uploading object
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {PalmOilFilesWeighBridgeCreateRequest} palmOilFilesWeighBridgeCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        palmOilFilesWeighBridgeCreate(authorization: string, palmOilFilesWeighBridgeCreateRequest: PalmOilFilesWeighBridgeCreateRequest, options?: any): AxiosPromise<PalmOilFilesWeighBridgeCreateResponse> {
            return localVarFp.palmOilFilesWeighBridgeCreate(authorization, palmOilFilesWeighBridgeCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get JWT
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        palmOilJwtGet(options?: any): AxiosPromise<PalmOilJwtGetResponse> {
            return localVarFp.palmOilJwtGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Used by Member and Worker App to get details of a notification
         * @summary Notifications Detail
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} notification notification type UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        palmOilUsersNotificationsGetDetail(authorization: string, notification: string, options?: any): AxiosPromise<PalmOilUsersNotificationGetDetailResponse> {
            return localVarFp.palmOilUsersNotificationsGetDetail(authorization, notification, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Validate OTP
         * @param {PalmOilUsersOtpValidateRequest} palmOilUsersOtpValidateRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        palmOilUsersOtpValidate(palmOilUsersOtpValidateRequest: PalmOilUsersOtpValidateRequest, options?: any): AxiosPromise<PalmOilUsersOtpValidateResponse> {
            return localVarFp.palmOilUsersOtpValidate(palmOilUsersOtpValidateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Validate user phone number.
         * @param {PalmOilUsersPhoneNumberValidateRequest} palmOilUsersPhoneNumberValidateRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        palmOilUsersPhoneNumberValidate(palmOilUsersPhoneNumberValidateRequest: PalmOilUsersPhoneNumberValidateRequest, options?: any): AxiosPromise<PalmOilUsersPhoneNumberValidateResponse> {
            return localVarFp.palmOilUsersPhoneNumberValidate(palmOilUsersPhoneNumberValidateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get referrals
         * @param {string} userId 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        palmOilUsersReferrals(userId: string, page?: number, limit?: number, options?: any): AxiosPromise<MembersReferralsListResponse> {
            return localVarFp.palmOilUsersReferrals(userId, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Registration Data
         * @param {string} userId 
         * @param {PalmOilUsersUpdateRegistrationRequest} palmOilUsersUpdateRegistrationRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        palmOilUsersUpdateRegistration(userId: string, palmOilUsersUpdateRegistrationRequest: PalmOilUsersUpdateRegistrationRequest, options?: any): AxiosPromise<PalmOilUsersUpdateRegistrationResponse> {
            return localVarFp.palmOilUsersUpdateRegistration(userId, palmOilUsersUpdateRegistrationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get villages
         * @param {string} [name] 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        palmOilVillagesGet(name?: string, page?: number, limit?: number, options?: any): AxiosPromise<PalmOilVillagesGetResponse> {
            return localVarFp.palmOilVillagesGet(name, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Submit weighbridge data
         * @param {PalmOilWeighbridgeSubmitRequest} [palmOilWeighbridgeSubmitRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        palmOilWeighbridgeSubmit(palmOilWeighbridgeSubmitRequest?: PalmOilWeighbridgeSubmitRequest, options?: any): AxiosPromise<PalmOilWeighbridgeSubmitResponse> {
            return localVarFp.palmOilWeighbridgeSubmit(palmOilWeighbridgeSubmitRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove Worker
         * @param {string} workerId 
         * @param {WorkerCategoryEnum} category 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        palmOilWorkersRemove(workerId: string, category: WorkerCategoryEnum, options?: any): AxiosPromise<PalmOilWorkersRemoveResponse> {
            return localVarFp.palmOilWorkersRemove(workerId, category, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Worker
         * @param {string} workerId 
         * @param {WorkerCategoryEnum} category 
         * @param {PalmOilWorkersUpdateRequest} palmOilWorkersUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        palmOilWorkersUpdate(workerId: string, category: WorkerCategoryEnum, palmOilWorkersUpdateRequest: PalmOilWorkersUpdateRequest, options?: any): AxiosPromise<PalmOilWorkersUpdateResponse> {
            return localVarFp.palmOilWorkersUpdate(workerId, category, palmOilWorkersUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PalmOilApi - object-oriented interface
 * @export
 * @class PalmOilApi
 * @extends {BaseAPI}
 */
export class PalmOilApi extends BaseAPI {
    /**
     * 
     * @summary Change PIN (with old PIN)
     * @param {PalmOilAuthPinChangeRequest} palmOilAuthPinChangeRequest 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof PalmOilApi
     */
    public palmOilAuthPinChange(palmOilAuthPinChangeRequest: PalmOilAuthPinChangeRequest, options?: AxiosRequestConfig) {
        return PalmOilApiFp(this.configuration).palmOilAuthPinChange(palmOilAuthPinChangeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Process the pin is already encrypted in frontend, but backend still needs to hash it before saving in database.
     * @summary Create PIN (after OTP valid)
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof PalmOilApi
     */
    public palmOilAuthPinCreate(body: object, options?: AxiosRequestConfig) {
        return PalmOilApiFp(this.configuration).palmOilAuthPinCreate(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Validate user PIN.
     * @param {PalmOilAuthPinValidateRequest} palmOilAuthPinValidateRequest 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof PalmOilApi
     */
    public palmOilAuthPinValidate(palmOilAuthPinValidateRequest: PalmOilAuthPinValidateRequest, options?: AxiosRequestConfig) {
        return PalmOilApiFp(this.configuration).palmOilAuthPinValidate(palmOilAuthPinValidateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint will be used to generate presigned URL for uploading object (image) directly to AWS S3 with expiry time
     * @summary Generate Presigned URL for uploading object
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {PalmOilFilesWeighBridgeCreateRequest} palmOilFilesWeighBridgeCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PalmOilApi
     */
    public palmOilFilesWeighBridgeCreate(authorization: string, palmOilFilesWeighBridgeCreateRequest: PalmOilFilesWeighBridgeCreateRequest, options?: AxiosRequestConfig) {
        return PalmOilApiFp(this.configuration).palmOilFilesWeighBridgeCreate(authorization, palmOilFilesWeighBridgeCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get JWT
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof PalmOilApi
     */
    public palmOilJwtGet(options?: AxiosRequestConfig) {
        return PalmOilApiFp(this.configuration).palmOilJwtGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Used by Member and Worker App to get details of a notification
     * @summary Notifications Detail
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {string} notification notification type UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PalmOilApi
     */
    public palmOilUsersNotificationsGetDetail(authorization: string, notification: string, options?: AxiosRequestConfig) {
        return PalmOilApiFp(this.configuration).palmOilUsersNotificationsGetDetail(authorization, notification, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Validate OTP
     * @param {PalmOilUsersOtpValidateRequest} palmOilUsersOtpValidateRequest 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof PalmOilApi
     */
    public palmOilUsersOtpValidate(palmOilUsersOtpValidateRequest: PalmOilUsersOtpValidateRequest, options?: AxiosRequestConfig) {
        return PalmOilApiFp(this.configuration).palmOilUsersOtpValidate(palmOilUsersOtpValidateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Validate user phone number.
     * @param {PalmOilUsersPhoneNumberValidateRequest} palmOilUsersPhoneNumberValidateRequest 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof PalmOilApi
     */
    public palmOilUsersPhoneNumberValidate(palmOilUsersPhoneNumberValidateRequest: PalmOilUsersPhoneNumberValidateRequest, options?: AxiosRequestConfig) {
        return PalmOilApiFp(this.configuration).palmOilUsersPhoneNumberValidate(palmOilUsersPhoneNumberValidateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get referrals
     * @param {string} userId 
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PalmOilApi
     */
    public palmOilUsersReferrals(userId: string, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return PalmOilApiFp(this.configuration).palmOilUsersReferrals(userId, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Registration Data
     * @param {string} userId 
     * @param {PalmOilUsersUpdateRegistrationRequest} palmOilUsersUpdateRegistrationRequest 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof PalmOilApi
     */
    public palmOilUsersUpdateRegistration(userId: string, palmOilUsersUpdateRegistrationRequest: PalmOilUsersUpdateRegistrationRequest, options?: AxiosRequestConfig) {
        return PalmOilApiFp(this.configuration).palmOilUsersUpdateRegistration(userId, palmOilUsersUpdateRegistrationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get villages
     * @param {string} [name] 
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PalmOilApi
     */
    public palmOilVillagesGet(name?: string, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return PalmOilApiFp(this.configuration).palmOilVillagesGet(name, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Submit weighbridge data
     * @param {PalmOilWeighbridgeSubmitRequest} [palmOilWeighbridgeSubmitRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PalmOilApi
     */
    public palmOilWeighbridgeSubmit(palmOilWeighbridgeSubmitRequest?: PalmOilWeighbridgeSubmitRequest, options?: AxiosRequestConfig) {
        return PalmOilApiFp(this.configuration).palmOilWeighbridgeSubmit(palmOilWeighbridgeSubmitRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove Worker
     * @param {string} workerId 
     * @param {WorkerCategoryEnum} category 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PalmOilApi
     */
    public palmOilWorkersRemove(workerId: string, category: WorkerCategoryEnum, options?: AxiosRequestConfig) {
        return PalmOilApiFp(this.configuration).palmOilWorkersRemove(workerId, category, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Worker
     * @param {string} workerId 
     * @param {WorkerCategoryEnum} category 
     * @param {PalmOilWorkersUpdateRequest} palmOilWorkersUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PalmOilApi
     */
    public palmOilWorkersUpdate(workerId: string, category: WorkerCategoryEnum, palmOilWorkersUpdateRequest: PalmOilWorkersUpdateRequest, options?: AxiosRequestConfig) {
        return PalmOilApiFp(this.configuration).palmOilWorkersUpdate(workerId, category, palmOilWorkersUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PartnersApi - axios parameter creator
 * @export
 */
export const PartnersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Activate/Deactivate User
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} userId 
         * @param {ActivateUserRequest} [activateUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateUser: async (authorization: string, userId: string, activateUserRequest?: ActivateUserRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('activateUser', 'authorization', authorization)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('activateUser', 'userId', userId)
            const localVarPath = `/api/v1/users/{userId}/activate`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(activateUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Used by all Partner user to add participants on a campaign
         * @summary Add New Campaign Participants
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} campaignId Campaign ID, represented in UUID type 4 format
         * @param {CampaignAddParticipantRequest} [campaignAddParticipantRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignAddParticipant: async (authorization: string, campaignId: string, campaignAddParticipantRequest?: CampaignAddParticipantRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('campaignAddParticipant', 'authorization', authorization)
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('campaignAddParticipant', 'campaignId', campaignId)
            const localVarPath = `/api/v1/partners/campaigns/{campaignId}/add-participant`
                .replace(`{${"campaignId"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(campaignAddParticipantRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Will be used by all Partner users to cancel campaign if status is still `SCHEDULED`
         * @summary Cancel Campaign
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} campaignId Campaign ID, represented in UUID type 4 format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelCampaign: async (authorization: string, campaignId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('cancelCampaign', 'authorization', authorization)
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('cancelCampaign', 'campaignId', campaignId)
            const localVarPath = `/api/v1/partners/campaigns/{campaignId}/cancel`
                .replace(`{${"campaignId"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Used by all Partner user to create a new campaign
         * @summary Create New Campaign
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {CreateCampaignRequest} [createCampaignRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCampaign: async (authorization: string, createCampaignRequest?: CreateCampaignRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createCampaign', 'authorization', authorization)
            const localVarPath = `/api/v1/partners/campaigns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCampaignRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Will be used by all Partner users to edit a campaign (only for the one with `SCHEDULED` status)
         * @summary Edit Campaign
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} campaignId Campaign ID, represented in UUID type 4 format
         * @param {EditCampaignRequest} [editCampaignRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editCampaign: async (authorization: string, campaignId: string, editCampaignRequest?: EditCampaignRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('editCampaign', 'authorization', authorization)
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('editCampaign', 'campaignId', campaignId)
            const localVarPath = `/api/v1/partners/campaigns/{campaignId}`
                .replace(`{${"campaignId"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editCampaignRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Will be used by all Partner user to view one of their campaign details
         * @summary Get Campaign Details
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} campaignId Campaign ID, represented in UUID type 4 format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaign: async (authorization: string, campaignId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getCampaign', 'authorization', authorization)
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('getCampaign', 'campaignId', campaignId)
            const localVarPath = `/api/v1/partners/campaigns/{campaignId}`
                .replace(`{${"campaignId"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Will be used by all Partner users to retrieve their own role including the list of Partners that they manage
         * @summary Get User Role
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserRole: async (authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getUserRole', 'authorization', authorization)
            const localVarPath = `/api/v1/users/role`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Used by all Partner user to retrieve list of campaigns. `status` query parameter allow list by using coma delimiter, will show all status if not specified
         * @summary List Campaign
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {Array<string>} [type] Filled with campaign type ID (from Get Campaign Types). Default will show campaign type
         * @param {Array<CampaignStatusEnum>} [status] 
         * @param {string} [name] Search query for campaign by Nama Promosi
         * @param {string} [orderBy] Column used for ordering, will accept the field name from response object
         * @param {OrderDirectionEnum} [direction] 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCampaign: async (authorization: string, type?: Array<string>, status?: Array<CampaignStatusEnum>, name?: string, orderBy?: string, direction?: OrderDirectionEnum, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('listCampaign', 'authorization', authorization)
            const localVarPath = `/api/v1/partners/campaigns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (type) {
                localVarQueryParameter['type'] = type.join(COLLECTION_FORMATS.csv);
            }

            if (status) {
                localVarQueryParameter['status'] = status.join(COLLECTION_FORMATS.csv);
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint is meant to be used for getting coupon detail vendor
         * @summary Get coupon detail vendor
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} couponCode coupon Code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parnersGetCouponDetail: async (authorization: string, couponCode: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('parnersGetCouponDetail', 'authorization', authorization)
            // verify required parameter 'couponCode' is not null or undefined
            assertParamExists('parnersGetCouponDetail', 'couponCode', couponCode)
            const localVarPath = `/api/v1/partners/coupons/{couponCode}`
                .replace(`{${"couponCode"}}`, encodeURIComponent(String(couponCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint will be used to create new product pricelist for store partner
         * @summary Create pricelist of partner
         * @param {PartnerVendorCreateProductPricelistRequest} [partnerVendorCreateProductPricelistRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerVendorCreateProductPricelist: async (partnerVendorCreateProductPricelistRequest?: PartnerVendorCreateProductPricelistRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/partners/products/pricelists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(partnerVendorCreateProductPricelistRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint will be called by partner web to get list of product pricelist.
         * @summary Get list of product pricelist for partner web
         * @param {string} [productName] Filter product by product name. If is nil, will return all products. If specified, will return products that have product name that similar the specified value. 
         * @param {string} [vendorId] 
         * @param {PartnerVendorGetProductPricelistsSortEnum} [sort] Sort field name
         * @param {OrderDirectionEnum} [direction] Sort direction
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerVendorGetProductPricelists: async (productName?: string, vendorId?: string, sort?: PartnerVendorGetProductPricelistsSortEnum, direction?: OrderDirectionEnum, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/partners/products/pricelists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (productName !== undefined) {
                localVarQueryParameter['productName'] = productName;
            }

            if (vendorId !== undefined) {
                localVarQueryParameter['vendorId'] = vendorId;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint will be used to update existing product pricelist for store partner
         * @summary Update pricelist of partner
         * @param {string} pricelistId Pricelist UUID
         * @param {PartnerVendorUpdateProductPricelistRequest} partnerVendorUpdateProductPricelistRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerVendorUpdateProductPricelist: async (pricelistId: string, partnerVendorUpdateProductPricelistRequest: PartnerVendorUpdateProductPricelistRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pricelistId' is not null or undefined
            assertParamExists('partnerVendorUpdateProductPricelist', 'pricelistId', pricelistId)
            // verify required parameter 'partnerVendorUpdateProductPricelistRequest' is not null or undefined
            assertParamExists('partnerVendorUpdateProductPricelist', 'partnerVendorUpdateProductPricelistRequest', partnerVendorUpdateProductPricelistRequest)
            const localVarPath = `/api/v1/partners/products/pricelists/{pricelistId}`
                .replace(`{${"pricelistId"}}`, encodeURIComponent(String(pricelistId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(partnerVendorUpdateProductPricelistRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Asset Summary per Partner, grouped by the Asset Type
         * @summary List Assets Summaries
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersAssetsGetSummary: async (authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('partnersAssetsGetSummary', 'authorization', authorization)
            const localVarPath = `/api/v1/partners/assets/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Campaign Summary per Partner, grouped by the Campaign Status
         * @summary List Campaign Summaries
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersCampaignsGetSummary: async (authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('partnersCampaignsGetSummary', 'authorization', authorization)
            const localVarPath = `/api/v1/partners/campaigns/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This will be used by all Partner user to confirm pending member request.
         * @summary Confirm Member
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} memberId 
         * @param {PartnersConfirmMemberRequest} partnersConfirmMemberRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersConfirmMember: async (authorization: string, memberId: string, partnersConfirmMemberRequest: PartnersConfirmMemberRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('partnersConfirmMember', 'authorization', authorization)
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('partnersConfirmMember', 'memberId', memberId)
            // verify required parameter 'partnersConfirmMemberRequest' is not null or undefined
            assertParamExists('partnersConfirmMember', 'partnersConfirmMemberRequest', partnersConfirmMemberRequest)
            const localVarPath = `/api/v1/partners/members/{memberId}/confirm`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(partnersConfirmMemberRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Used by a new user to link their Partner account into a specific supplier
         * @summary Link User to Supplier
         * @param {PartnersCreateSupplierLinkRequest} partnersCreateSupplierLinkRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersCreateSupplierLink: async (partnersCreateSupplierLinkRequest: PartnersCreateSupplierLinkRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnersCreateSupplierLinkRequest' is not null or undefined
            assertParamExists('partnersCreateSupplierLink', 'partnersCreateSupplierLinkRequest', partnersCreateSupplierLinkRequest)
            const localVarPath = `/api/v1/partners/suppliers/link`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(partnersCreateSupplierLinkRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint is meant to be used by FC to see list of ffb price that she/he submitted limited to 20 data 
         * @summary Get List of FFB Price V2 Histories filtered by user id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersFFBPricesHistories: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/partners/ffb-prices/histories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint is meant to be used to submit feedback by Partner ID. Users can submit their comment and give rating by some parameters as price, weighbridge, queue, sorting, and road access. If the users has submitted feedback before, then they submit it again, it will replace the existing feedback. 
         * @summary Submit Feedback for Partner
         * @param {string} partnerId Partner UUID
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {PartnersFeedbacksCreateRequest} partnersFeedbacksCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersFeedbacksCreate: async (partnerId: string, authorization: string, partnersFeedbacksCreateRequest: PartnersFeedbacksCreateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('partnersFeedbacksCreate', 'partnerId', partnerId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('partnersFeedbacksCreate', 'authorization', authorization)
            // verify required parameter 'partnersFeedbacksCreateRequest' is not null or undefined
            assertParamExists('partnersFeedbacksCreate', 'partnersFeedbacksCreateRequest', partnersFeedbacksCreateRequest)
            const localVarPath = `/api/v1/partners/{partnerId}/feedbacks`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(partnersFeedbacksCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint is meant to be used to get feedback list by Partner ID 
         * @summary Get Feedback List per Partner
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} partnerId Partner UUID
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersFeedbacksList: async (aPPTYPE: AppTypeEnum, partnerId: string, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('partnersFeedbacksList', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('partnersFeedbacksList', 'partnerId', partnerId)
            const localVarPath = `/api/v1/partners/{partnerId}/feedbacks`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the summary of a Partner\'s rating
         * @summary Get Feedback Summary per Partner
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} partnerId Partner UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersFeedbacksSummary: async (aPPTYPE: AppTypeEnum, partnerId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('partnersFeedbacksSummary', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('partnersFeedbacksSummary', 'partnerId', partnerId)
            const localVarPath = `/api/v1/partners/{partnerId}/feedbacks/summary`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the user feedback for related partner
         * @summary Get Feedback user by Partner ID
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} partnerId Partner UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersFeedbacksUser: async (aPPTYPE: AppTypeEnum, partnerId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('partnersFeedbacksUser', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('partnersFeedbacksUser', 'partnerId', partnerId)
            const localVarPath = `/api/v1/partners/{partnerId}/feedbacks/user`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint is meant to be used by FC to add FFB Price for each partner 
         * @summary Add FFB Price for each partner
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {PartnersFfbPriceCreateRequest} [partnersFfbPriceCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersFfbPriceCreate: async (authorization: string, partnersFfbPriceCreateRequest?: PartnersFfbPriceCreateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('partnersFfbPriceCreate', 'authorization', authorization)
            const localVarPath = `/api/v1/partner/ffb-price`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(partnersFfbPriceCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint is meant to be used by FC to add FFB Price for each partner 
         * @summary Add FFB Price for each partner
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {PartnersFfbPriceCreateV2Request} [partnersFfbPriceCreateV2Request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersFfbPriceCreateV2: async (authorization: string, partnersFfbPriceCreateV2Request?: PartnersFfbPriceCreateV2Request, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('partnersFfbPriceCreateV2', 'authorization', authorization)
            const localVarPath = `/api/v2/partners/ffb-prices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(partnersFfbPriceCreateV2Request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint is meant to be used by FC to add FFB Price for each partner 
         * @summary Add FFB Price for each partner
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {PartnersFfbPriceCreateV3Request} [partnersFfbPriceCreateV3Request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersFfbPriceCreateV3: async (authorization: string, partnersFfbPriceCreateV3Request?: PartnersFfbPriceCreateV3Request, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('partnersFfbPriceCreateV3', 'authorization', authorization)
            const localVarPath = `/api/v3/partners/ffb-prices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(partnersFfbPriceCreateV3Request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * this endpoint is used by daily limitation checking of Field Coordinator Activity feature. To block their activity if they already submit 5 FFB Price for each day. 
         * @summary Check Limit FFB Price Daily before FC can add FFB Price
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersFfbPriceLimitation: async (authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('partnersFfbPriceLimitation', 'authorization', authorization)
            const localVarPath = `/api/v1/partner/ffb-price/limits`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This is for get invoice detail by invoice no. 
         * @summary Get Invoice Detail by Invoice No
         * @param {string} phoneNo Phone number of the user, this is for guest mode
         * @param {string} invoiceNo Invoice number of the order
         * @param {string} xRecaptchaResponse  this is for recaptcha response header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersFinanceGetInvoiceDetail: async (phoneNo: string, invoiceNo: string, xRecaptchaResponse: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'phoneNo' is not null or undefined
            assertParamExists('partnersFinanceGetInvoiceDetail', 'phoneNo', phoneNo)
            // verify required parameter 'invoiceNo' is not null or undefined
            assertParamExists('partnersFinanceGetInvoiceDetail', 'invoiceNo', invoiceNo)
            // verify required parameter 'xRecaptchaResponse' is not null or undefined
            assertParamExists('partnersFinanceGetInvoiceDetail', 'xRecaptchaResponse', xRecaptchaResponse)
            const localVarPath = `/api/v1/partners/finance/invoice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (phoneNo !== undefined) {
                localVarQueryParameter['phoneNo'] = phoneNo;
            }

            if (invoiceNo !== undefined) {
                localVarQueryParameter['invoiceNo'] = invoiceNo;
            }

            if (xRecaptchaResponse != null) {
                localVarHeaderParameter['X-Recaptcha-Response'] = String(xRecaptchaResponse);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint is meant to be used by FC to see list of ffb price that she/he submitted 
         * @summary Get List of FFB Price
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersGetFfbPrices: async (authorization: string, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('partnersGetFfbPrices', 'authorization', authorization)
            const localVarPath = `/api/v1/partners/ffb-prices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Can be accessed by all Partner Web user to see details of a Partner\'s member
         * @summary Get Member Detail
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersGetMember: async (authorization: string, memberId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('partnersGetMember', 'authorization', authorization)
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('partnersGetMember', 'memberId', memberId)
            const localVarPath = `/api/v1/partners/members/{memberId}`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endpoint for a User from one Partner to get list of their members. Default response will show all status with items count limited to 10
         * @summary List Partner Members
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {Array<MemberStatusEnum>} [status] 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersGetMembers: async (authorization: string, status?: Array<MemberStatusEnum>, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('partnersGetMembers', 'authorization', authorization)
            const localVarPath = `/api/v1/partners/members`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (status) {
                localVarQueryParameter['status'] = status;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint is meant to be used for getting Member list on Campaign creation process.
         * @summary Get Member List per Partner (with Status & Same Campaign Type Status)
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} campaignType ID of the selected Campaign Type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersGetMembersStatus: async (authorization: string, campaignType: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('partnersGetMembersStatus', 'authorization', authorization)
            // verify required parameter 'campaignType' is not null or undefined
            assertParamExists('partnersGetMembersStatus', 'campaignType', campaignType)
            const localVarPath = `/api/v1/partners/members/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (campaignType !== undefined) {
                localVarQueryParameter['campaignType'] = campaignType;
            }

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Accessed to see details of a supplier
         * @summary Get Supplier Detail
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} supplierId Supplier ID in UUID type 4 format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersGetSupplier: async (authorization: string, supplierId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('partnersGetSupplier', 'authorization', authorization)
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('partnersGetSupplier', 'supplierId', supplierId)
            const localVarPath = `/api/v1/partners/suppliers/{supplierId}`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint is meant to be used for getting Supplier list on Campaign creation process. Partner ID for identifier will be retrieved from JWT. 
         * @summary Get Supplier List on Campaign Creation
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} campaignType ID of the selected Campaign Type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersGetSuppliersStatus: async (authorization: string, campaignType: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('partnersGetSuppliersStatus', 'authorization', authorization)
            // verify required parameter 'campaignType' is not null or undefined
            assertParamExists('partnersGetSuppliersStatus', 'campaignType', campaignType)
            const localVarPath = `/api/v1/partners/suppliers-new-campaign`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (campaignType !== undefined) {
                localVarQueryParameter['campaignType'] = campaignType;
            }

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Will be used by all Partner user to get list of specific Partner\'s users
         * @summary Get Users Per Partner
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} partnerId Partner UUID
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersGetUsersByPartner: async (authorization: string, partnerId: string, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('partnersGetUsersByPartner', 'authorization', authorization)
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('partnersGetUsersByPartner', 'partnerId', partnerId)
            const localVarPath = `/api/v1/partners/{partnerId}/users`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Member Summary per Partner, grouped by the Member Status
         * @summary List Members Summaries
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersMembersGetSummary: async (authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('partnersMembersGetSummary', 'authorization', authorization)
            const localVarPath = `/api/v1/partners/members/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint is meant to be used by partners to create their daily plantation activity plan
         * @summary Partners Plantations Create Schedules
         * @param {PartnersPlantationsCreateSchedulesRequest} [partnersPlantationsCreateSchedulesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersPlantationsCreateSchedules: async (partnersPlantationsCreateSchedulesRequest?: PartnersPlantationsCreateSchedulesRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/partners/plantations/schedules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(partnersPlantationsCreateSchedulesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Will return list of block assignments that are connected to current user business. Will use User ID from JWT and lookup the block assignments by utilizing `contact` and `business`. 
         * @summary Partners Plantations Get Block Assignments
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} [blockName] the name of block on plantations block assignment
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersPlantationsGetBlockAssignments: async (aPPTYPE: AppTypeEnum, blockName?: string, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('partnersPlantationsGetBlockAssignments', 'aPPTYPE', aPPTYPE)
            const localVarPath = `/api/v1/partners/plantations/block-assignments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (blockName !== undefined) {
                localVarQueryParameter['blockName'] = blockName;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint is meant to be used by partners web to get their ffb productions
         * @summary Partners Plantations Get FFB Productions
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {number} [month] Month in MM format
         * @param {number} [year] Year in YYYY format
         * @param {string} [sortBy] Sort the results by the specified field.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersPlantationsGetFfbProductions: async (aPPTYPE: AppTypeEnum, month?: number, year?: number, sortBy?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('partnersPlantationsGetFfbProductions', 'aPPTYPE', aPPTYPE)
            const localVarPath = `/api/v1/partners/plantations/ffb-productions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint will be called by partner web to get list of plantations schedules.
         * @summary Get list of plantations schedules for partner web
         * @param {PlantationScheduleStatusEnum} [status] Status of the plantation schedules. No filter applied if empty.
         * @param {PlantationActivityTypeEnum} [plantationActivityType] Type of the plantation activity. No filter applied if empty.
         * @param {Array<string>} [sortBy] Sort the results by the specified field.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersPlantationsGetSchedules: async (status?: PlantationScheduleStatusEnum, plantationActivityType?: PlantationActivityTypeEnum, sortBy?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/partners/plantations/schedules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (plantationActivityType !== undefined) {
                localVarQueryParameter['plantationActivityType'] = plantationActivityType;
            }

            if (sortBy) {
                localVarQueryParameter['sortBy'] = sortBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Will update partial block assignments that are connected to current user business. Will use User ID from JWT and lookup the block assignments by utilizing `contact` and `business`. 
         * @summary Partners Plantations Update Partial Block Assignments
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} id 
         * @param {PartnersPlantationsUpdatePartialBlockAssignmentsRequest} [partnersPlantationsUpdatePartialBlockAssignmentsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersPlantationsUpdatePartialBlockAssignments: async (aPPTYPE: AppTypeEnum, id: string, partnersPlantationsUpdatePartialBlockAssignmentsRequest?: PartnersPlantationsUpdatePartialBlockAssignmentsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('partnersPlantationsUpdatePartialBlockAssignments', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('partnersPlantationsUpdatePartialBlockAssignments', 'id', id)
            const localVarPath = `/api/v1/partners/plantations/block-assignments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(partnersPlantationsUpdatePartialBlockAssignmentsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint is meant to be used by partners to partially update their daily plantation activity plan
         * @summary Partners Plantations Update Schedules Partial
         * @param {string} id 
         * @param {PartnersPlantationsUpdateSchedulesPartialRequest} [partnersPlantationsUpdateSchedulesPartialRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersPlantationsUpdateSchedulesPartial: async (id: string, partnersPlantationsUpdateSchedulesPartialRequest?: PartnersPlantationsUpdateSchedulesPartialRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('partnersPlantationsUpdateSchedulesPartial', 'id', id)
            const localVarPath = `/api/v1/partners/plantations/schedules/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(partnersPlantationsUpdateSchedulesPartialRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Request new jwt based on partner id
         * @summary Partners Switch
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {PartnersSwitchRequest} partnersSwitchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersSwitch: async (authorization: string, partnersSwitchRequest: PartnersSwitchRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('partnersSwitch', 'authorization', authorization)
            // verify required parameter 'partnersSwitchRequest' is not null or undefined
            assertParamExists('partnersSwitch', 'partnersSwitchRequest', partnersSwitchRequest)
            const localVarPath = `/api/v1/partners/switch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(partnersSwitchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Used by Partner Admin to create account for another user. Email field is nullable, and status will use default `PARTNER_USER` if not provided. Will send registration SMS to the newly registered user.  # Dependencies  | Service Name | Usage | | ----------- | ----------- | | GCP KMS | Phone number decryption| | Twilio | SMS service | 
         * @summary Register Partner Web User
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {UsersCreateRegistrationRequest} usersCreateRegistrationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersUsersCreateRegistration: async (authorization: string, usersCreateRegistrationRequest: UsersCreateRegistrationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('partnersUsersCreateRegistration', 'authorization', authorization)
            // verify required parameter 'usersCreateRegistrationRequest' is not null or undefined
            assertParamExists('partnersUsersCreateRegistration', 'usersCreateRegistrationRequest', usersCreateRegistrationRequest)
            const localVarPath = `/api/v1/partners/users/registration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(usersCreateRegistrationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validate the OTP Token (in UUID) received from Register User endpoint
         * @summary Validate Registration Token
         * @param {PartnersUsersVerifyRegistrationRequest} partnersUsersVerifyRegistrationRequest 
         * @param {AppTypeEnum} [aPPTYPE] The name of the app that\&#39;s accessing the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersUsersVerifyRegistration: async (partnersUsersVerifyRegistrationRequest: PartnersUsersVerifyRegistrationRequest, aPPTYPE?: AppTypeEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnersUsersVerifyRegistrationRequest' is not null or undefined
            assertParamExists('partnersUsersVerifyRegistration', 'partnersUsersVerifyRegistrationRequest', partnersUsersVerifyRegistrationRequest)
            const localVarPath = `/api/v1/partners/users/registration/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(partnersUsersVerifyRegistrationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * this is for getting eligible vendor list of coupon
         * @summary Get Redeemed Coupon by Vendor ID
         * @param {string} vendorId Vendor Id
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {string} [customerName] Customer Name
         * @param {number} [redeemedDateTo] Redeemed Date To
         * @param {number} [redeemedDateFrom] Redeemed Date From
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersVendorGetRedeemedCoupons: async (vendorId: string, page?: number, limit?: number, customerName?: string, redeemedDateTo?: number, redeemedDateFrom?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vendorId' is not null or undefined
            assertParamExists('partnersVendorGetRedeemedCoupons', 'vendorId', vendorId)
            const localVarPath = `/api/v1/partners/vendors/{vendorId}/redeemed-coupons`
                .replace(`{${"vendorId"}}`, encodeURIComponent(String(vendorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (customerName !== undefined) {
                localVarQueryParameter['customerName'] = customerName;
            }

            if (redeemedDateTo !== undefined) {
                localVarQueryParameter['redeemedDateTo'] = redeemedDateTo;
            }

            if (redeemedDateFrom !== undefined) {
                localVarQueryParameter['redeemedDateFrom'] = redeemedDateFrom;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endpoint for Partner to show list of Suppliers.<br><br>  Partner ID for identifier will be retrieved from JWT.<br><br>  Default response will show all status with items count limited to 10. 
         * @summary List Suppliers
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {Array<MemberStatusEnum>} [status] 
         * @param {string} [supplierName] Search query for supplier by Nama
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supplierList: async (authorization: string, status?: Array<MemberStatusEnum>, supplierName?: string, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('supplierList', 'authorization', authorization)
            const localVarPath = `/api/v1/partners/suppliers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (status) {
                localVarQueryParameter['status'] = status;
            }

            if (supplierName !== undefined) {
                localVarQueryParameter['supplierName'] = supplierName;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Will be used by Partner admin to update Partner\'s user account. Will update the user data based on given parameters.
         * @summary Update User
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} userId 
         * @param {UpdateUserRequest} [updateUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser: async (authorization: string, userId: string, updateUserRequest?: UpdateUserRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateUser', 'authorization', authorization)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUser', 'userId', userId)
            const localVarPath = `/api/v1/users/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Used by all Partner user to create a new campaign V2
         * @summary Create New Campaign V2
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {V2CreateCampaignRequest} [v2CreateCampaignRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CreateCampaign: async (authorization: string, v2CreateCampaignRequest?: V2CreateCampaignRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('v2CreateCampaign', 'authorization', authorization)
            const localVarPath = `/api/v2/partners/campaigns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(v2CreateCampaignRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint is meant to be used by FC to see list of ffb price that she/he submitted filtered by month and year 
         * @summary Get List of FFB Price V2 filter by month and year
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {number} [month] Month in MM format
         * @param {number} [year] Year in YYYY format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2PartnersGetFfbPrices: async (page?: number, limit?: number, month?: number, year?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/partners/ffb-prices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Can be accessed by all Partner Web user to see details of a Partner\'s member
         * @summary Get Member Detail V2
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2PartnersGetMember: async (authorization: string, userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('v2PartnersGetMember', 'authorization', authorization)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('v2PartnersGetMember', 'userId', userId)
            const localVarPath = `/api/v2/partners/members/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endpoint for a User from one Partner to get list of their members. Default response will show all status with items count limited to 10
         * @summary List Partner Members V2
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {Array<MemberStatusEnum>} [status] 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2PartnersGetMembers: async (authorization: string, status?: Array<MemberStatusEnum>, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('v2PartnersGetMembers', 'authorization', authorization)
            const localVarPath = `/api/v2/partners/members`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (status) {
                localVarQueryParameter['status'] = status;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PartnersApi - functional programming interface
 * @export
 */
export const PartnersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PartnersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Activate/Deactivate User
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} userId 
         * @param {ActivateUserRequest} [activateUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activateUser(authorization: string, userId: string, activateUserRequest?: ActivateUserRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActivateUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activateUser(authorization, userId, activateUserRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Used by all Partner user to add participants on a campaign
         * @summary Add New Campaign Participants
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} campaignId Campaign ID, represented in UUID type 4 format
         * @param {CampaignAddParticipantRequest} [campaignAddParticipantRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignAddParticipant(authorization: string, campaignId: string, campaignAddParticipantRequest?: CampaignAddParticipantRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignAddParticipant(authorization, campaignId, campaignAddParticipantRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Will be used by all Partner users to cancel campaign if status is still `SCHEDULED`
         * @summary Cancel Campaign
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} campaignId Campaign ID, represented in UUID type 4 format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelCampaign(authorization: string, campaignId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CancelCampaignResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelCampaign(authorization, campaignId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Used by all Partner user to create a new campaign
         * @summary Create New Campaign
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {CreateCampaignRequest} [createCampaignRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCampaign(authorization: string, createCampaignRequest?: CreateCampaignRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateEditCampaignResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCampaign(authorization, createCampaignRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Will be used by all Partner users to edit a campaign (only for the one with `SCHEDULED` status)
         * @summary Edit Campaign
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} campaignId Campaign ID, represented in UUID type 4 format
         * @param {EditCampaignRequest} [editCampaignRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editCampaign(authorization: string, campaignId: string, editCampaignRequest?: EditCampaignRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateEditCampaignResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editCampaign(authorization, campaignId, editCampaignRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Will be used by all Partner user to view one of their campaign details
         * @summary Get Campaign Details
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} campaignId Campaign ID, represented in UUID type 4 format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCampaign(authorization: string, campaignId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCampaignResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCampaign(authorization, campaignId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Will be used by all Partner users to retrieve their own role including the list of Partners that they manage
         * @summary Get User Role
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserRole(authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserRoleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserRole(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Used by all Partner user to retrieve list of campaigns. `status` query parameter allow list by using coma delimiter, will show all status if not specified
         * @summary List Campaign
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {Array<string>} [type] Filled with campaign type ID (from Get Campaign Types). Default will show campaign type
         * @param {Array<CampaignStatusEnum>} [status] 
         * @param {string} [name] Search query for campaign by Nama Promosi
         * @param {string} [orderBy] Column used for ordering, will accept the field name from response object
         * @param {OrderDirectionEnum} [direction] 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCampaign(authorization: string, type?: Array<string>, status?: Array<CampaignStatusEnum>, name?: string, orderBy?: string, direction?: OrderDirectionEnum, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListCampaignResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCampaign(authorization, type, status, name, orderBy, direction, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint is meant to be used for getting coupon detail vendor
         * @summary Get coupon detail vendor
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} couponCode coupon Code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async parnersGetCouponDetail(authorization: string, couponCode: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnersGetCouponDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.parnersGetCouponDetail(authorization, couponCode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint will be used to create new product pricelist for store partner
         * @summary Create pricelist of partner
         * @param {PartnerVendorCreateProductPricelistRequest} [partnerVendorCreateProductPricelistRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partnerVendorCreateProductPricelist(partnerVendorCreateProductPricelistRequest?: PartnerVendorCreateProductPricelistRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnerVendorCreateProductPricelistResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partnerVendorCreateProductPricelist(partnerVendorCreateProductPricelistRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint will be called by partner web to get list of product pricelist.
         * @summary Get list of product pricelist for partner web
         * @param {string} [productName] Filter product by product name. If is nil, will return all products. If specified, will return products that have product name that similar the specified value. 
         * @param {string} [vendorId] 
         * @param {PartnerVendorGetProductPricelistsSortEnum} [sort] Sort field name
         * @param {OrderDirectionEnum} [direction] Sort direction
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partnerVendorGetProductPricelists(productName?: string, vendorId?: string, sort?: PartnerVendorGetProductPricelistsSortEnum, direction?: OrderDirectionEnum, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnerVendorGetProductPricelistsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partnerVendorGetProductPricelists(productName, vendorId, sort, direction, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint will be used to update existing product pricelist for store partner
         * @summary Update pricelist of partner
         * @param {string} pricelistId Pricelist UUID
         * @param {PartnerVendorUpdateProductPricelistRequest} partnerVendorUpdateProductPricelistRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partnerVendorUpdateProductPricelist(pricelistId: string, partnerVendorUpdateProductPricelistRequest: PartnerVendorUpdateProductPricelistRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnerVendorUpdateProductPricelistResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partnerVendorUpdateProductPricelist(pricelistId, partnerVendorUpdateProductPricelistRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Asset Summary per Partner, grouped by the Asset Type
         * @summary List Assets Summaries
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partnersAssetsGetSummary(authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnersAssetsGetSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partnersAssetsGetSummary(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Campaign Summary per Partner, grouped by the Campaign Status
         * @summary List Campaign Summaries
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partnersCampaignsGetSummary(authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnersCampaignsGetSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partnersCampaignsGetSummary(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This will be used by all Partner user to confirm pending member request.
         * @summary Confirm Member
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} memberId 
         * @param {PartnersConfirmMemberRequest} partnersConfirmMemberRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partnersConfirmMember(authorization: string, memberId: string, partnersConfirmMemberRequest: PartnersConfirmMemberRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnersConfirmMemberResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partnersConfirmMember(authorization, memberId, partnersConfirmMemberRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Used by a new user to link their Partner account into a specific supplier
         * @summary Link User to Supplier
         * @param {PartnersCreateSupplierLinkRequest} partnersCreateSupplierLinkRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partnersCreateSupplierLink(partnersCreateSupplierLinkRequest: PartnersCreateSupplierLinkRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnersCreateSupplierLinkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partnersCreateSupplierLink(partnersCreateSupplierLinkRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint is meant to be used by FC to see list of ffb price that she/he submitted limited to 20 data 
         * @summary Get List of FFB Price V2 Histories filtered by user id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partnersFFBPricesHistories(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PartnersFfbPricesHistoriesResponseItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partnersFFBPricesHistories(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint is meant to be used to submit feedback by Partner ID. Users can submit their comment and give rating by some parameters as price, weighbridge, queue, sorting, and road access. If the users has submitted feedback before, then they submit it again, it will replace the existing feedback. 
         * @summary Submit Feedback for Partner
         * @param {string} partnerId Partner UUID
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {PartnersFeedbacksCreateRequest} partnersFeedbacksCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partnersFeedbacksCreate(partnerId: string, authorization: string, partnersFeedbacksCreateRequest: PartnersFeedbacksCreateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnersFeedbacksCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partnersFeedbacksCreate(partnerId, authorization, partnersFeedbacksCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint is meant to be used to get feedback list by Partner ID 
         * @summary Get Feedback List per Partner
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} partnerId Partner UUID
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partnersFeedbacksList(aPPTYPE: AppTypeEnum, partnerId: string, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnersFeedbacksListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partnersFeedbacksList(aPPTYPE, partnerId, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Return the summary of a Partner\'s rating
         * @summary Get Feedback Summary per Partner
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} partnerId Partner UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partnersFeedbacksSummary(aPPTYPE: AppTypeEnum, partnerId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnersFeedbacksSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partnersFeedbacksSummary(aPPTYPE, partnerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Return the user feedback for related partner
         * @summary Get Feedback user by Partner ID
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} partnerId Partner UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partnersFeedbacksUser(aPPTYPE: AppTypeEnum, partnerId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeedbackUserForPartnerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partnersFeedbacksUser(aPPTYPE, partnerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint is meant to be used by FC to add FFB Price for each partner 
         * @summary Add FFB Price for each partner
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {PartnersFfbPriceCreateRequest} [partnersFfbPriceCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partnersFfbPriceCreate(authorization: string, partnersFfbPriceCreateRequest?: PartnersFfbPriceCreateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnersFfbPriceCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partnersFfbPriceCreate(authorization, partnersFfbPriceCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint is meant to be used by FC to add FFB Price for each partner 
         * @summary Add FFB Price for each partner
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {PartnersFfbPriceCreateV2Request} [partnersFfbPriceCreateV2Request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partnersFfbPriceCreateV2(authorization: string, partnersFfbPriceCreateV2Request?: PartnersFfbPriceCreateV2Request, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnersFfbPriceCreateV2Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partnersFfbPriceCreateV2(authorization, partnersFfbPriceCreateV2Request, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint is meant to be used by FC to add FFB Price for each partner 
         * @summary Add FFB Price for each partner
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {PartnersFfbPriceCreateV3Request} [partnersFfbPriceCreateV3Request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partnersFfbPriceCreateV3(authorization: string, partnersFfbPriceCreateV3Request?: PartnersFfbPriceCreateV3Request, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnersFfbPriceCreateV3Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partnersFfbPriceCreateV3(authorization, partnersFfbPriceCreateV3Request, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * this endpoint is used by daily limitation checking of Field Coordinator Activity feature. To block their activity if they already submit 5 FFB Price for each day. 
         * @summary Check Limit FFB Price Daily before FC can add FFB Price
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partnersFfbPriceLimitation(authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnersFfbPriceLimitationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partnersFfbPriceLimitation(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This is for get invoice detail by invoice no. 
         * @summary Get Invoice Detail by Invoice No
         * @param {string} phoneNo Phone number of the user, this is for guest mode
         * @param {string} invoiceNo Invoice number of the order
         * @param {string} xRecaptchaResponse  this is for recaptcha response header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partnersFinanceGetInvoiceDetail(phoneNo: string, invoiceNo: string, xRecaptchaResponse: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnersFinanceGetInvoiceDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partnersFinanceGetInvoiceDetail(phoneNo, invoiceNo, xRecaptchaResponse, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint is meant to be used by FC to see list of ffb price that she/he submitted 
         * @summary Get List of FFB Price
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partnersGetFfbPrices(authorization: string, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnersGetFfbPricesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partnersGetFfbPrices(authorization, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Can be accessed by all Partner Web user to see details of a Partner\'s member
         * @summary Get Member Detail
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partnersGetMember(authorization: string, memberId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnersGetMemberResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partnersGetMember(authorization, memberId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Endpoint for a User from one Partner to get list of their members. Default response will show all status with items count limited to 10
         * @summary List Partner Members
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {Array<MemberStatusEnum>} [status] 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partnersGetMembers(authorization: string, status?: Array<MemberStatusEnum>, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnersGetMembersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partnersGetMembers(authorization, status, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint is meant to be used for getting Member list on Campaign creation process.
         * @summary Get Member List per Partner (with Status & Same Campaign Type Status)
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} campaignType ID of the selected Campaign Type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partnersGetMembersStatus(authorization: string, campaignType: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnersGetMembersStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partnersGetMembersStatus(authorization, campaignType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Accessed to see details of a supplier
         * @summary Get Supplier Detail
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} supplierId Supplier ID in UUID type 4 format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partnersGetSupplier(authorization: string, supplierId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnersGetSupplierResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partnersGetSupplier(authorization, supplierId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint is meant to be used for getting Supplier list on Campaign creation process. Partner ID for identifier will be retrieved from JWT. 
         * @summary Get Supplier List on Campaign Creation
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} campaignType ID of the selected Campaign Type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partnersGetSuppliersStatus(authorization: string, campaignType: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnersGetSuppliersStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partnersGetSuppliersStatus(authorization, campaignType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Will be used by all Partner user to get list of specific Partner\'s users
         * @summary Get Users Per Partner
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} partnerId Partner UUID
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partnersGetUsersByPartner(authorization: string, partnerId: string, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnersGetUsersByPartnerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partnersGetUsersByPartner(authorization, partnerId, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Member Summary per Partner, grouped by the Member Status
         * @summary List Members Summaries
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partnersMembersGetSummary(authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnersMembersGetSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partnersMembersGetSummary(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint is meant to be used by partners to create their daily plantation activity plan
         * @summary Partners Plantations Create Schedules
         * @param {PartnersPlantationsCreateSchedulesRequest} [partnersPlantationsCreateSchedulesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partnersPlantationsCreateSchedules(partnersPlantationsCreateSchedulesRequest?: PartnersPlantationsCreateSchedulesRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DefaultSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partnersPlantationsCreateSchedules(partnersPlantationsCreateSchedulesRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Will return list of block assignments that are connected to current user business. Will use User ID from JWT and lookup the block assignments by utilizing `contact` and `business`. 
         * @summary Partners Plantations Get Block Assignments
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} [blockName] the name of block on plantations block assignment
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partnersPlantationsGetBlockAssignments(aPPTYPE: AppTypeEnum, blockName?: string, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnersPlantationsGetBlockAssignmentsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partnersPlantationsGetBlockAssignments(aPPTYPE, blockName, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint is meant to be used by partners web to get their ffb productions
         * @summary Partners Plantations Get FFB Productions
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {number} [month] Month in MM format
         * @param {number} [year] Year in YYYY format
         * @param {string} [sortBy] Sort the results by the specified field.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partnersPlantationsGetFfbProductions(aPPTYPE: AppTypeEnum, month?: number, year?: number, sortBy?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnersPlantationsGetFfbProductionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partnersPlantationsGetFfbProductions(aPPTYPE, month, year, sortBy, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint will be called by partner web to get list of plantations schedules.
         * @summary Get list of plantations schedules for partner web
         * @param {PlantationScheduleStatusEnum} [status] Status of the plantation schedules. No filter applied if empty.
         * @param {PlantationActivityTypeEnum} [plantationActivityType] Type of the plantation activity. No filter applied if empty.
         * @param {Array<string>} [sortBy] Sort the results by the specified field.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partnersPlantationsGetSchedules(status?: PlantationScheduleStatusEnum, plantationActivityType?: PlantationActivityTypeEnum, sortBy?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnersPlantationsGetSchedulesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partnersPlantationsGetSchedules(status, plantationActivityType, sortBy, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Will update partial block assignments that are connected to current user business. Will use User ID from JWT and lookup the block assignments by utilizing `contact` and `business`. 
         * @summary Partners Plantations Update Partial Block Assignments
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} id 
         * @param {PartnersPlantationsUpdatePartialBlockAssignmentsRequest} [partnersPlantationsUpdatePartialBlockAssignmentsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partnersPlantationsUpdatePartialBlockAssignments(aPPTYPE: AppTypeEnum, id: string, partnersPlantationsUpdatePartialBlockAssignmentsRequest?: PartnersPlantationsUpdatePartialBlockAssignmentsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DefaultSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partnersPlantationsUpdatePartialBlockAssignments(aPPTYPE, id, partnersPlantationsUpdatePartialBlockAssignmentsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint is meant to be used by partners to partially update their daily plantation activity plan
         * @summary Partners Plantations Update Schedules Partial
         * @param {string} id 
         * @param {PartnersPlantationsUpdateSchedulesPartialRequest} [partnersPlantationsUpdateSchedulesPartialRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partnersPlantationsUpdateSchedulesPartial(id: string, partnersPlantationsUpdateSchedulesPartialRequest?: PartnersPlantationsUpdateSchedulesPartialRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DefaultSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partnersPlantationsUpdateSchedulesPartial(id, partnersPlantationsUpdateSchedulesPartialRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Request new jwt based on partner id
         * @summary Partners Switch
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {PartnersSwitchRequest} partnersSwitchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partnersSwitch(authorization: string, partnersSwitchRequest: PartnersSwitchRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partnersSwitch(authorization, partnersSwitchRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Used by Partner Admin to create account for another user. Email field is nullable, and status will use default `PARTNER_USER` if not provided. Will send registration SMS to the newly registered user.  # Dependencies  | Service Name | Usage | | ----------- | ----------- | | GCP KMS | Phone number decryption| | Twilio | SMS service | 
         * @summary Register Partner Web User
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {UsersCreateRegistrationRequest} usersCreateRegistrationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partnersUsersCreateRegistration(authorization: string, usersCreateRegistrationRequest: UsersCreateRegistrationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UsersCreateRegistrationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partnersUsersCreateRegistration(authorization, usersCreateRegistrationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Validate the OTP Token (in UUID) received from Register User endpoint
         * @summary Validate Registration Token
         * @param {PartnersUsersVerifyRegistrationRequest} partnersUsersVerifyRegistrationRequest 
         * @param {AppTypeEnum} [aPPTYPE] The name of the app that\&#39;s accessing the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partnersUsersVerifyRegistration(partnersUsersVerifyRegistrationRequest: PartnersUsersVerifyRegistrationRequest, aPPTYPE?: AppTypeEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partnersUsersVerifyRegistration(partnersUsersVerifyRegistrationRequest, aPPTYPE, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * this is for getting eligible vendor list of coupon
         * @summary Get Redeemed Coupon by Vendor ID
         * @param {string} vendorId Vendor Id
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {string} [customerName] Customer Name
         * @param {number} [redeemedDateTo] Redeemed Date To
         * @param {number} [redeemedDateFrom] Redeemed Date From
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partnersVendorGetRedeemedCoupons(vendorId: string, page?: number, limit?: number, customerName?: string, redeemedDateTo?: number, redeemedDateFrom?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnersVendorGetRedeemedCouponsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partnersVendorGetRedeemedCoupons(vendorId, page, limit, customerName, redeemedDateTo, redeemedDateFrom, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Endpoint for Partner to show list of Suppliers.<br><br>  Partner ID for identifier will be retrieved from JWT.<br><br>  Default response will show all status with items count limited to 10. 
         * @summary List Suppliers
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {Array<MemberStatusEnum>} [status] 
         * @param {string} [supplierName] Search query for supplier by Nama
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supplierList(authorization: string, status?: Array<MemberStatusEnum>, supplierName?: string, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnersGetSuppliersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supplierList(authorization, status, supplierName, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Will be used by Partner admin to update Partner\'s user account. Will update the user data based on given parameters.
         * @summary Update User
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} userId 
         * @param {UpdateUserRequest} [updateUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUser(authorization: string, userId: string, updateUserRequest?: UpdateUserRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUser(authorization, userId, updateUserRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Used by all Partner user to create a new campaign V2
         * @summary Create New Campaign V2
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {V2CreateCampaignRequest} [v2CreateCampaignRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2CreateCampaign(authorization: string, v2CreateCampaignRequest?: V2CreateCampaignRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateEditCampaignResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2CreateCampaign(authorization, v2CreateCampaignRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint is meant to be used by FC to see list of ffb price that she/he submitted filtered by month and year 
         * @summary Get List of FFB Price V2 filter by month and year
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {number} [month] Month in MM format
         * @param {number} [year] Year in YYYY format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2PartnersGetFfbPrices(page?: number, limit?: number, month?: number, year?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V2PartnersGetFfbPricesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2PartnersGetFfbPrices(page, limit, month, year, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Can be accessed by all Partner Web user to see details of a Partner\'s member
         * @summary Get Member Detail V2
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2PartnersGetMember(authorization: string, userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V2PartnersGetMemberResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2PartnersGetMember(authorization, userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Endpoint for a User from one Partner to get list of their members. Default response will show all status with items count limited to 10
         * @summary List Partner Members V2
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {Array<MemberStatusEnum>} [status] 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2PartnersGetMembers(authorization: string, status?: Array<MemberStatusEnum>, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V2PartnersGetMembersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2PartnersGetMembers(authorization, status, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PartnersApi - factory interface
 * @export
 */
export const PartnersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PartnersApiFp(configuration)
    return {
        /**
         * 
         * @summary Activate/Deactivate User
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} userId 
         * @param {ActivateUserRequest} [activateUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateUser(authorization: string, userId: string, activateUserRequest?: ActivateUserRequest, options?: any): AxiosPromise<ActivateUserResponse> {
            return localVarFp.activateUser(authorization, userId, activateUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Used by all Partner user to add participants on a campaign
         * @summary Add New Campaign Participants
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} campaignId Campaign ID, represented in UUID type 4 format
         * @param {CampaignAddParticipantRequest} [campaignAddParticipantRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignAddParticipant(authorization: string, campaignId: string, campaignAddParticipantRequest?: CampaignAddParticipantRequest, options?: any): AxiosPromise<void> {
            return localVarFp.campaignAddParticipant(authorization, campaignId, campaignAddParticipantRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Will be used by all Partner users to cancel campaign if status is still `SCHEDULED`
         * @summary Cancel Campaign
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} campaignId Campaign ID, represented in UUID type 4 format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelCampaign(authorization: string, campaignId: string, options?: any): AxiosPromise<CancelCampaignResponse> {
            return localVarFp.cancelCampaign(authorization, campaignId, options).then((request) => request(axios, basePath));
        },
        /**
         * Used by all Partner user to create a new campaign
         * @summary Create New Campaign
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {CreateCampaignRequest} [createCampaignRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCampaign(authorization: string, createCampaignRequest?: CreateCampaignRequest, options?: any): AxiosPromise<CreateEditCampaignResponse> {
            return localVarFp.createCampaign(authorization, createCampaignRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Will be used by all Partner users to edit a campaign (only for the one with `SCHEDULED` status)
         * @summary Edit Campaign
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} campaignId Campaign ID, represented in UUID type 4 format
         * @param {EditCampaignRequest} [editCampaignRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editCampaign(authorization: string, campaignId: string, editCampaignRequest?: EditCampaignRequest, options?: any): AxiosPromise<CreateEditCampaignResponse> {
            return localVarFp.editCampaign(authorization, campaignId, editCampaignRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Will be used by all Partner user to view one of their campaign details
         * @summary Get Campaign Details
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} campaignId Campaign ID, represented in UUID type 4 format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaign(authorization: string, campaignId: string, options?: any): AxiosPromise<GetCampaignResponse> {
            return localVarFp.getCampaign(authorization, campaignId, options).then((request) => request(axios, basePath));
        },
        /**
         * Will be used by all Partner users to retrieve their own role including the list of Partners that they manage
         * @summary Get User Role
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserRole(authorization: string, options?: any): AxiosPromise<GetUserRoleResponse> {
            return localVarFp.getUserRole(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Used by all Partner user to retrieve list of campaigns. `status` query parameter allow list by using coma delimiter, will show all status if not specified
         * @summary List Campaign
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {Array<string>} [type] Filled with campaign type ID (from Get Campaign Types). Default will show campaign type
         * @param {Array<CampaignStatusEnum>} [status] 
         * @param {string} [name] Search query for campaign by Nama Promosi
         * @param {string} [orderBy] Column used for ordering, will accept the field name from response object
         * @param {OrderDirectionEnum} [direction] 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCampaign(authorization: string, type?: Array<string>, status?: Array<CampaignStatusEnum>, name?: string, orderBy?: string, direction?: OrderDirectionEnum, page?: number, limit?: number, options?: any): AxiosPromise<ListCampaignResponse> {
            return localVarFp.listCampaign(authorization, type, status, name, orderBy, direction, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint is meant to be used for getting coupon detail vendor
         * @summary Get coupon detail vendor
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} couponCode coupon Code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parnersGetCouponDetail(authorization: string, couponCode: string, options?: any): AxiosPromise<PartnersGetCouponDetailResponse> {
            return localVarFp.parnersGetCouponDetail(authorization, couponCode, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint will be used to create new product pricelist for store partner
         * @summary Create pricelist of partner
         * @param {PartnerVendorCreateProductPricelistRequest} [partnerVendorCreateProductPricelistRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerVendorCreateProductPricelist(partnerVendorCreateProductPricelistRequest?: PartnerVendorCreateProductPricelistRequest, options?: any): AxiosPromise<PartnerVendorCreateProductPricelistResponse> {
            return localVarFp.partnerVendorCreateProductPricelist(partnerVendorCreateProductPricelistRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint will be called by partner web to get list of product pricelist.
         * @summary Get list of product pricelist for partner web
         * @param {string} [productName] Filter product by product name. If is nil, will return all products. If specified, will return products that have product name that similar the specified value. 
         * @param {string} [vendorId] 
         * @param {PartnerVendorGetProductPricelistsSortEnum} [sort] Sort field name
         * @param {OrderDirectionEnum} [direction] Sort direction
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerVendorGetProductPricelists(productName?: string, vendorId?: string, sort?: PartnerVendorGetProductPricelistsSortEnum, direction?: OrderDirectionEnum, page?: number, limit?: number, options?: any): AxiosPromise<PartnerVendorGetProductPricelistsResponse> {
            return localVarFp.partnerVendorGetProductPricelists(productName, vendorId, sort, direction, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint will be used to update existing product pricelist for store partner
         * @summary Update pricelist of partner
         * @param {string} pricelistId Pricelist UUID
         * @param {PartnerVendorUpdateProductPricelistRequest} partnerVendorUpdateProductPricelistRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerVendorUpdateProductPricelist(pricelistId: string, partnerVendorUpdateProductPricelistRequest: PartnerVendorUpdateProductPricelistRequest, options?: any): AxiosPromise<PartnerVendorUpdateProductPricelistResponse> {
            return localVarFp.partnerVendorUpdateProductPricelist(pricelistId, partnerVendorUpdateProductPricelistRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Asset Summary per Partner, grouped by the Asset Type
         * @summary List Assets Summaries
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersAssetsGetSummary(authorization: string, options?: any): AxiosPromise<PartnersAssetsGetSummaryResponse> {
            return localVarFp.partnersAssetsGetSummary(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Campaign Summary per Partner, grouped by the Campaign Status
         * @summary List Campaign Summaries
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersCampaignsGetSummary(authorization: string, options?: any): AxiosPromise<PartnersCampaignsGetSummaryResponse> {
            return localVarFp.partnersCampaignsGetSummary(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * This will be used by all Partner user to confirm pending member request.
         * @summary Confirm Member
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} memberId 
         * @param {PartnersConfirmMemberRequest} partnersConfirmMemberRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersConfirmMember(authorization: string, memberId: string, partnersConfirmMemberRequest: PartnersConfirmMemberRequest, options?: any): AxiosPromise<PartnersConfirmMemberResponse> {
            return localVarFp.partnersConfirmMember(authorization, memberId, partnersConfirmMemberRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Used by a new user to link their Partner account into a specific supplier
         * @summary Link User to Supplier
         * @param {PartnersCreateSupplierLinkRequest} partnersCreateSupplierLinkRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersCreateSupplierLink(partnersCreateSupplierLinkRequest: PartnersCreateSupplierLinkRequest, options?: any): AxiosPromise<PartnersCreateSupplierLinkResponse> {
            return localVarFp.partnersCreateSupplierLink(partnersCreateSupplierLinkRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint is meant to be used by FC to see list of ffb price that she/he submitted limited to 20 data 
         * @summary Get List of FFB Price V2 Histories filtered by user id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersFFBPricesHistories(options?: any): AxiosPromise<Array<PartnersFfbPricesHistoriesResponseItem>> {
            return localVarFp.partnersFFBPricesHistories(options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint is meant to be used to submit feedback by Partner ID. Users can submit their comment and give rating by some parameters as price, weighbridge, queue, sorting, and road access. If the users has submitted feedback before, then they submit it again, it will replace the existing feedback. 
         * @summary Submit Feedback for Partner
         * @param {string} partnerId Partner UUID
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {PartnersFeedbacksCreateRequest} partnersFeedbacksCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersFeedbacksCreate(partnerId: string, authorization: string, partnersFeedbacksCreateRequest: PartnersFeedbacksCreateRequest, options?: any): AxiosPromise<PartnersFeedbacksCreateResponse> {
            return localVarFp.partnersFeedbacksCreate(partnerId, authorization, partnersFeedbacksCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint is meant to be used to get feedback list by Partner ID 
         * @summary Get Feedback List per Partner
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} partnerId Partner UUID
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersFeedbacksList(aPPTYPE: AppTypeEnum, partnerId: string, page?: number, limit?: number, options?: any): AxiosPromise<PartnersFeedbacksListResponse> {
            return localVarFp.partnersFeedbacksList(aPPTYPE, partnerId, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Return the summary of a Partner\'s rating
         * @summary Get Feedback Summary per Partner
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} partnerId Partner UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersFeedbacksSummary(aPPTYPE: AppTypeEnum, partnerId: string, options?: any): AxiosPromise<PartnersFeedbacksSummaryResponse> {
            return localVarFp.partnersFeedbacksSummary(aPPTYPE, partnerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Return the user feedback for related partner
         * @summary Get Feedback user by Partner ID
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} partnerId Partner UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersFeedbacksUser(aPPTYPE: AppTypeEnum, partnerId: string, options?: any): AxiosPromise<FeedbackUserForPartnerResponse> {
            return localVarFp.partnersFeedbacksUser(aPPTYPE, partnerId, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint is meant to be used by FC to add FFB Price for each partner 
         * @summary Add FFB Price for each partner
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {PartnersFfbPriceCreateRequest} [partnersFfbPriceCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersFfbPriceCreate(authorization: string, partnersFfbPriceCreateRequest?: PartnersFfbPriceCreateRequest, options?: any): AxiosPromise<PartnersFfbPriceCreateResponse> {
            return localVarFp.partnersFfbPriceCreate(authorization, partnersFfbPriceCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint is meant to be used by FC to add FFB Price for each partner 
         * @summary Add FFB Price for each partner
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {PartnersFfbPriceCreateV2Request} [partnersFfbPriceCreateV2Request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersFfbPriceCreateV2(authorization: string, partnersFfbPriceCreateV2Request?: PartnersFfbPriceCreateV2Request, options?: any): AxiosPromise<PartnersFfbPriceCreateV2Response> {
            return localVarFp.partnersFfbPriceCreateV2(authorization, partnersFfbPriceCreateV2Request, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint is meant to be used by FC to add FFB Price for each partner 
         * @summary Add FFB Price for each partner
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {PartnersFfbPriceCreateV3Request} [partnersFfbPriceCreateV3Request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersFfbPriceCreateV3(authorization: string, partnersFfbPriceCreateV3Request?: PartnersFfbPriceCreateV3Request, options?: any): AxiosPromise<PartnersFfbPriceCreateV3Response> {
            return localVarFp.partnersFfbPriceCreateV3(authorization, partnersFfbPriceCreateV3Request, options).then((request) => request(axios, basePath));
        },
        /**
         * this endpoint is used by daily limitation checking of Field Coordinator Activity feature. To block their activity if they already submit 5 FFB Price for each day. 
         * @summary Check Limit FFB Price Daily before FC can add FFB Price
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersFfbPriceLimitation(authorization: string, options?: any): AxiosPromise<PartnersFfbPriceLimitationResponse> {
            return localVarFp.partnersFfbPriceLimitation(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * This is for get invoice detail by invoice no. 
         * @summary Get Invoice Detail by Invoice No
         * @param {string} phoneNo Phone number of the user, this is for guest mode
         * @param {string} invoiceNo Invoice number of the order
         * @param {string} xRecaptchaResponse  this is for recaptcha response header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersFinanceGetInvoiceDetail(phoneNo: string, invoiceNo: string, xRecaptchaResponse: string, options?: any): AxiosPromise<PartnersFinanceGetInvoiceDetailResponse> {
            return localVarFp.partnersFinanceGetInvoiceDetail(phoneNo, invoiceNo, xRecaptchaResponse, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint is meant to be used by FC to see list of ffb price that she/he submitted 
         * @summary Get List of FFB Price
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersGetFfbPrices(authorization: string, page?: number, limit?: number, options?: any): AxiosPromise<PartnersGetFfbPricesResponse> {
            return localVarFp.partnersGetFfbPrices(authorization, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Can be accessed by all Partner Web user to see details of a Partner\'s member
         * @summary Get Member Detail
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersGetMember(authorization: string, memberId: string, options?: any): AxiosPromise<PartnersGetMemberResponse> {
            return localVarFp.partnersGetMember(authorization, memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint for a User from one Partner to get list of their members. Default response will show all status with items count limited to 10
         * @summary List Partner Members
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {Array<MemberStatusEnum>} [status] 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersGetMembers(authorization: string, status?: Array<MemberStatusEnum>, page?: number, limit?: number, options?: any): AxiosPromise<PartnersGetMembersResponse> {
            return localVarFp.partnersGetMembers(authorization, status, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint is meant to be used for getting Member list on Campaign creation process.
         * @summary Get Member List per Partner (with Status & Same Campaign Type Status)
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} campaignType ID of the selected Campaign Type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersGetMembersStatus(authorization: string, campaignType: string, options?: any): AxiosPromise<PartnersGetMembersStatusResponse> {
            return localVarFp.partnersGetMembersStatus(authorization, campaignType, options).then((request) => request(axios, basePath));
        },
        /**
         * Accessed to see details of a supplier
         * @summary Get Supplier Detail
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} supplierId Supplier ID in UUID type 4 format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersGetSupplier(authorization: string, supplierId: string, options?: any): AxiosPromise<PartnersGetSupplierResponse> {
            return localVarFp.partnersGetSupplier(authorization, supplierId, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint is meant to be used for getting Supplier list on Campaign creation process. Partner ID for identifier will be retrieved from JWT. 
         * @summary Get Supplier List on Campaign Creation
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} campaignType ID of the selected Campaign Type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersGetSuppliersStatus(authorization: string, campaignType: string, options?: any): AxiosPromise<PartnersGetSuppliersStatusResponse> {
            return localVarFp.partnersGetSuppliersStatus(authorization, campaignType, options).then((request) => request(axios, basePath));
        },
        /**
         * Will be used by all Partner user to get list of specific Partner\'s users
         * @summary Get Users Per Partner
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} partnerId Partner UUID
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersGetUsersByPartner(authorization: string, partnerId: string, page?: number, limit?: number, options?: any): AxiosPromise<PartnersGetUsersByPartnerResponse> {
            return localVarFp.partnersGetUsersByPartner(authorization, partnerId, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Member Summary per Partner, grouped by the Member Status
         * @summary List Members Summaries
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersMembersGetSummary(authorization: string, options?: any): AxiosPromise<PartnersMembersGetSummaryResponse> {
            return localVarFp.partnersMembersGetSummary(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint is meant to be used by partners to create their daily plantation activity plan
         * @summary Partners Plantations Create Schedules
         * @param {PartnersPlantationsCreateSchedulesRequest} [partnersPlantationsCreateSchedulesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersPlantationsCreateSchedules(partnersPlantationsCreateSchedulesRequest?: PartnersPlantationsCreateSchedulesRequest, options?: any): AxiosPromise<DefaultSuccessResponse> {
            return localVarFp.partnersPlantationsCreateSchedules(partnersPlantationsCreateSchedulesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Will return list of block assignments that are connected to current user business. Will use User ID from JWT and lookup the block assignments by utilizing `contact` and `business`. 
         * @summary Partners Plantations Get Block Assignments
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} [blockName] the name of block on plantations block assignment
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersPlantationsGetBlockAssignments(aPPTYPE: AppTypeEnum, blockName?: string, page?: number, limit?: number, options?: any): AxiosPromise<PartnersPlantationsGetBlockAssignmentsResponse> {
            return localVarFp.partnersPlantationsGetBlockAssignments(aPPTYPE, blockName, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint is meant to be used by partners web to get their ffb productions
         * @summary Partners Plantations Get FFB Productions
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {number} [month] Month in MM format
         * @param {number} [year] Year in YYYY format
         * @param {string} [sortBy] Sort the results by the specified field.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersPlantationsGetFfbProductions(aPPTYPE: AppTypeEnum, month?: number, year?: number, sortBy?: string, options?: any): AxiosPromise<PartnersPlantationsGetFfbProductionsResponse> {
            return localVarFp.partnersPlantationsGetFfbProductions(aPPTYPE, month, year, sortBy, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint will be called by partner web to get list of plantations schedules.
         * @summary Get list of plantations schedules for partner web
         * @param {PlantationScheduleStatusEnum} [status] Status of the plantation schedules. No filter applied if empty.
         * @param {PlantationActivityTypeEnum} [plantationActivityType] Type of the plantation activity. No filter applied if empty.
         * @param {Array<string>} [sortBy] Sort the results by the specified field.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersPlantationsGetSchedules(status?: PlantationScheduleStatusEnum, plantationActivityType?: PlantationActivityTypeEnum, sortBy?: Array<string>, options?: any): AxiosPromise<PartnersPlantationsGetSchedulesResponse> {
            return localVarFp.partnersPlantationsGetSchedules(status, plantationActivityType, sortBy, options).then((request) => request(axios, basePath));
        },
        /**
         * Will update partial block assignments that are connected to current user business. Will use User ID from JWT and lookup the block assignments by utilizing `contact` and `business`. 
         * @summary Partners Plantations Update Partial Block Assignments
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} id 
         * @param {PartnersPlantationsUpdatePartialBlockAssignmentsRequest} [partnersPlantationsUpdatePartialBlockAssignmentsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersPlantationsUpdatePartialBlockAssignments(aPPTYPE: AppTypeEnum, id: string, partnersPlantationsUpdatePartialBlockAssignmentsRequest?: PartnersPlantationsUpdatePartialBlockAssignmentsRequest, options?: any): AxiosPromise<DefaultSuccessResponse> {
            return localVarFp.partnersPlantationsUpdatePartialBlockAssignments(aPPTYPE, id, partnersPlantationsUpdatePartialBlockAssignmentsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint is meant to be used by partners to partially update their daily plantation activity plan
         * @summary Partners Plantations Update Schedules Partial
         * @param {string} id 
         * @param {PartnersPlantationsUpdateSchedulesPartialRequest} [partnersPlantationsUpdateSchedulesPartialRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersPlantationsUpdateSchedulesPartial(id: string, partnersPlantationsUpdateSchedulesPartialRequest?: PartnersPlantationsUpdateSchedulesPartialRequest, options?: any): AxiosPromise<DefaultSuccessResponse> {
            return localVarFp.partnersPlantationsUpdateSchedulesPartial(id, partnersPlantationsUpdateSchedulesPartialRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Request new jwt based on partner id
         * @summary Partners Switch
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {PartnersSwitchRequest} partnersSwitchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersSwitch(authorization: string, partnersSwitchRequest: PartnersSwitchRequest, options?: any): AxiosPromise<void> {
            return localVarFp.partnersSwitch(authorization, partnersSwitchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Used by Partner Admin to create account for another user. Email field is nullable, and status will use default `PARTNER_USER` if not provided. Will send registration SMS to the newly registered user.  # Dependencies  | Service Name | Usage | | ----------- | ----------- | | GCP KMS | Phone number decryption| | Twilio | SMS service | 
         * @summary Register Partner Web User
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {UsersCreateRegistrationRequest} usersCreateRegistrationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersUsersCreateRegistration(authorization: string, usersCreateRegistrationRequest: UsersCreateRegistrationRequest, options?: any): AxiosPromise<UsersCreateRegistrationResponse> {
            return localVarFp.partnersUsersCreateRegistration(authorization, usersCreateRegistrationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Validate the OTP Token (in UUID) received from Register User endpoint
         * @summary Validate Registration Token
         * @param {PartnersUsersVerifyRegistrationRequest} partnersUsersVerifyRegistrationRequest 
         * @param {AppTypeEnum} [aPPTYPE] The name of the app that\&#39;s accessing the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersUsersVerifyRegistration(partnersUsersVerifyRegistrationRequest: PartnersUsersVerifyRegistrationRequest, aPPTYPE?: AppTypeEnum, options?: any): AxiosPromise<void> {
            return localVarFp.partnersUsersVerifyRegistration(partnersUsersVerifyRegistrationRequest, aPPTYPE, options).then((request) => request(axios, basePath));
        },
        /**
         * this is for getting eligible vendor list of coupon
         * @summary Get Redeemed Coupon by Vendor ID
         * @param {string} vendorId Vendor Id
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {string} [customerName] Customer Name
         * @param {number} [redeemedDateTo] Redeemed Date To
         * @param {number} [redeemedDateFrom] Redeemed Date From
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersVendorGetRedeemedCoupons(vendorId: string, page?: number, limit?: number, customerName?: string, redeemedDateTo?: number, redeemedDateFrom?: number, options?: any): AxiosPromise<PartnersVendorGetRedeemedCouponsResponse> {
            return localVarFp.partnersVendorGetRedeemedCoupons(vendorId, page, limit, customerName, redeemedDateTo, redeemedDateFrom, options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint for Partner to show list of Suppliers.<br><br>  Partner ID for identifier will be retrieved from JWT.<br><br>  Default response will show all status with items count limited to 10. 
         * @summary List Suppliers
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {Array<MemberStatusEnum>} [status] 
         * @param {string} [supplierName] Search query for supplier by Nama
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supplierList(authorization: string, status?: Array<MemberStatusEnum>, supplierName?: string, page?: number, limit?: number, options?: any): AxiosPromise<PartnersGetSuppliersResponse> {
            return localVarFp.supplierList(authorization, status, supplierName, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Will be used by Partner admin to update Partner\'s user account. Will update the user data based on given parameters.
         * @summary Update User
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} userId 
         * @param {UpdateUserRequest} [updateUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser(authorization: string, userId: string, updateUserRequest?: UpdateUserRequest, options?: any): AxiosPromise<UpdateUserResponse> {
            return localVarFp.updateUser(authorization, userId, updateUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Used by all Partner user to create a new campaign V2
         * @summary Create New Campaign V2
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {V2CreateCampaignRequest} [v2CreateCampaignRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CreateCampaign(authorization: string, v2CreateCampaignRequest?: V2CreateCampaignRequest, options?: any): AxiosPromise<CreateEditCampaignResponse> {
            return localVarFp.v2CreateCampaign(authorization, v2CreateCampaignRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint is meant to be used by FC to see list of ffb price that she/he submitted filtered by month and year 
         * @summary Get List of FFB Price V2 filter by month and year
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {number} [month] Month in MM format
         * @param {number} [year] Year in YYYY format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2PartnersGetFfbPrices(page?: number, limit?: number, month?: number, year?: number, options?: any): AxiosPromise<V2PartnersGetFfbPricesResponse> {
            return localVarFp.v2PartnersGetFfbPrices(page, limit, month, year, options).then((request) => request(axios, basePath));
        },
        /**
         * Can be accessed by all Partner Web user to see details of a Partner\'s member
         * @summary Get Member Detail V2
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2PartnersGetMember(authorization: string, userId: string, options?: any): AxiosPromise<V2PartnersGetMemberResponse> {
            return localVarFp.v2PartnersGetMember(authorization, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint for a User from one Partner to get list of their members. Default response will show all status with items count limited to 10
         * @summary List Partner Members V2
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {Array<MemberStatusEnum>} [status] 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2PartnersGetMembers(authorization: string, status?: Array<MemberStatusEnum>, page?: number, limit?: number, options?: any): AxiosPromise<V2PartnersGetMembersResponse> {
            return localVarFp.v2PartnersGetMembers(authorization, status, page, limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PartnersApi - object-oriented interface
 * @export
 * @class PartnersApi
 * @extends {BaseAPI}
 */
export class PartnersApi extends BaseAPI {
    /**
     * 
     * @summary Activate/Deactivate User
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {string} userId 
     * @param {ActivateUserRequest} [activateUserRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public activateUser(authorization: string, userId: string, activateUserRequest?: ActivateUserRequest, options?: AxiosRequestConfig) {
        return PartnersApiFp(this.configuration).activateUser(authorization, userId, activateUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Used by all Partner user to add participants on a campaign
     * @summary Add New Campaign Participants
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {string} campaignId Campaign ID, represented in UUID type 4 format
     * @param {CampaignAddParticipantRequest} [campaignAddParticipantRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public campaignAddParticipant(authorization: string, campaignId: string, campaignAddParticipantRequest?: CampaignAddParticipantRequest, options?: AxiosRequestConfig) {
        return PartnersApiFp(this.configuration).campaignAddParticipant(authorization, campaignId, campaignAddParticipantRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Will be used by all Partner users to cancel campaign if status is still `SCHEDULED`
     * @summary Cancel Campaign
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {string} campaignId Campaign ID, represented in UUID type 4 format
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public cancelCampaign(authorization: string, campaignId: string, options?: AxiosRequestConfig) {
        return PartnersApiFp(this.configuration).cancelCampaign(authorization, campaignId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Used by all Partner user to create a new campaign
     * @summary Create New Campaign
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {CreateCampaignRequest} [createCampaignRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public createCampaign(authorization: string, createCampaignRequest?: CreateCampaignRequest, options?: AxiosRequestConfig) {
        return PartnersApiFp(this.configuration).createCampaign(authorization, createCampaignRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Will be used by all Partner users to edit a campaign (only for the one with `SCHEDULED` status)
     * @summary Edit Campaign
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {string} campaignId Campaign ID, represented in UUID type 4 format
     * @param {EditCampaignRequest} [editCampaignRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public editCampaign(authorization: string, campaignId: string, editCampaignRequest?: EditCampaignRequest, options?: AxiosRequestConfig) {
        return PartnersApiFp(this.configuration).editCampaign(authorization, campaignId, editCampaignRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Will be used by all Partner user to view one of their campaign details
     * @summary Get Campaign Details
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {string} campaignId Campaign ID, represented in UUID type 4 format
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public getCampaign(authorization: string, campaignId: string, options?: AxiosRequestConfig) {
        return PartnersApiFp(this.configuration).getCampaign(authorization, campaignId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Will be used by all Partner users to retrieve their own role including the list of Partners that they manage
     * @summary Get User Role
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public getUserRole(authorization: string, options?: AxiosRequestConfig) {
        return PartnersApiFp(this.configuration).getUserRole(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Used by all Partner user to retrieve list of campaigns. `status` query parameter allow list by using coma delimiter, will show all status if not specified
     * @summary List Campaign
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {Array<string>} [type] Filled with campaign type ID (from Get Campaign Types). Default will show campaign type
     * @param {Array<CampaignStatusEnum>} [status] 
     * @param {string} [name] Search query for campaign by Nama Promosi
     * @param {string} [orderBy] Column used for ordering, will accept the field name from response object
     * @param {OrderDirectionEnum} [direction] 
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public listCampaign(authorization: string, type?: Array<string>, status?: Array<CampaignStatusEnum>, name?: string, orderBy?: string, direction?: OrderDirectionEnum, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return PartnersApiFp(this.configuration).listCampaign(authorization, type, status, name, orderBy, direction, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint is meant to be used for getting coupon detail vendor
     * @summary Get coupon detail vendor
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {string} couponCode coupon Code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public parnersGetCouponDetail(authorization: string, couponCode: string, options?: AxiosRequestConfig) {
        return PartnersApiFp(this.configuration).parnersGetCouponDetail(authorization, couponCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint will be used to create new product pricelist for store partner
     * @summary Create pricelist of partner
     * @param {PartnerVendorCreateProductPricelistRequest} [partnerVendorCreateProductPricelistRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public partnerVendorCreateProductPricelist(partnerVendorCreateProductPricelistRequest?: PartnerVendorCreateProductPricelistRequest, options?: AxiosRequestConfig) {
        return PartnersApiFp(this.configuration).partnerVendorCreateProductPricelist(partnerVendorCreateProductPricelistRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint will be called by partner web to get list of product pricelist.
     * @summary Get list of product pricelist for partner web
     * @param {string} [productName] Filter product by product name. If is nil, will return all products. If specified, will return products that have product name that similar the specified value. 
     * @param {string} [vendorId] 
     * @param {PartnerVendorGetProductPricelistsSortEnum} [sort] Sort field name
     * @param {OrderDirectionEnum} [direction] Sort direction
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public partnerVendorGetProductPricelists(productName?: string, vendorId?: string, sort?: PartnerVendorGetProductPricelistsSortEnum, direction?: OrderDirectionEnum, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return PartnersApiFp(this.configuration).partnerVendorGetProductPricelists(productName, vendorId, sort, direction, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint will be used to update existing product pricelist for store partner
     * @summary Update pricelist of partner
     * @param {string} pricelistId Pricelist UUID
     * @param {PartnerVendorUpdateProductPricelistRequest} partnerVendorUpdateProductPricelistRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public partnerVendorUpdateProductPricelist(pricelistId: string, partnerVendorUpdateProductPricelistRequest: PartnerVendorUpdateProductPricelistRequest, options?: AxiosRequestConfig) {
        return PartnersApiFp(this.configuration).partnerVendorUpdateProductPricelist(pricelistId, partnerVendorUpdateProductPricelistRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Asset Summary per Partner, grouped by the Asset Type
     * @summary List Assets Summaries
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public partnersAssetsGetSummary(authorization: string, options?: AxiosRequestConfig) {
        return PartnersApiFp(this.configuration).partnersAssetsGetSummary(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Campaign Summary per Partner, grouped by the Campaign Status
     * @summary List Campaign Summaries
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public partnersCampaignsGetSummary(authorization: string, options?: AxiosRequestConfig) {
        return PartnersApiFp(this.configuration).partnersCampaignsGetSummary(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This will be used by all Partner user to confirm pending member request.
     * @summary Confirm Member
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {string} memberId 
     * @param {PartnersConfirmMemberRequest} partnersConfirmMemberRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public partnersConfirmMember(authorization: string, memberId: string, partnersConfirmMemberRequest: PartnersConfirmMemberRequest, options?: AxiosRequestConfig) {
        return PartnersApiFp(this.configuration).partnersConfirmMember(authorization, memberId, partnersConfirmMemberRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Used by a new user to link their Partner account into a specific supplier
     * @summary Link User to Supplier
     * @param {PartnersCreateSupplierLinkRequest} partnersCreateSupplierLinkRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public partnersCreateSupplierLink(partnersCreateSupplierLinkRequest: PartnersCreateSupplierLinkRequest, options?: AxiosRequestConfig) {
        return PartnersApiFp(this.configuration).partnersCreateSupplierLink(partnersCreateSupplierLinkRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint is meant to be used by FC to see list of ffb price that she/he submitted limited to 20 data 
     * @summary Get List of FFB Price V2 Histories filtered by user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public partnersFFBPricesHistories(options?: AxiosRequestConfig) {
        return PartnersApiFp(this.configuration).partnersFFBPricesHistories(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint is meant to be used to submit feedback by Partner ID. Users can submit their comment and give rating by some parameters as price, weighbridge, queue, sorting, and road access. If the users has submitted feedback before, then they submit it again, it will replace the existing feedback. 
     * @summary Submit Feedback for Partner
     * @param {string} partnerId Partner UUID
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {PartnersFeedbacksCreateRequest} partnersFeedbacksCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public partnersFeedbacksCreate(partnerId: string, authorization: string, partnersFeedbacksCreateRequest: PartnersFeedbacksCreateRequest, options?: AxiosRequestConfig) {
        return PartnersApiFp(this.configuration).partnersFeedbacksCreate(partnerId, authorization, partnersFeedbacksCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint is meant to be used to get feedback list by Partner ID 
     * @summary Get Feedback List per Partner
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} partnerId Partner UUID
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public partnersFeedbacksList(aPPTYPE: AppTypeEnum, partnerId: string, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return PartnersApiFp(this.configuration).partnersFeedbacksList(aPPTYPE, partnerId, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the summary of a Partner\'s rating
     * @summary Get Feedback Summary per Partner
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} partnerId Partner UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public partnersFeedbacksSummary(aPPTYPE: AppTypeEnum, partnerId: string, options?: AxiosRequestConfig) {
        return PartnersApiFp(this.configuration).partnersFeedbacksSummary(aPPTYPE, partnerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the user feedback for related partner
     * @summary Get Feedback user by Partner ID
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} partnerId Partner UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public partnersFeedbacksUser(aPPTYPE: AppTypeEnum, partnerId: string, options?: AxiosRequestConfig) {
        return PartnersApiFp(this.configuration).partnersFeedbacksUser(aPPTYPE, partnerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint is meant to be used by FC to add FFB Price for each partner 
     * @summary Add FFB Price for each partner
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {PartnersFfbPriceCreateRequest} [partnersFfbPriceCreateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public partnersFfbPriceCreate(authorization: string, partnersFfbPriceCreateRequest?: PartnersFfbPriceCreateRequest, options?: AxiosRequestConfig) {
        return PartnersApiFp(this.configuration).partnersFfbPriceCreate(authorization, partnersFfbPriceCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint is meant to be used by FC to add FFB Price for each partner 
     * @summary Add FFB Price for each partner
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {PartnersFfbPriceCreateV2Request} [partnersFfbPriceCreateV2Request] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public partnersFfbPriceCreateV2(authorization: string, partnersFfbPriceCreateV2Request?: PartnersFfbPriceCreateV2Request, options?: AxiosRequestConfig) {
        return PartnersApiFp(this.configuration).partnersFfbPriceCreateV2(authorization, partnersFfbPriceCreateV2Request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint is meant to be used by FC to add FFB Price for each partner 
     * @summary Add FFB Price for each partner
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {PartnersFfbPriceCreateV3Request} [partnersFfbPriceCreateV3Request] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public partnersFfbPriceCreateV3(authorization: string, partnersFfbPriceCreateV3Request?: PartnersFfbPriceCreateV3Request, options?: AxiosRequestConfig) {
        return PartnersApiFp(this.configuration).partnersFfbPriceCreateV3(authorization, partnersFfbPriceCreateV3Request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * this endpoint is used by daily limitation checking of Field Coordinator Activity feature. To block their activity if they already submit 5 FFB Price for each day. 
     * @summary Check Limit FFB Price Daily before FC can add FFB Price
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public partnersFfbPriceLimitation(authorization: string, options?: AxiosRequestConfig) {
        return PartnersApiFp(this.configuration).partnersFfbPriceLimitation(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This is for get invoice detail by invoice no. 
     * @summary Get Invoice Detail by Invoice No
     * @param {string} phoneNo Phone number of the user, this is for guest mode
     * @param {string} invoiceNo Invoice number of the order
     * @param {string} xRecaptchaResponse  this is for recaptcha response header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public partnersFinanceGetInvoiceDetail(phoneNo: string, invoiceNo: string, xRecaptchaResponse: string, options?: AxiosRequestConfig) {
        return PartnersApiFp(this.configuration).partnersFinanceGetInvoiceDetail(phoneNo, invoiceNo, xRecaptchaResponse, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint is meant to be used by FC to see list of ffb price that she/he submitted 
     * @summary Get List of FFB Price
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public partnersGetFfbPrices(authorization: string, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return PartnersApiFp(this.configuration).partnersGetFfbPrices(authorization, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Can be accessed by all Partner Web user to see details of a Partner\'s member
     * @summary Get Member Detail
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {string} memberId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public partnersGetMember(authorization: string, memberId: string, options?: AxiosRequestConfig) {
        return PartnersApiFp(this.configuration).partnersGetMember(authorization, memberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endpoint for a User from one Partner to get list of their members. Default response will show all status with items count limited to 10
     * @summary List Partner Members
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {Array<MemberStatusEnum>} [status] 
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public partnersGetMembers(authorization: string, status?: Array<MemberStatusEnum>, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return PartnersApiFp(this.configuration).partnersGetMembers(authorization, status, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint is meant to be used for getting Member list on Campaign creation process.
     * @summary Get Member List per Partner (with Status & Same Campaign Type Status)
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {string} campaignType ID of the selected Campaign Type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public partnersGetMembersStatus(authorization: string, campaignType: string, options?: AxiosRequestConfig) {
        return PartnersApiFp(this.configuration).partnersGetMembersStatus(authorization, campaignType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Accessed to see details of a supplier
     * @summary Get Supplier Detail
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {string} supplierId Supplier ID in UUID type 4 format
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public partnersGetSupplier(authorization: string, supplierId: string, options?: AxiosRequestConfig) {
        return PartnersApiFp(this.configuration).partnersGetSupplier(authorization, supplierId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint is meant to be used for getting Supplier list on Campaign creation process. Partner ID for identifier will be retrieved from JWT. 
     * @summary Get Supplier List on Campaign Creation
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {string} campaignType ID of the selected Campaign Type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public partnersGetSuppliersStatus(authorization: string, campaignType: string, options?: AxiosRequestConfig) {
        return PartnersApiFp(this.configuration).partnersGetSuppliersStatus(authorization, campaignType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Will be used by all Partner user to get list of specific Partner\'s users
     * @summary Get Users Per Partner
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {string} partnerId Partner UUID
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public partnersGetUsersByPartner(authorization: string, partnerId: string, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return PartnersApiFp(this.configuration).partnersGetUsersByPartner(authorization, partnerId, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Member Summary per Partner, grouped by the Member Status
     * @summary List Members Summaries
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public partnersMembersGetSummary(authorization: string, options?: AxiosRequestConfig) {
        return PartnersApiFp(this.configuration).partnersMembersGetSummary(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint is meant to be used by partners to create their daily plantation activity plan
     * @summary Partners Plantations Create Schedules
     * @param {PartnersPlantationsCreateSchedulesRequest} [partnersPlantationsCreateSchedulesRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public partnersPlantationsCreateSchedules(partnersPlantationsCreateSchedulesRequest?: PartnersPlantationsCreateSchedulesRequest, options?: AxiosRequestConfig) {
        return PartnersApiFp(this.configuration).partnersPlantationsCreateSchedules(partnersPlantationsCreateSchedulesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Will return list of block assignments that are connected to current user business. Will use User ID from JWT and lookup the block assignments by utilizing `contact` and `business`. 
     * @summary Partners Plantations Get Block Assignments
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} [blockName] the name of block on plantations block assignment
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public partnersPlantationsGetBlockAssignments(aPPTYPE: AppTypeEnum, blockName?: string, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return PartnersApiFp(this.configuration).partnersPlantationsGetBlockAssignments(aPPTYPE, blockName, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint is meant to be used by partners web to get their ffb productions
     * @summary Partners Plantations Get FFB Productions
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {number} [month] Month in MM format
     * @param {number} [year] Year in YYYY format
     * @param {string} [sortBy] Sort the results by the specified field.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public partnersPlantationsGetFfbProductions(aPPTYPE: AppTypeEnum, month?: number, year?: number, sortBy?: string, options?: AxiosRequestConfig) {
        return PartnersApiFp(this.configuration).partnersPlantationsGetFfbProductions(aPPTYPE, month, year, sortBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint will be called by partner web to get list of plantations schedules.
     * @summary Get list of plantations schedules for partner web
     * @param {PlantationScheduleStatusEnum} [status] Status of the plantation schedules. No filter applied if empty.
     * @param {PlantationActivityTypeEnum} [plantationActivityType] Type of the plantation activity. No filter applied if empty.
     * @param {Array<string>} [sortBy] Sort the results by the specified field.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public partnersPlantationsGetSchedules(status?: PlantationScheduleStatusEnum, plantationActivityType?: PlantationActivityTypeEnum, sortBy?: Array<string>, options?: AxiosRequestConfig) {
        return PartnersApiFp(this.configuration).partnersPlantationsGetSchedules(status, plantationActivityType, sortBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Will update partial block assignments that are connected to current user business. Will use User ID from JWT and lookup the block assignments by utilizing `contact` and `business`. 
     * @summary Partners Plantations Update Partial Block Assignments
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} id 
     * @param {PartnersPlantationsUpdatePartialBlockAssignmentsRequest} [partnersPlantationsUpdatePartialBlockAssignmentsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public partnersPlantationsUpdatePartialBlockAssignments(aPPTYPE: AppTypeEnum, id: string, partnersPlantationsUpdatePartialBlockAssignmentsRequest?: PartnersPlantationsUpdatePartialBlockAssignmentsRequest, options?: AxiosRequestConfig) {
        return PartnersApiFp(this.configuration).partnersPlantationsUpdatePartialBlockAssignments(aPPTYPE, id, partnersPlantationsUpdatePartialBlockAssignmentsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint is meant to be used by partners to partially update their daily plantation activity plan
     * @summary Partners Plantations Update Schedules Partial
     * @param {string} id 
     * @param {PartnersPlantationsUpdateSchedulesPartialRequest} [partnersPlantationsUpdateSchedulesPartialRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public partnersPlantationsUpdateSchedulesPartial(id: string, partnersPlantationsUpdateSchedulesPartialRequest?: PartnersPlantationsUpdateSchedulesPartialRequest, options?: AxiosRequestConfig) {
        return PartnersApiFp(this.configuration).partnersPlantationsUpdateSchedulesPartial(id, partnersPlantationsUpdateSchedulesPartialRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Request new jwt based on partner id
     * @summary Partners Switch
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {PartnersSwitchRequest} partnersSwitchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public partnersSwitch(authorization: string, partnersSwitchRequest: PartnersSwitchRequest, options?: AxiosRequestConfig) {
        return PartnersApiFp(this.configuration).partnersSwitch(authorization, partnersSwitchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Used by Partner Admin to create account for another user. Email field is nullable, and status will use default `PARTNER_USER` if not provided. Will send registration SMS to the newly registered user.  # Dependencies  | Service Name | Usage | | ----------- | ----------- | | GCP KMS | Phone number decryption| | Twilio | SMS service | 
     * @summary Register Partner Web User
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {UsersCreateRegistrationRequest} usersCreateRegistrationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public partnersUsersCreateRegistration(authorization: string, usersCreateRegistrationRequest: UsersCreateRegistrationRequest, options?: AxiosRequestConfig) {
        return PartnersApiFp(this.configuration).partnersUsersCreateRegistration(authorization, usersCreateRegistrationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Validate the OTP Token (in UUID) received from Register User endpoint
     * @summary Validate Registration Token
     * @param {PartnersUsersVerifyRegistrationRequest} partnersUsersVerifyRegistrationRequest 
     * @param {AppTypeEnum} [aPPTYPE] The name of the app that\&#39;s accessing the endpoint.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public partnersUsersVerifyRegistration(partnersUsersVerifyRegistrationRequest: PartnersUsersVerifyRegistrationRequest, aPPTYPE?: AppTypeEnum, options?: AxiosRequestConfig) {
        return PartnersApiFp(this.configuration).partnersUsersVerifyRegistration(partnersUsersVerifyRegistrationRequest, aPPTYPE, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * this is for getting eligible vendor list of coupon
     * @summary Get Redeemed Coupon by Vendor ID
     * @param {string} vendorId Vendor Id
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {string} [customerName] Customer Name
     * @param {number} [redeemedDateTo] Redeemed Date To
     * @param {number} [redeemedDateFrom] Redeemed Date From
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public partnersVendorGetRedeemedCoupons(vendorId: string, page?: number, limit?: number, customerName?: string, redeemedDateTo?: number, redeemedDateFrom?: number, options?: AxiosRequestConfig) {
        return PartnersApiFp(this.configuration).partnersVendorGetRedeemedCoupons(vendorId, page, limit, customerName, redeemedDateTo, redeemedDateFrom, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endpoint for Partner to show list of Suppliers.<br><br>  Partner ID for identifier will be retrieved from JWT.<br><br>  Default response will show all status with items count limited to 10. 
     * @summary List Suppliers
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {Array<MemberStatusEnum>} [status] 
     * @param {string} [supplierName] Search query for supplier by Nama
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public supplierList(authorization: string, status?: Array<MemberStatusEnum>, supplierName?: string, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return PartnersApiFp(this.configuration).supplierList(authorization, status, supplierName, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Will be used by Partner admin to update Partner\'s user account. Will update the user data based on given parameters.
     * @summary Update User
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {string} userId 
     * @param {UpdateUserRequest} [updateUserRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public updateUser(authorization: string, userId: string, updateUserRequest?: UpdateUserRequest, options?: AxiosRequestConfig) {
        return PartnersApiFp(this.configuration).updateUser(authorization, userId, updateUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Used by all Partner user to create a new campaign V2
     * @summary Create New Campaign V2
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {V2CreateCampaignRequest} [v2CreateCampaignRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public v2CreateCampaign(authorization: string, v2CreateCampaignRequest?: V2CreateCampaignRequest, options?: AxiosRequestConfig) {
        return PartnersApiFp(this.configuration).v2CreateCampaign(authorization, v2CreateCampaignRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint is meant to be used by FC to see list of ffb price that she/he submitted filtered by month and year 
     * @summary Get List of FFB Price V2 filter by month and year
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {number} [month] Month in MM format
     * @param {number} [year] Year in YYYY format
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public v2PartnersGetFfbPrices(page?: number, limit?: number, month?: number, year?: number, options?: AxiosRequestConfig) {
        return PartnersApiFp(this.configuration).v2PartnersGetFfbPrices(page, limit, month, year, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Can be accessed by all Partner Web user to see details of a Partner\'s member
     * @summary Get Member Detail V2
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public v2PartnersGetMember(authorization: string, userId: string, options?: AxiosRequestConfig) {
        return PartnersApiFp(this.configuration).v2PartnersGetMember(authorization, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endpoint for a User from one Partner to get list of their members. Default response will show all status with items count limited to 10
     * @summary List Partner Members V2
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {Array<MemberStatusEnum>} [status] 
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public v2PartnersGetMembers(authorization: string, status?: Array<MemberStatusEnum>, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return PartnersApiFp(this.configuration).v2PartnersGetMembers(authorization, status, page, limit, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PlantationsApi - axios parameter creator
 * @export
 */
export const PlantationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Will be used by plantation admin to check the data before update.
         * @summary Get Plantation Expense
         * @param {string} plantationExpenseId plantation expense UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlantationExpense: async (plantationExpenseId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'plantationExpenseId' is not null or undefined
            assertParamExists('getPlantationExpense', 'plantationExpenseId', plantationExpenseId)
            const localVarPath = `/api/v1/plantations/expense/{plantationExpenseId}`
                .replace(`{${"plantationExpenseId"}}`, encodeURIComponent(String(plantationExpenseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Will be used by plantation admin to check the harvest cost data before update.
         * @summary Get plantation harvest cost detail
         * @param {string} [weighbridgeId] id of harvest in UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlantationHarvestCost: async (weighbridgeId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/plantations/harvest-cost`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (weighbridgeId !== undefined) {
                localVarQueryParameter['weighbridgeId'] = weighbridgeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Will be used by plantation admin to check the data before update.
         * @summary Get Plantation Sale
         * @param {string} plantationSaleId plantation sale UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlantationSale: async (plantationSaleId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'plantationSaleId' is not null or undefined
            assertParamExists('getPlantationSale', 'plantationSaleId', plantationSaleId)
            const localVarPath = `/api/v1/plantations/sale/{plantationSaleId}`
                .replace(`{${"plantationSaleId"}}`, encodeURIComponent(String(plantationSaleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List of plantation expense inputed by plantation admin
         * @summary Get all list of plantation expense
         * @param {number} [date] Filter date. Will use current date if not provided.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlantationsExpenses: async (date?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/plantations/expense`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List of plantation TBS sale inputed by plantation admin
         * @summary Get all list of plantation TBS sale
         * @param {number} [date] Filter date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlantationsSales: async (date?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/plantations/sale`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint is used by Plantation Management to create a new load activity. Currently only support for Plantation Management. 
         * @summary Create Plantation Load Activity
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {PlantationActivitiesCreateLoadsRequest} [plantationActivitiesCreateLoadsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationActivitiesCreateLoads: async (aPPTYPE: AppTypeEnum, plantationActivitiesCreateLoadsRequest?: PlantationActivitiesCreateLoadsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('plantationActivitiesCreateLoads', 'aPPTYPE', aPPTYPE)
            const localVarPath = `/api/v1/plantations/activities/loads`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(plantationActivitiesCreateLoadsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint is used by Gapoktan Admin to update upkeep-fee of a plantation activity.  This endpoint will have a role validation to verify whether the user accessing this endpoint is Gapoktan Admin or not. If not, then 403 will be thrown. 
         * @summary Update upkeep-fee of a plantation activity
         * @param {string} activityUpkeepId The ID of the activity upkeep
         * @param {PlantationActivityUpkeepFeeUpdateRequest} plantationActivityUpkeepFeeUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationActivityUpkeepFeeUpdate: async (activityUpkeepId: string, plantationActivityUpkeepFeeUpdateRequest: PlantationActivityUpkeepFeeUpdateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'activityUpkeepId' is not null or undefined
            assertParamExists('plantationActivityUpkeepFeeUpdate', 'activityUpkeepId', activityUpkeepId)
            // verify required parameter 'plantationActivityUpkeepFeeUpdateRequest' is not null or undefined
            assertParamExists('plantationActivityUpkeepFeeUpdate', 'plantationActivityUpkeepFeeUpdateRequest', plantationActivityUpkeepFeeUpdateRequest)
            const localVarPath = `/api/v1/plantations/activities/{activityUpkeepId}/upkeep-fee`
                .replace(`{${"activityUpkeepId"}}`, encodeURIComponent(String(activityUpkeepId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(plantationActivityUpkeepFeeUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint is used by Gapoktan Admin to get list of upkeep activities.<br><br> This endpoint will have a role validation to verify whether the user accessing this endpoint is Gapoktan Admin or not. If not, then 403 will be thrown. # Glossary  | Keyword | Meaning | | ----------- | ----------- | | Fertilizing | Pemupukan| | Pruning | Penunasan | | Spraying | Penyemprotan | | Slashing | Pembabatan | | Ablation | Kastrasi | | Sanitation | Sanitasi | 
         * @summary Get List of Plantation Upkeep Activity
         * @param {number} [date] Filter date. Will use current date if not provided.
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationActivityUpkeepList: async (date?: number, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/plantations/activities/upkeeps`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint is used by Gapoktan Admin to get list of weighing activities to bind it with FFB sales data. Will return list of weighing activities that hasn\'t been connected to a weighbridge, or already been connected to a specific weighbridge that\'s being sent via `weighbridgeId` query param.  This endpoint will have a role validation to verify whether the user accessing this endpoint is Gapoktan Admin or not. If not, then 403 will be thrown. 
         * @summary Get List of Plantation Weighing Activity
         * @param {string} weighbridgeId ID of weighbridge ticket
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationActivityWeighingList: async (weighbridgeId: string, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'weighbridgeId' is not null or undefined
            assertParamExists('plantationActivityWeighingList', 'weighbridgeId', weighbridgeId)
            const localVarPath = `/api/v1/plantations/activities/weighing`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (weighbridgeId !== undefined) {
                localVarQueryParameter['weighbridgeId'] = weighbridgeId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Will be used by plantation admin create the expense of plantation.
         * @summary Create the expense of plantation
         * @param {PlantationExpenseCreateUpdateRequest} plantationExpenseCreateUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationExpenseCreate: async (plantationExpenseCreateUpdateRequest: PlantationExpenseCreateUpdateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'plantationExpenseCreateUpdateRequest' is not null or undefined
            assertParamExists('plantationExpenseCreate', 'plantationExpenseCreateUpdateRequest', plantationExpenseCreateUpdateRequest)
            const localVarPath = `/api/v1/plantations/expense`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(plantationExpenseCreateUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Will be used by plantation admin to update the data.
         * @summary Update the plantation expense by {plantationExpenseId}
         * @param {string} plantationExpenseId plantation expense UUID
         * @param {PlantationExpenseCreateUpdateRequest} plantationExpenseCreateUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationExpenseUpdate: async (plantationExpenseId: string, plantationExpenseCreateUpdateRequest: PlantationExpenseCreateUpdateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'plantationExpenseId' is not null or undefined
            assertParamExists('plantationExpenseUpdate', 'plantationExpenseId', plantationExpenseId)
            // verify required parameter 'plantationExpenseCreateUpdateRequest' is not null or undefined
            assertParamExists('plantationExpenseUpdate', 'plantationExpenseCreateUpdateRequest', plantationExpenseCreateUpdateRequest)
            const localVarPath = `/api/v1/plantations/expense/{plantationExpenseId}`
                .replace(`{${"plantationExpenseId"}}`, encodeURIComponent(String(plantationExpenseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(plantationExpenseCreateUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Will be used by plantation admin create or update the wages of plantation harvest cost.
         * @summary Create or Update the wages of plantation harvest cost
         * @param {PlantationHarvestCostCreateRequest} plantationHarvestCostCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationHarvestCostCreate: async (plantationHarvestCostCreateRequest: PlantationHarvestCostCreateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'plantationHarvestCostCreateRequest' is not null or undefined
            assertParamExists('plantationHarvestCostCreate', 'plantationHarvestCostCreateRequest', plantationHarvestCostCreateRequest)
            const localVarPath = `/api/v1/plantations/harvest-cost`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(plantationHarvestCostCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Will be used by plantation admin to create or update the data.
         * @summary Create or update the sale of plantation
         * @param {PlantationSaleCreateRequest} plantationSaleCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationSaleCreate: async (plantationSaleCreateRequest: PlantationSaleCreateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'plantationSaleCreateRequest' is not null or undefined
            assertParamExists('plantationSaleCreate', 'plantationSaleCreateRequest', plantationSaleCreateRequest)
            const localVarPath = `/api/v1/plantations/sale`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(plantationSaleCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Map the activity weighing with FFB Sales. This will be used for both save and update. In case of update, existing mapping will be removed and changed into the new one.
         * @summary Map Activity Weighing with Plantation Sale
         * @param {string} weighbridgeId Weighbridge UUID
         * @param {PlantationSaleMapWeighingRequest} plantationSaleMapWeighingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationSaleMapWeighing: async (weighbridgeId: string, plantationSaleMapWeighingRequest: PlantationSaleMapWeighingRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'weighbridgeId' is not null or undefined
            assertParamExists('plantationSaleMapWeighing', 'weighbridgeId', weighbridgeId)
            // verify required parameter 'plantationSaleMapWeighingRequest' is not null or undefined
            assertParamExists('plantationSaleMapWeighing', 'plantationSaleMapWeighingRequest', plantationSaleMapWeighingRequest)
            const localVarPath = `/api/v1/plantations/sale/{weighbridgeId}/weighing`
                .replace(`{${"weighbridgeId"}}`, encodeURIComponent(String(weighbridgeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(plantationSaleMapWeighingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint will be called by worker app to create harvesting activity
         * @summary Plantations activities create harvests
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {number} ffbQuantity Quantity of FFB in Janjang
         * @param {number} harvestingDate Date when user take a photo
         * @param {number} latitude 
         * @param {number} longitude 
         * @param {number} submittedAt datetime at UTC+0 in milliseconds when users create locally in offline mode
         * @param {string} userTimezone client timezone when user create harvesting activity
         * @param {string} [id] generated id
         * @param {number} [estimatedWeightAverageBunchKg] Estimated average FFB (BJR/Komidel) weight in kg
         * @param {string} [ffbCollectionPoint] 
         * @param {File} [photo] Photo of harvest fruit
         * @param {string} [type] 
         * @param {string} [blockId] 
         * @param {string} [plantationScheduleId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationsActivitiesCreateHarvests: async (aPPTYPE: AppTypeEnum, ffbQuantity: number, harvestingDate: number, latitude: number, longitude: number, submittedAt: number, userTimezone: string, id?: string, estimatedWeightAverageBunchKg?: number, ffbCollectionPoint?: string, photo?: File, type?: string, blockId?: string, plantationScheduleId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('plantationsActivitiesCreateHarvests', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'ffbQuantity' is not null or undefined
            assertParamExists('plantationsActivitiesCreateHarvests', 'ffbQuantity', ffbQuantity)
            // verify required parameter 'harvestingDate' is not null or undefined
            assertParamExists('plantationsActivitiesCreateHarvests', 'harvestingDate', harvestingDate)
            // verify required parameter 'latitude' is not null or undefined
            assertParamExists('plantationsActivitiesCreateHarvests', 'latitude', latitude)
            // verify required parameter 'longitude' is not null or undefined
            assertParamExists('plantationsActivitiesCreateHarvests', 'longitude', longitude)
            // verify required parameter 'submittedAt' is not null or undefined
            assertParamExists('plantationsActivitiesCreateHarvests', 'submittedAt', submittedAt)
            // verify required parameter 'userTimezone' is not null or undefined
            assertParamExists('plantationsActivitiesCreateHarvests', 'userTimezone', userTimezone)
            const localVarPath = `/api/v1/plantations/activities/harvests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


            if (id !== undefined) { 
                localVarFormParams.set('id', id as any);
            }
    
            if (ffbQuantity !== undefined) { 
                localVarFormParams.set('ffbQuantity', ffbQuantity as any);
            }
    
            if (estimatedWeightAverageBunchKg !== undefined) { 
                localVarFormParams.set('estimatedWeightAverageBunchKg', estimatedWeightAverageBunchKg as any);
            }
    
            if (ffbCollectionPoint !== undefined) { 
                localVarFormParams.set('ffbCollectionPoint', ffbCollectionPoint as any);
            }
    
            if (harvestingDate !== undefined) { 
                localVarFormParams.set('harvestingDate', harvestingDate as any);
            }
    
            if (latitude !== undefined) { 
                localVarFormParams.set('latitude', latitude as any);
            }
    
            if (longitude !== undefined) { 
                localVarFormParams.set('longitude', longitude as any);
            }
    
            if (photo !== undefined) { 
                localVarFormParams.set('photo', photo as any);
            }
    
            if (submittedAt !== undefined) { 
                localVarFormParams.set('submittedAt', submittedAt as any);
            }
    
            if (userTimezone !== undefined) { 
                localVarFormParams.set('userTimezone', userTimezone as any);
            }
    
            if (type !== undefined) { 
                localVarFormParams.set('type', type as any);
            }
    
            if (blockId !== undefined) { 
                localVarFormParams.set('blockId', blockId as any);
            }
    
            if (plantationScheduleId !== undefined) { 
                localVarFormParams.set('plantationScheduleId', plantationScheduleId as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  This endpoint is used by Worker to record their upkeep activities on plantation.<br><br> # Glossary  | Keyword | Meaning | | ----------- | ----------- | | Fertilizing | Pemupukan| | Pruning | Penunasan | | Spraying | Penyemprotan | | Slashing | Pembabatan | | Ablation | Kastrasi | | Sanitation | Sanitasi | 
         * @summary Create Plantations Upkeep Activity
         * @param {PlantationsActivitiesCreateUpkeepsRequest} [plantationsActivitiesCreateUpkeepsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationsActivitiesCreateUpkeeps: async (plantationsActivitiesCreateUpkeepsRequest?: PlantationsActivitiesCreateUpkeepsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/plantations/activities/upkeeps`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(plantationsActivitiesCreateUpkeepsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint is used to get plantations activities harvests 
         * @summary Plantations activities get harvests
         * @param {number} [startDate] Start Date for filtering list of data (in epoch) formatted in UTC-0. Will use current date if not provided
         * @param {number} [endDate] End Date for filtering list of data (in epoch) formatted in UTC-0. Will use current date if not provided
         * @param {Array<string>} [harvesterSupervisorId] Filter for the list of harvester supervisor contact id of the related harvesting activity
         * @param {Array<string>} [blockId] Filter for the list of block id of the related harvesting activity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationsActivitiesGetHarvests: async (startDate?: number, endDate?: number, harvesterSupervisorId?: Array<string>, blockId?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/plantations/activities/harvests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (harvesterSupervisorId) {
                localVarQueryParameter['harvesterSupervisorId'] = harvesterSupervisorId;
            }

            if (blockId) {
                localVarQueryParameter['blockId'] = blockId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint is used to get the limit of plantations activities creation for current user 
         * @summary Get plantations activities creation limit
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {TypePlantationsActivitiesEnum} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationsActivitiesGetLimits: async (authorization: string, type?: TypePlantationsActivitiesEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('plantationsActivitiesGetLimits', 'authorization', authorization)
            const localVarPath = `/api/v1/plantations/activities/limits`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Called by mobile app to Get all Plantation Activity Materials
         * @summary Get all Plantation Activity Materials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationsActivitiesGetMaterials: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/plantations/activities/materials`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint is used by mobile app to add Smallholder Upkeep activity
         * @summary Create Plantation activity Smallholder Upkeep
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {PlantationsActivitiesSmallholdersCreateUpkeepRequest} [plantationsActivitiesSmallholdersCreateUpkeepRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationsActivitiesSmallholdersCreateUpkeep: async (aPPTYPE: AppTypeEnum, plantationsActivitiesSmallholdersCreateUpkeepRequest?: PlantationsActivitiesSmallholdersCreateUpkeepRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('plantationsActivitiesSmallholdersCreateUpkeep', 'aPPTYPE', aPPTYPE)
            const localVarPath = `/api/v1/plantations/activities/smallholders/upkeeps`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(plantationsActivitiesSmallholdersCreateUpkeepRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Soft delete Upkeep History record (\"Catat Rawat\") based on the activityUpkeepId
         * @summary Delete Smallholder Activity Upkeep History by ID
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} activityUpkeepId The ID of the activity upkeep
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationsActivitiesSmallholdersDeleteUpkeep: async (aPPTYPE: AppTypeEnum, activityUpkeepId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('plantationsActivitiesSmallholdersDeleteUpkeep', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'activityUpkeepId' is not null or undefined
            assertParamExists('plantationsActivitiesSmallholdersDeleteUpkeep', 'activityUpkeepId', activityUpkeepId)
            const localVarPath = `/api/v1/plantations/activities/smallholders/upkeeps/{activityUpkeepId}`
                .replace(`{${"activityUpkeepId"}}`, encodeURIComponent(String(activityUpkeepId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint is used by mobile app to show list of Smallholder Upkeep activity
         * @summary Get Plantations activities Smallholders Upkeeps
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} [userId] used by DUTA app, id of the user that this request is for
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationsActivitiesSmallholdersGetUpkeeps: async (aPPTYPE: AppTypeEnum, userId?: string, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('plantationsActivitiesSmallholdersGetUpkeeps', 'aPPTYPE', aPPTYPE)
            const localVarPath = `/api/v1/plantations/activities/smallholders/upkeeps`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Called by mobile app to Get all Plantation Activity Smallholder Upkeeps Activities
         * @summary Get all Plantations Activities Smallholders Upkeeps Activities
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationsActivitiesSmallholdersUpkeepsGetActivities: async (aPPTYPE: AppTypeEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('plantationsActivitiesSmallholdersUpkeepsGetActivities', 'aPPTYPE', aPPTYPE)
            const localVarPath = `/api/v1/plantations/activities/smallholders/upkeeps/activities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Called by mobile app to Get all Plantation Activity Smallholder Upkeeps material fertilizers
         * @summary Get all Plantation Activity Smallholder Upkeeps material fertilizers
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationsActivitiesSmallholdersUpkeepsMaterialsGetFertilizers: async (aPPTYPE: AppTypeEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('plantationsActivitiesSmallholdersUpkeepsMaterialsGetFertilizers', 'aPPTYPE', aPPTYPE)
            const localVarPath = `/api/v1/plantations/activities/smallholders/upkeeps/materials/fertilizers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint is used to create plantations activities 
         * @summary Create plantation activities
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {TypePlantationsActivitiesEnum} type 
         * @param {PlantationsCreateActivitiesItemsRequest} items 
         * @param {File} [photo] Photo of harvest fruit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationsCreateActivities: async (authorization: string, type: TypePlantationsActivitiesEnum, items: PlantationsCreateActivitiesItemsRequest, photo?: File, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('plantationsCreateActivities', 'authorization', authorization)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('plantationsCreateActivities', 'type', type)
            // verify required parameter 'items' is not null or undefined
            assertParamExists('plantationsCreateActivities', 'items', items)
            const localVarPath = `/api/v1/plantations/activities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


            if (type !== undefined) { 
                localVarFormParams.set('type', type as any);
            }
    
            if (items !== undefined) { 
                localVarFormParams.set('items', items as any);
            }
    
            if (photo !== undefined) { 
                localVarFormParams.set('photo', photo as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Called by mobile app to Create Plantation FFB Sell Price record
         * @summary Create Plantation FFB Sell Price
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {PlantationsCreateFFBSellPriceRequestData} data 
         * @param {File} photo Photo of sales proof could be invoice, weightbridge card etc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationsCreateFFBSellPrice: async (aPPTYPE: AppTypeEnum, data: PlantationsCreateFFBSellPriceRequestData, photo: File, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('plantationsCreateFFBSellPrice', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'data' is not null or undefined
            assertParamExists('plantationsCreateFFBSellPrice', 'data', data)
            // verify required parameter 'photo' is not null or undefined
            assertParamExists('plantationsCreateFFBSellPrice', 'photo', photo)
            const localVarPath = `/api/v1/plantations/ffb-sell-prices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


            if (data !== undefined) { 
                localVarFormParams.set('data', data as any);
            }
    
            if (photo !== undefined) { 
                localVarFormParams.set('photo', photo as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Soft delete FFB Sell Price record (\"Catat Panen\") based on the ffbSellPriceId
         * @summary Delete FFB Sell Price by ID
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} ffbSellPriceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationsDeleteFFBSellPrice: async (aPPTYPE: AppTypeEnum, ffbSellPriceId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('plantationsDeleteFFBSellPrice', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'ffbSellPriceId' is not null or undefined
            assertParamExists('plantationsDeleteFFBSellPrice', 'ffbSellPriceId', ffbSellPriceId)
            const localVarPath = `/api/v1/plantations/ffb-sell-prices/{ffbSellPriceId}`
                .replace(`{${"ffbSellPriceId"}}`, encodeURIComponent(String(ffbSellPriceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint is used to create gapoktan plantations deliveries activities 
         * @summary Create plantation delivery activities
         * @param {PlantationsDeliveriesGapoktanCreateActivitiesRequest} [plantationsDeliveriesGapoktanCreateActivitiesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationsDeliveriesGapoktanCreateActivities: async (plantationsDeliveriesGapoktanCreateActivitiesRequest?: PlantationsDeliveriesGapoktanCreateActivitiesRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/plantations/deliveries/gapoktan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(plantationsDeliveriesGapoktanCreateActivitiesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Called by mobile app to Get processed users\'s FFB Sell Prices summaries for data visualization
         * @summary Get Plantation FFB Sell Prices summary data
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} farmId filter request by the specified Farm Id
         * @param {number} [year] filter request by the specified year in numeric YYYY format, &lt;br&gt; if value 0 will return ALL data aggregated not filtered by year &amp; month
         * @param {number} [month] filter request by the specified month in numeric MM format, &lt;br&gt; if value 0 will return ALL data aggregated not filtered by month in the specified year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationsFFBSellPricesGetSummaries: async (aPPTYPE: AppTypeEnum, farmId: string, year?: number, month?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('plantationsFFBSellPricesGetSummaries', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'farmId' is not null or undefined
            assertParamExists('plantationsFFBSellPricesGetSummaries', 'farmId', farmId)
            const localVarPath = `/api/v1/plantations/ffb-sell-prices/summaries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (farmId !== undefined) {
                localVarQueryParameter['farmId'] = farmId;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }

            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Called by mobile app to Get processed users\'s FFB Sell Prices income statement summaries. <br> when this API is called without `farmId`, `year` & `month` query params, will return user\'s income statement from ALL farm aggregated in CURRENT year & CURRENT month
         * @summary Get Plantation FFB Sell Prices Income Statement summary data
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} [farmId] optional, filter request by the specified Farm Id &lt;br&gt; when null will return aggregated data from all user\&#39;s farm
         * @param {number} [year] filter request by the specified year in numeric YYYY format, &lt;br&gt; if value 0 will return ALL data aggregated not filtered by year &amp; month
         * @param {number} [month] filter request by the specified month in numeric MM format, &lt;br&gt; if value 0 will return ALL data aggregated not filtered by month in the specified year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationsFFBSellPricesSummariesGetIncomeStatement: async (aPPTYPE: AppTypeEnum, farmId?: string, year?: number, month?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('plantationsFFBSellPricesSummariesGetIncomeStatement', 'aPPTYPE', aPPTYPE)
            const localVarPath = `/api/v1/plantations/ffb-sell-prices/summaries/income-statement`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (farmId !== undefined) {
                localVarQueryParameter['farmId'] = farmId;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }

            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endpoint to create or update FFB Sale activity
         * @summary Create or Update FFB Sale
         * @param {PlantationsFfbSaleCreateRequest} plantationsFfbSaleCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationsFfbSaleCreate: async (plantationsFfbSaleCreateRequest: PlantationsFfbSaleCreateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'plantationsFfbSaleCreateRequest' is not null or undefined
            assertParamExists('plantationsFfbSaleCreate', 'plantationsFfbSaleCreateRequest', plantationsFfbSaleCreateRequest)
            const localVarPath = `/api/v1/plantations/activities/ffb-sales`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(plantationsFfbSaleCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint is used to get history of plantations activities 
         * @summary Get history of plantation activities
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {TypePlantationsActivitiesEnum} [type] 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {number} [month] Month in MM format
         * @param {number} [year] Year in YYYY format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationsGetActivities: async (authorization: string, type?: TypePlantationsActivitiesEnum, page?: number, limit?: number, month?: number, year?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('plantationsGetActivities', 'authorization', authorization)
            const localVarPath = `/api/v1/plantations/activities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint is used to get history of plantations activities harvests reports 
         * @summary Get history of plantation activities harvests reports
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {number} [startDate] Start Date for filtering list of data (in epoch) formatted in UTC-0. Will use current date if not provided
         * @param {number} [endDate] End Date for filtering list of data (in epoch) formatted in UTC-0. Will use current date if not provided
         * @param {Array<string>} [harvesterSupervisorId] Filter for the list of harvester supervisor contact id of the related harvesting activity
         * @param {Array<string>} [blockId] Filter for the list of block id of the related harvesting activity
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationsGetActivitiesHarvestsReports: async (authorization: string, startDate?: number, endDate?: number, harvesterSupervisorId?: Array<string>, blockId?: Array<string>, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('plantationsGetActivitiesHarvestsReports', 'authorization', authorization)
            const localVarPath = `/api/v1/plantations/activities/harvests/reports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (harvesterSupervisorId) {
                localVarQueryParameter['harvesterSupervisorId'] = harvesterSupervisorId;
            }

            if (blockId) {
                localVarQueryParameter['blockId'] = blockId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Called by mobile app to Get List of users\'s recorder FFB Sell Prices
         * @summary List Plantation FFB Sell Prices
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} [userId] used by DUTA app, id of the user that this request is for
         * @param {string} [farmId] optional, filter request by the specified Farm Id &lt;br&gt; when null will return aggregated data from all user\&#39;s farm
         * @param {number} [year] filter request by the specified year in numeric YYYY format, &lt;br&gt; if value 0 will return ALL data aggregated not filtered by year &amp; month
         * @param {number} [month] filter request by the specified month in numeric MM format, &lt;br&gt; if value 0 will return ALL data aggregated not filtered by month in the specified year
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationsGetFFBSellPrices: async (aPPTYPE: AppTypeEnum, userId?: string, farmId?: string, year?: number, month?: number, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('plantationsGetFFBSellPrices', 'aPPTYPE', aPPTYPE)
            const localVarPath = `/api/v1/plantations/ffb-sell-prices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (farmId !== undefined) {
                localVarQueryParameter['farmId'] = farmId;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }

            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get detail of FFB Sale
         * @summary Get Plantation FFB Sale
         * @param {string} weighbridgeId Weighbridge UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationsGetFfbSale: async (weighbridgeId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'weighbridgeId' is not null or undefined
            assertParamExists('plantationsGetFfbSale', 'weighbridgeId', weighbridgeId)
            const localVarPath = `/api/v1/plantations/activities/ffb-sales/{weighbridgeId}`
                .replace(`{${"weighbridgeId"}}`, encodeURIComponent(String(weighbridgeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get summary of FFB Sales, including total deliveries, total FFB weight, revenue, cost, and net profit
         * @summary Get Summary of Plantation FFB Sales
         * @param {string} [supplierId] Supplier ID in UUID type 4 format. Won\&#39;t filter by supplier if not provided
         * @param {number} [date] Date for filtering list of data (in epoch) formatted in UTC-0. Will use current date if not provided
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationsGetFfbSalesSummary: async (supplierId?: string, date?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/plantations/activities/ffb-sales/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (supplierId !== undefined) {
                localVarQueryParameter['supplierId'] = supplierId;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Called by mobile app to get List Of Plantation Schedule
         * @summary Get list of plantation activity schedule.
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {PlantationActivityTypeEnum} [activityType] this is for filter plantation schedule by activity type
         * @param {string} [startDate] Start date for filtering plantation schedule date
         * @param {string} [endDate] End date for filtering plantation schedule date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationsGetSchedules: async (authorization: string, aPPTYPE: AppTypeEnum, activityType?: PlantationActivityTypeEnum, startDate?: string, endDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('plantationsGetSchedules', 'authorization', authorization)
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('plantationsGetSchedules', 'aPPTYPE', aPPTYPE)
            const localVarPath = `/api/v1/plantations/schedules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (activityType !== undefined) {
                localVarQueryParameter['activityType'] = activityType;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Called by mobile app to Get all Seeds
         * @summary Get all Plantation Seeds without any pagination or query parameters and sorted by sequence
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationsGetSeeds: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/plantations/seeds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get soil types
         * @summary Get Soil Types
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationsGetSoilTypes: async (aPPTYPE: AppTypeEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('plantationsGetSoilTypes', 'aPPTYPE', aPPTYPE)
            const localVarPath = `/api/v1/plantations/soil-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get list of FFB Sales of current users\' Supplier (will be fetch by the `contact` and `business` data)
         * @summary Get List of Plantation FFB Sales
         * @param {string} [supplierId] Supplier ID in UUID type 4 format. Won\&#39;t filter by supplier if not provided
         * @param {number} [date] Date for filtering list of data (in epoch) formatted in UTC-0. Will use current date if not provided
         * @param {number} [limit] Number of items per page.
         * @param {number} [page] Current page number to be accessed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationsListFfbSales: async (supplierId?: string, date?: number, limit?: number, page?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/plantations/activities/ffb-sales`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (supplierId !== undefined) {
                localVarQueryParameter['supplierId'] = supplierId;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Called by mobile app to Get Farmer Group/Asscociation List of Sales Report Grouped/Aggregated by Year-Month
         * @summary Get Plantation Report Sales data
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} [farmerGroupIds] filter request by the specified Farmer Group Ids &lt;br&gt; accept multiple Farmer Group Ids, comma (URL encoded &#x60;%2C&#x60;) separated.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationsReportsGetSales: async (aPPTYPE: AppTypeEnum, farmerGroupIds?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('plantationsReportsGetSales', 'aPPTYPE', aPPTYPE)
            const localVarPath = `/api/v1/plantations/reports/sales`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (farmerGroupIds !== undefined) {
                localVarQueryParameter['farmerGroupIds'] = farmerGroupIds;
            }

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Called by mobile app to Get Farmer Group/Asscociation List of Sales Report Details for the specified year & month Per Farmer Groups
         * @summary Get Plantation Report Sales Per Farmer Groups
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {number} year filter request by the specified year in numeric YYYY format
         * @param {number} month filter request by the specified month in numeric MM format
         * @param {string} [farmerGroupIds] filter request by the specified Farmer Group Ids &lt;br&gt; accept multiple Farmer Group Ids, comma (URL encoded &#x60;%2C&#x60;) separated.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationsReportsGetSalesPerFarmerGroup: async (aPPTYPE: AppTypeEnum, year: number, month: number, farmerGroupIds?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('plantationsReportsGetSalesPerFarmerGroup', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('plantationsReportsGetSalesPerFarmerGroup', 'year', year)
            // verify required parameter 'month' is not null or undefined
            assertParamExists('plantationsReportsGetSalesPerFarmerGroup', 'month', month)
            const localVarPath = `/api/v1/plantations/reports/sales/farmer-groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }

            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }

            if (farmerGroupIds !== undefined) {
                localVarQueryParameter['farmerGroupIds'] = farmerGroupIds;
            }

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Called by mobile app when create Plantation Schedule.
         * @summary Create Plantation Schedule
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {PlantationsSchedulesCreateRequest} plantationsSchedulesCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationsSchedulesCreate: async (authorization: string, plantationsSchedulesCreateRequest: PlantationsSchedulesCreateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('plantationsSchedulesCreate', 'authorization', authorization)
            // verify required parameter 'plantationsSchedulesCreateRequest' is not null or undefined
            assertParamExists('plantationsSchedulesCreate', 'plantationsSchedulesCreateRequest', plantationsSchedulesCreateRequest)
            const localVarPath = `/api/v1/plantations/schedules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(plantationsSchedulesCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Called by mobile app to get Plantation Schedule Harvest Activity details.
         * @summary Get plantation activity harvest schedule detail by scheduleId.
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} scheduleId plantation schedule id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationsSchedulesGetHarvestsDetail: async (authorization: string, aPPTYPE: AppTypeEnum, scheduleId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('plantationsSchedulesGetHarvestsDetail', 'authorization', authorization)
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('plantationsSchedulesGetHarvestsDetail', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'scheduleId' is not null or undefined
            assertParamExists('plantationsSchedulesGetHarvestsDetail', 'scheduleId', scheduleId)
            const localVarPath = `/api/v1/plantations/schedules/{scheduleId}/harvests`
                .replace(`{${"scheduleId"}}`, encodeURIComponent(String(scheduleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new plantation delivery
         * @summary Create a new plantation delivery
         * @param {V2PlantationCreateActivitiesDeliveriesRequest} v2PlantationCreateActivitiesDeliveriesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2PlantationCreateActivitiesDeliveries: async (v2PlantationCreateActivitiesDeliveriesRequest: V2PlantationCreateActivitiesDeliveriesRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'v2PlantationCreateActivitiesDeliveriesRequest' is not null or undefined
            assertParamExists('v2PlantationCreateActivitiesDeliveries', 'v2PlantationCreateActivitiesDeliveriesRequest', v2PlantationCreateActivitiesDeliveriesRequest)
            const localVarPath = `/api/v2/plantations/activities/deliveries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(v2PlantationCreateActivitiesDeliveriesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint is used by mobile app to add multiple Smallholder Upkeep activity
         * @summary Create Multiple Plantation activity Smallholder Upkeep
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {V2PlantationsActivitiesSmallholdersCreateUpkeepRequest} [v2PlantationsActivitiesSmallholdersCreateUpkeepRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2PlantationsActivitiesSmallholdersCreateUpkeep: async (aPPTYPE: AppTypeEnum, v2PlantationsActivitiesSmallholdersCreateUpkeepRequest?: V2PlantationsActivitiesSmallholdersCreateUpkeepRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('v2PlantationsActivitiesSmallholdersCreateUpkeep', 'aPPTYPE', aPPTYPE)
            const localVarPath = `/api/v2/plantations/activities/smallholders/upkeeps`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(v2PlantationsActivitiesSmallholdersCreateUpkeepRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint is used to create plantations activities <br> Changes: - V2 -> change to application/json, support harvest activities for association (gapoktan)<br> 
         * @summary Create Plantation Activities V2
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {V2PlantationsCreateActivitiesRequest} [v2PlantationsCreateActivitiesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2PlantationsCreateActivities: async (aPPTYPE: AppTypeEnum, v2PlantationsCreateActivitiesRequest?: V2PlantationsCreateActivitiesRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('v2PlantationsCreateActivities', 'aPPTYPE', aPPTYPE)
            const localVarPath = `/api/v2/plantations/activities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(v2PlantationsCreateActivitiesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This API is used to create plantation FFB sell price record in bulk
         * @summary Create Plantation FFB Sell Price V2
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {V2PlantationsCreateFFBSellPriceRequest} v2PlantationsCreateFFBSellPriceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2PlantationsCreateFFBSellPrice: async (aPPTYPE: AppTypeEnum, v2PlantationsCreateFFBSellPriceRequest: V2PlantationsCreateFFBSellPriceRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('v2PlantationsCreateFFBSellPrice', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'v2PlantationsCreateFFBSellPriceRequest' is not null or undefined
            assertParamExists('v2PlantationsCreateFFBSellPrice', 'v2PlantationsCreateFFBSellPriceRequest', v2PlantationsCreateFFBSellPriceRequest)
            const localVarPath = `/api/v2/plantations/ffb-sell-prices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(v2PlantationsCreateFFBSellPriceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Called by mobile app to get List Of Plantation Schedule
         * @summary Get list of plantation activity schedule.
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {PlantationActivityTypeEnum} [activityType] this is for filter plantation schedule by activity type
         * @param {number} [startDate] Start Date for filtering list of data (in epoch) formatted in UTC-0. Will use current date if not provided
         * @param {number} [endDate] End Date for filtering list of data (in epoch) formatted in UTC-0. Will use current date if not provided
         * @param {PlantationScheduleStatusEnum} [status] this is for filter plantation schedule by status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2PlantationsGetSchedules: async (authorization: string, activityType?: PlantationActivityTypeEnum, startDate?: number, endDate?: number, status?: PlantationScheduleStatusEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('v2PlantationsGetSchedules', 'authorization', authorization)
            const localVarPath = `/api/v2/plantations/schedules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (activityType !== undefined) {
                localVarQueryParameter['activityType'] = activityType;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlantationsApi - functional programming interface
 * @export
 */
export const PlantationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PlantationsApiAxiosParamCreator(configuration)
    return {
        /**
         * Will be used by plantation admin to check the data before update.
         * @summary Get Plantation Expense
         * @param {string} plantationExpenseId plantation expense UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlantationExpense(plantationExpenseId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPlantationExpenseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlantationExpense(plantationExpenseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Will be used by plantation admin to check the harvest cost data before update.
         * @summary Get plantation harvest cost detail
         * @param {string} [weighbridgeId] id of harvest in UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlantationHarvestCost(weighbridgeId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPlantationHarvestCostResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlantationHarvestCost(weighbridgeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Will be used by plantation admin to check the data before update.
         * @summary Get Plantation Sale
         * @param {string} plantationSaleId plantation sale UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlantationSale(plantationSaleId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPlantationSaleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlantationSale(plantationSaleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * List of plantation expense inputed by plantation admin
         * @summary Get all list of plantation expense
         * @param {number} [date] Filter date. Will use current date if not provided.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlantationsExpenses(date?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPlantationsExpensesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlantationsExpenses(date, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * List of plantation TBS sale inputed by plantation admin
         * @summary Get all list of plantation TBS sale
         * @param {number} [date] Filter date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlantationsSales(date?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPlantationsSalesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlantationsSales(date, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint is used by Plantation Management to create a new load activity. Currently only support for Plantation Management. 
         * @summary Create Plantation Load Activity
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {PlantationActivitiesCreateLoadsRequest} [plantationActivitiesCreateLoadsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async plantationActivitiesCreateLoads(aPPTYPE: AppTypeEnum, plantationActivitiesCreateLoadsRequest?: PlantationActivitiesCreateLoadsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DefaultSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.plantationActivitiesCreateLoads(aPPTYPE, plantationActivitiesCreateLoadsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint is used by Gapoktan Admin to update upkeep-fee of a plantation activity.  This endpoint will have a role validation to verify whether the user accessing this endpoint is Gapoktan Admin or not. If not, then 403 will be thrown. 
         * @summary Update upkeep-fee of a plantation activity
         * @param {string} activityUpkeepId The ID of the activity upkeep
         * @param {PlantationActivityUpkeepFeeUpdateRequest} plantationActivityUpkeepFeeUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async plantationActivityUpkeepFeeUpdate(activityUpkeepId: string, plantationActivityUpkeepFeeUpdateRequest: PlantationActivityUpkeepFeeUpdateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.plantationActivityUpkeepFeeUpdate(activityUpkeepId, plantationActivityUpkeepFeeUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint is used by Gapoktan Admin to get list of upkeep activities.<br><br> This endpoint will have a role validation to verify whether the user accessing this endpoint is Gapoktan Admin or not. If not, then 403 will be thrown. # Glossary  | Keyword | Meaning | | ----------- | ----------- | | Fertilizing | Pemupukan| | Pruning | Penunasan | | Spraying | Penyemprotan | | Slashing | Pembabatan | | Ablation | Kastrasi | | Sanitation | Sanitasi | 
         * @summary Get List of Plantation Upkeep Activity
         * @param {number} [date] Filter date. Will use current date if not provided.
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async plantationActivityUpkeepList(date?: number, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlantationActivityUpkeepListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.plantationActivityUpkeepList(date, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint is used by Gapoktan Admin to get list of weighing activities to bind it with FFB sales data. Will return list of weighing activities that hasn\'t been connected to a weighbridge, or already been connected to a specific weighbridge that\'s being sent via `weighbridgeId` query param.  This endpoint will have a role validation to verify whether the user accessing this endpoint is Gapoktan Admin or not. If not, then 403 will be thrown. 
         * @summary Get List of Plantation Weighing Activity
         * @param {string} weighbridgeId ID of weighbridge ticket
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async plantationActivityWeighingList(weighbridgeId: string, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlantationActivityWeighingListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.plantationActivityWeighingList(weighbridgeId, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Will be used by plantation admin create the expense of plantation.
         * @summary Create the expense of plantation
         * @param {PlantationExpenseCreateUpdateRequest} plantationExpenseCreateUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async plantationExpenseCreate(plantationExpenseCreateUpdateRequest: PlantationExpenseCreateUpdateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.plantationExpenseCreate(plantationExpenseCreateUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Will be used by plantation admin to update the data.
         * @summary Update the plantation expense by {plantationExpenseId}
         * @param {string} plantationExpenseId plantation expense UUID
         * @param {PlantationExpenseCreateUpdateRequest} plantationExpenseCreateUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async plantationExpenseUpdate(plantationExpenseId: string, plantationExpenseCreateUpdateRequest: PlantationExpenseCreateUpdateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.plantationExpenseUpdate(plantationExpenseId, plantationExpenseCreateUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Will be used by plantation admin create or update the wages of plantation harvest cost.
         * @summary Create or Update the wages of plantation harvest cost
         * @param {PlantationHarvestCostCreateRequest} plantationHarvestCostCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async plantationHarvestCostCreate(plantationHarvestCostCreateRequest: PlantationHarvestCostCreateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.plantationHarvestCostCreate(plantationHarvestCostCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Will be used by plantation admin to create or update the data.
         * @summary Create or update the sale of plantation
         * @param {PlantationSaleCreateRequest} plantationSaleCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async plantationSaleCreate(plantationSaleCreateRequest: PlantationSaleCreateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.plantationSaleCreate(plantationSaleCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Map the activity weighing with FFB Sales. This will be used for both save and update. In case of update, existing mapping will be removed and changed into the new one.
         * @summary Map Activity Weighing with Plantation Sale
         * @param {string} weighbridgeId Weighbridge UUID
         * @param {PlantationSaleMapWeighingRequest} plantationSaleMapWeighingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async plantationSaleMapWeighing(weighbridgeId: string, plantationSaleMapWeighingRequest: PlantationSaleMapWeighingRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.plantationSaleMapWeighing(weighbridgeId, plantationSaleMapWeighingRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint will be called by worker app to create harvesting activity
         * @summary Plantations activities create harvests
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {number} ffbQuantity Quantity of FFB in Janjang
         * @param {number} harvestingDate Date when user take a photo
         * @param {number} latitude 
         * @param {number} longitude 
         * @param {number} submittedAt datetime at UTC+0 in milliseconds when users create locally in offline mode
         * @param {string} userTimezone client timezone when user create harvesting activity
         * @param {string} [id] generated id
         * @param {number} [estimatedWeightAverageBunchKg] Estimated average FFB (BJR/Komidel) weight in kg
         * @param {string} [ffbCollectionPoint] 
         * @param {File} [photo] Photo of harvest fruit
         * @param {string} [type] 
         * @param {string} [blockId] 
         * @param {string} [plantationScheduleId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async plantationsActivitiesCreateHarvests(aPPTYPE: AppTypeEnum, ffbQuantity: number, harvestingDate: number, latitude: number, longitude: number, submittedAt: number, userTimezone: string, id?: string, estimatedWeightAverageBunchKg?: number, ffbCollectionPoint?: string, photo?: File, type?: string, blockId?: string, plantationScheduleId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlantationsCreateActivitiesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.plantationsActivitiesCreateHarvests(aPPTYPE, ffbQuantity, harvestingDate, latitude, longitude, submittedAt, userTimezone, id, estimatedWeightAverageBunchKg, ffbCollectionPoint, photo, type, blockId, plantationScheduleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *  This endpoint is used by Worker to record their upkeep activities on plantation.<br><br> # Glossary  | Keyword | Meaning | | ----------- | ----------- | | Fertilizing | Pemupukan| | Pruning | Penunasan | | Spraying | Penyemprotan | | Slashing | Pembabatan | | Ablation | Kastrasi | | Sanitation | Sanitasi | 
         * @summary Create Plantations Upkeep Activity
         * @param {PlantationsActivitiesCreateUpkeepsRequest} [plantationsActivitiesCreateUpkeepsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async plantationsActivitiesCreateUpkeeps(plantationsActivitiesCreateUpkeepsRequest?: PlantationsActivitiesCreateUpkeepsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlantationsActivitiesCreateUpkeepsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.plantationsActivitiesCreateUpkeeps(plantationsActivitiesCreateUpkeepsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint is used to get plantations activities harvests 
         * @summary Plantations activities get harvests
         * @param {number} [startDate] Start Date for filtering list of data (in epoch) formatted in UTC-0. Will use current date if not provided
         * @param {number} [endDate] End Date for filtering list of data (in epoch) formatted in UTC-0. Will use current date if not provided
         * @param {Array<string>} [harvesterSupervisorId] Filter for the list of harvester supervisor contact id of the related harvesting activity
         * @param {Array<string>} [blockId] Filter for the list of block id of the related harvesting activity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async plantationsActivitiesGetHarvests(startDate?: number, endDate?: number, harvesterSupervisorId?: Array<string>, blockId?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlantationsActivitiesGetHarvestsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.plantationsActivitiesGetHarvests(startDate, endDate, harvesterSupervisorId, blockId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint is used to get the limit of plantations activities creation for current user 
         * @summary Get plantations activities creation limit
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {TypePlantationsActivitiesEnum} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async plantationsActivitiesGetLimits(authorization: string, type?: TypePlantationsActivitiesEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlantationsActivitiesGetLimitsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.plantationsActivitiesGetLimits(authorization, type, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Called by mobile app to Get all Plantation Activity Materials
         * @summary Get all Plantation Activity Materials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async plantationsActivitiesGetMaterials(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlantationsActivitiesMaterialsListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.plantationsActivitiesGetMaterials(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint is used by mobile app to add Smallholder Upkeep activity
         * @summary Create Plantation activity Smallholder Upkeep
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {PlantationsActivitiesSmallholdersCreateUpkeepRequest} [plantationsActivitiesSmallholdersCreateUpkeepRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async plantationsActivitiesSmallholdersCreateUpkeep(aPPTYPE: AppTypeEnum, plantationsActivitiesSmallholdersCreateUpkeepRequest?: PlantationsActivitiesSmallholdersCreateUpkeepRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlantationsActivitiesSmallholdersCreateUpkeepResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.plantationsActivitiesSmallholdersCreateUpkeep(aPPTYPE, plantationsActivitiesSmallholdersCreateUpkeepRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Soft delete Upkeep History record (\"Catat Rawat\") based on the activityUpkeepId
         * @summary Delete Smallholder Activity Upkeep History by ID
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} activityUpkeepId The ID of the activity upkeep
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async plantationsActivitiesSmallholdersDeleteUpkeep(aPPTYPE: AppTypeEnum, activityUpkeepId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlantationsActivitiesSmallholdersDeleteUpkeepResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.plantationsActivitiesSmallholdersDeleteUpkeep(aPPTYPE, activityUpkeepId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint is used by mobile app to show list of Smallholder Upkeep activity
         * @summary Get Plantations activities Smallholders Upkeeps
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} [userId] used by DUTA app, id of the user that this request is for
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async plantationsActivitiesSmallholdersGetUpkeeps(aPPTYPE: AppTypeEnum, userId?: string, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlantationsActivitiesSmallholdersGetUpkeepsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.plantationsActivitiesSmallholdersGetUpkeeps(aPPTYPE, userId, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Called by mobile app to Get all Plantation Activity Smallholder Upkeeps Activities
         * @summary Get all Plantations Activities Smallholders Upkeeps Activities
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async plantationsActivitiesSmallholdersUpkeepsGetActivities(aPPTYPE: AppTypeEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlantationsActivitiesSmallholdersUpkeepsGetActivitiesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.plantationsActivitiesSmallholdersUpkeepsGetActivities(aPPTYPE, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Called by mobile app to Get all Plantation Activity Smallholder Upkeeps material fertilizers
         * @summary Get all Plantation Activity Smallholder Upkeeps material fertilizers
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async plantationsActivitiesSmallholdersUpkeepsMaterialsGetFertilizers(aPPTYPE: AppTypeEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlantationsActivitiesSmallholdersUpkeepsMaterialsGetFertilizersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.plantationsActivitiesSmallholdersUpkeepsMaterialsGetFertilizers(aPPTYPE, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint is used to create plantations activities 
         * @summary Create plantation activities
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {TypePlantationsActivitiesEnum} type 
         * @param {PlantationsCreateActivitiesItemsRequest} items 
         * @param {File} [photo] Photo of harvest fruit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async plantationsCreateActivities(authorization: string, type: TypePlantationsActivitiesEnum, items: PlantationsCreateActivitiesItemsRequest, photo?: File, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlantationsCreateActivitiesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.plantationsCreateActivities(authorization, type, items, photo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Called by mobile app to Create Plantation FFB Sell Price record
         * @summary Create Plantation FFB Sell Price
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {PlantationsCreateFFBSellPriceRequestData} data 
         * @param {File} photo Photo of sales proof could be invoice, weightbridge card etc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async plantationsCreateFFBSellPrice(aPPTYPE: AppTypeEnum, data: PlantationsCreateFFBSellPriceRequestData, photo: File, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlantationsCreateFFBSellPriceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.plantationsCreateFFBSellPrice(aPPTYPE, data, photo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Soft delete FFB Sell Price record (\"Catat Panen\") based on the ffbSellPriceId
         * @summary Delete FFB Sell Price by ID
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} ffbSellPriceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async plantationsDeleteFFBSellPrice(aPPTYPE: AppTypeEnum, ffbSellPriceId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlantationsDeleteFFBSellPriceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.plantationsDeleteFFBSellPrice(aPPTYPE, ffbSellPriceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint is used to create gapoktan plantations deliveries activities 
         * @summary Create plantation delivery activities
         * @param {PlantationsDeliveriesGapoktanCreateActivitiesRequest} [plantationsDeliveriesGapoktanCreateActivitiesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async plantationsDeliveriesGapoktanCreateActivities(plantationsDeliveriesGapoktanCreateActivitiesRequest?: PlantationsDeliveriesGapoktanCreateActivitiesRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlantationsDeliveriesGapoktanCreateActivitiesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.plantationsDeliveriesGapoktanCreateActivities(plantationsDeliveriesGapoktanCreateActivitiesRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Called by mobile app to Get processed users\'s FFB Sell Prices summaries for data visualization
         * @summary Get Plantation FFB Sell Prices summary data
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} farmId filter request by the specified Farm Id
         * @param {number} [year] filter request by the specified year in numeric YYYY format, &lt;br&gt; if value 0 will return ALL data aggregated not filtered by year &amp; month
         * @param {number} [month] filter request by the specified month in numeric MM format, &lt;br&gt; if value 0 will return ALL data aggregated not filtered by month in the specified year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async plantationsFFBSellPricesGetSummaries(aPPTYPE: AppTypeEnum, farmId: string, year?: number, month?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlantationsFFBSellPricesGetSummariesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.plantationsFFBSellPricesGetSummaries(aPPTYPE, farmId, year, month, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Called by mobile app to Get processed users\'s FFB Sell Prices income statement summaries. <br> when this API is called without `farmId`, `year` & `month` query params, will return user\'s income statement from ALL farm aggregated in CURRENT year & CURRENT month
         * @summary Get Plantation FFB Sell Prices Income Statement summary data
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} [farmId] optional, filter request by the specified Farm Id &lt;br&gt; when null will return aggregated data from all user\&#39;s farm
         * @param {number} [year] filter request by the specified year in numeric YYYY format, &lt;br&gt; if value 0 will return ALL data aggregated not filtered by year &amp; month
         * @param {number} [month] filter request by the specified month in numeric MM format, &lt;br&gt; if value 0 will return ALL data aggregated not filtered by month in the specified year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async plantationsFFBSellPricesSummariesGetIncomeStatement(aPPTYPE: AppTypeEnum, farmId?: string, year?: number, month?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlantationsFFBSellPricesSummariesGetIncomeStatementResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.plantationsFFBSellPricesSummariesGetIncomeStatement(aPPTYPE, farmId, year, month, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Endpoint to create or update FFB Sale activity
         * @summary Create or Update FFB Sale
         * @param {PlantationsFfbSaleCreateRequest} plantationsFfbSaleCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async plantationsFfbSaleCreate(plantationsFfbSaleCreateRequest: PlantationsFfbSaleCreateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.plantationsFfbSaleCreate(plantationsFfbSaleCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint is used to get history of plantations activities 
         * @summary Get history of plantation activities
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {TypePlantationsActivitiesEnum} [type] 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {number} [month] Month in MM format
         * @param {number} [year] Year in YYYY format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async plantationsGetActivities(authorization: string, type?: TypePlantationsActivitiesEnum, page?: number, limit?: number, month?: number, year?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlantationsGetActivitiesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.plantationsGetActivities(authorization, type, page, limit, month, year, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint is used to get history of plantations activities harvests reports 
         * @summary Get history of plantation activities harvests reports
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {number} [startDate] Start Date for filtering list of data (in epoch) formatted in UTC-0. Will use current date if not provided
         * @param {number} [endDate] End Date for filtering list of data (in epoch) formatted in UTC-0. Will use current date if not provided
         * @param {Array<string>} [harvesterSupervisorId] Filter for the list of harvester supervisor contact id of the related harvesting activity
         * @param {Array<string>} [blockId] Filter for the list of block id of the related harvesting activity
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async plantationsGetActivitiesHarvestsReports(authorization: string, startDate?: number, endDate?: number, harvesterSupervisorId?: Array<string>, blockId?: Array<string>, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlantationsGetActivitiesHarvestsReportsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.plantationsGetActivitiesHarvestsReports(authorization, startDate, endDate, harvesterSupervisorId, blockId, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Called by mobile app to Get List of users\'s recorder FFB Sell Prices
         * @summary List Plantation FFB Sell Prices
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} [userId] used by DUTA app, id of the user that this request is for
         * @param {string} [farmId] optional, filter request by the specified Farm Id &lt;br&gt; when null will return aggregated data from all user\&#39;s farm
         * @param {number} [year] filter request by the specified year in numeric YYYY format, &lt;br&gt; if value 0 will return ALL data aggregated not filtered by year &amp; month
         * @param {number} [month] filter request by the specified month in numeric MM format, &lt;br&gt; if value 0 will return ALL data aggregated not filtered by month in the specified year
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async plantationsGetFFBSellPrices(aPPTYPE: AppTypeEnum, userId?: string, farmId?: string, year?: number, month?: number, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlantationsGetFFBSellPricesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.plantationsGetFFBSellPrices(aPPTYPE, userId, farmId, year, month, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get detail of FFB Sale
         * @summary Get Plantation FFB Sale
         * @param {string} weighbridgeId Weighbridge UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async plantationsGetFfbSale(weighbridgeId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlantationsGetFfbSaleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.plantationsGetFfbSale(weighbridgeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get summary of FFB Sales, including total deliveries, total FFB weight, revenue, cost, and net profit
         * @summary Get Summary of Plantation FFB Sales
         * @param {string} [supplierId] Supplier ID in UUID type 4 format. Won\&#39;t filter by supplier if not provided
         * @param {number} [date] Date for filtering list of data (in epoch) formatted in UTC-0. Will use current date if not provided
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async plantationsGetFfbSalesSummary(supplierId?: string, date?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlantationsGetFfbSalesSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.plantationsGetFfbSalesSummary(supplierId, date, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Called by mobile app to get List Of Plantation Schedule
         * @summary Get list of plantation activity schedule.
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {PlantationActivityTypeEnum} [activityType] this is for filter plantation schedule by activity type
         * @param {string} [startDate] Start date for filtering plantation schedule date
         * @param {string} [endDate] End date for filtering plantation schedule date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async plantationsGetSchedules(authorization: string, aPPTYPE: AppTypeEnum, activityType?: PlantationActivityTypeEnum, startDate?: string, endDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlantationsGetSchedulesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.plantationsGetSchedules(authorization, aPPTYPE, activityType, startDate, endDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Called by mobile app to Get all Seeds
         * @summary Get all Plantation Seeds without any pagination or query parameters and sorted by sequence
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async plantationsGetSeeds(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlantationsGetSeedsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.plantationsGetSeeds(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get soil types
         * @summary Get Soil Types
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async plantationsGetSoilTypes(aPPTYPE: AppTypeEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlantationsGetSoilTypesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.plantationsGetSoilTypes(aPPTYPE, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get list of FFB Sales of current users\' Supplier (will be fetch by the `contact` and `business` data)
         * @summary Get List of Plantation FFB Sales
         * @param {string} [supplierId] Supplier ID in UUID type 4 format. Won\&#39;t filter by supplier if not provided
         * @param {number} [date] Date for filtering list of data (in epoch) formatted in UTC-0. Will use current date if not provided
         * @param {number} [limit] Number of items per page.
         * @param {number} [page] Current page number to be accessed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async plantationsListFfbSales(supplierId?: string, date?: number, limit?: number, page?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlantationsListFfbSalesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.plantationsListFfbSales(supplierId, date, limit, page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Called by mobile app to Get Farmer Group/Asscociation List of Sales Report Grouped/Aggregated by Year-Month
         * @summary Get Plantation Report Sales data
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} [farmerGroupIds] filter request by the specified Farmer Group Ids &lt;br&gt; accept multiple Farmer Group Ids, comma (URL encoded &#x60;%2C&#x60;) separated.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async plantationsReportsGetSales(aPPTYPE: AppTypeEnum, farmerGroupIds?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlantationsReportsGetSalesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.plantationsReportsGetSales(aPPTYPE, farmerGroupIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Called by mobile app to Get Farmer Group/Asscociation List of Sales Report Details for the specified year & month Per Farmer Groups
         * @summary Get Plantation Report Sales Per Farmer Groups
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {number} year filter request by the specified year in numeric YYYY format
         * @param {number} month filter request by the specified month in numeric MM format
         * @param {string} [farmerGroupIds] filter request by the specified Farmer Group Ids &lt;br&gt; accept multiple Farmer Group Ids, comma (URL encoded &#x60;%2C&#x60;) separated.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async plantationsReportsGetSalesPerFarmerGroup(aPPTYPE: AppTypeEnum, year: number, month: number, farmerGroupIds?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlantationsReportsGetSalesPerFarmerGroupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.plantationsReportsGetSalesPerFarmerGroup(aPPTYPE, year, month, farmerGroupIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Called by mobile app when create Plantation Schedule.
         * @summary Create Plantation Schedule
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {PlantationsSchedulesCreateRequest} plantationsSchedulesCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async plantationsSchedulesCreate(authorization: string, plantationsSchedulesCreateRequest: PlantationsSchedulesCreateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlantationsSchedulesCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.plantationsSchedulesCreate(authorization, plantationsSchedulesCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Called by mobile app to get Plantation Schedule Harvest Activity details.
         * @summary Get plantation activity harvest schedule detail by scheduleId.
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} scheduleId plantation schedule id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async plantationsSchedulesGetHarvestsDetail(authorization: string, aPPTYPE: AppTypeEnum, scheduleId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlantationsSchedulesGetHarvestsDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.plantationsSchedulesGetHarvestsDetail(authorization, aPPTYPE, scheduleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create a new plantation delivery
         * @summary Create a new plantation delivery
         * @param {V2PlantationCreateActivitiesDeliveriesRequest} v2PlantationCreateActivitiesDeliveriesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2PlantationCreateActivitiesDeliveries(v2PlantationCreateActivitiesDeliveriesRequest: V2PlantationCreateActivitiesDeliveriesRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V2PlantationCreateActivitiesDeliveriesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2PlantationCreateActivitiesDeliveries(v2PlantationCreateActivitiesDeliveriesRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint is used by mobile app to add multiple Smallholder Upkeep activity
         * @summary Create Multiple Plantation activity Smallholder Upkeep
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {V2PlantationsActivitiesSmallholdersCreateUpkeepRequest} [v2PlantationsActivitiesSmallholdersCreateUpkeepRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2PlantationsActivitiesSmallholdersCreateUpkeep(aPPTYPE: AppTypeEnum, v2PlantationsActivitiesSmallholdersCreateUpkeepRequest?: V2PlantationsActivitiesSmallholdersCreateUpkeepRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V2PlantationsActivitiesSmallholdersCreateUpkeepResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2PlantationsActivitiesSmallholdersCreateUpkeep(aPPTYPE, v2PlantationsActivitiesSmallholdersCreateUpkeepRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint is used to create plantations activities <br> Changes: - V2 -> change to application/json, support harvest activities for association (gapoktan)<br> 
         * @summary Create Plantation Activities V2
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {V2PlantationsCreateActivitiesRequest} [v2PlantationsCreateActivitiesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2PlantationsCreateActivities(aPPTYPE: AppTypeEnum, v2PlantationsCreateActivitiesRequest?: V2PlantationsCreateActivitiesRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V2PlantationsCreateActivitiesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2PlantationsCreateActivities(aPPTYPE, v2PlantationsCreateActivitiesRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This API is used to create plantation FFB sell price record in bulk
         * @summary Create Plantation FFB Sell Price V2
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {V2PlantationsCreateFFBSellPriceRequest} v2PlantationsCreateFFBSellPriceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2PlantationsCreateFFBSellPrice(aPPTYPE: AppTypeEnum, v2PlantationsCreateFFBSellPriceRequest: V2PlantationsCreateFFBSellPriceRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V2PlantationsCreateFFBSellPriceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2PlantationsCreateFFBSellPrice(aPPTYPE, v2PlantationsCreateFFBSellPriceRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Called by mobile app to get List Of Plantation Schedule
         * @summary Get list of plantation activity schedule.
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {PlantationActivityTypeEnum} [activityType] this is for filter plantation schedule by activity type
         * @param {number} [startDate] Start Date for filtering list of data (in epoch) formatted in UTC-0. Will use current date if not provided
         * @param {number} [endDate] End Date for filtering list of data (in epoch) formatted in UTC-0. Will use current date if not provided
         * @param {PlantationScheduleStatusEnum} [status] this is for filter plantation schedule by status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2PlantationsGetSchedules(authorization: string, activityType?: PlantationActivityTypeEnum, startDate?: number, endDate?: number, status?: PlantationScheduleStatusEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V2PlantationsGetSchedulesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2PlantationsGetSchedules(authorization, activityType, startDate, endDate, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PlantationsApi - factory interface
 * @export
 */
export const PlantationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PlantationsApiFp(configuration)
    return {
        /**
         * Will be used by plantation admin to check the data before update.
         * @summary Get Plantation Expense
         * @param {string} plantationExpenseId plantation expense UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlantationExpense(plantationExpenseId: string, options?: any): AxiosPromise<GetPlantationExpenseResponse> {
            return localVarFp.getPlantationExpense(plantationExpenseId, options).then((request) => request(axios, basePath));
        },
        /**
         * Will be used by plantation admin to check the harvest cost data before update.
         * @summary Get plantation harvest cost detail
         * @param {string} [weighbridgeId] id of harvest in UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlantationHarvestCost(weighbridgeId?: string, options?: any): AxiosPromise<GetPlantationHarvestCostResponse> {
            return localVarFp.getPlantationHarvestCost(weighbridgeId, options).then((request) => request(axios, basePath));
        },
        /**
         * Will be used by plantation admin to check the data before update.
         * @summary Get Plantation Sale
         * @param {string} plantationSaleId plantation sale UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlantationSale(plantationSaleId: string, options?: any): AxiosPromise<GetPlantationSaleResponse> {
            return localVarFp.getPlantationSale(plantationSaleId, options).then((request) => request(axios, basePath));
        },
        /**
         * List of plantation expense inputed by plantation admin
         * @summary Get all list of plantation expense
         * @param {number} [date] Filter date. Will use current date if not provided.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlantationsExpenses(date?: number, options?: any): AxiosPromise<GetPlantationsExpensesResponse> {
            return localVarFp.getPlantationsExpenses(date, options).then((request) => request(axios, basePath));
        },
        /**
         * List of plantation TBS sale inputed by plantation admin
         * @summary Get all list of plantation TBS sale
         * @param {number} [date] Filter date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlantationsSales(date?: number, options?: any): AxiosPromise<GetPlantationsSalesResponse> {
            return localVarFp.getPlantationsSales(date, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint is used by Plantation Management to create a new load activity. Currently only support for Plantation Management. 
         * @summary Create Plantation Load Activity
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {PlantationActivitiesCreateLoadsRequest} [plantationActivitiesCreateLoadsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationActivitiesCreateLoads(aPPTYPE: AppTypeEnum, plantationActivitiesCreateLoadsRequest?: PlantationActivitiesCreateLoadsRequest, options?: any): AxiosPromise<DefaultSuccessResponse> {
            return localVarFp.plantationActivitiesCreateLoads(aPPTYPE, plantationActivitiesCreateLoadsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint is used by Gapoktan Admin to update upkeep-fee of a plantation activity.  This endpoint will have a role validation to verify whether the user accessing this endpoint is Gapoktan Admin or not. If not, then 403 will be thrown. 
         * @summary Update upkeep-fee of a plantation activity
         * @param {string} activityUpkeepId The ID of the activity upkeep
         * @param {PlantationActivityUpkeepFeeUpdateRequest} plantationActivityUpkeepFeeUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationActivityUpkeepFeeUpdate(activityUpkeepId: string, plantationActivityUpkeepFeeUpdateRequest: PlantationActivityUpkeepFeeUpdateRequest, options?: any): AxiosPromise<void> {
            return localVarFp.plantationActivityUpkeepFeeUpdate(activityUpkeepId, plantationActivityUpkeepFeeUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint is used by Gapoktan Admin to get list of upkeep activities.<br><br> This endpoint will have a role validation to verify whether the user accessing this endpoint is Gapoktan Admin or not. If not, then 403 will be thrown. # Glossary  | Keyword | Meaning | | ----------- | ----------- | | Fertilizing | Pemupukan| | Pruning | Penunasan | | Spraying | Penyemprotan | | Slashing | Pembabatan | | Ablation | Kastrasi | | Sanitation | Sanitasi | 
         * @summary Get List of Plantation Upkeep Activity
         * @param {number} [date] Filter date. Will use current date if not provided.
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationActivityUpkeepList(date?: number, page?: number, limit?: number, options?: any): AxiosPromise<PlantationActivityUpkeepListResponse> {
            return localVarFp.plantationActivityUpkeepList(date, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint is used by Gapoktan Admin to get list of weighing activities to bind it with FFB sales data. Will return list of weighing activities that hasn\'t been connected to a weighbridge, or already been connected to a specific weighbridge that\'s being sent via `weighbridgeId` query param.  This endpoint will have a role validation to verify whether the user accessing this endpoint is Gapoktan Admin or not. If not, then 403 will be thrown. 
         * @summary Get List of Plantation Weighing Activity
         * @param {string} weighbridgeId ID of weighbridge ticket
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationActivityWeighingList(weighbridgeId: string, page?: number, limit?: number, options?: any): AxiosPromise<PlantationActivityWeighingListResponse> {
            return localVarFp.plantationActivityWeighingList(weighbridgeId, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Will be used by plantation admin create the expense of plantation.
         * @summary Create the expense of plantation
         * @param {PlantationExpenseCreateUpdateRequest} plantationExpenseCreateUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationExpenseCreate(plantationExpenseCreateUpdateRequest: PlantationExpenseCreateUpdateRequest, options?: any): AxiosPromise<void> {
            return localVarFp.plantationExpenseCreate(plantationExpenseCreateUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Will be used by plantation admin to update the data.
         * @summary Update the plantation expense by {plantationExpenseId}
         * @param {string} plantationExpenseId plantation expense UUID
         * @param {PlantationExpenseCreateUpdateRequest} plantationExpenseCreateUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationExpenseUpdate(plantationExpenseId: string, plantationExpenseCreateUpdateRequest: PlantationExpenseCreateUpdateRequest, options?: any): AxiosPromise<void> {
            return localVarFp.plantationExpenseUpdate(plantationExpenseId, plantationExpenseCreateUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Will be used by plantation admin create or update the wages of plantation harvest cost.
         * @summary Create or Update the wages of plantation harvest cost
         * @param {PlantationHarvestCostCreateRequest} plantationHarvestCostCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationHarvestCostCreate(plantationHarvestCostCreateRequest: PlantationHarvestCostCreateRequest, options?: any): AxiosPromise<void> {
            return localVarFp.plantationHarvestCostCreate(plantationHarvestCostCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Will be used by plantation admin to create or update the data.
         * @summary Create or update the sale of plantation
         * @param {PlantationSaleCreateRequest} plantationSaleCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationSaleCreate(plantationSaleCreateRequest: PlantationSaleCreateRequest, options?: any): AxiosPromise<void> {
            return localVarFp.plantationSaleCreate(plantationSaleCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Map the activity weighing with FFB Sales. This will be used for both save and update. In case of update, existing mapping will be removed and changed into the new one.
         * @summary Map Activity Weighing with Plantation Sale
         * @param {string} weighbridgeId Weighbridge UUID
         * @param {PlantationSaleMapWeighingRequest} plantationSaleMapWeighingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationSaleMapWeighing(weighbridgeId: string, plantationSaleMapWeighingRequest: PlantationSaleMapWeighingRequest, options?: any): AxiosPromise<void> {
            return localVarFp.plantationSaleMapWeighing(weighbridgeId, plantationSaleMapWeighingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint will be called by worker app to create harvesting activity
         * @summary Plantations activities create harvests
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {number} ffbQuantity Quantity of FFB in Janjang
         * @param {number} harvestingDate Date when user take a photo
         * @param {number} latitude 
         * @param {number} longitude 
         * @param {number} submittedAt datetime at UTC+0 in milliseconds when users create locally in offline mode
         * @param {string} userTimezone client timezone when user create harvesting activity
         * @param {string} [id] generated id
         * @param {number} [estimatedWeightAverageBunchKg] Estimated average FFB (BJR/Komidel) weight in kg
         * @param {string} [ffbCollectionPoint] 
         * @param {File} [photo] Photo of harvest fruit
         * @param {string} [type] 
         * @param {string} [blockId] 
         * @param {string} [plantationScheduleId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationsActivitiesCreateHarvests(aPPTYPE: AppTypeEnum, ffbQuantity: number, harvestingDate: number, latitude: number, longitude: number, submittedAt: number, userTimezone: string, id?: string, estimatedWeightAverageBunchKg?: number, ffbCollectionPoint?: string, photo?: File, type?: string, blockId?: string, plantationScheduleId?: string, options?: any): AxiosPromise<PlantationsCreateActivitiesResponse> {
            return localVarFp.plantationsActivitiesCreateHarvests(aPPTYPE, ffbQuantity, harvestingDate, latitude, longitude, submittedAt, userTimezone, id, estimatedWeightAverageBunchKg, ffbCollectionPoint, photo, type, blockId, plantationScheduleId, options).then((request) => request(axios, basePath));
        },
        /**
         *  This endpoint is used by Worker to record their upkeep activities on plantation.<br><br> # Glossary  | Keyword | Meaning | | ----------- | ----------- | | Fertilizing | Pemupukan| | Pruning | Penunasan | | Spraying | Penyemprotan | | Slashing | Pembabatan | | Ablation | Kastrasi | | Sanitation | Sanitasi | 
         * @summary Create Plantations Upkeep Activity
         * @param {PlantationsActivitiesCreateUpkeepsRequest} [plantationsActivitiesCreateUpkeepsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationsActivitiesCreateUpkeeps(plantationsActivitiesCreateUpkeepsRequest?: PlantationsActivitiesCreateUpkeepsRequest, options?: any): AxiosPromise<PlantationsActivitiesCreateUpkeepsResponse> {
            return localVarFp.plantationsActivitiesCreateUpkeeps(plantationsActivitiesCreateUpkeepsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint is used to get plantations activities harvests 
         * @summary Plantations activities get harvests
         * @param {number} [startDate] Start Date for filtering list of data (in epoch) formatted in UTC-0. Will use current date if not provided
         * @param {number} [endDate] End Date for filtering list of data (in epoch) formatted in UTC-0. Will use current date if not provided
         * @param {Array<string>} [harvesterSupervisorId] Filter for the list of harvester supervisor contact id of the related harvesting activity
         * @param {Array<string>} [blockId] Filter for the list of block id of the related harvesting activity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationsActivitiesGetHarvests(startDate?: number, endDate?: number, harvesterSupervisorId?: Array<string>, blockId?: Array<string>, options?: any): AxiosPromise<PlantationsActivitiesGetHarvestsResponse> {
            return localVarFp.plantationsActivitiesGetHarvests(startDate, endDate, harvesterSupervisorId, blockId, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint is used to get the limit of plantations activities creation for current user 
         * @summary Get plantations activities creation limit
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {TypePlantationsActivitiesEnum} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationsActivitiesGetLimits(authorization: string, type?: TypePlantationsActivitiesEnum, options?: any): AxiosPromise<PlantationsActivitiesGetLimitsResponse> {
            return localVarFp.plantationsActivitiesGetLimits(authorization, type, options).then((request) => request(axios, basePath));
        },
        /**
         * Called by mobile app to Get all Plantation Activity Materials
         * @summary Get all Plantation Activity Materials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationsActivitiesGetMaterials(options?: any): AxiosPromise<PlantationsActivitiesMaterialsListResponse> {
            return localVarFp.plantationsActivitiesGetMaterials(options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint is used by mobile app to add Smallholder Upkeep activity
         * @summary Create Plantation activity Smallholder Upkeep
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {PlantationsActivitiesSmallholdersCreateUpkeepRequest} [plantationsActivitiesSmallholdersCreateUpkeepRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationsActivitiesSmallholdersCreateUpkeep(aPPTYPE: AppTypeEnum, plantationsActivitiesSmallholdersCreateUpkeepRequest?: PlantationsActivitiesSmallholdersCreateUpkeepRequest, options?: any): AxiosPromise<PlantationsActivitiesSmallholdersCreateUpkeepResponse> {
            return localVarFp.plantationsActivitiesSmallholdersCreateUpkeep(aPPTYPE, plantationsActivitiesSmallholdersCreateUpkeepRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Soft delete Upkeep History record (\"Catat Rawat\") based on the activityUpkeepId
         * @summary Delete Smallholder Activity Upkeep History by ID
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} activityUpkeepId The ID of the activity upkeep
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationsActivitiesSmallholdersDeleteUpkeep(aPPTYPE: AppTypeEnum, activityUpkeepId: string, options?: any): AxiosPromise<PlantationsActivitiesSmallholdersDeleteUpkeepResponse> {
            return localVarFp.plantationsActivitiesSmallholdersDeleteUpkeep(aPPTYPE, activityUpkeepId, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint is used by mobile app to show list of Smallholder Upkeep activity
         * @summary Get Plantations activities Smallholders Upkeeps
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} [userId] used by DUTA app, id of the user that this request is for
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationsActivitiesSmallholdersGetUpkeeps(aPPTYPE: AppTypeEnum, userId?: string, page?: number, limit?: number, options?: any): AxiosPromise<PlantationsActivitiesSmallholdersGetUpkeepsResponse> {
            return localVarFp.plantationsActivitiesSmallholdersGetUpkeeps(aPPTYPE, userId, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Called by mobile app to Get all Plantation Activity Smallholder Upkeeps Activities
         * @summary Get all Plantations Activities Smallholders Upkeeps Activities
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationsActivitiesSmallholdersUpkeepsGetActivities(aPPTYPE: AppTypeEnum, options?: any): AxiosPromise<PlantationsActivitiesSmallholdersUpkeepsGetActivitiesResponse> {
            return localVarFp.plantationsActivitiesSmallholdersUpkeepsGetActivities(aPPTYPE, options).then((request) => request(axios, basePath));
        },
        /**
         * Called by mobile app to Get all Plantation Activity Smallholder Upkeeps material fertilizers
         * @summary Get all Plantation Activity Smallholder Upkeeps material fertilizers
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationsActivitiesSmallholdersUpkeepsMaterialsGetFertilizers(aPPTYPE: AppTypeEnum, options?: any): AxiosPromise<PlantationsActivitiesSmallholdersUpkeepsMaterialsGetFertilizersResponse> {
            return localVarFp.plantationsActivitiesSmallholdersUpkeepsMaterialsGetFertilizers(aPPTYPE, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint is used to create plantations activities 
         * @summary Create plantation activities
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {TypePlantationsActivitiesEnum} type 
         * @param {PlantationsCreateActivitiesItemsRequest} items 
         * @param {File} [photo] Photo of harvest fruit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationsCreateActivities(authorization: string, type: TypePlantationsActivitiesEnum, items: PlantationsCreateActivitiesItemsRequest, photo?: File, options?: any): AxiosPromise<PlantationsCreateActivitiesResponse> {
            return localVarFp.plantationsCreateActivities(authorization, type, items, photo, options).then((request) => request(axios, basePath));
        },
        /**
         * Called by mobile app to Create Plantation FFB Sell Price record
         * @summary Create Plantation FFB Sell Price
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {PlantationsCreateFFBSellPriceRequestData} data 
         * @param {File} photo Photo of sales proof could be invoice, weightbridge card etc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationsCreateFFBSellPrice(aPPTYPE: AppTypeEnum, data: PlantationsCreateFFBSellPriceRequestData, photo: File, options?: any): AxiosPromise<PlantationsCreateFFBSellPriceResponse> {
            return localVarFp.plantationsCreateFFBSellPrice(aPPTYPE, data, photo, options).then((request) => request(axios, basePath));
        },
        /**
         * Soft delete FFB Sell Price record (\"Catat Panen\") based on the ffbSellPriceId
         * @summary Delete FFB Sell Price by ID
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} ffbSellPriceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationsDeleteFFBSellPrice(aPPTYPE: AppTypeEnum, ffbSellPriceId: string, options?: any): AxiosPromise<PlantationsDeleteFFBSellPriceResponse> {
            return localVarFp.plantationsDeleteFFBSellPrice(aPPTYPE, ffbSellPriceId, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint is used to create gapoktan plantations deliveries activities 
         * @summary Create plantation delivery activities
         * @param {PlantationsDeliveriesGapoktanCreateActivitiesRequest} [plantationsDeliveriesGapoktanCreateActivitiesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationsDeliveriesGapoktanCreateActivities(plantationsDeliveriesGapoktanCreateActivitiesRequest?: PlantationsDeliveriesGapoktanCreateActivitiesRequest, options?: any): AxiosPromise<PlantationsDeliveriesGapoktanCreateActivitiesResponse> {
            return localVarFp.plantationsDeliveriesGapoktanCreateActivities(plantationsDeliveriesGapoktanCreateActivitiesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Called by mobile app to Get processed users\'s FFB Sell Prices summaries for data visualization
         * @summary Get Plantation FFB Sell Prices summary data
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} farmId filter request by the specified Farm Id
         * @param {number} [year] filter request by the specified year in numeric YYYY format, &lt;br&gt; if value 0 will return ALL data aggregated not filtered by year &amp; month
         * @param {number} [month] filter request by the specified month in numeric MM format, &lt;br&gt; if value 0 will return ALL data aggregated not filtered by month in the specified year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationsFFBSellPricesGetSummaries(aPPTYPE: AppTypeEnum, farmId: string, year?: number, month?: number, options?: any): AxiosPromise<PlantationsFFBSellPricesGetSummariesResponse> {
            return localVarFp.plantationsFFBSellPricesGetSummaries(aPPTYPE, farmId, year, month, options).then((request) => request(axios, basePath));
        },
        /**
         * Called by mobile app to Get processed users\'s FFB Sell Prices income statement summaries. <br> when this API is called without `farmId`, `year` & `month` query params, will return user\'s income statement from ALL farm aggregated in CURRENT year & CURRENT month
         * @summary Get Plantation FFB Sell Prices Income Statement summary data
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} [farmId] optional, filter request by the specified Farm Id &lt;br&gt; when null will return aggregated data from all user\&#39;s farm
         * @param {number} [year] filter request by the specified year in numeric YYYY format, &lt;br&gt; if value 0 will return ALL data aggregated not filtered by year &amp; month
         * @param {number} [month] filter request by the specified month in numeric MM format, &lt;br&gt; if value 0 will return ALL data aggregated not filtered by month in the specified year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationsFFBSellPricesSummariesGetIncomeStatement(aPPTYPE: AppTypeEnum, farmId?: string, year?: number, month?: number, options?: any): AxiosPromise<PlantationsFFBSellPricesSummariesGetIncomeStatementResponse> {
            return localVarFp.plantationsFFBSellPricesSummariesGetIncomeStatement(aPPTYPE, farmId, year, month, options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint to create or update FFB Sale activity
         * @summary Create or Update FFB Sale
         * @param {PlantationsFfbSaleCreateRequest} plantationsFfbSaleCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationsFfbSaleCreate(plantationsFfbSaleCreateRequest: PlantationsFfbSaleCreateRequest, options?: any): AxiosPromise<void> {
            return localVarFp.plantationsFfbSaleCreate(plantationsFfbSaleCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint is used to get history of plantations activities 
         * @summary Get history of plantation activities
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {TypePlantationsActivitiesEnum} [type] 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {number} [month] Month in MM format
         * @param {number} [year] Year in YYYY format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationsGetActivities(authorization: string, type?: TypePlantationsActivitiesEnum, page?: number, limit?: number, month?: number, year?: number, options?: any): AxiosPromise<PlantationsGetActivitiesResponse> {
            return localVarFp.plantationsGetActivities(authorization, type, page, limit, month, year, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint is used to get history of plantations activities harvests reports 
         * @summary Get history of plantation activities harvests reports
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {number} [startDate] Start Date for filtering list of data (in epoch) formatted in UTC-0. Will use current date if not provided
         * @param {number} [endDate] End Date for filtering list of data (in epoch) formatted in UTC-0. Will use current date if not provided
         * @param {Array<string>} [harvesterSupervisorId] Filter for the list of harvester supervisor contact id of the related harvesting activity
         * @param {Array<string>} [blockId] Filter for the list of block id of the related harvesting activity
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationsGetActivitiesHarvestsReports(authorization: string, startDate?: number, endDate?: number, harvesterSupervisorId?: Array<string>, blockId?: Array<string>, page?: number, limit?: number, options?: any): AxiosPromise<PlantationsGetActivitiesHarvestsReportsResponse> {
            return localVarFp.plantationsGetActivitiesHarvestsReports(authorization, startDate, endDate, harvesterSupervisorId, blockId, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Called by mobile app to Get List of users\'s recorder FFB Sell Prices
         * @summary List Plantation FFB Sell Prices
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} [userId] used by DUTA app, id of the user that this request is for
         * @param {string} [farmId] optional, filter request by the specified Farm Id &lt;br&gt; when null will return aggregated data from all user\&#39;s farm
         * @param {number} [year] filter request by the specified year in numeric YYYY format, &lt;br&gt; if value 0 will return ALL data aggregated not filtered by year &amp; month
         * @param {number} [month] filter request by the specified month in numeric MM format, &lt;br&gt; if value 0 will return ALL data aggregated not filtered by month in the specified year
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationsGetFFBSellPrices(aPPTYPE: AppTypeEnum, userId?: string, farmId?: string, year?: number, month?: number, page?: number, limit?: number, options?: any): AxiosPromise<PlantationsGetFFBSellPricesResponse> {
            return localVarFp.plantationsGetFFBSellPrices(aPPTYPE, userId, farmId, year, month, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Get detail of FFB Sale
         * @summary Get Plantation FFB Sale
         * @param {string} weighbridgeId Weighbridge UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationsGetFfbSale(weighbridgeId: string, options?: any): AxiosPromise<PlantationsGetFfbSaleResponse> {
            return localVarFp.plantationsGetFfbSale(weighbridgeId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get summary of FFB Sales, including total deliveries, total FFB weight, revenue, cost, and net profit
         * @summary Get Summary of Plantation FFB Sales
         * @param {string} [supplierId] Supplier ID in UUID type 4 format. Won\&#39;t filter by supplier if not provided
         * @param {number} [date] Date for filtering list of data (in epoch) formatted in UTC-0. Will use current date if not provided
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationsGetFfbSalesSummary(supplierId?: string, date?: number, options?: any): AxiosPromise<PlantationsGetFfbSalesSummaryResponse> {
            return localVarFp.plantationsGetFfbSalesSummary(supplierId, date, options).then((request) => request(axios, basePath));
        },
        /**
         * Called by mobile app to get List Of Plantation Schedule
         * @summary Get list of plantation activity schedule.
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {PlantationActivityTypeEnum} [activityType] this is for filter plantation schedule by activity type
         * @param {string} [startDate] Start date for filtering plantation schedule date
         * @param {string} [endDate] End date for filtering plantation schedule date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationsGetSchedules(authorization: string, aPPTYPE: AppTypeEnum, activityType?: PlantationActivityTypeEnum, startDate?: string, endDate?: string, options?: any): AxiosPromise<PlantationsGetSchedulesResponse> {
            return localVarFp.plantationsGetSchedules(authorization, aPPTYPE, activityType, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * Called by mobile app to Get all Seeds
         * @summary Get all Plantation Seeds without any pagination or query parameters and sorted by sequence
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationsGetSeeds(options?: any): AxiosPromise<PlantationsGetSeedsResponse> {
            return localVarFp.plantationsGetSeeds(options).then((request) => request(axios, basePath));
        },
        /**
         * Get soil types
         * @summary Get Soil Types
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationsGetSoilTypes(aPPTYPE: AppTypeEnum, options?: any): AxiosPromise<PlantationsGetSoilTypesResponse> {
            return localVarFp.plantationsGetSoilTypes(aPPTYPE, options).then((request) => request(axios, basePath));
        },
        /**
         * Get list of FFB Sales of current users\' Supplier (will be fetch by the `contact` and `business` data)
         * @summary Get List of Plantation FFB Sales
         * @param {string} [supplierId] Supplier ID in UUID type 4 format. Won\&#39;t filter by supplier if not provided
         * @param {number} [date] Date for filtering list of data (in epoch) formatted in UTC-0. Will use current date if not provided
         * @param {number} [limit] Number of items per page.
         * @param {number} [page] Current page number to be accessed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationsListFfbSales(supplierId?: string, date?: number, limit?: number, page?: number, options?: any): AxiosPromise<PlantationsListFfbSalesResponse> {
            return localVarFp.plantationsListFfbSales(supplierId, date, limit, page, options).then((request) => request(axios, basePath));
        },
        /**
         * Called by mobile app to Get Farmer Group/Asscociation List of Sales Report Grouped/Aggregated by Year-Month
         * @summary Get Plantation Report Sales data
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} [farmerGroupIds] filter request by the specified Farmer Group Ids &lt;br&gt; accept multiple Farmer Group Ids, comma (URL encoded &#x60;%2C&#x60;) separated.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationsReportsGetSales(aPPTYPE: AppTypeEnum, farmerGroupIds?: string, options?: any): AxiosPromise<PlantationsReportsGetSalesResponse> {
            return localVarFp.plantationsReportsGetSales(aPPTYPE, farmerGroupIds, options).then((request) => request(axios, basePath));
        },
        /**
         * Called by mobile app to Get Farmer Group/Asscociation List of Sales Report Details for the specified year & month Per Farmer Groups
         * @summary Get Plantation Report Sales Per Farmer Groups
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {number} year filter request by the specified year in numeric YYYY format
         * @param {number} month filter request by the specified month in numeric MM format
         * @param {string} [farmerGroupIds] filter request by the specified Farmer Group Ids &lt;br&gt; accept multiple Farmer Group Ids, comma (URL encoded &#x60;%2C&#x60;) separated.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationsReportsGetSalesPerFarmerGroup(aPPTYPE: AppTypeEnum, year: number, month: number, farmerGroupIds?: string, options?: any): AxiosPromise<PlantationsReportsGetSalesPerFarmerGroupResponse> {
            return localVarFp.plantationsReportsGetSalesPerFarmerGroup(aPPTYPE, year, month, farmerGroupIds, options).then((request) => request(axios, basePath));
        },
        /**
         * Called by mobile app when create Plantation Schedule.
         * @summary Create Plantation Schedule
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {PlantationsSchedulesCreateRequest} plantationsSchedulesCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationsSchedulesCreate(authorization: string, plantationsSchedulesCreateRequest: PlantationsSchedulesCreateRequest, options?: any): AxiosPromise<PlantationsSchedulesCreateResponse> {
            return localVarFp.plantationsSchedulesCreate(authorization, plantationsSchedulesCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Called by mobile app to get Plantation Schedule Harvest Activity details.
         * @summary Get plantation activity harvest schedule detail by scheduleId.
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {string} scheduleId plantation schedule id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantationsSchedulesGetHarvestsDetail(authorization: string, aPPTYPE: AppTypeEnum, scheduleId: string, options?: any): AxiosPromise<PlantationsSchedulesGetHarvestsDetailResponse> {
            return localVarFp.plantationsSchedulesGetHarvestsDetail(authorization, aPPTYPE, scheduleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new plantation delivery
         * @summary Create a new plantation delivery
         * @param {V2PlantationCreateActivitiesDeliveriesRequest} v2PlantationCreateActivitiesDeliveriesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2PlantationCreateActivitiesDeliveries(v2PlantationCreateActivitiesDeliveriesRequest: V2PlantationCreateActivitiesDeliveriesRequest, options?: any): AxiosPromise<V2PlantationCreateActivitiesDeliveriesResponse> {
            return localVarFp.v2PlantationCreateActivitiesDeliveries(v2PlantationCreateActivitiesDeliveriesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint is used by mobile app to add multiple Smallholder Upkeep activity
         * @summary Create Multiple Plantation activity Smallholder Upkeep
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {V2PlantationsActivitiesSmallholdersCreateUpkeepRequest} [v2PlantationsActivitiesSmallholdersCreateUpkeepRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2PlantationsActivitiesSmallholdersCreateUpkeep(aPPTYPE: AppTypeEnum, v2PlantationsActivitiesSmallholdersCreateUpkeepRequest?: V2PlantationsActivitiesSmallholdersCreateUpkeepRequest, options?: any): AxiosPromise<V2PlantationsActivitiesSmallholdersCreateUpkeepResponse> {
            return localVarFp.v2PlantationsActivitiesSmallholdersCreateUpkeep(aPPTYPE, v2PlantationsActivitiesSmallholdersCreateUpkeepRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint is used to create plantations activities <br> Changes: - V2 -> change to application/json, support harvest activities for association (gapoktan)<br> 
         * @summary Create Plantation Activities V2
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {V2PlantationsCreateActivitiesRequest} [v2PlantationsCreateActivitiesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2PlantationsCreateActivities(aPPTYPE: AppTypeEnum, v2PlantationsCreateActivitiesRequest?: V2PlantationsCreateActivitiesRequest, options?: any): AxiosPromise<V2PlantationsCreateActivitiesResponse> {
            return localVarFp.v2PlantationsCreateActivities(aPPTYPE, v2PlantationsCreateActivitiesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This API is used to create plantation FFB sell price record in bulk
         * @summary Create Plantation FFB Sell Price V2
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {V2PlantationsCreateFFBSellPriceRequest} v2PlantationsCreateFFBSellPriceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2PlantationsCreateFFBSellPrice(aPPTYPE: AppTypeEnum, v2PlantationsCreateFFBSellPriceRequest: V2PlantationsCreateFFBSellPriceRequest, options?: any): AxiosPromise<V2PlantationsCreateFFBSellPriceResponse> {
            return localVarFp.v2PlantationsCreateFFBSellPrice(aPPTYPE, v2PlantationsCreateFFBSellPriceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Called by mobile app to get List Of Plantation Schedule
         * @summary Get list of plantation activity schedule.
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {PlantationActivityTypeEnum} [activityType] this is for filter plantation schedule by activity type
         * @param {number} [startDate] Start Date for filtering list of data (in epoch) formatted in UTC-0. Will use current date if not provided
         * @param {number} [endDate] End Date for filtering list of data (in epoch) formatted in UTC-0. Will use current date if not provided
         * @param {PlantationScheduleStatusEnum} [status] this is for filter plantation schedule by status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2PlantationsGetSchedules(authorization: string, activityType?: PlantationActivityTypeEnum, startDate?: number, endDate?: number, status?: PlantationScheduleStatusEnum, options?: any): AxiosPromise<V2PlantationsGetSchedulesResponse> {
            return localVarFp.v2PlantationsGetSchedules(authorization, activityType, startDate, endDate, status, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PlantationsApi - object-oriented interface
 * @export
 * @class PlantationsApi
 * @extends {BaseAPI}
 */
export class PlantationsApi extends BaseAPI {
    /**
     * Will be used by plantation admin to check the data before update.
     * @summary Get Plantation Expense
     * @param {string} plantationExpenseId plantation expense UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlantationsApi
     */
    public getPlantationExpense(plantationExpenseId: string, options?: AxiosRequestConfig) {
        return PlantationsApiFp(this.configuration).getPlantationExpense(plantationExpenseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Will be used by plantation admin to check the harvest cost data before update.
     * @summary Get plantation harvest cost detail
     * @param {string} [weighbridgeId] id of harvest in UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlantationsApi
     */
    public getPlantationHarvestCost(weighbridgeId?: string, options?: AxiosRequestConfig) {
        return PlantationsApiFp(this.configuration).getPlantationHarvestCost(weighbridgeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Will be used by plantation admin to check the data before update.
     * @summary Get Plantation Sale
     * @param {string} plantationSaleId plantation sale UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlantationsApi
     */
    public getPlantationSale(plantationSaleId: string, options?: AxiosRequestConfig) {
        return PlantationsApiFp(this.configuration).getPlantationSale(plantationSaleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List of plantation expense inputed by plantation admin
     * @summary Get all list of plantation expense
     * @param {number} [date] Filter date. Will use current date if not provided.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlantationsApi
     */
    public getPlantationsExpenses(date?: number, options?: AxiosRequestConfig) {
        return PlantationsApiFp(this.configuration).getPlantationsExpenses(date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List of plantation TBS sale inputed by plantation admin
     * @summary Get all list of plantation TBS sale
     * @param {number} [date] Filter date
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlantationsApi
     */
    public getPlantationsSales(date?: number, options?: AxiosRequestConfig) {
        return PlantationsApiFp(this.configuration).getPlantationsSales(date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint is used by Plantation Management to create a new load activity. Currently only support for Plantation Management. 
     * @summary Create Plantation Load Activity
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {PlantationActivitiesCreateLoadsRequest} [plantationActivitiesCreateLoadsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlantationsApi
     */
    public plantationActivitiesCreateLoads(aPPTYPE: AppTypeEnum, plantationActivitiesCreateLoadsRequest?: PlantationActivitiesCreateLoadsRequest, options?: AxiosRequestConfig) {
        return PlantationsApiFp(this.configuration).plantationActivitiesCreateLoads(aPPTYPE, plantationActivitiesCreateLoadsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint is used by Gapoktan Admin to update upkeep-fee of a plantation activity.  This endpoint will have a role validation to verify whether the user accessing this endpoint is Gapoktan Admin or not. If not, then 403 will be thrown. 
     * @summary Update upkeep-fee of a plantation activity
     * @param {string} activityUpkeepId The ID of the activity upkeep
     * @param {PlantationActivityUpkeepFeeUpdateRequest} plantationActivityUpkeepFeeUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlantationsApi
     */
    public plantationActivityUpkeepFeeUpdate(activityUpkeepId: string, plantationActivityUpkeepFeeUpdateRequest: PlantationActivityUpkeepFeeUpdateRequest, options?: AxiosRequestConfig) {
        return PlantationsApiFp(this.configuration).plantationActivityUpkeepFeeUpdate(activityUpkeepId, plantationActivityUpkeepFeeUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint is used by Gapoktan Admin to get list of upkeep activities.<br><br> This endpoint will have a role validation to verify whether the user accessing this endpoint is Gapoktan Admin or not. If not, then 403 will be thrown. # Glossary  | Keyword | Meaning | | ----------- | ----------- | | Fertilizing | Pemupukan| | Pruning | Penunasan | | Spraying | Penyemprotan | | Slashing | Pembabatan | | Ablation | Kastrasi | | Sanitation | Sanitasi | 
     * @summary Get List of Plantation Upkeep Activity
     * @param {number} [date] Filter date. Will use current date if not provided.
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlantationsApi
     */
    public plantationActivityUpkeepList(date?: number, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return PlantationsApiFp(this.configuration).plantationActivityUpkeepList(date, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint is used by Gapoktan Admin to get list of weighing activities to bind it with FFB sales data. Will return list of weighing activities that hasn\'t been connected to a weighbridge, or already been connected to a specific weighbridge that\'s being sent via `weighbridgeId` query param.  This endpoint will have a role validation to verify whether the user accessing this endpoint is Gapoktan Admin or not. If not, then 403 will be thrown. 
     * @summary Get List of Plantation Weighing Activity
     * @param {string} weighbridgeId ID of weighbridge ticket
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlantationsApi
     */
    public plantationActivityWeighingList(weighbridgeId: string, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return PlantationsApiFp(this.configuration).plantationActivityWeighingList(weighbridgeId, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Will be used by plantation admin create the expense of plantation.
     * @summary Create the expense of plantation
     * @param {PlantationExpenseCreateUpdateRequest} plantationExpenseCreateUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlantationsApi
     */
    public plantationExpenseCreate(plantationExpenseCreateUpdateRequest: PlantationExpenseCreateUpdateRequest, options?: AxiosRequestConfig) {
        return PlantationsApiFp(this.configuration).plantationExpenseCreate(plantationExpenseCreateUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Will be used by plantation admin to update the data.
     * @summary Update the plantation expense by {plantationExpenseId}
     * @param {string} plantationExpenseId plantation expense UUID
     * @param {PlantationExpenseCreateUpdateRequest} plantationExpenseCreateUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlantationsApi
     */
    public plantationExpenseUpdate(plantationExpenseId: string, plantationExpenseCreateUpdateRequest: PlantationExpenseCreateUpdateRequest, options?: AxiosRequestConfig) {
        return PlantationsApiFp(this.configuration).plantationExpenseUpdate(plantationExpenseId, plantationExpenseCreateUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Will be used by plantation admin create or update the wages of plantation harvest cost.
     * @summary Create or Update the wages of plantation harvest cost
     * @param {PlantationHarvestCostCreateRequest} plantationHarvestCostCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlantationsApi
     */
    public plantationHarvestCostCreate(plantationHarvestCostCreateRequest: PlantationHarvestCostCreateRequest, options?: AxiosRequestConfig) {
        return PlantationsApiFp(this.configuration).plantationHarvestCostCreate(plantationHarvestCostCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Will be used by plantation admin to create or update the data.
     * @summary Create or update the sale of plantation
     * @param {PlantationSaleCreateRequest} plantationSaleCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlantationsApi
     */
    public plantationSaleCreate(plantationSaleCreateRequest: PlantationSaleCreateRequest, options?: AxiosRequestConfig) {
        return PlantationsApiFp(this.configuration).plantationSaleCreate(plantationSaleCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Map the activity weighing with FFB Sales. This will be used for both save and update. In case of update, existing mapping will be removed and changed into the new one.
     * @summary Map Activity Weighing with Plantation Sale
     * @param {string} weighbridgeId Weighbridge UUID
     * @param {PlantationSaleMapWeighingRequest} plantationSaleMapWeighingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlantationsApi
     */
    public plantationSaleMapWeighing(weighbridgeId: string, plantationSaleMapWeighingRequest: PlantationSaleMapWeighingRequest, options?: AxiosRequestConfig) {
        return PlantationsApiFp(this.configuration).plantationSaleMapWeighing(weighbridgeId, plantationSaleMapWeighingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint will be called by worker app to create harvesting activity
     * @summary Plantations activities create harvests
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {number} ffbQuantity Quantity of FFB in Janjang
     * @param {number} harvestingDate Date when user take a photo
     * @param {number} latitude 
     * @param {number} longitude 
     * @param {number} submittedAt datetime at UTC+0 in milliseconds when users create locally in offline mode
     * @param {string} userTimezone client timezone when user create harvesting activity
     * @param {string} [id] generated id
     * @param {number} [estimatedWeightAverageBunchKg] Estimated average FFB (BJR/Komidel) weight in kg
     * @param {string} [ffbCollectionPoint] 
     * @param {File} [photo] Photo of harvest fruit
     * @param {string} [type] 
     * @param {string} [blockId] 
     * @param {string} [plantationScheduleId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlantationsApi
     */
    public plantationsActivitiesCreateHarvests(aPPTYPE: AppTypeEnum, ffbQuantity: number, harvestingDate: number, latitude: number, longitude: number, submittedAt: number, userTimezone: string, id?: string, estimatedWeightAverageBunchKg?: number, ffbCollectionPoint?: string, photo?: File, type?: string, blockId?: string, plantationScheduleId?: string, options?: AxiosRequestConfig) {
        return PlantationsApiFp(this.configuration).plantationsActivitiesCreateHarvests(aPPTYPE, ffbQuantity, harvestingDate, latitude, longitude, submittedAt, userTimezone, id, estimatedWeightAverageBunchKg, ffbCollectionPoint, photo, type, blockId, plantationScheduleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  This endpoint is used by Worker to record their upkeep activities on plantation.<br><br> # Glossary  | Keyword | Meaning | | ----------- | ----------- | | Fertilizing | Pemupukan| | Pruning | Penunasan | | Spraying | Penyemprotan | | Slashing | Pembabatan | | Ablation | Kastrasi | | Sanitation | Sanitasi | 
     * @summary Create Plantations Upkeep Activity
     * @param {PlantationsActivitiesCreateUpkeepsRequest} [plantationsActivitiesCreateUpkeepsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlantationsApi
     */
    public plantationsActivitiesCreateUpkeeps(plantationsActivitiesCreateUpkeepsRequest?: PlantationsActivitiesCreateUpkeepsRequest, options?: AxiosRequestConfig) {
        return PlantationsApiFp(this.configuration).plantationsActivitiesCreateUpkeeps(plantationsActivitiesCreateUpkeepsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint is used to get plantations activities harvests 
     * @summary Plantations activities get harvests
     * @param {number} [startDate] Start Date for filtering list of data (in epoch) formatted in UTC-0. Will use current date if not provided
     * @param {number} [endDate] End Date for filtering list of data (in epoch) formatted in UTC-0. Will use current date if not provided
     * @param {Array<string>} [harvesterSupervisorId] Filter for the list of harvester supervisor contact id of the related harvesting activity
     * @param {Array<string>} [blockId] Filter for the list of block id of the related harvesting activity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlantationsApi
     */
    public plantationsActivitiesGetHarvests(startDate?: number, endDate?: number, harvesterSupervisorId?: Array<string>, blockId?: Array<string>, options?: AxiosRequestConfig) {
        return PlantationsApiFp(this.configuration).plantationsActivitiesGetHarvests(startDate, endDate, harvesterSupervisorId, blockId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint is used to get the limit of plantations activities creation for current user 
     * @summary Get plantations activities creation limit
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {TypePlantationsActivitiesEnum} [type] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlantationsApi
     */
    public plantationsActivitiesGetLimits(authorization: string, type?: TypePlantationsActivitiesEnum, options?: AxiosRequestConfig) {
        return PlantationsApiFp(this.configuration).plantationsActivitiesGetLimits(authorization, type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Called by mobile app to Get all Plantation Activity Materials
     * @summary Get all Plantation Activity Materials
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlantationsApi
     */
    public plantationsActivitiesGetMaterials(options?: AxiosRequestConfig) {
        return PlantationsApiFp(this.configuration).plantationsActivitiesGetMaterials(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint is used by mobile app to add Smallholder Upkeep activity
     * @summary Create Plantation activity Smallholder Upkeep
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {PlantationsActivitiesSmallholdersCreateUpkeepRequest} [plantationsActivitiesSmallholdersCreateUpkeepRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlantationsApi
     */
    public plantationsActivitiesSmallholdersCreateUpkeep(aPPTYPE: AppTypeEnum, plantationsActivitiesSmallholdersCreateUpkeepRequest?: PlantationsActivitiesSmallholdersCreateUpkeepRequest, options?: AxiosRequestConfig) {
        return PlantationsApiFp(this.configuration).plantationsActivitiesSmallholdersCreateUpkeep(aPPTYPE, plantationsActivitiesSmallholdersCreateUpkeepRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Soft delete Upkeep History record (\"Catat Rawat\") based on the activityUpkeepId
     * @summary Delete Smallholder Activity Upkeep History by ID
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} activityUpkeepId The ID of the activity upkeep
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlantationsApi
     */
    public plantationsActivitiesSmallholdersDeleteUpkeep(aPPTYPE: AppTypeEnum, activityUpkeepId: string, options?: AxiosRequestConfig) {
        return PlantationsApiFp(this.configuration).plantationsActivitiesSmallholdersDeleteUpkeep(aPPTYPE, activityUpkeepId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint is used by mobile app to show list of Smallholder Upkeep activity
     * @summary Get Plantations activities Smallholders Upkeeps
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} [userId] used by DUTA app, id of the user that this request is for
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlantationsApi
     */
    public plantationsActivitiesSmallholdersGetUpkeeps(aPPTYPE: AppTypeEnum, userId?: string, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return PlantationsApiFp(this.configuration).plantationsActivitiesSmallholdersGetUpkeeps(aPPTYPE, userId, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Called by mobile app to Get all Plantation Activity Smallholder Upkeeps Activities
     * @summary Get all Plantations Activities Smallholders Upkeeps Activities
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlantationsApi
     */
    public plantationsActivitiesSmallholdersUpkeepsGetActivities(aPPTYPE: AppTypeEnum, options?: AxiosRequestConfig) {
        return PlantationsApiFp(this.configuration).plantationsActivitiesSmallholdersUpkeepsGetActivities(aPPTYPE, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Called by mobile app to Get all Plantation Activity Smallholder Upkeeps material fertilizers
     * @summary Get all Plantation Activity Smallholder Upkeeps material fertilizers
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlantationsApi
     */
    public plantationsActivitiesSmallholdersUpkeepsMaterialsGetFertilizers(aPPTYPE: AppTypeEnum, options?: AxiosRequestConfig) {
        return PlantationsApiFp(this.configuration).plantationsActivitiesSmallholdersUpkeepsMaterialsGetFertilizers(aPPTYPE, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint is used to create plantations activities 
     * @summary Create plantation activities
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {TypePlantationsActivitiesEnum} type 
     * @param {PlantationsCreateActivitiesItemsRequest} items 
     * @param {File} [photo] Photo of harvest fruit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlantationsApi
     */
    public plantationsCreateActivities(authorization: string, type: TypePlantationsActivitiesEnum, items: PlantationsCreateActivitiesItemsRequest, photo?: File, options?: AxiosRequestConfig) {
        return PlantationsApiFp(this.configuration).plantationsCreateActivities(authorization, type, items, photo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Called by mobile app to Create Plantation FFB Sell Price record
     * @summary Create Plantation FFB Sell Price
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {PlantationsCreateFFBSellPriceRequestData} data 
     * @param {File} photo Photo of sales proof could be invoice, weightbridge card etc
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlantationsApi
     */
    public plantationsCreateFFBSellPrice(aPPTYPE: AppTypeEnum, data: PlantationsCreateFFBSellPriceRequestData, photo: File, options?: AxiosRequestConfig) {
        return PlantationsApiFp(this.configuration).plantationsCreateFFBSellPrice(aPPTYPE, data, photo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Soft delete FFB Sell Price record (\"Catat Panen\") based on the ffbSellPriceId
     * @summary Delete FFB Sell Price by ID
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} ffbSellPriceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlantationsApi
     */
    public plantationsDeleteFFBSellPrice(aPPTYPE: AppTypeEnum, ffbSellPriceId: string, options?: AxiosRequestConfig) {
        return PlantationsApiFp(this.configuration).plantationsDeleteFFBSellPrice(aPPTYPE, ffbSellPriceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint is used to create gapoktan plantations deliveries activities 
     * @summary Create plantation delivery activities
     * @param {PlantationsDeliveriesGapoktanCreateActivitiesRequest} [plantationsDeliveriesGapoktanCreateActivitiesRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlantationsApi
     */
    public plantationsDeliveriesGapoktanCreateActivities(plantationsDeliveriesGapoktanCreateActivitiesRequest?: PlantationsDeliveriesGapoktanCreateActivitiesRequest, options?: AxiosRequestConfig) {
        return PlantationsApiFp(this.configuration).plantationsDeliveriesGapoktanCreateActivities(plantationsDeliveriesGapoktanCreateActivitiesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Called by mobile app to Get processed users\'s FFB Sell Prices summaries for data visualization
     * @summary Get Plantation FFB Sell Prices summary data
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} farmId filter request by the specified Farm Id
     * @param {number} [year] filter request by the specified year in numeric YYYY format, &lt;br&gt; if value 0 will return ALL data aggregated not filtered by year &amp; month
     * @param {number} [month] filter request by the specified month in numeric MM format, &lt;br&gt; if value 0 will return ALL data aggregated not filtered by month in the specified year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlantationsApi
     */
    public plantationsFFBSellPricesGetSummaries(aPPTYPE: AppTypeEnum, farmId: string, year?: number, month?: number, options?: AxiosRequestConfig) {
        return PlantationsApiFp(this.configuration).plantationsFFBSellPricesGetSummaries(aPPTYPE, farmId, year, month, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Called by mobile app to Get processed users\'s FFB Sell Prices income statement summaries. <br> when this API is called without `farmId`, `year` & `month` query params, will return user\'s income statement from ALL farm aggregated in CURRENT year & CURRENT month
     * @summary Get Plantation FFB Sell Prices Income Statement summary data
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} [farmId] optional, filter request by the specified Farm Id &lt;br&gt; when null will return aggregated data from all user\&#39;s farm
     * @param {number} [year] filter request by the specified year in numeric YYYY format, &lt;br&gt; if value 0 will return ALL data aggregated not filtered by year &amp; month
     * @param {number} [month] filter request by the specified month in numeric MM format, &lt;br&gt; if value 0 will return ALL data aggregated not filtered by month in the specified year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlantationsApi
     */
    public plantationsFFBSellPricesSummariesGetIncomeStatement(aPPTYPE: AppTypeEnum, farmId?: string, year?: number, month?: number, options?: AxiosRequestConfig) {
        return PlantationsApiFp(this.configuration).plantationsFFBSellPricesSummariesGetIncomeStatement(aPPTYPE, farmId, year, month, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endpoint to create or update FFB Sale activity
     * @summary Create or Update FFB Sale
     * @param {PlantationsFfbSaleCreateRequest} plantationsFfbSaleCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlantationsApi
     */
    public plantationsFfbSaleCreate(plantationsFfbSaleCreateRequest: PlantationsFfbSaleCreateRequest, options?: AxiosRequestConfig) {
        return PlantationsApiFp(this.configuration).plantationsFfbSaleCreate(plantationsFfbSaleCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint is used to get history of plantations activities 
     * @summary Get history of plantation activities
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {TypePlantationsActivitiesEnum} [type] 
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {number} [month] Month in MM format
     * @param {number} [year] Year in YYYY format
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlantationsApi
     */
    public plantationsGetActivities(authorization: string, type?: TypePlantationsActivitiesEnum, page?: number, limit?: number, month?: number, year?: number, options?: AxiosRequestConfig) {
        return PlantationsApiFp(this.configuration).plantationsGetActivities(authorization, type, page, limit, month, year, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint is used to get history of plantations activities harvests reports 
     * @summary Get history of plantation activities harvests reports
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {number} [startDate] Start Date for filtering list of data (in epoch) formatted in UTC-0. Will use current date if not provided
     * @param {number} [endDate] End Date for filtering list of data (in epoch) formatted in UTC-0. Will use current date if not provided
     * @param {Array<string>} [harvesterSupervisorId] Filter for the list of harvester supervisor contact id of the related harvesting activity
     * @param {Array<string>} [blockId] Filter for the list of block id of the related harvesting activity
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlantationsApi
     */
    public plantationsGetActivitiesHarvestsReports(authorization: string, startDate?: number, endDate?: number, harvesterSupervisorId?: Array<string>, blockId?: Array<string>, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return PlantationsApiFp(this.configuration).plantationsGetActivitiesHarvestsReports(authorization, startDate, endDate, harvesterSupervisorId, blockId, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Called by mobile app to Get List of users\'s recorder FFB Sell Prices
     * @summary List Plantation FFB Sell Prices
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} [userId] used by DUTA app, id of the user that this request is for
     * @param {string} [farmId] optional, filter request by the specified Farm Id &lt;br&gt; when null will return aggregated data from all user\&#39;s farm
     * @param {number} [year] filter request by the specified year in numeric YYYY format, &lt;br&gt; if value 0 will return ALL data aggregated not filtered by year &amp; month
     * @param {number} [month] filter request by the specified month in numeric MM format, &lt;br&gt; if value 0 will return ALL data aggregated not filtered by month in the specified year
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlantationsApi
     */
    public plantationsGetFFBSellPrices(aPPTYPE: AppTypeEnum, userId?: string, farmId?: string, year?: number, month?: number, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return PlantationsApiFp(this.configuration).plantationsGetFFBSellPrices(aPPTYPE, userId, farmId, year, month, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get detail of FFB Sale
     * @summary Get Plantation FFB Sale
     * @param {string} weighbridgeId Weighbridge UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlantationsApi
     */
    public plantationsGetFfbSale(weighbridgeId: string, options?: AxiosRequestConfig) {
        return PlantationsApiFp(this.configuration).plantationsGetFfbSale(weighbridgeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get summary of FFB Sales, including total deliveries, total FFB weight, revenue, cost, and net profit
     * @summary Get Summary of Plantation FFB Sales
     * @param {string} [supplierId] Supplier ID in UUID type 4 format. Won\&#39;t filter by supplier if not provided
     * @param {number} [date] Date for filtering list of data (in epoch) formatted in UTC-0. Will use current date if not provided
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlantationsApi
     */
    public plantationsGetFfbSalesSummary(supplierId?: string, date?: number, options?: AxiosRequestConfig) {
        return PlantationsApiFp(this.configuration).plantationsGetFfbSalesSummary(supplierId, date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Called by mobile app to get List Of Plantation Schedule
     * @summary Get list of plantation activity schedule.
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {PlantationActivityTypeEnum} [activityType] this is for filter plantation schedule by activity type
     * @param {string} [startDate] Start date for filtering plantation schedule date
     * @param {string} [endDate] End date for filtering plantation schedule date
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlantationsApi
     */
    public plantationsGetSchedules(authorization: string, aPPTYPE: AppTypeEnum, activityType?: PlantationActivityTypeEnum, startDate?: string, endDate?: string, options?: AxiosRequestConfig) {
        return PlantationsApiFp(this.configuration).plantationsGetSchedules(authorization, aPPTYPE, activityType, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Called by mobile app to Get all Seeds
     * @summary Get all Plantation Seeds without any pagination or query parameters and sorted by sequence
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlantationsApi
     */
    public plantationsGetSeeds(options?: AxiosRequestConfig) {
        return PlantationsApiFp(this.configuration).plantationsGetSeeds(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get soil types
     * @summary Get Soil Types
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlantationsApi
     */
    public plantationsGetSoilTypes(aPPTYPE: AppTypeEnum, options?: AxiosRequestConfig) {
        return PlantationsApiFp(this.configuration).plantationsGetSoilTypes(aPPTYPE, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get list of FFB Sales of current users\' Supplier (will be fetch by the `contact` and `business` data)
     * @summary Get List of Plantation FFB Sales
     * @param {string} [supplierId] Supplier ID in UUID type 4 format. Won\&#39;t filter by supplier if not provided
     * @param {number} [date] Date for filtering list of data (in epoch) formatted in UTC-0. Will use current date if not provided
     * @param {number} [limit] Number of items per page.
     * @param {number} [page] Current page number to be accessed.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlantationsApi
     */
    public plantationsListFfbSales(supplierId?: string, date?: number, limit?: number, page?: number, options?: AxiosRequestConfig) {
        return PlantationsApiFp(this.configuration).plantationsListFfbSales(supplierId, date, limit, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Called by mobile app to Get Farmer Group/Asscociation List of Sales Report Grouped/Aggregated by Year-Month
     * @summary Get Plantation Report Sales data
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} [farmerGroupIds] filter request by the specified Farmer Group Ids &lt;br&gt; accept multiple Farmer Group Ids, comma (URL encoded &#x60;%2C&#x60;) separated.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlantationsApi
     */
    public plantationsReportsGetSales(aPPTYPE: AppTypeEnum, farmerGroupIds?: string, options?: AxiosRequestConfig) {
        return PlantationsApiFp(this.configuration).plantationsReportsGetSales(aPPTYPE, farmerGroupIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Called by mobile app to Get Farmer Group/Asscociation List of Sales Report Details for the specified year & month Per Farmer Groups
     * @summary Get Plantation Report Sales Per Farmer Groups
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {number} year filter request by the specified year in numeric YYYY format
     * @param {number} month filter request by the specified month in numeric MM format
     * @param {string} [farmerGroupIds] filter request by the specified Farmer Group Ids &lt;br&gt; accept multiple Farmer Group Ids, comma (URL encoded &#x60;%2C&#x60;) separated.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlantationsApi
     */
    public plantationsReportsGetSalesPerFarmerGroup(aPPTYPE: AppTypeEnum, year: number, month: number, farmerGroupIds?: string, options?: AxiosRequestConfig) {
        return PlantationsApiFp(this.configuration).plantationsReportsGetSalesPerFarmerGroup(aPPTYPE, year, month, farmerGroupIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Called by mobile app when create Plantation Schedule.
     * @summary Create Plantation Schedule
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {PlantationsSchedulesCreateRequest} plantationsSchedulesCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlantationsApi
     */
    public plantationsSchedulesCreate(authorization: string, plantationsSchedulesCreateRequest: PlantationsSchedulesCreateRequest, options?: AxiosRequestConfig) {
        return PlantationsApiFp(this.configuration).plantationsSchedulesCreate(authorization, plantationsSchedulesCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Called by mobile app to get Plantation Schedule Harvest Activity details.
     * @summary Get plantation activity harvest schedule detail by scheduleId.
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {string} scheduleId plantation schedule id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlantationsApi
     */
    public plantationsSchedulesGetHarvestsDetail(authorization: string, aPPTYPE: AppTypeEnum, scheduleId: string, options?: AxiosRequestConfig) {
        return PlantationsApiFp(this.configuration).plantationsSchedulesGetHarvestsDetail(authorization, aPPTYPE, scheduleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new plantation delivery
     * @summary Create a new plantation delivery
     * @param {V2PlantationCreateActivitiesDeliveriesRequest} v2PlantationCreateActivitiesDeliveriesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlantationsApi
     */
    public v2PlantationCreateActivitiesDeliveries(v2PlantationCreateActivitiesDeliveriesRequest: V2PlantationCreateActivitiesDeliveriesRequest, options?: AxiosRequestConfig) {
        return PlantationsApiFp(this.configuration).v2PlantationCreateActivitiesDeliveries(v2PlantationCreateActivitiesDeliveriesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint is used by mobile app to add multiple Smallholder Upkeep activity
     * @summary Create Multiple Plantation activity Smallholder Upkeep
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {V2PlantationsActivitiesSmallholdersCreateUpkeepRequest} [v2PlantationsActivitiesSmallholdersCreateUpkeepRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlantationsApi
     */
    public v2PlantationsActivitiesSmallholdersCreateUpkeep(aPPTYPE: AppTypeEnum, v2PlantationsActivitiesSmallholdersCreateUpkeepRequest?: V2PlantationsActivitiesSmallholdersCreateUpkeepRequest, options?: AxiosRequestConfig) {
        return PlantationsApiFp(this.configuration).v2PlantationsActivitiesSmallholdersCreateUpkeep(aPPTYPE, v2PlantationsActivitiesSmallholdersCreateUpkeepRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint is used to create plantations activities <br> Changes: - V2 -> change to application/json, support harvest activities for association (gapoktan)<br> 
     * @summary Create Plantation Activities V2
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {V2PlantationsCreateActivitiesRequest} [v2PlantationsCreateActivitiesRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlantationsApi
     */
    public v2PlantationsCreateActivities(aPPTYPE: AppTypeEnum, v2PlantationsCreateActivitiesRequest?: V2PlantationsCreateActivitiesRequest, options?: AxiosRequestConfig) {
        return PlantationsApiFp(this.configuration).v2PlantationsCreateActivities(aPPTYPE, v2PlantationsCreateActivitiesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This API is used to create plantation FFB sell price record in bulk
     * @summary Create Plantation FFB Sell Price V2
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {V2PlantationsCreateFFBSellPriceRequest} v2PlantationsCreateFFBSellPriceRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlantationsApi
     */
    public v2PlantationsCreateFFBSellPrice(aPPTYPE: AppTypeEnum, v2PlantationsCreateFFBSellPriceRequest: V2PlantationsCreateFFBSellPriceRequest, options?: AxiosRequestConfig) {
        return PlantationsApiFp(this.configuration).v2PlantationsCreateFFBSellPrice(aPPTYPE, v2PlantationsCreateFFBSellPriceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Called by mobile app to get List Of Plantation Schedule
     * @summary Get list of plantation activity schedule.
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {PlantationActivityTypeEnum} [activityType] this is for filter plantation schedule by activity type
     * @param {number} [startDate] Start Date for filtering list of data (in epoch) formatted in UTC-0. Will use current date if not provided
     * @param {number} [endDate] End Date for filtering list of data (in epoch) formatted in UTC-0. Will use current date if not provided
     * @param {PlantationScheduleStatusEnum} [status] this is for filter plantation schedule by status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlantationsApi
     */
    public v2PlantationsGetSchedules(authorization: string, activityType?: PlantationActivityTypeEnum, startDate?: number, endDate?: number, status?: PlantationScheduleStatusEnum, options?: AxiosRequestConfig) {
        return PlantationsApiFp(this.configuration).v2PlantationsGetSchedules(authorization, activityType, startDate, endDate, status, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PopupApi - axios parameter creator
 * @export
 */
export const PopupApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Display all popup 
         * @summary Get popup list
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {number} [vERSIONCODE] Version code of the app that\&#39;s accessing the endpoint.
         * @param {string} [code] Filter for the popup code, this define in database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPopupsList: async (aPPTYPE: AppTypeEnum, vERSIONCODE?: number, code?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('getPopupsList', 'aPPTYPE', aPPTYPE)
            const localVarPath = `/api/v1/popups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }

            if (vERSIONCODE != null) {
                localVarHeaderParameter['VERSION-CODE'] = typeof vERSIONCODE === 'string' 
                    ? vERSIONCODE 
                    : JSON.stringify(vERSIONCODE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PopupApi - functional programming interface
 * @export
 */
export const PopupApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PopupApiAxiosParamCreator(configuration)
    return {
        /**
         * Display all popup 
         * @summary Get popup list
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {number} [vERSIONCODE] Version code of the app that\&#39;s accessing the endpoint.
         * @param {string} [code] Filter for the popup code, this define in database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPopupsList(aPPTYPE: AppTypeEnum, vERSIONCODE?: number, code?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPopupsListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPopupsList(aPPTYPE, vERSIONCODE, code, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PopupApi - factory interface
 * @export
 */
export const PopupApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PopupApiFp(configuration)
    return {
        /**
         * Display all popup 
         * @summary Get popup list
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {number} [vERSIONCODE] Version code of the app that\&#39;s accessing the endpoint.
         * @param {string} [code] Filter for the popup code, this define in database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPopupsList(aPPTYPE: AppTypeEnum, vERSIONCODE?: number, code?: string, options?: any): AxiosPromise<GetPopupsListResponse> {
            return localVarFp.getPopupsList(aPPTYPE, vERSIONCODE, code, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PopupApi - object-oriented interface
 * @export
 * @class PopupApi
 * @extends {BaseAPI}
 */
export class PopupApi extends BaseAPI {
    /**
     * Display all popup 
     * @summary Get popup list
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {number} [vERSIONCODE] Version code of the app that\&#39;s accessing the endpoint.
     * @param {string} [code] Filter for the popup code, this define in database
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PopupApi
     */
    public getPopupsList(aPPTYPE: AppTypeEnum, vERSIONCODE?: number, code?: string, options?: AxiosRequestConfig) {
        return PopupApiFp(this.configuration).getPopupsList(aPPTYPE, vERSIONCODE, code, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * QuestApi - axios parameter creator
 * @export
 */
export const QuestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Return list of available quest for the current user
         * @summary Get Available Quest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questsList: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/quests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return list of available survey quest for the current user
         * @summary Get Available Survey Quest
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questsSurveyList: async (authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('questsSurveyList', 'authorization', authorization)
            const localVarPath = `/api/v1/quests/survey`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QuestApi - functional programming interface
 * @export
 */
export const QuestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QuestApiAxiosParamCreator(configuration)
    return {
        /**
         * Return list of available quest for the current user
         * @summary Get Available Quest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questsList(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestsListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questsList(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Return list of available survey quest for the current user
         * @summary Get Available Survey Quest
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questsSurveyList(authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestsSurveyListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questsSurveyList(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * QuestApi - factory interface
 * @export
 */
export const QuestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QuestApiFp(configuration)
    return {
        /**
         * Return list of available quest for the current user
         * @summary Get Available Quest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questsList(options?: any): AxiosPromise<QuestsListResponse> {
            return localVarFp.questsList(options).then((request) => request(axios, basePath));
        },
        /**
         * Return list of available survey quest for the current user
         * @summary Get Available Survey Quest
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questsSurveyList(authorization: string, options?: any): AxiosPromise<QuestsSurveyListResponse> {
            return localVarFp.questsSurveyList(authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * QuestApi - object-oriented interface
 * @export
 * @class QuestApi
 * @extends {BaseAPI}
 */
export class QuestApi extends BaseAPI {
    /**
     * Return list of available quest for the current user
     * @summary Get Available Quest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestApi
     */
    public questsList(options?: AxiosRequestConfig) {
        return QuestApiFp(this.configuration).questsList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return list of available survey quest for the current user
     * @summary Get Available Survey Quest
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestApi
     */
    public questsSurveyList(authorization: string, options?: AxiosRequestConfig) {
        return QuestApiFp(this.configuration).questsSurveyList(authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ReportApi - axios parameter creator
 * @export
 */
export const ReportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Used by MemberApp to get list of their(member) weighbridge cargo desc, can be sort by asc, desc 
         * @summary List Collector of Cargo Desc
         * @param {string} [sort] 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        membersGetWeighbridgesCargoDesc: async (sort?: string, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/report/members/weighbridges/cargo-desc`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Used by MemberApp to get list of their(member) weighbridge cargo desc, can be sort by asc, desc 
         * @summary List Collector of Cargo Desc V2
         * @param {number} month 1 - 12 (January - December)
         * @param {number} year 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        membersGetWeighbridgesCargoDescV2: async (month: number, year: number, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'month' is not null or undefined
            assertParamExists('membersGetWeighbridgesCargoDescV2', 'month', month)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('membersGetWeighbridgesCargoDescV2', 'year', year)
            const localVarPath = `/api/v2/report/members/weighbridges/cargo-desc`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Display line chart of contract summary report . Filtered by contract and period of time. Period of time: today, last 7 days, last 30 days, last 90 days. 
         * @summary Get transaction volume by contract and period of time
         * @param {ReportAssetContractFlagEnum} contractFlag 
         * @param {ReportAssetContractTimeRangeEnum} timeRange 
         * @param {string} [contractId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportContractDetail: async (contractFlag: ReportAssetContractFlagEnum, timeRange: ReportAssetContractTimeRangeEnum, contractId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractFlag' is not null or undefined
            assertParamExists('reportContractDetail', 'contractFlag', contractFlag)
            // verify required parameter 'timeRange' is not null or undefined
            assertParamExists('reportContractDetail', 'timeRange', timeRange)
            const localVarPath = `/api/v1/report/contract`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (contractId !== undefined) {
                localVarQueryParameter['contractId'] = contractId;
            }

            if (contractFlag !== undefined) {
                localVarQueryParameter['contractFlag'] = contractFlag;
            }

            if (timeRange !== undefined) {
                localVarQueryParameter['timeRange'] = timeRange;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Display line chart of contract summary report . Filtered by contract and period of time. Period of time by month (1 to 12). 
         * @summary Get transaction volume by contract and period of time
         * @param {ReportAssetContractFlagEnum} contractFlag 
         * @param {string} [contractId] 
         * @param {number} [month] month is from 1 to 12 (Januari to December)
         * @param {number} [year] year is from 1000 to 9999
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportContractDetailV2: async (contractFlag: ReportAssetContractFlagEnum, contractId?: string, month?: number, year?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractFlag' is not null or undefined
            assertParamExists('reportContractDetailV2', 'contractFlag', contractFlag)
            const localVarPath = `/api/v2/report/contract`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (contractId !== undefined) {
                localVarQueryParameter['contractId'] = contractId;
            }

            if (contractFlag !== undefined) {
                localVarQueryParameter['contractFlag'] = contractFlag;
            }

            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Display all asset contracts that users have 
         * @summary Get filter contracts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportContractFilter: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/report/contract/filter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Display summary of contract asset with total supply in tonnage and delivery. Filtered by contract and period of time. Period of time: today, last 7 days, last 30 days, last 90 days. 
         * @summary Get summary of contract
         * @param {ReportAssetContractTimeRangeEnum} timeRange 
         * @param {string} [contractId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportContractSummary: async (timeRange: ReportAssetContractTimeRangeEnum, contractId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'timeRange' is not null or undefined
            assertParamExists('reportContractSummary', 'timeRange', timeRange)
            const localVarPath = `/api/v1/report/contract/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (contractId !== undefined) {
                localVarQueryParameter['contractId'] = contractId;
            }

            if (timeRange !== undefined) {
                localVarQueryParameter['timeRange'] = timeRange;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Display summary of contract asset with total supply in tonnage and delivery. Filtered by contract and period of time. Period of time by month (1 to 12). 
         * @summary Get summary of contract
         * @param {string} [contractId] 
         * @param {number} [month] month is from 1 to 12 (Januari to December)
         * @param {number} [year] year is from 1000 to 9999
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportContractSummaryV2: async (contractId?: string, month?: number, year?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/report/contract/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (contractId !== undefined) {
                localVarQueryParameter['contractId'] = contractId;
            }

            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Display list of truck with each supply over a period of time. Filtered by contract and period of time. 
         * @summary Get Report Truck
         * @param {number} [month] Filter for the month report to be shown (will start from 1 for January)
         * @param {number} [year] year is from 1000 to 9999
         * @param {string} [supplierContractId] Filter for the supplier contract id report to be shown
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportTruckList: async (month?: number, year?: number, supplierContractId?: string, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/report/truck`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }

            if (supplierContractId !== undefined) {
                localVarQueryParameter['supplierContractId'] = supplierContractId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get workers activity by today, yesterday, current month and last month.
         * @summary Get Report of worker activity.
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportWorkers: async (authorization: string, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('reportWorkers', 'authorization', authorization)
            const localVarPath = `/api/v1/report/workers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get workers detail activity by workerId parameter
         * @summary Detail Summary Report.
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} workerId 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportWorkersSummary: async (authorization: string, workerId: string, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('reportWorkersSummary', 'authorization', authorization)
            // verify required parameter 'workerId' is not null or undefined
            assertParamExists('reportWorkersSummary', 'workerId', workerId)
            const localVarPath = `/api/v1/report/workers/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (workerId !== undefined) {
                localVarQueryParameter['workerId'] = workerId;
            }

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Display line chart of contract summary report . Filtered by contract and period of time. Period of time by month (1 to 12). 
         * @summary Get transaction volume by contract and period of time
         * @param {string} contractName 
         * @param {ReportAssetContractFlagEnum} contractFlag 
         * @param {number} month Month in MM format
         * @param {number} year Year in YYYY format
         * @param {string} [partnerId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v3ReportsContractsDetails: async (contractName: string, contractFlag: ReportAssetContractFlagEnum, month: number, year: number, partnerId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractName' is not null or undefined
            assertParamExists('v3ReportsContractsDetails', 'contractName', contractName)
            // verify required parameter 'contractFlag' is not null or undefined
            assertParamExists('v3ReportsContractsDetails', 'contractFlag', contractFlag)
            // verify required parameter 'month' is not null or undefined
            assertParamExists('v3ReportsContractsDetails', 'month', month)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('v3ReportsContractsDetails', 'year', year)
            const localVarPath = `/api/v3/reports/contracts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (contractName !== undefined) {
                localVarQueryParameter['contractName'] = contractName;
            }

            if (contractFlag !== undefined) {
                localVarQueryParameter['contractFlag'] = contractFlag;
            }

            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }

            if (partnerId !== undefined) {
                localVarQueryParameter['partnerId'] = partnerId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Report API for DO/SP/PB filtered by Month, Year, Supplier Contract Id, and Partner Id 
         * @summary Get transaction volume by contract and period of time
         * @param {string} supplierContractId 
         * @param {string} partnerId 
         * @param {number} month Month in MM format
         * @param {number} year Year in YYYY format
         * @param {boolean} [outlierSortation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v4ReportContractDetail: async (supplierContractId: string, partnerId: string, month: number, year: number, outlierSortation?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supplierContractId' is not null or undefined
            assertParamExists('v4ReportContractDetail', 'supplierContractId', supplierContractId)
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('v4ReportContractDetail', 'partnerId', partnerId)
            // verify required parameter 'month' is not null or undefined
            assertParamExists('v4ReportContractDetail', 'month', month)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('v4ReportContractDetail', 'year', year)
            const localVarPath = `/api/v4/reports/contracts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (supplierContractId !== undefined) {
                localVarQueryParameter['supplierContractId'] = supplierContractId;
            }

            if (partnerId !== undefined) {
                localVarQueryParameter['partnerId'] = partnerId;
            }

            if (outlierSortation !== undefined) {
                localVarQueryParameter['outlierSortation'] = outlierSortation;
            }

            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Report API for DO/SP/PB filtered by date, Supplier Contract Id, and Partner Id 
         * @summary Get transaction volume by contract and period of time
         * @param {string} supplierContractId 
         * @param {string} partnerId 
         * @param {number} date date in epoch format
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {boolean} [outlierSortation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v4ReportContractDetailOfDetail: async (supplierContractId: string, partnerId: string, date: number, page?: number, limit?: number, outlierSortation?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supplierContractId' is not null or undefined
            assertParamExists('v4ReportContractDetailOfDetail', 'supplierContractId', supplierContractId)
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('v4ReportContractDetailOfDetail', 'partnerId', partnerId)
            // verify required parameter 'date' is not null or undefined
            assertParamExists('v4ReportContractDetailOfDetail', 'date', date)
            const localVarPath = `/api/v4/reports/contracts/details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (supplierContractId !== undefined) {
                localVarQueryParameter['supplierContractId'] = supplierContractId;
            }

            if (partnerId !== undefined) {
                localVarQueryParameter['partnerId'] = partnerId;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (outlierSortation !== undefined) {
                localVarQueryParameter['outlierSortation'] = outlierSortation;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportApi - functional programming interface
 * @export
 */
export const ReportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportApiAxiosParamCreator(configuration)
    return {
        /**
         * Used by MemberApp to get list of their(member) weighbridge cargo desc, can be sort by asc, desc 
         * @summary List Collector of Cargo Desc
         * @param {string} [sort] 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async membersGetWeighbridgesCargoDesc(sort?: string, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MembersWeighbridgesCargoDescResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.membersGetWeighbridgesCargoDesc(sort, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Used by MemberApp to get list of their(member) weighbridge cargo desc, can be sort by asc, desc 
         * @summary List Collector of Cargo Desc V2
         * @param {number} month 1 - 12 (January - December)
         * @param {number} year 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async membersGetWeighbridgesCargoDescV2(month: number, year: number, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MembersWeighbridgesCargoDescResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.membersGetWeighbridgesCargoDescV2(month, year, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Display line chart of contract summary report . Filtered by contract and period of time. Period of time: today, last 7 days, last 30 days, last 90 days. 
         * @summary Get transaction volume by contract and period of time
         * @param {ReportAssetContractFlagEnum} contractFlag 
         * @param {ReportAssetContractTimeRangeEnum} timeRange 
         * @param {string} [contractId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportContractDetail(contractFlag: ReportAssetContractFlagEnum, timeRange: ReportAssetContractTimeRangeEnum, contractId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportContractDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportContractDetail(contractFlag, timeRange, contractId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Display line chart of contract summary report . Filtered by contract and period of time. Period of time by month (1 to 12). 
         * @summary Get transaction volume by contract and period of time
         * @param {ReportAssetContractFlagEnum} contractFlag 
         * @param {string} [contractId] 
         * @param {number} [month] month is from 1 to 12 (Januari to December)
         * @param {number} [year] year is from 1000 to 9999
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportContractDetailV2(contractFlag: ReportAssetContractFlagEnum, contractId?: string, month?: number, year?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportContractDetailResponseV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportContractDetailV2(contractFlag, contractId, month, year, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Display all asset contracts that users have 
         * @summary Get filter contracts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportContractFilter(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReportContractFilterResponseItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportContractFilter(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Display summary of contract asset with total supply in tonnage and delivery. Filtered by contract and period of time. Period of time: today, last 7 days, last 30 days, last 90 days. 
         * @summary Get summary of contract
         * @param {ReportAssetContractTimeRangeEnum} timeRange 
         * @param {string} [contractId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportContractSummary(timeRange: ReportAssetContractTimeRangeEnum, contractId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportContractSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportContractSummary(timeRange, contractId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Display summary of contract asset with total supply in tonnage and delivery. Filtered by contract and period of time. Period of time by month (1 to 12). 
         * @summary Get summary of contract
         * @param {string} [contractId] 
         * @param {number} [month] month is from 1 to 12 (Januari to December)
         * @param {number} [year] year is from 1000 to 9999
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportContractSummaryV2(contractId?: string, month?: number, year?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportContractSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportContractSummaryV2(contractId, month, year, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Display list of truck with each supply over a period of time. Filtered by contract and period of time. 
         * @summary Get Report Truck
         * @param {number} [month] Filter for the month report to be shown (will start from 1 for January)
         * @param {number} [year] year is from 1000 to 9999
         * @param {string} [supplierContractId] Filter for the supplier contract id report to be shown
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportTruckList(month?: number, year?: number, supplierContractId?: string, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportTruckListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportTruckList(month, year, supplierContractId, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get workers activity by today, yesterday, current month and last month.
         * @summary Get Report of worker activity.
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportWorkers(authorization: string, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportWorkersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportWorkers(authorization, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get workers detail activity by workerId parameter
         * @summary Detail Summary Report.
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} workerId 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportWorkersSummary(authorization: string, workerId: string, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportWorkersSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportWorkersSummary(authorization, workerId, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Display line chart of contract summary report . Filtered by contract and period of time. Period of time by month (1 to 12). 
         * @summary Get transaction volume by contract and period of time
         * @param {string} contractName 
         * @param {ReportAssetContractFlagEnum} contractFlag 
         * @param {number} month Month in MM format
         * @param {number} year Year in YYYY format
         * @param {string} [partnerId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v3ReportsContractsDetails(contractName: string, contractFlag: ReportAssetContractFlagEnum, month: number, year: number, partnerId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V3ReportContractDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v3ReportsContractsDetails(contractName, contractFlag, month, year, partnerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Report API for DO/SP/PB filtered by Month, Year, Supplier Contract Id, and Partner Id 
         * @summary Get transaction volume by contract and period of time
         * @param {string} supplierContractId 
         * @param {string} partnerId 
         * @param {number} month Month in MM format
         * @param {number} year Year in YYYY format
         * @param {boolean} [outlierSortation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v4ReportContractDetail(supplierContractId: string, partnerId: string, month: number, year: number, outlierSortation?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V4ReportContractDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v4ReportContractDetail(supplierContractId, partnerId, month, year, outlierSortation, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Report API for DO/SP/PB filtered by date, Supplier Contract Id, and Partner Id 
         * @summary Get transaction volume by contract and period of time
         * @param {string} supplierContractId 
         * @param {string} partnerId 
         * @param {number} date date in epoch format
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {boolean} [outlierSortation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v4ReportContractDetailOfDetail(supplierContractId: string, partnerId: string, date: number, page?: number, limit?: number, outlierSortation?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V4ReportContractDetailOfDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v4ReportContractDetailOfDetail(supplierContractId, partnerId, date, page, limit, outlierSortation, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ReportApi - factory interface
 * @export
 */
export const ReportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportApiFp(configuration)
    return {
        /**
         * Used by MemberApp to get list of their(member) weighbridge cargo desc, can be sort by asc, desc 
         * @summary List Collector of Cargo Desc
         * @param {string} [sort] 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        membersGetWeighbridgesCargoDesc(sort?: string, page?: number, limit?: number, options?: any): AxiosPromise<MembersWeighbridgesCargoDescResponse> {
            return localVarFp.membersGetWeighbridgesCargoDesc(sort, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Used by MemberApp to get list of their(member) weighbridge cargo desc, can be sort by asc, desc 
         * @summary List Collector of Cargo Desc V2
         * @param {number} month 1 - 12 (January - December)
         * @param {number} year 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        membersGetWeighbridgesCargoDescV2(month: number, year: number, page?: number, limit?: number, options?: any): AxiosPromise<MembersWeighbridgesCargoDescResponse> {
            return localVarFp.membersGetWeighbridgesCargoDescV2(month, year, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Display line chart of contract summary report . Filtered by contract and period of time. Period of time: today, last 7 days, last 30 days, last 90 days. 
         * @summary Get transaction volume by contract and period of time
         * @param {ReportAssetContractFlagEnum} contractFlag 
         * @param {ReportAssetContractTimeRangeEnum} timeRange 
         * @param {string} [contractId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportContractDetail(contractFlag: ReportAssetContractFlagEnum, timeRange: ReportAssetContractTimeRangeEnum, contractId?: string, options?: any): AxiosPromise<ReportContractDetailResponse> {
            return localVarFp.reportContractDetail(contractFlag, timeRange, contractId, options).then((request) => request(axios, basePath));
        },
        /**
         * Display line chart of contract summary report . Filtered by contract and period of time. Period of time by month (1 to 12). 
         * @summary Get transaction volume by contract and period of time
         * @param {ReportAssetContractFlagEnum} contractFlag 
         * @param {string} [contractId] 
         * @param {number} [month] month is from 1 to 12 (Januari to December)
         * @param {number} [year] year is from 1000 to 9999
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportContractDetailV2(contractFlag: ReportAssetContractFlagEnum, contractId?: string, month?: number, year?: number, options?: any): AxiosPromise<ReportContractDetailResponseV2> {
            return localVarFp.reportContractDetailV2(contractFlag, contractId, month, year, options).then((request) => request(axios, basePath));
        },
        /**
         * Display all asset contracts that users have 
         * @summary Get filter contracts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportContractFilter(options?: any): AxiosPromise<Array<ReportContractFilterResponseItem>> {
            return localVarFp.reportContractFilter(options).then((request) => request(axios, basePath));
        },
        /**
         * Display summary of contract asset with total supply in tonnage and delivery. Filtered by contract and period of time. Period of time: today, last 7 days, last 30 days, last 90 days. 
         * @summary Get summary of contract
         * @param {ReportAssetContractTimeRangeEnum} timeRange 
         * @param {string} [contractId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportContractSummary(timeRange: ReportAssetContractTimeRangeEnum, contractId?: string, options?: any): AxiosPromise<ReportContractSummaryResponse> {
            return localVarFp.reportContractSummary(timeRange, contractId, options).then((request) => request(axios, basePath));
        },
        /**
         * Display summary of contract asset with total supply in tonnage and delivery. Filtered by contract and period of time. Period of time by month (1 to 12). 
         * @summary Get summary of contract
         * @param {string} [contractId] 
         * @param {number} [month] month is from 1 to 12 (Januari to December)
         * @param {number} [year] year is from 1000 to 9999
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportContractSummaryV2(contractId?: string, month?: number, year?: number, options?: any): AxiosPromise<ReportContractSummaryResponse> {
            return localVarFp.reportContractSummaryV2(contractId, month, year, options).then((request) => request(axios, basePath));
        },
        /**
         * Display list of truck with each supply over a period of time. Filtered by contract and period of time. 
         * @summary Get Report Truck
         * @param {number} [month] Filter for the month report to be shown (will start from 1 for January)
         * @param {number} [year] year is from 1000 to 9999
         * @param {string} [supplierContractId] Filter for the supplier contract id report to be shown
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportTruckList(month?: number, year?: number, supplierContractId?: string, page?: number, limit?: number, options?: any): AxiosPromise<ReportTruckListResponse> {
            return localVarFp.reportTruckList(month, year, supplierContractId, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Get workers activity by today, yesterday, current month and last month.
         * @summary Get Report of worker activity.
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportWorkers(authorization: string, page?: number, limit?: number, options?: any): AxiosPromise<ReportWorkersResponse> {
            return localVarFp.reportWorkers(authorization, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Get workers detail activity by workerId parameter
         * @summary Detail Summary Report.
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} workerId 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportWorkersSummary(authorization: string, workerId: string, page?: number, limit?: number, options?: any): AxiosPromise<ReportWorkersSummaryResponse> {
            return localVarFp.reportWorkersSummary(authorization, workerId, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Display line chart of contract summary report . Filtered by contract and period of time. Period of time by month (1 to 12). 
         * @summary Get transaction volume by contract and period of time
         * @param {string} contractName 
         * @param {ReportAssetContractFlagEnum} contractFlag 
         * @param {number} month Month in MM format
         * @param {number} year Year in YYYY format
         * @param {string} [partnerId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v3ReportsContractsDetails(contractName: string, contractFlag: ReportAssetContractFlagEnum, month: number, year: number, partnerId?: string, options?: any): AxiosPromise<V3ReportContractDetailResponse> {
            return localVarFp.v3ReportsContractsDetails(contractName, contractFlag, month, year, partnerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Report API for DO/SP/PB filtered by Month, Year, Supplier Contract Id, and Partner Id 
         * @summary Get transaction volume by contract and period of time
         * @param {string} supplierContractId 
         * @param {string} partnerId 
         * @param {number} month Month in MM format
         * @param {number} year Year in YYYY format
         * @param {boolean} [outlierSortation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v4ReportContractDetail(supplierContractId: string, partnerId: string, month: number, year: number, outlierSortation?: boolean, options?: any): AxiosPromise<V4ReportContractDetailResponse> {
            return localVarFp.v4ReportContractDetail(supplierContractId, partnerId, month, year, outlierSortation, options).then((request) => request(axios, basePath));
        },
        /**
         * Report API for DO/SP/PB filtered by date, Supplier Contract Id, and Partner Id 
         * @summary Get transaction volume by contract and period of time
         * @param {string} supplierContractId 
         * @param {string} partnerId 
         * @param {number} date date in epoch format
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {boolean} [outlierSortation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v4ReportContractDetailOfDetail(supplierContractId: string, partnerId: string, date: number, page?: number, limit?: number, outlierSortation?: boolean, options?: any): AxiosPromise<V4ReportContractDetailOfDetailResponse> {
            return localVarFp.v4ReportContractDetailOfDetail(supplierContractId, partnerId, date, page, limit, outlierSortation, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReportApi - object-oriented interface
 * @export
 * @class ReportApi
 * @extends {BaseAPI}
 */
export class ReportApi extends BaseAPI {
    /**
     * Used by MemberApp to get list of their(member) weighbridge cargo desc, can be sort by asc, desc 
     * @summary List Collector of Cargo Desc
     * @param {string} [sort] 
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public membersGetWeighbridgesCargoDesc(sort?: string, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return ReportApiFp(this.configuration).membersGetWeighbridgesCargoDesc(sort, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Used by MemberApp to get list of their(member) weighbridge cargo desc, can be sort by asc, desc 
     * @summary List Collector of Cargo Desc V2
     * @param {number} month 1 - 12 (January - December)
     * @param {number} year 
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public membersGetWeighbridgesCargoDescV2(month: number, year: number, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return ReportApiFp(this.configuration).membersGetWeighbridgesCargoDescV2(month, year, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Display line chart of contract summary report . Filtered by contract and period of time. Period of time: today, last 7 days, last 30 days, last 90 days. 
     * @summary Get transaction volume by contract and period of time
     * @param {ReportAssetContractFlagEnum} contractFlag 
     * @param {ReportAssetContractTimeRangeEnum} timeRange 
     * @param {string} [contractId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public reportContractDetail(contractFlag: ReportAssetContractFlagEnum, timeRange: ReportAssetContractTimeRangeEnum, contractId?: string, options?: AxiosRequestConfig) {
        return ReportApiFp(this.configuration).reportContractDetail(contractFlag, timeRange, contractId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Display line chart of contract summary report . Filtered by contract and period of time. Period of time by month (1 to 12). 
     * @summary Get transaction volume by contract and period of time
     * @param {ReportAssetContractFlagEnum} contractFlag 
     * @param {string} [contractId] 
     * @param {number} [month] month is from 1 to 12 (Januari to December)
     * @param {number} [year] year is from 1000 to 9999
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public reportContractDetailV2(contractFlag: ReportAssetContractFlagEnum, contractId?: string, month?: number, year?: number, options?: AxiosRequestConfig) {
        return ReportApiFp(this.configuration).reportContractDetailV2(contractFlag, contractId, month, year, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Display all asset contracts that users have 
     * @summary Get filter contracts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public reportContractFilter(options?: AxiosRequestConfig) {
        return ReportApiFp(this.configuration).reportContractFilter(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Display summary of contract asset with total supply in tonnage and delivery. Filtered by contract and period of time. Period of time: today, last 7 days, last 30 days, last 90 days. 
     * @summary Get summary of contract
     * @param {ReportAssetContractTimeRangeEnum} timeRange 
     * @param {string} [contractId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public reportContractSummary(timeRange: ReportAssetContractTimeRangeEnum, contractId?: string, options?: AxiosRequestConfig) {
        return ReportApiFp(this.configuration).reportContractSummary(timeRange, contractId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Display summary of contract asset with total supply in tonnage and delivery. Filtered by contract and period of time. Period of time by month (1 to 12). 
     * @summary Get summary of contract
     * @param {string} [contractId] 
     * @param {number} [month] month is from 1 to 12 (Januari to December)
     * @param {number} [year] year is from 1000 to 9999
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public reportContractSummaryV2(contractId?: string, month?: number, year?: number, options?: AxiosRequestConfig) {
        return ReportApiFp(this.configuration).reportContractSummaryV2(contractId, month, year, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Display list of truck with each supply over a period of time. Filtered by contract and period of time. 
     * @summary Get Report Truck
     * @param {number} [month] Filter for the month report to be shown (will start from 1 for January)
     * @param {number} [year] year is from 1000 to 9999
     * @param {string} [supplierContractId] Filter for the supplier contract id report to be shown
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public reportTruckList(month?: number, year?: number, supplierContractId?: string, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return ReportApiFp(this.configuration).reportTruckList(month, year, supplierContractId, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get workers activity by today, yesterday, current month and last month.
     * @summary Get Report of worker activity.
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public reportWorkers(authorization: string, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return ReportApiFp(this.configuration).reportWorkers(authorization, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get workers detail activity by workerId parameter
     * @summary Detail Summary Report.
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {string} workerId 
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public reportWorkersSummary(authorization: string, workerId: string, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return ReportApiFp(this.configuration).reportWorkersSummary(authorization, workerId, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Display line chart of contract summary report . Filtered by contract and period of time. Period of time by month (1 to 12). 
     * @summary Get transaction volume by contract and period of time
     * @param {string} contractName 
     * @param {ReportAssetContractFlagEnum} contractFlag 
     * @param {number} month Month in MM format
     * @param {number} year Year in YYYY format
     * @param {string} [partnerId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public v3ReportsContractsDetails(contractName: string, contractFlag: ReportAssetContractFlagEnum, month: number, year: number, partnerId?: string, options?: AxiosRequestConfig) {
        return ReportApiFp(this.configuration).v3ReportsContractsDetails(contractName, contractFlag, month, year, partnerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Report API for DO/SP/PB filtered by Month, Year, Supplier Contract Id, and Partner Id 
     * @summary Get transaction volume by contract and period of time
     * @param {string} supplierContractId 
     * @param {string} partnerId 
     * @param {number} month Month in MM format
     * @param {number} year Year in YYYY format
     * @param {boolean} [outlierSortation] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public v4ReportContractDetail(supplierContractId: string, partnerId: string, month: number, year: number, outlierSortation?: boolean, options?: AxiosRequestConfig) {
        return ReportApiFp(this.configuration).v4ReportContractDetail(supplierContractId, partnerId, month, year, outlierSortation, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Report API for DO/SP/PB filtered by date, Supplier Contract Id, and Partner Id 
     * @summary Get transaction volume by contract and period of time
     * @param {string} supplierContractId 
     * @param {string} partnerId 
     * @param {number} date date in epoch format
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {boolean} [outlierSortation] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public v4ReportContractDetailOfDetail(supplierContractId: string, partnerId: string, date: number, page?: number, limit?: number, outlierSortation?: boolean, options?: AxiosRequestConfig) {
        return ReportApiFp(this.configuration).v4ReportContractDetailOfDetail(supplierContractId, partnerId, date, page, limit, outlierSortation, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ReportsApi - axios parameter creator
 * @export
 */
export const ReportsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This will returns list of reports shortcut or summary
         * @summary Get the shortcut or summary of reports
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsGetReportShortcut: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/reports/shortcuts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Display summary of supplier contract with total supply in tonnage and delivery. 
         * @summary Get summary of supplier contract report
         * @param {number} [month] Month in MM format
         * @param {number} [year] Year in YYYY format
         * @param {string} [contractName] 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v3ReportsContractsSummaries: async (month?: number, year?: number, contractName?: string, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v3/reports/contracts/summaries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }

            if (contractName !== undefined) {
                localVarQueryParameter['contractName'] = contractName;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Display summary of supplier contract with several summarized data including: <br> 1. total supply in tonnage <br> 2. total trip <br> 3. sortation average <br> 4. latest trip date <br> 5. latest trip date which the sortation is outlier <br> 
         * @summary get supplier contract report summaries v4
         * @param {number} month Month in MM format
         * @param {number} year Year in YYYY format
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v4ReportsContractsSummaries: async (month: number, year: number, aPPTYPE: AppTypeEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'month' is not null or undefined
            assertParamExists('v4ReportsContractsSummaries', 'month', month)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('v4ReportsContractsSummaries', 'year', year)
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('v4ReportsContractsSummaries', 'aPPTYPE', aPPTYPE)
            const localVarPath = `/api/v4/reports/contracts/summaries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportsApi - functional programming interface
 * @export
 */
export const ReportsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportsApiAxiosParamCreator(configuration)
    return {
        /**
         * This will returns list of reports shortcut or summary
         * @summary Get the shortcut or summary of reports
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportsGetReportShortcut(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportsGetReportShortcutResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportsGetReportShortcut(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Display summary of supplier contract with total supply in tonnage and delivery. 
         * @summary Get summary of supplier contract report
         * @param {number} [month] Month in MM format
         * @param {number} [year] Year in YYYY format
         * @param {string} [contractName] 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v3ReportsContractsSummaries(month?: number, year?: number, contractName?: string, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V3ReportsContractsSummariesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v3ReportsContractsSummaries(month, year, contractName, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Display summary of supplier contract with several summarized data including: <br> 1. total supply in tonnage <br> 2. total trip <br> 3. sortation average <br> 4. latest trip date <br> 5. latest trip date which the sortation is outlier <br> 
         * @summary get supplier contract report summaries v4
         * @param {number} month Month in MM format
         * @param {number} year Year in YYYY format
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v4ReportsContractsSummaries(month: number, year: number, aPPTYPE: AppTypeEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V4ReportsContractsSummariesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v4ReportsContractsSummaries(month, year, aPPTYPE, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ReportsApi - factory interface
 * @export
 */
export const ReportsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportsApiFp(configuration)
    return {
        /**
         * This will returns list of reports shortcut or summary
         * @summary Get the shortcut or summary of reports
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsGetReportShortcut(options?: any): AxiosPromise<ReportsGetReportShortcutResponse> {
            return localVarFp.reportsGetReportShortcut(options).then((request) => request(axios, basePath));
        },
        /**
         * Display summary of supplier contract with total supply in tonnage and delivery. 
         * @summary Get summary of supplier contract report
         * @param {number} [month] Month in MM format
         * @param {number} [year] Year in YYYY format
         * @param {string} [contractName] 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v3ReportsContractsSummaries(month?: number, year?: number, contractName?: string, page?: number, limit?: number, options?: any): AxiosPromise<V3ReportsContractsSummariesResponse> {
            return localVarFp.v3ReportsContractsSummaries(month, year, contractName, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Display summary of supplier contract with several summarized data including: <br> 1. total supply in tonnage <br> 2. total trip <br> 3. sortation average <br> 4. latest trip date <br> 5. latest trip date which the sortation is outlier <br> 
         * @summary get supplier contract report summaries v4
         * @param {number} month Month in MM format
         * @param {number} year Year in YYYY format
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v4ReportsContractsSummaries(month: number, year: number, aPPTYPE: AppTypeEnum, options?: any): AxiosPromise<V4ReportsContractsSummariesResponse> {
            return localVarFp.v4ReportsContractsSummaries(month, year, aPPTYPE, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReportsApi - object-oriented interface
 * @export
 * @class ReportsApi
 * @extends {BaseAPI}
 */
export class ReportsApi extends BaseAPI {
    /**
     * This will returns list of reports shortcut or summary
     * @summary Get the shortcut or summary of reports
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public reportsGetReportShortcut(options?: AxiosRequestConfig) {
        return ReportsApiFp(this.configuration).reportsGetReportShortcut(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Display summary of supplier contract with total supply in tonnage and delivery. 
     * @summary Get summary of supplier contract report
     * @param {number} [month] Month in MM format
     * @param {number} [year] Year in YYYY format
     * @param {string} [contractName] 
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public v3ReportsContractsSummaries(month?: number, year?: number, contractName?: string, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return ReportsApiFp(this.configuration).v3ReportsContractsSummaries(month, year, contractName, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Display summary of supplier contract with several summarized data including: <br> 1. total supply in tonnage <br> 2. total trip <br> 3. sortation average <br> 4. latest trip date <br> 5. latest trip date which the sortation is outlier <br> 
     * @summary get supplier contract report summaries v4
     * @param {number} month Month in MM format
     * @param {number} year Year in YYYY format
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public v4ReportsContractsSummaries(month: number, year: number, aPPTYPE: AppTypeEnum, options?: AxiosRequestConfig) {
        return ReportsApiFp(this.configuration).v4ReportsContractsSummaries(month, year, aPPTYPE, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RewardApi - axios parameter creator
 * @export
 */
export const RewardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Will return the list of gold. The response will be ordered by small nominal ascending order
         * @summary Get Reward List
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {string} [rewardCategoryCode] Reward category code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loyaltyGetRewardList: async (page?: number, limit?: number, rewardCategoryCode?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/loyalty/rewards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (rewardCategoryCode !== undefined) {
                localVarQueryParameter['rewardCategoryCode'] = rewardCategoryCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * redeem reward
         * @summary redeem reward
         * @param {LoyaltyRedeemRewardRequest} loyaltyRedeemRewardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loyaltyRedeemReward: async (loyaltyRedeemRewardRequest: LoyaltyRedeemRewardRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loyaltyRedeemRewardRequest' is not null or undefined
            assertParamExists('loyaltyRedeemReward', 'loyaltyRedeemRewardRequest', loyaltyRedeemRewardRequest)
            const localVarPath = `/api/v1/admins/loyalty/rewards/redeem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loyaltyRedeemRewardRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RewardApi - functional programming interface
 * @export
 */
export const RewardApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RewardApiAxiosParamCreator(configuration)
    return {
        /**
         * Will return the list of gold. The response will be ordered by small nominal ascending order
         * @summary Get Reward List
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {string} [rewardCategoryCode] Reward category code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loyaltyGetRewardList(page?: number, limit?: number, rewardCategoryCode?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoyaltyGetRewardListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loyaltyGetRewardList(page, limit, rewardCategoryCode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * redeem reward
         * @summary redeem reward
         * @param {LoyaltyRedeemRewardRequest} loyaltyRedeemRewardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loyaltyRedeemReward(loyaltyRedeemRewardRequest: LoyaltyRedeemRewardRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoyaltyRedeemRewardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loyaltyRedeemReward(loyaltyRedeemRewardRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RewardApi - factory interface
 * @export
 */
export const RewardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RewardApiFp(configuration)
    return {
        /**
         * Will return the list of gold. The response will be ordered by small nominal ascending order
         * @summary Get Reward List
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {string} [rewardCategoryCode] Reward category code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loyaltyGetRewardList(page?: number, limit?: number, rewardCategoryCode?: string, options?: any): AxiosPromise<LoyaltyGetRewardListResponse> {
            return localVarFp.loyaltyGetRewardList(page, limit, rewardCategoryCode, options).then((request) => request(axios, basePath));
        },
        /**
         * redeem reward
         * @summary redeem reward
         * @param {LoyaltyRedeemRewardRequest} loyaltyRedeemRewardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loyaltyRedeemReward(loyaltyRedeemRewardRequest: LoyaltyRedeemRewardRequest, options?: any): AxiosPromise<LoyaltyRedeemRewardResponse> {
            return localVarFp.loyaltyRedeemReward(loyaltyRedeemRewardRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RewardApi - object-oriented interface
 * @export
 * @class RewardApi
 * @extends {BaseAPI}
 */
export class RewardApi extends BaseAPI {
    /**
     * Will return the list of gold. The response will be ordered by small nominal ascending order
     * @summary Get Reward List
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {string} [rewardCategoryCode] Reward category code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardApi
     */
    public loyaltyGetRewardList(page?: number, limit?: number, rewardCategoryCode?: string, options?: AxiosRequestConfig) {
        return RewardApiFp(this.configuration).loyaltyGetRewardList(page, limit, rewardCategoryCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * redeem reward
     * @summary redeem reward
     * @param {LoyaltyRedeemRewardRequest} loyaltyRedeemRewardRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardApi
     */
    public loyaltyRedeemReward(loyaltyRedeemRewardRequest: LoyaltyRedeemRewardRequest, options?: AxiosRequestConfig) {
        return RewardApiFp(this.configuration).loyaltyRedeemReward(loyaltyRedeemRewardRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ShareApi - axios parameter creator
 * @export
 */
export const ShareApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create share referral
         * @summary Create share referral
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {ShareCreateShareReferralRequest} shareCreateShareReferralRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShareReferral: async (aPPTYPE: AppTypeEnum, shareCreateShareReferralRequest: ShareCreateShareReferralRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('createShareReferral', 'aPPTYPE', aPPTYPE)
            // verify required parameter 'shareCreateShareReferralRequest' is not null or undefined
            assertParamExists('createShareReferral', 'shareCreateShareReferralRequest', shareCreateShareReferralRequest)
            const localVarPath = `/api/v1/share`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shareCreateShareReferralRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get share referral
         * @summary Get share referral
         * @param {string} shareId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShareReferral: async (shareId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shareId' is not null or undefined
            assertParamExists('getShareReferral', 'shareId', shareId)
            const localVarPath = `/api/v1/share/{shareId}`
                .replace(`{${"shareId"}}`, encodeURIComponent(String(shareId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ShareApi - functional programming interface
 * @export
 */
export const ShareApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ShareApiAxiosParamCreator(configuration)
    return {
        /**
         * Create share referral
         * @summary Create share referral
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {ShareCreateShareReferralRequest} shareCreateShareReferralRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createShareReferral(aPPTYPE: AppTypeEnum, shareCreateShareReferralRequest: ShareCreateShareReferralRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShareCreateShareReferralResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createShareReferral(aPPTYPE, shareCreateShareReferralRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get share referral
         * @summary Get share referral
         * @param {string} shareId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getShareReferral(shareId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShareGetShareReferralResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getShareReferral(shareId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ShareApi - factory interface
 * @export
 */
export const ShareApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ShareApiFp(configuration)
    return {
        /**
         * Create share referral
         * @summary Create share referral
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {ShareCreateShareReferralRequest} shareCreateShareReferralRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShareReferral(aPPTYPE: AppTypeEnum, shareCreateShareReferralRequest: ShareCreateShareReferralRequest, options?: any): AxiosPromise<ShareCreateShareReferralResponse> {
            return localVarFp.createShareReferral(aPPTYPE, shareCreateShareReferralRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get share referral
         * @summary Get share referral
         * @param {string} shareId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShareReferral(shareId: string, options?: any): AxiosPromise<ShareGetShareReferralResponse> {
            return localVarFp.getShareReferral(shareId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ShareApi - object-oriented interface
 * @export
 * @class ShareApi
 * @extends {BaseAPI}
 */
export class ShareApi extends BaseAPI {
    /**
     * Create share referral
     * @summary Create share referral
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {ShareCreateShareReferralRequest} shareCreateShareReferralRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShareApi
     */
    public createShareReferral(aPPTYPE: AppTypeEnum, shareCreateShareReferralRequest: ShareCreateShareReferralRequest, options?: AxiosRequestConfig) {
        return ShareApiFp(this.configuration).createShareReferral(aPPTYPE, shareCreateShareReferralRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get share referral
     * @summary Get share referral
     * @param {string} shareId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShareApi
     */
    public getShareReferral(shareId: string, options?: AxiosRequestConfig) {
        return ShareApiFp(this.configuration).getShareReferral(shareId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ShippingApi - axios parameter creator
 * @export
 */
export const ShippingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Calculate shipping cost based on total weight and destination 
         * @summary Calculate shipping cost
         * @param {ShippingCostCalculateRequest} shippingCostCalculateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shippingCostCalculate: async (shippingCostCalculateRequest: ShippingCostCalculateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shippingCostCalculateRequest' is not null or undefined
            assertParamExists('shippingCostCalculate', 'shippingCostCalculateRequest', shippingCostCalculateRequest)
            const localVarPath = `/api/v1/shipping/cost/calculate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shippingCostCalculateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Calculate shipping cost based on total weight and destination 
         * @summary Calculate shipping cost V2
         * @param {ShippingCostCalculateV2Request} shippingCostCalculateV2Request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shippingCostCalculateV2: async (shippingCostCalculateV2Request: ShippingCostCalculateV2Request, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shippingCostCalculateV2Request' is not null or undefined
            assertParamExists('shippingCostCalculateV2', 'shippingCostCalculateV2Request', shippingCostCalculateV2Request)
            const localVarPath = `/api/v2/shipping/cost/calculate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shippingCostCalculateV2Request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ShippingApi - functional programming interface
 * @export
 */
export const ShippingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ShippingApiAxiosParamCreator(configuration)
    return {
        /**
         * Calculate shipping cost based on total weight and destination 
         * @summary Calculate shipping cost
         * @param {ShippingCostCalculateRequest} shippingCostCalculateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shippingCostCalculate(shippingCostCalculateRequest: ShippingCostCalculateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShippingCostCalculateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shippingCostCalculate(shippingCostCalculateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Calculate shipping cost based on total weight and destination 
         * @summary Calculate shipping cost V2
         * @param {ShippingCostCalculateV2Request} shippingCostCalculateV2Request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shippingCostCalculateV2(shippingCostCalculateV2Request: ShippingCostCalculateV2Request, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShippingCostCalculateV2Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shippingCostCalculateV2(shippingCostCalculateV2Request, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ShippingApi - factory interface
 * @export
 */
export const ShippingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ShippingApiFp(configuration)
    return {
        /**
         * Calculate shipping cost based on total weight and destination 
         * @summary Calculate shipping cost
         * @param {ShippingCostCalculateRequest} shippingCostCalculateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shippingCostCalculate(shippingCostCalculateRequest: ShippingCostCalculateRequest, options?: any): AxiosPromise<ShippingCostCalculateResponse> {
            return localVarFp.shippingCostCalculate(shippingCostCalculateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Calculate shipping cost based on total weight and destination 
         * @summary Calculate shipping cost V2
         * @param {ShippingCostCalculateV2Request} shippingCostCalculateV2Request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shippingCostCalculateV2(shippingCostCalculateV2Request: ShippingCostCalculateV2Request, options?: any): AxiosPromise<ShippingCostCalculateV2Response> {
            return localVarFp.shippingCostCalculateV2(shippingCostCalculateV2Request, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ShippingApi - object-oriented interface
 * @export
 * @class ShippingApi
 * @extends {BaseAPI}
 */
export class ShippingApi extends BaseAPI {
    /**
     * Calculate shipping cost based on total weight and destination 
     * @summary Calculate shipping cost
     * @param {ShippingCostCalculateRequest} shippingCostCalculateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShippingApi
     */
    public shippingCostCalculate(shippingCostCalculateRequest: ShippingCostCalculateRequest, options?: AxiosRequestConfig) {
        return ShippingApiFp(this.configuration).shippingCostCalculate(shippingCostCalculateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Calculate shipping cost based on total weight and destination 
     * @summary Calculate shipping cost V2
     * @param {ShippingCostCalculateV2Request} shippingCostCalculateV2Request 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShippingApi
     */
    public shippingCostCalculateV2(shippingCostCalculateV2Request: ShippingCostCalculateV2Request, options?: AxiosRequestConfig) {
        return ShippingApiFp(this.configuration).shippingCostCalculateV2(shippingCostCalculateV2Request, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SubagentApi - axios parameter creator
 * @export
 */
export const SubagentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Endpoint for creating sawitpoin redistribution
         * @summary Create sawitpoin redistribution
         * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
         * @param {SawitpoinRedistributionCreateRequest} sawitpoinRedistributionCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sawitpoinRedistributionCreate: async (authorization: string, sawitpoinRedistributionCreateRequest: SawitpoinRedistributionCreateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('sawitpoinRedistributionCreate', 'authorization', authorization)
            // verify required parameter 'sawitpoinRedistributionCreateRequest' is not null or undefined
            assertParamExists('sawitpoinRedistributionCreate', 'sawitpoinRedistributionCreateRequest', sawitpoinRedistributionCreateRequest)
            const localVarPath = `/api/v1/sawitpoin/redistribution`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sawitpoinRedistributionCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Detail sawitpoin redistribution
         * @summary Get Sawitpoin Redistribution
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} redistributionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sawitpoinRedistributionDetail: async (authorization: string, redistributionId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('sawitpoinRedistributionDetail', 'authorization', authorization)
            // verify required parameter 'redistributionId' is not null or undefined
            assertParamExists('sawitpoinRedistributionDetail', 'redistributionId', redistributionId)
            const localVarPath = `/api/v1/sawitpoin/redistribution/{redistributionId}`
                .replace(`{${"redistributionId"}}`, encodeURIComponent(String(redistributionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endpoint for editing sawitpoin redistribution<br><br>  Our internal admin can also use this endpoint. The difference is that FE will send only `percentage` in the request, while the internal admin will send all the request body (must complete or otherwise will return 422). 
         * @summary Edit sawitpoin redistribution
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} redistributionId 
         * @param {SawitpoinRedistributionEditRequest} sawitpoinRedistributionEditRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sawitpoinRedistributionEdit: async (authorization: string, redistributionId: string, sawitpoinRedistributionEditRequest: SawitpoinRedistributionEditRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('sawitpoinRedistributionEdit', 'authorization', authorization)
            // verify required parameter 'redistributionId' is not null or undefined
            assertParamExists('sawitpoinRedistributionEdit', 'redistributionId', redistributionId)
            // verify required parameter 'sawitpoinRedistributionEditRequest' is not null or undefined
            assertParamExists('sawitpoinRedistributionEdit', 'sawitpoinRedistributionEditRequest', sawitpoinRedistributionEditRequest)
            const localVarPath = `/api/v1/sawitpoin/redistribution/{redistributionId}`
                .replace(`{${"redistributionId"}}`, encodeURIComponent(String(redistributionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sawitpoinRedistributionEditRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List of sub-agents by DO
         * @summary List of Sawitpoin Redistribution
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sawitpoinRedistributionList: async (authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('sawitpoinRedistributionList', 'authorization', authorization)
            const localVarPath = `/api/v1/sawitpoin/redistribution`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endpoint for creating new sub-agent
         * @summary Create new sub-agent
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {SubAgentCreateRequest} subAgentCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subAgentCreate: async (authorization: string, subAgentCreateRequest: SubAgentCreateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('subAgentCreate', 'authorization', authorization)
            // verify required parameter 'subAgentCreateRequest' is not null or undefined
            assertParamExists('subAgentCreate', 'subAgentCreateRequest', subAgentCreateRequest)
            const localVarPath = `/api/v1/subagent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(subAgentCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List of sub-agents by DO
         * @summary List of Sub-Agents
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} [supplierContractId] Filter for the supplier contract id sub-agent list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subAgentList: async (authorization: string, supplierContractId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('subAgentList', 'authorization', authorization)
            const localVarPath = `/api/v1/subagent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (supplierContractId !== undefined) {
                localVarQueryParameter['supplierContractId'] = supplierContractId;
            }

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endpoint for adding sub-agent truck
         * @summary Add sub-agent truck
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {SubAgentTruckCreateRequest} subAgentTruckCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subAgentTruckCreate: async (authorization: string, subAgentTruckCreateRequest: SubAgentTruckCreateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('subAgentTruckCreate', 'authorization', authorization)
            // verify required parameter 'subAgentTruckCreateRequest' is not null or undefined
            assertParamExists('subAgentTruckCreate', 'subAgentTruckCreateRequest', subAgentTruckCreateRequest)
            const localVarPath = `/api/v1/subagent/truck`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(subAgentTruckCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endpoint for listing sub-agent\'s truck
         * @summary List of sub-agent truck
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} [platNo] Search query for sub agent truck plat no
         * @param {string} [orderBy] Column used for ordering, will accept the field name from response object
         * @param {OrderDirectionEnum} [direction] 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subAgentTruckList: async (authorization: string, platNo?: string, orderBy?: string, direction?: OrderDirectionEnum, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('subAgentTruckList', 'authorization', authorization)
            const localVarPath = `/api/v1/subagent/truck`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (platNo !== undefined) {
                localVarQueryParameter['platNo'] = platNo;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endpoint for getting daily price per sub-agent per supplier
         * @summary Get Daily Price per Sub-Agent
         * @param {string} supplierId Supplier ID in UUID type 4 format
         * @param {number} [datetime] datetime for filtering sub-agent daily price, if empty will use current timestamp. Use epoch timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subagentDailyPriceList: async (supplierId: string, datetime?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('subagentDailyPriceList', 'supplierId', supplierId)
            const localVarPath = `/api/v1/subagent/{supplierId}/daily-price`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (datetime !== undefined) {
                localVarQueryParameter['datetime'] = datetime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endpoint for setting daily price per sub-agent
         * @summary Set Daily Price per Sub-Agent
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} supplierId Supplier ID in UUID type 4 format
         * @param {SubagentDailyPriceSaveRequest} subagentDailyPriceSaveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subagentDailyPriceSave: async (authorization: string, supplierId: string, subagentDailyPriceSaveRequest: SubagentDailyPriceSaveRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('subagentDailyPriceSave', 'authorization', authorization)
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('subagentDailyPriceSave', 'supplierId', supplierId)
            // verify required parameter 'subagentDailyPriceSaveRequest' is not null or undefined
            assertParamExists('subagentDailyPriceSave', 'subagentDailyPriceSaveRequest', subagentDailyPriceSaveRequest)
            const localVarPath = `/api/v1/subagent/{supplierId}/daily-price`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(subagentDailyPriceSaveRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List of Supplier\'s Sub-Agents daily supply
         * @summary Get Daily Supply List
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} supplierId Supplier ID in UUID type 4 format
         * @param {number} [date] Date for filtering subagent daily supply date (in epoch) formatted in UTC-0
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subagentDailySupply: async (authorization: string, supplierId: string, date?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('subagentDailySupply', 'authorization', authorization)
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('subagentDailySupply', 'supplierId', supplierId)
            const localVarPath = `/api/v1/subagent/{supplierId}/daily-supply`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Detail of Supplier\'s Sub-Agents daily supply and it costs
         * @summary Get Detail Daily Supply Costs
         * @param {string} weighbridgeId Weighbridge UUID
         * @param {string} supplierId Supplier ID in UUID type 4 format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subagentDailySupplyCosts: async (weighbridgeId: string, supplierId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'weighbridgeId' is not null or undefined
            assertParamExists('subagentDailySupplyCosts', 'weighbridgeId', weighbridgeId)
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('subagentDailySupplyCosts', 'supplierId', supplierId)
            const localVarPath = `/api/v1/subagent/{supplierId}/daily-supply/{weighbridgeId}`
                .replace(`{${"weighbridgeId"}}`, encodeURIComponent(String(weighbridgeId)))
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endpoint for create or update daily supply
         * @summary Create or Update Daily Supply
         * @param {string} supplierId Supplier ID in UUID type 4 format
         * @param {SubagentDailySupplyCreateRequest} subagentDailySupplyCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subagentDailySupplyCreate: async (supplierId: string, subagentDailySupplyCreateRequest: SubagentDailySupplyCreateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('subagentDailySupplyCreate', 'supplierId', supplierId)
            // verify required parameter 'subagentDailySupplyCreateRequest' is not null or undefined
            assertParamExists('subagentDailySupplyCreate', 'subagentDailySupplyCreateRequest', subagentDailySupplyCreateRequest)
            const localVarPath = `/api/v1/subagent/{supplierId}/daily-supply`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(subagentDailySupplyCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List of Supplier\'s Sub-Agents monthly supply
         * @summary Get Monthly Supply List
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} supplierId Supplier ID in UUID type 4 format
         * @param {number} month Filter for the month to be shown (in epoch)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subagentMonthlySupply: async (authorization: string, supplierId: string, month: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('subagentMonthlySupply', 'authorization', authorization)
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('subagentMonthlySupply', 'supplierId', supplierId)
            // verify required parameter 'month' is not null or undefined
            assertParamExists('subagentMonthlySupply', 'month', month)
            const localVarPath = `/api/v1/subagent/{supplierId}/monthly-supply`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endpoint for listing trucks per sub-agent
         * @summary List Trucks per Sub-Agent
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} subagentId Sub Agent UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckSubAgentList: async (authorization: string, subagentId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('truckSubAgentList', 'authorization', authorization)
            // verify required parameter 'subagentId' is not null or undefined
            assertParamExists('truckSubAgentList', 'subagentId', subagentId)
            const localVarPath = `/api/v1/subagent/{subagentId}/truck`
                .replace(`{${"subagentId"}}`, encodeURIComponent(String(subagentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endpoint for storing & updating sub-agent truck mapping.  If the weighbridge is present, then the start and end of the mapping will use the weighbridge\'s entry and exit time 
         * @summary Map Sub-Agent to Truck (v2)
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {V2SubAgentTruckCreate} v2SubAgentTruckCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2SubAgentTruckCreate: async (authorization: string, v2SubAgentTruckCreate: V2SubAgentTruckCreate, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('v2SubAgentTruckCreate', 'authorization', authorization)
            // verify required parameter 'v2SubAgentTruckCreate' is not null or undefined
            assertParamExists('v2SubAgentTruckCreate', 'v2SubAgentTruckCreate', v2SubAgentTruckCreate)
            const localVarPath = `/api/v2/subagent/truck`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(v2SubAgentTruckCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SubagentApi - functional programming interface
 * @export
 */
export const SubagentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SubagentApiAxiosParamCreator(configuration)
    return {
        /**
         * Endpoint for creating sawitpoin redistribution
         * @summary Create sawitpoin redistribution
         * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
         * @param {SawitpoinRedistributionCreateRequest} sawitpoinRedistributionCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sawitpoinRedistributionCreate(authorization: string, sawitpoinRedistributionCreateRequest: SawitpoinRedistributionCreateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sawitpoinRedistributionCreate(authorization, sawitpoinRedistributionCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Detail sawitpoin redistribution
         * @summary Get Sawitpoin Redistribution
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} redistributionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sawitpoinRedistributionDetail(authorization: string, redistributionId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SawitpoinRedistributionDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sawitpoinRedistributionDetail(authorization, redistributionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Endpoint for editing sawitpoin redistribution<br><br>  Our internal admin can also use this endpoint. The difference is that FE will send only `percentage` in the request, while the internal admin will send all the request body (must complete or otherwise will return 422). 
         * @summary Edit sawitpoin redistribution
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} redistributionId 
         * @param {SawitpoinRedistributionEditRequest} sawitpoinRedistributionEditRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sawitpoinRedistributionEdit(authorization: string, redistributionId: string, sawitpoinRedistributionEditRequest: SawitpoinRedistributionEditRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SawitpoinRedistributionEditResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sawitpoinRedistributionEdit(authorization, redistributionId, sawitpoinRedistributionEditRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * List of sub-agents by DO
         * @summary List of Sawitpoin Redistribution
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sawitpoinRedistributionList(authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SawitpoinRedistributionListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sawitpoinRedistributionList(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Endpoint for creating new sub-agent
         * @summary Create new sub-agent
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {SubAgentCreateRequest} subAgentCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subAgentCreate(authorization: string, subAgentCreateRequest: SubAgentCreateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubAgentCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subAgentCreate(authorization, subAgentCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * List of sub-agents by DO
         * @summary List of Sub-Agents
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} [supplierContractId] Filter for the supplier contract id sub-agent list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subAgentList(authorization: string, supplierContractId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubAgentListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subAgentList(authorization, supplierContractId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Endpoint for adding sub-agent truck
         * @summary Add sub-agent truck
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {SubAgentTruckCreateRequest} subAgentTruckCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subAgentTruckCreate(authorization: string, subAgentTruckCreateRequest: SubAgentTruckCreateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subAgentTruckCreate(authorization, subAgentTruckCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Endpoint for listing sub-agent\'s truck
         * @summary List of sub-agent truck
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} [platNo] Search query for sub agent truck plat no
         * @param {string} [orderBy] Column used for ordering, will accept the field name from response object
         * @param {OrderDirectionEnum} [direction] 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subAgentTruckList(authorization: string, platNo?: string, orderBy?: string, direction?: OrderDirectionEnum, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubAgentTruckListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subAgentTruckList(authorization, platNo, orderBy, direction, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Endpoint for getting daily price per sub-agent per supplier
         * @summary Get Daily Price per Sub-Agent
         * @param {string} supplierId Supplier ID in UUID type 4 format
         * @param {number} [datetime] datetime for filtering sub-agent daily price, if empty will use current timestamp. Use epoch timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subagentDailyPriceList(supplierId: string, datetime?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubagentDailyPriceListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subagentDailyPriceList(supplierId, datetime, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Endpoint for setting daily price per sub-agent
         * @summary Set Daily Price per Sub-Agent
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} supplierId Supplier ID in UUID type 4 format
         * @param {SubagentDailyPriceSaveRequest} subagentDailyPriceSaveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subagentDailyPriceSave(authorization: string, supplierId: string, subagentDailyPriceSaveRequest: SubagentDailyPriceSaveRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subagentDailyPriceSave(authorization, supplierId, subagentDailyPriceSaveRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * List of Supplier\'s Sub-Agents daily supply
         * @summary Get Daily Supply List
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} supplierId Supplier ID in UUID type 4 format
         * @param {number} [date] Date for filtering subagent daily supply date (in epoch) formatted in UTC-0
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subagentDailySupply(authorization: string, supplierId: string, date?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubagentDailySupplyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subagentDailySupply(authorization, supplierId, date, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get Detail of Supplier\'s Sub-Agents daily supply and it costs
         * @summary Get Detail Daily Supply Costs
         * @param {string} weighbridgeId Weighbridge UUID
         * @param {string} supplierId Supplier ID in UUID type 4 format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subagentDailySupplyCosts(weighbridgeId: string, supplierId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubagentDailySupplyCostsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subagentDailySupplyCosts(weighbridgeId, supplierId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Endpoint for create or update daily supply
         * @summary Create or Update Daily Supply
         * @param {string} supplierId Supplier ID in UUID type 4 format
         * @param {SubagentDailySupplyCreateRequest} subagentDailySupplyCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subagentDailySupplyCreate(supplierId: string, subagentDailySupplyCreateRequest: SubagentDailySupplyCreateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subagentDailySupplyCreate(supplierId, subagentDailySupplyCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * List of Supplier\'s Sub-Agents monthly supply
         * @summary Get Monthly Supply List
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} supplierId Supplier ID in UUID type 4 format
         * @param {number} month Filter for the month to be shown (in epoch)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subagentMonthlySupply(authorization: string, supplierId: string, month: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubagentMonthlySupplyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subagentMonthlySupply(authorization, supplierId, month, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Endpoint for listing trucks per sub-agent
         * @summary List Trucks per Sub-Agent
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} subagentId Sub Agent UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async truckSubAgentList(authorization: string, subagentId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TruckSubAgentListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.truckSubAgentList(authorization, subagentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Endpoint for storing & updating sub-agent truck mapping.  If the weighbridge is present, then the start and end of the mapping will use the weighbridge\'s entry and exit time 
         * @summary Map Sub-Agent to Truck (v2)
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {V2SubAgentTruckCreate} v2SubAgentTruckCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2SubAgentTruckCreate(authorization: string, v2SubAgentTruckCreate: V2SubAgentTruckCreate, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2SubAgentTruckCreate(authorization, v2SubAgentTruckCreate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SubagentApi - factory interface
 * @export
 */
export const SubagentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SubagentApiFp(configuration)
    return {
        /**
         * Endpoint for creating sawitpoin redistribution
         * @summary Create sawitpoin redistribution
         * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
         * @param {SawitpoinRedistributionCreateRequest} sawitpoinRedistributionCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sawitpoinRedistributionCreate(authorization: string, sawitpoinRedistributionCreateRequest: SawitpoinRedistributionCreateRequest, options?: any): AxiosPromise<void> {
            return localVarFp.sawitpoinRedistributionCreate(authorization, sawitpoinRedistributionCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Detail sawitpoin redistribution
         * @summary Get Sawitpoin Redistribution
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} redistributionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sawitpoinRedistributionDetail(authorization: string, redistributionId: string, options?: any): AxiosPromise<SawitpoinRedistributionDetailResponse> {
            return localVarFp.sawitpoinRedistributionDetail(authorization, redistributionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint for editing sawitpoin redistribution<br><br>  Our internal admin can also use this endpoint. The difference is that FE will send only `percentage` in the request, while the internal admin will send all the request body (must complete or otherwise will return 422). 
         * @summary Edit sawitpoin redistribution
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} redistributionId 
         * @param {SawitpoinRedistributionEditRequest} sawitpoinRedistributionEditRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sawitpoinRedistributionEdit(authorization: string, redistributionId: string, sawitpoinRedistributionEditRequest: SawitpoinRedistributionEditRequest, options?: any): AxiosPromise<SawitpoinRedistributionEditResponse> {
            return localVarFp.sawitpoinRedistributionEdit(authorization, redistributionId, sawitpoinRedistributionEditRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * List of sub-agents by DO
         * @summary List of Sawitpoin Redistribution
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sawitpoinRedistributionList(authorization: string, options?: any): AxiosPromise<SawitpoinRedistributionListResponse> {
            return localVarFp.sawitpoinRedistributionList(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint for creating new sub-agent
         * @summary Create new sub-agent
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {SubAgentCreateRequest} subAgentCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subAgentCreate(authorization: string, subAgentCreateRequest: SubAgentCreateRequest, options?: any): AxiosPromise<SubAgentCreateResponse> {
            return localVarFp.subAgentCreate(authorization, subAgentCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * List of sub-agents by DO
         * @summary List of Sub-Agents
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} [supplierContractId] Filter for the supplier contract id sub-agent list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subAgentList(authorization: string, supplierContractId?: string, options?: any): AxiosPromise<SubAgentListResponse> {
            return localVarFp.subAgentList(authorization, supplierContractId, options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint for adding sub-agent truck
         * @summary Add sub-agent truck
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {SubAgentTruckCreateRequest} subAgentTruckCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subAgentTruckCreate(authorization: string, subAgentTruckCreateRequest: SubAgentTruckCreateRequest, options?: any): AxiosPromise<void> {
            return localVarFp.subAgentTruckCreate(authorization, subAgentTruckCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint for listing sub-agent\'s truck
         * @summary List of sub-agent truck
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} [platNo] Search query for sub agent truck plat no
         * @param {string} [orderBy] Column used for ordering, will accept the field name from response object
         * @param {OrderDirectionEnum} [direction] 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subAgentTruckList(authorization: string, platNo?: string, orderBy?: string, direction?: OrderDirectionEnum, page?: number, limit?: number, options?: any): AxiosPromise<SubAgentTruckListResponse> {
            return localVarFp.subAgentTruckList(authorization, platNo, orderBy, direction, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint for getting daily price per sub-agent per supplier
         * @summary Get Daily Price per Sub-Agent
         * @param {string} supplierId Supplier ID in UUID type 4 format
         * @param {number} [datetime] datetime for filtering sub-agent daily price, if empty will use current timestamp. Use epoch timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subagentDailyPriceList(supplierId: string, datetime?: number, options?: any): AxiosPromise<SubagentDailyPriceListResponse> {
            return localVarFp.subagentDailyPriceList(supplierId, datetime, options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint for setting daily price per sub-agent
         * @summary Set Daily Price per Sub-Agent
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} supplierId Supplier ID in UUID type 4 format
         * @param {SubagentDailyPriceSaveRequest} subagentDailyPriceSaveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subagentDailyPriceSave(authorization: string, supplierId: string, subagentDailyPriceSaveRequest: SubagentDailyPriceSaveRequest, options?: any): AxiosPromise<void> {
            return localVarFp.subagentDailyPriceSave(authorization, supplierId, subagentDailyPriceSaveRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * List of Supplier\'s Sub-Agents daily supply
         * @summary Get Daily Supply List
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} supplierId Supplier ID in UUID type 4 format
         * @param {number} [date] Date for filtering subagent daily supply date (in epoch) formatted in UTC-0
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subagentDailySupply(authorization: string, supplierId: string, date?: number, options?: any): AxiosPromise<SubagentDailySupplyResponse> {
            return localVarFp.subagentDailySupply(authorization, supplierId, date, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Detail of Supplier\'s Sub-Agents daily supply and it costs
         * @summary Get Detail Daily Supply Costs
         * @param {string} weighbridgeId Weighbridge UUID
         * @param {string} supplierId Supplier ID in UUID type 4 format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subagentDailySupplyCosts(weighbridgeId: string, supplierId: string, options?: any): AxiosPromise<SubagentDailySupplyCostsResponse> {
            return localVarFp.subagentDailySupplyCosts(weighbridgeId, supplierId, options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint for create or update daily supply
         * @summary Create or Update Daily Supply
         * @param {string} supplierId Supplier ID in UUID type 4 format
         * @param {SubagentDailySupplyCreateRequest} subagentDailySupplyCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subagentDailySupplyCreate(supplierId: string, subagentDailySupplyCreateRequest: SubagentDailySupplyCreateRequest, options?: any): AxiosPromise<void> {
            return localVarFp.subagentDailySupplyCreate(supplierId, subagentDailySupplyCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * List of Supplier\'s Sub-Agents monthly supply
         * @summary Get Monthly Supply List
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} supplierId Supplier ID in UUID type 4 format
         * @param {number} month Filter for the month to be shown (in epoch)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subagentMonthlySupply(authorization: string, supplierId: string, month: number, options?: any): AxiosPromise<SubagentMonthlySupplyResponse> {
            return localVarFp.subagentMonthlySupply(authorization, supplierId, month, options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint for listing trucks per sub-agent
         * @summary List Trucks per Sub-Agent
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} subagentId Sub Agent UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckSubAgentList(authorization: string, subagentId: string, options?: any): AxiosPromise<TruckSubAgentListResponse> {
            return localVarFp.truckSubAgentList(authorization, subagentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint for storing & updating sub-agent truck mapping.  If the weighbridge is present, then the start and end of the mapping will use the weighbridge\'s entry and exit time 
         * @summary Map Sub-Agent to Truck (v2)
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {V2SubAgentTruckCreate} v2SubAgentTruckCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2SubAgentTruckCreate(authorization: string, v2SubAgentTruckCreate: V2SubAgentTruckCreate, options?: any): AxiosPromise<void> {
            return localVarFp.v2SubAgentTruckCreate(authorization, v2SubAgentTruckCreate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SubagentApi - object-oriented interface
 * @export
 * @class SubagentApi
 * @extends {BaseAPI}
 */
export class SubagentApi extends BaseAPI {
    /**
     * Endpoint for creating sawitpoin redistribution
     * @summary Create sawitpoin redistribution
     * @param {string} authorization API Key sent with Basic authentication, will be using a static API Key
     * @param {SawitpoinRedistributionCreateRequest} sawitpoinRedistributionCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubagentApi
     */
    public sawitpoinRedistributionCreate(authorization: string, sawitpoinRedistributionCreateRequest: SawitpoinRedistributionCreateRequest, options?: AxiosRequestConfig) {
        return SubagentApiFp(this.configuration).sawitpoinRedistributionCreate(authorization, sawitpoinRedistributionCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Detail sawitpoin redistribution
     * @summary Get Sawitpoin Redistribution
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {string} redistributionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubagentApi
     */
    public sawitpoinRedistributionDetail(authorization: string, redistributionId: string, options?: AxiosRequestConfig) {
        return SubagentApiFp(this.configuration).sawitpoinRedistributionDetail(authorization, redistributionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endpoint for editing sawitpoin redistribution<br><br>  Our internal admin can also use this endpoint. The difference is that FE will send only `percentage` in the request, while the internal admin will send all the request body (must complete or otherwise will return 422). 
     * @summary Edit sawitpoin redistribution
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {string} redistributionId 
     * @param {SawitpoinRedistributionEditRequest} sawitpoinRedistributionEditRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubagentApi
     */
    public sawitpoinRedistributionEdit(authorization: string, redistributionId: string, sawitpoinRedistributionEditRequest: SawitpoinRedistributionEditRequest, options?: AxiosRequestConfig) {
        return SubagentApiFp(this.configuration).sawitpoinRedistributionEdit(authorization, redistributionId, sawitpoinRedistributionEditRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List of sub-agents by DO
     * @summary List of Sawitpoin Redistribution
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubagentApi
     */
    public sawitpoinRedistributionList(authorization: string, options?: AxiosRequestConfig) {
        return SubagentApiFp(this.configuration).sawitpoinRedistributionList(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endpoint for creating new sub-agent
     * @summary Create new sub-agent
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {SubAgentCreateRequest} subAgentCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubagentApi
     */
    public subAgentCreate(authorization: string, subAgentCreateRequest: SubAgentCreateRequest, options?: AxiosRequestConfig) {
        return SubagentApiFp(this.configuration).subAgentCreate(authorization, subAgentCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List of sub-agents by DO
     * @summary List of Sub-Agents
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {string} [supplierContractId] Filter for the supplier contract id sub-agent list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubagentApi
     */
    public subAgentList(authorization: string, supplierContractId?: string, options?: AxiosRequestConfig) {
        return SubagentApiFp(this.configuration).subAgentList(authorization, supplierContractId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endpoint for adding sub-agent truck
     * @summary Add sub-agent truck
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {SubAgentTruckCreateRequest} subAgentTruckCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubagentApi
     */
    public subAgentTruckCreate(authorization: string, subAgentTruckCreateRequest: SubAgentTruckCreateRequest, options?: AxiosRequestConfig) {
        return SubagentApiFp(this.configuration).subAgentTruckCreate(authorization, subAgentTruckCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endpoint for listing sub-agent\'s truck
     * @summary List of sub-agent truck
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {string} [platNo] Search query for sub agent truck plat no
     * @param {string} [orderBy] Column used for ordering, will accept the field name from response object
     * @param {OrderDirectionEnum} [direction] 
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubagentApi
     */
    public subAgentTruckList(authorization: string, platNo?: string, orderBy?: string, direction?: OrderDirectionEnum, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return SubagentApiFp(this.configuration).subAgentTruckList(authorization, platNo, orderBy, direction, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endpoint for getting daily price per sub-agent per supplier
     * @summary Get Daily Price per Sub-Agent
     * @param {string} supplierId Supplier ID in UUID type 4 format
     * @param {number} [datetime] datetime for filtering sub-agent daily price, if empty will use current timestamp. Use epoch timestamp
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubagentApi
     */
    public subagentDailyPriceList(supplierId: string, datetime?: number, options?: AxiosRequestConfig) {
        return SubagentApiFp(this.configuration).subagentDailyPriceList(supplierId, datetime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endpoint for setting daily price per sub-agent
     * @summary Set Daily Price per Sub-Agent
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {string} supplierId Supplier ID in UUID type 4 format
     * @param {SubagentDailyPriceSaveRequest} subagentDailyPriceSaveRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubagentApi
     */
    public subagentDailyPriceSave(authorization: string, supplierId: string, subagentDailyPriceSaveRequest: SubagentDailyPriceSaveRequest, options?: AxiosRequestConfig) {
        return SubagentApiFp(this.configuration).subagentDailyPriceSave(authorization, supplierId, subagentDailyPriceSaveRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List of Supplier\'s Sub-Agents daily supply
     * @summary Get Daily Supply List
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {string} supplierId Supplier ID in UUID type 4 format
     * @param {number} [date] Date for filtering subagent daily supply date (in epoch) formatted in UTC-0
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubagentApi
     */
    public subagentDailySupply(authorization: string, supplierId: string, date?: number, options?: AxiosRequestConfig) {
        return SubagentApiFp(this.configuration).subagentDailySupply(authorization, supplierId, date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Detail of Supplier\'s Sub-Agents daily supply and it costs
     * @summary Get Detail Daily Supply Costs
     * @param {string} weighbridgeId Weighbridge UUID
     * @param {string} supplierId Supplier ID in UUID type 4 format
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubagentApi
     */
    public subagentDailySupplyCosts(weighbridgeId: string, supplierId: string, options?: AxiosRequestConfig) {
        return SubagentApiFp(this.configuration).subagentDailySupplyCosts(weighbridgeId, supplierId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endpoint for create or update daily supply
     * @summary Create or Update Daily Supply
     * @param {string} supplierId Supplier ID in UUID type 4 format
     * @param {SubagentDailySupplyCreateRequest} subagentDailySupplyCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubagentApi
     */
    public subagentDailySupplyCreate(supplierId: string, subagentDailySupplyCreateRequest: SubagentDailySupplyCreateRequest, options?: AxiosRequestConfig) {
        return SubagentApiFp(this.configuration).subagentDailySupplyCreate(supplierId, subagentDailySupplyCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List of Supplier\'s Sub-Agents monthly supply
     * @summary Get Monthly Supply List
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {string} supplierId Supplier ID in UUID type 4 format
     * @param {number} month Filter for the month to be shown (in epoch)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubagentApi
     */
    public subagentMonthlySupply(authorization: string, supplierId: string, month: number, options?: AxiosRequestConfig) {
        return SubagentApiFp(this.configuration).subagentMonthlySupply(authorization, supplierId, month, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endpoint for listing trucks per sub-agent
     * @summary List Trucks per Sub-Agent
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {string} subagentId Sub Agent UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubagentApi
     */
    public truckSubAgentList(authorization: string, subagentId: string, options?: AxiosRequestConfig) {
        return SubagentApiFp(this.configuration).truckSubAgentList(authorization, subagentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endpoint for storing & updating sub-agent truck mapping.  If the weighbridge is present, then the start and end of the mapping will use the weighbridge\'s entry and exit time 
     * @summary Map Sub-Agent to Truck (v2)
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {V2SubAgentTruckCreate} v2SubAgentTruckCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubagentApi
     */
    public v2SubAgentTruckCreate(authorization: string, v2SubAgentTruckCreate: V2SubAgentTruckCreate, options?: AxiosRequestConfig) {
        return SubagentApiFp(this.configuration).v2SubAgentTruckCreate(authorization, v2SubAgentTruckCreate, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SupplierApi - axios parameter creator
 * @export
 */
export const SupplierApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Endpoint for Supplier to save Partner\'s Daily Price
         * @summary Store Partner Daily Price for Supplier
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} supplierId Supplier ID in UUID type 4 format
         * @param {SupplierDailyPriceCreateRequest} [supplierDailyPriceCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supplierDailyPriceCreate: async (authorization: string, supplierId: string, supplierDailyPriceCreateRequest?: SupplierDailyPriceCreateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('supplierDailyPriceCreate', 'authorization', authorization)
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('supplierDailyPriceCreate', 'supplierId', supplierId)
            const localVarPath = `/api/v1/supplier/{supplierId}/daily-price`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(supplierDailyPriceCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SupplierApi - functional programming interface
 * @export
 */
export const SupplierApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SupplierApiAxiosParamCreator(configuration)
    return {
        /**
         * Endpoint for Supplier to save Partner\'s Daily Price
         * @summary Store Partner Daily Price for Supplier
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} supplierId Supplier ID in UUID type 4 format
         * @param {SupplierDailyPriceCreateRequest} [supplierDailyPriceCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supplierDailyPriceCreate(authorization: string, supplierId: string, supplierDailyPriceCreateRequest?: SupplierDailyPriceCreateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supplierDailyPriceCreate(authorization, supplierId, supplierDailyPriceCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SupplierApi - factory interface
 * @export
 */
export const SupplierApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SupplierApiFp(configuration)
    return {
        /**
         * Endpoint for Supplier to save Partner\'s Daily Price
         * @summary Store Partner Daily Price for Supplier
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} supplierId Supplier ID in UUID type 4 format
         * @param {SupplierDailyPriceCreateRequest} [supplierDailyPriceCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supplierDailyPriceCreate(authorization: string, supplierId: string, supplierDailyPriceCreateRequest?: SupplierDailyPriceCreateRequest, options?: any): AxiosPromise<void> {
            return localVarFp.supplierDailyPriceCreate(authorization, supplierId, supplierDailyPriceCreateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SupplierApi - object-oriented interface
 * @export
 * @class SupplierApi
 * @extends {BaseAPI}
 */
export class SupplierApi extends BaseAPI {
    /**
     * Endpoint for Supplier to save Partner\'s Daily Price
     * @summary Store Partner Daily Price for Supplier
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {string} supplierId Supplier ID in UUID type 4 format
     * @param {SupplierDailyPriceCreateRequest} [supplierDailyPriceCreateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierApi
     */
    public supplierDailyPriceCreate(authorization: string, supplierId: string, supplierDailyPriceCreateRequest?: SupplierDailyPriceCreateRequest, options?: AxiosRequestConfig) {
        return SupplierApiFp(this.configuration).supplierDailyPriceCreate(authorization, supplierId, supplierDailyPriceCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SupplierContractsApi - axios parameter creator
 * @export
 */
export const SupplierContractsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * The API finds the users ID of the owner for every supplier contracts 
         * @summary Get list of users ID who is owner of each supplier contract given a partner id
         * @param {string} [partnerId] Partner ID in UUID type 4 format. No filter applied if empty.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supplierContractsUsersGet: async (partnerId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/supplier-contracts/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (partnerId !== undefined) {
                localVarQueryParameter['partnerId'] = partnerId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SupplierContractsApi - functional programming interface
 * @export
 */
export const SupplierContractsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SupplierContractsApiAxiosParamCreator(configuration)
    return {
        /**
         * The API finds the users ID of the owner for every supplier contracts 
         * @summary Get list of users ID who is owner of each supplier contract given a partner id
         * @param {string} [partnerId] Partner ID in UUID type 4 format. No filter applied if empty.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supplierContractsUsersGet(partnerId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSupplierContractsUsersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supplierContractsUsersGet(partnerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SupplierContractsApi - factory interface
 * @export
 */
export const SupplierContractsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SupplierContractsApiFp(configuration)
    return {
        /**
         * The API finds the users ID of the owner for every supplier contracts 
         * @summary Get list of users ID who is owner of each supplier contract given a partner id
         * @param {string} [partnerId] Partner ID in UUID type 4 format. No filter applied if empty.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supplierContractsUsersGet(partnerId?: string, options?: any): AxiosPromise<GetSupplierContractsUsersResponse> {
            return localVarFp.supplierContractsUsersGet(partnerId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SupplierContractsApi - object-oriented interface
 * @export
 * @class SupplierContractsApi
 * @extends {BaseAPI}
 */
export class SupplierContractsApi extends BaseAPI {
    /**
     * The API finds the users ID of the owner for every supplier contracts 
     * @summary Get list of users ID who is owner of each supplier contract given a partner id
     * @param {string} [partnerId] Partner ID in UUID type 4 format. No filter applied if empty.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierContractsApi
     */
    public supplierContractsUsersGet(partnerId?: string, options?: AxiosRequestConfig) {
        return SupplierContractsApiFp(this.configuration).supplierContractsUsersGet(partnerId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SupplychainApi - axios parameter creator
 * @export
 */
export const SupplychainApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Admins can able to add stock to inventory
         * @summary Create product stock
         * @param {AdminsSupplyChainInventoryStockCreateRequest} [adminsSupplyChainInventoryStockCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsSupplyChainInventoryStockCreate: async (adminsSupplyChainInventoryStockCreateRequest?: AdminsSupplyChainInventoryStockCreateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admins/supplychain/inventory/stock`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminsSupplyChainInventoryStockCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Admins can able to get product stock from inventory
         * @summary Get all list of stock
         * @param {string} stockId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsSupplyChainInventoryStockGetDetail: async (stockId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stockId' is not null or undefined
            assertParamExists('adminsSupplyChainInventoryStockGetDetail', 'stockId', stockId)
            const localVarPath = `/api/v1/admins/supplychain/inventory/stock/{stockId}`
                .replace(`{${"stockId"}}`, encodeURIComponent(String(stockId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Admins can able to update product stock to inventory
         * @summary Update stock
         * @param {string} stockId 
         * @param {AdminsSupplyChainInventoryStockUpdateRequest} [adminsSupplyChainInventoryStockUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsSupplyChainInventoryStockUpdate: async (stockId: string, adminsSupplyChainInventoryStockUpdateRequest?: AdminsSupplyChainInventoryStockUpdateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stockId' is not null or undefined
            assertParamExists('adminsSupplyChainInventoryStockUpdate', 'stockId', stockId)
            const localVarPath = `/api/v1/admins/supplychain/inventory/stock/{stockId}`
                .replace(`{${"stockId"}}`, encodeURIComponent(String(stockId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminsSupplyChainInventoryStockUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SupplychainApi - functional programming interface
 * @export
 */
export const SupplychainApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SupplychainApiAxiosParamCreator(configuration)
    return {
        /**
         * Admins can able to add stock to inventory
         * @summary Create product stock
         * @param {AdminsSupplyChainInventoryStockCreateRequest} [adminsSupplyChainInventoryStockCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsSupplyChainInventoryStockCreate(adminsSupplyChainInventoryStockCreateRequest?: AdminsSupplyChainInventoryStockCreateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminsSupplyChainInventoryStockCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsSupplyChainInventoryStockCreate(adminsSupplyChainInventoryStockCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Admins can able to get product stock from inventory
         * @summary Get all list of stock
         * @param {string} stockId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsSupplyChainInventoryStockGetDetail(stockId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminsSupplyChainInventoryStockGetDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsSupplyChainInventoryStockGetDetail(stockId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Admins can able to update product stock to inventory
         * @summary Update stock
         * @param {string} stockId 
         * @param {AdminsSupplyChainInventoryStockUpdateRequest} [adminsSupplyChainInventoryStockUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsSupplyChainInventoryStockUpdate(stockId: string, adminsSupplyChainInventoryStockUpdateRequest?: AdminsSupplyChainInventoryStockUpdateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminsSupplyChainInventoryStockUpdateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsSupplyChainInventoryStockUpdate(stockId, adminsSupplyChainInventoryStockUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SupplychainApi - factory interface
 * @export
 */
export const SupplychainApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SupplychainApiFp(configuration)
    return {
        /**
         * Admins can able to add stock to inventory
         * @summary Create product stock
         * @param {AdminsSupplyChainInventoryStockCreateRequest} [adminsSupplyChainInventoryStockCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsSupplyChainInventoryStockCreate(adminsSupplyChainInventoryStockCreateRequest?: AdminsSupplyChainInventoryStockCreateRequest, options?: any): AxiosPromise<AdminsSupplyChainInventoryStockCreateResponse> {
            return localVarFp.adminsSupplyChainInventoryStockCreate(adminsSupplyChainInventoryStockCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Admins can able to get product stock from inventory
         * @summary Get all list of stock
         * @param {string} stockId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsSupplyChainInventoryStockGetDetail(stockId: string, options?: any): AxiosPromise<AdminsSupplyChainInventoryStockGetDetailResponse> {
            return localVarFp.adminsSupplyChainInventoryStockGetDetail(stockId, options).then((request) => request(axios, basePath));
        },
        /**
         * Admins can able to update product stock to inventory
         * @summary Update stock
         * @param {string} stockId 
         * @param {AdminsSupplyChainInventoryStockUpdateRequest} [adminsSupplyChainInventoryStockUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsSupplyChainInventoryStockUpdate(stockId: string, adminsSupplyChainInventoryStockUpdateRequest?: AdminsSupplyChainInventoryStockUpdateRequest, options?: any): AxiosPromise<AdminsSupplyChainInventoryStockUpdateResponse> {
            return localVarFp.adminsSupplyChainInventoryStockUpdate(stockId, adminsSupplyChainInventoryStockUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SupplychainApi - object-oriented interface
 * @export
 * @class SupplychainApi
 * @extends {BaseAPI}
 */
export class SupplychainApi extends BaseAPI {
    /**
     * Admins can able to add stock to inventory
     * @summary Create product stock
     * @param {AdminsSupplyChainInventoryStockCreateRequest} [adminsSupplyChainInventoryStockCreateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplychainApi
     */
    public adminsSupplyChainInventoryStockCreate(adminsSupplyChainInventoryStockCreateRequest?: AdminsSupplyChainInventoryStockCreateRequest, options?: AxiosRequestConfig) {
        return SupplychainApiFp(this.configuration).adminsSupplyChainInventoryStockCreate(adminsSupplyChainInventoryStockCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Admins can able to get product stock from inventory
     * @summary Get all list of stock
     * @param {string} stockId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplychainApi
     */
    public adminsSupplyChainInventoryStockGetDetail(stockId: string, options?: AxiosRequestConfig) {
        return SupplychainApiFp(this.configuration).adminsSupplyChainInventoryStockGetDetail(stockId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Admins can able to update product stock to inventory
     * @summary Update stock
     * @param {string} stockId 
     * @param {AdminsSupplyChainInventoryStockUpdateRequest} [adminsSupplyChainInventoryStockUpdateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplychainApi
     */
    public adminsSupplyChainInventoryStockUpdate(stockId: string, adminsSupplyChainInventoryStockUpdateRequest?: AdminsSupplyChainInventoryStockUpdateRequest, options?: AxiosRequestConfig) {
        return SupplychainApiFp(this.configuration).adminsSupplyChainInventoryStockUpdate(stockId, adminsSupplyChainInventoryStockUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SurveysApi - axios parameter creator
 * @export
 */
export const SurveysApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Surveyor will visit farm owner and do field survey. They will collect some data and also its geolocation of their farmArea. Temporary survey member and its farms data. Combined registering a member and collecting data into single json.
         * @summary Submit survey data
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {SurveyCreateRequest} surveyCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        surveyCreate: async (authorization: string, surveyCreateRequest: SurveyCreateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('surveyCreate', 'authorization', authorization)
            // verify required parameter 'surveyCreateRequest' is not null or undefined
            assertParamExists('surveyCreate', 'surveyCreateRequest', surveyCreateRequest)
            const localVarPath = `/api/v1/survey`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(surveyCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SurveysApi - functional programming interface
 * @export
 */
export const SurveysApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SurveysApiAxiosParamCreator(configuration)
    return {
        /**
         * Surveyor will visit farm owner and do field survey. They will collect some data and also its geolocation of their farmArea. Temporary survey member and its farms data. Combined registering a member and collecting data into single json.
         * @summary Submit survey data
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {SurveyCreateRequest} surveyCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async surveyCreate(authorization: string, surveyCreateRequest: SurveyCreateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveyCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.surveyCreate(authorization, surveyCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SurveysApi - factory interface
 * @export
 */
export const SurveysApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SurveysApiFp(configuration)
    return {
        /**
         * Surveyor will visit farm owner and do field survey. They will collect some data and also its geolocation of their farmArea. Temporary survey member and its farms data. Combined registering a member and collecting data into single json.
         * @summary Submit survey data
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {SurveyCreateRequest} surveyCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        surveyCreate(authorization: string, surveyCreateRequest: SurveyCreateRequest, options?: any): AxiosPromise<SurveyCreateResponse> {
            return localVarFp.surveyCreate(authorization, surveyCreateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SurveysApi - object-oriented interface
 * @export
 * @class SurveysApi
 * @extends {BaseAPI}
 */
export class SurveysApi extends BaseAPI {
    /**
     * Surveyor will visit farm owner and do field survey. They will collect some data and also its geolocation of their farmArea. Temporary survey member and its farms data. Combined registering a member and collecting data into single json.
     * @summary Submit survey data
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {SurveyCreateRequest} surveyCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveysApi
     */
    public surveyCreate(authorization: string, surveyCreateRequest: SurveyCreateRequest, options?: AxiosRequestConfig) {
        return SurveysApiFp(this.configuration).surveyCreate(authorization, surveyCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SystemApi - axios parameter creator
 * @export
 */
export const SystemApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Test Event
         * @summary Test Event
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemTestEvent: async (body: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('systemTestEvent', 'body', body)
            const localVarPath = `/api/v1/system/test-event`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SystemApi - functional programming interface
 * @export
 */
export const SystemApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SystemApiAxiosParamCreator(configuration)
    return {
        /**
         * Test Event
         * @summary Test Event
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async systemTestEvent(body: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SystemTestEventResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.systemTestEvent(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SystemApi - factory interface
 * @export
 */
export const SystemApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SystemApiFp(configuration)
    return {
        /**
         * Test Event
         * @summary Test Event
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemTestEvent(body: object, options?: any): AxiosPromise<SystemTestEventResponse> {
            return localVarFp.systemTestEvent(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SystemApi - object-oriented interface
 * @export
 * @class SystemApi
 * @extends {BaseAPI}
 */
export class SystemApi extends BaseAPI {
    /**
     * Test Event
     * @summary Test Event
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    public systemTestEvent(body: object, options?: AxiosRequestConfig) {
        return SystemApiFp(this.configuration).systemTestEvent(body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Will be used by user to get their profile detail
         * @summary Get User Profile
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetProfile: async (authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('userGetProfile', 'authorization', authorization)
            const localVarPath = `/api/v1/users/profiles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Will cover the summary related to referral, including referral code, SawitPoin received from referral, and count of referrals. The endpoint will retrieve the user ID from JWT claims
         * @summary Get Referral Summary
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetReferralSummary: async (aPPTYPE: AppTypeEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('userGetReferralSummary', 'aPPTYPE', aPPTYPE)
            const localVarPath = `/api/v1/users/referral/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Show list of referrals that has registered by using current user\'s referral code.  The filtering by user\'s name will be case-insensitive, and match the exact character of the user\'s name 
         * @summary Get Referral List
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {string} [name] Name of the user to be used as search filter.
         * @param {'REGISTERED' | 'MISSION_COMPLETED'} [status] Status of the referred user, Will return all referrals if not provided 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userReferralList: async (page?: number, limit?: number, name?: string, status?: 'REGISTERED' | 'MISSION_COMPLETED', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/referral`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validate referral code before saving it when hitting the PUT `/api/v1/auth` endpoint  This endpoint will check whether the referral code is exist in the `user` table or not 
         * @summary Validate Referral Code
         * @param {UserValidateReferralCodeRequest} userValidateReferralCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userValidateReferralCode: async (userValidateReferralCodeRequest: UserValidateReferralCodeRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userValidateReferralCodeRequest' is not null or undefined
            assertParamExists('userValidateReferralCode', 'userValidateReferralCodeRequest', userValidateReferralCodeRequest)
            const localVarPath = `/api/v1/users/referral/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userValidateReferralCodeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Will be used by users to update their firebase token
         * @summary Update Firebase Token
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {UsersUpdateFirebaseTokenRequest} [usersUpdateFirebaseTokenRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersUpdateFirebaseToken: async (authorization: string, usersUpdateFirebaseTokenRequest?: UsersUpdateFirebaseTokenRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('usersUpdateFirebaseToken', 'authorization', authorization)
            const localVarPath = `/api/v1/users/firebase-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(usersUpdateFirebaseTokenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration)
    return {
        /**
         * Will be used by user to get their profile detail
         * @summary Get User Profile
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userGetProfile(authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserGetProfileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userGetProfile(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Will cover the summary related to referral, including referral code, SawitPoin received from referral, and count of referrals. The endpoint will retrieve the user ID from JWT claims
         * @summary Get Referral Summary
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userGetReferralSummary(aPPTYPE: AppTypeEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserGetReferralSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userGetReferralSummary(aPPTYPE, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Show list of referrals that has registered by using current user\'s referral code.  The filtering by user\'s name will be case-insensitive, and match the exact character of the user\'s name 
         * @summary Get Referral List
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {string} [name] Name of the user to be used as search filter.
         * @param {'REGISTERED' | 'MISSION_COMPLETED'} [status] Status of the referred user, Will return all referrals if not provided 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userReferralList(page?: number, limit?: number, name?: string, status?: 'REGISTERED' | 'MISSION_COMPLETED', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserReferralListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userReferralList(page, limit, name, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Validate referral code before saving it when hitting the PUT `/api/v1/auth` endpoint  This endpoint will check whether the referral code is exist in the `user` table or not 
         * @summary Validate Referral Code
         * @param {UserValidateReferralCodeRequest} userValidateReferralCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userValidateReferralCode(userValidateReferralCodeRequest: UserValidateReferralCodeRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserValidateReferralCodeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userValidateReferralCode(userValidateReferralCodeRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Will be used by users to update their firebase token
         * @summary Update Firebase Token
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {UsersUpdateFirebaseTokenRequest} [usersUpdateFirebaseTokenRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersUpdateFirebaseToken(authorization: string, usersUpdateFirebaseTokenRequest?: UsersUpdateFirebaseTokenRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UsersUpdateFirebaseTokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersUpdateFirebaseToken(authorization, usersUpdateFirebaseTokenRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsersApiFp(configuration)
    return {
        /**
         * Will be used by user to get their profile detail
         * @summary Get User Profile
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetProfile(authorization: string, options?: any): AxiosPromise<UserGetProfileResponse> {
            return localVarFp.userGetProfile(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Will cover the summary related to referral, including referral code, SawitPoin received from referral, and count of referrals. The endpoint will retrieve the user ID from JWT claims
         * @summary Get Referral Summary
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetReferralSummary(aPPTYPE: AppTypeEnum, options?: any): AxiosPromise<UserGetReferralSummaryResponse> {
            return localVarFp.userGetReferralSummary(aPPTYPE, options).then((request) => request(axios, basePath));
        },
        /**
         * Show list of referrals that has registered by using current user\'s referral code.  The filtering by user\'s name will be case-insensitive, and match the exact character of the user\'s name 
         * @summary Get Referral List
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {string} [name] Name of the user to be used as search filter.
         * @param {'REGISTERED' | 'MISSION_COMPLETED'} [status] Status of the referred user, Will return all referrals if not provided 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userReferralList(page?: number, limit?: number, name?: string, status?: 'REGISTERED' | 'MISSION_COMPLETED', options?: any): AxiosPromise<UserReferralListResponse> {
            return localVarFp.userReferralList(page, limit, name, status, options).then((request) => request(axios, basePath));
        },
        /**
         * Validate referral code before saving it when hitting the PUT `/api/v1/auth` endpoint  This endpoint will check whether the referral code is exist in the `user` table or not 
         * @summary Validate Referral Code
         * @param {UserValidateReferralCodeRequest} userValidateReferralCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userValidateReferralCode(userValidateReferralCodeRequest: UserValidateReferralCodeRequest, options?: any): AxiosPromise<UserValidateReferralCodeResponse> {
            return localVarFp.userValidateReferralCode(userValidateReferralCodeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Will be used by users to update their firebase token
         * @summary Update Firebase Token
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {UsersUpdateFirebaseTokenRequest} [usersUpdateFirebaseTokenRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersUpdateFirebaseToken(authorization: string, usersUpdateFirebaseTokenRequest?: UsersUpdateFirebaseTokenRequest, options?: any): AxiosPromise<UsersUpdateFirebaseTokenResponse> {
            return localVarFp.usersUpdateFirebaseToken(authorization, usersUpdateFirebaseTokenRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
    /**
     * Will be used by user to get their profile detail
     * @summary Get User Profile
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public userGetProfile(authorization: string, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).userGetProfile(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Will cover the summary related to referral, including referral code, SawitPoin received from referral, and count of referrals. The endpoint will retrieve the user ID from JWT claims
     * @summary Get Referral Summary
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public userGetReferralSummary(aPPTYPE: AppTypeEnum, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).userGetReferralSummary(aPPTYPE, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Show list of referrals that has registered by using current user\'s referral code.  The filtering by user\'s name will be case-insensitive, and match the exact character of the user\'s name 
     * @summary Get Referral List
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {string} [name] Name of the user to be used as search filter.
     * @param {'REGISTERED' | 'MISSION_COMPLETED'} [status] Status of the referred user, Will return all referrals if not provided 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public userReferralList(page?: number, limit?: number, name?: string, status?: 'REGISTERED' | 'MISSION_COMPLETED', options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).userReferralList(page, limit, name, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Validate referral code before saving it when hitting the PUT `/api/v1/auth` endpoint  This endpoint will check whether the referral code is exist in the `user` table or not 
     * @summary Validate Referral Code
     * @param {UserValidateReferralCodeRequest} userValidateReferralCodeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public userValidateReferralCode(userValidateReferralCodeRequest: UserValidateReferralCodeRequest, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).userValidateReferralCode(userValidateReferralCodeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Will be used by users to update their firebase token
     * @summary Update Firebase Token
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {UsersUpdateFirebaseTokenRequest} [usersUpdateFirebaseTokenRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersUpdateFirebaseToken(authorization: string, usersUpdateFirebaseTokenRequest?: UsersUpdateFirebaseTokenRequest, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersUpdateFirebaseToken(authorization, usersUpdateFirebaseTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * VersionsApi - axios parameter creator
 * @export
 */
export const VersionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get current active app version in Play Store for either Member or Worker App. We need this to check if the user\'s app is outdated or need force update. 
         * @summary Get current active app version.
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {number} [vERSIONCODE] Version code of the app that\&#39;s accessing the endpoint.
         * @param {string} [vERSIONNAME] The complete version of the app that\&#39;s accessing the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appVersionCheck: async (aPPTYPE: AppTypeEnum, vERSIONCODE?: number, vERSIONNAME?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPPTYPE' is not null or undefined
            assertParamExists('appVersionCheck', 'aPPTYPE', aPPTYPE)
            const localVarPath = `/api/v1/app/version/check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (aPPTYPE != null) {
                localVarHeaderParameter['APP-TYPE'] = typeof aPPTYPE === 'string' 
                    ? aPPTYPE 
                    : JSON.stringify(aPPTYPE);
            }

            if (vERSIONCODE != null) {
                localVarHeaderParameter['VERSION-CODE'] = typeof vERSIONCODE === 'string' 
                    ? vERSIONCODE 
                    : JSON.stringify(vERSIONCODE);
            }

            if (vERSIONNAME != null) {
                localVarHeaderParameter['VERSION-NAME'] = String(vERSIONNAME);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VersionsApi - functional programming interface
 * @export
 */
export const VersionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VersionsApiAxiosParamCreator(configuration)
    return {
        /**
         * Get current active app version in Play Store for either Member or Worker App. We need this to check if the user\'s app is outdated or need force update. 
         * @summary Get current active app version.
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {number} [vERSIONCODE] Version code of the app that\&#39;s accessing the endpoint.
         * @param {string} [vERSIONNAME] The complete version of the app that\&#39;s accessing the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appVersionCheck(aPPTYPE: AppTypeEnum, vERSIONCODE?: number, vERSIONNAME?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppVersionCheckResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appVersionCheck(aPPTYPE, vERSIONCODE, vERSIONNAME, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * VersionsApi - factory interface
 * @export
 */
export const VersionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VersionsApiFp(configuration)
    return {
        /**
         * Get current active app version in Play Store for either Member or Worker App. We need this to check if the user\'s app is outdated or need force update. 
         * @summary Get current active app version.
         * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
         * @param {number} [vERSIONCODE] Version code of the app that\&#39;s accessing the endpoint.
         * @param {string} [vERSIONNAME] The complete version of the app that\&#39;s accessing the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appVersionCheck(aPPTYPE: AppTypeEnum, vERSIONCODE?: number, vERSIONNAME?: string, options?: any): AxiosPromise<AppVersionCheckResponse> {
            return localVarFp.appVersionCheck(aPPTYPE, vERSIONCODE, vERSIONNAME, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VersionsApi - object-oriented interface
 * @export
 * @class VersionsApi
 * @extends {BaseAPI}
 */
export class VersionsApi extends BaseAPI {
    /**
     * Get current active app version in Play Store for either Member or Worker App. We need this to check if the user\'s app is outdated or need force update. 
     * @summary Get current active app version.
     * @param {AppTypeEnum} aPPTYPE The name of the app that\&#39;s accessing the endpoint.
     * @param {number} [vERSIONCODE] Version code of the app that\&#39;s accessing the endpoint.
     * @param {string} [vERSIONNAME] The complete version of the app that\&#39;s accessing the endpoint.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VersionsApi
     */
    public appVersionCheck(aPPTYPE: AppTypeEnum, vERSIONCODE?: number, vERSIONNAME?: string, options?: AxiosRequestConfig) {
        return VersionsApiFp(this.configuration).appVersionCheck(aPPTYPE, vERSIONCODE, vERSIONNAME, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WebhooksApi - axios parameter creator
 * @export
 */
export const WebhooksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Used by system to receive payment notification from doku
         * @summary receive doku payment notifications
         * @param {string} clientId Client ID retrieved from DOKU Back Office.
         * @param {string} requestId Unique random string (max 128 characters) generated from merchant side to protect duplicate request.
         * @param {string} requestTimestamp Timestamp request on UTC time in ISO8601 UTC+0 format.
         * @param {string} signature Security parameter that needs to be generated on merchant Backend and placed to the header request to ensure that the request is coming from valid merchant.
         * @param {WebhooksDokuReceivePaymentNotificationRequest} webhooksDokuReceivePaymentNotificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhooksDokuReceivePaymentNotification: async (clientId: string, requestId: string, requestTimestamp: string, signature: string, webhooksDokuReceivePaymentNotificationRequest: WebhooksDokuReceivePaymentNotificationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('webhooksDokuReceivePaymentNotification', 'clientId', clientId)
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('webhooksDokuReceivePaymentNotification', 'requestId', requestId)
            // verify required parameter 'requestTimestamp' is not null or undefined
            assertParamExists('webhooksDokuReceivePaymentNotification', 'requestTimestamp', requestTimestamp)
            // verify required parameter 'signature' is not null or undefined
            assertParamExists('webhooksDokuReceivePaymentNotification', 'signature', signature)
            // verify required parameter 'webhooksDokuReceivePaymentNotificationRequest' is not null or undefined
            assertParamExists('webhooksDokuReceivePaymentNotification', 'webhooksDokuReceivePaymentNotificationRequest', webhooksDokuReceivePaymentNotificationRequest)
            const localVarPath = `/webhooks/doku/receive-payment-notification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (clientId != null) {
                localVarHeaderParameter['Client-Id'] = String(clientId);
            }

            if (requestId != null) {
                localVarHeaderParameter['Request-Id'] = String(requestId);
            }

            if (requestTimestamp != null) {
                localVarHeaderParameter['Request-Timestamp'] = String(requestTimestamp);
            }

            if (signature != null) {
                localVarHeaderParameter['Signature'] = String(signature);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(webhooksDokuReceivePaymentNotificationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Used by system to receive notification from ivowaba
         * @summary receive ivowaba notification
         * @param {WebhooksIvowabaReceiveNotificationRequest} webhooksIvowabaReceiveNotificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhooksIvowabaReceiveNotification: async (webhooksIvowabaReceiveNotificationRequest: WebhooksIvowabaReceiveNotificationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'webhooksIvowabaReceiveNotificationRequest' is not null or undefined
            assertParamExists('webhooksIvowabaReceiveNotification', 'webhooksIvowabaReceiveNotificationRequest', webhooksIvowabaReceiveNotificationRequest)
            const localVarPath = `/webhooks/ivowaba/receive-notification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(webhooksIvowabaReceiveNotificationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Used by system to receive sms delivery report from jatis
         * @summary receive jatis sms delivery report
         * @param {string} messageId messageId retrieved from Jatis SMS Delivery Report Callback. messageId is the one received when successfully submit SMS.
         * @param {string} deliverystatus deliverystatus retrieved from Jatis SMS Delivery Report Callback. deliverystatus is specified on Jatis delivery status code.
         * @param {string} datereceived datereceived retrieved from Jatis SMS Delivery Report Callback.
         * @param {string} description description retrieved from Jatis SMS Delivery Report Callback.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhooksJatisGetSmsDeliveryReport: async (messageId: string, deliverystatus: string, datereceived: string, description: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('webhooksJatisGetSmsDeliveryReport', 'messageId', messageId)
            // verify required parameter 'deliverystatus' is not null or undefined
            assertParamExists('webhooksJatisGetSmsDeliveryReport', 'deliverystatus', deliverystatus)
            // verify required parameter 'datereceived' is not null or undefined
            assertParamExists('webhooksJatisGetSmsDeliveryReport', 'datereceived', datereceived)
            // verify required parameter 'description' is not null or undefined
            assertParamExists('webhooksJatisGetSmsDeliveryReport', 'description', description)
            const localVarPath = `/webhooks/jatis/receive-sms-delivery-report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (messageId !== undefined) {
                localVarQueryParameter['messageId'] = messageId;
            }

            if (deliverystatus !== undefined) {
                localVarQueryParameter['deliverystatus'] = deliverystatus;
            }

            if (datereceived !== undefined) {
                localVarQueryParameter['datereceived'] = datereceived;
            }

            if (description !== undefined) {
                localVarQueryParameter['description'] = description;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WebhooksApi - functional programming interface
 * @export
 */
export const WebhooksApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WebhooksApiAxiosParamCreator(configuration)
    return {
        /**
         * Used by system to receive payment notification from doku
         * @summary receive doku payment notifications
         * @param {string} clientId Client ID retrieved from DOKU Back Office.
         * @param {string} requestId Unique random string (max 128 characters) generated from merchant side to protect duplicate request.
         * @param {string} requestTimestamp Timestamp request on UTC time in ISO8601 UTC+0 format.
         * @param {string} signature Security parameter that needs to be generated on merchant Backend and placed to the header request to ensure that the request is coming from valid merchant.
         * @param {WebhooksDokuReceivePaymentNotificationRequest} webhooksDokuReceivePaymentNotificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webhooksDokuReceivePaymentNotification(clientId: string, requestId: string, requestTimestamp: string, signature: string, webhooksDokuReceivePaymentNotificationRequest: WebhooksDokuReceivePaymentNotificationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webhooksDokuReceivePaymentNotification(clientId, requestId, requestTimestamp, signature, webhooksDokuReceivePaymentNotificationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Used by system to receive notification from ivowaba
         * @summary receive ivowaba notification
         * @param {WebhooksIvowabaReceiveNotificationRequest} webhooksIvowabaReceiveNotificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webhooksIvowabaReceiveNotification(webhooksIvowabaReceiveNotificationRequest: WebhooksIvowabaReceiveNotificationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webhooksIvowabaReceiveNotification(webhooksIvowabaReceiveNotificationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Used by system to receive sms delivery report from jatis
         * @summary receive jatis sms delivery report
         * @param {string} messageId messageId retrieved from Jatis SMS Delivery Report Callback. messageId is the one received when successfully submit SMS.
         * @param {string} deliverystatus deliverystatus retrieved from Jatis SMS Delivery Report Callback. deliverystatus is specified on Jatis delivery status code.
         * @param {string} datereceived datereceived retrieved from Jatis SMS Delivery Report Callback.
         * @param {string} description description retrieved from Jatis SMS Delivery Report Callback.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webhooksJatisGetSmsDeliveryReport(messageId: string, deliverystatus: string, datereceived: string, description: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webhooksJatisGetSmsDeliveryReport(messageId, deliverystatus, datereceived, description, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WebhooksApi - factory interface
 * @export
 */
export const WebhooksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WebhooksApiFp(configuration)
    return {
        /**
         * Used by system to receive payment notification from doku
         * @summary receive doku payment notifications
         * @param {string} clientId Client ID retrieved from DOKU Back Office.
         * @param {string} requestId Unique random string (max 128 characters) generated from merchant side to protect duplicate request.
         * @param {string} requestTimestamp Timestamp request on UTC time in ISO8601 UTC+0 format.
         * @param {string} signature Security parameter that needs to be generated on merchant Backend and placed to the header request to ensure that the request is coming from valid merchant.
         * @param {WebhooksDokuReceivePaymentNotificationRequest} webhooksDokuReceivePaymentNotificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhooksDokuReceivePaymentNotification(clientId: string, requestId: string, requestTimestamp: string, signature: string, webhooksDokuReceivePaymentNotificationRequest: WebhooksDokuReceivePaymentNotificationRequest, options?: any): AxiosPromise<void> {
            return localVarFp.webhooksDokuReceivePaymentNotification(clientId, requestId, requestTimestamp, signature, webhooksDokuReceivePaymentNotificationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Used by system to receive notification from ivowaba
         * @summary receive ivowaba notification
         * @param {WebhooksIvowabaReceiveNotificationRequest} webhooksIvowabaReceiveNotificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhooksIvowabaReceiveNotification(webhooksIvowabaReceiveNotificationRequest: WebhooksIvowabaReceiveNotificationRequest, options?: any): AxiosPromise<void> {
            return localVarFp.webhooksIvowabaReceiveNotification(webhooksIvowabaReceiveNotificationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Used by system to receive sms delivery report from jatis
         * @summary receive jatis sms delivery report
         * @param {string} messageId messageId retrieved from Jatis SMS Delivery Report Callback. messageId is the one received when successfully submit SMS.
         * @param {string} deliverystatus deliverystatus retrieved from Jatis SMS Delivery Report Callback. deliverystatus is specified on Jatis delivery status code.
         * @param {string} datereceived datereceived retrieved from Jatis SMS Delivery Report Callback.
         * @param {string} description description retrieved from Jatis SMS Delivery Report Callback.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhooksJatisGetSmsDeliveryReport(messageId: string, deliverystatus: string, datereceived: string, description: string, options?: any): AxiosPromise<void> {
            return localVarFp.webhooksJatisGetSmsDeliveryReport(messageId, deliverystatus, datereceived, description, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WebhooksApi - object-oriented interface
 * @export
 * @class WebhooksApi
 * @extends {BaseAPI}
 */
export class WebhooksApi extends BaseAPI {
    /**
     * Used by system to receive payment notification from doku
     * @summary receive doku payment notifications
     * @param {string} clientId Client ID retrieved from DOKU Back Office.
     * @param {string} requestId Unique random string (max 128 characters) generated from merchant side to protect duplicate request.
     * @param {string} requestTimestamp Timestamp request on UTC time in ISO8601 UTC+0 format.
     * @param {string} signature Security parameter that needs to be generated on merchant Backend and placed to the header request to ensure that the request is coming from valid merchant.
     * @param {WebhooksDokuReceivePaymentNotificationRequest} webhooksDokuReceivePaymentNotificationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhooksApi
     */
    public webhooksDokuReceivePaymentNotification(clientId: string, requestId: string, requestTimestamp: string, signature: string, webhooksDokuReceivePaymentNotificationRequest: WebhooksDokuReceivePaymentNotificationRequest, options?: AxiosRequestConfig) {
        return WebhooksApiFp(this.configuration).webhooksDokuReceivePaymentNotification(clientId, requestId, requestTimestamp, signature, webhooksDokuReceivePaymentNotificationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Used by system to receive notification from ivowaba
     * @summary receive ivowaba notification
     * @param {WebhooksIvowabaReceiveNotificationRequest} webhooksIvowabaReceiveNotificationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhooksApi
     */
    public webhooksIvowabaReceiveNotification(webhooksIvowabaReceiveNotificationRequest: WebhooksIvowabaReceiveNotificationRequest, options?: AxiosRequestConfig) {
        return WebhooksApiFp(this.configuration).webhooksIvowabaReceiveNotification(webhooksIvowabaReceiveNotificationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Used by system to receive sms delivery report from jatis
     * @summary receive jatis sms delivery report
     * @param {string} messageId messageId retrieved from Jatis SMS Delivery Report Callback. messageId is the one received when successfully submit SMS.
     * @param {string} deliverystatus deliverystatus retrieved from Jatis SMS Delivery Report Callback. deliverystatus is specified on Jatis delivery status code.
     * @param {string} datereceived datereceived retrieved from Jatis SMS Delivery Report Callback.
     * @param {string} description description retrieved from Jatis SMS Delivery Report Callback.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhooksApi
     */
    public webhooksJatisGetSmsDeliveryReport(messageId: string, deliverystatus: string, datereceived: string, description: string, options?: AxiosRequestConfig) {
        return WebhooksApiFp(this.configuration).webhooksJatisGetSmsDeliveryReport(messageId, deliverystatus, datereceived, description, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WeighbridgeuploadApi - axios parameter creator
 * @export
 */
export const WeighbridgeuploadApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Bulk submit weighbridgeupload
         * @summary Bulk submit weighbridgeupload
         * @param {WeighbridgeUploadBulkSubmitRequest} weighbridgeUploadBulkSubmitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        weighbridgeUploadBulkSubmit: async (weighbridgeUploadBulkSubmitRequest: WeighbridgeUploadBulkSubmitRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'weighbridgeUploadBulkSubmitRequest' is not null or undefined
            assertParamExists('weighbridgeUploadBulkSubmit', 'weighbridgeUploadBulkSubmitRequest', weighbridgeUploadBulkSubmitRequest)
            const localVarPath = `/api/v1/weighbridgeupload/bulk-submit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(weighbridgeUploadBulkSubmitRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Submit weighbridge upload picture and get presigned url
         * @summary Submit weighbridge upload picture
         * @param {WeighbridgeUploadCreateRequest} weighbridgeUploadCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        weighbridgeUploadCreate: async (weighbridgeUploadCreateRequest: WeighbridgeUploadCreateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'weighbridgeUploadCreateRequest' is not null or undefined
            assertParamExists('weighbridgeUploadCreate', 'weighbridgeUploadCreateRequest', weighbridgeUploadCreateRequest)
            const localVarPath = `/api/v1/weighbridgeupload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(weighbridgeUploadCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get weighbridge upload detail.
         * @summary Get Weighbridge Upload Detail
         * @param {string} weighbridgeUploadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        weighbridgeUploadDetail: async (weighbridgeUploadId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'weighbridgeUploadId' is not null or undefined
            assertParamExists('weighbridgeUploadDetail', 'weighbridgeUploadId', weighbridgeUploadId)
            const localVarPath = `/api/v1/weighbridgeupload/{weighbridgeUploadId}`
                .replace(`{${"weighbridgeUploadId"}}`, encodeURIComponent(String(weighbridgeUploadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get weighbridge upload extracted field from uploaded picture.
         * @summary Get Weighbridge Upload Extracted Field from Uploaded Picture
         * @param {string} weighbridgeUploadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        weighbridgeUploadExtract: async (weighbridgeUploadId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'weighbridgeUploadId' is not null or undefined
            assertParamExists('weighbridgeUploadExtract', 'weighbridgeUploadId', weighbridgeUploadId)
            const localVarPath = `/api/v1/weighbridgeupload/{weighbridgeUploadId}/extract`
                .replace(`{${"weighbridgeUploadId"}}`, encodeURIComponent(String(weighbridgeUploadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List of weighbridge uploaded
         * @summary List Weighbridge Uploaded
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        weighbridgeUploadList: async (page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/weighbridgeupload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get weighbridge upload detail picture asset (presigned url).
         * @summary Get Weighbridge Upload Picture
         * @param {string} weighbridgeUploadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        weighbridgeUploadPicture: async (weighbridgeUploadId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'weighbridgeUploadId' is not null or undefined
            assertParamExists('weighbridgeUploadPicture', 'weighbridgeUploadId', weighbridgeUploadId)
            const localVarPath = `/api/v1/weighbridgeupload/{weighbridgeUploadId}/picture`
                .replace(`{${"weighbridgeUploadId"}}`, encodeURIComponent(String(weighbridgeUploadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update weighbridge upload
         * @summary Update weighbridge upload
         * @param {string} weighbridgeUploadId 
         * @param {WeighbridgeUploadUpdateRequest} weighbridgeUploadUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        weighbridgeUploadUpdate: async (weighbridgeUploadId: string, weighbridgeUploadUpdateRequest: WeighbridgeUploadUpdateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'weighbridgeUploadId' is not null or undefined
            assertParamExists('weighbridgeUploadUpdate', 'weighbridgeUploadId', weighbridgeUploadId)
            // verify required parameter 'weighbridgeUploadUpdateRequest' is not null or undefined
            assertParamExists('weighbridgeUploadUpdate', 'weighbridgeUploadUpdateRequest', weighbridgeUploadUpdateRequest)
            const localVarPath = `/api/v1/weighbridgeupload/{weighbridgeUploadId}`
                .replace(`{${"weighbridgeUploadId"}}`, encodeURIComponent(String(weighbridgeUploadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(weighbridgeUploadUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WeighbridgeuploadApi - functional programming interface
 * @export
 */
export const WeighbridgeuploadApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WeighbridgeuploadApiAxiosParamCreator(configuration)
    return {
        /**
         * Bulk submit weighbridgeupload
         * @summary Bulk submit weighbridgeupload
         * @param {WeighbridgeUploadBulkSubmitRequest} weighbridgeUploadBulkSubmitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async weighbridgeUploadBulkSubmit(weighbridgeUploadBulkSubmitRequest: WeighbridgeUploadBulkSubmitRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WeighbridgeUploadBulkSubmitResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.weighbridgeUploadBulkSubmit(weighbridgeUploadBulkSubmitRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Submit weighbridge upload picture and get presigned url
         * @summary Submit weighbridge upload picture
         * @param {WeighbridgeUploadCreateRequest} weighbridgeUploadCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async weighbridgeUploadCreate(weighbridgeUploadCreateRequest: WeighbridgeUploadCreateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WeighbridgeUploadCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.weighbridgeUploadCreate(weighbridgeUploadCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get weighbridge upload detail.
         * @summary Get Weighbridge Upload Detail
         * @param {string} weighbridgeUploadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async weighbridgeUploadDetail(weighbridgeUploadId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WeighbridgeUploadDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.weighbridgeUploadDetail(weighbridgeUploadId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get weighbridge upload extracted field from uploaded picture.
         * @summary Get Weighbridge Upload Extracted Field from Uploaded Picture
         * @param {string} weighbridgeUploadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async weighbridgeUploadExtract(weighbridgeUploadId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WeighbridgeUploadExtractResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.weighbridgeUploadExtract(weighbridgeUploadId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * List of weighbridge uploaded
         * @summary List Weighbridge Uploaded
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async weighbridgeUploadList(page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WeighbridgeUploadListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.weighbridgeUploadList(page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get weighbridge upload detail picture asset (presigned url).
         * @summary Get Weighbridge Upload Picture
         * @param {string} weighbridgeUploadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async weighbridgeUploadPicture(weighbridgeUploadId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WeighbridgeUploadPictureResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.weighbridgeUploadPicture(weighbridgeUploadId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update weighbridge upload
         * @summary Update weighbridge upload
         * @param {string} weighbridgeUploadId 
         * @param {WeighbridgeUploadUpdateRequest} weighbridgeUploadUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async weighbridgeUploadUpdate(weighbridgeUploadId: string, weighbridgeUploadUpdateRequest: WeighbridgeUploadUpdateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WeighbridgeUploadUpdateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.weighbridgeUploadUpdate(weighbridgeUploadId, weighbridgeUploadUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WeighbridgeuploadApi - factory interface
 * @export
 */
export const WeighbridgeuploadApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WeighbridgeuploadApiFp(configuration)
    return {
        /**
         * Bulk submit weighbridgeupload
         * @summary Bulk submit weighbridgeupload
         * @param {WeighbridgeUploadBulkSubmitRequest} weighbridgeUploadBulkSubmitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        weighbridgeUploadBulkSubmit(weighbridgeUploadBulkSubmitRequest: WeighbridgeUploadBulkSubmitRequest, options?: any): AxiosPromise<WeighbridgeUploadBulkSubmitResponse> {
            return localVarFp.weighbridgeUploadBulkSubmit(weighbridgeUploadBulkSubmitRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Submit weighbridge upload picture and get presigned url
         * @summary Submit weighbridge upload picture
         * @param {WeighbridgeUploadCreateRequest} weighbridgeUploadCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        weighbridgeUploadCreate(weighbridgeUploadCreateRequest: WeighbridgeUploadCreateRequest, options?: any): AxiosPromise<WeighbridgeUploadCreateResponse> {
            return localVarFp.weighbridgeUploadCreate(weighbridgeUploadCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get weighbridge upload detail.
         * @summary Get Weighbridge Upload Detail
         * @param {string} weighbridgeUploadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        weighbridgeUploadDetail(weighbridgeUploadId: string, options?: any): AxiosPromise<WeighbridgeUploadDetailResponse> {
            return localVarFp.weighbridgeUploadDetail(weighbridgeUploadId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get weighbridge upload extracted field from uploaded picture.
         * @summary Get Weighbridge Upload Extracted Field from Uploaded Picture
         * @param {string} weighbridgeUploadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        weighbridgeUploadExtract(weighbridgeUploadId: string, options?: any): AxiosPromise<WeighbridgeUploadExtractResponse> {
            return localVarFp.weighbridgeUploadExtract(weighbridgeUploadId, options).then((request) => request(axios, basePath));
        },
        /**
         * List of weighbridge uploaded
         * @summary List Weighbridge Uploaded
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        weighbridgeUploadList(page?: number, limit?: number, options?: any): AxiosPromise<WeighbridgeUploadListResponse> {
            return localVarFp.weighbridgeUploadList(page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Get weighbridge upload detail picture asset (presigned url).
         * @summary Get Weighbridge Upload Picture
         * @param {string} weighbridgeUploadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        weighbridgeUploadPicture(weighbridgeUploadId: string, options?: any): AxiosPromise<WeighbridgeUploadPictureResponse> {
            return localVarFp.weighbridgeUploadPicture(weighbridgeUploadId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update weighbridge upload
         * @summary Update weighbridge upload
         * @param {string} weighbridgeUploadId 
         * @param {WeighbridgeUploadUpdateRequest} weighbridgeUploadUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        weighbridgeUploadUpdate(weighbridgeUploadId: string, weighbridgeUploadUpdateRequest: WeighbridgeUploadUpdateRequest, options?: any): AxiosPromise<WeighbridgeUploadUpdateResponse> {
            return localVarFp.weighbridgeUploadUpdate(weighbridgeUploadId, weighbridgeUploadUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WeighbridgeuploadApi - object-oriented interface
 * @export
 * @class WeighbridgeuploadApi
 * @extends {BaseAPI}
 */
export class WeighbridgeuploadApi extends BaseAPI {
    /**
     * Bulk submit weighbridgeupload
     * @summary Bulk submit weighbridgeupload
     * @param {WeighbridgeUploadBulkSubmitRequest} weighbridgeUploadBulkSubmitRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WeighbridgeuploadApi
     */
    public weighbridgeUploadBulkSubmit(weighbridgeUploadBulkSubmitRequest: WeighbridgeUploadBulkSubmitRequest, options?: AxiosRequestConfig) {
        return WeighbridgeuploadApiFp(this.configuration).weighbridgeUploadBulkSubmit(weighbridgeUploadBulkSubmitRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Submit weighbridge upload picture and get presigned url
     * @summary Submit weighbridge upload picture
     * @param {WeighbridgeUploadCreateRequest} weighbridgeUploadCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WeighbridgeuploadApi
     */
    public weighbridgeUploadCreate(weighbridgeUploadCreateRequest: WeighbridgeUploadCreateRequest, options?: AxiosRequestConfig) {
        return WeighbridgeuploadApiFp(this.configuration).weighbridgeUploadCreate(weighbridgeUploadCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get weighbridge upload detail.
     * @summary Get Weighbridge Upload Detail
     * @param {string} weighbridgeUploadId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WeighbridgeuploadApi
     */
    public weighbridgeUploadDetail(weighbridgeUploadId: string, options?: AxiosRequestConfig) {
        return WeighbridgeuploadApiFp(this.configuration).weighbridgeUploadDetail(weighbridgeUploadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get weighbridge upload extracted field from uploaded picture.
     * @summary Get Weighbridge Upload Extracted Field from Uploaded Picture
     * @param {string} weighbridgeUploadId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WeighbridgeuploadApi
     */
    public weighbridgeUploadExtract(weighbridgeUploadId: string, options?: AxiosRequestConfig) {
        return WeighbridgeuploadApiFp(this.configuration).weighbridgeUploadExtract(weighbridgeUploadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List of weighbridge uploaded
     * @summary List Weighbridge Uploaded
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WeighbridgeuploadApi
     */
    public weighbridgeUploadList(page?: number, limit?: number, options?: AxiosRequestConfig) {
        return WeighbridgeuploadApiFp(this.configuration).weighbridgeUploadList(page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get weighbridge upload detail picture asset (presigned url).
     * @summary Get Weighbridge Upload Picture
     * @param {string} weighbridgeUploadId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WeighbridgeuploadApi
     */
    public weighbridgeUploadPicture(weighbridgeUploadId: string, options?: AxiosRequestConfig) {
        return WeighbridgeuploadApiFp(this.configuration).weighbridgeUploadPicture(weighbridgeUploadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update weighbridge upload
     * @summary Update weighbridge upload
     * @param {string} weighbridgeUploadId 
     * @param {WeighbridgeUploadUpdateRequest} weighbridgeUploadUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WeighbridgeuploadApi
     */
    public weighbridgeUploadUpdate(weighbridgeUploadId: string, weighbridgeUploadUpdateRequest: WeighbridgeUploadUpdateRequest, options?: AxiosRequestConfig) {
        return WeighbridgeuploadApiFp(this.configuration).weighbridgeUploadUpdate(weighbridgeUploadId, weighbridgeUploadUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WorkersApi - axios parameter creator
 * @export
 */
export const WorkersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This endpoint is meant to be used to get activity list of worker by Worker ID, for example, submitting weighbridge slip, etc. 
         * @summary Get worker activity list v1 by User ID
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        activitiesList: async (authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('activitiesList', 'authorization', authorization)
            const localVarPath = `/api/v1/activities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint is meant to be used to get activity list of worker by Worker ID, for example, submitting weighbridge slip, etc. 
         * @summary Get worker activity list v2 by User ID
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activitiesListV2: async (authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('activitiesListV2', 'authorization', authorization)
            const localVarPath = `/api/v2/activities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get weighbridge detail.
         * @summary Get Weighbridge detail
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} weighbridgeTicketId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        weighbridgeDetail: async (authorization: string, weighbridgeTicketId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('weighbridgeDetail', 'authorization', authorization)
            // verify required parameter 'weighbridgeTicketId' is not null or undefined
            assertParamExists('weighbridgeDetail', 'weighbridgeTicketId', weighbridgeTicketId)
            const localVarPath = `/api/v1/workers/weighbridge/{weighbridgeTicketId}`
                .replace(`{${"weighbridgeTicketId"}}`, encodeURIComponent(String(weighbridgeTicketId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint is used by daily limitation checking of Driver Activity feature. To block their activity if they already submit 2 Activities (input weighbridge data) for each day. 
         * @summary Check Limit of driver activities (scan (qr code) and input data weighbridge)
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workerActivitiesGetLimitation: async (authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('workerActivitiesGetLimitation', 'authorization', authorization)
            const localVarPath = `/api/v1/workers/activities/limits`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create worker activity accessed from wb scan QR
         * @summary Create worker activity
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {WorkerCreateActivitiesRequest} [workerCreateActivitiesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workerCreateActivities: async (authorization: string, workerCreateActivitiesRequest?: WorkerCreateActivitiesRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('workerCreateActivities', 'authorization', authorization)
            const localVarPath = `/api/v1/workers/activities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workerCreateActivitiesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create worker activity accessed from wb scan QR V2 including user location (lat and long)
         * @summary Create worker activity V2
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {WorkerCreateActivitiesRequestV2} [workerCreateActivitiesRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workerCreateActivitiesV2: async (authorization: string, workerCreateActivitiesRequestV2?: WorkerCreateActivitiesRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('workerCreateActivitiesV2', 'authorization', authorization)
            const localVarPath = `/api/v2/workers/activities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workerCreateActivitiesRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create worker activity accessed from wb scan QR V3 with user latitude and longitude location (new on v2) with returned ffb image (new on v3) 
         * @summary Create worker activity V3
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} ticketNumber 
         * @param {CollectorTypeEnum} collectorType 
         * @param {string} collectorName 
         * @param {number} returnedQuantity Count of pulangan (janjang)
         * @param {number} weightAverageBunchKg Average of sawit weight (Komidel)
         * @param {number} latitude Worker current latitude
         * @param {number} longitude Worker current longitude
         * @param {File} returnedFfbPhoto Photo of returned fresh fruit bunches
         * @param {WorkerCreateActivitiesFeebackRequest} feedbacks 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workerCreateActivitiesV3: async (authorization: string, ticketNumber: string, collectorType: CollectorTypeEnum, collectorName: string, returnedQuantity: number, weightAverageBunchKg: number, latitude: number, longitude: number, returnedFfbPhoto: File, feedbacks: WorkerCreateActivitiesFeebackRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('workerCreateActivitiesV3', 'authorization', authorization)
            // verify required parameter 'ticketNumber' is not null or undefined
            assertParamExists('workerCreateActivitiesV3', 'ticketNumber', ticketNumber)
            // verify required parameter 'collectorType' is not null or undefined
            assertParamExists('workerCreateActivitiesV3', 'collectorType', collectorType)
            // verify required parameter 'collectorName' is not null or undefined
            assertParamExists('workerCreateActivitiesV3', 'collectorName', collectorName)
            // verify required parameter 'returnedQuantity' is not null or undefined
            assertParamExists('workerCreateActivitiesV3', 'returnedQuantity', returnedQuantity)
            // verify required parameter 'weightAverageBunchKg' is not null or undefined
            assertParamExists('workerCreateActivitiesV3', 'weightAverageBunchKg', weightAverageBunchKg)
            // verify required parameter 'latitude' is not null or undefined
            assertParamExists('workerCreateActivitiesV3', 'latitude', latitude)
            // verify required parameter 'longitude' is not null or undefined
            assertParamExists('workerCreateActivitiesV3', 'longitude', longitude)
            // verify required parameter 'returnedFfbPhoto' is not null or undefined
            assertParamExists('workerCreateActivitiesV3', 'returnedFfbPhoto', returnedFfbPhoto)
            // verify required parameter 'feedbacks' is not null or undefined
            assertParamExists('workerCreateActivitiesV3', 'feedbacks', feedbacks)
            const localVarPath = `/api/v3/workers/activities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


            if (ticketNumber !== undefined) { 
                localVarFormParams.append('ticketNumber', ticketNumber as any);
            }
    
            if (collectorType !== undefined) { 
                localVarFormParams.append('collectorType', collectorType as any);
            }
    
            if (collectorName !== undefined) { 
                localVarFormParams.append('collectorName', collectorName as any);
            }
    
            if (returnedQuantity !== undefined) { 
                localVarFormParams.append('returnedQuantity', returnedQuantity as any);
            }
    
            if (weightAverageBunchKg !== undefined) { 
                localVarFormParams.append('weightAverageBunchKg', weightAverageBunchKg as any);
            }
    
            if (latitude !== undefined) { 
                localVarFormParams.append('latitude', latitude as any);
            }
    
            if (longitude !== undefined) { 
                localVarFormParams.append('longitude', longitude as any);
            }
    
            if (returnedFfbPhoto !== undefined) { 
                localVarFormParams.append('returnedFfbPhoto', returnedFfbPhoto as any);
            }
    
            if (feedbacks !== undefined) { 
                localVarFormParams.append('feedbacks', new Blob([JSON.stringify(feedbacks)], { type: "application/json", }));
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create worker activity accessed from wb scan QR with partner_id and non partner mill weighbridge ticket image on request body (new at v4) 
         * @summary Create worker activity V4
         * @param {WorkerCreateActivitiesV4Request} [workerCreateActivitiesV4Request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workerCreateActivitiesV4: async (workerCreateActivitiesV4Request?: WorkerCreateActivitiesV4Request, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v4/workers/activities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workerCreateActivitiesV4Request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get List of worker activity, can use the query param of ticketNumber to get specific activity 
         * @summary Get worker activity
         * @param {string} [ticketNumber] ticket number of weighbridge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workerGetActivities: async (ticketNumber?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/workers/activities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ticketNumber !== undefined) {
                localVarQueryParameter['ticketNumber'] = ticketNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint is meant to be used to submit weighbridge data. This is a documentation for existing endpoint that currently still running 
         * @summary Submit Weighbridge Data
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {WorkersWeighbridgeSubmitRequest} workersWeighbridgeSubmitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workersWeighbridgeSubmit: async (authorization: string, workersWeighbridgeSubmitRequest: WorkersWeighbridgeSubmitRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('workersWeighbridgeSubmit', 'authorization', authorization)
            // verify required parameter 'workersWeighbridgeSubmitRequest' is not null or undefined
            assertParamExists('workersWeighbridgeSubmit', 'workersWeighbridgeSubmitRequest', workersWeighbridgeSubmitRequest)
            const localVarPath = `/palm-oil/v1/workers/weighbridge`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workersWeighbridgeSubmitRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint is meant to be used to update weighbridge data after manual review from product team and use only for our internal. Use Partner and Ticket number as unique identifier for weighbridge slip 
         * @summary Update Weighbridge Data
         * @param {string} weighbridgeId Weighbridge UUID
         * @param {string} authorization Authorization token for AI updating weighbridge slip
         * @param {WorkersWeighbridgeUpdateRequest} workersWeighbridgeUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workersWeighbridgeUpdate: async (weighbridgeId: string, authorization: string, workersWeighbridgeUpdateRequest: WorkersWeighbridgeUpdateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'weighbridgeId' is not null or undefined
            assertParamExists('workersWeighbridgeUpdate', 'weighbridgeId', weighbridgeId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('workersWeighbridgeUpdate', 'authorization', authorization)
            // verify required parameter 'workersWeighbridgeUpdateRequest' is not null or undefined
            assertParamExists('workersWeighbridgeUpdate', 'workersWeighbridgeUpdateRequest', workersWeighbridgeUpdateRequest)
            const localVarPath = `/api/v1/workers/weighbridge/update/{weighbridgeId}`
                .replace(`{${"weighbridgeId"}}`, encodeURIComponent(String(weighbridgeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workersWeighbridgeUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List of confirmed weighbridge tickets
         * @summary List Weighbridges
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {number} [startAt] Start date for filtering weighbridge date (in epoch) formatted in UTC-0
         * @param {number} [endAt] End date for filtering weighbridge date (in epoch) formatted in UTC-0
         * @param {string} [orderBy] Column used for ordering, will accept the field name from response object
         * @param {OrderDirectionEnum} [direction] 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workersWeighbridgesList: async (authorization: string, startAt?: number, endAt?: number, orderBy?: string, direction?: OrderDirectionEnum, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('workersWeighbridgesList', 'authorization', authorization)
            const localVarPath = `/api/v1/workers/weighbridges`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startAt !== undefined) {
                localVarQueryParameter['startAt'] = startAt;
            }

            if (endAt !== undefined) {
                localVarQueryParameter['endAt'] = endAt;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkersApi - functional programming interface
 * @export
 */
export const WorkersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorkersApiAxiosParamCreator(configuration)
    return {
        /**
         * This endpoint is meant to be used to get activity list of worker by Worker ID, for example, submitting weighbridge slip, etc. 
         * @summary Get worker activity list v1 by User ID
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async activitiesList(authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActivitiesListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activitiesList(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint is meant to be used to get activity list of worker by Worker ID, for example, submitting weighbridge slip, etc. 
         * @summary Get worker activity list v2 by User ID
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activitiesListV2(authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActivitiesListV2Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activitiesListV2(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get weighbridge detail.
         * @summary Get Weighbridge detail
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} weighbridgeTicketId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async weighbridgeDetail(authorization: string, weighbridgeTicketId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WeighbridgeGetResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.weighbridgeDetail(authorization, weighbridgeTicketId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint is used by daily limitation checking of Driver Activity feature. To block their activity if they already submit 2 Activities (input weighbridge data) for each day. 
         * @summary Check Limit of driver activities (scan (qr code) and input data weighbridge)
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workerActivitiesGetLimitation(authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkerActivitiesGetLimitationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workerActivitiesGetLimitation(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create worker activity accessed from wb scan QR
         * @summary Create worker activity
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {WorkerCreateActivitiesRequest} [workerCreateActivitiesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workerCreateActivities(authorization: string, workerCreateActivitiesRequest?: WorkerCreateActivitiesRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkerCreateActivitiesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workerCreateActivities(authorization, workerCreateActivitiesRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create worker activity accessed from wb scan QR V2 including user location (lat and long)
         * @summary Create worker activity V2
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {WorkerCreateActivitiesRequestV2} [workerCreateActivitiesRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workerCreateActivitiesV2(authorization: string, workerCreateActivitiesRequestV2?: WorkerCreateActivitiesRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkerCreateActivitiesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workerCreateActivitiesV2(authorization, workerCreateActivitiesRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create worker activity accessed from wb scan QR V3 with user latitude and longitude location (new on v2) with returned ffb image (new on v3) 
         * @summary Create worker activity V3
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} ticketNumber 
         * @param {CollectorTypeEnum} collectorType 
         * @param {string} collectorName 
         * @param {number} returnedQuantity Count of pulangan (janjang)
         * @param {number} weightAverageBunchKg Average of sawit weight (Komidel)
         * @param {number} latitude Worker current latitude
         * @param {number} longitude Worker current longitude
         * @param {File} returnedFfbPhoto Photo of returned fresh fruit bunches
         * @param {WorkerCreateActivitiesFeebackRequest} feedbacks 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workerCreateActivitiesV3(authorization: string, ticketNumber: string, collectorType: CollectorTypeEnum, collectorName: string, returnedQuantity: number, weightAverageBunchKg: number, latitude: number, longitude: number, returnedFfbPhoto: File, feedbacks: WorkerCreateActivitiesFeebackRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkerCreateActivitiesV3Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workerCreateActivitiesV3(authorization, ticketNumber, collectorType, collectorName, returnedQuantity, weightAverageBunchKg, latitude, longitude, returnedFfbPhoto, feedbacks, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create worker activity accessed from wb scan QR with partner_id and non partner mill weighbridge ticket image on request body (new at v4) 
         * @summary Create worker activity V4
         * @param {WorkerCreateActivitiesV4Request} [workerCreateActivitiesV4Request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workerCreateActivitiesV4(workerCreateActivitiesV4Request?: WorkerCreateActivitiesV4Request, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkerCreateActivitiesV4Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workerCreateActivitiesV4(workerCreateActivitiesV4Request, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get List of worker activity, can use the query param of ticketNumber to get specific activity 
         * @summary Get worker activity
         * @param {string} [ticketNumber] ticket number of weighbridge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workerGetActivities(ticketNumber?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkerGetActivitiesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workerGetActivities(ticketNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint is meant to be used to submit weighbridge data. This is a documentation for existing endpoint that currently still running 
         * @summary Submit Weighbridge Data
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {WorkersWeighbridgeSubmitRequest} workersWeighbridgeSubmitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workersWeighbridgeSubmit(authorization: string, workersWeighbridgeSubmitRequest: WorkersWeighbridgeSubmitRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkersWeighbridgeSubmitResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workersWeighbridgeSubmit(authorization, workersWeighbridgeSubmitRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint is meant to be used to update weighbridge data after manual review from product team and use only for our internal. Use Partner and Ticket number as unique identifier for weighbridge slip 
         * @summary Update Weighbridge Data
         * @param {string} weighbridgeId Weighbridge UUID
         * @param {string} authorization Authorization token for AI updating weighbridge slip
         * @param {WorkersWeighbridgeUpdateRequest} workersWeighbridgeUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workersWeighbridgeUpdate(weighbridgeId: string, authorization: string, workersWeighbridgeUpdateRequest: WorkersWeighbridgeUpdateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkersWeighbridgeUpdateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workersWeighbridgeUpdate(weighbridgeId, authorization, workersWeighbridgeUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * List of confirmed weighbridge tickets
         * @summary List Weighbridges
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {number} [startAt] Start date for filtering weighbridge date (in epoch) formatted in UTC-0
         * @param {number} [endAt] End date for filtering weighbridge date (in epoch) formatted in UTC-0
         * @param {string} [orderBy] Column used for ordering, will accept the field name from response object
         * @param {OrderDirectionEnum} [direction] 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workersWeighbridgesList(authorization: string, startAt?: number, endAt?: number, orderBy?: string, direction?: OrderDirectionEnum, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkersWeighbridgesListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workersWeighbridgesList(authorization, startAt, endAt, orderBy, direction, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WorkersApi - factory interface
 * @export
 */
export const WorkersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorkersApiFp(configuration)
    return {
        /**
         * This endpoint is meant to be used to get activity list of worker by Worker ID, for example, submitting weighbridge slip, etc. 
         * @summary Get worker activity list v1 by User ID
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        activitiesList(authorization: string, options?: any): AxiosPromise<ActivitiesListResponse> {
            return localVarFp.activitiesList(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint is meant to be used to get activity list of worker by Worker ID, for example, submitting weighbridge slip, etc. 
         * @summary Get worker activity list v2 by User ID
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activitiesListV2(authorization: string, options?: any): AxiosPromise<ActivitiesListV2Response> {
            return localVarFp.activitiesListV2(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get weighbridge detail.
         * @summary Get Weighbridge detail
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} weighbridgeTicketId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        weighbridgeDetail(authorization: string, weighbridgeTicketId: string, options?: any): AxiosPromise<WeighbridgeGetResponse> {
            return localVarFp.weighbridgeDetail(authorization, weighbridgeTicketId, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint is used by daily limitation checking of Driver Activity feature. To block their activity if they already submit 2 Activities (input weighbridge data) for each day. 
         * @summary Check Limit of driver activities (scan (qr code) and input data weighbridge)
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workerActivitiesGetLimitation(authorization: string, options?: any): AxiosPromise<WorkerActivitiesGetLimitationResponse> {
            return localVarFp.workerActivitiesGetLimitation(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Create worker activity accessed from wb scan QR
         * @summary Create worker activity
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {WorkerCreateActivitiesRequest} [workerCreateActivitiesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workerCreateActivities(authorization: string, workerCreateActivitiesRequest?: WorkerCreateActivitiesRequest, options?: any): AxiosPromise<WorkerCreateActivitiesResponse> {
            return localVarFp.workerCreateActivities(authorization, workerCreateActivitiesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create worker activity accessed from wb scan QR V2 including user location (lat and long)
         * @summary Create worker activity V2
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {WorkerCreateActivitiesRequestV2} [workerCreateActivitiesRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workerCreateActivitiesV2(authorization: string, workerCreateActivitiesRequestV2?: WorkerCreateActivitiesRequestV2, options?: any): AxiosPromise<WorkerCreateActivitiesResponse> {
            return localVarFp.workerCreateActivitiesV2(authorization, workerCreateActivitiesRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * Create worker activity accessed from wb scan QR V3 with user latitude and longitude location (new on v2) with returned ffb image (new on v3) 
         * @summary Create worker activity V3
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {string} ticketNumber 
         * @param {CollectorTypeEnum} collectorType 
         * @param {string} collectorName 
         * @param {number} returnedQuantity Count of pulangan (janjang)
         * @param {number} weightAverageBunchKg Average of sawit weight (Komidel)
         * @param {number} latitude Worker current latitude
         * @param {number} longitude Worker current longitude
         * @param {File} returnedFfbPhoto Photo of returned fresh fruit bunches
         * @param {WorkerCreateActivitiesFeebackRequest} feedbacks 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workerCreateActivitiesV3(authorization: string, ticketNumber: string, collectorType: CollectorTypeEnum, collectorName: string, returnedQuantity: number, weightAverageBunchKg: number, latitude: number, longitude: number, returnedFfbPhoto: File, feedbacks: WorkerCreateActivitiesFeebackRequest, options?: any): AxiosPromise<WorkerCreateActivitiesV3Response> {
            return localVarFp.workerCreateActivitiesV3(authorization, ticketNumber, collectorType, collectorName, returnedQuantity, weightAverageBunchKg, latitude, longitude, returnedFfbPhoto, feedbacks, options).then((request) => request(axios, basePath));
        },
        /**
         * Create worker activity accessed from wb scan QR with partner_id and non partner mill weighbridge ticket image on request body (new at v4) 
         * @summary Create worker activity V4
         * @param {WorkerCreateActivitiesV4Request} [workerCreateActivitiesV4Request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workerCreateActivitiesV4(workerCreateActivitiesV4Request?: WorkerCreateActivitiesV4Request, options?: any): AxiosPromise<WorkerCreateActivitiesV4Response> {
            return localVarFp.workerCreateActivitiesV4(workerCreateActivitiesV4Request, options).then((request) => request(axios, basePath));
        },
        /**
         * Get List of worker activity, can use the query param of ticketNumber to get specific activity 
         * @summary Get worker activity
         * @param {string} [ticketNumber] ticket number of weighbridge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workerGetActivities(ticketNumber?: string, options?: any): AxiosPromise<WorkerGetActivitiesResponse> {
            return localVarFp.workerGetActivities(ticketNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint is meant to be used to submit weighbridge data. This is a documentation for existing endpoint that currently still running 
         * @summary Submit Weighbridge Data
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {WorkersWeighbridgeSubmitRequest} workersWeighbridgeSubmitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workersWeighbridgeSubmit(authorization: string, workersWeighbridgeSubmitRequest: WorkersWeighbridgeSubmitRequest, options?: any): AxiosPromise<WorkersWeighbridgeSubmitResponse> {
            return localVarFp.workersWeighbridgeSubmit(authorization, workersWeighbridgeSubmitRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint is meant to be used to update weighbridge data after manual review from product team and use only for our internal. Use Partner and Ticket number as unique identifier for weighbridge slip 
         * @summary Update Weighbridge Data
         * @param {string} weighbridgeId Weighbridge UUID
         * @param {string} authorization Authorization token for AI updating weighbridge slip
         * @param {WorkersWeighbridgeUpdateRequest} workersWeighbridgeUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workersWeighbridgeUpdate(weighbridgeId: string, authorization: string, workersWeighbridgeUpdateRequest: WorkersWeighbridgeUpdateRequest, options?: any): AxiosPromise<WorkersWeighbridgeUpdateResponse> {
            return localVarFp.workersWeighbridgeUpdate(weighbridgeId, authorization, workersWeighbridgeUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * List of confirmed weighbridge tickets
         * @summary List Weighbridges
         * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
         * @param {number} [startAt] Start date for filtering weighbridge date (in epoch) formatted in UTC-0
         * @param {number} [endAt] End date for filtering weighbridge date (in epoch) formatted in UTC-0
         * @param {string} [orderBy] Column used for ordering, will accept the field name from response object
         * @param {OrderDirectionEnum} [direction] 
         * @param {number} [page] Current page number to be accessed.
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workersWeighbridgesList(authorization: string, startAt?: number, endAt?: number, orderBy?: string, direction?: OrderDirectionEnum, page?: number, limit?: number, options?: any): AxiosPromise<WorkersWeighbridgesListResponse> {
            return localVarFp.workersWeighbridgesList(authorization, startAt, endAt, orderBy, direction, page, limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WorkersApi - object-oriented interface
 * @export
 * @class WorkersApi
 * @extends {BaseAPI}
 */
export class WorkersApi extends BaseAPI {
    /**
     * This endpoint is meant to be used to get activity list of worker by Worker ID, for example, submitting weighbridge slip, etc. 
     * @summary Get worker activity list v1 by User ID
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof WorkersApi
     */
    public activitiesList(authorization: string, options?: AxiosRequestConfig) {
        return WorkersApiFp(this.configuration).activitiesList(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint is meant to be used to get activity list of worker by Worker ID, for example, submitting weighbridge slip, etc. 
     * @summary Get worker activity list v2 by User ID
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkersApi
     */
    public activitiesListV2(authorization: string, options?: AxiosRequestConfig) {
        return WorkersApiFp(this.configuration).activitiesListV2(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get weighbridge detail.
     * @summary Get Weighbridge detail
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {string} weighbridgeTicketId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkersApi
     */
    public weighbridgeDetail(authorization: string, weighbridgeTicketId: string, options?: AxiosRequestConfig) {
        return WorkersApiFp(this.configuration).weighbridgeDetail(authorization, weighbridgeTicketId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint is used by daily limitation checking of Driver Activity feature. To block their activity if they already submit 2 Activities (input weighbridge data) for each day. 
     * @summary Check Limit of driver activities (scan (qr code) and input data weighbridge)
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkersApi
     */
    public workerActivitiesGetLimitation(authorization: string, options?: AxiosRequestConfig) {
        return WorkersApiFp(this.configuration).workerActivitiesGetLimitation(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create worker activity accessed from wb scan QR
     * @summary Create worker activity
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {WorkerCreateActivitiesRequest} [workerCreateActivitiesRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkersApi
     */
    public workerCreateActivities(authorization: string, workerCreateActivitiesRequest?: WorkerCreateActivitiesRequest, options?: AxiosRequestConfig) {
        return WorkersApiFp(this.configuration).workerCreateActivities(authorization, workerCreateActivitiesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create worker activity accessed from wb scan QR V2 including user location (lat and long)
     * @summary Create worker activity V2
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {WorkerCreateActivitiesRequestV2} [workerCreateActivitiesRequestV2] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkersApi
     */
    public workerCreateActivitiesV2(authorization: string, workerCreateActivitiesRequestV2?: WorkerCreateActivitiesRequestV2, options?: AxiosRequestConfig) {
        return WorkersApiFp(this.configuration).workerCreateActivitiesV2(authorization, workerCreateActivitiesRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create worker activity accessed from wb scan QR V3 with user latitude and longitude location (new on v2) with returned ffb image (new on v3) 
     * @summary Create worker activity V3
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {string} ticketNumber 
     * @param {CollectorTypeEnum} collectorType 
     * @param {string} collectorName 
     * @param {number} returnedQuantity Count of pulangan (janjang)
     * @param {number} weightAverageBunchKg Average of sawit weight (Komidel)
     * @param {number} latitude Worker current latitude
     * @param {number} longitude Worker current longitude
     * @param {File} returnedFfbPhoto Photo of returned fresh fruit bunches
     * @param {WorkerCreateActivitiesFeebackRequest} feedbacks 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkersApi
     */
    public workerCreateActivitiesV3(authorization: string, ticketNumber: string, collectorType: CollectorTypeEnum, collectorName: string, returnedQuantity: number, weightAverageBunchKg: number, latitude: number, longitude: number, returnedFfbPhoto: File, feedbacks: WorkerCreateActivitiesFeebackRequest, options?: AxiosRequestConfig) {
        return WorkersApiFp(this.configuration).workerCreateActivitiesV3(authorization, ticketNumber, collectorType, collectorName, returnedQuantity, weightAverageBunchKg, latitude, longitude, returnedFfbPhoto, feedbacks, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create worker activity accessed from wb scan QR with partner_id and non partner mill weighbridge ticket image on request body (new at v4) 
     * @summary Create worker activity V4
     * @param {WorkerCreateActivitiesV4Request} [workerCreateActivitiesV4Request] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkersApi
     */
    public workerCreateActivitiesV4(workerCreateActivitiesV4Request?: WorkerCreateActivitiesV4Request, options?: AxiosRequestConfig) {
        return WorkersApiFp(this.configuration).workerCreateActivitiesV4(workerCreateActivitiesV4Request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get List of worker activity, can use the query param of ticketNumber to get specific activity 
     * @summary Get worker activity
     * @param {string} [ticketNumber] ticket number of weighbridge
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkersApi
     */
    public workerGetActivities(ticketNumber?: string, options?: AxiosRequestConfig) {
        return WorkersApiFp(this.configuration).workerGetActivities(ticketNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint is meant to be used to submit weighbridge data. This is a documentation for existing endpoint that currently still running 
     * @summary Submit Weighbridge Data
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {WorkersWeighbridgeSubmitRequest} workersWeighbridgeSubmitRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkersApi
     */
    public workersWeighbridgeSubmit(authorization: string, workersWeighbridgeSubmitRequest: WorkersWeighbridgeSubmitRequest, options?: AxiosRequestConfig) {
        return WorkersApiFp(this.configuration).workersWeighbridgeSubmit(authorization, workersWeighbridgeSubmitRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint is meant to be used to update weighbridge data after manual review from product team and use only for our internal. Use Partner and Ticket number as unique identifier for weighbridge slip 
     * @summary Update Weighbridge Data
     * @param {string} weighbridgeId Weighbridge UUID
     * @param {string} authorization Authorization token for AI updating weighbridge slip
     * @param {WorkersWeighbridgeUpdateRequest} workersWeighbridgeUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkersApi
     */
    public workersWeighbridgeUpdate(weighbridgeId: string, authorization: string, workersWeighbridgeUpdateRequest: WorkersWeighbridgeUpdateRequest, options?: AxiosRequestConfig) {
        return WorkersApiFp(this.configuration).workersWeighbridgeUpdate(weighbridgeId, authorization, workersWeighbridgeUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List of confirmed weighbridge tickets
     * @summary List Weighbridges
     * @param {string} authorization Bearer token/JWT will be used for auth. DEPRECATED. Use securitySchemes instead. 
     * @param {number} [startAt] Start date for filtering weighbridge date (in epoch) formatted in UTC-0
     * @param {number} [endAt] End date for filtering weighbridge date (in epoch) formatted in UTC-0
     * @param {string} [orderBy] Column used for ordering, will accept the field name from response object
     * @param {OrderDirectionEnum} [direction] 
     * @param {number} [page] Current page number to be accessed.
     * @param {number} [limit] Number of items per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkersApi
     */
    public workersWeighbridgesList(authorization: string, startAt?: number, endAt?: number, orderBy?: string, direction?: OrderDirectionEnum, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return WorkersApiFp(this.configuration).workersWeighbridgesList(authorization, startAt, endAt, orderBy, direction, page, limit, options).then((request) => request(this.axios, this.basePath));
    }
}


